
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6572"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6572"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a1O7I", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < digits[i]) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRegister("gNDfO", function(module, exports) {
module.exports = new URL("success.eecc0838.svg", import.meta.url).toString();

});

parcelRegister("btwiI", function(module, exports) {
module.exports = new URL("wheel.07240e8d.svg", import.meta.url).toString();

});

parcelRegister("9nqpg", function(module, exports) {
module.exports = new URL("exclamation.24d19768.svg", import.meta.url).toString();

});

parcelRegister("e5cS6", function(module, exports) {
module.exports = new URL("cross.a9503c99.svg", import.meta.url).toString();

});

parcelRegister("34LYy", function(module, exports) {
module.exports = new URL("vf-logo.bd4b8018.png", import.meta.url).toString();

});

parcelRegister("7igRj", function(module, exports) {
module.exports = new URL("cancelled.7a894738.svg", import.meta.url).toString();

});

parcelRegister("optnq", function(module, exports) {
module.exports = new URL("logout.46776294.svg", import.meta.url).toString();

});

parcelRegister("gZlTU", function(module, exports) {
module.exports = new URL("bmp-logo.07c09f97.svg", import.meta.url).toString();

});

// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $0d4b25392f45f74c$export$4add775dfee37121 = function(fs) {
    return function(xs) {
        var l = fs.length;
        var k = xs.length;
        var result = new Array(l * k);
        var n = 0;
        for(var i = 0; i < l; i++){
            var f = fs[i];
            for(var j = 0; j < k; j++)result[n++] = f(xs[j]);
        }
        return result;
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
var $5807467a73465f3c$export$3af17640bddf7212 = {
    compose: function(f) {
        return function(g) {
            return function(x) {
                return f(g(x));
            };
        };
    }
};
var $5807467a73465f3c$export$f672e0b6f7222cd7 = function(dict) {
    return dict.compose;
};
var $5807467a73465f3c$export$b5a9558a7176e41b = function(dictSemigroupoid) {
    var compose1 = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return function(f) {
        return function(g) {
            return compose1(g)(f);
        };
    };
};


var $5be483788e0e6f04$export$f0954fd7d5368655 = function(dict) {
    return dict.identity;
};
var $5be483788e0e6f04$export$7037e3b2ba3bd7aa = {
    identity: function(x) {
        return x;
    },
    Semigroupoid0: function() {
        return $5807467a73465f3c$export$3af17640bddf7212;
    }
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
var $5089f43af3d55e5d$export$4bed41887d8c5096 = true;


var $f57f4b701aa7b66e$export$af631764ddc44097 = function(f) {
    return function(g) {
        return function(x) {
            return function(y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var $f57f4b701aa7b66e$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
var $f57f4b701aa7b66e$export$5b38a098e5a9e7ca = function(a) {
    return function(v) {
        return a;
    };
};
var $f57f4b701aa7b66e$export$32c25ff0a0410173 = function(f) {
    var go = function($copy_n) {
        return function($copy_acc) {
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(n, acc) {
                if (n <= 0) {
                    $tco_done = true;
                    return acc;
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $tco_var_n = n - 1 | 0;
                    $copy_acc = f(acc);
                    return;
                }
                throw new Error("Failed pattern match at Data.Function (line 107, column 3 - line 109, column 37): " + [
                    n.constructor.name,
                    acc.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_acc);
            return $tco_result;
        };
    };
    return go;
};
var $f57f4b701aa7b66e$export$5f9c390da86b6e49 = function(x) {
    return function(f) {
        return f(x);
    };
};
var $f57f4b701aa7b66e$export$5635d7ef4b8fee1c = function(f) {
    return function(x) {
        return f(x);
    };
};


// Generated by purs version 0.15.15
const $889a8f7c70c4a41c$export$dc30017ac4432edc = function(f) {
    return function(arr) {
        var l = arr.length;
        var result = new Array(l);
        for(var i = 0; i < l; i++)result[i] = f(arr[i]);
        return result;
    };
};




// Generated by purs version 0.15.15
const $05149ea687d6b460$export$523c0b569236b342 = undefined;




// Generated by purs version 0.15.15
var $c6a0478cbb9b5a21$export$accffb5fb4579e0d = /* #__PURE__ */ function() {
    function $$Proxy() {}
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
}();


var $f4b2eb11fc32ed34$export$871de8747c9eaa88 = function(dict) {
    return dict.map;
};
var $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(fa) {
        return function(f) {
            return map1(f)(fa);
        };
    };
};
var $f4b2eb11fc32ed34$export$490e536ee7389aeb = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
};
var $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(x) {
            return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x))(f);
        };
    };
};
var $f4b2eb11fc32ed34$export$b818c54ed8d3e90a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(x) {
        return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x));
    };
};
var $f4b2eb11fc32ed34$export$816e5e05deb8955e = {
    map: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $f4b2eb11fc32ed34$export$11c8d16a3c15d11b = {
    map: /* #__PURE__ */ $5807467a73465f3c$export$f672e0b6f7222cd7($5807467a73465f3c$export$3af17640bddf7212)
};
var $f4b2eb11fc32ed34$export$2330f868b62ed546 = {
    map: $889a8f7c70c4a41c$export$dc30017ac4432edc
};
var $f4b2eb11fc32ed34$export$18c957606d8bdf09 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(ff) {
        return function(x) {
            return map1(function(f) {
                return f(x);
            })(ff);
        };
    };
};



var $7576d3a958d66ab0$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7576d3a958d66ab0$export$e24166bf2f1a6c73 = {
    apply: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$816e5e05deb8955e;
    }
};
var $7576d3a958d66ab0$export$2f68caa5c730775d = {
    apply: function(f) {
        return function(g) {
            return function(x) {
                return f(x)(g(x));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $7576d3a958d66ab0$export$60d7bd9d686a5521 = {
    apply: $0d4b25392f45f74c$export$4add775dfee37121,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $7576d3a958d66ab0$export$5635d7ef4b8fee1c = function(dict) {
    return dict.apply;
};
var $7576d3a958d66ab0$export$e48e2da4536c2eea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca)(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$3d5d566a030a20fc = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7576d3a958d66ab0$var$identity))(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$f016650e64b51e7d = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return apply1(map(f)(a))(b);
            };
        };
    };
};
var $7576d3a958d66ab0$export$30190e46300cc996 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return apply1(apply1(map(f)(a))(b))(c);
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6659660f0e855aea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return apply1(apply1(apply1(map(f)(a))(b))(c))(d);
                    };
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6c80f2f7f1ad8105 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return apply1(apply1(apply1(apply1(map(f)(a))(b))(c))(d))(e);
                        };
                    };
                };
            };
        };
    };
};





var $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557 = function(dict) {
    return dict.pure;
};
var $c50cfdb0b9e8fa31$export$6f0673371501d6b6 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (!v) return v1;
            if (v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$a55877ca9db47377 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$53544bd8de5a7427 = function(dictApplicative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApplicative.Apply0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return function(a) {
            return apply(pure1(f))(a);
        };
    };
};
var $c50cfdb0b9e8fa31$export$598532d07e20ffc2 = {
    pure: function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $c50cfdb0b9e8fa31$export$e68c32b2a06f106c = {
    pure: function(x) {
        return function(v) {
            return x;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e = {
    pure: function(x) {
        return [
            x
        ];
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};


// Generated by purs version 0.15.15
const $e001a8e6e4264547$export$4d853d3353098e5a = function(arr) {
    return function(f) {
        var result = [];
        for(var i = 0, l = arr.length; i < l; i++)Array.prototype.push.apply(result, f(arr[i]));
        return result;
    };
};








var $70cd3177464e7915$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $70cd3177464e7915$export$584af591d945b55a = function(dict) {
    return dict.discard;
};
var $70cd3177464e7915$export$6dbdf4766af04452 = {
    bind: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $70cd3177464e7915$export$2c348afe2becdb4f = {
    bind: function(m) {
        return function(f) {
            return function(x) {
                return f(m(x))(x);
            };
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $70cd3177464e7915$export$794f9574ca20b986 = {
    bind: $e001a8e6e4264547$export$4d853d3353098e5a,
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};
var $70cd3177464e7915$export$2385a24977818dd0 = function(dict) {
    return dict.bind;
};
var $70cd3177464e7915$export$f2077a1c19a006d9 = function(dictBind) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($70cd3177464e7915$export$2385a24977818dd0(dictBind));
};
var $70cd3177464e7915$export$ea9fbbe247ef8e50 = function(dictBind) {
    var bindFlipped1 = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bindFlipped1(f)(g(a));
            };
        };
    };
};
var $70cd3177464e7915$export$61a2047e1b1e0d3e = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bind1(f(a))(g);
            };
        };
    };
};
var $70cd3177464e7915$export$9a012077684d4c76 = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$f73711e565ded7e = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$2937bb6ffdfdda28 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(cond) {
        return function(t) {
            return function(f) {
                return bind1(cond)(function(cond$prime) {
                    if (cond$prime) return t;
                    return f;
                });
            };
        };
    };
};
var $70cd3177464e7915$export$f7e2c8231c57a8bd = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(m) {
        return bind1(m)($70cd3177464e7915$var$identity);
    };
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
const $b693645c2c75f222$export$171e7edd26203a84 = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
const $b693645c2c75f222$export$4fd8af2c48c43416 = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};


// Generated by purs version 0.15.15
// module Data.Symbol
const $bb08fe6cef393d6b$export$401372c57776dc = function(arg) {
    return arg;
};



var $1f7f00687c3959c5$export$340e995c37375b7a = function(s) {
    return function(f) {
        return $bb08fe6cef393d6b$export$401372c57776dc(function(dictIsSymbol) {
            return f(dictIsSymbol);
        })({
            reflectSymbol: function(v) {
                return s;
            }
        })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
    };
};
var $1f7f00687c3959c5$export$e5ed8a20a1c4d576 = function(dict) {
    return dict.reflectSymbol;
};



// Generated by purs version 0.15.15
var $58f3cdfbfe212d20$var$Void = function(x) {
    return x;
};
var $58f3cdfbfe212d20$export$f172309911142386 = function(a) {
    var spin = function($copy_v) {
        var $tco_result;
        function $tco_loop(v) {
            $copy_v = v;
            return;
        }
        while(true)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return spin(a);
};


// Generated by purs version 0.15.15
const $d2fadbdf02925823$export$12c1b2b255bc527d = function(label) {
    return function(rec) {
        return ({}).hasOwnProperty.call(rec, label);
    };
};
const $d2fadbdf02925823$export$1d94535d2cda4eda = function(label) {
    return function(rec) {
        return rec[label];
    };
};
const $d2fadbdf02925823$export$444262986932b766 = function(label) {
    return function(value) {
        return function(rec) {
            var copy = {};
            for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
            copy[label] = value;
            return copy;
        };
    };
};
const $d2fadbdf02925823$export$14b6a75b3eb38458 = function(label) {
    return function(rec) {
        var copy = {};
        for(var key in rec)if (key !== label && ({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
        return copy;
    };
};





var $d7bf9817a417d4ae$export$36aabcd6b6e45f3b = {
    append: function(v) {
        return $58f3cdfbfe212d20$export$f172309911142386;
    }
};
var $d7bf9817a417d4ae$export$824c37c4afd77b1 = {
    append: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    }
};
var $d7bf9817a417d4ae$export$d9b7100b101f2c5b = {
    append: $b693645c2c75f222$export$171e7edd26203a84
};
var $d7bf9817a417d4ae$export$955753116dc9242c = {
    appendRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    }
};
var $d7bf9817a417d4ae$export$af5ddea0c4d23f3c = {
    append: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $d7bf9817a417d4ae$export$d082f07d0a8e9909 = {
    append: $b693645c2c75f222$export$4fd8af2c48c43416
};
var $d7bf9817a417d4ae$export$1e8e5e81637c934d = function(dict) {
    return dict.appendRecord;
};
var $d7bf9817a417d4ae$export$dbfe6b321632d7c9 = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $d7bf9817a417d4ae$export$10d8903dec122b9d = function(dict) {
    return dict.append;
};
var $d7bf9817a417d4ae$export$49c9dc4575956c55 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(f) {
            return function(g) {
                return function(x) {
                    return append1(f(x))(g(x));
                };
            };
        }
    };
};
var $d7bf9817a417d4ae$export$74eae24c3d2a7535 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
                return {
                    appendRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = appendRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(append1(get(ra))(get(rb)))(tail);
                            };
                        };
                    }
                };
            };
        };
    };
};


var $75e93a4111e80214$export$186d613bb872946c = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909),
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $75e93a4111e80214$export$228be17d80722ab = function(dict) {
    return dict.alt;
};



// Generated by purs version 0.15.15
const $cd1cb347a48b7ff0$export$afdd678689eb299 = 2147483647;
const $cd1cb347a48b7ff0$export$4a17ba08fd82d88b = -2147483648;
const $cd1cb347a48b7ff0$export$4ffd3705721c8b5b = String.fromCharCode(65535);
const $cd1cb347a48b7ff0$export$d6be889e229abd84 = String.fromCharCode(0);
const $cd1cb347a48b7ff0$export$ef55dfccfe3a15b = Number.POSITIVE_INFINITY;
const $cd1cb347a48b7ff0$export$d1edf35dfee544b5 = Number.NEGATIVE_INFINITY;


// Generated by purs version 0.15.15
var $e07f6ef164bf0728$var$unsafeCompareImpl = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(x) {
                return function(y) {
                    return x < y ? lt : x === y ? eq : gt;
                };
            };
        };
    };
};
const $e07f6ef164bf0728$export$fcb09e9654c4896a = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$654933317498633e = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$a509696eaf723ed7 = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$bfcbb0304ffa620f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$5a20025607cdef3f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$6d083685ddc7682f = function(f) {
    return function(xs) {
        return function(ys) {
            var i = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i < xlen && i < ylen){
                var x = xs[i];
                var y = ys[i];
                var o = f(x)(y);
                if (o !== 0) return o;
                i++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};


// Generated by purs version 0.15.15
var $f4eec6a416d226bf$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
const $f4eec6a416d226bf$export$373f9c52154d3177 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$123e3cb4a5e139f4 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$9fc9964c874ac58 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$b056fd0da0447ba9 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$bb9bce33bd088a97 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$e89e5efeb0be06bc = function(f) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i = 0; i < xs.length; i++){
                if (!f(xs[i])(ys[i])) return false;
            }
            return true;
        };
    };
};





var $37b880af5f4991bd$export$2965418ef5ae9704 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$671c8820f3b36bad = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$fa624555ca2acbc8 = {
    eq: $f4eec6a416d226bf$export$bb9bce33bd088a97
};
var $37b880af5f4991bd$export$d12253326f924cb1 = {
    eqRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $37b880af5f4991bd$export$14e60b8fdd01f41c = function(dict) {
    return dict.eqRecord;
};
var $37b880af5f4991bd$export$691c0e424728509e = function() {
    return function(dictEqRecord) {
        return {
            eq: $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $37b880af5f4991bd$export$db5a78c472a81a32 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$e24978670be1e4f3 = {
    eq: $f4eec6a416d226bf$export$9fc9964c874ac58
};
var $37b880af5f4991bd$export$e65788c6d4494539 = {
    eq: $f4eec6a416d226bf$export$123e3cb4a5e139f4
};
var $37b880af5f4991bd$export$bcd79f9321394c38 = {
    eq: $f4eec6a416d226bf$export$b056fd0da0447ba9
};
var $37b880af5f4991bd$export$d7927e8ffc1afb48 = {
    eq: $f4eec6a416d226bf$export$373f9c52154d3177
};
var $37b880af5f4991bd$export$96fd6c73d03c9dd2 = function(dict) {
    return dict.eq1;
};
var $37b880af5f4991bd$export$9663ddc1cf085b32 = function(dict) {
    return dict.eq;
};
var $37b880af5f4991bd$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$d7927e8ffc1afb48);
var $37b880af5f4991bd$export$159e06dc5ec60b00 = function(dictEq) {
    return {
        eq: $f4eec6a416d226bf$export$e89e5efeb0be06bc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq))
    };
};
var $37b880af5f4991bd$export$861eb926e0b8ea5b = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$159e06dc5ec60b00(dictEq));
    }
};
var $37b880af5f4991bd$export$730b16b2c839caa0 = function(dictEqRecord) {
    var eqRecord1 = $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            return function(dictEq) {
                var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
                return {
                    eqRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = eqRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return eq3(get(ra))(get(rb)) && tail;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $37b880af5f4991bd$export$5475dfc31a65c2cd = function(dictEq) {
    var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(y) {
            return $37b880af5f4991bd$var$eq2(eq3(x)(y))(false);
        };
    };
};
var $37b880af5f4991bd$export$d0aa07ff560ecb = function(dictEq1) {
    var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq12 = eq11(dictEq);
        return function(x) {
            return function(y) {
                return $37b880af5f4991bd$var$eq2(eq12(x)(y))(false);
            };
        };
    };
};


// Generated by purs version 0.15.15
var $5026be88823ef1f4$export$7158f0ceb70f54c7 = /* #__PURE__ */ function() {
    function LT() {}
    LT.value = new LT();
    return LT;
}();
var $5026be88823ef1f4$export$b023c82b48e70453 = /* #__PURE__ */ function() {
    function GT() {}
    GT.value = new GT();
    return GT;
}();
var $5026be88823ef1f4$export$1c0a5d05eb3f6e18 = /* #__PURE__ */ function() {
    function EQ() {}
    EQ.value = new EQ();
    return EQ;
}();
var $5026be88823ef1f4$export$c1dd7b0030d4618e = {
    show: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return "LT";
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return "GT";
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return "EQ";
        throw new Error("Failed pattern match at Data.Ordering (line 26, column 1 - line 29, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $5026be88823ef1f4$export$d04ea36c3e51a408 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return v1;
            throw new Error("Failed pattern match at Data.Ordering (line 21, column 1 - line 24, column 18): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $5026be88823ef1f4$export$6897c284b6f9f4dc = function(v) {
    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v.constructor.name
    ]);
};
var $5026be88823ef1f4$export$82d306ead3b703cd = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.15
const $6997dff57b67dccd$export$8964faf538cd4472 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x - y | 0;
    };
};
const $6997dff57b67dccd$export$592dc8db1291fc5e = function(n1) {
    return function(n2) {
        return n1 - n2;
    };
};


// Generated by purs version 0.15.15
const $d134be8d1f9fbf5c$export$3493e4651621d0b = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x + y | 0;
    };
};
const $d134be8d1f9fbf5c$export$9961c9313a91a4c2 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x * y | 0;
    };
};
const $d134be8d1f9fbf5c$export$7851ca78a7fd68e5 = function(n1) {
    return function(n2) {
        return n1 + n2;
    };
};
const $d134be8d1f9fbf5c$export$3c84e2814d77f9f0 = function(n1) {
    return function(n2) {
        return n1 * n2;
    };
};






var $c0e822be92afc4df$export$2fbd183cf91e4d96 = function(dict) {
    return dict.zeroRecord;
};
var $c0e822be92afc4df$export$7f9972325ebfd559 = function(dict) {
    return dict.zero;
};
var $c0e822be92afc4df$export$348dab40c63d4f3e = {
    add: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    zero: $05149ea687d6b460$export$523c0b569236b342,
    mul: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    one: $05149ea687d6b460$export$523c0b569236b342
};
var $c0e822be92afc4df$export$5f825cdfc30c8d7a = {
    addRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    mulRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    oneRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    zeroRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $c0e822be92afc4df$export$28b7adff71d7e2f2 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        mul: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        one: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        zero: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $c0e822be92afc4df$export$f48694d6539477b9 = {
    add: $d134be8d1f9fbf5c$export$7851ca78a7fd68e5,
    zero: 0.0,
    mul: $d134be8d1f9fbf5c$export$3c84e2814d77f9f0,
    one: 1.0
};
var $c0e822be92afc4df$export$7e80d6910c05bd77 = {
    add: $d134be8d1f9fbf5c$export$3493e4651621d0b,
    zero: 0,
    mul: $d134be8d1f9fbf5c$export$9961c9313a91a4c2,
    one: 1
};
var $c0e822be92afc4df$export$e9e5a13b3096dd62 = function(dict) {
    return dict.oneRecord;
};
var $c0e822be92afc4df$export$80bf7733f1207381 = function(dict) {
    return dict.one;
};
var $c0e822be92afc4df$export$ff4422e298afd4cc = function(dict) {
    return dict.mulRecord;
};
var $c0e822be92afc4df$export$6e3a27864ab166fe = function(dict) {
    return dict.mul;
};
var $c0e822be92afc4df$export$ab0ab92b3cb31c66 = function(dict) {
    return dict.addRecord;
};
var $c0e822be92afc4df$export$93af3fe715165fc8 = function() {
    return function(dictSemiringRecord) {
        return {
            add: $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            mul: $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            one: $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            zero: $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $c0e822be92afc4df$export$e16d8520af44a096 = function(dict) {
    return dict.add;
};
var $c0e822be92afc4df$export$4946f164d066bdc5 = function(dictSemiring) {
    var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(f) {
            return function(g) {
                return function(x) {
                    return add1(f(x))(g(x));
                };
            };
        },
        zero: function(v) {
            return zero1;
        },
        mul: function(f) {
            return function(g) {
                return function(x) {
                    return mul1(f(x))(g(x));
                };
            };
        },
        one: function(v) {
            return one1;
        }
    };
};
var $c0e822be92afc4df$export$8d7f5ae13d42a4f9 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemiringRecord) {
            var addRecord1 = $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord);
            var mulRecord1 = $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord);
            var oneRecord1 = $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord);
            var zeroRecord1 = $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord);
            return function(dictSemiring) {
                var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
                var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
                var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
                var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
                return {
                    addRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = addRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(add1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    mulRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = mulRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(mul1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    oneRecord: function(v) {
                        return function(v1) {
                            var tail = oneRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(one1)(tail);
                        };
                    },
                    zeroRecord: function(v) {
                        return function(v1) {
                            var tail = zeroRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(zero1)(tail);
                        };
                    }
                };
            };
        };
    };
};






var $d061555d3b2c84b2$var$semiringRecord = /* #__PURE__ */ $c0e822be92afc4df$export$93af3fe715165fc8();
var $d061555d3b2c84b2$export$11a6fe76b07a0 = function(dict) {
    return dict.subRecord;
};
var $d061555d3b2c84b2$export$f93b5905241a7cca = function(dict) {
    return dict.sub;
};
var $d061555d3b2c84b2$export$e2da189c845067f9 = {
    sub: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$348dab40c63d4f3e;
    }
};
var $d061555d3b2c84b2$export$38dc985ea1e564cd = {
    subRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    SemiringRecord0: function() {
        return $c0e822be92afc4df$export$5f825cdfc30c8d7a;
    }
};
var $d061555d3b2c84b2$export$857cf13a2f74264d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semiringRecordCons = $c0e822be92afc4df$export$8d7f5ae13d42a4f9(dictIsSymbol)();
    return function() {
        return function(dictRingRecord) {
            var subRecord1 = $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord);
            var semiringRecordCons1 = semiringRecordCons(dictRingRecord.SemiringRecord0());
            return function(dictRing) {
                var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
                var semiringRecordCons2 = semiringRecordCons1(dictRing.Semiring0());
                return {
                    subRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = subRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(sub1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    SemiringRecord0: function() {
                        return semiringRecordCons2;
                    }
                };
            };
        };
    };
};
var $d061555d3b2c84b2$export$492fe4fa507ea6ad = function() {
    return function(dictRingRecord) {
        var semiringRecord1 = $d061555d3b2c84b2$var$semiringRecord(dictRingRecord.SemiringRecord0());
        return {
            sub: $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semiring0: function() {
                return semiringRecord1;
            }
        };
    };
};
var $d061555d3b2c84b2$export$948aff48831eff14 = {
    sub: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$28b7adff71d7e2f2;
    }
};
var $d061555d3b2c84b2$export$194f4464e73e7816 = {
    sub: $6997dff57b67dccd$export$592dc8db1291fc5e,
    Semiring0: function() {
        return $c0e822be92afc4df$export$f48694d6539477b9;
    }
};
var $d061555d3b2c84b2$export$d40e27c88e22a303 = {
    sub: $6997dff57b67dccd$export$8964faf538cd4472,
    Semiring0: function() {
        return $c0e822be92afc4df$export$7e80d6910c05bd77;
    }
};
var $d061555d3b2c84b2$export$9f43d8c61dde305d = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringFn = $c0e822be92afc4df$export$4946f164d066bdc5(dictRing.Semiring0());
    return {
        sub: function(f) {
            return function(g) {
                return function(x) {
                    return sub1(f(x))(g(x));
                };
            };
        },
        Semiring0: function() {
            return semiringFn;
        }
    };
};
var $d061555d3b2c84b2$export$aef51622e549b8b0 = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
    return function(a) {
        return sub1(zero)(a);
    };
};






var $97937c29f879e68e$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $97937c29f879e68e$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $97937c29f879e68e$export$752cdd067643c910 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$2965418ef5ae9704;
    }
};
var $97937c29f879e68e$export$f6b429625e3530b0 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$671c8820f3b36bad;
    }
};
var $97937c29f879e68e$export$c5f2758e49b2b86a = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$bfcbb0304ffa620f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$fa624555ca2acbc8;
        }
    };
}();
var $97937c29f879e68e$export$927f7db8ecc0069f = {
    compareRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            };
        };
    },
    EqRecord0: function() {
        return $37b880af5f4991bd$export$d12253326f924cb1;
    }
};
var $97937c29f879e68e$export$55c25d215527e8e8 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$db5a78c472a81a32;
    }
};
var $97937c29f879e68e$export$dcb5533042a37f3c = {
    compare: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            throw new Error("Failed pattern match at Data.Ord (line 126, column 1 - line 133, column 20): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5026be88823ef1f4$export$82d306ead3b703cd;
    }
};
var $97937c29f879e68e$export$5ed021ff2336715c = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$a509696eaf723ed7($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e24978670be1e4f3;
        }
    };
}();
var $97937c29f879e68e$export$ff461bf68e7dd332 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$654933317498633e($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e65788c6d4494539;
        }
    };
}();
var $97937c29f879e68e$export$3abd12c96be3b09b = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$5a20025607cdef3f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$bcd79f9321394c38;
        }
    };
}();
var $97937c29f879e68e$export$ef759d57a4e44836 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$fcb09e9654c4896a($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$d7927e8ffc1afb48;
        }
    };
}();
var $97937c29f879e68e$export$f595b73424c1647a = function(dict) {
    return dict.compareRecord;
};
var $97937c29f879e68e$export$ebb7a7956d139174 = function() {
    return function(dictOrdRecord) {
        var eqRec1 = $97937c29f879e68e$var$eqRec(dictOrdRecord.EqRecord0());
        return {
            compare: $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Eq0: function() {
                return eqRec1;
            }
        };
    };
};
var $97937c29f879e68e$export$693feb0c3c484b70 = function(dict) {
    return dict.compare1;
};
var $97937c29f879e68e$export$398604a469f7de9a = function(dict) {
    return dict.compare;
};
var $97937c29f879e68e$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $97937c29f879e68e$export$e9509a298f6befc2 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(x) {
            return function(y) {
                return compare3(f(x))(f(y));
            };
        };
    };
};
var $97937c29f879e68e$export$f517ea36c68d4644 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$4be320a4fd1ac499 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$9b050841a3a1b328 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$23e3e2011c250f0f = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(Semiring0);
        return function(x) {
            var $89 = lessThan1(x)(zero);
            if ($89) return negate1(one);
            var $90 = greaterThan1(x)(zero);
            if ($90) return one;
            return x;
        };
    };
};
var $97937c29f879e68e$export$f0c1dc893917aeba = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$8960430cfd85939f = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return y;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return x;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$96ec731ed4dcb222 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return x;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return y;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$6ace7ea8ac01a75e = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqArray = $37b880af5f4991bd$export$159e06dc5ec60b00(dictOrd.Eq0());
    return {
        compare: function() {
            var toDelta = function(x) {
                return function(y) {
                    var v = compare3(x)(y);
                    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 1;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $97937c29f879e68e$var$compare2(0)($e07f6ef164bf0728$export$6d083685ddc7682f(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $97937c29f879e68e$export$8e34cc59438cf1bf = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd));
    },
    Eq10: function() {
        return $37b880af5f4991bd$export$861eb926e0b8ea5b;
    }
};
var $97937c29f879e68e$export$a9b387b18fb85611 = function(dictOrdRecord) {
    var compareRecord1 = $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord);
    var eqRowCons = $37b880af5f4991bd$export$730b16b2c839caa0(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var eqRowCons1 = eqRowCons(dictIsSymbol);
            return function(dictOrd) {
                var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
                var eqRowCons2 = eqRowCons1(dictOrd.Eq0());
                return {
                    compareRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var left = compare3($d2fadbdf02925823$export$1d94535d2cda4eda(key)(ra))($d2fadbdf02925823$export$1d94535d2cda4eda(key)(rb));
                                var $95 = $97937c29f879e68e$var$notEq(left)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
                                if ($95) return left;
                                return compareRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons2;
                    }
                };
            };
        };
    };
};
var $97937c29f879e68e$export$7d15b64cf5a3a4c4 = function(dictOrd) {
    var min1 = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    var max1 = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                return min1(hi)(max1(low)(x));
            };
        };
    };
};
var $97937c29f879e68e$export$cf95c51b03f10bae = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                if (lessThan1(x)(low)) return false;
                if (greaterThan1(x)(hi)) return false;
                return true;
            };
        };
    };
};
var $97937c29f879e68e$export$2335f513bbd82c6d = function(dictOrd) {
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(dictOrd);
    return function(dictRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        return function(x) {
            var $99 = greaterThanOrEq1(x)(zero);
            if ($99) return x;
            return negate1(x);
        };
    };
};







var $69d0e3dbb12088d2$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $69d0e3dbb12088d2$export$407dd25a598bb432 = function(dict) {
    return dict.topRecord;
};
var $69d0e3dbb12088d2$export$1e95b668f3b82d = function(dict) {
    return dict.top;
};
var $69d0e3dbb12088d2$export$48259b86288d7b58 = {
    top: $05149ea687d6b460$export$523c0b569236b342,
    bottom: $05149ea687d6b460$export$523c0b569236b342,
    Ord0: function() {
        return $97937c29f879e68e$export$f6b429625e3530b0;
    }
};
var $69d0e3dbb12088d2$export$8978fddf7d98bede = {
    topRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    bottomRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    OrdRecord0: function() {
        return $97937c29f879e68e$export$927f7db8ecc0069f;
    }
};
var $69d0e3dbb12088d2$export$6001ef8e188ae2f5 = /* #__PURE__ */ function() {
    return {
        bottom: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        top: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        Ord0: function() {
            return $97937c29f879e68e$export$55c25d215527e8e8;
        }
    };
}();
var $69d0e3dbb12088d2$export$2e0fd44408d4861 = /* #__PURE__ */ function() {
    return {
        top: $5026be88823ef1f4$export$b023c82b48e70453.value,
        bottom: $5026be88823ef1f4$export$7158f0ceb70f54c7.value,
        Ord0: function() {
            return $97937c29f879e68e$export$dcb5533042a37f3c;
        }
    };
}();
var $69d0e3dbb12088d2$export$5acaecf0b0cd5fa9 = {
    top: $cd1cb347a48b7ff0$export$ef55dfccfe3a15b,
    bottom: $cd1cb347a48b7ff0$export$d1edf35dfee544b5,
    Ord0: function() {
        return $97937c29f879e68e$export$5ed021ff2336715c;
    }
};
var $69d0e3dbb12088d2$export$c84fa7e5ca2385dd = {
    top: $cd1cb347a48b7ff0$export$afdd678689eb299,
    bottom: $cd1cb347a48b7ff0$export$4a17ba08fd82d88b,
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79 = {
    top: $cd1cb347a48b7ff0$export$4ffd3705721c8b5b,
    bottom: $cd1cb347a48b7ff0$export$d6be889e229abd84,
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $69d0e3dbb12088d2$export$b6c012947af8ebbc = {
    top: true,
    bottom: false,
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $69d0e3dbb12088d2$export$72232990c70f5e82 = function(dict) {
    return dict.bottomRecord;
};
var $69d0e3dbb12088d2$export$8d7db335b27db939 = function() {
    return function(dictBoundedRecord) {
        var ordRecord1 = $69d0e3dbb12088d2$var$ordRecord(dictBoundedRecord.OrdRecord0());
        return {
            top: $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            bottom: $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Ord0: function() {
                return ordRecord1;
            }
        };
    };
};
var $69d0e3dbb12088d2$export$40e543e69a8b3fbb = function(dict) {
    return dict.bottom;
};
var $69d0e3dbb12088d2$export$53fc630a84ecc59b = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictBounded) {
        var top1 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom1 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        var Ord0 = dictBounded.Ord0();
        return function() {
            return function() {
                return function(dictBoundedRecord) {
                    var topRecord1 = $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord);
                    var bottomRecord1 = $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord);
                    var ordRecordCons = $97937c29f879e68e$export$a9b387b18fb85611(dictBoundedRecord.OrdRecord0())()(dictIsSymbol)(Ord0);
                    return {
                        topRecord: function(v) {
                            return function(rowProxy) {
                                var tail = topRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(top1)(tail);
                            };
                        },
                        bottomRecord: function(v) {
                            return function(rowProxy) {
                                var tail = bottomRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(bottom1)(tail);
                            };
                        },
                        OrdRecord0: function() {
                            return ordRecordCons;
                        }
                    };
                };
            };
        };
    };
};





// Generated by purs version 0.15.15

var $3d82dffba933b011$export$e8c9127d2f50172d = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$8824a2bea4c1012c = {
    imap: function(ab) {
        return function(ba) {
            return function(v) {
                return function($42) {
                    return ab(v(ba($42)));
                };
            };
        };
    }
};
var $3d82dffba933b011$export$1c6d49d5878078c3 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$ef56ebe0e8112a3f = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$562bca5a8a46bf61 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$bf44d3d4196f3d53 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$eb38b1c8c5f72ca8 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map(f);
        };
    };
};
var $3d82dffba933b011$export$c469d4e9c6f65eae = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$2330f868b62ed546)
};
var $3d82dffba933b011$export$993789ec90a91854 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$11c8d16a3c15d11b)
};
var $3d82dffba933b011$export$b2517b0ab3a58435 = function(dict) {
    return dict.imap;
};
var $3d82dffba933b011$export$6e542772b026aecb = function(dictInvariant) {
    var imap1 = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    return imap1(f)(g)(v);
                };
            };
        }
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $41dd51408824a8aa$export$c7cd64a71178c531 = function(n) {
    return n.toString();
};
const $41dd51408824a8aa$export$e43176eac712254a = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
const $41dd51408824a8aa$export$91f9c7a21f1f86c8 = function(c) {
    var code = c.charCodeAt(0);
    if (code < 0x20 || code === 0x7F) {
        switch(c){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "	":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code.toString(10) + "'";
    }
    return c === "'" || c === "\\" ? "'\\" + c + "'" : "'" + c + "'";
};
const $41dd51408824a8aa$export$336c8e5b2153cec7 = function(s) {
    var l = s.length;
    return '"' + s.replace(/[\0-\x1F\x7F"\\]/g, function(c, i) {
        switch(c){
            case '"':
            case "\\":
                return "\\" + c;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "	":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
    }) + '"';
};
const $41dd51408824a8aa$export$a23154580f12ac67 = function(f) {
    return function(xs) {
        var ss = [];
        for(var i = 0, l = xs.length; i < l; i++)ss[i] = f(xs[i]);
        return "[" + ss.join(",") + "]";
    };
};






var $2c6b3d51d10471a7$export$2052789f27d4993d = {
    show: $58f3cdfbfe212d20$export$f172309911142386
};
var $2c6b3d51d10471a7$export$5a8c7efb782a6055 = {
    show: function(v) {
        return "unit";
    }
};
var $2c6b3d51d10471a7$export$e4b6cd05df3043f6 = {
    show: $41dd51408824a8aa$export$336c8e5b2153cec7
};
var $2c6b3d51d10471a7$export$a673323aec880979 = {
    showRecordFields: function(v) {
        return function(v1) {
            return "";
        };
    }
};
var $2c6b3d51d10471a7$export$2633f2b0f857f544 = function(dict) {
    return dict.showRecordFields;
};
var $2c6b3d51d10471a7$export$28b0be767d2bc2c2 = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record) + "}");
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$3805d09d172f9aca = {
    show: function(v) {
        return "Proxy";
    }
};
var $2c6b3d51d10471a7$export$e5aa470f8f97c3fe = {
    show: $41dd51408824a8aa$export$e43176eac712254a
};
var $2c6b3d51d10471a7$export$3d7cf516d27998a0 = {
    show: $41dd51408824a8aa$export$c7cd64a71178c531
};
var $2c6b3d51d10471a7$export$def6059c21714f2a = {
    show: $41dd51408824a8aa$export$91f9c7a21f1f86c8
};
var $2c6b3d51d10471a7$export$ad55f318773e3cd5 = {
    show: function(v) {
        if (v) return "true";
        if (!v) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $2c6b3d51d10471a7$export$57bf213be019eeb0 = function(dict) {
    return dict.show;
};
var $2c6b3d51d10471a7$export$5bda33a3389a7225 = function(dictShow) {
    return {
        show: $41dd51408824a8aa$export$a23154580f12ac67($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow))
    };
};
var $2c6b3d51d10471a7$export$70f8f8693d114c9d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
        return function(dictShow) {
            var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
            return {
                showRecordFields: function(v) {
                    return function(record) {
                        var tail = showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                        return " " + (key + (": " + (show1(focus) + ("," + tail))));
                    };
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$d57593979a3bd7f3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            showRecordFields: function(v) {
                return function(record) {
                    var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                    return " " + (key + (": " + (show1(focus) + " ")));
                };
            }
        };
    };
};




var $91c996e9c07e3b3f$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $91c996e9c07e3b3f$export$dd5fad028b7772cd = /* #__PURE__ */ function() {
    function Inl(value0) {
        this.value0 = value0;
    }
    Inl.create = function(value0) {
        return new Inl(value0);
    };
    return Inl;
}();
var $91c996e9c07e3b3f$export$df71ca4577dbdff6 = /* #__PURE__ */ function() {
    function Inr(value0) {
        this.value0 = value0;
    }
    Inr.create = function(value0) {
        return new Inr(value0);
    };
    return Inr;
}();
var $91c996e9c07e3b3f$export$264ad599d7cef668 = /* #__PURE__ */ function() {
    function Product(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product.create = function(value0) {
        return function(value1) {
            return new Product(value0, value1);
        };
    };
    return Product;
}();
var $91c996e9c07e3b3f$var$NoConstructors = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$928c7f2d618c070b = /* #__PURE__ */ function() {
    function NoArguments() {}
    NoArguments.value = new NoArguments();
    return NoArguments;
}();
var $91c996e9c07e3b3f$export$8bfc33963ccbb2a = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$84637ea037d2e218 = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$2c618a4308a30424 = function(dict) {
    return dict.to;
};
var $91c996e9c07e3b3f$export$a76fa7ac9b018069 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return "(Inl " + (show1(v.value0) + ")");
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return "(Inr " + (show2(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Generic.Rep (line 32, column 1 - line 34, column 42): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $91c996e9c07e3b3f$export$821c121fea76e4f5 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Product " + (show1(v.value0) + (" " + (show2(v.value1) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$1275f813f7f7622c = {
    show: function(v) {
        return "NoArguments";
    }
};
var $91c996e9c07e3b3f$export$4133b31869b937df = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            show: function(v) {
                return "(Constructor @" + ($91c996e9c07e3b3f$var$show(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)) + (" " + (show1(v) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$b1716375e6f06e2d = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Argument " + (show1(v) + ")");
        }
    };
};
var $91c996e9c07e3b3f$export$3d0c2c94453de4b8 = function(dictGeneric) {
    return function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    };
};
var $91c996e9c07e3b3f$export$6788812c4e6611e6 = function(dict) {
    return dict.from;
};


// Generated by purs version 0.15.15
















var $06733ae99ed4f534$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $06733ae99ed4f534$export$bebe9059409a0d04 = /* #__PURE__ */ function() {
    function Nothing() {}
    Nothing.value = new Nothing();
    return Nothing;
}();
var $06733ae99ed4f534$export$8a67b48435b5d073 = /* #__PURE__ */ function() {
    function Just(value0) {
        this.value0 = value0;
    }
    Just.create = function(value0) {
        return new Just(value0);
    };
    return Just;
}();
var $06733ae99ed4f534$export$9b814e760fdd264a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "(Just " + (show(v.value0) + ")");
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v.constructor.name
            ]);
        }
    };
};
var $06733ae99ed4f534$export$fb85b8a3a6158141 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(append1(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        }
    };
};
var $06733ae99ed4f534$export$516e28dec6a4b6d4 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(a) {
            return alt(map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(a))(pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
        };
    };
};
var $06733ae99ed4f534$export$89fc9eb1adf8ed28 = function(dictSemigroup) {
    var semigroupMaybe1 = $06733ae99ed4f534$export$fb85b8a3a6158141(dictSemigroup);
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return semigroupMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$76f250758a65e763 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v($05149ea687d6b460$export$523c0b569236b342);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 250, column 1 - line 250, column 62): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$f8b8b9ce72e9ccbf = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$4967676db1b89293 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(true)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $06733ae99ed4f534$export$c15bd07a493e1236 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $06733ae99ed4f534$export$a1265319b56c5090 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $06733ae99ed4f534$export$8a67b48435b5d073(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    }
};
var $06733ae99ed4f534$export$fdd2427f0e60fd66 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1.value0));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    }
};
var $06733ae99ed4f534$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $06733ae99ed4f534$export$62eda6ff839a0571 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($06733ae99ed4f534$export$fdd2427f0e60fd66)
};
var $06733ae99ed4f534$export$770f48d991b0f2a2 = function(a) {
    return $06733ae99ed4f534$export$76f250758a65e763(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$43db023a260c5e9f = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$2506262575dd10a7 = function() {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v.constructor.name
        ]);
    };
};
var $06733ae99ed4f534$export$cb6d304dbd10aa95 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1));
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$8f45bb76abf9699e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $06733ae99ed4f534$export$e35c29f98d259c46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMaybe1 = $06733ae99ed4f534$export$8f45bb76abf9699e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return compare(x.value0)(y.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$b59095d05faa8cf6 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq));
    }
};
var $06733ae99ed4f534$export$c82772423d5de0b = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd));
    },
    Eq10: function() {
        return $06733ae99ed4f534$export$b59095d05faa8cf6;
    }
};
var $06733ae99ed4f534$export$158982e65b249847 = function(dictBounded) {
    var ordMaybe1 = $06733ae99ed4f534$export$e35c29f98d259c46(dictBounded.Ord0());
    return {
        top: new $06733ae99ed4f534$export$8a67b48435b5d073($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded)),
        bottom: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Ord0: function() {
            return ordMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$22d9917da16590e7 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$var$map(v.value0)(v1);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $06733ae99ed4f534$export$e5fea5661dee377 = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $06733ae99ed4f534$export$22d9917da16590e7;
    }
};
var $06733ae99ed4f534$export$9e0396ae96a86801 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        zero: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        one: new $06733ae99ed4f534$export$8a67b48435b5d073($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring)),
        add: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(add(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 190, column 1 - line 198, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        mul: function(x) {
            return function(y) {
                return $06733ae99ed4f534$var$apply($06733ae99ed4f534$var$map(mul)(x))(y);
            };
        }
    };
};
var $06733ae99ed4f534$export$b203ef4465f15037 = /* #__PURE__ */ function() {
    return {
        pure: $06733ae99ed4f534$export$8a67b48435b5d073.create,
        Apply0: function() {
            return $06733ae99ed4f534$export$22d9917da16590e7;
        }
    };
}();
var $06733ae99ed4f534$export$f78a1c2d38efcc13 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Bind1: function() {
        return $06733ae99ed4f534$export$e5fea5661dee377;
    }
};
var $06733ae99ed4f534$export$a22c94fdeac581ff = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$164e6bcbae9cfdd0 = /* #__PURE__ */ function() {
    return {
        empty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Alt0: function() {
            return $06733ae99ed4f534$export$a22c94fdeac581ff;
        }
    };
}();
var $06733ae99ed4f534$export$92d23d3d8fa78a80 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Plus1: function() {
        return $06733ae99ed4f534$export$164e6bcbae9cfdd0;
    }
};







var $7d4cccdf062a2261$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left(value0) {
        this.value0 = value0;
    }
    Left.create = function(value0) {
        return new Left(value0);
    };
    return Left;
}();
var $7d4cccdf062a2261$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right(value0) {
        this.value0 = value0;
    }
    Right.create = function(value0) {
        return new Right(value0);
    };
    return Right;
}();
var $7d4cccdf062a2261$export$37ab35e89b41eda = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(Left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(Right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $7d4cccdf062a2261$export$e29cdc8bc2cafc59 = function(f) {
    return $06733ae99ed4f534$export$76f250758a65e763(function($138) {
        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(f($138));
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$a92e4c44d367d0af = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a))($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$72a1c23d752d2155 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $7d4cccdf062a2261$export$19db0165690c701a(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $7d4cccdf062a2261$export$f0a413d3d6075601 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(m.value0);
            if (m instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(f(m.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $7d4cccdf062a2261$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $7d4cccdf062a2261$export$26473b852950cc9f = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($7d4cccdf062a2261$export$f0a413d3d6075601)
};
var $7d4cccdf062a2261$export$f41f6e6ed5e42617 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$27d3ca2b5d864fdd = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$a6bf632a63e8a255 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$ed20f362be8f8b52 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            return new $7d4cccdf062a2261$export$19db0165690c701a(v(v1));
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$export$bde8fea66b0f9f9a = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $7d4cccdf062a2261$export$f105364bfbaa033b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqEither2 = eqEither1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$551ea40f4c230981 = function(dictEq) {
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqEither1(dictEq1));
        }
    };
};
var $7d4cccdf062a2261$export$f4a01dc57c45522b = function(dictOrd) {
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictOrd);
    var eq1Either1 = $7d4cccdf062a2261$export$551ea40f4c230981(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordEither1(dictOrd1));
        },
        Eq10: function() {
            return eq1Either1;
        }
    };
};
var $7d4cccdf062a2261$export$5f5be1bb6cd1fded = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7d4cccdf062a2261$export$3a6c138b8d0f3874 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $7d4cccdf062a2261$export$d649b6842e09f2b = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $7d4cccdf062a2261$export$a9d71693f0c1a85d = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $7d4cccdf062a2261$export$7877a478dd30fd3d = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(a) {
        return function(b) {
            return alt(map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(a))(map1($7d4cccdf062a2261$export$19db0165690c701a.create)(b));
        };
    };
};
var $7d4cccdf062a2261$export$39ea3c8fac814734 = function(dictBounded) {
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordEither2 = ordEither1(dictBounded1.Ord0());
        return {
            top: new $7d4cccdf062a2261$export$19db0165690c701a($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $7d4cccdf062a2261$export$37c4d04eafdc5515(bottom),
            Ord0: function() {
                return ordEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$521d8864384143c6 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($06733ae99ed4f534$export$8a67b48435b5d073.create)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value));
}();
var $7d4cccdf062a2261$export$d5df7cb019d08f04 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7d4cccdf062a2261$var$map(v.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $7d4cccdf062a2261$export$3806e10d0c441ac5 = {
    bind: /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(e) {
        return function(v) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(e);
        };
    })(function(a) {
        return function(f) {
            return f(a);
        };
    }),
    Apply0: function() {
        return $7d4cccdf062a2261$export$d5df7cb019d08f04;
    }
};
var $7d4cccdf062a2261$export$56cf4be43732c31d = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(x) {
            return function(y) {
                return $7d4cccdf062a2261$var$apply($7d4cccdf062a2261$var$map(append1)(x))(y);
            };
        }
    };
};
var $7d4cccdf062a2261$export$400f1ef3f3ec304d = /* #__PURE__ */ function() {
    return {
        pure: $7d4cccdf062a2261$export$19db0165690c701a.create,
        Apply0: function() {
            return $7d4cccdf062a2261$export$d5df7cb019d08f04;
        }
    };
}();
var $7d4cccdf062a2261$export$b3b4ecb28e3a8df3 = {
    Applicative0: function() {
        return $7d4cccdf062a2261$export$400f1ef3f3ec304d;
    },
    Bind1: function() {
        return $7d4cccdf062a2261$export$3806e10d0c441ac5;
    }
};
var $7d4cccdf062a2261$export$79ac44fe35dcf650 = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};






// Generated by purs version 0.15.15
const $01fd16aefb19fd56$export$f6d4f01ca39c2fe = function(a) {
    return function() {
        return a;
    };
};
const $01fd16aefb19fd56$export$b771a24b80e4c766 = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $01fd16aefb19fd56$export$161ebd47ed3ced60 = function(f) {
    return function() {
        while(!f());
    };
};
const $01fd16aefb19fd56$export$27334490557f84d2 = function(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
};
const $01fd16aefb19fd56$export$3dfbdd78bf0090db = function(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
};
const $01fd16aefb19fd56$export$eff012ca4e6ded0b = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};




// Generated by purs version 0.15.15




var $d3d065da31679be1$export$7e7b1df9f5185791 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var when = $c50cfdb0b9e8fa31$export$a55877ca9db47377(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return when(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$551dd5524146e426 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var unless = $c50cfdb0b9e8fa31$export$6f0673371501d6b6(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return unless(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$d34b9ad93b1f095a = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$598532d07e20ffc2;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$6dbdf4766af04452;
    }
};
var $d3d065da31679be1$export$513f938006a06509 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$e68c32b2a06f106c;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$2c348afe2becdb4f;
    }
};
var $d3d065da31679be1$export$68aea3a98a23c265 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$794f9574ca20b986;
    }
};
var $d3d065da31679be1$export$167848c32e61a4d4 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(a)(function(a$prime) {
                return pure(f(a$prime));
            });
        };
    };
};
var $d3d065da31679be1$export$2f6ca3d3b1f80bf5 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(f)(function(f$prime) {
                return bind(a)(function(a$prime) {
                    return pure(f$prime(a$prime));
                });
            });
        };
    };
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
const $9f3b30719c815f93$export$748d824f642f540d = function(x) {
    return Math.min(Math.abs(x), 2147483647);
};
const $9f3b30719c815f93$export$baf7824ae32165f5 = function(x) {
    return function(y) {
        if (y === 0) return 0;
        return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
};
const $9f3b30719c815f93$export$faa51fbcd7b05d8f = function(x) {
    return function(y) {
        if (y === 0) return 0;
        var yy = Math.abs(y);
        return (x % yy + yy) % yy;
    };
};
const $9f3b30719c815f93$export$6db30f2997f70499 = function(n1) {
    return function(n2) {
        return n1 / n2;
    };
};


// Generated by purs version 0.15.15


var $a64f08f726dec5e9$var$ringRecord = /* #__PURE__ */ $d061555d3b2c84b2$export$492fe4fa507ea6ad();
var $a64f08f726dec5e9$export$4fcc4024c8011653 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$e2da189c845067f9;
    }
};
var $a64f08f726dec5e9$export$a2ce2b4503316dcc = {
    RingRecord0: function() {
        return $d061555d3b2c84b2$export$38dc985ea1e564cd;
    }
};
var $a64f08f726dec5e9$export$dc394faf01ed3f4e = function(dictIsSymbol) {
    var ringRecordCons = $d061555d3b2c84b2$export$857cf13a2f74264d(dictIsSymbol)();
    return function() {
        return function(dictCommutativeRingRecord) {
            var ringRecordCons1 = ringRecordCons(dictCommutativeRingRecord.RingRecord0());
            return function(dictCommutativeRing) {
                var ringRecordCons2 = ringRecordCons1(dictCommutativeRing.Ring0());
                return {
                    RingRecord0: function() {
                        return ringRecordCons2;
                    }
                };
            };
        };
    };
};
var $a64f08f726dec5e9$export$d4bbb7afedb09bfd = function() {
    return function(dictCommutativeRingRecord) {
        var ringRecord1 = $a64f08f726dec5e9$var$ringRecord(dictCommutativeRingRecord.RingRecord0());
        return {
            Ring0: function() {
                return ringRecord1;
            }
        };
    };
};
var $a64f08f726dec5e9$export$7f39ee449b822938 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$948aff48831eff14;
    }
};
var $a64f08f726dec5e9$export$ed11bb9ee1d36807 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$194f4464e73e7816;
    }
};
var $a64f08f726dec5e9$export$5745e05f6b169cee = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$d40e27c88e22a303;
    }
};
var $a64f08f726dec5e9$export$bdad616b79aca10 = function(dictCommutativeRing) {
    var ringFn = $d061555d3b2c84b2$export$9f43d8c61dde305d(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringFn;
        }
    };
};





var $b0cd729514c2504e$export$842a2cf37af977e1 = function(dict) {
    return dict.mod;
};
var $b0cd729514c2504e$export$f81847884871263e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEuclideanRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $24 = eq(b)(zero);
                if ($24) return a;
                return $b0cd729514c2504e$export$f81847884871263e(dictEq)(dictEuclideanRing)(b)(mod1(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$ea62662521882766 = {
    degree: function(v) {
        return 1;
    },
    div: $9f3b30719c815f93$export$6db30f2997f70499,
    mod: function(v) {
        return function(v1) {
            return 0.0;
        };
    },
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$ed11bb9ee1d36807;
    }
};
var $b0cd729514c2504e$export$437776face1858ae = {
    degree: $9f3b30719c815f93$export$748d824f642f540d,
    div: $9f3b30719c815f93$export$baf7824ae32165f5,
    mod: $9f3b30719c815f93$export$faa51fbcd7b05d8f,
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$5745e05f6b169cee;
    }
};
var $b0cd729514c2504e$export$159d9494db57879b = function(dict) {
    return dict.div;
};
var $b0cd729514c2504e$export$f686d97e407ec4ef = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var gcd1 = $b0cd729514c2504e$export$f81847884871263e(dictEq);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var div1 = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Semiring0);
        var gcd2 = gcd1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $26 = eq(a)(zero) || eq(b)(zero);
                if ($26) return zero;
                return div1(mul(a)(b))(gcd2(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};








var $784e1bd3d26d71da$var$semigroupRecord = /* #__PURE__ */ $d7bf9817a417d4ae$export$dbfe6b321632d7c9();
var $784e1bd3d26d71da$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$export$852b4040eee6c6ba = {
    mempty: $05149ea687d6b460$export$523c0b569236b342,
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$824c37c4afd77b1;
    }
};
var $784e1bd3d26d71da$export$fc39f3d77fa2e58a = {
    mempty: "",
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
    }
};
var $784e1bd3d26d71da$export$254fca207e30c208 = {
    memptyRecord: function(v) {
        return {};
    },
    SemigroupRecord0: function() {
        return $d7bf9817a417d4ae$export$955753116dc9242c;
    }
};
var $784e1bd3d26d71da$export$84dd8432d2bb1dc3 = /* #__PURE__ */ function() {
    return {
        mempty: $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value,
        Semigroup0: function() {
            return $5026be88823ef1f4$export$d04ea36c3e51a408;
        }
    };
}();
var $784e1bd3d26d71da$export$db307f59121ffcc4 = {
    mempty: [],
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d082f07d0a8e9909;
    }
};
var $784e1bd3d26d71da$export$ae16212c99887b7f = function(dict) {
    return dict.memptyRecord;
};
var $784e1bd3d26d71da$export$b6526a2ab5064058 = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $784e1bd3d26d71da$var$semigroupRecord(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $784e1bd3d26d71da$export$9a7d64bc1d75357 = function(dict) {
    return dict.mempty;
};
var $784e1bd3d26d71da$export$192e81b9fe7e4abe = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupFn = $d7bf9817a417d4ae$export$49c9dc4575956c55(dictMonoid.Semigroup0());
    return {
        mempty: function(v) {
            return mempty1;
        },
        Semigroup0: function() {
            return semigroupFn;
        }
    };
};
var $784e1bd3d26d71da$export$d672019c76a5af4a = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semigroupRecordCons = $d7bf9817a417d4ae$export$74eae24c3d2a7535(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v) {
                        var tail = memptyRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var insert = $d2fadbdf02925823$export$444262986932b766(key);
                        return insert(mempty1)(tail);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $784e1bd3d26d71da$export$836601bcef5ff40 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(x) {
        var go = function(p) {
            if (p <= 0) return mempty1;
            if (p === 1) return x;
            if ($784e1bd3d26d71da$var$mod(p)(2) === 0) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(x$prime);
            }
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(append(x$prime)(x));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p.constructor.name
            ]);
        };
        return go;
    };
};
var $784e1bd3d26d71da$export$864d727b48066337 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return mempty1;
            throw new Error("Failed pattern match at Data.Monoid (line 96, column 1 - line 96, column 49): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};



var $6c2f8951ecf9531e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $6c2f8951ecf9531e$export$7e900d895707a1af = {
    Applicative0: function() {
        return $6c2f8951ecf9531e$export$89bf999217d3022a;
    },
    Bind1: function() {
        return $6c2f8951ecf9531e$export$855330f8a2a9f2e8;
    }
};
var $6c2f8951ecf9531e$export$855330f8a2a9f2e8 = {
    bind: $01fd16aefb19fd56$export$b771a24b80e4c766,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$export$89bf999217d3022a = {
    pure: $01fd16aefb19fd56$export$f6d4f01ca39c2fe,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$var$$lazy_functorEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $c50cfdb0b9e8fa31$export$53544bd8de5a7427($6c2f8951ecf9531e$export$89bf999217d3022a)
    };
});
var $6c2f8951ecf9531e$var$$lazy_applyEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($6c2f8951ecf9531e$export$7e900d895707a1af),
        Functor0: function() {
            return $6c2f8951ecf9531e$var$$lazy_functorEffect(0);
        }
    };
});
var $6c2f8951ecf9531e$export$91fce01ecf0438e1 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_functorEffect(20);
var $6c2f8951ecf9531e$export$59a7b217c53300d2 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_applyEffect(23);
var $6c2f8951ecf9531e$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $6c2f8951ecf9531e$export$58139e981c60cf43 = function(dictSemigroup) {
    return {
        append: $6c2f8951ecf9531e$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $6c2f8951ecf9531e$export$2d8226ee4b2722f7 = function(dictMonoid) {
    var semigroupEffect1 = $6c2f8951ecf9531e$export$58139e981c60cf43(dictMonoid.Semigroup0());
    return {
        mempty: $01fd16aefb19fd56$export$f6d4f01ca39c2fe($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupEffect1;
        }
    };
};


// Generated by purs version 0.15.15
function $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c(err) {
    return err.stack || err.toString();
}
function $ad2cf6904bca3ba1$export$a3bc9b8ed74fc(msg) {
    return new Error(msg);
}
function $ad2cf6904bca3ba1$export$d010f7d0d0793465(msg) {
    return function(cause) {
        return new Error(msg, {
            cause: cause
        });
    };
}
function $ad2cf6904bca3ba1$export$afd88dc4d34c0903(msg) {
    return function(name) {
        const e = new Error(msg);
        e.name = name;
        return e;
    };
}
function $ad2cf6904bca3ba1$export$a8ecead220dd38a6(e) {
    return e.message;
}
function $ad2cf6904bca3ba1$export$a8ff84c12d48cfa6(e) {
    return e.name || "Error";
}
function $ad2cf6904bca3ba1$export$c159e25936a96837(just) {
    return function(nothing) {
        return function(e) {
            return e.stack ? just(e.stack) : nothing;
        };
    };
}
function $ad2cf6904bca3ba1$export$de0c4a986b439e52(e) {
    return function() {
        throw e;
    };
}
function $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(c) {
    return function(t) {
        return function() {
            try {
                return t();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c(e)();
                else return c(new Error(e.toString()))();
            }
        };
    };
}







var $4e52402d7134c8bb$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $4e52402d7134c8bb$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $4e52402d7134c8bb$export$410a452afcd48948 = function(action) {
    return $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(function($3) {
        return $4e52402d7134c8bb$var$pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($3));
    })($4e52402d7134c8bb$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(action));
};
var $4e52402d7134c8bb$export$7b1a37e4f0fe815 = function($4) {
    return $ad2cf6904bca3ba1$export$de0c4a986b439e52($ad2cf6904bca3ba1$export$a3bc9b8ed74fc($4));
};
var $4e52402d7134c8bb$export$a57ab32f40f83ea9 = /* #__PURE__ */ function() {
    return $ad2cf6904bca3ba1$export$c159e25936a96837($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $4e52402d7134c8bb$export$3879b24e8245693d = {
    show: $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c
};


var $5dfefa023749ded0$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $5dfefa023749ded0$export$8bf7aba4a9e09055 = function(dict) {
    return dict.throwError;
};
var $5dfefa023749ded0$export$fff877a725e9aba1 = /* #__PURE__ */ function() {
    return {
        throwError: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Monad0: function() {
            return $06733ae99ed4f534$export$f78a1c2d38efcc13;
        }
    };
}();
var $5dfefa023749ded0$export$390154ec55cffb04 = /* #__PURE__ */ function() {
    return {
        throwError: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        Monad0: function() {
            return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
        }
    };
}();
var $5dfefa023749ded0$export$e4992fc673e7b027 = {
    throwError: $ad2cf6904bca3ba1$export$de0c4a986b439e52,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $5dfefa023749ded0$export$438e6a8af9a8a22d = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1($05149ea687d6b460$export$523c0b569236b342);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 79, column 1 - line 81, column 33): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$fff877a725e9aba1;
    }
};
var $5dfefa023749ded0$export$abb16404f142771a = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 72, column 1 - line 74, column 35): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$390154ec55cffb04;
    }
};
var $5dfefa023749ded0$export$434b8bb3cd954f77 = {
    catchError: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ad2cf6904bca3ba1$export$d49c1c6bf2cedce5),
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$e4992fc673e7b027;
    }
};
var $5dfefa023749ded0$export$1cf01ae67112be7b = function(dictMonadThrow) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0());
    return function(error) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(throwError1(error))(pure);
    };
};
var $5dfefa023749ded0$export$bd6bd7bb5418f998 = function(dictMonadThrow) {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0()));
};
var $5dfefa023749ded0$export$3dede90624df3ba9 = function(dict) {
    return dict.catchError;
};
var $5dfefa023749ded0$export$b726b0cdf642257a = function(dictMonadError) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadError.MonadThrow0());
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    return function(p) {
        return function(act) {
            return function(handler) {
                var handle = function(e) {
                    var v = p(e);
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return throwError1(e);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return handler(v.value0);
                    throw new Error("Failed pattern match at Control.Monad.Error.Class (line 57, column 5 - line 59, column 26): " + [
                        v.constructor.name
                    ]);
                };
                return catchError1(act)(handle);
            };
        };
    };
};
var $5dfefa023749ded0$export$410a452afcd48948 = function(dictMonadError) {
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(a) {
        return catchError1(map($7d4cccdf062a2261$export$19db0165690c701a.create)(a))(function($52) {
            return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($52));
        });
    };
};
var $5dfefa023749ded0$export$8f240c41514f3a3e = function(dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var try1 = $5dfefa023749ded0$export$410a452afcd48948(dictMonadError);
    var discard1 = $5dfefa023749ded0$var$discard(Bind1);
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(MonadThrow0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(acquire) {
        return function(release) {
            return function(kleisli) {
                return bind(acquire)(function(resource) {
                    return bind(try1(kleisli(resource)))(function(result) {
                        return discard1(release(resource))(function() {
                            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(throwError1)(pure)(result);
                        });
                    });
                });
            };
        };
    };
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

var $a1e0a82f0b162743$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $a1e0a82f0b162743$export$15718d19459d1753 = {
    defer: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $a1e0a82f0b162743$export$5dc1db391e531241 = {
    defer: function(f) {
        return function(x) {
            return f($05149ea687d6b460$export$523c0b569236b342)(x);
        };
    }
};
var $a1e0a82f0b162743$export$260e5c0943f31606 = function(dict) {
    return dict.defer;
};
var $a1e0a82f0b162743$export$d838837eb5b184e3 = function(dictLazy) {
    var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(f) {
        var $lazy_go = $a1e0a82f0b162743$var$$runtime_lazy("go", "Control.Lazy", function() {
            return defer1(function(v) {
                return f($lazy_go(25));
            });
        });
        var go = $lazy_go(25);
        return go;
    };
};






// Generated by purs version 0.15.15
const $083bebfcbf303ad1$export$e5682d87e23bb875 = function(b1) {
    return function(b2) {
        return b1 && b2;
    };
};
const $083bebfcbf303ad1$export$4edd36328926db3d = function(b1) {
    return function(b2) {
        return b1 || b2;
    };
};
const $083bebfcbf303ad1$export$856531720ce57da6 = function(b) {
    return !b;
};






var $f8fc227945eb179e$export$4c5e47bb71c07b6a = function(dict) {
    return dict.ttRecord;
};
var $f8fc227945eb179e$export$80bf595f9d9a1157 = function(dict) {
    return dict.tt;
};
var $f8fc227945eb179e$export$242da53d3ad27a73 = function(dict) {
    return dict.notRecord;
};
var $f8fc227945eb179e$export$6003a5f097c73977 = function(dict) {
    return dict.not;
};
var $f8fc227945eb179e$export$30918bdfe7eba090 = function(dict) {
    return dict.impliesRecord;
};
var $f8fc227945eb179e$export$6c53455e54f455ef = function(dict) {
    return dict.implies;
};
var $f8fc227945eb179e$export$960158ea2ad21b8d = {
    ff: $05149ea687d6b460$export$523c0b569236b342,
    tt: $05149ea687d6b460$export$523c0b569236b342,
    implies: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    conj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    disj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    not: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $f8fc227945eb179e$export$456c60aba1aeaaa = {
    conjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    disjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    ffRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    impliesRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    notRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    ttRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $f8fc227945eb179e$export$7347fefc6a9ef6b6 = /* #__PURE__ */ function() {
    return {
        conj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        disj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        implies: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        ff: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        not: function(v) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        },
        tt: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $f8fc227945eb179e$export$1b03126bff237ceb = function(dict) {
    return dict.ffRecord;
};
var $f8fc227945eb179e$export$f59495b1b7502b33 = function(dict) {
    return dict.ff;
};
var $f8fc227945eb179e$export$84e5fab3d833d7a2 = function(dict) {
    return dict.disjRecord;
};
var $f8fc227945eb179e$export$9bd7ee00e37438db = function(dict) {
    return dict.disj;
};
var $f8fc227945eb179e$export$d7d9283ee84f4c3f = {
    ff: false,
    tt: true,
    implies: function(a) {
        return function(b) {
            return $f8fc227945eb179e$export$9bd7ee00e37438db($f8fc227945eb179e$export$d7d9283ee84f4c3f)($f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f)(a))(b);
        };
    },
    conj: $083bebfcbf303ad1$export$e5682d87e23bb875,
    disj: $083bebfcbf303ad1$export$4edd36328926db3d,
    not: $083bebfcbf303ad1$export$856531720ce57da6
};
var $f8fc227945eb179e$export$49ae8d06200d7fce = function(dict) {
    return dict.conjRecord;
};
var $f8fc227945eb179e$export$7f2b975cf624805f = function() {
    return function(dictHeytingAlgebraRecord) {
        return {
            ff: $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            tt: $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            conj: $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            disj: $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            implies: $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            not: $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $f8fc227945eb179e$export$fb254c661fe9c0db = function(dict) {
    return dict.conj;
};
var $f8fc227945eb179e$export$e9ae480d80dfc592 = function(dictHeytingAlgebra) {
    var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: function(v) {
            return ff1;
        },
        tt: function(v) {
            return tt1;
        },
        implies: function(f) {
            return function(g) {
                return function(a) {
                    return implies1(f(a))(g(a));
                };
            };
        },
        conj: function(f) {
            return function(g) {
                return function(a) {
                    return conj1(f(a))(g(a));
                };
            };
        },
        disj: function(f) {
            return function(g) {
                return function(a) {
                    return disj1(f(a))(g(a));
                };
            };
        },
        not: function(f) {
            return function(a) {
                return not1(f(a));
            };
        }
    };
};
var $f8fc227945eb179e$export$8b20a52b1d1213a4 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictHeytingAlgebraRecord) {
            var conjRecord1 = $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord);
            var disjRecord1 = $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord);
            var impliesRecord1 = $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord);
            var ffRecord1 = $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord);
            var notRecord1 = $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord);
            var ttRecord1 = $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord);
            return function(dictHeytingAlgebra) {
                var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
                var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
                var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
                var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
                var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
                var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
                return {
                    conjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = conjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(conj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    disjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = disjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(disj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    impliesRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = impliesRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(implies1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    ffRecord: function(v) {
                        return function(row) {
                            var tail = ffRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(ff1)(tail);
                        };
                    },
                    notRecord: function(v) {
                        return function(row) {
                            var tail = notRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                            return insert(not1(get(row)))(tail);
                        };
                    },
                    ttRecord: function(v) {
                        return function(row) {
                            var tail = ttRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(tt1)(tail);
                        };
                    }
                };
            };
        };
    };
};










var $71f2e2e9476163f8$export$1908877435b1d5e9 = /* #__PURE__ */ function() {
    function Tuple(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple.create = function(value0) {
        return function(value1) {
            return new Tuple(value0, value1);
        };
    };
    return Tuple;
}();
var $71f2e2e9476163f8$export$7864d59d01b6d6bf = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $71f2e2e9476163f8$export$b0e76d9850c64156 = function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value0);
};
var $71f2e2e9476163f8$export$6f71268a1666ab58 = function(v) {
    return v.value1;
};
var $71f2e2e9476163f8$export$c29279d1dfdefb95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Tuple " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $71f2e2e9476163f8$export$a55548456e48767 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    return function(dictSemiring1) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring1);
        var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring1);
        return {
            add: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(add(v.value0)(v1.value0), add1(v.value1)(v1.value1));
                };
            },
            one: new $71f2e2e9476163f8$export$1908877435b1d5e9(one, $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring1)),
            mul: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(mul(v.value0)(v1.value0), mul1(v.value1)(v1.value1));
                };
            },
            zero: new $71f2e2e9476163f8$export$1908877435b1d5e9(zero, $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring1))
        };
    };
};
var $71f2e2e9476163f8$export$ab2b4b200e457b99 = {
    compose: function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1);
        };
    }
};
var $71f2e2e9476163f8$export$1f8404c41aab4117 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$9ba4b2debe474100 = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringTuple1 = $71f2e2e9476163f8$export$a55548456e48767(dictRing.Semiring0());
    return function(dictRing1) {
        var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing1);
        var semiringTuple2 = semiringTuple1(dictRing1.Semiring0());
        return {
            sub: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(sub(v.value0)(v1.value0), sub1(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$a9eaa17b3ab5a78d = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupTuple1 = $71f2e2e9476163f8$export$1f8404c41aab4117(dictMonoid.Semigroup0());
    return function(dictMonoid1) {
        var semigroupTuple2 = semigroupTuple1(dictMonoid1.Semigroup0());
        return {
            mempty: new $71f2e2e9476163f8$export$1908877435b1d5e9(mempty, $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
            Semigroup0: function() {
                return semigroupTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$47e10f15d8f6e8d8 = function(dictHeytingAlgebra) {
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return function(dictHeytingAlgebra1) {
        var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra1);
        var conj2 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra1);
        var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra1);
        var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra1);
        return {
            tt: new $71f2e2e9476163f8$export$1908877435b1d5e9(tt, $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra1)),
            ff: new $71f2e2e9476163f8$export$1908877435b1d5e9(ff, $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra1)),
            implies: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(implies(v.value0)(v1.value0), implies1(v.value1)(v1.value1));
                };
            },
            conj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(conj1(v.value0)(v1.value0), conj2(v.value1)(v1.value1));
                };
            },
            disj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(disj(v.value0)(v1.value0), disj1(v.value1)(v1.value1));
                };
            },
            not: function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(not(v.value0), not1(v.value1));
            }
        };
    };
};
var $71f2e2e9476163f8$export$8b71b9e63ea20f7b = {
    to: function(x) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(x.value0, x.value1);
    },
    from: function(x) {
        return new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1);
    }
};
var $71f2e2e9476163f8$export$19ab04734dcb0ff0 = {
    map: function(f) {
        return function(m) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(m.value0, f(m.value1));
        };
    }
};
var $71f2e2e9476163f8$export$9801206bd382aee0 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($71f2e2e9476163f8$export$19ab04734dcb0ff0)
};
var $71f2e2e9476163f8$export$9e770fa6ce19a9d6 = function(v) {
    return v.value0;
};
var $71f2e2e9476163f8$export$28de2725b8db0d42 = function(dictLazy) {
    var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(dictLazy1) {
        var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy1);
        return {
            defer: function(f) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(defer(function(v) {
                    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(f($05149ea687d6b460$export$523c0b569236b342));
                }), defer1(function(v) {
                    return $71f2e2e9476163f8$export$6f71268a1666ab58(f($05149ea687d6b460$export$523c0b569236b342));
                }));
            }
        };
    };
};
var $71f2e2e9476163f8$export$1d78bbb1aca8569c = {
    extend: function(f) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v));
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $71f2e2e9476163f8$export$d625e8a97ba36bd6 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$8f11eb03746a66e2 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$11462014c11c050e = function(dictEq) {
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqTuple1(dictEq1));
        }
    };
};
var $71f2e2e9476163f8$export$2c05c340f808b07c = function(dictOrd) {
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictOrd);
    var eq1Tuple1 = $71f2e2e9476163f8$export$11462014c11c050e(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordTuple1(dictOrd1));
        },
        Eq10: function() {
            return eq1Tuple1;
        }
    };
};
var $71f2e2e9476163f8$export$c3095a23b368d1f2 = function(f) {
    return function(a) {
        return function(b) {
            return f(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, b));
        };
    };
};
var $71f2e2e9476163f8$export$8e995acc5599767e = {
    extract: $71f2e2e9476163f8$export$6f71268a1666ab58,
    Extend0: function() {
        return $71f2e2e9476163f8$export$1d78bbb1aca8569c;
    }
};
var $71f2e2e9476163f8$export$4b53a8a87c01bf43 = function(dictCommutativeRing) {
    var ringTuple1 = $71f2e2e9476163f8$export$9ba4b2debe474100(dictCommutativeRing.Ring0());
    return function(dictCommutativeRing1) {
        var ringTuple2 = ringTuple1(dictCommutativeRing1.Ring0());
        return {
            Ring0: function() {
                return ringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$f1ad4da5028a9f5f = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordTuple2 = ordTuple1(dictBounded1.Ord0());
        return {
            top: new $71f2e2e9476163f8$export$1908877435b1d5e9(top, $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $71f2e2e9476163f8$export$1908877435b1d5e9(bottom, $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded1)),
            Ord0: function() {
                return ordTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$cc556dd69d46ad4 = function(dictBooleanAlgebra) {
    var heytingAlgebraTuple1 = $71f2e2e9476163f8$export$47e10f15d8f6e8d8(dictBooleanAlgebra.HeytingAlgebra0());
    return function(dictBooleanAlgebra1) {
        var heytingAlgebraTuple2 = heytingAlgebraTuple1(dictBooleanAlgebra1.HeytingAlgebra0());
        return {
            HeytingAlgebra0: function() {
                return heytingAlgebraTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$c87751c00e30fc9e = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v.value1(v1.value1));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $71f2e2e9476163f8$export$5266c91ec2409601 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictSemigroup);
    return {
        bind: function(v) {
            return function(f) {
                var v1 = f(v.value1);
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v1.value1);
            };
        },
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$2f2c2cdaef7b685e = function(dictMonoid) {
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictMonoid.Semigroup0());
    return {
        pure: $71f2e2e9476163f8$export$1908877435b1d5e9.create($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$d5a06b0f6aa5b11a = function(dictMonoid) {
    var applicativeTuple1 = $71f2e2e9476163f8$export$2f2c2cdaef7b685e(dictMonoid);
    var bindTuple1 = $71f2e2e9476163f8$export$5266c91ec2409601(dictMonoid.Semigroup0());
    return {
        Applicative0: function() {
            return applicativeTuple1;
        },
        Bind1: function() {
            return bindTuple1;
        }
    };
};


var $20615e99b278adf5$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $20615e99b278adf5$export$eb54baf0b342cb1d = function(dict) {
    return dict.bimap;
};
var $20615e99b278adf5$export$2ad466be2e2b0196 = function(dictBifunctor) {
    var bimap1 = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return function(f) {
        return bimap1(f)($20615e99b278adf5$var$identity);
    };
};
var $20615e99b278adf5$export$6630987c9d273301 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($20615e99b278adf5$var$identity);
};
var $20615e99b278adf5$export$34a2521cb7920188 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), g(v.value1));
            };
        };
    }
};
var $20615e99b278adf5$export$9b66d4861c364eff = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v2.value0));
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1(v2.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 32, column 1 - line 34, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $20615e99b278adf5$export$52f77c2cc8ef8f31 = {
    bimap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};




// Generated by purs version 0.15.15
/* globals setImmediate, clearImmediate, setTimeout, clearTimeout */ /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */ var $b28443a27438717a$var$Aff = function() {
    // A unique value for empty.
    var EMPTY = {};
    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */ var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */ var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    // Various constructors used in interpretation
    var CONS = "Cons"; // Cons-list, for stacks
    var RESUME = "Resume"; // Continue indiscriminately
    var RELEASE = "Release"; // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED = "Forked"; // Reference to a forked fiber, with resumption stack
    var FIBER = "Fiber"; // Actual fiber reference
    var THUNK = "Thunk"; // Primed effect, ready to invoke
    function Aff(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler(error) {
        return new Aff(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error) {
            setTimeout(function() {
                throw error;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error) {
            return left(error);
        }
    }
    function runAsync(left, eff, k) {
        try {
            return eff(k)();
        } catch (error) {
            k(left(error))();
            return nonCanceler;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size !== 0){
                size--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i, tmp;
                if (size === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size) % limit] = cb;
                size++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result) && util.fromLeft(result)) setTimeout(function() {
                                    throw util.fromLeft(result);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k in fibers)if (fibers.hasOwnProperty(k)) {
                        killCount++;
                        kill(k);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error) {
                        return new Aff(SYNC, function() {
                            for(var k in kills)if (kills.hasOwnProperty(k)) kills[k]();
                        });
                    };
                };
            }
        };
    }
    // Fiber state machine
    var SUSPENDED = 0; // Suspended, pending a join.
    var CONTINUE = 1; // Interpret the next instruction.
    var STEP_BIND = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING = 4; // An async effect is running.
    var RETURN = 5; // The current stack has returned.
    var COMPLETED = 6; // The entire fiber has completed.
    function Fiber(util, supervisor, aff) {
        // Monotonically increasing tick, increased on each asynchronous turn.
        var runTick = 0;
        // The current branch of the state machine.
        var status = SUSPENDED;
        // The current point of interest for the state machine branch.
        var step = aff; // Successful step
        var fail = null; // Failure step
        var interrupt = null; // Asynchronous interrupt
        // Stack of continuations for the current fiber.
        var bhead = null;
        var btail = null;
        // Stack of attempts and finalizers for error recovery. Every `Cons` is also
        // tagged with current `interrupt` state. We use this to track which items
        // should be ignored or evaluated as a result of a kill.
        var attempts = null;
        // A special state is needed for Bracket, because it cannot be killed. When
        // we enter a bracket acquisition or finalizer, we increment the counter,
        // and then decrement once complete.
        var bracketCount = 0;
        // Each join gets a new id so they can be revoked.
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        // Each invocation of `run` requires a tick. When an asynchronous effect is
        // resolved, we must check that the local tick coincides with the fiber
        // tick before resuming. This prevents multiple async continuations from
        // accidentally resuming the same fiber. A common example may be invoking
        // the provided callback in `makeAff` more than once, but it may also be an
        // async effect resuming after the fiber was already cancelled.
        function run(localRunTick) {
            var tmp, result, attempt;
            while(true){
                tmp = null;
                result = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step = bhead(step);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail = util.left(e);
                            step = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step)) {
                            status = RETURN;
                            fail = step;
                            step = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step = util.fromRight(step);
                        }
                        break;
                    case CONTINUE:
                        switch(step.tag){
                            case BIND:
                                if (bhead) btail = new Aff(CONS, bhead, btail);
                                bhead = step._2;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step = util.right(step._1);
                                } else {
                                    status = STEP_BIND;
                                    step = step._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step = runSync(util.left, util.right, step._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step = runAsync(util.left, step._1, function(result) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            // It's possible to interrupt the fiber between enqueuing and
                                            // resuming, so we need to check that the runTick is still
                                            // valid.
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step = result;
                                            run(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail = util.left(step._1);
                                step = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step._1) tmp.run();
                                step = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step = sequential(util, supervisor, step._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        // If the current stack has returned, and we have no other stacks to
                        // resume or finalizers to run, the fiber has halted and we can
                        // invoke all join callbacks. Otherwise we need to resume.
                        if (attempts === null) {
                            status = COMPLETED;
                            step = interrupt || fail || step;
                        } else {
                            // The interrupt status for the enqueued item.
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    // We should compare the interrupt status as well because we
                                    // only want it to apply if there has been an interrupt since
                                    // enqueuing the catch.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail) {
                                        status = CONTINUE;
                                        step = attempt._2(util.fromLeft(fail));
                                        fail = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    // As with Catch, we only want to ignore in the case of an
                                    // interrupt since enqueing the item.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step = util.fromRight(step);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail === null) {
                                        result = util.fromRight(step);
                                        // We need to enqueue the Release with the same interrupt
                                        // status as the Bracket that is initiating it.
                                        attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                                        // We should only coninue as long as the interrupt status has not changed or
                                        // we are currently within a non-interruptable finalizer.
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step = attempt._3(result);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    // It has only been killed if the interrupt status has changed
                                    // since we enqueued the item, and the bracket count is 0. If the
                                    // bracket count is non-zero then we are in a masked state so it's
                                    // impossible to be killed.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail) step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                                    else step = attempt._1.completed(util.fromRight(step))(attempt._2);
                                    fail = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    step = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step = attempt._1;
                                    fail = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k in joins)if (joins.hasOwnProperty(k)) {
                            rethrow = rethrow && joins[k].rethrow;
                            runEff(joins[k].handler(step));
                        }
                        joins = null;
                        // If we have an interrupt and a fail, then the thread threw while
                        // running finalizers. This should always rethrow in a fresh stack.
                        if (interrupt && fail) setTimeout(function() {
                            throw util.fromLeft(fail);
                        }, 0);
                        else if (util.isLeft(step) && rethrow) setTimeout(function() {
                            // Guard on reathrow because a completely synchronous fiber can
                            // still have an observer which was added after-the-fact.
                            if (rethrow) throw util.fromLeft(step);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join.rethrow;
                    join.handler(step)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill(error, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error);
                        status = COMPLETED;
                        step = interrupt;
                        run(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
                            status = RETURN;
                            step = null;
                            fail = null;
                            run(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step = null;
                            fail = null;
                        }
                }
                return canceler;
            };
        }
        function join(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run(runTick);
                return canceler;
            };
        }
        return {
            kill: kill,
            join: join,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run(runTick);
                    });
                    else run(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        // Table of all forked fibers.
        var fiberId = 0;
        var fibers = {};
        // Table of currently running cancelers, as a product of `Alt` behavior.
        var killId = 0;
        var kills = {};
        // Error used for early cancelation on Alt branches.
        var early = new Error("[ParAff] Early exit");
        // Error used to kill the entire tree.
        var interrupt = null;
        // The root pointer of the tree.
        var root = EMPTY;
        // Walks a tree, invoking all the cancelers. Returns the table of pending
        // cancellation fibers.
        function kill(error, par, cb) {
            var step = par;
            var head = null;
            var tail = null;
            var count = 0;
            var kills = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step.tag){
                    case FORKED:
                        if (step._3 === EMPTY) {
                            tmp = fibers[step._1];
                            kills[count++] = tmp.kill(error, function(result) {
                                return function() {
                                    count--;
                                    if (count === 0) cb(result)();
                                };
                            });
                        }
                        // Terminal case.
                        if (head === null) break loop;
                        // Go down the right side of the tree.
                        step = head._2;
                        if (tail === null) head = null;
                        else {
                            head = tail._1;
                            tail = tail._2;
                        }
                        break;
                    case MAP:
                        step = step._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head) tail = new Aff(CONS, head, tail);
                        head = step;
                        step = step._1;
                        break;
                }
            }
            if (count === 0) cb(util.right(void 0))();
            else {
                // Run the cancelation effects. We alias `count` because it's mutable.
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills[kid] = kills[kid]();
            }
            return kills;
        }
        // When a fiber resolves, we need to bubble back up the tree with the
        // result, computing the applicative nodes.
        function join(result, head, tail) {
            var fail, step, lhs, rhs, tmp, kid;
            if (util.isLeft(result)) {
                fail = result;
                step = null;
            } else {
                step = result;
                fail = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                // We should never continue if the entire tree has been interrupted.
                if (interrupt !== null) return;
                // We've made it all the way to the root of the tree, which means
                // the tree has fully evaluated.
                if (head === null) {
                    cb(fail || step)();
                    return;
                }
                // The tree has already been computed, so we shouldn't try to do it
                // again. This should never happen.
                // TODO: Remove this?
                if (head._3 !== EMPTY) return;
                switch(head.tag){
                    case MAP:
                        if (fail === null) {
                            head._3 = util.right(head._1(util.fromRight(step)));
                            step = head._3;
                        } else head._3 = fail;
                        break;
                    case APPLY:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // If we have a failure we should kill the other side because we
                        // can't possible yield a result anymore.
                        if (fail) {
                            head._3 = fail;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(fail, null, null);
                                    else join(fail, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) // We can only proceed if both sides have resolved.
                        return;
                        else {
                            step = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head._3 = step;
                        }
                        break;
                    case ALT:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // We can only proceed if both have resolved or we have a success
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        // If both sides resolve with an error, we should continue with the
                        // first error
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail = step === lhs ? rhs : lhs;
                            step = null;
                            head._3 = fail;
                        } else {
                            head._3 = step;
                            tmp = true;
                            kid = killId++;
                            // Once a side has resolved, we need to cancel the side that is still
                            // pending before we can continue.
                            kills[kid] = kill(early, step === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(step, null, null);
                                    else join(step, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail === null) head = null;
                else {
                    head = tail._1;
                    tail = tail._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result;
                    join(result, fiber._2._1, fiber._2._2);
                };
            };
        }
        // Walks the applicative tree, substituting non-applicative nodes with
        // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
        // as a mutable slot for memoization. In an unresolved state, the `_3`
        // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
        // the left side first, because both operations are left-associative. As
        // we `RETURN` from those branches, we then walk the right side.
        function run() {
            var status = CONTINUE;
            var step = par;
            var head = null;
            var tail = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step.tag){
                            case MAP:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(MAP, step._1, EMPTY, EMPTY);
                                step = step._2;
                                break;
                            case APPLY:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(APPLY, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            case ALT:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(ALT, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            default:
                                // When we hit a leaf value, we suspend the stack in the `FORKED`.
                                // When the fiber resolves, it can bubble back up the tree.
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step;
                                step = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        // Terminal case, we are back at the root.
                        if (head === null) break loop;
                        // If we are done with the right side, we need to continue down the
                        // left. Otherwise we should continue up the stack.
                        if (head._1 === EMPTY) {
                            head._1 = step;
                            status = CONTINUE;
                            step = head._2;
                            head._2 = EMPTY;
                        } else {
                            head._2 = step;
                            step = head;
                            if (tail === null) head = null;
                            else {
                                head = tail._1;
                                tail = tail._2;
                            }
                        }
                }
            }
            // Keep a reference to the tree root so it can be cancelled.
            root = step;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        // Cancels the entire tree. If there are already subtrees being canceled,
        // we need to first cancel those joins. We will then add fresh joins for
        // all pending branches including those that were in the process of being
        // canceled.
        function cancel(error, cb) {
            interrupt = util.left(error);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill(error, root, cb);
            return function(killError) {
                return new Aff(ASYNC, function(killCb) {
                    return function() {
                        for(var kid in newKills)if (newKills.hasOwnProperty(kid)) newKills[kid]();
                        return nonCanceler;
                    };
                });
            };
        }
        run();
        return function(killError) {
            return new Aff(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential(util, supervisor, par) {
        return new Aff(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff.EMPTY = EMPTY;
    Aff.Pure = AffCtr(PURE);
    Aff.Throw = AffCtr(THROW);
    Aff.Catch = AffCtr(CATCH);
    Aff.Sync = AffCtr(SYNC);
    Aff.Async = AffCtr(ASYNC);
    Aff.Bind = AffCtr(BIND);
    Aff.Bracket = AffCtr(BRACKET);
    Aff.Fork = AffCtr(FORK);
    Aff.Seq = AffCtr(SEQ);
    Aff.ParMap = AffCtr(MAP);
    Aff.ParApply = AffCtr(APPLY);
    Aff.ParAlt = AffCtr(ALT);
    Aff.Fiber = Fiber;
    Aff.Supervisor = Supervisor;
    Aff.Scheduler = Scheduler;
    Aff.nonCanceler = nonCanceler;
    return Aff;
}();
const $b28443a27438717a$export$68c6660df485915b = $b28443a27438717a$var$Aff.Pure;
const $b28443a27438717a$export$520252a01094c36e = $b28443a27438717a$var$Aff.Throw;
function $b28443a27438717a$export$eb5e86cd5464556e(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Catch(aff, k);
    };
}
function $b28443a27438717a$export$a0135aecf4a782ab(f) {
    return function(aff) {
        if (aff.tag === $b28443a27438717a$var$Aff.Pure.tag) return $b28443a27438717a$var$Aff.Pure(f(aff._1));
        else return $b28443a27438717a$var$Aff.Bind(aff, function(value) {
            return $b28443a27438717a$var$Aff.Pure(f(value));
        });
    };
}
function $b28443a27438717a$export$8fe95d71d8c6b6f3(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Bind(aff, k);
    };
}
function $b28443a27438717a$export$f97e7884af471963(immediate) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.Fork(immediate, aff);
    };
}
const $b28443a27438717a$export$3c6532f01a0290eb = $b28443a27438717a$var$Aff.Sync;
function $b28443a27438717a$export$68695d37eb163711(f) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.ParMap(f, aff);
    };
}
function $b28443a27438717a$export$bce00526579b3344(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParApply(aff1, aff2);
    };
}
function $b28443a27438717a$export$6a44b66c7edadaa(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParAlt(aff1, aff2);
    };
}
const $b28443a27438717a$export$49d5975414e0a979 = $b28443a27438717a$var$Aff.Async;
function $b28443a27438717a$export$9ad792f02752f447(acquire) {
    return function(options) {
        return function(k) {
            return $b28443a27438717a$var$Aff.Bracket(acquire, options, k);
        };
    };
}
function $b28443a27438717a$export$f24188c8fd3f1234(util, aff) {
    return function() {
        return $b28443a27438717a$var$Aff.Fiber(util, null, aff);
    };
}
function $b28443a27438717a$export$7a3baea9562462c7(util, aff) {
    return function() {
        var supervisor = $b28443a27438717a$var$Aff.Supervisor(util);
        return {
            fiber: $b28443a27438717a$var$Aff.Fiber(util, supervisor, aff),
            supervisor: supervisor
        };
    };
}
function $b28443a27438717a$export$a494cc11bfc0c750(error, supervisor, cb) {
    return supervisor.killAll(error, cb);
}
const $b28443a27438717a$export$389c1406f5ae6ae7 = function() {
    function setDelay(n, k) {
        if (n === 0 && typeof setImmediate !== "undefined") return setImmediate(k);
        else return setTimeout(k, n);
    }
    function clearDelay(n, t) {
        if (n === 0 && typeof clearImmediate !== "undefined") return clearImmediate(t);
        else return clearTimeout(t);
    }
    return function(right, ms) {
        return $b28443a27438717a$var$Aff.Async(function(cb) {
            return function() {
                var timer = setDelay(ms, cb(right()));
                return function() {
                    return $b28443a27438717a$var$Aff.Sync(function() {
                        return right(clearDelay(ms, timer));
                    });
                };
            };
        });
    };
}();
const $b28443a27438717a$export$139486a45824a247 = $b28443a27438717a$var$Aff.Seq;







// Generated by purs version 0.15.15




// Generated by purs version 0.15.15




var $50c50d1f444e5fa4$export$544bf02140fa9a77 = function(x) {
    return x;
};
var $50c50d1f444e5fa4$export$7af8a265c45f06a6 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Identity " + (show(v) + ")");
        }
    };
};
var $50c50d1f444e5fa4$export$de6e130f3067e173 = function(dictSemiring) {
    return dictSemiring;
};
var $50c50d1f444e5fa4$export$fbd9f08ec652d5d9 = function(dictSemigroup) {
    return dictSemigroup;
};
var $50c50d1f444e5fa4$export$7f1a4089c064b339 = function(dictRing) {
    return dictRing;
};
var $50c50d1f444e5fa4$export$af307155aba4d997 = function(dictOrd) {
    return dictOrd;
};
var $50c50d1f444e5fa4$export$4e4e6c89b10840f9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $50c50d1f444e5fa4$export$2f07791950174d24 = function(dictMonoid) {
    return dictMonoid;
};
var $50c50d1f444e5fa4$export$c7656c1a42d43140 = function(dictLazy) {
    return dictLazy;
};
var $50c50d1f444e5fa4$export$7e3f9626786077f7 = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $50c50d1f444e5fa4$export$dc85e8383eafbd81 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $50c50d1f444e5fa4$export$ace4d1c3770c9591 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($50c50d1f444e5fa4$export$dc85e8383eafbd81)
};
var $50c50d1f444e5fa4$export$a04fa6f5a41919d9 = {
    extend: function(f) {
        return function(m) {
            return f(m);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$4d1b13d40da4cff7 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $50c50d1f444e5fa4$export$b3449ff235884fd4 = function(dictEq) {
    return dictEq;
};
var $50c50d1f444e5fa4$export$43b3c8db16b4e7b8 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($50c50d1f444e5fa4$export$b3449ff235884fd4(dictEq));
    }
};
var $50c50d1f444e5fa4$export$982c033a83dfd7d3 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($50c50d1f444e5fa4$export$af307155aba4d997(dictOrd));
    },
    Eq10: function() {
        return $50c50d1f444e5fa4$export$43b3c8db16b4e7b8;
    }
};
var $50c50d1f444e5fa4$export$aac6efd7b2eac4c4 = {
    extract: function(v) {
        return v;
    },
    Extend0: function() {
        return $50c50d1f444e5fa4$export$a04fa6f5a41919d9;
    }
};
var $50c50d1f444e5fa4$export$133f9093a008dc4d = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $50c50d1f444e5fa4$export$5be407eed81cb759 = function(dictBounded) {
    return dictBounded;
};
var $50c50d1f444e5fa4$export$c3b024d9c40a32df = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $50c50d1f444e5fa4$export$c7d2c62721e92954 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$91e759983456b85e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$fd3b2458e55fc503 = {
    pure: $50c50d1f444e5fa4$export$544bf02140fa9a77,
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0 = {
    Applicative0: function() {
        return $50c50d1f444e5fa4$export$fd3b2458e55fc503;
    },
    Bind1: function() {
        return $50c50d1f444e5fa4$export$91e759983456b85e;
    }
};
var $50c50d1f444e5fa4$export$1cd7ff14f6a7fcef = {
    alt: function(x) {
        return function(v) {
            return x;
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};







// Generated by purs version 0.15.15
const $e521936ea118867a$export$339fb7f00efd6941 = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
const $e521936ea118867a$export$d23276e97b1411ef = function(f) {
    return function() {
        var ref = {
            value: null
        };
        ref.value = f(ref);
        return ref;
    };
};
const $e521936ea118867a$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $e521936ea118867a$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $e521936ea118867a$export$68d8715fc104d294 = function(val) {
    return function(ref) {
        return function() {
            ref.value = val;
        };
    };
};




var $90327512d8280b8d$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $90327512d8280b8d$export$b8cb59497041ffe4 = $e521936ea118867a$export$339fb7f00efd6941;
var $90327512d8280b8d$export$4d5401161a900ce1 = $e521936ea118867a$export$cc2488c59b3f757;
var $90327512d8280b8d$export$3ff57735a52b8713 = function(f) {
    return $90327512d8280b8d$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $90327512d8280b8d$export$45b91115a89d6020 = function(f) {
    return function(s) {
        return $90327512d8280b8d$var$$$void($90327512d8280b8d$export$3ff57735a52b8713(f)(s));
    };
};


var $f93520de2fa37b44$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f93520de2fa37b44$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f93520de2fa37b44$export$550acbd06a1f5a6a = /* #__PURE__ */ function() {
    function Loop(value0) {
        this.value0 = value0;
    }
    Loop.create = function(value0) {
        return new Loop(value0);
    };
    return Loop;
}();
var $f93520de2fa37b44$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done(value0) {
        this.value0 = value0;
    }
    Done.create = function(value0) {
        return new Done(value0);
    };
    return Done;
}();
var $f93520de2fa37b44$export$c025cfd4cc93300b = function(dict) {
    return dict.tailRecM;
};
var $f93520de2fa37b44$export$9056a6bb308e8c79 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return tailRecM1(function(o) {
                    return f(o.a)(o.b);
                })({
                    a: a,
                    b: b
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$db5fda1cbdfd94f2 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return tailRecM1(function(o) {
                        return f(o.a)(o.b)(o.c);
                    })({
                        a: a,
                        b: b,
                        c: c
                    });
                };
            };
        };
    };
};
var $f93520de2fa37b44$export$f216db41e265325c = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(m) {
        return tailRecM1(function(v) {
            return mapFlipped(m)(function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1.value0);
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 179, column 43 - line 181, column 19): " + [
                    v1.constructor.name
                ]);
            });
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$4f7c5e075dda46f7 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(dictMonadRec) {
        var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
        return function(m) {
            return tailRecM1(function(v) {
                return mapFlipped(m)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(append(v)(v1.value0));
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 172, column 45 - line 174, column 26): " + [
                        v1.constructor.name
                    ]);
                });
            })(mempty);
        };
    };
};
var $f93520de2fa37b44$export$2e586eaa876dd2fd = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                $copy_v = f(v.value0);
                return;
            }
            if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) {
                $tco_done = true;
                return v.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go(f($85));
    };
};
var $f93520de2fa37b44$export$1a33088d59e37d84 = function(f) {
    return function(a) {
        return function(b) {
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                return f(o.a)(o.b);
            })({
                a: a,
                b: b
            });
        };
    };
};
var $f93520de2fa37b44$export$6866e5a95a71aa68 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                    return f(o.a)(o.b)(o.c);
                })({
                    a: a,
                    b: b,
                    c: c
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$6a06149683d26749 = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 153, column 7 - line 153, column 31): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $06733ae99ed4f534$export$f78a1c2d38efcc13;
    }
};
var $f93520de2fa37b44$export$ef692454cdd8c2ba = {
    tailRecM: function(f) {
        var runIdentity = function(v) {
            return v;
        };
        var $86 = $f93520de2fa37b44$export$2e586eaa876dd2fd(function($88) {
            return runIdentity(f($88));
        });
        return function($87) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($86($87));
        };
    },
    Monad0: function() {
        return $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0;
    }
};
var $f93520de2fa37b44$export$6871d929a8e135b0 = {
    tailRecM: function(f) {
        return function(a0) {
            return function(e) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(a) {
                    return f(a)(e);
                })(a0);
            };
        };
    },
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $f93520de2fa37b44$export$ddd28c989be5e46c = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
    }
};
var $f93520de2fa37b44$export$c2472dc015e90d28 = {
    tailRecM: function(f) {
        return function(a) {
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v.constructor.name
                ]);
            };
            return function __do() {
                var r = $f93520de2fa37b44$var$bindFlipped($90327512d8280b8d$export$b8cb59497041ffe4)(f(a))();
                (function() {
                    while(!function __do() {
                        var v = $e521936ea118867a$export$aafa59e2e03f2942(r)();
                        if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                            var e = f(v.value0)();
                            $e521936ea118867a$export$68d8715fc104d294(e)(r)();
                            return false;
                        }
                        if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $f93520de2fa37b44$var$map(fromDone)($e521936ea118867a$export$aafa59e2e03f2942(r))();
            };
        };
    },
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f93520de2fa37b44$export$432fdf8e79663288 = function(a) {
    return function(b) {
        return function(c) {
            return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                a: a,
                b: b,
                c: c
            });
        };
    };
};
var $f93520de2fa37b44$export$e10d15f285e25594 = function(a) {
    return function(b) {
        return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
            a: a,
            b: b
        });
    };
};
var $f93520de2fa37b44$export$ff1ade7cb067ac12 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m.value0);
            if (m instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(f(m.value0));
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $f93520de2fa37b44$export$116a0f7f2303acd8 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(ma) {
        return tailRecM1(function(u) {
            return voidRight(new $f93520de2fa37b44$export$550acbd06a1f5a6a(u))(ma);
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$61e43214bca7f031 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(v(v2.value0));
                if (v2 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1(v2.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// module Unsafe.Coerce
const $ac8b3532514ac019$export$401372c57776dc = function(x) {
    return x;
};




var $2b857e558a2a0921$export$2bf63e57346d9602 = $ac8b3532514ac019$export$401372c57776dc;


// Generated by purs version 0.15.15
const $f11e5cd39add8df2$export$aca8cce159e578de = function(f) {
    return function(a) {
        return function() {
            return f(a());
        };
    };
};
const $f11e5cd39add8df2$export$3bbfc465dcacc7f4 = function(a) {
    return function() {
        return a;
    };
};
const $f11e5cd39add8df2$export$b25ab69b10c0d17b = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $f11e5cd39add8df2$export$889ea624f2cb2c57 = function(f) {
    return f();
};
function $f11e5cd39add8df2$export$f021a974ad8da35c(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
}
function $f11e5cd39add8df2$export$f89de2e5bf57e5e6(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
}
const $f11e5cd39add8df2$export$8802485f9deae94f = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};
function $f11e5cd39add8df2$export$b8cb59497041ffe4(val) {
    return function() {
        return {
            value: val
        };
    };
}
const $f11e5cd39add8df2$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $f11e5cd39add8df2$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $f11e5cd39add8df2$export$68d8715fc104d294 = function(a) {
    return function(ref) {
        return function() {
            return ref.value = a; // eslint-disable-line no-return-assign
        };
    };
};











var $08944f7287e2704c$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $08944f7287e2704c$export$4d5401161a900ce1 = $f11e5cd39add8df2$export$cc2488c59b3f757;
var $08944f7287e2704c$export$3ff57735a52b8713 = function(f) {
    return $08944f7287e2704c$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $08944f7287e2704c$export$a47991927f51461e = {
    map: $f11e5cd39add8df2$export$aca8cce159e578de
};
var $08944f7287e2704c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$export$962073314682c2c = {
    Applicative0: function() {
        return $08944f7287e2704c$export$603d84e49041d7b2;
    },
    Bind1: function() {
        return $08944f7287e2704c$export$14049c9ff5b55fb3;
    }
};
var $08944f7287e2704c$export$14049c9ff5b55fb3 = {
    bind: $f11e5cd39add8df2$export$b25ab69b10c0d17b,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$export$603d84e49041d7b2 = {
    pure: $f11e5cd39add8df2$export$3bbfc465dcacc7f4,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$var$$lazy_applyST = /* #__PURE__ */ $08944f7287e2704c$var$$runtime_lazy("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($08944f7287e2704c$export$962073314682c2c),
        Functor0: function() {
            return $08944f7287e2704c$export$a47991927f51461e;
        }
    };
});
var $08944f7287e2704c$export$65915895b3a8faeb = /* #__PURE__ */ $08944f7287e2704c$var$$lazy_applyST(47);
var $08944f7287e2704c$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($08944f7287e2704c$export$65915895b3a8faeb);
var $08944f7287e2704c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $08944f7287e2704c$export$56941e1c622ade00 = function(dictSemigroup) {
    return {
        append: $08944f7287e2704c$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $08944f7287e2704c$export$24025a1415d0847d = {
    tailRecM: function(f) {
        return function(a) {
            var isLooping = function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return true;
                return false;
            };
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 70, column 32 - line 70, column 46): " + [
                    v.constructor.name
                ]);
            };
            return $08944f7287e2704c$var$bind($08944f7287e2704c$var$bindFlipped($f11e5cd39add8df2$export$b8cb59497041ffe4)(f(a)))(function(r) {
                return $08944f7287e2704c$var$discard($f11e5cd39add8df2$export$f021a974ad8da35c($08944f7287e2704c$var$map(isLooping)($f11e5cd39add8df2$export$aafa59e2e03f2942(r)))($08944f7287e2704c$var$bind($f11e5cd39add8df2$export$aafa59e2e03f2942(r))(function(v) {
                    if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $08944f7287e2704c$var$bind(f(v.value0))(function(e) {
                        return $08944f7287e2704c$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(e)(r));
                    });
                    if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $08944f7287e2704c$var$pure($05149ea687d6b460$export$523c0b569236b342);
                    throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 62, column 18 - line 66, column 28): " + [
                        v.constructor.name
                    ]);
                })))(function() {
                    return $08944f7287e2704c$var$map(fromDone)($f11e5cd39add8df2$export$aafa59e2e03f2942(r));
                });
            });
        };
    },
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $08944f7287e2704c$export$85c55a7e282bbb67 = function(dictMonoid) {
    var semigroupST1 = $08944f7287e2704c$export$56941e1c622ade00(dictMonoid.Semigroup0());
    return {
        mempty: $08944f7287e2704c$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupST1;
        }
    };
};



var $dd1bd2cc217b6a6d$export$162690b6fa074d8b = {
    liftST: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $dd1bd2cc217b6a6d$export$d1b56b21630310a5 = {
    liftST: $2b857e558a2a0921$export$2bf63e57346d9602,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $dd1bd2cc217b6a6d$export$90556654c9c47d5f = function(dict) {
    return dict.liftST;
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
var $67e1952ff57566f7$export$bb801a161a3121f0 = function(dict) {
    return dict.callCC;
};


// Generated by purs version 0.15.15




var $74738728c27df511$export$97f42efbb325fef6 = {
    ask: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $74738728c27df511$export$487d42cd354774ee = {
    local: /* #__PURE__ */ $5807467a73465f3c$export$b5a9558a7176e41b($5807467a73465f3c$export$3af17640bddf7212),
    MonadAsk0: function() {
        return $74738728c27df511$export$97f42efbb325fef6;
    }
};
var $74738728c27df511$export$3bf5078b16209b91 = function(dict) {
    return dict.local;
};
var $74738728c27df511$export$1b4aee0b51c3def8 = function(dict) {
    return dict.ask;
};
var $74738728c27df511$export$5551e829c4b2a916 = function(dictMonadAsk) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonadAsk.Monad0().Bind1().Apply0().Functor0());
    var ask1 = $74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk);
    return function(f) {
        return map(f)(ask1);
    };
};



// Generated by purs version 0.15.15


var $f2d5035ce6148af6$export$ca000e230c0caa3e = function(dict) {
    return dict.state;
};
var $f2d5035ce6148af6$export$327f7b26ebf455db = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(s) {
        return state1(function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, s);
        });
    };
};
var $f2d5035ce6148af6$export$45b91115a89d6020 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, f(s));
        });
    };
};
var $f2d5035ce6148af6$export$3ff57735a52b8713 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            var s$prime = f(s);
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(s$prime, s$prime);
        });
    };
};
var $f2d5035ce6148af6$export$49487f6cbb79019d = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(s), s);
        });
    };
};
var $f2d5035ce6148af6$export$3988ae62b71be9a3 = function(dictMonadState) {
    return $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState)(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(s, s);
    });
};


// Generated by purs version 0.15.15
var $384c24655e07f36c$export$590e8b2c435046d9 = function(dict) {
    return dict.lift;
};





// Generated by purs version 0.15.15


var $f2c9b767d25cfbb9$export$86a2e24932ca2aa0 = {
    liftEffect: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f2c9b767d25cfbb9$export$34255e15eb56d2b3 = function(dict) {
    return dict.liftEffect;
};


var $fca560e14229da4e$export$14010cd19909b6b = function(x) {
    return x;
};
var $fca560e14229da4e$export$2a106bc5b2e64dce = function(f) {
    return function(v) {
        return function(k) {
            return v(f(k));
        };
    };
};
var $fca560e14229da4e$export$358211fab263c66b = function(v) {
    return function(k) {
        return v(k);
    };
};
var $fca560e14229da4e$export$5419b7e78c76e565 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fca560e14229da4e$export$6a2bb59a0c53ce17 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        return function(m) {
            return function(k) {
                return bind(m)(k);
            };
        };
    }
};
var $fca560e14229da4e$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $fca560e14229da4e$export$604f139dbf56bccf = function(f) {
    return function(v) {
        return function(k) {
            return f(v(k));
        };
    };
};
var $fca560e14229da4e$export$232156ef715cfc9b = function(dictFunctor) {
    return {
        map: function(f) {
            return function(v) {
                return function(k) {
                    return v(function(a) {
                        return k(f(a));
                    });
                };
            };
        }
    };
};
var $fca560e14229da4e$export$6b05a2ec606a3559 = function(dictApply) {
    var functorContT1 = $fca560e14229da4e$export$232156ef715cfc9b(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return v(function(g) {
                        return v1(function(a) {
                            return k(g(a));
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorContT1;
        }
    };
};
var $fca560e14229da4e$export$91905d227b995e9d = function(dictBind) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(k$prime) {
                    return v(function(a) {
                        var v1 = k(a);
                        return v1(k$prime);
                    });
                };
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$ebd715a8b64afb39 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($fca560e14229da4e$export$6b05a2ec606a3559(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $fca560e14229da4e$export$d73f0595e894296c = function(dictApplicative) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(k) {
                return k(a);
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$735f43b0215ad39 = function(dictMonad) {
    var applicativeContT1 = $fca560e14229da4e$export$d73f0595e894296c(dictMonad.Applicative0());
    var bindContT1 = $fca560e14229da4e$export$91905d227b995e9d(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeContT1;
        },
        Bind1: function() {
            return bindContT1;
        }
    };
};
var $fca560e14229da4e$export$6062b41302ddcd80 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        ask: $fca560e14229da4e$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$dbf903f187194ce5 = function(dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(MonadAsk0.Monad0().Bind1());
    var ask = $74738728c27df511$export$1b4aee0b51c3def8(MonadAsk0);
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskContT1 = $fca560e14229da4e$export$6062b41302ddcd80(MonadAsk0);
    return {
        local: function(f) {
            return function(v) {
                return function(k) {
                    return bind(ask)(function(r) {
                        return local(f)(v(function() {
                            var $94 = local($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(r));
                            return function($95) {
                                return $94(k($95));
                            };
                        }()));
                    });
                };
            };
        },
        MonadAsk0: function() {
            return monadAskContT1;
        }
    };
};
var $fca560e14229da4e$export$fd982f3f83dedfc9 = function(dictMonad) {
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(dictMonad);
    return {
        callCC: function(f) {
            return function(k) {
                var v = f(function(a) {
                    return function(v1) {
                        return k(a);
                    };
                });
                return v(k);
            };
        },
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$35d988300b9091c9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftEffect: function() {
            var $96 = $fca560e14229da4e$var$lift(Monad0);
            var $97 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($98) {
                return $96($97($98));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$1aa60909d07c5b2d = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        state: function() {
            var $99 = $fca560e14229da4e$var$lift(Monad0);
            var $100 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($101) {
                return $99($100($101));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$845d7a4c5796dca2 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftST: function() {
            var $102 = $fca560e14229da4e$var$lift(Monad0);
            var $103 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($104) {
                return $102($103($104));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$e824ef6fc9053d43 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictApplicative));
    var semigroupContT1 = $fca560e14229da4e$export$ebd715a8b64afb39(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupContT2 = semigroupContT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupContT2;
            }
        };
    };
};


// Generated by purs version 0.15.15












// Generated by purs version 0.15.15



var $2c4a247071255d7e$export$de3113ed932c61ab = function(dict) {
    return dict.tell;
};
var $2c4a247071255d7e$export$167b0ad523238611 = function(dict) {
    return dict.pass;
};
var $2c4a247071255d7e$export$63174c828edd6ff8 = function(dict) {
    return dict.listen;
};
var $2c4a247071255d7e$export$e63807bfd37abcc0 = function(dictMonadWriter) {
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen1 = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return bind(listen1(m))(function(v) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v.value1)));
            });
        };
    };
};
var $2c4a247071255d7e$export$b0a417369eddf9f2 = function(dictMonadWriter) {
    var pass1 = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return pass1(bind(m)(function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, f));
            }));
        };
    };
};








var $d2284b2d3e1b6f87$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $d2284b2d3e1b6f87$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d2284b2d3e1b6f87$export$2e7afd25df37516b = function(x) {
    return x;
};
var $d2284b2d3e1b6f87$export$998a9a780731dd5b = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            var mapLeft = function(v1) {
                return function(v2) {
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0);
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1(v2.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return map1(mapLeft(f))(v);
        };
    };
};
var $d2284b2d3e1b6f87$export$8291c2122093ac93 = function(v) {
    return v;
};
var $d2284b2d3e1b6f87$export$779e60e46c1e0f8b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d2284b2d3e1b6f87$export$fa93accd6d6dc1d2 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return bind(m)(function(a) {
                return pure(new $7d4cccdf062a2261$export$19db0165690c701a(a));
            });
        };
    }
};
var $d2284b2d3e1b6f87$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d2284b2d3e1b6f87$export$d684c62fe584fcfa = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map1($d2284b2d3e1b6f87$var$map(f)));
        }
    };
};
var $d2284b2d3e1b6f87$export$67aba9fb222c5e1d = function(dictApplicative) {
    var $191 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function($192) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($191($192));
    };
};
var $d2284b2d3e1b6f87$export$5a198347e9244c74 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        },
        Bind1: function() {
            return $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($193) {
                    return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($193));
                })(function(a) {
                    var v1 = k(a);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$581feac922061bf0 = function(dictMonad) {
    var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$963960a96c103d2f = function(dictMonad) {
    return {
        pure: function() {
            var $194 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($195) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($194($7d4cccdf062a2261$export$19db0165690c701a.create($195)));
            };
        }(),
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$3539db811b3307bc = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $d2284b2d3e1b6f87$export$90c373eb83297b8e = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        ask: $d2284b2d3e1b6f87$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fb6edd8453289893 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskExceptT1 = $d2284b2d3e1b6f87$export$90c373eb83297b8e(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(local(f));
        },
        MonadAsk0: function() {
            return monadAskExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$aed911633663c3d8 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $7d4cccdf062a2261$export$19db0165690c701a(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$14ff7e4e497a86b1 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftEffect: function() {
            var $196 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $197 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($198) {
                return $196($197($198));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fed8f4223a283613 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        tailRecM: function(f) {
            var $199 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(m$prime.value0));
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 75, column 14 - line 78, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($200) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($199($200));
            };
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$e8228b6b505171fd = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $d2284b2d3e1b6f87$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad1);
    return {
        tell: function() {
            var $201 = $d2284b2d3e1b6f87$var$lift(Monad1);
            var $202 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($203) {
                return $201($202($203));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$a9c9aad9aca5566b = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellExceptT1 = $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9(MonadTell1);
    return {
        listen: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return bind(listen(m))(function(v) {
                return pure($d2284b2d3e1b6f87$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a.value0), $d2284b2d3e1b6f87$var$identity);
                    if (a instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$19db0165690c701a(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 135, column 10 - line 137, column 45): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$75f89ba5e7a712b0 = function(dictMonad) {
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
    return {
        throwError: function() {
            var $204 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($205) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($204($7d4cccdf062a2261$export$37c4d04eafdc5515.create($205)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$78c1353d784c47dd = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadThrowExceptT1 = $d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad);
    return {
        catchError: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(a) {
                    var v1 = k(a);
                    return v1;
                })(function($206) {
                    return pure($7d4cccdf062a2261$export$19db0165690c701a.create($206));
                }));
            };
        },
        MonadThrow0: function() {
            return monadThrowExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$5b1239aace2566fd = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftST: function() {
            var $207 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $208 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$9a16ccee20eb55ce = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var semigroupExceptT1 = $d2284b2d3e1b6f87$export$3539db811b3307bc(dictMonad);
    return function(dictMonoid) {
        var semigroupExceptT2 = semigroupExceptT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(Bind1.Apply0().Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return bind(v)(function(rm) {
                        if (rm instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rm.value0));
                        if (rm instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return bind(v1)(function(rn) {
                            if (rn instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rn.value0));
                            if (rn instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(append(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var altExceptT1 = $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var altExceptT2 = altExceptT1(dictMonad);
        return {
            empty: $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad))(mempty),
            Alt0: function() {
                return altExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$bfd291e36e6170e5 = function(dictMonoid) {
    var plusExceptT1 = $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMonad) {
        var applicativeExceptT1 = $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        var plusExceptT2 = plusExceptT1(dictMonad);
        return {
            Applicative0: function() {
                return applicativeExceptT1;
            },
            Plus1: function() {
                return plusExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$2b1e74d8588fcb7c = function(dictMonoid) {
    var alternativeExceptT1 = $d2284b2d3e1b6f87$export$bfd291e36e6170e5(dictMonoid);
    return function(dictMonad) {
        var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
        var alternativeExceptT2 = alternativeExceptT1(dictMonad);
        return {
            Monad0: function() {
                return monadExceptT1;
            },
            Alternative1: function() {
                return alternativeExceptT2;
            }
        };
    };
};


// Generated by purs version 0.15.15



















var $7038ccc2f7f5bbce$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7038ccc2f7f5bbce$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7038ccc2f7f5bbce$export$ad3c05b40854bc17 = function(x) {
    return x;
};
var $7038ccc2f7f5bbce$export$74b507a1130daad6 = function(v) {
    return v;
};
var $7038ccc2f7f5bbce$export$e423059046893ebc = {
    Coercible0: function() {
        return undefined;
    }
};
var $7038ccc2f7f5bbce$export$84eda9cb75492c36 = {
    lift: function(dictMonad) {
        var $163 = $d3d065da31679be1$export$167848c32e61a4d4(dictMonad)($06733ae99ed4f534$export$8a67b48435b5d073.create);
        return function($164) {
            return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($163($164));
        };
    }
};
var $7038ccc2f7f5bbce$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $7038ccc2f7f5bbce$export$d0ac118ccd5cda07 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $7038ccc2f7f5bbce$export$3bf77092340654e0 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map1($7038ccc2f7f5bbce$var$map(f))(v);
            };
        }
    };
};
var $7038ccc2f7f5bbce$export$63cf87c0678a1d2c = function(dictMonad) {
    return {
        Applicative0: function() {
            return $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
        },
        Bind1: function() {
            return $7038ccc2f7f5bbce$export$c4ec8f671a263573(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$c4ec8f671a263573 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        var v2 = f(v1.value0);
                        return v2;
                    }
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 55, column 11 - line 57, column 42): " + [
                        v1.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e = function(dictMonad) {
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad)),
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4797150488333da1 = function(dictMonad) {
    return {
        pure: function() {
            var $165 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($166) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($165($06733ae99ed4f534$export$8a67b48435b5d073.create($166)));
            };
        }(),
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$984e03b79d8c6656 = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $7038ccc2f7f5bbce$export$36c6624b0bef0761 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        ask: $7038ccc2f7f5bbce$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d73769631c0edb39 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskMaybeT1 = $7038ccc2f7f5bbce$export$36c6624b0bef0761(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(local(f));
        },
        MonadAsk0: function() {
            return monadAskMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$ec6a88a02083ed25 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $06733ae99ed4f534$export$8a67b48435b5d073(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$2f876a9cb1e407d9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftEffect: function() {
            var $167 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $168 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($169) {
                return $167($168($169));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$7b9e3f37a9f7f6b2 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        tailRecM: function(f) {
            var $170 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 83, column 16 - line 86, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($171) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($170($171));
            };
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$99cfcc8edd025934 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$907950ecc201e8fb = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad1);
    return {
        tell: function() {
            var $172 = $7038ccc2f7f5bbce$var$lift(Monad1);
            var $173 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$5afebe755b331e96 = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellMaybeT1 = $7038ccc2f7f5bbce$export$907950ecc201e8fb(MonadTell1);
    return {
        listen: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return bind(listen(m))(function(v) {
                return pure($7038ccc2f7f5bbce$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $71f2e2e9476163f8$export$1908877435b1d5e9($06733ae99ed4f534$export$bebe9059409a0d04.value, $7038ccc2f7f5bbce$var$identity);
                    if (a instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $06733ae99ed4f534$export$8a67b48435b5d073(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 120, column 10 - line 122, column 43): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$8908e8a28a021e1c = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$f77b055a7835b1d0 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowMaybeT1 = $7038ccc2f7f5bbce$export$8908e8a28a021e1c(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return catchError(v)(function(a) {
                    var v1 = h(a);
                    return v1;
                });
            };
        },
        MonadThrow0: function() {
            return monadThrowMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4033508ee81d9e59 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftST: function() {
            var $175 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$20ac3a2d3113d020 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7038ccc2f7f5bbce$export$4797150488333da1(dictMonad));
    var semigroupMaybeT1 = $7038ccc2f7f5bbce$export$984e03b79d8c6656(dictMonad);
    return function(dictMonoid) {
        var semigroupMaybeT2 = semigroupMaybeT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupMaybeT2;
            }
        };
    };
};
var $7038ccc2f7f5bbce$export$e14125e5a208a0c9 = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(Bind1.Apply0().Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return bind(v)(function(m) {
                    if (m instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                    return pure(m);
                });
            };
        },
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$140a10b5716e1900 = function(dictMonad) {
    var altMaybeT1 = $7038ccc2f7f5bbce$export$e14125e5a208a0c9(dictMonad);
    return {
        empty: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0())($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Alt0: function() {
            return altMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$68df7d2debd59865 = function(dictMonad) {
    var applicativeMaybeT1 = $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
    var plusMaybeT1 = $7038ccc2f7f5bbce$export$140a10b5716e1900(dictMonad);
    return {
        Applicative0: function() {
            return applicativeMaybeT1;
        },
        Plus1: function() {
            return plusMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d4030eff1969644e = function(dictMonad) {
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad);
    var alternativeMaybeT1 = $7038ccc2f7f5bbce$export$68df7d2debd59865(dictMonad);
    return {
        Monad0: function() {
            return monadMaybeT1;
        },
        Alternative1: function() {
            return alternativeMaybeT1;
        }
    };
};


// Generated by purs version 0.15.15












// Generated by purs version 0.15.15


var $7abe8fbe97ebda87$export$b7c99dd4fc96d90e = {
    empty: [],
    Alt0: function() {
        return $75e93a4111e80214$export$186d613bb872946c;
    }
};
var $7abe8fbe97ebda87$export$6e22c362a0406a2c = function(dict) {
    return dict.empty;
};


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

var $a4e6c090e9e673b6$export$8c14e57e778d3873 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};


var $4fa4836228a192cc$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $4fa4836228a192cc$export$4997ffc0176396a6 = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$wrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $4fa4836228a192cc$export$debb760848ca95a = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$unwrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fa4836228a192cc$export$5ac000a3404ef088 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$18fe6ced65b9d3a7 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$9824f93a497ba98e = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$3b98aa7d576b2b80 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$a2a39c9747f0e54a = function() {
    return function(v) {
        return $4fa4836228a192cc$var$unwrap1;
    };
};
var $4fa4836228a192cc$export$df3f009e3d155b20 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$f2787354896befb9 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$d0d3897f12fa9d17 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$e8dd23d7349f1a08 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$fb4902fd9e525693 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$cbef643c6d6f42c2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$bae63404e9252557 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$940059b52273aa56 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$b77ba17f6321a9fb = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$59af3bbd6a00f6a9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$78c87ff68dcb8da2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$3ff57735a52b8713 = function() {
    return function(fn) {
        return function(t) {
            return $4fa4836228a192cc$var$wrap1(fn($4fa4836228a192cc$var$unwrap1(t)));
        };
    };
};
var $4fa4836228a192cc$export$bb44f104e3c54dae = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$b533eaec53aab18a = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$7317c19c5df48291 = function() {
    return function() {
        return function() {
            return function(v) {
                return function(f) {
                    return $4fa4836228a192cc$var$coerce(f($4fa4836228a192cc$var$wrap1));
                };
            };
        };
    };
};




// Generated by purs version 0.15.15
var $ae8714ffa2598cf8$var$To = function(x) {
    return x;
};
var $ae8714ffa2598cf8$var$From = function(x) {
    return x;
};
var $ae8714ffa2598cf8$export$9fc2f52ae8ba6578 = {
    proof: function(a) {
        return a;
    },
    Coercible0: function() {
        return undefined;
    }
};
var $ae8714ffa2598cf8$export$3d466392f5188420 = function(dict) {
    return dict.proof;
};
var $ae8714ffa2598cf8$export$2c618a4308a30424 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};
var $ae8714ffa2598cf8$export$6788812c4e6611e6 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};


var $3ce830dde03d3389$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $3ce830dde03d3389$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3ce830dde03d3389$export$c2a69422949c6b5c = {
    distribute: function(dictFunctor) {
        var $34 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($3ce830dde03d3389$var$unwrap);
        return function($35) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($34($35));
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $36 = map(function($38) {
                return $3ce830dde03d3389$var$unwrap(f($38));
            });
            return function($37) {
                return $50c50d1f444e5fa4$export$544bf02140fa9a77($36($37));
            };
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $3ce830dde03d3389$export$f02a9ddbe4480f19 = function(dict) {
    return dict.distribute;
};
var $3ce830dde03d3389$export$31ac6c2237b1bf1b = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return function(e) {
                return map(function(v) {
                    return v(e);
                })(a);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $39 = $3ce830dde03d3389$export$f02a9ddbe4480f19($3ce830dde03d3389$export$31ac6c2237b1bf1b)(dictFunctor);
            var $40 = map(f);
            return function($41) {
                return $39($40($41));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $3ce830dde03d3389$export$e6005abdfe1aac80 = function(dictDistributive) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictDistributive.Functor0());
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        return function(f) {
            var $42 = map(f);
            return function($43) {
                return $42(distribute2($43));
            };
        };
    };
};
var $3ce830dde03d3389$export$2d5a930f1676b9b7 = function(dictDistributive) {
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $44 = map(f);
            return function($45) {
                return distribute2($44($45));
            };
        };
    };
};
var $3ce830dde03d3389$export$76df48f9f3fb8eb1 = function(dictTypeEquals) {
    var from = $ae8714ffa2598cf8$export$6788812c4e6611e6(dictTypeEquals);
    return {
        collect: function(dictFunctor) {
            return $3ce830dde03d3389$export$2d5a930f1676b9b7($3ce830dde03d3389$export$76df48f9f3fb8eb1(dictTypeEquals))(dictFunctor);
        },
        distribute: function(dictFunctor) {
            var $46 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(from($05149ea687d6b460$export$523c0b569236b342));
            var $47 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($71f2e2e9476163f8$export$6f71268a1666ab58);
            return function($48) {
                return $46($47($48));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $3ce830dde03d3389$export$bb44f104e3c54dae = function(dict) {
    return dict.collect;
};
var $3ce830dde03d3389$export$f13cbf7f76d41467 = function(dictDistributive) {
    var collect1 = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    return function(dictFunctor) {
        return collect1(dictFunctor)($3ce830dde03d3389$var$identity);
    };
};







var $848780da1bf26d9d$export$ea3c61b219e01d1e = function(x) {
    return x;
};
var $848780da1bf26d9d$export$36ee99cc8d1d67c9 = function(f) {
    return function(v) {
        return function($152) {
            return v(f($152));
        };
    };
};
var $848780da1bf26d9d$export$f356de2c51baae29 = function(v) {
    return v;
};
var $848780da1bf26d9d$export$f52dceb6bbe9cc1f = {
    Coercible0: function() {
        return undefined;
    }
};
var $848780da1bf26d9d$export$95510d0cd7e6e7eb = {
    lift: function(dictMonad) {
        return function($153) {
            return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($153));
        };
    }
};
var $848780da1bf26d9d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $848780da1bf26d9d$export$1b8048a192a96779 = function(f) {
    return function(v) {
        return function($154) {
            return f(v($154));
        };
    };
};
var $848780da1bf26d9d$export$9ef8da126720992c = function(dictFunctor) {
    return {
        map: function() {
            var $155 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function($156) {
                return $848780da1bf26d9d$export$1b8048a192a96779($155($156));
            };
        }()
    };
};
var $848780da1bf26d9d$export$4b73f9411376f1b4 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(a) {
                return function(e) {
                    return collect1(function(r) {
                        return r(e);
                    })(a);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $157 = $3ce830dde03d3389$export$f02a9ddbe4480f19($848780da1bf26d9d$export$4b73f9411376f1b4(dictDistributive))(dictFunctor);
                var $158 = map(f);
                return function($159) {
                    return $157($158($159));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$fee188993a7996b7 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(r) {
                    return apply(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$4255fb962d7d3c76 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(r) {
                    return bind(v(r))(function(a) {
                        var v1 = k(a);
                        return v1(r);
                    });
                };
            };
        },
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$12572275428491c2 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($848780da1bf26d9d$export$fee188993a7996b7(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $848780da1bf26d9d$export$aef633589549fee0 = function(dictApplicative) {
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictApplicative.Apply0());
    return {
        pure: function() {
            var $160 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($161) {
                return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($160($161)));
            };
        }(),
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$6f721f6865c71dd2 = function(dictMonad) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictMonad.Applicative0());
    var bindReaderT1 = $848780da1bf26d9d$export$4255fb962d7d3c76(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Bind1: function() {
            return bindReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1fc6951fa9cc0730 = function(dictMonad) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonad);
    return {
        ask: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$202df576a32d0b15 = function(dictMonad) {
    var monadAskReaderT1 = $848780da1bf26d9d$export$1fc6951fa9cc0730(dictMonad);
    return {
        local: $848780da1bf26d9d$export$36ee99cc8d1d67c9,
        MonadAsk0: function() {
            return monadAskReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$9f6c922afb6673fe = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(r) {
                return callCC(function(c) {
                    var v = f(function($162) {
                        return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(c($162)));
                    });
                    return v(r);
                });
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$a554ebf369a3f56d = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftEffect: function() {
            var $163 = $848780da1bf26d9d$var$lift(Monad0);
            var $164 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($165) {
                return $163($164($165));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$b063aaccf75fba13 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        tailRecM: function(k) {
            return function(a) {
                var k$prime = function(r) {
                    return function(a$prime) {
                        var v = k(a$prime);
                        return bindFlipped(pure)(v(r));
                    };
                };
                return function(r) {
                    return tailRecM(k$prime(r))(a);
                };
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$48d7aff14d826a4f = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        state: function() {
            var $166 = $848780da1bf26d9d$var$lift(Monad0);
            var $167 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$ab1235cf7f047d07 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad1);
    return {
        tell: function() {
            var $169 = $848780da1bf26d9d$var$lift(Monad1);
            var $170 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($171) {
                return $169($170($171));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$662fa4b34fb6720c = function(dictMonadWriter) {
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellReaderT1 = $848780da1bf26d9d$export$ab1235cf7f047d07(dictMonadWriter.MonadTell1());
    return {
        listen: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter)),
        pass: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter)),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1b067e2856bff729 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        throwError: function() {
            var $172 = $848780da1bf26d9d$var$lift(Monad0);
            var $173 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$484cd3c856ffc7 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowReaderT1 = $848780da1bf26d9d$export$1b067e2856bff729(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(r) {
                    return catchError(v(r))(function(e) {
                        var v1 = h(e);
                        return v1(r);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$162b6a611607bf69 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftST: function() {
            var $175 = $848780da1bf26d9d$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$df55f2197442fd9 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($848780da1bf26d9d$export$aef633589549fee0(dictApplicative));
    var semigroupReaderT1 = $848780da1bf26d9d$export$12572275428491c2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupReaderT2 = semigroupReaderT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupReaderT2;
            }
        };
    };
};
var $848780da1bf26d9d$export$32cadcb66dd98ef3 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return alt(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$97f8c30f9c69a13c = function(dictPlus) {
    var altReaderT1 = $848780da1bf26d9d$export$32cadcb66dd98ef3(dictPlus.Alt0());
    return {
        empty: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus)),
        Alt0: function() {
            return altReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$8bebb77f5bc043a9 = function(dictAlternative) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictAlternative.Applicative0());
    var plusReaderT1 = $848780da1bf26d9d$export$97f8c30f9c69a13c(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Plus1: function() {
            return plusReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$3772d6c9d5f8e735 = function(dictMonadPlus) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadPlus.Monad0());
    var alternativeReaderT1 = $848780da1bf26d9d$export$8bebb77f5bc043a9(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadReaderT1;
        },
        Alternative1: function() {
            return alternativeReaderT1;
        }
    };
};


// Generated by purs version 0.15.15



















var $d9ef009191ddae40$export$6bef9d59f22e8880 = function(x) {
    return x;
};
var $d9ef009191ddae40$export$973e92d98e897dbf = function(v) {
    return v;
};
var $d9ef009191ddae40$export$d5b925da5ee69c31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d9ef009191ddae40$export$6b749a3db2c2aac6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return bind(m)(function(a) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                });
            };
        }
    };
};
var $d9ef009191ddae40$export$c950a71321ef1ffc = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d9ef009191ddae40$export$502115c714790859 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d9ef009191ddae40$export$c950a71321ef1ffc(map(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1);
            }));
        }
    };
};
var $d9ef009191ddae40$export$730fbe746bee115d = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v);
    };
};
var $d9ef009191ddae40$export$2f46a8de9e2e0acc = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var Functor0 = dictApply.Functor0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(Functor0);
        return {
            apply: function(v) {
                return function(v1) {
                    var k = function(v3) {
                        return function(v4) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0(v4.value0), append(v3.value1)(v4.value1));
                        };
                    };
                    return apply(map(k)(v))(v1);
                };
            },
            Functor0: function() {
                return functorWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$4483e5256f36d121 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup);
    return function(dictBind) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
        var Apply0 = dictBind.Apply0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var applyWriterT2 = applyWriterT1(Apply0);
        return {
            bind: function(v) {
                return function(k) {
                    return bind(v)(function(v1) {
                        var v2 = k(v1.value0);
                        return map(function(v3) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0, append(v1.value1)(v3.value1));
                        })(v2);
                    });
                };
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8c475e05f959fff2 = function(dictApply) {
    return function(dictSemigroup) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup)(dictApply));
        return function(dictSemigroup1) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1))
            };
        };
    };
};
var $d9ef009191ddae40$export$c3b0a193a5475c40 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var applyWriterT2 = applyWriterT1(dictApplicative.Apply0());
        return {
            pure: function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$a45df43c41b778a = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    var bindWriterT1 = $d9ef009191ddae40$export$4483e5256f36d121(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var applicativeWriterT2 = applicativeWriterT1(dictMonad.Applicative0());
        var bindWriterT2 = bindWriterT1(dictMonad.Bind1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Bind1: function() {
                return bindWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$2b88d21fdbd23b84 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadAsk) {
        var Monad0 = dictMonadAsk.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            ask: lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$1e8e23b27bf4b6eb = function(dictMonoid) {
    var monadAskWriterT1 = $d9ef009191ddae40$export$2b88d21fdbd23b84(dictMonoid);
    return function(dictMonadReader) {
        var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
        var monadAskWriterT2 = monadAskWriterT1(dictMonadReader.MonadAsk0());
        return {
            local: function(f) {
                return $d9ef009191ddae40$export$c950a71321ef1ffc(local(f));
            },
            MonadAsk0: function() {
                return monadAskWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$7520b5391c6ad7c7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadCont) {
        var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
        var monadWriterT2 = monadWriterT1(dictMonadCont.Monad0());
        return {
            callCC: function(f) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                    });
                    return v;
                });
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$29fece65832b4369 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftEffect: function() {
                var $259 = lift(Monad0);
                var $260 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($261) {
                    return $259($260($261));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$36179168852a11d0 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            tailRecM: function(f) {
                return function(a) {
                    var f$prime = function(v) {
                        var v1 = f(v.value0);
                        return bind(v1)(function(v2) {
                            return pure(function() {
                                if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                throw new Error("Failed pattern match at Control.Monad.Writer.Trans (line 84, column 16 - line 86, column 47): " + [
                                    v2.value0.constructor.name
                                ]);
                            }());
                        });
                    };
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                };
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$6594c621b12bf0b9 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadState) {
        var Monad0 = dictMonadState.Monad0();
        var lift1 = lift(Monad0);
        var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            state: function(f) {
                return lift1(state(f));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$b022f808a9791225 = function(dictMonoid) {
    var Semigroup0 = dictMonoid.Semigroup0();
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonad) {
        var monadWriterT2 = monadWriterT1(dictMonad);
        return {
            tell: function() {
                var $262 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
                var $263 = $71f2e2e9476163f8$export$1908877435b1d5e9.create($05149ea687d6b460$export$523c0b569236b342);
                return function($264) {
                    return $d9ef009191ddae40$export$6bef9d59f22e8880($262($263($264)));
                };
            }(),
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f2385bf9afd45c19 = function(dictMonoid) {
    var monadTellWriterT1 = $d9ef009191ddae40$export$b022f808a9791225(dictMonoid);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var monadTellWriterT2 = monadTellWriterT1(dictMonad);
        return {
            listen: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1), v1.value1));
                });
            },
            pass: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0.value0, v1.value0.value1(v1.value1)));
                });
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8fbe11284b53cf18 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadThrow) {
        var Monad0 = dictMonadThrow.Monad0();
        var lift1 = lift(Monad0);
        var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            throwError: function(e) {
                return lift1(throwError(e));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f7d1d5bacfa0742c = function(dictMonoid) {
    var monadThrowWriterT1 = $d9ef009191ddae40$export$8fbe11284b53cf18(dictMonoid);
    return function(dictMonadError) {
        var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
        var monadThrowWriterT2 = monadThrowWriterT1(dictMonadError.MonadThrow0());
        return {
            catchError: function(v) {
                return function(h) {
                    return catchError(v)(function(e) {
                        var v1 = h(e);
                        return v1;
                    });
                };
            },
            MonadThrow0: function() {
                return monadThrowWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$3e5fc362694e79bf = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftST: function() {
                var $265 = lift(Monad0);
                var $266 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($267) {
                    return $265($266($267));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8a353f8c5b798525 = function(dictApplicative) {
    var semigroupWriterT1 = $d9ef009191ddae40$export$8c475e05f959fff2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid)(dictApplicative));
        var semigroupWriterT2 = semigroupWriterT1(dictMonoid.Semigroup0());
        return function(dictMonoid1) {
            var semigroupWriterT3 = semigroupWriterT2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupWriterT3;
                }
            };
        };
    };
};
var $d9ef009191ddae40$export$6f6793d950011736 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        },
        Functor0: function() {
            return functorWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$a57a36ca2cee11fb = function(dictPlus) {
    var altWriterT1 = $d9ef009191ddae40$export$6f6793d950011736(dictPlus.Alt0());
    return {
        empty: $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus),
        Alt0: function() {
            return altWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$c91ecc30f23c76ec = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    return function(dictAlternative) {
        var applicativeWriterT2 = applicativeWriterT1(dictAlternative.Applicative0());
        var plusWriterT1 = $d9ef009191ddae40$export$a57a36ca2cee11fb(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Plus1: function() {
                return plusWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$1c68552a87a434af = function(dictMonoid) {
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    var alternativeWriterT1 = $d9ef009191ddae40$export$c91ecc30f23c76ec(dictMonoid);
    return function(dictMonadPlus) {
        var monadWriterT2 = monadWriterT1(dictMonadPlus.Monad0());
        var alternativeWriterT2 = alternativeWriterT1(dictMonadPlus.Alternative1());
        return {
            Monad0: function() {
                return monadWriterT2;
            },
            Alternative1: function() {
                return alternativeWriterT2;
            }
        };
    };
};




// Generated by purs version 0.15.15






// Generated by purs version 0.15.15








var $60e028b2ef4ceb5f$export$86fbec116b87613f = function(x) {
    return x;
};
var $60e028b2ef4ceb5f$export$993a94e8f319ddca = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(App " + (show(v) + ")");
        }
    };
};
var $60e028b2ef4ceb5f$export$25412483a1d87cf9 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append1)(v)(v1);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$ca15fc0ee645d5ca = function(dictPlus) {
    return dictPlus;
};
var $60e028b2ef4ceb5f$export$d6896dcb1200915c = {
    Coercible0: function() {
        return undefined;
    }
};
var $60e028b2ef4ceb5f$export$4d0b678caa24727 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var semigroupApp1 = $60e028b2ef4ceb5f$export$25412483a1d87cf9(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupApp2 = semigroupApp1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$5dee9c05ece04940 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $60e028b2ef4ceb5f$export$6a01a2292278ad36 = function(dictMonad) {
    return dictMonad;
};
var $60e028b2ef4ceb5f$export$aef3f1b3df1ccc91 = function(dictLazy) {
    return dictLazy;
};
var $60e028b2ef4ceb5f$export$74e988bb94b714ec = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$d26bca0552b37bb6 = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$e5247fd078351cb8 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $60e028b2ef4ceb5f$export$79ab389dc7ad1e04 = function(dictFunctor) {
    return dictFunctor;
};
var $60e028b2ef4ceb5f$export$4392ba23127b7f7e = function(dictExtend) {
    return dictExtend;
};
var $60e028b2ef4ceb5f$export$ca57ebaecdc7d318 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$f5438903fac97fd7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqApp2 = eqApp1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$878272f7ccf91d14 = function(dictEq1) {
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqApp1(dictEq));
        }
    };
};
var $60e028b2ef4ceb5f$export$594a740e645fec3d = function(dictOrd1) {
    var ordApp1 = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd1);
    var eq1App1 = $60e028b2ef4ceb5f$export$878272f7ccf91d14(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordApp1(dictOrd));
        },
        Eq10: function() {
            return eq1App1;
        }
    };
};
var $60e028b2ef4ceb5f$export$7470af1a1433fe40 = function(dictComonad) {
    return dictComonad;
};
var $60e028b2ef4ceb5f$export$a9edb76092ee7d6f = function(dictBind) {
    return dictBind;
};
var $60e028b2ef4ceb5f$export$e73125860a07eff3 = function(dictApply) {
    return dictApply;
};
var $60e028b2ef4ceb5f$export$3550db4068efefdd = function(dictApplicative) {
    return dictApplicative;
};
var $60e028b2ef4ceb5f$export$afc0b729746e2971 = function(dictAlternative) {
    return dictAlternative;
};
var $60e028b2ef4ceb5f$export$69ee13496a90cde5 = function(dictAlt) {
    return dictAlt;
};




var $6051f44ece6b7171$export$5a3a146e358e1bcf = function(x) {
    return x;
};
var $6051f44ece6b7171$export$48988665210796c9 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Compose " + (show(v) + ")");
        }
    };
};
var $6051f44ece6b7171$export$db82d32400573da6 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6051f44ece6b7171$export$4e14cb014c72d19c = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return map(map1(f))(v);
                };
            }
        };
    };
};
var $6051f44ece6b7171$export$861bef6ec455b19c = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eqApp = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq11);
        return function(dictEq) {
            var eq11 = eq1(eqApp(dictEq));
            return {
                eq: function(v) {
                    return function(v1) {
                        return eq11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$71b54a761b111692 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordApp = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd11);
        var eqCompose2 = eqCompose1(dictOrd11.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(ordApp(dictOrd));
            var eqCompose3 = eqCompose2(dictOrd.Eq0());
            return {
                compare: function(v) {
                    return function(v1) {
                        return compare11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                },
                Eq0: function() {
                    return eqCompose3;
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$cbe2b7f63279884c = function(dictEq1) {
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictEq1);
    return function(dictEq11) {
        var eqCompose2 = eqCompose1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCompose2(dictEq));
            }
        };
    };
};
var $6051f44ece6b7171$export$d435219eb92d4b50 = function(dictOrd1) {
    var ordCompose1 = $6051f44ece6b7171$export$71b54a761b111692(dictOrd1);
    var eq1Compose1 = $6051f44ece6b7171$export$cbe2b7f63279884c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordCompose2 = ordCompose1(dictOrd11);
        var eq1Compose2 = eq1Compose1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordCompose2(dictOrd));
            },
            Eq10: function() {
                return eq1Compose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$6ac747c53920df53 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(natF) {
        return function(natG) {
            return function(v) {
                return natF(map(natG)(v));
            };
        };
    };
};
var $6051f44ece6b7171$export$6b631277dc31d20d = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var Functor0 = dictApply.Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(Functor0);
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorCompose2 = functorCompose1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return apply(map(apply1)(v))(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$ce6787b8eb4a9f48 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyCompose1 = $6051f44ece6b7171$export$6b631277dc31d20d(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyCompose2 = applyCompose1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $112 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
                return function($113) {
                    return $6051f44ece6b7171$export$5a3a146e358e1bcf(pure($112($113)));
                };
            }(),
            Apply0: function() {
                return applyCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$b9fb31044795461 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(dictAlt.Functor0());
    return function(dictFunctor) {
        var functorCompose2 = functorCompose1(dictFunctor);
        return {
            alt: function(v) {
                return function(v1) {
                    return alt(v)(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$2f025d423e425357 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altCompose1 = $6051f44ece6b7171$export$b9fb31044795461(dictPlus.Alt0());
    return function(dictFunctor) {
        var altCompose2 = altCompose1(dictFunctor);
        return {
            empty: empty,
            Alt0: function() {
                return altCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$3bf64fe887e680d3 = function(dictAlternative) {
    var applicativeCompose1 = $6051f44ece6b7171$export$ce6787b8eb4a9f48(dictAlternative.Applicative0());
    var plusCompose1 = $6051f44ece6b7171$export$2f025d423e425357(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeCompose2 = applicativeCompose1(dictApplicative);
        var plusCompose2 = plusCompose1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeCompose2;
            },
            Plus1: function() {
                return plusCompose2;
            }
        };
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $87f783ef0843fa28$export$2ed6d41c398ed712 = function(f) {
    return function(xs) {
        return xs.map(function(_, i, xs) {
            return f(xs.slice(i));
        });
    };
};





var $c8f9cdd14046b503$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c8f9cdd14046b503$export$cd01f0fbd2ca8bd6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        extend: function(f) {
            return function(g) {
                return function(w) {
                    return f(function(w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function() {
            return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
        }
    };
};
var $c8f9cdd14046b503$export$a321b0e45770af43 = {
    extend: $87f783ef0843fa28$export$2ed6d41c398ed712,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $c8f9cdd14046b503$export$8b58be045bf06082 = function(dict) {
    return dict.extend;
};
var $c8f9cdd14046b503$export$285c6f9556cd75fc = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(w) {
        return function(f) {
            return extend1(f)(w);
        };
    };
};
var $c8f9cdd14046b503$export$ecd5e8ace626722c = function(dictExtend) {
    return $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend)($c8f9cdd14046b503$var$identity);
};
var $c8f9cdd14046b503$export$fbe89af2ce156300 = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var $c8f9cdd14046b503$export$a868f0c7fe15a03f = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return g(extend1(f)(w));
            };
        };
    };
};



var $b3e944c79ac8b935$export$f9380c9a627682d3 = function(dict) {
    return dict.extract;
};





// Generated by purs version 0.15.15


var $d0c5be72120caeb7$export$578ae18717ba10de = {
    cmap: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d0c5be72120caeb7$export$b186cb408b99d7fc = function(dict) {
    return dict.cmap;
};
var $d0c5be72120caeb7$export$d0a699a1379b7fb5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(x) {
        return function(f) {
            return cmap1(f)(x);
        };
    };
};
var $d0c5be72120caeb7$export$8c14e57e778d3873 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return map($58f3cdfbfe212d20$export$f172309911142386)(cmap1($58f3cdfbfe212d20$export$f172309911142386)(a));
        };
    };
};
var $d0c5be72120caeb7$export$dc224e55acb863f5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(v) {
        return function(f) {
            return cmap1(f);
        };
    };
};



// Generated by purs version 0.15.15


var $9be1c75e3223ee2e$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $9be1c75e3223ee2e$var$wrap = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $9be1c75e3223ee2e$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $9be1c75e3223ee2e$export$e10497e40cde5fd3 = {
    dimap: function(a2b) {
        return function(c2d) {
            return function(b2c) {
                return function($18) {
                    return c2d(b2c(a2b($18)));
                };
            };
        };
    }
};
var $9be1c75e3223ee2e$export$7c344215185fc3ac = function(dict) {
    return dict.dimap;
};
var $9be1c75e3223ee2e$export$48f54268254cf7d0 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(a2b) {
        return dimap1(a2b)($9be1c75e3223ee2e$var$identity);
    };
};
var $9be1c75e3223ee2e$export$6630987c9d273301 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(b2c) {
        return dimap1($9be1c75e3223ee2e$var$identity)(b2c);
    };
};
var $9be1c75e3223ee2e$export$93b4506d26e3367 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return dimap1($9be1c75e3223ee2e$var$wrap)($9be1c75e3223ee2e$var$unwrap);
    };
};
var $9be1c75e3223ee2e$export$d25bf6793fd4dfcb = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return function(v) {
            return dimap1($9be1c75e3223ee2e$var$unwrap)($9be1c75e3223ee2e$var$wrap);
        };
    };
};
var $9be1c75e3223ee2e$export$29d5d0b2414dfc5c = function(dictCategory) {
    var identity1 = $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory);
    return function(dictProfunctor) {
        var rmap1 = $9be1c75e3223ee2e$export$6630987c9d273301(dictProfunctor);
        return function(f) {
            return rmap1(f)(identity1);
        };
    };
};



var $b5fb63758051b147$var$lcmap = /* #__PURE__ */ $9be1c75e3223ee2e$export$48f54268254cf7d0($9be1c75e3223ee2e$export$e10497e40cde5fd3);
var $b5fb63758051b147$export$c8d61c7aefcd2eb9 = function(x) {
    return x;
};
var $b5fb63758051b147$export$4b8724da343f8670 = function(dictExtend) {
    var composeCoKleisliFlipped = $c8f9cdd14046b503$export$fbe89af2ce156300(dictExtend);
    return {
        compose: function(v) {
            return function(v1) {
                return composeCoKleisliFlipped(v)(v1);
            };
        }
    };
};
var $b5fb63758051b147$export$7c2608c347081d34 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $65 = map(f);
                    return function($66) {
                        return g(v($65($66)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$1b28cf6e14cef765 = function(dictComonad) {
    var Functor0 = dictComonad.Extend0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(Functor0);
    return {
        first: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v(map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(x)), $71f2e2e9476163f8$export$6f71268a1666ab58(extract(x)));
            };
        },
        second: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9($71f2e2e9476163f8$export$9e770fa6ce19a9d6(extract(x)), v(map($71f2e2e9476163f8$export$6f71268a1666ab58)(x)));
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$95b15c3b108c70f1 = {
    Coercible0: function() {
        return undefined;
    }
};
var $b5fb63758051b147$export$538b19297a2c28a0 = function(f) {
    return function(v) {
        return $b5fb63758051b147$var$lcmap(f)(v);
    };
};
var $b5fb63758051b147$export$85082d7f68510c56 = {
    map: function(f) {
        return function(v) {
            return function($67) {
                return f(v($67));
            };
        };
    }
};
var $b5fb63758051b147$export$c2eec9047e1c22f6 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($b5fb63758051b147$export$85082d7f68510c56)
};
var $b5fb63758051b147$export$6ca61216e8ebd2dc = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            return function(a) {
                return map(function(v) {
                    return v(a);
                })(f);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $68 = $3ce830dde03d3389$export$f02a9ddbe4480f19($b5fb63758051b147$export$6ca61216e8ebd2dc)(dictFunctor);
            var $69 = map(f);
            return function($70) {
                return $68($69($70));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$45296f90ce78a5aa = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(dictFunctor);
    return {
        closed: function(v) {
            return function(g) {
                return function(x) {
                    return v(map(function(v1) {
                        return v1(x);
                    })(g));
                };
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$1b18a904dcda2b6c = function(dictComonad) {
    var semigroupoidCostar1 = $b5fb63758051b147$export$4b8724da343f8670(dictComonad.Extend0());
    return {
        identity: $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad),
        Semigroupoid0: function() {
            return semigroupoidCostar1;
        }
    };
};
var $b5fb63758051b147$export$12684125bae58283 = function(dictContravariant) {
    var cmap = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    var $71 = cmap(f);
                    return function($72) {
                        return g(v($71($72)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$bee433edbc7aed34 = {
    apply: function(v) {
        return function(v1) {
            return function(a) {
                return v(a)(v1(a));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$9af761d291db49ef = {
    bind: function(v) {
        return function(f) {
            return function(x) {
                var v1 = f(v(x));
                return v1(x);
            };
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$ddef3771953a3c3c = {
    pure: function(a) {
        return function(v) {
            return a;
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$88fc0f5d12a9e446 = {
    Applicative0: function() {
        return $b5fb63758051b147$export$ddef3771953a3c3c;
    },
    Bind1: function() {
        return $b5fb63758051b147$export$9af761d291db49ef;
    }
};



// Generated by purs version 0.15.15










var $6f71832c0f0d3a5b$export$1644ba17714857f1 = function(x) {
    return x;
};
var $6f71832c0f0d3a5b$export$5c32215407d0c561 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return {
        compose: function(v) {
            return function(v1) {
                return function(x) {
                    return bind(v1(x))(v);
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$a1c7b121a12f67f7 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $127 = map(g);
                    return function($128) {
                        return $127(v(f($128)));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$1bd208d997e69566 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictFunctor);
    return {
        first: function(v) {
            return function(v1) {
                return map(function(v2) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v2, v1.value1);
                })(v(v1.value0));
            };
        },
        second: function(v) {
            return function(v1) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0))(v(v1.value1));
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$5646bceeba0ed2e7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6f71832c0f0d3a5b$export$8ba4b27aef989a18 = function(dictInvariant) {
    var imap = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    var $129 = imap(f)(g);
                    return function($130) {
                        return $129(v($130));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$e7b43b239cd8e22a = function(f) {
    return function(v) {
        return function($131) {
            return f(v($131));
        };
    };
};
var $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                var $132 = map(f);
                return function($133) {
                    return $132(v($133));
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$8e00b62431cd4eb7 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                return function(a) {
                    return collect1(function(v) {
                        return v(a);
                    })(f);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $134 = $3ce830dde03d3389$export$f02a9ddbe4480f19($6f71832c0f0d3a5b$export$8e00b62431cd4eb7(dictDistributive))(dictFunctor);
                var $135 = map(f);
                return function($136) {
                    return $134($135($136));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$ee38dceaf1b0a7c1 = function(dictDistributive) {
    var distribute = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive)($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictDistributive.Functor0());
    return {
        closed: function(v) {
            return function(g) {
                return distribute(function($137) {
                    return v(g($137));
                });
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$9b633f3f90080760 = function(dictApplicative) {
    var Functor0 = dictApplicative.Apply0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(Functor0);
    return {
        left: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                var $138 = map($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
                return function($139) {
                    return $138(v($139));
                };
            }())(function($140) {
                return pure($7d4cccdf062a2261$export$19db0165690c701a.create($140));
            });
        },
        right: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($141) {
                return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($141));
            })(function() {
                var $142 = map($7d4cccdf062a2261$export$19db0165690c701a.create);
                return function($143) {
                    return $142(v($143));
                };
            }());
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$2315b5444b191e9f = function(dictMonad) {
    var semigroupoidStar1 = $6f71832c0f0d3a5b$export$5c32215407d0c561(dictMonad.Bind1());
    return {
        identity: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Semigroupoid0: function() {
            return semigroupoidStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$3a827cf342dc199f = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(a) {
                    return apply(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a9fd453e55672cc4 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(f) {
                return function(x) {
                    return bind(v(x))(function(a) {
                        var v1 = f(a);
                        return v1(x);
                    });
                };
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7a1642fc72453036 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$be30334ea1d81019 = function(dictMonad) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictMonad.Applicative0());
    var bindStar1 = $6f71832c0f0d3a5b$export$a9fd453e55672cc4(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Bind1: function() {
            return bindStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$35f44c8ce889b889 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(a) {
                    return alt(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a37a0eff981675fc = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altStar1 = $6f71832c0f0d3a5b$export$35f44c8ce889b889(dictPlus.Alt0());
    return {
        empty: function(v) {
            return empty;
        },
        Alt0: function() {
            return altStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$b508333aabf9ba3d = function(dictAlternative) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictAlternative.Applicative0());
    var plusStar1 = $6f71832c0f0d3a5b$export$a37a0eff981675fc(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Plus1: function() {
            return plusStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7fe0d763dfe145d = function(dictMonadPlus) {
    var monadStar1 = $6f71832c0f0d3a5b$export$be30334ea1d81019(dictMonadPlus.Monad0());
    var alternativeStar1 = $6f71832c0f0d3a5b$export$b508333aabf9ba3d(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStar1;
        },
        Alternative1: function() {
            return alternativeStar1;
        }
    };
};





var $86141680556a7436$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $86141680556a7436$export$e97768dcd3ffe6df = function(x) {
    return x;
};
var $86141680556a7436$export$3c7b24ce1c81e349 = function(dict) {
    return dict.sequential;
};
var $86141680556a7436$export$451942af9381149c = function(dict) {
    return dict.parallel;
};
var $86141680556a7436$export$ddc88912bc863338 = {
    Coercible0: function() {
        return undefined;
    }
};
var $86141680556a7436$export$76ad2e05fec13cc8 = function(dictMonoid) {
    var applyWriterT = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictParallel) {
        var applyWriterT1 = applyWriterT(dictParallel.Apply0());
        var applyWriterT2 = applyWriterT(dictParallel.Apply1());
        return {
            parallel: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$451942af9381149c(dictParallel)),
            sequential: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
            Apply0: function() {
                return applyWriterT1;
            },
            Apply1: function() {
                return applyWriterT2;
            }
        };
    };
};
var $86141680556a7436$export$48c6c5bbf7c98dc9 = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyStar = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply0());
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply1());
    return {
        parallel: function(v) {
            return function($124) {
                return parallel1(v($124));
            };
        },
        sequential: function(v) {
            return function($125) {
                return sequential1(v($125));
            };
        },
        Apply0: function() {
            return applyStar;
        },
        Apply1: function() {
            return applyStar1;
        }
    };
};
var $86141680556a7436$export$cfbddc4e0911f419 = function(dictParallel) {
    var applyReaderT = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply0());
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply1());
    return {
        parallel: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$451942af9381149c(dictParallel)),
        sequential: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
        Apply0: function() {
            return applyReaderT;
        },
        Apply1: function() {
            return applyReaderT1;
        }
    };
};
var $86141680556a7436$export$31d7210ae04b04da = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($06733ae99ed4f534$export$22d9917da16590e7);
    return function(dictMonad) {
        var applyMaybeT = $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyMaybeT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$29ed81e6361e826b = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($7d4cccdf062a2261$export$d5df7cb019d08f04);
    return function(dictMonad) {
        var applyExceptT = $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyExceptT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$36431f0cd2fca0df = function(dictParallel) {
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    return {
        parallel: function(v) {
            return function($126) {
                return v(sequential1($126));
            };
        },
        sequential: function(v) {
            return function($127) {
                return v(parallel1($127));
            };
        },
        Apply0: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        },
        Apply1: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        }
    };
};
var $86141680556a7436$export$aecfbd788a6caa47 = function(dictMonadEffect) {
    var applyContT = $fca560e14229da4e$export$6b05a2ec606a3559(dictMonadEffect.Monad0().Bind1().Apply0());
    return {
        parallel: $86141680556a7436$export$e97768dcd3ffe6df,
        sequential: function(v) {
            return v;
        },
        Apply0: function() {
            return applyContT;
        },
        Apply1: function() {
            return $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$bf3675a1b3711367 = function(dictMonadEffect) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88($fca560e14229da4e$export$232156ef715cfc9b(dictMonadEffect.Monad0().Bind1().Apply0().Functor0()));
    return {
        map: function(f) {
            var $128 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $129 = map(f);
            var $130 = $86141680556a7436$export$3c7b24ce1c81e349($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            return function($131) {
                return $128($129($130($131)));
            };
        }
    };
};
var $86141680556a7436$export$803a06b7a7e59726 = function(dictMonadEffect) {
    var Bind1 = dictMonadEffect.Monad0().Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(ra) {
                        return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(rb) {
                            return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(rb)))(function(mb) {
                                    if (mb instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(a))(ra));
                                    if (mb instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(a(mb.value0));
                                    throw new Error("Failed pattern match at Control.Parallel.Class (line 83, column 7 - line 85, column 26): " + [
                                        mb.constructor.name
                                    ]);
                                });
                            }))(function() {
                                return $fca560e14229da4e$export$358211fab263c66b(v1)(function(b) {
                                    return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ra)))(function(ma) {
                                        if (ma instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(rb));
                                        if (ma instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(ma.value0(b));
                                        throw new Error("Failed pattern match at Control.Parallel.Class (line 89, column 7 - line 91, column 26): " + [
                                            ma.constructor.name
                                        ]);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$5823fd8d45c99450 = function(dictMonadEffect) {
    var applyParCont1 = $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
    return {
        pure: function() {
            var $132 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $133 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictMonadEffect.Monad0().Applicative0()));
            return function($134) {
                return $132($133($134));
            };
        }(),
        Apply0: function() {
            return applyParCont1;
        }
    };
};
var $86141680556a7436$export$e02ea57753bb8483 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var functorParCont1 = $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
    return {
        alt: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(done) {
                        return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                            return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                    return k(a);
                                });
                            });
                        }))(function() {
                            return $fca560e14229da4e$export$358211fab263c66b(v1)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                    if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                    return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                        return k(a);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorParCont1;
        }
    };
};
var $86141680556a7436$export$eed929a02bcaa239 = function(dictMonadEffect) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadEffect.Monad0().Applicative0());
    var altParCont1 = $86141680556a7436$export$e02ea57753bb8483(dictMonadEffect);
    return {
        empty: function(v) {
            return pure($05149ea687d6b460$export$523c0b569236b342);
        },
        Alt0: function() {
            return altParCont1;
        }
    };
};
var $86141680556a7436$export$2e55be12f6c16793 = function(dictMonadEffect) {
    var applicativeParCont1 = $86141680556a7436$export$5823fd8d45c99450(dictMonadEffect);
    var plusParCont1 = $86141680556a7436$export$eed929a02bcaa239(dictMonadEffect);
    return {
        Applicative0: function() {
            return applicativeParCont1;
        },
        Plus1: function() {
            return plusParCont1;
        }
    };
};


// Generated by purs version 0.15.15
const $44c597fdc38e7b03$export$6332150c6d01d807 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = len - 1; i >= 0; i--)acc = f(xs[i])(acc);
            return acc;
        };
    };
};
const $44c597fdc38e7b03$export$6b86e13802001a00 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = 0; i < len; i++)acc = f(acc)(xs[i]);
            return acc;
        };
    };
};











// Generated by purs version 0.15.15









var $490ec114b4138e6d$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $490ec114b4138e6d$export$a7f096464cca5f3a = function(x) {
    return x;
};
var $490ec114b4138e6d$export$593e0c14cbf7732e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Functor.Coproduct (line 63, column 1 - line 65, column 60): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $490ec114b4138e6d$export$79ffe56a765070d2 = function(ga) {
    return new $7d4cccdf062a2261$export$19db0165690c701a(ga);
};
var $490ec114b4138e6d$export$7fc1e26c1ee5b3a4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $490ec114b4138e6d$export$eabcd2c8791e7bf4 = function(fa) {
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(fa);
};
var $490ec114b4138e6d$export$e192c0fa89a291cb = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $490ec114b4138e6d$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$30aaa5110153edc1 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq13(v.value0)(v1.value0);
                        return false;
                    };
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$4f54a72d7417da7c = function(dictEq1) {
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Coproduct1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $490ec114b4138e6d$export$ec3d1f0587fb15ed = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Coproduct2 = eq1Coproduct1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare13(v.value0)(v1.value0);
                        throw new Error("Failed pattern match at Data.Functor.Coproduct (line 57, column 5 - line 61, column 43): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
            },
            Eq10: function() {
                return eq1Coproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$f437f5dfb3faee67 = function(dictOrd1) {
    var ord1Coproduct1 = $490ec114b4138e6d$export$ec3d1f0587fb15ed(dictOrd1);
    var eqCoproduct1 = $490ec114b4138e6d$export$4f54a72d7417da7c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Coproduct1(dictOrd11));
        var eqCoproduct2 = eqCoproduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqCoproduct3 = eqCoproduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqCoproduct3;
                }
            };
        };
    };
};
var $490ec114b4138e6d$export$ab04af7daecb905f = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Functor.Coproduct (line 27, column 1 - line 27, column 78): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $490ec114b4138e6d$export$7ce1af5f45fd6777 = function(dictExtend) {
    var extend = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    var functorCoproduct1 = $490ec114b4138e6d$export$e192c0fa89a291cb(dictExtend.Functor0());
    return function(dictExtend1) {
        var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend1);
        var functorCoproduct2 = functorCoproduct1(dictExtend1.Functor0());
        return {
            extend: function(f) {
                var $106 = $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $108 = extend(function($110) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($110)));
                    });
                    return function($109) {
                        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($108($109));
                    };
                }())(function() {
                    var $111 = extend1(function($113) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($113)));
                    });
                    return function($112) {
                        return $7d4cccdf062a2261$export$19db0165690c701a.create($111($112));
                    };
                }());
                return function($107) {
                    return $490ec114b4138e6d$export$a7f096464cca5f3a($106($107));
                };
            },
            Functor0: function() {
                return functorCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$2f16914668ceb808 = function(dictComonad) {
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var extendCoproduct1 = $490ec114b4138e6d$export$7ce1af5f45fd6777(dictComonad.Extend0());
    return function(dictComonad1) {
        var extendCoproduct2 = extendCoproduct1(dictComonad1.Extend0());
        return {
            extract: $490ec114b4138e6d$export$ab04af7daecb905f(extract)($b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad1)),
            Extend0: function() {
                return extendCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$c1a518500c2ed5de = function(natF) {
    return function(natG) {
        return function(v) {
            return $490ec114b4138e6d$var$bimap(natF)(natG)(v);
        };
    };
};




// Generated by purs version 0.15.15




var $92016ca92c497156$export$b25abba66f7be210 = function(x) {
    return x;
};
var $92016ca92c497156$export$20f833961f1940c8 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "First (" + (show(v) + ")");
        }
    };
};
var $92016ca92c497156$export$53ff158b23f5d382 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v;
            return v1;
        };
    }
};
var $92016ca92c497156$export$4d7d8eedf770f0 = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $92016ca92c497156$export$f6a5e365037ccf9a = $06733ae99ed4f534$export$c82772423d5de0b;
var $92016ca92c497156$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $92016ca92c497156$export$db2423f7434b7a30 = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $92016ca92c497156$export$53ff158b23f5d382;
        }
    };
}();
var $92016ca92c497156$export$e17b0506de713d2e = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $92016ca92c497156$export$6f62e1511455cb87 = $06733ae99ed4f534$export$62eda6ff839a0571;
var $92016ca92c497156$export$98d9d13e8b5bfe4d = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $92016ca92c497156$export$590ee69b33ca98b4 = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $92016ca92c497156$export$8232f15b0b41395c = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $92016ca92c497156$export$1a969f11cd8a353e = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $92016ca92c497156$export$315f32b6f78e2785 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $92016ca92c497156$export$456f8570baa6024f = $06733ae99ed4f534$export$e5fea5661dee377;
var $92016ca92c497156$export$e48e2da4536c2eea = $06733ae99ed4f534$export$22d9917da16590e7;
var $92016ca92c497156$export$178f5831973b2ff8 = $06733ae99ed4f534$export$b203ef4465f15037;
var $92016ca92c497156$export$5cfe42f95bdf312b = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($92016ca92c497156$export$53ff158b23f5d382),
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $92016ca92c497156$export$e3c1997b7c0ee480 = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($92016ca92c497156$export$db2423f7434b7a30),
    Alt0: function() {
        return $92016ca92c497156$export$5cfe42f95bdf312b;
    }
};
var $92016ca92c497156$export$92398121afed1258 = {
    Applicative0: function() {
        return $92016ca92c497156$export$178f5831973b2ff8;
    },
    Plus1: function() {
        return $92016ca92c497156$export$e3c1997b7c0ee480;
    }
};



// Generated by purs version 0.15.15




var $65ae0a43a0950bac$export$c688766eb4789b8c = function(x) {
    return x;
};
var $65ae0a43a0950bac$export$3e00b8f10f0f4e39 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Conj " + (show(v) + ")");
        }
    };
};
var $65ae0a43a0950bac$export$b71164e0e6b84c70 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$91e0ef53a9c72523 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$74eade9f2b920d02 = function(dictOrd) {
    return dictOrd;
};
var $65ae0a43a0950bac$export$4f2b093ea8408d89 = function(dictHeytingAlgebra) {
    var semigroupConj1 = $65ae0a43a0950bac$export$91e0ef53a9c72523(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
var $65ae0a43a0950bac$export$48b7cf0194537bca = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $65ae0a43a0950bac$export$2d4ce045d5165d6f = function(dictEq) {
    return dictEq;
};
var $65ae0a43a0950bac$export$43823c09e8843bf5 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($65ae0a43a0950bac$export$2d4ce045d5165d6f(dictEq));
    }
};
var $65ae0a43a0950bac$export$a6a01ce014de97e1 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($65ae0a43a0950bac$export$74eade9f2b920d02(dictOrd));
    },
    Eq10: function() {
        return $65ae0a43a0950bac$export$43823c09e8843bf5;
    }
};
var $65ae0a43a0950bac$export$a4102daba18ffc08 = function(dictBounded) {
    return dictBounded;
};
var $65ae0a43a0950bac$export$a163c218e9f2482b = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $65ae0a43a0950bac$export$b79fdb9ffe29876e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$af9c11f53d676ebc = {
    pure: $65ae0a43a0950bac$export$c688766eb4789b8c,
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$7c7cf1e6ee225e25 = {
    Applicative0: function() {
        return $65ae0a43a0950bac$export$af9c11f53d676ebc;
    },
    Bind1: function() {
        return $65ae0a43a0950bac$export$b79fdb9ffe29876e;
    }
};


// Generated by purs version 0.15.15




var $1242d110ab1edcd9$export$286e7113895e33ef = function(x) {
    return x;
};
var $1242d110ab1edcd9$export$84ed1543fc941c9a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Disj " + (show(v) + ")");
        }
    };
};
var $1242d110ab1edcd9$export$5b0a7c2f35d7a492 = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$f23e3b19aa9e04ea = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$5f1629868b2a8f7a = function(dictOrd) {
    return dictOrd;
};
var $1242d110ab1edcd9$export$e1c73e5b30670500 = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $1242d110ab1edcd9$export$f23e3b19aa9e04ea(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
var $1242d110ab1edcd9$export$410cd7ab647069e5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $1242d110ab1edcd9$export$3f2868cf248cd7c5 = function(dictEq) {
    return dictEq;
};
var $1242d110ab1edcd9$export$8ab894b15d39baff = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($1242d110ab1edcd9$export$3f2868cf248cd7c5(dictEq));
    }
};
var $1242d110ab1edcd9$export$b2df6a05be54d5b7 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($1242d110ab1edcd9$export$5f1629868b2a8f7a(dictOrd));
    },
    Eq10: function() {
        return $1242d110ab1edcd9$export$8ab894b15d39baff;
    }
};
var $1242d110ab1edcd9$export$fcd058ea94ebee31 = function(dictBounded) {
    return dictBounded;
};
var $1242d110ab1edcd9$export$6e64deb0714631e6 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $1242d110ab1edcd9$export$997bc439fd07ce0b = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$a5d698d68d7ba6f5 = {
    pure: $1242d110ab1edcd9$export$286e7113895e33ef,
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$15ab4d3c125d7ac0 = {
    Applicative0: function() {
        return $1242d110ab1edcd9$export$a5d698d68d7ba6f5;
    },
    Bind1: function() {
        return $1242d110ab1edcd9$export$997bc439fd07ce0b;
    }
};


// Generated by purs version 0.15.15





var $8257f7a36ab9f9cd$export$c26a72e8d91adeec = function(x) {
    return x;
};
var $8257f7a36ab9f9cd$export$367774d50e2e283e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Dual " + (show(v) + ")");
        }
    };
};
var $8257f7a36ab9f9cd$export$dc7d4cd4865fc48 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return append1(v1)(v);
            };
        }
    };
};
var $8257f7a36ab9f9cd$export$baedc2c70a4ae2b1 = function(dictOrd) {
    return dictOrd;
};
var $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb = function(dictMonoid) {
    var semigroupDual1 = $8257f7a36ab9f9cd$export$dc7d4cd4865fc48(dictMonoid.Semigroup0());
    return {
        mempty: $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid),
        Semigroup0: function() {
            return semigroupDual1;
        }
    };
};
var $8257f7a36ab9f9cd$export$916a3957c09e9ed5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $8257f7a36ab9f9cd$export$2b6bf0b2b79b7623 = function(dictEq) {
    return dictEq;
};
var $8257f7a36ab9f9cd$export$334c9b177d56941 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($8257f7a36ab9f9cd$export$2b6bf0b2b79b7623(dictEq));
    }
};
var $8257f7a36ab9f9cd$export$f00e1ac1e19e7381 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($8257f7a36ab9f9cd$export$baedc2c70a4ae2b1(dictOrd));
    },
    Eq10: function() {
        return $8257f7a36ab9f9cd$export$334c9b177d56941;
    }
};
var $8257f7a36ab9f9cd$export$5a3916bf05e599b0 = function(dictBounded) {
    return dictBounded;
};
var $8257f7a36ab9f9cd$export$9e642462d19ab815 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $8257f7a36ab9f9cd$export$307a1784edb0cbc9 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$f853c12137409deb = {
    pure: $8257f7a36ab9f9cd$export$c26a72e8d91adeec,
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$965738b694a4882b = {
    Applicative0: function() {
        return $8257f7a36ab9f9cd$export$f853c12137409deb;
    },
    Bind1: function() {
        return $8257f7a36ab9f9cd$export$307a1784edb0cbc9;
    }
};


// Generated by purs version 0.15.15



var $57b8542ac3131c5d$export$6aef3ff797629bec = function(x) {
    return x;
};
var $57b8542ac3131c5d$export$e6887fe542fcbae3 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Endo " + (show(v) + ")");
        }
    };
};
var $57b8542ac3131c5d$export$5f7c224ff60452b9 = function(dictSemigroupoid) {
    var compose = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return {
        append: function(v) {
            return function(v1) {
                return compose(v)(v1);
            };
        }
    };
};
var $57b8542ac3131c5d$export$5f95a5e6b940187f = function(dictOrd) {
    return dictOrd;
};
var $57b8542ac3131c5d$export$947ca1a8eed6111 = function(dictCategory) {
    var semigroupEndo1 = $57b8542ac3131c5d$export$5f7c224ff60452b9(dictCategory.Semigroupoid0());
    return {
        mempty: $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory),
        Semigroup0: function() {
            return semigroupEndo1;
        }
    };
};
var $57b8542ac3131c5d$export$ee65626e0479baec = function(dictEq) {
    return dictEq;
};
var $57b8542ac3131c5d$export$35b120d2f621b3e2 = function(dictBounded) {
    return dictBounded;
};








var $4fe7b6acfba7f29f$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $4fe7b6acfba7f29f$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fe7b6acfba7f29f$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($4fe7b6acfba7f29f$var$monoidEndo);
var $4fe7b6acfba7f29f$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf = function(dict) {
    return dict.foldr;
};
var $4fe7b6acfba7f29f$export$f14ab6cb4b8e359c = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(idx) {
        var go = function(a) {
            return function(cursor) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $292 = cursor.pos === idx;
                if ($292) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $451 = foldr2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($452) {
            return function(v) {
                return v.elem;
            }($451($452));
        };
    };
};
var $4fe7b6acfba7f29f$export$7b1b591b262c240 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)(function(v) {
        return function(v1) {
            return false;
        };
    })(true);
};
var $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        return foldr2($75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0()))($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus));
    };
};
var $4fe7b6acfba7f29f$export$79f3cac53daaaae6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0());
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        return function(f) {
            return foldr2(function($453) {
                return alt(f($453));
            })(empty);
        };
    };
};
var $4fe7b6acfba7f29f$export$33f63ccdb08d8723 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldable) {
        var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return function(f) {
            return foldr2(function($454) {
                return applySecond(f($454));
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $4fe7b6acfba7f29f$export$9747ee7caa0b40b1 = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse_1(dictFoldable));
    };
};
var $4fe7b6acfba7f29f$export$4426b9bff8b7b6fb = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return traverse_1(dictFoldable)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$50ae948ca12cdcbc = function(dict) {
    return dict.foldl;
};
var $4fe7b6acfba7f29f$export$fe35754984712af1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(idx) {
        var go = function(cursor) {
            return function(a) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $296 = cursor.pos === idx;
                if ($296) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $455 = foldl2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($456) {
            return function(v) {
                return v.elem;
            }($455($456));
        };
    };
};
var $4fe7b6acfba7f29f$export$739ec22334c44788 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go = function(v) {
                    return function(v1) {
                        if (v.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append(v.acc)(append(sep)(v1))
                        };
                    };
                };
                return foldl2(go)({
                    init: true,
                    acc: mempty
                })(xs).acc;
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$f24224f1c91d8156 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
        return foldl2(function(c) {
            return function(v) {
                return add1(one)(c);
            };
        })($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$c42fa06aba2a552c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var max$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $303 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$b023c82b48e70453.value);
                    if ($303) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(max$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$b25e0be55f42c9a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$c42fa06aba2a552c(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$b65392d958998255 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var min$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $307 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                    if ($307) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 454, column 3 - line 454, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(min$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$916782c1f0ddb132 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$b65392d958998255(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$dbd0f18357df1ddd = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring))($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$8a63f25cc62965f1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$e16d8520af44a096(dictSemiring))($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v.value1)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v.value1);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$9519b6731ae6781c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$ff97dbee91e727b6 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return mempty;
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$3c076fb5bbc5428f = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6a194eaac00c1ff4 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$fbf8f11f9a917de3 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6857d056e9f0762d = {
    foldr: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldl: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$b0c90191a04a5815 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a3b6f6613d3d5767 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$edac6f86a9ee0bec = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldr2(function(x) {
                return function(acc) {
                    return append(f(x))(acc);
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$e97014618a7eb593 = {
    foldr: $44c597fdc38e7b03$export$6332150c6d01d807,
    foldl: $44c597fdc38e7b03$export$6b86e13802001a00,
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$edac6f86a9ee0bec($4fe7b6acfba7f29f$export$e97014618a7eb593)(dictMonoid);
    }
};
var $4fe7b6acfba7f29f$export$1131b47d09454899 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldl2(function(acc) {
                return function(x) {
                    return append(acc)(f(x));
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$b66cdc0497d8a99a = function(dict) {
    return dict.foldMap;
};
var $4fe7b6acfba7f29f$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(i) {
                return function(v) {
                    return foldr2(f)(i)(v);
                };
            };
        },
        foldl: function(f) {
            return function(i) {
                return function(v) {
                    return foldl2(f)(i)(v);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap3 = foldMap2(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMap3(f)(v);
                };
            };
        }
    };
};
var $4fe7b6acfba7f29f$export$5677464b2ea4179d = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(i) {
                    return function(v) {
                        return foldr2($f57f4b701aa7b66e$export$8a83211c878a3f1f(foldr3(f)))(i)(v);
                    };
                };
            },
            foldl: function(f) {
                return function(i) {
                    return function(v) {
                        return foldl2(foldl3(f))(i)(v);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMap4(foldMap5(f))(v);
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$5c9c2b827ab84341 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldr2(f)(z))(foldr3(f)(z));
                };
            },
            foldl: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldl2(f)(z))(foldl3(f)(z));
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMap4(f))(foldMap5(f));
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$d127e049f7f9d81c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a013322ac1f6d3aa = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return function(v) {
                        return foldr2(f)(foldr3(f)(z)(v.value1))(v.value0);
                    };
                };
            },
            foldl: function(f) {
                return function(z) {
                    return function(v) {
                        return foldl3(f)(foldl2(f)(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMap4(f)(v.value0))(foldMap5(f)(v.value1));
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$e623e8bf74059b22 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap($4fe7b6acfba7f29f$var$unwrap(foldMap2(function() {
                    var $457 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c);
                    return function($458) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($457($458)));
                    };
                }())(xs)))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$9b986141719153e = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap(foldMap2(function($459) {
                    return $57b8542ac3131c5d$export$6aef3ff797629bec(c($459));
                })(xs))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$dfc7155ac0343b8 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($92016ca92c497156$export$db2423f7434b7a30);
    return function(dictEq) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(a) {
            var $460 = foldMap2(function(v) {
                var $444 = eq2(a)(v.value0);
                if ($444) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            });
            return function($461) {
                return $4fe7b6acfba7f29f$var$unwrap($460($461));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$7606e2cbf4afaea2 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(a) {
                        return function(m) {
                            return append(d)(append(t(a))(m));
                        };
                    };
                    return $4fe7b6acfba7f29f$var$unwrap(foldMap2(joined)(f))(d);
                };
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$5a27709e8737ce25 = function(dictFoldable) {
    var surroundMap1 = $4fe7b6acfba7f29f$export$7606e2cbf4afaea2(dictFoldable);
    return function(dictSemigroup) {
        var surroundMap2 = surroundMap1(dictSemigroup);
        return function(d) {
            return surroundMap2(d)($4fe7b6acfba7f29f$var$identity);
        };
    };
};
var $4fe7b6acfba7f29f$export$7a067f9280ad8af0 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(b0) {
                return foldl2(function(b) {
                    return function(a) {
                        return bind(b)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f)(a));
                    };
                })(pure(b0));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$93e2b83da34ff82a = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictMonoid) {
        return foldMap2(dictMonoid)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$23e5dcedfce4509c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return p(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$71aa6c912b956294 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v1)) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$4154a199d7d90455 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($1242d110ab1edcd9$export$286e7113895e33ef)(foldMap2($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$5bf96401662340b7 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
    return function(dictEq) {
        var $462 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $4fe7b6acfba7f29f$export$63faa62a0284a4a6 = function(dictFoldable) {
    var elem1 = $4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable);
    return function(dictEq) {
        var elem2 = elem1(dictEq);
        return function(x) {
            var $464 = elem2(x);
            return function($465) {
                return !$464($465);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$252bb8b3bbdf6749 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable);
    return function(dictHeytingAlgebra) {
        return any1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$84bf76cd7afc7469 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($65ae0a43a0950bac$export$c688766eb4789b8c)(foldMap2($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$21c0ac7fe1cef1b8 = function(dictFoldable) {
    var all1 = $4fe7b6acfba7f29f$export$84bf76cd7afc7469(dictFoldable);
    return function(dictHeytingAlgebra) {
        return all1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};


// Generated by purs version 0.15.15
// jshint maxparams: 3
const $e2e7171b55349aa8$export$778bf95e3da1fa51 = function() {
    function array1(a) {
        return [
            a
        ];
    }
    function array2(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    }
    function array3(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply) {
        return function(map) {
            return function(pure) {
                return function(f) {
                    return function(array) {
                        function go(bot, top) {
                            switch(top - bot){
                                case 0:
                                    return pure([]);
                                case 1:
                                    return map(array1)(f(array[bot]));
                                case 2:
                                    return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                                case 3:
                                    return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                                default:
                                    // This slightly tricky pivot selection aims to produce two
                                    // even-length partitions where possible.
                                    var pivot = bot + Math.floor((top - bot) / 4) * 2;
                                    return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                            }
                        }
                        return go(0, array.length);
                    };
                };
            };
        };
    };
}();





// Generated by purs version 0.15.15






var $10ae0394c8c3139a$export$8ad5d15375e29446 = function(x) {
    return x;
};
var $10ae0394c8c3139a$export$698fc26f8c8bb631 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Const " + (show(v) + ")");
        }
    };
};
var $10ae0394c8c3139a$export$8e644eba3b05046b = function(dictSemiring) {
    return dictSemiring;
};
var $10ae0394c8c3139a$export$8f2711bf2f3160c6 = {
    compose: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $10ae0394c8c3139a$export$6eaf1848e07ae857 = function(dictSemigroup) {
    return dictSemigroup;
};
var $10ae0394c8c3139a$export$e21edfc60fb6207c = function(dictRing) {
    return dictRing;
};
var $10ae0394c8c3139a$export$2dc639aba34e0026 = function(dictOrd) {
    return dictOrd;
};
var $10ae0394c8c3139a$export$ea93befd55cd9816 = {
    Coercible0: function() {
        return undefined;
    }
};
var $10ae0394c8c3139a$export$d484d0b1dc07b605 = function(dictMonoid) {
    return dictMonoid;
};
var $10ae0394c8c3139a$export$208a79db5ecd5bbf = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $10ae0394c8c3139a$export$c03820c48bf31fc8 = {
    map: function(f) {
        return function(m) {
            return m;
        };
    }
};
var $10ae0394c8c3139a$export$30c2a66ea46ad17b = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($10ae0394c8c3139a$export$c03820c48bf31fc8)
};
var $10ae0394c8c3139a$export$aa81c0060845253 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $10ae0394c8c3139a$export$1688a037b5b692da = function(dictEq) {
    return dictEq;
};
var $10ae0394c8c3139a$export$bdb9acf61703c804 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($10ae0394c8c3139a$export$1688a037b5b692da(dictEq));
    return {
        eq1: function(dictEq1) {
            return eq;
        }
    };
};
var $10ae0394c8c3139a$export$87702177ef8adff4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($10ae0394c8c3139a$export$2dc639aba34e0026(dictOrd));
    var eq1Const1 = $10ae0394c8c3139a$export$bdb9acf61703c804(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return compare;
        },
        Eq10: function() {
            return eq1Const1;
        }
    };
};
var $10ae0394c8c3139a$export$c708f2c7ab030e40 = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $10ae0394c8c3139a$export$9ca7ce64fd99d2e3 = function(dictBounded) {
    return dictBounded;
};
var $10ae0394c8c3139a$export$b7df7e3b07273a9c = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $10ae0394c8c3139a$export$17ba89632b46bf87 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return append1(v)(v1);
            };
        },
        Functor0: function() {
            return $10ae0394c8c3139a$export$c03820c48bf31fc8;
        }
    };
};
var $10ae0394c8c3139a$export$38647a91a5af2717 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyConst1 = $10ae0394c8c3139a$export$17ba89632b46bf87(dictMonoid.Semigroup0());
    return {
        pure: function(v) {
            return mempty;
        },
        Apply0: function() {
            return applyConst1;
        }
    };
};








// Generated by purs version 0.15.15











var $a2051f9edf3d1db6$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $a2051f9edf3d1db6$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $a2051f9edf3d1db6$export$264ad599d7cef668 = function(x) {
    return x;
};
var $a2051f9edf3d1db6$export$821c121fea76e4f5 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(product " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $a2051f9edf3d1db6$export$dbd0f18357df1ddd = function(fa) {
    return function(ga) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fa, ga);
    };
};
var $a2051f9edf3d1db6$export$7ea85e95f1a9febc = {
    Coercible0: function() {
        return undefined;
    }
};
var $a2051f9edf3d1db6$export$e5b52224642d1f48 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $a2051f9edf3d1db6$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$df541bd41566d1a7 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        return eq12(v.value0)(v1.value0) && eq13(v.value1)(v1.value1);
                    };
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$e82658b20fc49a26 = function(dictEq1) {
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Product1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Product2 = eq1Product1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        var v2 = compare12(v.value0)(v1.value0);
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return compare13(v.value1)(v1.value1);
                        return v2;
                    };
                };
            },
            Eq10: function() {
                return eq1Product2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$96856f3fc4c91454 = function(dictOrd1) {
    var ord1Product1 = $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7(dictOrd1);
    var eqProduct1 = $a2051f9edf3d1db6$export$e82658b20fc49a26(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Product1(dictOrd11));
        var eqProduct2 = eqProduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqProduct3 = eqProduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqProduct3;
                }
            };
        };
    };
};
var $a2051f9edf3d1db6$export$a3738445608c58d6 = function(natF) {
    return function(natG) {
        return function(v) {
            return $a2051f9edf3d1db6$var$bimap(natF)(natG)(v);
        };
    };
};
var $a2051f9edf3d1db6$export$893d0f454e6dfaee = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorProduct1 = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictApply.Functor0());
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorProduct2 = functorProduct1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(apply(v.value0)(v1.value0))(apply1(v.value1)(v1.value1));
                };
            },
            Functor0: function() {
                return functorProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$5990c3ca6a566877 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictBind.Apply0());
    return function(dictBind1) {
        var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind1);
        var applyProduct2 = applyProduct1(dictBind1.Apply0());
        return {
            bind: function(v) {
                return function(f) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(bind(v.value0)(function($128) {
                        return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($a2051f9edf3d1db6$var$unwrap(f($128)));
                    }))(bind1(v.value1)(function($129) {
                        return $71f2e2e9476163f8$export$6f71268a1666ab58($a2051f9edf3d1db6$var$unwrap(f($129)));
                    }));
                };
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2034ae3acf01a9af = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
        var applyProduct2 = applyProduct1(dictApplicative1.Apply0());
        return {
            pure: function(a) {
                return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(pure(a))(pure1(a));
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2dfe129c60aea5cb = function(dictMonad) {
    var applicativeProduct1 = $a2051f9edf3d1db6$export$2034ae3acf01a9af(dictMonad.Applicative0());
    var bindProduct1 = $a2051f9edf3d1db6$export$5990c3ca6a566877(dictMonad.Bind1());
    return function(dictMonad1) {
        var applicativeProduct2 = applicativeProduct1(dictMonad1.Applicative0());
        var bindProduct2 = bindProduct1(dictMonad1.Bind1());
        return {
            Applicative0: function() {
                return applicativeProduct2;
            },
            Bind1: function() {
                return bindProduct2;
            }
        };
    };
};





// Generated by purs version 0.15.15




var $1b4bd570fcdcddf2$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $1b4bd570fcdcddf2$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $1b4bd570fcdcddf2$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1;
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            throw new Error("Failed pattern match at Data.Maybe.Last (line 54, column 1 - line 56, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $1b4bd570fcdcddf2$export$4ded69d4b0c99b7b = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $1b4bd570fcdcddf2$export$64bd44ceff2f4638 = $06733ae99ed4f534$export$c82772423d5de0b;
var $1b4bd570fcdcddf2$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1b4bd570fcdcddf2$export$862bb074dbe2690f = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $1b4bd570fcdcddf2$export$6d3c4648150c5bae;
        }
    };
}();
var $1b4bd570fcdcddf2$export$25d122cd3cbaf721 = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $1b4bd570fcdcddf2$export$21558e167578c47d = $06733ae99ed4f534$export$62eda6ff839a0571;
var $1b4bd570fcdcddf2$export$74aba74241121413 = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $1b4bd570fcdcddf2$export$7f096d1e61d1725f = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $1b4bd570fcdcddf2$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $1b4bd570fcdcddf2$export$634a54207b73ac14 = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $1b4bd570fcdcddf2$export$835f68c2f339b021 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $1b4bd570fcdcddf2$export$f2b93d1f1ac78d51 = $06733ae99ed4f534$export$e5fea5661dee377;
var $1b4bd570fcdcddf2$export$dcd798c84777f95 = $06733ae99ed4f534$export$22d9917da16590e7;
var $1b4bd570fcdcddf2$export$5b4de68c5dd33934 = $06733ae99ed4f534$export$b203ef4465f15037;
var $1b4bd570fcdcddf2$export$a0374697fe7c8648 = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($1b4bd570fcdcddf2$export$6d3c4648150c5bae),
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $1b4bd570fcdcddf2$export$1bb9770eb80691dd = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($1b4bd570fcdcddf2$export$862bb074dbe2690f),
    Alt0: function() {
        return $1b4bd570fcdcddf2$export$a0374697fe7c8648;
    }
};
var $1b4bd570fcdcddf2$export$bc87013f8f3da20e = {
    Applicative0: function() {
        return $1b4bd570fcdcddf2$export$5b4de68c5dd33934;
    },
    Plus1: function() {
        return $1b4bd570fcdcddf2$export$1bb9770eb80691dd;
    }
};


// Generated by purs version 0.15.15




var $e48f2e41a907ae60$export$14f8ce08180a98e1 = function(x) {
    return x;
};
var $e48f2e41a907ae60$export$d0709814982cbf95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Additive " + (show(v) + ")");
        }
    };
};
var $e48f2e41a907ae60$export$8adb2de2291fe34 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return add(v)(v1);
            };
        }
    };
};
var $e48f2e41a907ae60$export$45e15fb7ca2189d8 = function(dictOrd) {
    return dictOrd;
};
var $e48f2e41a907ae60$export$c38b62d29991685f = function(dictSemiring) {
    var semigroupAdditive1 = $e48f2e41a907ae60$export$8adb2de2291fe34(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring),
        Semigroup0: function() {
            return semigroupAdditive1;
        }
    };
};
var $e48f2e41a907ae60$export$ba106ed6ee21ba26 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $e48f2e41a907ae60$export$7e0cae55dbdaa6a6 = function(dictEq) {
    return dictEq;
};
var $e48f2e41a907ae60$export$3bc4d3e676a5f3ba = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($e48f2e41a907ae60$export$7e0cae55dbdaa6a6(dictEq));
    }
};
var $e48f2e41a907ae60$export$bf0109c88461ccc9 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($e48f2e41a907ae60$export$45e15fb7ca2189d8(dictOrd));
    },
    Eq10: function() {
        return $e48f2e41a907ae60$export$3bc4d3e676a5f3ba;
    }
};
var $e48f2e41a907ae60$export$ac1ed4a2f2107898 = function(dictBounded) {
    return dictBounded;
};
var $e48f2e41a907ae60$export$9ed13d4e91f74d66 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};
var $e48f2e41a907ae60$export$3c0293aa90d839fe = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$3f78fbeb96209a2 = {
    pure: $e48f2e41a907ae60$export$14f8ce08180a98e1,
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$50439d128d692efb = {
    Applicative0: function() {
        return $e48f2e41a907ae60$export$3f78fbeb96209a2;
    },
    Bind1: function() {
        return $e48f2e41a907ae60$export$3c0293aa90d839fe;
    }
};





// Generated by purs version 0.15.15




var $665413393090e9d0$export$d0198c9c86fc2be1 = function(x) {
    return x;
};
var $665413393090e9d0$export$27987c20bfe6da1c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Multiplicative " + (show(v) + ")");
        }
    };
};
var $665413393090e9d0$export$879165283e0876da = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return mul(v)(v1);
            };
        }
    };
};
var $665413393090e9d0$export$a745aa1873a0c2a6 = function(dictOrd) {
    return dictOrd;
};
var $665413393090e9d0$export$b1fd47ce92821578 = function(dictSemiring) {
    var semigroupMultiplicative1 = $665413393090e9d0$export$879165283e0876da(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring),
        Semigroup0: function() {
            return semigroupMultiplicative1;
        }
    };
};
var $665413393090e9d0$export$fb489b392661d391 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $665413393090e9d0$export$d7079d8ae90b8bb4 = function(dictEq) {
    return dictEq;
};
var $665413393090e9d0$export$989c1e5544f0c166 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($665413393090e9d0$export$d7079d8ae90b8bb4(dictEq));
    }
};
var $665413393090e9d0$export$fecaa24314ae6d78 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($665413393090e9d0$export$a745aa1873a0c2a6(dictOrd));
    },
    Eq10: function() {
        return $665413393090e9d0$export$989c1e5544f0c166;
    }
};
var $665413393090e9d0$export$bbf6fde3198eeb4e = function(dictBounded) {
    return dictBounded;
};
var $665413393090e9d0$export$4270b48d12c8e2c9 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $665413393090e9d0$export$b787e2c352a5d886 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$98fc700c14e70ff0 = {
    pure: $665413393090e9d0$export$d0198c9c86fc2be1,
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$8980d206f063bc12 = {
    Applicative0: function() {
        return $665413393090e9d0$export$98fc700c14e70ff0;
    },
    Bind1: function() {
        return $665413393090e9d0$export$b787e2c352a5d886;
    }
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
var $b5a91a6cc4fccdbd$export$e55c55b7b44ad601 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$28dda4bfb631a565 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$8c9fed8401f25951 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$25c41c6231a79e25 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$b9d5be898ea82056 = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$68347817ab3710ea = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(x)(s);
                var v1 = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(f)(v.accum);
                return {
                    accum: v1.accum,
                    value: v1.value(v.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd;
    }
};
var $b5a91a6cc4fccdbd$export$d997dc0aadd0b300 = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(f)(s);
                var v1 = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(x)(v.accum);
                return {
                    accum: v1.accum,
                    value: v.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$b9d5be898ea82056;
    }
};
var $b5a91a6cc4fccdbd$export$c4ee441de2fba0d9 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$68347817ab3710ea;
    }
};
var $b5a91a6cc4fccdbd$export$9fd2229713491b84 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$d997dc0aadd0b300;
    }
};



var $11d1e86de605dfc6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $11d1e86de605dfc6$export$df3f009e3d155b20 = function(dict) {
    return dict.traverse;
};
var $11d1e86de605dfc6$export$d35878ee42638401 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $11d1e86de605dfc6$export$b86a2d00788e21b6 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($665413393090e9d0$export$d0198c9c86fc2be1)(v);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $11d1e86de605dfc6$export$80f6258c17467741 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $11d1e86de605dfc6$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$63e84f34fb558532 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $11d1e86de605dfc6$export$29eea1300519490d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $11d1e86de605dfc6$export$54df524caf88dbea = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(v);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $11d1e86de605dfc6$export$a73c18000a1a08d7 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($1242d110ab1edcd9$export$286e7113895e33ef)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($1242d110ab1edcd9$export$286e7113895e33ef)(v);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $11d1e86de605dfc6$export$e6d8402c3fd7d14d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return pure(v);
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $11d1e86de605dfc6$export$ecbf0d941e1ac029 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($65ae0a43a0950bac$export$c688766eb4789b8c)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($65ae0a43a0950bac$export$c688766eb4789b8c)(v);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $11d1e86de605dfc6$export$8c91a5391205dbe = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictTraversable.Functor0());
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var functorCompose1 = functorCompose(dictTraversable1.Functor0());
        var foldableCompose1 = foldableCompose(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverse4(traverse5(f))(v));
                    };
                };
            },
            sequence: function(dictApplicative) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversable)(dictTraversable1))(dictApplicative)($11d1e86de605dfc6$var$identity);
            },
            Functor0: function() {
                return functorCompose1;
            },
            Foldable1: function() {
                return foldableCompose1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$617ac6e03fd9951c = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(v);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $11d1e86de605dfc6$export$417d88f64c497aed = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    return function(dictApplicative) {
        return traverse2(dictApplicative)($11d1e86de605dfc6$var$identity);
    };
};
var $11d1e86de605dfc6$export$9e4a28683e28e26a = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $e2e7171b55349aa8$export$778bf95e3da1fa51($7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0))($f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0()))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($11d1e86de605dfc6$export$9e4a28683e28e26a)(dictApplicative);
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $11d1e86de605dfc6$export$49bb65c2ea163039 = function(dict) {
    return dict.sequence;
};
var $11d1e86de605dfc6$var$sequence1 = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$744e1c7707f1991f = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictTraversable.Functor0());
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse3 = traverse2(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverse3(f)(v));
                };
            };
        },
        sequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var sequence3 = sequence2(dictApplicative);
            return function(v) {
                return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(sequence3(v));
            };
        },
        Functor0: function() {
            return functorApp;
        },
        Foldable1: function() {
            return foldableApp;
        }
    };
};
var $11d1e86de605dfc6$export$78124b32135c203a = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictTraversable.Functor0());
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorCoproduct1 = functorCoproduct(dictTraversable1.Functor0());
        var foldableCoproduct1 = foldableCoproduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $313 = map(function($316) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($316));
                        });
                        var $314 = traverse4(f);
                        return function($315) {
                            return $313($314($315));
                        };
                    }())(function() {
                        var $317 = map(function($320) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($320));
                        });
                        var $318 = traverse5(f);
                        return function($319) {
                            return $317($318($319));
                        };
                    }());
                };
            },
            sequence: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $321 = map(function($324) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($324));
                    });
                    var $322 = sequence2(dictApplicative);
                    return function($323) {
                        return $321($322($323));
                    };
                }())(function() {
                    var $325 = map(function($328) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($328));
                    });
                    var $326 = sequence3(dictApplicative);
                    return function($327) {
                        return $325($326($327));
                    };
                }());
            },
            Functor0: function() {
                return functorCoproduct1;
            },
            Foldable1: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$1cee23aad9b21cdc = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($92016ca92c497156$export$b25abba66f7be210)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($92016ca92c497156$export$b25abba66f7be210)(sequence2(v));
        };
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $11d1e86de605dfc6$export$f5923975fb28337f = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(sequence2(v));
        };
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $11d1e86de605dfc6$export$261d8d87b1749d17 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictTraversable.Functor0());
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorProduct1 = functorProduct(dictTraversable1.Functor0());
        var foldableProduct1 = foldableProduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverse4(f)(v.value0))(traverse5(f)(v.value1));
                    };
                };
            },
            sequence: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var sequence4 = sequence2(dictApplicative);
                var sequence5 = sequence3(dictApplicative);
                return function(v) {
                    return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(sequence4(v.value0))(sequence5(v.value1));
                };
            },
            Functor0: function() {
                return functorProduct1;
            },
            Foldable1: function() {
                return foldableProduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$d50a9c31d69ee13c = function(dictTraversable) {
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable.Functor0());
    return function(dictApplicative) {
        var sequence3 = sequence2(dictApplicative);
        return function(f) {
            return function(ta) {
                return sequence3(map(f)(ta));
            };
        };
    };
};
var $11d1e86de605dfc6$export$d54b12b778292b35 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$64df51ac031d4ad2 = function(dictTraversable) {
    var mapAccumR1 = $11d1e86de605dfc6$export$d54b12b778292b35(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumR1(function(b) {
                    return function(a) {
                        var b$prime = f(a)(b);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$d5f444bb5e0f233 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$65f513eaf3c582b8 = function(dictTraversable) {
    var mapAccumL1 = $11d1e86de605dfc6$export$d5f444bb5e0f233(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b) {
                    return function(a) {
                        var b$prime = f(b)(a);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$f89de2e5bf57e5e6 = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
        return function(x) {
            return function(f) {
                return traverse2(f)(x);
            };
        };
    };
};


var $355d9520a1199e68$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $355d9520a1199e68$export$3b8cfe43eb195e1d = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
        return function(dictFoldable) {
            var traverse_1 = traverse_(dictFoldable);
            return function(f) {
                var $51 = traverse_1(function($53) {
                    return parallel(f($53));
                });
                return function($52) {
                    return sequential($51($52));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$bb703a54931a70b6 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        return function(dictTraversable) {
            var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
            return function(f) {
                var $54 = traverse(function($56) {
                    return parallel(f($56));
                });
                return function($55) {
                    return sequential($54($55));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$a907a2b4fd85b16b = function(dictParallel) {
    var parTraverse_1 = $355d9520a1199e68$export$3b8cfe43eb195e1d(dictParallel);
    return function(dictApplicative) {
        var parTraverse_2 = parTraverse_1(dictApplicative);
        return function(dictFoldable) {
            return parTraverse_2(dictFoldable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$b9becc45c388432c = function(dictParallel) {
    var parTraverse1 = $355d9520a1199e68$export$bb703a54931a70b6(dictParallel);
    return function(dictApplicative) {
        var parTraverse2 = parTraverse1(dictApplicative);
        return function(dictTraversable) {
            return parTraverse2(dictTraversable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$a82aaa9906cdb569 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                return function(f) {
                    var $57 = oneOfMap(function($59) {
                        return parallel(f($59));
                    });
                    return function($58) {
                        return sequential($57($58));
                    };
                };
            };
        };
    };
};
var $355d9520a1199e68$export$70e1ad49970879b5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                var $60 = oneOfMap(parallel);
                return function($61) {
                    return sequential($60($61));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$3d88e33b68f7b8a5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictParallel.Apply1());
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(mf) {
        return function(ma) {
            return sequential(apply(parallel(mf))(parallel(ma)));
        };
    };
};










// Generated by purs version 0.15.15






var $3c54b6e6d30cc3be$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $3c54b6e6d30cc3be$var$over = /* #__PURE__ */ $4fa4836228a192cc$export$fb4902fd9e525693()();
var $3c54b6e6d30cc3be$var$negate = /* #__PURE__ */ $d061555d3b2c84b2$export$aef51622e549b8b0($d061555d3b2c84b2$export$194f4464e73e7816);
var $3c54b6e6d30cc3be$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3c54b6e6d30cc3be$export$f2a120b78af04023 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$760297a502ec68f7 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$e4eccef8f937a949 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$8c68c012e85c37f4 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$d3134eff2123aadb = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$9eabacebe6624782 = function(dict) {
    return dict.toDuration;
};
var $3c54b6e6d30cc3be$export$358ac052a84a2abd = {
    show: function(v) {
        return "(Seconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$f5f4de8badcbd545 = {
    show: function(v) {
        return "(Minutes " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$1d3b9b5391a72ae7 = {
    show: function(v) {
        return "(Milliseconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$c5d3ca6fc3468bcf = {
    show: function(v) {
        return "(Hours " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$de46f7d16350d367 = {
    show: function(v) {
        return "(Days " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$bccfb43682e4a5e4 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$def67087bd72fdb7 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$5f6754e19ae8b602 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$e8bb798e27d1673b = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$34e2a018de95f3d = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$d6d247637e7494c9 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$e0a5c04af6395341 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$4ccf8d6c1ebfa128 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$3ab38ab5accb6ec2 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$321d65ffd9e957ce = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$f5994f75b457cdcc = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$961a021281e4c248 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5ca80b70b64299ae = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$a5ba0a6cacc34910 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5b5983dc8ed41daa = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$bccfb43682e4a5e4;
    }
};
var $3c54b6e6d30cc3be$export$1857fd2af0af50be = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272;
    }
};
var $3c54b6e6d30cc3be$export$70200b12758a7a61 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$def67087bd72fdb7;
    }
};
var $3c54b6e6d30cc3be$export$22829380fb9f2b93 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$5f6754e19ae8b602;
    }
};
var $3c54b6e6d30cc3be$export$9bd04d01a6c9ebc2 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$e8bb798e27d1673b;
    }
};
var $3c54b6e6d30cc3be$export$1a0a2c8fdf902748 = function(dict) {
    return dict.fromDuration;
};
var $3c54b6e6d30cc3be$export$28743521ea1cb8f9 = function(dictDuration) {
    var $57 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    var $58 = $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)($3c54b6e6d30cc3be$var$negate);
    var $59 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function($60) {
        return $57($58($59($60)));
    };
};
var $3c54b6e6d30cc3be$export$980dbec50a957fc7 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$4771a2ee9f50caac = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$699cb56941ecf990 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$fd6d5f49667130a4 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$c66ee96f983a5e21 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$1791f02d01a6ae8 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$f2a120b78af04023)(function(v) {
        return v * 1000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 1000.0;
    })
};
var $3c54b6e6d30cc3be$export$563c2be46809b74f = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$760297a502ec68f7)(function(v) {
        return v * 60000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 60000.0;
    })
};
var $3c54b6e6d30cc3be$export$44304cbc75c995e8 = {
    fromDuration: $3c54b6e6d30cc3be$var$identity,
    toDuration: $3c54b6e6d30cc3be$var$identity
};
var $3c54b6e6d30cc3be$export$117f08340b9f6c14 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$8c68c012e85c37f4)(function(v) {
        return v * 3600000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 3600000.0;
    })
};
var $3c54b6e6d30cc3be$export$93ad8ffd4576e464 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$d3134eff2123aadb)(function(v) {
        return v * 8.64e7;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 8.64e7;
    })
};
var $3c54b6e6d30cc3be$export$3082151037402ab5 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(dictDuration1) {
        var $61 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration1);
        return function($62) {
            return $61(fromDuration1($62));
        };
    };
};






// Generated by purs version 0.15.15
const $c02f07bc0f38e9e9$export$c62839628b30a695 = function(f) {
    return f();
};




// Generated by purs version 0.15.15
// module Partial.Unsafe
const $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81 = function(f) {
    return f();
};


// Generated by purs version 0.15.15
// module Partial
const $d8f9d43a2c2b18d5$export$b479f9f69f916b6a = function(msg) {
    throw new Error(msg);
};


var $dcd3eefef707675c$export$ddf616d7646fcc8e = function() {
    return $d8f9d43a2c2b18d5$export$b479f9f69f916b6a;
};
var $dcd3eefef707675c$var$crashWith1 = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $dcd3eefef707675c$export$dcc9d38dbc7992eb = function() {
    return $dcd3eefef707675c$var$crashWith1("Partial.crash: partial function");
};


var $8bcde8f642a64c7d$var$crashWith = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $8bcde8f642a64c7d$export$cb50937af21de128 = $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81;
var $8bcde8f642a64c7d$export$51b220bae4359b72 = function(msg) {
    return $8bcde8f642a64c7d$export$cb50937af21de128(function() {
        return $8bcde8f642a64c7d$var$crashWith(msg);
    });
};



var $edf0339512807bee$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $edf0339512807bee$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $edf0339512807bee$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $edf0339512807bee$var$Fiber = function(x) {
    return x;
};
var $edf0339512807bee$var$FFIUtil = function(x) {
    return x;
};
var $edf0339512807bee$export$22f79b48f44c15eb = function(x) {
    return x;
};
var $edf0339512807bee$export$4de6f17bc3dfa03 = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(false);
var $edf0339512807bee$export$608d3e3a27b14320 = {
    Coercible0: function() {
        return undefined;
    }
};
var $edf0339512807bee$export$d7f9012ed771d686 = {
    map: $b28443a27438717a$export$68695d37eb163711
};
var $edf0339512807bee$export$e8a7d9b8d7dc616a = {
    map: $b28443a27438717a$export$a0135aecf4a782ab
};
var $edf0339512807bee$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $edf0339512807bee$export$469c8a16c186651e = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(true);
var $edf0339512807bee$var$ffiUtil = /* #__PURE__ */ function() {
    var unsafeFromRight = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v.constructor.name
        ]);
    };
    var isLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return true;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        right: $7d4cccdf062a2261$export$19db0165690c701a.create
    };
}();
var $edf0339512807bee$var$makeFiber = function(aff) {
    return $b28443a27438717a$export$f24188c8fd3f1234($edf0339512807bee$var$ffiUtil, aff);
};
var $edf0339512807bee$export$30b347ca11a80af4 = function(aff) {
    return function __do() {
        var fiber = $edf0339512807bee$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $edf0339512807bee$export$c8704a1045ed544d = function($75) {
    return $edf0339512807bee$var$$$void($edf0339512807bee$export$30b347ca11a80af4($75));
};
var $edf0339512807bee$export$d133944c527f2403 = $edf0339512807bee$var$makeFiber;
var $edf0339512807bee$export$1391212d75b2ee65 = function(v) {
    return $b28443a27438717a$export$389c1406f5ae6ae7($7d4cccdf062a2261$export$19db0165690c701a.create, v);
};
var $edf0339512807bee$export$df5598cc12b9c8c = function(acquire) {
    return function(completed) {
        return $b28443a27438717a$export$9ad792f02752f447(acquire)({
            killed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed)
        });
    };
};
var $edf0339512807bee$export$83901714774e2edc = {
    apply: $b28443a27438717a$export$bce00526579b3344,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$83901714774e2edc);
var $edf0339512807bee$export$fc7e409bd1eae683 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$b147a380fa8fdc0e = {
    Applicative0: function() {
        return $edf0339512807bee$export$9dc0454a98607988;
    },
    Bind1: function() {
        return $edf0339512807bee$export$f885f489dcf38a2d;
    }
};
var $edf0339512807bee$export$f885f489dcf38a2d = {
    bind: $b28443a27438717a$export$8fe95d71d8c6b6f3,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$export$9dc0454a98607988 = {
    pure: $b28443a27438717a$export$68c6660df485915b,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$var$$lazy_applyAff = /* #__PURE__ */ $edf0339512807bee$var$$runtime_lazy("applyAff", "Effect.Aff", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($edf0339512807bee$export$b147a380fa8fdc0e),
        Functor0: function() {
            return $edf0339512807bee$export$e8a7d9b8d7dc616a;
        }
    };
});
var $edf0339512807bee$export$114a07f1fb466c63 = /* #__PURE__ */ $edf0339512807bee$var$$lazy_applyAff(73);
var $edf0339512807bee$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $edf0339512807bee$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$var$lift21 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$export$d0776e69f204de29 = function(aff) {
    return function(v) {
        return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))({
            killed: function(e) {
                return function(v1) {
                    return v(e);
                };
            },
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2)
        })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(aff));
    };
};
var $edf0339512807bee$export$7f8bd3bb7f01e042 = function(fin) {
    return function(a) {
        return $edf0339512807bee$export$df5598cc12b9c8c($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(fin))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a));
    };
};
var $edf0339512807bee$export$859f4dae848ac0ae = function(a) {
    return $edf0339512807bee$export$df5598cc12b9c8c(a)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342)))($edf0339512807bee$var$pure2);
};
var $edf0339512807bee$export$6c7682db87129472 = {
    defer: function(f) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))(f);
    }
};
var $edf0339512807bee$export$cb4623454f96d5e0 = {
    parallel: $ac8b3532514ac019$export$401372c57776dc,
    sequential: $b28443a27438717a$export$139486a45824a247,
    Apply0: function() {
        return $edf0339512807bee$export$114a07f1fb466c63;
    },
    Apply1: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$parallel = /* #__PURE__ */ $86141680556a7436$export$451942af9381149c($edf0339512807bee$export$cb4623454f96d5e0);
var $edf0339512807bee$export$389e6cb252ce112f = {
    pure: function($76) {
        return $edf0339512807bee$var$parallel($edf0339512807bee$var$pure2($76));
    },
    Apply0: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$pure3 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$389e6cb252ce112f);
var $edf0339512807bee$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $edf0339512807bee$export$aa5306b4d3514fa0 = function(dictMonoid) {
    var semigroupParAff1 = $edf0339512807bee$export$fc7e409bd1eae683(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure3($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupParAff1;
        }
    };
};
var $edf0339512807bee$export$1cab8188db0c4c1f = {
    append: function(v) {
        return function(v1) {
            return function(err) {
                return $edf0339512807bee$var$parSequence_([
                    v(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $edf0339512807bee$export$1dbf838572c25e01 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift21($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$666a030cecdf96c = {
    liftEffect: $b28443a27438717a$export$3c6532f01a0290eb,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $edf0339512807bee$export$952106a975f35ae2 = function($77) {
    return $edf0339512807bee$export$22f79b48f44c15eb($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$liftEffect($77)));
};
var $edf0339512807bee$export$f3d782c2b95165ad = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(k) {
        return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.join(k));
    });
};
var $edf0339512807bee$export$29466a041ff3b3e0 = {
    map: function(f) {
        return function(t) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$map1(f)($edf0339512807bee$export$f3d782c2b95165ad(t))));
        };
    }
};
var $edf0339512807bee$export$4d705d914d07c7a7 = {
    apply: function(t1) {
        return function(t2) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$apply($edf0339512807bee$export$f3d782c2b95165ad(t1))($edf0339512807bee$export$f3d782c2b95165ad(t2))));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $edf0339512807bee$export$6db27cd2d1558d76 = {
    pure: function(a) {
        return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$pure2(a)));
    },
    Apply0: function() {
        return $edf0339512807bee$export$4d705d914d07c7a7;
    }
};
var $edf0339512807bee$export$c65b2010df1810d = function(e) {
    return function(v) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$liftEffect(v.isSuspended))(function(suspended) {
            if (suspended) return $edf0339512807bee$var$liftEffect($edf0339512807bee$var$$$void(v.kill(e, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure($05149ea687d6b460$export$523c0b569236b342)))));
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.kill(e, k));
            });
        });
    };
};
var $edf0339512807bee$export$12fb9217a4d25158 = /* #__PURE__ */ function() {
    var $78 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($edf0339512807bee$export$c65b2010df1810d);
    return function($79) {
        return $edf0339512807bee$export$22f79b48f44c15eb($78($79));
    };
}();
var $edf0339512807bee$export$54b8dc42dcff4ab1 = function(aff) {
    var killError = $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("[Aff] Child fiber outlived parent");
    var killAll = function(err) {
        return function(sup) {
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $b28443a27438717a$export$a494cc11bfc0c750(err, sup.supervisor, k($edf0339512807bee$var$pure1($05149ea687d6b460$export$523c0b569236b342)));
            });
        };
    };
    var acquire = function __do() {
        var sup = $b28443a27438717a$export$7a3baea9562462c7($edf0339512807bee$var$ffiUtil, aff)();
        sup.fiber.run();
        return sup;
    };
    return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$liftEffect(acquire))({
        killed: function(err) {
            return function(sup) {
                return $edf0339512807bee$var$parSequence_([
                    $edf0339512807bee$export$c65b2010df1810d(err)(sup.fiber),
                    killAll(err)(sup)
                ]);
            };
        },
        failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError)),
        completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError))
    })(function($80) {
        return $edf0339512807bee$export$f3d782c2b95165ad(function(v) {
            return v.fiber;
        }($80));
    });
};
var $edf0339512807bee$export$d9b2f32f45e29810 = {
    liftST: /* #__PURE__ */ function() {
        var $81 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f($dd1bd2cc217b6a6d$export$d1b56b21630310a5);
        return function($82) {
            return $edf0339512807bee$var$liftEffect($81($82));
        };
    }(),
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$37a9b80154c7d256 = {
    throwError: $b28443a27438717a$export$520252a01094c36e,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$9efce1646e93cba4 = {
    catchError: $b28443a27438717a$export$eb5e86cd5464556e,
    MonadThrow0: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $edf0339512807bee$var$$$try = /* #__PURE__ */ $5dfefa023749ded0$export$410a452afcd48948($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$var$catchError = /* #__PURE__ */ $5dfefa023749ded0$export$3dede90624df3ba9($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$export$77f9e426014f6edd = $edf0339512807bee$var$$$try;
var $edf0339512807bee$export$60f50bfed4143f9d = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$30b347ca11a80af4($edf0339512807bee$var$bindFlipped(function($83) {
            return $edf0339512807bee$var$liftEffect(k($83));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$ef62257e6f8a5f8c = function(k) {
    return function(aff) {
        return $edf0339512807bee$var$$$void($edf0339512807bee$export$60f50bfed4143f9d(k)(aff));
    };
};
var $edf0339512807bee$export$52011fb9f1f7b7e2 = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$d133944c527f2403($edf0339512807bee$var$bindFlipped(function($84) {
            return $edf0339512807bee$var$liftEffect(k($84));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$974f8db4a62dd716 = {
    tailRecM: function(k) {
        var go = function(a) {
            return $edf0339512807bee$var$bind1(k(a))(function(res) {
                if (res instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $edf0339512807bee$var$pure2(res.value0);
                if (res instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return go(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go;
    },
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$b59d1737970253ab = function(dictMonoid) {
    var semigroupAff1 = $edf0339512807bee$export$1dbf838572c25e01(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure2($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupAff1;
        }
    };
};
var $edf0339512807bee$export$8deb6e154ce67af6 = /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342));
var $edf0339512807bee$export$800a937b75981c0e = {
    mempty: $edf0339512807bee$export$8deb6e154ce67af6,
    Semigroup0: function() {
        return $edf0339512807bee$export$1cab8188db0c4c1f;
    }
};
var $edf0339512807bee$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($edf0339512807bee$export$800a937b75981c0e);
var $edf0339512807bee$export$b3e22bcfd64c1022 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(v) {
    return $edf0339512807bee$var$pure($edf0339512807bee$var$mempty);
});
var $edf0339512807bee$export$a19cb95a0294477 = /* #__PURE__ */ function() {
    var $85 = $edf0339512807bee$var$map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
    return function($86) {
        return $85($edf0339512807bee$export$77f9e426014f6edd($86));
    };
}();
var $edf0339512807bee$export$371c34bc9954b4c6 = {
    alt: $b28443a27438717a$export$6a44b66c7edadaa,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$export$75f84a0612e9fcac = {
    alt: function(a1) {
        return function(a2) {
            return $edf0339512807bee$var$catchError(a1)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a2));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$e8a7d9b8d7dc616a;
    }
};
var $edf0339512807bee$export$982abcb51ccf01ce = {
    empty: /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256)(/* #__PURE__ */ $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Always fails")),
    Alt0: function() {
        return $edf0339512807bee$export$75f84a0612e9fcac;
    }
};
var $edf0339512807bee$export$a77596dfa1aa0c51 = {
    empty: /* #__PURE__ */ $edf0339512807bee$var$parallel(/* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($edf0339512807bee$export$982abcb51ccf01ce)),
    Alt0: function() {
        return $edf0339512807bee$export$371c34bc9954b4c6;
    }
};
var $edf0339512807bee$export$96ad65bdc35fd68a = {
    Applicative0: function() {
        return $edf0339512807bee$export$389e6cb252ce112f;
    },
    Plus1: function() {
        return $edf0339512807bee$export$a77596dfa1aa0c51;
    }
};




// Generated by purs version 0.15.15












// Generated by purs version 0.15.15
var $17a55b211df71f15$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
const $17a55b211df71f15$export$bacb5cc5a11aef16 = $17a55b211df71f15$var$getEffProp("children");
const $17a55b211df71f15$export$52f4bb9f897f1dda = $17a55b211df71f15$var$getEffProp("firstElementChild");
const $17a55b211df71f15$export$b58800d9b8f19191 = $17a55b211df71f15$var$getEffProp("lastElementChild");
const $17a55b211df71f15$export$f89766fb54dff747 = $17a55b211df71f15$var$getEffProp("childElementCount");
function $17a55b211df71f15$export$242934abc2863db9(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
function $17a55b211df71f15$export$2e83b5c43fb7af7b(selector) {
    return function(node) {
        return function() {
            return node.querySelectorAll(selector);
        };
    };
}




// Generated by purs version 0.15.15
/* eslint-disable no-eq-null, eqeqeq */ const $305519516124a7ff$export$7b1b591b262c240 = null;
function $305519516124a7ff$export$133fc36489ac9add(a, r, f) {
    return a == null ? r : f(a);
}
function $305519516124a7ff$export$9b7835891cf7097a(x) {
    return x;
}







var $0a5aaf95f168428e$export$b187f57ee1822bc5 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($305519516124a7ff$export$7b1b591b262c240)($305519516124a7ff$export$9b7835891cf7097a);
var $0a5aaf95f168428e$export$1ba013b88f4f21f3 = function(n) {
    return $305519516124a7ff$export$133fc36489ac9add(n, $06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create);
};
var $0a5aaf95f168428e$export$643760463fdd14c1 = function(dictShow) {
    return {
        show: function() {
            var $17 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("null")($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow));
            return function($18) {
                return $17($0a5aaf95f168428e$export$1ba013b88f4f21f3($18));
            };
        }()
    };
};
var $0a5aaf95f168428e$export$1d97b52fc2e07cdc = function(dictEq) {
    return {
        eq: $f57f4b701aa7b66e$export$af631764ddc44097($37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq)))($0a5aaf95f168428e$export$1ba013b88f4f21f3)
    };
};
var $0a5aaf95f168428e$export$4fb7d8da662af215 = function(dictOrd) {
    var eqNullable1 = $0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictOrd.Eq0());
    return {
        compare: $f57f4b701aa7b66e$export$af631764ddc44097($97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd)))($0a5aaf95f168428e$export$1ba013b88f4f21f3),
        Eq0: function() {
            return eqNullable1;
        }
    };
};
var $0a5aaf95f168428e$export$1b7ecac9aff49fbc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictEq));
    }
};
var $0a5aaf95f168428e$export$46a371b99e80ea42 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($0a5aaf95f168428e$export$4fb7d8da662af215(dictOrd));
    },
    Eq10: function() {
        return $0a5aaf95f168428e$export$1b7ecac9aff49fbc;
    }
};




var $77e12228cc269e35$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $77e12228cc269e35$export$fe9de06a57e74a75 = function(x) {
    return x;
};
var $77e12228cc269e35$export$78fb49a702cc1f2 = function(qs) {
    var $2 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $3 = $17a55b211df71f15$export$242934abc2863db9(qs);
    return function($4) {
        return $2($3($4));
    };
};
var $77e12228cc269e35$export$52785ae9e93eaaf8 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $77e12228cc269e35$export$ed55255aef9f10db = {
    Coercible0: function() {
        return undefined;
    }
};
var $77e12228cc269e35$export$80cfcf47c97f2a3 = /* #__PURE__ */ function() {
    var $5 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($17a55b211df71f15$export$b58800d9b8f19191($6));
    };
}();
var $77e12228cc269e35$export$ef511da7c0e45881 = /* #__PURE__ */ function() {
    var $7 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($8) {
        return $7($17a55b211df71f15$export$52f4bb9f897f1dda($8));
    };
}();
var $77e12228cc269e35$export$d5769763ca9e4d49 = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15
function $98db70b23aa8a6ea$export$f5cdf3809b4587f3(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $98db70b23aa8a6ea$export$d5d038f71f8391de(type) {
    return function(listener) {
        return function(options) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, options);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$3f65cefe8380dbea(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$8ff9f68337b520c0(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$716a11175c03fb4e(event) {
    return function(target) {
        return function() {
            return target.dispatchEvent(event);
        };
    };
}


// Generated by purs version 0.15.15




// Generated by purs version 0.15.15
const $2603425f82e959df$export$8291e5b88f90ce4 = function() {
    return window;
};


// Generated by purs version 0.15.15


var $d8c91a2be15f75cb$export$212382f8c1a1154e = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$880a60b2adf28011 = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$ede06c734afe650b = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$95abab3275973ab6 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$c58d7d69adf07268 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$6d81548222f15a9a = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$e2c5e238f46c1980 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$a0bcd3a016e5808d = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$7e4243c3c9480b2b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$24a4aa0a132c9555 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$b50b66d86c8b8bf = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$10c76280137f9306 = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15
function $50ae04148e431f75$export$44271b4f0c6a3563(a) {
    return function() {
        return a.target;
    };
}
function $50ae04148e431f75$export$1f61c53461aff4a5(target) {
    return function(a) {
        return function() {
            a.target = target;
        };
    };
}
function $50ae04148e431f75$export$24422be91ad4011f(a) {
    return function() {
        return a.download;
    };
}
function $50ae04148e431f75$export$4c9843daef742201(download) {
    return function(a) {
        return function() {
            a.download = download;
        };
    };
}
function $50ae04148e431f75$export$bad408f43b005bc8(a) {
    return function() {
        return a.rel;
    };
}
function $50ae04148e431f75$export$9e86d1af7d63c52c(rel) {
    return function(a) {
        return function() {
            a.rel = rel;
        };
    };
}
function $50ae04148e431f75$export$edb1c8e715f3944e(a) {
    return function() {
        return a.rev;
    };
}
function $50ae04148e431f75$export$671b41179a9f15fb(rev) {
    return function(a) {
        return function() {
            a.rev = rev;
        };
    };
}
function $50ae04148e431f75$export$5884a0b424dd5ef2(a) {
    return function() {
        return a.relList;
    };
}
function $50ae04148e431f75$export$4bf4138386d6b8cc(a) {
    return function() {
        return a.hreflang;
    };
}
function $50ae04148e431f75$export$17b5334c80252e15(hreflang) {
    return function(a) {
        return function() {
            a.hreflang = hreflang;
        };
    };
}
function $50ae04148e431f75$export$d4a6a4db5b31e621(a) {
    return function() {
        return a.type;
    };
}
function $50ae04148e431f75$export$1bf7f05044e9c5cb(type) {
    return function(a) {
        return function() {
            a.type = type;
        };
    };
}
function $50ae04148e431f75$export$6f093cfa640b7166(a) {
    return function() {
        return a.text;
    };
}
function $50ae04148e431f75$export$cbe0d99836e1498f(text) {
    return function(a) {
        return function() {
            a.text = text;
        };
    };
}



// Generated by purs version 0.15.15
function $6d8c9719a60f7848$export$5235d6e581ca586e(nothing, just, name, value) {
    if (typeof window !== "undefined") {
        var ty = window[name];
        if (ty != null && value instanceof ty) return just(value);
    }
    var obj = value;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name) return just(value);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}



var $4d89ff275c04492e$export$e3dc45f84eae905c = function(name) {
    return function(value) {
        return $6d8c9719a60f7848$export$5235d6e581ca586e($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, name, value);
    };
};


var $b2b4e127c7797d01$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$9da26c0441db8b03 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");


// Generated by purs version 0.15.15
function $63866c0466b6a770$export$228be17d80722ab(area) {
    return function() {
        return area.alt;
    };
}
function $63866c0466b6a770$export$14a0e7c2e6152665(alt) {
    return function(area) {
        return function() {
            area.alt = alt;
        };
    };
}
function $63866c0466b6a770$export$5bf93b4680474bd(area) {
    return function() {
        return area.coords;
    };
}
function $63866c0466b6a770$export$d03eafa2070fb6d7(coords) {
    return function(area) {
        return function() {
            area.coords = coords;
        };
    };
}
function $63866c0466b6a770$export$98bada23690e67eb(area) {
    return function() {
        return area.shape;
    };
}
function $63866c0466b6a770$export$89565ec41213f41c(shape) {
    return function(area) {
        return function() {
            area.shape = shape;
        };
    };
}
function $63866c0466b6a770$export$44271b4f0c6a3563(area) {
    return function() {
        return area.target;
    };
}
function $63866c0466b6a770$export$1f61c53461aff4a5(target) {
    return function(area) {
        return function() {
            area.target = target;
        };
    };
}
function $63866c0466b6a770$export$24422be91ad4011f(area) {
    return function() {
        return area.download;
    };
}
function $63866c0466b6a770$export$4c9843daef742201(download) {
    return function(area) {
        return function() {
            area.download = download;
        };
    };
}
function $63866c0466b6a770$export$bad408f43b005bc8(area) {
    return function() {
        return area.rel;
    };
}
function $63866c0466b6a770$export$9e86d1af7d63c52c(rel) {
    return function(area) {
        return function() {
            area.rel = rel;
        };
    };
}
function $63866c0466b6a770$export$5884a0b424dd5ef2(area) {
    return function() {
        return area.relList;
    };
}
function $63866c0466b6a770$export$4bf4138386d6b8cc(area) {
    return function() {
        return area.hreflang;
    };
}
function $63866c0466b6a770$export$17b5334c80252e15(hreflang) {
    return function(area) {
        return function() {
            area.hreflang = hreflang;
        };
    };
}
function $63866c0466b6a770$export$d4a6a4db5b31e621(area) {
    return function() {
        return area.type;
    };
}
function $63866c0466b6a770$export$1bf7f05044e9c5cb(type) {
    return function(area) {
        return function() {
            area.type = type;
        };
    };
}




var $c47d991e98d75165$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");


// Generated by purs version 0.15.15
function $bcd5a412110bec59$export$185802fd694ee1f5() {
    return new Audio();
}
function $bcd5a412110bec59$export$2faa2f53d87c7f7e(url) {
    return function() {
        return new Audio(url);
    };
}




var $9c48a3b1514e7e20$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$20f9c2173df486a8 = $bcd5a412110bec59$export$2faa2f53d87c7f7e;


// Generated by purs version 0.15.15


var $28cc3aca3b37f8c1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");


// Generated by purs version 0.15.15
function $9c737e057094c556$export$8f51af5840e0602a(base) {
    return function() {
        return base.href;
    };
}
function $9c737e057094c556$export$428f6e77b5a5a669(href) {
    return function(base) {
        return function() {
            base.href = href;
        };
    };
}
function $9c737e057094c556$export$44271b4f0c6a3563(base) {
    return function() {
        return base.target;
    };
}
function $9c737e057094c556$export$1f61c53461aff4a5(target) {
    return function(base) {
        return function() {
            base.target = target;
        };
    };
}




var $1f63464ba4e88016$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");


// Generated by purs version 0.15.15


var $9e295ac610849d32$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");


// Generated by purs version 0.15.15
function $20a948bbaa0c268a$export$4c47992fc278c9a0(button) {
    return function() {
        return button.autofocus;
    };
}
function $20a948bbaa0c268a$export$db2bbdcbda3d335e(autofocus) {
    return function(button) {
        return function() {
            button.autofocus = autofocus;
        };
    };
}
function $20a948bbaa0c268a$export$683472f6198a076e(button) {
    return function() {
        return button.disabled;
    };
}
function $20a948bbaa0c268a$export$4532d31cef66d703(disabled) {
    return function(button) {
        return function() {
            button.disabled = disabled;
        };
    };
}
function $20a948bbaa0c268a$export$242c63e9758836c2(button) {
    return function() {
        return button.form;
    };
}
function $20a948bbaa0c268a$export$7e4d70bab1b5c4a0(button) {
    return function() {
        return button.formAction;
    };
}
function $20a948bbaa0c268a$export$577bb1d64e4c83b9(formAction) {
    return function(button) {
        return function() {
            button.formAction = formAction;
        };
    };
}
function $20a948bbaa0c268a$export$21f1c8008acfa9c0(button) {
    return function() {
        return button.formEnctype;
    };
}
function $20a948bbaa0c268a$export$346989dcff4ba18b(formEnctype) {
    return function(button) {
        return function() {
            button.formEnctype = formEnctype;
        };
    };
}
function $20a948bbaa0c268a$export$3f1ffee261a00124(button) {
    return function() {
        return button.formMethod;
    };
}
function $20a948bbaa0c268a$export$c38a1a871bb0e145(formMethod) {
    return function(button) {
        return function() {
            button.formMethod = formMethod;
        };
    };
}
function $20a948bbaa0c268a$export$87c857905fcc4a84(button) {
    return function() {
        return button.formNoValidate;
    };
}
function $20a948bbaa0c268a$export$ad9ff32d0af51586(formNoValidate) {
    return function(button) {
        return function() {
            button.formNoValidate = formNoValidate;
        };
    };
}
function $20a948bbaa0c268a$export$497949a0ae76184f(button) {
    return function() {
        return button.formTarget;
    };
}
function $20a948bbaa0c268a$export$4c7e983548149eb5(formTarget) {
    return function(button) {
        return function() {
            button.formTarget = formTarget;
        };
    };
}
function $20a948bbaa0c268a$export$a8ff84c12d48cfa6(button) {
    return function() {
        return button.name;
    };
}
function $20a948bbaa0c268a$export$6cf3d710d3a367e5(name) {
    return function(button) {
        return function() {
            button.name = name;
        };
    };
}
function $20a948bbaa0c268a$export$d4a6a4db5b31e621(button) {
    return function() {
        return button.type;
    };
}
function $20a948bbaa0c268a$export$1bf7f05044e9c5cb(type) {
    return function(button) {
        return function() {
            button.type = type;
        };
    };
}
function $20a948bbaa0c268a$export$2ab9a8f9f1186f14(button) {
    return function() {
        return button.value;
    };
}
function $20a948bbaa0c268a$export$80746c6bc6142fc8(value) {
    return function(button) {
        return function() {
            button.value = value;
        };
    };
}
function $20a948bbaa0c268a$export$5e55a9e709e8e020(button) {
    return function() {
        return button.willValidate;
    };
}
function $20a948bbaa0c268a$export$1bdd3f9a89b22594(button) {
    return function() {
        return button.validity;
    };
}
function $20a948bbaa0c268a$export$6ee4201e37a931e2(button) {
    return function() {
        return button.validationMessage;
    };
}
function $20a948bbaa0c268a$export$50d70f8cedc54453(button) {
    return function() {
        return button.checkValidity();
    };
}
function $20a948bbaa0c268a$export$b962d864c477cc49(button) {
    return function() {
        return button.reportValidity();
    };
}
function $20a948bbaa0c268a$export$6f569cb704992105(value) {
    return function(button) {
        return function() {
            button.setCustomValidity(value);
        };
    };
}
function $20a948bbaa0c268a$export$a238cb463698c900(button) {
    return function() {
        return button.labels;
    };
}







var $c6219700cb28efb6$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($20a948bbaa0c268a$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $7d547317abc5459f$export$7e3df82ee760448c(canvas) {
    return function() {
        return canvas.width;
    };
}
function $7d547317abc5459f$export$67f48e0594af05d(width) {
    return function(canvas) {
        return function() {
            canvas.width = width;
        };
    };
}
function $7d547317abc5459f$export$ac607276a8fe9f0a(canvas) {
    return function() {
        return canvas.height;
    };
}
function $7d547317abc5459f$export$3f31360357be44e4(height) {
    return function(canvas) {
        return function() {
            canvas.height = height;
        };
    };
}




var $f8ac89c5dd24c0f2$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");


// Generated by purs version 0.15.15


var $6018dac1d12eb9e0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");


// Generated by purs version 0.15.15
function $29e81da2666ff0a3$export$2ab9a8f9f1186f14(data) {
    return function() {
        return data.value;
    };
}
function $29e81da2666ff0a3$export$80746c6bc6142fc8(value) {
    return function(data) {
        return function() {
            data.value = value;
        };
    };
}




var $450df947978ac297$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");


// Generated by purs version 0.15.15
function $8cebdc995025043e$export$41c562ebe57d11e2(dle) {
    return function() {
        return dle.options;
    };
}




var $e6ed11a356105002$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");


// Generated by purs version 0.15.15


var $61286eb7c73211a7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");


// Generated by purs version 0.15.15
function $0e1ad3264aa8b3c4$export$445a11d197c0312(doc) {
    return doc.documentElement;
}
function $0e1ad3264aa8b3c4$export$327008c45899d79e(doc) {
    return doc.head;
}
function $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc) {
    return doc.body;
}
function $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc) {
    return doc.activeElement;
}
function $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc) {
    return doc.currentScript;
}
function $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc) {
    return doc.referrer;
}
function $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc) {
    return doc.title;
}
function $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(title, doc) {
    doc.title = title;
}







// Generated by purs version 0.15.15


var $99cfc603fe5cc0f7$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 = /* #__PURE__ */ function() {
    function Interactive() {}
    Interactive.value = new Interactive();
    return Interactive;
}();
var $99cfc603fe5cc0f7$export$37474717eef9e2a4 = /* #__PURE__ */ function() {
    function Complete() {}
    Complete.value = new Complete();
    return Complete;
}();
var $99cfc603fe5cc0f7$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "Interactive";
        if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "Complete";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $99cfc603fe5cc0f7$export$c2d084dc44961371 = function(v) {
    if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "loading";
    if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "interactive";
    if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "complete";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 22, column 9 - line 25, column 25): " + [
        v.constructor.name
    ]);
};
var $99cfc603fe5cc0f7$export$98e6a39c04603d36 = function(v) {
    if (v === "loading") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
    if (v === "interactive") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$43d8ad7b9c99dd97.value);
    if (v === "complete") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$37474717eef9e2a4.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $99cfc603fe5cc0f7$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return true;
            return false;
        };
    }
};
var $99cfc603fe5cc0f7$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $99cfc603fe5cc0f7$export$c71e02dcc13f94a6;
    }
};


// Generated by purs version 0.15.15


var $ecd74bf9585b1551$export$3824c08153b44726 = /* #__PURE__ */ function() {
    function Visible() {}
    Visible.value = new Visible();
    return Visible;
}();
var $ecd74bf9585b1551$export$8dc98ba7eadeaa56 = /* #__PURE__ */ function() {
    function Hidden() {}
    Hidden.value = new Hidden();
    return Hidden;
}();
var $ecd74bf9585b1551$export$d2d17f8156d66f42 = {
    show: function(v) {
        if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "Visible";
        if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "Hidden";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $ecd74bf9585b1551$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "visible";
    if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "hidden";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 20, column 9 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $ecd74bf9585b1551$export$98e6a39c04603d36 = function(v) {
    if (v === "visible") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$3824c08153b44726.value);
    if (v === "hidden") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$8dc98ba7eadeaa56.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ecd74bf9585b1551$export$e4139843c5cdd239 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return true;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return true;
            return false;
        };
    }
};
var $ecd74bf9585b1551$export$712b05ab3ead9d93 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ecd74bf9585b1551$export$e4139843c5cdd239;
    }
};



var $f6c9290a5db8f197$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f6c9290a5db8f197$export$3d0d3483832deb8e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $2 = $06733ae99ed4f534$export$43db023a260c5e9f($ecd74bf9585b1551$export$3824c08153b44726.value);
        return function($3) {
            return $2($ecd74bf9585b1551$export$98e6a39c04603d36($3));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc);
    });
};
var $f6c9290a5db8f197$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$d8d5f203c133934 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$ce0e204f587740c3 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$fb184b623420d9be = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc);
    };
};
var $f6c9290a5db8f197$export$420a7f2fd9cad6f6 = function(newTitle) {
    return function(doc) {
        return function() {
            return $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(newTitle, doc);
        };
    };
};
var $f6c9290a5db8f197$export$a0c6a011d8b20057 = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc);
    };
};
var $f6c9290a5db8f197$export$1ae2b664eea77b7e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
        return function($5) {
            return $4($99cfc603fe5cc0f7$export$98e6a39c04603d36($5));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc);
    });
};
var $f6c9290a5db8f197$export$5fd5031fecdacec3 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$327008c45899d79e(doc);
    });
};
var $f6c9290a5db8f197$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$45b532d2a1c7642b = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$cb6b1c55e7404aef = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$170c446b87804fad = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$445a11d197c0312(doc);
    });
};
var $f6c9290a5db8f197$export$7aca2fdfd0625e3a = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc);
    });
};
var $f6c9290a5db8f197$export$32180ef41b15b513 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc);
    });
};
var $f6c9290a5db8f197$export$da980962bd2147a4 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc);
    });
};


// Generated by purs version 0.15.15
function $ccf49930316caf57$export$b2a016fb14adc1e4(nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value);
    else return nothing;
}
function $ccf49930316caf57$export$fb184b623420d9be(elt) {
    return function() {
        return elt.title;
    };
}
function $ccf49930316caf57$export$420a7f2fd9cad6f6(title) {
    return function(elt) {
        return function() {
            elt.title = title;
        };
    };
}
function $ccf49930316caf57$export$9a771d6906431624(elt) {
    return function() {
        return elt.lang;
    };
}
function $ccf49930316caf57$export$a3665b844fbc095d(lang) {
    return function(elt) {
        return function() {
            elt.lang = lang;
        };
    };
}
function $ccf49930316caf57$export$147ec2801e896265(elt) {
    return function() {
        return elt.dir;
    };
}
function $ccf49930316caf57$export$5d00cbe77a0f4da4(dir) {
    return function(elt) {
        return function() {
            elt.dir = dir;
        };
    };
}
function $ccf49930316caf57$export$73920f18ca706874(elt) {
    return function() {
        return elt.hidden;
    };
}
function $ccf49930316caf57$export$306a681a1fc87013(hidden) {
    return function(elt) {
        return function() {
            elt.hidden = hidden;
        };
    };
}
function $ccf49930316caf57$export$9a625f9de50bf0b7(elt) {
    return function() {
        return elt.tabIndex;
    };
}
function $ccf49930316caf57$export$de72581b19a869cc(tabIndex) {
    return function(elt) {
        return function() {
            elt.tabIndex = tabIndex;
        };
    };
}
function $ccf49930316caf57$export$c746a5152d4ba26c(elt) {
    return function() {
        return elt.draggable;
    };
}
function $ccf49930316caf57$export$b681bd05c45bbdd7(draggable) {
    return function(elt) {
        return function() {
            elt.draggable = draggable;
        };
    };
}
function $ccf49930316caf57$export$d9d317b4285c34e7(elt) {
    return function() {
        return elt.contentEditable;
    };
}
function $ccf49930316caf57$export$91a56ab73e46c5d4(contentEditable) {
    return function(elt) {
        return function() {
            elt.contentEditable = contentEditable;
        };
    };
}
function $ccf49930316caf57$export$3453cc819780f652(elt) {
    return function() {
        return elt.isContentEditable;
    };
}
function $ccf49930316caf57$export$afbe3196582d9f14(elt) {
    return function() {
        return elt.spellcheck;
    };
}
function $ccf49930316caf57$export$f5c89d87509db2c2(spellcheck) {
    return function(elt) {
        return function() {
            elt.spellcheck = spellcheck;
        };
    };
}
function $ccf49930316caf57$export$64ef1bee2b9504c1(elt) {
    return function() {
        return elt.click();
    };
}
function $ccf49930316caf57$export$d7ddd398f22d79ef(elt) {
    return function() {
        return elt.focus();
    };
}
function $ccf49930316caf57$export$2cc7ff91bcacba5e(elt) {
    return function() {
        return elt.blur();
    };
}
function $ccf49930316caf57$export$351f7ed5e1f4cbfb(el) {
    return function() {
        return el.offsetParent;
    };
}
function $ccf49930316caf57$export$9051df5ff5b6ece8(el) {
    return function() {
        return el.offsetTop;
    };
}
function $ccf49930316caf57$export$4ad6bc00a859a01c(el) {
    return function() {
        return el.offsetLeft;
    };
}
function $ccf49930316caf57$export$abda199d6e675d54(el) {
    return function() {
        return el.offsetWidth;
    };
}
function $ccf49930316caf57$export$720e3813341eb9b(el) {
    return function() {
        return el.offsetHeight;
    };
}







var $5ae75883a0b7923c$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$759f2a42fd33dfde = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($ccf49930316caf57$export$351f7ed5e1f4cbfb($3));
    };
}();
var $5ae75883a0b7923c$export$7039ba397093f069 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$66db07be43ecb0c3 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a7f097b65af8aa04 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a0a0bf09b44710c9 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$c56654a6d0e3bd48 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$31942037104a4a20 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};


// Generated by purs version 0.15.15
function $1de55632ffb04144$export$2e40c9e35e9506f4(embed) {
    return function() {
        return embed.src;
    };
}
function $1de55632ffb04144$export$5771e3a4c80da7df(src) {
    return function(embed) {
        return function() {
            embed.src = src;
        };
    };
}
function $1de55632ffb04144$export$d4a6a4db5b31e621(embed) {
    return function() {
        return embed.type;
    };
}
function $1de55632ffb04144$export$1bf7f05044e9c5cb(type) {
    return function(embed) {
        return function() {
            embed.type = type;
        };
    };
}
function $1de55632ffb04144$export$7e3df82ee760448c(embed) {
    return function() {
        return embed.width;
    };
}
function $1de55632ffb04144$export$67f48e0594af05d(width) {
    return function(embed) {
        return function() {
            embed.width = width;
        };
    };
}
function $1de55632ffb04144$export$ac607276a8fe9f0a(embed) {
    return function() {
        return embed.height;
    };
}
function $1de55632ffb04144$export$3f31360357be44e4(height) {
    return function(embed) {
        return function() {
            embed.height = height;
        };
    };
}




var $6948c2c57b43dc19$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");


// Generated by purs version 0.15.15
function $f5ce06e2d4c9fafa$export$683472f6198a076e(fieldset) {
    return function() {
        return fieldset.disabled;
    };
}
function $f5ce06e2d4c9fafa$export$4532d31cef66d703(disabled) {
    return function(fieldset) {
        return function() {
            fieldset.disabled = disabled;
        };
    };
}
function $f5ce06e2d4c9fafa$export$242c63e9758836c2(fieldset) {
    return function() {
        return fieldset.form;
    };
}
function $f5ce06e2d4c9fafa$export$a8ff84c12d48cfa6(fieldset) {
    return function() {
        return fieldset.name;
    };
}
function $f5ce06e2d4c9fafa$export$6cf3d710d3a367e5(name) {
    return function(fieldset) {
        return function() {
            fieldset.name = name;
        };
    };
}
function $f5ce06e2d4c9fafa$export$d4a6a4db5b31e621(fieldset) {
    return function() {
        return fieldset.type;
    };
}
function $f5ce06e2d4c9fafa$export$1bf7f05044e9c5cb(type) {
    return function(fieldset) {
        return function() {
            fieldset.type = type;
        };
    };
}
function $f5ce06e2d4c9fafa$export$5e55a9e709e8e020(fieldset) {
    return function() {
        return fieldset.willValidate;
    };
}
function $f5ce06e2d4c9fafa$export$1bdd3f9a89b22594(fieldset) {
    return function() {
        return fieldset.validity;
    };
}
function $f5ce06e2d4c9fafa$export$6ee4201e37a931e2(fieldset) {
    return function() {
        return fieldset.validationMessage;
    };
}
function $f5ce06e2d4c9fafa$export$50d70f8cedc54453(fieldset) {
    return function() {
        return fieldset.checkValidity();
    };
}
function $f5ce06e2d4c9fafa$export$b962d864c477cc49(fieldset) {
    return function() {
        return fieldset.reportValidity();
    };
}
function $f5ce06e2d4c9fafa$export$6f569cb704992105(value) {
    return function(fieldset) {
        return function() {
            fieldset.setCustomValidity(value);
        };
    };
}







var $b837b4d3f419e563$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($f5ce06e2d4c9fafa$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $ea01f93abd44760a$export$7e2eca70ed294fb(form) {
    return function() {
        return form.acceptCharset;
    };
}
function $ea01f93abd44760a$export$9ec8703ca0dc2663(acceptCharset) {
    return function(form) {
        return function() {
            form.acceptCharset = acceptCharset;
        };
    };
}
function $ea01f93abd44760a$export$31eb53bd5b582a97(form) {
    return function() {
        return form.action;
    };
}
function $ea01f93abd44760a$export$a0c65badd8d09883(action) {
    return function(form) {
        return function() {
            form.action = action;
        };
    };
}
function $ea01f93abd44760a$export$485ded5f26ebe08d(form) {
    return function() {
        return form.autocomplete;
    };
}
function $ea01f93abd44760a$export$5fb7c729919301a5(autocomplete) {
    return function(form) {
        return function() {
            form.autocomplete = autocomplete;
        };
    };
}
function $ea01f93abd44760a$export$9fc5d082ec250407(form) {
    return function() {
        return form.enctype;
    };
}
function $ea01f93abd44760a$export$71f7bac871e6ce1b(enctype) {
    return function(form) {
        return function() {
            form.enctype = enctype;
        };
    };
}
function $ea01f93abd44760a$export$d8738670c721d955(form) {
    return function() {
        return form.encoding;
    };
}
function $ea01f93abd44760a$export$11699ce243a224fd(encoding) {
    return function(form) {
        return function() {
            form.encoding = encoding;
        };
    };
}
function $ea01f93abd44760a$export$26f73335cc2e7868(form) {
    return function() {
        return form.method;
    };
}
function $ea01f93abd44760a$export$8c6ecab5174b959(method) {
    return function(form) {
        return function() {
            form.method = method;
        };
    };
}
function $ea01f93abd44760a$export$a8ff84c12d48cfa6(form) {
    return function() {
        return form.name;
    };
}
function $ea01f93abd44760a$export$6cf3d710d3a367e5(name) {
    return function(form) {
        return function() {
            form.name = name;
        };
    };
}
function $ea01f93abd44760a$export$f50297589147f25e(form) {
    return function() {
        return form.noValidate;
    };
}
function $ea01f93abd44760a$export$2271539dcccd0a8a(noValidate) {
    return function(form) {
        return function() {
            form.noValidate = noValidate;
        };
    };
}
function $ea01f93abd44760a$export$44271b4f0c6a3563(form) {
    return function() {
        return form.target;
    };
}
function $ea01f93abd44760a$export$1f61c53461aff4a5(target) {
    return function(form) {
        return function() {
            form.target = target;
        };
    };
}
function $ea01f93abd44760a$export$f24224f1c91d8156(form) {
    return function() {
        return form.length;
    };
}
function $ea01f93abd44760a$export$853c27de4ce0f746(form) {
    return function() {
        form.submit();
    };
}
function $ea01f93abd44760a$export$aad8462122ac592b(form) {
    return function() {
        form.reset();
    };
}
function $ea01f93abd44760a$export$50d70f8cedc54453(form) {
    return function() {
        return form.checkValidity();
    };
}
function $ea01f93abd44760a$export$b962d864c477cc49(form) {
    return function() {
        return form.reportValidity();
    };
}




var $9f3b722473e4bf22$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");


// Generated by purs version 0.15.15


var $3f8a2c745615078e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");


// Generated by purs version 0.15.15


var $f437286c23d51fb9$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");


// Generated by purs version 0.15.15


var $a4ab4f8ed836a554$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");


// Generated by purs version 0.15.15
function $966466ed4b666020$export$2e40c9e35e9506f4(iframe) {
    return function() {
        return iframe.src;
    };
}
function $966466ed4b666020$export$5771e3a4c80da7df(src) {
    return function(iframe) {
        return function() {
            iframe.src = src;
        };
    };
}
function $966466ed4b666020$export$7be70892c9d4d10e(iframe) {
    return function() {
        return iframe.srcdoc;
    };
}
function $966466ed4b666020$export$8a11fa357d4cbbc0(srcdoc) {
    return function(iframe) {
        return function() {
            iframe.srcdoc = srcdoc;
        };
    };
}
function $966466ed4b666020$export$a8ff84c12d48cfa6(iframe) {
    return function() {
        return iframe.name;
    };
}
function $966466ed4b666020$export$6cf3d710d3a367e5(name) {
    return function(iframe) {
        return function() {
            iframe.name = name;
        };
    };
}
function $966466ed4b666020$export$7e3df82ee760448c(iframe) {
    return function() {
        return iframe.width;
    };
}
function $966466ed4b666020$export$67f48e0594af05d(width) {
    return function(iframe) {
        return function() {
            iframe.width = width;
        };
    };
}
function $966466ed4b666020$export$ac607276a8fe9f0a(iframe) {
    return function() {
        return iframe.height;
    };
}
function $966466ed4b666020$export$3f31360357be44e4(height) {
    return function(iframe) {
        return function() {
            iframe.height = height;
        };
    };
}
function $966466ed4b666020$export$a51825c89fe24f94(iframe) {
    return function() {
        return iframe.contentDocument;
    };
}
function $966466ed4b666020$export$688aae7b7ac35f92(iframe) {
    return function() {
        return iframe.contentWindow;
    };
}







var $bd620e99ccde661e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $bd620e99ccde661e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$6677e9b58554b15d = /* #__PURE__ */ function() {
    var $2 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($966466ed4b666020$export$688aae7b7ac35f92($3));
    };
}();
var $bd620e99ccde661e$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($966466ed4b666020$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.15
function $4fb986a93dbcc125$export$185802fd694ee1f5() {
    return new Image();
}
function $4fb986a93dbcc125$export$11b6d15e47fb61cf(width) {
    return function(height) {
        return function() {
            return new Image(width, height);
        };
    };
}
function $4fb986a93dbcc125$export$228be17d80722ab(image) {
    return function() {
        return image.alt;
    };
}
function $4fb986a93dbcc125$export$14a0e7c2e6152665(alt) {
    return function(image) {
        return function() {
            image.alt = alt;
        };
    };
}
function $4fb986a93dbcc125$export$2e40c9e35e9506f4(image) {
    return function() {
        return image.src;
    };
}
function $4fb986a93dbcc125$export$5771e3a4c80da7df(src) {
    return function(image) {
        return function() {
            image.src = src;
        };
    };
}
function $4fb986a93dbcc125$export$c2507fd1cd56d483(image) {
    return function() {
        return image.srcset;
    };
}
function $4fb986a93dbcc125$export$c95fa5d268267aa4(srcset) {
    return function(image) {
        return function() {
            image.srcset = srcset;
        };
    };
}
function $4fb986a93dbcc125$export$c647cb0ee6e282fe(image) {
    return function() {
        return image.sizes;
    };
}
function $4fb986a93dbcc125$export$2652819f9fe6d59b(sizes) {
    return function(image) {
        return function() {
            image.sizes = sizes;
        };
    };
}
function $4fb986a93dbcc125$export$22e7408040d24cb8(image) {
    return function() {
        return image.currentSrc;
    };
}
function $4fb986a93dbcc125$export$2a95876eedf9defd(image) {
    return image.crossOrigin;
}
function $4fb986a93dbcc125$export$15671bab5b2a825c(crossOrigin, image) {
    image.crossOrigin = crossOrigin;
}
function $4fb986a93dbcc125$export$86f8f9f08863e403(image) {
    return function() {
        return image.useMap;
    };
}
function $4fb986a93dbcc125$export$ab416bdbb887640e(useMap) {
    return function(image) {
        return function() {
            image.useMap = useMap;
        };
    };
}
function $4fb986a93dbcc125$export$5c90113a285f2241(image) {
    return function() {
        return image.isMap;
    };
}
function $4fb986a93dbcc125$export$e634cf4c55ef6324(isMap) {
    return function(image) {
        return function() {
            image.isMap = isMap;
        };
    };
}
function $4fb986a93dbcc125$export$7e3df82ee760448c(image) {
    return function() {
        return image.width;
    };
}
function $4fb986a93dbcc125$export$67f48e0594af05d(width) {
    return function(image) {
        return function() {
            image.width = width;
        };
    };
}
function $4fb986a93dbcc125$export$ac607276a8fe9f0a(image) {
    return function() {
        return image.height;
    };
}
function $4fb986a93dbcc125$export$3f31360357be44e4(height) {
    return function(image) {
        return function() {
            image.height = height;
        };
    };
}
function $4fb986a93dbcc125$export$c32e50dfb9f4ec89(image) {
    return function() {
        return image.naturalWidth;
    };
}
function $4fb986a93dbcc125$export$6a4b566b54dc81c0(image) {
    return function() {
        return image.naturalHeight;
    };
}
function $4fb986a93dbcc125$export$8b29ef2611187a5f(image) {
    return function() {
        return image.referrerPolicy;
    };
}
function $4fb986a93dbcc125$export$c73d54db5b3c6ed4(referrerPolicy) {
    return function(image) {
        return function() {
            image.referrerPolicy = referrerPolicy;
        };
    };
}
function $4fb986a93dbcc125$export$8774eb0dcbbe3146(image) {
    return image.decoding;
}
function $4fb986a93dbcc125$export$533597f26ad51793(decoding, image) {
    image.decoding = decoding;
}
function $4fb986a93dbcc125$export$c1978f45d5c8c1fd(image) {
    return image.loading;
}
function $4fb986a93dbcc125$export$820843123ac3b9d(loading, image) {
    image.loading = loading;
}
function $4fb986a93dbcc125$export$b1bc8081da8c9e77(image) {
    return function() {
        return image.complete;
    };
}







// Generated by purs version 0.15.15
const $28d793bcad7b6401$export$33e695b1da6bf8ce = function mkEffectFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $28d793bcad7b6401$export$d349e7010d9e4f18 = function mkEffectFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $28d793bcad7b6401$export$1329fa30c595aae1 = function mkEffectFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $28d793bcad7b6401$export$745d51d1abc5cd82 = function mkEffectFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $28d793bcad7b6401$export$b3413456c3617180 = function mkEffectFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $28d793bcad7b6401$export$becea21a68009b07 = function mkEffectFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $28d793bcad7b6401$export$83674e2607660e0f = function mkEffectFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $28d793bcad7b6401$export$c7f26c65f1b8e3 = function mkEffectFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $28d793bcad7b6401$export$5d4846e0dbe026fa = function mkEffectFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $28d793bcad7b6401$export$ac08820aca1c1ebc = function mkEffectFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $28d793bcad7b6401$export$84baa7a1ea5377fd = function runEffectFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $28d793bcad7b6401$export$6a301f847372dca1 = function runEffectFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $28d793bcad7b6401$export$40df0ea470e346f0 = function runEffectFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$ec3c5c8caae58867 = function runEffectFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$5b882d1088aa8dc9 = function runEffectFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$53e477d88d18e854 = function runEffectFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$2d0fb35e82261b8d = function runEffectFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$801a85b4a2b405ac = function runEffectFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$326863f2889caa23 = function runEffectFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$8fc2053a354b81aa = function runEffectFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};





var $252b49eb63e60f04$export$6b33adf3a8e3f704 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$5d4846e0dbe026fa(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return append($28d793bcad7b6401$export$326863f2889caa23(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i))($28d793bcad7b6401$export$326863f2889caa23(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1b434506fc11421 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$c7f26c65f1b8e3(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return append($28d793bcad7b6401$export$801a85b4a2b405ac(f1)(a)(b)(c)(d)(e)(f)(g)(h))($28d793bcad7b6401$export$801a85b4a2b405ac(f2)(a)(b)(c)(d)(e)(f)(g)(h));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$f9d62e28920765a6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$83674e2607660e0f(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return append($28d793bcad7b6401$export$2d0fb35e82261b8d(f1)(a)(b)(c)(d)(e)(f)(g))($28d793bcad7b6401$export$2d0fb35e82261b8d(f2)(a)(b)(c)(d)(e)(f)(g));
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1cdb6e5a843aefe2 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$becea21a68009b07(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return append($28d793bcad7b6401$export$53e477d88d18e854(f1)(a)(b)(c)(d)(e)(f))($28d793bcad7b6401$export$53e477d88d18e854(f2)(a)(b)(c)(d)(e)(f));
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$99aa837ed31887aa = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$b3413456c3617180(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return append($28d793bcad7b6401$export$5b882d1088aa8dc9(f1)(a)(b)(c)(d)(e))($28d793bcad7b6401$export$5b882d1088aa8dc9(f2)(a)(b)(c)(d)(e));
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$8cb019b91258e3b9 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$745d51d1abc5cd82(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return append($28d793bcad7b6401$export$ec3c5c8caae58867(f1)(a)(b)(c)(d))($28d793bcad7b6401$export$ec3c5c8caae58867(f2)(a)(b)(c)(d));
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$fb0bdf58ff0a6426 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$1329fa30c595aae1(function(a) {
                    return function(b) {
                        return function(c) {
                            return append($28d793bcad7b6401$export$40df0ea470e346f0(f1)(a)(b)(c))($28d793bcad7b6401$export$40df0ea470e346f0(f2)(a)(b)(c));
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$9bf195cde6bca966 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$d349e7010d9e4f18(function(a) {
                    return function(b) {
                        return append($28d793bcad7b6401$export$6a301f847372dca1(f1)(a)(b))($28d793bcad7b6401$export$6a301f847372dca1(f2)(a)(b));
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$39f0bfa3de9c8ca1 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$ac08820aca1c1ebc(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return function(j) {
                                                        return append($28d793bcad7b6401$export$8fc2053a354b81aa(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j))($28d793bcad7b6401$export$8fc2053a354b81aa(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$d15c5b9160f5bf5 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$33e695b1da6bf8ce(function(a) {
                    return append($28d793bcad7b6401$export$84baa7a1ea5377fd(f1)(a))($28d793bcad7b6401$export$84baa7a1ea5377fd(f2)(a));
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$951567719e338e25 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn91 = $252b49eb63e60f04$export$6b33adf3a8e3f704(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$5d4846e0dbe026fa(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return mempty;
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn91;
        }
    };
};
var $252b49eb63e60f04$export$60b4106c40599be6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn81 = $252b49eb63e60f04$export$1b434506fc11421(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$c7f26c65f1b8e3(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return mempty;
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn81;
        }
    };
};
var $252b49eb63e60f04$export$63d6254dd5b47db1 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn71 = $252b49eb63e60f04$export$f9d62e28920765a6(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$83674e2607660e0f(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return mempty;
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn71;
        }
    };
};
var $252b49eb63e60f04$export$80d58e93d1dd53e4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn61 = $252b49eb63e60f04$export$1cdb6e5a843aefe2(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$becea21a68009b07(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return mempty;
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn61;
        }
    };
};
var $252b49eb63e60f04$export$c346a9c2957c12e8 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn51 = $252b49eb63e60f04$export$99aa837ed31887aa(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$b3413456c3617180(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return mempty;
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn51;
        }
    };
};
var $252b49eb63e60f04$export$fd6b07fef28d22de = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn41 = $252b49eb63e60f04$export$8cb019b91258e3b9(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$745d51d1abc5cd82(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return mempty;
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn41;
        }
    };
};
var $252b49eb63e60f04$export$f091af598ee150a6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn31 = $252b49eb63e60f04$export$fb0bdf58ff0a6426(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$1329fa30c595aae1(function(v) {
            return function(v1) {
                return function(v2) {
                    return mempty;
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn31;
        }
    };
};
var $252b49eb63e60f04$export$6294c3a3ece87949 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn21 = $252b49eb63e60f04$export$9bf195cde6bca966(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$d349e7010d9e4f18(function(v) {
            return function(v1) {
                return mempty;
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn21;
        }
    };
};
var $252b49eb63e60f04$export$c62e1ced10b8c8b0 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn101 = $252b49eb63e60f04$export$39f0bfa3de9c8ca1(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$ac08820aca1c1ebc(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return function(v9) {
                                                return mempty;
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn101;
        }
    };
};
var $252b49eb63e60f04$export$333b269eda63e7a7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn11 = $252b49eb63e60f04$export$d15c5b9160f5bf5(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$33e695b1da6bf8ce(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupEffectFn11;
        }
    };
};



// Generated by purs version 0.15.15


var $ff8d4f0527bf7f56$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $ff8d4f0527bf7f56$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "Anonymous";
        if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "UseCredentials";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 18, column 10 - line 20, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $ff8d4f0527bf7f56$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 30, column 9 - line 32, column 38): " + [
        v.constructor.name
    ]);
};
var $ff8d4f0527bf7f56$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "anonymous") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "use-credentials") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$bf6fef082af5a2d3.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return true;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $ff8d4f0527bf7f56$export$4877633354812171 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9;
    }
};


// Generated by purs version 0.15.15


var $becf597acb9365c5$export$2ae15352e0a80063 = /* #__PURE__ */ function() {
    function Sync() {}
    Sync.value = new Sync();
    return Sync;
}();
var $becf597acb9365c5$export$4d3c597da532240f = /* #__PURE__ */ function() {
    function Async() {}
    Async.value = new Async();
    return Async;
}();
var $becf597acb9365c5$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $becf597acb9365c5$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "Sync";
        if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "Async";
        if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "Auto";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 19, column 10 - line 22, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $becf597acb9365c5$export$c2d084dc44961371 = function(v) {
    if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "sync";
    if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "async";
    if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "auto";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 33, column 9 - line 36, column 17): " + [
        v.constructor.name
    ]);
};
var $becf597acb9365c5$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    if (v === "sync") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$2ae15352e0a80063.value);
    if (v === "async") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$4d3c597da532240f.value);
    if (v === "auto") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $becf597acb9365c5$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return true;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return true;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return true;
            return false;
        };
    }
};
var $becf597acb9365c5$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $becf597acb9365c5$export$e32bcfaf2cb99de5;
    }
};


// Generated by purs version 0.15.15


var $a591d06baacc8fdb$export$a4acc175556f6dbc = /* #__PURE__ */ function() {
    function Eager() {}
    Eager.value = new Eager();
    return Eager;
}();
var $a591d06baacc8fdb$export$b624eff549462981 = /* #__PURE__ */ function() {
    function Lazy() {}
    Lazy.value = new Lazy();
    return Lazy;
}();
var $a591d06baacc8fdb$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "Eager";
        if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "Lazy";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 18, column 10 - line 20, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $a591d06baacc8fdb$export$c2d084dc44961371 = function(v) {
    if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "eager";
    if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "lazy";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 30, column 9 - line 32, column 17): " + [
        v.constructor.name
    ]);
};
var $a591d06baacc8fdb$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "eager") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "lazy") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$b624eff549462981.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $a591d06baacc8fdb$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return true;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return true;
            return false;
        };
    }
};
var $a591d06baacc8fdb$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a591d06baacc8fdb$export$e32bcfaf2cb99de5;
    }
};



var $29906668619f3a83$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $29906668619f3a83$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3ac708362c1f96eb = function(laziness) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$820843123ac3b9d)($a591d06baacc8fdb$export$c2d084dc44961371(laziness));
};
var $29906668619f3a83$export$fe0b2eeb59b63d00 = function(hint) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$533597f26ad51793)($becf597acb9365c5$export$c2d084dc44961371(hint));
};
var $29906668619f3a83$export$e7fd69f64f92856 = function(mode) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$15671bab5b2a825c)($ff8d4f0527bf7f56$export$c2d084dc44961371(mode));
};
var $29906668619f3a83$export$46c1c92549715335 = /* #__PURE__ */ function() {
    var $3 = $29906668619f3a83$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
        return function($7) {
            return $6($a591d06baacc8fdb$export$98e6a39c04603d36($7));
        };
    }());
    var $4 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$c1978f45d5c8c1fd);
    return function($5) {
        return $3($4($5));
    };
}();
var $29906668619f3a83$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$7b9cc1601c0b9c78 = /* #__PURE__ */ function() {
    var $8 = $29906668619f3a83$var$map(function() {
        var $11 = $06733ae99ed4f534$export$43db023a260c5e9f($becf597acb9365c5$export$6cc2e70440926d44.value);
        return function($12) {
            return $11($becf597acb9365c5$export$98e6a39c04603d36($12));
        };
    }());
    var $9 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$8774eb0dcbbe3146);
    return function($10) {
        return $8($9($10));
    };
}();
var $29906668619f3a83$export$c47cb7c63271266e = /* #__PURE__ */ function() {
    var $13 = $29906668619f3a83$var$map($70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377)($ff8d4f0527bf7f56$export$98e6a39c04603d36)($0a5aaf95f168428e$export$1ba013b88f4f21f3));
    var $14 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$2a95876eedf9defd);
    return function($15) {
        return $13($14($15));
    };
}();
var $29906668619f3a83$export$20f9c2173df486a8 = $4fb986a93dbcc125$export$11b6d15e47fb61cf;


// Generated by purs version 0.15.15
function $22cc4a9f2b8eb096$export$73f57eecff448cc8(input) {
    return function() {
        return input.accept;
    };
}
function $22cc4a9f2b8eb096$export$b20dfae471de8dc1(accept) {
    return function(input) {
        return function() {
            input.accept = accept;
        };
    };
}
function $22cc4a9f2b8eb096$export$228be17d80722ab(input) {
    return function() {
        return input.alt;
    };
}
function $22cc4a9f2b8eb096$export$14a0e7c2e6152665(alt) {
    return function(input) {
        return function() {
            input.alt = alt;
        };
    };
}
function $22cc4a9f2b8eb096$export$485ded5f26ebe08d(input) {
    return function() {
        return input.autocomplete;
    };
}
function $22cc4a9f2b8eb096$export$5fb7c729919301a5(autocomplete) {
    return function(input) {
        return function() {
            input.autocomplete = autocomplete;
        };
    };
}
function $22cc4a9f2b8eb096$export$4c47992fc278c9a0(input) {
    return function() {
        return input.autofocus;
    };
}
function $22cc4a9f2b8eb096$export$db2bbdcbda3d335e(autofocus) {
    return function(input) {
        return function() {
            input.autofocus = autofocus;
        };
    };
}
function $22cc4a9f2b8eb096$export$8f49a7e9e3141ccc(input) {
    return function() {
        return input.defaultChecked;
    };
}
function $22cc4a9f2b8eb096$export$63092561e9c9bec4(defaultChecked) {
    return function(input) {
        return function() {
            input.defaultChecked = defaultChecked;
        };
    };
}
function $22cc4a9f2b8eb096$export$b96bb35bc88d6fa(input) {
    return function() {
        return input.checked;
    };
}
function $22cc4a9f2b8eb096$export$d2270ed72c00a9b2(checked) {
    return function(input) {
        return function() {
            input.checked = checked;
        };
    };
}
function $22cc4a9f2b8eb096$export$9ebb36ddc946da55(input) {
    return function() {
        return input.dirName;
    };
}
function $22cc4a9f2b8eb096$export$e2460e55089b163d(dirName) {
    return function(input) {
        return function() {
            input.dirName = dirName;
        };
    };
}
function $22cc4a9f2b8eb096$export$683472f6198a076e(input) {
    return function() {
        return input.disabled;
    };
}
function $22cc4a9f2b8eb096$export$4532d31cef66d703(disabled) {
    return function(input) {
        return function() {
            input.disabled = disabled;
        };
    };
}
function $22cc4a9f2b8eb096$export$242c63e9758836c2(input) {
    return function() {
        return input.form;
    };
}
function $22cc4a9f2b8eb096$export$92d18e9db2d4e896(input) {
    return function() {
        return input.files;
    };
}
function $22cc4a9f2b8eb096$export$7e4d70bab1b5c4a0(input) {
    return function() {
        return input.formAction;
    };
}
function $22cc4a9f2b8eb096$export$577bb1d64e4c83b9(formAction) {
    return function(input) {
        return function() {
            input.formAction = formAction;
        };
    };
}
function $22cc4a9f2b8eb096$export$21f1c8008acfa9c0(input) {
    return function() {
        return input.formEnctype;
    };
}
function $22cc4a9f2b8eb096$export$346989dcff4ba18b(formEnctype) {
    return function(input) {
        return function() {
            input.formEnctype = formEnctype;
        };
    };
}
function $22cc4a9f2b8eb096$export$3f1ffee261a00124(input) {
    return function() {
        return input.formMethod;
    };
}
function $22cc4a9f2b8eb096$export$c38a1a871bb0e145(formMethod) {
    return function(input) {
        return function() {
            input.formMethod = formMethod;
        };
    };
}
function $22cc4a9f2b8eb096$export$87c857905fcc4a84(input) {
    return function() {
        return input.formNoValidate;
    };
}
function $22cc4a9f2b8eb096$export$ad9ff32d0af51586(formNoValidate) {
    return function(input) {
        return function() {
            input.formNoValidate = formNoValidate;
        };
    };
}
function $22cc4a9f2b8eb096$export$497949a0ae76184f(input) {
    return function() {
        return input.formTarget;
    };
}
function $22cc4a9f2b8eb096$export$4c7e983548149eb5(formTarget) {
    return function(input) {
        return function() {
            input.formTarget = formTarget;
        };
    };
}
function $22cc4a9f2b8eb096$export$ac607276a8fe9f0a(input) {
    return function() {
        return input.height;
    };
}
function $22cc4a9f2b8eb096$export$3f31360357be44e4(height) {
    return function(input) {
        return function() {
            input.height = height;
        };
    };
}
function $22cc4a9f2b8eb096$export$5a1fde3dfe3b3c2a(input) {
    return function() {
        return input.indeterminate;
    };
}
function $22cc4a9f2b8eb096$export$52735f1bbb810b6(indeterminate) {
    return function(input) {
        return function() {
            input.indeterminate = indeterminate;
        };
    };
}
function $22cc4a9f2b8eb096$export$8932efb87fe83757(input) {
    return function() {
        return input.list;
    };
}
function $22cc4a9f2b8eb096$export$8960430cfd85939f(input) {
    return function() {
        return input.max;
    };
}
function $22cc4a9f2b8eb096$export$b03015b7eb8a4a0d(max) {
    return function(input) {
        return function() {
            input.max = max;
        };
    };
}
function $22cc4a9f2b8eb096$export$c9f461152c658a8b(input) {
    return function() {
        return input.maxLength;
    };
}
function $22cc4a9f2b8eb096$export$45077a575ddd961f(maxLength) {
    return function(input) {
        return function() {
            input.maxLength = maxLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$96ec731ed4dcb222(input) {
    return function() {
        return input.min;
    };
}
function $22cc4a9f2b8eb096$export$46d199234e678744(min) {
    return function(input) {
        return function() {
            input.min = min;
        };
    };
}
function $22cc4a9f2b8eb096$export$8fe860a115a1e636(input) {
    return function() {
        return input.minLength;
    };
}
function $22cc4a9f2b8eb096$export$2b867239766ba1e3(minLength) {
    return function(input) {
        return function() {
            input.minLength = minLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$939ddaa3205df08e(input) {
    return function() {
        return input.multiple;
    };
}
function $22cc4a9f2b8eb096$export$be7c7381b31f2269(multiple) {
    return function(input) {
        return function() {
            input.multiple = multiple;
        };
    };
}
function $22cc4a9f2b8eb096$export$a8ff84c12d48cfa6(input) {
    return function() {
        return input.name;
    };
}
function $22cc4a9f2b8eb096$export$6cf3d710d3a367e5(name) {
    return function(input) {
        return function() {
            input.name = name;
        };
    };
}
function $22cc4a9f2b8eb096$export$24f82734ea047e6f(input) {
    return function() {
        return input.pattern;
    };
}
function $22cc4a9f2b8eb096$export$faed90dbedc3b6d5(pattern) {
    return function(input) {
        return function() {
            input.pattern = pattern;
        };
    };
}
function $22cc4a9f2b8eb096$export$c7187bbd1a7a9244(input) {
    return function() {
        return input.placeholder;
    };
}
function $22cc4a9f2b8eb096$export$645bf5697adfa088(placeholder) {
    return function(input) {
        return function() {
            input.placeholder = placeholder;
        };
    };
}
function $22cc4a9f2b8eb096$export$b2cbc93d4da94977(input) {
    return function() {
        return input.readOnly;
    };
}
function $22cc4a9f2b8eb096$export$62311ce54ddfc862(readOnly) {
    return function(input) {
        return function() {
            input.readOnly = readOnly;
        };
    };
}
function $22cc4a9f2b8eb096$export$a7a0278c004aac3f(input) {
    return function() {
        return input.required;
    };
}
function $22cc4a9f2b8eb096$export$47f9362469f346c4(required) {
    return function(input) {
        return function() {
            input.required = required;
        };
    };
}
function $22cc4a9f2b8eb096$export$346677f925de839c(input) {
    return function() {
        return input.size;
    };
}
function $22cc4a9f2b8eb096$export$1c70a6cc12bc0366(size) {
    return function(input) {
        return function() {
            input.size = size;
        };
    };
}
function $22cc4a9f2b8eb096$export$2e40c9e35e9506f4(input) {
    return function() {
        return input.src;
    };
}
function $22cc4a9f2b8eb096$export$5771e3a4c80da7df(src) {
    return function(input) {
        return function() {
            input.src = src;
        };
    };
}
function $22cc4a9f2b8eb096$export$35d34bc0ed591a92(input) {
    return function() {
        return input.step;
    };
}
function $22cc4a9f2b8eb096$export$5305615f76bbd5b5(step) {
    return function(input) {
        return function() {
            input.step = step;
        };
    };
}
function $22cc4a9f2b8eb096$export$d4a6a4db5b31e621(input) {
    return function() {
        return input.type;
    };
}
function $22cc4a9f2b8eb096$export$1bf7f05044e9c5cb(type) {
    return function(input) {
        return function() {
            input.type = type;
        };
    };
}
function $22cc4a9f2b8eb096$export$1a01ae0705bafd37(input) {
    return function() {
        return input.defaultValue;
    };
}
function $22cc4a9f2b8eb096$export$d8becbd7468e206f(defaultValue) {
    return function(input) {
        return function() {
            input.defaultValue = defaultValue;
        };
    };
}
function $22cc4a9f2b8eb096$export$2ab9a8f9f1186f14(input) {
    return function() {
        return input.value;
    };
}
function $22cc4a9f2b8eb096$export$80746c6bc6142fc8(value) {
    return function(input) {
        return function() {
            input.value = value;
        };
    };
}
function $22cc4a9f2b8eb096$export$f0d0381422fe3a76(input) {
    return function() {
        return input.valueAsDate;
    };
}
function $22cc4a9f2b8eb096$export$8dfa787857729211(valueAsDate) {
    return function(input) {
        return function() {
            input.valueAsDate = valueAsDate;
        };
    };
}
function $22cc4a9f2b8eb096$export$3e66e4a199ac841d(input) {
    return function() {
        return input.valueAsNumber;
    };
}
function $22cc4a9f2b8eb096$export$4f64bca7327fe0dc(valueAsNumber) {
    return function(input) {
        return function() {
            input.valueAsNumber = valueAsNumber;
        };
    };
}
function $22cc4a9f2b8eb096$export$7e3df82ee760448c(input) {
    return function() {
        return input.width;
    };
}
function $22cc4a9f2b8eb096$export$67f48e0594af05d(width) {
    return function(input) {
        return function() {
            input.width = width;
        };
    };
}
function $22cc4a9f2b8eb096$export$801b713d5ecf6e3f(n) {
    return function(input) {
        return function() {
            input.stepUp(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$228be912dbc8075f(n) {
    return function(input) {
        return function() {
            input.stepDown(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$5e55a9e709e8e020(input) {
    return function() {
        return input.willValidate;
    };
}
function $22cc4a9f2b8eb096$export$1bdd3f9a89b22594(input) {
    return function() {
        return input.validity;
    };
}
function $22cc4a9f2b8eb096$export$6ee4201e37a931e2(input) {
    return function() {
        return input.validationMessage;
    };
}
function $22cc4a9f2b8eb096$export$50d70f8cedc54453(input) {
    return function() {
        return input.checkValidity();
    };
}
function $22cc4a9f2b8eb096$export$b962d864c477cc49(input) {
    return function() {
        return input.reportValidity();
    };
}
function $22cc4a9f2b8eb096$export$6f569cb704992105(value) {
    return function(input) {
        return function() {
            input.setCustomValidity(value);
        };
    };
}
function $22cc4a9f2b8eb096$export$a238cb463698c900(input) {
    return function() {
        return input.labels;
    };
}
function $22cc4a9f2b8eb096$export$2e6c959c16ff56b8(input) {
    return function() {
        input.select();
    };
}
function $22cc4a9f2b8eb096$export$5e2f617ae845fb63(input) {
    return function() {
        return input.selectionStart;
    };
}
function $22cc4a9f2b8eb096$export$47b9c21811f199bd(selectionStart) {
    return function(input) {
        return function() {
            input.selectionStart = selectionStart;
        };
    };
}
function $22cc4a9f2b8eb096$export$1028be563f1155b2(input) {
    return function() {
        return input.selectionEnd;
    };
}
function $22cc4a9f2b8eb096$export$15d012c6be3c352(selectionEnd) {
    return function(input) {
        return function() {
            input.selectionEnd = selectionEnd;
        };
    };
}
function $22cc4a9f2b8eb096$export$b4e8aad052258154(input) {
    return function() {
        return input.selectionDirection;
    };
}
function $22cc4a9f2b8eb096$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(input) {
        return function() {
            input.selectionDirection = selectionDirection;
        };
    };
}
function $22cc4a9f2b8eb096$export$2add2a46d1c1d557(replacement) {
    return function(input) {
        return function() {
            input.setRangeText(replacement);
        };
    };
}
function $22cc4a9f2b8eb096$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $22cc4a9f2b8eb096$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(input) {
                return function() {
                    input.setSelectionRange(start, end, direction, input);
                };
            };
        };
    };
}






// Generated by purs version 0.15.15


var $c09a3e7cfbb6a57f$export$8163af2a41fbee7 = /* #__PURE__ */ function() {
    function Preserve() {}
    Preserve.value = new Preserve();
    return Preserve;
}();
var $c09a3e7cfbb6a57f$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select() {}
    Select.value = new Select();
    return Select;
}();
var $c09a3e7cfbb6a57f$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $c09a3e7cfbb6a57f$export$290d774e6bd35c9a = /* #__PURE__ */ function() {
    function End() {}
    End.value = new End();
    return End;
}();
var $c09a3e7cfbb6a57f$export$7e20bbef4bce8df9 = {
    show: function(v) {
        if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "Preserve";
        if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "Select";
        if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "Start";
        if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "End";
        throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 17, column 10 - line 21, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $c09a3e7cfbb6a57f$export$c2d084dc44961371 = function(v) {
    if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "preserve";
    if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "select";
    if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "start";
    if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "end";
    throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 32, column 9 - line 36, column 15): " + [
        v.constructor.name
    ]);
};
var $c09a3e7cfbb6a57f$export$98e6a39c04603d36 = function(v) {
    if (v === "preserve") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$8163af2a41fbee7.value);
    if (v === "select") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$ef9b1a59e592288f.value);
    if (v === "start") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$568b89e600fc77eb.value);
    if (v === "end") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$290d774e6bd35c9a.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return true;
            return false;
        };
    }
};
var $c09a3e7cfbb6a57f$export$81b0e65721ff4cca = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7;
    }
};



var $dbc3cf4ed216a106$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $dbc3cf4ed216a106$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$daa292563bc4c5ef = $22cc4a9f2b8eb096$export$801b713d5ecf6e3f;
var $dbc3cf4ed216a106$export$218b3ebffb5cc7e4 = /* #__PURE__ */ $dbc3cf4ed216a106$export$daa292563bc4c5ef(1);
var $dbc3cf4ed216a106$export$6dd86ef1ac84105c = $22cc4a9f2b8eb096$export$228be912dbc8075f;
var $dbc3cf4ed216a106$export$d45ac0df5909f3e5 = /* #__PURE__ */ $dbc3cf4ed216a106$export$6dd86ef1ac84105c(1);
var $dbc3cf4ed216a106$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $22cc4a9f2b8eb096$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $dbc3cf4ed216a106$export$8837f4fc672e936d = /* #__PURE__ */ function() {
    var $2 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($22cc4a9f2b8eb096$export$8932efb87fe83757($3));
    };
}();
var $dbc3cf4ed216a106$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $4 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($22cc4a9f2b8eb096$export$242c63e9758836c2($5));
    };
}();
var $dbc3cf4ed216a106$export$3a444357c5f65f65 = /* #__PURE__ */ function() {
    var $6 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($22cc4a9f2b8eb096$export$92d18e9db2d4e896($7));
    };
}();


// Generated by purs version 0.15.15
function $3aa32ab13deeb208$export$4c47992fc278c9a0(keygen) {
    return function() {
        return keygen.autofocus;
    };
}
function $3aa32ab13deeb208$export$db2bbdcbda3d335e(autofocus) {
    return function(keygen) {
        return function() {
            keygen.autofocus = autofocus;
        };
    };
}
function $3aa32ab13deeb208$export$1cb6aab4c63c6c51(keygen) {
    return function() {
        return keygen.challenge;
    };
}
function $3aa32ab13deeb208$export$e4ab94f6a56193a3(challenge) {
    return function(keygen) {
        return function() {
            keygen.challenge = challenge;
        };
    };
}
function $3aa32ab13deeb208$export$683472f6198a076e(keygen) {
    return function() {
        return keygen.disabled;
    };
}
function $3aa32ab13deeb208$export$4532d31cef66d703(disabled) {
    return function(keygen) {
        return function() {
            keygen.disabled = disabled;
        };
    };
}
function $3aa32ab13deeb208$export$242c63e9758836c2(keygen) {
    return function() {
        return keygen.form;
    };
}
function $3aa32ab13deeb208$export$63e1099bcd6b827d(keygen) {
    return function() {
        return keygen.keytype;
    };
}
function $3aa32ab13deeb208$export$d04d7126b9e1b9(keytype) {
    return function(keygen) {
        return function() {
            keygen.keytype = keytype;
        };
    };
}
function $3aa32ab13deeb208$export$a8ff84c12d48cfa6(keygen) {
    return function() {
        return keygen.name;
    };
}
function $3aa32ab13deeb208$export$6cf3d710d3a367e5(name) {
    return function(keygen) {
        return function() {
            keygen.name = name;
        };
    };
}
function $3aa32ab13deeb208$export$d4a6a4db5b31e621(keygen) {
    return function() {
        return keygen.type;
    };
}
function $3aa32ab13deeb208$export$5e55a9e709e8e020(keygen) {
    return function() {
        return keygen.willValidate;
    };
}
function $3aa32ab13deeb208$export$1bdd3f9a89b22594(keygen) {
    return function() {
        return keygen.validity;
    };
}
function $3aa32ab13deeb208$export$6ee4201e37a931e2(keygen) {
    return function() {
        return keygen.validationMessage;
    };
}
function $3aa32ab13deeb208$export$50d70f8cedc54453(keygen) {
    return function() {
        return keygen.checkValidity();
    };
}
function $3aa32ab13deeb208$export$b962d864c477cc49(keygen) {
    return function() {
        return keygen.reportValidity();
    };
}
function $3aa32ab13deeb208$export$6f569cb704992105(value) {
    return function(keygen) {
        return function() {
            keygen.setCustomValidity(value);
        };
    };
}
function $3aa32ab13deeb208$export$a238cb463698c900(keygen) {
    return function() {
        return keygen.labels;
    };
}







var $35aecd379c08dc0f$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($3aa32ab13deeb208$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $f247ebfc04032388$export$2ab9a8f9f1186f14(li) {
    return function() {
        return li.value;
    };
}
function $f247ebfc04032388$export$80746c6bc6142fc8(value) {
    return function(li) {
        return function() {
            li.value = value;
        };
    };
}




var $46bf88ea94d3504e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");


// Generated by purs version 0.15.15
function $8772cd4a9c558251$export$242c63e9758836c2(label) {
    return function() {
        return label.form;
    };
}
function $8772cd4a9c558251$export$35d9e1c947946090(label) {
    return function() {
        return label.htmlFor;
    };
}
function $8772cd4a9c558251$export$a6c638cfae205843(htmlFor) {
    return function(label) {
        return function() {
            label.htmlFor = htmlFor;
        };
    };
}
function $8772cd4a9c558251$export$317fb27ad464e186(label) {
    return function() {
        return label.control;
    };
}







var $ba933b3d44ed7c03$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $ba933b3d44ed7c03$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($8772cd4a9c558251$export$242c63e9758836c2($3));
    };
}();
var $ba933b3d44ed7c03$export$b5cde1de278b4330 = /* #__PURE__ */ function() {
    var $4 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($8772cd4a9c558251$export$317fb27ad464e186($5));
    };
}();


// Generated by purs version 0.15.15
function $5013c6f6daaea1f9$export$242c63e9758836c2(le) {
    return function() {
        return le.form;
    };
}







var $396c0721c94d9624$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($5013c6f6daaea1f9$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $00356bd5e80c6412$export$683472f6198a076e(link) {
    return function() {
        return link.disabled;
    };
}
function $00356bd5e80c6412$export$4532d31cef66d703(disabled) {
    return function(link) {
        return function() {
            link.disabled = disabled;
        };
    };
}
function $00356bd5e80c6412$export$8f51af5840e0602a(link) {
    return function() {
        return link.href;
    };
}
function $00356bd5e80c6412$export$428f6e77b5a5a669(href) {
    return function(link) {
        return function() {
            link.href = href;
        };
    };
}
function $00356bd5e80c6412$export$c47cb7c63271266e(link) {
    return function() {
        return link.crossOrigin;
    };
}
function $00356bd5e80c6412$export$e7fd69f64f92856(crossOrigin) {
    return function(link) {
        return function() {
            link.crossOrigin = crossOrigin;
        };
    };
}
function $00356bd5e80c6412$export$bad408f43b005bc8(link) {
    return function() {
        return link.rel;
    };
}
function $00356bd5e80c6412$export$9e86d1af7d63c52c(rel) {
    return function(link) {
        return function() {
            link.rel = rel;
        };
    };
}
function $00356bd5e80c6412$export$edb1c8e715f3944e(link) {
    return function() {
        return link.rev;
    };
}
function $00356bd5e80c6412$export$671b41179a9f15fb(rev) {
    return function(link) {
        return function() {
            link.rev = rev;
        };
    };
}
function $00356bd5e80c6412$export$5884a0b424dd5ef2(link) {
    return function() {
        return link.relList;
    };
}
function $00356bd5e80c6412$export$987d49ffe1b0900f(link) {
    return function() {
        return link.media;
    };
}
function $00356bd5e80c6412$export$5c1855deea651e41(media) {
    return function(link) {
        return function() {
            link.media = media;
        };
    };
}
function $00356bd5e80c6412$export$4bf4138386d6b8cc(link) {
    return function() {
        return link.hreflang;
    };
}
function $00356bd5e80c6412$export$17b5334c80252e15(hreflang) {
    return function(link) {
        return function() {
            link.hreflang = hreflang;
        };
    };
}
function $00356bd5e80c6412$export$d4a6a4db5b31e621(link) {
    return function() {
        return link.type;
    };
}
function $00356bd5e80c6412$export$1bf7f05044e9c5cb(type) {
    return function(link) {
        return function() {
            link.type = type;
        };
    };
}




var $66527c1ba968c066$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");


// Generated by purs version 0.15.15
function $5dbae6eb2b9d7a07$export$a8ff84c12d48cfa6(map) {
    return function() {
        return map.name;
    };
}
function $5dbae6eb2b9d7a07$export$6cf3d710d3a367e5(name) {
    return function(map) {
        return function() {
            map.name = name;
        };
    };
}
function $5dbae6eb2b9d7a07$export$4bdc600e2ccf60d6(map) {
    return function() {
        return map.areas;
    };
}
function $5dbae6eb2b9d7a07$export$6c746a5570b8b35c(map) {
    return function() {
        return map.images;
    };
}




var $55159de58cd7500d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");


// Generated by purs version 0.15.15
function $67f0fc7db8c638cb$export$2e40c9e35e9506f4(media) {
    return function() {
        return media.src;
    };
}
function $67f0fc7db8c638cb$export$5771e3a4c80da7df(src) {
    return function(media) {
        return function() {
            media.src = src;
        };
    };
}
function $67f0fc7db8c638cb$export$22e7408040d24cb8(media) {
    return function() {
        return media.currentSrc;
    };
}
function $67f0fc7db8c638cb$export$c47cb7c63271266e(media) {
    return function() {
        return media.crossOrigin;
    };
}
function $67f0fc7db8c638cb$export$e7fd69f64f92856(crossOrigin) {
    return function(media) {
        return function() {
            media.crossOrigin = crossOrigin;
        };
    };
}
function $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(media) {
    return media.networkState;
}
function $67f0fc7db8c638cb$export$513ccb98c53b8039(media) {
    return function() {
        return media.preload;
    };
}
function $67f0fc7db8c638cb$export$f6b3982121e869a(preload) {
    return function(media) {
        return function() {
            media.preload = preload;
        };
    };
}
function $67f0fc7db8c638cb$export$11e63f7b0f3d9900(media) {
    return function() {
        return media.load();
    };
}
function $67f0fc7db8c638cb$export$1a796126c2303a8(type, media) {
    return media.canPlayType(type);
}
function $67f0fc7db8c638cb$export$4bf8a366db6a678b(media) {
    return media.readyState;
}
function $67f0fc7db8c638cb$export$c8243f3943339030(media) {
    return function() {
        return media.seeking;
    };
}
function $67f0fc7db8c638cb$export$283f641d6ed1ac80(media) {
    return function() {
        return media.currentTime;
    };
}
function $67f0fc7db8c638cb$export$428d94eac67f5311(currentTime) {
    return function(media) {
        return function() {
            media.currentTime = currentTime;
        };
    };
}
function $67f0fc7db8c638cb$export$1f34108aa9eb96ab(media) {
    return function() {
        return media.duration;
    };
}
function $67f0fc7db8c638cb$export$3ee8fbdbeceaef0e(media) {
    return function() {
        return media.getStartDate();
    };
}
function $67f0fc7db8c638cb$export$cd215b91700bbebc(media) {
    return function() {
        return media.paused;
    };
}
function $67f0fc7db8c638cb$export$388da195c50bfd17(media) {
    return function() {
        return media.defaultPlaybackRate;
    };
}
function $67f0fc7db8c638cb$export$6fa34934a59a9a1(defaultPlaybackRate) {
    return function(media) {
        return function() {
            media.defaultPlaybackRate = defaultPlaybackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$6d7f3930b8041bc4(media) {
    return function() {
        return media.playbackRate;
    };
}
function $67f0fc7db8c638cb$export$3f48445a0d32edb0(playbackRate) {
    return function(media) {
        return function() {
            media.playbackRate = playbackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$999b7b72c79021f2(media) {
    return function() {
        return media.ended;
    };
}
function $67f0fc7db8c638cb$export$b243096046abd58(media) {
    return function() {
        return media.autoplay;
    };
}
function $67f0fc7db8c638cb$export$7a98ea7b6e6b2d36(autoplay) {
    return function(media) {
        return function() {
            media.autoplay = autoplay;
        };
    };
}
function $67f0fc7db8c638cb$export$f9ef67375ddc185(media) {
    return function() {
        return media.loop;
    };
}
function $67f0fc7db8c638cb$export$cf50c2db8dc11f8e(loop) {
    return function(media) {
        return function() {
            media.loop = loop;
        };
    };
}
function $67f0fc7db8c638cb$export$899fbdb5fa08b653(media) {
    return function() {
        media.play();
    };
}
function $67f0fc7db8c638cb$export$229c72e5fdee233b(media) {
    return function() {
        media.pause();
    };
}
function $67f0fc7db8c638cb$export$2855e964765eac9(media) {
    return function() {
        return media.mediaGroup;
    };
}
function $67f0fc7db8c638cb$export$2c8be4634a501ac1(mediaGroup) {
    return function(media) {
        return function() {
            media.mediaGroup = mediaGroup;
        };
    };
}
function $67f0fc7db8c638cb$export$cc1adf6fb659c762(media) {
    return function() {
        return media.controls;
    };
}
function $67f0fc7db8c638cb$export$891f55ce9f9e8605(controls) {
    return function(media) {
        return function() {
            media.controls = controls;
        };
    };
}
function $67f0fc7db8c638cb$export$7714b48ed08b13f2(media) {
    return function() {
        return media.volume;
    };
}
function $67f0fc7db8c638cb$export$246e658b67178cb0(volume) {
    return function(media) {
        return function() {
            media.volume = volume;
        };
    };
}
function $67f0fc7db8c638cb$export$987a4e3838aef8c6(media) {
    return function() {
        return media.muted;
    };
}
function $67f0fc7db8c638cb$export$a1680ba91cc9be33(muted) {
    return function(media) {
        return function() {
            media.muted = muted;
        };
    };
}
function $67f0fc7db8c638cb$export$4c9bd91015e50a76(media) {
    return function() {
        return media.defaultMuted;
    };
}
function $67f0fc7db8c638cb$export$a203b6be5128443d(defaultMuted) {
    return function(media) {
        return function() {
            media.defaultMuted = defaultMuted;
        };
    };
}


// Generated by purs version 0.15.15
function $1cf1b1293ed20ecf$export$d90166409dd04e85(c) {
    return c.charCodeAt(0);
}
function $1cf1b1293ed20ecf$export$30216c0101da0ee0(c) {
    return String.fromCharCode(c);
}


// Generated by purs version 0.15.15






var $f1992c51575cdea6$export$864d727b48066337 = function(dictAlternative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
    return function(v) {
        if (v) return pure($05149ea687d6b460$export$523c0b569236b342);
        if (!v) return empty;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $f1992c51575cdea6$export$5e87c78e215371ee = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Plus1: function() {
        return $7abe8fbe97ebda87$export$b7c99dd4fc96d90e;
    }
};















// Generated by purs version 0.15.15
const $6c33ca7d98a534e5$export$6368c6d238d348f0 = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var maybe = f(value);
                            if (isNothing(maybe)) return result;
                            var tuple = fromJust(maybe);
                            result.push(fst(tuple));
                            value = snd(tuple);
                        }
                    };
                };
            };
        };
    };
};







// Generated by purs version 0.15.15
const $b1275140774187c9$export$e3753a19e82ccedc = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var tuple = f(value);
                            result.push(fst(tuple));
                            var maybe = snd(tuple);
                            if (isNothing(maybe)) return result;
                            value = fromJust(maybe);
                        }
                    };
                };
            };
        };
    };
};




// Generated by purs version 0.15.15





// Generated by purs version 0.15.15








// Generated by purs version 0.15.15



var $baee932cbcb11133$export$d36c09e5d02927e7 = function(x) {
    return x;
};
var $baee932cbcb11133$export$cbb92fe0a8d77a01 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Max " + (show(v) + ")");
        }
    };
};
var $baee932cbcb11133$export$a132d56c46b55689 = function(dictOrd) {
    var max = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return max(v)(v1);
            };
        }
    };
};
var $baee932cbcb11133$export$1c8bde74ed3994f3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $baee932cbcb11133$export$1f74115b8967ed30 = function(dictBounded) {
    var semigroupMax1 = $baee932cbcb11133$export$a132d56c46b55689(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded),
        Semigroup0: function() {
            return semigroupMax1;
        }
    };
};
var $baee932cbcb11133$export$2d291ba9538dc344 = function(dictEq) {
    return dictEq;
};
var $baee932cbcb11133$export$9193f18dc6b98d96 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMax1 = $baee932cbcb11133$export$2d291ba9538dc344(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMax1;
        }
    };
};


// Generated by purs version 0.15.15



var $78eaf69ebdcfa03a$export$dfed19fabc75a31d = function(x) {
    return x;
};
var $78eaf69ebdcfa03a$export$7b461170c443f592 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Min " + (show(v) + ")");
        }
    };
};
var $78eaf69ebdcfa03a$export$7a307765ab1cd61e = function(dictOrd) {
    var min = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return min(v)(v1);
            };
        }
    };
};
var $78eaf69ebdcfa03a$export$1aba8bd40545d1a0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78eaf69ebdcfa03a$export$6c7bc156e3eb9786 = function(dictBounded) {
    var semigroupMin1 = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded),
        Semigroup0: function() {
            return semigroupMin1;
        }
    };
};
var $78eaf69ebdcfa03a$export$aa006854d430a332 = function(dictEq) {
    return dictEq;
};
var $78eaf69ebdcfa03a$export$ea9a45890a65660 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMin1 = $78eaf69ebdcfa03a$export$aa006854d430a332(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMin1;
        }
    };
};





var $086486679aa806fa$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $086486679aa806fa$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $086486679aa806fa$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $086486679aa806fa$var$ala = /* #__PURE__ */ $4fa4836228a192cc$export$7317c19c5df48291()()();
var $086486679aa806fa$var$JoinWith = function(x) {
    return x;
};
var $086486679aa806fa$var$FoldRight1 = /* #__PURE__ */ function() {
    function FoldRight1(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FoldRight1.create = function(value0) {
        return function(value1) {
            return new FoldRight1(value0, value1);
        };
    };
    return FoldRight1;
}();
var $086486679aa806fa$var$Act = function(x) {
    return x;
};
var $086486679aa806fa$var$semigroupJoinWith = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return function(j) {
                    return append(v(j))(append(j)(v1(j)));
                };
            };
        }
    };
};
var $086486679aa806fa$var$semigroupAct = function(dictApply) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApply);
    return {
        append: function(v) {
            return function(v1) {
                return applySecond(v)(v1);
            };
        }
    };
};
var $086486679aa806fa$var$runFoldRight1 = function(v) {
    return v.value0(v.value1);
};
var $086486679aa806fa$var$mkFoldRight1 = /* #__PURE__ */ function() {
    return $086486679aa806fa$var$FoldRight1.create($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
}();
var $086486679aa806fa$var$joinee = function(v) {
    return v;
};
var $086486679aa806fa$var$getAct = function(v) {
    return v;
};
var $086486679aa806fa$export$c8b99533c112636f = function(dict) {
    return dict.foldr1;
};
var $086486679aa806fa$export$eb5e1ef4ea2eca3d = function(dict) {
    return dict.foldl1;
};
var $086486679aa806fa$export$c42fa06aba2a552c = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $120 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
                if ($120) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$b65392d958998255 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $121 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                if ($121) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$ffb07d5442a5d6a6 = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $086486679aa806fa$export$9519b6731ae6781c = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $086486679aa806fa$export$3c076fb5bbc5428f = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $086486679aa806fa$export$1f8d30ddb0a4c229 = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $086486679aa806fa$var$foldRight1Semigroup = {
    append: function(v) {
        return function(v1) {
            return new $086486679aa806fa$var$FoldRight1(function(a) {
                return function(f) {
                    return v.value0(f(v.value1)(v1.value0(a)(f)))(f);
                };
            }, v1.value1);
        };
    }
};
var $086486679aa806fa$var$semigroupDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$dc7d4cd4865fc48($086486679aa806fa$var$foldRight1Semigroup);
var $086486679aa806fa$export$4a5b2f24b03cc38b = function(dictFoldable1) {
    var foldr11 = $086486679aa806fa$export$c8b99533c112636f(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $159 = foldr11(append);
                var $160 = map(f);
                return function($161) {
                    return $159($160($161));
                };
            };
        };
    };
};
var $086486679aa806fa$export$3341743d361f5644 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $162 = foldl11(append);
                var $163 = map(f);
                return function($164) {
                    return $162($163($164));
                };
            };
        };
    };
};
var $086486679aa806fa$export$b50c31bb8aebd2a7 = function(dict) {
    return dict.foldMap1;
};
var $086486679aa806fa$export$8dd52a2a23ae4dc4 = function(dictFoldable1) {
    var $165 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $167 = $086486679aa806fa$var$alaF($8257f7a36ab9f9cd$export$c26a72e8d91adeec)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$semigroupDual))($086486679aa806fa$var$mkFoldRight1);
        return function($168) {
            return $086486679aa806fa$var$runFoldRight1($167($168));
        };
    }());
    return function($166) {
        return $165($f57f4b701aa7b66e$export$8a83211c878a3f1f($166));
    };
};
var $086486679aa806fa$export$8af34898c082e678 = function(dictFoldable1) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $169 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$foldRight1Semigroup)($086486679aa806fa$var$mkFoldRight1);
        return function($170) {
            return $086486679aa806fa$var$runFoldRight1($169($170));
        };
    }());
};
var $086486679aa806fa$export$a91e4d9c87e70eae = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupJoinWith(dictSemigroup));
        return function(j) {
            return function(f) {
                return function(foldable) {
                    return $086486679aa806fa$var$joinee(foldMap12(function($171) {
                        return $086486679aa806fa$var$JoinWith($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f($171)));
                    })(foldable))(j);
                };
            };
        };
    };
};
var $086486679aa806fa$export$739ec22334c44788 = function(dictFoldable1) {
    var intercalateMap1 = $086486679aa806fa$export$a91e4d9c87e70eae(dictFoldable1);
    return function(dictSemigroup) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(intercalateMap1(dictSemigroup))($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$b25e0be55f42c9a = function(dictOrd) {
    var semigroupMax = $baee932cbcb11133$export$a132d56c46b55689(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($baee932cbcb11133$export$d36c09e5d02927e7)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMax));
    };
};
var $086486679aa806fa$export$916782c1f0ddb132 = function(dictOrd) {
    var semigroupMin = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($78eaf69ebdcfa03a$export$dfed19fabc75a31d)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMin));
    };
};
var $086486679aa806fa$export$4d892265b7b103bf = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictApply) {
        var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictApply.Functor0());
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupAct(dictApply));
        return function(f) {
            return function(t) {
                return voidRight($05149ea687d6b460$export$523c0b569236b342)($086486679aa806fa$var$getAct(foldMap12(function($172) {
                    return $086486679aa806fa$var$Act(f($172));
                })(t)));
            };
        };
    };
};
var $086486679aa806fa$export$f339179a581d1957 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse1_1(dictApply));
    };
};
var $086486679aa806fa$export$1e2962bbf3c67125 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return traverse1_1(dictApply)($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$2e430a6d03f6ee23 = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        return foldMap11(dictSemigroup)($086486679aa806fa$var$identity);
    };
};




var $e4fb66202bb8a4f4$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $e4fb66202bb8a4f4$export$d2990bb35e0a3e00 = function(dict) {
    return dict.traverse1;
};
var $e4fb66202bb8a4f4$export$d35878ee42638401 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$ffb07d5442a5d6a6;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $e4fb66202bb8a4f4$export$63e84f34fb558532 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$3c076fb5bbc5428f;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $e4fb66202bb8a4f4$export$c8ca5446ba1698 = function(dictTraversable1) {
    var traverse11 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    return function(dictApply) {
        return traverse11(dictApply)($e4fb66202bb8a4f4$var$identity);
    };
};
var $e4fb66202bb8a4f4$export$54df524caf88dbea = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$54df524caf88dbea)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$1f8d30ddb0a4c229;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $e4fb66202bb8a4f4$export$b86a2d00788e21b6 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$b86a2d00788e21b6)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$9519b6731ae6781c;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $e4fb66202bb8a4f4$export$6deffb29affc84c6 = function(dict) {
    return dict.sequence1;
};
var $e4fb66202bb8a4f4$export$61888596d46ec879 = function(dictTraversable1) {
    var sequence11 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable1.Traversable1().Functor0());
    return function(dictApply) {
        var sequence12 = sequence11(dictApply);
        return function(f) {
            return function(ta) {
                return sequence12(map(f)(ta));
            };
        };
    };
};



var $cf5af1199a495394$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cf5af1199a495394$export$158c052536266a97 = function(dict) {
    return dict.unfoldr1;
};
var $cf5af1199a495394$export$b5ac0a9881e433c3 = {
    unfoldr1: function(f) {
        return function(b) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073($71f2e2e9476163f8$export$9e770fa6ce19a9d6(f(b)));
        };
    }
};
var $cf5af1199a495394$export$587ba9a9bf3cf8b4 = {
    unfoldr1: /* #__PURE__ */ $b1275140774187c9$export$e3753a19e82ccedc($06733ae99ed4f534$export$4967676db1b89293)($cf5af1199a495394$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58)
};
var $cf5af1199a495394$export$dcb5d70039e504cd = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(v) {
            var step = function(i) {
                if (i <= 0) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, $06733ae99ed4f534$export$bebe9059409a0d04.value);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, new $06733ae99ed4f534$export$8a67b48435b5d073(i - 1 | 0));
                throw new Error("Failed pattern match at Data.Unfoldable1 (line 68, column 5 - line 68, column 39): " + [
                    i.constructor.name
                ]);
            };
            return unfoldr11(step)(n - 1 | 0);
        };
    };
};
var $cf5af1199a495394$export$d2a13fab7d8f2b56 = function(dictApply) {
    return function(dictUnfoldable1) {
        var replicate11 = $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1);
        return function(dictTraversable1) {
            var sequence1 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1)(dictApply);
            return function(n) {
                return function(m) {
                    return sequence1(replicate11(n)(m));
                };
            };
        };
    };
};
var $cf5af1199a495394$export$439306a4dcaafbb9 = function(dictUnfoldable1) {
    return $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1)(1);
};
var $cf5af1199a495394$export$d02631cccf789723 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(start) {
        return function(end) {
            var go = function(delta) {
                return function(i) {
                    var i$prime = i + delta | 0;
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(i, function() {
                        var $25 = i === end;
                        if ($25) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(i$prime);
                    }());
                };
            };
            var delta = function() {
                var $26 = end >= start;
                if ($26) return 1;
                return -1;
            }();
            return unfoldr11(go(delta))(start);
        };
    };
};
var $cf5af1199a495394$export$f1977d76a1a6e399 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(f) {
            return function(s) {
                var go = function(v) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
                        var $28 = v.value1 > 0;
                        if ($28) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1 - 1 | 0));
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    }());
                };
                return unfoldr11(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9(s, n - 1 | 0));
            };
        };
    };
};



var $cb5fedc2c4837e1c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $cb5fedc2c4837e1c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cb5fedc2c4837e1c$export$df2b8ee1690308ae = function(dict) {
    return dict.unfoldr;
};
var $cb5fedc2c4837e1c$export$b5169c61b27df85a = {
    unfoldr: function(f) {
        return function(b) {
            return $cb5fedc2c4837e1c$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(f(b));
        };
    },
    Unfoldable10: function() {
        return $cf5af1199a495394$export$b5ac0a9881e433c3;
    }
};
var $cb5fedc2c4837e1c$export$2b90ca20b4b58da5 = {
    unfoldr: /* #__PURE__ */ $6c33ca7d98a534e5$export$6368c6d238d348f0($06733ae99ed4f534$export$4967676db1b89293)($cb5fedc2c4837e1c$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58),
    Unfoldable10: function() {
        return $cf5af1199a495394$export$587ba9a9bf3cf8b4;
    }
};
var $cb5fedc2c4837e1c$export$606959e7ccb797f0 = function(dictUnfoldable) {
    var unfoldr1 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(n) {
        return function(v) {
            var step = function(i) {
                var $17 = i <= 0;
                if ($17) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v, i - 1 | 0));
            };
            return unfoldr1(step)(n);
        };
    };
};
var $cb5fedc2c4837e1c$export$1e1bbcb33c108a24 = function(dictApplicative) {
    return function(dictUnfoldable) {
        var replicate1 = $cb5fedc2c4837e1c$export$606959e7ccb797f0(dictUnfoldable);
        return function(dictTraversable) {
            var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable)(dictApplicative);
            return function(n) {
                return function(m) {
                    return sequence(replicate1(n)(m));
                };
            };
        };
    };
};
var $cb5fedc2c4837e1c$export$f883a24d5edde77c = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($05149ea687d6b460$export$523c0b569236b342);
};
var $cb5fedc2c4837e1c$export$43db023a260c5e9f = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(b) {
        return $cb5fedc2c4837e1c$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)($06733ae99ed4f534$export$bebe9059409a0d04.value))(b);
    });
};




var $f935a9866e211c00$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7576d3a958d66ab0$export$2f68caa5c730775d);
var $f935a9866e211c00$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $f935a9866e211c00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $f935a9866e211c00$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($06733ae99ed4f534$export$92d23d3d8fa78a80);
var $f935a9866e211c00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $f935a9866e211c00$var$bottom1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$var$top1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$export$a3fdfde49d86b899 = function(x) {
    return x;
};
var $f935a9866e211c00$export$45328c01562fb205 = function(dict) {
    return dict.toEnum;
};
var $f935a9866e211c00$export$61d85e1612867711 = function(dict) {
    return dict.succ;
};
var $f935a9866e211c00$export$f55455e25c350f35 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(succ1));
    };
};
var $f935a9866e211c00$export$3d0bc2efe492e4f7 = {
    show: function(v) {
        return "(Cardinality " + ($f935a9866e211c00$var$show(v) + ")");
    }
};
var $f935a9866e211c00$export$c238ae40a8cccc17 = function(dict) {
    return dict.pred;
};
var $f935a9866e211c00$export$68d5f1a472f8251a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $f935a9866e211c00$export$d3d8047a35329ac2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $f935a9866e211c00$export$b385cb642735011f = function(dict) {
    return dict.fromEnum;
};
var $f935a9866e211c00$export$1e2c188a485bdeae = function(dictBoundedEnum) {
    var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    return function(low) {
        return function(high) {
            return function(x) {
                var v = toEnum1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    var $140 = x < fromEnum1(bottom2);
                    if ($140) return low;
                    return high;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$63b732e1f89f043e = $37b880af5f4991bd$export$e65788c6d4494539;
var $f935a9866e211c00$export$c0a99362196d7617 = /* #__PURE__ */ function() {
    return {
        succ: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        pred: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Ord0: function() {
            return $97937c29f879e68e$export$f6b429625e3530b0;
        }
    };
}();
var $f935a9866e211c00$export$51ea709069e9f759 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var ordTuple = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictEnum.Ord0());
    return function(dictBoundedEnum) {
        var Bounded0 = dictBoundedEnum.Bounded0();
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(Bounded0);
        var Enum1 = dictBoundedEnum.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(Bounded0);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var ordTuple1 = ordTuple(Enum1.Ord0());
        return {
            succ: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(bottom2))(succ1(v.value0)))(function() {
                    var $183 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($184) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($183($184));
                    };
                }())(succ2(v.value1));
            },
            pred: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(top2))(pred1(v.value0)))(function() {
                    var $185 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($186) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($185($186));
                    };
                }())(pred2(v.value1));
            },
            Ord0: function() {
                return ordTuple1;
            }
        };
    };
};
var $f935a9866e211c00$export$94be50e509bf721a = {
    succ: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $97937c29f879e68e$export$dcb5533042a37f3c;
    }
};
var $f935a9866e211c00$export$4d9047d2b06c2498 = function(dictBoundedEnum) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var ordMaybe = $06733ae99ed4f534$export$e35c29f98d259c46(Enum1.Ord0());
    return {
        succ: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $06733ae99ed4f534$export$8a67b48435b5d073(bottom2));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f935a9866e211c00$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(succ1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        pred: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(pred1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        Ord0: function() {
            return ordMaybe;
        }
    };
};
var $f935a9866e211c00$export$f8cd1ff55b5d915b = {
    succ: function(n) {
        var $153 = n < $f935a9866e211c00$var$top;
        if ($153) return new $06733ae99ed4f534$export$8a67b48435b5d073(n + 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(n) {
        var $154 = n > $f935a9866e211c00$var$bottom;
        if ($154) return new $06733ae99ed4f534$export$8a67b48435b5d073(n - 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $f935a9866e211c00$export$51bf4ec4e9fd2fba = function(dictEnum) {
    var Ord0 = dictEnum.Ord0();
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(Ord0.Eq0());
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(Ord0);
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(Ord0);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(Ord0);
    return function(dictUnfoldable1) {
        var singleton = $cf5af1199a495394$export$439306a4dcaafbb9(dictUnfoldable1);
        var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
        var go = function(step) {
            return function(op) {
                return function(to) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $f935a9866e211c00$var$bind(step(a))(function(a$prime) {
                            return $f935a9866e211c00$var$voidLeft($f935a9866e211c00$var$guard(op(a$prime)(to)))(a$prime);
                        }));
                    };
                };
            };
        };
        return function(v) {
            return function(v1) {
                if (eq1(v)(v1)) return singleton(v);
                if (lessThan1(v)(v1)) return unfoldr1(go(succ1)(lessThanOrEq1)(v1))(v);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return unfoldr1(go(pred1)(greaterThanOrEq1)(v1))(v);
                throw new Error("Failed pattern match at Data.Enum (line 186, column 14 - line 190, column 51): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$c023000aca534be0 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(dictFunctor) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictBoundedEnum) {
            var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
            var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
            var go = function(step) {
                return function(to) {
                    return function(e) {
                        if (e <= to) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(e, e + step | 0));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Data.Enum (line 217, column 5 - line 219, column 28): " + [
                            step.constructor.name,
                            to.constructor.name,
                            e.constructor.name
                        ]);
                    };
                };
            };
            return function(a) {
                return function(b) {
                    return function(c) {
                        var c$prime = fromEnum1(c);
                        var b$prime = fromEnum1(b);
                        var a$prime = fromEnum1(a);
                        return map1(function($187) {
                            return $f935a9866e211c00$var$fromJust(toEnum1($187));
                        })(unfoldr(go(b$prime - a$prime | 0)(c$prime))(a$prime));
                    };
                };
            };
        };
    };
};
var $f935a9866e211c00$export$3733bec825dc17c = function(dictBoundedEnum) {
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBoundedEnum.Bounded0());
    var ordEither = $7d4cccdf062a2261$export$f105364bfbaa033b(Enum1.Ord0());
    return function(dictBoundedEnum1) {
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum1.Bounded0());
        var Enum11 = dictBoundedEnum1.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum11);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum11);
        var ordEither1 = ordEither(Enum11.Ord0());
        return {
            succ: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$19db0165690c701a(bottom2)))(function($188) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($188));
                })(succ1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($189) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($189));
                })(succ2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            pred: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($190) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($190));
                })(pred1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$37c4d04eafdc5515(top2)))(function($191) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($191));
                })(pred2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            Ord0: function() {
                return ordEither1;
            }
        };
    };
};
var $f935a9866e211c00$export$6670eb63482acbe8 = {
    succ: function(v) {
        if (!v) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(v) {
        if (v) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $f935a9866e211c00$export$ab0f40ba1313e2bb = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(pred1));
    };
};
var $f935a9866e211c00$var$diag = function(a) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, a);
};
var $f935a9866e211c00$export$c0c53cc9a0565905 = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $192 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($193) {
                return $192(pred1($193));
            };
        }());
    };
};
var $f935a9866e211c00$export$556edd6c9fb1e655 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $194 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($195) {
                return $194(succ1($195));
            };
        }());
    };
};
var $f935a9866e211c00$export$9263b51426343c61 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        return function(i$prime) {
            var go = function($copy_i) {
                return function($copy_x) {
                    var $tco_var_i = $copy_i;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(i, x) {
                        var $168 = i === 0;
                        if ($168) {
                            $tco_done = true;
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(x);
                        }
                        var v = succ1(x);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_i = i - 1 | 0;
                            $copy_x = v.value0;
                            return;
                        }
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        }
                        throw new Error("Failed pattern match at Data.Enum (line 296, column 12 - line 298, column 33): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                    return $tco_result;
                };
            };
            var $171 = i$prime < 0;
            if ($171) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return go(i$prime)(bottom2);
        };
    };
};
var $f935a9866e211c00$export$11e799785deb08e4 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) + 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$dc42af8461b24233 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) - 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$21fa49008ecbb00a = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var go = function($copy_i) {
        return function($copy_x) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, x) {
                var v = pred1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_i = i + 1 | 0;
                    $copy_x = v.value0;
                    return;
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return i;
                }
                throw new Error("Failed pattern match at Data.Enum (line 309, column 5 - line 311, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
            return $tco_result;
        };
    };
    return go(0);
};
var $f935a9866e211c00$export$18eeb03d5b80a339 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        var go = function($copy_i) {
            return function($copy_x) {
                var $tco_var_i = $copy_i;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(i, x) {
                    var v = succ1(x);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_i = i + 1 | 0;
                        $copy_x = v.value0;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return i;
                    }
                    throw new Error("Failed pattern match at Data.Enum (line 276, column 5 - line 278, column 19): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                return $tco_result;
            };
        };
        return go(1)(bottom2);
    };
};
var $f935a9866e211c00$var$charToEnum = function(v) {
    if (v >= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) && v <= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1)) return new $06733ae99ed4f534$export$8a67b48435b5d073($1cf1b1293ed20ecf$export$30216c0101da0ee0(v));
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $f935a9866e211c00$export$8ff57056df5ff58e = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $f935a9866e211c00$export$9e9949f96c411257 = function(dict) {
    return dict.cardinality;
};
var $f935a9866e211c00$export$670c12fc7b01c16 = {
    cardinality: 1,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(0),
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$48259b86288d7b58;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$c0a99362196d7617;
    }
};
var $f935a9866e211c00$export$fe7add2041208ec9 = {
    cardinality: 3,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 0;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 1;
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 2;
        throw new Error("Failed pattern match at Data.Enum (line 137, column 1 - line 145, column 18): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$2e0fd44408d4861;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$94be50e509bf721a;
    }
};
var $f935a9866e211c00$export$be1f07c3580164c = /* #__PURE__ */ function() {
    return {
        cardinality: $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1) - $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) | 0,
        toEnum: $f935a9866e211c00$var$charToEnum,
        fromEnum: $1cf1b1293ed20ecf$export$d90166409dd04e85,
        Bounded0: function() {
            return $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79;
        },
        Enum1: function() {
            return $f935a9866e211c00$export$8ff57056df5ff58e;
        }
    };
}();
var $f935a9866e211c00$export$3d0fa7de09d15272 = {
    cardinality: 2,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Enum (line 118, column 1 - line 124, column 20): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$b6c012947af8ebbc;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$6670eb63482acbe8;
    }
};






// Generated by purs version 0.15.15


var $0a45d905703115c9$export$fadaed88e803a5ce = /* #__PURE__ */ function() {
    function Unspecified() {}
    Unspecified.value = new Unspecified();
    return Unspecified;
}();
var $0a45d905703115c9$export$ad3bd6e4e1ec5d06 = /* #__PURE__ */ function() {
    function Maybe() {}
    Maybe.value = new Maybe();
    return Maybe;
}();
var $0a45d905703115c9$export$1fa2c133480c0d67 = /* #__PURE__ */ function() {
    function Probably() {}
    Probably.value = new Probably();
    return Probably;
}();
var $0a45d905703115c9$export$639d66421832ff11 = {
    show: function(v) {
        if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "Unspecified";
        if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "Maybe";
        if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "Probably";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $0a45d905703115c9$export$c2d084dc44961371 = function(v) {
    if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "";
    if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "maybe";
    if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "probably";
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 29, column 9 - line 32, column 25): " + [
        v.constructor.name
    ]);
};
var $0a45d905703115c9$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$fadaed88e803a5ce.value);
    if (v === "maybe") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$ad3bd6e4e1ec5d06.value);
    if (v === "probably") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$1fa2c133480c0d67.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $0a45d905703115c9$export$34fdecd70907479d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return true;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return true;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return true;
            return false;
        };
    }
};
var $0a45d905703115c9$export$dbc9bfdb74d43b21 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0a45d905703115c9$export$34fdecd70907479d;
    }
};


// Generated by purs version 0.15.15



var $c7b3b04bec1e8e92$export$1f74963c34e8bfec = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $c7b3b04bec1e8e92$export$5407f8fd4e62a93 = /* #__PURE__ */ function() {
    function Idle() {}
    Idle.value = new Idle();
    return Idle;
}();
var $c7b3b04bec1e8e92$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $c7b3b04bec1e8e92$export$9f99d34709abd9bc = /* #__PURE__ */ function() {
    function NoSource() {}
    NoSource.value = new NoSource();
    return NoSource;
}();
var $c7b3b04bec1e8e92$var$toEnumNetworkState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$5407f8fd4e62a93.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$669f6ea7d267feaf.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$9f99d34709abd9bc.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c7b3b04bec1e8e92$export$6dde42aa2c503bde = {
    show: function(v) {
        if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return "Empty";
        if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return "Idle";
        if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return "NoSource";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 30, column 1 - line 34, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $c7b3b04bec1e8e92$var$fromEnumNetworkState = function(v) {
    if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return 0;
    if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return 1;
    if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return 2;
    if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 47, column 3 - line 51, column 18): " + [
        v.constructor.name
    ]);
};
var $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return true;
            return false;
        };
    }
};
var $c7b3b04bec1e8e92$export$dd5f9f1c18c12839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5;
    }
};
var $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    Ord0: function() {
        return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
    }
};
var $c7b3b04bec1e8e92$export$63a4f766ab578d95 = /* #__PURE__ */ function() {
    return {
        bottom: $c7b3b04bec1e8e92$export$1f74963c34e8bfec.value,
        top: $c7b3b04bec1e8e92$export$9f99d34709abd9bc.value,
        Ord0: function() {
            return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
        }
    };
}();
var $c7b3b04bec1e8e92$export$19d342d9da2ba7a3 = {
    cardinality: 4,
    toEnum: $c7b3b04bec1e8e92$var$toEnumNetworkState,
    fromEnum: $c7b3b04bec1e8e92$var$fromEnumNetworkState,
    Bounded0: function() {
        return $c7b3b04bec1e8e92$export$63a4f766ab578d95;
    },
    Enum1: function() {
        return $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1;
    }
};


// Generated by purs version 0.15.15



var $e0710ab4ffdb9869$export$aeb73cf127af2fad = /* #__PURE__ */ function() {
    function HaveNothing() {}
    HaveNothing.value = new HaveNothing();
    return HaveNothing;
}();
var $e0710ab4ffdb9869$export$e96d91cd125cf5ba = /* #__PURE__ */ function() {
    function HaveMetadata() {}
    HaveMetadata.value = new HaveMetadata();
    return HaveMetadata;
}();
var $e0710ab4ffdb9869$export$c416983dd5609b6e = /* #__PURE__ */ function() {
    function HaveCurrentData() {}
    HaveCurrentData.value = new HaveCurrentData();
    return HaveCurrentData;
}();
var $e0710ab4ffdb9869$export$3c862393aec03c72 = /* #__PURE__ */ function() {
    function HaveFutureData() {}
    HaveFutureData.value = new HaveFutureData();
    return HaveFutureData;
}();
var $e0710ab4ffdb9869$export$c0fee25792a80051 = /* #__PURE__ */ function() {
    function HaveEnoughData() {}
    HaveEnoughData.value = new HaveEnoughData();
    return HaveEnoughData;
}();
var $e0710ab4ffdb9869$var$toEnumReadyState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$e96d91cd125cf5ba.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c416983dd5609b6e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$3c862393aec03c72.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c0fee25792a80051.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $e0710ab4ffdb9869$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return "HaveNothing";
        if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return "HaveMetadata";
        if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return "HaveCurrentData";
        if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return "HaveFutureData";
        if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return "HaveEnoughData";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 31, column 1 - line 36, column 41): " + [
            v.constructor.name
        ]);
    }
};
var $e0710ab4ffdb9869$var$fromEnumReadyState = function(v) {
    if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return 0;
    if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return 1;
    if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return 2;
    if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return 3;
    if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return 4;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 50, column 3 - line 55, column 24): " + [
        v.constructor.name
    ]);
};
var $e0710ab4ffdb9869$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return true;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return true;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return true;
            return false;
        };
    }
};
var $e0710ab4ffdb9869$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e0710ab4ffdb9869$export$c71e02dcc13f94a6;
    }
};
var $e0710ab4ffdb9869$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    Ord0: function() {
        return $e0710ab4ffdb9869$export$6557947d538c3b81;
    }
};
var $e0710ab4ffdb9869$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $e0710ab4ffdb9869$export$aeb73cf127af2fad.value,
        top: $e0710ab4ffdb9869$export$c0fee25792a80051.value,
        Ord0: function() {
            return $e0710ab4ffdb9869$export$6557947d538c3b81;
        }
    };
}();
var $e0710ab4ffdb9869$export$94a641e970e969f9 = {
    cardinality: 5,
    toEnum: $e0710ab4ffdb9869$var$toEnumReadyState,
    fromEnum: $e0710ab4ffdb9869$var$fromEnumReadyState,
    Bounded0: function() {
        return $e0710ab4ffdb9869$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $e0710ab4ffdb9869$export$f705a14e9e99c6f0;
    }
};



var $01a0e25b259ac8ae$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $01a0e25b259ac8ae$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e0710ab4ffdb9869$export$94a641e970e969f9);
var $01a0e25b259ac8ae$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($c7b3b04bec1e8e92$export$19d342d9da2ba7a3);
var $01a0e25b259ac8ae$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$1ae2b664eea77b7e = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
        return function($5) {
            return $4($01a0e25b259ac8ae$var$toEnum($5));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$4bf8a366db6a678b(el);
    });
};
var $01a0e25b259ac8ae$export$8ee3aa19592dce0d = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
        return function($7) {
            return $6($01a0e25b259ac8ae$var$toEnum1($7));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(el);
    });
};
var $01a0e25b259ac8ae$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$2b5874dc653b656c = function(ty) {
    return function(el) {
        return $01a0e25b259ac8ae$var$map(function() {
            var $8 = $06733ae99ed4f534$export$43db023a260c5e9f($0a45d905703115c9$export$fadaed88e803a5ce.value);
            return function($9) {
                return $8($0a45d905703115c9$export$98e6a39c04603d36($9));
            };
        }())(function() {
            return $67f0fc7db8c638cb$export$1a796126c2303a8(ty, el);
        });
    };
};


// Generated by purs version 0.15.15
function $d825508ebfe0ea30$export$a8ff84c12d48cfa6(meta) {
    return function() {
        return meta.name;
    };
}
function $d825508ebfe0ea30$export$6cf3d710d3a367e5(name) {
    return function(meta) {
        return function() {
            meta.name = name;
        };
    };
}
function $d825508ebfe0ea30$export$725a8790b31857c5(meta) {
    return function() {
        return meta.httpEquiv;
    };
}
function $d825508ebfe0ea30$export$253f18aa71ab8120(httpEquiv) {
    return function(meta) {
        return function() {
            meta.httpEquiv = httpEquiv;
        };
    };
}
function $d825508ebfe0ea30$export$a7db06668cad9adb(meta) {
    return function() {
        return meta.content;
    };
}
function $d825508ebfe0ea30$export$431313f2afd011e2(content) {
    return function(meta) {
        return function() {
            meta.content = content;
        };
    };
}




var $2f7018ceaced9755$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");


// Generated by purs version 0.15.15
function $4054571ff23c1117$export$2ab9a8f9f1186f14(meter) {
    return function() {
        return meter.value;
    };
}
function $4054571ff23c1117$export$80746c6bc6142fc8(value) {
    return function(meter) {
        return function() {
            meter.value = value;
        };
    };
}
function $4054571ff23c1117$export$96ec731ed4dcb222(meter) {
    return function() {
        return meter.min;
    };
}
function $4054571ff23c1117$export$46d199234e678744(min) {
    return function(meter) {
        return function() {
            meter.min = min;
        };
    };
}
function $4054571ff23c1117$export$8960430cfd85939f(meter) {
    return function() {
        return meter.max;
    };
}
function $4054571ff23c1117$export$b03015b7eb8a4a0d(max) {
    return function(meter) {
        return function() {
            meter.max = max;
        };
    };
}
function $4054571ff23c1117$export$e81601c80b4e876e(meter) {
    return function() {
        return meter.low;
    };
}
function $4054571ff23c1117$export$8b78ab0b9863288b(low) {
    return function(meter) {
        return function() {
            meter.low = low;
        };
    };
}
function $4054571ff23c1117$export$7cb505ef3217a5c4(meter) {
    return function() {
        return meter.high;
    };
}
function $4054571ff23c1117$export$f4a8cfe80ee4d275(high) {
    return function(meter) {
        return function() {
            meter.high = high;
        };
    };
}
function $4054571ff23c1117$export$49f2954c623150dd(meter) {
    return function() {
        return meter.optimum;
    };
}
function $4054571ff23c1117$export$47b0039e9987ccc5(optimum) {
    return function(meter) {
        return function() {
            meter.optimum = optimum;
        };
    };
}
function $4054571ff23c1117$export$a238cb463698c900(meter) {
    return function() {
        return meter.labels;
    };
}




var $82f5a476dc04f459$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");


// Generated by purs version 0.15.15
function $01bff2db061b962c$export$3035df57df42c31a(mod) {
    return function() {
        return mod.cite;
    };
}
function $01bff2db061b962c$export$86262a2b9f03fae3(cite) {
    return function(mod) {
        return function() {
            mod.cite = cite;
        };
    };
}
function $01bff2db061b962c$export$3a17bddce263fba0(mod) {
    return function() {
        return mod.dateTime;
    };
}
function $01bff2db061b962c$export$3a84b9eda98e95dc(dateTime) {
    return function(mod) {
        return function() {
            mod.dateTime = dateTime;
        };
    };
}




var $498acb025c9c8d86$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");


// Generated by purs version 0.15.15
function $d6916e47721f2e71$export$e2239770db970295(ol) {
    return function() {
        return ol.reversed;
    };
}
function $d6916e47721f2e71$export$9c908e987b6cb694(reversed) {
    return function(ol) {
        return function() {
            ol.reversed = reversed;
        };
    };
}
function $d6916e47721f2e71$export$b3571188c770cc5a(ol) {
    return function() {
        return ol.start;
    };
}
function $d6916e47721f2e71$export$b61b8b027b966010(start) {
    return function(ol) {
        return function() {
            ol.start = start;
        };
    };
}
function $d6916e47721f2e71$export$d4a6a4db5b31e621(ol) {
    return function() {
        return ol.type;
    };
}
function $d6916e47721f2e71$export$1bf7f05044e9c5cb(type) {
    return function(ol) {
        return function() {
            ol.type = type;
        };
    };
}




var $a24ac5c57b03a069$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");


// Generated by purs version 0.15.15
function $909c91e6774cc50c$export$70ac1efc5b13b551(object) {
    return function() {
        return object.data;
    };
}
function $909c91e6774cc50c$export$3a6802af14bf5fa6(data) {
    return function(object) {
        return function() {
            object.data = data;
        };
    };
}
function $909c91e6774cc50c$export$d4a6a4db5b31e621(object) {
    return function() {
        return object.type;
    };
}
function $909c91e6774cc50c$export$1bf7f05044e9c5cb(type) {
    return function(object) {
        return function() {
            object.type = type;
        };
    };
}
function $909c91e6774cc50c$export$dc0b74bdecf765a4(object) {
    return function() {
        return object.typeMustMatch;
    };
}
function $909c91e6774cc50c$export$a8ff84c12d48cfa6(object) {
    return function() {
        return object.name;
    };
}
function $909c91e6774cc50c$export$6cf3d710d3a367e5(name) {
    return function(object) {
        return function() {
            object.name = name;
        };
    };
}
function $909c91e6774cc50c$export$86f8f9f08863e403(object) {
    return function() {
        return object.useMap;
    };
}
function $909c91e6774cc50c$export$ab416bdbb887640e(useMap) {
    return function(object) {
        return function() {
            object.useMap = useMap;
        };
    };
}
function $909c91e6774cc50c$export$242c63e9758836c2(object) {
    return function() {
        return object.form;
    };
}
function $909c91e6774cc50c$export$7e3df82ee760448c(object) {
    return function() {
        return object.width;
    };
}
function $909c91e6774cc50c$export$67f48e0594af05d(width) {
    return function(object) {
        return function() {
            object.width = width;
        };
    };
}
function $909c91e6774cc50c$export$ac607276a8fe9f0a(object) {
    return function() {
        return object.height;
    };
}
function $909c91e6774cc50c$export$3f31360357be44e4(height) {
    return function(object) {
        return function() {
            object.height = height;
        };
    };
}
function $909c91e6774cc50c$export$a51825c89fe24f94(object) {
    return function() {
        return object.contentDocument;
    };
}
function $909c91e6774cc50c$export$5e55a9e709e8e020(object) {
    return function() {
        return object.willValidate;
    };
}
function $909c91e6774cc50c$export$1bdd3f9a89b22594(object) {
    return function() {
        return object.validity;
    };
}
function $909c91e6774cc50c$export$6ee4201e37a931e2(object) {
    return function() {
        return object.validationMessage;
    };
}
function $909c91e6774cc50c$export$50d70f8cedc54453(object) {
    return function() {
        return object.checkValidity();
    };
}
function $909c91e6774cc50c$export$b962d864c477cc49(object) {
    return function() {
        return object.reportValidity();
    };
}
function $909c91e6774cc50c$export$6f569cb704992105(value) {
    return function(object) {
        return function() {
            object.setCustomValidity(value);
        };
    };
}







var $c9b6ae535f32e637$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $c9b6ae535f32e637$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($909c91e6774cc50c$export$242c63e9758836c2($3));
    };
}();
var $c9b6ae535f32e637$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($909c91e6774cc50c$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.15
function $b75c0419f3dc5c84$export$683472f6198a076e(optgroup) {
    return function() {
        return optgroup.disabled;
    };
}
function $b75c0419f3dc5c84$export$4532d31cef66d703(disabled) {
    return function(optgroup) {
        return function() {
            optgroup.disabled = disabled;
        };
    };
}
function $b75c0419f3dc5c84$export$1237798dc640739a(optgroup) {
    return function() {
        return optgroup.label;
    };
}
function $b75c0419f3dc5c84$export$4f65e594f6031297(label) {
    return function(optgroup) {
        return function() {
            optgroup.label = label;
        };
    };
}




var $c89958870ff6a525$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");


// Generated by purs version 0.15.15
function $e580fc0cf2be85d0$export$683472f6198a076e(option) {
    return function() {
        return option.disabled;
    };
}
function $e580fc0cf2be85d0$export$4532d31cef66d703(disabled) {
    return function(option) {
        return function() {
            option.disabled = disabled;
        };
    };
}
function $e580fc0cf2be85d0$export$242c63e9758836c2(option) {
    return function() {
        return option.form;
    };
}
function $e580fc0cf2be85d0$export$1237798dc640739a(option) {
    return function() {
        return option.label;
    };
}
function $e580fc0cf2be85d0$export$4f65e594f6031297(label) {
    return function(option) {
        return function() {
            option.label = label;
        };
    };
}
function $e580fc0cf2be85d0$export$63db087985f790e3(option) {
    return function() {
        return option.defaultSelected;
    };
}
function $e580fc0cf2be85d0$export$83d19b461d3b2ee7(defaultSelected) {
    return function(option) {
        return function() {
            option.defaultSelected = defaultSelected;
        };
    };
}
function $e580fc0cf2be85d0$export$d90250155de6d7e7(option) {
    return function() {
        return option.selected;
    };
}
function $e580fc0cf2be85d0$export$5a4818cec1656a71(selected) {
    return function(option) {
        return function() {
            option.selected = selected;
        };
    };
}
function $e580fc0cf2be85d0$export$2ab9a8f9f1186f14(option) {
    return function() {
        return option.value;
    };
}
function $e580fc0cf2be85d0$export$80746c6bc6142fc8(value) {
    return function(option) {
        return function() {
            option.value = value;
        };
    };
}
function $e580fc0cf2be85d0$export$6f093cfa640b7166(option) {
    return function() {
        return option.text;
    };
}
function $e580fc0cf2be85d0$export$cbe0d99836e1498f(text) {
    return function(option) {
        return function() {
            option.text = text;
        };
    };
}
function $e580fc0cf2be85d0$export$b610b8812bbcded9(option) {
    return function() {
        return option.index;
    };
}







var $18ef343036740bd3$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($e580fc0cf2be85d0$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $9bed875784302b3c$export$242c63e9758836c2(output) {
    return function() {
        return output.form;
    };
}
function $9bed875784302b3c$export$a8ff84c12d48cfa6(output) {
    return function() {
        return output.name;
    };
}
function $9bed875784302b3c$export$6cf3d710d3a367e5(name) {
    return function(output) {
        return function() {
            output.name = name;
        };
    };
}
function $9bed875784302b3c$export$d4a6a4db5b31e621(output) {
    return function() {
        return output.type;
    };
}
function $9bed875784302b3c$export$1a01ae0705bafd37(output) {
    return function() {
        return output.defaultValue;
    };
}
function $9bed875784302b3c$export$d8becbd7468e206f(defaultValue) {
    return function(output) {
        return function() {
            output.defaultValue = defaultValue;
        };
    };
}
function $9bed875784302b3c$export$2ab9a8f9f1186f14(output) {
    return function() {
        return output.value;
    };
}
function $9bed875784302b3c$export$80746c6bc6142fc8(value) {
    return function(output) {
        return function() {
            output.value = value;
        };
    };
}
function $9bed875784302b3c$export$5e55a9e709e8e020(output) {
    return function() {
        return output.willValidate;
    };
}
function $9bed875784302b3c$export$1bdd3f9a89b22594(output) {
    return function() {
        return output.validity;
    };
}
function $9bed875784302b3c$export$6ee4201e37a931e2(output) {
    return function() {
        return output.validationMessage;
    };
}
function $9bed875784302b3c$export$50d70f8cedc54453(output) {
    return function() {
        return output.checkValidity();
    };
}
function $9bed875784302b3c$export$b962d864c477cc49(output) {
    return function() {
        return output.reportValidity();
    };
}
function $9bed875784302b3c$export$6f569cb704992105(value) {
    return function(output) {
        return function() {
            output.setCustomValidity(value);
        };
    };
}
function $9bed875784302b3c$export$a238cb463698c900(output) {
    return function() {
        return output.labels;
    };
}







var $77afbd0210834ce4$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9bed875784302b3c$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15


var $caf6f82488ae8096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");


// Generated by purs version 0.15.15
function $1c5afef61dd21eb4$export$a8ff84c12d48cfa6(param) {
    return function() {
        return param.name;
    };
}
function $1c5afef61dd21eb4$export$6cf3d710d3a367e5(name) {
    return function(param) {
        return function() {
            param.name = name;
        };
    };
}
function $1c5afef61dd21eb4$export$2ab9a8f9f1186f14(param) {
    return function() {
        return param.value;
    };
}
function $1c5afef61dd21eb4$export$80746c6bc6142fc8(value) {
    return function(param) {
        return function() {
            param.value = value;
        };
    };
}




var $f98a066659a15f53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");


// Generated by purs version 0.15.15


var $84ac7e6146bd7613$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");


// Generated by purs version 0.15.15
function $c65b15421363cde9$export$2ab9a8f9f1186f14(progress) {
    return function() {
        return progress.value;
    };
}
function $c65b15421363cde9$export$80746c6bc6142fc8(value) {
    return function(progress) {
        return function() {
            progress.value = value;
        };
    };
}
function $c65b15421363cde9$export$8960430cfd85939f(progress) {
    return function() {
        return progress.max;
    };
}
function $c65b15421363cde9$export$b03015b7eb8a4a0d(max) {
    return function(progress) {
        return function() {
            progress.max = max;
        };
    };
}
function $c65b15421363cde9$export$5880b8b5730aff45(progress) {
    return function() {
        return progress.position;
    };
}
function $c65b15421363cde9$export$a238cb463698c900(progress) {
    return function() {
        return progress.labels;
    };
}




var $dabdbb18392010de$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");


// Generated by purs version 0.15.15
function $1e6d0af303f227ec$export$3035df57df42c31a(quote) {
    return function() {
        return quote.cite;
    };
}
function $1e6d0af303f227ec$export$86262a2b9f03fae3(cite) {
    return function(quote) {
        return function() {
            quote.cite = cite;
        };
    };
}




var $5d0c2c5071b861d1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");


// Generated by purs version 0.15.15
function $4bf6127f0f22b047$export$2e40c9e35e9506f4(script) {
    return function() {
        return script.src;
    };
}
function $4bf6127f0f22b047$export$5771e3a4c80da7df(src) {
    return function(script) {
        return function() {
            script.src = src;
        };
    };
}
function $4bf6127f0f22b047$export$d4a6a4db5b31e621(script) {
    return function() {
        return script.type;
    };
}
function $4bf6127f0f22b047$export$1bf7f05044e9c5cb(type) {
    return function(script) {
        return function() {
            script.type = type;
        };
    };
}
function $4bf6127f0f22b047$export$e4c823724462c3fd(script) {
    return function() {
        return script.charset;
    };
}
function $4bf6127f0f22b047$export$61ed102e375c8bae(charset) {
    return function(script) {
        return function() {
            script.charset = charset;
        };
    };
}
function $4bf6127f0f22b047$export$12af436354f1a4f7(script) {
    return function() {
        return script.async;
    };
}
function $4bf6127f0f22b047$export$8ed1e1e4b75b53c6(async) {
    return function(script) {
        return function() {
            script.async = async;
        };
    };
}
function $4bf6127f0f22b047$export$260e5c0943f31606(script) {
    return function() {
        return script.defer;
    };
}
function $4bf6127f0f22b047$export$d440c7f1383ddd12(defer) {
    return function(script) {
        return function() {
            script.defer = defer;
        };
    };
}
function $4bf6127f0f22b047$export$c47cb7c63271266e(script) {
    return function() {
        return script.crossOrigin;
    };
}
function $4bf6127f0f22b047$export$e7fd69f64f92856(crossOrigin) {
    return function(script) {
        return function() {
            script.crossOrigin = crossOrigin;
        };
    };
}
function $4bf6127f0f22b047$export$6f093cfa640b7166(script) {
    return function() {
        return script.text;
    };
}
function $4bf6127f0f22b047$export$cbe0d99836e1498f(text) {
    return function(script) {
        return function() {
            script.text = text;
        };
    };
}




var $1143394fd0c1cb41$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");


// Generated by purs version 0.15.15
function $4f460bff72193069$export$4c47992fc278c9a0(select) {
    return function() {
        return select.autofocus;
    };
}
function $4f460bff72193069$export$db2bbdcbda3d335e(autofocus) {
    return function(select) {
        return function() {
            select.autofocus = autofocus;
        };
    };
}
function $4f460bff72193069$export$683472f6198a076e(select) {
    return function() {
        return select.disabled;
    };
}
function $4f460bff72193069$export$4532d31cef66d703(disabled) {
    return function(select) {
        return function() {
            select.disabled = disabled;
        };
    };
}
function $4f460bff72193069$export$939ddaa3205df08e(select) {
    return function() {
        return select.multiple;
    };
}
function $4f460bff72193069$export$be7c7381b31f2269(multiple) {
    return function(select) {
        return function() {
            select.multiple = multiple;
        };
    };
}
function $4f460bff72193069$export$242c63e9758836c2(select) {
    return function() {
        return select.form;
    };
}
function $4f460bff72193069$export$a8ff84c12d48cfa6(select) {
    return function() {
        return select.name;
    };
}
function $4f460bff72193069$export$6cf3d710d3a367e5(name) {
    return function(select) {
        return function() {
            select.name = name;
        };
    };
}
function $4f460bff72193069$export$a7a0278c004aac3f(select) {
    return function() {
        return select.required;
    };
}
function $4f460bff72193069$export$47f9362469f346c4(required) {
    return function(select) {
        return function() {
            select.required = required;
        };
    };
}
function $4f460bff72193069$export$346677f925de839c(select) {
    return function() {
        return select.size;
    };
}
function $4f460bff72193069$export$1c70a6cc12bc0366(size) {
    return function(select) {
        return function() {
            select.size = size;
        };
    };
}
function $4f460bff72193069$export$d4a6a4db5b31e621(select) {
    return function() {
        return select.type;
    };
}
function $4f460bff72193069$export$f24224f1c91d8156(select) {
    return function() {
        return select.length;
    };
}
function $4f460bff72193069$export$e37a2cb6f0a9cac9(length) {
    return function(select) {
        return function() {
            select.length = length;
        };
    };
}
function $4f460bff72193069$export$b0ea99e7ae5aed6c(select) {
    return function() {
        return select.selectedOptions;
    };
}
function $4f460bff72193069$export$9ea87e299ff6a368(select) {
    return function() {
        return select.selectedIndex;
    };
}
function $4f460bff72193069$export$940820044e1b4923(selectedIndex) {
    return function(select) {
        return function() {
            select.selectedIndex = selectedIndex;
        };
    };
}
function $4f460bff72193069$export$2ab9a8f9f1186f14(select) {
    return function() {
        return select.value;
    };
}
function $4f460bff72193069$export$80746c6bc6142fc8(value) {
    return function(select) {
        return function() {
            select.value = value;
        };
    };
}
function $4f460bff72193069$export$5e55a9e709e8e020(select) {
    return function() {
        return select.willValidate;
    };
}
function $4f460bff72193069$export$1bdd3f9a89b22594(select) {
    return function() {
        return select.validity;
    };
}
function $4f460bff72193069$export$6ee4201e37a931e2(select) {
    return function() {
        return select.validationMessage;
    };
}
function $4f460bff72193069$export$50d70f8cedc54453(select) {
    return function() {
        return select.checkValidity();
    };
}
function $4f460bff72193069$export$b962d864c477cc49(select) {
    return function() {
        return select.reportValidity();
    };
}
function $4f460bff72193069$export$6f569cb704992105(value) {
    return function(select) {
        return function() {
            select.setCustomValidity(value);
        };
    };
}
function $4f460bff72193069$export$a238cb463698c900(select) {
    return function() {
        return select.labels;
    };
}







var $a54214b82be35498$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($4f460bff72193069$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $30fdbf6c46de325a$export$2e40c9e35e9506f4(source) {
    return function() {
        return source.src;
    };
}
function $30fdbf6c46de325a$export$5771e3a4c80da7df(src) {
    return function(source) {
        return function() {
            source.src = src;
        };
    };
}
function $30fdbf6c46de325a$export$d4a6a4db5b31e621(source) {
    return function() {
        return source.type;
    };
}
function $30fdbf6c46de325a$export$1bf7f05044e9c5cb(type) {
    return function(source) {
        return function() {
            source.type = type;
        };
    };
}
function $30fdbf6c46de325a$export$987d49ffe1b0900f(source) {
    return function() {
        return source.media;
    };
}
function $30fdbf6c46de325a$export$5c1855deea651e41(media) {
    return function(source) {
        return function() {
            source.media = media;
        };
    };
}




var $e84e4cab6b69fa3a$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");


// Generated by purs version 0.15.15


var $1258819ad56163ca$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");


// Generated by purs version 0.15.15
function $3945cfcc1dd51d92$export$987d49ffe1b0900f(style) {
    return function() {
        return style.media;
    };
}
function $3945cfcc1dd51d92$export$5c1855deea651e41(media) {
    return function(style) {
        return function() {
            style.media = media;
        };
    };
}
function $3945cfcc1dd51d92$export$d4a6a4db5b31e621(style) {
    return function() {
        return style.type;
    };
}
function $3945cfcc1dd51d92$export$1bf7f05044e9c5cb(type) {
    return function(style) {
        return function() {
            style.type = type;
        };
    };
}




var $c2a5f1d09180ba9d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");


// Generated by purs version 0.15.15


var $4d7ca2355751c293$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");


// Generated by purs version 0.15.15
function $dd45d132df79042b$export$47be69ffacd0da98(cell) {
    return function() {
        return cell.colSpan;
    };
}
function $dd45d132df79042b$export$41feea65f12f6ad6(colSpan) {
    return function(cell) {
        return function() {
            cell.colSpan = colSpan;
        };
    };
}
function $dd45d132df79042b$export$a5ce0649174d616e(cell) {
    return function() {
        return cell.rowSpan;
    };
}
function $dd45d132df79042b$export$1f37716400d14942(rowSpan) {
    return function(cell) {
        return function() {
            cell.rowSpan = rowSpan;
        };
    };
}
function $dd45d132df79042b$export$b507ffb2fd978043(cell) {
    return function() {
        return cell.cellIndex;
    };
}




var $ca40d224410598c5$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");


// Generated by purs version 0.15.15
function $34ac56698048b1d0$export$afc1bfabebaf28a2(col) {
    return function() {
        return col.span;
    };
}
function $34ac56698048b1d0$export$8ab2f2e6ee8ed0a8(span) {
    return function(col) {
        return function() {
            col.span = span;
        };
    };
}




var $298b737852233db7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");


// Generated by purs version 0.15.15


var $90a91012d61f1bcd$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");


// Generated by purs version 0.15.15
function $48dd68dffe0e6e15$export$b815d8b2ae8b8a8f(table) {
    return function() {
        return table.caption;
    };
}
function $48dd68dffe0e6e15$export$c1cd099bccef98fe(caption) {
    return function(table) {
        return function() {
            table.caption = caption;
        };
    };
}
function $48dd68dffe0e6e15$export$690474d079e8aee0(table) {
    return function() {
        return table.createCaption();
    };
}
function $48dd68dffe0e6e15$export$2f169497140e8e8c(table) {
    return function() {
        table.deleteCaption();
    };
}
function $48dd68dffe0e6e15$export$75d2083daf0d4c8(table) {
    return function() {
        return table.tHead;
    };
}
function $48dd68dffe0e6e15$export$accedb93377ebcb2(tHead) {
    return function(table) {
        return function() {
            table.tHead = tHead;
        };
    };
}
function $48dd68dffe0e6e15$export$8e9dedfded1540ee(table) {
    return function() {
        return table.createTHead();
    };
}
function $48dd68dffe0e6e15$export$c28532ed8fc4a976(table) {
    return function() {
        table.deleteTHead();
    };
}
function $48dd68dffe0e6e15$export$6c9b4fbde50fbc0f(table) {
    return function() {
        return table.tFoot;
    };
}
function $48dd68dffe0e6e15$export$10a8938b95fbdb4(tFoot) {
    return function(table) {
        return function() {
            table.tFoot = tFoot;
        };
    };
}
function $48dd68dffe0e6e15$export$ab9f248e0049bb9d(table) {
    return function() {
        return table.createTFoot();
    };
}
function $48dd68dffe0e6e15$export$3c3cb2a6af70fe52(table) {
    return function() {
        table.deleteTFoot();
    };
}
function $48dd68dffe0e6e15$export$c63586cd99d53eee(table) {
    return function() {
        return table.tBodies;
    };
}
function $48dd68dffe0e6e15$export$76a5bd1e5d516e91(table) {
    return function() {
        return table.createTBody();
    };
}
function $48dd68dffe0e6e15$export$2dd197b55cf13440(table) {
    return function() {
        return table.rows;
    };
}
function $48dd68dffe0e6e15$export$281b3c86eeab738f(index) {
    return function(table) {
        return function() {
            return table.insertRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$2ef39e5ffdaff9ed(index) {
    return function(table) {
        return function() {
            table.deleteRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$1edee58a52776cd9(table) {
    return function() {
        return table.border;
    };
}
function $48dd68dffe0e6e15$export$df6de19f3e6baa52(border) {
    return function(table) {
        return function() {
            table.border = border;
        };
    };
}







var $00106f41ab48b85e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $00106f41ab48b85e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ffb9307dee41683 = /* #__PURE__ */ function() {
    var $3 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($4) {
        return $3($48dd68dffe0e6e15$export$75d2083daf0d4c8($4));
    };
}();
var $00106f41ab48b85e$export$4ce044d081650b4 = /* #__PURE__ */ function() {
    var $5 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($48dd68dffe0e6e15$export$6c9b4fbde50fbc0f($6));
    };
}();
var $00106f41ab48b85e$export$73c0abfa2c0e52e4 = function($7) {
    return $48dd68dffe0e6e15$export$accedb93377ebcb2($0a5aaf95f168428e$export$b187f57ee1822bc5($7));
};
var $00106f41ab48b85e$export$1350b3df0623f8d7 = function($8) {
    return $48dd68dffe0e6e15$export$10a8938b95fbdb4($0a5aaf95f168428e$export$b187f57ee1822bc5($8));
};
var $00106f41ab48b85e$export$c972b85f531b9f41 = function($9) {
    return $48dd68dffe0e6e15$export$c1cd099bccef98fe($0a5aaf95f168428e$export$b187f57ee1822bc5($9));
};
var $00106f41ab48b85e$export$6f91cb21ef21b608 = $48dd68dffe0e6e15$export$281b3c86eeab738f;
var $00106f41ab48b85e$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $00106f41ab48b85e$export$6f91cb21ef21b608(-1);
}();
var $00106f41ab48b85e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$8e3c2dfdc4f0453d = /* #__PURE__ */ function() {
    var $10 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($48dd68dffe0e6e15$export$b815d8b2ae8b8a8f($11));
    };
}();


// Generated by purs version 0.15.15
function $d0f5df104e75ba24$export$5cff813ca8e50db9(cell) {
    return function() {
        return cell.scope;
    };
}
function $d0f5df104e75ba24$export$d9e5239df8f952de(scope) {
    return function(cell) {
        return function() {
            cell.scope = scope;
        };
    };
}
function $d0f5df104e75ba24$export$2bcb785951133fe5(cell) {
    return function() {
        return cell.abbr;
    };
}
function $d0f5df104e75ba24$export$4b75111ed99261c8(abbr) {
    return function(cell) {
        return function() {
            cell.abbr = abbr;
        };
    };
}




var $51e7753cdccb5d79$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");


// Generated by purs version 0.15.15
function $e090f42f468fa271$export$f6e5b2c929a2f19d(row) {
    return function() {
        return row.rowIndex;
    };
}
function $e090f42f468fa271$export$11d8b50a98496a38(row) {
    return function() {
        return row.sectionRowIndex;
    };
}
function $e090f42f468fa271$export$57ba6370ea0e47f8(row) {
    return function() {
        return row.cells;
    };
}
function $e090f42f468fa271$export$96a7dd0d30a5e7fe(index) {
    return function(row) {
        return function() {
            return row.insertCell(index);
        };
    };
}
function $e090f42f468fa271$export$6e37d353cc5629c9(index) {
    return function(row) {
        return function() {
            row.deleteCell(index);
        };
    };
}




var $633aaa19d7d1d3a1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$27b66c5ce67ee025 = $e090f42f468fa271$export$96a7dd0d30a5e7fe;
var $633aaa19d7d1d3a1$export$51965e0a3b80eb5c = /* #__PURE__ */ function() {
    return $633aaa19d7d1d3a1$export$27b66c5ce67ee025(-1);
}();
var $633aaa19d7d1d3a1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");


// Generated by purs version 0.15.15
function $dba0680894fb8dd0$export$2dd197b55cf13440(section) {
    return function() {
        return section.rows;
    };
}
function $dba0680894fb8dd0$export$281b3c86eeab738f(index) {
    return function(section) {
        return function() {
            return section.insertRow(index);
        };
    };
}
function $dba0680894fb8dd0$export$2ef39e5ffdaff9ed(index) {
    return function(section) {
        return function() {
            section.deleteRow(index);
        };
    };
}




var $53881fd03908fa53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$6f91cb21ef21b608 = $dba0680894fb8dd0$export$281b3c86eeab738f;
var $53881fd03908fa53$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $53881fd03908fa53$export$6f91cb21ef21b608(-1);
}();
var $53881fd03908fa53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");


// Generated by purs version 0.15.15
function $1b3a563b18f6151d$export$a7db06668cad9adb(template) {
    return function() {
        return template.content;
    };
}




var $fee13735939d9bee$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");


// Generated by purs version 0.15.15
function $28c3e08a1c48c9af$export$485ded5f26ebe08d(textarea) {
    return function() {
        return textarea.autocomplete;
    };
}
function $28c3e08a1c48c9af$export$5fb7c729919301a5(autocomplete) {
    return function(textarea) {
        return function() {
            textarea.autocomplete = autocomplete;
        };
    };
}
function $28c3e08a1c48c9af$export$4c47992fc278c9a0(textarea) {
    return function() {
        return textarea.autofocus;
    };
}
function $28c3e08a1c48c9af$export$db2bbdcbda3d335e(autofocus) {
    return function(textarea) {
        return function() {
            textarea.autofocus = autofocus;
        };
    };
}
function $28c3e08a1c48c9af$export$1eebcb1e706ab348(textarea) {
    return function() {
        return textarea.cols;
    };
}
function $28c3e08a1c48c9af$export$3df203352cd8517(cols) {
    return function(textarea) {
        return function() {
            textarea.cols = cols;
        };
    };
}
function $28c3e08a1c48c9af$export$9ebb36ddc946da55(textarea) {
    return function() {
        return textarea.dirName;
    };
}
function $28c3e08a1c48c9af$export$e2460e55089b163d(dirName) {
    return function(textarea) {
        return function() {
            textarea.dirName = dirName;
        };
    };
}
function $28c3e08a1c48c9af$export$683472f6198a076e(textarea) {
    return function() {
        return textarea.disabled;
    };
}
function $28c3e08a1c48c9af$export$4532d31cef66d703(disabled) {
    return function(textarea) {
        return function() {
            textarea.disabled = disabled;
        };
    };
}
function $28c3e08a1c48c9af$export$242c63e9758836c2(textarea) {
    return function() {
        return textarea.form;
    };
}
function $28c3e08a1c48c9af$export$c9f461152c658a8b(textarea) {
    return function() {
        return textarea.maxLength;
    };
}
function $28c3e08a1c48c9af$export$45077a575ddd961f(maxLength) {
    return function(textarea) {
        return function() {
            textarea.maxLength = maxLength;
        };
    };
}
function $28c3e08a1c48c9af$export$8fe860a115a1e636(textarea) {
    return function() {
        return textarea.minLength;
    };
}
function $28c3e08a1c48c9af$export$2b867239766ba1e3(minLength) {
    return function(textarea) {
        return function() {
            textarea.minLength = minLength;
        };
    };
}
function $28c3e08a1c48c9af$export$a8ff84c12d48cfa6(textarea) {
    return function() {
        return textarea.name;
    };
}
function $28c3e08a1c48c9af$export$6cf3d710d3a367e5(name) {
    return function(textarea) {
        return function() {
            textarea.name = name;
        };
    };
}
function $28c3e08a1c48c9af$export$c7187bbd1a7a9244(textarea) {
    return function() {
        return textarea.placeholder;
    };
}
function $28c3e08a1c48c9af$export$645bf5697adfa088(placeholder) {
    return function(textarea) {
        return function() {
            textarea.placeholder = placeholder;
        };
    };
}
function $28c3e08a1c48c9af$export$b2cbc93d4da94977(textarea) {
    return function() {
        return textarea.readOnly;
    };
}
function $28c3e08a1c48c9af$export$62311ce54ddfc862(readOnly) {
    return function(textarea) {
        return function() {
            textarea.readOnly = readOnly;
        };
    };
}
function $28c3e08a1c48c9af$export$a7a0278c004aac3f(textarea) {
    return function() {
        return textarea.required;
    };
}
function $28c3e08a1c48c9af$export$47f9362469f346c4(required) {
    return function(textarea) {
        return function() {
            textarea.required = required;
        };
    };
}
function $28c3e08a1c48c9af$export$2dd197b55cf13440(textarea) {
    return function() {
        return textarea.rows;
    };
}
function $28c3e08a1c48c9af$export$f2d998961118057a(rows) {
    return function(textarea) {
        return function() {
            textarea.rows = rows;
        };
    };
}
function $28c3e08a1c48c9af$export$4997ffc0176396a6(textarea) {
    return function() {
        return textarea.wrap;
    };
}
function $28c3e08a1c48c9af$export$696447b714acda6d(wrap) {
    return function(textarea) {
        return function() {
            textarea.wrap = wrap;
        };
    };
}
function $28c3e08a1c48c9af$export$d4a6a4db5b31e621(textarea) {
    return function() {
        return textarea.type;
    };
}
function $28c3e08a1c48c9af$export$1a01ae0705bafd37(textarea) {
    return function() {
        return textarea.defaultValue;
    };
}
function $28c3e08a1c48c9af$export$d8becbd7468e206f(defaultValue) {
    return function(textarea) {
        return function() {
            textarea.defaultValue = defaultValue;
        };
    };
}
function $28c3e08a1c48c9af$export$2ab9a8f9f1186f14(textarea) {
    return function() {
        return textarea.value;
    };
}
function $28c3e08a1c48c9af$export$80746c6bc6142fc8(value) {
    return function(textarea) {
        return function() {
            textarea.value = value;
        };
    };
}
function $28c3e08a1c48c9af$export$6f846043e306f02c(textarea) {
    return function() {
        return textarea.textLength;
    };
}
function $28c3e08a1c48c9af$export$5e55a9e709e8e020(textarea) {
    return function() {
        return textarea.willValidate;
    };
}
function $28c3e08a1c48c9af$export$1bdd3f9a89b22594(textarea) {
    return function() {
        return textarea.validity;
    };
}
function $28c3e08a1c48c9af$export$6ee4201e37a931e2(textarea) {
    return function() {
        return textarea.validationMessage;
    };
}
function $28c3e08a1c48c9af$export$50d70f8cedc54453(textarea) {
    return function() {
        return textarea.checkValidity();
    };
}
function $28c3e08a1c48c9af$export$b962d864c477cc49(textarea) {
    return function() {
        return textarea.reportValidity();
    };
}
function $28c3e08a1c48c9af$export$6f569cb704992105(value) {
    return function(textarea) {
        return function() {
            textarea.setCustomValidity(value);
        };
    };
}
function $28c3e08a1c48c9af$export$a238cb463698c900(textarea) {
    return function() {
        return textarea.labels;
    };
}
function $28c3e08a1c48c9af$export$2e6c959c16ff56b8(textarea) {
    return function() {
        textarea.select();
    };
}
function $28c3e08a1c48c9af$export$5e2f617ae845fb63(textarea) {
    return function() {
        return textarea.selectionStart;
    };
}
function $28c3e08a1c48c9af$export$47b9c21811f199bd(selectionStart) {
    return function(textarea) {
        return function() {
            textarea.selectionStart = selectionStart;
        };
    };
}
function $28c3e08a1c48c9af$export$1028be563f1155b2(textarea) {
    return function() {
        return textarea.selectionEnd;
    };
}
function $28c3e08a1c48c9af$export$15d012c6be3c352(selectionEnd) {
    return function(textarea) {
        return function() {
            textarea.selectionEnd = selectionEnd;
        };
    };
}
function $28c3e08a1c48c9af$export$b4e8aad052258154(textarea) {
    return function() {
        return textarea.selectionDirection;
    };
}
function $28c3e08a1c48c9af$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(textarea) {
        return function() {
            textarea.selectionDirection = selectionDirection;
        };
    };
}
function $28c3e08a1c48c9af$export$2add2a46d1c1d557(replacement) {
    return function(textarea) {
        return function() {
            textarea.setRangeText(replacement);
        };
    };
}
function $28c3e08a1c48c9af$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $28c3e08a1c48c9af$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(textarea) {
                return function() {
                    textarea.setSelectionRange(start, end, direction);
                };
            };
        };
    };
}








var $514f398dc6a7828b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $28c3e08a1c48c9af$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $514f398dc6a7828b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($28c3e08a1c48c9af$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.15
function $68df52b2f5f30ba7$export$3a17bddce263fba0(time) {
    return function() {
        return time.dateTime;
    };
}
function $68df52b2f5f30ba7$export$3a84b9eda98e95dc(dateTime) {
    return function(time) {
        return function() {
            time.dateTime = dateTime;
        };
    };
}




var $f1291cf94838d52b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");


// Generated by purs version 0.15.15
function $a7993cc78206c04b$export$6f093cfa640b7166(title) {
    return function() {
        return title.text;
    };
}
function $a7993cc78206c04b$export$cbe0d99836e1498f(text) {
    return function(title) {
        return function() {
            title.text = text;
        };
    };
}




var $71325cd3e1c1cf85$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");


// Generated by purs version 0.15.15
function $2f0649a862aa117b$export$78062f36b16ed2f8(track) {
    return function() {
        return track.kind;
    };
}
function $2f0649a862aa117b$export$8f76af250dd43cf6(kind) {
    return function(track) {
        return function() {
            track.kind = kind;
        };
    };
}
function $2f0649a862aa117b$export$2e40c9e35e9506f4(track) {
    return function() {
        return track.src;
    };
}
function $2f0649a862aa117b$export$5771e3a4c80da7df(src) {
    return function(track) {
        return function() {
            track.src = src;
        };
    };
}
function $2f0649a862aa117b$export$4be5a609db5ad788(track) {
    return function() {
        return track.srclang;
    };
}
function $2f0649a862aa117b$export$5406412834bff708(srclang) {
    return function(track) {
        return function() {
            track.srclang = srclang;
        };
    };
}
function $2f0649a862aa117b$export$1237798dc640739a(track) {
    return function() {
        return track.label;
    };
}
function $2f0649a862aa117b$export$4f65e594f6031297(label) {
    return function(track) {
        return function() {
            track.label = label;
        };
    };
}
// ----------------------------------------------------------------------------
const $2f0649a862aa117b$export$2e2bcd8739ae039 = function(track) {
    return function() {
        return track["default"];
    };
};
function $2f0649a862aa117b$export$d590af038dd015bd(def) {
    return function(track) {
        return function() {
            track["default"] = def;
        };
    };
}
function $2f0649a862aa117b$export$4bf8a366db6a678b(track) {
    return track.readyState;
}







// Generated by purs version 0.15.15



var $436d616104359630$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $436d616104359630$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $436d616104359630$export$b6517d5bdd20170e = /* #__PURE__ */ function() {
    function Loaded() {}
    Loaded.value = new Loaded();
    return Loaded;
}();
var $436d616104359630$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $436d616104359630$export$dc807b9f83d61e2e = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$57ca7e07b341709d.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$669f6ea7d267feaf.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$b6517d5bdd20170e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$edf27be85e5f6da0.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $436d616104359630$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $436d616104359630$export$57ca7e07b341709d) return "None";
        if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return "Loaded";
        if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return "Error";
        throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 30, column 1 - line 34, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $436d616104359630$export$9974ae2c28acb3c9 = function(v) {
    if (v instanceof $436d616104359630$export$57ca7e07b341709d) return 0;
    if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return 1;
    if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return 2;
    if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 47, column 3 - line 51, column 15): " + [
        v.constructor.name
    ]);
};
var $436d616104359630$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return true;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return true;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return true;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $436d616104359630$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $436d616104359630$export$c71e02dcc13f94a6;
    }
};
var $436d616104359630$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    Ord0: function() {
        return $436d616104359630$export$6557947d538c3b81;
    }
};
var $436d616104359630$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $436d616104359630$export$57ca7e07b341709d.value,
        top: $436d616104359630$export$edf27be85e5f6da0.value,
        Ord0: function() {
            return $436d616104359630$export$6557947d538c3b81;
        }
    };
}();
var $436d616104359630$export$94a641e970e969f9 = {
    cardinality: 4,
    toEnum: $436d616104359630$export$dc807b9f83d61e2e,
    fromEnum: $436d616104359630$export$9974ae2c28acb3c9,
    Bounded0: function() {
        return $436d616104359630$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $436d616104359630$export$f705a14e9e99c6f0;
    }
};



var $057c37bcb2e4f7d0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $057c37bcb2e4f7d0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($436d616104359630$export$94a641e970e969f9);
var $057c37bcb2e4f7d0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$1ae2b664eea77b7e = function(el) {
    return $057c37bcb2e4f7d0$var$map(function() {
        var $3 = $06733ae99ed4f534$export$43db023a260c5e9f($436d616104359630$export$57ca7e07b341709d.value);
        return function($4) {
            return $3($057c37bcb2e4f7d0$var$toEnum($4));
        };
    }())(function() {
        return $2f0649a862aa117b$export$4bf8a366db6a678b(el);
    });
};
var $057c37bcb2e4f7d0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");


// Generated by purs version 0.15.15


var $de5b01932d221096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");


// Generated by purs version 0.15.15
// ----------------------------------------------------------------------------
function $61cfdbf50fc824d4$export$7e3df82ee760448c(video) {
    return function() {
        return video.width;
    };
}
function $61cfdbf50fc824d4$export$67f48e0594af05d(width) {
    return function(video) {
        return function() {
            video.width = width;
        };
    };
}
function $61cfdbf50fc824d4$export$ac607276a8fe9f0a(video) {
    return function() {
        return video.height;
    };
}
function $61cfdbf50fc824d4$export$3f31360357be44e4(height) {
    return function(video) {
        return function() {
            video.height = height;
        };
    };
}
function $61cfdbf50fc824d4$export$dbb4894ced044525(video) {
    return function() {
        return video.videoWidth;
    };
}
function $61cfdbf50fc824d4$export$848581bdb4a7943d(video) {
    return function() {
        return video.videoHeight;
    };
}
function $61cfdbf50fc824d4$export$b840e55573b2d2e7(video) {
    return function() {
        return video.poster;
    };
}
function $61cfdbf50fc824d4$export$2c8117e8f5cb8138(poster) {
    return function(video) {
        return function() {
            video.poster = poster;
        };
    };
}




var $7732702ec87f6f21$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");


// Generated by purs version 0.15.15
function $75f6ec27f640501f$export$7c341cb16fc91138(history) {
    return function() {
        return history.back();
    };
}
function $75f6ec27f640501f$export$174bb771924e7eb1(history) {
    return function() {
        return history.forward();
    };
}
function $75f6ec27f640501f$export$93bb224d05b3906d(delta) {
    return function(history) {
        return function() {
            return history.go(delta);
        };
    };
}
function $75f6ec27f640501f$export$ba0fd82af7b4fe6e(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.pushState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$e68dd4d2e7e08394(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.replaceState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$ca000e230c0caa3e(history) {
    return function() {
        return history.state;
    };
}



var $c4fd6deeadc2e277$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c4fd6deeadc2e277$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c4fd6deeadc2e277$export$61abde59b50deb8e = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$dd5ad0b65cf665da = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$1f333647865369bf = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$e587774857b65d31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$2cdd79be0aa3bb07 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$3c3105bc6097b846 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$214a01057915d716 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$dbc0939544a3624 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$214a01057915d716;
    }
};
var $c4fd6deeadc2e277$export$28be1498e824b653 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$7c3d39f0cf320c7b = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$28be1498e824b653;
    }
};
var $c4fd6deeadc2e277$export$3e1b8005eb6f3d68 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$4ef0c953a661f864 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare1(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$3e1b8005eb6f3d68;
    }
};


// Generated by purs version 0.15.15
function $f8ebc5adafdca7e8$export$d6af199866bfb566(location) {
    return function() {
        return location.hash;
    };
}
function $f8ebc5adafdca7e8$export$42c3f3255a992e7(hash) {
    return function(location) {
        return function() {
            location.hash = hash;
        };
    };
}
function $f8ebc5adafdca7e8$export$5e032988b71f6158(location) {
    return function() {
        return location.host;
    };
}
function $f8ebc5adafdca7e8$export$db0724f89fd14c87(host) {
    return function(location) {
        return function() {
            location.host = host;
        };
    };
}
function $f8ebc5adafdca7e8$export$640106f6dc7d2706(location) {
    return function() {
        return location.hostname;
    };
}
function $f8ebc5adafdca7e8$export$d120c0a46ba2e633(hostname) {
    return function(location) {
        return function() {
            location.hostname = hostname;
        };
    };
}
function $f8ebc5adafdca7e8$export$8f51af5840e0602a(location) {
    return function() {
        return location.href;
    };
}
function $f8ebc5adafdca7e8$export$428f6e77b5a5a669(href) {
    return function(location) {
        return function() {
            location.href = href;
        };
    };
}
function $f8ebc5adafdca7e8$export$f710a83a91838a36(location) {
    return function() {
        return location.origin;
    };
}
function $f8ebc5adafdca7e8$export$717aaa4b4fe61ebd(origin) {
    return function(location) {
        return function() {
            location.origin = origin;
        };
    };
}
function $f8ebc5adafdca7e8$export$7333db99aa99d383(location) {
    return function() {
        return location.pathname;
    };
}
function $f8ebc5adafdca7e8$export$8c7da94d5c72705a(pathname) {
    return function(location) {
        return function() {
            location.pathname = pathname;
        };
    };
}
function $f8ebc5adafdca7e8$export$2433da7bd3cc7af7(location) {
    return function() {
        return location.port;
    };
}
function $f8ebc5adafdca7e8$export$b0effcd3879eb064(port) {
    return function(location) {
        return function() {
            location.port = port;
        };
    };
}
function $f8ebc5adafdca7e8$export$a51d6b395ff4c65a(location) {
    return function() {
        return location.protocol;
    };
}
function $f8ebc5adafdca7e8$export$caabdac475e4f216(protocol) {
    return function(location) {
        return function() {
            location.protocol = protocol;
        };
    };
}
function $f8ebc5adafdca7e8$export$d76128d007d19019(location) {
    return function() {
        return location.search;
    };
}
function $f8ebc5adafdca7e8$export$f96d8961b67fb6df(search) {
    return function(location) {
        return function() {
            location.search = search;
        };
    };
}
function $f8ebc5adafdca7e8$export$e6e34fd1f2686227(url) {
    return function(location) {
        return function() {
            location.assign(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$77ad94ebf1c2b9ed(url) {
    return function(location) {
        return function() {
            location.replace(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$32da5b5043dcd88c(location) {
    return function() {
        location.reload();
    };
}




// Generated by purs version 0.15.15
function $a62c4ef37c9a21b6$export$789c912f57fe164c(navigator) {
    return function() {
        return navigator.language;
    };
}
function $a62c4ef37c9a21b6$export$d0d68bb9ed2c643d(navigator) {
    return function() {
        return navigator.languages;
    };
}
function $a62c4ef37c9a21b6$export$c65ce66152f1cb9d(navigator) {
    return function() {
        return navigator.onLine;
    };
}
function $a62c4ef37c9a21b6$export$722a64dea1b767dc(navigator) {
    return function() {
        return navigator.platform;
    };
}
function $a62c4ef37c9a21b6$export$3dcce53a3755dc8c(navigator) {
    return function() {
        return navigator.userAgent;
    };
}




// Generated by purs version 0.15.15
function $aa35a24624ec08d2$export$5a7bfc01df82fcd1(window) {
    return function() {
        return window.document;
    };
}
function $aa35a24624ec08d2$export$ec7c8efa7f5790ae(window) {
    return function() {
        return window.navigator;
    };
}
function $aa35a24624ec08d2$export$17b07c660794dc13(window) {
    return function() {
        return window.location;
    };
}
function $aa35a24624ec08d2$export$55abd4691b317664(window) {
    return function() {
        return window.history;
    };
}
function $aa35a24624ec08d2$export$d23fbaf1a2e7133c(window) {
    return function() {
        return window.innerWidth;
    };
}
function $aa35a24624ec08d2$export$d3ad305c42af1069(window) {
    return function() {
        return window.innerHeight;
    };
}
function $aa35a24624ec08d2$export$5ea928c9faf85bd3(str) {
    return function(window) {
        return function() {
            window.alert(str);
        };
    };
}
function $aa35a24624ec08d2$export$715f9d76bb8c1fea(str) {
    return function(window) {
        return function() {
            return window.confirm(str);
        };
    };
}
function $aa35a24624ec08d2$export$7290db243fe4f181(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.moveBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$75f1ccd6dc32e80a(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.moveTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$f4b9acba9659afe8(url) {
    return function(name) {
        return function(features) {
            return function(window) {
                return function() {
                    return window.open(url, name, features);
                };
            };
        };
    };
}
function $aa35a24624ec08d2$export$8360e631d277ea4d(window) {
    return function() {
        return window.close();
    };
}
function $aa35a24624ec08d2$export$fc5b8aac72846d1e(window) {
    return function() {
        return window.outerHeight;
    };
}
function $aa35a24624ec08d2$export$e823f88e4111159a(window) {
    return function() {
        return window.outerWidth;
    };
}
function $aa35a24624ec08d2$export$c2d084dc44961371(window) {
    return function() {
        window.print();
    };
}
function $aa35a24624ec08d2$export$ce783d49a08713a7(str) {
    return function(defaultText) {
        return function(window) {
            return function() {
                return window.prompt(str, defaultText);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5f72b7db69802ea0(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.resizeBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$663d9c149a16f84d(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.resizeTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$daeacaab2dbcebdc(window) {
    return function() {
        return window.screenX;
    };
}
function $aa35a24624ec08d2$export$51b695a8750464db(window) {
    return function() {
        return window.screenY;
    };
}
function $aa35a24624ec08d2$export$209876d7b1ac8f3(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scroll(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$19a39865fecdb343(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scrollBy(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5320ec237fcf13b2(window) {
    return function() {
        return window.scrollX;
    };
}
function $aa35a24624ec08d2$export$2dd824eca41ca48d(window) {
    return function() {
        return window.scrollY;
    };
}
function $aa35a24624ec08d2$export$c2ed3351cac403d1(window) {
    return function() {
        return window.localStorage;
    };
}
function $aa35a24624ec08d2$export$f119d83aa936d634(window) {
    return function() {
        return window.sessionStorage;
    };
}
function $aa35a24624ec08d2$export$6cb2c4c0a22909c0(fn) {
    return function(window) {
        return function() {
            return window.requestAnimationFrame(fn);
        };
    };
}
function $aa35a24624ec08d2$export$e00521de187a817a(id) {
    return function(window) {
        return function() {
            return window.cancelAnimationFrame(id);
        };
    };
}
function $aa35a24624ec08d2$export$9288a5d956b3efbe(opts) {
    return function(fn) {
        return function(window) {
            return function() {
                return window.requestIdleCallback(fn, opts);
            };
        };
    };
}
function $aa35a24624ec08d2$export$bf0a62c3939e5933(id) {
    return function(window) {
        return function() {
            return window.cancelIdleCallback(id);
        };
    };
}
function $aa35a24624ec08d2$export$91124bb58bc04465(window) {
    return function() {
        return window.parent;
    };
}
function $aa35a24624ec08d2$export$b161e74f44e020b9(window) {
    return function() {
        return window.opener;
    };
}








var $6b26c9b0fa2d7b7a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $6b26c9b0fa2d7b7a$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $6b26c9b0fa2d7b7a$var$RequestIdleCallbackId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$var$RequestAnimationFrameId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6b26c9b0fa2d7b7a$export$20682ad686515a40 = function(msg) {
    return function(defaultText) {
        return function(window) {
            return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)(defaultText)(window));
        };
    };
};
var $6b26c9b0fa2d7b7a$export$195ba6d62321b933 = function(msg) {
    return function(window) {
        return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)("")(window));
    };
};
var $6b26c9b0fa2d7b7a$export$1828d3c48a8aa004 = function(window) {
    return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$b161e74f44e020b9(window));
};
var $6b26c9b0fa2d7b7a$export$3ce6949f20cea765 = function(url$prime) {
    return function(name) {
        return function(features) {
            return function(window) {
                return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$f4b9acba9659afe8(url$prime)(name)(features)(window));
            };
        };
    };
};
var $6b26c9b0fa2d7b7a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Window");
var $6b26c9b0fa2d7b7a$export$5e61711963baf8b7 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$2a5c622a4a2ca36d = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$5e61711963baf8b7;
    }
};
var $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$5ec63fa26beb11f3 = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337;
    }
};




// Generated by purs version 0.15.15
var $98632a8bc67f7e8c$export$117f7ddab482d006 = "unload";
var $98632a8bc67f7e8c$export$e03c1c3201ee8bb7 = "toggle";
var $98632a8bc67f7e8c$export$853c27de4ce0f746 = "submit";
var $98632a8bc67f7e8c$export$ddcffe0146c8f882 = "storage";
var $98632a8bc67f7e8c$export$2e6c959c16ff56b8 = "select";
var $98632a8bc67f7e8c$export$aad8462122ac592b = "reset";
var $98632a8bc67f7e8c$export$1427eba79b2ae340 = "readystatechange";
var $98632a8bc67f7e8c$export$504d7abb21fa8c9 = "progress";
var $98632a8bc67f7e8c$export$9b6706c8686cfc8e = "paste";
var $98632a8bc67f7e8c$export$6dd222fd9e8d7968 = "online";
var $98632a8bc67f7e8c$export$3b16d2a27b22a87a = "offline";
var $98632a8bc67f7e8c$export$a8ecead220dd38a6 = "message";
var $98632a8bc67f7e8c$export$dca0cefb631ec861 = "loadstart";
var $98632a8bc67f7e8c$export$ddc39cda6f909ee1 = "loadend";
var $98632a8bc67f7e8c$export$11e63f7b0f3d9900 = "load";
var $98632a8bc67f7e8c$export$8d5b9ac6cde54772 = "languagechange";
var $98632a8bc67f7e8c$export$9f85add0327f687e = "invalid";
var $98632a8bc67f7e8c$export$b7e3ae3d7c15e42e = "input";
var $98632a8bc67f7e8c$export$d7ddd398f22d79ef = "focus";
var $98632a8bc67f7e8c$export$a3bc9b8ed74fc = "error";
var $98632a8bc67f7e8c$export$ead50553077ff635 = "DOMContentLoaded";
var $98632a8bc67f7e8c$export$af2a99f971a346e6 = "cut";
var $98632a8bc67f7e8c$export$784d13d8ee351f07 = "copy";
var $98632a8bc67f7e8c$export$8360e631d277ea4d = "close";
var $98632a8bc67f7e8c$export$64ef1bee2b9504c1 = "click";
var $98632a8bc67f7e8c$export$d8a7b8f475ec0161 = "change";
var $98632a8bc67f7e8c$export$70b61ad426ddbe54 = "cancel";
var $98632a8bc67f7e8c$export$2cc7ff91bcacba5e = "blur";
var $98632a8bc67f7e8c$export$26ecb34e09d46df7 = "beforescriptexecute";
var $98632a8bc67f7e8c$export$ad2ab82a6fc787c7 = "beforeprint";
var $98632a8bc67f7e8c$export$7af6a91a06bd66bd = "afterscriptexecute";
var $98632a8bc67f7e8c$export$56890049c3283011 = "afterprint";
var $98632a8bc67f7e8c$export$5def58af4fd46132 = "abort";






var $deee5b6018c98796$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $deee5b6018c98796$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $deee5b6018c98796$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $deee5b6018c98796$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $deee5b6018c98796$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $deee5b6018c98796$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $deee5b6018c98796$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $deee5b6018c98796$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $deee5b6018c98796$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $deee5b6018c98796$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256);
var $deee5b6018c98796$export$895e5c0dd54cd456 = function(query) {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$var$liftEffect($deee5b6018c98796$var$bindFlipped($deee5b6018c98796$var$composeKleisliFlipped(function() {
        var $16 = $77e12228cc269e35$export$78fb49a702cc1f2(query);
        return function($17) {
            return $16($f6c9290a5db8f197$export$c8b651b897da2de($17));
        };
    }())($aa35a24624ec08d2$export$5a7bfc01df82fcd1))($2603425f82e959df$export$8291e5b88f90ce4)))(function(mel) {
        return $deee5b6018c98796$var$pure($deee5b6018c98796$var$bindFlipped1($5ae75883a0b7923c$export$c56654a6d0e3bd48)(mel));
    });
};
var $deee5b6018c98796$export$1b79e4d7fc8e4817 = /* #__PURE__ */ $edf0339512807bee$export$ef62257e6f8a5f8c(/* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ad2cf6904bca3ba1$export$de0c4a986b439e52)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $deee5b6018c98796$var$pure1($05149ea687d6b460$export$523c0b569236b342))));
var $deee5b6018c98796$export$11dc33decdfc25c9 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(callback) {
    return function __do() {
        var rs = $deee5b6018c98796$var$bindFlipped($f6c9290a5db8f197$export$1ae2b664eea77b7e)($deee5b6018c98796$var$bindFlipped($aa35a24624ec08d2$export$5a7bfc01df82fcd1)($2603425f82e959df$export$8291e5b88f90ce4))();
        if (rs instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) {
            var et = $deee5b6018c98796$var$map($6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6)($2603425f82e959df$export$8291e5b88f90ce4)();
            var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(v) {
                return callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342));
            })();
            $98db70b23aa8a6ea$export$3f65cefe8380dbea($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et)();
            return $edf0339512807bee$export$952106a975f35ae2($98db70b23aa8a6ea$export$8ff9f68337b520c0($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et));
        }
        callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342))();
        return $edf0339512807bee$export$8deb6e154ce67af6;
    };
});
var $deee5b6018c98796$export$f79c83a36c9670be = /* #__PURE__ */ $deee5b6018c98796$var$discard($edf0339512807bee$export$f885f489dcf38a2d)($deee5b6018c98796$export$11dc33decdfc25c9)(function() {
    return $deee5b6018c98796$var$bind($deee5b6018c98796$export$895e5c0dd54cd456("body"))(function(body) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($deee5b6018c98796$var$throwError($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Could not find body")))($deee5b6018c98796$var$pure)(body);
    });
});


// Generated by purs version 0.15.15













// Generated by purs version 0.15.15


// Generated by purs version 0.15.15



var $3cc7d978c1d7ea03$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $3cc7d978c1d7ea03$export$d2a72f000c4be67b = /* #__PURE__ */ function() {
    function Completed(value0) {
        this.value0 = value0;
    }
    Completed.create = function(value0) {
        return new Completed(value0);
    };
    return Completed;
}();
var $3cc7d978c1d7ea03$export$91ae1e982b7b05d4 = /* #__PURE__ */ function() {
    function Failed(value0) {
        this.value0 = value0;
    }
    Failed.create = function(value0) {
        return new Failed(value0);
    };
    return Failed;
}();
var $3cc7d978c1d7ea03$export$bc0dd2ad24d78194 = /* #__PURE__ */ function() {
    function Killed(value0) {
        this.value0 = value0;
    }
    Killed.create = function(value0) {
        return new Killed(value0);
    };
    return Killed;
}();
var $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96 = function(dict) {
    return dict.uninterruptible;
};
var $3cc7d978c1d7ea03$export$a1428c8f7ba796e8 = function(dict) {
    return dict.suspend;
};
var $3cc7d978c1d7ea03$export$b3e22bcfd64c1022 = function(dict) {
    return dict.never;
};
var $3cc7d978c1d7ea03$export$353ec5b900391c5 = {
    suspend: $edf0339512807bee$export$4de6f17bc3dfa03,
    fork: $edf0339512807bee$export$469c8a16c186651e,
    join: $edf0339512807bee$export$f3d782c2b95165ad,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    },
    Functor1: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $3cc7d978c1d7ea03$export$283d19abc99a5706 = {
    kill: $edf0339512807bee$export$c65b2010df1810d,
    MonadFork0: function() {
        return $3cc7d978c1d7ea03$export$353ec5b900391c5;
    },
    MonadThrow1: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $3cc7d978c1d7ea03$export$f2e13c7c49fc01aa = {
    bracket: function(acquire) {
        return function(release) {
            return function(run) {
                return $b28443a27438717a$export$9ad792f02752f447(acquire)({
                    completed: function($44) {
                        return release($3cc7d978c1d7ea03$export$d2a72f000c4be67b.create($44));
                    },
                    failed: function($45) {
                        return release($3cc7d978c1d7ea03$export$91ae1e982b7b05d4.create($45));
                    },
                    killed: function($46) {
                        return release($3cc7d978c1d7ea03$export$bc0dd2ad24d78194.create($46));
                    }
                })(run);
            };
        };
    },
    uninterruptible: $edf0339512807bee$export$859f4dae848ac0ae,
    never: $edf0339512807bee$export$b3e22bcfd64c1022,
    MonadKill0: function() {
        return $3cc7d978c1d7ea03$export$283d19abc99a5706;
    },
    MonadError1: function() {
        return $edf0339512807bee$export$9efce1646e93cba4;
    }
};
var $3cc7d978c1d7ea03$export$dfdb508572caf3d7 = function(dict) {
    return dict.kill;
};
var $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd = function(dict) {
    return dict.join;
};
var $3cc7d978c1d7ea03$export$7a5058c6b79333e0 = function(dict) {
    return dict.fork;
};
var $3cc7d978c1d7ea03$export$21277a949ab1c87a = function(dictMonadFork) {
    var suspend1 = $3cc7d978c1d7ea03$export$a1428c8f7ba796e8(dictMonadFork);
    var fork1 = $3cc7d978c1d7ea03$export$7a5058c6b79333e0(dictMonadFork);
    var Monad0 = dictMonadFork.Monad0();
    var monadReaderT = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    var Functor1 = dictMonadFork.Functor1();
    return {
        suspend: function(v) {
            return function($47) {
                return suspend1(v($47));
            };
        },
        fork: function(v) {
            return function($48) {
                return fork1(v($48));
            };
        },
        join: function() {
            var $49 = $3cc7d978c1d7ea03$var$lift(Monad0);
            var $50 = $3cc7d978c1d7ea03$export$f7e2c8231c57a8bd(dictMonadFork);
            return function($51) {
                return $49($50($51));
            };
        }(),
        Monad0: function() {
            return monadReaderT;
        },
        Functor1: function() {
            return Functor1;
        }
    };
};
var $3cc7d978c1d7ea03$export$b03c2ddf720364a4 = function(dictMonadKill) {
    var MonadThrow1 = dictMonadKill.MonadThrow1();
    var lift1 = $3cc7d978c1d7ea03$var$lift(MonadThrow1.Monad0());
    var kill1 = $3cc7d978c1d7ea03$export$dfdb508572caf3d7(dictMonadKill);
    var monadForkReaderT1 = $3cc7d978c1d7ea03$export$21277a949ab1c87a(dictMonadKill.MonadFork0());
    var monadThrowReaderT = $848780da1bf26d9d$export$1b067e2856bff729(MonadThrow1);
    return {
        kill: function(e) {
            var $52 = kill1(e);
            return function($53) {
                return lift1($52($53));
            };
        },
        MonadFork0: function() {
            return monadForkReaderT1;
        },
        MonadThrow1: function() {
            return monadThrowReaderT;
        }
    };
};
var $3cc7d978c1d7ea03$export$df5598cc12b9c8c = function(dict) {
    return dict.bracket;
};
var $3cc7d978c1d7ea03$export$746d58fd4800e2fa = function(dictMonadBracket) {
    var bracket1 = $3cc7d978c1d7ea03$export$df5598cc12b9c8c(dictMonadBracket);
    var uninterruptible1 = $3cc7d978c1d7ea03$export$bb8edd1f55ec0e96(dictMonadBracket);
    var MonadError1 = dictMonadBracket.MonadError1();
    var monadKillReaderT1 = $3cc7d978c1d7ea03$export$b03c2ddf720364a4(dictMonadBracket.MonadKill0());
    var monadErrorReaderT = $848780da1bf26d9d$export$484cd3c856ffc7(MonadError1);
    return {
        bracket: function(v) {
            return function(release) {
                return function(run) {
                    return function(r) {
                        return bracket1(v(r))(function(c) {
                            return function(a) {
                                return $848780da1bf26d9d$export$f356de2c51baae29(release(c)(a))(r);
                            };
                        })(function(a) {
                            return $848780da1bf26d9d$export$f356de2c51baae29(run(a))(r);
                        });
                    };
                };
            };
        },
        uninterruptible: function(k) {
            return function(r) {
                return uninterruptible1($848780da1bf26d9d$export$f356de2c51baae29(k)(r));
            };
        },
        never: $3cc7d978c1d7ea03$var$lift(MonadError1.MonadThrow0().Monad0())($3cc7d978c1d7ea03$export$b3e22bcfd64c1022(dictMonadBracket)),
        MonadKill0: function() {
            return monadKillReaderT1;
        },
        MonadError1: function() {
            return monadErrorReaderT;
        }
    };
};







// Generated by purs version 0.15.15














// Generated by purs version 0.15.15
// Generated by purs version 0.15.15






// Generated by purs version 0.15.15








// Generated by purs version 0.15.15
const $63ebef0b12494a84$export$e1e714991b6c2aba = function(f) {
    return function(xs) {
        var l = xs.length;
        var result = Array(l);
        for(var i = 0; i < l; i++)result[i] = f(i)(xs[i]);
        return result;
    };
};






















var $334541180b4ef18c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $334541180b4ef18c$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $334541180b4ef18c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($665413393090e9d0$export$fb489b392661d391);
var $334541180b4ef18c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $334541180b4ef18c$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1b4bd570fcdcddf2$export$74aba74241121413);
var $334541180b4ef18c$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($92016ca92c497156$export$98d9d13e8b5bfe4d);
var $334541180b4ef18c$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $334541180b4ef18c$var$map6 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8257f7a36ab9f9cd$export$916a3957c09e9ed5);
var $334541180b4ef18c$var$map7 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1242d110ab1edcd9$export$410cd7ab647069e5);
var $334541180b4ef18c$var$bimap1 = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $334541180b4ef18c$var$map8 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($65ae0a43a0950bac$export$48b7cf0194537bca);
var $334541180b4ef18c$var$map9 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($e48f2e41a907ae60$export$ba106ed6ee21ba26);
var $334541180b4ef18c$export$8f07ddce13659f50 = function(dict) {
    return dict.mapWithIndex;
};
var $334541180b4ef18c$export$6942612de3ba9e09 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    return function(f) {
        return mapWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $334541180b4ef18c$export$98b99a3e5a5c2768 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $334541180b4ef18c$export$341bcd9812b20e54 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorProduct1 = functorProduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap(mapWithIndex1(function($63) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($63));
                    }))(mapWithIndex2(function($64) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($64));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorProduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$3f7256b7802d7d35 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $334541180b4ef18c$export$ff6e9b408c0f1d0a = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $334541180b4ef18c$export$67874b1834c6566b = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $334541180b4ef18c$export$26258e29c904633d = {
    mapWithIndex: function(f) {
        return function(v) {
            return f($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $334541180b4ef18c$export$707dfb58df7f6e4f = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $334541180b4ef18c$export$381e44b6c18f93d6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $334541180b4ef18c$export$50b3765d14980fc = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $334541180b4ef18c$export$b6070cf53db1d339 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $334541180b4ef18c$export$6f7aa172554aa552 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCoproduct1 = functorCoproduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap1(mapWithIndex1(function($65) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($65));
                    }))(mapWithIndex2(function($66) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($66));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorCoproduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$dba6a24121753c2b = {
    mapWithIndex: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    }
};
var $334541180b4ef18c$export$8ba1941ba7d99c6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map8(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $334541180b4ef18c$export$7935f2d7643e66ce = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCompose1 = functorCompose(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return mapWithIndex1(function() {
                        var $67 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                        return function($68) {
                            return mapWithIndex2($67($68));
                        };
                    }())(v);
                };
            },
            Functor0: function() {
                return functorCompose1;
            }
        };
    };
};
var $334541180b4ef18c$export$f10d51ea0aa3da42 = {
    mapWithIndex: $63ebef0b12494a84$export$e1e714991b6c2aba,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $334541180b4ef18c$export$ffe1008ccae78edc = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return mapWithIndex1(f)(v);
            };
        },
        Functor0: function() {
            return functorApp;
        }
    };
};
var $334541180b4ef18c$export$eee3f4036a1ebada = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map9(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};












var $519ef1967f17d101$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldr2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldl2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldMap2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldr3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldl3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldMap3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldr4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldl4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldMap4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldr5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldl5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldMap5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldr6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldl6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldMap6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldr7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldl7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldMap7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldr8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $519ef1967f17d101$var$foldl8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $519ef1967f17d101$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $519ef1967f17d101$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($519ef1967f17d101$var$monoidEndo);
var $519ef1967f17d101$export$d859ed9adfa064ca = function(dict) {
    return dict.foldrWithIndex;
};
var $519ef1967f17d101$export$d13ff16378fefe83 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
        return function(f) {
            return foldrWithIndex1(function(i) {
                var $289 = f(i);
                return function($290) {
                    return applySecond($289($290));
                };
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $519ef1967f17d101$export$f441c83f81b7710f = function(dictApplicative) {
    var traverseWithIndex_1 = $519ef1967f17d101$export$d13ff16378fefe83(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $519ef1967f17d101$export$9b986141719153e = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(f) {
        return foldrWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$2d70b9efb960f478 = function(dict) {
    return dict.foldlWithIndex;
};
var $519ef1967f17d101$export$e623e8bf74059b22 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        return foldlWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$a0208fa03195d5a3 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v.value1);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $519ef1967f17d101$export$e07746a44d4d0673 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $519ef1967f17d101$export$db675654cef60b9a = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap1(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $519ef1967f17d101$export$3a92905df29453fa = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap2(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $519ef1967f17d101$export$92c42163dd2c46ce = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $519ef1967f17d101$export$328d1f7f0045c999 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap3(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $519ef1967f17d101$export$617fc130b23797ca = {
    foldrWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $519ef1967f17d101$export$dc8026a24f95d0a9 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap4(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $519ef1967f17d101$export$a77c731c3b37cfd = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap5(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $519ef1967f17d101$export$1add8b24fb58b747 = {
    foldrWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $519ef1967f17d101$export$707470fe74326665 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap6(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $519ef1967f17d101$export$f9ed9b5a8131479e = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap7(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $519ef1967f17d101$export$ca16238ae0303ef0 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(a0) {
                return foldlWithIndex1(function(i) {
                    return function(ma) {
                        return function(b) {
                            return bind(ma)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f(i))(b));
                        };
                    };
                })(pure(a0));
            };
        };
    };
};
var $519ef1967f17d101$export$998b3d14abdd8136 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldrWithIndex1(function(i) {
                return function(x) {
                    return function(acc) {
                        return append(f(i)(x))(acc);
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$e728f47f20b1eb28 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $291 = $519ef1967f17d101$var$foldr8(function(v) {
                return function(y) {
                    return f(v.value0)(v.value1)(y);
                };
            })(z);
            var $292 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $294 = $519ef1967f17d101$var$foldl8(function(y) {
                return function(v) {
                    return f(v.value0)(y)(v.value1);
                };
            })(z);
            var $295 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $519ef1967f17d101$export$998b3d14abdd8136($519ef1967f17d101$export$e728f47f20b1eb28)(dictMonoid);
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $519ef1967f17d101$export$d58f3ffea0efd404 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldlWithIndex1(function(i) {
                return function(acc) {
                    return function(x) {
                        return append(acc)(f(i)(x));
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$18153bb1181268e5 = function(dict) {
    return dict.foldMapWithIndex;
};
var $519ef1967f17d101$export$ca1485f10f9ca9ee = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictFoldableWithIndex.Foldable0());
    return {
        foldrWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldrWithIndex1(f)(z)(v);
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldlWithIndex1(f)(z)(v);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex2(f)(v);
                };
            };
        },
        Foldable0: function() {
            return foldableApp;
        }
    };
};
var $519ef1967f17d101$export$ed9dddd4d2a66e4d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCompose1 = foldableCompose(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldrWithIndex1(function(a) {
                            return $f57f4b701aa7b66e$export$8a83211c878a3f1f(foldrWithIndex2($71f2e2e9476163f8$export$c3095a23b368d1f2(f)(a)));
                        })(i)(v);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldlWithIndex1(function() {
                            var $297 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($298) {
                                return foldlWithIndex2($297($298));
                            };
                        }())(i)(v);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMapWithIndex3(function() {
                            var $299 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($300) {
                                return foldMapWithIndex4($299($300));
                            };
                        }())(v);
                    };
                };
            },
            Foldable0: function() {
                return foldableCompose1;
            }
        };
    };
};
var $519ef1967f17d101$export$c8998bd70c04c75d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCoproduct1 = foldableCoproduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldrWithIndex1(function($301) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($301));
                    })(z))(foldrWithIndex2(function($302) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($302));
                    })(z));
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldlWithIndex1(function($303) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($303));
                    })(z))(foldlWithIndex2(function($304) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($304));
                    })(z));
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMapWithIndex3(function($305) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($305));
                    }))(foldMapWithIndex4(function($306) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($306));
                    }));
                };
            },
            Foldable0: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$e0fd1e7d0cab0fb2 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableProduct1 = foldableProduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldrWithIndex1(function($307) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($307));
                        })(foldrWithIndex2(function($308) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($308));
                        })(z)(v.value1))(v.value0);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldlWithIndex2(function($309) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($309));
                        })(foldlWithIndex1(function($310) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($310));
                        })(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMapWithIndex3(function($311) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($311));
                        })(v.value0))(foldMapWithIndex4(function($312) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($312));
                        })(v.value1));
                    };
                };
            },
            Foldable0: function() {
                return foldableProduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$a2a2be54aa786fa = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap($519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $313 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c(i));
                    return function($314) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($313($314)));
                    };
                })(xs)))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$f48decfd8b6d8740 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $315 = c(i);
                    return function($316) {
                        return $57b8542ac3131c5d$export$6aef3ff797629bec($315($316));
                    };
                })(xs))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$9f81331332e444a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(i) {
                        return function(a) {
                            return function(m) {
                                return append(d)(append(t(i)(a))(m));
                            };
                        };
                    };
                    return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(joined)(f))(d);
                };
            };
        };
    };
};
var $519ef1967f17d101$export$222b6fd2bc53ca7a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictMonoid) {
        var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
        return function(f) {
            return foldMapWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $519ef1967f17d101$export$d803998e74b07aa8 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v)(v2)) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        index: v,
                        value: v2
                    });
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$c34ce7d3b9a0e = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return f(v)(v2);
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$6d3978b14e304a71 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra));
        return function(t) {
            var $317 = foldMapWithIndex2(function(i) {
                var $319 = t(i);
                return function($320) {
                    return $1242d110ab1edcd9$export$286e7113895e33ef($319($320));
                };
            });
            return function($318) {
                return $519ef1967f17d101$var$unwrap($317($318));
            };
        };
    };
};
var $519ef1967f17d101$export$5dc11e929c02e763 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra));
        return function(t) {
            var $321 = foldMapWithIndex2(function(i) {
                var $323 = t(i);
                return function($324) {
                    return $65ae0a43a0950bac$export$c688766eb4789b8c($323($324));
                };
            });
            return function($322) {
                return $519ef1967f17d101$var$unwrap($321($322));
            };
        };
    };
};







// Generated by purs version 0.15.15
















// Generated by purs version 0.15.15

















var $2c7a64ff78781336$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$b86a2d00788e21b6);
var $2c7a64ff78781336$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $2c7a64ff78781336$var$traverse2 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$f5923975fb28337f);
var $2c7a64ff78781336$var$traverse3 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$1cee23aad9b21cdc);
var $2c7a64ff78781336$var$traverse4 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$54df524caf88dbea);
var $2c7a64ff78781336$var$traverse5 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$a73c18000a1a08d7);
var $2c7a64ff78781336$var$traverse6 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$ecbf0d941e1ac029);
var $2c7a64ff78781336$var$traverse7 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$617ac6e03fd9951c);
var $2c7a64ff78781336$export$37034f8d74d84f8b = function(dictTraversableWithIndex) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversableWithIndex.Traversable2());
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence1 = sequence(dictApplicative);
        return function(f) {
            var $174 = mapWithIndex(f);
            return function($175) {
                return sequence1($174($175));
            };
        };
    };
};
var $2c7a64ff78781336$export$955fdc0d24efa249 = function(dict) {
    return dict.traverseWithIndex;
};
var $2c7a64ff78781336$export$d50a9c31d69ee13c = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    return function(dictApplicative) {
        var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
        return function(f) {
            return traverseWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $2c7a64ff78781336$export$649571d878667376 = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f($05149ea687d6b460$export$523c0b569236b342)(v.value1));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$98b99a3e5a5c2768;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a0208fa03195d5a3;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $2c7a64ff78781336$export$f5fab9ea43775499 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexProduct = $334541180b4ef18c$export$341bcd9812b20e54(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexProduct = $519ef1967f17d101$export$e0fd1e7d0cab0fb2(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableProduct = $11d1e86de605dfc6$export$261d8d87b1749d17(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexProduct1 = functorWithIndexProduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexProduct1 = foldableWithIndexProduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableProduct1 = traversableProduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverseWithIndex3(function($176) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($176));
                        })(v.value0))(traverseWithIndex4(function($177) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($177));
                        })(v.value1));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexProduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexProduct1;
            },
            Traversable2: function() {
                return traversableProduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$340ca064331c9524 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$3f7256b7802d7d35;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e07746a44d4d0673;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $2c7a64ff78781336$export$971c834447f08858 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse1(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$ff6e9b408c0f1d0a;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$db675654cef60b9a;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$80f6258c17467741;
    }
};
var $2c7a64ff78781336$export$82bf3aff27014955 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse2(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$67874b1834c6566b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$3a92905df29453fa;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$f5923975fb28337f;
    }
};
var $2c7a64ff78781336$export$e4fe4683618a40ff = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f($05149ea687d6b460$export$523c0b569236b342)(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$26258e29c904633d;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$92c42163dd2c46ce;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $2c7a64ff78781336$export$c0565467517236ee = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse3(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$707dfb58df7f6e4f;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$328d1f7f0045c999;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$1cee23aad9b21cdc;
    }
};
var $2c7a64ff78781336$export$c5842444d22f461a = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v($05149ea687d6b460$export$523c0b569236b342)(v1.value0));
                throw new Error("Failed pattern match at Data.TraversableWithIndex (line 95, column 1 - line 97, column 53): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$381e44b6c18f93d6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$617fc130b23797ca;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$29eea1300519490d;
    }
};
var $2c7a64ff78781336$export$f81f0b3aaf5918a5 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse4(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$50b3765d14980fc;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$dc8026a24f95d0a9;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $2c7a64ff78781336$export$298c1e0a7ee97588 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse5(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$b6070cf53db1d339;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a77c731c3b37cfd;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$a73c18000a1a08d7;
    }
};
var $2c7a64ff78781336$export$fad1c006f410e5e2 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCoproduct = $334541180b4ef18c$export$6f7aa172554aa552(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCoproduct = $519ef1967f17d101$export$c8998bd70c04c75d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCoproduct = $11d1e86de605dfc6$export$78124b32135c203a(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCoproduct1 = functorWithIndexCoproduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCoproduct1 = foldableWithIndexCoproduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCoproduct1 = traversableCoproduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $178 = map(function($181) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($181));
                        });
                        var $179 = traverseWithIndex3(function($182) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($182));
                        });
                        return function($180) {
                            return $178($179($180));
                        };
                    }())(function() {
                        var $183 = map(function($186) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($186));
                        });
                        var $184 = traverseWithIndex4(function($187) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($187));
                        });
                        return function($185) {
                            return $183($184($185));
                        };
                    }());
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCoproduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCoproduct1;
            },
            Traversable2: function() {
                return traversableCoproduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$8270215089848547 = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$dba6a24121753c2b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$1add8b24fb58b747;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$e6d8402c3fd7d14d;
    }
};
var $2c7a64ff78781336$export$b78ffb8a06781844 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse6(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$8ba1941ba7d99c6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$707470fe74326665;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$ecbf0d941e1ac029;
    }
};
var $2c7a64ff78781336$export$e1331c7aac1da04e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCompose = $334541180b4ef18c$export$7935f2d7643e66ce(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCompose = $519ef1967f17d101$export$ed9dddd4d2a66e4d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCompose = $11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCompose1 = functorWithIndexCompose(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCompose1 = foldableWithIndexCompose(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCompose1 = traversableCompose(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverseWithIndex3(function() {
                            var $188 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($189) {
                                return traverseWithIndex4($188($189));
                            };
                        }())(v));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCompose1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCompose1;
            },
            Traversable2: function() {
                return traversableCompose1;
            }
        };
    };
};
var $2c7a64ff78781336$export$96888504550934b5 = {
    traverseWithIndex: function(dictApplicative) {
        return $2c7a64ff78781336$export$37034f8d74d84f8b($2c7a64ff78781336$export$96888504550934b5)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$f10d51ea0aa3da42;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e728f47f20b1eb28;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$9e4a28683e28e26a;
    }
};
var $2c7a64ff78781336$export$fc84432b7fe0f34e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexApp = $334541180b4ef18c$export$ffe1008ccae78edc(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexApp = $519ef1967f17d101$export$ca1485f10f9ca9ee(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableApp = $11d1e86de605dfc6$export$744e1c7707f1991f(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverseWithIndex2(f)(v));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexApp;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexApp;
        },
        Traversable2: function() {
            return traversableApp;
        }
    };
};
var $2c7a64ff78781336$export$3d12857a1613dde6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse7(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$eee3f4036a1ebada;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$f9ed9b5a8131479e;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$617ac6e03fd9951c;
    }
};
var $2c7a64ff78781336$export$34e92304ce7da557 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$6062de19d97bcfe7 = function(dictTraversableWithIndex) {
    var mapAccumRWithIndex1 = $2c7a64ff78781336$export$34e92304ce7da557(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumRWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(a)(b);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$2594b6cb66070a = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$2aa973d5e57cdb6b = function(dictTraversableWithIndex) {
    var mapAccumLWithIndex1 = $2c7a64ff78781336$export$2594b6cb66070a(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumLWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(b)(a);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$363f6bf7e04ec632 = function(dictApplicative) {
    return function(dictTraversableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)(dictApplicative));
    };
};




var $1f1c3fb67e79b37f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $1f1c3fb67e79b37f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $1f1c3fb67e79b37f$export$d8deaab87a4e223a = /* #__PURE__ */ function() {
    function NonEmpty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty.create = function(value0) {
        return function(value1) {
            return new NonEmpty(value0, value1);
        };
    };
    return NonEmpty;
}();
var $1f1c3fb67e79b37f$export$3d29df45c3f8cf54 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return {
        unfoldr1: function(f) {
            return function(b) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($1f1c3fb67e79b37f$var$map(unfoldr($1f1c3fb67e79b37f$var$map1(f)))(f(b)));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $1f1c3fb67e79b37f$export$439306a4dcaafbb9 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    return function(a) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, empty);
    };
};
var $1f1c3fb67e79b37f$export$ffafc93d2cc87798 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(NonEmpty " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$d0a7bd743ccb8d67 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, append1(v.value1)(append1(pure(v1.value0))(v1.value1)));
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$a9a18ae5ba42aeab = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(v) {
        return alt(pure(v.value0))(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(m.value0), map2(f)(m.value1));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$cdee60b0fe4303fd = function(dictFunctorWithIndex) {
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0), mapWithIndex(function($245) {
                    return f($06733ae99ed4f534$export$8a67b48435b5d073.create($245));
                })(v.value1));
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$1d4c49925323035a = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$20ebd08132411556 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f(v.value0))(foldMap1(f)(v.value1));
                };
            };
        },
        foldl: function(f) {
            return function(b) {
                return function(v) {
                    return foldl(f)(f(b)(v.value0))(v.value1);
                };
            };
        },
        foldr: function(f) {
            return function(b) {
                return function(v) {
                    return f(v.value0)(foldr(f)(b)(v.value1));
                };
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$9a79a74e355c28b1 = function(dictFoldableWithIndex) {
    var foldMapWithIndex = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldlWithIndex = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldrWithIndex = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldableWithIndex.Foldable0());
    return {
        foldMapWithIndex: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0))(foldMapWithIndex1(function($246) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($246));
                    })(v.value1));
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return foldlWithIndex(function($247) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($247));
                    })(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(b)(v.value0))(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)(foldrWithIndex(function($248) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($248));
                    })(b)(v.value1));
                };
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$dbb721137b3f0cf6 = function(dictTraversable) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictTraversable.Functor0());
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(v.value0))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        },
        Foldable1: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$6e693a2e8188a772 = function(dictTraversableWithIndex) {
    var traverseWithIndex = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndex1 = $1f1c3fb67e79b37f$export$cdee60b0fe4303fd(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexNonEmpty1 = $1f1c3fb67e79b37f$export$9a79a74e355c28b1(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableNonEmpty1 = $1f1c3fb67e79b37f$export$dbb721137b3f0cf6(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)))(traverseWithIndex1(function($249) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($249));
                    })(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndex1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexNonEmpty1;
        },
        Traversable2: function() {
            return traversableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$ca19152d833c8d01 = function(dictFoldable) {
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldable);
    return {
        foldMap1: function(dictSemigroup) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                return function(v) {
                    return foldl(function(s) {
                        return function(a1) {
                            return append1(s)(f(a1));
                        };
                    })(f(v.value0))(v.value1);
                };
            };
        },
        foldr1: function(f) {
            return function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v.value0)(f(v.value0))(foldr(function(a1) {
                    var $250 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a1)(f(a1));
                    return function($251) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($250($251));
                    };
                })($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value1));
            };
        },
        foldl1: function(f) {
            return function(v) {
                return foldl(f)(v.value0)(v.value1);
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$eb5e1ef4ea2eca3d = function(dictFoldable) {
    return $086486679aa806fa$export$eb5e1ef4ea2eca3d($1f1c3fb67e79b37f$export$ca19152d833c8d01(dictFoldable));
};
var $1f1c3fb67e79b37f$export$460809894af54b0a = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq11(x.value1)(y.value1);
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$ec32b9103f985218 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        var compare11 = compare1(dictOrd);
        var eqNonEmpty2 = eqNonEmpty1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare11(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqNonEmpty2;
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$6a8b366193197b51 = function(dictEq1) {
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqNonEmpty1(dictEq));
        }
    };
};
var $1f1c3fb67e79b37f$export$de0dd6c052e29447 = function(dictOrd1) {
    var ordNonEmpty1 = $1f1c3fb67e79b37f$export$ec32b9103f985218(dictOrd1);
    var eq1NonEmpty1 = $1f1c3fb67e79b37f$export$6a8b366193197b51(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordNonEmpty1(dictOrd));
        },
        Eq10: function() {
            return eq1NonEmpty1;
        }
    };
};











var $78c799cba34fcb8d$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $78c799cba34fcb8d$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $78c799cba34fcb8d$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $78c799cba34fcb8d$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $78c799cba34fcb8d$export$ab241a3582569781 = function(x) {
    return x;
};
var $78c799cba34fcb8d$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $78c799cba34fcb8d$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78c799cba34fcb8d$export$4fa915e2865b1814 = function(a) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $78c799cba34fcb8d$var$listMap = function(f) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value1.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result;
                        function $tco_loop(v2, v3) {
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v2 = v2.value1;
                                $copy_v3 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value1.value0), v3)));
                                return;
                            }
                            $tco_done1 = true;
                            return v3;
                        }
                        while(!$tco_done1)$tco_result = $tco_loop($tco_var_v2, $copy_v3);
                        return $tco_result;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $78c799cba34fcb8d$export$40b9e4330ffd17e3 = {
    map: $78c799cba34fcb8d$var$listMap
};
var $78c799cba34fcb8d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$3c979cc7d75b024c = /* #__PURE__ */ $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$92659ee1fc91a075 = {
    foldr: function(f) {
        return function(b) {
            var rev = function() {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            }();
            var $284 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f))(b);
            return function($285) {
                return $284(rev($285));
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b, v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done1 = true;
                        return b;
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_b = f(b)(v.value0);
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)(function(acc) {
                var $286 = append2(acc);
                return function($287) {
                    return $286(f($287));
                };
            })(mempty);
        };
    }
};
var $78c799cba34fcb8d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $78c799cba34fcb8d$export$604c31769a93bbe0 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$20ebd08132411556($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $78c799cba34fcb8d$var$foldl(function(v1) {
                        return function(a) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 + 1 | 0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.value1));
                        };
                    });
                    return rev(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
                }();
                return $71f2e2e9476163f8$export$6f71268a1666ab58($78c799cba34fcb8d$var$foldl(function(v1) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $288 = $78c799cba34fcb8d$var$foldl(function(v) {
                return function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, acc));
            return function($289) {
                return $71f2e2e9476163f8$export$6f71268a1666ab58($288($289));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $290 = append2(acc);
                    var $291 = f(i);
                    return function($292) {
                        return $290($291($292));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$9a79a74e355c28b1($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldMapWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$18153bb1181268e5($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldlWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldlWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $78c799cba34fcb8d$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $293 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($294) {
                        return f($293($294));
                    };
                }())(v);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldlWithIndex(function() {
                    var $295 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($296) {
                        return f($295($296));
                    };
                }())(b)(v);
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldrWithIndex(function() {
                    var $297 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($298) {
                        return f($297($298));
                    };
                }())(b)(v);
            };
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$604c31769a93bbe0;
    }
};
var $78c799cba34fcb8d$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $78c799cba34fcb8d$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(i)(x), acc);
                };
            };
        })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50(/* #__PURE__ */ $1f1c3fb67e79b37f$export$cdee60b0fe4303fd($78c799cba34fcb8d$export$3951fb12c9649f2b));
var $78c799cba34fcb8d$export$116ff457f4ca2f6a = {
    mapWithIndex: function(fn) {
        return function(v) {
            return $78c799cba34fcb8d$var$mapWithIndex(function() {
                var $299 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                return function($300) {
                    return fn($299($300));
                };
            }())(v);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            return $78c799cba34fcb8d$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(ys)(xs);
        };
    }
};
var $78c799cba34fcb8d$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $78c799cba34fcb8d$export$14584e231e9c63ca = /* #__PURE__ */ function() {
    return {
        mempty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Semigroup0: function() {
            return $78c799cba34fcb8d$export$11cb7909a85856b;
        }
    };
}();
var $78c799cba34fcb8d$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $78c799cba34fcb8d$var$append1(v.value1)($78c799cba34fcb8d$export$effcdbd76139450(as$prime)));
        };
    }
};
var $78c799cba34fcb8d$export$36831384a74c4427 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return "Nil";
            return "(" + ($78c799cba34fcb8d$var$intercalate(" : ")($78c799cba34fcb8d$var$map(show)(v)) + " : Nil)");
        }
    };
};
var $78c799cba34fcb8d$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($1f1c3fb67e79b37f$export$ffafc93d2cc87798(dictShow)($78c799cba34fcb8d$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $78c799cba34fcb8d$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $301 = map1($78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            var $302 = $78c799cba34fcb8d$var$foldl(function(acc) {
                var $304 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                return function($305) {
                    return $304(f($305));
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($303) {
                return $301($302($303));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$99c2ce29c0ead637)(dictApplicative)($78c799cba34fcb8d$var$identity);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$export$d0a0d45336d2d3e3 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $78c799cba34fcb8d$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var rev = $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var $306 = map1(rev);
            var $307 = $78c799cba34fcb8d$var$foldlWithIndex1(function(i) {
                return function(acc) {
                    var $309 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                    var $310 = f(i);
                    return function($311) {
                        return $309($310($311));
                    };
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($308) {
                return $306($307($308));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$99c2ce29c0ead637;
    }
};
var $78c799cba34fcb8d$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249(/* #__PURE__ */ $1f1c3fb67e79b37f$export$6e693a2e8188a772($78c799cba34fcb8d$export$aed77e3b7bbfc02d));
var $78c799cba34fcb8d$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $78c799cba34fcb8d$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map1($78c799cba34fcb8d$export$ab241a3582569781)(traverseWithIndex1(function() {
                    var $312 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($313) {
                        return f($312($313));
                    };
                }())(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};
var $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo);
                            return;
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    }
};
var $78c799cba34fcb8d$export$1d41caf0a0a6a680 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(memo);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    },
    Unfoldable10: function() {
        return $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df;
    }
};
var $78c799cba34fcb8d$export$6907256bb4275b5b = /* #__PURE__ */ $1f1c3fb67e79b37f$export$3d29df45c3f8cf54($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $78c799cba34fcb8d$export$b16c60cd2a91c938 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ca19152d833c8d01($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: new $78c799cba34fcb8d$export$74c44e616647f5c0(f(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v1.acc)), v1.val),
                        acc: new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.acc)
                    };
                };
            };
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v), $78c799cba34fcb8d$var$foldr(go)({
                val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(v.value1).val);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$a2b02e086d468c06 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var go = function(a$prime) {
                    return function(v2) {
                        var acc$prime = new $78c799cba34fcb8d$export$74c44e616647f5c0(a$prime, v2.acc);
                        return {
                            val: new $78c799cba34fcb8d$export$74c44e616647f5c0(v(acc$prime), v2.val),
                            acc: acc$prime
                        };
                    };
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v(v1), $78c799cba34fcb8d$var$foldr(go)({
                    val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                    acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                })(v1.value1).val);
            }
            throw new Error("Failed pattern match at Data.List.Types (line 180, column 1 - line 187, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (!v2) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_var_v = v.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v2 && eq(v1.value0)(v.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go(xs)(ys)(true);
            };
        };
    }
};
var $78c799cba34fcb8d$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$96fd6c73d03c9dd2($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$var$eqNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$460809894af54b0a($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$80901a10e94c964a = /* #__PURE__ */ $1f1c3fb67e79b37f$export$6a8b366193197b51($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $78c799cba34fcb8d$var$eq1(dictEq)
    };
};
var $78c799cba34fcb8d$export$25985b0447eac39b = function(dictEq) {
    return $78c799cba34fcb8d$var$eqNonEmpty(dictEq);
};
var $78c799cba34fcb8d$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    $tco_var_v = v.value1;
                                    $copy_v1 = v1.value1;
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 60, column 5 - line 60, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go(xs)(ys);
            };
        };
    },
    Eq10: function() {
        return $78c799cba34fcb8d$export$b7e705972f3b8317;
    }
};
var $78c799cba34fcb8d$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$693feb0c3c484b70($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$var$ordNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ec32b9103f985218($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$bf20701e75931fe8 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$de0dd6c052e29447($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $78c799cba34fcb8d$var$compare1(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $78c799cba34fcb8d$export$783a13ebf5a1203d = function(dictOrd) {
    return $78c799cba34fcb8d$var$ordNonEmpty(dictOrd);
};
var $78c799cba34fcb8d$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return v.value0;
    },
    Extend0: function() {
        return $78c799cba34fcb8d$export$44a6d15320cfc4c5;
    }
};
var $78c799cba34fcb8d$export$7e49f2fa1ca16fbc = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$map(v.value0)(v1))($7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc);
var $78c799cba34fcb8d$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0(v1.value0), $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$apply(v.value1)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($78c799cba34fcb8d$var$apply(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$497dcf96eb2383ec = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1(v1(v.value0))($70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 164, column 1 - line 166, column 37): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $78c799cba34fcb8d$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = f(v.value0);
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, $78c799cba34fcb8d$var$append1(v1.value1)($78c799cba34fcb8d$var$bind(v.value1)(function($314) {
                return $78c799cba34fcb8d$export$effcdbd76139450(f($314));
            })));
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$497dcf96eb2383ec;
    }
};
var $78c799cba34fcb8d$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$97980ce7ea95015b = {
    alt: $78c799cba34fcb8d$var$append1,
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$55d622505c452dcb = /* #__PURE__ */ function() {
    return {
        empty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Alt0: function() {
            return $78c799cba34fcb8d$export$97980ce7ea95015b;
        }
    };
}();
var $78c799cba34fcb8d$export$503ce72759d93980 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $78c799cba34fcb8d$export$55d622505c452dcb;
    }
};
var $78c799cba34fcb8d$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $78c799cba34fcb8d$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $78c799cba34fcb8d$export$503ce72759d93980;
    }
};
var $78c799cba34fcb8d$export$e5d0ed5dac805e10 = {
    pure: /* #__PURE__ */ function() {
        var $315 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
        return function($316) {
            return $78c799cba34fcb8d$export$ab241a3582569781($315($316));
        };
    }(),
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$e5d0ed5dac805e10);
var $78c799cba34fcb8d$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$12e3398ee6f4a417;
    }
};
var $78c799cba34fcb8d$export$fac1bbd0707bc766 = {
    traverse1: function(dictApply) {
        var Functor0 = dictApply.Functor0();
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        return function(f) {
            return function(v) {
                return mapFlipped($78c799cba34fcb8d$var$foldl(function(acc) {
                    var $317 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))(acc);
                    return function($318) {
                        return $317(f($318));
                    };
                })(map1($78c799cba34fcb8d$var$pure)(f(v.value0)))(v.value1))(function(v1) {
                    return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))($78c799cba34fcb8d$var$pure(v1.value0))(v1.value1);
                });
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$d2990bb35e0a3e00($78c799cba34fcb8d$export$fac1bbd0707bc766)(dictApply)($78c799cba34fcb8d$var$identity);
    },
    Foldable10: function() {
        return $78c799cba34fcb8d$export$b16c60cd2a91c938;
    },
    Traversable1: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};



var $5ce356b15dd97b57$var$Leaf = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $5ce356b15dd97b57$var$Two = /* #__PURE__ */ function() {
    function Two(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Two(value0, value1, value2);
            };
        };
    };
    return Two;
}();
var $5ce356b15dd97b57$var$Three = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return new Three(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Three;
}();
var $5ce356b15dd97b57$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return new TwoLeft(value0, value1);
        };
    };
    return TwoLeft;
}();
var $5ce356b15dd97b57$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return new TwoRight(value0, value1);
        };
    };
    return TwoRight;
}();
var $5ce356b15dd97b57$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeLeft(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeLeft;
}();
var $5ce356b15dd97b57$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeMiddle(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $5ce356b15dd97b57$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeRight(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeRight;
}();
var $5ce356b15dd97b57$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new KickUp(value0, value1, value2);
            };
        };
    };
    return KickUp;
}();
var $5ce356b15dd97b57$var$fromZipper = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v1;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v1, v.value0.value0, v.value0.value1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Internal (line 25, column 3 - line 30, column 76): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Internal (line 22, column 1 - line 22, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $5ce356b15dd97b57$export$b5a179e49e0f2907 = function(comp) {
    return function(k) {
        return function(orig) {
            var up = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                            $tco_done = true;
                            return new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2);
                        }
                        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v1.value0, v1.value1, v1.value2, v.value0.value0, v.value0.value1));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1.value0, v1.value1, v1.value2));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2), v.value0.value0, new $5ce356b15dd97b57$var$Two(v.value0.value1, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1.value0), v1.value1, new $5ce356b15dd97b57$var$Two(v1.value2, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v.value0.value2), v.value0.value3, new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Internal (line 58, column 5 - line 63, column 90): " + [
                                v.value0.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 55, column 3 - line 55, column 50): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            var down = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $5ce356b15dd97b57$var$Leaf) {
                            $tco_done1 = true;
                            return {
                                found: false,
                                result: up(v)(new $5ce356b15dd97b57$var$KickUp($5ce356b15dd97b57$var$Leaf.value, k, $5ce356b15dd97b57$var$Leaf.value))
                            };
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Two) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoLeft(v1.value1, v1.value2), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoRight(v1.value0, v1.value1), v);
                            $copy_v1 = v1.value2;
                            return;
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Three) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            var v3 = comp(k)(v1.value3);
                            if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v3 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeMiddle(v1.value0, v1.value1, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value2;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3), v);
                            $copy_v1 = v1.value4;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 38, column 3 - line 38, column 81): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return down($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(orig);
        };
    };
};
var $5ce356b15dd97b57$export$4e5bc754a9c955a = /* #__PURE__ */ function() {
    return $5ce356b15dd97b57$var$Leaf.value;
}();













var $3d4fd987da5242ff$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3d4fd987da5242ff$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$tailRecM2 = /* #__PURE__ */ $f93520de2fa37b44$export$9056a6bb308e8c79($f93520de2fa37b44$export$6a06149683d26749);
var $3d4fd987da5242ff$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $3d4fd987da5242ff$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($f93520de2fa37b44$export$61e43214bca7f031);
var $3d4fd987da5242ff$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($78c799cba34fcb8d$export$92659ee1fc91a075)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $3d4fd987da5242ff$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $3d4fd987da5242ff$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $3d4fd987da5242ff$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3d4fd987da5242ff$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $3d4fd987da5242ff$export$b6d8713d53419d4c = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2.value1));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$var$foldr(function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1, v1.value1));
        };
    })(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
}();
var $3d4fd987da5242ff$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$823be24f8766da23 = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $3d4fd987da5242ff$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
};
var $3d4fd987da5242ff$export$c01875f616615628 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
    throw new Error("Failed pattern match at Data.List (line 245, column 1 - line 245, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$71c2a1babd78d286 = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    if (prefix instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && input instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && eq2(prefix.value0)(input.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: prefix.value1,
                        b: input.value1
                    }));
                    if (prefix instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$7fe28cb29e71bf10(input));
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                };
            };
            return $3d4fd987da5242ff$var$tailRecM2(go)(v)(s);
        };
    };
};
var $3d4fd987da5242ff$export$afc1bfabebaf28a2 = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1.value0)) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v)(v1.value1);
            return {
                init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2.init),
                rest: v2.rest
            };
        }
        return {
            init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            rest: v1
        };
    };
};
var $3d4fd987da5242ff$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $3d4fd987da5242ff$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
    };
};
var $3d4fd987da5242ff$export$439306a4dcaafbb9 = function(a) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$b035e44d7bb4278f = function(cmp) {
    var merge = function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, merge(v)(v1.value1));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, merge(v.value1)(v1));
            }
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v1;
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v;
            throw new Error("Failed pattern match at Data.List (line 466, column 3 - line 466, column 38): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var mergePairs = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(merge(v.value0)(v.value1.value0), mergePairs(v.value1.value1));
        return v;
    };
    var mergeAll = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v.value0;
            }
            $copy_v = mergePairs(v);
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var sequences = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v.value1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return descending(v.value1.value0)($3d4fd987da5242ff$export$439306a4dcaafbb9(v.value0))(v.value1.value1);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return ascending(v.value1.value0)(function(v1) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
            })(v.value1.value1);
        }
        return $3d4fd987da5242ff$export$439306a4dcaafbb9(v);
    };
    var descending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$eq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done1 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1), sequences(v2));
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var ascending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done2 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$notEq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = function(ys) {
                            return v1(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, ys));
                        };
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done2 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1($3d4fd987da5242ff$export$439306a4dcaafbb9(v)), sequences(v2));
                }
                while(!$tco_done2)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return function($444) {
        return mergeAll(sequences($444));
    };
};
var $3d4fd987da5242ff$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $3d4fd987da5242ff$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $3d4fd987da5242ff$var$tails = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, $3d4fd987da5242ff$var$tails(v.value1));
    throw new Error("Failed pattern match at Data.List (line 641, column 1 - line 641, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $3d4fd987da5242ff$export$66c1ae025e96b4bc = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$b7df5d561049483a = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v1 < 1) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $tco_var_v1 = v1 - 1 | 0;
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 513, column 3 - line 513, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$9384c7afe4015e42 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v1.value0)) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                $tco_done = true;
                return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$712962e076096ed4 = function(lst) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        revInit: v1,
                        last: v.value0
                    });
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 270, column 3 - line 270, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return $3d4fd987da5242ff$var$map(function(h) {
        return {
            init: $3d4fd987da5242ff$export$66c1ae025e96b4bc(h.revInit),
            last: h.last
        };
    })(go(lst)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
};
var $3d4fd987da5242ff$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v.value0)(v1.value0), v2);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $3d4fd987da5242ff$export$66c1ae025e96b4bc(go(xs)(ys)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $3d4fd987da5242ff$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $3d4fd987da5242ff$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($3d4fd987da5242ff$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $3d4fd987da5242ff$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start === end) return $3d4fd987da5242ff$export$439306a4dcaafbb9(start);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var go = function($copy_s) {
                return function($copy_e) {
                    return function($copy_step) {
                        return function($copy_rest) {
                            var $tco_var_s = $copy_s;
                            var $tco_var_e = $copy_e;
                            var $tco_var_step = $copy_step;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(s, e, step, rest) {
                                if (s === e) {
                                    $tco_done = true;
                                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                }
                                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                    $tco_var_s = s + step | 0;
                                    $tco_var_e = e;
                                    $tco_var_step = step;
                                    $copy_rest = new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List (line 148, column 3 - line 149, column 65): " + [
                                    s.constructor.name,
                                    e.constructor.name,
                                    step.constructor.name,
                                    rest.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_s, $tco_var_e, $tco_var_step, $copy_rest);
                            return $tco_result;
                        };
                    };
                };
            };
            return go(end)(start)(function() {
                var $325 = start > end;
                if ($325) return 1;
                return -1;
            }())($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        }
        throw new Error("Failed pattern match at Data.List (line 144, column 1 - line 144, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$b29f828819edca8d = function(p) {
    return function(xs) {
        var select = function(x) {
            return function(v) {
                var $328 = p(x);
                if ($328) return {
                    no: v.no,
                    yes: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.yes)
                };
                return {
                    no: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.no),
                    yes: v.yes
                };
            };
        };
        return $3d4fd987da5242ff$var$foldr(select)({
            no: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            yes: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
        })(xs);
    };
};
var $3d4fd987da5242ff$export$7b1b591b262c240 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $3d4fd987da5242ff$export$18f77a3bafa759b9 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return v1;
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        var v3 = $5ce356b15dd97b57$export$b5a179e49e0f2907(p)(v2.value0)(v);
                        if (v3.found) {
                            $tco_var_v = v3.result;
                            $tco_var_v1 = v1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                        $tco_var_v = v3.result;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 673, column 5 - line 673, column 23): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var $445 = go($5ce356b15dd97b57$export$4e5bc754a9c955a)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    return function($446) {
        return $3d4fd987da5242ff$export$66c1ae025e96b4bc($445($446));
    };
};
var $3d4fd987da5242ff$export$94f4066a75b10404 = function(dictOrd) {
    return $3d4fd987da5242ff$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3d4fd987da5242ff$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var v2 = f(v1.value0);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 419, column 5 - line 421, column 32): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.List (line 417, column 3 - line 417, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$17771a97d85ba7eb = function(dictMonadRec) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonadRec.Monad0().Bind1());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt = $75e93a4111e80214$export$228be17d80722ab(Alt0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Alt0.Functor0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
        return function(p) {
            var go = function(acc) {
                return bind1(alt(map1($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(p))(pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342))))(function(aa) {
                    return pure($3d4fd987da5242ff$var$bimap(function(v) {
                        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, acc);
                    })(function(v) {
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(acc);
                    })(aa));
                });
            };
            return tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $3d4fd987da5242ff$export$934820ddadec516f = function(dictMonadRec) {
    var manyRec1 = $3d4fd987da5242ff$export$17771a97d85ba7eb(dictMonadRec);
    return function(dictAlternative) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
        var manyRec2 = manyRec1(dictAlternative);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(manyRec2(v));
        };
    };
};
var $3d4fd987da5242ff$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(defer(function(v1) {
                return $3d4fd987da5242ff$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $3d4fd987da5242ff$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($3d4fd987da5242ff$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$f24224f1c91d8156 = /* #__PURE__ */ $3d4fd987da5242ff$var$foldl(function(acc) {
    return function(v) {
        return acc + 1 | 0;
    };
})(0);
var $3d4fd987da5242ff$export$4c7897fafd92b108 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $3d4fd987da5242ff$export$b8bc901090d2b1d4 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9(v1);
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var v3 = v(v1)(v2.value0);
                if (v3 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$b8bc901090d2b1d4(v)(v1)(v2.value1));
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2);
            }
            throw new Error("Failed pattern match at Data.List (line 216, column 1 - line 216, column 68): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$9f200c4466975173(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $3d4fd987da5242ff$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$2cd8252107eb640b = function(lst) {
    return $3d4fd987da5242ff$var$map(function(v) {
        return v.init;
    })($3d4fd987da5242ff$export$712962e076096ed4(lst));
};
var $3d4fd987da5242ff$export$b610b8812bbcded9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 === 0) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v.value1;
                $copy_v1 = v1 - 1 | 0;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 281, column 1 - line 281, column 44): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$5fd5031fecdacec3 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$9cb09a71b7d66923 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$9cb09a71b7d66923(v.value1);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$5fd5031fecdacec3)(v.value1)), $3d4fd987da5242ff$export$9cb09a71b7d66923(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value1, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$c01875f616615628)(v.value1))));
    throw new Error("Failed pattern match at Data.List (line 813, column 1 - line 813, column 54): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$3f063810d7bf01bd = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v(v1.value0))(v1.value1);
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v2.init), $3d4fd987da5242ff$export$3f063810d7bf01bd(v)(v2.rest));
        }
        throw new Error("Failed pattern match at Data.List (line 609, column 1 - line 609, column 80): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$1f7a5bf12caafbd = function(p) {
    var $447 = $3d4fd987da5242ff$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $3d4fd987da5242ff$var$eq(p(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $448 = $3d4fd987da5242ff$export$b035e44d7bb4278f(p);
    return function($449) {
        return $447($448($449));
    };
};
var $3d4fd987da5242ff$export$e5e25fbcc1f7affe = function(dictEq) {
    return $3d4fd987da5242ff$export$3f063810d7bf01bd($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$361434b95a7d965 = function(dictOrd) {
    var $450 = $3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictOrd.Eq0());
    var $451 = $3d4fd987da5242ff$export$97db5808d8f88186(dictOrd);
    return function($452) {
        return $450($451($452));
    };
};
var $3d4fd987da5242ff$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure(v1);
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1)(v2.value0))(function(b$prime) {
                    return $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad)(v)(b$prime)(v2.value1);
                });
                throw new Error("Failed pattern match at Data.List (line 824, column 1 - line 824, column 72): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $3d4fd987da5242ff$export$de3a4d4a0d731119 = function(fn) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (fn(v1.value0)) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v + 1 | 0;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.List (line 301, column 3 - line 301, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go(0);
};
var $3d4fd987da5242ff$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $3d4fd987da5242ff$var$map(function(v) {
            return ($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(fn)($3d4fd987da5242ff$export$66c1ae025e96b4bc(xs)));
    };
};
var $3d4fd987da5242ff$export$20098ecb074a31e6 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1.value0))(function(b) {
                return bind1($3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad)(v)(v1.value1))(function(xs$prime) {
                    return pure(function() {
                        if (b) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List (line 403, column 1 - line 403, column 75): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (p(v1.value0)) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Data.List (line 390, column 3 - line 390, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$f161f39e9c06ab2d = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            return $3d4fd987da5242ff$export$3dea766d36a8935f(function(x) {
                return $3d4fd987da5242ff$var$any(v(x))(v2);
            })(v1);
        };
    };
};
var $3d4fd987da5242ff$export$1f4807a235930d45 = function(dictEq) {
    return $3d4fd987da5242ff$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$45273896c792ff3b = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $3d4fd987da5242ff$export$45273896c792ff3b(v)($3d4fd987da5242ff$export$3dea766d36a8935f(function(y) {
            return !v(v1.value0)(y);
        })(v1.value1)));
        throw new Error("Failed pattern match at Data.List (line 705, column 1 - line 705, column 61): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$edce5881c815871 = function(dictEq) {
    return $3d4fd987da5242ff$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$3c57592525e2b27e = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32($78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq2(x)(y);
            };
        }
    };
};
var $3d4fd987da5242ff$export$21c206d752eba296 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqPattern1 = $3d4fd987da5242ff$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $3d4fd987da5242ff$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v.value0)) {
                $copy_v = v.value1;
                return;
            }
            $tco_done = true;
            return v;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $3d4fd987da5242ff$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$b7df5d561049483a($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$663103110d94aac9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v < 1) {
                $tco_done = true;
                return v1;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v - 1 | 0;
                $copy_v1 = v1.value1;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 536, column 1 - line 536, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $3d4fd987da5242ff$export$b7df5d561049483a(end - start | 0)($3d4fd987da5242ff$export$663103110d94aac9(start)(xs));
        };
    };
};
var $3d4fd987da5242ff$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$663103110d94aac9($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1)(v2.value0)) return v2.value1;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$9ea2b6c3fae093d8(v)(v1)(v2.value1));
            throw new Error("Failed pattern match at Data.List (line 732, column 1 - line 732, column 67): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $3d4fd987da5242ff$var$append1(xs)($3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$9ea2b6c3fae093d8(eq2)))($3d4fd987da5242ff$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $3d4fd987da5242ff$export$971dd5b0dfd021b6 = function(dictEq) {
    return $3d4fd987da5242ff$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$90f9093465da3136 = function(v) {
    return function(v1) {
        if (v === 0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value1);
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v2) {
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2);
        })($3d4fd987da5242ff$export$90f9093465da3136(v - 1 | 0)(v1.value1));
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $3d4fd987da5242ff$export$1822828d790e23ee = function(dictEq) {
    return $3d4fd987da5242ff$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$acaf96a27438246b = function(dictEq) {
    return $3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$1822828d790e23ee(dictEq)));
};
var $3d4fd987da5242ff$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$var$bind);
var $3d4fd987da5242ff$export$ee1b3e54f0441b22 = function(v) {
    return $3d4fd987da5242ff$var$bind(v)($3d4fd987da5242ff$var$identity);
};
var $3d4fd987da5242ff$export$986c2bbe7a34be0b = /* #__PURE__ */ $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$var$identity);
var $3d4fd987da5242ff$export$2dd9d44f93be5e22 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                var v3 = v1(v2.value0);
                if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v2.value1;
                if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.value0, v2.value1);
                throw new Error("Failed pattern match at Data.List (line 352, column 3 - line 354, column 23): " + [
                    v3.constructor.name
                ]);
            }());
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$2dd9d44f93be5e22(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $3d4fd987da5242ff$export$2dd9d44f93be5e22(n)(function($453) {
            return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($453));
        });
    };
};



// Generated by purs version 0.15.15





















var $ea3eb84de0acf574$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $ea3eb84de0acf574$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ea3eb84de0acf574$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ea3eb84de0acf574$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ea3eb84de0acf574$var$abs = /* #__PURE__ */ $97937c29f879e68e$export$2335f513bbd82c6d($97937c29f879e68e$export$ff461bf68e7dd332)($d061555d3b2c84b2$export$d40e27c88e22a303);
var $ea3eb84de0acf574$export$3024f3bfb62054a3 = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $ea3eb84de0acf574$export$85c928794f8d04d4 = /* #__PURE__ */ function() {
    function Node(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    Node.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new Node(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Node;
}();
var $ea3eb84de0acf574$var$IterLeaf = /* #__PURE__ */ function() {
    function IterLeaf() {}
    IterLeaf.value = new IterLeaf();
    return IterLeaf;
}();
var $ea3eb84de0acf574$var$IterEmit = /* #__PURE__ */ function() {
    function IterEmit(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterEmit.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterEmit(value0, value1, value2);
            };
        };
    };
    return IterEmit;
}();
var $ea3eb84de0acf574$var$IterNode = /* #__PURE__ */ function() {
    function IterNode(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    IterNode.create = function(value0) {
        return function(value1) {
            return new IterNode(value0, value1);
        };
    };
    return IterNode;
}();
var $ea3eb84de0acf574$export$4546c67049b8e195 = /* #__PURE__ */ function() {
    function IterDone() {}
    IterDone.value = new IterDone();
    return IterDone;
}();
var $ea3eb84de0acf574$export$e512af67edd28ac0 = /* #__PURE__ */ function() {
    function IterNext(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterNext.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterNext(value0, value1, value2);
            };
        };
    };
    return IterNext;
}();
var $ea3eb84de0acf574$export$f836382419f64c98 = /* #__PURE__ */ function() {
    function Split(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Split.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Split(value0, value1, value2);
            };
        };
    };
    return Split;
}();
var $ea3eb84de0acf574$var$SplitLast = /* #__PURE__ */ function() {
    function SplitLast(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SplitLast.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SplitLast(value0, value1, value2);
            };
        };
    };
    return SplitLast;
}();
var $ea3eb84de0acf574$export$8cd737e72cfcb4cd = function(k, v, l, r) {
    if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + r.value0 | 0, 1 + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
            r.constructor.name
        ]);
    }
    if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + l.value0 | 0, 1 + l.value1 | 0, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + function() {
            var $280 = l.value0 > r.value0;
            if ($280) return l.value0;
            return r.value0;
        }() | 0, (1 + l.value1 | 0) + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
            r.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
        l.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$a07cd7d770cb0fb3 = /* #__PURE__ */ function() {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($ea3eb84de0acf574$var$IterNode.create)($ea3eb84de0acf574$var$IterLeaf.value);
}();
var $ea3eb84de0acf574$var$stepWith = function(f) {
    return function(next) {
        return function(done) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v instanceof $ea3eb84de0acf574$var$IterLeaf) {
                        $tco_done = true;
                        return done($05149ea687d6b460$export$523c0b569236b342);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterEmit) {
                        $tco_done = true;
                        return next(v.value0, v.value1, v.value2);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterNode) {
                        $copy_v = f(v.value1)(v.value0);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 940, column 8 - line 946, column 20): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$346677f925de839c = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value1;
    throw new Error("Failed pattern match at Data.Map.Internal (line 618, column 8 - line 620, column 24): " + [
        v.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
    };
};
var $ea3eb84de0acf574$export$807b724170e609fd = /* #__PURE__ */ function() {
    var height = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0;
        throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
            v.constructor.name
        ]);
    };
    var rotateLeft = function(k, v, l, rk, rv, rl, rr) {
        if (rl instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && rl.value0 > height(rr)) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rl.value2, rl.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, rl.value5, rr));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl), rr);
    };
    var rotateRight = function(k, v, lk, lv, ll, lr, r) {
        if (lr instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && height(ll) <= lr.value0) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lr.value2, lr.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, lr.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr.value5, r));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr, r));
    };
    return function(k, v, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && r.value0 > 1) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (r.value0 > (l.value0 + 1 | 0)) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
                if (l.value0 > (r.value0 + 1 | 0)) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            }
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3 && l.value0 > 1) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
            l.constructor.name
        ]);
    };
}();
var $ea3eb84de0acf574$var$$lazy_unsafeSplit = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplit", "Data.Map.Internal", function() {
    return function(comp, k, m) {
        if (m instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$f836382419f64c98($06733ae99ed4f534$export$bebe9059409a0d04.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
        if (m instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = comp(k)(m.value2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(793)(comp, k, m.value4);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, v1.value2, m.value5));
            }
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(796)(comp, k, m.value5);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, m.value4, v1.value1), v1.value2);
            }
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$f836382419f64c98(new $06733ae99ed4f534$export$8a67b48435b5d073(m.value3), m.value4, m.value5);
            throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
            m.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$export$9827c6ff7b07c8a4 = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplit(786);
var $ea3eb84de0acf574$var$$lazy_unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplitLast", "Data.Map.Internal", function() {
    return function(k, v, l, r) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$SplitLast(k, v, l);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(779)(r.value2, r.value3, r.value4, r.value5);
            return new $ea3eb84de0acf574$var$SplitLast(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(k, v, l, v1.value2));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(775);
var $ea3eb84de0acf574$export$76d750f4290aa12 = function(v, v1) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v1;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        var v2 = $ea3eb84de0acf574$var$unsafeSplitLast(v.value2, v.value3, v.value4, v.value5);
        return $ea3eb84de0acf574$export$807b724170e609fd(v2.value0, v2.value1, v2.value2, v1);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
        v.constructor.name,
        v1.constructor.name
    ]);
};
var $ea3eb84de0acf574$var$$lazy_unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeDifference", "Data.Map.Internal", function() {
    return function(comp, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(841)(comp, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(842)(comp, v.value2, r.value5);
            return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 836, column 39 - line 843, column 33): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeDifference(835);
var $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeIntersectionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(825)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(826)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 827, column 5 - line 831, column 37): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 820, column 49 - line 831, column 37): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(819);
var $ea3eb84de0acf574$var$$lazy_unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeUnionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return r;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(809)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(810)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, r.value3, l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 811, column 5 - line 815, column 46): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 804, column 42 - line 815, column 46): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(803);
var $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeUnionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$722fbec263ad908a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        var v2 = f(v.value3);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v2.value0, v.value4, v.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 531, column 11 - line 535, column 38): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 527, column 7 - line 535, column 38): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 524, column 8 - line 535, column 38): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$b072eafdc1d506c3 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        var go = function(ind) {
            return function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return ind + "Leaf";
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return ind + ("[" + ($ea3eb84de0acf574$var$show(v.value0) + ("] " + (show1(v.value2) + (" => " + (show2(v.value3) + "\n")))))) + (go(ind + "    ")(v.value4) + "\n" + go(ind + "    ")(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 233, column 12 - line 238, column 34): " + [
                    v.constructor.name
                ]);
            };
        };
        return go("");
    };
};
var $ea3eb84de0acf574$export$12ebb66e272c23f3 = function() {
    return function(dictOrd) {
        var unionWith1 = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
        return function(dictSemigroup) {
            return {
                append: unionWith1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $ea3eb84de0acf574$var$semigroupMap1 = /* #__PURE__ */ $ea3eb84de0acf574$export$12ebb66e272c23f3();
var $ea3eb84de0acf574$export$3e41007ebfff0e64 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(m) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
            return $ea3eb84de0acf574$var$map(function(a) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2));
            })(v.value0);
        };
    };
};
var $ea3eb84de0acf574$export$6a0d13241802fe80 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return false;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return true;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 7 - line 462, column 19): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 456, column 8 - line 462, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6be5ce76a5140a15 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v2 = f(v.value2)(v.value3);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v2.value0, go(v.value4), go(v.value5));
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 661, column 7 - line 665, column 47): " + [
                    v2.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 658, column 8 - line 665, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$e70771d2e7e590a = function(dictOrd) {
    var $780 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    return function($781) {
        return $780($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($781));
    };
};
var $ea3eb84de0acf574$export$6c45e13560e32a55 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 295, column 7 - line 302, column 38): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 292, column 8 - line 302, column 38): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$7b26f9c4323be72 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 327, column 7 - line 333, column 42): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 324, column 8 - line 333, column 42): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dfc7155ac0343b8 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value3);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$var$iterMapU = function(iter) {
    return function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return iter;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
            }
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
            return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, new $ea3eb84de0acf574$var$IterNode(v.value5, iter)));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 973, column 17 - line 988, column 56): " + [
            v.constructor.name
        ]);
    };
};
var $ea3eb84de0acf574$export$882785ec79906152 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapU);
var $ea3eb84de0acf574$var$stepUnfoldrUnordered = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$882785ec79906152(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$4e1300b52a76ba3a = function(dictUnfoldable) {
    var $782 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldrUnordered);
    return function($783) {
        return $782($ea3eb84de0acf574$export$a07cd7d770cb0fb3($783));
    };
};
var $ea3eb84de0acf574$export$b60b523eeb066dbd = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$882785ec79906152(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapR = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
                    $copy_v = v.value5;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 963, column 13 - line 970, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$dc5b2553d8583b72 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapR);
var $ea3eb84de0acf574$export$cdc6b87d9fb979 = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$dc5b2553d8583b72(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapL = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
                    $copy_v = v.value4;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 951, column 13 - line 958, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$273c44542cac8efe = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapL);
var $ea3eb84de0acf574$export$3b67892037786a5b = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$export$4719e5aa2706059f = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v2 = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                                if (v2 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && eq1(v.value0)(v2.value0) && eq2(v.value1)(v2.value1)) {
                                    $tco_var_a = v.value2;
                                    $copy_b = v2.value2;
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return true;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 859, column 14 - line 868, column 13): " + [
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }()
        };
    };
};
var $ea3eb84de0acf574$export$2b627c4f0ac5579b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqMapIter2 = eqMapIter1(dictOrd1.Eq0());
        return {
            compare: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                            var v1 = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v1 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v3 = compare(v1.value0)(v.value0);
                                if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    var v4 = compare1(v1.value1)(v.value1);
                                    if (v4 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                        $tco_var_a = v1.value2;
                                        $copy_b = v.value2;
                                        return;
                                    }
                                    $tco_done = true;
                                    return v4;
                                }
                                $tco_done = true;
                                return v3;
                            }
                            if (v1 instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                    $tco_done = true;
                                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                                }
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 873, column 14 - line 891, column 11): " + [
                                v1.constructor.name,
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }(),
            Eq0: function() {
                return eqMapIter2;
            }
        };
    };
};
var $ea3eb84de0acf574$var$stepUnfoldr = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$273c44542cac8efe(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$823be24f8766da23 = function(dictUnfoldable) {
    var $784 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldr);
    return function($785) {
        return $784($ea3eb84de0acf574$export$a07cd7d770cb0fb3($785));
    };
};
var $ea3eb84de0acf574$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $ea3eb84de0acf574$export$c448526daa762015 = function(dictShow) {
    var showTuple = $71f2e2e9476163f8$export$c29279d1dfdefb95(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(showTuple(dictShow1)));
        return {
            show: function(as) {
                return "(fromFoldable " + (show1($ea3eb84de0acf574$var$toUnfoldable1(as)) + ")");
            }
        };
    };
};
var $ea3eb84de0acf574$export$35d0420a84c5d3ae = function(dictOrd) {
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    return function(dictEq) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var go = function(m1) {
            return function(m2) {
                if (m1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (m1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = lookup1(m1.value2)(m2);
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq1(m1.value3)(v1.value0) && go(m1.value4)(m2) && go(m1.value5)(m2);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 611, column 7 - line 614, column 40): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 608, column 14 - line 614, column 40): " + [
                    m1.constructor.name
                ]);
            };
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dd1bc94b04021eeb = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
    return false;
};
var $ea3eb84de0acf574$export$a6c74cde0675b326 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeIntersectionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$bc86dfbf7795668c = function(dictOrd) {
    return $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$435aa68287e449bf = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(k) {
            return function(v) {
                var go = function(v1) {
                    if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                    if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        var v2 = compare(k)(v1.value2);
                        if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                        if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, app(v1.value3)(v), v1.value4, v1.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 486, column 7 - line 489, column 44): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 483, column 8 - line 489, column 44): " + [
                        v1.constructor.name
                    ]);
                };
                return go;
            };
        };
    };
};
var $ea3eb84de0acf574$export$21a5ca8aa77d35ff = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v2 = compare(k)(v1.value2);
                    if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                    if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, v, v1.value4, v1.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                    v1.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$3930f636962ed944 = {
    map: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 147, column 10 - line 150, column 39): " + [
                v.constructor.name
            ]);
        };
        return go;
    }
};
var $ea3eb84de0acf574$export$d7c684e0b3e84e77 = {
    mapWithIndex: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value2)(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 155, column 10 - line 158, column 41): " + [
                v.constructor.name
            ]);
        };
        return go;
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    }
};
var $ea3eb84de0acf574$export$4295a0c2ad7aa544 = {
    foldr: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(172)(m$prime.value4, f(m$prime.value3)($lazy_go(172)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(169);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(178)(f($lazy_go(178)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(175);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    }
};
var $ea3eb84de0acf574$export$91e1c50dfb7225a6 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(192)(m$prime.value4, f(m$prime.value2)(m$prime.value3)($lazy_go(192)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 189, column 26 - line 192, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(189);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(198)(f(m$prime.value2)($lazy_go(198)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 195, column 26 - line 198, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(195);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value2)(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 201, column 10 - line 204, column 30): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    Foldable0: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    return $519ef1967f17d101$export$d859ed9adfa064ca($ea3eb84de0acf574$export$91e1c50dfb7225a6)(function(k) {
        return function(v) {
            return function(acc) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(k, acc);
            };
        };
    })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$export$78146089411e393d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 209, column 10 - line 215, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($ea3eb84de0acf574$export$78146089411e393d)(dictApplicative)($ea3eb84de0acf574$var$identity);
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    },
    Foldable1: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$8999febf5cd85b5c = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value2)(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 221, column 10 - line 227, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    FunctorWithIndex0: function() {
        return $ea3eb84de0acf574$export$d7c684e0b3e84e77;
    },
    FoldableWithIndex1: function() {
        return $ea3eb84de0acf574$export$91e1c50dfb7225a6;
    },
    Traversable2: function() {
        return $ea3eb84de0acf574$export$78146089411e393d;
    }
};
var $ea3eb84de0acf574$export$68c286be0e7e55b7 = /* #__PURE__ */ function() {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($ea3eb84de0acf574$export$4295a0c2ad7aa544)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$var$foldSubmapBy = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(dictOrd);
    return function(appendFn) {
        return function(memptyValue) {
            return function(kmin) {
                return function(kmax) {
                    return function(f) {
                        var tooSmall = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThan1(k)(kmin.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 389, column 7 - line 393, column 22): " + [
                                kmin.constructor.name
                            ]);
                        }();
                        var tooLarge = function() {
                            if (kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return greaterThan1(k)(kmax.value0);
                            };
                            if (kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 396, column 7 - line 400, column 22): " + [
                                kmax.constructor.name
                            ]);
                        }();
                        var inBounds = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k) && lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 403, column 7 - line 411, column 21): " + [
                                kmin.constructor.name,
                                kmax.constructor.name
                            ]);
                        }();
                        var go = function(v) {
                            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return memptyValue;
                            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return appendFn(appendFn(function() {
                                var $643 = tooSmall(v.value2);
                                if ($643) return memptyValue;
                                return go(v.value4);
                            }())(function() {
                                var $644 = inBounds(v.value2);
                                if ($644) return f(v.value2)(v.value3);
                                return memptyValue;
                            }()))(function() {
                                var $645 = tooLarge(v.value2);
                                if ($645) return memptyValue;
                                return go(v.value5);
                            }());
                            throw new Error("Failed pattern match at Data.Map.Internal (line 413, column 10 - line 419, column 66): " + [
                                v.constructor.name
                            ]);
                        };
                        return go;
                    };
                };
            };
        };
    };
};
var $ea3eb84de0acf574$export$3f9a381f67a51fcd = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    return function(dictMonoid) {
        return foldSubmapBy1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0()))($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid));
    };
};
var $ea3eb84de0acf574$export$3c39a95b7a4d5e28 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value4;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 361, column 11 - line 366, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$211c88c643c40f46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$3c39a95b7a4d5e28(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 342, column 7 - line 348, column 25): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 339, column 8 - line 348, column 25): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$35f577b3da447d17 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value5;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 352, column 11 - line 357, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$9318a1f920537b0d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$35f577b3da447d17(v.value4);
                throw new Error("Failed pattern match at Data.Map.Internal (line 311, column 7 - line 318, column 21): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 308, column 8 - line 318, column 21): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$d7a60370122a9ab0 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)(v.value3)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 627, column 8 - line 633, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$151f9a87a7fd5652 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 640, column 8 - line 646, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$3dea766d36a8935f = function(dictOrd) {
    var $786 = $ea3eb84de0acf574$export$d7a60370122a9ab0(dictOrd);
    return function($787) {
        return $786($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($787));
    };
};
var $ea3eb84de0acf574$export$85aac4508ff70b8 = function(dictEq) {
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(eqMapIter1(dictEq1));
        return {
            eq: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                        return false;
                    }
                    if (xs instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        if (ys instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && xs.value1 === ys.value1) return eq1($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                        return false;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 94, column 14 - line 105, column 16): " + [
                        xs.constructor.name
                    ]);
                };
            }
        };
    };
};
var $ea3eb84de0acf574$export$3d0d4caf881d6855 = function(dictOrd) {
    var ordMapIter1 = $ea3eb84de0acf574$export$2b627c4f0ac5579b(dictOrd);
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(ordMapIter1(dictOrd1));
        var eqMap2 = eqMap1(dictOrd1.Eq0());
        return {
            compare: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                        return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    }
                    if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                };
            },
            Eq0: function() {
                return eqMap2;
            }
        };
    };
};
var $ea3eb84de0acf574$export$e321b34a2787dc8d = function(dictEq) {
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqMap1(dictEq1));
        }
    };
};
var $ea3eb84de0acf574$export$e2f3c1862bab1bff = function(dictOrd) {
    var ordMap1 = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    var eq1Map1 = $ea3eb84de0acf574$export$e321b34a2787dc8d(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordMap1(dictOrd1));
        },
        Eq10: function() {
            return eq1Map1;
        }
    };
};
var $ea3eb84de0acf574$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
}();
var $ea3eb84de0acf574$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(function(m) {
            return function(v) {
                return insert1(v.value0)(v.value1)(m);
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$690be49d504fc7f = function(dictOrd) {
    var insertWith1 = $ea3eb84de0acf574$export$435aa68287e449bf(dictOrd);
    return function(dictFoldable) {
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        return function(f) {
            var f$prime = insertWith1($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
            return foldl(function(m) {
                return function(v) {
                    return f$prime(v.value0)(v.value1)(m);
                };
            })($ea3eb84de0acf574$export$6e22c362a0406a2c);
        };
    };
};
var $ea3eb84de0acf574$export$78cfe3464e7eb77b = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldableWithIndex) {
        return $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex)(function(k) {
            return function(m) {
                return function(v) {
                    return insert1(k)(v)(m);
                };
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$546d2468bc9efbc6 = function() {
    return function(dictOrd) {
        var semigroupMap2 = $ea3eb84de0acf574$var$semigroupMap1(dictOrd);
        return function(dictSemigroup) {
            var semigroupMap3 = semigroupMap2(dictSemigroup);
            return {
                mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                Semigroup0: function() {
                    return semigroupMap3;
                }
            };
        };
    };
};
var $ea3eb84de0acf574$export$d6b4f308683e59db = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(kmin) {
        return function(kmax) {
            return foldSubmapBy1(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c)(kmin)(kmax)($ea3eb84de0acf574$export$439306a4dcaafbb9);
        };
    };
};
var $ea3eb84de0acf574$export$30b2db2f7030f6cf = function(dictOrd) {
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$acaf96a27438246b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(m1) {
        return function(m2) {
            return $ea3eb84de0acf574$var$unsafeDifference(compare, m1, m2);
        };
    };
};
var $ea3eb84de0acf574$export$1822828d790e23ee = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6583e3e95cb5e9d1 = function(dictOrd) {
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 === 2 && v.value5.value0 === 1 && v.value1 > v.value5.value1 && greaterThan1(v.value5.value2)(v.value2) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 264, column 11 - line 268, column 60): " + [
                    v.value5.constructor.name
                ]);
            }
            if (v.value4 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v.value0 === 2 && v.value4.value0 === 1 && v.value1 > v.value4.value1 && lessThan1(v.value4.value2)(v.value2) && go(v.value4);
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 > v.value5.value0 && greaterThan1(v.value5.value2)(v.value2) && v.value0 > v.value4.value0 && lessThan1(v.value4.value2)(v.value2) && $ea3eb84de0acf574$var$abs(v.value5.value0 - v.value4.value0 | 0) < 2 && ((v.value5.value1 + v.value4.value1 | 0) + 1 | 0) === v.value1 && go(v.value4) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 270, column 11 - line 274, column 108): " + [
                    v.value5.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 262, column 7 - line 274, column 108): " + [
                v.value4.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 259, column 8 - line 274, column 108): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$986c2bbe7a34be0b = function(dictOrd) {
    return $ea3eb84de0acf574$export$e70771d2e7e590a(dictOrd)($ea3eb84de0acf574$var$identity);
};
var $ea3eb84de0acf574$export$8952a3dc6f3cd264 = function(dictOrd) {
    return {
        apply: $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($ea3eb84de0acf574$var$identity),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$886591aa0ffe34d5 = function(dictOrd) {
    var mapMaybeWithKey1 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    var applyMap1 = $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
    return {
        bind: function(m) {
            return function(f) {
                return mapMaybeWithKey1(function(k) {
                    var $788 = lookup1(k);
                    return function($789) {
                        return $788(f($789));
                    };
                })(m);
            };
        },
        Apply0: function() {
            return applyMap1;
        }
    };
};
var $ea3eb84de0acf574$export$2fa1dac9e337f670 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value2)(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 693, column 8 - line 695, column 62): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$4154a199d7d90455 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 683, column 8 - line 685, column 58): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$22a7378e1d3307a4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
                var v2 = f(v.value0);
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(k, v2.value0, v.value1, v.value2);
                throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ea3eb84de0acf574$export$9030392ec4d635ff = function(dictOrd) {
    return {
        alt: $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$4c085c510196daa3 = function(dictOrd) {
    var altMap1 = $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
    return {
        empty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        Alt0: function() {
            return altMap1;
        }
    };
};







// Generated by purs version 0.15.15
const $93c729927fdf3160$export$bef1f36f5486a6a3 = function(s) {
    return function() {
        console.log(s);
    };
};
const $93c729927fdf3160$export$c106dd0671a0fc2d = function(s) {
    return function() {
        console.warn(s);
    };
};
const $93c729927fdf3160$export$a3bc9b8ed74fc = function(s) {
    return function() {
        console.error(s);
    };
};
const $93c729927fdf3160$export$a80b3bd66acc52ff = function(s) {
    return function() {
        console.info(s);
    };
};
const $93c729927fdf3160$export$1c9f709888824e05 = function(s) {
    return function() {
        console.debug(s);
    };
};
const $93c729927fdf3160$export$2da9be4cfdb689b1 = function(s) {
    return function() {
        console.time(s);
    };
};
const $93c729927fdf3160$export$1694f226a9241aae = function(s) {
    return function() {
        console.timeLog(s);
    };
};
const $93c729927fdf3160$export$8f2977fb54cb3601 = function(s) {
    return function() {
        console.timeEnd(s);
    };
};
const $93c729927fdf3160$export$42ffd38884aecdac = function() {
    console.clear();
};
const $93c729927fdf3160$export$e5e25fbcc1f7affe = function(s) {
    return function() {
        console.group(s);
    };
};
const $93c729927fdf3160$export$488ef8fb3416a29f = function(s) {
    return function() {
        console.groupCollapsed(s);
    };
};
const $93c729927fdf3160$export$a57f3dfe595273e6 = function() {
    console.groupEnd();
};



var $78386b654cef599e$export$28709abf85ddce1d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$c106dd0671a0fc2d(show(a));
    };
};
var $78386b654cef599e$export$9f43f5977f8d5609 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$bef1f36f5486a6a3(show(a));
    };
};
var $78386b654cef599e$export$fc9467e2ad369291 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a80b3bd66acc52ff(show(a));
    };
};
var $78386b654cef599e$export$a188e271553f9211 = function(name) {
    return function(inner) {
        return function __do() {
            $93c729927fdf3160$export$e5e25fbcc1f7affe(name)();
            var result = inner();
            $93c729927fdf3160$export$a57f3dfe595273e6();
            return result;
        };
    };
};
var $78386b654cef599e$export$cbd229996ecd7704 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a3bc9b8ed74fc(show(a));
    };
};
var $78386b654cef599e$export$18fab8ed91d044eb = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$1c9f709888824e05(show(a));
    };
};




// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
const $99af8ad7682e39c7$export$260e5c0943f31606 = function(thunk) {
    var v = null;
    return function() {
        if (thunk === undefined) return v;
        v = thunk();
        thunk = undefined; // eslint-disable-line no-param-reassign
        return v;
    };
};
const $99af8ad7682e39c7$export$4d82290515cd0ddb = function(l) {
    return l();
};



















var $73aa5dd1904ebcb7$export$bb0ce398898c1c48 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(x) {
            return "(defer \\_ -> " + (show($99af8ad7682e39c7$export$4d82290515cd0ddb(x)) + ")");
        }
    };
};
var $73aa5dd1904ebcb7$export$a23c81c7931f53a = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return add($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        zero: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return zero;
        }),
        mul: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mul($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        one: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return one;
        })
    };
};
var $73aa5dd1904ebcb7$export$8400f884b0cf16b1 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return append1($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$6dfc43186b725e5c = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringLazy1 = $73aa5dd1904ebcb7$export$a23c81c7931f53a(dictRing.Semiring0());
    return {
        sub: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return sub($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        Semiring0: function() {
            return semiringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$fe3e07ed2de45f8f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupLazy1 = $73aa5dd1904ebcb7$export$8400f884b0cf16b1(dictMonoid.Semigroup0());
    return {
        mempty: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$56fd27feb83d90f5 = {
    defer: function(f) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($05149ea687d6b460$export$523c0b569236b342));
        });
    }
};
var $73aa5dd1904ebcb7$export$3780b8670d5f24f8 = {
    map: function(f) {
        return function(l) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            });
        };
    }
};
var $73aa5dd1904ebcb7$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $73aa5dd1904ebcb7$export$8f588843775274ce = {
    mapWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$3bd0a60cfec06f1a = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($73aa5dd1904ebcb7$export$3780b8670d5f24f8)
};
var $73aa5dd1904ebcb7$export$6ad686e404b9cd02 = {
    foldr: function(f) {
        return function(z) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l))(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(l) {
                return f(z)($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    }
};
var $73aa5dd1904ebcb7$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$export$c99a011ac0d986c7 = {
    foldrWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap1 = $73aa5dd1904ebcb7$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$d75b77350c4c9111 = {
    traverse: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(l) {
                return map1(function($103) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($103));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(l) {
            return map1(function($104) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($104));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    },
    Foldable1: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($73aa5dd1904ebcb7$export$d75b77350c4c9111);
var $73aa5dd1904ebcb7$export$1c9f73288a97bff6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse1 = $73aa5dd1904ebcb7$var$traverse(dictApplicative);
        return function(f) {
            return traverse1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $73aa5dd1904ebcb7$export$8f588843775274ce;
    },
    FoldableWithIndex1: function() {
        return $73aa5dd1904ebcb7$export$c99a011ac0d986c7;
    },
    Traversable2: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$8d84e581926eaeba = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldr1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    foldl1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$316fa2792966d831 = {
    traverse1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(l) {
                return map1(function($105) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($105));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(l) {
            return map1(function($106) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($106));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Foldable10: function() {
        return $73aa5dd1904ebcb7$export$8d84e581926eaeba;
    },
    Traversable1: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$5db1a0137683eb80 = {
    extend: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f(x);
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqLazy1 = $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        },
        Eq0: function() {
            return eqLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$4fb3dc255b34fa12 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictEq));
    }
};
var $73aa5dd1904ebcb7$export$d65b504a31b57308 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictOrd));
    },
    Eq10: function() {
        return $73aa5dd1904ebcb7$export$4fb3dc255b34fa12;
    }
};
var $73aa5dd1904ebcb7$export$544fccaec3eca1d4 = {
    extract: $99af8ad7682e39c7$export$4d82290515cd0ddb,
    Extend0: function() {
        return $73aa5dd1904ebcb7$export$5db1a0137683eb80;
    }
};
var $73aa5dd1904ebcb7$export$b0aa908a8262dbd4 = function(dictCommutativeRing) {
    var ringLazy1 = $73aa5dd1904ebcb7$export$6dfc43186b725e5c(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$d150da49d30e2076 = function(dictEuclideanRing) {
    var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
    var mod = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
    var commutativeRingLazy1 = $73aa5dd1904ebcb7$export$b0aa908a8262dbd4(dictEuclideanRing.CommutativeRing0());
    return {
        degree: function() {
            var $107 = $b0cd729514c2504e$export$a23b7da4bc008930(dictEuclideanRing);
            return function($108) {
                return $107($99af8ad7682e39c7$export$4d82290515cd0ddb($108));
            };
        }(),
        div: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return div($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        mod: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mod($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        CommutativeRing0: function() {
            return commutativeRingLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$aabc837ad904b190 = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordLazy1 = $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictBounded.Ord0());
    return {
        top: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return top;
        }),
        bottom: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return bottom;
        }),
        Ord0: function() {
            return ordLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$c3ec2aebe6109e81 = {
    apply: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f)($99af8ad7682e39c7$export$4d82290515cd0ddb(x));
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
var $73aa5dd1904ebcb7$export$e1a4485e8a67faf2 = {
    bind: function(l) {
        return function(f) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            });
        };
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$89956d4f263e939b = function(dictHeytingAlgebra) {
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return ff;
        }),
        tt: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return tt;
        }),
        implies: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(implies)(a))(b);
            };
        },
        conj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(conj)(a))(b);
            };
        },
        disj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(disj)(a))(b);
            };
        },
        not: function(a) {
            return $73aa5dd1904ebcb7$var$map(not)(a);
        }
    };
};
var $73aa5dd1904ebcb7$export$27ff7cba27a505be = function(dictBooleanAlgebra) {
    var heytingAlgebraLazy1 = $73aa5dd1904ebcb7$export$89956d4f263e939b(dictBooleanAlgebra.HeytingAlgebra0());
    return {
        HeytingAlgebra0: function() {
            return heytingAlgebraLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$28587442a46d4141 = {
    pure: function(a) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return a;
        });
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$cfa2e2b570f2d5d3 = {
    Applicative0: function() {
        return $73aa5dd1904ebcb7$export$28587442a46d4141;
    },
    Bind1: function() {
        return $73aa5dd1904ebcb7$export$e1a4485e8a67faf2;
    }
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15










// Generated by purs version 0.15.15

var $b890a9c9ccf92ae9$export$49a1dce2f81a97d6 = $ac8b3532514ac019$export$401372c57776dc;
var $b890a9c9ccf92ae9$export$7488c940d035302c = $ac8b3532514ac019$export$401372c57776dc;









var $026fde5446dd624a$var$CoyonedaF = /* #__PURE__ */ function() {
    function CoyonedaF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CoyonedaF.create = function(value0) {
        return function(value1) {
            return new CoyonedaF(value0, value1);
        };
    };
    return CoyonedaF;
}();
var $026fde5446dd624a$export$518a6adb5ee0288f = function(x) {
    return x;
};
var $026fde5446dd624a$export$1088317934ed5679 = function(f) {
    return function(v) {
        return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
            return f(v1.value0)(v1.value1);
        })(v);
    };
};
var $026fde5446dd624a$export$36cf4525d9d7ca3c = function(dictFunctor) {
    return $026fde5446dd624a$export$1088317934ed5679($f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor));
};
var $026fde5446dd624a$export$e10932df6e0657f1 = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldr(function($175) {
                        return f(k($175));
                    })(z);
                });
            };
        },
        foldl: function(f) {
            return function(z) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldl(function(x) {
                        var $176 = f(x);
                        return function($177) {
                            return $176(k($177));
                        };
                    })(z);
                });
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap1(function($178) {
                        return f(k($178));
                    });
                });
            };
        }
    };
};
var $026fde5446dd624a$export$bd381ac72ce00e4e = function(dictFoldable1) {
    var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictFoldable1.Foldable0());
    return {
        foldMap1: function(dictSemigroup) {
            var foldMap11 = foldMap1(dictSemigroup);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    return foldMap11(function($179) {
                        return f(k($179));
                    });
                });
            };
        },
        foldr1: $086486679aa806fa$export$8af34898c082e678($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        foldl1: $086486679aa806fa$export$8dd52a2a23ae4dc4($026fde5446dd624a$export$bd381ac72ce00e4e(dictFoldable1)),
        Foldable0: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$4c17598ac057c221 = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
        return function(dictEq) {
            var eq11 = eq1(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        return eq11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                }
            };
        };
    };
};
var $026fde5446dd624a$export$e3d23e83f1d891bb = function(dictFunctor) {
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictFunctor);
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
        var eqCoyoneda2 = eqCoyoneda1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(dictOrd);
            var eqCoyoneda3 = eqCoyoneda2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        return compare11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                },
                Eq0: function() {
                    return eqCoyoneda3;
                }
            };
        };
    };
};
var $026fde5446dd624a$export$8fee22dc2f6f5e8 = function(dictFunctor) {
    var eqCoyoneda1 = $026fde5446dd624a$export$4c17598ac057c221(dictFunctor);
    return function(dictEq1) {
        var eqCoyoneda2 = eqCoyoneda1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCoyoneda2(dictEq));
            }
        };
    };
};
var $026fde5446dd624a$export$72164df904554716 = function(dictFunctor) {
    var ordCoyoneda1 = $026fde5446dd624a$export$e3d23e83f1d891bb(dictFunctor);
    var eq1Coyoneda1 = $026fde5446dd624a$export$8fee22dc2f6f5e8(dictFunctor);
    return function(dictOrd1) {
        var ordCoyoneda2 = ordCoyoneda1(dictOrd1);
        var eq1Coyoneda2 = eq1Coyoneda1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordCoyoneda2(dictOrd));
            },
            Eq10: function() {
                return eq1Coyoneda2;
            }
        };
    };
};
var $026fde5446dd624a$export$cc61df270d10d232 = function(k) {
    return function(fi) {
        return $b890a9c9ccf92ae9$export$7488c940d035302c(new $026fde5446dd624a$var$CoyonedaF(k, fi));
    };
};
var $026fde5446dd624a$export$bd40aba71422b460 = {
    map: function(f) {
        return function(v) {
            return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                return $026fde5446dd624a$export$cc61df270d10d232(function($180) {
                    return f(v1.value0($180));
                })(v1.value1);
            })(v);
        };
    }
};
var $026fde5446dd624a$export$4b21c9b3969f8a88 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($026fde5446dd624a$export$bd40aba71422b460)
};
var $026fde5446dd624a$export$782bd81bf3515665 = function(nat) {
    return function(v) {
        return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
            return $026fde5446dd624a$export$cc61df270d10d232(v1.value0)(nat(v1.value1));
        })(v);
    };
};
var $026fde5446dd624a$export$6320c031d6b6270f = /* #__PURE__ */ $026fde5446dd624a$export$cc61df270d10d232(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $026fde5446dd624a$export$215969f5aee12fc3 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictDistributive.Functor0());
    return {
        collect: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                var $181 = collect1(function($183) {
                    return lowerCoyoneda1(f($183));
                });
                return function($182) {
                    return $026fde5446dd624a$export$6320c031d6b6270f($181($182));
                };
            };
        },
        distribute: function(dictFunctor) {
            var $184 = collect(dictFunctor)(lowerCoyoneda1);
            return function($185) {
                return $026fde5446dd624a$export$6320c031d6b6270f($184($185));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$946e5a80c258b6f7 = function(dictExtend) {
    var extend = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return {
        extend: function(f) {
            return function(v) {
                return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                    return $026fde5446dd624a$export$6320c031d6b6270f(extend(function() {
                        var $186 = $026fde5446dd624a$export$cc61df270d10d232(v1.value0);
                        return function($187) {
                            return f($186($187));
                        };
                    }())(v1.value1));
                })(v);
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$1a78c49d463144db = {
    lift: function(dictMonad) {
        return $026fde5446dd624a$export$6320c031d6b6270f;
    }
};
var $026fde5446dd624a$export$d249e493735a3666 = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var foldableCoyoneda1 = $026fde5446dd624a$export$e10932df6e0657f1(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $188 = map($026fde5446dd624a$export$6320c031d6b6270f);
                    var $189 = traverse1(function($191) {
                        return f(k($191));
                    });
                    return function($190) {
                        return $188($189($190));
                    };
                });
            };
        },
        sequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $192 = map($026fde5446dd624a$export$6320c031d6b6270f);
                var $193 = traverse1(k);
                return function($194) {
                    return $192($193($194));
                };
            });
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        },
        Foldable1: function() {
            return foldableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$592beb634cc81a68 = function(dictTraversable1) {
    var traverse1 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    var sequence1 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var Traversable1 = dictTraversable1.Traversable1();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Traversable1.Functor0());
    var foldable1Coyoneda1 = $026fde5446dd624a$export$bd381ac72ce00e4e(dictTraversable1.Foldable10());
    var traversableCoyoneda1 = $026fde5446dd624a$export$d249e493735a3666(Traversable1);
    return {
        traverse1: function(dictApply) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
            var traverse11 = traverse1(dictApply);
            return function(f) {
                return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                    var $195 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                    var $196 = traverse11(function($198) {
                        return f(k($198));
                    });
                    return function($197) {
                        return $195($196($197));
                    };
                });
            };
        },
        sequence1: function(dictApply) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
            var sequence11 = sequence1(dictApply);
            return $026fde5446dd624a$export$1088317934ed5679(function(k) {
                var $199 = map1($026fde5446dd624a$export$6320c031d6b6270f);
                var $200 = map(k);
                return function($201) {
                    return $199(sequence11($200($201)));
                };
            });
        },
        Foldable10: function() {
            return foldable1Coyoneda1;
        },
        Traversable1: function() {
            return traversableCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$3a5b6268908c7242 = function(dictComonad) {
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var extendCoyoneda1 = $026fde5446dd624a$export$946e5a80c258b6f7(dictComonad.Extend0());
    return {
        extract: function(v) {
            return $b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                return v1.value0(extract(v1.value1));
            })(v);
        },
        Extend0: function() {
            return extendCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$96fda80da8742a6b = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictApply.Functor0());
    return {
        apply: function(f) {
            return function(g) {
                return $026fde5446dd624a$export$6320c031d6b6270f(apply(lowerCoyoneda1(f))(lowerCoyoneda1(g)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$ef5b465291a6417e = function(dictBind) {
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    var Apply0 = dictBind.Apply0();
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(Apply0.Functor0());
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(Apply0);
    return {
        bind: function(v) {
            return function(f) {
                return $026fde5446dd624a$export$6320c031d6b6270f($b890a9c9ccf92ae9$export$49a1dce2f81a97d6(function(v1) {
                    return bindFlipped(function($202) {
                        return lowerCoyoneda1(f(v1.value0($202)));
                    })(v1.value1);
                })(v));
            };
        },
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$d337c8e043437698 = function(dictApplicative) {
    var applyCoyoneda1 = $026fde5446dd624a$export$96fda80da8742a6b(dictApplicative.Apply0());
    return {
        pure: function() {
            var $203 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($204) {
                return $026fde5446dd624a$export$6320c031d6b6270f($203($204));
            };
        }(),
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$dfa10a61f5e8217c = function(dictMonad) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictMonad.Applicative0());
    var bindCoyoneda1 = $026fde5446dd624a$export$ef5b465291a6417e(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Bind1: function() {
            return bindCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$daa4182a46d81e3 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var lowerCoyoneda1 = $026fde5446dd624a$export$36cf4525d9d7ca3c(dictAlt.Functor0());
    return {
        alt: function(x) {
            return function(y) {
                return $026fde5446dd624a$export$6320c031d6b6270f(alt(lowerCoyoneda1(x))(lowerCoyoneda1(y)));
            };
        },
        Functor0: function() {
            return $026fde5446dd624a$export$bd40aba71422b460;
        }
    };
};
var $026fde5446dd624a$export$f434c65db07c2e04 = function(dictPlus) {
    var altCoyoneda1 = $026fde5446dd624a$export$daa4182a46d81e3(dictPlus.Alt0());
    return {
        empty: $026fde5446dd624a$export$6320c031d6b6270f($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus)),
        Alt0: function() {
            return altCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$15bae6aadce01350 = function(dictAlternative) {
    var applicativeCoyoneda1 = $026fde5446dd624a$export$d337c8e043437698(dictAlternative.Applicative0());
    var plusCoyoneda1 = $026fde5446dd624a$export$f434c65db07c2e04(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Plus1: function() {
            return plusCoyoneda1;
        }
    };
};
var $026fde5446dd624a$export$e819965db94a810a = function(dictMonadPlus) {
    var monadCoyoneda1 = $026fde5446dd624a$export$dfa10a61f5e8217c(dictMonadPlus.Monad0());
    var alternativeCoyoneda1 = $026fde5446dd624a$export$15bae6aadce01350(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadCoyoneda1;
        },
        Alternative1: function() {
            return alternativeCoyoneda1;
        }
    };
};







// Generated by purs version 0.15.15




// Generated by purs version 0.15.15



var $d6e193625ed1395d$export$f120638069846a46 = function(x) {
    return x;
};
var $d6e193625ed1395d$export$f0a5727b2ca16d5e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Alternate " + (show(v) + ")");
        }
    };
};
var $d6e193625ed1395d$export$74ec47bea0d6428d = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    return {
        append: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        }
    };
};
var $d6e193625ed1395d$export$aa34ebff6fae0aee = function(dictPlus) {
    return dictPlus;
};
var $d6e193625ed1395d$export$19a135ecc0f14c10 = function(dictOrd) {
    return dictOrd;
};
var $d6e193625ed1395d$export$48cb8ce12ac615c3 = function(dictOrd1) {
    return dictOrd1;
};
var $d6e193625ed1395d$export$bbb1334b7c1198d0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d6e193625ed1395d$export$6e373ee97dbd5f68 = function(dictPlus) {
    var semigroupAlternate1 = $d6e193625ed1395d$export$74ec47bea0d6428d(dictPlus.Alt0());
    return {
        mempty: $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus),
        Semigroup0: function() {
            return semigroupAlternate1;
        }
    };
};
var $d6e193625ed1395d$export$748db8accd45ad60 = function(dictMonad) {
    return dictMonad;
};
var $d6e193625ed1395d$export$912ca5da2b71dd9f = function(dictFunctor) {
    return dictFunctor;
};
var $d6e193625ed1395d$export$45877b7cfa857b08 = function(dictExtend) {
    return dictExtend;
};
var $d6e193625ed1395d$export$744ff834b4c5965c = function(dictEq) {
    return dictEq;
};
var $d6e193625ed1395d$export$d92024b57d6b2a3c = function(dictEq1) {
    return dictEq1;
};
var $d6e193625ed1395d$export$eecf6e094270f0ca = function(dictComonad) {
    return dictComonad;
};
var $d6e193625ed1395d$export$d72d6cfff25c7246 = function(dictBounded) {
    return dictBounded;
};
var $d6e193625ed1395d$export$8c4b2dd7bc59a54a = function(dictBind) {
    return dictBind;
};
var $d6e193625ed1395d$export$cddaca6aae5306c4 = function(dictApply) {
    return dictApply;
};
var $d6e193625ed1395d$export$3655a3e6b92e2b2a = function(dictApplicative) {
    return dictApplicative;
};
var $d6e193625ed1395d$export$a428b63860a2744 = function(dictAlternative) {
    return dictAlternative;
};
var $d6e193625ed1395d$export$ca414a3aae651090 = function(dictAlt) {
    return dictAlt;
};






// Generated by purs version 0.15.15


var $f9a2039294f26822$var$OrdBox = /* #__PURE__ */ function() {
    function OrdBox(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    OrdBox.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new OrdBox(value0, value1, value2);
            };
        };
    };
    return OrdBox;
}();
var $f9a2039294f26822$export$6a3ff69c92a20cd2 = function(v) {
    return v.value2;
};
var $f9a2039294f26822$export$c2a88327b4ac50f8 = function(dictOrd) {
    return $f9a2039294f26822$var$OrdBox.create($37b880af5f4991bd$export$9663ddc1cf085b32(dictOrd.Eq0()))($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $f9a2039294f26822$export$1aabb6943cc59794 = {
    eq: function(v) {
        return function(v1) {
            return v.value0(v.value2)(v1.value2);
        };
    }
};
var $f9a2039294f26822$export$a4fa2470ead172bd = {
    compare: function(v) {
        return function(v1) {
            return v.value1(v.value2)(v1.value2);
        };
    },
    Eq0: function() {
        return $f9a2039294f26822$export$1aabb6943cc59794;
    }
};


var $0f3b7f18059106fc$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $0f3b7f18059106fc$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)($f9a2039294f26822$export$a4fa2470ead172bd);
var $0f3b7f18059106fc$var$foldSubmap = /* #__PURE__ */ $ea3eb84de0acf574$export$3f9a381f67a51fcd($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$pop1 = /* #__PURE__ */ $ea3eb84de0acf574$export$3e41007ebfff0e64($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($0f3b7f18059106fc$var$ordTuple);
var $0f3b7f18059106fc$var$SlotStorage = function(x) {
    return x;
};
var $0f3b7f18059106fc$export$bbd679b9fab4c947 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var foldSubmap1 = $0f3b7f18059106fc$var$foldSubmap($d6e193625ed1395d$export$6e373ee97dbd5f68($ea3eb84de0acf574$export$4c085c510196daa3(dictOrd)));
            return function(sym) {
                return function(v) {
                    var key = reflectSymbol(sym);
                    var go = function(v1) {
                        return function(val) {
                            if (key === v1.value0) return $ea3eb84de0acf574$export$439306a4dcaafbb9($f9a2039294f26822$export$6a3ff69c92a20cd2(v1.value1))(val);
                            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$6e22c362a0406a2c;
                            throw new Error("Failed pattern match at Halogen.Data.Slot (line 121, column 3 - line 123, column 38): " + [
                                v1.constructor.name,
                                val.constructor.name
                            ]);
                        };
                    };
                    return $0f3b7f18059106fc$var$un($d6e193625ed1395d$export$f120638069846a46)(foldSubmap1($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)(v));
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$3e41007ebfff0e64 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$pop1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$dfc7155ac0343b8 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $0f3b7f18059106fc$var$lookup1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$21a5ca8aa77d35ff = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $f9a2039294f26822$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(val) {
                        return function(v) {
                            return $0f3b7f18059106fc$var$insert1(new $71f2e2e9476163f8$export$1908877435b1d5e9(reflectSymbol(sym), mkOrdBox(key)))(val)(v);
                        };
                    };
                };
            };
        };
    };
};
var $0f3b7f18059106fc$export$91dbfdfb14db6990 = function(dictApplicative) {
    var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative)($ea3eb84de0acf574$export$4295a0c2ad7aa544);
    return function(v) {
        return function(k) {
            return traverse_(function($54) {
                return k($54);
            })(v);
        };
    };
};
var $0f3b7f18059106fc$export$6e22c362a0406a2c = $ea3eb84de0acf574$export$6e22c362a0406a2c;


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15

var $4d40d048175dacfe$export$7ba2b3d677b0db1c = /* #__PURE__ */ function() {
    function AutocompleteOff() {}
    AutocompleteOff.value = new AutocompleteOff();
    return AutocompleteOff;
}();
var $4d40d048175dacfe$export$1ef0df3f3e6a4dab = /* #__PURE__ */ function() {
    function AutocompleteOn() {}
    AutocompleteOn.value = new AutocompleteOn();
    return AutocompleteOn;
}();
var $4d40d048175dacfe$export$4da01cb598a0d97e = /* #__PURE__ */ function() {
    function AutocompleteName() {}
    AutocompleteName.value = new AutocompleteName();
    return AutocompleteName;
}();
var $4d40d048175dacfe$export$ccb63fd7a749a381 = /* #__PURE__ */ function() {
    function AutocompleteHonorificPrefix() {}
    AutocompleteHonorificPrefix.value = new AutocompleteHonorificPrefix();
    return AutocompleteHonorificPrefix;
}();
var $4d40d048175dacfe$export$a2e3a2bb787472eb = /* #__PURE__ */ function() {
    function AutocompleteGivenName() {}
    AutocompleteGivenName.value = new AutocompleteGivenName();
    return AutocompleteGivenName;
}();
var $4d40d048175dacfe$export$c2899da73c95f826 = /* #__PURE__ */ function() {
    function AutocompleteAdditionalName() {}
    AutocompleteAdditionalName.value = new AutocompleteAdditionalName();
    return AutocompleteAdditionalName;
}();
var $4d40d048175dacfe$export$b189863462ae27fe = /* #__PURE__ */ function() {
    function AutocompleteFamilyName() {}
    AutocompleteFamilyName.value = new AutocompleteFamilyName();
    return AutocompleteFamilyName;
}();
var $4d40d048175dacfe$export$5481c9b080fac1ad = /* #__PURE__ */ function() {
    function AutocompleteHonorificSuffix() {}
    AutocompleteHonorificSuffix.value = new AutocompleteHonorificSuffix();
    return AutocompleteHonorificSuffix;
}();
var $4d40d048175dacfe$export$ed6c67e3f00c02f7 = /* #__PURE__ */ function() {
    function AutocompleteNickname() {}
    AutocompleteNickname.value = new AutocompleteNickname();
    return AutocompleteNickname;
}();
var $4d40d048175dacfe$export$3f2abff6b2574d28 = /* #__PURE__ */ function() {
    function AutocompleteEmail() {}
    AutocompleteEmail.value = new AutocompleteEmail();
    return AutocompleteEmail;
}();
var $4d40d048175dacfe$export$8ef7db4a55783560 = /* #__PURE__ */ function() {
    function AutocompleteUsername() {}
    AutocompleteUsername.value = new AutocompleteUsername();
    return AutocompleteUsername;
}();
var $4d40d048175dacfe$export$2aec4081bfc982fb = /* #__PURE__ */ function() {
    function AutocompleteNewPassword() {}
    AutocompleteNewPassword.value = new AutocompleteNewPassword();
    return AutocompleteNewPassword;
}();
var $4d40d048175dacfe$export$8ee6fb6ac028afda = /* #__PURE__ */ function() {
    function AutocompleteCurrentPassword() {}
    AutocompleteCurrentPassword.value = new AutocompleteCurrentPassword();
    return AutocompleteCurrentPassword;
}();
var $4d40d048175dacfe$export$6f27218568808639 = /* #__PURE__ */ function() {
    function AutocompleteOneTimeCode() {}
    AutocompleteOneTimeCode.value = new AutocompleteOneTimeCode();
    return AutocompleteOneTimeCode;
}();
var $4d40d048175dacfe$export$9748581da6bbbe4e = /* #__PURE__ */ function() {
    function AutocompleteOrganizationTitle() {}
    AutocompleteOrganizationTitle.value = new AutocompleteOrganizationTitle();
    return AutocompleteOrganizationTitle;
}();
var $4d40d048175dacfe$export$5fd9f780846e028b = /* #__PURE__ */ function() {
    function AutocompleteOrganization() {}
    AutocompleteOrganization.value = new AutocompleteOrganization();
    return AutocompleteOrganization;
}();
var $4d40d048175dacfe$export$499720fb85152dfe = /* #__PURE__ */ function() {
    function AutocompleteStreetAddress() {}
    AutocompleteStreetAddress.value = new AutocompleteStreetAddress();
    return AutocompleteStreetAddress;
}();
var $4d40d048175dacfe$export$6b6488e90da63d6 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine1() {}
    AutocompleteAddressLine1.value = new AutocompleteAddressLine1();
    return AutocompleteAddressLine1;
}();
var $4d40d048175dacfe$export$92dfe98bc9dbafde = /* #__PURE__ */ function() {
    function AutocompleteAddressLine2() {}
    AutocompleteAddressLine2.value = new AutocompleteAddressLine2();
    return AutocompleteAddressLine2;
}();
var $4d40d048175dacfe$export$ea74132c1bd19261 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine3() {}
    AutocompleteAddressLine3.value = new AutocompleteAddressLine3();
    return AutocompleteAddressLine3;
}();
var $4d40d048175dacfe$export$e5454c7695ddbd5c = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel1() {}
    AutocompleteAddressLevel1.value = new AutocompleteAddressLevel1();
    return AutocompleteAddressLevel1;
}();
var $4d40d048175dacfe$export$af0e2cc0795570d9 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel2() {}
    AutocompleteAddressLevel2.value = new AutocompleteAddressLevel2();
    return AutocompleteAddressLevel2;
}();
var $4d40d048175dacfe$export$f76ce82784afe674 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel3() {}
    AutocompleteAddressLevel3.value = new AutocompleteAddressLevel3();
    return AutocompleteAddressLevel3;
}();
var $4d40d048175dacfe$export$5f9c079ff6708773 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel4() {}
    AutocompleteAddressLevel4.value = new AutocompleteAddressLevel4();
    return AutocompleteAddressLevel4;
}();
var $4d40d048175dacfe$export$44c5bb026cbe6e37 = /* #__PURE__ */ function() {
    function AutocompleteCountry() {}
    AutocompleteCountry.value = new AutocompleteCountry();
    return AutocompleteCountry;
}();
var $4d40d048175dacfe$export$e259ef3995a99fd4 = /* #__PURE__ */ function() {
    function AutocompleteCountryName() {}
    AutocompleteCountryName.value = new AutocompleteCountryName();
    return AutocompleteCountryName;
}();
var $4d40d048175dacfe$export$f95f909e01aa4cb3 = /* #__PURE__ */ function() {
    function AutocompletePostalCode() {}
    AutocompletePostalCode.value = new AutocompletePostalCode();
    return AutocompletePostalCode;
}();
var $4d40d048175dacfe$export$67ade628725afe90 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardName() {}
    AutocompleteCreditCardName.value = new AutocompleteCreditCardName();
    return AutocompleteCreditCardName;
}();
var $4d40d048175dacfe$export$f03ef3c27a8e4a4b = /* #__PURE__ */ function() {
    function AutocompleteCreditCardGivenName() {}
    AutocompleteCreditCardGivenName.value = new AutocompleteCreditCardGivenName();
    return AutocompleteCreditCardGivenName;
}();
var $4d40d048175dacfe$export$1b45801580e5182f = /* #__PURE__ */ function() {
    function AutocompleteCreditCardAdditionalName() {}
    AutocompleteCreditCardAdditionalName.value = new AutocompleteCreditCardAdditionalName();
    return AutocompleteCreditCardAdditionalName;
}();
var $4d40d048175dacfe$export$d906c17550f3b6f1 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardFamilyName() {}
    AutocompleteCreditCardFamilyName.value = new AutocompleteCreditCardFamilyName();
    return AutocompleteCreditCardFamilyName;
}();
var $4d40d048175dacfe$export$267a9616c09f33fa = /* #__PURE__ */ function() {
    function AutocompleteCreditCardNumber() {}
    AutocompleteCreditCardNumber.value = new AutocompleteCreditCardNumber();
    return AutocompleteCreditCardNumber;
}();
var $4d40d048175dacfe$export$4ac537c498251bbf = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpiration() {}
    AutocompleteCreditCardExpiration.value = new AutocompleteCreditCardExpiration();
    return AutocompleteCreditCardExpiration;
}();
var $4d40d048175dacfe$export$2e15cf96bd811454 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationMonth() {}
    AutocompleteCreditCardExpirationMonth.value = new AutocompleteCreditCardExpirationMonth();
    return AutocompleteCreditCardExpirationMonth;
}();
var $4d40d048175dacfe$export$7c4efb1d2d0a7d5d = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationYear() {}
    AutocompleteCreditCardExpirationYear.value = new AutocompleteCreditCardExpirationYear();
    return AutocompleteCreditCardExpirationYear;
}();
var $4d40d048175dacfe$export$42f27b71e570e84c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardSecurityCode() {}
    AutocompleteCreditCardSecurityCode.value = new AutocompleteCreditCardSecurityCode();
    return AutocompleteCreditCardSecurityCode;
}();
var $4d40d048175dacfe$export$7dd055ac3e2d902c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardType() {}
    AutocompleteCreditCardType.value = new AutocompleteCreditCardType();
    return AutocompleteCreditCardType;
}();
var $4d40d048175dacfe$export$918eb55efc9f2e5c = /* #__PURE__ */ function() {
    function AutocompleteTransactionCurrency() {}
    AutocompleteTransactionCurrency.value = new AutocompleteTransactionCurrency();
    return AutocompleteTransactionCurrency;
}();
var $4d40d048175dacfe$export$9d4a96b43ef247de = /* #__PURE__ */ function() {
    function AutocompleteTransactionAmount() {}
    AutocompleteTransactionAmount.value = new AutocompleteTransactionAmount();
    return AutocompleteTransactionAmount;
}();
var $4d40d048175dacfe$export$f69bc69473d6d1fa = /* #__PURE__ */ function() {
    function AutocompleteLanguage() {}
    AutocompleteLanguage.value = new AutocompleteLanguage();
    return AutocompleteLanguage;
}();
var $4d40d048175dacfe$export$db103677e4262f74 = /* #__PURE__ */ function() {
    function AutocompleteBirthday() {}
    AutocompleteBirthday.value = new AutocompleteBirthday();
    return AutocompleteBirthday;
}();
var $4d40d048175dacfe$export$976267f1375fd072 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayDay() {}
    AutocompleteBirthdayDay.value = new AutocompleteBirthdayDay();
    return AutocompleteBirthdayDay;
}();
var $4d40d048175dacfe$export$345017daa9311763 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayMonth() {}
    AutocompleteBirthdayMonth.value = new AutocompleteBirthdayMonth();
    return AutocompleteBirthdayMonth;
}();
var $4d40d048175dacfe$export$a58218c48fdc359f = /* #__PURE__ */ function() {
    function AutocompleteBirthdayYear() {}
    AutocompleteBirthdayYear.value = new AutocompleteBirthdayYear();
    return AutocompleteBirthdayYear;
}();
var $4d40d048175dacfe$export$41a3d5735ecfd56f = /* #__PURE__ */ function() {
    function AutocompleteSex() {}
    AutocompleteSex.value = new AutocompleteSex();
    return AutocompleteSex;
}();
var $4d40d048175dacfe$export$dc25bbd279bd7147 = /* #__PURE__ */ function() {
    function AutocompleteTelephone() {}
    AutocompleteTelephone.value = new AutocompleteTelephone();
    return AutocompleteTelephone;
}();
var $4d40d048175dacfe$export$f37489576ac4e3f5 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneCountryCode() {}
    AutocompleteTelephoneCountryCode.value = new AutocompleteTelephoneCountryCode();
    return AutocompleteTelephoneCountryCode;
}();
var $4d40d048175dacfe$export$85265d7dd09c0246 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneNational() {}
    AutocompleteTelephoneNational.value = new AutocompleteTelephoneNational();
    return AutocompleteTelephoneNational;
}();
var $4d40d048175dacfe$export$fb4e6d66ca842722 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneAreaCode() {}
    AutocompleteTelephoneAreaCode.value = new AutocompleteTelephoneAreaCode();
    return AutocompleteTelephoneAreaCode;
}();
var $4d40d048175dacfe$export$149dc202c94ba771 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocal() {}
    AutocompleteTelephoneLocal.value = new AutocompleteTelephoneLocal();
    return AutocompleteTelephoneLocal;
}();
var $4d40d048175dacfe$export$c3fb770456fc7a2e = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalPrefix() {}
    AutocompleteTelephoneLocalPrefix.value = new AutocompleteTelephoneLocalPrefix();
    return AutocompleteTelephoneLocalPrefix;
}();
var $4d40d048175dacfe$export$97df2b5615a1b054 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalSuffix() {}
    AutocompleteTelephoneLocalSuffix.value = new AutocompleteTelephoneLocalSuffix();
    return AutocompleteTelephoneLocalSuffix;
}();
var $4d40d048175dacfe$export$7aa0294a80b301d4 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneExtension() {}
    AutocompleteTelephoneExtension.value = new AutocompleteTelephoneExtension();
    return AutocompleteTelephoneExtension;
}();
var $4d40d048175dacfe$export$1294e96da410451d = /* #__PURE__ */ function() {
    function AutocompleteIMPP() {}
    AutocompleteIMPP.value = new AutocompleteIMPP();
    return AutocompleteIMPP;
}();
var $4d40d048175dacfe$export$acf71e1d98edce93 = /* #__PURE__ */ function() {
    function AutocompleteURL() {}
    AutocompleteURL.value = new AutocompleteURL();
    return AutocompleteURL;
}();
var $4d40d048175dacfe$export$7a4045fb80d6a5eb = /* #__PURE__ */ function() {
    function AutocompletePhoto() {}
    AutocompletePhoto.value = new AutocompletePhoto();
    return AutocompletePhoto;
}();
var $4d40d048175dacfe$export$9b8eae2964bb4cd5 = function(v) {
    if (v instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return "off";
    if (v instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return "on";
    if (v instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return "name";
    if (v instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return "honorific-prefix";
    if (v instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return "given-name";
    if (v instanceof $4d40d048175dacfe$export$c2899da73c95f826) return "additional-name";
    if (v instanceof $4d40d048175dacfe$export$b189863462ae27fe) return "family-name";
    if (v instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return "honorific-suffix";
    if (v instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return "nickname";
    if (v instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return "email";
    if (v instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return "username";
    if (v instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return "new-password";
    if (v instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return "current-password";
    if (v instanceof $4d40d048175dacfe$export$6f27218568808639) return "one-time-code";
    if (v instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return "organization-title";
    if (v instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return "organization";
    if (v instanceof $4d40d048175dacfe$export$499720fb85152dfe) return "street-address";
    if (v instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return "address-line1";
    if (v instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return "address-line2";
    if (v instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return "address-line3";
    if (v instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return "address-level1";
    if (v instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return "address-level2";
    if (v instanceof $4d40d048175dacfe$export$f76ce82784afe674) return "address-level3";
    if (v instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return "address-level4";
    if (v instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return "country";
    if (v instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return "country-name";
    if (v instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return "postal-code";
    if (v instanceof $4d40d048175dacfe$export$67ade628725afe90) return "cc-name";
    if (v instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return "cc-given-name";
    if (v instanceof $4d40d048175dacfe$export$1b45801580e5182f) return "cc-additional-name";
    if (v instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return "cc-family-name";
    if (v instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return "cc-number";
    if (v instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return "cc-exp";
    if (v instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return "cc-exp-month";
    if (v instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return "cc-exp-year";
    if (v instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return "cc-csc";
    if (v instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return "cc-type";
    if (v instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return "transaction-currency";
    if (v instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return "transaction-amount";
    if (v instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return "language";
    if (v instanceof $4d40d048175dacfe$export$db103677e4262f74) return "bday";
    if (v instanceof $4d40d048175dacfe$export$976267f1375fd072) return "bday-day";
    if (v instanceof $4d40d048175dacfe$export$345017daa9311763) return "bday-month";
    if (v instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return "bday-year";
    if (v instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return "sex";
    if (v instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return "tel";
    if (v instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return "tel-country-code";
    if (v instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return "tel-national";
    if (v instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return "telarea-code";
    if (v instanceof $4d40d048175dacfe$export$149dc202c94ba771) return "tel-local";
    if (v instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return "tel-local-prefix";
    if (v instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return "tel-local-suffix";
    if (v instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return "tel-extension";
    if (v instanceof $4d40d048175dacfe$export$1294e96da410451d) return "impp";
    if (v instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return "url";
    if (v instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return "photo";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 67, column 26 - line 123, column 31): " + [
        v.constructor.name
    ]);
};
var $4d40d048175dacfe$export$51a22934b9cdbac4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return true;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return true;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return true;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return true;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return true;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return true;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return true;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return true;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return true;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return true;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return true;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return true;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return true;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return true;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return true;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return true;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return true;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return true;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return true;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return true;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return true;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return true;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return true;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return true;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return true;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return true;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return true;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return true;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return true;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return true;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return true;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return true;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return true;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return true;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return true;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return true;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return true;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return true;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return true;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return true;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return true;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return true;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return true;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return true;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return true;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return true;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return true;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return true;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return true;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return true;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return true;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return true;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return true;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return true;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return true;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return true;
            return false;
        };
    }
};
var $4d40d048175dacfe$export$72232ffdb2635391 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c && y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7ba2b3d677b0db1c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab && y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1ef0df3f3e6a4dab) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e && y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$4da01cb598a0d97e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381 && y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ccb63fd7a749a381) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb && y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$a2e3a2bb787472eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826 && y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$c2899da73c95f826) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe && y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$b189863462ae27fe) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad && y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5481c9b080fac1ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7 && y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ed6c67e3f00c02f7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28 && y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$3f2abff6b2574d28) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560 && y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$8ef7db4a55783560) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb && y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$2aec4081bfc982fb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda && y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$8ee6fb6ac028afda) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639 && y instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$6f27218568808639) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e && y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$9748581da6bbbe4e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b && y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5fd9f780846e028b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe && y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$499720fb85152dfe) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6 && y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$6b6488e90da63d6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde && y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$92dfe98bc9dbafde) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261 && y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$ea74132c1bd19261) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c && y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$e5454c7695ddbd5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9 && y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$af0e2cc0795570d9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674 && y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f76ce82784afe674) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773 && y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$5f9c079ff6708773) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37 && y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$44c5bb026cbe6e37) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4 && y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$e259ef3995a99fd4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3 && y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f95f909e01aa4cb3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90 && y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$67ade628725afe90) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b && y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f03ef3c27a8e4a4b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f && y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1b45801580e5182f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1 && y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$d906c17550f3b6f1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa && y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$267a9616c09f33fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf && y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$4ac537c498251bbf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454 && y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$2e15cf96bd811454) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d && y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7c4efb1d2d0a7d5d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c && y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$42f27b71e570e84c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c && y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7dd055ac3e2d902c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c && y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$918eb55efc9f2e5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de && y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$9d4a96b43ef247de) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa && y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f69bc69473d6d1fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74 && y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$db103677e4262f74) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072 && y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$976267f1375fd072) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763 && y instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$345017daa9311763) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f && y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$a58218c48fdc359f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f && y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$41a3d5735ecfd56f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147 && y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$dc25bbd279bd7147) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5 && y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$f37489576ac4e3f5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246 && y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$85265d7dd09c0246) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722 && y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$fb4e6d66ca842722) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771 && y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$149dc202c94ba771) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e && y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$c3fb770456fc7a2e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054 && y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$97df2b5615a1b054) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4 && y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$7aa0294a80b301d4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d && y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$1294e96da410451d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93 && y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4d40d048175dacfe$export$acf71e1d98edce93) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb && y instanceof $4d40d048175dacfe$export$7a4045fb80d6a5eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4d40d048175dacfe$export$51a22934b9cdbac4;
    }
};


// Generated by purs version 0.15.15

var $c67b43ffea069cfb$export$f2f6344eac5a3091 = /* #__PURE__ */ function() {
    function ButtonButton() {}
    ButtonButton.value = new ButtonButton();
    return ButtonButton;
}();
var $c67b43ffea069cfb$export$883ac606d954afa4 = /* #__PURE__ */ function() {
    function ButtonSubmit() {}
    ButtonSubmit.value = new ButtonSubmit();
    return ButtonSubmit;
}();
var $c67b43ffea069cfb$export$7c5d4436120726a7 = /* #__PURE__ */ function() {
    function ButtonReset() {}
    ButtonReset.value = new ButtonReset();
    return ButtonReset;
}();
var $c67b43ffea069cfb$export$354e79e7f4fdf8f9 = function(v) {
    if (v instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return "button";
    if (v instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return "submit";
    if (v instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return "reset";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 14, column 20 - line 17, column 25): " + [
        v.constructor.name
    ]);
};
var $c67b43ffea069cfb$export$eedf6d78b7217aa7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return true;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return true;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return true;
            return false;
        };
    }
};
var $c67b43ffea069cfb$export$d2ecbd2aa2e5439c = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091 && y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c67b43ffea069cfb$export$f2f6344eac5a3091) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4 && y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c67b43ffea069cfb$export$883ac606d954afa4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c67b43ffea069cfb$export$7c5d4436120726a7 && y instanceof $c67b43ffea069cfb$export$7c5d4436120726a7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c67b43ffea069cfb$export$eedf6d78b7217aa7;
    }
};


// Generated by purs version 0.15.15

var $f2665e311d0e2c2e$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $f2665e311d0e2c2e$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $f2665e311d0e2c2e$export$8cede0459d8015c9 = function(v) {
    if (v instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 13, column 26 - line 15, column 38): " + [
        v.constructor.name
    ]);
};
var $f2665e311d0e2c2e$export$63add5f8c2317041 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return true;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $f2665e311d0e2c2e$export$8999465764c5da85 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700 && y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $f2665e311d0e2c2e$export$e1bb774e9664e700) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3 && y instanceof $f2665e311d0e2c2e$export$bf6fef082af5a2d3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $f2665e311d0e2c2e$export$63add5f8c2317041;
    }
};


// Generated by purs version 0.15.15

var $0e909c93feacf06e$export$c75f22af8298685 = /* #__PURE__ */ function() {
    function DirLTR() {}
    DirLTR.value = new DirLTR();
    return DirLTR;
}();
var $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 = /* #__PURE__ */ function() {
    function DirRTL() {}
    DirRTL.value = new DirRTL();
    return DirRTL;
}();
var $0e909c93feacf06e$export$db0b550dbafe50c7 = /* #__PURE__ */ function() {
    function DirAuto() {}
    DirAuto.value = new DirAuto();
    return DirAuto;
}();
var $0e909c93feacf06e$export$5f8a4393c9c60d1a = function(v) {
    if (v instanceof $0e909c93feacf06e$export$c75f22af8298685) return "ltr";
    if (v instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return "rtl";
    if (v instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 14, column 18 - line 17, column 20): " + [
        v.constructor.name
    ]);
};
var $0e909c93feacf06e$export$c646568b5e94d926 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return true;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return true;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return true;
            return false;
        };
    }
};
var $0e909c93feacf06e$export$e1551c9d6a26f7f3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685 && y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0e909c93feacf06e$export$c75f22af8298685) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1 && y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0e909c93feacf06e$export$f3ecd00e2fcb9ec1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0e909c93feacf06e$export$db0b550dbafe50c7 && y instanceof $0e909c93feacf06e$export$db0b550dbafe50c7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0e909c93feacf06e$export$c646568b5e94d926;
    }
};


// Generated by purs version 0.15.15

var $d3d5c2135d61b9e7$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $d3d5c2135d61b9e7$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $d3d5c2135d61b9e7$export$ac1e6270deebeb79 = function(v) {
    if (v instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return "post";
    if (v instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return "get";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 13, column 20 - line 15, column 15): " + [
        v.constructor.name
    ]);
};
var $d3d5c2135d61b9e7$export$f6f118a39bdefe44 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return true;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return true;
            return false;
        };
    }
};
var $d3d5c2135d61b9e7$export$5fa44f1be85134a1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad && y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $d3d5c2135d61b9e7$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1 && y instanceof $d3d5c2135d61b9e7$export$1bb358554aac31c1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $d3d5c2135d61b9e7$export$f6f118a39bdefe44;
    }
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15


var $25a73b5eff39e983$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $25a73b5eff39e983$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $25a73b5eff39e983$export$483c11740a902fcd = function(x) {
    return x;
};
var $25a73b5eff39e983$export$74c0afb45691d798 = {
    show: function(v) {
        return "(MediaType " + ($25a73b5eff39e983$var$show(v) + ")");
    }
};
var $25a73b5eff39e983$export$37246347bfd87552 = {
    Coercible0: function() {
        return undefined;
    }
};
var $25a73b5eff39e983$export$2fed9e13b0c7effc = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $25a73b5eff39e983$export$11071179e210ac75 = {
    compare: function(x) {
        return function(y) {
            return $25a73b5eff39e983$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $25a73b5eff39e983$export$2fed9e13b0c7effc;
    }
};





// Generated by purs version 0.15.15
const $5b07e36f812dd04b$export$3ece336175b57f19 = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(s1) {
                return function(s2) {
                    var result = s1.localeCompare(s2);
                    return result < 0 ? lt : result > 0 ? gt : eq;
                };
            };
        };
    };
};
const $5b07e36f812dd04b$export$77ad94ebf1c2b9ed = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(s1, s2);
        };
    };
};
const $5b07e36f812dd04b$export$b8b3234b4edfc4c2 = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2); // eslint-disable-line no-useless-escape
        };
    };
};
const $5b07e36f812dd04b$export$65980d18b75784e2 = function(sep) {
    return function(s) {
        return s.split(sep);
    };
};
const $5b07e36f812dd04b$export$b1ceac3893cbda6b = function(s) {
    return s.toLowerCase();
};
const $5b07e36f812dd04b$export$43df7fc17cca38a4 = function(s) {
    return s.toUpperCase();
};
const $5b07e36f812dd04b$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
const $5b07e36f812dd04b$export$ec1dc8fbeea3467e = function(s) {
    return function(xs) {
        return xs.join(s);
    };
};



var $22d4f8ab6946d33a$export$7b1b591b262c240 = function(s) {
    return s === "";
};
var $22d4f8ab6946d33a$export$35652c12e6caefdf = /* #__PURE__ */ function() {
    return $5b07e36f812dd04b$export$3ece336175b57f19($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value);
}();


var $a54f870bf00314e8$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $a54f870bf00314e8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a54f870bf00314e8$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($25a73b5eff39e983$export$2fed9e13b0c7effc);
var $a54f870bf00314e8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($25a73b5eff39e983$export$11071179e210ac75);
var $a54f870bf00314e8$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $a54f870bf00314e8$export$8e926b7ab266774b = /* #__PURE__ */ function() {
    function AcceptMediaType(value0) {
        this.value0 = value0;
    }
    AcceptMediaType.create = function(value0) {
        return new AcceptMediaType(value0);
    };
    return AcceptMediaType;
}();
var $a54f870bf00314e8$export$f7dfb125ffc1f9b2 = /* #__PURE__ */ function() {
    function AcceptFileExtension(value0) {
        this.value0 = value0;
    }
    AcceptFileExtension.create = function(value0) {
        return new AcceptFileExtension(value0);
    };
    return AcceptFileExtension;
}();
var $a54f870bf00314e8$export$cdbf5a093552f797 = function(x) {
    return x;
};
var $a54f870bf00314e8$export$335b3365a1f7dcb5 = {
    append: function(v) {
        return function(v1) {
            return $a54f870bf00314e8$var$append(v)(v1);
        };
    }
};
var $a54f870bf00314e8$export$ef578e44d5d087ca = function(v) {
    if (v instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return v.value0;
    if (v instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return v.value0;
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 34, column 29 - line 36, column 33): " + [
        v.constructor.name
    ]);
};
var $a54f870bf00314e8$export$67347a102a60396a = function(v) {
    return $5b07e36f812dd04b$export$ec1dc8fbeea3467e(",")($a54f870bf00314e8$var$map($a54f870bf00314e8$export$ef578e44d5d087ca)(v));
};
var $a54f870bf00314e8$export$48e9de57e04e82db = function(mt) {
    return [
        new $a54f870bf00314e8$export$8e926b7ab266774b(mt)
    ];
};
var $a54f870bf00314e8$export$1b45514b112dd749 = function(ext) {
    return [
        new $a54f870bf00314e8$export$f7dfb125ffc1f9b2(ext)
    ];
};
var $a54f870bf00314e8$export$d6146bb235b883d4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$eq(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return x.value0 === y.value0;
            return false;
        };
    }
};
var $a54f870bf00314e8$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($a54f870bf00314e8$export$d6146bb235b883d4));
var $a54f870bf00314e8$export$56a1e1f55aab9839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b && y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $a54f870bf00314e8$var$compare(x.value0)(y.value0);
            if (x instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a54f870bf00314e8$export$8e926b7ab266774b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2 && y instanceof $a54f870bf00314e8$export$f7dfb125ffc1f9b2) return $a54f870bf00314e8$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$d6146bb235b883d4;
    }
};
var $a54f870bf00314e8$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($a54f870bf00314e8$export$56a1e1f55aab9839));
var $a54f870bf00314e8$export$6683b104f83faddd = {
    eq: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$eq2(x)(y);
        };
    }
};
var $a54f870bf00314e8$export$5822e39e3fdf7b = {
    compare: function(x) {
        return function(y) {
            return $a54f870bf00314e8$var$compare2(x)(y);
        };
    },
    Eq0: function() {
        return $a54f870bf00314e8$export$6683b104f83faddd;
    }
};


// Generated by purs version 0.15.15

var $cec7e3152401d818$export$80f44e7a00b6023f = /* #__PURE__ */ function() {
    function InputButton() {}
    InputButton.value = new InputButton();
    return InputButton;
}();
var $cec7e3152401d818$export$fa1253a65a9e747d = /* #__PURE__ */ function() {
    function InputCheckbox() {}
    InputCheckbox.value = new InputCheckbox();
    return InputCheckbox;
}();
var $cec7e3152401d818$export$c860ea55e361ded9 = /* #__PURE__ */ function() {
    function InputColor() {}
    InputColor.value = new InputColor();
    return InputColor;
}();
var $cec7e3152401d818$export$7ac9d04ce3f22c96 = /* #__PURE__ */ function() {
    function InputDate() {}
    InputDate.value = new InputDate();
    return InputDate;
}();
var $cec7e3152401d818$export$6a70bbf20f9e4d15 = /* #__PURE__ */ function() {
    function InputDatetimeLocal() {}
    InputDatetimeLocal.value = new InputDatetimeLocal();
    return InputDatetimeLocal;
}();
var $cec7e3152401d818$export$497a6aaf7dad75ee = /* #__PURE__ */ function() {
    function InputEmail() {}
    InputEmail.value = new InputEmail();
    return InputEmail;
}();
var $cec7e3152401d818$export$688bf7bc8f9a8891 = /* #__PURE__ */ function() {
    function InputFile() {}
    InputFile.value = new InputFile();
    return InputFile;
}();
var $cec7e3152401d818$export$f953fc739c1a72e8 = /* #__PURE__ */ function() {
    function InputHidden() {}
    InputHidden.value = new InputHidden();
    return InputHidden;
}();
var $cec7e3152401d818$export$94c7ee1e602c3016 = /* #__PURE__ */ function() {
    function InputImage() {}
    InputImage.value = new InputImage();
    return InputImage;
}();
var $cec7e3152401d818$export$e3f21b3e5e110727 = /* #__PURE__ */ function() {
    function InputMonth() {}
    InputMonth.value = new InputMonth();
    return InputMonth;
}();
var $cec7e3152401d818$export$cf9581d419a141cf = /* #__PURE__ */ function() {
    function InputNumber() {}
    InputNumber.value = new InputNumber();
    return InputNumber;
}();
var $cec7e3152401d818$export$66ebaee5e192c141 = /* #__PURE__ */ function() {
    function InputPassword() {}
    InputPassword.value = new InputPassword();
    return InputPassword;
}();
var $cec7e3152401d818$export$324f219e224c2ba4 = /* #__PURE__ */ function() {
    function InputRadio() {}
    InputRadio.value = new InputRadio();
    return InputRadio;
}();
var $cec7e3152401d818$export$7fd9b60c3e71d3cc = /* #__PURE__ */ function() {
    function InputRange() {}
    InputRange.value = new InputRange();
    return InputRange;
}();
var $cec7e3152401d818$export$e5f0f61dd2ad15f5 = /* #__PURE__ */ function() {
    function InputReset() {}
    InputReset.value = new InputReset();
    return InputReset;
}();
var $cec7e3152401d818$export$28044d9a5dbb104e = /* #__PURE__ */ function() {
    function InputSearch() {}
    InputSearch.value = new InputSearch();
    return InputSearch;
}();
var $cec7e3152401d818$export$41cafe4e2581754d = /* #__PURE__ */ function() {
    function InputSubmit() {}
    InputSubmit.value = new InputSubmit();
    return InputSubmit;
}();
var $cec7e3152401d818$export$5a51e0eecea5d8bd = /* #__PURE__ */ function() {
    function InputTel() {}
    InputTel.value = new InputTel();
    return InputTel;
}();
var $cec7e3152401d818$export$7034fcb7d6351061 = /* #__PURE__ */ function() {
    function InputText() {}
    InputText.value = new InputText();
    return InputText;
}();
var $cec7e3152401d818$export$d62c52bf2c44ba6f = /* #__PURE__ */ function() {
    function InputTime() {}
    InputTime.value = new InputTime();
    return InputTime;
}();
var $cec7e3152401d818$export$dfe56e1f58ed5cb2 = /* #__PURE__ */ function() {
    function InputUrl() {}
    InputUrl.value = new InputUrl();
    return InputUrl;
}();
var $cec7e3152401d818$export$8e8a9e74dfcf346a = /* #__PURE__ */ function() {
    function InputWeek() {}
    InputWeek.value = new InputWeek();
    return InputWeek;
}();
var $cec7e3152401d818$export$349063a07c8ae46b = function(v) {
    if (v instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return "button";
    if (v instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return "checkbox";
    if (v instanceof $cec7e3152401d818$export$c860ea55e361ded9) return "color";
    if (v instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return "date";
    if (v instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return "datetime-local";
    if (v instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return "email";
    if (v instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return "file";
    if (v instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return "hidden";
    if (v instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return "image";
    if (v instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return "month";
    if (v instanceof $cec7e3152401d818$export$cf9581d419a141cf) return "number";
    if (v instanceof $cec7e3152401d818$export$66ebaee5e192c141) return "password";
    if (v instanceof $cec7e3152401d818$export$324f219e224c2ba4) return "radio";
    if (v instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return "range";
    if (v instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return "reset";
    if (v instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return "search";
    if (v instanceof $cec7e3152401d818$export$41cafe4e2581754d) return "submit";
    if (v instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return "tel";
    if (v instanceof $cec7e3152401d818$export$7034fcb7d6351061) return "text";
    if (v instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return "time";
    if (v instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return "url";
    if (v instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return "week";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
        v.constructor.name
    ]);
};
var $cec7e3152401d818$export$417491cbf879eb77 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return true;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return true;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return true;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return true;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return true;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return true;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return true;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return true;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return true;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return true;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return true;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return true;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return true;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return true;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return true;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return true;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return true;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return true;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return true;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return true;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return true;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return true;
            return false;
        };
    }
};
var $cec7e3152401d818$export$6dd7322953dee4dc = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f && y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$80f44e7a00b6023f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d && y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$fa1253a65a9e747d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9 && y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$c860ea55e361ded9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96 && y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7ac9d04ce3f22c96) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15 && y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$6a70bbf20f9e4d15) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee && y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$497a6aaf7dad75ee) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891 && y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$688bf7bc8f9a8891) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8 && y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$f953fc739c1a72e8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016 && y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$94c7ee1e602c3016) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727 && y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$e3f21b3e5e110727) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf && y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$cf9581d419a141cf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141 && y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$66ebaee5e192c141) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4 && y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$324f219e224c2ba4) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc && y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7fd9b60c3e71d3cc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5 && y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$e5f0f61dd2ad15f5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e && y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$28044d9a5dbb104e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d && y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$41cafe4e2581754d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd && y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$5a51e0eecea5d8bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061 && y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$7034fcb7d6351061) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f && y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$d62c52bf2c44ba6f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2 && y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $cec7e3152401d818$export$dfe56e1f58ed5cb2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a && y instanceof $cec7e3152401d818$export$8e8a9e74dfcf346a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $cec7e3152401d818$export$417491cbf879eb77;
    }
};


// Generated by purs version 0.15.15

var $0d6d338ad81e2ec3$export$35c6296c72c0b98 = /* #__PURE__ */ function() {
    function KindSubtitles() {}
    KindSubtitles.value = new KindSubtitles();
    return KindSubtitles;
}();
var $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa = /* #__PURE__ */ function() {
    function KindCaptions() {}
    KindCaptions.value = new KindCaptions();
    return KindCaptions;
}();
var $0d6d338ad81e2ec3$export$ed9577fa4e97a113 = /* #__PURE__ */ function() {
    function KindDescriptions() {}
    KindDescriptions.value = new KindDescriptions();
    return KindDescriptions;
}();
var $0d6d338ad81e2ec3$export$6b7135087206d174 = /* #__PURE__ */ function() {
    function KindChapters() {}
    KindChapters.value = new KindChapters();
    return KindChapters;
}();
var $0d6d338ad81e2ec3$export$a2734ee0406012d8 = /* #__PURE__ */ function() {
    function KindMetadata() {}
    KindMetadata.value = new KindMetadata();
    return KindMetadata;
}();
var $0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53 = function(v) {
    if (v instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return "subtitles";
    if (v instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return "captions";
    if (v instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return "descriptions";
    if (v instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return "chapters";
    if (v instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 16, column 19 - line 21, column 29): " + [
        v.constructor.name
    ]);
};
var $0d6d338ad81e2ec3$export$4037dad5bbd136 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return true;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return true;
            return false;
        };
    }
};
var $0d6d338ad81e2ec3$export$70ddb214b8742e4 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98 && y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$35c6296c72c0b98) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa && y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$57c7f27d38c9b1fa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113 && y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$ed9577fa4e97a113) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174 && y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0d6d338ad81e2ec3$export$6b7135087206d174) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8 && y instanceof $0d6d338ad81e2ec3$export$a2734ee0406012d8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0d6d338ad81e2ec3$export$4037dad5bbd136;
    }
};


// Generated by purs version 0.15.15

var $01636ff1929ca3b5$export$d4c4e98c5044dc8 = /* #__PURE__ */ function() {
    function MenuList() {}
    MenuList.value = new MenuList();
    return MenuList;
}();
var $01636ff1929ca3b5$export$c7e742effb1c51e2 = /* #__PURE__ */ function() {
    function MenuContext() {}
    MenuContext.value = new MenuContext();
    return MenuContext;
}();
var $01636ff1929ca3b5$export$5ed3d899d0b4c46b = /* #__PURE__ */ function() {
    function MenuToolbar() {}
    MenuToolbar.value = new MenuToolbar();
    return MenuToolbar;
}();
var $01636ff1929ca3b5$export$1746677a19c76ca = function(v) {
    if (v instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return "list";
    if (v instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return "context";
    if (v instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return "toolbar";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 14, column 18 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $01636ff1929ca3b5$export$fb82239a3dd454ef = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return true;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return true;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return true;
            return false;
        };
    }
};
var $01636ff1929ca3b5$export$93b0f2b60788283e = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8 && y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $01636ff1929ca3b5$export$d4c4e98c5044dc8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2 && y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $01636ff1929ca3b5$export$c7e742effb1c51e2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b && y instanceof $01636ff1929ca3b5$export$5ed3d899d0b4c46b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $01636ff1929ca3b5$export$fb82239a3dd454ef;
    }
};


// Generated by purs version 0.15.15

var $16370a0f58f1c8c4$export$45504f2104ec46b9 = /* #__PURE__ */ function() {
    function MenuitemCommand() {}
    MenuitemCommand.value = new MenuitemCommand();
    return MenuitemCommand;
}();
var $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 = /* #__PURE__ */ function() {
    function MenuitemCheckbox() {}
    MenuitemCheckbox.value = new MenuitemCheckbox();
    return MenuitemCheckbox;
}();
var $16370a0f58f1c8c4$export$d4d65a7e83785e4a = /* #__PURE__ */ function() {
    function MenuitemRadio() {}
    MenuitemRadio.value = new MenuitemRadio();
    return MenuitemRadio;
}();
var $16370a0f58f1c8c4$export$3e035bf7a26d866f = function(v) {
    if (v instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return "command";
    if (v instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return "checkbox";
    if (v instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return "radio";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 14, column 22 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $16370a0f58f1c8c4$export$e73111b8eb7b1a2f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return true;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return true;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return true;
            return false;
        };
    }
};
var $16370a0f58f1c8c4$export$67edf3145dec517a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9 && y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $16370a0f58f1c8c4$export$45504f2104ec46b9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39 && y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $16370a0f58f1c8c4$export$eea2e5b7a15a4e39) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a && y instanceof $16370a0f58f1c8c4$export$d4d65a7e83785e4a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $16370a0f58f1c8c4$export$e73111b8eb7b1a2f;
    }
};


// Generated by purs version 0.15.15



var $018a854b7e87c5c3$export$44ce537f0c9df246 = /* #__PURE__ */ function() {
    function Uppercase() {}
    Uppercase.value = new Uppercase();
    return Uppercase;
}();
var $018a854b7e87c5c3$export$83336b6c62a5a6d9 = /* #__PURE__ */ function() {
    function Lowercase() {}
    Lowercase.value = new Lowercase();
    return Lowercase;
}();
var $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 = /* #__PURE__ */ function() {
    function NumeralDecimal() {}
    NumeralDecimal.value = new NumeralDecimal();
    return NumeralDecimal;
}();
var $018a854b7e87c5c3$export$d7365b08e0f1de3f = /* #__PURE__ */ function() {
    function NumeralRoman(value0) {
        this.value0 = value0;
    }
    NumeralRoman.create = function(value0) {
        return new NumeralRoman(value0);
    };
    return NumeralRoman;
}();
var $018a854b7e87c5c3$export$d3365947fb5d3bc = /* #__PURE__ */ function() {
    function OrderedListNumeric(value0) {
        this.value0 = value0;
    }
    OrderedListNumeric.create = function(value0) {
        return new OrderedListNumeric(value0);
    };
    return OrderedListNumeric;
}();
var $018a854b7e87c5c3$export$6f21557799b70c7b = /* #__PURE__ */ function() {
    function OrderedListAlphabetic(value0) {
        this.value0 = value0;
    }
    OrderedListAlphabetic.create = function(value0) {
        return new OrderedListAlphabetic(value0);
    };
    return OrderedListAlphabetic;
}();
var $018a854b7e87c5c3$export$a347b8fb4fdf4d6c = function(v) {
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return "1";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "i";
    if (v instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && v.value0 instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && v.value0.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "I";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return "a";
    if (v instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && v.value0 instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return "A";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 27, column 25 - line 32, column 41): " + [
        v.constructor.name
    ]);
};
var $018a854b7e87c5c3$export$9fb147ac07d57455 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return true;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return true;
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($018a854b7e87c5c3$export$9fb147ac07d57455);
var $018a854b7e87c5c3$export$7549aa54c7bac647 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return true;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($018a854b7e87c5c3$export$7549aa54c7bac647);
var $018a854b7e87c5c3$export$e819e2655e0fcc28 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$eq1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $018a854b7e87c5c3$export$1bd622e0e5e4efb1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246 && y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$44ce537f0c9df246) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9 && y instanceof $018a854b7e87c5c3$export$83336b6c62a5a6d9) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$9fb147ac07d57455;
    }
};
var $018a854b7e87c5c3$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($018a854b7e87c5c3$export$1bd622e0e5e4efb1);
var $018a854b7e87c5c3$export$cd9389dd72b9960d = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36 && y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$4ae8afa1ef3b3b36) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f && y instanceof $018a854b7e87c5c3$export$d7365b08e0f1de3f) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$7549aa54c7bac647;
    }
};
var $018a854b7e87c5c3$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($018a854b7e87c5c3$export$cd9389dd72b9960d);
var $018a854b7e87c5c3$export$8c507121dc4e4ea6 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc && y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $018a854b7e87c5c3$var$compare1(x.value0)(y.value0);
            if (x instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $018a854b7e87c5c3$export$d3365947fb5d3bc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $018a854b7e87c5c3$export$6f21557799b70c7b && y instanceof $018a854b7e87c5c3$export$6f21557799b70c7b) return $018a854b7e87c5c3$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $018a854b7e87c5c3$export$e819e2655e0fcc28;
    }
};


// Generated by purs version 0.15.15

var $5d22526bed7c1d63$export$c9ce58abf53417e5 = /* #__PURE__ */ function() {
    function PreloadNone() {}
    PreloadNone.value = new PreloadNone();
    return PreloadNone;
}();
var $5d22526bed7c1d63$export$5e05b189d974313d = /* #__PURE__ */ function() {
    function PreloadAuto() {}
    PreloadAuto.value = new PreloadAuto();
    return PreloadAuto;
}();
var $5d22526bed7c1d63$export$177dbf7da98d3f0a = /* #__PURE__ */ function() {
    function PreloadMetadata() {}
    PreloadMetadata.value = new PreloadMetadata();
    return PreloadMetadata;
}();
var $5d22526bed7c1d63$export$d6626656355d8e39 = function(v) {
    if (v instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return "none";
    if (v instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return "auto";
    if (v instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 14, column 22 - line 17, column 32): " + [
        v.constructor.name
    ]);
};
var $5d22526bed7c1d63$export$2dcc86def1e5568e = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return true;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return true;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return true;
            return false;
        };
    }
};
var $5d22526bed7c1d63$export$c419e612a877bba3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5 && y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5d22526bed7c1d63$export$c9ce58abf53417e5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d && y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5d22526bed7c1d63$export$5e05b189d974313d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a && y instanceof $5d22526bed7c1d63$export$177dbf7da98d3f0a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5d22526bed7c1d63$export$2dcc86def1e5568e;
    }
};


// Generated by purs version 0.15.15

var $28290d8d8d6af995$export$85b4c654d12206aa = /* #__PURE__ */ function() {
    function ScopeRow() {}
    ScopeRow.value = new ScopeRow();
    return ScopeRow;
}();
var $28290d8d8d6af995$export$bf0d11cf8bd9f5de = /* #__PURE__ */ function() {
    function ScopeCol() {}
    ScopeCol.value = new ScopeCol();
    return ScopeCol;
}();
var $28290d8d8d6af995$export$5910a17af6f76381 = /* #__PURE__ */ function() {
    function ScopeRowGroup() {}
    ScopeRowGroup.value = new ScopeRowGroup();
    return ScopeRowGroup;
}();
var $28290d8d8d6af995$export$6ce944503089dadd = /* #__PURE__ */ function() {
    function ScopeColGroup() {}
    ScopeColGroup.value = new ScopeColGroup();
    return ScopeColGroup;
}();
var $28290d8d8d6af995$export$5663b51bd1c6c084 = /* #__PURE__ */ function() {
    function ScopeAuto() {}
    ScopeAuto.value = new ScopeAuto();
    return ScopeAuto;
}();
var $28290d8d8d6af995$export$ce228bdd501ce63 = function(v) {
    if (v instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return "row";
    if (v instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return "col";
    if (v instanceof $28290d8d8d6af995$export$5910a17af6f76381) return "rowgroup";
    if (v instanceof $28290d8d8d6af995$export$6ce944503089dadd) return "colgroup";
    if (v instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 16, column 20 - line 21, column 22): " + [
        v.constructor.name
    ]);
};
var $28290d8d8d6af995$export$118ba639ca4f9d14 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return true;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return true;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return true;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return true;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return true;
            return false;
        };
    }
};
var $28290d8d8d6af995$export$4afeaf27b056d536 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa && y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$85b4c654d12206aa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de && y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$bf0d11cf8bd9f5de) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381 && y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$5910a17af6f76381) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd && y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $28290d8d8d6af995$export$6ce944503089dadd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $28290d8d8d6af995$export$5663b51bd1c6c084 && y instanceof $28290d8d8d6af995$export$5663b51bd1c6c084) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $28290d8d8d6af995$export$118ba639ca4f9d14;
    }
};


// Generated by purs version 0.15.15



var $9c6cb90b338ac9f8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $9c6cb90b338ac9f8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$5ed021ff2336715c);
var $9c6cb90b338ac9f8$export$b24b633b1364b94b = /* #__PURE__ */ function() {
    function Any() {}
    Any.value = new Any();
    return Any;
}();
var $9c6cb90b338ac9f8$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0) {
        this.value0 = value0;
    }
    Step.create = function(value0) {
        return new Step(value0);
    };
    return Step;
}();
var $9c6cb90b338ac9f8$export$eb5efa61a2272b57 = function(v) {
    if (v instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return "any";
    if (v instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$show(v.value0);
    throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 13, column 19 - line 15, column 19): " + [
        v.constructor.name
    ]);
};
var $9c6cb90b338ac9f8$export$8db64ca9ca089cac = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return true;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return x.value0 === y.value0;
            return false;
        };
    }
};
var $9c6cb90b338ac9f8$export$848021523941663f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b && y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $9c6cb90b338ac9f8$export$b24b633b1364b94b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a && y instanceof $9c6cb90b338ac9f8$export$fd55ce593607084a) return $9c6cb90b338ac9f8$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $9c6cb90b338ac9f8$export$8db64ca9ca089cac;
    }
};


// Generated by purs version 0.15.15

var $545e4dccf243e400$export$a12ca0aab327cfc7 = /* #__PURE__ */ function() {
    function Hard() {}
    Hard.value = new Hard();
    return Hard;
}();
var $545e4dccf243e400$export$f8ab8e157e94ef80 = /* #__PURE__ */ function() {
    function Soft() {}
    Soft.value = new Soft();
    return Soft;
}();
var $545e4dccf243e400$export$a763fdfe677a0aa9 = function(v) {
    if (v instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return "hard";
    if (v instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return "soft";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 13, column 19 - line 15, column 17): " + [
        v.constructor.name
    ]);
};
var $545e4dccf243e400$export$2ca5a4c778c64452 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return true;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return true;
            return false;
        };
    }
};
var $545e4dccf243e400$export$7166197b77e6499a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7 && y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $545e4dccf243e400$export$a12ca0aab327cfc7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $545e4dccf243e400$export$f8ab8e157e94ef80 && y instanceof $545e4dccf243e400$export$f8ab8e157e94ef80) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $545e4dccf243e400$export$2ca5a4c778c64452;
    }
};






// Generated by purs version 0.15.15


var $969bbf7e7aa55092$export$37de0cf0f2f21d21 = function(x) {
    return x;
};
var $969bbf7e7aa55092$export$f4c20fd541e0bbe4 = /* #__PURE__ */ function() {
    function RefUpdate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RefUpdate.create = function(value0) {
        return function(value1) {
            return new RefUpdate(value0, value1);
        };
    };
    return RefUpdate;
}();
var $969bbf7e7aa55092$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0) {
        this.value0 = value0;
    }
    Action.create = function(value0) {
        return new Action(value0);
    };
    return Action;
}();
var $969bbf7e7aa55092$export$e4f50b41777b2135 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $969bbf7e7aa55092$export$f406a712694a6a92 = {
    Coercible0: function() {
        return undefined;
    }
};
var $969bbf7e7aa55092$export$5158bce98a089317 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $969bbf7e7aa55092$export$f4c20fd541e0bbe4) return new $969bbf7e7aa55092$export$f4c20fd541e0bbe4(m.value0, m.value1);
            if (m instanceof $969bbf7e7aa55092$export$e19cd5f9376f8cee) return new $969bbf7e7aa55092$export$e19cd5f9376f8cee(f(m.value0));
            throw new Error("Failed pattern match at Halogen.Query.Input (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $969bbf7e7aa55092$export$9947dab6e2c9dd9d = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
//------------------------------------------------------------------------------
// Array creation --------------------------------------------------------------
//------------------------------------------------------------------------------
const $fc8c1182ec2aefec$export$3561205b7dff20bf = function(start, end) {
    var step = start > end ? -1 : 1;
    var result = new Array(step * (end - start) + 1);
    var i = start, n = 0;
    while(i !== end){
        result[n++] = i;
        i += step;
    }
    result[n] = i;
    return result;
};
var $fc8c1182ec2aefec$var$replicateFill = function(count, value) {
    if (count < 1) return [];
    var result = new Array(count);
    return result.fill(value);
};
var $fc8c1182ec2aefec$var$replicatePolyfill = function(count, value) {
    var result = [];
    var n = 0;
    for(var i = 0; i < count; i++)result[n++] = value;
    return result;
};
const $fc8c1182ec2aefec$export$86a7d437bed76c03 = typeof Array.prototype.fill === "function" ? $fc8c1182ec2aefec$var$replicateFill : $fc8c1182ec2aefec$var$replicatePolyfill;
const $fc8c1182ec2aefec$export$7de5ece11b723a44 = function() {
    function Cons(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    var emptyList = {};
    function curryCons(head) {
        return function(tail) {
            return new Cons(head, tail);
        };
    }
    function listToArray(list) {
        var result = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result[count++] = xs.head;
            xs = xs.tail;
        }
        return result;
    }
    return function(foldr, xs) {
        return listToArray(foldr(curryCons)(emptyList)(xs));
    };
}();
const $fc8c1182ec2aefec$export$f24224f1c91d8156 = function(xs) {
    return xs.length;
};
const $fc8c1182ec2aefec$export$99063656965a82f5 = function(empty, next, xs) {
    return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
};
const $fc8c1182ec2aefec$export$fe8606c16d7ceed6 = function(just, nothing, xs, i) {
    return i < 0 || i >= xs.length ? nothing : just(xs[i]);
};
const $fc8c1182ec2aefec$export$7ad327e9a65b0147 = function(nothing, isJust, f, xs) {
    for(var i = 0; i < xs.length; i++){
        var result = f(xs[i]);
        if (isJust(result)) return result;
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$885b84ba169666c7 = function(just, nothing, f, xs) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$32bcb9f71841245e = function(just, nothing, f, xs) {
    for(var i = xs.length - 1; i >= 0; i--){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$d553b0efc2008003 = function(just, nothing, i, a, l) {
    if (i < 0 || i > l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 0, a);
    return just(l1);
};
const $fc8c1182ec2aefec$export$e83371a4d1b4407c = function(just, nothing, i, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 1);
    return just(l1);
};
const $fc8c1182ec2aefec$export$4bc13c05b5f586d5 = function(just, nothing, i, a, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1[i] = a;
    return just(l1);
};
const $fc8c1182ec2aefec$export$66c1ae025e96b4bc = function(l) {
    return l.slice().reverse();
};
const $fc8c1182ec2aefec$export$ee1b3e54f0441b22 = function(xss) {
    if (xss.length <= 10000) // This method is faster, but it crashes on big arrays.
    // So we use it when can and fallback to simple variant otherwise.
    return Array.prototype.concat.apply([], xss);
    var result = [];
    for(var i = 0, l = xss.length; i < l; i++){
        var xs = xss[i];
        for(var j = 0, m = xs.length; j < m; j++)result.push(xs[j]);
    }
    return result;
};
const $fc8c1182ec2aefec$export$e85b5b674fbfff84 = function(f, xs) {
    return xs.filter(f);
};
const $fc8c1182ec2aefec$export$25718970d830661a = function(f, xs) {
    var yes = [];
    var no = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        if (f(x)) yes.push(x);
        else no.push(x);
    }
    return {
        yes: yes,
        no: no
    };
};
const $fc8c1182ec2aefec$export$53974fb866918d71 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = 0; i < len; i++){
        acc = f(acc)(xs[i]);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$771bbc3bb9be46c2 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = len - 1; i >= 0; i--){
        acc = f(xs[i])(acc);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        var out;
        if (xs.length < 2) return xs;
        out = xs.slice(0);
        mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);
        return out;
    };
}();
const $fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a = function(s, e, l) {
    return l.slice(s, e);
};
const $fc8c1182ec2aefec$export$67fd4cff6f1e6bc = function(f, xs, ys) {
    var l = xs.length < ys.length ? xs.length : ys.length;
    var result = new Array(l);
    for(var i = 0; i < l; i++)result[i] = f(xs[i])(ys[i]);
    return result;
};
const $fc8c1182ec2aefec$export$b98f41a67d1483f3 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (p(xs[i])) return true;
    }
    return false;
};
const $fc8c1182ec2aefec$export$739e1ef870df7d82 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (!p(xs[i])) return false;
    }
    return true;
};
const $fc8c1182ec2aefec$export$4459d383cf3fd31d = function(xs, n) {
    return xs[n];
};










// Generated by purs version 0.15.15
function $0dbe0c7353bd68b1$export$b8cb59497041ffe4() {
    return [];
}
const $0dbe0c7353bd68b1$export$6dc5f95d8548a16a = function(just, nothing, i, xs) {
    return i >= 0 && i < xs.length ? just(xs[i]) : nothing;
};
const $0dbe0c7353bd68b1$export$284bbde9874b0917 = function(i, a, xs) {
    var ret = i >= 0 && i < xs.length;
    if (ret) xs[i] = a;
    return ret;
};
const $0dbe0c7353bd68b1$export$b0d1de20d482ef7d = function(xs) {
    return xs.length;
};
const $0dbe0c7353bd68b1$export$636ddc1660dd1285 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.pop()) : nothing;
};
const $0dbe0c7353bd68b1$export$f8b776ba78ff4419 = function(as, xs) {
    return xs.push.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$8a1b3b221575bba8 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.shift()) : nothing;
};
const $0dbe0c7353bd68b1$export$23e87bb70af50c39 = function(as, xs) {
    return xs.unshift.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$b05cd45ffb08c41e = function(i, howMany, bs, xs) {
    return xs.splice.apply(xs, [
        i,
        howMany
    ].concat(bs));
};
function $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl(xs) {
    return xs;
}
const $0dbe0c7353bd68b1$export$f2963aff015afecf = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
const $0dbe0c7353bd68b1$export$601e856cb1838137 = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
function $0dbe0c7353bd68b1$var$copyImpl(xs) {
    return xs.slice();
}
const $0dbe0c7353bd68b1$export$2109af1090f5f6b7 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$cd8ba9f9707c2718 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$57a1a2542c1220dc = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        if (xs.length < 2) return xs;
        mergeFromTo(compare, fromOrdering, xs, xs.slice(0), 0, xs.length);
        return xs;
    };
}();
const $0dbe0c7353bd68b1$export$66323db02f2496b6 = function(xs) {
    var n = xs.length;
    var as = new Array(n);
    for(var i = 0; i < n; i++)as[i] = {
        value: xs[i],
        index: i
    };
    return as;
};
const $0dbe0c7353bd68b1$export$80f4edbb06ec8379 = function(a, xs) {
    return xs.push(a);
};




// Generated by purs version 0.15.15
const $cc20365e325869f4$export$d092af9ac17843bc = function mkSTFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $cc20365e325869f4$export$6a3a9c423c2be31e = function mkSTFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $cc20365e325869f4$export$20b99d064a00c9ee = function mkSTFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $cc20365e325869f4$export$88b7720b4d616633 = function mkSTFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $cc20365e325869f4$export$ff210326ba56123c = function mkSTFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $cc20365e325869f4$export$1df8279312f4490c = function mkSTFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $cc20365e325869f4$export$c438f7da82a827de = function mkSTFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $cc20365e325869f4$export$8016275d609fc2cf = function mkSTFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $cc20365e325869f4$export$85672cd282a38b9f = function mkSTFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $cc20365e325869f4$export$1e8732a765f7f6a9 = function mkSTFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $cc20365e325869f4$export$16973cca6f004709 = function runSTFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $cc20365e325869f4$export$67ab494f009454e2 = function runSTFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $cc20365e325869f4$export$d02c4697b083e08e = function runSTFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $cc20365e325869f4$export$38a1b097838c69d7 = function runSTFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$df815fcba9ace1f4 = function runSTFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$18e87184adad44fe = function runSTFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$e282c4050f6499d3 = function runSTFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$1d03302402d80b8a = function runSTFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$9671bb34351fe15d = function runSTFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$54118f4544b4eca2 = function runSTFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};







var $784e144d56146b5c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $784e144d56146b5c$export$8ff712f7409e81c7 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39);
var $784e144d56146b5c$export$37cdb546b806ae87 = function(a) {
    return $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39)([
        a
    ]);
};
var $784e144d56146b5c$export$cc9b8725eef9c137 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$601e856cb1838137);
var $784e144d56146b5c$export$7c850c5af9b9983e = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$f2963aff015afecf);
var $784e144d56146b5c$export$a8793e37025aca3d = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$66323db02f2496b6);
var $784e144d56146b5c$export$80340c06f76ce783 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$cd8ba9f9707c2718);
var $784e144d56146b5c$export$fd51609fe570ea92 = function(f) {
    return function(xs) {
        return function __do() {
            var result = $784e144d56146b5c$export$80340c06f76ce783(xs)();
            f(result)();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        };
    };
};
var $784e144d56146b5c$export$869882364835d202 = /* #__PURE__ */ $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$b05cd45ffb08c41e);
var $784e144d56146b5c$export$b035e44d7bb4278f = function(comp) {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array.ST (line 129, column 40 - line 132, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $784e144d56146b5c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $784e144d56146b5c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $784e144d56146b5c$export$97db5808d8f88186 = function(dictOrd) {
    return $784e144d56146b5c$export$b035e44d7bb4278f($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $784e144d56146b5c$export$fba63a578e423eb = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$8a1b3b221575bba8)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$889ea624f2cb2c57 = function(st) {
    return $784e144d56146b5c$var$bind(st)($784e144d56146b5c$export$7c850c5af9b9983e)();
};
var $784e144d56146b5c$export$907644183e99da16 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$f8b776ba78ff4419);
var $784e144d56146b5c$export$4cbf152802aa238 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$80f4edbb06ec8379);
var $784e144d56146b5c$export$3e41007ebfff0e64 = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$636ddc1660dd1285)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$dc13bdd74c909d26 = /* #__PURE__ */ $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$284bbde9874b0917);
var $784e144d56146b5c$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$6dc5f95d8548a16a)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$3ff57735a52b8713 = function(i) {
    return function(f) {
        return function(xs) {
            return function __do() {
                var entry = $784e144d56146b5c$export$4d3fb11e950abb9e(i)(xs)();
                if (entry instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $784e144d56146b5c$export$dc13bdd74c909d26(i)(f(entry.value0))(xs)();
                if (entry instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                throw new Error("Failed pattern match at Data.Array.ST (line 234, column 3 - line 236, column 26): " + [
                    entry.constructor.name
                ]);
            };
        };
    };
};
var $784e144d56146b5c$export$f24224f1c91d8156 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$b0d1de20d482ef7d);
var $784e144d56146b5c$export$792f3d81ea979f55 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$2109af1090f5f6b7);
var $784e144d56146b5c$export$9cd59f9826255e47 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$57a1a2542c1220dc);


// Generated by purs version 0.15.15






var $8dd172f1ebfb42af$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $8dd172f1ebfb42af$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$Iterator = /* #__PURE__ */ function() {
    function Iterator(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Iterator.create = function(value0) {
        return function(value1) {
            return new Iterator(value0, value1);
        };
    };
    return Iterator;
}();
var $8dd172f1ebfb42af$export$4d3fb11e950abb9e = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$48cfd1e771a65c4f = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        $08944f7287e2704c$export$3ff57735a52b8713(function(v1) {
            return v1 + 1 | 0;
        })(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$f458d78453dee163 = function(p) {
    return function(iter) {
        return function(array) {
            return function __do() {
                var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
                while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                    var mx = $8dd172f1ebfb42af$export$4d3fb11e950abb9e(iter)();
                    if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && p(mx.value0)) {
                        $784e144d56146b5c$export$4cbf152802aa238(mx.value0)(array)();
                        return $8dd172f1ebfb42af$var$$$void($8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter))();
                    }
                    return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                })();
                return {};
            };
        };
    };
};
var $8dd172f1ebfb42af$export$907644183e99da16 = /* #__PURE__ */ $8dd172f1ebfb42af$export$f458d78453dee163(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $8dd172f1ebfb42af$export$6f58e2338da23f4d = function(f) {
    return $8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$Iterator.create(f))($f11e5cd39add8df2$export$b8cb59497041ffe4(0));
};
var $8dd172f1ebfb42af$export$c1a059043cc9c119 = function(iter) {
    return function(f) {
        return function __do() {
            var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
            while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                var mx = $8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter)();
                if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return f(mx.value0)();
                if (mx instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                throw new Error("Failed pattern match at Data.Array.ST.Iterator (line 42, column 5 - line 44, column 47): " + [
                    mx.constructor.name
                ]);
            })();
            return {};
        };
    };
};
var $8dd172f1ebfb42af$export$dc4133c4d1844d49 = /* #__PURE__ */ function() {
    var $20 = $8dd172f1ebfb42af$var$map($06733ae99ed4f534$export$4967676db1b89293);
    return function($21) {
        return $20($8dd172f1ebfb42af$export$4d3fb11e950abb9e($21));
    };
}();






// Generated by purs version 0.15.15
// module Data.Function.Uncurried
const $8f2697950ee155e1$export$c12d67bac152a4ed = function(fn) {
    return function() {
        return fn();
    };
};
const $8f2697950ee155e1$export$b12d5f1f5e196716 = function(fn) {
    /* jshint maxparams: 2 */ return function(a, b) {
        return fn(a)(b);
    };
};
const $8f2697950ee155e1$export$7c6645ed044f896a = function(fn) {
    /* jshint maxparams: 3 */ return function(a, b, c) {
        return fn(a)(b)(c);
    };
};
const $8f2697950ee155e1$export$f9fcbfb8cc9a5d08 = function(fn) {
    /* jshint maxparams: 4 */ return function(a, b, c, d) {
        return fn(a)(b)(c)(d);
    };
};
const $8f2697950ee155e1$export$253781be9f84fbc = function(fn) {
    /* jshint maxparams: 5 */ return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e);
    };
};
const $8f2697950ee155e1$export$5a7e13c76f011743 = function(fn) {
    /* jshint maxparams: 6 */ return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f);
    };
};
const $8f2697950ee155e1$export$72dc4a47844c2067 = function(fn) {
    /* jshint maxparams: 7 */ return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g);
    };
};
const $8f2697950ee155e1$export$f3e23d6db0ceb902 = function(fn) {
    /* jshint maxparams: 8 */ return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h);
    };
};
const $8f2697950ee155e1$export$d6fc3733d257ba4b = function(fn) {
    /* jshint maxparams: 9 */ return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i);
    };
};
const $8f2697950ee155e1$export$55270393dfa2c83f = function(fn) {
    /* jshint maxparams: 10 */ return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j);
    };
};
const $8f2697950ee155e1$export$6114565cacc4a539 = function(fn) {
    return fn();
};
const $8f2697950ee155e1$export$b3f66664347b6e8d = function(fn) {
    return function(a) {
        return function(b) {
            return fn(a, b);
        };
    };
};
const $8f2697950ee155e1$export$dd8987cb9f63b77e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return fn(a, b, c);
            };
        };
    };
};
const $8f2697950ee155e1$export$c4d34fab9eba1901 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return fn(a, b, c, d);
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$ce6386a175247406 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return fn(a, b, c, d, e);
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$6764cfc4c1bcc63e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return fn(a, b, c, d, e, f);
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$27ec8d6a229d5fae = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return fn(a, b, c, d, e, f, g);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$8a7620e07ee87dd2 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return fn(a, b, c, d, e, f, g, h);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$a68eb29a6e51700a = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return fn(a, b, c, d, e, f, g, h, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$182286db78b54e73 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return fn(a, b, c, d, e, f, g, h, i, j);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};


var $d587cad88c02b1d0$export$44d12d4204be2f8c = function(f) {
    return f;
};
var $d587cad88c02b1d0$export$31aab8bc8543af98 = function(f) {
    return f;
};











var $396c4c3d9e7fae3c$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$intercalate1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $396c4c3d9e7fae3c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $396c4c3d9e7fae3c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $396c4c3d9e7fae3c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $396c4c3d9e7fae3c$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$fold1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $396c4c3d9e7fae3c$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$export$b634740ce272acb5 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$67fd4cff6f1e6bc);
var $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $396c4c3d9e7fae3c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($396c4c3d9e7fae3c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $396c4c3d9e7fae3c$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(us) {
        return function(xs) {
            return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                return traverse_1(function(v) {
                    return $784e144d56146b5c$export$dc13bdd74c909d26(v.value0)(v.value1)(res);
                })(us);
            })(xs)();
        };
    };
};
var $396c4c3d9e7fae3c$export$b6d8713d53419d4c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$4bc13c05b5f586d5)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$90bcd20c17ae578e = function() {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$4459d383cf3fd31d);
};
var $396c4c3d9e7fae3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $396c4c3d9e7fae3c$export$b446f6baa3bb1430 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(x) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                head: x,
                tail: xs
            });
        };
    });
}();
var $396c4c3d9e7fae3c$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(xs) {
        var len = $fc8c1182ec2aefec$export$f24224f1c91d8156(xs);
        var f = function(i) {
            if (i < len) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9($396c4c3d9e7fae3c$var$unsafeIndex1(xs)(i), i + 1 | 0));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Array (line 163, column 3 - line 165, column 26): " + [
                i.constructor.name
            ]);
        };
        return unfoldr(f)(0);
    };
};
var $396c4c3d9e7fae3c$export$c01875f616615628 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(v) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(xs);
        };
    });
}();
var $396c4c3d9e7fae3c$export$b035e44d7bb4278f = function(comp) {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array (line 897, column 38 - line 900, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $396c4c3d9e7fae3c$var$sortWith1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$ff461bf68e7dd332);
var $396c4c3d9e7fae3c$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $396c4c3d9e7fae3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $784e144d56146b5c$export$fd51609fe570ea92($784e144d56146b5c$export$4cbf152802aa238(x))(xs)();
    };
};
var $396c4c3d9e7fae3c$export$58adb3bec8346d0f = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a);
var $396c4c3d9e7fae3c$export$b0d75975ac0be0e1 = function(v) {
    return function(v1) {
        if (v <= 0) return {
            before: [],
            after: v1
        };
        return {
            before: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(v)(v1),
            after: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(v)($fc8c1182ec2aefec$export$f24224f1c91d8156(v1))(v1)
        };
    };
};
var $396c4c3d9e7fae3c$export$b7df5d561049483a = function(n) {
    return function(xs) {
        var $152 = n < 1;
        if ($152) return [];
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(n)(xs);
    };
};
var $396c4c3d9e7fae3c$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $396c4c3d9e7fae3c$export$64df51ac031d4ad2 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$771bbc3bb9be46c2);
var $396c4c3d9e7fae3c$export$65f513eaf3c582b8 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$53974fb866918d71);
var $396c4c3d9e7fae3c$export$606959e7ccb797f0 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$86a7d437bed76c03);
var $396c4c3d9e7fae3c$export$d02631cccf789723 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$3561205b7dff20bf);
var $396c4c3d9e7fae3c$export$b29f828819edca8d = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$25718970d830661a);
var $396c4c3d9e7fae3c$export$7b1b591b262c240 = function(xs) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156(xs) === 0;
};
var $396c4c3d9e7fae3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(is) {
        return function(f) {
            return function(xs) {
                return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                    return traverse_1(function(i) {
                        return $784e144d56146b5c$export$3ff57735a52b8713(i)(f)(res);
                    })(is);
                })(xs)();
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8f07ddce13659f50 = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $396c4c3d9e7fae3c$export$af200dcf8b7cb5de = function(a) {
    return function(arr) {
        var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(arr);
        if (v < 2) return arr;
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $784e144d56146b5c$export$889ea624f2cb2c57(function() {
            var unsafeGetElem = function(idx) {
                return $396c4c3d9e7fae3c$var$unsafeIndex1(arr)(idx);
            };
            return function __do() {
                var out = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                $784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(0))(out)();
                $f11e5cd39add8df2$export$f89de2e5bf57e5e6(1)(v)(function(idx) {
                    return function __do() {
                        $784e144d56146b5c$export$4cbf152802aa238(a)(out)();
                        return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(idx))(out))();
                    };
                })();
                return out;
            };
        }());
        throw new Error("Failed pattern match at Data.Array (line 623, column 21 - line 633, column 17): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$739ec22334c44788 = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$intercalate1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$9f200c4466975173 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$d553b0efc2008003)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$2cd8252107eb640b = function(xs) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(xs)) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $06733ae99ed4f534$export$8a67b48435b5d073($396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0)(xs));
    throw new Error("Failed pattern match at Data.Array (line 351, column 1 - line 351, column 45): " + [
        xs.constructor.name
    ]);
};
var $396c4c3d9e7fae3c$export$b610b8812bbcded9 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$fe8606c16d7ceed6)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$4c7897fafd92b108 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0);
};
var $396c4c3d9e7fae3c$export$712962e076096ed4 = function(xs) {
    return $396c4c3d9e7fae3c$var$apply($396c4c3d9e7fae3c$var$map(function(v) {
        return function(v1) {
            return {
                init: v,
                last: v1
            };
        };
    })($396c4c3d9e7fae3c$export$2cd8252107eb640b(xs)))($396c4c3d9e7fae3c$export$4c7897fafd92b108(xs));
};
var $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(f(x))(xs);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$afc1bfabebaf28a2 = function(p) {
    return function(arr) {
        var go = function($copy_i) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i) {
                var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(arr)(i);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $156 = p(v.value0);
                    if ($156) {
                        $copy_i = i + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(i);
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.Array (line 1035, column 5 - line 1037, column 25): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_i);
            return $tco_result;
        };
        var breakIndex = go(0);
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && breakIndex.value0 === 0) return {
            init: [],
            rest: arr
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            init: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(breakIndex.value0)(arr),
            rest: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(breakIndex.value0)($fc8c1182ec2aefec$export$f24224f1c91d8156(arr))(arr)
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
            init: arr,
            rest: []
        };
        throw new Error("Failed pattern match at Data.Array (line 1022, column 3 - line 1028, column 30): " + [
            breakIndex.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$9384c7afe4015e42 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).init;
    };
};
var $396c4c3d9e7fae3c$export$23c8d3f8757cab88 = function(xs) {
    return function __do() {
        var fsts = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var snds = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
            return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
        })();
        $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(v) {
            return function __do() {
                $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value0)(fsts))();
                return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value1)(snds))();
            };
        })();
        var fsts$prime = $784e144d56146b5c$export$7c850c5af9b9983e(fsts)();
        var snds$prime = $784e144d56146b5c$export$7c850c5af9b9983e(snds)();
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fsts$prime, snds$prime);
    }();
};
var $396c4c3d9e7fae3c$export$5fd5031fecdacec3 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(0);
};
var $396c4c3d9e7fae3c$export$18f77a3bafa759b9 = function(comp) {
    return function(xs) {
        var indexedAndSorted = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(x) {
            return function(y) {
                return comp($71f2e2e9476163f8$export$6f71268a1666ab58(x))($71f2e2e9476163f8$export$6f71268a1666ab58(y));
            };
        })($396c4c3d9e7fae3c$export$8f07ddce13659f50($71f2e2e9476163f8$export$1908877435b1d5e9.create)(xs));
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(indexedAndSorted);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)($396c4c3d9e7fae3c$var$sortWith1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(function __do() {
            var result = $784e144d56146b5c$export$cc9b8725eef9c137($396c4c3d9e7fae3c$export$439306a4dcaafbb9(v.value0))();
            $f11e5cd39add8df2$export$8802485f9deae94f(indexedAndSorted)(function(v1) {
                return function __do() {
                    var lst = $396c4c3d9e7fae3c$var$map2(function() {
                        var $183 = function($185) {
                            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$4c7897fafd92b108($185));
                        };
                        return function($184) {
                            return $71f2e2e9476163f8$export$6f71268a1666ab58($183($184));
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(result))();
                    return $396c4c3d9e7fae3c$var$when($396c4c3d9e7fae3c$var$notEq(comp(lst)(v1.value1))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value))($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v1)(result)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }()));
        throw new Error("Failed pattern match at Data.Array (line 1115, column 17 - line 1123, column 28): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$94f4066a75b10404 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$3f063810d7bf01bd = function(op) {
    return function(xs) {
        return function __do() {
            var result = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(x) {
                return $396c4c3d9e7fae3c$var$$$void(function __do() {
                    var sub1 = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                    $784e144d56146b5c$export$4cbf152802aa238(x)(sub1)();
                    $8dd172f1ebfb42af$export$f458d78453dee163(op(x))(iter)(sub1)();
                    var grp = $784e144d56146b5c$export$7c850c5af9b9983e(sub1)();
                    return $784e144d56146b5c$export$4cbf152802aa238(grp)(result)();
                });
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$1f7a5bf12caafbd = function(cmp) {
    var $186 = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $187 = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(cmp);
    return function($188) {
        return $186($187($188));
    };
};
var $396c4c3d9e7fae3c$export$361434b95a7d965 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$e5e25fbcc1f7affe = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$3f063810d7bf01bd(eq2)(xs);
    };
};
var $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$7de5ece11b723a44)($4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable));
};
var $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$50ae948ca12cdcbc = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$9cb09a71b7d66923 = function(xs) {
    var buildNext = function(idx) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$50ae948ca12cdcbc)($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(acc) {
            return function(nextArr) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(el) {
                    return new $06733ae99ed4f534$export$8a67b48435b5d073($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([
                        el
                    ])($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$c40cf5aab899f397)(el))(acc));
                })($396c4c3d9e7fae3c$export$b610b8812bbcded9(nextArr)(idx));
            };
        })(xs);
    };
    var go = function($copy_idx) {
        return function($copy_allArrays) {
            var $tco_var_idx = $copy_idx;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(idx, allArrays) {
                var v = buildNext(idx);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return allArrays;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_idx = idx + 1 | 0;
                    $copy_allArrays = $396c4c3d9e7fae3c$export$c40cf5aab899f397(allArrays)(v.value0);
                    return;
                }
                throw new Error("Failed pattern match at Data.Array (line 837, column 22 - line 839, column 52): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_idx, $copy_allArrays);
            return $tco_result;
        };
    };
    return go(0)([]);
};
var $396c4c3d9e7fae3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        return function(b) {
            return function(array) {
                var go = function(res) {
                    return function(i) {
                        if (i >= $fc8c1182ec2aefec$export$f24224f1c91d8156(array)) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(res));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind1(f(res)($396c4c3d9e7fae3c$var$unsafeIndex1(array)(i)))(function(res$prime) {
                            return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                                a: res$prime,
                                b: i + 1 | 0
                            }));
                        });
                        throw new Error("Failed pattern match at Data.Array (line 1349, column 3 - line 1353, column 42): " + [
                            res.constructor.name,
                            i.constructor.name
                        ]);
                    };
                };
                return tailRecM2(go)(b)(0);
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$b66cdc0497d8a99a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$foldMap1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)(function(v) {
                return pure1(b);
            })(function(a) {
                return function(as) {
                    return bind1(f(b)(a))(function(b$prime) {
                        return $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(as);
                    });
                };
            });
        };
    };
};
var $396c4c3d9e7fae3c$export$93e2b83da34ff82a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$fold1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$23e5dcedfce4509c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$7ad327e9a65b0147)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$c15bd07a493e1236);
}();
var $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$32bcb9f71841245e)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(ys) {
            var i = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)(function(v) {
                return v + 1 | 0;
            })($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(y) {
                return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
            })(ys));
            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$9f200c4466975173(i)(x)(ys));
        };
    };
};
var $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$de3a4d4a0d731119 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$885b84ba169666c7)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$71aa6c912b956294 = function(f) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$map($396c4c3d9e7fae3c$var$unsafeIndex1(xs))($396c4c3d9e7fae3c$export$de3a4d4a0d731119(f)(xs));
    };
};
var $396c4c3d9e7fae3c$export$3dea766d36a8935f = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$e85b5b674fbfff84);
var $396c4c3d9e7fae3c$export$f161f39e9c06ab2d = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(x) {
                return $06733ae99ed4f534$export$c15bd07a493e1236($396c4c3d9e7fae3c$export$de3a4d4a0d731119(eq2(x))(ys));
            })(xs);
        };
    };
};
var $396c4c3d9e7fae3c$export$1f4807a235930d45 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$63faa62a0284a4a6 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$4967676db1b89293(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$5bf96401662340b7 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$533af5c8cd6afa16 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).rest;
    };
};
var $396c4c3d9e7fae3c$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b7df5d561049483a($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$663103110d94aac9 = function(n) {
    return function(xs) {
        var $173 = n < 1;
        if ($173) return xs;
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(n)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs))(xs);
    };
};
var $396c4c3d9e7fae3c$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$663103110d94aac9($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$90f9093465da3136 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$e83371a4d1b4407c)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.length === 0) return [];
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v2)(function(i) {
                return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$90f9093465da3136(i)(v2));
            })($396c4c3d9e7fae3c$export$de3a4d4a0d731119(v(v1))(v2));
        };
    };
};
var $396c4c3d9e7fae3c$export$1822828d790e23ee = function(dictEq) {
    return $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$acaf96a27438246b = function(dictEq) {
    return $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf($396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq));
};
var $396c4c3d9e7fae3c$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$append([
            x
        ])(xs);
    };
};
var $396c4c3d9e7fae3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply1(map3($396c4c3d9e7fae3c$export$8327ebbef2a0ba76)(v))(defer(function(v1) {
                return $396c4c3d9e7fae3c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $396c4c3d9e7fae3c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1([]));
        };
    };
};
var $396c4c3d9e7fae3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986));
var $396c4c3d9e7fae3c$export$e70771d2e7e590a = function(f) {
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function() {
        var $189 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])($396c4c3d9e7fae3c$export$439306a4dcaafbb9);
        return function($190) {
            return $189(f($190));
        };
    }());
};
var $396c4c3d9e7fae3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var traverse1 = $396c4c3d9e7fae3c$var$traverse(dictApplicative);
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    return function(p) {
        var $191 = map3($396c4c3d9e7fae3c$export$e70771d2e7e590a(function(v) {
            if (v.value1) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }));
        var $192 = traverse1(function(x) {
            return map3($71f2e2e9476163f8$export$1908877435b1d5e9.create(x))(p(x));
        });
        return function($193) {
            return $191($192($193));
        };
    };
};
var $396c4c3d9e7fae3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $396c4c3d9e7fae3c$export$e70771d2e7e590a(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $396c4c3d9e7fae3c$export$4154a199d7d90455 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$b98f41a67d1483f3);
var $396c4c3d9e7fae3c$export$45273896c792ff3b = function(eq2) {
    return function(xs) {
        return function __do() {
            var arr = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(xs)(function(x) {
                return function __do() {
                    var e = $396c4c3d9e7fae3c$var$map2(function() {
                        var $194 = $396c4c3d9e7fae3c$export$4154a199d7d90455(function(v) {
                            return eq2(v)(x);
                        });
                        return function($195) {
                            return !$194($195);
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(arr))();
                    return $396c4c3d9e7fae3c$var$when(e)($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(x)(arr)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(arr)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$edce5881c815871 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$var$append(xs)($396c4c3d9e7fae3c$export$50ae948ca12cdcbc($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(eq2)))($396c4c3d9e7fae3c$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $396c4c3d9e7fae3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                var v = f(x);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $396c4c3d9e7fae3c$export$90f9093465da3136(i)(xs);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(v.value0)(xs);
                throw new Error("Failed pattern match at Data.Array (line 601, column 10 - line 603, column 32): " + [
                    v.constructor.name
                ]);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$84bf76cd7afc7469 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$739e1ef870df7d82);






// Generated by purs version 0.15.15

var $47a0a3ebf66dcc6a$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Step.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Step(value0, value1, value2, value3);
                };
            };
        };
    };
    return Step;
}();
var $47a0a3ebf66dcc6a$export$4f45170fb98a7886 = $ac8b3532514ac019$export$401372c57776dc;
var $47a0a3ebf66dcc6a$export$35d34bc0ed591a92 = function(v, a) {
    return v.value2(v.value1, a);
};
var $47a0a3ebf66dcc6a$export$dc52c2e07163a142 = $ac8b3532514ac019$export$401372c57776dc;
var $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de = function(v) {
    return v.value3(v.value1);
};
var $47a0a3ebf66dcc6a$export$f9380c9a627682d3 = /* #__PURE__ */ $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v) {
    return v.value0;
});


// Generated by purs version 0.15.15







var $bef4063d6d8fe507$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $bef4063d6d8fe507$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $bef4063d6d8fe507$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $bef4063d6d8fe507$export$f89ac22183df46e9 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$4d8ac795221d227 = function(x) {
    return x;
};
var $bef4063d6d8fe507$export$5f1af8db9871e1d6 = /* #__PURE__ */ function() {
    function Text(value0) {
        this.value0 = value0;
    }
    Text.create = function(value0) {
        return new Text(value0);
    };
    return Text;
}();
var $bef4063d6d8fe507$export$cc2832fafe367c5e = /* #__PURE__ */ function() {
    function Elem(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Elem.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Elem(value0, value1, value2, value3);
                };
            };
        };
    };
    return Elem;
}();
var $bef4063d6d8fe507$export$bade370ab89110b = /* #__PURE__ */ function() {
    function Keyed(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Keyed.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Keyed(value0, value1, value2, value3);
                };
            };
        };
    };
    return Keyed;
}();
var $bef4063d6d8fe507$export$a829527ff4e4114a = /* #__PURE__ */ function() {
    function Widget(value0) {
        this.value0 = value0;
    }
    Widget.create = function(value0) {
        return new Widget(value0);
    };
    return Widget;
}();
var $bef4063d6d8fe507$export$b73d5241bf90e3b6 = /* #__PURE__ */ function() {
    function Grafted(value0) {
        this.value0 = value0;
    }
    Grafted.create = function(value0) {
        return new Grafted(value0);
    };
    return Grafted;
}();
var $bef4063d6d8fe507$export$8ac9228c788aaa24 = /* #__PURE__ */ function() {
    function Graft(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Graft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Graft(value0, value1, value2);
            };
        };
    };
    return Graft;
}();
var $bef4063d6d8fe507$export$c0694dcc5ceec5fe = function(f) {
    return function($61) {
        return f($61);
    };
};
var $bef4063d6d8fe507$export$1b27a95e780e7371 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $bef4063d6d8fe507$export$2de60fdae46e330f = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $bef4063d6d8fe507$export$15ad108a4eed29f5 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$79c9400ffffba296 = {
    Coercible0: function() {
        return undefined;
    }
};
var $bef4063d6d8fe507$export$9bae923d92949c2f = $ac8b3532514ac019$export$401372c57776dc;
var $bef4063d6d8fe507$export$d77f48fa96824602 = {
    map: function(g) {
        return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
            return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v.value0, function($62) {
                return g(v.value1($62));
            }, v.value2));
        });
    }
};
var $bef4063d6d8fe507$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bef4063d6d8fe507$export$d77f48fa96824602);
var $bef4063d6d8fe507$export$1654609171f4374f = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v1.value0);
            if (v1 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$map2(v)(v1.value0));
            return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24($bef4063d6d8fe507$var$identity, v, v1)));
        };
    }
};
var $bef4063d6d8fe507$export$520c9b3bf6c7d33a = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $bef4063d6d8fe507$export$23ec092d74ce9fd = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $bef4063d6d8fe507$export$45ea1942547d2591 = {
    bimap: function(f) {
        return function(g) {
            return $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
                return $bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(function($63) {
                    return f(v.value0($63));
                }, function($64) {
                    return g(v.value1($64));
                }, v.value2));
            });
        };
    }
};
var $bef4063d6d8fe507$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($bef4063d6d8fe507$export$45ea1942547d2591);
var $bef4063d6d8fe507$export$cb4b70c26113b373 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
                if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v)(v1)(v2.value0));
                return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$export$9bae923d92949c2f(new $bef4063d6d8fe507$export$8ac9228c788aaa24(v, v1, v2)));
            };
        };
    }
};
var $bef4063d6d8fe507$export$355e219ccdea0aec = /* #__PURE__ */ $bef4063d6d8fe507$export$c0694dcc5ceec5fe(function(v) {
    var go = function(v2) {
        if (v2 instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v2.value0);
        if (v2 instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map(go)(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v2.value0, v2.value1, v.value0(v2.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1(go))(v2.value3));
        if (v2 instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return new $bef4063d6d8fe507$export$a829527ff4e4114a(v.value1(v2.value0));
        if (v2 instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return new $bef4063d6d8fe507$export$b73d5241bf90e3b6($bef4063d6d8fe507$var$bimap(v.value0)(v.value1)(v2.value0));
        throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
            v2.constructor.name
        ]);
    };
    return go(v.value2);
});
var $bef4063d6d8fe507$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            if (v instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return new $bef4063d6d8fe507$export$5f1af8db9871e1d6(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$cc2832fafe367c5e(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$bade370ab89110b) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, f(v.value2), $bef4063d6d8fe507$var$map($bef4063d6d8fe507$var$map1($bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)))(v.value3));
            if (v instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return g(v.value0);
            if (v instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $bef4063d6d8fe507$export$8b4d9aa5702dece6(f)(g)($bef4063d6d8fe507$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.Types (line 48, column 20 - line 53, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};


// Generated by purs version 0.15.15
"use strict";
function $39e0beec4569345c$export$e21bd765865a4e96(key, obj) {
    return obj[key];
}
function $39e0beec4569345c$export$2d12e28667eef122(key, obj) {
    return obj.hasOwnProperty(key);
}
function $39e0beec4569345c$export$eecc4ddbfda9d798(key, val, obj) {
    obj[key] = val;
}
function $39e0beec4569345c$export$97784d9c47ea0c18(key, obj) {
    delete obj[key];
}
function $39e0beec4569345c$export$3dfbdd78bf0090db(a, f) {
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(f(i, a[i]));
    return b;
}
function $39e0beec4569345c$export$b658ad92e4f7ae19(a, f) {
    for(var i = 0; i < a.length; i++)f(a[i]);
}
function $39e0beec4569345c$export$2da2a225d7cdb301(o, f) {
    var ks = Object.keys(o);
    for(var i = 0; i < ks.length; i++){
        var k = ks[i];
        f(k, o[k]);
    }
}
function $39e0beec4569345c$export$eb8acc503e07b694(n, f) {
    for(var i = 0; i < n; i++)f();
}
function $39e0beec4569345c$export$2422518e1f611f3f(a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i = 0;
    while(true){
        if (i < l1) {
            if (i < l2) a3.push(f1(i, a1[i], a2[i]));
            else f2(i, a1[i]);
        } else if (i < l2) a3.push(f3(i, a2[i]));
        else break;
        i++;
    }
    return a3;
}
function $39e0beec4569345c$export$e766566cf460084(as, fk, f) {
    var o = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        o[k] = f(k, i, a);
    }
    return o;
}
function $39e0beec4569345c$export$ca7590ccd55f275f(o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        if (o1.hasOwnProperty(k)) o2[k] = f1(k, i, o1[k], a);
        else o2[k] = f3(k, i, a);
    }
    for(var k in o1){
        if (k in o2) continue;
        f2(k, o1[k]);
    }
    return o2;
}
function $39e0beec4569345c$export$9bc2d847a861e3d8(a, b) {
    return a === b;
}
function $39e0beec4569345c$export$b2ce9ad90858ed7a(s, doc) {
    return doc.createTextNode(s);
}
function $39e0beec4569345c$export$94b0296cab6203e(s, n) {
    n.textContent = s;
}
function $39e0beec4569345c$export$c8a8987d4410bf2d(ns, name, doc) {
    if (ns != null) return doc.createElementNS(ns, name);
    else return doc.createElement(name);
}
function $39e0beec4569345c$export$11c1557a40268f0f(i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) b.insertBefore(a, n);
}
function $39e0beec4569345c$export$7ae609f7af59e4f7(a, b) {
    if (b && a.parentNode === b) b.removeChild(a);
}
function $39e0beec4569345c$export$b54be7ce267a037b(a) {
    return a.parentNode;
}
function $39e0beec4569345c$export$9fec4d97f1922e0b(ns, attr, val, el) {
    if (ns != null) el.setAttributeNS(ns, attr, val);
    else el.setAttribute(attr, val);
}
function $39e0beec4569345c$export$6399f3bb52316b2c(ns, attr, el) {
    if (ns != null) el.removeAttributeNS(ns, attr);
    else el.removeAttribute(attr);
}
function $39e0beec4569345c$export$7895096fcdde5712(ns, attr, el) {
    if (ns != null) return el.hasAttributeNS(ns, attr);
    else return el.hasAttribute(attr);
}
function $39e0beec4569345c$export$3f65cefe8380dbea(ev, listener, el) {
    el.addEventListener(ev, listener, false);
}
function $39e0beec4569345c$export$8ff9f68337b520c0(ev, listener, el) {
    el.removeEventListener(ev, listener, false);
}
var $39e0beec4569345c$export$1e4bb18162c9f619 = void 0;


// Generated by purs version 0.15.15
const $0061661dcaa2328e$export$b8cb59497041ffe4 = function() {
    return {};
};
function $0061661dcaa2328e$export$6dc5f95d8548a16a(just) {
    return function(nothing) {
        return function(k) {
            return function(m) {
                return function() {
                    return ({}).hasOwnProperty.call(m, k) ? just(m[k]) : nothing;
                };
            };
        };
    };
}
function $0061661dcaa2328e$export$dc13bdd74c909d26(k) {
    return function(v) {
        return function(m) {
            return function() {
                m[k] = v;
                return m;
            };
        };
    };
}
const $0061661dcaa2328e$export$1822828d790e23ee = function(k) {
    return function(m) {
        return function() {
            delete m[k];
            return m;
        };
    };
};



var $47b38aa8c72308f2$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $0061661dcaa2328e$export$6dc5f95d8548a16a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();



var $ac7bed94ac89bf37$export$7ff190aa1ea44157 = $39e0beec4569345c$export$e21bd765865a4e96;
var $ac7bed94ac89bf37$export$7c850c5af9b9983e = $ac8b3532514ac019$export$401372c57776dc;
var $ac7bed94ac89bf37$export$fcec48ff7d1e433f = $39e0beec4569345c$export$eecc4ddbfda9d798;
var $ac7bed94ac89bf37$export$af208d62fa81d7e9 = $0061661dcaa2328e$export$b8cb59497041ffe4;
var $ac7bed94ac89bf37$export$60e478053f1f2ade = $39e0beec4569345c$export$97784d9c47ea0c18;


// Generated by purs version 0.15.15
var $875f34aecc7bf161$var$getProp = function(name) {
    return function(doctype) {
        return doctype[name];
    };
};
const $875f34aecc7bf161$export$3c44083a252eeb14 = $875f34aecc7bf161$var$getProp("namespaceURI");
const $875f34aecc7bf161$export$6ae22f6d74087c1a = $875f34aecc7bf161$var$getProp("prefix");
const $875f34aecc7bf161$export$cbef64f03c7768af = $875f34aecc7bf161$var$getProp("localName");
const $875f34aecc7bf161$export$45e0b80f1e500bd4 = $875f34aecc7bf161$var$getProp("tagName");
function $875f34aecc7bf161$export$d560c7e4a29451c2(node) {
    return function() {
        return node.id;
    };
}
function $875f34aecc7bf161$export$5fd54ffb744fa241(id) {
    return function(node) {
        return function() {
            node.id = id;
        };
    };
}
function $875f34aecc7bf161$export$2913c0c0b5623090(node) {
    return function() {
        return node.className;
    };
}
function $875f34aecc7bf161$export$11c615ce16f87241(element) {
    return function() {
        return element.classList;
    };
}
function $875f34aecc7bf161$export$826e926e0c74f2b8(className) {
    return function(node) {
        return function() {
            node.className = className;
        };
    };
}
function $875f34aecc7bf161$export$af941c3c7c3b40f5(localName) {
    return function(doc) {
        return function() {
            return doc.getElementsByTagName(localName);
        };
    };
}
function $875f34aecc7bf161$export$83374683e5723893(ns) {
    return function(localName) {
        return function(doc) {
            return function() {
                return doc.getElementsByTagNameNS(ns, localName);
            };
        };
    };
}
function $875f34aecc7bf161$export$764e2797d3aa1cff(classNames) {
    return function(doc) {
        return function() {
            return doc.getElementsByClassName(classNames);
        };
    };
}
function $875f34aecc7bf161$export$9fec4d97f1922e0b(name) {
    return function(value) {
        return function(element) {
            return function() {
                element.setAttribute(name, value);
            };
        };
    };
}
function $875f34aecc7bf161$export$2dc9d886be7724ad(name) {
    return function(element) {
        return function() {
            return element.getAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$7895096fcdde5712(name) {
    return function(element) {
        return function() {
            return element.hasAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$6399f3bb52316b2c(name) {
    return function(element) {
        return function() {
            element.removeAttribute(name);
        };
    };
}
function $875f34aecc7bf161$export$de994efd351b291c(selector) {
    return function(element) {
        return function() {
            return element.matches(selector);
        };
    };
}
function $875f34aecc7bf161$export$15ddd5fd0edb3555(selector) {
    return function(element) {
        return function() {
            return element.closest(selector);
        };
    };
}
function $875f34aecc7bf161$export$3e0c8fa3b5e4b3b9(node) {
    return function() {
        return node.scrollTop;
    };
}
function $875f34aecc7bf161$export$38a81aac5c9c320d(scrollTop) {
    return function(node) {
        return function() {
            node.scrollTop = scrollTop;
        };
    };
}
function $875f34aecc7bf161$export$6eddf9bc7f2b7d80(node) {
    return function() {
        return node.scrollLeft;
    };
}
function $875f34aecc7bf161$export$ed5fd5ffe5ab0ac(scrollLeft) {
    return function(node) {
        return function() {
            node.scrollLeft = scrollLeft;
        };
    };
}
function $875f34aecc7bf161$export$dc81048565b75a98(el) {
    return function() {
        return el.scrollWidth;
    };
}
function $875f34aecc7bf161$export$5a0845c0f7cb1511(el) {
    return function() {
        return el.scrollHeight;
    };
}
function $875f34aecc7bf161$export$b570871c7d022cff(el) {
    return function() {
        return el.clientTop;
    };
}
function $875f34aecc7bf161$export$6af8701396d90b51(el) {
    return function() {
        return el.clientLeft;
    };
}
function $875f34aecc7bf161$export$f451d61d633bfdbe(el) {
    return function() {
        return el.clientWidth;
    };
}
function $875f34aecc7bf161$export$1ceecc078aa19b72(el) {
    return function() {
        return el.clientHeight;
    };
}
function $875f34aecc7bf161$export$84fe60b31769e95f(el) {
    return function() {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y
        };
    };
}
function $875f34aecc7bf161$export$4afda0764643aba3(props) {
    return function(el) {
        return function() {
            return el.attachShadow(props);
        };
    };
}







// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
function $d6be799e52b0a69c$export$fe54a26f58202d85(el) {
    return el.mode;
}
function $d6be799e52b0a69c$export$5e032988b71f6158(el) {
    return function() {
        return el.host;
    };
}




var $33beec599fea318b$export$779aeef03935e9f3 = /* #__PURE__ */ function() {
    function Open() {}
    Open.value = new Open();
    return Open;
}();
var $33beec599fea318b$export$b6448e3d47beddf0 = /* #__PURE__ */ function() {
    function Closed() {}
    Closed.value = new Closed();
    return Closed;
}();
var $33beec599fea318b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $33beec599fea318b$export$2197b54dae41dfe4 = {
    show: function(v) {
        if (v instanceof $33beec599fea318b$export$779aeef03935e9f3) return "open";
        if (v instanceof $33beec599fea318b$export$b6448e3d47beddf0) return "closed";
        throw new Error("Failed pattern match at Web.DOM.ShadowRoot (line 22, column 1 - line 24, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $33beec599fea318b$export$549ff81930776885 = /* #__PURE__ */ function() {
    var modeFromString = function(v) {
        if (v === "open") return new $06733ae99ed4f534$export$8a67b48435b5d073($33beec599fea318b$export$779aeef03935e9f3.value);
        if (v === "closed") return new $06733ae99ed4f534$export$8a67b48435b5d073($33beec599fea318b$export$b6448e3d47beddf0.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    return function($5) {
        return modeFromString($d6be799e52b0a69c$export$fe54a26f58202d85($5));
    };
}();



var $6cbf6bdab8368bba$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($33beec599fea318b$export$2197b54dae41dfe4);
var $6cbf6bdab8368bba$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $6cbf6bdab8368bba$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6cbf6bdab8368bba$export$82e9f45cca5ba907 = function($3) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($875f34aecc7bf161$export$6ae22f6d74087c1a($3));
};
var $6cbf6bdab8368bba$export$4bb31c815825375a = function($4) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($875f34aecc7bf161$export$3c44083a252eeb14($4));
};
var $6cbf6bdab8368bba$var$initToProps = function(init) {
    return {
        mode: $6cbf6bdab8368bba$var$show(init.mode),
        delegatesFocus: init.delegatesFocus
    };
};
var $6cbf6bdab8368bba$export$5c5bb02a2f64596a = function($5) {
    return $875f34aecc7bf161$export$83374683e5723893($0a5aaf95f168428e$export$b187f57ee1822bc5($5));
};
var $6cbf6bdab8368bba$export$735ee1799fd02602 = function(attr) {
    var $6 = $6cbf6bdab8368bba$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $7 = $875f34aecc7bf161$export$2dc9d886be7724ad(attr);
    return function($8) {
        return $6($7($8));
    };
};
var $6cbf6bdab8368bba$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Element");
var $6cbf6bdab8368bba$export$ff7f7c97cdce86e = function(qs) {
    var $9 = $6cbf6bdab8368bba$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $10 = $875f34aecc7bf161$export$15ddd5fd0edb3555(qs);
    return function($11) {
        return $9($10($11));
    };
};
var $6cbf6bdab8368bba$export$c9f3f5ba3dfbdf61 = function($12) {
    return $875f34aecc7bf161$export$4afda0764643aba3($6cbf6bdab8368bba$var$initToProps($12));
};


var $784c06f0344d34c4$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $784c06f0344d34c4$export$db317447723f2845 = function(x) {
    return x;
};
var $784c06f0344d34c4$var$haltWidget = function(v) {
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.widget);
};
var $784c06f0344d34c4$var$$lazy_patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchWidget", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchWidget(291)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) {
            var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.widget, vdom.value0);
            var res$prime = $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v) {
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(v.value0, {
                    build: state.build,
                    widget: res
                }, $784c06f0344d34c4$var$$lazy_patchWidget(296), $784c06f0344d34c4$var$haltWidget));
            })(res);
            return res$prime;
        }
        $784c06f0344d34c4$var$haltWidget(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchWidget = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchWidget(286);
var $784c06f0344d34c4$var$haltText = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    return $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
};
var $784c06f0344d34c4$var$$lazy_patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchText", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchText(82)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) {
            if (state.value === vdom.value0) return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, state, $784c06f0344d34c4$var$$lazy_patchText(85), $784c06f0344d34c4$var$haltText));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var nextState = {
                    build: state.build,
                    node: state.node,
                    value: vdom.value0
                };
                $39e0beec4569345c$export$94b0296cab6203e(vdom.value0, state.node);
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchText(89), $784c06f0344d34c4$var$haltText));
            }
        }
        $784c06f0344d34c4$var$haltText(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchText = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchText(77);
var $784c06f0344d34c4$var$haltKeyed = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
    $39e0beec4569345c$export$2da2a225d7cdb301(v.children, function(v1, s) {
        return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
    });
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.attrs);
};
var $784c06f0344d34c4$var$haltElem = function(v) {
    var parent = $39e0beec4569345c$export$b54be7ce267a037b(v.node);
    $39e0beec4569345c$export$7ae609f7af59e4f7(v.node, parent);
    $39e0beec4569345c$export$b658ad92e4f7ae19(v.children, $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de);
    return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(v.attrs);
};
var $784c06f0344d34c4$var$eqElemSpec = function(ns1, v, ns2, v1) {
    var $63 = v === v1;
    if ($63) {
        if (ns1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && ns2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && ns1.value0 === ns2.value0) return true;
        if (ns1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && ns2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
        return false;
    }
    return false;
};
var $784c06f0344d34c4$var$$lazy_patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchElem", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchElem(135)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(vdom.value3);
            var v1 = $fc8c1182ec2aefec$export$f24224f1c91d8156(state.children);
            if (v1 === 0 && v === 0) {
                var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(149), $784c06f0344d34c4$var$haltElem));
            }
            var onThis = function(v2, s) {
                return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(ix, s, v2) {
                var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(s, v2);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(ix, v2) {
                var res = state.build(v2);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $39e0beec4569345c$export$2422518e1f611f3f(state.children, vdom.value3, onThese, onThis, onThat);
            var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchElem(172), $784c06f0344d34c4$var$haltElem));
        }
        $784c06f0344d34c4$var$haltElem(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchElem = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchElem(130);
var $784c06f0344d34c4$var$$lazy_patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$runtime_lazy("patchKeyed", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $784c06f0344d34c4$var$$lazy_patchKeyed(222)(state, $bef4063d6d8fe507$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $bef4063d6d8fe507$export$bade370ab89110b && $784c06f0344d34c4$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(vdom.value3);
            if (state.length === 0 && v === 0) {
                var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children,
                    length: 0
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(237), $784c06f0344d34c4$var$haltKeyed));
            }
            var onThis = function(v2, s) {
                return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(v2, ix$prime, s, v3) {
                var res = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(s, v3.value1);
                $39e0beec4569345c$export$11c1557a40268f0f(ix$prime, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(v2, ix, v3) {
                var res = state.build(v3.value1);
                $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $39e0beec4569345c$export$ca7590ccd55f275f(state.children, vdom.value3, $71f2e2e9476163f8$export$9e770fa6ce19a9d6, onThese, onThis, onThat);
            var attrs2 = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2,
                length: v
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(state.node, nextState, $784c06f0344d34c4$var$$lazy_patchKeyed(261), $784c06f0344d34c4$var$haltKeyed));
        }
        $784c06f0344d34c4$var$haltKeyed(state);
        return state.build(vdom);
    };
});
var $784c06f0344d34c4$var$patchKeyed = /* #__PURE__ */ $784c06f0344d34c4$var$$lazy_patchKeyed(217);
var $784c06f0344d34c4$export$150cc32b4adaaae = function(v, build, w) {
    var res = v.buildWidget(v)(w);
    var res$prime = $47a0a3ebf66dcc6a$export$4f45170fb98a7886(function(v1) {
        return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(v1.value0, {
            build: build,
            widget: res
        }, $784c06f0344d34c4$var$patchWidget, $784c06f0344d34c4$var$haltWidget));
    })(res);
    return res$prime;
};
var $784c06f0344d34c4$export$97ed363902aee1ba = function(v, build, s) {
    var node = $39e0beec4569345c$export$b2ce9ad90858ed7a(s, v.document);
    var state = {
        build: build,
        node: node,
        value: s
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchText, $784c06f0344d34c4$var$haltText));
};
var $784c06f0344d34c4$export$198573fdc68576c0 = function(v, build, ns1, name1, as1, ch1) {
    var el = $39e0beec4569345c$export$c8a8987d4410bf2d($0a5aaf95f168428e$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $6cbf6bdab8368bba$export$83a0de4644f1fbc4(el);
    var onChild = function(v1, ix, v2) {
        var res = build(v2.value1);
        $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $39e0beec4569345c$export$e766566cf460084(ch1, $71f2e2e9476163f8$export$9e770fa6ce19a9d6, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children,
        length: $fc8c1182ec2aefec$export$f24224f1c91d8156(ch1)
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchKeyed, $784c06f0344d34c4$var$haltKeyed));
};
var $784c06f0344d34c4$export$88209766f38bf9bf = function(v, build, ns1, name1, as1, ch1) {
    var el = $39e0beec4569345c$export$c8a8987d4410bf2d($0a5aaf95f168428e$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $6cbf6bdab8368bba$export$83a0de4644f1fbc4(el);
    var onChild = function(ix, child) {
        var res = build(child);
        $39e0beec4569345c$export$11c1557a40268f0f(ix, $47a0a3ebf66dcc6a$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $39e0beec4569345c$export$3dfbdd78bf0090db(ch1, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children
    };
    return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, state, $784c06f0344d34c4$var$patchElem, $784c06f0344d34c4$var$haltElem));
};
var $784c06f0344d34c4$export$7d13c0f6790d0505 = function(spec) {
    var $lazy_build = $784c06f0344d34c4$var$$runtime_lazy("build", "Halogen.VDom.DOM", function() {
        return function(v) {
            if (v instanceof $bef4063d6d8fe507$export$5f1af8db9871e1d6) return $784c06f0344d34c4$export$97ed363902aee1ba(spec, $lazy_build(59), v.value0);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return $784c06f0344d34c4$export$88209766f38bf9bf(spec, $lazy_build(60), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $bef4063d6d8fe507$export$bade370ab89110b) return $784c06f0344d34c4$export$198573fdc68576c0(spec, $lazy_build(61), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $bef4063d6d8fe507$export$a829527ff4e4114a) return $784c06f0344d34c4$export$150cc32b4adaaae(spec, $lazy_build(62), v.value0);
            if (v instanceof $bef4063d6d8fe507$export$b73d5241bf90e3b6) return $lazy_build(63)($bef4063d6d8fe507$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                v.constructor.name
            ]);
        };
    });
    var build = $lazy_build(58);
    return build;
};






// Generated by purs version 0.15.15






// Generated by purs version 0.15.15
function $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value) {
    return typeof value;
}
function $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $c2c5bfcfd98ddabb$export$630801d484da15df(value) {
    return value === null;
}
function $c2c5bfcfd98ddabb$export$fce6876652108ab(value) {
    return value === undefined;
}
const $c2c5bfcfd98ddabb$export$43bee75e5e14138e = Array.isArray || function(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
};










// Generated by purs version 0.15.15
const $4ab74a20512cef04$export$5b3229f64c38e483 = function(just) {
    return function(nothing) {
        return function(n) {
            /* jshint bitwise: false */ return (n | 0) === n ? just(n) : nothing;
        };
    };
};
const $4ab74a20512cef04$export$a0a81dc3380ce7d3 = function(n) {
    return n;
};
const $4ab74a20512cef04$export$221b4f162df9878c = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s) {
                /* jshint bitwise: false */ if (pattern.test(s)) {
                    var i = parseInt(s, radix);
                    return (i | 0) === i ? just(i) : nothing;
                } else return nothing;
            };
        };
    };
};
const $4ab74a20512cef04$export$f601457c5ee3082f = function(radix) {
    return function(i) {
        return i.toString(radix);
    };
};
const $4ab74a20512cef04$export$dcbbe75d5a67af21 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x / y | 0;
    };
};
const $4ab74a20512cef04$export$fb1897a40d146f7f = function(x) {
    return function(y) {
        return x % y;
    };
};
const $4ab74a20512cef04$export$9c297f60e22e3389 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return Math.pow(x, y) | 0;
    };
};







// Generated by purs version 0.15.15
/* globals exports */ const $9a14cd925227149d$export$9e06de0973666692 = NaN;
const $9a14cd925227149d$export$c9f5652083b8129d = isNaN;
const $9a14cd925227149d$export$a0978488bc4efbee = Infinity;
const $9a14cd925227149d$export$65f0b13f2f82375a = isFinite;
function $9a14cd925227149d$export$3ffe08ccbe76f69e(str, isFinite1, just, nothing) {
    var num = parseFloat(str);
    if (isFinite1(num)) return just(num);
    else return nothing;
}
const $9a14cd925227149d$export$2335f513bbd82c6d = Math.abs;
const $9a14cd925227149d$export$fd6306be3fde5b04 = Math.acos;
const $9a14cd925227149d$export$41726bdb1fc63f = Math.asin;
const $9a14cd925227149d$export$628dc4eed22b0fbd = Math.atan;
const $9a14cd925227149d$export$b8b770ee6a0d9760 = function(y) {
    return function(x) {
        return Math.atan2(y, x);
    };
};
const $9a14cd925227149d$export$803ce6b71a0a94b2 = Math.ceil;
const $9a14cd925227149d$export$50d414a77b60d802 = Math.cos;
const $9a14cd925227149d$export$b310ec824aaee37f = Math.exp;
const $9a14cd925227149d$export$a3fe094919f356fd = Math.floor;
const $9a14cd925227149d$export$bef1f36f5486a6a3 = Math.log;
const $9a14cd925227149d$export$8960430cfd85939f = function(n1) {
    return function(n2) {
        return Math.max(n1, n2);
    };
};
const $9a14cd925227149d$export$96ec731ed4dcb222 = function(n1) {
    return function(n2) {
        return Math.min(n1, n2);
    };
};
const $9a14cd925227149d$export$9c297f60e22e3389 = function(n) {
    return function(p) {
        return Math.pow(n, p);
    };
};
const $9a14cd925227149d$export$159037f780d3415c = function(n) {
    return function(m) {
        return n % m;
    };
};
const $9a14cd925227149d$export$2077e0241d6afd3c = Math.round;
const $9a14cd925227149d$export$c5552dfdbc7cec71 = Math.sign ? Math.sign : function(x) {
    return x === 0 || x !== x ? x : x < 0 ? -1 : 1;
};
const $9a14cd925227149d$export$5de3937cb4b592ed = Math.sin;
const $9a14cd925227149d$export$eba8049fb5020b81 = Math.sqrt;
const $9a14cd925227149d$export$fcdd3b0b3246a325 = Math.tan;
const $9a14cd925227149d$export$1fe87bd59b089f0 = Math.trunc ? Math.trunc : function(x) {
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};



var $052de1c85deb22bf$export$a4b4b4d4d776fe92 = 6.283185307179586;
var $052de1c85deb22bf$export$2fa35f36c870f3b7 = 1.4142135623730951;
var $052de1c85deb22bf$export$9eaf1e6179158e34 = 0.7071067811865476;
var $052de1c85deb22bf$export$18c7bea995a110f = 3.141592653589793;
var $052de1c85deb22bf$export$4d03748825f009b9 = 1.4426950408889634;
var $052de1c85deb22bf$export$4ca92b5d1d793bd5 = 0.4342944819032518;
var $052de1c85deb22bf$export$27692bafabcf0fdc = 0.6931471805599453;
var $052de1c85deb22bf$export$e1abf6863d05a89e = 2.302585092994046;
var $052de1c85deb22bf$export$3004f64547af360e = function(str) {
    return $9a14cd925227149d$export$3ffe08ccbe76f69e(str, $9a14cd925227149d$export$65f0b13f2f82375a, $06733ae99ed4f534$export$8a67b48435b5d073.create, $06733ae99ed4f534$export$bebe9059409a0d04.value);
};
var $052de1c85deb22bf$export$f1e1789686576879 = 2.718281828459045;




var $8d5664f12212b23e$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$Radix = function(x) {
    return x;
};
var $8d5664f12212b23e$export$33ca3b017f2e3089 = /* #__PURE__ */ function() {
    function Even() {}
    Even.value = new Even();
    return Even;
}();
var $8d5664f12212b23e$export$6bbc73627dceae86 = /* #__PURE__ */ function() {
    function Odd() {}
    Odd.value = new Odd();
    return Odd;
}();
var $8d5664f12212b23e$export$9f422d81718beff7 = {
    show: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return "Even";
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return "Odd";
        throw new Error("Failed pattern match at Data.Int (line 117, column 1 - line 119, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $8d5664f12212b23e$export$1db3e511bfb04803 = function(n) {
    if (n >= 2 && n <= 36) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Int (line 198, column 1 - line 198, column 28): " + [
        n.constructor.name
    ]);
};
var $8d5664f12212b23e$export$74b48c691cc42eb1 = function(x) {
    return (x & 1) !== 0;
};
var $8d5664f12212b23e$export$90d8fbb029b06afc = 8;
var $8d5664f12212b23e$export$9c12a48020146abe = 16;
var $8d5664f12212b23e$export$d7a050b0311540b9 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$221b4f162df9878c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$export$3004f64547af360e = /* #__PURE__ */ $8d5664f12212b23e$export$d7a050b0311540b9(10);
var $8d5664f12212b23e$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$5b3229f64c38e483($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$var$unsafeClamp = function(x) {
    if (!$9a14cd925227149d$export$65f0b13f2f82375a(x)) return 0;
    if (x >= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$top)) return $8d5664f12212b23e$var$top;
    if (x <= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$bottom)) return $8d5664f12212b23e$var$bottom;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$43db023a260c5e9f(0)($8d5664f12212b23e$export$7bbb4164c9a77bc2(x));
    throw new Error("Failed pattern match at Data.Int (line 72, column 1 - line 72, column 29): " + [
        x.constructor.name
    ]);
};
var $8d5664f12212b23e$export$2077e0241d6afd3c = function($37) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$2077e0241d6afd3c($37));
};
var $8d5664f12212b23e$export$1fe87bd59b089f0 = function($38) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$1fe87bd59b089f0($38));
};
var $8d5664f12212b23e$export$a3fe094919f356fd = function($39) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$a3fe094919f356fd($39));
};
var $8d5664f12212b23e$export$df5fefc55a4eba3c = function(x) {
    return (x & 1) === 0;
};
var $8d5664f12212b23e$export$efe353078db02e10 = function(n) {
    var $28 = $8d5664f12212b23e$export$df5fefc55a4eba3c(n);
    if ($28) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
    return $8d5664f12212b23e$export$6bbc73627dceae86.value;
};
var $8d5664f12212b23e$export$8424267183f54e9d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return true;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return true;
            return false;
        };
    }
};
var $8d5664f12212b23e$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($8d5664f12212b23e$export$8424267183f54e9d);
var $8d5664f12212b23e$export$8b12bf30fdd3264f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Int (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $8d5664f12212b23e$export$8424267183f54e9d;
    }
};
var $8d5664f12212b23e$export$39d55cbe74216cbe = /* #__PURE__ */ function() {
    return {
        zero: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        add: function(x) {
            return function(y) {
                var $33 = $8d5664f12212b23e$var$eq1(x)(y);
                if ($33) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
                return $8d5664f12212b23e$export$6bbc73627dceae86.value;
            };
        },
        one: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        mul: function(v) {
            return function(v1) {
                if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && v1 instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $8d5664f12212b23e$export$6bbc73627dceae86.value;
                return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
            };
        }
    };
}();
var $8d5664f12212b23e$export$e741c28ebd8a3552 = {
    sub: /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($8d5664f12212b23e$export$39d55cbe74216cbe),
    Semiring0: function() {
        return $8d5664f12212b23e$export$39d55cbe74216cbe;
    }
};
var $8d5664f12212b23e$export$5bd06fe87b344eef = {
    recip: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$78a48a3d1e5dbe89 = 10;
var $8d5664f12212b23e$export$cf50720682a32a87 = {
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$965db879d0c14bc1 = {
    degree: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return 0;
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return 1;
        throw new Error("Failed pattern match at Data.Int (line 137, column 1 - line 141, column 17): " + [
            v.constructor.name
        ]);
    },
    div: function(x) {
        return function(v) {
            return x;
        };
    },
    mod: function(v) {
        return function(v1) {
            return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
        };
    },
    CommutativeRing0: function() {
        return $8d5664f12212b23e$export$cf50720682a32a87;
    }
};
var $8d5664f12212b23e$export$803ce6b71a0a94b2 = function($40) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$803ce6b71a0a94b2($40));
};
var $8d5664f12212b23e$export$fc5d11f6ca2bf4fc = /* #__PURE__ */ function() {
    return {
        bottom: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        top: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        Ord0: function() {
            return $8d5664f12212b23e$export$8b12bf30fdd3264f;
        }
    };
}();
var $8d5664f12212b23e$export$33902b7329277358 = 2;
var $8d5664f12212b23e$export$95b61e7c39ae893a = 36;


// Generated by purs version 0.15.15



















var $ba51d599f79a6310$var$sequence1 = /* #__PURE__ */ $e4fb66202bb8a4f4$export$6deffb29affc84c6($78c799cba34fcb8d$export$fac1bbd0707bc766);
var $ba51d599f79a6310$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ba51d599f79a6310$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$3c979cc7d75b024c);
var $ba51d599f79a6310$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$12e3398ee6f4a417);
var $ba51d599f79a6310$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ba51d599f79a6310$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $ba51d599f79a6310$export$b634740ce272acb5 = function(f) {
    return function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0)(v1.value0), $3d4fd987da5242ff$export$b634740ce272acb5(f)(v.value1)(v1.value1));
        };
    };
};
var $ba51d599f79a6310$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence11 = $ba51d599f79a6310$var$sequence1(dictApplicative.Apply0());
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence11($ba51d599f79a6310$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $ba51d599f79a6310$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $ba51d599f79a6310$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $ba51d599f79a6310$var$wrappedOperation2 = function(name) {
    return function(f) {
        return function(v) {
            return function(v1) {
                var v2 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v1.value1));
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v2.value0, v2.value1);
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
                throw new Error("Failed pattern match at Data.List.NonEmpty (line 105, column 3 - line 107, column 81): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ba51d599f79a6310$var$wrappedOperation = function(name) {
    return function(f) {
        return function(v) {
            var v1 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v1.value1);
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 92, column 3 - line 94, column 81): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$b6d8713d53419d4c = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($193) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($193));
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 198, column 1 - line 198, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$23c8d3f8757cab88 = function(ts) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9($ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(ts), $ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)(ts));
};
var $ba51d599f79a6310$export$712962e076096ed4 = function(v) {
    var v1 = $3d4fd987da5242ff$export$712962e076096ed4(v.value1);
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
        init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        last: v.value0
    };
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
        init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0.init),
        last: v1.value0.last
    };
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 160, column 35 - line 162, column 50): " + [
        v1.constructor.name
    ]);
};
var $ba51d599f79a6310$export$ef1d06dc4d91d507 = /* #__PURE__ */ function() {
    var $194 = $ba51d599f79a6310$var$wrappedOperation2("unionBy");
    return function($195) {
        return $194($3d4fd987da5242ff$export$ef1d06dc4d91d507($195));
    };
}();
var $ba51d599f79a6310$export$971dd5b0dfd021b6 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("union")($3d4fd987da5242ff$export$971dd5b0dfd021b6(dictEq));
};
var $ba51d599f79a6310$export$b446f6baa3bb1430 = function(v) {
    return {
        head: v.value0,
        tail: v.value1
    };
};
var $ba51d599f79a6310$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $ba51d599f79a6310$export$823be24f8766da23 = function(dictUnfoldable) {
    var $196 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $ba51d599f79a6310$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
    return function($197) {
        return $196($ba51d599f79a6310$export$effcdbd76139450($197));
    };
};
var $ba51d599f79a6310$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $ba51d599f79a6310$export$b035e44d7bb4278f = /* #__PURE__ */ function() {
    var $198 = $ba51d599f79a6310$var$wrappedOperation("sortBy");
    return function($199) {
        return $198($3d4fd987da5242ff$export$b035e44d7bb4278f($199));
    };
}();
var $ba51d599f79a6310$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $ba51d599f79a6310$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $ba51d599f79a6310$export$c40cf5aab899f397 = function(v) {
    return function(y) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(y));
    };
};
var $ba51d599f79a6310$export$439306a4dcaafbb9 = /* #__PURE__ */ function() {
    var $200 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
    return function($201) {
        return $78c799cba34fcb8d$export$ab241a3582569781($200($201));
    };
}();
var $ba51d599f79a6310$export$5b6d1d165591a48c = function(v) {
    return function(v1) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(v1));
        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $ba51d599f79a6310$export$439306a4dcaafbb9(v1);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 140, column 1 - line 140, column 51): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$66c1ae025e96b4bc = /* #__PURE__ */ $ba51d599f79a6310$var$wrappedOperation("reverse")($3d4fd987da5242ff$export$66c1ae025e96b4bc);
var $ba51d599f79a6310$export$edce5881c815871 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("nubEq")($3d4fd987da5242ff$export$edce5881c815871(dictEq));
};
var $ba51d599f79a6310$export$45273896c792ff3b = /* #__PURE__ */ function() {
    var $202 = $ba51d599f79a6310$var$wrappedOperation("nubByEq");
    return function($203) {
        return $202($3d4fd987da5242ff$export$45273896c792ff3b($203));
    };
}();
var $ba51d599f79a6310$export$18f77a3bafa759b9 = /* #__PURE__ */ function() {
    var $204 = $ba51d599f79a6310$var$wrappedOperation("nubBy");
    return function($205) {
        return $204($3d4fd987da5242ff$export$18f77a3bafa759b9($205));
    };
}();
var $ba51d599f79a6310$export$94f4066a75b10404 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("nub")($3d4fd987da5242ff$export$94f4066a75b10404(dictOrd));
};
var $ba51d599f79a6310$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0), v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($206) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($206));
            })($3d4fd987da5242ff$export$cba09f9e3d3e58eb(i - 1 | 0)(f)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 203, column 1 - line 203, column 82): " + [
                i.constructor.name,
                f.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$var$lift = function(f) {
    return function(v) {
        return f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$e70771d2e7e590a = function($207) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$e70771d2e7e590a($207));
};
var $ba51d599f79a6310$export$b29f828819edca8d = function($208) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b29f828819edca8d($208));
};
var $ba51d599f79a6310$export$afc1bfabebaf28a2 = function($209) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$afc1bfabebaf28a2($209));
};
var $ba51d599f79a6310$export$b7df5d561049483a = function($210) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b7df5d561049483a($210));
};
var $ba51d599f79a6310$export$9384c7afe4015e42 = function($211) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$9384c7afe4015e42($211));
};
var $ba51d599f79a6310$export$f24224f1c91d8156 = function(v) {
    return 1 + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $ba51d599f79a6310$export$4c7897fafd92b108 = function(v) {
    return $06733ae99ed4f534$export$43db023a260c5e9f(v.value0)($3d4fd987da5242ff$export$4c7897fafd92b108(v.value1));
};
var $ba51d599f79a6310$export$f161f39e9c06ab2d = /* #__PURE__ */ function() {
    var $212 = $ba51d599f79a6310$var$wrappedOperation2("intersectBy");
    return function($213) {
        return $212($3d4fd987da5242ff$export$f161f39e9c06ab2d($213));
    };
}();
var $ba51d599f79a6310$export$1f4807a235930d45 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("intersect")($3d4fd987da5242ff$export$1f4807a235930d45(dictEq));
};
var $ba51d599f79a6310$export$9f200c4466975173 = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1)));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($214) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($214));
            })($3d4fd987da5242ff$export$9f200c4466975173(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 193, column 1 - line 193, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$2cd8252107eb640b = function(v) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(function(v1) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
    })($3d4fd987da5242ff$export$2cd8252107eb640b(v.value1));
};
var $ba51d599f79a6310$export$b610b8812bbcded9 = function(v) {
    return function(i) {
        if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $3d4fd987da5242ff$export$b610b8812bbcded9(v.value1)(i - 1 | 0);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 167, column 1 - line 167, column 52): " + [
            v.constructor.name,
            i.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $ba51d599f79a6310$export$3f063810d7bf01bd = /* #__PURE__ */ function() {
    var $215 = $ba51d599f79a6310$var$wrappedOperation("groupBy");
    return function($216) {
        return $215($3d4fd987da5242ff$export$3f063810d7bf01bd($216));
    };
}();
var $ba51d599f79a6310$export$1f7a5bf12caafbd = /* #__PURE__ */ function() {
    var $217 = $ba51d599f79a6310$var$wrappedOperation("groupAllBy");
    return function($218) {
        return $217($3d4fd987da5242ff$export$1f7a5bf12caafbd($218));
    };
}();
var $ba51d599f79a6310$export$361434b95a7d965 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("groupAll")($3d4fd987da5242ff$export$361434b95a7d965(dictOrd));
};
var $ba51d599f79a6310$export$e5e25fbcc1f7affe = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("group")($3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictEq));
};
var $ba51d599f79a6310$export$88e0dae599377b39 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v.value1));
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 121, column 1 - line 121, column 57): " + [
        v.constructor.name
    ]);
};
var $ba51d599f79a6310$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $219 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function($220) {
        return $ba51d599f79a6310$export$88e0dae599377b39($219($220));
    };
};
var $ba51d599f79a6310$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var foldM1 = $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(b) {
            return function(v) {
                return bind1(f(b)(v.value0))(function(b$prime) {
                    return foldM1(f)(b$prime)(v.value1);
                });
            };
        };
    };
};
var $ba51d599f79a6310$export$8855a8be7bd3e9f8 = function(f) {
    return function(v) {
        var v1 = $3d4fd987da5242ff$export$8855a8be7bd3e9f8(f)(v.value1);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0 + 1 | 0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 187, column 3 - line 191, column 29): " + [
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$de3a4d4a0d731119 = function(f) {
    return function(v) {
        if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function(v1) {
            return v1 + 1 | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(f)(v.value1));
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 180, column 1 - line 180, column 69): " + [
            f.constructor.name,
            v.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$20098ecb074a31e6 = function(dictMonad) {
    var $221 = $3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad);
    return function($222) {
        return $ba51d599f79a6310$var$lift($221($222));
    };
};
var $ba51d599f79a6310$export$3dea766d36a8935f = function($223) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$3dea766d36a8935f($223));
};
var $ba51d599f79a6310$export$c19d79386f4ed99a = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$8855a8be7bd3e9f8(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$f444781b0adb7e4d = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$de3a4d4a0d731119(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$533af5c8cd6afa16 = function($224) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$533af5c8cd6afa16($224));
};
var $ba51d599f79a6310$export$663103110d94aac9 = function($225) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$663103110d94aac9($225));
};
var $ba51d599f79a6310$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x, xs);
    };
};
var $ba51d599f79a6310$export$8327ebbef2a0ba76 = function(y) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(y, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ba51d599f79a6310$var$bind);
var $ba51d599f79a6310$export$ee1b3e54f0441b22 = function(v) {
    return $ba51d599f79a6310$var$bind(v)($ba51d599f79a6310$var$identity);
};
var $ba51d599f79a6310$export$986c2bbe7a34be0b = /* #__PURE__ */ $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$986c2bbe7a34be0b);
var $ba51d599f79a6310$export$89c5a0ebe497f8c7 = function(dictFoldable) {
    var fromFoldable1 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function(v) {
        return function(ys) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $ba51d599f79a6310$var$append1(v.value1)(fromFoldable1(ys)));
        };
    };
};






// Generated by purs version 0.15.15
const $092fe44bc0883be6$export$709e3b51bf2e2249 = function(a) {
    return a.join("");
};
const $092fe44bc0883be6$export$f718f38b069557c4 = function(s) {
    return s.split("");
};
const $092fe44bc0883be6$export$439306a4dcaafbb9 = function(c) {
    return c;
};
const $092fe44bc0883be6$export$f23b62aaf3f3dcce = function(just) {
    return function(nothing) {
        return function(i) {
            return function(s) {
                return i >= 0 && i < s.length ? just(s.charAt(i)) : nothing;
            };
        };
    };
};
const $092fe44bc0883be6$export$dc80a44c5e0495a = function(just) {
    return function(nothing) {
        return function(s) {
            return s.length === 1 ? just(s) : nothing;
        };
    };
};
const $092fe44bc0883be6$export$f24224f1c91d8156 = function(s) {
    return s.length;
};
const $092fe44bc0883be6$export$29a68f758c141c85 = function(p) {
    return function(s) {
        var i = 0;
        while(i < s.length && p(s.charAt(i)))i++;
        return i;
    };
};
const $092fe44bc0883be6$export$7e78e83ef6946ae3 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.indexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$dbaa25b6da818165 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    if (startAt < 0 || startAt > s.length) return nothing;
                    var i = s.indexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$a83518545dfc0fc1 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.lastIndexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$12738dfb878f3de0 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    var i = s.lastIndexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$b7df5d561049483a = function(n) {
    return function(s) {
        return s.substr(0, n);
    };
};
const $092fe44bc0883be6$export$663103110d94aac9 = function(n) {
    return function(s) {
        return s.substring(n);
    };
};
const $092fe44bc0883be6$export$58adb3bec8346d0f = function(b) {
    return function(e) {
        return function(s) {
            return s.slice(b, e);
        };
    };
};
const $092fe44bc0883be6$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        return {
            before: s.substring(0, i),
            after: s.substring(i)
        };
    };
};



// Generated by purs version 0.15.15
const $3296d29fc7ea4822$export$bbcf894add1d392c = function(i) {
    return function(s) {
        if (i >= 0 && i < s.length) return s.charAt(i);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
const $3296d29fc7ea4822$export$eba6f6f03b0a92e7 = function(s) {
    if (s.length === 1) return s.charAt(0);
    throw new Error("Data.String.Unsafe.char: Expected string of length 1.");
};




var $1a77d6934b592676$export$b446f6baa3bb1430 = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3296d29fc7ea4822$export$bbcf894add1d392c(0)(v),
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(v)
    });
};
var $1a77d6934b592676$export$bafb3da1554990db = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dc80a44c5e0495a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$1bbc425ddca7f2c6 = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$cc5663efaab5bcf6 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(str) - $092fe44bc0883be6$export$f24224f1c91d8156(v) | 0)(str);
        var $14 = v1.after === v;
        if ($14) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.before);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$71c2a1babd78d286 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(v))(str);
        var $20 = v1.before === v;
        if ($20) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.after);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$9dc3eed83bb14216 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$12738dfb878f3de0($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$557cfb7ed375eeb7 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$a83518545dfc0fc1($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$7f0e23922170149a = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dbaa25b6da818165($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$305f7d4e9d4624f2 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$7e78e83ef6946ae3($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$6ba801e3e123536e = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$2344b14b097df817 = function(pat) {
    var $23 = $1a77d6934b592676$export$305f7d4e9d4624f2(pat);
    return function($24) {
        return $06733ae99ed4f534$export$c15bd07a493e1236($23($24));
    };
};
var $1a77d6934b592676$export$bbcf894add1d392c = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$f23b62aaf3f3dcce($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();



var $c97d2d0f578f81ad$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c97d2d0f578f81ad$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $c97d2d0f578f81ad$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $c97d2d0f578f81ad$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c97d2d0f578f81ad$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c97d2d0f578f81ad$export$f6a37cc43a8b8898 = /* #__PURE__ */ function() {
    function ForeignError(value0) {
        this.value0 = value0;
    }
    ForeignError.create = function(value0) {
        return new ForeignError(value0);
    };
    return ForeignError;
}();
var $c97d2d0f578f81ad$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch.create = function(value0) {
        return function(value1) {
            return new TypeMismatch(value0, value1);
        };
    };
    return TypeMismatch;
}();
var $c97d2d0f578f81ad$export$20d9a5af040a79f1 = /* #__PURE__ */ function() {
    function ErrorAtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex(value0, value1);
        };
    };
    return ErrorAtIndex;
}();
var $c97d2d0f578f81ad$export$92e5795aa905bd26 = /* #__PURE__ */ function() {
    function ErrorAtProperty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty(value0, value1);
        };
    };
    return ErrorAtProperty;
}();
var $c97d2d0f578f81ad$export$9d82982d31d9d171 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$19df04dfac508e15 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$ca110433ecb89bbf = {
    show: function(v) {
        if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return "(ForeignError " + ($c97d2d0f578f81ad$var$show(v.value0) + ")");
        if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "(ErrorAtIndex " + ($c97d2d0f578f81ad$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "(ErrorAtProperty " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "(TypeMismatch " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($c97d2d0f578f81ad$var$show(v.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v.constructor.name
        ]);
    }
};
var $c97d2d0f578f81ad$export$a2293656e769bd56 = function(v) {
    if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return v.value0;
    if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "Error at array index " + ($c97d2d0f578f81ad$var$show1(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "Error at property " + ($c97d2d0f578f81ad$var$show(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "Type mismatch: expected " + (v.value0 + (", found " + v.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v.constructor.name
    ]);
};
var $c97d2d0f578f81ad$export$4e0f52105ee4b19b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 174, column 1 - line 174, column 103): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$a540325489296c24 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value) || $c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 179, column 1 - line 179, column 109): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$62e87727fba30d8d = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 169, column 1 - line 169, column 98): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$2b62a06a9fee979c = function(dictMonad) {
    var $153 = $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad));
    return function($154) {
        return $153($ba51d599f79a6310$export$439306a4dcaafbb9($154));
    };
};
var $c97d2d0f578f81ad$export$d3f4ca0e55363719 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$43bee75e5e14138e(value)) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a("array", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$6190f2182377b437 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(tag) {
        return function(value) {
            if ($c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) === tag) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a(tag, $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value.constructor.name
            ]);
        };
    };
};
var $c97d2d0f578f81ad$export$f9a84177eae95ed5 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Boolean");
};
var $c97d2d0f578f81ad$export$347fd215c36b10be = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Number");
};
var $c97d2d0f578f81ad$export$ac3747cb00139c63 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $c97d2d0f578f81ad$export$347fd215c36b10be(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Int", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromNumber = function() {
            var $155 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($156) {
                return $155($8d5664f12212b23e$export$7bbb4164c9a77bc2($156));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromNumber)))(readNumber1(value));
    };
};
var $c97d2d0f578f81ad$export$dda73877cb166cd3 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("String");
};
var $c97d2d0f578f81ad$export$85b98eeba3f0a3b4 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readString1 = $c97d2d0f578f81ad$export$dda73877cb166cd3(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Char", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromString = function() {
            var $157 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($158) {
                return $157($1a77d6934b592676$export$bafb3da1554990db($158));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromString)))(readString1(value));
    };
};
var $c97d2d0f578f81ad$export$29dc7ef345289543 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return x.value0 === y.value0;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            return false;
        };
    }
};
var $c97d2d0f578f81ad$export$661e78eef4f027af = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $c97d2d0f578f81ad$var$compare(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) {
                var v = $c97d2d0f578f81ad$var$compare1(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Foreign (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c97d2d0f578f81ad$export$29dc7ef345289543;
    }
};


// Generated by purs version 0.15.15
function $03b6b966974423fe$export$86b08f6436aa565c(m) {
    return function() {
        var r = {};
        for(var k in m)if (hasOwnProperty.call(m, k)) r[k] = m[k];
        return r;
    };
}
const $03b6b966974423fe$export$6e22c362a0406a2c = {};
function $03b6b966974423fe$export$c764c4f4747e1972(f) {
    return f();
}
function $03b6b966974423fe$export$7c3aa937ffdd4482(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(m0[k]);
    return m;
}
function $03b6b966974423fe$export$b583322487d15176(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(k)(m0[k]);
    return m;
}
function $03b6b966974423fe$export$882f367473bfeff9(bind) {
    return function(f) {
        return function(mz) {
            return function(m) {
                var acc = mz;
                function g(k) {
                    return function(z) {
                        return f(z)(k)(m[k]);
                    };
                }
                for(var k in m)if (hasOwnProperty.call(m, k)) acc = bind(acc)(g(k));
                return acc;
            };
        };
    };
}
function $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, fromMaybe) {
    var acc = z;
    for(var k in m)if (hasOwnProperty.call(m, k)) {
        var maybeR = f(acc)(k)(m[k]);
        var r = fromMaybe(null)(maybeR);
        if (r === null) return acc;
        else acc = r;
    }
    return acc;
}
function $03b6b966974423fe$export$84bf76cd7afc7469(f) {
    return function(m) {
        for(var k in m){
            if (hasOwnProperty.call(m, k) && !f(k)(m[k])) return false;
        }
        return true;
    };
}
function $03b6b966974423fe$export$346677f925de839c(m) {
    var s = 0;
    for(var k in m)if (hasOwnProperty.call(m, k)) ++s;
    return s;
}
function $03b6b966974423fe$export$75b750e7d0325364(no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
}
function $03b6b966974423fe$export$d947399a194fcef2(no, yes, k, m) {
    return function() {
        return k in m ? yes(m[k]) : no;
    };
}
function $03b6b966974423fe$export$4b1360bff9337362(f) {
    return function(m) {
        var r = [];
        for(var k in m)if (hasOwnProperty.call(m, k)) r.push(f(k)(m[k]));
        return r;
    };
}
const $03b6b966974423fe$export$ed97f33186d4b816 = Object.keys || $03b6b966974423fe$export$4b1360bff9337362(function(k) {
    return function() {
        return k;
    };
});

























var $c045ea5df33bba60$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $c045ea5df33bba60$var$showTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c045ea5df33bba60$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$forWithIndex_ = /* #__PURE__ */ $519ef1967f17d101$export$f441c83f81b7710f($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $c045ea5df33bba60$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $c045ea5df33bba60$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c045ea5df33bba60$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c045ea5df33bba60$export$68c286be0e7e55b7 = /* #__PURE__ */ $03b6b966974423fe$export$4b1360bff9337362(function(v) {
    return function(v1) {
        return v1;
    };
});
var $c045ea5df33bba60$export$823be24f8766da23 = function(dictUnfoldable) {
    var $89 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $90 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($91) {
        return $89($90($91));
    };
};
var $c045ea5df33bba60$export$930399be55d0753b = function(dictUnfoldable) {
    var $92 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $93 = $c045ea5df33bba60$var$sortWith($71f2e2e9476163f8$export$9e770fa6ce19a9d6);
    var $94 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($95) {
        return $92($93($94($95)));
    };
};
var $c045ea5df33bba60$var$toAscArray = /* #__PURE__ */ $c045ea5df33bba60$export$930399be55d0753b($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $c045ea5df33bba60$var$toArray = /* #__PURE__ */ function() {
    return $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $c045ea5df33bba60$export$170df9728335f27d = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return $03b6b966974423fe$export$c764c4f4747e1972($c045ea5df33bba60$var$bindFlipped($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v))($0061661dcaa2328e$export$b8cb59497041ffe4));
    };
};
var $c045ea5df33bba60$export$4cfa48b10b7cd72d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225($c045ea5df33bba60$var$showTuple(dictShow)));
    return {
        show: function(m) {
            return "(fromFoldable " + (show($c045ea5df33bba60$var$toArray(m)) + ")");
        }
    };
};
var $c045ea5df33bba60$var$mutate = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $c045ea5df33bba60$export$170df9728335f27d(m)();
            f(s)();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$6a0d13241802fe80 = /* #__PURE__ */ $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $c045ea5df33bba60$export$1292458786b96e98 = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$b583322487d15176(m, f);
    };
};
var $c045ea5df33bba60$export$dfc7155ac0343b8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $c045ea5df33bba60$export$35d0420a84c5d3ae = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(m1) {
        return function(m2) {
            var f = function(k) {
                return function(v) {
                    return $03b6b966974423fe$export$75b750e7d0325364(false, eq(v), k, m2);
                };
            };
            return $03b6b966974423fe$export$84bf76cd7afc7469(f)(m1);
        };
    };
};
var $c045ea5df33bba60$export$dd1bc94b04021eeb = /* #__PURE__ */ $03b6b966974423fe$export$84bf76cd7afc7469(function(v) {
    return function(v1) {
        return false;
    };
});
var $c045ea5df33bba60$export$21a5ca8aa77d35ff = function(k) {
    return function(v) {
        return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v));
    };
};
var $c045ea5df33bba60$export$b7bb4265e2e489e0 = {
    map: function(f) {
        return function(m) {
            return $03b6b966974423fe$export$7c3aa937ffdd4482(m, f);
        };
    }
};
var $c045ea5df33bba60$export$9c938d99ebec5017 = {
    mapWithIndex: $c045ea5df33bba60$export$1292458786b96e98,
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    }
};
var $c045ea5df33bba60$export$a47a4d0fc4d6b25 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $c045ea5df33bba60$export$78cfe3464e7eb77b = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $c045ea5df33bba60$var$forWithIndex_(dictFoldableWithIndex);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            forWithIndex_1(l)(function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s);
                };
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$690be49d504fc7f = function(dictFoldable) {
    var for_1 = $c045ea5df33bba60$var$for_(dictFoldable);
    return function(f) {
        return function(l) {
            return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
                var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
                for_1(l)(function(v) {
                    return function __do() {
                        var v$prime = $03b6b966974423fe$export$d947399a194fcef2(v.value1, f(v.value1), v.value0, s)();
                        return $0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v$prime)(s)();
                    };
                })();
                return s;
            });
        };
    };
};
var $c045ea5df33bba60$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable1 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(fromFoldable1(l))(function(v) {
                return $c045ea5df33bba60$var$$$void($0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v.value1)(s));
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$a153ee4522d3545b = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$a769d86e5b325bcf = function(f) {
    return function(z) {
        return function(m) {
            return $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, $06733ae99ed4f534$export$43db023a260c5e9f);
        };
    };
};
var $c045ea5df33bba60$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(z) {
            return $03b6b966974423fe$export$882f367473bfeff9(bind1)(f)(pure1(z));
        };
    };
};
var $c045ea5df33bba60$var$foldM1 = /* #__PURE__ */ $c045ea5df33bba60$export$7a067f9280ad8af0($08944f7287e2704c$export$962073314682c2c);
var $c045ea5df33bba60$export$971dd5b0dfd021b6 = function(m) {
    return $c045ea5df33bba60$var$mutate(function(s) {
        return $c045ea5df33bba60$var$foldM1(function(s$prime) {
            return function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s$prime);
                };
            };
        })(s)(m);
    });
};
var $c045ea5df33bba60$export$30b2db2f7030f6cf = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)($c045ea5df33bba60$export$971dd5b0dfd021b6)($03b6b966974423fe$export$6e22c362a0406a2c);
};
var $c045ea5df33bba60$export$ed1b4f34a0e8b0cc = function(f) {
    return function(m1) {
        return function(m2) {
            return $c045ea5df33bba60$var$mutate(function(s1) {
                return $c045ea5df33bba60$var$foldM1(function(s2) {
                    return function(k) {
                        return function(v1) {
                            return $0061661dcaa2328e$export$dc13bdd74c909d26(k)($03b6b966974423fe$export$75b750e7d0325364(v1, function(v2) {
                                return f(v1)(v2);
                            }, k, m2))(s2);
                        };
                    };
                })(s1)(m1);
            })(m2);
        };
    };
};
var $c045ea5df33bba60$export$7d0c6e9c5931d4de = function(dictSemigroup) {
    return {
        append: $c045ea5df33bba60$export$ed1b4f34a0e8b0cc($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $c045ea5df33bba60$export$cd8dd1e1b4d46833 = function(dictSemigroup) {
    var semigroupObject1 = $c045ea5df33bba60$export$7d0c6e9c5931d4de(dictSemigroup);
    return {
        mempty: $03b6b966974423fe$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupObject1;
        }
    };
};
var $c045ea5df33bba60$export$93e2b83da34ff82a = /* #__PURE__ */ $03b6b966974423fe$export$882f367473bfeff9($f57f4b701aa7b66e$export$5f9c390da86b6e49);
var $c045ea5df33bba60$export$b66cdc0497d8a99a = function(dictMonoid) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
            return function(k) {
                return function(v) {
                    return append1(acc)(f(k)(v));
                };
            };
        })(mempty);
    };
};
var $c045ea5df33bba60$export$fb5657e12344d3bf = {
    foldl: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(z) {
            return function(v) {
                return f(z);
            };
        });
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr(f)(z)($c045ea5df33bba60$export$68c286be0e7e55b7(m));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
        return function(f) {
            return foldMap1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    }
};
var $c045ea5df33bba60$export$341deb6f42c48978 = {
    foldlWithIndex: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
    },
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr($71f2e2e9476163f8$export$7864d59d01b6d6bf(f))(z)($03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create)(m));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
    },
    Foldable0: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$cffdb9059fc42749 = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(ms) {
                return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
                    return function(k) {
                        return function(v) {
                            return apply(map($f57f4b701aa7b66e$export$8a83211c878a3f1f($c045ea5df33bba60$export$21a5ca8aa77d35ff(k)))(acc))(f(k)(v));
                        };
                    };
                })(pure1($03b6b966974423fe$export$6e22c362a0406a2c))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $c045ea5df33bba60$export$9c938d99ebec5017;
    },
    FoldableWithIndex1: function() {
        return $c045ea5df33bba60$export$341deb6f42c48978;
    },
    Traversable2: function() {
        return $c045ea5df33bba60$export$aeab5e284d2f12ed;
    }
};
var $c045ea5df33bba60$export$aeab5e284d2f12ed = {
    traverse: function(dictApplicative) {
        var $96 = $2c7a64ff78781336$export$955fdc0d24efa249($c045ea5df33bba60$export$cffdb9059fc42749)(dictApplicative);
        return function($97) {
            return $96($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($97));
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)(dictApplicative)($c045ea5df33bba60$var$identity);
    },
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    },
    Foldable1: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$d7a60370122a9ab0 = function(predicate) {
    return function(m) {
        var go = function() {
            var step = function(acc) {
                return function(k) {
                    return function(v) {
                        var $86 = predicate(k)(v);
                        if ($86) return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(acc);
                        return $c045ea5df33bba60$var$pure(acc);
                    };
                };
            };
            return function __do() {
                var m$prime = $0061661dcaa2328e$export$b8cb59497041ffe4();
                return $c045ea5df33bba60$var$foldM1(step)(m$prime)(m)();
            };
        }();
        return $03b6b966974423fe$export$c764c4f4747e1972(go);
    };
};
var $c045ea5df33bba60$export$151f9a87a7fd5652 = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0(function($98) {
        return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate($98));
    });
};
var $c045ea5df33bba60$export$3dea766d36a8935f = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate));
};
var $c045ea5df33bba60$export$fddc1e6ca29dc4b4 = function(dictEq) {
    var isSubmap1 = $c045ea5df33bba60$export$35d0420a84c5d3ae(dictEq);
    return {
        eq: function(m1) {
            return function(m2) {
                return isSubmap1(m1)(m2) && isSubmap1(m2)(m1);
            };
        }
    };
};
var $c045ea5df33bba60$export$6393680ec5f1a42e = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e($c045ea5df33bba60$var$ordTuple(dictOrd)));
    var eqObject1 = $c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictOrd.Eq0());
    return {
        compare: function(m1) {
            return function(m2) {
                return compare($c045ea5df33bba60$var$toAscArray(m1))($c045ea5df33bba60$var$toAscArray(m2));
            };
        },
        Eq0: function() {
            return eqObject1;
        }
    };
};
var $c045ea5df33bba60$export$11e732c5af6e2d9f = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictEq));
    }
};
var $c045ea5df33bba60$export$1822828d790e23ee = function(k) {
    return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$1822828d790e23ee(k));
};
var $c045ea5df33bba60$export$3e41007ebfff0e64 = function(k) {
    return function(m) {
        return $c045ea5df33bba60$var$mapFlipped($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m))(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $c045ea5df33bba60$export$1822828d790e23ee(k)(m));
        });
    };
};
var $c045ea5df33bba60$export$22a7378e1d3307a4 = function(f) {
    return function(k) {
        return function(m) {
            var v = f($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m));
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c045ea5df33bba60$export$1822828d790e23ee(k)(m);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c045ea5df33bba60$export$21a5ca8aa77d35ff(k)(v.value0)(m);
            throw new Error("Failed pattern match at Foreign.Object (line 210, column 15 - line 212, column 25): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c045ea5df33bba60$export$722fbec263ad908a = function(f) {
    return function(k) {
        return function(m) {
            return $c045ea5df33bba60$export$22a7378e1d3307a4($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(f))(k)(m);
        };
    };
};






var $f9cd20a8b77a6bf5$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f9cd20a8b77a6bf5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $f9cd20a8b77a6bf5$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f9cd20a8b77a6bf5$export$f880a2f905254b02 = /* #__PURE__ */ function() {
    function Created(value0) {
        this.value0 = value0;
    }
    Created.create = function(value0) {
        return new Created(value0);
    };
    return Created;
}();
var $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3 = /* #__PURE__ */ function() {
    function Removed(value0) {
        this.value0 = value0;
    }
    Removed.create = function(value0) {
        return new Removed(value0);
    };
    return Removed;
}();
var $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 = /* #__PURE__ */ function() {
    function Attribute(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Attribute.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Attribute(value0, value1, value2);
            };
        };
    };
    return Attribute;
}();
var $f9cd20a8b77a6bf5$export$41b04b3a73e7216d = /* #__PURE__ */ function() {
    function Property(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Property.create = function(value0) {
        return function(value1) {
            return new Property(value0, value1);
        };
    };
    return Property;
}();
var $f9cd20a8b77a6bf5$export$a428cd33b25d5283 = /* #__PURE__ */ function() {
    function Handler(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Handler.create = function(value0) {
        return function(value1) {
            return new Handler(value0, value1);
        };
    };
    return Handler;
}();
var $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa = /* #__PURE__ */ function() {
    function Ref(value0) {
        this.value0 = value0;
    }
    Ref.create = function(value0) {
        return new Ref(value0);
    };
    return Ref;
}();
var $f9cd20a8b77a6bf5$var$unsafeGetProperty = $39e0beec4569345c$export$e21bd765865a4e96;
var $f9cd20a8b77a6bf5$var$setProperty = $39e0beec4569345c$export$eecc4ddbfda9d798;
var $f9cd20a8b77a6bf5$var$removeProperty = function(key, el) {
    var v = $39e0beec4569345c$export$7895096fcdde5712($305519516124a7ff$export$7b1b591b262c240, key, el);
    if (v) return $39e0beec4569345c$export$6399f3bb52316b2c($305519516124a7ff$export$7b1b591b262c240, key, el);
    var v1 = $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f($39e0beec4569345c$export$e21bd765865a4e96(key, el));
    if (v1 === "string") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, "", el);
    if (key === "rowSpan") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, 1, el);
    if (key === "colSpan") return $39e0beec4569345c$export$eecc4ddbfda9d798(key, 1, el);
    return $39e0beec4569345c$export$eecc4ddbfda9d798(key, $39e0beec4569345c$export$1e4bb18162c9f619, el);
};
var $f9cd20a8b77a6bf5$var$propToStrKey = function(v) {
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "attr/" + (v.value0.value0 + (":" + v.value1));
    if (v instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return "attr/:" + v.value1;
    if (v instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return "prop/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return "handler/" + v.value0;
    if (v instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return "ref";
    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
        v.constructor.name
    ]);
};
var $f9cd20a8b77a6bf5$export$681fbf510ccdea38 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$c90971b081d8b87e = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$e6c76fe186213c01 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$cb9950a5a4987d69 = $ac8b3532514ac019$export$401372c57776dc;
var $f9cd20a8b77a6bf5$export$537b40a6761b64a = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) return new $f9cd20a8b77a6bf5$export$a428cd33b25d5283(v1.value0, $f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value1));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return new $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa($f9cd20a8b77a6bf5$var$map($f9cd20a8b77a6bf5$var$map1(v))(v1.value0));
            return v1;
        };
    }
};
var $f9cd20a8b77a6bf5$export$14e000ba7a516325 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $f9cd20a8b77a6bf5$export$f880a2f905254b02) return new $f9cd20a8b77a6bf5$export$f880a2f905254b02(v(v1.value0));
            if (v1 instanceof $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3) return new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(v(v1.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 49, column 1 - line 51, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $f9cd20a8b77a6bf5$export$ff441cf2113a23d9 = function(emit) {
    return function(el) {
        var removeProp = function(prevEvents) {
            return function(v, v1) {
                if (v1 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) return $39e0beec4569345c$export$6399f3bb52316b2c($0a5aaf95f168428e$export$b187f57ee1822bc5(v1.value0), v1.value1, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) return $f9cd20a8b77a6bf5$var$removeProperty(v1.value0, el);
                if (v1 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $ac7bed94ac89bf37$export$7ff190aa1ea44157(v1.value0, prevEvents);
                    return $39e0beec4569345c$export$8ff9f68337b520c0(v1.value0, $71f2e2e9476163f8$export$9e770fa6ce19a9d6(handler), el);
                }
                if (v1 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return $05149ea687d6b460$export$523c0b569236b342;
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                    v1.constructor.name
                ]);
            };
        };
        var mbEmit = function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return emit(v.value0)();
            return $05149ea687d6b460$export$523c0b569236b342;
        };
        var haltProp = function(state) {
            var v = $c045ea5df33bba60$export$dfc7155ac0343b8("ref")(state.props);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) return mbEmit(v.value0.value0(new $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3(el)));
            return $05149ea687d6b460$export$523c0b569236b342;
        };
        var diffProp = function(prevEvents, events) {
            return function(v, v1, v11, v2) {
                if (v11 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720 && v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    var $66 = v11.value2 === v2.value2;
                    if ($66) return v2;
                    $39e0beec4569345c$export$9fec4d97f1922e0b($0a5aaf95f168428e$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d && v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    var v4 = $39e0beec4569345c$export$9bc2d847a861e3d8(v11.value1, v2.value1);
                    if (v4) return v2;
                    if (v2.value0 === "value") {
                        var elVal = $f9cd20a8b77a6bf5$var$unsafeGetProperty("value", el);
                        var $75 = $39e0beec4569345c$export$9bc2d847a861e3d8(elVal, v2.value1);
                        if ($75) return v2;
                        $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                        return v2;
                    }
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v11 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283 && v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var handler = $ac7bed94ac89bf37$export$7ff190aa1ea44157(v2.value0, prevEvents);
                    $e521936ea118867a$export$68d8715fc104d294(v2.value1)($71f2e2e9476163f8$export$6f71268a1666ab58(handler))();
                    $ac7bed94ac89bf37$export$fcec48ff7d1e433f(v2.value0, handler, events);
                    return v2;
                }
                return v2;
            };
        };
        var applyProp = function(events) {
            return function(v, v1, v2) {
                if (v2 instanceof $f9cd20a8b77a6bf5$export$ab9c25261cd8c720) {
                    $39e0beec4569345c$export$9fec4d97f1922e0b($0a5aaf95f168428e$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$41b04b3a73e7216d) {
                    $f9cd20a8b77a6bf5$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$a428cd33b25d5283) {
                    var v3 = $39e0beec4569345c$export$e21bd765865a4e96(v2.value0, events);
                    if ($39e0beec4569345c$export$2d12e28667eef122(v2.value0, events)) {
                        $e521936ea118867a$export$68d8715fc104d294(v2.value1)($71f2e2e9476163f8$export$6f71268a1666ab58(v3))();
                        return v2;
                    }
                    var ref = $90327512d8280b8d$export$b8cb59497041ffe4(v2.value1)();
                    var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(ev) {
                        return function __do() {
                            var f$prime = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
                            return mbEmit(f$prime(ev));
                        };
                    })();
                    $ac7bed94ac89bf37$export$fcec48ff7d1e433f(v2.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(listener, ref), events);
                    $39e0beec4569345c$export$3f65cefe8380dbea(v2.value0, listener, el);
                    return v2;
                }
                if (v2 instanceof $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa) {
                    mbEmit(v2.value0(new $f9cd20a8b77a6bf5$export$f880a2f905254b02(el)));
                    return v2;
                }
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                    v2.constructor.name
                ]);
            };
        };
        var $lazy_patchProp = $f9cd20a8b77a6bf5$var$$runtime_lazy("patchProp", "Halogen.VDom.DOM.Prop", function() {
            return function(state, ps2) {
                var events = $ac7bed94ac89bf37$export$af208d62fa81d7e9();
                var onThis = removeProp(state.events);
                var onThese = diffProp(state.events, events);
                var onThat = applyProp(events);
                var props = $39e0beec4569345c$export$ca7590ccd55f275f(state.props, ps2, $f9cd20a8b77a6bf5$var$propToStrKey, onThese, onThis, onThat);
                var nextState = {
                    events: $ac7bed94ac89bf37$export$7c850c5af9b9983e(events),
                    props: props
                };
                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($05149ea687d6b460$export$523c0b569236b342, nextState, $lazy_patchProp(100), haltProp));
            };
        });
        var patchProp = $lazy_patchProp(87);
        var renderProp = function(ps1) {
            var events = $ac7bed94ac89bf37$export$af208d62fa81d7e9();
            var ps1$prime = $39e0beec4569345c$export$e766566cf460084(ps1, $f9cd20a8b77a6bf5$var$propToStrKey, applyProp(events));
            var state = {
                events: $ac7bed94ac89bf37$export$7c850c5af9b9983e(events),
                props: ps1$prime
            };
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($05149ea687d6b460$export$523c0b569236b342, state, patchProp, haltProp));
        };
        return renderProp;
    };
};




var $c959b62ce0c19dfe$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c959b62ce0c19dfe$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f9cd20a8b77a6bf5$export$537b40a6761b64a);
var $c959b62ce0c19dfe$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($969bbf7e7aa55092$export$5158bce98a089317);
var $c959b62ce0c19dfe$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $c959b62ce0c19dfe$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($bef4063d6d8fe507$export$cb4b70c26113b373);
var $c959b62ce0c19dfe$export$9dcd2b1ca4768128 = function(x) {
    return x;
};
var $c959b62ce0c19dfe$export$f0c5cfb390964b78 = function($28) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($bef4063d6d8fe507$export$a829527ff4e4114a.create($28));
};
var $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9 = function(dict) {
    return dict.toPropValue;
};
var $c959b62ce0c19dfe$export$6f093cfa640b7166 = function($29) {
    return $c959b62ce0c19dfe$export$9dcd2b1ca4768128($bef4063d6d8fe507$export$5f1af8db9871e1d6.create($29));
};
var $c959b62ce0c19dfe$export$eff4d24c3ff7876e = function(f) {
    return new $f9cd20a8b77a6bf5$export$9bcc32033bdd12aa(function($30) {
        return f(function(v) {
            if (v instanceof $f9cd20a8b77a6bf5$export$f880a2f905254b02) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            if (v instanceof $f9cd20a8b77a6bf5$export$bf3e0e645ed29ea3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Halogen.HTML.Core (line 109, column 21 - line 111, column 23): " + [
                v.constructor.name
            ]);
        }($30));
    });
};
var $c959b62ce0c19dfe$export$977f3f6a9323c0f6 = function(dictIsProp) {
    var toPropValue1 = $c959b62ce0c19dfe$export$ccd8a7ec14afc6c9(dictIsProp);
    return function(v) {
        var $31 = $f9cd20a8b77a6bf5$export$41b04b3a73e7216d.create(v);
        return function($32) {
            return $31(toPropValue1($32));
        };
    };
};
var $c959b62ce0c19dfe$export$3313fed09a42a979 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c959b62ce0c19dfe$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            return $bef4063d6d8fe507$export$8b4d9aa5702dece6($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(f))))(function() {
                var $33 = $c959b62ce0c19dfe$var$un($c959b62ce0c19dfe$export$9dcd2b1ca4768128);
                return function($34) {
                    return $33(g($34));
                };
            }())(v);
        };
    };
};
var $c959b62ce0c19dfe$export$8dbf9c790527241e = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $bef4063d6d8fe507$export$bade370ab89110b(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$78da172345adb805 = {
    toPropValue: function($35) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($545e4dccf243e400$export$a763fdfe677a0aa9($35));
    }
};
var $c959b62ce0c19dfe$export$32e0d8bef35d3088 = {
    toPropValue: $f9cd20a8b77a6bf5$export$681fbf510ccdea38
};
var $c959b62ce0c19dfe$export$a77e3c7f90d13c3c = {
    toPropValue: function($36) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($9c6cb90b338ac9f8$export$eb5efa61a2272b57($36));
    }
};
var $c959b62ce0c19dfe$export$cf79af8281015ccd = {
    toPropValue: function($37) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($28290d8d8d6af995$export$ce228bdd501ce63($37));
    }
};
var $c959b62ce0c19dfe$export$1cf8b1fb41618835 = {
    toPropValue: function($38) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($5d22526bed7c1d63$export$d6626656355d8e39($38));
    }
};
var $c959b62ce0c19dfe$export$93423863175829d3 = {
    toPropValue: function($39) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($018a854b7e87c5c3$export$a347b8fb4fdf4d6c($39));
    }
};
var $c959b62ce0c19dfe$export$6b61652c1897c1a = {
    toPropValue: $f9cd20a8b77a6bf5$export$c90971b081d8b87e
};
var $c959b62ce0c19dfe$export$4a37bd3810743b12 = {
    toPropValue: function($40) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($16370a0f58f1c8c4$export$3e035bf7a26d866f($40));
    }
};
var $c959b62ce0c19dfe$export$4111c2fa23eef626 = {
    toPropValue: function($41) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($01636ff1929ca3b5$export$1746677a19c76ca($41));
    }
};
var $c959b62ce0c19dfe$export$7bd1d02eb87275db = {
    toPropValue: /* #__PURE__ */ function() {
        var $42 = $4fa4836228a192cc$export$debb760848ca95a();
        return function($43) {
            return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($42($43));
        };
    }()
};
var $c959b62ce0c19dfe$export$f017ebe0bff0b5df = {
    toPropValue: function($44) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($0d6d338ad81e2ec3$export$8d81b1ec6c8c1d53($44));
    }
};
var $c959b62ce0c19dfe$export$4c390c75bcc39428 = {
    toPropValue: $f9cd20a8b77a6bf5$export$e6c76fe186213c01
};
var $c959b62ce0c19dfe$export$7333503111bf9adf = {
    toPropValue: function($45) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($cec7e3152401d818$export$349063a07c8ae46b($45));
    }
};
var $c959b62ce0c19dfe$export$27dc712f9cde9a29 = {
    toPropValue: function($46) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($a54f870bf00314e8$export$67347a102a60396a($46));
    }
};
var $c959b62ce0c19dfe$export$efe5d718899194d9 = {
    toPropValue: function($47) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($d3d5c2135d61b9e7$export$ac1e6270deebeb79($47));
    }
};
var $c959b62ce0c19dfe$export$60997a3274b6da18 = {
    toPropValue: function($48) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($0e909c93feacf06e$export$5f8a4393c9c60d1a($48));
    }
};
var $c959b62ce0c19dfe$export$56ccba9272e74ac2 = {
    toPropValue: function($49) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($f2665e311d0e2c2e$export$8cede0459d8015c9($49));
    }
};
var $c959b62ce0c19dfe$export$d48eb3d89026ef9 = {
    toPropValue: function($50) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($c67b43ffea069cfb$export$354e79e7f4fdf8f9($50));
    }
};
var $c959b62ce0c19dfe$export$4e3e21220a22c900 = {
    toPropValue: $f9cd20a8b77a6bf5$export$cb9950a5a4987d69
};
var $c959b62ce0c19dfe$export$a538daf4c6392dcf = {
    toPropValue: function($51) {
        return $f9cd20a8b77a6bf5$export$681fbf510ccdea38($4d40d048175dacfe$export$9b8eae2964bb4cd5($51));
    }
};
var $c959b62ce0c19dfe$export$c3c52e219617878 = /* #__PURE__ */ function() {
    return $f9cd20a8b77a6bf5$export$a428cd33b25d5283.create;
}();
var $c959b62ce0c19dfe$export$8454457683f90105 = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $bef4063d6d8fe507$export$cc2832fafe367c5e(ns, name, props, children);
            };
        };
    };
};
var $c959b62ce0c19dfe$export$a671de4661736606 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return $c959b62ce0c19dfe$var$bimap($c959b62ce0c19dfe$var$map($c959b62ce0c19dfe$var$map1($c959b62ce0c19dfe$var$map2(g))))(f)(v);
            };
        };
    }
};
var $c959b62ce0c19dfe$export$a02e13c6b9f001c6 = {
    map: /* #__PURE__ */ $20615e99b278adf5$export$6630987c9d273301($c959b62ce0c19dfe$export$a671de4661736606)
};
var $c959b62ce0c19dfe$export$7aabe8b3a840d2fd = function(ns) {
    return function(v) {
        return $f9cd20a8b77a6bf5$export$ab9c25261cd8c720.create(ns)(v);
    };
};


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15










var $dc7ffeabd143829e$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $dc7ffeabd143829e$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $dc7ffeabd143829e$var$Pure = /* #__PURE__ */ function() {
    function Pure(value0) {
        this.value0 = value0;
    }
    Pure.create = function(value0) {
        return new Pure(value0);
    };
    return Pure;
}();
var $dc7ffeabd143829e$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $dc7ffeabd143829e$var$Ap = /* #__PURE__ */ function() {
    function Ap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ap.create = function(value0) {
        return function(value1) {
            return new Ap(value0, value1);
        };
    };
    return Ap;
}();
var $dc7ffeabd143829e$var$mkAp = function(fba) {
    return function(fb) {
        return new $dc7ffeabd143829e$var$Ap(fba, fb);
    };
};
var $dc7ffeabd143829e$export$9f6cb61afbf051fa = /* #__PURE__ */ function() {
    return $dc7ffeabd143829e$var$Lift.create;
}();
var $dc7ffeabd143829e$var$goLeft = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(fStack) {
        return function(valStack) {
            return function(nat) {
                return function(func) {
                    return function(count) {
                        if (func instanceof $dc7ffeabd143829e$var$Pure) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                            func: pure(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Lift) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                            func: nat(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $dc7ffeabd143829e$var$Ap) return $dc7ffeabd143829e$var$goLeft(dictApplicative)(fStack)($ba51d599f79a6310$export$8327ebbef2a0ba76(func.value1)(valStack))(nat)(func.value0)(count + 1 | 0);
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                            func.constructor.name
                        ]);
                    };
                };
            };
        };
    };
};
var $dc7ffeabd143829e$var$goApply = function(dictApplicative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApplicative.Apply0());
    return function(fStack) {
        return function(vals) {
            return function(gVal) {
                if (fStack instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gVal);
                if (fStack instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var gRes = apply(fStack.value0.func)(gVal);
                    var $31 = fStack.value0.count === 1;
                    if ($31) {
                        if (fStack.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gRes);
                        return $dc7ffeabd143829e$var$goApply(dictApplicative)(fStack.value1)(vals)(gRes);
                    }
                    if (vals instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(gRes);
                    if (vals instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0({
                        func: gRes,
                        count: fStack.value0.count - 1 | 0
                    }, fStack.value1), new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(vals.value0, vals.value1)));
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                        vals.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                    fStack.constructor.name
                ]);
            };
        };
    };
};
var $dc7ffeabd143829e$export$a37c0cfb408cb5d9 = {
    map: function(f) {
        return function(x) {
            return $dc7ffeabd143829e$var$mkAp(new $dc7ffeabd143829e$var$Pure(f))(x);
        };
    }
};
var $dc7ffeabd143829e$export$952b32e119338067 = function(dictApplicative) {
    var goApply1 = $dc7ffeabd143829e$var$goApply(dictApplicative);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var goLeft1 = $dc7ffeabd143829e$var$goLeft(dictApplicative);
    return function(nat) {
        return function(z) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Pure) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(pure(v.value1.value0.value0));
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Lift) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $dc7ffeabd143829e$var$Ap) {
                        var nextVals = new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value1.value0.value1, v.value1.value1);
                        $copy_v = goLeft1(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                        return;
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                        v.value1.value0.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $ba51d599f79a6310$export$439306a4dcaafbb9(z)));
        };
    };
};
var $dc7ffeabd143829e$export$ab82a8987829bde0 = function(dictApplicative) {
    return $dc7ffeabd143829e$export$952b32e119338067(dictApplicative)($dc7ffeabd143829e$var$identity);
};
var $dc7ffeabd143829e$export$6b0545b2ed7e7da2 = {
    apply: function(fba) {
        return function(fb) {
            return $dc7ffeabd143829e$var$mkAp(fba)(fb);
        };
    },
    Functor0: function() {
        return $dc7ffeabd143829e$export$a37c0cfb408cb5d9;
    }
};
var $dc7ffeabd143829e$export$b8278c4ac41154ad = /* #__PURE__ */ function() {
    return {
        pure: $dc7ffeabd143829e$var$Pure.create,
        Apply0: function() {
            return $dc7ffeabd143829e$export$6b0545b2ed7e7da2;
        }
    };
}();
var $dc7ffeabd143829e$var$foldFreeAp1 = /* #__PURE__ */ $dc7ffeabd143829e$export$952b32e119338067($dc7ffeabd143829e$export$b8278c4ac41154ad);
var $dc7ffeabd143829e$export$2a17b194dc6daf5e = function(f) {
    return $dc7ffeabd143829e$var$foldFreeAp1(function($54) {
        return $dc7ffeabd143829e$export$9f6cb61afbf051fa(f($54));
    });
};
var $dc7ffeabd143829e$export$1d298f88ddccfbbf = function(dictMonoid) {
    var foldFreeAp2 = $dc7ffeabd143829e$export$952b32e119338067($10ae0394c8c3139a$export$38647a91a5af2717(dictMonoid));
    return function(k) {
        var $55 = foldFreeAp2(function($57) {
            return $10ae0394c8c3139a$export$8ad5d15375e29446(k($57));
        });
        return function($56) {
            return $dc7ffeabd143829e$var$unwrap($55($56));
        };
    };
};





// Generated by purs version 0.15.15






// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
















var $8cad8efed8fc4b93$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $8cad8efed8fc4b93$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8cad8efed8fc4b93$export$a9e3236c55b65445 = /* #__PURE__ */ function() {
    function CatQueue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue.create = function(value0) {
        return function(value1) {
            return new CatQueue(value0, value1);
        };
    };
    return CatQueue;
}();
var $8cad8efed8fc4b93$export$712962e076096ed4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, v.value1.value1)));
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value0));
            return;
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 92, column 1 - line 92, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$b446f6baa3bb1430 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value1), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            return;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0.value1, v.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$c40cf5aab899f397 = function(v) {
    return function(a) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value1));
    };
};
var $8cad8efed8fc4b93$export$76888aafd695b76f = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(CatQueue " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        }
    };
};
var $8cad8efed8fc4b93$export$7b1b591b262c240 = function(v) {
    if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $8cad8efed8fc4b93$export$f24224f1c91d8156 = function(v) {
    return $3d4fd987da5242ff$export$f24224f1c91d8156(v.value0) + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $8cad8efed8fc4b93$export$cd9df59029b2f7f5 = {
    map: function(f) {
        return function(v) {
            return new $8cad8efed8fc4b93$export$a9e3236c55b65445($8cad8efed8fc4b93$var$map(f)(v.value0), $8cad8efed8fc4b93$var$map(f)(v.value1));
        };
    }
};
var $8cad8efed8fc4b93$export$2411eb790d3ef577 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($8cad8efed8fc4b93$export$2411eb790d3ef577)(dictMonoid);
    },
    foldr: function(f) {
        return $4fe7b6acfba7f29f$export$9b986141719153e($8cad8efed8fc4b93$export$2411eb790d3ef577)(f);
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatQueue (line 147, column 16 - line 149, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $8cad8efed8fc4b93$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($8cad8efed8fc4b93$export$2411eb790d3ef577);
var $8cad8efed8fc4b93$export$12a82fa16f3fa685 = {
    append: /* #__PURE__ */ $8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)
};
var $8cad8efed8fc4b93$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $8cad8efed8fc4b93$export$82bbee97f7dffc83 = {
    mempty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Semigroup0: function() {
        return $8cad8efed8fc4b93$export$12a82fa16f3fa685;
    }
};
var $8cad8efed8fc4b93$export$439306a4dcaafbb9 = /* #__PURE__ */ $8cad8efed8fc4b93$export$c40cf5aab899f397($8cad8efed8fc4b93$export$6e22c362a0406a2c);
var $8cad8efed8fc4b93$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($8cad8efed8fc4b93$export$82bbee97f7dffc83);
    return function(f) {
        return foldMap($8cad8efed8fc4b93$export$439306a4dcaafbb9)(f);
    };
};
var $8cad8efed8fc4b93$export$402e17453440564b = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $123 = map1($8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            var $124 = $8cad8efed8fc4b93$var$foldl(function(acc) {
                var $126 = lift2($8cad8efed8fc4b93$export$c40cf5aab899f397)(acc);
                return function($127) {
                    return $126(f($127));
                };
            })(pure($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            return function($125) {
                return $123($124($125));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($8cad8efed8fc4b93$export$402e17453440564b)(dictApplicative);
    },
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    },
    Foldable1: function() {
        return $8cad8efed8fc4b93$export$2411eb790d3ef577;
    }
};
var $8cad8efed8fc4b93$export$4d02617d29cfe99c = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 154, column 24 - line 156, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    }
};
var $8cad8efed8fc4b93$export$7536d90e702d15a6 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 161, column 24 - line 163, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    },
    Unfoldable10: function() {
        return $8cad8efed8fc4b93$export$4d02617d29cfe99c;
    }
};
var $8cad8efed8fc4b93$var$cqEq = function(dictEq) {
    var elemEq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && elemEq(v1.value0.value0)(v.value0.value0)) {
                    $tco_var_xs = v1.value0.value1;
                    $copy_ys = v.value0.value1;
                    return;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return true;
                }
                $tco_done = true;
                return false;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$8d0b86d96cb644e8 = function(dictEq) {
    return {
        eq: $8cad8efed8fc4b93$var$cqEq(dictEq)
    };
};
var $8cad8efed8fc4b93$var$cqCompare = function(dictOrd) {
    var elemCompare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var v2 = elemCompare(v1.value0.value0)(v.value0.value0);
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_var_xs = v1.value0.value1;
                        $copy_ys = v.value0.value1;
                        return;
                    }
                    $tco_done = true;
                    return v2;
                }
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$b023c82b48e70453.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                }
                throw new Error("Failed pattern match at Data.CatQueue (line 117, column 16 - line 124, column 30): " + [
                    v1.constructor.name,
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$cce3b6ca8e6b304d = function(dictOrd) {
    var eqCatQueue1 = $8cad8efed8fc4b93$export$8d0b86d96cb644e8(dictOrd.Eq0());
    return {
        compare: $8cad8efed8fc4b93$var$cqCompare(dictOrd),
        Eq0: function() {
            return eqCatQueue1;
        }
    };
};
var $8cad8efed8fc4b93$export$8327ebbef2a0ba76 = function(a) {
    return function(v) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value0), v.value1);
    };
};
var $8cad8efed8fc4b93$export$64857ab1e7904bd4 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Bind1: function() {
        return $8cad8efed8fc4b93$export$5f82bc311535f1fb;
    }
};
var $8cad8efed8fc4b93$export$5f82bc311535f1fb = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($8cad8efed8fc4b93$export$2411eb790d3ef577)($8cad8efed8fc4b93$export$82bbee97f7dffc83)),
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$export$6d9d1867ada2692e = {
    pure: $8cad8efed8fc4b93$export$439306a4dcaafbb9,
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$var$$lazy_applyCatQueue = /* #__PURE__ */ $8cad8efed8fc4b93$var$$runtime_lazy("applyCatQueue", "Data.CatQueue", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($8cad8efed8fc4b93$export$64857ab1e7904bd4),
        Functor0: function() {
            return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
        }
    };
});
var $8cad8efed8fc4b93$export$b30f70c26a58b039 = /* #__PURE__ */ $8cad8efed8fc4b93$var$$lazy_applyCatQueue(174);
var $8cad8efed8fc4b93$export$ece98441a77a02d = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($8cad8efed8fc4b93$export$12a82fa16f3fa685),
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    }
};
var $8cad8efed8fc4b93$export$f14c1a5864c2efe5 = {
    empty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Alt0: function() {
        return $8cad8efed8fc4b93$export$ece98441a77a02d;
    }
};
var $8cad8efed8fc4b93$export$6613cb99fa5f98f9 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Plus1: function() {
        return $8cad8efed8fc4b93$export$f14c1a5864c2efe5;
    }
};
var $8cad8efed8fc4b93$export$3e8f97b430646754 = {
    Monad0: function() {
        return $8cad8efed8fc4b93$export$64857ab1e7904bd4;
    },
    Alternative1: function() {
        return $8cad8efed8fc4b93$export$6613cb99fa5f98f9;
    }
};













var $2f87b4fe4d8f7a0f$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2f87b4fe4d8f7a0f$export$7475bf8196f095ad = /* #__PURE__ */ function() {
    function CatNil() {}
    CatNil.value = new CatNil();
    return CatNil;
}();
var $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e = /* #__PURE__ */ function() {
    function CatCons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons.create = function(value0) {
        return function(value1) {
            return new CatCons(value0, value1);
        };
    };
    return CatCons;
}();
var $2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return "CatNil";
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return "(CatList " + (show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($8cad8efed8fc4b93$export$76888aafd695b76f($2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99(dictShow)))(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.CatList (line 147, column 1 - line 149, column 71): " + [
                v.constructor.name
            ]);
        }
    };
};
var $2f87b4fe4d8f7a0f$export$7b1b591b262c240 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return true;
    return false;
};
var $2f87b4fe4d8f7a0f$var$link = function(v) {
    return function(v1) {
        if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v1;
        if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v;
        if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(v.value0, $8cad8efed8fc4b93$export$c40cf5aab899f397(v.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2f87b4fe4d8f7a0f$var$foldr = function(k) {
    return function(b) {
        return function(q) {
            var foldl = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v;
                                $tco_var_v1 = v(v1)(v2.value0);
                                $copy_v2 = v2.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done1 = true;
                            return foldl(function(x) {
                                return function(i) {
                                    return i(x);
                                };
                            })(b)(ys);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_xs = v.value0.value1;
                            $copy_ys = new $78c799cba34fcb8d$export$74c44e616647f5c0(k(v.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go(q)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
        var $66 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
        if ($66) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v.constructor.name
    ]);
};
var $2f87b4fe4d8f7a0f$export$9dc212839863b867 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($2f87b4fe4d8f7a0f$export$9dc212839863b867)(dictMonoid);
    },
    foldr: function(f) {
        return function(s) {
            return function(l) {
                return $4fe7b6acfba7f29f$export$9b986141719153e($2f87b4fe4d8f7a0f$export$9dc212839863b867)(f)(s)(l);
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatList (line 156, column 16 - line 158, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $2f87b4fe4d8f7a0f$export$f24224f1c91d8156 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($2f87b4fe4d8f7a0f$export$9dc212839863b867)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $2f87b4fe4d8f7a0f$var$foldMap = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return mempty;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $75 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($75) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return append2(v(v1.value0))($2f87b4fe4d8f7a0f$var$foldMap(dictMonoid)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 134, column 1 - line 134, column 62): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
}();
var $2f87b4fe4d8f7a0f$export$10d8903dec122b9d = $2f87b4fe4d8f7a0f$var$link;
var $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76 = function(a) {
    return function(cat) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c))(cat);
    };
};
var $2f87b4fe4d8f7a0f$export$2fa88228892893e6 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $80 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($80) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(v(v1.value0))($f4b2eb11fc32ed34$export$871de8747c9eaa88($2f87b4fe4d8f7a0f$export$2fa88228892893e6)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 184, column 1 - line 188, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9 = function(a) {
    return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(a)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
};
var $2f87b4fe4d8f7a0f$export$e0c854626a3eddb8 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                    var d = function() {
                        var $85 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                        if ($85) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                    }();
                    return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v(v1.value0)))($11d1e86de605dfc6$export$df3f009e3d155b20($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(v)(d));
                }
                throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $89 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
                    if ($89) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
                }();
                return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v.value0))($11d1e86de605dfc6$export$49bb65c2ea163039($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    },
    Foldable1: function() {
        return $2f87b4fe4d8f7a0f$export$9dc212839863b867;
    }
};
var $2f87b4fe4d8f7a0f$export$da599a1924f5bf13 = {
    append: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d
};
var $2f87b4fe4d8f7a0f$export$f4b77959e4023828 = /* #__PURE__ */ function() {
    return {
        mempty: $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value,
        Semigroup0: function() {
            return $2f87b4fe4d8f7a0f$export$da599a1924f5bf13;
        }
    };
}();
var $2f87b4fe4d8f7a0f$export$607c251688bb5f73 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Bind1: function() {
        return $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22;
    }
};
var $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22 = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $2f87b4fe4d8f7a0f$var$foldMap($2f87b4fe4d8f7a0f$export$f4b77959e4023828)),
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$export$360f55d5496233b2 = {
    pure: $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9,
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$var$$lazy_applyCatList = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$runtime_lazy("applyCatList", "Data.CatList", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($2f87b4fe4d8f7a0f$export$607c251688bb5f73),
        Functor0: function() {
            return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
        }
    };
});
var $2f87b4fe4d8f7a0f$export$6c3a453d31b3c12e = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(190);
var $2f87b4fe4d8f7a0f$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap1 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($2f87b4fe4d8f7a0f$export$f4b77959e4023828);
    return function(f) {
        return foldMap1($2f87b4fe4d8f7a0f$export$439306a4dcaafbb9)(f);
    };
};
var $2f87b4fe4d8f7a0f$export$c40cf5aab899f397 = function(cat) {
    return function(a) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(cat)(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c));
    };
};
var $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345 = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 170, column 24 - line 172, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$6cb6a5647a60bec3 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 163, column 24 - line 165, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    },
    Unfoldable10: function() {
        return $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345;
    }
};
var $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad = {
    alt: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d,
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    }
};
var $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2 = {
    empty: $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c,
    Alt0: function() {
        return $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad;
    }
};
var $2f87b4fe4d8f7a0f$export$37a37f49d0feb489 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Plus1: function() {
        return $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2;
    }
};
var $2f87b4fe4d8f7a0f$export$2074eaaf9933bfe1 = {
    Monad0: function() {
        return $2f87b4fe4d8f7a0f$export$607c251688bb5f73;
    },
    Alternative1: function() {
        return $2f87b4fe4d8f7a0f$export$37a37f49d0feb489;
    }
};














var $d0bd5a116d2d5f24$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $d0bd5a116d2d5f24$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($2f87b4fe4d8f7a0f$export$da599a1924f5bf13);
var $d0bd5a116d2d5f24$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $d0bd5a116d2d5f24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d0bd5a116d2d5f24$var$ExpF = function(x) {
    return x;
};
var $d0bd5a116d2d5f24$var$Free = /* #__PURE__ */ function() {
    function Free(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free.create = function(value0) {
        return function(value1) {
            return new Free(value0, value1);
        };
    };
    return Free;
}();
var $d0bd5a116d2d5f24$var$Return = /* #__PURE__ */ function() {
    function Return(value0) {
        this.value0 = value0;
    }
    Return.create = function(value0) {
        return new Return(value0);
    };
    return Return;
}();
var $d0bd5a116d2d5f24$var$Bind = /* #__PURE__ */ function() {
    function Bind(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind.create = function(value0) {
        return function(value1) {
            return new Bind(value0, value1);
        };
    };
    return Bind;
}();
var $d0bd5a116d2d5f24$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        var runExpF = function(v2) {
            return v2;
        };
        var concatF = function(v2) {
            return function(r) {
                return new $d0bd5a116d2d5f24$var$Free(v2.value0, $d0bd5a116d2d5f24$var$append(v2.value1)(r));
            };
        };
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Return) {
            var v2 = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(v.value1);
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                $tco_done = true;
                return new $d0bd5a116d2d5f24$var$Return(v.value0.value0);
            }
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v2.constructor.name
            ]);
        }
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Bind) {
            $tco_done = true;
            return new $d0bd5a116d2d5f24$var$Bind(v.value0.value0, function(a) {
                return concatF(v.value0.value1(a))(v.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        return function(k) {
            var go = function(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) return map2($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map2($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(k(map1(v.value1)(v.value0)));
                throw new Error("Failed pattern match at Control.Monad.Free (line 194, column 10 - line 196, column 37): " + [
                    v.constructor.name
                ]);
            };
            return tailRecM(go);
        };
    };
};
var $d0bd5a116d2d5f24$export$39b8ebacf8133f4f = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(k) {
        var go = function($copy_f) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) {
                    $tco_done = true;
                    return v.value0;
                }
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) {
                    $copy_f = k(map1(v.value1)(v.value0));
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 178, column 10 - line 180, column 33): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_f);
            return $tco_result;
        };
        return go;
    };
};
var $d0bd5a116d2d5f24$export$a7b5be099b56a644 = function(k) {
    return function(j) {
        return function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return j(v.value0);
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return k(v.value0)(v.value1);
            throw new Error("Failed pattern match at Control.Monad.Free (line 213, column 17 - line 215, column 20): " + [
                v.constructor.name
            ]);
        };
    };
};
var $d0bd5a116d2d5f24$export$fbb4d68fe60c1629 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return $d0bd5a116d2d5f24$export$a7b5be099b56a644(function(g) {
        return function(i) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(map1(i)(g));
        };
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $d0bd5a116d2d5f24$var$fromView = function(f) {
    return new $d0bd5a116d2d5f24$var$Free(f, $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c);
};
var $d0bd5a116d2d5f24$export$4997ffc0176396a6 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, $ac8b3532514ac019$export$401372c57776dc));
};
var $d0bd5a116d2d5f24$export$7c20f42c1b2b8c79 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return $d0bd5a116d2d5f24$export$4997ffc0176396a6(pure1(f));
    };
};
var $d0bd5a116d2d5f24$export$25ad06f1eebea5a0 = {
    Applicative0: function() {
        return $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
    },
    Bind1: function() {
        return $d0bd5a116d2d5f24$export$39486fc5c75854c8;
    }
};
var $d0bd5a116d2d5f24$export$245cefec95375d9a = {
    map: function(k) {
        return function(f) {
            return $70cd3177464e7915$export$f2077a1c19a006d9($d0bd5a116d2d5f24$export$39486fc5c75854c8)(function() {
                var $189 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
                return function($190) {
                    return $189(k($190));
                };
            }())(f);
        };
    }
};
var $d0bd5a116d2d5f24$export$39486fc5c75854c8 = {
    bind: function(v) {
        return function(k) {
            return new $d0bd5a116d2d5f24$var$Free(v.value0, $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(v.value1)(k));
        };
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$export$b9ce46e7f510eb18 = {
    pure: function($191) {
        return $d0bd5a116d2d5f24$var$fromView($d0bd5a116d2d5f24$var$Return.create($191));
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$var$$lazy_freeApply = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$runtime_lazy("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d0bd5a116d2d5f24$export$25ad06f1eebea5a0),
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        }
    };
});
var $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112 = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$lazy_freeApply(77);
var $d0bd5a116d2d5f24$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($d0bd5a116d2d5f24$export$2d6a2fb8bce0f112);
var $d0bd5a116d2d5f24$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
var $d0bd5a116d2d5f24$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$export$d68567ac4fd5624d = function(dictSemigroup) {
    return {
        append: $d0bd5a116d2d5f24$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $d0bd5a116d2d5f24$export$b3d357ba4a1dabd2 = {
    tailRecM: function(k) {
        return function(a) {
            return $d0bd5a116d2d5f24$var$bind(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($d0bd5a116d2d5f24$export$b3d357ba4a1dabd2)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $d0bd5a116d2d5f24$var$pure(v.value0);
                throw new Error("Failed pattern match at Control.Monad.Free (line 86, column 26 - line 88, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
    }
};
var $d0bd5a116d2d5f24$export$8040756fd4c77395 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, function($192) {
        return $d0bd5a116d2d5f24$var$pure($192);
    }));
};
var $d0bd5a116d2d5f24$export$5eeb2de8b5f5121f = {
    lift: function(dictMonad) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395;
    }
};
var $d0bd5a116d2d5f24$export$cb3638ab887278d6 = function(dictMonoid) {
    var semigroupFree1 = $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictMonoid.Semigroup0());
    return {
        mempty: $d0bd5a116d2d5f24$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$d6dbe5e3073f84e = function(k) {
    var go = function(f) {
        var v = $d0bd5a116d2d5f24$var$toView(f);
        if (v instanceof $d0bd5a116d2d5f24$var$Return) return $d0bd5a116d2d5f24$var$pure(v.value0);
        if (v instanceof $d0bd5a116d2d5f24$var$Bind) return $d0bd5a116d2d5f24$var$bind(k(v.value0))($d0bd5a116d2d5f24$var$map(go)(v.value1));
        throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $d0bd5a116d2d5f24$export$9624ed458578c422 = function(k) {
    return $d0bd5a116d2d5f24$export$d6dbe5e3073f84e(function($193) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395(k($193));
    });
};
var $d0bd5a116d2d5f24$export$7bf6537c73f09eab = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictFoldable) {
        var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return {
            foldMap: function(dictMonoid) {
                var foldMap1 = foldMap(dictMonoid);
                return function(f) {
                    var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                        return function($194) {
                            return function(v) {
                                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldMap1($lazy_go(94))(v.value0);
                                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0);
                                throw new Error("Failed pattern match at Control.Monad.Free (line 93, column 21 - line 95, column 21): " + [
                                    v.constructor.name
                                ]);
                            }(resume1($194));
                        };
                    });
                    var go = $lazy_go(93);
                    return go;
                };
            },
            foldl: function(f) {
                var go = function(r) {
                    return function($195) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldl(go)(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(r)(v.value0);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 98, column 23 - line 100, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($195));
                    };
                };
                return go;
            },
            foldr: function(f) {
                var go = function(r) {
                    return function($196) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldr($f57f4b701aa7b66e$export$8a83211c878a3f1f(go))(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0)(r);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 103, column 23 - line 105, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($196));
                    };
                };
                return go;
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$816b93e586e4c75c = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(Functor0);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var foldableFree1 = $d0bd5a116d2d5f24$export$7bf6537c73f09eab(Functor0)(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                    return function($197) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return map1(function($198) {
                                return $d0bd5a116d2d5f24$var$join($d0bd5a116d2d5f24$export$8040756fd4c77395($198));
                            })(traverse1($lazy_go(111))(v.value0));
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map1($d0bd5a116d2d5f24$var$pure)(f(v.value0));
                            throw new Error("Failed pattern match at Control.Monad.Free (line 110, column 21 - line 112, column 30): " + [
                                v.constructor.name
                            ]);
                        }(resume1($197));
                    };
                });
                var go = $lazy_go(110);
                return go;
            };
        },
        sequence: function(dictApplicative) {
            return function(tma) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($d0bd5a116d2d5f24$export$816b93e586e4c75c(dictTraversable))(dictApplicative)($d0bd5a116d2d5f24$var$identity)(tma);
            };
        },
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        },
        Foldable1: function() {
            return foldableFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$eb0e66a9104d4874 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(k) {
        var go = function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return map1($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map1(function($199) {
                return $f93520de2fa37b44$export$550acbd06a1f5a6a.create(v.value1($199));
            })(k(v.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v.constructor.name
            ]);
        };
        return tailRecM(go);
    };
};
var $d0bd5a116d2d5f24$export$14742287b71545dd = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
        return function(dictEq) {
            var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq1($d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor)(dictEq1)(dictEq))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq(v1.value0)(v.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$10be470239ca56c7 = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
        var eqFree2 = eqFree1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
            var eqFree3 = eqFree2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare1($d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor)(dictOrd1)(dictOrd))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare(v1.value0)(v.value0);
                        throw new Error("Failed pattern match at Control.Monad.Free (line 56, column 17 - line 60, column 36): " + [
                            v1.constructor.name,
                            v.constructor.name
                        ]);
                    };
                },
                Eq0: function() {
                    return eqFree3;
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$269c49b8f4785316 = function(dictFunctor) {
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictEq1) {
        var eqFree2 = eqFree1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqFree2(dictEq));
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$915c63020dce06b2 = function(dictFunctor) {
    var ordFree1 = $d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor);
    var eq1Free1 = $d0bd5a116d2d5f24$export$269c49b8f4785316(dictFunctor);
    return function(dictOrd1) {
        var ordFree2 = ordFree1(dictOrd1);
        var eq1Free2 = eq1Free1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordFree2(dictOrd));
            },
            Eq10: function() {
                return eq1Free2;
            }
        };
    };
};

















// Generated by purs version 0.15.15



// Generated by purs version 0.15.15















var $d30ea600cb89759b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d30ea600cb89759b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $d30ea600cb89759b$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d30ea600cb89759b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($73aa5dd1904ebcb7$export$28587442a46d4141);
var $d30ea600cb89759b$export$1bffd077443cd981 = /* #__PURE__ */ function() {
    function Yield(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Yield.create = function(value0) {
        return function(value1) {
            return new Yield(value0, value1);
        };
    };
    return Yield;
}();
var $d30ea600cb89759b$export$38d24f5c1eb0e4c0 = /* #__PURE__ */ function() {
    function Skip(value0) {
        this.value0 = value0;
    }
    Skip.create = function(value0) {
        return new Skip(value0);
    };
    return Skip;
}();
var $d30ea600cb89759b$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $d30ea600cb89759b$export$4ae3cbbaa857dd72 = function(x) {
    return x;
};
var $d30ea600cb89759b$export$72a5dac3748973f0 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return pure1(new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(v));
    };
};
var $d30ea600cb89759b$export$860beaf0e87f1a9f = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map2(function($338) {
            return $d30ea600cb89759b$export$38d24f5c1eb0e4c0.create($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($338)));
        })(v);
    };
};
var $d30ea600cb89759b$export$c48e357c1a89b78d = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        return function(z) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0.value1, $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                    return $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad)(f)(v.value0.value0);
                }));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 130, column 3 - line 130, column 60): " + [
                    v.constructor.name
                ]);
            };
            return map2(g)(f(z));
        };
    };
};
var $d30ea600cb89759b$export$b446f6baa3bb1430 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        var g = function(v1) {
            if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1))));
            if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad)($99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0));
            if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 195, column 3 - line 195, column 50): " + [
                v1.constructor.name
            ]);
        };
        return bind(v)(g);
    };
};
var $d30ea600cb89759b$export$c01875f616615628 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$6f71268a1666ab58))(uncons1(l));
    };
};
var $d30ea600cb89759b$var$stepMap = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map2(f)(v);
        };
    };
};
var $d30ea600cb89759b$export$9384c7afe4015e42 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $255 = f(v.value0);
                if ($255) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value1));
                return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 154, column 3 - line 154, column 68): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$65f513eaf3c582b8 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(b) {
            return function(l) {
                var g = function(v) {
                    var h = function(v1) {
                        if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                            var b$prime$prime = f(v.value0)(v1.value0);
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(b$prime$prime, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1)), v.value0));
                        }
                        if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0)), v.value0));
                        if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Control.Monad.List.Trans (line 248, column 5 - line 248, column 78): " + [
                            v1.constructor.name
                        ]);
                    };
                    return map2(h)(v.value1);
                };
                return unfold1(g)(new $71f2e2e9476163f8$export$1908877435b1d5e9(b, l));
            };
        };
    };
};
var $d30ea600cb89759b$export$3466dae21163a3ee = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(h) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981(h, t));
        };
    };
};
var $d30ea600cb89759b$export$68159836694e22c1 = function(dictApplicative) {
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(dictApplicative);
    return function(h) {
        return function(t) {
            return prepend$prime1(h)($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(t)));
        };
    };
};
var $d30ea600cb89759b$export$f2c4f74e8fe88e34 = function(dictApplicative) {
    return $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative)($d30ea600cb89759b$export$7fe28cb29e71bf10.value);
};
var $d30ea600cb89759b$export$439306a4dcaafbb9 = function(dictApplicative) {
    var prepend1 = $d30ea600cb89759b$export$68159836694e22c1(dictApplicative);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(a) {
        return prepend1(a)(nil1);
    };
};
var $d30ea600cb89759b$export$b7df5d561049483a = function(dictApplicative) {
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return nil1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v2.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 147, column 3 - line 147, column 47): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$e3b52f6f0a4bd72e = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Applicative0);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var Functor0 = Bind1.Apply0().Functor0();
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(Applicative0);
    var wrapEffect1 = $d30ea600cb89759b$export$860beaf0e87f1a9f(Functor0);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var g = function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f(prepend$prime1)($99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                    return $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad)(f)(v.value0.value1)(v1.value0.value1);
                })))(f(v.value0.value0)(v1.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 260, column 3 - line 260, column 25): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var loop = function(fa) {
            return function(fb) {
                return wrapEffect1(bind(uncons1(fa))(function(ua) {
                    return bind(uncons1(fb))(function(ub) {
                        return g(ua)(ub);
                    });
                }));
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$b634740ce272acb5 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var zipWith$prime1 = $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad);
    return function(f) {
        var g = function(a) {
            return function(b) {
                return pure1(f(a)(b));
            };
        };
        return zipWith$prime1(g);
    };
};
var $d30ea600cb89759b$export$acf0795b499e2d1a = {
    Coercible0: function() {
        return undefined;
    }
};
var $d30ea600cb89759b$export$e70771d2e7e590a = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return $06733ae99ed4f534$export$43db023a260c5e9f($d30ea600cb89759b$export$38d24f5c1eb0e4c0.create)($d30ea600cb89759b$var$map($d30ea600cb89759b$export$1bffd077443cd981.create)(f(v.value0)))($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value1));
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 183, column 3 - line 183, column 72): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$c1a059043cc9c119 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(a) {
            var g = function(x) {
                return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(x), x)));
            };
            return unfold1(g)(a);
        };
    };
};
var $d30ea600cb89759b$export$76d90c956114f2c2 = function(dictMonad) {
    return $d30ea600cb89759b$export$c1a059043cc9c119(dictMonad)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$5fd5031fecdacec3 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6))(uncons1(l));
    };
};
var $d30ea600cb89759b$export$5af6b427ff316359 = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return {
        map: function(f) {
            var g = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(f(v.value0), $d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 280, column 5 - line 280, column 48): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(g);
        }
    };
};
var $d30ea600cb89759b$export$df62323340295157 = function(dictApplicative) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(fa) {
        return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f($d30ea600cb89759b$export$1bffd077443cd981.create)($99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return nil1;
        })))(fa);
    };
};
var $d30ea600cb89759b$export$619131e858bec5bb = {
    lift: function(dictMonad) {
        return $d30ea600cb89759b$export$df62323340295157(dictMonad.Applicative0());
    }
};
var $d30ea600cb89759b$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $d30ea600cb89759b$export$5f62080e6ea5ad16 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))(function(b$prime) {
                        return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                            a: b$prime,
                            b: v.value0.value1
                        }));
                    });
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 221, column 5 - line 221, column 45): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$3120598051129cb3 = function(dictMonadRec) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadRec.Monad0().Applicative0());
    return $d30ea600cb89759b$export$5f62080e6ea5ad16(dictMonadRec)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$48b115eebb7f3c53 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: f(b)(v.value0.value0),
                        b: v.value0.value1
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 239, column 7 - line 239, column 47): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$fa87a49fad651048 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))($f57f4b701aa7b66e$export$8a83211c878a3f1f(loop)(v.value0.value1));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 212, column 5 - line 212, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$99ac321f734efd9b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return $d30ea600cb89759b$export$fa87a49fad651048(dictMonad)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$50ae948ca12cdcbc = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return loop(f(b)(v.value0.value0))(v.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 229, column 5 - line 229, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$3dea766d36a8935f = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value1);
                var $305 = f(v.value0);
                if ($305) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, s$prime);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value0);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 176, column 3 - line 176, column 80): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$533af5c8cd6afa16 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $310 = f(v.value0);
                if ($310) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value1));
                return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, v.value1);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 169, column 3 - line 169, column 70): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$663103110d94aac9 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return v1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 162, column 3 - line 162, column 44): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$8327ebbef2a0ba76 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(lh) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981($99af8ad7682e39c7$export$4d82290515cd0ddb(lh), t));
        };
    };
};
var $d30ea600cb89759b$export$e5d91f6921d97963 = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var singleton1 = $d30ea600cb89759b$export$439306a4dcaafbb9(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    return {
        unfoldr1: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return singleton1(v.value0);
                    if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value1.value0));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 294, column 12 - line 296, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        }
    };
};
var $d30ea600cb89759b$export$bbfbcefbf94b996f = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    var unfoldable1ListT1 = $d30ea600cb89759b$export$e5d91f6921d97963(dictMonad);
    return {
        unfoldr: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return nil1;
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value0.value1));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 287, column 12 - line 289, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        },
        Unfoldable10: function() {
            return unfoldable1ListT1;
        }
    };
};
var $d30ea600cb89759b$export$e65aba2be8e37f8a = function(dictApplicative) {
    return {
        append: $d30ea600cb89759b$var$concat(dictApplicative)
    };
};
var $d30ea600cb89759b$var$concat = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(x) {
        return function(y) {
            var f = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(y)));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 106, column 3 - line 106, column 43): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(f)(x);
        };
    };
};
var $d30ea600cb89759b$export$6b8d2264760710b = function(dictApplicative) {
    var semigroupListT1 = $d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative);
    return {
        mempty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative),
        Semigroup0: function() {
            return semigroupListT1;
        }
    };
};
var $d30ea600cb89759b$export$986c2bbe7a34be0b = function(dictFunctor) {
    return $d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$204d5ba0706a4088 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
        },
        Bind1: function() {
            return $d30ea600cb89759b$export$871b02513702e0(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$871b02513702e0 = function(dictMonad) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictMonad.Applicative0()));
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictMonad.Bind1().Apply0().Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var g = function(v) {
                    if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                        var h = function(s$prime) {
                            return append(f(v.value0))($70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(s$prime)(f));
                        };
                        return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(h)(v.value1));
                    }
                    if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                        return $70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(v1)(f);
                    })(v.value0));
                    if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 306, column 5 - line 308, column 31): " + [
                        v.constructor.name
                    ]);
                };
                return stepMap1(g)(fa);
            };
        },
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$fd7d3bacedac3347 = function(dictMonad) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d30ea600cb89759b$export$204d5ba0706a4088(dictMonad)),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$cf70c952df59e46e = function(dictMonad) {
    return {
        pure: $d30ea600cb89759b$export$439306a4dcaafbb9(dictMonad.Applicative0()),
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$f00d8368ae31463f = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftEffect: function() {
            var $339 = $d30ea600cb89759b$var$lift(Monad0);
            var $340 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($341) {
                return $339($340($341));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$24d9325f26d68bae = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftST: function() {
            var $342 = $d30ea600cb89759b$var$lift(Monad0);
            var $343 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($344) {
                return $342($343($344));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$bf13ffdc6b7113ca = function(dictApplicative) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictApplicative.Apply0().Functor0());
    return {
        alt: $d30ea600cb89759b$var$concat(dictApplicative),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$82f742a0347e990a = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var altListT1 = $d30ea600cb89759b$export$bf13ffdc6b7113ca(Applicative0);
    return {
        empty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0),
        Alt0: function() {
            return altListT1;
        }
    };
};
var $d30ea600cb89759b$export$183e8a1c18c60fd3 = function(dictMonad) {
    var applicativeListT1 = $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
    var plusListT1 = $d30ea600cb89759b$export$82f742a0347e990a(dictMonad);
    return {
        Applicative0: function() {
            return applicativeListT1;
        },
        Plus1: function() {
            return plusListT1;
        }
    };
};
var $d30ea600cb89759b$export$bb0af79e56ac53fe = function(dictMonad) {
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(dictMonad);
    var alternativeListT1 = $d30ea600cb89759b$export$183e8a1c18c60fd3(dictMonad);
    return {
        Monad0: function() {
            return monadListT1;
        },
        Alternative1: function() {
            return alternativeListT1;
        }
    };
};



// Generated by purs version 0.15.15















var $712b2df71ce372f8$export$6950f537d8cb5965 = /* #__PURE__ */ function() {
    function RWSResult(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RWSResult.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RWSResult(value0, value1, value2);
            };
        };
    };
    return RWSResult;
}();
var $712b2df71ce372f8$export$f3fc26d039f92fdf = function(x) {
    return x;
};
var $712b2df71ce372f8$export$82c3159babd6b403 = function(f) {
    return function(m) {
        return function(r) {
            return function(s) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf(m)(f(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$4c8676657688a1cd = function(v) {
    return v;
};
var $712b2df71ce372f8$export$7bded133c80fee1b = {
    Coercible0: function() {
        return undefined;
    }
};
var $712b2df71ce372f8$export$1d2bc64ff0e647b4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return function(v) {
                    return function(s) {
                        return bind(m)(function(a) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        });
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$b3b7a52c4baabcad = function(f) {
    return function(v) {
        return function(r) {
            return function(s) {
                return f(v(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$ab4be9af97c7111d = {
    defer: function(f) {
        return function(r) {
            return function(s) {
                var v = f($05149ea687d6b460$export$523c0b569236b342);
                return v(r)(s);
            };
        };
    }
};
var $712b2df71ce372f8$export$799f7a47278c4ab2 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return map(function(v1) {
                            return new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value0, f(v1.value1), v1.value2);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$8f895b27f6bea35a = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$9492f7142a7c6dda = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$3f72b7b9b643060e = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var Functor0 = dictBind.Apply0().Functor0();
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(Functor0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return {
            apply: function(v) {
                return function(v1) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v2) {
                                return mapFlipped(v1(r)(v2.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v2.value1(v3.value1), append(v2.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Functor0: function() {
                return functorRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$ecf0616f2cad1379 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictBind.Apply0().Functor0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            bind: function(v) {
                return function(f) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v1) {
                                var v2 = f(v1.value1);
                                return mapFlipped(v2(r)(v1.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v3.value1, append(v1.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$863b3ca33677d9b2 = function(dictBind) {
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(applyRWST1(dictMonoid));
        return function(dictSemigroup) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $712b2df71ce372f8$export$b7ffaf6687c91068 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictMonad.Bind1());
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            pure: function(a) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$3addf8bc39ac949f = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var bindRWST1 = $712b2df71ce372f8$export$ecf0616f2cad1379(dictMonad.Bind1());
    return function(dictMonoid) {
        var applicativeRWST2 = applicativeRWST1(dictMonoid);
        var bindRWST2 = bindRWST1(dictMonoid);
        return {
            Applicative0: function() {
                return applicativeRWST2;
            },
            Bind1: function() {
                return bindRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$b3a6ad9a80cd89aa = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            ask: function(r) {
                return function(s) {
                    return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, r, mempty));
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$149b7da9e90e1eac = function(dictMonad) {
    var monadAskRWST1 = $712b2df71ce372f8$export$b3a6ad9a80cd89aa(dictMonad);
    return function(dictMonoid) {
        var monadAskRWST2 = monadAskRWST1(dictMonoid);
        return {
            local: function(f) {
                return function(m) {
                    return function(r) {
                        return function(s) {
                            return m(f(r))(s);
                        };
                    };
                };
            },
            MonadAsk0: function() {
                return monadAskRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$1947b5c08efdf68f = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftEffect: function() {
                var $284 = lift(Monad0);
                var $285 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($286) {
                    return $284($285($286));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$858b449733703d7f = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tailRecM: function(k) {
                return function(a) {
                    var k$prime = function(r) {
                        return function(v) {
                            var v1 = k(v.value1);
                            return bind(v1(r)(v.value0))(function(v2) {
                                return pure(function() {
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    throw new Error("Failed pattern match at Control.Monad.RWS.Trans (line 129, column 16 - line 131, column 68): " + [
                                        v2.value1.constructor.name
                                    ]);
                                }());
                            });
                        };
                    };
                    return function(r) {
                        return function(s) {
                            return tailRecM(k$prime(r))(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        };
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$c835aca1626da706 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            state: function(f) {
                return function(v) {
                    return function(s) {
                        var v1 = f(s);
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value1, v1.value0, mempty));
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$5538632dd3cd70cc = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var Semigroup0 = dictMonoid.Semigroup0();
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tell: function(w) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, $05149ea687d6b460$export$523c0b569236b342, w));
                    };
                };
            },
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$d26d81ccbf9cc981 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadTellRWST1 = $712b2df71ce372f8$export$5538632dd3cd70cc(dictMonad);
    return function(dictMonoid) {
        var monadTellRWST2 = monadTellRWST1(dictMonoid);
        return {
            listen: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value2), v.value2));
                        });
                    };
                };
            },
            pass: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, v.value1.value0, v.value1.value1(v.value2)));
                        });
                    };
                };
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$9d857fb7268a3f42 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            throwError: function(e) {
                return lift(throwError(e));
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$f1aa4e7ce0e20856 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowRWST1 = $712b2df71ce372f8$export$9d857fb7268a3f42(dictMonadError.MonadThrow0());
    return function(dictMonoid) {
        var monadThrowRWST2 = monadThrowRWST1(dictMonoid);
        return {
            catchError: function(m) {
                return function(h) {
                    return function(r) {
                        return function(s) {
                            return catchError(m(r)(s))(function(e) {
                                var v = h(e);
                                return v(r)(s);
                            });
                        };
                    };
                };
            },
            MonadThrow0: function() {
                return monadThrowRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$fa98ca5d27201430 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftST: function() {
                var $287 = lift(Monad0);
                var $288 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($289) {
                    return $287($288($289));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$83c8cfee0365f931 = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var semigroupRWST1 = $712b2df71ce372f8$export$863b3ca33677d9b2(dictMonad.Bind1());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(applicativeRWST1(dictMonoid));
        var semigroupRWST2 = semigroupRWST1(dictMonoid);
        return function(dictMonoid1) {
            var semigroupRWST3 = semigroupRWST2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupRWST3;
                }
            };
        };
    };
};
var $712b2df71ce372f8$export$cfb751420c588279 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return function(s) {
                        return alt(v(r)(s))(v1(r)(s));
                    };
                };
            };
        },
        Functor0: function() {
            return functorRWST1;
        }
    };
};
var $712b2df71ce372f8$export$6179beba56f1d9b2 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altRWST1 = $712b2df71ce372f8$export$cfb751420c588279(dictPlus.Alt0());
    return {
        empty: function(v) {
            return function(v1) {
                return empty;
            };
        },
        Alt0: function() {
            return altRWST1;
        }
    };
};
var $712b2df71ce372f8$export$26aad7e9ffabe87b = function(dictMonoid) {
    return function(dictAlternative) {
        var plusRWST1 = $712b2df71ce372f8$export$6179beba56f1d9b2(dictAlternative.Plus1());
        return function(dictMonad) {
            var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad)(dictMonoid);
            return {
                Applicative0: function() {
                    return applicativeRWST1;
                },
                Plus1: function() {
                    return plusRWST1;
                }
            };
        };
    };
};



// Generated by purs version 0.15.15




















var $e9bda291f4ec10ec$export$73ce73bddfe2800a = function(x) {
    return x;
};
var $e9bda291f4ec10ec$export$72aea7109e8312dd = function(f) {
    return function(v) {
        return function($199) {
            return v(f($199));
        };
    };
};
var $e9bda291f4ec10ec$export$c5ba8a89d9140c32 = function(v) {
    return v;
};
var $e9bda291f4ec10ec$export$dce35699eedd4739 = {
    Coercible0: function() {
        return undefined;
    }
};
var $e9bda291f4ec10ec$export$5e0a9e9fea50cb88 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return function(s) {
                return bind(m)(function(x) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(x, s));
                });
            };
        };
    }
};
var $e9bda291f4ec10ec$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $e9bda291f4ec10ec$export$8342df5ddac360cd = function(f) {
    return function(v) {
        return function($200) {
            return f(v($200));
        };
    };
};
var $e9bda291f4ec10ec$export$dce43013fc3a5fe1 = {
    defer: function(f) {
        return function(s) {
            var v = f($05149ea687d6b460$export$523c0b569236b342);
            return v(s);
        };
    }
};
var $e9bda291f4ec10ec$export$d5449d946db19e3a = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(s) {
                    return map(function(v1) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v1.value0), v1.value1);
                    })(v(s));
                };
            };
        }
    };
};
var $e9bda291f4ec10ec$export$193956ba360b7728 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$99aa49a66d7c0535 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$345b4840c14ff10f = function(dictMonad) {
    return {
        Applicative0: function() {
            return $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
        },
        Bind1: function() {
            return $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$f28534bdc7259c7 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(s) {
                    return bind(v(s))(function(v1) {
                        var v3 = f(v1.value0);
                        return v3(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef = function(dictMonad) {
    var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$5cbc630d6fbe2e14 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        pure: function(a) {
            return function(s) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$726f0b075e4f5d8b = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $e9bda291f4ec10ec$export$45bacc938270e8f5 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        ask: $e9bda291f4ec10ec$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$20f71c563c2e6d49 = function(dictMonadReader) {
    var monadAskStateT1 = $e9bda291f4ec10ec$export$45bacc938270e8f5(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $201 = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
            return function($202) {
                return $e9bda291f4ec10ec$export$8342df5ddac360cd($201($202));
            };
        }(),
        MonadAsk0: function() {
            return monadAskStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$2e498a385f8c30f1 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(s) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return function(s$prime) {
                            return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s$prime));
                        };
                    });
                    return v(s);
                });
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$cba9856135198781 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftEffect: function() {
            var $203 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $204 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($205) {
                return $203($204($205));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$ade5de830b656137 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        tailRecM: function(f) {
            return function(a) {
                var f$prime = function(v) {
                    var v1 = f(v.value0);
                    return bind(v1(v.value1))(function(v2) {
                        return pure(function() {
                            if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            throw new Error("Failed pattern match at Control.Monad.State.Trans (line 88, column 16 - line 90, column 40): " + [
                                v2.value0.constructor.name
                            ]);
                        }());
                    });
                };
                return function(s) {
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
                };
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$fc3b89a546fa5c5c = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad);
    return {
        state: function(f) {
            return function($206) {
                return pure(f($206));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$7fdbbf63ca644aa6 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad1);
    return {
        tell: function() {
            var $207 = $e9bda291f4ec10ec$var$lift(Monad1);
            var $208 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$f97520cd68688e2d = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellStateT1 = $e9bda291f4ec10ec$export$7fdbbf63ca644aa6(MonadTell1);
    return {
        listen: function(m) {
            return function(s) {
                return bind(listen(m(s)))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                });
            };
        },
        pass: function(m) {
            return function(s) {
                return pass(bind(m(s))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                }));
            };
        },
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$89cac97299cfdec2 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $e9bda291f4ec10ec$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$c2a2ecf63b1e47e2 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowStateT1 = $e9bda291f4ec10ec$export$89cac97299cfdec2(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(s) {
                    return catchError(v(s))(function(e) {
                        var v1 = h(e);
                        return v1(s);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$e7c6f10a88f3ca17 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftST: function() {
            var $210 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $211 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($212) {
                return $210($211($212));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$9d9b8c7bcee971bf = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    var semigroupStateT1 = $e9bda291f4ec10ec$export$726f0b075e4f5d8b(dictMonad);
    return function(dictMonoid) {
        var semigroupStateT2 = semigroupStateT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d5bde0fdc0bca75b = function(dictMonad) {
    return function(dictAlt) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
        var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictAlt.Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return function(s) {
                        return alt(v(s))(v1(s));
                    };
                };
            },
            Functor0: function() {
                return functorStateT1;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$300a7627bf7b0e65 = function(dictMonad) {
    var altStateT1 = $e9bda291f4ec10ec$export$d5bde0fdc0bca75b(dictMonad);
    return function(dictPlus) {
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        var altStateT2 = altStateT1(dictPlus.Alt0());
        return {
            empty: function(v) {
                return empty;
            },
            Alt0: function() {
                return altStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d31747194ff6662e = function(dictMonad) {
    var applicativeStateT1 = $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
    var plusStateT1 = $e9bda291f4ec10ec$export$300a7627bf7b0e65(dictMonad);
    return function(dictAlternative) {
        var plusStateT2 = plusStateT1(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeStateT1;
            },
            Plus1: function() {
                return plusStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$b08eeaf68c7005d9 = function(dictMonadPlus) {
    var Monad0 = dictMonadPlus.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    var alternativeStateT1 = $e9bda291f4ec10ec$export$d31747194ff6662e(Monad0)(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStateT1;
        },
        Alternative1: function() {
            return alternativeStateT1;
        }
    };
};





var $b6d6cce78665f23d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $b6d6cce78665f23d$var$lift1 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $b6d6cce78665f23d$var$lift2 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $b6d6cce78665f23d$var$lift3 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $b6d6cce78665f23d$var$lift4 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $b6d6cce78665f23d$var$lift5 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $b6d6cce78665f23d$export$bd75e69808ef8e57 = {
    liftAff: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    MonadEffect0: function() {
        return $edf0339512807bee$export$666a030cecdf96c;
    }
};
var $b6d6cce78665f23d$export$37f61af225938e0f = function(dict) {
    return dict.liftAff;
};
var $b6d6cce78665f23d$export$53acd6df2cbe3344 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectContT = $fca560e14229da4e$export$35d988300b9091c9(MonadEffect0);
    return {
        liftAff: function() {
            var $65 = $b6d6cce78665f23d$var$lift(MonadEffect0.Monad0());
            var $66 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($67) {
                return $65($66($67));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $b6d6cce78665f23d$export$87a4e9dc50af0c41 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectExceptT = $d2284b2d3e1b6f87$export$14ff7e4e497a86b1(MonadEffect0);
    return {
        liftAff: function() {
            var $68 = $b6d6cce78665f23d$var$lift1(MonadEffect0.Monad0());
            var $69 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($70) {
                return $68($69($70));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $b6d6cce78665f23d$export$72b48760d563ad73 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectListT = $d30ea600cb89759b$export$f00d8368ae31463f(MonadEffect0);
    return {
        liftAff: function() {
            var $71 = $b6d6cce78665f23d$var$lift2(MonadEffect0.Monad0());
            var $72 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($73) {
                return $71($72($73));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $b6d6cce78665f23d$export$7091efe953cca892 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectMaybe = $7038ccc2f7f5bbce$export$2f876a9cb1e407d9(MonadEffect0);
    return {
        liftAff: function() {
            var $74 = $b6d6cce78665f23d$var$lift3(MonadEffect0.Monad0());
            var $75 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($76) {
                return $74($75($76));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $b6d6cce78665f23d$export$5fd9f999a5266faf = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectRWS = $712b2df71ce372f8$export$1947b5c08efdf68f(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $77 = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
                return function($78) {
                    return $77(liftAff1($78));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS;
            }
        };
    };
};
var $b6d6cce78665f23d$export$fa61c33f24d5bab = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectReader = $848780da1bf26d9d$export$a554ebf369a3f56d(MonadEffect0);
    return {
        liftAff: function() {
            var $79 = $b6d6cce78665f23d$var$lift4(MonadEffect0.Monad0());
            var $80 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($81) {
                return $79($80($81));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $b6d6cce78665f23d$export$1c14dadc45d4bfb9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectState = $e9bda291f4ec10ec$export$cba9856135198781(MonadEffect0);
    return {
        liftAff: function() {
            var $82 = $b6d6cce78665f23d$var$lift5(MonadEffect0.Monad0());
            var $83 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($84) {
                return $82($83($84));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $b6d6cce78665f23d$export$7ad7619eecdb33a9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectWriter = $d9ef009191ddae40$export$29fece65832b4369(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $85 = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid))(Monad0);
                return function($86) {
                    return $85(liftAff1($86));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter;
            }
        };
    };
};




// Generated by purs version 0.15.15

var $100f96dc727fa3bb$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ChildQuery.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ChildQuery(value0, value1, value2);
            };
        };
    };
    return ChildQuery;
}();
var $100f96dc727fa3bb$export$183d7a788d583d00 = $ac8b3532514ac019$export$401372c57776dc;
var $100f96dc727fa3bb$export$edf7909ca53834c6 = $ac8b3532514ac019$export$401372c57776dc;
var $100f96dc727fa3bb$export$22f9ac696d7058c1 = {
    map: function(f) {
        return $100f96dc727fa3bb$export$183d7a788d583d00(function(v) {
            return $100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                return v.value0(dictApplicative);
            }, v.value1, function($8) {
                return f(v.value2($8));
            }));
        });
    }
};


// Generated by purs version 0.15.15














// Generated by purs version 0.15.15
function $ef57d2bf6d374935$export$2230c7466f27d38a(a) {
    return function(b) {
        return a === b;
    };
}



var $871d3d7bcf6be72e$export$4fd25d6ead33df13 = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$50f4602e25613a3e = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$54d9901699893a6 = $ef57d2bf6d374935$export$2230c7466f27d38a;
var $871d3d7bcf6be72e$export$139829c37543f0b8 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1) || eq(v)(v1);
            };
        }
    };
};
var $871d3d7bcf6be72e$export$32e537f465b3365f = {
    eq: function(v) {
        return function(v1) {
            return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1);
        };
    }
};


var $8360250a454b77aa$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $8360250a454b77aa$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $8360250a454b77aa$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $8360250a454b77aa$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $8360250a454b77aa$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $8360250a454b77aa$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a);
var $8360250a454b77aa$var$traverse_1 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8360250a454b77aa$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $8360250a454b77aa$var$traverse_2 = /* #__PURE__ */ $8360250a454b77aa$var$traverse_($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $8360250a454b77aa$var$Subscription = function(x) {
    return x;
};
var $8360250a454b77aa$var$Listener = function(x) {
    return x;
};
var $8360250a454b77aa$var$Emitter = function(x) {
    return x;
};
var $8360250a454b77aa$export$f500693cef883ffd = function(v) {
    return v;
};
var $8360250a454b77aa$export$ec068583843480e7 = function(v) {
    return function(k) {
        return v(function($76) {
            return $8360250a454b77aa$var$$$void(k($76));
        });
    };
};
var $8360250a454b77aa$export$7251a5ca64435ded = /* #__PURE__ */ $6c2f8951ecf9531e$export$58139e981c60cf43($d7bf9817a417d4ae$export$824c37c4afd77b1);
var $8360250a454b77aa$export$5e14cdade93d6f7b = function(v) {
    return function(a) {
        return v(a);
    };
};
var $8360250a454b77aa$export$f78eaf36ddcc5627 = /* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($784e1bd3d26d71da$export$852b4040eee6c6ba);
var $8360250a454b77aa$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $784e1bd3d26d71da$export$192e81b9fe7e4abe(/* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($8360250a454b77aa$export$f78eaf36ddcc5627)));
var $8360250a454b77aa$export$59cc8049ccd39a18 = $8360250a454b77aa$var$coerce;
var $8360250a454b77aa$export$8fdc462d887e88b6 = {
    map: function(f) {
        return function(v) {
            return function(k) {
                return v(function($77) {
                    return k(f($77));
                });
            };
        };
    }
};
var $8360250a454b77aa$export$93e2b83da34ff82a = function(f) {
    return function(v) {
        return function(b) {
            return function(k) {
                return function __do() {
                    var result = $90327512d8280b8d$export$b8cb59497041ffe4(b)();
                    return v(function(a) {
                        return $8360250a454b77aa$var$bind($90327512d8280b8d$export$3ff57735a52b8713(f(a))(result))(k);
                    })();
                };
            };
        };
    };
};
var $8360250a454b77aa$export$3dea766d36a8935f = function(p) {
    return function(v) {
        return function(k) {
            return v(function(a) {
                var $57 = p(a);
                if ($57) return k(a);
                return $8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342);
            });
        };
    };
};
var $8360250a454b77aa$export$185802fd694ee1f5 = function __do() {
    var subscribers = $90327512d8280b8d$export$b8cb59497041ffe4([])();
    return {
        emitter: function(k) {
            return function __do() {
                $90327512d8280b8d$export$45b91115a89d6020(function(v) {
                    return $8360250a454b77aa$var$append(v)([
                        k
                    ]);
                })(subscribers)();
                return $90327512d8280b8d$export$45b91115a89d6020($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($871d3d7bcf6be72e$export$54d9901699893a6)(k))(subscribers);
            };
        },
        listener: function(a) {
            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(subscribers))($8360250a454b77aa$var$traverse_1(function(k) {
                return k(a);
            }));
        }
    };
};
var $8360250a454b77aa$export$d838837eb5b184e3 = function(f) {
    var v = $c02f07bc0f38e9e9$export$c62839628b30a695($8360250a454b77aa$export$185802fd694ee1f5);
    var v1 = f(v.emitter);
    return function(k) {
        return function __do() {
            var v2 = $8360250a454b77aa$export$ec068583843480e7(v1.input)($8360250a454b77aa$export$5e14cdade93d6f7b(v.listener))();
            var v3 = $8360250a454b77aa$export$ec068583843480e7(v1.output)(k)();
            return $8360250a454b77aa$var$applySecond(v2)(v3);
        };
    };
};
var $8360250a454b77aa$export$98d7d43cbbc38ca1 = {
    cmap: function(f) {
        return function(v) {
            return $8360250a454b77aa$var$coerce(function($78) {
                return v(f($78));
            });
        };
    }
};
var $8360250a454b77aa$export$641721d49e3b53db = {
    apply: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var latestA = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var latestB = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var v2 = v(function(a) {
                        return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(a))(latestA)();
                            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(latestB))($8360250a454b77aa$var$traverse_2(function($79) {
                                return k(a($79));
                            }))();
                        };
                    })();
                    var v3 = v1(function(b) {
                        return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(latestB)();
                            return $8360250a454b77aa$var$bind($e521936ea118867a$export$aafa59e2e03f2942(latestA))($8360250a454b77aa$var$traverse_2(function($80) {
                                return k(function(v3) {
                                    return v3(b);
                                }($80));
                            }))();
                        };
                    })();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($8360250a454b77aa$export$641721d49e3b53db);
var $8360250a454b77aa$export$1096768271b079ef = function(dictSemigroup) {
    return {
        append: $8360250a454b77aa$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $8360250a454b77aa$export$3b69707d5efd35bb = function(dictMonoid) {
    var semigroupEmitter1 = $8360250a454b77aa$export$1096768271b079ef(dictMonoid.Semigroup0());
    return {
        mempty: $8360250a454b77aa$var$mempty,
        Semigroup0: function() {
            return semigroupEmitter1;
        }
    };
};
var $8360250a454b77aa$export$b87fc96b41f99504 = {
    pure: function(a) {
        return function(k) {
            return function __do() {
                k(a)();
                return $8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342);
            };
        };
    },
    Apply0: function() {
        return $8360250a454b77aa$export$641721d49e3b53db;
    }
};
var $8360250a454b77aa$export$e54eec101f91650d = {
    alt: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var v2 = v(k)();
                    var v3 = v1(k)();
                    return $8360250a454b77aa$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $8360250a454b77aa$export$8fdc462d887e88b6;
    }
};
var $8360250a454b77aa$export$18c97e2c4a95b65b = {
    empty: function(v) {
        return $8360250a454b77aa$var$pure($8360250a454b77aa$var$pure($05149ea687d6b460$export$523c0b569236b342));
    },
    Alt0: function() {
        return $8360250a454b77aa$export$e54eec101f91650d;
    }
};
var $8360250a454b77aa$export$9afcd97a0eb7b5aa = {
    Applicative0: function() {
        return $8360250a454b77aa$export$b87fc96b41f99504;
    },
    Plus1: function() {
        return $8360250a454b77aa$export$18c97e2c4a95b65b;
    }
};


var $84222ab19bdc98bd$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $84222ab19bdc98bd$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($ea3eb84de0acf574$export$91e1c50dfb7225a6);
var $84222ab19bdc98bd$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($ea3eb84de0acf574$export$78146089411e393d);
var $84222ab19bdc98bd$var$slots = /* #__PURE__ */ $0f3b7f18059106fc$export$bbd679b9fab4c947();
var $84222ab19bdc98bd$var$lookup = /* #__PURE__ */ $0f3b7f18059106fc$export$dfc7155ac0343b8();
var $84222ab19bdc98bd$var$over = /* #__PURE__ */ $4fa4836228a192cc$export$fb4902fd9e525693()();
var $84222ab19bdc98bd$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8360250a454b77aa$export$8fdc462d887e88b6);
var $84222ab19bdc98bd$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $84222ab19bdc98bd$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$34a2521cb7920188);
var $84222ab19bdc98bd$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($100f96dc727fa3bb$export$22f9ac696d7058c1);
var $84222ab19bdc98bd$export$f3ce0030ce21b322 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$77e8fa738093aa8c = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$7254cc27399e90bd = /* #__PURE__ */ function() {
    function State(value0) {
        this.value0 = value0;
    }
    State.create = function(value0) {
        return new State(value0);
    };
    return State;
}();
var $84222ab19bdc98bd$export$b5b6bb8bb5273115 = /* #__PURE__ */ function() {
    function Subscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Subscribe.create = function(value0) {
        return function(value1) {
            return new Subscribe(value0, value1);
        };
    };
    return Subscribe;
}();
var $84222ab19bdc98bd$export$cf424b9d16eab6b0 = /* #__PURE__ */ function() {
    function Unsubscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Unsubscribe.create = function(value0) {
        return function(value1) {
            return new Unsubscribe(value0, value1);
        };
    };
    return Unsubscribe;
}();
var $84222ab19bdc98bd$export$5ba9ac88cb4a4c17 = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $84222ab19bdc98bd$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0) {
        this.value0 = value0;
    }
    ChildQuery.create = function(value0) {
        return new ChildQuery(value0);
    };
    return ChildQuery;
}();
var $84222ab19bdc98bd$export$c97bcbb53b4e15e4 = /* #__PURE__ */ function() {
    function Raise(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Raise.create = function(value0) {
        return function(value1) {
            return new Raise(value0, value1);
        };
    };
    return Raise;
}();
var $84222ab19bdc98bd$export$6e7e621f508eff66 = /* #__PURE__ */ function() {
    function Par(value0) {
        this.value0 = value0;
    }
    Par.create = function(value0) {
        return new Par(value0);
    };
    return Par;
}();
var $84222ab19bdc98bd$export$8cdfc2927e464854 = /* #__PURE__ */ function() {
    function Fork(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Fork.create = function(value0) {
        return function(value1) {
            return new Fork(value0, value1);
        };
    };
    return Fork;
}();
var $84222ab19bdc98bd$export$26aa7833c998c5d3 = /* #__PURE__ */ function() {
    function Join(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Join.create = function(value0) {
        return function(value1) {
            return new Join(value0, value1);
        };
    };
    return Join;
}();
var $84222ab19bdc98bd$export$25e269b2a286b4be = /* #__PURE__ */ function() {
    function Kill(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Kill.create = function(value0) {
        return function(value1) {
            return new Kill(value0, value1);
        };
    };
    return Kill;
}();
var $84222ab19bdc98bd$export$c2ea277386f73da0 = /* #__PURE__ */ function() {
    function GetRef(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    GetRef.create = function(value0) {
        return function(value1) {
            return new GetRef(value0, value1);
        };
    };
    return GetRef;
}();
var $84222ab19bdc98bd$export$a719947860ecc9c1 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$9599f158307d5f79 = function(x) {
    return x;
};
var $84222ab19bdc98bd$export$f500693cef883ffd = function(sid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$cf424b9d16eab6b0(sid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$614bd1e27186eef8 = function(esc) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(esc, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342)));
};
var $84222ab19bdc98bd$export$ec068583843480e7 = function(es) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function(v) {
        return es;
    }, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$24cfcc8b33bdb8e8 = function(dictSemigroup) {
    return $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictSemigroup);
};
var $84222ab19bdc98bd$export$66313c302b2ea154 = function(o) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(o, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$dcd0d083aa86c355 = function() {
    return function(dictIsSymbol) {
        var slots1 = $84222ab19bdc98bd$var$slots(dictIsSymbol);
        return function(dictOrd) {
            var slots2 = slots1(dictOrd);
            return function(label) {
                return function(q) {
                    var catMapMaybes = function(dictOrd1) {
                        var insert = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd1);
                        return $84222ab19bdc98bd$var$foldrWithIndex(function(k) {
                            return function(v) {
                                return function(acc) {
                                    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)($f57f4b701aa7b66e$export$8a83211c878a3f1f(insert(k))(acc))(v);
                                };
                            };
                        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
                    };
                    var catMapMaybes1 = catMapMaybes(dictOrd);
                    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c9e0c97aebb96176($100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                        var map4 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                        var traverse1 = $84222ab19bdc98bd$var$traverse(dictApplicative);
                        return function(k) {
                            var $173 = map4(catMapMaybes1);
                            var $174 = traverse1(k);
                            var $175 = slots2(label);
                            return function($176) {
                                return $173($174($175($176)));
                            };
                        };
                    }, q, $84222ab19bdc98bd$var$identity))));
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2fa187e846a241c4 = function() {
    return function(dictIsSymbol) {
        var lookup1 = $84222ab19bdc98bd$var$lookup(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(q) {
                        return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c9e0c97aebb96176($100f96dc727fa3bb$export$edf7909ca53834c6(new $100f96dc727fa3bb$export$c9e0c97aebb96176(function(dictApplicative) {
                            var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
                            return function(k) {
                                var $177 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(pure1($06733ae99ed4f534$export$bebe9059409a0d04.value))(k);
                                var $178 = lookup2(label)(p);
                                return function($179) {
                                    return $177($178($179));
                                };
                            };
                        }, q, $84222ab19bdc98bd$var$identity))));
                    };
                };
            };
        };
    };
};
var $84222ab19bdc98bd$export$2a9fc99fce80131a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $84222ab19bdc98bd$export$7e953d51c2b3343e = $97937c29f879e68e$export$ff461bf68e7dd332;
var $84222ab19bdc98bd$export$e0bae42e641783be = {
    Coercible0: function() {
        return undefined;
    }
};
var $84222ab19bdc98bd$export$2b4680b78d507e0e = function(dictMonoid) {
    return $d0bd5a116d2d5f24$export$cb3638ab887278d6(dictMonoid);
};
var $84222ab19bdc98bd$export$a19097d0708c88b2 = {
    lift: function(dictMonad) {
        return function($180) {
            return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($180)));
        };
    }
};
var $84222ab19bdc98bd$export$a558113f6f2e3f2d = $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
var $84222ab19bdc98bd$export$87bf621137788b28 = {
    state: function($181) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$7254cc27399e90bd.create($181)));
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$cf461d6710b3adc = function(dictMonadTell) {
    var Semigroup0 = dictMonadTell.Semigroup0();
    return {
        tell: function() {
            var $182 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($183) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($182($183))));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$4671b1f72e4f4ad4 = function(dictMonadThrow) {
    return {
        throwError: function() {
            var $184 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($185) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($184($185))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$aecceb0bc1bf10d9 = function(dictMonadEffect) {
    return {
        liftEffect: function() {
            var $186 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($187) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($186($187))));
            };
        }(),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$8feaa16df4090813 = function(dictMonadAsk) {
    return {
        ask: $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk))),
        Monad0: function() {
            return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
        }
    };
};
var $84222ab19bdc98bd$export$6f4dec227404555 = function(dictMonadAff) {
    var monadEffectHalogenM1 = $84222ab19bdc98bd$export$aecceb0bc1bf10d9(dictMonadAff.MonadEffect0());
    return {
        liftAff: function() {
            var $188 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($189) {
                return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$5ba9ac88cb4a4c17.create($188($189))));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectHalogenM1;
        }
    };
};
var $84222ab19bdc98bd$export$88e5a30f85fcd860 = function(f) {
    return function(v) {
        var go = function(v1) {
            if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
            if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(f(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$88e5a30f85fcd860(f)))(v1.value0));
            if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$88e5a30f85fcd860(f)(v1.value0), v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
            if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
            throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 290, column 8 - line 301, column 29): " + [
                v1.constructor.name
            ]);
        };
        return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
    };
};
var $84222ab19bdc98bd$export$77c80fee367384a1 = function(dictFunctor) {
    return function(f) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(function() {
                    var $190 = $84222ab19bdc98bd$var$map(f);
                    return function($191) {
                        return $190(v1.value0($191));
                    };
                }(), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$77c80fee367384a1(dictFunctor)(f)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 269, column 8 - line 280, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$dfdb508572caf3d7 = function(fid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$25e269b2a286b4be(fid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$f7e2c8231c57a8bd = function(fid) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$26aa7833c998c5d3(fid, $05149ea687d6b460$export$523c0b569236b342));
};
var $84222ab19bdc98bd$export$d4721e7c31d91ccb = function(f) {
    return function(f$prime) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $192 = $84222ab19bdc98bd$var$map1(f);
                    return function($193) {
                        return $192(v1.value0(f$prime($193)));
                    };
                }());
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$d4721e7c31d91ccb(f)(f$prime)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 247, column 8 - line 258, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(nat(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$over($84222ab19bdc98bd$export$a719947860ecc9c1)($dc7ffeabd143829e$export$2a17b194dc6daf5e($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)))(v1.value0));
                if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854($84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor)(nat)(v1.value0), v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 312, column 8 - line 323, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $d0bd5a116d2d5f24$export$9624ed458578c422(go)(v);
        };
    };
};
var $84222ab19bdc98bd$export$f0c653cfd7dea798 = function(p) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$c2ea277386f73da0(p, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$bf09f5de576f9cf1 = $d0bd5a116d2d5f24$export$245cefec95375d9a;
var $84222ab19bdc98bd$export$e670701c689a627c = $dc7ffeabd143829e$export$a37c0cfb408cb5d9;
var $84222ab19bdc98bd$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$e670701c689a627c);
var $84222ab19bdc98bd$export$12e8711db3d90a36 = function(dictFunctor) {
    var map4 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                if (v instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return new $84222ab19bdc98bd$export$7254cc27399e90bd(function() {
                    var $194 = $84222ab19bdc98bd$var$lmap(f);
                    return function($195) {
                        return $194(v.value0($195));
                    };
                }());
                if (v instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return new $84222ab19bdc98bd$export$b5b6bb8bb5273115(v.value0, function($196) {
                    return f(v.value1($196));
                });
                if (v instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return new $84222ab19bdc98bd$export$cf424b9d16eab6b0(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return new $84222ab19bdc98bd$export$5ba9ac88cb4a4c17(map4(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return new $84222ab19bdc98bd$export$c9e0c97aebb96176($84222ab19bdc98bd$var$map2(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return new $84222ab19bdc98bd$export$c97bcbb53b4e15e4(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return new $84222ab19bdc98bd$export$6e7e621f508eff66($84222ab19bdc98bd$var$map3(f)(v.value0));
                if (v instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return new $84222ab19bdc98bd$export$8cdfc2927e464854(v.value0, function($197) {
                    return f(v.value1($197));
                });
                if (v instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return new $84222ab19bdc98bd$export$26aa7833c998c5d3(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return new $84222ab19bdc98bd$export$25e269b2a286b4be(v.value0, f(v.value1));
                if (v instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return new $84222ab19bdc98bd$export$c2ea277386f73da0(v.value0, function($198) {
                    return f(v.value1($198));
                });
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 57, column 11 - line 68, column 37): " + [
                    v.constructor.name
                ]);
            };
        }
    };
};
var $84222ab19bdc98bd$export$7a5058c6b79333e0 = function(hmu) {
    return $d0bd5a116d2d5f24$export$8040756fd4c77395(new $84222ab19bdc98bd$export$8cdfc2927e464854(hmu, $84222ab19bdc98bd$var$identity));
};
var $84222ab19bdc98bd$export$5e41ee1c67709c46 = $37b880af5f4991bd$export$e65788c6d4494539;
var $84222ab19bdc98bd$export$5d7b8e78e43e2e55 = $37b880af5f4991bd$export$e65788c6d4494539;
var $84222ab19bdc98bd$export$172cc2b2b4e6467a = $d0bd5a116d2d5f24$export$39486fc5c75854c8;
var $84222ab19bdc98bd$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $84222ab19bdc98bd$export$728fdd75cbe6b202 = $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112;
var $84222ab19bdc98bd$export$86681bd6e5a32e67 = $dc7ffeabd143829e$export$6b0545b2ed7e7da2;
var $84222ab19bdc98bd$export$c43a5691f7e31126 = {
    parallel: function($199) {
        return $84222ab19bdc98bd$export$a719947860ecc9c1($dc7ffeabd143829e$export$9f6cb61afbf051fa($199));
    },
    sequential: function($200) {
        return $84222ab19bdc98bd$export$9599f158307d5f79($d0bd5a116d2d5f24$export$8040756fd4c77395($84222ab19bdc98bd$export$6e7e621f508eff66.create($200)));
    },
    Apply0: function() {
        return $84222ab19bdc98bd$export$728fdd75cbe6b202;
    },
    Apply1: function() {
        return $84222ab19bdc98bd$export$86681bd6e5a32e67;
    }
};
var $84222ab19bdc98bd$export$be2318e898dcc68 = $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
var $84222ab19bdc98bd$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $84222ab19bdc98bd$export$5cb2ea25322ba73e = {
    tailRecM: function(k) {
        return function(a) {
            return $84222ab19bdc98bd$var$bind(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($84222ab19bdc98bd$export$5cb2ea25322ba73e)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $84222ab19bdc98bd$var$pure(v.value0);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 105, column 26 - line 107, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $84222ab19bdc98bd$export$a558113f6f2e3f2d;
    }
};
var $84222ab19bdc98bd$export$a8dcf11c663b5a8c = $dc7ffeabd143829e$export$b8278c4ac41154ad;


// Generated by purs version 0.15.15


var $43c0c9babefbb793$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($026fde5446dd624a$export$bd40aba71422b460);
var $43c0c9babefbb793$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $43c0c9babefbb793$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize(value0) {
        this.value0 = value0;
    }
    Initialize.create = function(value0) {
        return new Initialize(value0);
    };
    return Initialize;
}();
var $43c0c9babefbb793$export$29defdae7b3f3a01 = /* #__PURE__ */ function() {
    function Finalize(value0) {
        this.value0 = value0;
    }
    Finalize.create = function(value0) {
        return new Finalize(value0);
    };
    return Finalize;
}();
var $43c0c9babefbb793$export$fc713a64b8ca1b7a = /* #__PURE__ */ function() {
    function Receive(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Receive.create = function(value0) {
        return function(value1) {
            return new Receive(value0, value1);
        };
    };
    return Receive;
}();
var $43c0c9babefbb793$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Action.create = function(value0) {
        return function(value1) {
            return new Action(value0, value1);
        };
    };
    return Action;
}();
var $43c0c9babefbb793$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Query.create = function(value0) {
        return function(value1) {
            return new Query(value0, value1);
        };
    };
    return Query;
}();
var $43c0c9babefbb793$export$dc697e7b72225166 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(f(m.value0));
            if (m instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(m.value0, f(m.value1));
            if (m instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(f)(m.value0), $43c0c9babefbb793$var$map1(f)(m.value1));
            throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $43c0c9babefbb793$export$211dae0362bd77c6 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                if (v instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return new $43c0c9babefbb793$export$b03b1c699c90a9b4(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return new $43c0c9babefbb793$export$29defdae7b3f3a01(g(v.value0));
                if (v instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return new $43c0c9babefbb793$export$fc713a64b8ca1b7a(f(v.value0), g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return new $43c0c9babefbb793$export$e19cd5f9376f8cee(v.value0, g(v.value1));
                if (v instanceof $43c0c9babefbb793$export$62297b13309008b2) return new $43c0c9babefbb793$export$62297b13309008b2($43c0c9babefbb793$var$map(g)(v.value0), $43c0c9babefbb793$var$map1(g)(v.value1));
                throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 16, column 15 - line 21, column 45): " + [
                    v.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.15






var $f1bf345cdb6c789d$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f1bf345cdb6c789d$var$Thunk = /* #__PURE__ */ function() {
    function Thunk(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Thunk.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Thunk(value0, value1, value2, value3);
                };
            };
        };
    };
    return Thunk;
}();
var $f1bf345cdb6c789d$var$unsafeThunkId = $ac8b3532514ac019$export$401372c57776dc;
var $f1bf345cdb6c789d$var$unsafeEqThunk = function(v, v1) {
    return $39e0beec4569345c$export$9bc2d847a861e3d8(v.value0, v1.value0) && $39e0beec4569345c$export$9bc2d847a861e3d8(v.value1, v1.value1) && v.value1(v.value3, v1.value3);
};
var $f1bf345cdb6c789d$var$thunk = function(tid, eqFn, f, a) {
    return new $f1bf345cdb6c789d$var$Thunk(tid, eqFn, f, a);
};
var $f1bf345cdb6c789d$export$c6666e7f0d2efc62 = function(f, a) {
    return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), $39e0beec4569345c$export$9bc2d847a861e3d8, f, a);
};
var $f1bf345cdb6c789d$export$8a29159161b2b8a6 = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $39e0beec4569345c$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_2"], b["_2"]);
    };
    return function(f, a, b) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"]);
        }, {
            "_1": a,
            "_2": b
        });
    };
}();
var $f1bf345cdb6c789d$export$7f0ccf52046143dd = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $39e0beec4569345c$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_2"], b["_2"]) && $39e0beec4569345c$export$9bc2d847a861e3d8(a["_3"], b["_3"]);
    };
    return function(f, a, b, c) {
        return $f1bf345cdb6c789d$var$thunk($f1bf345cdb6c789d$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"])(v["_3"]);
        }, {
            "_1": a,
            "_2": b,
            "_3": c
        });
    };
}();
var $f1bf345cdb6c789d$export$6fa757c467a343e = function(eqFn) {
    return function(f) {
        var tid = $f1bf345cdb6c789d$var$unsafeThunkId({
            f: f
        });
        var eqFn$prime = $8f2697950ee155e1$export$b12d5f1f5e196716(eqFn);
        return function(a) {
            return $f1bf345cdb6c789d$var$thunk(tid, eqFn$prime, f, a);
        };
    };
};
var $f1bf345cdb6c789d$export$1a6f8a190b47b840 = function(v) {
    return v.value2(v.value3);
};
var $f1bf345cdb6c789d$export$ad7ceecc341abc7e = function(k) {
    return function(v) {
        return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function($51) {
            return k(v.value2($51));
        }, v.value3);
    };
};
var $f1bf345cdb6c789d$export$b2cccb4e0928a3a6 = $f1bf345cdb6c789d$export$ad7ceecc341abc7e;
var $f1bf345cdb6c789d$export$2d03ed83ba31f127 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $f1bf345cdb6c789d$var$Thunk(v.value0, v.value1, function() {
                    var $52 = map(f);
                    return function($53) {
                        return $52(v.value2($53));
                    };
                }(), v.value3);
            };
        }
    };
};
var $f1bf345cdb6c789d$export$d46b23c375182cf8 = function(toVDom) {
    var haltThunk = function(state) {
        return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(state.vdom);
    };
    var $lazy_patchThunk = $f1bf345cdb6c789d$var$$runtime_lazy("patchThunk", "Halogen.VDom.Thunk", function() {
        return function(state, t2) {
            var $48 = $f1bf345cdb6c789d$var$unsafeEqThunk(state.thunk, t2);
            if ($48) return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(state.vdom), state, $lazy_patchThunk(112), haltThunk));
            var vdom = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(state.vdom, toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t2)));
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(vdom), {
                vdom: vdom,
                thunk: t2
            }, $lazy_patchThunk(115), haltThunk));
        };
    });
    var patchThunk = $lazy_patchThunk(108);
    var renderThunk = function(spec) {
        return function(t) {
            var vdom = $784c06f0344d34c4$export$7d13c0f6790d0505(spec)(toVDom($f1bf345cdb6c789d$export$1a6f8a190b47b840(t)));
            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(vdom), {
                thunk: t,
                vdom: vdom
            }, patchThunk, haltThunk));
        };
    };
    return renderThunk;
};



var $eea39ea934373596$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $eea39ea934373596$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($84222ab19bdc98bd$export$be2318e898dcc68)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $eea39ea934373596$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $eea39ea934373596$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($c959b62ce0c19dfe$export$a671de4661736606);
var $eea39ea934373596$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $eea39ea934373596$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $eea39ea934373596$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($c959b62ce0c19dfe$export$a671de4661736606);
var $eea39ea934373596$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $eea39ea934373596$var$lookup = /* #__PURE__ */ $0f3b7f18059106fc$export$dfc7155ac0343b8();
var $eea39ea934373596$var$pop = /* #__PURE__ */ $0f3b7f18059106fc$export$3e41007ebfff0e64();
var $eea39ea934373596$var$insert = /* #__PURE__ */ $0f3b7f18059106fc$export$21a5ca8aa77d35ff();
var $eea39ea934373596$export$bbf8b056cc92e88d = /* #__PURE__ */ function() {
    function ComponentSlot(value0) {
        this.value0 = value0;
    }
    ComponentSlot.create = function(value0) {
        return new ComponentSlot(value0);
    };
    return ComponentSlot;
}();
var $eea39ea934373596$export$5e46cfa5e835a582 = /* #__PURE__ */ function() {
    function ThunkSlot(value0) {
        this.value0 = value0;
    }
    ThunkSlot.create = function(value0) {
        return new ThunkSlot(value0);
    };
    return ThunkSlot;
}();
var $eea39ea934373596$export$48f0293959eb16ec = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$802c6b8ce0f42195 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$9eef9effff68b10a = function(args) {
    return function(v) {
        if (v instanceof $43c0c9babefbb793$export$b03b1c699c90a9b4) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.initialize))(v.value0);
        if (v instanceof $43c0c9babefbb793$export$29defdae7b3f3a01) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.finalize))(v.value0);
        if (v instanceof $43c0c9babefbb793$export$fc713a64b8ca1b7a) return $eea39ea934373596$var$voidLeft($eea39ea934373596$var$traverse_(args.handleAction)(args.receive(v.value0)))(v.value1);
        if (v instanceof $43c0c9babefbb793$export$e19cd5f9376f8cee) return $eea39ea934373596$var$voidLeft(args.handleAction(v.value0))(v.value1);
        if (v instanceof $43c0c9babefbb793$export$62297b13309008b2) return $026fde5446dd624a$export$1088317934ed5679(function(g) {
            var $45 = $eea39ea934373596$var$map($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v.value1($05149ea687d6b460$export$523c0b569236b342))(g));
            return function($46) {
                return $45(args.handleQuery($46));
            };
        })(v.value0);
        throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
            v.constructor.name
        ]);
    };
};
var $eea39ea934373596$export$89c807d7ece13702 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$3bb93a8213d3ef21 = $ac8b3532514ac019$export$401372c57776dc;
var $eea39ea934373596$export$6294a7576a4b06c3 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
                return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$export$89c807d7ece13702({
                    get: slot.get,
                    pop: slot.pop,
                    set: slot.set,
                    input: slot.input,
                    output: slot.output,
                    component: $eea39ea934373596$export$b2cccb4e0928a3a6(dictFunctor)(nat)(slot.component)
                }));
            })(v.value0);
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$b2cccb4e0928a3a6($eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat)))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [
                v.constructor.name
            ]);
        };
    };
};
var $eea39ea934373596$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    var hoist1 = $84222ab19bdc98bd$export$b2cccb4e0928a3a6(dictFunctor);
    return function(nat) {
        return $eea39ea934373596$export$802c6b8ce0f42195(function(c) {
            return $eea39ea934373596$export$3bb93a8213d3ef21({
                initialState: c.initialState,
                render: function() {
                    var $47 = $eea39ea934373596$var$lmap($eea39ea934373596$export$6294a7576a4b06c3(dictFunctor)(nat));
                    return function($48) {
                        return $47(c.render($48));
                    };
                }(),
                "eval": function() {
                    var $49 = hoist1(nat);
                    return function($50) {
                        return $49(c["eval"]($50));
                    };
                }()
            });
        });
    };
};
var $eea39ea934373596$export$ed5606d1e76f4b8b = {
    map: function(f) {
        return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
            return $eea39ea934373596$export$89c807d7ece13702({
                get: slot.get,
                pop: slot.pop,
                set: slot.set,
                component: slot.component,
                input: slot.input,
                output: $eea39ea934373596$var$map1($eea39ea934373596$var$map2(f))(slot.output)
            });
        });
    }
};
var $eea39ea934373596$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($eea39ea934373596$export$ed5606d1e76f4b8b);
var $eea39ea934373596$export$e299aa0f47209936 = {
    map: function(f) {
        return function(v) {
            if (v instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return new $eea39ea934373596$export$bbf8b056cc92e88d($eea39ea934373596$var$map3(f)(v.value0));
            if (v instanceof $eea39ea934373596$export$5e46cfa5e835a582) return new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$ad7ceecc341abc7e($eea39ea934373596$var$bimap($f4b2eb11fc32ed34$export$871de8747c9eaa88($eea39ea934373596$export$e299aa0f47209936)(f))(f))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 209, column 11 - line 211, column 74): " + [
                v.constructor.name
            ]);
        };
    }
};
var $eea39ea934373596$export$cb95887a94082d64 = /* #__PURE__ */ function() {
    return {
        handleAction: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($eea39ea934373596$var$pure($05149ea687d6b460$export$523c0b569236b342)),
        handleQuery: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($eea39ea934373596$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value)),
        receive: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        initialize: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        finalize: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $eea39ea934373596$export$f7e7e2efed606f4a = function() {
    return function(dictIsSymbol) {
        var lookup1 = $eea39ea934373596$var$lookup(dictIsSymbol);
        var pop1 = $eea39ea934373596$var$pop(dictIsSymbol);
        var insert1 = $eea39ea934373596$var$insert(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            var pop2 = pop1(dictOrd);
            var insert2 = insert1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(comp) {
                        return function(input) {
                            return function(output) {
                                return $eea39ea934373596$export$89c807d7ece13702({
                                    get: lookup2(label)(p),
                                    pop: pop2(label)(p),
                                    set: insert2(label)(p),
                                    component: comp,
                                    input: input,
                                    output: output
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};



// Generated by purs version 0.15.15





// Generated by purs version 0.15.15




var $e5b7e89a68d9c456$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $e5b7e89a68d9c456$export$f4752d802d3c730b = function(ctor) {
    return function(children) {
        var v = ctor([]);
        if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
        return v;
    };
};
var $e5b7e89a68d9c456$export$f691a8759658f782 = function(ctor) {
    return function(props) {
        return function(children) {
            var v = ctor(props)([]);
            if (v instanceof $bef4063d6d8fe507$export$cc2832fafe367c5e) return new $bef4063d6d8fe507$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
            return v;
        };
    };
};
var $e5b7e89a68d9c456$export$8a24d5472c669cc1 = function($14) {
    return $c959b62ce0c19dfe$export$8dbf9c790527241e($e5b7e89a68d9c456$var$pure($14));
};
var $e5b7e89a68d9c456$export$8dbf9c790527241e = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$8dbf9c790527241e($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $e5b7e89a68d9c456$export$cba2bb7f1b8927c4 = function($15) {
    return $c959b62ce0c19dfe$export$8454457683f90105($e5b7e89a68d9c456$var$pure($15));
};
var $e5b7e89a68d9c456$export$8454457683f90105 = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$8454457683f90105($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $e5b7e89a68d9c456$export$c63c6f932822f543 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("em");
var $e5b7e89a68d9c456$export$a5c38c2752f1223a = /* #__PURE__ */ $e5b7e89a68d9c456$export$c63c6f932822f543([]);
var $e5b7e89a68d9c456$export$2be46bb7e96db87f = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("embed");
var $e5b7e89a68d9c456$export$b53e7b77250f04f9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2be46bb7e96db87f([]);
var $e5b7e89a68d9c456$export$a38812d1aa1302d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("fieldset");
var $e5b7e89a68d9c456$export$2dc1b8d0924efe56 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a38812d1aa1302d9([]);
var $e5b7e89a68d9c456$export$b75acb72a9c69c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figcaption");
var $e5b7e89a68d9c456$export$60dfbef68b872a19 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b75acb72a9c69c26([]);
var $e5b7e89a68d9c456$export$991dc94f816a1d48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("figure");
var $e5b7e89a68d9c456$export$e3500458218031e0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$991dc94f816a1d48([]);
var $e5b7e89a68d9c456$export$adb608be33961c98 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("footer");
var $e5b7e89a68d9c456$export$70a8ff4564bfd029 = /* #__PURE__ */ $e5b7e89a68d9c456$export$adb608be33961c98([]);
var $e5b7e89a68d9c456$export$6210fa4921d2a466 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("form");
var $e5b7e89a68d9c456$export$1df82cba65ddbdc7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6210fa4921d2a466([]);
var $e5b7e89a68d9c456$export$448e4850cad7c7b0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h1");
var $e5b7e89a68d9c456$export$762b01c17cd5ef84 = /* #__PURE__ */ $e5b7e89a68d9c456$export$448e4850cad7c7b0([]);
var $e5b7e89a68d9c456$export$a943aa9a0fca3f0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h2");
var $e5b7e89a68d9c456$export$fb9cd428790d91ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$a943aa9a0fca3f0b([]);
var $e5b7e89a68d9c456$export$7edd4a21fac8ce55 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h3");
var $e5b7e89a68d9c456$export$d3f2bf86163ce5b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$7edd4a21fac8ce55([]);
var $e5b7e89a68d9c456$export$51a85cc1b68f452c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h4");
var $e5b7e89a68d9c456$export$44266b9d6c80e925 = /* #__PURE__ */ $e5b7e89a68d9c456$export$51a85cc1b68f452c([]);
var $e5b7e89a68d9c456$export$f44841a11990acb2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h5");
var $e5b7e89a68d9c456$export$29e7034271223ef2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f44841a11990acb2([]);
var $e5b7e89a68d9c456$export$c9ccd321d64f47e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("h6");
var $e5b7e89a68d9c456$export$454ef0c5c33a2870 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c9ccd321d64f47e3([]);
var $e5b7e89a68d9c456$export$5fd5031fecdacec3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("head");
var $e5b7e89a68d9c456$export$1139b773e3687c26 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5fd5031fecdacec3([]);
var $e5b7e89a68d9c456$export$38e42c68cf43b5d4 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("header");
var $e5b7e89a68d9c456$export$8bf7349458487350 = /* #__PURE__ */ $e5b7e89a68d9c456$export$38e42c68cf43b5d4([]);
var $e5b7e89a68d9c456$export$b4adb3f464574dcf = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("hr")(props)([]);
};
var $e5b7e89a68d9c456$export$d5ef68f9e25856a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b4adb3f464574dcf([]);
var $e5b7e89a68d9c456$export$c0bb0b647f701bb5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("html");
var $e5b7e89a68d9c456$export$435678c2016b20e2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c0bb0b647f701bb5([]);
var $e5b7e89a68d9c456$export$23f2a1d2818174ef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("i");
var $e5b7e89a68d9c456$export$3d4cba5f342e903e = /* #__PURE__ */ $e5b7e89a68d9c456$export$23f2a1d2818174ef([]);
var $e5b7e89a68d9c456$export$8cde213409fd6377 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("iframe")(props)([]);
};
var $e5b7e89a68d9c456$export$463b44d9bf3628be = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("img")(props)([]);
};
var $e5b7e89a68d9c456$export$b7e3ae3d7c15e42e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("input")(props)([]);
};
var $e5b7e89a68d9c456$export$27a48efc044c200a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ins");
var $e5b7e89a68d9c456$export$be13014404ffcf2b = /* #__PURE__ */ $e5b7e89a68d9c456$export$27a48efc044c200a([]);
var $e5b7e89a68d9c456$export$1ed45b69d23c052b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("kbd");
var $e5b7e89a68d9c456$export$4a6534c938817498 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1ed45b69d23c052b([]);
var $e5b7e89a68d9c456$export$1237798dc640739a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("label");
var $e5b7e89a68d9c456$export$71f1ceb3290c95d7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1237798dc640739a([]);
var $e5b7e89a68d9c456$export$9a9b59e08de24cef = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("legend");
var $e5b7e89a68d9c456$export$d57b7c1bdf9a3bfc = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a9b59e08de24cef([]);
var $e5b7e89a68d9c456$export$19caeaf7d9d84644 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("li");
var $e5b7e89a68d9c456$export$867ad32b190d58af = /* #__PURE__ */ $e5b7e89a68d9c456$export$19caeaf7d9d84644([]);
var $e5b7e89a68d9c456$export$9c30223ca0a664fb = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("link")(props)([]);
};
var $e5b7e89a68d9c456$export$f22da7240b7add18 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("main");
var $e5b7e89a68d9c456$export$88d8d81b07aa78ac = /* #__PURE__ */ $e5b7e89a68d9c456$export$f22da7240b7add18([]);
var $e5b7e89a68d9c456$export$871de8747c9eaa88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("map");
var $e5b7e89a68d9c456$export$aca8cce159e578de = /* #__PURE__ */ $e5b7e89a68d9c456$export$871de8747c9eaa88([]);
var $e5b7e89a68d9c456$export$bf7f2fce5c1cf636 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("mark");
var $e5b7e89a68d9c456$export$8e88f701cd5c1522 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bf7f2fce5c1cf636([]);
var $e5b7e89a68d9c456$export$b1e5508a851be14d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menu");
var $e5b7e89a68d9c456$export$d18229b57986002 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b1e5508a851be14d([]);
var $e5b7e89a68d9c456$export$f68e44d881264486 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("menuitem");
var $e5b7e89a68d9c456$export$e25e9f3e172962c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f68e44d881264486([]);
var $e5b7e89a68d9c456$export$6990040ee07315 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("meta")(props)([]);
};
var $e5b7e89a68d9c456$export$82334bbdfcebb57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("meter");
var $e5b7e89a68d9c456$export$86fa78168c2ac21a = /* #__PURE__ */ $e5b7e89a68d9c456$export$82334bbdfcebb57([]);
var $e5b7e89a68d9c456$export$80e4b313e5e6b30d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("nav");
var $e5b7e89a68d9c456$export$5c8b9c326353f574 = /* #__PURE__ */ $e5b7e89a68d9c456$export$80e4b313e5e6b30d([]);
var $e5b7e89a68d9c456$export$528ba0e6da49e146 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("noscript");
var $e5b7e89a68d9c456$export$6d2a3f75abf3cf2f = /* #__PURE__ */ $e5b7e89a68d9c456$export$528ba0e6da49e146([]);
var $e5b7e89a68d9c456$export$be5493f9613cbbe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("object");
var $e5b7e89a68d9c456$export$5486b676036981c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$be5493f9613cbbe([]);
var $e5b7e89a68d9c456$export$b2235297ee22a6fe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ol");
var $e5b7e89a68d9c456$export$ccd58f56d982d30 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b2235297ee22a6fe([]);
var $e5b7e89a68d9c456$export$b9d336f245a516e8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("optgroup");
var $e5b7e89a68d9c456$export$5e41220970d85779 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b9d336f245a516e8([]);
var $e5b7e89a68d9c456$export$a75d1723e6bda2ec = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("option");
var $e5b7e89a68d9c456$export$32e31af4e5fb3144 = /* #__PURE__ */ $e5b7e89a68d9c456$export$a75d1723e6bda2ec([]);
var $e5b7e89a68d9c456$export$c789db2c85949867 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("output");
var $e5b7e89a68d9c456$export$8874a395de964196 = /* #__PURE__ */ $e5b7e89a68d9c456$export$c789db2c85949867([]);
var $e5b7e89a68d9c456$export$ffb5f4729a158638 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("p");
var $e5b7e89a68d9c456$export$3950a0ab4293f4c0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$ffb5f4729a158638([]);
var $e5b7e89a68d9c456$export$6f7d1d9d04558207 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("param")(props)([]);
};
var $e5b7e89a68d9c456$export$2af2ac64526e2aa9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("pre");
var $e5b7e89a68d9c456$export$40eb7481a9b1d565 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2af2ac64526e2aa9([]);
var $e5b7e89a68d9c456$export$504d7abb21fa8c9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("progress");
var $e5b7e89a68d9c456$export$c56c869b2fd24a27 = /* #__PURE__ */ $e5b7e89a68d9c456$export$504d7abb21fa8c9([]);
var $e5b7e89a68d9c456$export$9e5f44173e64f162 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("q");
var $e5b7e89a68d9c456$export$cfeebac18d15c854 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9e5f44173e64f162([]);
var $e5b7e89a68d9c456$export$6d4c73e3ddf8818b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rp");
var $e5b7e89a68d9c456$export$16adec6ab929083f = /* #__PURE__ */ $e5b7e89a68d9c456$export$6d4c73e3ddf8818b([]);
var $e5b7e89a68d9c456$export$f08282231bb71285 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("rt");
var $e5b7e89a68d9c456$export$512c1f41f1ce606b = /* #__PURE__ */ $e5b7e89a68d9c456$export$f08282231bb71285([]);
var $e5b7e89a68d9c456$export$f2b283820b448b35 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ruby");
var $e5b7e89a68d9c456$export$8e70c3d96e82daa8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f2b283820b448b35([]);
var $e5b7e89a68d9c456$export$8c1cb8fb6818c292 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("samp");
var $e5b7e89a68d9c456$export$6d135438f4b2f058 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8c1cb8fb6818c292([]);
var $e5b7e89a68d9c456$export$bc237d627614fc48 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("script");
var $e5b7e89a68d9c456$export$dc29c33250ef6a12 = /* #__PURE__ */ $e5b7e89a68d9c456$export$bc237d627614fc48([]);
var $e5b7e89a68d9c456$export$fe2e36411d703b3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("section");
var $e5b7e89a68d9c456$export$23973f3de41ad862 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fe2e36411d703b3d([]);
var $e5b7e89a68d9c456$export$2e6c959c16ff56b8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("select");
var $e5b7e89a68d9c456$export$626530082bbb6846 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2e6c959c16ff56b8([]);
var $e5b7e89a68d9c456$export$3c17b0e969a90510 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("small");
var $e5b7e89a68d9c456$export$7c956911267b1bca = /* #__PURE__ */ $e5b7e89a68d9c456$export$3c17b0e969a90510([]);
var $e5b7e89a68d9c456$export$b4d5da5f34fb77ad = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("source")(props)([]);
};
var $e5b7e89a68d9c456$export$afc1bfabebaf28a2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("span");
var $e5b7e89a68d9c456$export$727654ffe296bd78 = /* #__PURE__ */ $e5b7e89a68d9c456$export$afc1bfabebaf28a2([]);
var $e5b7e89a68d9c456$export$59ae2c325a998f89 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("strong");
var $e5b7e89a68d9c456$export$e4a9f9f4befb34d3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$59ae2c325a998f89([]);
var $e5b7e89a68d9c456$export$1d567c320f4763bc = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("style");
var $e5b7e89a68d9c456$export$91f114121fd8ef96 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d567c320f4763bc([]);
var $e5b7e89a68d9c456$export$f93b5905241a7cca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sub");
var $e5b7e89a68d9c456$export$1b578d76e1a8b229 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f93b5905241a7cca([]);
var $e5b7e89a68d9c456$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("summary");
var $e5b7e89a68d9c456$export$2107ebccf1a0ff3d = /* #__PURE__ */ $e5b7e89a68d9c456$export$9a2dbef7a17e2e58([]);
var $e5b7e89a68d9c456$export$abe1cd54efe9b9cd = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("sup");
var $e5b7e89a68d9c456$export$2ed99a076908dcca = /* #__PURE__ */ $e5b7e89a68d9c456$export$abe1cd54efe9b9cd([]);
var $e5b7e89a68d9c456$export$9852986a3ec5f6a0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("table");
var $e5b7e89a68d9c456$export$67d0d859a50d84a3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9852986a3ec5f6a0([]);
var $e5b7e89a68d9c456$export$7cdd536eaa8f163c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tbody");
var $e5b7e89a68d9c456$export$a78509387f11524c = /* #__PURE__ */ $e5b7e89a68d9c456$export$7cdd536eaa8f163c([]);
var $e5b7e89a68d9c456$export$2beef8af2014e5c6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("td");
var $e5b7e89a68d9c456$export$bf83c8517c04b4f6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2beef8af2014e5c6([]);
var $e5b7e89a68d9c456$export$a3574df893ffa88d = function(es) {
    return $e5b7e89a68d9c456$export$8454457683f90105("textarea")(es)([]);
};
var $e5b7e89a68d9c456$export$9396b2f97a03ad14 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tfoot");
var $e5b7e89a68d9c456$export$7f741d66040a80c8 = /* #__PURE__ */ $e5b7e89a68d9c456$export$9396b2f97a03ad14([]);
var $e5b7e89a68d9c456$export$d657bc098992a431 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("th");
var $e5b7e89a68d9c456$export$5e18a33d145a9a4c = /* #__PURE__ */ $e5b7e89a68d9c456$export$d657bc098992a431([]);
var $e5b7e89a68d9c456$export$e3f32a5920890b82 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("thead");
var $e5b7e89a68d9c456$export$e607565248beba15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$e3f32a5920890b82([]);
var $e5b7e89a68d9c456$export$2da9be4cfdb689b1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("time");
var $e5b7e89a68d9c456$export$cf828072303f47a1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2da9be4cfdb689b1([]);
var $e5b7e89a68d9c456$export$fb184b623420d9be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("title");
var $e5b7e89a68d9c456$export$913d7d8b8f172930 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fb184b623420d9be([]);
var $e5b7e89a68d9c456$export$72451b88a72ad9c2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("tr");
var $e5b7e89a68d9c456$export$6645783692722b88 = /* #__PURE__ */ $e5b7e89a68d9c456$export$72451b88a72ad9c2([]);
var $e5b7e89a68d9c456$export$6b2a7d5132615086 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("track")(props)([]);
};
var $e5b7e89a68d9c456$export$3b14a55fb2447963 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("u");
var $e5b7e89a68d9c456$export$cea9ae7324478a0a = /* #__PURE__ */ $e5b7e89a68d9c456$export$3b14a55fb2447963([]);
var $e5b7e89a68d9c456$export$b5023c870cb34848 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("ul");
var $e5b7e89a68d9c456$export$995bef5d59d32608 = /* #__PURE__ */ $e5b7e89a68d9c456$export$b5023c870cb34848([]);
var $e5b7e89a68d9c456$export$4732baac96d948aa = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("var");
var $e5b7e89a68d9c456$export$f6567ad6eb928d58 = /* #__PURE__ */ $e5b7e89a68d9c456$export$4732baac96d948aa([]);
var $e5b7e89a68d9c456$export$5f8d3589eb8441ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("video");
var $e5b7e89a68d9c456$export$aeb4f4e4f36fb9d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$5f8d3589eb8441ca([]);
var $e5b7e89a68d9c456$export$ee8f8f9447a35bdc = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("wbr")(props)([]);
};
var $e5b7e89a68d9c456$export$9198f9466fc833e = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dt");
var $e5b7e89a68d9c456$export$eaec8774df2ce75c = /* #__PURE__ */ $e5b7e89a68d9c456$export$9198f9466fc833e([]);
var $e5b7e89a68d9c456$export$53d26b7a9a23d594 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dl");
var $e5b7e89a68d9c456$export$e8817a08353617fb = /* #__PURE__ */ $e5b7e89a68d9c456$export$53d26b7a9a23d594([]);
var $e5b7e89a68d9c456$export$159d9494db57879b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("div");
var $e5b7e89a68d9c456$export$3327f90baeaa2cb3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$159d9494db57879b([]);
var $e5b7e89a68d9c456$export$518824cf31321346 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dialog");
var $e5b7e89a68d9c456$export$95cd7f04cb5b4aa5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$518824cf31321346([]);
var $e5b7e89a68d9c456$export$771f54d1a902afc9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dfn");
var $e5b7e89a68d9c456$export$afe13c5e7d9b4a7 = /* #__PURE__ */ $e5b7e89a68d9c456$export$771f54d1a902afc9([]);
var $e5b7e89a68d9c456$export$41ee12f6f6f05843 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("details");
var $e5b7e89a68d9c456$export$a47bcbad56ffd401 = /* #__PURE__ */ $e5b7e89a68d9c456$export$41ee12f6f6f05843([]);
var $e5b7e89a68d9c456$export$1d2f21e549771e67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("del");
var $e5b7e89a68d9c456$export$965d9e1c56547986 = /* #__PURE__ */ $e5b7e89a68d9c456$export$1d2f21e549771e67([]);
var $e5b7e89a68d9c456$export$eaaeafa904fe3ddf = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("dd");
var $e5b7e89a68d9c456$export$333318a39958213e = /* #__PURE__ */ $e5b7e89a68d9c456$export$eaaeafa904fe3ddf([]);
var $e5b7e89a68d9c456$export$d6956b5f6d5ee87d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("datalist");
var $e5b7e89a68d9c456$export$4479caebc8699400 = /* #__PURE__ */ $e5b7e89a68d9c456$export$d6956b5f6d5ee87d([]);
var $e5b7e89a68d9c456$export$ae50443ffc990749 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("command")(props)([]);
};
var $e5b7e89a68d9c456$export$3db318dd257cd653 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("colgroup");
var $e5b7e89a68d9c456$export$4d89c25fc3dc3ce6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$3db318dd257cd653([]);
var $e5b7e89a68d9c456$export$aba86695643891f5 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("col")(props)([]);
};
var $e5b7e89a68d9c456$export$6565f9f03506010b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("code");
var $e5b7e89a68d9c456$export$a82e8ec18d45f1e3 = /* #__PURE__ */ $e5b7e89a68d9c456$export$6565f9f03506010b([]);
var $e5b7e89a68d9c456$export$3035df57df42c31a = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("cite");
var $e5b7e89a68d9c456$export$4371c8153c03edbd = /* #__PURE__ */ $e5b7e89a68d9c456$export$3035df57df42c31a([]);
var $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("caption");
var $e5b7e89a68d9c456$export$63f9754c9b1fac36 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8e3c2dfdc4f0453d([]);
var $e5b7e89a68d9c456$export$67ea982130081db = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("canvas")(props)([]);
};
var $e5b7e89a68d9c456$export$2ba01fb71ed41cb6 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("button");
var $e5b7e89a68d9c456$export$ff362f92cc25e36a = /* #__PURE__ */ $e5b7e89a68d9c456$export$2ba01fb71ed41cb6([]);
var $e5b7e89a68d9c456$export$479ac0420f53ed26 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("br")(props)([]);
};
var $e5b7e89a68d9c456$export$73cdcb65e5517a4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$479ac0420f53ed26([]);
var $e5b7e89a68d9c456$export$32180ef41b15b513 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("body");
var $e5b7e89a68d9c456$export$72fbd758d159fe4b = /* #__PURE__ */ $e5b7e89a68d9c456$export$32180ef41b15b513([]);
var $e5b7e89a68d9c456$export$67dc04e652a298ca = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("blockquote");
var $e5b7e89a68d9c456$export$3b176ffafe2ecb0b = /* #__PURE__ */ $e5b7e89a68d9c456$export$67dc04e652a298ca([]);
var $e5b7e89a68d9c456$export$fae0db89ef70aab2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdo");
var $e5b7e89a68d9c456$export$e57ac2b1cb1a62e1 = /* #__PURE__ */ $e5b7e89a68d9c456$export$fae0db89ef70aab2([]);
var $e5b7e89a68d9c456$export$2d20a4e9df674436 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("bdi");
var $e5b7e89a68d9c456$export$f5459c7588d93378 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2d20a4e9df674436([]);
var $e5b7e89a68d9c456$export$e2253033e6e1df16 = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("base")(props)([]);
};
var $e5b7e89a68d9c456$export$8b22cf2602fb60ce = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("b");
var $e5b7e89a68d9c456$export$c69d65aa55814164 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8b22cf2602fb60ce([]);
var $e5b7e89a68d9c456$export$592b77e6034db746 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("audio");
var $e5b7e89a68d9c456$export$610b618347792e57 = /* #__PURE__ */ $e5b7e89a68d9c456$export$592b77e6034db746([]);
var $e5b7e89a68d9c456$export$64a02cd6422b91be = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("aside");
var $e5b7e89a68d9c456$export$a3ab01131aa7ecca = /* #__PURE__ */ $e5b7e89a68d9c456$export$64a02cd6422b91be([]);
var $e5b7e89a68d9c456$export$bba2aacf8566461b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("article");
var $e5b7e89a68d9c456$export$1cb8fa25968bee4e = /* #__PURE__ */ $e5b7e89a68d9c456$export$bba2aacf8566461b([]);
var $e5b7e89a68d9c456$export$bb3edc44842b5f2e = function(props) {
    return $e5b7e89a68d9c456$export$8454457683f90105("area")(props)([]);
};
var $e5b7e89a68d9c456$export$f7d3c097ceca6c15 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("address");
var $e5b7e89a68d9c456$export$acfbe12b190f4a67 = /* #__PURE__ */ $e5b7e89a68d9c456$export$f7d3c097ceca6c15([]);
var $e5b7e89a68d9c456$export$2bcb785951133fe5 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("abbr");
var $e5b7e89a68d9c456$export$b4f279e367d2ba24 = /* #__PURE__ */ $e5b7e89a68d9c456$export$2bcb785951133fe5([]);
var $e5b7e89a68d9c456$export$407448d2b89b1813 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8454457683f90105("a");
var $e5b7e89a68d9c456$export$a17c37559e1db147 = /* #__PURE__ */ $e5b7e89a68d9c456$export$407448d2b89b1813([]);


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15






















var $94c2c7ff32ca5bd1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f9cd20a8b77a6bf5$export$537b40a6761b64a);
var $94c2c7ff32ca5bd1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($969bbf7e7aa55092$export$5158bce98a089317);
var $94c2c7ff32ca5bd1$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $94c2c7ff32ca5bd1$export$4a4574f653808a56 = function(x) {
    return x;
};
var $94c2c7ff32ca5bd1$export$eff4d24c3ff7876e = /* #__PURE__ */ function() {
    var go = function(p) {
        return function(mel) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $969bbf7e7aa55092$export$f4c20fd541e0bbe4(p, mel));
        };
    };
    return function($29) {
        return $c959b62ce0c19dfe$export$eff4d24c3ff7876e(go($29));
    };
}();
var $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6 = function(dictIsProp) {
    return $c959b62ce0c19dfe$export$977f3f6a9323c0f6(dictIsProp);
};
var $94c2c7ff32ca5bd1$var$prop1 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$4e3e21220a22c900);
var $94c2c7ff32ca5bd1$var$prop2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$32e0d8bef35d3088);
var $94c2c7ff32ca5bd1$var$prop3 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$4c390c75bcc39428);
var $94c2c7ff32ca5bd1$var$prop4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$6b61652c1897c1a);
var $94c2c7ff32ca5bd1$export$b2cbc93d4da94977 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("readOnly");
var $94c2c7ff32ca5bd1$export$bad408f43b005bc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("rel");
var $94c2c7ff32ca5bd1$export$a7a0278c004aac3f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("required");
var $94c2c7ff32ca5bd1$export$a5ce0649174d616e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rowSpan");
var $94c2c7ff32ca5bd1$export$2dd197b55cf13440 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("rows");
var $94c2c7ff32ca5bd1$export$5cff813ca8e50db9 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$cf79af8281015ccd)("scope");
var $94c2c7ff32ca5bd1$export$d90250155de6d7e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("selected");
var $94c2c7ff32ca5bd1$export$9ea87e299ff6a368 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("selectedIndex");
var $94c2c7ff32ca5bd1$export$afbe3196582d9f14 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("spellcheck");
var $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("src");
var $94c2c7ff32ca5bd1$export$1c5fb2289a93dd05 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("srcdoc");
var $94c2c7ff32ca5bd1$export$35d34bc0ed591a92 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$a77e3c7f90d13c3c)("step");
var $94c2c7ff32ca5bd1$export$9a625f9de50bf0b7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("tabIndex");
var $94c2c7ff32ca5bd1$export$44271b4f0c6a3563 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("target");
var $94c2c7ff32ca5bd1$export$fb184b623420d9be = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("title");
var $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("type");
};
var $94c2c7ff32ca5bd1$export$2ab9a8f9f1186f14 = function(dictIsProp) {
    return $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6(dictIsProp)("value");
};
var $94c2c7ff32ca5bd1$export$7e3df82ee760448c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("width");
var $94c2c7ff32ca5bd1$export$513ccb98c53b8039 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$1cf8b1fb41618835)("preload");
var $94c2c7ff32ca5bd1$export$b840e55573b2d2e7 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("poster");
var $94c2c7ff32ca5bd1$export$c7187bbd1a7a9244 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("placeholder");
var $94c2c7ff32ca5bd1$export$24f82734ea047e6f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("pattern");
var $94c2c7ff32ca5bd1$export$f50297589147f25e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("noValidate");
var $94c2c7ff32ca5bd1$export$18bca78ee4b12477 = {
    Coercible0: function() {
        return undefined;
    }
};
var $94c2c7ff32ca5bd1$export$a8ff84c12d48cfa6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("name");
var $94c2c7ff32ca5bd1$export$987a4e3838aef8c6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("muted");
var $94c2c7ff32ca5bd1$export$939ddaa3205df08e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("multiple");
var $94c2c7ff32ca5bd1$export$96ec731ed4dcb222 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("min");
var $94c2c7ff32ca5bd1$export$26f73335cc2e7868 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$efe5d718899194d9)("method");
var $94c2c7ff32ca5bd1$export$8960430cfd85939f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop4("max");
var $94c2c7ff32ca5bd1$export$f9ef67375ddc185 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("loop");
var $94c2c7ff32ca5bd1$export$d560c7e4a29451c2 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("id");
var $94c2c7ff32ca5bd1$export$8f51af5840e0602a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("href");
var $94c2c7ff32ca5bd1$export$ac607276a8fe9f0a = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("height");
var $94c2c7ff32ca5bd1$export$f268b02200c313cd = {
    map: function(f) {
        return function(m) {
            return $94c2c7ff32ca5bd1$var$map($94c2c7ff32ca5bd1$var$map1(f))(m);
        };
    }
};
var $94c2c7ff32ca5bd1$export$f89de2e5bf57e5e6 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("htmlFor");
var $94c2c7ff32ca5bd1$export$9f77e0932fb78f72 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $94c2c7ff32ca5bd1$export$9fc5d082ec250407 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$7bd1d02eb87275db)("enctype");
var $94c2c7ff32ca5bd1$export$c746a5152d4ba26c = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("draggable");
var $94c2c7ff32ca5bd1$export$24422be91ad4011f = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("download");
var $94c2c7ff32ca5bd1$export$683472f6198a076e = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("disabled");
var $94c2c7ff32ca5bd1$export$25eaa035e2e3a214 = /* #__PURE__ */ function() {
    var $30 = $f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f);
    return function($31) {
        return $94c2c7ff32ca5bd1$export$683472f6198a076e($30($31));
    };
}();
var $94c2c7ff32ca5bd1$export$cc1adf6fb659c762 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("controls");
var $94c2c7ff32ca5bd1$export$1eebcb1e706ab348 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("cols");
var $94c2c7ff32ca5bd1$export$47be69ffacd0da98 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop3("colSpan");
var $94c2c7ff32ca5bd1$export$188d75d71883854a = /* #__PURE__ */ function() {
    var $32 = $94c2c7ff32ca5bd1$var$prop2("className");
    var $33 = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ");
    var $34 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546)($94c2c7ff32ca5bd1$var$unwrap);
    return function($35) {
        return $32($33($34($35)));
    };
}();
var $94c2c7ff32ca5bd1$export$dbf49ecbc3d3d264 = /* #__PURE__ */ function() {
    var $36 = $94c2c7ff32ca5bd1$var$prop2("className");
    return function($37) {
        return $36($94c2c7ff32ca5bd1$var$unwrap($37));
    };
}();
var $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("checked");
var $94c2c7ff32ca5bd1$export$e4c823724462c3fd = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("charset");
var $94c2c7ff32ca5bd1$export$b243096046abd58 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autoplay");
var $94c2c7ff32ca5bd1$export$4c47992fc278c9a0 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop1("autofocus");
var $94c2c7ff32ca5bd1$export$485ded5f26ebe08d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$a538daf4c6392dcf)("autocomplete");
var $94c2c7ff32ca5bd1$export$3c95eba0a7ef85d = /* #__PURE__ */ function() {
    var $38 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
    return function($39) {
        return $c959b62ce0c19dfe$export$7aabe8b3a840d2fd($38($39));
    };
}();
var $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd = /* #__PURE__ */ function() {
    return $c959b62ce0c19dfe$export$7aabe8b3a840d2fd($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $94c2c7ff32ca5bd1$export$8837f4fc672e936d = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("list");
var $94c2c7ff32ca5bd1$export$1d567c320f4763bc = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("style");
var $94c2c7ff32ca5bd1$export$228be17d80722ab = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("alt");
var $94c2c7ff32ca5bd1$export$31eb53bd5b582a97 = /* #__PURE__ */ $94c2c7ff32ca5bd1$var$prop2("action");
var $94c2c7ff32ca5bd1$export$73f57eecff448cc8 = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$977f3f6a9323c0f6($c959b62ce0c19dfe$export$27dc712f9cde9a29)("accept");




var $9913c23e14d7f752$var$componentSlot = /* #__PURE__ */ $eea39ea934373596$export$f7e7e2efed606f4a();
var $9913c23e14d7f752$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $9913c23e14d7f752$export$76bf64fc47d1f9ce = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))));
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$103b78750979eead = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $9913c23e14d7f752$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return function(outputQuery) {
                                return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)(function($11) {
                                    return $06733ae99ed4f534$export$8a67b48435b5d073.create(outputQuery($11));
                                })));
                            };
                        };
                    };
                };
            };
        };
    };
};
var $9913c23e14d7f752$export$9756366f7cb6f62b = function(eqFn) {
    return function(f) {
        return $9913c23e14d7f752$var$map(function($12) {
            return $c959b62ce0c19dfe$export$f0c5cfb390964b78($eea39ea934373596$export$5e46cfa5e835a582.create($12));
        })($f1bf345cdb6c789d$export$6fa757c467a343e(eqFn)(f));
    };
};
var $9913c23e14d7f752$export$1590e93dfc8f2cb5 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$7f0ccf52046143dd(f, a, b, c)));
            };
        };
    };
};
var $9913c23e14d7f752$export$5a7f8ed0ed0de90f = function(f) {
    return function(a) {
        return function(b) {
            return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$8a29159161b2b8a6(f, a, b)));
        };
    };
};
var $9913c23e14d7f752$export$488013bae63b21da = function(f) {
    return function(a) {
        return $c959b62ce0c19dfe$export$f0c5cfb390964b78(new $eea39ea934373596$export$5e46cfa5e835a582($f1bf345cdb6c789d$export$c6666e7f0d2efc62(f, a)));
    };
};
var $9913c23e14d7f752$export$1fb0fe1b9ee1b1bf = $ac8b3532514ac019$export$401372c57776dc;



// Generated by purs version 0.15.15













var $2925bc950f7308d7$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($84222ab19bdc98bd$export$bf09f5de576f9cf1);
var $2925bc950f7308d7$var$queryAll = /* #__PURE__ */ $84222ab19bdc98bd$export$dcd0d083aa86c355();
var $2925bc950f7308d7$var$query = /* #__PURE__ */ $84222ab19bdc98bd$export$2fa187e846a241c4();
var $2925bc950f7308d7$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $2925bc950f7308d7$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $2925bc950f7308d7$export$786cec95229c2a31 = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return $2925bc950f7308d7$var$$$void(queryAll2(label)(req($05149ea687d6b460$export$523c0b569236b342)));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$de3113ed932c61ab = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return $2925bc950f7308d7$var$$$void(query2(slot)(label)(req($05149ea687d6b460$export$523c0b569236b342)));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$57331aaf6e3ff74d = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $2925bc950f7308d7$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return queryAll2(label)(req($2925bc950f7308d7$var$identity));
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$b5fe3f66a567bec0 = function() {
    return function(dictIsSymbol) {
        var query1 = $2925bc950f7308d7$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return query2(slot)(label)(req($2925bc950f7308d7$var$identity));
                    };
                };
            };
        };
    };
};
var $2925bc950f7308d7$export$a39c6a18d03be90d = function(act) {
    return act($05149ea687d6b460$export$523c0b569236b342);
};
var $2925bc950f7308d7$export$377703b067ff01a = function(req) {
    return req($2925bc950f7308d7$var$identity);
};
var $2925bc950f7308d7$export$bd6cf4e30aa8da47 = /* #__PURE__ */ function() {
    var $24 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($84222ab19bdc98bd$export$bf09f5de576f9cf1)(function(v) {
        return $2925bc950f7308d7$var$bindFlipped($5ae75883a0b7923c$export$c56654a6d0e3bd48)(v);
    });
    return function($25) {
        return $24($84222ab19bdc98bd$export$f0c653cfd7dea798($25));
    };
}();




// Generated by purs version 0.15.15
























// Generated by purs version 0.15.15







var $ef932f98609e5673$export$57f9bfb98da0e5b8 = function(x) {
    return x;
};
var $ef932f98609e5673$export$74fd2e01b52646ce = function(x) {
    return x;
};
var $ef932f98609e5673$export$b29cd3b133bc0fa4 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$b325883598264040 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$dcc8908fea536646 = function(dictApplicative) {
    var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return traverse_(f)(st.rendering);
        });
    };
};
var $ef932f98609e5673$var$mkRenderStateX = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$8a58ffe66c3bbb4d = function(dictFunctor) {
    return function(f) {
        return $ef932f98609e5673$export$b325883598264040(function(st) {
            return $ef932f98609e5673$var$mkRenderStateX(f(st.rendering));
        });
    };
};
var $ef932f98609e5673$export$52c65da2de355775 = $ac8b3532514ac019$export$401372c57776dc;
var $ef932f98609e5673$export$43ced40f2a8d1657 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $ef932f98609e5673$export$2999486de8d3a294 = function(component) {
    return function(input) {
        return function(handler) {
            return function(lchs) {
                return function __do() {
                    var selfRef = $90327512d8280b8d$export$b8cb59497041ffe4({})();
                    var childrenIn = $90327512d8280b8d$export$b8cb59497041ffe4($0f3b7f18059106fc$export$6e22c362a0406a2c)();
                    var childrenOut = $90327512d8280b8d$export$b8cb59497041ffe4($0f3b7f18059106fc$export$6e22c362a0406a2c)();
                    var handlerRef = $90327512d8280b8d$export$b8cb59497041ffe4(handler)();
                    var pendingQueries = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))();
                    var pendingOuts = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))();
                    var pendingHandlers = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
                    var fresh = $90327512d8280b8d$export$b8cb59497041ffe4(1)();
                    var subscriptions = $90327512d8280b8d$export$b8cb59497041ffe4(new $06733ae99ed4f534$export$8a67b48435b5d073($ea3eb84de0acf574$export$6e22c362a0406a2c))();
                    var forks = $90327512d8280b8d$export$b8cb59497041ffe4($ea3eb84de0acf574$export$6e22c362a0406a2c)();
                    var ds = {
                        component: component,
                        state: component.initialState(input),
                        refs: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                        children: $0f3b7f18059106fc$export$6e22c362a0406a2c,
                        childrenIn: childrenIn,
                        childrenOut: childrenOut,
                        selfRef: selfRef,
                        handlerRef: handlerRef,
                        pendingQueries: pendingQueries,
                        pendingOuts: pendingOuts,
                        pendingHandlers: pendingHandlers,
                        rendering: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                        fresh: fresh,
                        subscriptions: subscriptions,
                        forks: forks,
                        lifecycleHandlers: lchs
                    };
                    $e521936ea118867a$export$68d8715fc104d294(ds)(selfRef)();
                    return $ef932f98609e5673$export$52c65da2de355775(selfRef);
                };
            };
        };
    };
};








var $6bfb10b11a80fc8b$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $6bfb10b11a80fc8b$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $6bfb10b11a80fc8b$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($84222ab19bdc98bd$export$2a9fc99fce80131a);
var $6bfb10b11a80fc8b$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $6bfb10b11a80fc8b$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $6bfb10b11a80fc8b$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $6bfb10b11a80fc8b$var$discard1 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $6bfb10b11a80fc8b$var$traverse_1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($edf0339512807bee$export$9dc0454a98607988);
var $6bfb10b11a80fc8b$var$traverse_2 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($78c799cba34fcb8d$export$92659ee1fc91a075);
var $6bfb10b11a80fc8b$var$fork = /* #__PURE__ */ $3cc7d978c1d7ea03$export$7a5058c6b79333e0($3cc7d978c1d7ea03$export$353ec5b900391c5);
var $6bfb10b11a80fc8b$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $6bfb10b11a80fc8b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $6bfb10b11a80fc8b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($026fde5446dd624a$export$bd40aba71422b460);
var $6bfb10b11a80fc8b$var$parallel = /* #__PURE__ */ $86141680556a7436$export$451942af9381149c($edf0339512807bee$export$cb4623454f96d5e0);
var $6bfb10b11a80fc8b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $6bfb10b11a80fc8b$var$sequential = /* #__PURE__ */ $86141680556a7436$export$3c7b24ce1c81e349($edf0339512807bee$export$cb4623454f96d5e0);
var $6bfb10b11a80fc8b$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $6bfb10b11a80fc8b$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($84222ab19bdc98bd$export$2a9fc99fce80131a);
var $6bfb10b11a80fc8b$var$retractFreeAp = /* #__PURE__ */ $dc7ffeabd143829e$export$ab82a8987829bde0($edf0339512807bee$export$389e6cb252ce112f);
var $6bfb10b11a80fc8b$var$$$delete = /* #__PURE__ */ $ea3eb84de0acf574$export$1822828d790e23ee($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$unlessM = /* #__PURE__ */ $d3d065da31679be1$export$551dd5524146e426($6c2f8951ecf9531e$export$7e900d895707a1af);
var $6bfb10b11a80fc8b$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$traverse_3 = /* #__PURE__ */ $6bfb10b11a80fc8b$var$traverse_1($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $6bfb10b11a80fc8b$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($84222ab19bdc98bd$export$7e953d51c2b3343e);
var $6bfb10b11a80fc8b$var$lookup2 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6bfb10b11a80fc8b$var$foldFree = /* #__PURE__ */ $d0bd5a116d2d5f24$export$eb0e66a9104d4874($edf0339512807bee$export$974f8db4a62dd716);
var $6bfb10b11a80fc8b$var$alter = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6bfb10b11a80fc8b$var$unsubscribe = function(sid) {
    return function(ref) {
        return function __do() {
            var v = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
            var subs = $e521936ea118867a$export$aafa59e2e03f2942(v.subscriptions)();
            return $6bfb10b11a80fc8b$var$traverse_($8360250a454b77aa$export$f500693cef883ffd)($6bfb10b11a80fc8b$var$bindFlipped($6bfb10b11a80fc8b$var$lookup(sid))(subs))();
        };
    };
};
var $6bfb10b11a80fc8b$export$2d912d1764c6009b = function(ref) {
    return function(au) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return au;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(au, v.value0)))(ref));
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                v.constructor.name
            ]);
        });
    };
};
var $6bfb10b11a80fc8b$export$b7a8cef929df0d3c = function(lchs) {
    return function(f) {
        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294({
            initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            finalizers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
        })(lchs)))(function() {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect(f))(function(result) {
                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(lchs)))(function(v) {
                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_2($6bfb10b11a80fc8b$var$fork)(v.finalizers))(function() {
                        return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$parSequence_(v.initializers))(function() {
                            return $6bfb10b11a80fc8b$var$pure(result);
                        });
                    });
                });
            });
        });
    };
};
var $6bfb10b11a80fc8b$export$c4c41c035efd1fb3 = /* #__PURE__ */ $edf0339512807bee$export$ef62257e6f8a5f8c(/* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ad2cf6904bca3ba1$export$de0c4a986b439e52)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a)($05149ea687d6b460$export$523c0b569236b342))));
var $6bfb10b11a80fc8b$var$fresh = function(f) {
    return function(ref) {
        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
            return $6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$4d5401161a900ce1(function(i) {
                return {
                    state: i + 1 | 0,
                    value: f(i)
                };
            })(v.fresh));
        });
    };
};
var $6bfb10b11a80fc8b$export$f960635a4c7f8a61 = function(render) {
    return function(ref) {
        return function(q) {
            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v["component"]["eval"](new $43c0c9babefbb793$export$62297b13309008b2($6bfb10b11a80fc8b$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($026fde5446dd624a$export$6320c031d6b6270f(q)), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))));
            });
        };
    };
};
var $6bfb10b11a80fc8b$export$b505393bc8c03d39 = function(render) {
    return function(initRef) {
        return function(v) {
            var evalChildQuery = function(ref) {
                return function(cqb) {
                    return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v1) {
                        return $100f96dc727fa3bb$export$183d7a788d583d00(function(v2) {
                            var evalChild = function(v3) {
                                return $6bfb10b11a80fc8b$var$parallel($6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v3)))(function(dsx) {
                                    return $ef932f98609e5673$export$b325883598264040(function(ds) {
                                        return $6bfb10b11a80fc8b$export$f960635a4c7f8a61(render)(ds.selfRef)(v2.value1);
                                    })(dsx);
                                }));
                            };
                            return $6bfb10b11a80fc8b$var$map1(v2.value2)($6bfb10b11a80fc8b$var$sequential(v2.value0($edf0339512807bee$export$389e6cb252ce112f)(evalChild)(v1.children)));
                        })(cqb);
                    });
                };
            };
            var go = function(ref) {
                return function(v1) {
                    if (v1 instanceof $84222ab19bdc98bd$export$7254cc27399e90bd) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        var v3 = v1.value0(v2.state);
                        if ($871d3d7bcf6be72e$export$54d9901699893a6(v2.state)(v3.value1)) return $6bfb10b11a80fc8b$var$pure(v3.value0);
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$68d8715fc104d294({
                            component: v2.component,
                            refs: v2.refs,
                            children: v2.children,
                            childrenIn: v2.childrenIn,
                            childrenOut: v2.childrenOut,
                            selfRef: v2.selfRef,
                            handlerRef: v2.handlerRef,
                            pendingQueries: v2.pendingQueries,
                            pendingOuts: v2.pendingOuts,
                            pendingHandlers: v2.pendingHandlers,
                            rendering: v2.rendering,
                            fresh: v2.fresh,
                            subscriptions: v2.subscriptions,
                            forks: v2.forks,
                            lifecycleHandlers: v2.lifecycleHandlers,
                            state: v3.value1
                        })(ref)))(function() {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$b7a8cef929df0d3c(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v3.value0);
                            });
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                            v3.constructor.name
                        ]);
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$b5b6bb8bb5273115) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($84222ab19bdc98bd$export$f3ce0030ce21b322)(ref))(function(sid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($8360250a454b77aa$export$ec068583843480e7(v1.value0(sid))(function(act) {
                            return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($6bfb10b11a80fc8b$export$6533955444d826a5(render)(ref)(new $969bbf7e7aa55092$export$e19cd5f9376f8cee(act)));
                        })))(function(finalize) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                                return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$map2($6bfb10b11a80fc8b$var$insert(sid)(finalize)))(v2.subscriptions)))(function() {
                                    return $6bfb10b11a80fc8b$var$pure(v1.value1(sid));
                                });
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$cf424b9d16eab6b0) return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unsubscribe(v1.value0)(ref)))(function() {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1);
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$5ba9ac88cb4a4c17) return v1.value0;
                    if (v1 instanceof $84222ab19bdc98bd$export$c9e0c97aebb96176) return evalChildQuery(ref)(v1.value0);
                    if (v1 instanceof $84222ab19bdc98bd$export$c97bcbb53b4e15e4) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.handlerRef)))(function(handler) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$export$2d912d1764c6009b(v2.pendingOuts)(handler(v1.value0)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$6e7e621f508eff66) return $6bfb10b11a80fc8b$var$sequential($6bfb10b11a80fc8b$var$retractFreeAp($dc7ffeabd143829e$export$2a17b194dc6daf5e(function() {
                        var $119 = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref);
                        return function($120) {
                            return $6bfb10b11a80fc8b$var$parallel($119($120));
                        };
                    }())(v1.value0)));
                    if (v1 instanceof $84222ab19bdc98bd$export$8cdfc2927e464854) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fresh($84222ab19bdc98bd$export$77e8fa738093aa8c)(ref))(function(fid) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                            return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(doneRef) {
                                return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$fork($edf0339512807bee$export$7f8bd3bb7f01e042($6bfb10b11a80fc8b$var$liftEffect(function __do() {
                                    $90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$$$delete(fid))(v2.forks)();
                                    return $e521936ea118867a$export$68d8715fc104d294(true)(doneRef)();
                                }))($6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1.value0))))(function(fiber) {
                                    return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$liftEffect($6bfb10b11a80fc8b$var$unlessM($e521936ea118867a$export$aafa59e2e03f2942(doneRef))($90327512d8280b8d$export$45b91115a89d6020($6bfb10b11a80fc8b$var$insert1(fid)(fiber))(v2.forks))))(function() {
                                        return $6bfb10b11a80fc8b$var$pure(v1.value1(fid));
                                    });
                                });
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$26aa7833c998c5d3) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($edf0339512807bee$export$f3d782c2b95165ad)($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$25e269b2a286b4be) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(v2.forks)))(function(forkMap) {
                            return $6bfb10b11a80fc8b$var$discard1($6bfb10b11a80fc8b$var$traverse_3($edf0339512807bee$export$c65b2010df1810d($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Cancelled")))($6bfb10b11a80fc8b$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $6bfb10b11a80fc8b$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $84222ab19bdc98bd$export$c2ea277386f73da0) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v2) {
                        return $6bfb10b11a80fc8b$var$pure(v1.value1($6bfb10b11a80fc8b$var$lookup2(v1.value0)(v2.refs)));
                    });
                    throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $6bfb10b11a80fc8b$var$foldFree(go(initRef))(v);
        };
    };
};
var $6bfb10b11a80fc8b$export$6533955444d826a5 = function(render) {
    return function(ref) {
        return function(v) {
            if (v instanceof $969bbf7e7aa55092$export$f4c20fd541e0bbe4) return $6bfb10b11a80fc8b$var$liftEffect($f57f4b701aa7b66e$export$8a83211c878a3f1f($90327512d8280b8d$export$45b91115a89d6020)(ref)($ef932f98609e5673$export$43ced40f2a8d1657(function(st) {
                return {
                    component: st.component,
                    state: st.state,
                    children: st.children,
                    childrenIn: st.childrenIn,
                    childrenOut: st.childrenOut,
                    selfRef: st.selfRef,
                    handlerRef: st.handlerRef,
                    pendingQueries: st.pendingQueries,
                    pendingOuts: st.pendingOuts,
                    pendingHandlers: st.pendingHandlers,
                    rendering: st.rendering,
                    fresh: st.fresh,
                    subscriptions: st.subscriptions,
                    forks: st.forks,
                    lifecycleHandlers: st.lifecycleHandlers,
                    refs: $6bfb10b11a80fc8b$var$alter($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v.value1))(v.value0)(st.refs)
                };
            })));
            if (v instanceof $969bbf7e7aa55092$export$e19cd5f9376f8cee) return $6bfb10b11a80fc8b$var$bind1($6bfb10b11a80fc8b$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(function(v1) {
                return $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(ref)(v1["component"]["eval"](new $43c0c9babefbb793$export$e19cd5f9376f8cee(v.value0, $05149ea687d6b460$export$523c0b569236b342)));
            });
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                v.constructor.name
            ]);
        };
    };
};








var $f469b52d7c3c8200$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f469b52d7c3c8200$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $f469b52d7c3c8200$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $f469b52d7c3c8200$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($edf0339512807bee$export$9dc0454a98607988)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f469b52d7c3c8200$var$fork = /* #__PURE__ */ $3cc7d978c1d7ea03$export$7a5058c6b79333e0($3cc7d978c1d7ea03$export$353ec5b900391c5);
var $f469b52d7c3c8200$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f469b52d7c3c8200$var$traverse_1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$traverse_2 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $f469b52d7c3c8200$var$traverse_3 = /* #__PURE__ */ $f469b52d7c3c8200$var$traverse_1($ea3eb84de0acf574$export$4295a0c2ad7aa544);
var $f469b52d7c3c8200$var$discard2 = /* #__PURE__ */ $f469b52d7c3c8200$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $f469b52d7c3c8200$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f469b52d7c3c8200$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $f469b52d7c3c8200$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $f469b52d7c3c8200$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$renderStateX = /* #__PURE__ */ $ef932f98609e5673$export$8a58ffe66c3bbb4d($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $f469b52d7c3c8200$var$foreachSlot = /* #__PURE__ */ $0f3b7f18059106fc$export$91dbfdfb14db6990($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$renderStateX_ = /* #__PURE__ */ $ef932f98609e5673$export$dcc8908fea536646($6c2f8951ecf9531e$export$89bf999217d3022a);
var $f469b52d7c3c8200$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($f93520de2fa37b44$export$c2472dc015e90d28);
var $f469b52d7c3c8200$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f469b52d7c3c8200$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $f469b52d7c3c8200$var$liftEffect1 = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $f469b52d7c3c8200$var$newLifecycleHandlers = /* #__PURE__ */ function() {
    return $90327512d8280b8d$export$b8cb59497041ffe4({
        initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        finalizers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
    });
}();
var $f469b52d7c3c8200$var$handlePending = function(ref) {
    return function __do() {
        var queue = $e521936ea118867a$export$aafa59e2e03f2942(ref)();
        $e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(ref)();
        return $f469b52d7c3c8200$var$for_(queue)(function() {
            var $59 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
            return function($60) {
                return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($59($3d4fd987da5242ff$export$66c1ae025e96b4bc($60)));
            };
        }())();
    };
};
var $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks = function(v) {
    return function __do() {
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_2($f469b52d7c3c8200$var$traverse_3($8360250a454b77aa$export$f500693cef883ffd)))($e521936ea118867a$export$aafa59e2e03f2942(v.subscriptions))();
        $e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.subscriptions)();
        $f469b52d7c3c8200$var$bindFlipped($f469b52d7c3c8200$var$traverse_3(function() {
            var $61 = $edf0339512807bee$export$c65b2010df1810d($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("finalized"));
            return function($62) {
                return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($61($62));
            };
        }()))($e521936ea118867a$export$aafa59e2e03f2942(v.forks))();
        return $e521936ea118867a$export$68d8715fc104d294($ea3eb84de0acf574$export$6e22c362a0406a2c)(v.forks)();
    };
};
var $f469b52d7c3c8200$export$32d31a833a940d1c = function(renderSpec) {
    return function(component) {
        return function(i) {
            var squashChildInitializers = function(lchs) {
                return function(preInits) {
                    return $ef932f98609e5673$export$b325883598264040(function(st) {
                        var parentInitializer = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$b03b1c699c90a9b4($05149ea687d6b460$export$523c0b569236b342)));
                        return $90327512d8280b8d$export$45b91115a89d6020(function(handlers) {
                            return {
                                initializers: new $78c799cba34fcb8d$export$74c44e616647f5c0($f469b52d7c3c8200$var$discard2($f469b52d7c3c8200$var$parSequence_($3d4fd987da5242ff$export$66c1ae025e96b4bc(handlers.initializers)))(function() {
                                    return $f469b52d7c3c8200$var$discard2(parentInitializer)(function() {
                                        return $f469b52d7c3c8200$var$liftEffect(function __do() {
                                            $f469b52d7c3c8200$var$handlePending(st.pendingQueries)();
                                            return $f469b52d7c3c8200$var$handlePending(st.pendingOuts)();
                                        });
                                    });
                                }), preInits),
                                finalizers: handlers.finalizers
                            };
                        })(lchs);
                    });
                };
            };
            var runComponent = function(lchs) {
                return function(handler) {
                    return function(j) {
                        return $eea39ea934373596$export$802c6b8ce0f42195(function(c) {
                            return function __do() {
                                var lchs$prime = $f469b52d7c3c8200$var$newLifecycleHandlers();
                                var $$var = $ef932f98609e5673$export$2999486de8d3a294(c)(j)(handler)(lchs$prime)();
                                var pre = $e521936ea118867a$export$aafa59e2e03f2942(lchs)();
                                $e521936ea118867a$export$68d8715fc104d294({
                                    initializers: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                                    finalizers: pre.finalizers
                                })(lchs)();
                                $f469b52d7c3c8200$var$bindFlipped($ef932f98609e5673$export$b325883598264040(function() {
                                    var $63 = render(lchs);
                                    return function($64) {
                                        return $63(function(v) {
                                            return v.selfRef;
                                        }($64));
                                    };
                                }()))($e521936ea118867a$export$aafa59e2e03f2942($$var))();
                                $f469b52d7c3c8200$var$bindFlipped(squashChildInitializers(lchs)(pre.initializers))($e521936ea118867a$export$aafa59e2e03f2942($$var))();
                                return $$var;
                            };
                        });
                    };
                };
            };
            var renderChild = function(lchs) {
                return function(handler) {
                    return function(childrenInRef) {
                        return function(childrenOutRef) {
                            return $eea39ea934373596$export$48f0293959eb16ec(function(slot) {
                                return function __do() {
                                    var childrenIn = $f469b52d7c3c8200$var$map(slot.pop)($e521936ea118867a$export$aafa59e2e03f2942(childrenInRef))();
                                    var $$var = function() {
                                        if (childrenIn instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                            $e521936ea118867a$export$68d8715fc104d294(childrenIn.value0.value1)(childrenInRef)();
                                            var dsx = $e521936ea118867a$export$aafa59e2e03f2942(childrenIn.value0.value0)();
                                            $ef932f98609e5673$export$b325883598264040(function(st) {
                                                return function __do() {
                                                    $f57f4b701aa7b66e$export$8a83211c878a3f1f($e521936ea118867a$export$68d8715fc104d294)(st.handlerRef)(function() {
                                                        var $65 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f469b52d7c3c8200$var$pure1($05149ea687d6b460$export$523c0b569236b342))(handler);
                                                        return function($66) {
                                                            return $65(slot.output($66));
                                                        };
                                                    }())();
                                                    return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$fc713a64b8ca1b7a(slot.input, $05149ea687d6b460$export$523c0b569236b342))))();
                                                };
                                            })(dsx)();
                                            return childrenIn.value0.value0;
                                        }
                                        if (childrenIn instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return runComponent(lchs)(function() {
                                            var $67 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f469b52d7c3c8200$var$pure1($05149ea687d6b460$export$523c0b569236b342))(handler);
                                            return function($68) {
                                                return $67(slot.output($68));
                                            };
                                        }())(slot.input)(slot.component)();
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                            childrenIn.constructor.name
                                        ]);
                                    }();
                                    var isDuplicate = $f469b52d7c3c8200$var$map(function($69) {
                                        return $06733ae99ed4f534$export$c15bd07a493e1236(slot.get($69));
                                    })($e521936ea118867a$export$aafa59e2e03f2942(childrenOutRef))();
                                    $f469b52d7c3c8200$var$when(isDuplicate)($93c729927fdf3160$export$c106dd0671a0fc2d("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                    $90327512d8280b8d$export$45b91115a89d6020(slot.set($$var))(childrenOutRef)();
                                    return $f469b52d7c3c8200$var$bind($e521936ea118867a$export$aafa59e2e03f2942($$var))($f469b52d7c3c8200$var$renderStateX(function(v) {
                                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4e52402d7134c8bb$export$7b1a37e4f0fe815("Halogen internal error: child was not initialized in renderChild");
                                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f469b52d7c3c8200$var$pure(renderSpec.renderChild(v.value0));
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                            v.constructor.name
                                        ]);
                                    }))();
                                };
                            });
                        };
                    };
                };
            };
            var render = function(lchs) {
                return function($$var) {
                    return function __do() {
                        var v = $e521936ea118867a$export$aafa59e2e03f2942($$var)();
                        var shouldProcessHandlers = $f469b52d7c3c8200$var$map($06733ae99ed4f534$export$4967676db1b89293)($e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers))();
                        $f469b52d7c3c8200$var$when(shouldProcessHandlers)($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))(v.pendingHandlers))();
                        $e521936ea118867a$export$68d8715fc104d294($0f3b7f18059106fc$export$6e22c362a0406a2c)(v.childrenOut)();
                        $e521936ea118867a$export$68d8715fc104d294(v.children)(v.childrenIn)();
                        var handler = function() {
                            var $70 = $6bfb10b11a80fc8b$export$2d912d1764c6009b(v.pendingHandlers);
                            var $71 = $6bfb10b11a80fc8b$export$6533955444d826a5(render)(v.selfRef);
                            return function($72) {
                                return $70($f469b52d7c3c8200$var$$$void($71($72)));
                            };
                        }();
                        var childHandler = function() {
                            var $73 = $6bfb10b11a80fc8b$export$2d912d1764c6009b(v.pendingQueries);
                            return function($74) {
                                return $73(handler($969bbf7e7aa55092$export$e19cd5f9376f8cee.create($74)));
                            };
                        }();
                        var rendering = renderSpec.render(function($75) {
                            return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3(handler($75));
                        })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                        var children = $e521936ea118867a$export$aafa59e2e03f2942(v.childrenOut)();
                        var childrenIn = $e521936ea118867a$export$aafa59e2e03f2942(v.childrenIn)();
                        $f469b52d7c3c8200$var$foreachSlot(childrenIn)(function(v1) {
                            return function __do() {
                                var childDS = $e521936ea118867a$export$aafa59e2e03f2942(v1)();
                                $f469b52d7c3c8200$var$renderStateX_(renderSpec.removeChild)(childDS)();
                                return finalize(lchs)(childDS)();
                            };
                        })();
                        $f57f4b701aa7b66e$export$8a83211c878a3f1f($90327512d8280b8d$export$45b91115a89d6020)(v.selfRef)($ef932f98609e5673$export$43ced40f2a8d1657(function(ds$prime) {
                            return {
                                component: ds$prime.component,
                                state: ds$prime.state,
                                refs: ds$prime.refs,
                                childrenIn: ds$prime.childrenIn,
                                childrenOut: ds$prime.childrenOut,
                                selfRef: ds$prime.selfRef,
                                handlerRef: ds$prime.handlerRef,
                                pendingQueries: ds$prime.pendingQueries,
                                pendingOuts: ds$prime.pendingOuts,
                                pendingHandlers: ds$prime.pendingHandlers,
                                fresh: ds$prime.fresh,
                                subscriptions: ds$prime.subscriptions,
                                forks: ds$prime.forks,
                                lifecycleHandlers: ds$prime.lifecycleHandlers,
                                rendering: new $06733ae99ed4f534$export$8a67b48435b5d073(rendering),
                                children: children
                            };
                        }))();
                        return $f469b52d7c3c8200$var$when(shouldProcessHandlers)($f57f4b701aa7b66e$export$8a83211c878a3f1f($f469b52d7c3c8200$var$tailRecM)($05149ea687d6b460$export$523c0b569236b342)(function(v1) {
                            return function __do() {
                                var handlers = $e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers)();
                                $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073($78c799cba34fcb8d$export$c1bed610ade55e1c.value))(v.pendingHandlers)();
                                $f469b52d7c3c8200$var$traverse_2(function() {
                                    var $76 = $f469b52d7c3c8200$var$traverse_($f469b52d7c3c8200$var$fork);
                                    return function($77) {
                                        return $6bfb10b11a80fc8b$export$c4c41c035efd1fb3($76($3d4fd987da5242ff$export$66c1ae025e96b4bc($77)));
                                    };
                                }())(handlers)();
                                var mmore = $e521936ea118867a$export$aafa59e2e03f2942(v.pendingHandlers)();
                                var $52 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)($3d4fd987da5242ff$export$7b1b591b262c240)(mmore);
                                if ($52) return $f469b52d7c3c8200$var$voidLeft($e521936ea118867a$export$68d8715fc104d294($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.pendingHandlers))(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342))();
                                return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                            };
                        }))();
                    };
                };
            };
            var finalize = function(lchs) {
                return $ef932f98609e5673$export$b325883598264040(function(st) {
                    return function __do() {
                        $f469b52d7c3c8200$var$cleanupSubscriptionsAndForks(st)();
                        var f = $6bfb10b11a80fc8b$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $43c0c9babefbb793$export$29defdae7b3f3a01($05149ea687d6b460$export$523c0b569236b342)));
                        $90327512d8280b8d$export$45b91115a89d6020(function(handlers) {
                            return {
                                initializers: handlers.initializers,
                                finalizers: new $78c799cba34fcb8d$export$74c44e616647f5c0(f, handlers.finalizers)
                            };
                        })(lchs)();
                        return $f469b52d7c3c8200$var$foreachSlot(st.children)(function(v) {
                            return function __do() {
                                var dsx = $e521936ea118867a$export$aafa59e2e03f2942(v)();
                                return finalize(lchs)(dsx)();
                            };
                        })();
                    };
                });
            };
            var evalDriver = function(disposed) {
                return function(ref) {
                    return function(q) {
                        return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($e521936ea118867a$export$aafa59e2e03f2942(disposed)))(function(v) {
                            if (v) return $f469b52d7c3c8200$var$pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
                            return $6bfb10b11a80fc8b$export$f960635a4c7f8a61(render)(ref)(q);
                        });
                    };
                };
            };
            var dispose = function(disposed) {
                return function(lchs) {
                    return function(dsx) {
                        return $6bfb10b11a80fc8b$export$b7a8cef929df0d3c(lchs)(function __do() {
                            var v = $e521936ea118867a$export$aafa59e2e03f2942(disposed)();
                            if (v) return $05149ea687d6b460$export$523c0b569236b342;
                            $e521936ea118867a$export$68d8715fc104d294(true)(disposed)();
                            finalize(lchs)(dsx)();
                            return $ef932f98609e5673$export$b325883598264040(function(v1) {
                                return function __do() {
                                    var v2 = $f469b52d7c3c8200$var$liftEffect1($e521936ea118867a$export$aafa59e2e03f2942(v1.selfRef))();
                                    return $f469b52d7c3c8200$var$for_(v2.rendering)(renderSpec.dispose)();
                                };
                            })(dsx)();
                        });
                    };
                };
            };
            return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($f469b52d7c3c8200$var$newLifecycleHandlers))(function(lchs) {
                return $f469b52d7c3c8200$var$bind1($f469b52d7c3c8200$var$liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(disposed) {
                    return $6bfb10b11a80fc8b$export$b7a8cef929df0d3c(lchs)(function __do() {
                        var sio = $8360250a454b77aa$export$185802fd694ee1f5();
                        var dsx = $f469b52d7c3c8200$var$bindFlipped($e521936ea118867a$export$aafa59e2e03f2942)(runComponent(lchs)(function() {
                            var $78 = $8360250a454b77aa$export$5e14cdade93d6f7b(sio.listener);
                            return function($79) {
                                return $f469b52d7c3c8200$var$liftEffect($78($79));
                            };
                        }())(i)(component))();
                        return $ef932f98609e5673$export$b325883598264040(function(st) {
                            return $f469b52d7c3c8200$var$pure({
                                query: evalDriver(disposed)(st.selfRef),
                                messages: sio.emitter,
                                dispose: dispose(disposed)(lchs)(dsx)
                            });
                        })(dsx)();
                    });
                });
            });
        };
    };
};









// Generated by purs version 0.15.15
var $9c38b931c8b22574$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
function $9c38b931c8b22574$export$c441300b2d51b958(node) {
    return node.nodeType;
}
function $9c38b931c8b22574$export$860bddf988a8498c(node) {
    return node.nodeName;
}
const $9c38b931c8b22574$export$74061d4f476da680 = $9c38b931c8b22574$var$getEffProp("baseURI");
const $9c38b931c8b22574$export$23cc1b2a9bb6c61a = $9c38b931c8b22574$var$getEffProp("ownerDocument");
const $9c38b931c8b22574$export$72030ded560177b6 = $9c38b931c8b22574$var$getEffProp("parentNode");
const $9c38b931c8b22574$export$e8e77848f4a9ad40 = $9c38b931c8b22574$var$getEffProp("parentElement");
function $9c38b931c8b22574$export$13782f450ac5e09a(node) {
    return function() {
        return node.hasChildNodes();
    };
}
const $9c38b931c8b22574$export$c9fa23d9ff60a2d1 = $9c38b931c8b22574$var$getEffProp("childNodes");
const $9c38b931c8b22574$export$274e0d97326033db = $9c38b931c8b22574$var$getEffProp("firstChild");
const $9c38b931c8b22574$export$951f870fb0fe03c3 = $9c38b931c8b22574$var$getEffProp("lastChild");
const $9c38b931c8b22574$export$e2e6c080f0f2a76d = $9c38b931c8b22574$var$getEffProp("previousSibling");
const $9c38b931c8b22574$export$2eda4366e9b7c29f = $9c38b931c8b22574$var$getEffProp("nextSibling");
const $9c38b931c8b22574$export$d6cd495109f5e655 = $9c38b931c8b22574$var$getEffProp("nodeValue");
function $9c38b931c8b22574$export$df6212ebae08b450(value) {
    return function(node) {
        return function() {
            node.nodeValue = value;
        };
    };
}
const $9c38b931c8b22574$export$e0e0794250e9118f = $9c38b931c8b22574$var$getEffProp("textContent");
function $9c38b931c8b22574$export$94b0296cab6203e(value) {
    return function(node) {
        return function() {
            node.textContent = value;
        };
    };
}
function $9c38b931c8b22574$export$a3295358bff77e(node) {
    return function() {
        node.normalize();
    };
}
function $9c38b931c8b22574$export$9cd59f9826255e47(node) {
    return function() {
        return node.cloneNode(false);
    };
}
function $9c38b931c8b22574$export$b7d58db314e0ac27(node) {
    return function() {
        return node.cloneNode(true);
    };
}
function $9c38b931c8b22574$export$55e9b4d3368d84dd(node1) {
    return function(node2) {
        return function() {
            return node1.isEqualNode(node2);
        };
    };
}
function $9c38b931c8b22574$export$aff35b31398d5fba(node1) {
    return function(node2) {
        return function() {
            return node1.compareDocumentPosition(node2);
        };
    };
}
function $9c38b931c8b22574$export$2344b14b097df817(node1) {
    return function(node2) {
        return function() {
            return node1.contains(node2);
        };
    };
}
function $9c38b931c8b22574$export$b9a4e863f082a036(prefix) {
    return function(node) {
        return function() {
            return node.lookupPrefix(prefix);
        };
    };
}
function $9c38b931c8b22574$export$a79c57bed1c08193(ns) {
    return function(node) {
        return function() {
            return node.lookupNamespaceURI(ns);
        };
    };
}
function $9c38b931c8b22574$export$61f41c073d810e4f(ns) {
    return function(node) {
        return function() {
            return node.isDefaultNamespace(ns);
        };
    };
}
function $9c38b931c8b22574$export$86b68c7dbeb53c22(node1) {
    return function(node2) {
        return function(parent) {
            return function() {
                parent.insertBefore(node1, node2);
            };
        };
    };
}
function $9c38b931c8b22574$export$1b8e57c9ea42f1d2(node) {
    return function(parent) {
        return function() {
            parent.appendChild(node);
        };
    };
}
function $9c38b931c8b22574$export$46f78da0e790aab7(newChild) {
    return function(oldChild) {
        return function(parent) {
            return function() {
                parent.replaceChild(newChild, oldChild);
            };
        };
    };
}
function $9c38b931c8b22574$export$7ae609f7af59e4f7(node) {
    return function(parent) {
        return function() {
            parent.removeChild(node);
        };
    };
}









// Generated by purs version 0.15.15



var $aa7bef674fe53e14$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $aa7bef674fe53e14$export$dc064fe9e59310fd = /* #__PURE__ */ function() {
    function ElementNode() {}
    ElementNode.value = new ElementNode();
    return ElementNode;
}();
var $aa7bef674fe53e14$export$dc88047a888cd46b = /* #__PURE__ */ function() {
    function AttributeNode() {}
    AttributeNode.value = new AttributeNode();
    return AttributeNode;
}();
var $aa7bef674fe53e14$export$f0a25ea3087686aa = /* #__PURE__ */ function() {
    function TextNode() {}
    TextNode.value = new TextNode();
    return TextNode;
}();
var $aa7bef674fe53e14$export$28835d60136fdd55 = /* #__PURE__ */ function() {
    function CDATASectionNode() {}
    CDATASectionNode.value = new CDATASectionNode();
    return CDATASectionNode;
}();
var $aa7bef674fe53e14$export$a4de1a63043e7a6d = /* #__PURE__ */ function() {
    function EntityReferenceNode() {}
    EntityReferenceNode.value = new EntityReferenceNode();
    return EntityReferenceNode;
}();
var $aa7bef674fe53e14$export$34dac3329b92804f = /* #__PURE__ */ function() {
    function EntityNode() {}
    EntityNode.value = new EntityNode();
    return EntityNode;
}();
var $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 = /* #__PURE__ */ function() {
    function ProcessingInstructionNode() {}
    ProcessingInstructionNode.value = new ProcessingInstructionNode();
    return ProcessingInstructionNode;
}();
var $aa7bef674fe53e14$export$dd3132c03c97153e = /* #__PURE__ */ function() {
    function CommentNode() {}
    CommentNode.value = new CommentNode();
    return CommentNode;
}();
var $aa7bef674fe53e14$export$9da34d55490083d8 = /* #__PURE__ */ function() {
    function DocumentNode() {}
    DocumentNode.value = new DocumentNode();
    return DocumentNode;
}();
var $aa7bef674fe53e14$export$c4edab6ab3262a44 = /* #__PURE__ */ function() {
    function DocumentTypeNode() {}
    DocumentTypeNode.value = new DocumentTypeNode();
    return DocumentTypeNode;
}();
var $aa7bef674fe53e14$export$ed75c007fb9b19c0 = /* #__PURE__ */ function() {
    function DocumentFragmentNode() {}
    DocumentFragmentNode.value = new DocumentFragmentNode();
    return DocumentFragmentNode;
}();
var $aa7bef674fe53e14$export$71dc25271abd047 = /* #__PURE__ */ function() {
    function NotationNode() {}
    NotationNode.value = new NotationNode();
    return NotationNode;
}();
var $aa7bef674fe53e14$var$toEnumNodeType = function(v) {
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc064fe9e59310fd.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc88047a888cd46b.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$f0a25ea3087686aa.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$28835d60136fdd55.value);
    if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$a4de1a63043e7a6d.value);
    if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$34dac3329b92804f.value);
    if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$2458c2a2a9d8a0a8.value);
    if (v === 8) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dd3132c03c97153e.value);
    if (v === 9) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$9da34d55490083d8.value);
    if (v === 10) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$c4edab6ab3262a44.value);
    if (v === 11) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$ed75c007fb9b19c0.value);
    if (v === 12) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$71dc25271abd047.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $aa7bef674fe53e14$export$eb0d4895a3e15732 = {
    show: function(v) {
        if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return "ElementNode";
        if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return "AttributeNode";
        if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return "TextNode";
        if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return "CDATASectionNode";
        if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return "EntityReferenceNode";
        if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return "EntityNode";
        if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return "ProcessingInstructionNode";
        if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return "CommentNode";
        if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return "DocumentNode";
        if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return "DocumentTypeNode";
        if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return "DocumentFragmentNode";
        if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return "NotationNode";
        throw new Error("Failed pattern match at Web.DOM.NodeType (line 39, column 1 - line 51, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $aa7bef674fe53e14$var$fromEnumNodeType = function(v) {
    if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return 1;
    if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return 2;
    if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return 3;
    if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return 4;
    if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return 5;
    if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return 6;
    if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return 7;
    if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return 8;
    if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return 9;
    if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return 10;
    if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return 11;
    if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return 12;
    throw new Error("Failed pattern match at Web.DOM.NodeType (line 68, column 1 - line 68, column 36): " + [
        v.constructor.name
    ]);
};
var $aa7bef674fe53e14$export$88377e09539feb78 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd && y instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return true;
            if (x instanceof $aa7bef674fe53e14$export$dc88047a888cd46b && y instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return true;
            if (x instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa && y instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return true;
            if (x instanceof $aa7bef674fe53e14$export$28835d60136fdd55 && y instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return true;
            if (x instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d && y instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return true;
            if (x instanceof $aa7bef674fe53e14$export$34dac3329b92804f && y instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return true;
            if (x instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 && y instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return true;
            if (x instanceof $aa7bef674fe53e14$export$dd3132c03c97153e && y instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return true;
            if (x instanceof $aa7bef674fe53e14$export$9da34d55490083d8 && y instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return true;
            if (x instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44 && y instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return true;
            if (x instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0 && y instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return true;
            if (x instanceof $aa7bef674fe53e14$export$71dc25271abd047 && y instanceof $aa7bef674fe53e14$export$71dc25271abd047) return true;
            return false;
        };
    }
};
var $aa7bef674fe53e14$export$98741689c6e0b987 = {
    compare: function(x) {
        return function(y) {
            return $aa7bef674fe53e14$var$compare($aa7bef674fe53e14$var$fromEnumNodeType(x))($aa7bef674fe53e14$var$fromEnumNodeType(y));
        };
    },
    Eq0: function() {
        return $aa7bef674fe53e14$export$88377e09539feb78;
    }
};
var $aa7bef674fe53e14$export$61b56a5f9f6230cb = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    Ord0: function() {
        return $aa7bef674fe53e14$export$98741689c6e0b987;
    }
};
var $aa7bef674fe53e14$export$5879f3f4738185fd = /* #__PURE__ */ function() {
    return {
        bottom: $aa7bef674fe53e14$export$dc064fe9e59310fd.value,
        top: $aa7bef674fe53e14$export$71dc25271abd047.value,
        Ord0: function() {
            return $aa7bef674fe53e14$export$98741689c6e0b987;
        }
    };
}();
var $aa7bef674fe53e14$export$db18e9bcd7fea75b = {
    cardinality: 12,
    toEnum: $aa7bef674fe53e14$var$toEnumNodeType,
    fromEnum: $aa7bef674fe53e14$var$fromEnumNodeType,
    Bounded0: function() {
        return $aa7bef674fe53e14$export$5879f3f4738185fd;
    },
    Enum1: function() {
        return $aa7bef674fe53e14$export$61b56a5f9f6230cb;
    }
};



var $43db1f7c9150eb00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $43db1f7c9150eb00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $43db1f7c9150eb00$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($aa7bef674fe53e14$export$db18e9bcd7fea75b);
var $43db1f7c9150eb00$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $43db1f7c9150eb00$export$6c33a601ef71fce7 = /* #__PURE__ */ function() {
    var $4 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($9c38b931c8b22574$export$e2e6c080f0f2a76d($5));
    };
}();
var $43db1f7c9150eb00$export$b54be7ce267a037b = /* #__PURE__ */ function() {
    var $6 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($9c38b931c8b22574$export$72030ded560177b6($7));
    };
}();
var $43db1f7c9150eb00$export$222ab8a52715b4f4 = /* #__PURE__ */ function() {
    var $8 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($9) {
        return $8($9c38b931c8b22574$export$e8e77848f4a9ad40($9));
    };
}();
var $43db1f7c9150eb00$export$512a1115db01100d = /* #__PURE__ */ function() {
    var $10 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($9c38b931c8b22574$export$23cc1b2a9bb6c61a($11));
    };
}();
var $43db1f7c9150eb00$export$63bfedaececbd5f5 = /* #__PURE__ */ function() {
    var $12 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($13) {
        return $12($9c38b931c8b22574$export$d6cd495109f5e655($13));
    };
}();
var $43db1f7c9150eb00$export$4debbe1037afe35e = function() {
    return function($14) {
        return $43db1f7c9150eb00$var$fromJust($43db1f7c9150eb00$var$toEnum($9c38b931c8b22574$export$c441300b2d51b958($14)));
    };
};
var $43db1f7c9150eb00$export$335219007e689d29 = /* #__PURE__ */ function() {
    var $15 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($16) {
        return $15($9c38b931c8b22574$export$2eda4366e9b7c29f($16));
    };
}();
var $43db1f7c9150eb00$export$20ad2ac0440a470d = function(p) {
    var $17 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $18 = $9c38b931c8b22574$export$b9a4e863f082a036(p);
    return function($19) {
        return $17($18($19));
    };
};
var $43db1f7c9150eb00$export$eca9f13e904be86a = function(ns) {
    var $20 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $21 = $9c38b931c8b22574$export$a79c57bed1c08193(ns);
    return function($22) {
        return $20($21($22));
    };
};
var $43db1f7c9150eb00$export$86c2694e50e8251b = /* #__PURE__ */ function() {
    var $23 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($24) {
        return $23($9c38b931c8b22574$export$951f870fb0fe03c3($24));
    };
}();
var $43db1f7c9150eb00$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Node");
var $43db1f7c9150eb00$export$b212a48622cd6ee3 = /* #__PURE__ */ function() {
    var $25 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($26) {
        return $25($9c38b931c8b22574$export$274e0d97326033db($26));
    };
}();






var $80d0fbcfdca571e1$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $80d0fbcfdca571e1$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $80d0fbcfdca571e1$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $80d0fbcfdca571e1$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $80d0fbcfdca571e1$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $80d0fbcfdca571e1$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $80d0fbcfdca571e1$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592($f8fc227945eb179e$export$d7d9283ee84f4c3f)));
var $80d0fbcfdca571e1$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $80d0fbcfdca571e1$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $80d0fbcfdca571e1$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $80d0fbcfdca571e1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $80d0fbcfdca571e1$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $80d0fbcfdca571e1$var$RenderState = function(x) {
    return x;
};
var $80d0fbcfdca571e1$var$substInParent = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$86b68c7dbeb53c22(v)(v1.value0)(v2.value0));
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$1b8e57c9ea42f1d2(v)(v2.value0));
            return $80d0fbcfdca571e1$var$pure($05149ea687d6b460$export$523c0b569236b342);
        };
    };
};
var $80d0fbcfdca571e1$var$removeChild = function(v) {
    return function __do() {
        var npn = $43db1f7c9150eb00$export$b54be7ce267a037b(v.node)();
        return $80d0fbcfdca571e1$var$traverse_(function(pn) {
            return $9c38b931c8b22574$export$7ae609f7af59e4f7(v.node)(pn);
        })(npn)();
    };
};
var $80d0fbcfdca571e1$var$mkSpec = function(handler) {
    return function(renderChildRef) {
        return function(document) {
            var getNode = $ef932f98609e5673$export$b29cd3b133bc0fa4(function(v) {
                return v.node;
            });
            var done = function(st) {
                if (st instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(st.value0);
                return $05149ea687d6b460$export$523c0b569236b342;
            };
            var buildWidget = function(spec) {
                var buildThunk = $f1bf345cdb6c789d$export$d46b23c375182cf8($80d0fbcfdca571e1$var$unwrap)(spec);
                var $lazy_patch = $80d0fbcfdca571e1$var$$runtime_lazy("patch", "Halogen.VDom.Driver", function() {
                    return function(st, slot) {
                        if (st instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            if (slot instanceof $eea39ea934373596$export$bbf8b056cc92e88d) {
                                $47a0a3ebf66dcc6a$export$ba038fef9cd0a0de(st.value0);
                                return $lazy_renderComponentSlot(100)(slot.value0);
                            }
                            if (slot instanceof $eea39ea934373596$export$5e46cfa5e835a582) {
                                var step$prime = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(st.value0, slot.value0);
                                return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(step$prime), new $06733ae99ed4f534$export$8a67b48435b5d073(step$prime), $lazy_patch(103), done));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                slot.constructor.name
                            ]);
                        }
                        return $lazy_render(104)(slot);
                    };
                });
                var $lazy_render = $80d0fbcfdca571e1$var$$runtime_lazy("render", "Halogen.VDom.Driver", function() {
                    return function(slot) {
                        if (slot instanceof $eea39ea934373596$export$bbf8b056cc92e88d) return $lazy_renderComponentSlot(86)(slot.value0);
                        if (slot instanceof $eea39ea934373596$export$5e46cfa5e835a582) {
                            var step = buildThunk(slot.value0);
                            return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a($47a0a3ebf66dcc6a$export$f9380c9a627682d3(step), new $06733ae99ed4f534$export$8a67b48435b5d073(step), $lazy_patch(89), done));
                        }
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                            slot.constructor.name
                        ]);
                    };
                });
                var $lazy_renderComponentSlot = $80d0fbcfdca571e1$var$$runtime_lazy("renderComponentSlot", "Halogen.VDom.Driver", function() {
                    return function(cs) {
                        var renderChild = $e521936ea118867a$export$aafa59e2e03f2942(renderChildRef)();
                        var rsx = renderChild(cs)();
                        var node = getNode(rsx);
                        return $47a0a3ebf66dcc6a$export$dc52c2e07163a142(new $47a0a3ebf66dcc6a$export$fd55ce593607084a(node, $06733ae99ed4f534$export$bebe9059409a0d04.value, $lazy_patch(117), done));
                    };
                });
                var patch = $lazy_patch(91);
                var render = $lazy_render(82);
                var renderComponentSlot = $lazy_renderComponentSlot(109);
                return render;
            };
            var buildAttributes = $f9cd20a8b77a6bf5$export$ff441cf2113a23d9(handler);
            return {
                buildWidget: buildWidget,
                buildAttributes: buildAttributes,
                document: document
            };
        };
    };
};
var $80d0fbcfdca571e1$var$renderSpec = function(document) {
    return function(container) {
        var render = function(handler) {
            return function(child) {
                return function(v) {
                    return function(v1) {
                        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return function __do() {
                            var renderChildRef = $90327512d8280b8d$export$b8cb59497041ffe4(child)();
                            var spec = $80d0fbcfdca571e1$var$mkSpec(handler)(renderChildRef)(document);
                            var machine = $784c06f0344d34c4$export$7d13c0f6790d0505(spec)(v);
                            var node = $47a0a3ebf66dcc6a$export$f9380c9a627682d3(machine);
                            $80d0fbcfdca571e1$var$$$void($9c38b931c8b22574$export$1b8e57c9ea42f1d2(node)($5ae75883a0b7923c$export$83a0de4644f1fbc4(container)))();
                            return {
                                machine: machine,
                                node: node,
                                renderChildRef: renderChildRef
                            };
                        };
                        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function __do() {
                            $e521936ea118867a$export$68d8715fc104d294(child)(v1.value0.renderChildRef)();
                            var parent = $43db1f7c9150eb00$export$b54be7ce267a037b(v1.value0.node)();
                            var nextSib = $43db1f7c9150eb00$export$335219007e689d29(v1.value0.node)();
                            var machine$prime = $47a0a3ebf66dcc6a$export$35d34bc0ed591a92(v1.value0.machine, v);
                            var newNode = $47a0a3ebf66dcc6a$export$f9380c9a627682d3(machine$prime);
                            $80d0fbcfdca571e1$var$when($80d0fbcfdca571e1$var$not($871d3d7bcf6be72e$export$54d9901699893a6)(v1.value0.node)(newNode))($80d0fbcfdca571e1$var$substInParent(newNode)(nextSib)(parent))();
                            return {
                                machine: machine$prime,
                                node: newNode,
                                renderChildRef: v1.value0.renderChildRef
                            };
                        };
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                            v1.constructor.name
                        ]);
                    };
                };
            };
        };
        return {
            render: render,
            renderChild: $80d0fbcfdca571e1$var$identity,
            removeChild: $80d0fbcfdca571e1$var$removeChild,
            dispose: $80d0fbcfdca571e1$var$removeChild
        };
    };
};
var $80d0fbcfdca571e1$export$32d31a833a940d1c = function(component) {
    return function(i) {
        return function(element) {
            return $80d0fbcfdca571e1$var$bind1($80d0fbcfdca571e1$var$liftEffect($80d0fbcfdca571e1$var$map($f6c9290a5db8f197$export$ce0e204f587740c3)($80d0fbcfdca571e1$var$bindFlipped($aa35a24624ec08d2$export$5a7bfc01df82fcd1)($2603425f82e959df$export$8291e5b88f90ce4))))(function(document) {
                return $f469b52d7c3c8200$export$32d31a833a940d1c($80d0fbcfdca571e1$var$renderSpec(document)(element))(component)(i);
            });
        };
    };
};


// Generated by purs version 0.15.15
// See: https://stackoverflow.com/questions/566922/how-do-i-download-javascript-string-as-a-file
const $8f9b63d9d9618bc3$export$24422be91ad4011f = (filename, text)=>{
    var element = document.createElement("a");
    element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};





// Generated by purs version 0.15.15
/* eslint-disable no-eq-null, eqeqeq */ function $0e031af7428ef07d$export$dbafa4424a806c15(x) {
    return x;
}
const $0e031af7428ef07d$export$63ea9a5410ee0cef = null;
function $0e031af7428ef07d$export$fac44ee5b035f737(j) {
    return JSON.stringify(j);
}
function $0e031af7428ef07d$export$de66f4fa6860548(i) {
    return function(j) {
        return JSON.stringify(j, null, i);
    };
}
function $0e031af7428ef07d$var$isArray(a) {
    return Object.prototype.toString.call(a) === "[object Array]";
}
function $0e031af7428ef07d$export$8e91e9560ac84224(isNull, isBool, isNum, isStr, isArr, isObj, j) {
    if (j == null) return isNull();
    else if (typeof j === "boolean") return isBool(j);
    else if (typeof j === "number") return isNum(j);
    else if (typeof j === "string") return isStr(j);
    else if (Object.prototype.toString.call(j) === "[object Array]") return isArr(j);
    else return isObj(j);
}
function $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a, b) {
    if (a == null) {
        if (b == null) return EQ;
        else return LT;
    } else if (typeof a === "boolean") {
        if (typeof b === "boolean") {
            // boolean / boolean
            if (a === b) return EQ;
            else if (a === false) return LT;
            else return GT;
        } else if (b == null) return GT;
        else return LT;
    } else if (typeof a === "number") {
        if (typeof b === "number") {
            if (a === b) return EQ;
            else if (a < b) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else return LT;
    } else if (typeof a === "string") {
        if (typeof b === "string") {
            if (a === b) return EQ;
            else if (a < b) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else return LT;
    } else if ($0e031af7428ef07d$var$isArray(a)) {
        if ($0e031af7428ef07d$var$isArray(b)) {
            for(var i = 0; i < Math.min(a.length, b.length); i++){
                var ca = $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a[i], b[i]);
                if (ca !== EQ) return ca;
            }
            if (a.length === b.length) return EQ;
            else if (a.length < b.length) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else if (typeof b === "string") return GT;
        else return LT;
    } else {
        if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else if (typeof b === "string") return GT;
        else if ($0e031af7428ef07d$var$isArray(b)) return GT;
        else {
            var akeys = Object.keys(a);
            var bkeys = Object.keys(b);
            if (akeys.length < bkeys.length) return LT;
            else if (akeys.length > bkeys.length) return GT;
            var keys = akeys.concat(bkeys).sort();
            for(var j = 0; j < keys.length; j++){
                var k = keys[j];
                if (a[k] === undefined) return LT;
                else if (b[k] === undefined) return GT;
                var ck = $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a[k], b[k]);
                if (ck !== EQ) return ck;
            }
            return EQ;
        }
    }
}








var $2a035e92dc768ac1$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $2a035e92dc768ac1$var$verbJsonType = function(def) {
    return function(f) {
        return function(g) {
            return g(def)(f);
        };
    };
};
var $2a035e92dc768ac1$var$toJsonType = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$var$verbJsonType($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $2a035e92dc768ac1$export$c36def4669cfa602 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(0.0);
var $2a035e92dc768ac1$export$9024d20d7989ccd8 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(true);
var $2a035e92dc768ac1$export$ecfbf588917514aa = function(key) {
    return function(val) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($c045ea5df33bba60$export$439306a4dcaafbb9(key)(val));
    };
};
var $2a035e92dc768ac1$export$4f9a0f50606bc43c = function(j) {
    return $0e031af7428ef07d$export$dbafa4424a806c15([
        j
    ]);
};
var $2a035e92dc768ac1$export$29860be44d1074fa = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(false);
var $2a035e92dc768ac1$export$d2aabff522f82ec3 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15("");
var $2a035e92dc768ac1$export$d0304b893d105187 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15($03b6b966974423fe$export$6e22c362a0406a2c);
var $2a035e92dc768ac1$export$108d15c9b507bd0b = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15([]);
var $2a035e92dc768ac1$var$isJsonType = /* #__PURE__ */ $2a035e92dc768ac1$var$verbJsonType(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $2a035e92dc768ac1$export$d2871cfbf3cbd4f2 = {
    compare: function(a) {
        return function(b) {
            return $0e031af7428ef07d$export$6b486fc7358c5fa4($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value, $5026be88823ef1f4$export$b023c82b48e70453.value, $5026be88823ef1f4$export$7158f0ceb70f54c7.value, a, b);
        };
    },
    Eq0: function() {
        return $2a035e92dc768ac1$export$e8f903c542fcf2a5;
    }
};
var $2a035e92dc768ac1$export$e8f903c542fcf2a5 = {
    eq: function(j1) {
        return function(j2) {
            return $2a035e92dc768ac1$var$eq($97937c29f879e68e$export$398604a469f7de9a($2a035e92dc768ac1$export$d2871cfbf3cbd4f2)(j1)(j2))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    }
};
var $2a035e92dc768ac1$var$eqJNull = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $2a035e92dc768ac1$var$ordJNull = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $2a035e92dc768ac1$var$eqJNull;
    }
};
var $2a035e92dc768ac1$export$1532fd4f75be8b9c = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$844ec244b1367d54 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$1532fd4f75be8b9c);
var $2a035e92dc768ac1$export$f84e8e69fd4488a5 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$1532fd4f75be8b9c);
var $2a035e92dc768ac1$export$d4dde8795f959ed3 = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, j);
        };
    };
};
var $2a035e92dc768ac1$export$a6cdc56e425d0d0a = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$d4dde8795f959ed3);
var $2a035e92dc768ac1$export$697e4a1b90752ce2 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$d4dde8795f959ed3);
var $2a035e92dc768ac1$export$ec3647fa336ee4ac = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$7e4aa119212bc614 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$ec3647fa336ee4ac);
var $2a035e92dc768ac1$export$a0a81dc3380ce7d3 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$ec3647fa336ee4ac);
var $2a035e92dc768ac1$export$4d5744f54c133204 = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224(f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$630801d484da15df = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$4d5744f54c133204);
var $2a035e92dc768ac1$export$f0aa72cd87f2bde5 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$4d5744f54c133204);
var $2a035e92dc768ac1$export$fff3b6519135a62b = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$f9ce7b637dfbe238 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$fff3b6519135a62b);
var $2a035e92dc768ac1$export$3c2e6d1b7583eee6 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$fff3b6519135a62b);
var $2a035e92dc768ac1$export$d7ae7d568ec9dc3c = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$43bee75e5e14138e = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$d7ae7d568ec9dc3c);
var $2a035e92dc768ac1$export$45b10814cc054894 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$d7ae7d568ec9dc3c);
var $2a035e92dc768ac1$export$cda231bc8c57ca4 = function(a) {
    return function(b) {
        return function(c) {
            return function(d) {
                return function(e) {
                    return function(f) {
                        return function(json) {
                            return $0e031af7428ef07d$export$8e91e9560ac84224(a, b, c, d, e, f, json);
                        };
                    };
                };
            };
        };
    };
};



// Generated by purs version 0.15.15










var $4672333bf471fbe0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $4672333bf471fbe0$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$34a2521cb7920188);
var $4672333bf471fbe0$var$identity1 = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4672333bf471fbe0$export$a111e9ced3f1d2d0 = /* #__PURE__ */ function() {
    function Codec(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Codec.create = function(value0) {
        return function(value1) {
            return new Codec(value0, value1);
        };
    };
    return Codec;
}();
var $4672333bf471fbe0$export$255bfd6acde6dd7 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(function() {
                        var $91 = map1(g);
                        return function($92) {
                            return $91(v.value0($92));
                        };
                    }(), function() {
                        var $93 = $4672333bf471fbe0$var$map(g);
                        return function($94) {
                            return $93(v.value1(f($94)));
                        };
                    }());
                };
            };
        }
    };
};
var $4672333bf471fbe0$export$1eacdb5c4de310e7 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(function() {
                    var $95 = map1(f);
                    return function($96) {
                        return $95(v.value0($96));
                    };
                }(), function() {
                    var $97 = $4672333bf471fbe0$var$map(f);
                    return function($98) {
                        return $97(v.value1($98));
                    };
                }());
            };
        }
    };
};
var $4672333bf471fbe0$export$b800e9f26729a89c = function(dictFunctor) {
    return {
        imap: $3d82dffba933b011$export$eb38b1c8c5f72ca8($4672333bf471fbe0$export$1eacdb5c4de310e7(dictFunctor))
    };
};
var $4672333bf471fbe0$export$28632269e4a04430 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorCodec1 = $4672333bf471fbe0$export$1eacdb5c4de310e7(dictApply.Functor0());
    return function(dictSemigroup) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c($71f2e2e9476163f8$export$c87751c00e30fc9e(dictSemigroup));
        return {
            apply: function(v) {
                return function(v1) {
                    return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(function(a) {
                        return apply(v.value0(a))(v1.value0(a));
                    }, function(c) {
                        return apply1(v.value1(c))(v1.value1(c));
                    });
                };
            },
            Functor0: function() {
                return functorCodec1;
            }
        };
    };
};
var $4672333bf471fbe0$export$d341f7db1273e8ab = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyCodec1 = $4672333bf471fbe0$export$28632269e4a04430(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($71f2e2e9476163f8$export$2f2c2cdaef7b685e(dictMonoid));
        var applyCodec2 = applyCodec1(dictMonoid.Semigroup0());
        return {
            pure: function(x) {
                return new $4672333bf471fbe0$export$a111e9ced3f1d2d0($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(pure(x)), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(pure1(x)));
            },
            Apply0: function() {
                return applyCodec2;
            }
        };
    };
};
var $4672333bf471fbe0$export$7e0d8bd8ccbe00fd = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorCodec1 = $4672333bf471fbe0$export$1eacdb5c4de310e7(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(function(a) {
                    return alt(v.value0(a))(v1.value0(a));
                }, v1.value1);
            };
        },
        Functor0: function() {
            return functorCodec1;
        }
    };
};
var $4672333bf471fbe0$export$b2cccb4e0928a3a6 = function(f) {
    return function(v) {
        return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(function($99) {
            return f(v.value0($99));
        }, v.value1);
    };
};
var $4672333bf471fbe0$export$c564cdbbe6da493 = function(v) {
    return function($100) {
        return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(v.value1($100));
    };
};
var $4672333bf471fbe0$export$2f872c0f2117be69 = function(v) {
    return v.value0;
};
var $4672333bf471fbe0$export$f672e0b6f7222cd7 = function(dictBind) {
    var composeKleisliFlipped = $70cd3177464e7915$export$ea9fbbe247ef8e50(dictBind);
    return function(v) {
        return function(v1) {
            return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(composeKleisliFlipped(v.value0)(v1.value0), function() {
                var $101 = $4672333bf471fbe0$var$lmap(function($103) {
                    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(v1.value1($103));
                });
                return function($102) {
                    return $101(v.value1($102));
                };
            }());
        };
    };
};
var $4672333bf471fbe0$export$b5a9558a7176e41b = function(dictBind) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($4672333bf471fbe0$export$f672e0b6f7222cd7(dictBind));
};
var $4672333bf471fbe0$export$a1db28a6a036e024 = function(f) {
    return function(g) {
        return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(f, function(b) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(g(b), b);
        });
    };
};
var $4672333bf471fbe0$export$1c37c01eba8ed446 = function(f) {
    return function(g) {
        return new $4672333bf471fbe0$export$a111e9ced3f1d2d0(f, function(b) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(g(b), b);
        });
    };
};
var $4672333bf471fbe0$export$d838837eb5b184e3 = function(f) {
    return $4672333bf471fbe0$export$1c37c01eba8ed446(function(x) {
        return $4672333bf471fbe0$export$2f872c0f2117be69(f($4672333bf471fbe0$export$d838837eb5b184e3(f)))(x);
    })(function(x) {
        return $4672333bf471fbe0$export$c564cdbbe6da493(f($4672333bf471fbe0$export$d838837eb5b184e3(f)))(x);
    });
};
var $4672333bf471fbe0$export$f0954fd7d5368655 = function(dictApplicative) {
    return $4672333bf471fbe0$export$1c37c01eba8ed446($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative))($4672333bf471fbe0$var$identity1);
};


// Generated by purs version 0.15.15


















// Generated by purs version 0.15.15
/* global Symbol */ var $bfc50dc5547207b7$var$hasArrayFrom = typeof Array.from === "function";
var $bfc50dc5547207b7$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $bfc50dc5547207b7$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $bfc50dc5547207b7$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
const $bfc50dc5547207b7$export$81daff3801c9c982 = function(fallback) {
    return $bfc50dc5547207b7$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
const $bfc50dc5547207b7$export$5f0398d7608003c3 = function(fallback) {
    return function(Just) {
        return function(Nothing) {
            return function(unsafeCodePointAt0) {
                return function(index) {
                    return function(str) {
                        var length = str.length;
                        if (index < 0 || index >= length) return Nothing;
                        if ($bfc50dc5547207b7$var$hasStringIterator) {
                            var iter = str[Symbol.iterator]();
                            for(var i = index;; --i){
                                var o = iter.next();
                                if (o.done) return Nothing;
                                if (i === 0) return Just(unsafeCodePointAt0(o.value));
                            }
                        }
                        return fallback(index)(str);
                    };
                };
            };
        };
    };
};
const $bfc50dc5547207b7$export$2964bc4d0a1ede06 = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(pred) {
            return function(str) {
                var iter = str[Symbol.iterator]();
                for(var cpCount = 0;; ++cpCount){
                    var o = iter.next();
                    if (o.done) return cpCount;
                    var cp = unsafeCodePointAt0(o.value);
                    if (!pred(cp)) return cpCount;
                }
            };
        };
        return fallback;
    };
};
const $bfc50dc5547207b7$export$c41b441de25e3d55 = function(singleton) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? function(cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) return String.fromCodePoint.apply(String, cps);
        return cps.map(singleton).join("");
    } : function(cps) {
        return cps.map(singleton).join("");
    };
};
const $bfc50dc5547207b7$export$ecb7b38eca4fe9ff = function(fallback) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
const $bfc50dc5547207b7$export$6d9af221d75dd06f = function(fallback) {
    return function(n) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(str) {
            var accum = "";
            var iter = str[Symbol.iterator]();
            for(var i = 0; i < n; ++i){
                var o = iter.next();
                if (o.done) return accum;
                accum += o.value;
            }
            return accum;
        };
        return fallback(n);
    };
};
const $bfc50dc5547207b7$export$c61d72f8b05641be = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt0);
        };
        return fallback;
    };
};
















var $3ee2158c14339cc9$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3ee2158c14339cc9$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $3ee2158c14339cc9$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3ee2158c14339cc9$var$unfoldr = /* #__PURE__ */ $cb5fedc2c4837e1c$export$df2b8ee1690308ae($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $3ee2158c14339cc9$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $3ee2158c14339cc9$var$CodePoint = function(x) {
    return x;
};
var $3ee2158c14339cc9$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $3ee2158c14339cc9$export$1e278a1fb25ff338 = {
    show: function(v) {
        return "(CodePoint 0x" + ($5b07e36f812dd04b$export$43df7fc17cca38a4($4ab74a20512cef04$export$f601457c5ee3082f($8d5664f12212b23e$export$9c12a48020146abe)(v)) + ")");
    }
};
var $3ee2158c14339cc9$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $3ee2158c14339cc9$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $3ee2158c14339cc9$export$b446f6baa3bb1430 = function(s) {
    var v = $092fe44bc0883be6$export$f24224f1c91d8156(s);
    if (v === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s)),
        tail: ""
    });
    var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $43 = $3ee2158c14339cc9$var$isLead(cu0) && $3ee2158c14339cc9$var$isTrail(cu1);
    if ($43) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1),
        tail: $092fe44bc0883be6$export$663103110d94aac9(2)(s)
    });
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: cu0,
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(s)
    });
};
var $3ee2158c14339cc9$var$unconsButWithTuple = function(s) {
    return $3ee2158c14339cc9$var$map(function(v) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.head, v.tail);
    })($3ee2158c14339cc9$export$b446f6baa3bb1430(s));
};
var $3ee2158c14339cc9$var$toCodePointArrayFallback = function(s) {
    return $3ee2158c14339cc9$var$unfoldr($3ee2158c14339cc9$var$unconsButWithTuple)(s);
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0Fallback = function(s) {
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $47 = $3ee2158c14339cc9$var$isLead(cu0) && $092fe44bc0883be6$export$f24224f1c91d8156(s) > 1;
    if ($47) {
        var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
        var $48 = $3ee2158c14339cc9$var$isTrail(cu1);
        if ($48) return $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0 = /* #__PURE__ */ $bfc50dc5547207b7$export$81daff3801c9c982($3ee2158c14339cc9$var$unsafeCodePointAt0Fallback);
var $3ee2158c14339cc9$export$50a427d3c041e0d2 = /* #__PURE__ */ $bfc50dc5547207b7$export$c61d72f8b05641be($3ee2158c14339cc9$var$toCodePointArrayFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$f24224f1c91d8156 = function($74) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156($3ee2158c14339cc9$export$50a427d3c041e0d2($74));
};
var $3ee2158c14339cc9$export$557cfb7ed375eeb7 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$557cfb7ed375eeb7(p)(s));
    };
};
var $3ee2158c14339cc9$export$305f7d4e9d4624f2 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s));
    };
};
var $3ee2158c14339cc9$var$fromCharCode = /* #__PURE__ */ function() {
    var $75 = $f935a9866e211c00$export$1e2c188a485bdeae($f935a9866e211c00$export$be1f07c3580164c)($69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79))($69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79));
    return function($76) {
        return $092fe44bc0883be6$export$439306a4dcaafbb9($75($76));
    };
}();
var $3ee2158c14339cc9$var$singletonFallback = function(v) {
    if (v <= 65535) return $3ee2158c14339cc9$var$fromCharCode(v);
    var lead = $3ee2158c14339cc9$var$div(v - 65536 | 0)(1024) + 55296 | 0;
    var trail = $3ee2158c14339cc9$var$mod(v - 65536 | 0)(1024) + 56320 | 0;
    return $3ee2158c14339cc9$var$fromCharCode(lead) + $3ee2158c14339cc9$var$fromCharCode(trail);
};
var $3ee2158c14339cc9$export$6fadda5ad927586c = /* #__PURE__ */ $bfc50dc5547207b7$export$c41b441de25e3d55($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$export$439306a4dcaafbb9 = /* #__PURE__ */ $bfc50dc5547207b7$export$ecb7b38eca4fe9ff($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$var$takeFallback = function(v) {
    return function(v1) {
        if (v < 1) return "";
        var v2 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v1);
        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $3ee2158c14339cc9$export$439306a4dcaafbb9(v2.value0.head) + $3ee2158c14339cc9$var$takeFallback(v - 1 | 0)(v2.value0.tail);
        return v1;
    };
};
var $3ee2158c14339cc9$export$b7df5d561049483a = /* #__PURE__ */ $bfc50dc5547207b7$export$6d9af221d75dd06f($3ee2158c14339cc9$var$takeFallback);
var $3ee2158c14339cc9$export$9dc3eed83bb14216 = function(p) {
    return function(i) {
        return function(s) {
            var i$prime = $092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(i)(s));
            return $3ee2158c14339cc9$var$map(function(k) {
                return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s));
            })($1a77d6934b592676$export$9dc3eed83bb14216(p)(i$prime)(s));
        };
    };
};
var $3ee2158c14339cc9$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        var before = $3ee2158c14339cc9$export$b7df5d561049483a(i)(s);
        return {
            before: before,
            after: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(before))(s)
        };
    };
};
var $3ee2158c14339cc9$export$e200a5917becef04 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $3ee2158c14339cc9$export$b08a820ff2b5847d = {
    compare: function(x) {
        return function(y) {
            return $3ee2158c14339cc9$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $3ee2158c14339cc9$export$e200a5917becef04;
    }
};
var $3ee2158c14339cc9$export$663103110d94aac9 = function(n) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(n)(s)))(s);
    };
};
var $3ee2158c14339cc9$export$7f0e23922170149a = function(p) {
    return function(i) {
        return function(s) {
            var s$prime = $3ee2158c14339cc9$export$663103110d94aac9(i)(s);
            return $3ee2158c14339cc9$var$map(function(k) {
                return i + $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s$prime)) | 0;
            })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s$prime));
        };
    };
};
var $3ee2158c14339cc9$var$countTail = function($copy_p) {
    return function($copy_s) {
        return function($copy_accum) {
            var $tco_var_p = $copy_p;
            var $tco_var_s = $copy_s;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(p, s, accum) {
                var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $61 = p(v.value0.head);
                    if ($61) {
                        $tco_var_p = p;
                        $tco_var_s = v.value0.tail;
                        $copy_accum = accum + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return accum;
                }
                $tco_done = true;
                return accum;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_p, $tco_var_s, $copy_accum);
            return $tco_result;
        };
    };
};
var $3ee2158c14339cc9$var$countFallback = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$countTail(p)(s)(0);
    };
};
var $3ee2158c14339cc9$export$29a68f758c141c85 = /* #__PURE__ */ $bfc50dc5547207b7$export$2964bc4d0a1ede06($3ee2158c14339cc9$var$countFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$663103110d94aac9($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$b7df5d561049483a($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$dd1029f96c3dd62a = function($77) {
    return $3ee2158c14339cc9$var$CodePoint($3ee2158c14339cc9$var$fromEnum($77));
};
var $3ee2158c14339cc9$var$codePointAtFallback = function($copy_n) {
    return function($copy_s) {
        var $tco_var_n = $copy_n;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(n, s) {
            var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var $66 = n === 0;
                if ($66) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.head);
                }
                $tco_var_n = n - 1 | 0;
                $copy_s = v.value0.tail;
                return;
            }
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_s);
        return $tco_result;
    };
};
var $3ee2158c14339cc9$export$42977f40461e1360 = function(v) {
    return function(v1) {
        if (v < 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0 && v1 === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($3ee2158c14339cc9$var$unsafeCodePointAt0(v1));
        return $bfc50dc5547207b7$export$5f0398d7608003c3($3ee2158c14339cc9$var$codePointAtFallback)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value)($3ee2158c14339cc9$var$unsafeCodePointAt0)(v)(v1);
    };
};
var $3ee2158c14339cc9$export$1c2b30ab4636bf91 = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $3ee2158c14339cc9$export$b08a820ff2b5847d;
    }
};
var $3ee2158c14339cc9$export$2a3400c6862992c1 = /* #__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v) {
            return v;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $3ee2158c14339cc9$export$1c2b30ab4636bf91;
        },
        Enum1: function() {
            return $3ee2158c14339cc9$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $3ee2158c14339cc9$var$$lazy_enumCodePoint = /* #__PURE__ */ $3ee2158c14339cc9$var$$runtime_lazy("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        pred: $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        Ord0: function() {
            return $3ee2158c14339cc9$export$b08a820ff2b5847d;
        }
    };
});
var $3ee2158c14339cc9$export$4bc346dd2fb559f7 = /* #__PURE__ */ $3ee2158c14339cc9$var$$lazy_enumCodePoint(59);










var $59dadf91e1f9eb9a$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $59dadf91e1f9eb9a$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $59dadf91e1f9eb9a$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $59dadf91e1f9eb9a$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $59dadf91e1f9eb9a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $59dadf91e1f9eb9a$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $59dadf91e1f9eb9a$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$25cda6d3e08b28fe);
var $59dadf91e1f9eb9a$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $59dadf91e1f9eb9a$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $59dadf91e1f9eb9a$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377);
var $59dadf91e1f9eb9a$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $59dadf91e1f9eb9a$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $59dadf91e1f9eb9a$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $59dadf91e1f9eb9a$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($2a035e92dc768ac1$export$d2871cfbf3cbd4f2);
var $59dadf91e1f9eb9a$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $59dadf91e1f9eb9a$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $59dadf91e1f9eb9a$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $59dadf91e1f9eb9a$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249($2c7a64ff78781336$export$96888504550934b5)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $59dadf91e1f9eb9a$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $59dadf91e1f9eb9a$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0) {
        this.value0 = value0;
    }
    TypeMismatch.create = function(value0) {
        return new TypeMismatch(value0);
    };
    return TypeMismatch;
}();
var $59dadf91e1f9eb9a$export$35fbad60f29e98f2 = /* #__PURE__ */ function() {
    function UnexpectedValue(value0) {
        this.value0 = value0;
    }
    UnexpectedValue.create = function(value0) {
        return new UnexpectedValue(value0);
    };
    return UnexpectedValue;
}();
var $59dadf91e1f9eb9a$export$d58b23382c8562e = /* #__PURE__ */ function() {
    function AtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtIndex.create = function(value0) {
        return function(value1) {
            return new AtIndex(value0, value1);
        };
    };
    return AtIndex;
}();
var $59dadf91e1f9eb9a$export$26ae1106fd92d0a8 = /* #__PURE__ */ function() {
    function AtKey(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtKey.create = function(value0) {
        return function(value1) {
            return new AtKey(value0, value1);
        };
    };
    return AtKey;
}();
var $59dadf91e1f9eb9a$export$4e021928efe6b6bd = /* #__PURE__ */ function() {
    function Named(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Named.create = function(value0) {
        return function(value1) {
            return new Named(value0, value1);
        };
    };
    return Named;
}();
var $59dadf91e1f9eb9a$export$d171f9c68f3539d0 = /* #__PURE__ */ function() {
    function MissingValue() {}
    MissingValue.value = new MissingValue();
    return MissingValue;
}();
var $59dadf91e1f9eb9a$export$d3ac27ab5a0173d = {
    show: function(v) {
        if (v instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return "(TypeMismatch " + ($59dadf91e1f9eb9a$var$show(v.value0) + ")");
        if (v instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return "(UnexpectedValue " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ")");
        if (v instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return "(AtIndex " + ($59dadf91e1f9eb9a$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($59dadf91e1f9eb9a$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return "(AtKey " + ($59dadf91e1f9eb9a$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($59dadf91e1f9eb9a$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return "(Named " + ($59dadf91e1f9eb9a$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($59dadf91e1f9eb9a$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0) return "MissingValue";
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 77, column 10 - line 83, column 34): " + [
            v.constructor.name
        ]);
    }
};
var $59dadf91e1f9eb9a$export$dcb784050502c5aa = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(p) {
            return function(codecA) {
                return function(codecR) {
                    var key = reflectSymbol(p);
                    var enc$prime = function(val) {
                        var w = $4672333bf471fbe0$export$c564cdbbe6da493(codecR)(val);
                        var v = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(val);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9(key, $4672333bf471fbe0$export$c564cdbbe6da493(codecA)(v.value0)), w);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return w;
                        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 308, column 5 - line 310, column 18): " + [
                            v.constructor.name
                        ]);
                    };
                    var dec$prime = function(obj) {
                        return $59dadf91e1f9eb9a$var$bind($4672333bf471fbe0$export$2f872c0f2117be69(codecR)(obj))(function(r) {
                            return $59dadf91e1f9eb9a$var$bind($59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$26ae1106fd92d0a8.create(key))(function() {
                                var v = $c045ea5df33bba60$export$dfc7155ac0343b8(key)(obj);
                                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $59dadf91e1f9eb9a$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($4672333bf471fbe0$export$2f872c0f2117be69(codecA)(v.value0));
                                return new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value);
                            }()))(function(a) {
                                return $59dadf91e1f9eb9a$var$pure($d2fadbdf02925823$export$444262986932b766(key)(a)(r));
                            });
                        });
                    };
                    return $4672333bf471fbe0$export$1c37c01eba8ed446(dec$prime)(enc$prime);
                };
            };
        };
    };
};
var $59dadf91e1f9eb9a$export$953dd5c815c55fd6 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(p) {
            return function(codecA) {
                return function(codecR) {
                    var enc$prime = function(key) {
                        return function(val) {
                            return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9(key, $4672333bf471fbe0$export$c564cdbbe6da493(codecA)($d2fadbdf02925823$export$1d94535d2cda4eda(key)(val))), $4672333bf471fbe0$export$c564cdbbe6da493(codecR)(val));
                        };
                    };
                    var dec$prime = function(key) {
                        return function(obj) {
                            return $59dadf91e1f9eb9a$var$bind($4672333bf471fbe0$export$2f872c0f2117be69(codecR)(obj))(function(r) {
                                return $59dadf91e1f9eb9a$var$bind($59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$26ae1106fd92d0a8.create(key))(function() {
                                    var v = $c045ea5df33bba60$export$dfc7155ac0343b8(key)(obj);
                                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4672333bf471fbe0$export$2f872c0f2117be69(codecA)(v.value0);
                                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515($59dadf91e1f9eb9a$export$d171f9c68f3539d0.value);
                                    throw new Error("Failed pattern match at Data.Codec.Argonaut (line 264, column 29 - line 266, column 34): " + [
                                        v.constructor.name
                                    ]);
                                }()))(function(a) {
                                    return $59dadf91e1f9eb9a$var$pure($d2fadbdf02925823$export$444262986932b766(key)(a)(r));
                                });
                            });
                        };
                    };
                    var key = reflectSymbol(p);
                    return $4672333bf471fbe0$export$1c37c01eba8ed446(dec$prime(key))(enc$prime(key));
                };
            };
        };
    };
};
var $59dadf91e1f9eb9a$export$e5185e241753e543 = /* #__PURE__ */ function() {
    return new $4672333bf471fbe0$export$a111e9ced3f1d2d0($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($59dadf91e1f9eb9a$var$pure({})), $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($71f2e2e9476163f8$export$2f2c2cdaef7b685e($78c799cba34fcb8d$export$14584e231e9c63ca)));
}();
var $59dadf91e1f9eb9a$export$977f3f6a9323c0f6 = function(key) {
    return function(codec) {
        return $4672333bf471fbe0$export$1c37c01eba8ed446(function(obj) {
            return $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$26ae1106fd92d0a8.create(key))($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515($59dadf91e1f9eb9a$export$d171f9c68f3539d0.value))($4672333bf471fbe0$export$2f872c0f2117be69(codec))($c045ea5df33bba60$export$dfc7155ac0343b8(key)(obj)));
        })(function() {
            var $200 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(key);
            var $201 = $4672333bf471fbe0$export$c564cdbbe6da493(codec);
            return function($202) {
                return $59dadf91e1f9eb9a$var$pure1($200($201($202)));
            };
        }());
    };
};
var $59dadf91e1f9eb9a$export$56923548158521c8 = function(name) {
    return function(f) {
        return function(g) {
            return function(codec) {
                return $4672333bf471fbe0$export$a1db28a6a036e024(function(j) {
                    return $59dadf91e1f9eb9a$var$bindFlipped(function() {
                        var $203 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $59dadf91e1f9eb9a$export$4e021928efe6b6bd(name, new $59dadf91e1f9eb9a$export$35fbad60f29e98f2(j)));
                        return function($204) {
                            return $203(f($204));
                        };
                    }())($4672333bf471fbe0$export$2f872c0f2117be69(codec)(j));
                })(function() {
                    var $205 = $4672333bf471fbe0$export$c564cdbbe6da493(codec);
                    return function($206) {
                        return $205(g($206));
                    };
                }());
            };
        };
    };
};
var $59dadf91e1f9eb9a$export$f0345d087708be2e = function(err) {
    var go = function(v) {
        if (v instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return "  Expected value of type '" + (v.value0 + "'.");
        if (v instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return "  Unexpected value " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ".");
        if (v instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return "  At array index " + ($59dadf91e1f9eb9a$var$show1(v.value0) + (":\n" + go(v.value1)));
        if (v instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return "  At object key " + (v.value0 + (":\n" + go(v.value1)));
        if (v instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return "  Under '" + (v.value0 + ("':\n" + go(v.value1)));
        if (v instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0) return "  No value was found.";
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 90, column 8 - line 96, column 43): " + [
            v.constructor.name
        ]);
    };
    return "An error occurred while decoding a JSON value:\n" + go(err);
};
var $59dadf91e1f9eb9a$export$e1744e1bc4c7f337 = function(name) {
    return function(codec) {
        return $4672333bf471fbe0$export$a1db28a6a036e024(function() {
            var $207 = $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create(name));
            var $208 = $4672333bf471fbe0$export$2f872c0f2117be69(codec);
            return function($209) {
                return $207($208($209));
            };
        }())($4672333bf471fbe0$export$c564cdbbe6da493(codec));
    };
};
var $59dadf91e1f9eb9a$var$jsonPrimCodec = function(ty) {
    return function(f) {
        return $4672333bf471fbe0$export$a1db28a6a036e024(function() {
            var $210 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$168e2d3b16829a(ty)))($59dadf91e1f9eb9a$var$pure);
            return function($211) {
                return $210(f($211));
            };
        }());
    };
};
var $59dadf91e1f9eb9a$export$7b1b591b262c240 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Null")($2a035e92dc768ac1$export$f0aa72cd87f2bde5)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($0e031af7428ef07d$export$63ea9a5410ee0cef));
var $59dadf91e1f9eb9a$export$98e628dec113755e = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Number")($2a035e92dc768ac1$export$a0a81dc3380ce7d3)($0e031af7428ef07d$export$dbafa4424a806c15);
var $59dadf91e1f9eb9a$export$22b082955e083ec3 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("String")($2a035e92dc768ac1$export$f84e8e69fd4488a5)($0e031af7428ef07d$export$dbafa4424a806c15);
var $59dadf91e1f9eb9a$export$490e536ee7389aeb = /* #__PURE__ */ function() {
    return $59dadf91e1f9eb9a$var$jsonPrimCodec("Void")($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($58f3cdfbfe212d20$export$f172309911142386);
}();
var $59dadf91e1f9eb9a$export$7b419323e6ed4f31 = /* #__PURE__ */ $4672333bf471fbe0$export$a1db28a6a036e024($59dadf91e1f9eb9a$var$pure)(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $59dadf91e1f9eb9a$export$685e5903508e8c02 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Object")($2a035e92dc768ac1$export$697e4a1b90752ce2)($0e031af7428ef07d$export$dbafa4424a806c15);
var $59dadf91e1f9eb9a$export$be5493f9613cbbe = function(name) {
    return function(codec) {
        return $4672333bf471fbe0$export$a1db28a6a036e024(function(j) {
            return $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create(name))($59dadf91e1f9eb9a$var$bindFlipped($4672333bf471fbe0$export$2f872c0f2117be69(codec))($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$685e5903508e8c02)(j)));
        })(function(a) {
            return $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$685e5903508e8c02)($59dadf91e1f9eb9a$var$fromFoldable($4672333bf471fbe0$export$c564cdbbe6da493(codec)(a)));
        });
    };
};
var $59dadf91e1f9eb9a$export$30e92a5785ab2f48 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Array")($2a035e92dc768ac1$export$45b10814cc054894)($0e031af7428ef07d$export$dbafa4424a806c15);
var $59dadf91e1f9eb9a$export$7d260a2a5f8bc19e = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Int")(/* #__PURE__ */ $59dadf91e1f9eb9a$var$composeKleisliFlipped($8d5664f12212b23e$export$7bbb4164c9a77bc2)($2a035e92dc768ac1$export$a0a81dc3380ce7d3))(function($212) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($4ab74a20512cef04$export$a0a81dc3380ce7d3($212));
});
var $59dadf91e1f9eb9a$export$4201f0c4645b3d26 = function(name) {
    return function(codec) {
        return $4672333bf471fbe0$export$a1db28a6a036e024(function(j) {
            return $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create(name))($59dadf91e1f9eb9a$var$bindFlipped($4672333bf471fbe0$export$2f872c0f2117be69(codec))($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$30e92a5785ab2f48)(j)));
        })(function(a) {
            return $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$30e92a5785ab2f48)($59dadf91e1f9eb9a$var$fromFoldable1($4672333bf471fbe0$export$c564cdbbe6da493(codec)(a)));
        });
    };
};
var $59dadf91e1f9eb9a$export$b610b8812bbcded9 = function(ix) {
    return function(codec) {
        return $4672333bf471fbe0$export$1c37c01eba8ed446(function(xs) {
            return $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$d58b23382c8562e.create(ix))($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515($59dadf91e1f9eb9a$export$d171f9c68f3539d0.value))($4672333bf471fbe0$export$2f872c0f2117be69(codec))($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(ix)));
        })(function() {
            var $213 = $4672333bf471fbe0$export$c564cdbbe6da493(codec);
            return function($214) {
                return $59dadf91e1f9eb9a$var$pure1($213($214));
            };
        }());
    };
};
var $59dadf91e1f9eb9a$export$57ecdac35deb6f24 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $59dadf91e1f9eb9a$export$168e2d3b16829a(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $59dadf91e1f9eb9a$export$35fbad60f29e98f2(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $59dadf91e1f9eb9a$export$d58b23382c8562e(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $59dadf91e1f9eb9a$export$26ae1106fd92d0a8(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $59dadf91e1f9eb9a$export$4e021928efe6b6bd(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $59dadf91e1f9eb9a$export$d171f9c68f3539d0.value;
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 74, column 1 - line 74, column 67): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))));
        if (x instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1)))));
        if (x instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))))));
        if (x instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))));
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 74, column 1 - line 74, column 67): " + [
            x.constructor.name
        ]);
    }
};
var $59dadf91e1f9eb9a$export$d838837eb5b184e3 = function(f) {
    return $4672333bf471fbe0$export$a1db28a6a036e024(function(x) {
        return $4672333bf471fbe0$export$2f872c0f2117be69(f($59dadf91e1f9eb9a$export$d838837eb5b184e3(f)))(x);
    })(function(x) {
        return $4672333bf471fbe0$export$c564cdbbe6da493(f($59dadf91e1f9eb9a$export$d838837eb5b184e3(f)))(x);
    });
};
var $59dadf91e1f9eb9a$export$39ab000ce9c1c5aa = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a && y instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return x.value0 === y.value0;
            if (x instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2 && y instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return $59dadf91e1f9eb9a$var$eq1(x.value0)(y.value0);
            if (x instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e && y instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($59dadf91e1f9eb9a$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8 && y instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($59dadf91e1f9eb9a$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd && y instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($59dadf91e1f9eb9a$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0 && y instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0) return true;
            return false;
        };
    }
};
var $59dadf91e1f9eb9a$export$e25e82e4962e5280 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a && y instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return $59dadf91e1f9eb9a$var$compare(x.value0)(y.value0);
            if (x instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $59dadf91e1f9eb9a$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2 && y instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return $59dadf91e1f9eb9a$var$compare1(x.value0)(y.value0);
            if (x instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $59dadf91e1f9eb9a$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e && y instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) {
                var v = $59dadf91e1f9eb9a$var$compare2(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($59dadf91e1f9eb9a$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $59dadf91e1f9eb9a$export$d58b23382c8562e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8 && y instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) {
                var v = $59dadf91e1f9eb9a$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($59dadf91e1f9eb9a$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $59dadf91e1f9eb9a$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd && y instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) {
                var v = $59dadf91e1f9eb9a$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($59dadf91e1f9eb9a$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $59dadf91e1f9eb9a$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0 && y instanceof $59dadf91e1f9eb9a$export$d171f9c68f3539d0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Codec.Argonaut (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $59dadf91e1f9eb9a$export$39ab000ce9c1c5aa;
    }
};
var $59dadf91e1f9eb9a$export$b7145ad46ad18fbe = function() {
    return function(name) {
        return function(codec) {
            return $4672333bf471fbe0$export$a1db28a6a036e024(function() {
                var $215 = $59dadf91e1f9eb9a$var$bimap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create(name))($59dadf91e1f9eb9a$var$coerce);
                var $216 = $4672333bf471fbe0$export$2f872c0f2117be69(codec);
                return function($217) {
                    return $215($216($217));
                };
            }())($59dadf91e1f9eb9a$var$coerce($4672333bf471fbe0$export$c564cdbbe6da493(codec)));
        };
    };
};
var $59dadf91e1f9eb9a$export$b77dcf7160a1d98a = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("CodePoint")(/* #__PURE__ */ $59dadf91e1f9eb9a$var$composeKleisliFlipped(/* #__PURE__ */ $3ee2158c14339cc9$export$42977f40461e1360(0))($2a035e92dc768ac1$export$f84e8e69fd4488a5))(function($218) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($3ee2158c14339cc9$export$439306a4dcaafbb9($218));
});
var $59dadf91e1f9eb9a$export$eba6f6f03b0a92e7 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Char")(/* #__PURE__ */ $59dadf91e1f9eb9a$var$composeKleisliFlipped($1a77d6934b592676$export$bafb3da1554990db)($2a035e92dc768ac1$export$f84e8e69fd4488a5))(function($219) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($092fe44bc0883be6$export$439306a4dcaafbb9($219));
});
var $59dadf91e1f9eb9a$export$4a21f16c33752377 = /* #__PURE__ */ $59dadf91e1f9eb9a$var$jsonPrimCodec("Boolean")($2a035e92dc768ac1$export$3c2e6d1b7583eee6)($0e031af7428ef07d$export$dbafa4424a806c15);
var $59dadf91e1f9eb9a$export$2f23118c22fb2630 = function(codec) {
    return $4672333bf471fbe0$export$a1db28a6a036e024(function(j) {
        return $59dadf91e1f9eb9a$var$bindFlipped($59dadf91e1f9eb9a$var$traverseWithIndex(function(ix) {
            return function(j$prime) {
                return $59dadf91e1f9eb9a$var$lmap($59dadf91e1f9eb9a$export$d58b23382c8562e.create(ix))($4672333bf471fbe0$export$2f872c0f2117be69(codec)(j$prime));
            };
        }))($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$30e92a5785ab2f48)(j));
    })(function(a) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($59dadf91e1f9eb9a$var$map1($4672333bf471fbe0$export$c564cdbbe6da493(codec))(a));
    });
};


// Generated by purs version 0.15.15
var $4261ba653755ead8$var$createDateTime = function(y, m, d, h, mi, s, ms) {
    var dateTime = new Date(Date.UTC(y, m, d, h, mi, s, ms));
    if (y >= 0 && y < 100) dateTime.setUTCFullYear(y);
    return dateTime;
};
function $4261ba653755ead8$export$4ceb5c6f8416b1d0(y, mo, d, h, mi, s, ms) {
    return $4261ba653755ead8$var$createDateTime(y, mo - 1, d, h, mi, s, ms).getTime();
}
function $4261ba653755ead8$export$e7e4adb27c12afea(ctor) {
    return function(instant) {
        var dt = new Date(instant);
        return ctor(dt.getUTCFullYear())(dt.getUTCMonth() + 1)(dt.getUTCDate())(dt.getUTCHours())(dt.getUTCMinutes())(dt.getUTCSeconds())(dt.getUTCMilliseconds());
    };
}




// Generated by purs version 0.15.15
var $ccd022413a8f6522$var$createDate = function(y, m, d) {
    var date = new Date(Date.UTC(y, m, d));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date;
};
function $ccd022413a8f6522$export$278f2462bca80341(ctor, y, m, d) {
    var date = $ccd022413a8f6522$var$createDate(y, m - 1, d);
    return ctor(date.getUTCFullYear())(date.getUTCMonth() + 1)(date.getUTCDate());
}
function $ccd022413a8f6522$export$ee51fdb63bd93b0d(y, m, d) {
    return $ccd022413a8f6522$var$createDate(y, m - 1, d).getUTCDay();
}
function $ccd022413a8f6522$export$345f31f1ea862984(y1, m1, d1, y2, m2, d2) {
    var dt1 = $ccd022413a8f6522$var$createDate(y1, m1 - 1, d1);
    var dt2 = $ccd022413a8f6522$var$createDate(y2, m2 - 1, d2);
    return dt1.getTime() - dt2.getTime();
}







// Generated by purs version 0.15.15







var $e660aadfc8d8f891$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $e660aadfc8d8f891$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $e660aadfc8d8f891$var$Year = function(x) {
    return x;
};
var $e660aadfc8d8f891$export$7ee64068511a2cf0 = /* #__PURE__ */ function() {
    function Monday() {}
    Monday.value = new Monday();
    return Monday;
}();
var $e660aadfc8d8f891$export$238f9ec8ec28fcac = /* #__PURE__ */ function() {
    function Tuesday() {}
    Tuesday.value = new Tuesday();
    return Tuesday;
}();
var $e660aadfc8d8f891$export$6f4beda448624874 = /* #__PURE__ */ function() {
    function Wednesday() {}
    Wednesday.value = new Wednesday();
    return Wednesday;
}();
var $e660aadfc8d8f891$export$ee7232f0b12ab062 = /* #__PURE__ */ function() {
    function Thursday() {}
    Thursday.value = new Thursday();
    return Thursday;
}();
var $e660aadfc8d8f891$export$bb123522327d81ed = /* #__PURE__ */ function() {
    function Friday() {}
    Friday.value = new Friday();
    return Friday;
}();
var $e660aadfc8d8f891$export$446056e25969c735 = /* #__PURE__ */ function() {
    function Saturday() {}
    Saturday.value = new Saturday();
    return Saturday;
}();
var $e660aadfc8d8f891$export$8c9ac6ac028cebb2 = /* #__PURE__ */ function() {
    function Sunday() {}
    Sunday.value = new Sunday();
    return Sunday;
}();
var $e660aadfc8d8f891$export$abbad8e042a8ca41 = /* #__PURE__ */ function() {
    function January() {}
    January.value = new January();
    return January;
}();
var $e660aadfc8d8f891$export$e047bba63374153d = /* #__PURE__ */ function() {
    function February() {}
    February.value = new February();
    return February;
}();
var $e660aadfc8d8f891$export$ed40a0eacb1c1a7d = /* #__PURE__ */ function() {
    function March() {}
    March.value = new March();
    return March;
}();
var $e660aadfc8d8f891$export$b6e6de8185ac3568 = /* #__PURE__ */ function() {
    function April() {}
    April.value = new April();
    return April;
}();
var $e660aadfc8d8f891$export$50f4a85d6a193e43 = /* #__PURE__ */ function() {
    function May() {}
    May.value = new May();
    return May;
}();
var $e660aadfc8d8f891$export$ce3b81704c71b930 = /* #__PURE__ */ function() {
    function June() {}
    June.value = new June();
    return June;
}();
var $e660aadfc8d8f891$export$c35bbee8dc2d7f43 = /* #__PURE__ */ function() {
    function July() {}
    July.value = new July();
    return July;
}();
var $e660aadfc8d8f891$export$2646d2f8aef985a3 = /* #__PURE__ */ function() {
    function August() {}
    August.value = new August();
    return August;
}();
var $e660aadfc8d8f891$export$e18cdb270c0e647a = /* #__PURE__ */ function() {
    function September() {}
    September.value = new September();
    return September;
}();
var $e660aadfc8d8f891$export$af81d92e3606877a = /* #__PURE__ */ function() {
    function October() {}
    October.value = new October();
    return October;
}();
var $e660aadfc8d8f891$export$f440124e379d2b2 = /* #__PURE__ */ function() {
    function November() {}
    November.value = new November();
    return November;
}();
var $e660aadfc8d8f891$export$2d0bdb7c83ff083d = /* #__PURE__ */ function() {
    function December() {}
    December.value = new December();
    return December;
}();
var $e660aadfc8d8f891$var$Day = function(x) {
    return x;
};
var $e660aadfc8d8f891$export$fceec8b7cf7955e1 = {
    show: function(v) {
        return "(Year " + ($e660aadfc8d8f891$var$show(v) + ")");
    }
};
var $e660aadfc8d8f891$export$dca9d2e6bdb73ac1 = {
    show: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return "Monday";
        if (v instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return "Tuesday";
        if (v instanceof $e660aadfc8d8f891$export$6f4beda448624874) return "Wednesday";
        if (v instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return "Thursday";
        if (v instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return "Friday";
        if (v instanceof $e660aadfc8d8f891$export$446056e25969c735) return "Saturday";
        if (v instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return "Sunday";
        throw new Error("Failed pattern match at Data.Date.Component (line 184, column 1 - line 191, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $e660aadfc8d8f891$export$448238afa9640888 = {
    show: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return "January";
        if (v instanceof $e660aadfc8d8f891$export$e047bba63374153d) return "February";
        if (v instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return "March";
        if (v instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return "April";
        if (v instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return "May";
        if (v instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return "June";
        if (v instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return "July";
        if (v instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return "August";
        if (v instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return "September";
        if (v instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return "October";
        if (v instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return "November";
        if (v instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return "December";
        throw new Error("Failed pattern match at Data.Date.Component (line 101, column 1 - line 113, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $e660aadfc8d8f891$export$4cdce79cadb90595 = {
    show: function(v) {
        return "(Day " + ($e660aadfc8d8f891$var$show(v) + ")");
    }
};
var $e660aadfc8d8f891$export$265bd81dab95f118 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $e660aadfc8d8f891$export$87032c9ef54f957e = $97937c29f879e68e$export$ff461bf68e7dd332;
var $e660aadfc8d8f891$export$a20272c1d8245ff5 = $37b880af5f4991bd$export$e65788c6d4494539;
var $e660aadfc8d8f891$export$4d379f0fc2d943bb = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0 && y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return true;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac && y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return true;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874 && y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return true;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062 && y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return true;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed && y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return true;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735 && y instanceof $e660aadfc8d8f891$export$446056e25969c735) return true;
            if (x instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2 && y instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return true;
            return false;
        };
    }
};
var $e660aadfc8d8f891$export$a765516151070d24 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0 && y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac && y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874 && y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062 && y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed && y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735 && y instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2 && y instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e660aadfc8d8f891$export$4d379f0fc2d943bb;
    }
};
var $e660aadfc8d8f891$export$927de8112dffb3f8 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41 && y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return true;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d && y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return true;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d && y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return true;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568 && y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return true;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43 && y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return true;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930 && y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return true;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43 && y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return true;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3 && y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return true;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a && y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return true;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a && y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return true;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2 && y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return true;
            if (x instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d && y instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return true;
            return false;
        };
    }
};
var $e660aadfc8d8f891$export$98d905cecec08501 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41 && y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d && y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d && y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568 && y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43 && y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930 && y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43 && y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3 && y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a && y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a && y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2 && y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d && y instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e660aadfc8d8f891$export$927de8112dffb3f8;
    }
};
var $e660aadfc8d8f891$export$9736822bc4d08a1e = $37b880af5f4991bd$export$e65788c6d4494539;
var $e660aadfc8d8f891$export$bcd3d7e0476c0ec3 = /* #__PURE__ */ function() {
    return {
        bottom: -271820,
        top: 275759,
        Ord0: function() {
            return $e660aadfc8d8f891$export$265bd81dab95f118;
        }
    };
}();
var $e660aadfc8d8f891$export$a8f04630df721b18 = /* #__PURE__ */ function() {
    return {
        bottom: $e660aadfc8d8f891$export$7ee64068511a2cf0.value,
        top: $e660aadfc8d8f891$export$8c9ac6ac028cebb2.value,
        Ord0: function() {
            return $e660aadfc8d8f891$export$a765516151070d24;
        }
    };
}();
var $e660aadfc8d8f891$export$ab1d1b39e9a2bfeb = /* #__PURE__ */ function() {
    return {
        bottom: $e660aadfc8d8f891$export$abbad8e042a8ca41.value,
        top: $e660aadfc8d8f891$export$2d0bdb7c83ff083d.value,
        Ord0: function() {
            return $e660aadfc8d8f891$export$98d905cecec08501;
        }
    };
}();
var $e660aadfc8d8f891$export$2391dde84a7e2cbd = {
    cardinality: 547580,
    toEnum: function(n) {
        if (n >= -271820 && n <= 275759) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 35, column 1 - line 40, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$bcd3d7e0476c0ec3;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumYear(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumYear = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumYear", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $55 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            var $56 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            return function($57) {
                return $55(function(v) {
                    return v + 1 | 0;
                }($56($57)));
            };
        }(),
        pred: function() {
            var $58 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            var $59 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            return function($60) {
                return $58(function(v) {
                    return v - 1 | 0;
                }($59($60)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$265bd81dab95f118;
        }
    };
});
var $e660aadfc8d8f891$export$71b4ec642fe3649 = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumYear(31);
var $e660aadfc8d8f891$export$f8fb631899e9bc28 = {
    cardinality: 7,
    toEnum: function(v) {
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$7ee64068511a2cf0.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$238f9ec8ec28fcac.value);
        if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$6f4beda448624874.value);
        if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ee7232f0b12ab062.value);
        if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$bb123522327d81ed.value);
        if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$446056e25969c735.value);
        if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$8c9ac6ac028cebb2.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return 1;
        if (v instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return 2;
        if (v instanceof $e660aadfc8d8f891$export$6f4beda448624874) return 3;
        if (v instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return 4;
        if (v instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return 5;
        if (v instanceof $e660aadfc8d8f891$export$446056e25969c735) return 6;
        if (v instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return 7;
        throw new Error("Failed pattern match at Data.Date.Component (line 175, column 14 - line 182, column 16): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$a8f04630df721b18;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumWeekday(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumWeekday = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumWeekday", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $61 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
            var $62 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$f8fb631899e9bc28);
            return function($63) {
                return $61(function(v) {
                    return v + 1 | 0;
                }($62($63)));
            };
        }(),
        pred: function() {
            var $64 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
            var $65 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$f8fb631899e9bc28);
            return function($66) {
                return $64(function(v) {
                    return v - 1 | 0;
                }($65($66)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$a765516151070d24;
        }
    };
});
var $e660aadfc8d8f891$export$63166656fe259224 = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumWeekday(160);
var $e660aadfc8d8f891$export$e744bc4044126e99 = {
    cardinality: 12,
    toEnum: function(v) {
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$abbad8e042a8ca41.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$e047bba63374153d.value);
        if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ed40a0eacb1c1a7d.value);
        if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$b6e6de8185ac3568.value);
        if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$50f4a85d6a193e43.value);
        if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ce3b81704c71b930.value);
        if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$c35bbee8dc2d7f43.value);
        if (v === 8) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$2646d2f8aef985a3.value);
        if (v === 9) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$e18cdb270c0e647a.value);
        if (v === 10) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$af81d92e3606877a.value);
        if (v === 11) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$f440124e379d2b2.value);
        if (v === 12) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return 1;
        if (v instanceof $e660aadfc8d8f891$export$e047bba63374153d) return 2;
        if (v instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return 3;
        if (v instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return 4;
        if (v instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return 5;
        if (v instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return 6;
        if (v instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return 7;
        if (v instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return 8;
        if (v instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return 9;
        if (v instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return 10;
        if (v instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return 11;
        if (v instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return 12;
        throw new Error("Failed pattern match at Data.Date.Component (line 87, column 14 - line 99, column 19): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$ab1d1b39e9a2bfeb;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumMonth(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumMonth = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumMonth", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $67 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
            var $68 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
            return function($69) {
                return $67(function(v) {
                    return v + 1 | 0;
                }($68($69)));
            };
        }(),
        pred: function() {
            var $70 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
            var $71 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
            return function($72) {
                return $70(function(v) {
                    return v - 1 | 0;
                }($71($72)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$98d905cecec08501;
        }
    };
});
var $e660aadfc8d8f891$export$fe5733da28f67bc = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumMonth(67);
var $e660aadfc8d8f891$export$337e475a74d6aff0 = {
    bottom: 1,
    top: 31,
    Ord0: function() {
        return $e660aadfc8d8f891$export$87032c9ef54f957e;
    }
};
var $e660aadfc8d8f891$export$2f59e9c675f625db = {
    cardinality: 31,
    toEnum: function(n) {
        if (n >= 1 && n <= 31) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 133, column 1 - line 138, column 23): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$337e475a74d6aff0;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumDay(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumDay = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumDay", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $73 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
            var $74 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
            return function($75) {
                return $73(function(v) {
                    return v + 1 | 0;
                }($74($75)));
            };
        }(),
        pred: function() {
            var $76 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
            var $77 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
            return function($78) {
                return $76(function(v) {
                    return v - 1 | 0;
                }($77($78)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$87032c9ef54f957e;
        }
    };
});
var $e660aadfc8d8f891$export$14dd55f5b902975a = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumDay(129);













var $7577649a7445e8e0$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $7577649a7445e8e0$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $7577649a7445e8e0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
var $7577649a7445e8e0$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$fceec8b7cf7955e1);
var $7577649a7445e8e0$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$448238afa9640888);
var $7577649a7445e8e0$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$4cdce79cadb90595);
var $7577649a7445e8e0$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $7577649a7445e8e0$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $7577649a7445e8e0$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $7577649a7445e8e0$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$a20272c1d8245ff5);
var $7577649a7445e8e0$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$927de8112dffb3f8);
var $7577649a7445e8e0$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$9736822bc4d08a1e);
var $7577649a7445e8e0$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$265bd81dab95f118);
var $7577649a7445e8e0$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$98d905cecec08501);
var $7577649a7445e8e0$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$87032c9ef54f957e);
var $7577649a7445e8e0$var$succ = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$fe5733da28f67bc);
var $7577649a7445e8e0$var$succ1 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$14dd55f5b902975a);
var $7577649a7445e8e0$var$greaterThan = /* #__PURE__ */ $97937c29f879e68e$export$f517ea36c68d4644(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($e660aadfc8d8f891$export$87032c9ef54f957e));
var $7577649a7445e8e0$var$succ2 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$71b4ec642fe3649);
var $7577649a7445e8e0$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $7577649a7445e8e0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7577649a7445e8e0$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $7577649a7445e8e0$var$pred = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$fe5733da28f67bc);
var $7577649a7445e8e0$var$pred1 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$14dd55f5b902975a);
var $7577649a7445e8e0$var$pred2 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$71b4ec642fe3649);
var $7577649a7445e8e0$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $7577649a7445e8e0$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $7577649a7445e8e0$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $7577649a7445e8e0$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $7577649a7445e8e0$var$$$Date = /* #__PURE__ */ function() {
    function $$Date(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    $$Date.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new $$Date(value0, value1, value2);
            };
        };
    };
    return $$Date;
}();
var $7577649a7445e8e0$export$31803937850fb2da = function(v) {
    return v.value0;
};
var $7577649a7445e8e0$export$b7f7efbe9ab39b25 = function(v) {
    var n = $ccd022413a8f6522$export$ee51fdb63bd93b0d(v.value0, $7577649a7445e8e0$var$fromEnum(v.value1), v.value2);
    var $86 = n === 0;
    if ($86) return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum(7));
    return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum(n));
};
var $7577649a7445e8e0$export$893a9e6d06ff9c67 = {
    show: function(v) {
        return "(Date " + ($7577649a7445e8e0$var$show(v.value0) + (" " + ($7577649a7445e8e0$var$show1(v.value1) + (" " + ($7577649a7445e8e0$var$show2(v.value2) + ")")))));
    }
};
var $7577649a7445e8e0$export$af5de1609f06c8e6 = function(v) {
    return v.value1;
};
var $7577649a7445e8e0$export$553d7fa8e3805fc0 = function(y) {
    var y$prime = $7577649a7445e8e0$var$fromEnum1(y);
    return $7577649a7445e8e0$var$mod(y$prime)(4) === 0 && ($7577649a7445e8e0$var$mod(y$prime)(400) === 0 || !($7577649a7445e8e0$var$mod(y$prime)(100) === 0));
};
var $7577649a7445e8e0$export$36818250d6c87922 = function(y) {
    return function(m) {
        var unsafeDay = function($154) {
            return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum1($154));
        };
        if (m instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$e047bba63374153d) {
            if ($7577649a7445e8e0$export$553d7fa8e3805fc0(y)) return unsafeDay(29);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return unsafeDay(28);
        }
        if (m instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return unsafeDay(31);
        throw new Error("Failed pattern match at Data.Date (line 127, column 22 - line 141, column 27): " + [
            m.constructor.name
        ]);
    };
};
var $7577649a7445e8e0$export$4eced57d6183c43d = {
    eq: function(x) {
        return function(y) {
            return $7577649a7445e8e0$var$eq1(x.value0)(y.value0) && $7577649a7445e8e0$var$eq2(x.value1)(y.value1) && $7577649a7445e8e0$var$eq3(x.value2)(y.value2);
        };
    }
};
var $7577649a7445e8e0$var$eq4 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($7577649a7445e8e0$export$4eced57d6183c43d);
var $7577649a7445e8e0$export$722593c82468f9f4 = {
    compare: function(x) {
        return function(y) {
            var v = $7577649a7445e8e0$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v1 = $7577649a7445e8e0$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $7577649a7445e8e0$var$compare2(x.value2)(y.value2);
        };
    },
    Eq0: function() {
        return $7577649a7445e8e0$export$4eced57d6183c43d;
    }
};
var $7577649a7445e8e0$export$72e9e4e3053b6c59 = {
    succ: function(v) {
        var sm = $7577649a7445e8e0$var$succ(v.value1);
        var l = $7577649a7445e8e0$export$36818250d6c87922(v.value0)(v.value1);
        var sd = function() {
            var v1 = $7577649a7445e8e0$var$succ1(v.value2);
            var $118 = $7577649a7445e8e0$var$greaterThan(v1)(new $06733ae99ed4f534$export$8a67b48435b5d073(l));
            if ($118) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return v1;
        }();
        var m$prime = function() {
            var $119 = $06733ae99ed4f534$export$4967676db1b89293(sd);
            if ($119) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$abbad8e042a8ca41.value)(sm);
            return v.value1;
        }();
        var y$prime = function() {
            var $120 = $06733ae99ed4f534$export$4967676db1b89293(sd) && $06733ae99ed4f534$export$4967676db1b89293(sm);
            if ($120) return $7577649a7445e8e0$var$succ2(v.value0);
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }();
        var d$prime = function() {
            var $121 = $06733ae99ed4f534$export$4967676db1b89293(sd);
            if ($121) return $7577649a7445e8e0$var$toEnum1(1);
            return sd;
        }();
        return $7577649a7445e8e0$var$apply($7577649a7445e8e0$var$apply($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create)(y$prime))($7577649a7445e8e0$var$pure(m$prime)))(d$prime);
    },
    pred: function(v) {
        var pm = $7577649a7445e8e0$var$pred(v.value1);
        var pd = $7577649a7445e8e0$var$pred1(v.value2);
        var y$prime = function() {
            var $126 = $06733ae99ed4f534$export$4967676db1b89293(pd) && $06733ae99ed4f534$export$4967676db1b89293(pm);
            if ($126) return $7577649a7445e8e0$var$pred2(v.value0);
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }();
        var m$prime = function() {
            var $127 = $06733ae99ed4f534$export$4967676db1b89293(pd);
            if ($127) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value)(pm);
            return v.value1;
        }();
        var l = $7577649a7445e8e0$export$36818250d6c87922(v.value0)(m$prime);
        var d$prime = function() {
            var $128 = $06733ae99ed4f534$export$4967676db1b89293(pd);
            if ($128) return new $06733ae99ed4f534$export$8a67b48435b5d073(l);
            return pd;
        }();
        return $7577649a7445e8e0$var$apply($7577649a7445e8e0$var$apply($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create)(y$prime))($7577649a7445e8e0$var$pure(m$prime)))(d$prime);
    },
    Ord0: function() {
        return $7577649a7445e8e0$export$722593c82468f9f4;
    }
};
var $7577649a7445e8e0$var$pred3 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($7577649a7445e8e0$export$72e9e4e3053b6c59);
var $7577649a7445e8e0$var$succ3 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($7577649a7445e8e0$export$72e9e4e3053b6c59);
var $7577649a7445e8e0$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(v) {
        return function(v1) {
            return toDuration($ccd022413a8f6522$export$345f31f1ea862984(v.value0, $7577649a7445e8e0$var$fromEnum(v.value1), v.value2, v1.value0, $7577649a7445e8e0$var$fromEnum(v1.value1), v1.value2));
        };
    };
};
var $7577649a7445e8e0$export$d2d39d1adcc883a2 = function(v) {
    return v.value2;
};
var $7577649a7445e8e0$export$e352e11a7fa73bba = function(y) {
    return function(m) {
        return function(d) {
            var mkDate = function(y$prime) {
                return function(m$prime) {
                    return function(d$prime) {
                        return new $7577649a7445e8e0$var$$$Date(y$prime, $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum2(m$prime)), d$prime);
                    };
                };
            };
            return $ccd022413a8f6522$export$278f2462bca80341(mkDate, y, $7577649a7445e8e0$var$fromEnum(m), d);
        };
    };
};
var $7577649a7445e8e0$export$4803c954abcb09a = function(y) {
    return function(m) {
        return function(d) {
            var dt = new $7577649a7445e8e0$var$$$Date(y, m, d);
            var $144 = $7577649a7445e8e0$var$eq4($7577649a7445e8e0$export$e352e11a7fa73bba(y)(m)(d))(dt);
            if ($144) return new $06733ae99ed4f534$export$8a67b48435b5d073(dt);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $7577649a7445e8e0$export$590ef5e04dc36aa5 = /* #__PURE__ */ function() {
    return {
        bottom: new $7577649a7445e8e0$var$$$Date($69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$bcd3d7e0476c0ec3), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$ab1d1b39e9a2bfeb), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$337e475a74d6aff0)),
        top: new $7577649a7445e8e0$var$$$Date($69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$bcd3d7e0476c0ec3), $69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$ab1d1b39e9a2bfeb), $69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$337e475a74d6aff0)),
        Ord0: function() {
            return $7577649a7445e8e0$export$722593c82468f9f4;
        }
    };
}();
var $7577649a7445e8e0$export$2c0e788bcc82013 = function(v) {
    return function(date) {
        var adj = function(v1) {
            return function(v2) {
                if (v1 === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v2);
                var j = v1 + $7577649a7445e8e0$var$fromEnum2(v2.value2) | 0;
                var low = j < 1;
                var l = $7577649a7445e8e0$export$36818250d6c87922(v2.value0)(function() {
                    if (low) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value)($7577649a7445e8e0$var$pred(v2.value1));
                    return v2.value1;
                }());
                var hi = j > $7577649a7445e8e0$var$fromEnum2(l);
                var i$prime = function() {
                    if (low) return j;
                    if (hi) return (j - $7577649a7445e8e0$var$fromEnum2(l) | 0) - 1 | 0;
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return 0;
                    throw new Error("Failed pattern match at Data.Date (line 101, column 9 - line 103, column 28): ");
                }();
                var dt$prime = function() {
                    if (low) return $7577649a7445e8e0$var$bindFlipped($7577649a7445e8e0$var$pred3)($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create(v2.value0)(v2.value1))($7577649a7445e8e0$var$toEnum1(1)));
                    if (hi) return $7577649a7445e8e0$var$succ3(new $7577649a7445e8e0$var$$$Date(v2.value0, v2.value1, l));
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create(v2.value0)(v2.value1))($7577649a7445e8e0$var$toEnum1(j));
                    throw new Error("Failed pattern match at Data.Date (line 104, column 9 - line 106, column 48): ");
                }();
                return $7577649a7445e8e0$var$bindFlipped(adj(i$prime))(dt$prime);
            };
        };
        return $7577649a7445e8e0$var$bind($8d5664f12212b23e$export$7bbb4164c9a77bc2(v))($f57f4b701aa7b66e$export$8a83211c878a3f1f(adj)(date));
    };
};



// Generated by purs version 0.15.15
var $209026257f9663e4$var$createUTC = function(y, mo, d, h, m, s, ms) {
    var date = new Date(Date.UTC(y, mo, d, h, m, s, ms));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date.getTime();
};
function $209026257f9663e4$export$345f31f1ea862984(rec1, rec2) {
    var msUTC1 = $209026257f9663e4$var$createUTC(rec1.year, rec1.month - 1, rec1.day, rec1.hour, rec1.minute, rec1.second, rec1.millisecond);
    var msUTC2 = $209026257f9663e4$var$createUTC(rec2.year, rec2.month - 1, rec2.day, rec2.hour, rec2.minute, rec2.second, rec2.millisecond);
    return msUTC1 - msUTC2;
}
function $209026257f9663e4$export$e01c022ccf7c1b57(just) {
    return function(nothing) {
        return function(offset) {
            return function(rec) {
                var msUTC = $209026257f9663e4$var$createUTC(rec.year, rec.month - 1, rec.day, rec.hour, rec.minute, rec.second, rec.millisecond);
                var dt = new Date(msUTC + offset);
                return isNaN(dt.getTime()) ? nothing : just({
                    year: dt.getUTCFullYear(),
                    month: dt.getUTCMonth() + 1,
                    day: dt.getUTCDate(),
                    hour: dt.getUTCHours(),
                    minute: dt.getUTCMinutes(),
                    second: dt.getUTCSeconds(),
                    millisecond: dt.getUTCMilliseconds()
                });
            };
        };
    };
}















// Generated by purs version 0.15.15













// Generated by purs version 0.15.15






var $0b11e4a917ce3a7d$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $0b11e4a917ce3a7d$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $0b11e4a917ce3a7d$var$Second = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Minute = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Millisecond = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Hour = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$export$ded5f90a35c30d2e = {
    show: function(v) {
        return "(Second " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$59c06e2004fc98a4 = {
    show: function(v) {
        return "(Minute " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$5bcc2f09c21d8c42 = {
    show: function(v) {
        return "(Millisecond " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$737acbed1f5b7f59 = {
    show: function(v) {
        return "(Hour " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$cda9505f3bbd31a6 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$cbed256bda88f39a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$9ae204e537c07a49 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$1d37a2519784e654 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$17f5c7433e4de947 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$10d6cfb0f5850aca = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$a2181cffc8c78aa4 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$14f9cc6a73419a24 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$cda9505f3bbd31a6;
    }
};
var $0b11e4a917ce3a7d$export$2e9ad76d003e68e6 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$cbed256bda88f39a;
    }
};
var $0b11e4a917ce3a7d$export$1bc1fc48769dfdc5 = {
    bottom: 0,
    top: 999,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf;
    }
};
var $0b11e4a917ce3a7d$export$a07dd689fd52f43a = {
    bottom: 0,
    top: 23,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$9ae204e537c07a49;
    }
};
var $0b11e4a917ce3a7d$export$c9467b6184dd9c81 = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 90, column 1 - line 95, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$14f9cc6a73419a24;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumSecond(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumSecond = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumSecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $36 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            var $37 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            return function($38) {
                return $36(function(v) {
                    return v + 1 | 0;
                }($37($38)));
            };
        }(),
        pred: function() {
            var $39 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            var $40 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            return function($41) {
                return $39(function(v) {
                    return v - 1 | 0;
                }($40($41)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$cda9505f3bbd31a6;
        }
    };
});
var $0b11e4a917ce3a7d$export$a7beee32098a9d39 = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumSecond(86);
var $0b11e4a917ce3a7d$export$d4e91fe4c2aba62a = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 61, column 1 - line 66, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$2e9ad76d003e68e6;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumMinute(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumMinute = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumMinute", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $42 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            var $43 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            return function($44) {
                return $42(function(v) {
                    return v + 1 | 0;
                }($43($44)));
            };
        }(),
        pred: function() {
            var $45 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            var $46 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            return function($47) {
                return $45(function(v) {
                    return v - 1 | 0;
                }($46($47)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$cbed256bda88f39a;
        }
    };
});
var $0b11e4a917ce3a7d$export$997c451dd6e71518 = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumMinute(57);
var $0b11e4a917ce3a7d$export$4789fa20e673c035 = {
    cardinality: 1000,
    toEnum: function(n) {
        if (n >= 0 && n <= 999) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 120, column 1 - line 125, column 31): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$1bc1fc48769dfdc5;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumMillisecond(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumMillisecond = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumMillisecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $48 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
            var $49 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
            return function($50) {
                return $48(function(v) {
                    return v + 1 | 0;
                }($49($50)));
            };
        }(),
        pred: function() {
            var $51 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
            var $52 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
            return function($53) {
                return $51(function(v) {
                    return v - 1 | 0;
                }($52($53)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf;
        }
    };
});
var $0b11e4a917ce3a7d$export$f76f413973d04ccc = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumMillisecond(116);
var $0b11e4a917ce3a7d$export$3e668e9da55710cb = {
    cardinality: 24,
    toEnum: function(n) {
        if (n >= 0 && n <= 23) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 32, column 1 - line 37, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$a07dd689fd52f43a;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumHour(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumHour = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumHour", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $54 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            var $55 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            return function($56) {
                return $54(function(v) {
                    return v + 1 | 0;
                }($55($56)));
            };
        }(),
        pred: function() {
            var $57 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            var $58 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            return function($59) {
                return $57(function(v) {
                    return v - 1 | 0;
                }($58($59)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$9ae204e537c07a49;
        }
    };
});
var $0b11e4a917ce3a7d$export$dac2f6c805cf929f = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumHour(28);




var $d254595454e6e9b0$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$737acbed1f5b7f59);
var $d254595454e6e9b0$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$59c06e2004fc98a4);
var $d254595454e6e9b0$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$ded5f90a35c30d2e);
var $d254595454e6e9b0$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$5bcc2f09c21d8c42);
var $d254595454e6e9b0$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $d254595454e6e9b0$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $d254595454e6e9b0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d254595454e6e9b0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $d254595454e6e9b0$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $d254595454e6e9b0$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $d254595454e6e9b0$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $d254595454e6e9b0$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $d254595454e6e9b0$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $d254595454e6e9b0$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $d254595454e6e9b0$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $d254595454e6e9b0$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$a2181cffc8c78aa4);
var $d254595454e6e9b0$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$17f5c7433e4de947);
var $d254595454e6e9b0$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$1d37a2519784e654);
var $d254595454e6e9b0$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$10d6cfb0f5850aca);
var $d254595454e6e9b0$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$9ae204e537c07a49);
var $d254595454e6e9b0$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$cbed256bda88f39a);
var $d254595454e6e9b0$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$cda9505f3bbd31a6);
var $d254595454e6e9b0$var$compare3 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf);
var $d254595454e6e9b0$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$def67087bd72fdb7);
var $d254595454e6e9b0$var$negateDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$28743521ea1cb8f9($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $d254595454e6e9b0$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $d254595454e6e9b0$var$fromDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$1a0a2c8fdf902748($3c54b6e6d30cc3be$export$93ad8ffd4576e464);
var $d254595454e6e9b0$var$greaterThan = /* #__PURE__ */ $97937c29f879e68e$export$f517ea36c68d4644($3c54b6e6d30cc3be$export$e0a5c04af6395341);
var $d254595454e6e9b0$var$lessThan = /* #__PURE__ */ $97937c29f879e68e$export$9b050841a3a1b328($3c54b6e6d30cc3be$export$e0a5c04af6395341);
var $d254595454e6e9b0$var$append2 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$e8bb798e27d1673b);
var $d254595454e6e9b0$export$680ea196effce5f = /* #__PURE__ */ function() {
    function Time(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Time.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Time(value0, value1, value2, value3);
                };
            };
        };
    };
    return Time;
}();
var $d254595454e6e9b0$export$a8b500dc61192962 = {
    show: function(v) {
        return "(Time " + ($d254595454e6e9b0$var$show(v.value0) + (" " + ($d254595454e6e9b0$var$show1(v.value1) + (" " + ($d254595454e6e9b0$var$show2(v.value2) + (" " + ($d254595454e6e9b0$var$show3(v.value3) + ")")))))));
    }
};
var $d254595454e6e9b0$export$6d7f956f1942326e = function(s) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, v.value1, s, v.value3);
    };
};
var $d254595454e6e9b0$export$9488e8f97d913fb3 = function(m) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, m, v.value2, v.value3);
    };
};
var $d254595454e6e9b0$export$694994bc4ee8aa99 = function(ms) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, v.value1, v.value2, ms);
    };
};
var $d254595454e6e9b0$export$73c2a04c9ce973a8 = function(h) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(h, v.value1, v.value2, v.value3);
    };
};
var $d254595454e6e9b0$export$3d3c77ce7df7d30d = function(v) {
    return v.value2;
};
var $d254595454e6e9b0$export$1cacba1045a8e790 = function(v) {
    return v.value1;
};
var $d254595454e6e9b0$export$edc5e5cb87280477 = function(v) {
    return v.value3;
};
var $d254595454e6e9b0$var$millisToTime = function(v) {
    var hours = $9a14cd925227149d$export$a3fe094919f356fd(v / 3600000.0);
    var minutes = $9a14cd925227149d$export$a3fe094919f356fd((v - hours * 3600000.0) / 60000.0);
    var seconds = $9a14cd925227149d$export$a3fe094919f356fd((v - (hours * 3600000.0 + minutes * 60000.0)) / 1000.0);
    var milliseconds = v - (hours * 3600000.0 + minutes * 60000.0 + seconds * 1000.0);
    return $d254595454e6e9b0$var$fromJust($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($d254595454e6e9b0$var$toEnum($8d5664f12212b23e$export$a3fe094919f356fd(hours))))($d254595454e6e9b0$var$toEnum1($8d5664f12212b23e$export$a3fe094919f356fd(minutes))))($d254595454e6e9b0$var$toEnum2($8d5664f12212b23e$export$a3fe094919f356fd(seconds))))($d254595454e6e9b0$var$toEnum3($8d5664f12212b23e$export$a3fe094919f356fd(milliseconds))));
};
var $d254595454e6e9b0$export$842e383dfc19bc67 = function(v) {
    return v.value0;
};
var $d254595454e6e9b0$var$timeToMillis = function(t) {
    return 3600000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum($d254595454e6e9b0$export$842e383dfc19bc67(t))) + 60000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum1($d254595454e6e9b0$export$1cacba1045a8e790(t))) + 1000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum2($d254595454e6e9b0$export$3d3c77ce7df7d30d(t))) + $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum3($d254595454e6e9b0$export$edc5e5cb87280477(t)));
};
var $d254595454e6e9b0$export$9fe01c5d451d5493 = {
    eq: function(x) {
        return function(y) {
            return $d254595454e6e9b0$var$eq(x.value0)(y.value0) && $d254595454e6e9b0$var$eq1(x.value1)(y.value1) && $d254595454e6e9b0$var$eq2(x.value2)(y.value2) && $d254595454e6e9b0$var$eq3(x.value3)(y.value3);
        };
    }
};
var $d254595454e6e9b0$export$153601f213258a17 = {
    compare: function(x) {
        return function(y) {
            var v = $d254595454e6e9b0$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v1 = $d254595454e6e9b0$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v2 = $d254595454e6e9b0$var$compare2(x.value2)(y.value2);
            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $d254595454e6e9b0$var$compare3(x.value3)(y.value3);
        };
    },
    Eq0: function() {
        return $d254595454e6e9b0$export$9fe01c5d451d5493;
    }
};
var $d254595454e6e9b0$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(t1) {
        return function(t2) {
            return toDuration($d254595454e6e9b0$var$append1($d254595454e6e9b0$var$timeToMillis(t1))($d254595454e6e9b0$var$negateDuration($d254595454e6e9b0$var$timeToMillis(t2))));
        };
    };
};
var $d254595454e6e9b0$export$70fbaefa75d69ccd = /* #__PURE__ */ function() {
    return {
        bottom: new $d254595454e6e9b0$export$680ea196effce5f($69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$a07dd689fd52f43a), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$2e9ad76d003e68e6), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$14f9cc6a73419a24), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5)),
        top: new $d254595454e6e9b0$export$680ea196effce5f($69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$a07dd689fd52f43a), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$2e9ad76d003e68e6), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$14f9cc6a73419a24), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5)),
        Ord0: function() {
            return $d254595454e6e9b0$export$153601f213258a17;
        }
    };
}();
var $d254595454e6e9b0$var$maxTime = /* #__PURE__ */ $d254595454e6e9b0$var$timeToMillis(/* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($d254595454e6e9b0$export$70fbaefa75d69ccd));
var $d254595454e6e9b0$var$minTime = /* #__PURE__ */ $d254595454e6e9b0$var$timeToMillis(/* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($d254595454e6e9b0$export$70fbaefa75d69ccd));
var $d254595454e6e9b0$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(t) {
            var tLength = $d254595454e6e9b0$var$timeToMillis(t);
            var d$prime = fromDuration1(d);
            var wholeDays = $9a14cd925227149d$export$a3fe094919f356fd($d254595454e6e9b0$var$unwrap(d$prime) / 8.64e7);
            var msAdjust = $d254595454e6e9b0$var$append1(d$prime)($d254595454e6e9b0$var$negateDuration($d254595454e6e9b0$var$fromDuration(wholeDays)));
            var msAdjusted = $d254595454e6e9b0$var$append1(tLength)(msAdjust);
            var wrap = function() {
                var $157 = $d254595454e6e9b0$var$greaterThan(msAdjusted)($d254595454e6e9b0$var$maxTime);
                if ($157) return 1.0;
                var $158 = $d254595454e6e9b0$var$lessThan(msAdjusted)($d254595454e6e9b0$var$minTime);
                if ($158) return -1;
                return 0.0;
            }();
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($d254595454e6e9b0$var$append2(wholeDays)(wrap), $d254595454e6e9b0$var$millisToTime($d254595454e6e9b0$var$append1(msAdjusted)(8.64e7 * -wrap)));
        };
    };
};




var $18f2b327b2ac3376$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $18f2b327b2ac3376$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $18f2b327b2ac3376$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $18f2b327b2ac3376$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $18f2b327b2ac3376$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $18f2b327b2ac3376$var$fromEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $18f2b327b2ac3376$var$fromEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $18f2b327b2ac3376$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($7577649a7445e8e0$export$893a9e6d06ff9c67);
var $18f2b327b2ac3376$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($d254595454e6e9b0$export$a8b500dc61192962);
var $18f2b327b2ac3376$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($7577649a7445e8e0$export$4eced57d6183c43d);
var $18f2b327b2ac3376$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($d254595454e6e9b0$export$9fe01c5d451d5493);
var $18f2b327b2ac3376$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($7577649a7445e8e0$export$722593c82468f9f4);
var $18f2b327b2ac3376$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($d254595454e6e9b0$export$153601f213258a17);
var $18f2b327b2ac3376$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $18f2b327b2ac3376$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $18f2b327b2ac3376$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $18f2b327b2ac3376$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($06733ae99ed4f534$export$e5fea5661dee377);
var $18f2b327b2ac3376$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $18f2b327b2ac3376$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $18f2b327b2ac3376$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $18f2b327b2ac3376$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $18f2b327b2ac3376$var$toEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $18f2b327b2ac3376$var$toEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $18f2b327b2ac3376$var$toEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $18f2b327b2ac3376$export$82f9ebd9adeba146 = /* #__PURE__ */ function() {
    function DateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DateTime.create = function(value0) {
        return function(value1) {
            return new DateTime(value0, value1);
        };
    };
    return DateTime;
}();
var $18f2b327b2ac3376$var$toRecord = function(v) {
    return {
        year: $18f2b327b2ac3376$var$fromEnum($7577649a7445e8e0$export$31803937850fb2da(v.value0)),
        month: $18f2b327b2ac3376$var$fromEnum1($7577649a7445e8e0$export$af5de1609f06c8e6(v.value0)),
        day: $18f2b327b2ac3376$var$fromEnum2($7577649a7445e8e0$export$d2d39d1adcc883a2(v.value0)),
        hour: $18f2b327b2ac3376$var$fromEnum3($d254595454e6e9b0$export$842e383dfc19bc67(v.value1)),
        minute: $18f2b327b2ac3376$var$fromEnum4($d254595454e6e9b0$export$1cacba1045a8e790(v.value1)),
        second: $18f2b327b2ac3376$var$fromEnum5($d254595454e6e9b0$export$3d3c77ce7df7d30d(v.value1)),
        millisecond: $18f2b327b2ac3376$var$fromEnum6($d254595454e6e9b0$export$edc5e5cb87280477(v.value1))
    };
};
var $18f2b327b2ac3376$export$2da9be4cfdb689b1 = function(v) {
    return v.value1;
};
var $18f2b327b2ac3376$export$a1af12e21b57795a = {
    show: function(v) {
        return "(DateTime " + ($18f2b327b2ac3376$var$show(v.value0) + (" " + ($18f2b327b2ac3376$var$show1(v.value1) + ")")));
    }
};
var $18f2b327b2ac3376$export$1c14df74454c0d0b = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($18f2b327b2ac3376$export$82f9ebd9adeba146.create(v.value0))(f(v.value1));
        };
    };
};
var $18f2b327b2ac3376$export$26fd29b5462b0349 = function(f) {
    return function(v) {
        return new $18f2b327b2ac3376$export$82f9ebd9adeba146(v.value0, f(v.value1));
    };
};
var $18f2b327b2ac3376$export$715dbfedef2473ff = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($f57f4b701aa7b66e$export$8a83211c878a3f1f($18f2b327b2ac3376$export$82f9ebd9adeba146.create)(v.value1))(f(v.value0));
        };
    };
};
var $18f2b327b2ac3376$export$fd4b8ebd80749cf = function(f) {
    return function(v) {
        return new $18f2b327b2ac3376$export$82f9ebd9adeba146(f(v.value0), v.value1);
    };
};
var $18f2b327b2ac3376$export$a99463abb2339a45 = {
    eq: function(x) {
        return function(y) {
            return $18f2b327b2ac3376$var$eq(x.value0)(y.value0) && $18f2b327b2ac3376$var$eq1(x.value1)(y.value1);
        };
    }
};
var $18f2b327b2ac3376$export$e2fa58ffd7b3a1ab = {
    compare: function(x) {
        return function(y) {
            var v = $18f2b327b2ac3376$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $18f2b327b2ac3376$var$compare1(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $18f2b327b2ac3376$export$a99463abb2339a45;
    }
};
var $18f2b327b2ac3376$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($209026257f9663e4$export$345f31f1ea862984($18f2b327b2ac3376$var$toRecord(dt1), $18f2b327b2ac3376$var$toRecord(dt2)));
        };
    };
};
var $18f2b327b2ac3376$export$324d90190a8b822a = function(v) {
    return v.value0;
};
var $18f2b327b2ac3376$export$d0805f5a2dd21c64 = /* #__PURE__ */ function() {
    return {
        bottom: new $18f2b327b2ac3376$export$82f9ebd9adeba146($69d0e3dbb12088d2$export$40e543e69a8b3fbb($7577649a7445e8e0$export$590ef5e04dc36aa5), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($d254595454e6e9b0$export$70fbaefa75d69ccd)),
        top: new $18f2b327b2ac3376$export$82f9ebd9adeba146($69d0e3dbb12088d2$export$1e95b668f3b82d($7577649a7445e8e0$export$590ef5e04dc36aa5), $69d0e3dbb12088d2$export$1e95b668f3b82d($d254595454e6e9b0$export$70fbaefa75d69ccd)),
        Ord0: function() {
            return $18f2b327b2ac3376$export$e2fa58ffd7b3a1ab;
        }
    };
}();
var $18f2b327b2ac3376$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(dt) {
            return $18f2b327b2ac3376$var$bind($209026257f9663e4$export$e01c022ccf7c1b57($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value)(fromDuration(d))($18f2b327b2ac3376$var$toRecord(dt)))(function(rec) {
                return $18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($18f2b327b2ac3376$export$82f9ebd9adeba146.create)($18f2b327b2ac3376$var$join($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($7577649a7445e8e0$export$4803c954abcb09a)($18f2b327b2ac3376$var$toEnum(rec.year)))($18f2b327b2ac3376$var$toEnum1(rec.month)))($18f2b327b2ac3376$var$toEnum2(rec.day)))))($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($18f2b327b2ac3376$var$toEnum3(rec.hour)))($18f2b327b2ac3376$var$toEnum4(rec.minute)))($18f2b327b2ac3376$var$toEnum5(rec.second)))($18f2b327b2ac3376$var$toEnum6(rec.millisecond)));
            });
        };
    };
};









var $0e22ea1e74f8e3e7$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $0e22ea1e74f8e3e7$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $0e22ea1e74f8e3e7$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($3c54b6e6d30cc3be$export$1d3b9b5391a72ae7);
var $0e22ea1e74f8e3e7$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $0e22ea1e74f8e3e7$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$a07dd689fd52f43a);
var $0e22ea1e74f8e3e7$var$bottom1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$2e9ad76d003e68e6);
var $0e22ea1e74f8e3e7$var$bottom2 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$14f9cc6a73419a24);
var $0e22ea1e74f8e3e7$var$bottom3 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5);
var $0e22ea1e74f8e3e7$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$def67087bd72fdb7);
var $0e22ea1e74f8e3e7$var$negateDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$28743521ea1cb8f9($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $0e22ea1e74f8e3e7$var$Instant = function(x) {
    return x;
};
var $0e22ea1e74f8e3e7$export$d09033f410e6cbd8 = function(v) {
    return v;
};
var $0e22ea1e74f8e3e7$export$c2dea5c02f48568d = /* #__PURE__ */ function() {
    var mkDateTime = function(y) {
        return function(mo) {
            return function(d) {
                return function(h) {
                    return function(mi) {
                        return function(s) {
                            return function(ms) {
                                return new $18f2b327b2ac3376$export$82f9ebd9adeba146($7577649a7445e8e0$export$e352e11a7fa73bba(y)($0e22ea1e74f8e3e7$var$fromJust($0e22ea1e74f8e3e7$var$toEnum(mo)))(d), new $d254595454e6e9b0$export$680ea196effce5f(h, mi, s, ms));
                            };
                        };
                    };
                };
            };
        };
    };
    return $4261ba653755ead8$export$e7e4adb27c12afea(mkDateTime);
}();
var $0e22ea1e74f8e3e7$export$84fb2716d05f64f3 = {
    show: function(v) {
        return "(Instant " + ($0e22ea1e74f8e3e7$var$show(v) + ")");
    }
};
var $0e22ea1e74f8e3e7$export$e2fa58ffd7b3a1ab = $3c54b6e6d30cc3be$export$e0a5c04af6395341;
var $0e22ea1e74f8e3e7$export$6e4cd7a6d73ce13e = function(v) {
    if (v >= -8639977881600000 && v <= 8.639977881599999e15) return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.DateTime.Instant (line 44, column 1 - line 44, column 41): " + [
        v.constructor.name
    ]);
};
var $0e22ea1e74f8e3e7$export$e141e740b7704cc4 = function(v) {
    return $4261ba653755ead8$export$4ceb5c6f8416b1d0($7577649a7445e8e0$export$31803937850fb2da(v.value0), $0e22ea1e74f8e3e7$var$fromEnum($7577649a7445e8e0$export$af5de1609f06c8e6(v.value0)), $7577649a7445e8e0$export$d2d39d1adcc883a2(v.value0), $d254595454e6e9b0$export$842e383dfc19bc67(v.value1), $d254595454e6e9b0$export$1cacba1045a8e790(v.value1), $d254595454e6e9b0$export$3d3c77ce7df7d30d(v.value1), $d254595454e6e9b0$export$edc5e5cb87280477(v.value1));
};
var $0e22ea1e74f8e3e7$export$e57ff100d91bd4b9 = function(d) {
    return $4261ba653755ead8$export$4ceb5c6f8416b1d0($7577649a7445e8e0$export$31803937850fb2da(d), $0e22ea1e74f8e3e7$var$fromEnum($7577649a7445e8e0$export$af5de1609f06c8e6(d)), $7577649a7445e8e0$export$d2d39d1adcc883a2(d), $0e22ea1e74f8e3e7$var$bottom, $0e22ea1e74f8e3e7$var$bottom1, $0e22ea1e74f8e3e7$var$bottom2, $0e22ea1e74f8e3e7$var$bottom3);
};
var $0e22ea1e74f8e3e7$export$a99463abb2339a45 = $3c54b6e6d30cc3be$export$699cb56941ecf990;
var $0e22ea1e74f8e3e7$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($0e22ea1e74f8e3e7$var$append1($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(dt1))($0e22ea1e74f8e3e7$var$negateDuration($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(dt2))));
        };
    };
};
var $0e22ea1e74f8e3e7$export$af36687d2b3e6466 = /* #__PURE__ */ function() {
    return {
        bottom: -8639977881600000,
        top: 8.639977881599999e15,
        Ord0: function() {
            return $0e22ea1e74f8e3e7$export$e2fa58ffd7b3a1ab;
        }
    };
}();


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15


// Generated by purs version 0.15.15




// Generated by purs version 0.15.15






var $826fbbc6c8d1e9e2$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $826fbbc6c8d1e9e2$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $826fbbc6c8d1e9e2$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $826fbbc6c8d1e9e2$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $826fbbc6c8d1e9e2$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($2a035e92dc768ac1$export$d2871cfbf3cbd4f2);
var $826fbbc6c8d1e9e2$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $826fbbc6c8d1e9e2$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0) {
        this.value0 = value0;
    }
    TypeMismatch.create = function(value0) {
        return new TypeMismatch(value0);
    };
    return TypeMismatch;
}();
var $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 = /* #__PURE__ */ function() {
    function UnexpectedValue(value0) {
        this.value0 = value0;
    }
    UnexpectedValue.create = function(value0) {
        return new UnexpectedValue(value0);
    };
    return UnexpectedValue;
}();
var $826fbbc6c8d1e9e2$export$d58b23382c8562e = /* #__PURE__ */ function() {
    function AtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtIndex.create = function(value0) {
        return function(value1) {
            return new AtIndex(value0, value1);
        };
    };
    return AtIndex;
}();
var $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 = /* #__PURE__ */ function() {
    function AtKey(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtKey.create = function(value0) {
        return function(value1) {
            return new AtKey(value0, value1);
        };
    };
    return AtKey;
}();
var $826fbbc6c8d1e9e2$export$4e021928efe6b6bd = /* #__PURE__ */ function() {
    function Named(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Named.create = function(value0) {
        return function(value1) {
            return new Named(value0, value1);
        };
    };
    return Named;
}();
var $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 = /* #__PURE__ */ function() {
    function MissingValue() {}
    MissingValue.value = new MissingValue();
    return MissingValue;
}();
var $826fbbc6c8d1e9e2$export$d3ac27ab5a0173d = {
    show: function(v) {
        if (v instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return "(TypeMismatch " + ($826fbbc6c8d1e9e2$var$show(v.value0) + ")");
        if (v instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return "(UnexpectedValue " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ")");
        if (v instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return "(AtIndex " + ($826fbbc6c8d1e9e2$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return "(AtKey " + ($826fbbc6c8d1e9e2$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return "(Named " + ($826fbbc6c8d1e9e2$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return "MissingValue";
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 24, column 10 - line 30, column 35): " + [
            v.constructor.name
        ]);
    }
};
var $826fbbc6c8d1e9e2$export$f0345d087708be2e = function(err) {
    var go = function(v) {
        if (v instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return "  Expected value of type '" + (v.value0 + "'.");
        if (v instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return "  Unexpected value " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ".");
        if (v instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return "  At array index " + ($826fbbc6c8d1e9e2$var$show1(v.value0) + (":\n" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return "  At object key '" + (v.value0 + ("':\n" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return "  Under '" + (v.value0 + ("':\n" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return "  No value was found.";
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 37, column 8 - line 43, column 44): " + [
            v.constructor.name
        ]);
    };
    return "An error occurred while decoding a JSON value:\n" + go(err);
};
var $826fbbc6c8d1e9e2$export$57ecdac35deb6f24 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$168e2d3b16829a(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$d58b23382c8562e(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value;
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 21, column 1 - line 21, column 68): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))));
        if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1)))));
        if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))))));
        if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))));
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 21, column 1 - line 21, column 68): " + [
            x.constructor.name
        ]);
    }
};
var $826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a && y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return x.value0 === y.value0;
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 && y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $826fbbc6c8d1e9e2$var$eq1(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e && y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 && y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd && y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 && y instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return true;
            return false;
        };
    }
};
var $826fbbc6c8d1e9e2$export$e25e82e4962e5280 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a && y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 && y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $826fbbc6c8d1e9e2$var$compare1(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e && y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) {
                var v = $826fbbc6c8d1e9e2$var$compare2(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 && y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) {
                var v = $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd && y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) {
                var v = $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 && y instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa;
    }
};



// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
const $b54742048bb717e1$export$2e94f3cfb1cd0b3b = function(f, xs) {
    var acc = xs[xs.length - 1];
    for(var i = xs.length - 2; i >= 0; i--)acc = f(xs[i])(acc);
    return acc;
};
const $b54742048bb717e1$export$a723804e3f3d0e95 = function(f, xs) {
    var acc = xs[0];
    var len = xs.length;
    for(var i = 1; i < len; i++)acc = f(acc)(xs[i]);
    return acc;
};
const $b54742048bb717e1$export$c510f955a36e0bd4 = function() {
    function Cont(fn) {
        this.fn = fn;
    }
    var emptyList = {};
    var ConsCell = function(head, tail) {
        this.head = head;
        this.tail = tail;
    };
    function finalCell(head) {
        return new ConsCell(head, emptyList);
    }
    function consList(x) {
        return function(xs) {
            return new ConsCell(x, xs);
        };
    }
    function listToArray(list) {
        var arr = [];
        var xs = list;
        while(xs !== emptyList){
            arr.push(xs.head);
            xs = xs.tail;
        }
        return arr;
    }
    return function(apply, map, f) {
        var buildFrom = function(x, ys) {
            return apply(map(consList)(f(x)))(ys);
        };
        var go = function(acc, currentLen, xs) {
            if (currentLen === 0) return acc;
            else {
                var last = xs[currentLen - 1];
                return new Cont(function() {
                    var built = go(buildFrom(last, acc), currentLen - 1, xs);
                    return built;
                });
            }
        };
        return function(array) {
            var acc = map(finalCell)(f(array[array.length - 1]));
            var result = go(acc, array.length - 1, array);
            while(result instanceof Cont)result = result.fn();
            return map(listToArray)(result);
        };
    };
}();





















var $91ee3359f6bcea22$export$f2d78e4bd16a0737 = function(x) {
    return x;
};
var $91ee3359f6bcea22$export$5cc19ce746f40583 = $cf5af1199a495394$export$587ba9a9bf3cf8b4;
var $91ee3359f6bcea22$export$24956e78dc18af4a = $2c7a64ff78781336$export$96888504550934b5;
var $91ee3359f6bcea22$export$81b6a4240b5ed5ff = $11d1e86de605dfc6$export$9e4a28683e28e26a;
var $91ee3359f6bcea22$export$58eaac0549d62906 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(v) {
            return "(NonEmptyArray " + (show(v) + ")");
        }
    };
};
var $91ee3359f6bcea22$export$7e27c982686236c = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $91ee3359f6bcea22$export$ba5ac798a83b9940 = function(dictOrd) {
    return $97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd);
};
var $91ee3359f6bcea22$export$576ea700d31dfbbe = $97937c29f879e68e$export$8e34cc59438cf1bf;
var $91ee3359f6bcea22$export$b6607029fd0e1ebc = $d3d065da31679be1$export$68aea3a98a23c265;
var $91ee3359f6bcea22$export$e1a7484e8d239345 = $334541180b4ef18c$export$f10d51ea0aa3da42;
var $91ee3359f6bcea22$export$cf42eb1af12f469e = $f4b2eb11fc32ed34$export$2330f868b62ed546;
var $91ee3359f6bcea22$export$277d8f0716691388 = $519ef1967f17d101$export$e728f47f20b1eb28;
var $91ee3359f6bcea22$export$7090c31be3a1e8ea = $4fe7b6acfba7f29f$export$e97014618a7eb593;
var $91ee3359f6bcea22$export$33591d20dac5147e = {
    foldMap1: function(dictSemigroup) {
        return $086486679aa806fa$export$3341743d361f5644($91ee3359f6bcea22$export$33591d20dac5147e)($91ee3359f6bcea22$export$cf42eb1af12f469e)(dictSemigroup);
    },
    foldr1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$2e94f3cfb1cd0b3b),
    foldl1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$a723804e3f3d0e95),
    Foldable0: function() {
        return $91ee3359f6bcea22$export$7090c31be3a1e8ea;
    }
};
var $91ee3359f6bcea22$export$a72b8d310e29f00f = {
    traverse1: function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return $b54742048bb717e1$export$c510f955a36e0bd4(apply, map, f);
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($91ee3359f6bcea22$export$a72b8d310e29f00f)(dictApply);
    },
    Foldable10: function() {
        return $91ee3359f6bcea22$export$33591d20dac5147e;
    },
    Traversable1: function() {
        return $91ee3359f6bcea22$export$81b6a4240b5ed5ff;
    }
};
var $91ee3359f6bcea22$export$e2c877c9efbd93a4 = function(dictEq) {
    return $37b880af5f4991bd$export$159e06dc5ec60b00(dictEq);
};
var $91ee3359f6bcea22$export$5f4f90502fd988f7 = $37b880af5f4991bd$export$861eb926e0b8ea5b;
var $91ee3359f6bcea22$export$4b9e170bb3e49bd0 = $70cd3177464e7915$export$794f9574ca20b986;
var $91ee3359f6bcea22$export$8f8661c5387016c3 = $7576d3a958d66ab0$export$60d7bd9d686a5521;
var $91ee3359f6bcea22$export$df94f54a91732973 = $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
var $91ee3359f6bcea22$export$4d39f82ee37f3a51 = $75e93a4111e80214$export$186d613bb872946c;
















var $e39dfcf102cdca3c$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $e39dfcf102cdca3c$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $e39dfcf102cdca3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $e39dfcf102cdca3c$var$intercalate1 = /* #__PURE__ */ $086486679aa806fa$export$739ec22334c44788($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$foldMap11 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fold11 = /* #__PURE__ */ $086486679aa806fa$export$2e430a6d03f6ee23($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $e39dfcf102cdca3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$var$unsafeFromArrayF = $ac8b3532514ac019$export$401372c57776dc;
var $e39dfcf102cdca3c$var$unsafeFromArray = $91ee3359f6bcea22$export$f2d78e4bd16a0737;
var $e39dfcf102cdca3c$export$9cb09a71b7d66923 = function($99) {
    return $e39dfcf102cdca3c$var$coerce($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($99)));
};
var $e39dfcf102cdca3c$export$45b10814cc054894 = function(v) {
    return v;
};
var $e39dfcf102cdca3c$export$c2d77a2584a0f97e = function(eq) {
    return function(xs) {
        var $100 = $396c4c3d9e7fae3c$export$ef1d06dc4d91d507(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
        return function($101) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($100($101));
        };
    };
};
var $e39dfcf102cdca3c$export$437026b4e0b5fcf6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$c2d77a2584a0f97e($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        var $102 = $e39dfcf102cdca3c$export$c2d77a2584a0f97e(eq)(xs);
        return function($103) {
            return $102($e39dfcf102cdca3c$export$45b10814cc054894($103));
        };
    };
};
var $e39dfcf102cdca3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    var $104 = $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188)($e39dfcf102cdca3c$var$unsafeFromArray)($e39dfcf102cdca3c$var$unsafeFromArray);
    return function($105) {
        return $104($396c4c3d9e7fae3c$export$23c8d3f8757cab88($e39dfcf102cdca3c$export$45b10814cc054894($105)));
    };
}();
var $e39dfcf102cdca3c$export$b6d8713d53419d4c = function(i) {
    return function(x) {
        var $106 = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(x);
        return function($107) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($106($e39dfcf102cdca3c$export$45b10814cc054894($107)));
        };
    };
};
var $e39dfcf102cdca3c$export$8901015135f2fb22 = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8901015135f2fb22($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$b634740ce272acb5(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
        };
    };
};
var $e39dfcf102cdca3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var zipWithA1 = $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return $e39dfcf102cdca3c$var$unsafeFromArrayF(zipWithA1(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
            };
        };
    };
};
var $e39dfcf102cdca3c$export$b0d75975ac0be0e1 = function(i) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b0d75975ac0be0e1(i)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var some1 = $396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative);
    return function(dictLazy) {
        var $108 = some1(dictLazy);
        return function($109) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($108($109));
        };
    };
};
var $e39dfcf102cdca3c$export$5b6d1d165591a48c = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397(xs)(x));
    };
};
var $e39dfcf102cdca3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397($e39dfcf102cdca3c$export$45b10814cc054894(xs))(x));
    };
};
var $e39dfcf102cdca3c$export$439306a4dcaafbb9 = function($110) {
    return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$439306a4dcaafbb9($110));
};
var $e39dfcf102cdca3c$export$606959e7ccb797f0 = function(i) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$606959e7ccb797f0($e39dfcf102cdca3c$var$max(1)(i))(x));
    };
};
var $e39dfcf102cdca3c$export$d02631cccf789723 = function(x) {
    return function(y) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$d02631cccf789723(x)(y));
    };
};
var $e39dfcf102cdca3c$export$25b721c466a8ec4a = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append(xs)($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        var $111 = $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb(i)(f);
        return function($112) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($111($e39dfcf102cdca3c$export$45b10814cc054894($112)));
        };
    };
};
var $e39dfcf102cdca3c$export$df22145cad61b1dc = function(eq) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        var $113 = $e39dfcf102cdca3c$export$df22145cad61b1dc(eq)(xs);
        return function($114) {
            return $113($e39dfcf102cdca3c$export$45b10814cc054894($114));
        };
    };
};
var $e39dfcf102cdca3c$export$5c3f7b482f544831 = function(dictEq) {
    return $e39dfcf102cdca3c$export$df22145cad61b1dc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$1f4807a235930d45 = function(dictEq) {
    return $e39dfcf102cdca3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$739ec22334c44788 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$intercalate1(dictSemigroup);
};
var $e39dfcf102cdca3c$export$9f200c4466975173 = function(i) {
    return function(x) {
        var $115 = $396c4c3d9e7fae3c$export$9f200c4466975173(i)(x);
        return function($116) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($115($e39dfcf102cdca3c$export$45b10814cc054894($116)));
        };
    };
};
var $e39dfcf102cdca3c$export$95b95426129653f6 = function(dictFoldable1) {
    var $117 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable1.Foldable0());
    return function($118) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($117($118));
    };
};
var $e39dfcf102cdca3c$export$571d59b505e6bb4e = function(xs) {
    if ($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) > 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e39dfcf102cdca3c$var$unsafeFromArray(xs));
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Array.NonEmpty (line 161, column 1 - line 161, column 58): " + [
        xs.constructor.name
    ]);
};
var $e39dfcf102cdca3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $119 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function($120) {
        return $e39dfcf102cdca3c$export$571d59b505e6bb4e($119($120));
    };
};
var $e39dfcf102cdca3c$export$55f57584ad1f8cc9 = function($121) {
    return $e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($121)));
};
var $e39dfcf102cdca3c$export$c8b99533c112636f = /* #__PURE__ */ $086486679aa806fa$export$c8b99533c112636f($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$eb5e1ef4ea2eca3d = /* #__PURE__ */ $086486679aa806fa$export$eb5e1ef4ea2eca3d($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$b50c31bb8aebd2a7 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$foldMap11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$2e430a6d03f6ee23 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$fold11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$244bb8babc536271 = function(dictEq) {
    var difference1 = $396c4c3d9e7fae3c$export$acaf96a27438246b(dictEq);
    return function(xs) {
        return difference1($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x)(xs));
    };
};
var $e39dfcf102cdca3c$export$1d4c49925323035a = function(v) {
    return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(v.value0)(v.value1);
};
var $e39dfcf102cdca3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($91ee3359f6bcea22$export$4b9e170bb3e49bd0));
var $e39dfcf102cdca3c$export$ee1b3e54f0441b22 = /* #__PURE__ */ function() {
    var $122 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e)($e39dfcf102cdca3c$export$45b10814cc054894);
    return function($123) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($fc8c1182ec2aefec$export$ee1b3e54f0441b22($e39dfcf102cdca3c$export$45b10814cc054894($122($123))));
    };
}();
var $e39dfcf102cdca3c$export$caf8a2f37e9533e = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append($e39dfcf102cdca3c$export$45b10814cc054894(xs))(ys));
    };
};
var $e39dfcf102cdca3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        var $124 = $396c4c3d9e7fae3c$export$2dd9d44f93be5e22(i)(f);
        return function($125) {
            return $124($e39dfcf102cdca3c$export$45b10814cc054894($125));
        };
    };
};
var $e39dfcf102cdca3c$var$adaptMaybe = function(f) {
    return function($126) {
        return $e39dfcf102cdca3c$var$fromJust(f($e39dfcf102cdca3c$export$45b10814cc054894($126)));
    };
};
var $e39dfcf102cdca3c$export$5fd5031fecdacec3 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$5fd5031fecdacec3);
var $e39dfcf102cdca3c$export$2cd8252107eb640b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$2cd8252107eb640b);
var $e39dfcf102cdca3c$export$4c7897fafd92b108 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$4c7897fafd92b108);
var $e39dfcf102cdca3c$export$c01875f616615628 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$c01875f616615628);
var $e39dfcf102cdca3c$export$b446f6baa3bb1430 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$b446f6baa3bb1430);
var $e39dfcf102cdca3c$export$bdf81af0000aaf5a = function($127) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.head, v.tail);
    }($e39dfcf102cdca3c$export$b446f6baa3bb1430($127));
};
var $e39dfcf102cdca3c$export$712962e076096ed4 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$712962e076096ed4);
var $e39dfcf102cdca3c$var$adaptAny = function(f) {
    return function($128) {
        return f($e39dfcf102cdca3c$export$45b10814cc054894($128));
    };
};
var $e39dfcf102cdca3c$export$84bf76cd7afc7469 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$84bf76cd7afc7469(p));
};
var $e39dfcf102cdca3c$export$4154a199d7d90455 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$4154a199d7d90455(p));
};
var $e39dfcf102cdca3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$986c2bbe7a34be0b);
var $e39dfcf102cdca3c$export$1822828d790e23ee = function(dictEq) {
    var delete1 = $396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(delete1(x));
    };
};
var $e39dfcf102cdca3c$export$90f9093465da3136 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$90f9093465da3136(i));
};
var $e39dfcf102cdca3c$export$9ea2b6c3fae093d8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$acaf96a27438246b = function(dictEq) {
    var difference$prime1 = $e39dfcf102cdca3c$export$244bb8babc536271(dictEq);
    return function(xs) {
        return $e39dfcf102cdca3c$var$adaptAny(difference$prime1(xs));
    };
};
var $e39dfcf102cdca3c$export$663103110d94aac9 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$663103110d94aac9(i));
};
var $e39dfcf102cdca3c$export$2b3b686e33c80c56 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$2b3b686e33c80c56(i));
};
var $e39dfcf102cdca3c$export$533af5c8cd6afa16 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$533af5c8cd6afa16(f));
};
var $e39dfcf102cdca3c$export$5bf96401662340b7 = function(dictEq) {
    var elem1 = $396c4c3d9e7fae3c$export$5bf96401662340b7(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elem1(x));
    };
};
var $e39dfcf102cdca3c$export$f444781b0adb7e4d = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$c19d79386f4ed99a = function(dictEq) {
    var elemLastIndex1 = $396c4c3d9e7fae3c$export$c19d79386f4ed99a(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemLastIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$3dea766d36a8935f = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$3dea766d36a8935f(f));
};
var $e39dfcf102cdca3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var filterA1 = $396c4c3d9e7fae3c$export$e6e803076c284bc5(dictApplicative);
    return function(f) {
        return $e39dfcf102cdca3c$var$adaptAny(filterA1(f));
    };
};
var $e39dfcf102cdca3c$export$71aa6c912b956294 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$71aa6c912b956294(p));
};
var $e39dfcf102cdca3c$export$de3a4d4a0d731119 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$de3a4d4a0d731119(p));
};
var $e39dfcf102cdca3c$export$8855a8be7bd3e9f8 = function(x) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(x));
};
var $e39dfcf102cdca3c$export$23e5dcedfce4509c = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$23e5dcedfce4509c(p));
};
var $e39dfcf102cdca3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var foldM1 = $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var foldRecM1 = $396c4c3d9e7fae3c$export$61b0588efceffce4(dictMonadRec);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldRecM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$b610b8812bbcded9 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b610b8812bbcded9);
var $e39dfcf102cdca3c$export$f24224f1c91d8156 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($fc8c1182ec2aefec$export$f24224f1c91d8156);
var $e39dfcf102cdca3c$export$e70771d2e7e590a = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$e70771d2e7e590a(f));
};
var $e39dfcf102cdca3c$export$63faa62a0284a4a6 = function(dictEq) {
    var notElem1 = $396c4c3d9e7fae3c$export$63faa62a0284a4a6(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(notElem1(x));
    };
};
var $e39dfcf102cdca3c$export$b29f828819edca8d = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b29f828819edca8d(f));
};
var $e39dfcf102cdca3c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$58adb3bec8346d0f(start)(end));
    };
};
var $e39dfcf102cdca3c$export$afc1bfabebaf28a2 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$afc1bfabebaf28a2(f));
};
var $e39dfcf102cdca3c$export$b7df5d561049483a = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b7df5d561049483a(i));
};
var $e39dfcf102cdca3c$export$9100289823a975b0 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9100289823a975b0(i));
};
var $e39dfcf102cdca3c$export$9384c7afe4015e42 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9384c7afe4015e42(f));
};
var $e39dfcf102cdca3c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable));
};
var $e39dfcf102cdca3c$var$unsafeAdapt = function(f) {
    var $129 = $e39dfcf102cdca3c$var$adaptAny(f);
    return function($130) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($129($130));
    };
};
var $e39dfcf102cdca3c$export$8327ebbef2a0ba76 = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x));
};
var $e39dfcf102cdca3c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$e5e25fbcc1f7affe(dictEq));
};
var $e39dfcf102cdca3c$export$1f7a5bf12caafbd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$1f7a5bf12caafbd(op));
};
var $e39dfcf102cdca3c$export$361434b95a7d965 = function(dictOrd) {
    return $e39dfcf102cdca3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $e39dfcf102cdca3c$export$3f063810d7bf01bd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$3f063810d7bf01bd(op));
};
var $e39dfcf102cdca3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff(dictOrd);
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(insert1(x));
    };
};
var $e39dfcf102cdca3c$export$b8bc901090d2b1d4 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b8bc901090d2b1d4(f)(x));
    };
};
var $e39dfcf102cdca3c$export$af200dcf8b7cb5de = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$af200dcf8b7cb5de(x));
};
var $e39dfcf102cdca3c$export$8f07ddce13659f50 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8f07ddce13659f50(f));
};
var $e39dfcf102cdca3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var modifyAtIndices1 = $396c4c3d9e7fae3c$export$7fd3d81fba5daa58(dictFoldable);
    return function(is) {
        return function(f) {
            return $e39dfcf102cdca3c$var$unsafeAdapt(modifyAtIndices1(is)(f));
        };
    };
};
var $e39dfcf102cdca3c$export$94f4066a75b10404 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$94f4066a75b10404(dictOrd));
};
var $e39dfcf102cdca3c$export$18f77a3bafa759b9 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$18f77a3bafa759b9(f));
};
var $e39dfcf102cdca3c$export$45273896c792ff3b = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$45273896c792ff3b(f));
};
var $e39dfcf102cdca3c$export$edce5881c815871 = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$edce5881c815871(dictEq));
};
var $e39dfcf102cdca3c$export$66c1ae025e96b4bc = /* #__PURE__ */ $e39dfcf102cdca3c$var$unsafeAdapt($fc8c1182ec2aefec$export$66c1ae025e96b4bc);
var $e39dfcf102cdca3c$export$65f513eaf3c582b8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$65f513eaf3c582b8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$64df51ac031d4ad2 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$64df51ac031d4ad2(f)(x));
    };
};
var $e39dfcf102cdca3c$export$97db5808d8f88186 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$97db5808d8f88186(dictOrd));
};
var $e39dfcf102cdca3c$export$b035e44d7bb4278f = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b035e44d7bb4278f(f));
};
var $e39dfcf102cdca3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var sortWith1 = $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde(dictOrd);
    return function(f) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(sortWith1(f));
    };
};
var $e39dfcf102cdca3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var updateAtIndices1 = $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257(dictFoldable);
    return function(pairs) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(updateAtIndices1(pairs));
    };
};
var $e39dfcf102cdca3c$export$90bcd20c17ae578e = function() {
    return $e39dfcf102cdca3c$var$adaptAny($e39dfcf102cdca3c$var$unsafeIndex1);
};
var $e39dfcf102cdca3c$var$unsafeIndex2 = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$export$d1f81bca2a8c7b07 = function(dictUnfoldable1) {
    var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(xs) {
        var len = $e39dfcf102cdca3c$export$f24224f1c91d8156(xs);
        var f = function(i) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($e39dfcf102cdca3c$var$unsafeIndex2(xs)(i), function() {
                var $98 = i < (len - 1 | 0);
                if ($98) return new $06733ae99ed4f534$export$8a67b48435b5d073(i + 1 | 0);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }());
        };
        return unfoldr1(f)(0);
    };
};

















// Generated by purs version 0.15.15













var $a393155e52307a24$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $a393155e52307a24$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $a393155e52307a24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $a393155e52307a24$var$$$Set = function(x) {
    return x;
};
var $a393155e52307a24$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd));
};
var $a393155e52307a24$export$e03c1c3201ee8bb7 = function(dictOrd) {
    var alter = $ea3eb84de0acf574$export$22a7378e1d3307a4(dictOrd);
    return function(a) {
        return function(v) {
            return alter($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342))(function(v1) {
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }))(a)(v);
        };
    };
};
var $a393155e52307a24$export$e98af36a72b77685 = function(v) {
    return v;
};
var $a393155e52307a24$var$toList = function(v) {
    return $ea3eb84de0acf574$export$ed97f33186d4b816(v);
};
var $a393155e52307a24$export$823be24f8766da23 = function(dictUnfoldable) {
    var $96 = $3d4fd987da5242ff$export$823be24f8766da23(dictUnfoldable);
    return function($97) {
        return $96($a393155e52307a24$var$toList($97));
    };
};
var $a393155e52307a24$var$toUnfoldable1 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $a393155e52307a24$export$346677f925de839c = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$346677f925de839c);
var $a393155e52307a24$export$439306a4dcaafbb9 = function(a) {
    return $ea3eb84de0acf574$export$439306a4dcaafbb9(a)($05149ea687d6b460$export$523c0b569236b342);
};
var $a393155e52307a24$export$10430edbe04e7f5c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(s) {
            return "(fromFoldable " + (show($a393155e52307a24$var$toUnfoldable1(s)) + ")");
        }
    };
};
var $a393155e52307a24$export$7c6a06df4f9b9fb3 = function(dictOrd) {
    return {
        append: $a393155e52307a24$export$971dd5b0dfd021b6(dictOrd)
    };
};
var $a393155e52307a24$export$6a0d13241802fe80 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6a0d13241802fe80(dictOrd));
};
var $a393155e52307a24$export$dd1bc94b04021eeb = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$dd1bc94b04021eeb);
var $a393155e52307a24$export$bc86dfbf7795668c = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$bc86dfbf7795668c(dictOrd));
};
var $a393155e52307a24$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(a) {
        return function(v) {
            return insert1(a)($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    };
};
var $a393155e52307a24$export$d81aa96f14f987cc = $a393155e52307a24$var$$$Set;
var $a393155e52307a24$export$fd19c21b7e75dff0 = {
    foldMap: function(dictMonoid) {
        var foldMap1 = $a393155e52307a24$var$foldMap(dictMonoid);
        return function(f) {
            var $98 = foldMap1(f);
            return function($99) {
                return $98($a393155e52307a24$var$toList($99));
            };
        };
    },
    foldl: function(f) {
        return function(x) {
            var $100 = $a393155e52307a24$var$foldl(f)(x);
            return function($101) {
                return $100($a393155e52307a24$var$toList($101));
            };
        };
    },
    foldr: function(f) {
        return function(x) {
            var $102 = $a393155e52307a24$var$foldr(f)(x);
            return function($103) {
                return $102($a393155e52307a24$var$toList($103));
            };
        };
    }
};
var $a393155e52307a24$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$export$3c39a95b7a4d5e28 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$3c39a95b7a4d5e28(v));
};
var $a393155e52307a24$export$35f577b3da447d17 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$35f577b3da447d17(v));
};
var $a393155e52307a24$export$3dea766d36a8935f = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$151f9a87a7fd5652(dictOrd));
};
var $a393155e52307a24$export$15038a5bf6277d57 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($ea3eb84de0acf574$export$85aac4508ff70b8(dictEq)($37b880af5f4991bd$export$671c8820f3b36bad));
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v)(v1);
            };
        }
    };
};
var $a393155e52307a24$export$273c875222ee923d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqSet1 = $a393155e52307a24$export$15038a5bf6277d57(dictOrd.Eq0());
    return {
        compare: function(s1) {
            return function(s2) {
                return compare($a393155e52307a24$var$toList(s1))($a393155e52307a24$var$toList(s2));
            };
        },
        Eq0: function() {
            return eqSet1;
        }
    };
};
var $a393155e52307a24$export$886f72205c1e73dc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($a393155e52307a24$export$15038a5bf6277d57(dictEq));
    }
};
var $a393155e52307a24$export$3f209a28ab615424 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($a393155e52307a24$export$273c875222ee923d(dictOrd));
    },
    Eq10: function() {
        return $a393155e52307a24$export$886f72205c1e73dc;
    }
};
var $a393155e52307a24$export$6e22c362a0406a2c = $ea3eb84de0acf574$export$6e22c362a0406a2c;
var $a393155e52307a24$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
        return foldl2(function(m) {
            return function(a) {
                return insert1(a)(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$871de8747c9eaa88 = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldl1(function(m) {
            return function(a) {
                return insert1(f(a))(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$e70771d2e7e590a = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldr1(function(a) {
            return function(acc) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(b) {
                    return insert1(b)(acc);
                })(f(a));
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$30c0d87180d1a2c7 = function(dictOrd) {
    var semigroupSet1 = $a393155e52307a24$export$7c6a06df4f9b9fb3(dictOrd);
    return {
        mempty: $a393155e52307a24$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupSet1;
        }
    };
};
var $a393155e52307a24$export$30b2db2f7030f6cf = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        return foldl2($a393155e52307a24$export$971dd5b0dfd021b6(dictOrd))($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$acaf96a27438246b = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$acaf96a27438246b(dictOrd));
};
var $a393155e52307a24$export$e06bd7b1ab877a71 = function(dictOrd) {
    var difference1 = $a393155e52307a24$export$acaf96a27438246b(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$dd1bc94b04021eeb(difference1(s1)(s2));
        };
    };
};
var $a393155e52307a24$export$fed8bbb04775a01f = function(dictOrd) {
    var subset1 = $a393155e52307a24$export$e06bd7b1ab877a71(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$346677f925de839c(s1) !== $a393155e52307a24$export$346677f925de839c(s2) && subset1(s1)(s2);
        };
    };
};
var $a393155e52307a24$export$1822828d790e23ee = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$1822828d790e23ee(dictOrd));
};
var $a393155e52307a24$export$6583e3e95cb5e9d1 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6583e3e95cb5e9d1(dictOrd));
};
var $a393155e52307a24$export$986c2bbe7a34be0b = function(dictOrd) {
    return $a393155e52307a24$export$e70771d2e7e590a(dictOrd)($a393155e52307a24$var$identity);
};



// Generated by purs version 0.15.15











var $5505a3400147efbd$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $5505a3400147efbd$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377);
var $5505a3400147efbd$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $5505a3400147efbd$export$5e0a9ee3d3833c14 = function(x) {
    return x;
};
var $5505a3400147efbd$export$b6a781e0c851762d = function(x) {
    return x;
};
var $5505a3400147efbd$export$43df7fc17cca38a4 = function(v) {
    return $5b07e36f812dd04b$export$43df7fc17cca38a4(v);
};
var $5505a3400147efbd$export$f84e8e69fd4488a5 = function(v) {
    return v;
};
var $5505a3400147efbd$export$b1ceac3893cbda6b = function(v) {
    return $5b07e36f812dd04b$export$b1ceac3893cbda6b(v);
};
var $5505a3400147efbd$export$9c23a244a4c30cab = {
    show: function(v) {
        return "(NonEmptyString.unsafeFromString " + ($5505a3400147efbd$var$show(v) + ")");
    }
};
var $5505a3400147efbd$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $5505a3400147efbd$export$744c07e924c63a64 = {
    show: function(v) {
        return "(NonEmptyReplacement " + ($5505a3400147efbd$var$show1(v) + ")");
    }
};
var $5505a3400147efbd$export$d35c69c74cf52f2a = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $5505a3400147efbd$export$f2627aa412761e90 = $5505a3400147efbd$export$d35c69c74cf52f2a;
var $5505a3400147efbd$export$b8b3234b4edfc4c2 = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$b8b3234b4edfc4c2(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$77ad94ebf1c2b9ed = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$77ad94ebf1c2b9ed(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$8e478561c4b63c72 = function(s1) {
    return function(v) {
        return s1 + v;
    };
};
var $5505a3400147efbd$export$5dc47cd73bc6c69d = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $5505a3400147efbd$export$c5ad7bed4061c986 = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $5505a3400147efbd$export$17c9b383a1071b74 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return {
        nes: function(p) {
            return reflectSymbol(p);
        }
    };
};
var $5505a3400147efbd$export$1a8016356aadf775 = function(dict) {
    return dict.nes;
};
var $5505a3400147efbd$export$632efc9d6c44380 = function() {
    return {
        nes: function(v) {
            return "";
        }
    };
};
var $5505a3400147efbd$export$35652c12e6caefdf = function(v) {
    return function(v1) {
        return $22d4f8ab6946d33a$export$35652c12e6caefdf(v)(v1);
    };
};
var $5505a3400147efbd$export$d4df5207b384f835 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $5505a3400147efbd$export$9e6c3fdf667ac5ae = function(dictFoldable1) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable1.Foldable0())($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(v) {
        var $59 = intercalate(v);
        return function($60) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($59($60));
        };
    };
};
var $5505a3400147efbd$export$ec1dc8fbeea3467e = function(dictFoldable) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(splice) {
        var $61 = intercalate(splice);
        return function($62) {
            return $61($62);
        };
    };
};
var $5505a3400147efbd$export$f542ede54c0f0952 = function(dictFoldable1) {
    var joinWith2 = $5505a3400147efbd$export$ec1dc8fbeea3467e(dictFoldable1.Foldable0());
    return function(splice) {
        var $63 = joinWith2(splice);
        return function($64) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($63($64));
        };
    };
};
var $5505a3400147efbd$export$3004f64547af360e = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
};
var $5505a3400147efbd$export$71c2a1babd78d286 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$71c2a1babd78d286(pat)));
};
var $5505a3400147efbd$export$cc5663efaab5bcf6 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$cc5663efaab5bcf6(pat)));
};
var $5505a3400147efbd$export$87c2784dc9fc4ab = function(v) {
    return $5505a3400147efbd$export$3004f64547af360e($5b07e36f812dd04b$export$87c2784dc9fc4ab(v));
};
var $5505a3400147efbd$export$6c65599023ae894b = function() {
    return function($65) {
        return $5505a3400147efbd$var$fromJust($5505a3400147efbd$export$3004f64547af360e($65));
    };
};
var $5505a3400147efbd$export$5982362881026796 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $5505a3400147efbd$export$db52a218b305ccab = $5505a3400147efbd$export$5982362881026796;
var $5505a3400147efbd$export$2344b14b097df817 = function($66) {
    return $5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$2344b14b097df817($66));
};
var $5505a3400147efbd$export$8c3d57ec79c4009e = function(v) {
    return function(s2) {
        return v + s2;
    };
};







var $160716589b57c4ec$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $160716589b57c4ec$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $160716589b57c4ec$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$99c2ce29c0ead637)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $160716589b57c4ec$var$fromFoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $160716589b57c4ec$var$fromFoldable1 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $160716589b57c4ec$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($91ee3359f6bcea22$export$81b6a4240b5ed5ff)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse2 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$d0a0d45336d2d3e3)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse3 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20(/* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($11d1e86de605dfc6$export$9e4a28683e28e26a))($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse4 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20(/* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($78c799cba34fcb8d$export$99c2ce29c0ead637))($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse5 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249($2c7a64ff78781336$export$96888504550934b5)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $160716589b57c4ec$export$a752bd756a1ddd62 = function(decoder) {
    return function(obj) {
        return function(str) {
            var decode = function(json) {
                var $35 = $2a035e92dc768ac1$export$630801d484da15df(json);
                if ($35) return $160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                return $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str))(decoder(json)));
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value))(decode)($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$65e8cd53bb7e3167 = function(decoder) {
    return function(obj) {
        return function(str) {
            var decode = function() {
                var $44 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str));
                return function($45) {
                    return $44(decoder($45));
                };
            }();
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value))(function() {
                var $46 = $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create);
                return function($47) {
                    return $46(decode($47));
                };
            }())($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$2c9b3f539cb25b05 = function(decoder) {
    return function(obj) {
        return function(str) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(str, $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value)))(function() {
                var $48 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str));
                return function($49) {
                    return $48(decoder($49));
                };
            }())($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$c576f0bf806d7130 = function(v) {
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($0e031af7428ef07d$export$dbafa4424a806c15("Value cannot be Void")));
};
var $160716589b57c4ec$export$a0fb664af7d0cc44 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$1532fd4f75be8b9c(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("String")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$874d75d651b25595 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$ec3647fa336ee4ac(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Number")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$d6ce7784e89e4f30 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$4d5744f54c133204(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("null")))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342)));
}();
var $160716589b57c4ec$export$30ea34212b8dfba3 = function(json) {
    return $160716589b57c4ec$var$bindFlipped($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd("NonEmptyString", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json))))($160716589b57c4ec$var$map($5505a3400147efbd$export$3004f64547af360e)($160716589b57c4ec$export$a0fb664af7d0cc44(json)));
};
var $160716589b57c4ec$export$2ebe793352894353 = function(decoder) {
    return function(json) {
        if ($2a035e92dc768ac1$export$630801d484da15df(json)) return $160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(decoder(json));
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Decoders (line 37, column 1 - line 41, column 38): " + [
            decoder.constructor.name,
            json.constructor.name
        ]);
    };
};
var $160716589b57c4ec$export$10fbded63f740d7b = /* #__PURE__ */ function() {
    var $50 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Object"));
    return function($51) {
        return $50($2a035e92dc768ac1$export$697e4a1b90752ce2($51));
    };
}();
var $160716589b57c4ec$export$9443fc6f73bb4af5 = /* #__PURE__ */ function() {
    var $52 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Array"));
    return function($53) {
        return $52($2a035e92dc768ac1$export$45b10814cc054894($53));
    };
}();
var $160716589b57c4ec$export$81a8dc2369cfa9c9 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $54 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("List"));
        var $55 = $160716589b57c4ec$var$traverse(decoder);
        return function($56) {
            return $54($55($56));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$856c6a7d662218dc = function(dictOrd) {
    var fromFoldable2 = $160716589b57c4ec$var$fromFoldable1(dictOrd);
    return function(decoder) {
        var $57 = $160716589b57c4ec$var$map(fromFoldable2);
        var $58 = $160716589b57c4ec$export$81a8dc2369cfa9c9(decoder);
        return function($59) {
            return $57($58($59));
        };
    };
};
var $160716589b57c4ec$export$616fc2952a7ddd7e = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $60 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmptyArray"));
        var $61 = $160716589b57c4ec$var$traverse1(decoder);
        return function($62) {
            return $60($61($62));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $63 = $160716589b57c4ec$var$map(function(x) {
            return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(x.head)(x.tail);
        });
        var $64 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmptyArray"));
        return function($65) {
            return $63($64($396c4c3d9e7fae3c$export$b446f6baa3bb1430($65)));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$6e075b5db6f456bc = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $66 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmptyList"));
        var $67 = $160716589b57c4ec$var$traverse2(decoder);
        return function($68) {
            return $66($67($68));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $69 = $160716589b57c4ec$var$map(function(x) {
            return $ba51d599f79a6310$export$cc3b5f3f66225fbe(x.head)(x.tail);
        });
        var $70 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmptyList"));
        return function($71) {
            return $69($70($3d4fd987da5242ff$export$b446f6baa3bb1430($71)));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5)));
};
var $160716589b57c4ec$export$5223c50aad43e366 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $72 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmpty Array"));
        var $73 = $160716589b57c4ec$var$traverse3(decoder);
        return function($74) {
            return $72($73($74));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $75 = $160716589b57c4ec$var$map(function(x) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x.head, x.tail);
        });
        var $76 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmpty Array"));
        return function($77) {
            return $75($76($396c4c3d9e7fae3c$export$b446f6baa3bb1430($77)));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$cc44286d42597985 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $78 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmpty List"));
        var $79 = $160716589b57c4ec$var$traverse4(decoder);
        return function($80) {
            return $78($79($80));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $81 = $160716589b57c4ec$var$map(function(x) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x.head, x.tail);
        });
        var $82 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmpty List"));
        return function($83) {
            return $81($82($3d4fd987da5242ff$export$b446f6baa3bb1430($83)));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5)));
};
var $160716589b57c4ec$export$2046d9d5fd83c6e2 = /* #__PURE__ */ $160716589b57c4ec$var$composeKleisliFlipped(/* #__PURE__ */ function() {
    var $84 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Integer"));
    return function($85) {
        return $84($8d5664f12212b23e$export$7bbb4164c9a77bc2($85));
    };
}())($160716589b57c4ec$export$874d75d651b25595);
var $160716589b57c4ec$export$96fc93a77504a477 = function(decoder) {
    return function(json) {
        return $160716589b57c4ec$var$map($50c50d1f444e5fa4$export$544bf02140fa9a77)(decoder(json));
    };
};
var $160716589b57c4ec$export$5501dc3a72754845 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $86 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("ForeignObject"));
        var $87 = $160716589b57c4ec$var$traverse5(decoder);
        return function($88) {
            return $86($87($88));
        };
    }())($160716589b57c4ec$export$10fbded63f740d7b);
};
var $160716589b57c4ec$export$ca42b39dda7b755 = function(decoderA) {
    return function(decoderB) {
        return function(json) {
            return $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("Either"))($160716589b57c4ec$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(obj) {
                return $160716589b57c4ec$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("tag", $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value))($c045ea5df33bba60$export$dfc7155ac0343b8("tag")(obj)))(function(tag) {
                    return $160716589b57c4ec$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("value", $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value))($c045ea5df33bba60$export$dfc7155ac0343b8("value")(obj)))(function(val) {
                        var v = $2a035e92dc768ac1$export$f84e8e69fd4488a5(tag);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "Right") return $160716589b57c4ec$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(decoderB(val));
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "Left") return $160716589b57c4ec$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(decoderA(val));
                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("tag", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(tag)));
                    });
                });
            }));
        };
    };
};
var $160716589b57c4ec$export$1f5a05ca6191a69a = function(json) {
    return $160716589b57c4ec$var$bindFlipped($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd("CodePoint", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json))))($160716589b57c4ec$var$map($3ee2158c14339cc9$export$42977f40461e1360(0))($160716589b57c4ec$export$a0fb664af7d0cc44(json)));
};
var $160716589b57c4ec$export$7e6b1898d6f2947e = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$fff3b6519135a62b(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Boolean")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$81879b02e9646afe = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $89 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("Array"));
        var $90 = $160716589b57c4ec$var$traverseWithIndex(function(i) {
            var $92 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$d58b23382c8562e.create(i));
            return function($93) {
                return $92(decoder($93));
            };
        });
        return function($91) {
            return $89($90($91));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5);
};
var $160716589b57c4ec$export$f388ba5c0507726 = function(decoderA) {
    return function(decoderB) {
        return function(json) {
            var f = function(v) {
                if (v.length === 2) return $160716589b57c4ec$var$apply($160716589b57c4ec$var$map($71f2e2e9476163f8$export$1908877435b1d5e9.create)(decoderA(v[0])))(decoderB(v[1]));
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Tuple"));
            };
            return $160716589b57c4ec$var$bind($160716589b57c4ec$export$81879b02e9646afe($7d4cccdf062a2261$export$19db0165690c701a.create)(json))(f);
        };
    };
};
var $160716589b57c4ec$export$55fc690486870f87 = function(dictOrd) {
    var fromFoldable2 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072(dictOrd)($78c799cba34fcb8d$export$92659ee1fc91a075);
    return function(decoderA) {
        return function(decoderB) {
            var $94 = $160716589b57c4ec$var$map(fromFoldable2);
            var $95 = $160716589b57c4ec$export$81a8dc2369cfa9c9($160716589b57c4ec$export$f388ba5c0507726(decoderA)(decoderB));
            return function($96) {
                return $94($95($96));
            };
        };
    };
};









// Generated by purs version 0.15.15



// Generated by purs version 0.15.15
function $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2) {
    var copy = {};
    for(var k1 in r2)if (({}).hasOwnProperty.call(r2, k1)) copy[k1] = r2[k1];
    for(var k2 in r1)if (({}).hasOwnProperty.call(r1, k2)) copy[k2] = r1[k2];
    return copy;
}



var $7839e24eedf166a9$export$b2a4c822ec4216bb = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($e624b6ee0b54010c$export$92a1542aa06c886);




var $15e8567e7c31ba30$export$971dd5b0dfd021b6 = function() {
    return function(l) {
        return function(r) {
            return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
        };
    };
};
var $15e8567e7c31ba30$export$adaa4cf7ef1b65be = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(b) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(b)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$94f4066a75b10404 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $15e8567e7c31ba30$export$4950aa0f605343fb = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$21a5ca8aa77d35ff = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(a) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(a)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$3988ae62b71be9a3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(l) {
            return function(r) {
                return $d2fadbdf02925823$export$1d94535d2cda4eda(reflectSymbol(l))(r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$3ff57735a52b8713 = function(dictIsSymbol) {
    var set1 = $15e8567e7c31ba30$export$adaa4cf7ef1b65be(dictIsSymbol)()();
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function() {
        return function() {
            return function(l) {
                return function(f) {
                    return function(r) {
                        return set1(l)(f(get1(l)(r)))(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$db0231a0f4325b7b = {
    equalFields: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $15e8567e7c31ba30$export$91610c87b78a6ed5 = function(dict) {
    return dict.equalFields;
};
var $15e8567e7c31ba30$export$772630fbd62849b4 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function() {
            return function(dictEqualFields) {
                var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
                return {
                    equalFields: function(v) {
                        return function(a) {
                            return function(b) {
                                var get$prime = get1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var equalRest = equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                return eq(get$prime(a))(get$prime(b)) && equalRest(a)(b);
                            };
                        };
                    }
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$411ce8e5a71e3069 = function() {
    return function(dictEqualFields) {
        var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
        return function(a) {
            return function(b) {
                return equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(a)(b);
            };
        };
    };
};
var $15e8567e7c31ba30$export$812eab5d580a29df = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$1822828d790e23ee = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(r) {
                    return $d2fadbdf02925823$export$14b6a75b3eb38458(reflectSymbol(l))(r);
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$7ac989ec0c9c279 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var delete1 = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
    return function(dictIsSymbol1) {
        var insert1 = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol1)()();
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(prev) {
                            return function(next) {
                                return function(record) {
                                    return insert1(next)(get1(prev)(record))(delete1(prev)(record));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};



var $e2b1be82a5e6d14f$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $e2b1be82a5e6d14f$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $e2b1be82a5e6d14f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $e2b1be82a5e6d14f$export$355fe3e8bf1b90ac = {
    gDecodeJson: function(v) {
        return function(v1) {
            return new $7d4cccdf062a2261$export$19db0165690c701a({});
        };
    }
};
var $e2b1be82a5e6d14f$export$84d469437cbcf120 = function(dict) {
    return dict.gDecodeJson;
};
var $e2b1be82a5e6d14f$export$c576f0bf806d7130 = {
    decodeJson: $160716589b57c4ec$export$c576f0bf806d7130
};
var $e2b1be82a5e6d14f$export$b423891985836fe9 = function(dictGDecodeJson) {
    var gDecodeJson1 = $e2b1be82a5e6d14f$export$84d469437cbcf120(dictGDecodeJson);
    return function() {
        return {
            decodeJson: function(json) {
                var v = $2a035e92dc768ac1$export$697e4a1b90752ce2(json);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return gDecodeJson1(v.value0)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Object"));
                throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 103, column 5 - line 105, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $e2b1be82a5e6d14f$export$12808118396f3c8d = {
    decodeJson: $160716589b57c4ec$export$a0fb664af7d0cc44
};
var $e2b1be82a5e6d14f$export$2b11fc8bd46f4a11 = {
    decodeJson: $160716589b57c4ec$export$874d75d651b25595
};
var $e2b1be82a5e6d14f$export$15d491fcb9f2da43 = {
    decodeJson: $160716589b57c4ec$export$d6ce7784e89e4f30
};
var $e2b1be82a5e6d14f$export$809268d4a5d588e2 = {
    decodeJson: $160716589b57c4ec$export$30ea34212b8dfba3
};
var $e2b1be82a5e6d14f$export$c2f7b8312539f0ea = /* #__PURE__ */ function() {
    return {
        decodeJson: $7d4cccdf062a2261$export$19db0165690c701a.create
    };
}();
var $e2b1be82a5e6d14f$export$fee2d5446387c54f = {
    decodeJson: $160716589b57c4ec$export$2046d9d5fd83c6e2
};
var $e2b1be82a5e6d14f$export$c337bc5569ed68fc = function(dict) {
    return dict.decodeJsonField;
};
var $e2b1be82a5e6d14f$export$44d61a05912ad881 = function(dictDecodeJsonField) {
    var decodeJsonField1 = $e2b1be82a5e6d14f$export$c337bc5569ed68fc(dictDecodeJsonField);
    return function(dictGDecodeJson) {
        var gDecodeJson1 = $e2b1be82a5e6d14f$export$84d469437cbcf120(dictGDecodeJson);
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
            return function() {
                return function() {
                    return {
                        gDecodeJson: function(object) {
                            return function(v) {
                                var fieldName = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var fieldValue = $c045ea5df33bba60$export$dfc7155ac0343b8(fieldName)(object);
                                var v1 = decodeJsonField1(fieldValue);
                                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e2b1be82a5e6d14f$var$bind($e2b1be82a5e6d14f$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(fieldName))(v1.value0))(function(val) {
                                    return $e2b1be82a5e6d14f$var$bind(gDecodeJson1(object)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(function(rest) {
                                        return new $7d4cccdf062a2261$export$19db0165690c701a(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(val)(rest));
                                    });
                                });
                                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(fieldName, $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value));
                                throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 127, column 5 - line 134, column 44): " + [
                                    v1.constructor.name
                                ]);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $e2b1be82a5e6d14f$export$f35b91d6928b8f9a = {
    decodeJson: $160716589b57c4ec$export$1f5a05ca6191a69a
};
var $e2b1be82a5e6d14f$export$5a21fe33ecda3e76 = {
    decodeJson: $160716589b57c4ec$export$7e6b1898d6f2947e
};
var $e2b1be82a5e6d14f$export$cd9ded616c0cfb91 = function(dict) {
    return dict.decodeJson;
};
var $e2b1be82a5e6d14f$export$48f40a6bda333d72 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictDecodeJson1) {
        return {
            decodeJson: $160716589b57c4ec$export$ca42b39dda7b755(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
        };
    };
};
var $e2b1be82a5e6d14f$export$6c5207b40709ea3b = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$2ebe793352894353($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$a13e2a25697f85d0 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$616fc2952a7ddd7e($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$af80faa854f5e9f2 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$6e075b5db6f456bc($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$66d3e413e47dd1c8 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$5223c50aad43e366($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$d4dc80ba4c20e110 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$cc44286d42597985($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$269e6545e7001224 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictDecodeJson1) {
        return {
            decodeJson: $160716589b57c4ec$export$f388ba5c0507726(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
        };
    };
};
var $e2b1be82a5e6d14f$export$81a8dc2369cfa9c9 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$81a8dc2369cfa9c9($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$55fc690486870f87 = function(dictOrd) {
    var decodeMap1 = $160716589b57c4ec$export$55fc690486870f87(dictOrd);
    return function(dictDecodeJson) {
        var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
        return function(dictDecodeJson1) {
            return {
                decodeJson: decodeMap1(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
            };
        };
    };
};
var $e2b1be82a5e6d14f$export$856c6a7d662218dc = function(dictOrd) {
    var decodeSet1 = $160716589b57c4ec$export$856c6a7d662218dc(dictOrd);
    return function(dictDecodeJson) {
        return {
            decodeJson: decodeSet1($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
        };
    };
};
var $e2b1be82a5e6d14f$export$96fc93a77504a477 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$96fc93a77504a477($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$5501dc3a72754845 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$5501dc3a72754845($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$5be2ed97e7605dc7 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91($e2b1be82a5e6d14f$export$6c5207b40709ea3b(dictDecodeJson));
    return {
        decodeJsonField: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(decodeJson1(v.value0));
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 139, column 1 - line 143, column 49): " + [
                v.constructor.name
            ]);
        }
    };
};
var $e2b1be82a5e6d14f$export$d94c139f6fec2f7f = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return {
        decodeJsonField: function(j) {
            return $e2b1be82a5e6d14f$var$map(decodeJson1)(j);
        }
    };
};
var $e2b1be82a5e6d14f$export$81879b02e9646afe = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$81879b02e9646afe($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};



// Generated by purs version 0.15.15


// Generated by purs version 0.15.15




















var $13459527b23e3834$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $13459527b23e3834$var$toUnfoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $13459527b23e3834$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $13459527b23e3834$var$toUnfoldable2 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $13459527b23e3834$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($c045ea5df33bba60$export$b7bb4265e2e489e0);
var $13459527b23e3834$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $13459527b23e3834$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $13459527b23e3834$export$8b58be045bf06082 = function(encoder) {
    return function(v) {
        var $40 = $2a035e92dc768ac1$export$d4dde8795f959ed3($2a035e92dc768ac1$export$ecfbf588917514aa(v.value0)(v.value1))(function() {
            var $42 = $c045ea5df33bba60$export$21a5ca8aa77d35ff(v.value0)(v.value1);
            return function($43) {
                return $0e031af7428ef07d$export$dbafa4424a806c15($42($43));
            };
        }());
        return function($41) {
            return $40(encoder($41));
        };
    };
};
var $13459527b23e3834$export$1b7bab5c5d935cc2 = function(encoder) {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $13459527b23e3834$export$8b58be045bf06082(encoder)(v.value0);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return encoder;
        throw new Error("Failed pattern match at Data.Argonaut.Encode.Encoders (line 121, column 26 - line 123, column 21): " + [
            v.constructor.name
        ]);
    };
};
var $13459527b23e3834$export$51606c257d29b318 = $58f3cdfbfe212d20$export$f172309911142386;
var $13459527b23e3834$export$1e1028966b5c7065 = /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($0e031af7428ef07d$export$63ea9a5410ee0cef);
var $13459527b23e3834$export$1990b7ba8cf7db93 = function(encoderA) {
    return function(encoderB) {
        return function(v) {
            return $0e031af7428ef07d$export$dbafa4424a806c15([
                encoderA(v.value0),
                encoderB(v.value1)
            ]);
        };
    };
};
var $13459527b23e3834$export$8146d2e653b87d6a = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$ed41c27e89606957 = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$c29c3caf25da2814 = function($44) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($5505a3400147efbd$export$f84e8e69fd4488a5($44));
};
var $13459527b23e3834$export$640dd262b265c9a9 = function(encoder) {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $0e031af7428ef07d$export$63ea9a5410ee0cef;
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return encoder(v.value0);
        throw new Error("Failed pattern match at Data.Argonaut.Encode.Encoders (line 31, column 23 - line 33, column 22): " + [
            v.constructor.name
        ]);
    };
};
var $13459527b23e3834$export$7e4c09a944a44110 = function(encoder) {
    var $45 = $13459527b23e3834$var$map(encoder);
    return function($46) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($45($13459527b23e3834$var$toUnfoldable($46)));
    };
};
var $13459527b23e3834$export$200318d1f3aaee40 = function(dictOrd) {
    return function(encoderA) {
        return function(encoderB) {
            var $47 = $13459527b23e3834$export$7e4c09a944a44110($13459527b23e3834$export$1990b7ba8cf7db93(encoderA)(encoderB));
            return function($48) {
                return $47($13459527b23e3834$var$toUnfoldable1($48));
            };
        };
    };
};
var $13459527b23e3834$export$36a027b7379a8473 = function(encoder) {
    var $49 = $13459527b23e3834$export$7e4c09a944a44110(encoder);
    return function($50) {
        return $49($ba51d599f79a6310$export$effcdbd76139450($50));
    };
};
var $13459527b23e3834$export$9973f50fa8b005f0 = function(encoder) {
    return function(v) {
        return $13459527b23e3834$export$7e4c09a944a44110(encoder)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $13459527b23e3834$export$24396ced56124c99 = function(dictOrd) {
    return function(encoder) {
        var $51 = $13459527b23e3834$export$7e4c09a944a44110(encoder);
        return function($52) {
            return $51($13459527b23e3834$var$toUnfoldable2($52));
        };
    };
};
var $13459527b23e3834$export$28bc1625998ce845 = function($53) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($4ab74a20512cef04$export$a0a81dc3380ce7d3($53));
};
var $13459527b23e3834$export$e3b86e35b7509c0f = function(encoder) {
    return function(v) {
        return encoder(v);
    };
};
var $13459527b23e3834$export$4acff49b3f5661ea = function(encoder) {
    var $54 = $13459527b23e3834$var$map1(encoder);
    return function($55) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($54($55));
    };
};
var $13459527b23e3834$export$4abd2b0a026f89b4 = function(encoderA) {
    return function(encoderB) {
        var obj = function(encoder) {
            return function(tag) {
                return function(x) {
                    return $0e031af7428ef07d$export$dbafa4424a806c15($13459527b23e3834$var$fromFoldable(new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9("tag", $0e031af7428ef07d$export$dbafa4424a806c15(tag)), new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9("value", encoder(x)), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                };
            };
        };
        return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(obj(encoderA)("Left"))(obj(encoderB)("Right"));
    };
};
var $13459527b23e3834$export$3c427c24c389d273 = function($56) {
    return $13459527b23e3834$export$8146d2e653b87d6a($3ee2158c14339cc9$export$439306a4dcaafbb9($56));
};
var $13459527b23e3834$export$dbc5a334ff3f5549 = function($57) {
    return $13459527b23e3834$export$8146d2e653b87d6a($092fe44bc0883be6$export$439306a4dcaafbb9($57));
};
var $13459527b23e3834$export$1b0ad99313e5e2c6 = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$5953f05715bb15e3 = function(encoder) {
    var $58 = $13459527b23e3834$var$map(encoder);
    return function($59) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($58($59));
    };
};
var $13459527b23e3834$export$91d9dd2dfe32db48 = function(encoder) {
    var $60 = $13459527b23e3834$export$5953f05715bb15e3(encoder);
    return function($61) {
        return $60($e39dfcf102cdca3c$export$45b10814cc054894($61));
    };
};
var $13459527b23e3834$export$6ec85285b5083458 = function(encoder) {
    return function(v) {
        return $13459527b23e3834$export$5953f05715bb15e3(encoder)($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(v.value0)(v.value1));
    };
};
var $13459527b23e3834$export$64c3bd3785fd1b3d = function(encoder) {
    return function(k) {
        return $13459527b23e3834$var$map2(function() {
            var $62 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(k);
            return function($63) {
                return $62(encoder($63));
            };
        }());
    };
};
var $13459527b23e3834$export$3f4996019e520711 = function(encoder) {
    return function(k) {
        var $64 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(k);
        return function($65) {
            return $64(encoder($65));
        };
    };
};






var $eb7399d322077fcf$export$12b4d820b2ffc726 = {
    gEncodeJson: function(v) {
        return function(v1) {
            return $03b6b966974423fe$export$6e22c362a0406a2c;
        };
    }
};
var $eb7399d322077fcf$export$71d5229e5fea6423 = function(dict) {
    return dict.gEncodeJson;
};
var $eb7399d322077fcf$export$51606c257d29b318 = {
    encodeJson: $13459527b23e3834$export$51606c257d29b318
};
var $eb7399d322077fcf$export$2aa47014064a90c3 = function(dictGEncodeJson) {
    var gEncodeJson1 = $eb7399d322077fcf$export$71d5229e5fea6423(dictGEncodeJson);
    return function() {
        return {
            encodeJson: function(rec) {
                return $0e031af7428ef07d$export$dbafa4424a806c15(gEncodeJson1(rec)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $eb7399d322077fcf$export$c29c3caf25da2814 = {
    encodeJson: $13459527b23e3834$export$c29c3caf25da2814
};
var $eb7399d322077fcf$export$107c2db3e23b569f = {
    encodeJson: $13459527b23e3834$export$1e1028966b5c7065
};
var $eb7399d322077fcf$export$35d3004eff90f123 = {
    encodeJson: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa)
};
var $eb7399d322077fcf$export$188ec67d44674d4b = {
    encodeJson: $13459527b23e3834$export$8146d2e653b87d6a
};
var $eb7399d322077fcf$export$ff344db3ed099c93 = {
    encodeJson: $13459527b23e3834$export$ed41c27e89606957
};
var $eb7399d322077fcf$export$7f2886916ce99188 = {
    encodeJson: $13459527b23e3834$export$1b0ad99313e5e2c6
};
var $eb7399d322077fcf$export$b198596427f378ab = {
    encodeJson: $13459527b23e3834$export$28bc1625998ce845
};
var $eb7399d322077fcf$export$54792ca0aed9ef3e = {
    encodeJson: $13459527b23e3834$export$3c427c24c389d273
};
var $eb7399d322077fcf$export$4c18328fed860aaf = {
    encodeJson: $13459527b23e3834$export$dbc5a334ff3f5549
};
var $eb7399d322077fcf$export$a865279d3b7b5f70 = function(dict) {
    return dict.encodeJson;
};
var $eb7399d322077fcf$export$7d680688dffcbf51 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$5953f05715bb15e3($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$4db564460363add2 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictEncodeJson1) {
        return {
            encodeJson: $13459527b23e3834$export$4abd2b0a026f89b4(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
        };
    };
};
var $eb7399d322077fcf$export$9586dd179e1b28a2 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$7e4c09a944a44110($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$7c8b8b15a35b2ba2 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$640dd262b265c9a9($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$f6c72b1e53ea64f6 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$91d9dd2dfe32db48($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$7097ab98fad5367 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$36a027b7379a8473($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$78e6cf694b290b54 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$6ec85285b5083458($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$23073eb3fb9ac1be = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$9973f50fa8b005f0($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$ff58b39dae45faec = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictEncodeJson1) {
        return {
            encodeJson: $13459527b23e3834$export$1990b7ba8cf7db93(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
        };
    };
};
var $eb7399d322077fcf$export$200318d1f3aaee40 = function(dictOrd) {
    var encodeMap1 = $13459527b23e3834$export$200318d1f3aaee40(dictOrd);
    return function(dictEncodeJson) {
        var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
        return function(dictEncodeJson1) {
            return {
                encodeJson: encodeMap1(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
            };
        };
    };
};
var $eb7399d322077fcf$export$24396ced56124c99 = function(dictOrd) {
    var encodeSet1 = $13459527b23e3834$export$24396ced56124c99(dictOrd);
    return function(dictEncodeJson) {
        return {
            encodeJson: encodeSet1($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
        };
    };
};
var $eb7399d322077fcf$export$cc2f530f06b3b8c8 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictGEncodeJson) {
        var gEncodeJson1 = $eb7399d322077fcf$export$71d5229e5fea6423(dictGEncodeJson);
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
            return function() {
                return {
                    gEncodeJson: function(row) {
                        return function(v) {
                            return $c045ea5df33bba60$export$21a5ca8aa77d35ff(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(encodeJson1(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row)))(gEncodeJson1(row)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
                        };
                    }
                };
            };
        };
    };
};
var $eb7399d322077fcf$export$e3b86e35b7509c0f = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$e3b86e35b7509c0f($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$4acff49b3f5661ea = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$4acff49b3f5661ea($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};


// Generated by purs version 0.15.15
// module Data.BigInt

var $a1O7I = parcelRequire("a1O7I");
function $998a039567e3ac95$export$dab5af3a58709df4(str) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a1O7I)))(str, 10);
}
function $998a039567e3ac95$export$bf52c0f6b8383d0c(just) {
    return function(nothing) {
        return function(b) {
            return function(s) {
                try {
                    var x = (0, (/*@__PURE__*/$parcel$interopDefault($a1O7I)))(s, b);
                    return just(x);
                } catch (err) {
                    return nothing;
                }
            };
        };
    };
}
function $998a039567e3ac95$var$truncate(n) {
    if (n > 0) return Math.floor(n);
    return Math.ceil(n);
}
function $998a039567e3ac95$export$5b3229f64c38e483(just) {
    return function(nothing) {
        return function(n) {
            try {
                var x = (0, (/*@__PURE__*/$parcel$interopDefault($a1O7I)))($998a039567e3ac95$var$truncate(n));
                return just(x);
            } catch (err) {
                return nothing;
            }
        };
    };
}
function $998a039567e3ac95$export$62ffe363f1b08494(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a1O7I)))(n);
}
function $998a039567e3ac95$export$9c747160cc52aa46(base) {
    return function(x) {
        return x.toString(base);
    };
}
function $998a039567e3ac95$export$a0a81dc3380ce7d3(x) {
    return x.toJSNumber();
}
function $998a039567e3ac95$export$a2eb628399fb8acb(x) {
    return function(y) {
        return x.add(y);
    };
}
function $998a039567e3ac95$export$13b5a2267b5ffc6d(x) {
    return function(y) {
        return x.multiply(y);
    };
}
function $998a039567e3ac95$export$c5540d7539521bc9(x) {
    return function(y) {
        return x.minus(y);
    };
}
function $998a039567e3ac95$export$754eda16ef25e289(x) {
    return function(y) {
        return x.mod(y);
    };
}
function $998a039567e3ac95$export$5bd7fd27804ae2c0(x) {
    return function(y) {
        return x.divide(y);
    };
}
function $998a039567e3ac95$export$a053999e8b710938(x) {
    return function(y) {
        return x.equals(y);
    };
}
function $998a039567e3ac95$export$5ce577e10f017679(x) {
    return function(y) {
        return x.compare(y);
    };
}
function $998a039567e3ac95$export$2335f513bbd82c6d(x) {
    return x.abs();
}
function $998a039567e3ac95$export$df5fefc55a4eba3c(x) {
    return x.isEven();
}
function $998a039567e3ac95$export$74b48c691cc42eb1(x) {
    return x.isOdd();
}
function $998a039567e3ac95$export$1cac00b2a622912a(x) {
    return x.isPrime();
}
function $998a039567e3ac95$export$9c297f60e22e3389(x) {
    return function(y) {
        return x.pow(y);
    };
}
function $998a039567e3ac95$export$6003a5f097c73977(x) {
    return x.not();
}
function $998a039567e3ac95$export$252bb8b3bbdf6749(x) {
    return function(y) {
        return x.or(y);
    };
}
function $998a039567e3ac95$export$6444ef5cd411280c(x) {
    return function(y) {
        return x.xor(y);
    };
}
function $998a039567e3ac95$export$21c0ac7fe1cef1b8(x) {
    return function(y) {
        return x.and(y);
    };
}
function $998a039567e3ac95$export$efa0dab3924c2f4d(x) {
    return function(n) {
        return x.shiftLeft(n);
    };
}
function $998a039567e3ac95$export$f91dd9ffc24874e3(x) {
    return function(n) {
        return x.shiftRight(n);
    };
}
function $998a039567e3ac95$export$59aa9f0508cd86f6(radix) {
    return function(x) {
        return x.toArray(radix);
    };
}






// Generated by purs version 0.15.15
// module Data.Reflectable
const $044b7bf065b0340f$export$401372c57776dc = function(arg) {
    return arg;
};



var $d41e8d86812192aa$export$dd269e5ba76f17bc = {};
var $d41e8d86812192aa$export$d8c65d0b93e1a2d0 = {};
var $d41e8d86812192aa$export$fba7d4b066ce97d0 = {};
var $d41e8d86812192aa$export$7330694d573975a4 = {};
var $d41e8d86812192aa$export$a9914fcb177f3582 = function() {
    return function(s) {
        return function(f) {
            return $044b7bf065b0340f$export$401372c57776dc(function(dictReflectable) {
                return f(dictReflectable);
            })({
                reflectType: function(v) {
                    return s;
                }
            })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        };
    };
};
var $d41e8d86812192aa$export$d9dd92dcc65e83ce = function(dict) {
    return dict.reflectType;
};






var $42bb2ee83e728aa3$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $42bb2ee83e728aa3$export$f84e8e69fd4488a5 = /* #__PURE__ */ $998a039567e3ac95$export$9c747160cc52aa46(10);
var $42bb2ee83e728aa3$export$e7a1baa2fae31f0f = function($12) {
    return $8d5664f12212b23e$export$7bbb4164c9a77bc2($998a039567e3ac95$export$a0a81dc3380ce7d3($12));
};
var $42bb2ee83e728aa3$export$c23f3fe5a5641fef = function(i) {
    return function(bi) {
        return $42bb2ee83e728aa3$var$fromJust($5505a3400147efbd$export$3004f64547af360e($998a039567e3ac95$export$9c747160cc52aa46(i)(bi)));
    };
};
var $42bb2ee83e728aa3$export$a32d92513910ae35 = /* #__PURE__ */ $42bb2ee83e728aa3$export$c23f3fe5a5641fef(10);
var $42bb2ee83e728aa3$export$d02f3f8a4a9d9687 = {
    show: function(x) {
        return '(fromString "' + ($42bb2ee83e728aa3$export$f84e8e69fd4488a5(x) + '")');
    }
};
var $42bb2ee83e728aa3$export$69fb02bfcf12f956 = {
    add: $998a039567e3ac95$export$a2eb628399fb8acb,
    zero: /* #__PURE__ */ $998a039567e3ac95$export$62ffe363f1b08494(0),
    mul: $998a039567e3ac95$export$13b5a2267b5ffc6d,
    one: /* #__PURE__ */ $998a039567e3ac95$export$62ffe363f1b08494(1)
};
var $42bb2ee83e728aa3$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($42bb2ee83e728aa3$export$69fb02bfcf12f956);
var $42bb2ee83e728aa3$export$e306a275e43b2c5c = {
    sub: $998a039567e3ac95$export$c5540d7539521bc9,
    Semiring0: function() {
        return $42bb2ee83e728aa3$export$69fb02bfcf12f956;
    }
};
var $42bb2ee83e728aa3$var$sub = /* #__PURE__ */ $d061555d3b2c84b2$export$f93b5905241a7cca($42bb2ee83e728aa3$export$e306a275e43b2c5c);
var $42bb2ee83e728aa3$export$fb1897a40d146f7f = $998a039567e3ac95$export$754eda16ef25e289;
var $42bb2ee83e728aa3$export$dcbbe75d5a67af21 = $998a039567e3ac95$export$5bd7fd27804ae2c0;
var $42bb2ee83e728aa3$export$8f5aca4682af05e8 = function() {
    return function(dictReflectable) {
        var reflectType = $d41e8d86812192aa$export$d9dd92dcc65e83ce(dictReflectable);
        return function(v) {
            return $998a039567e3ac95$export$dab5af3a58709df4(reflectType($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
        };
    };
};
var $42bb2ee83e728aa3$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $998a039567e3ac95$export$5b3229f64c38e483($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $42bb2ee83e728aa3$export$169538a1203df787 = /* #__PURE__ */ function() {
    return $998a039567e3ac95$export$bf52c0f6b8383d0c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $42bb2ee83e728aa3$export$3004f64547af360e = /* #__PURE__ */ $42bb2ee83e728aa3$export$169538a1203df787(10);
var $42bb2ee83e728aa3$export$a3814c85036d46cf = {
    eq: $998a039567e3ac95$export$a053999e8b710938
};
var $42bb2ee83e728aa3$export$6e394a688eb23b55 = {
    compare: function(x) {
        return function(y) {
            var v = $998a039567e3ac95$export$5ce577e10f017679(x)(y);
            if (v === 1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v === 0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
        };
    },
    Eq0: function() {
        return $42bb2ee83e728aa3$export$a3814c85036d46cf;
    }
};
var $42bb2ee83e728aa3$export$dd36f89e8d11cef0 = {
    Ring0: function() {
        return $42bb2ee83e728aa3$export$e306a275e43b2c5c;
    }
};
var $42bb2ee83e728aa3$export$ef4744d73986e4c1 = {
    div: function(x) {
        return function(y) {
            return $998a039567e3ac95$export$5bd7fd27804ae2c0($42bb2ee83e728aa3$var$sub(x)($b0cd729514c2504e$export$842a2cf37af977e1($42bb2ee83e728aa3$export$ef4744d73986e4c1)(x)(y)))(y);
        };
    },
    mod: function(x) {
        return function(y) {
            var yy = $998a039567e3ac95$export$2335f513bbd82c6d(y);
            return $998a039567e3ac95$export$754eda16ef25e289($42bb2ee83e728aa3$var$add($998a039567e3ac95$export$754eda16ef25e289(x)(yy))(yy))(yy);
        };
    },
    degree: function($13) {
        return $8d5664f12212b23e$export$a3fe094919f356fd($998a039567e3ac95$export$a0a81dc3380ce7d3($998a039567e3ac95$export$2335f513bbd82c6d($13)));
    },
    CommutativeRing0: function() {
        return $42bb2ee83e728aa3$export$dd36f89e8d11cef0;
    }
};










// Generated by purs version 0.15.15




// Generated by purs version 0.15.15
var $f38acfbf15955b73$export$c1c8be52b85daeca = function(dict) {
    return dict.sized;
};
var $f38acfbf15955b73$export$4380c87abf28fdf = function(dict) {
    return dict.resize;
};
var $f38acfbf15955b73$export$24b3f9c3c8227daa = function(dict) {
    return dict.chooseInt;
};
var $f38acfbf15955b73$export$73d56bd430e66c0c = function(dict) {
    return dict.chooseFloat;
};
var $f38acfbf15955b73$export$ed1be54c7ccedf5b = function(dict) {
    return dict.chooseBool;
};


// Generated by purs version 0.15.15



// Generated by purs version 0.15.15











// Generated by purs version 0.15.15



var $19578e25953179c0$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $19578e25953179c0$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $19578e25953179c0$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(x) {
            return x;
        };
    }
};
var $19578e25953179c0$export$4ded69d4b0c99b7b = function(dictOrd) {
    return dictOrd;
};
var $19578e25953179c0$export$74aba74241121413 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $19578e25953179c0$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return dictEq;
};
var $19578e25953179c0$export$634a54207b73ac14 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($19578e25953179c0$export$4dd70ef4fbe4d1f3(dictEq));
    }
};
var $19578e25953179c0$export$64bd44ceff2f4638 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($19578e25953179c0$export$4ded69d4b0c99b7b(dictOrd));
    },
    Eq10: function() {
        return $19578e25953179c0$export$634a54207b73ac14;
    }
};
var $19578e25953179c0$export$835f68c2f339b021 = function(dictBounded) {
    return dictBounded;
};
var $19578e25953179c0$export$dcd798c84777f95 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $19578e25953179c0$export$74aba74241121413;
    }
};
var $19578e25953179c0$export$f2b93d1f1ac78d51 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$5b4de68c5dd33934 = {
    pure: $19578e25953179c0$export$bed9238d8933c9a8,
    Apply0: function() {
        return $19578e25953179c0$export$dcd798c84777f95;
    }
};
var $19578e25953179c0$export$25d122cd3cbaf721 = {
    Applicative0: function() {
        return $19578e25953179c0$export$5b4de68c5dd33934;
    },
    Bind1: function() {
        return $19578e25953179c0$export$f2b93d1f1ac78d51;
    }
};






var $6482d98559452a87$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $6482d98559452a87$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $6482d98559452a87$var$monoidAdditive = /* #__PURE__ */ $e48f2e41a907ae60$export$c38b62d29991685f($c0e822be92afc4df$export$f48694d6539477b9);
var $6482d98559452a87$var$Cons = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $6482d98559452a87$var$Nil = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $6482d98559452a87$var$FreqSemigroup = function(x) {
    return x;
};
var $6482d98559452a87$export$62262501c20ccc48 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictMonadGen) {
        var Monad0 = dictMonadGen.Monad0();
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var Bind1 = Monad0.Bind1();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
        var sized = $f38acfbf15955b73$export$c1c8be52b85daeca(dictMonadGen);
        return function(dictUnfoldable) {
            var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
            return function(gen) {
                var unfold = function(v) {
                    if (v instanceof $6482d98559452a87$var$Nil) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    if (v instanceof $6482d98559452a87$var$Cons) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, v.value1));
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 102, column 12 - line 104, column 35): " + [
                        v.constructor.name
                    ]);
                };
                var loopGen = function(v) {
                    if (v.value1 <= 0) return pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(v.value0));
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind(gen)(function(x) {
                        return pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $6482d98559452a87$var$Cons(x, v.value0), v.value1 - 1 | 0)));
                    });
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 94, column 3 - line 94, column 68): " + [
                        v.constructor.name
                    ]);
                };
                return map(unfoldr(unfold))(sized(function() {
                    var $126 = tailRecM(loopGen);
                    var $127 = $71f2e2e9476163f8$export$1908877435b1d5e9.create($6482d98559452a87$var$Nil.value);
                    return function($128) {
                        return $126($127($128));
                    };
                }()));
            };
        };
    };
};
var $6482d98559452a87$var$semigroupFreqSemigroup = {
    append: function(v) {
        return function(v1) {
            return function(pos) {
                var v2 = v(pos);
                if (v2.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0.value0);
                return v2;
            };
        };
    }
};
var $6482d98559452a87$var$getFreqVal = function(v) {
    return function($129) {
        return $71f2e2e9476163f8$export$6f71268a1666ab58(v($129));
    };
};
var $6482d98559452a87$var$fromIndex = function(dictFoldable1) {
    var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($19578e25953179c0$export$6d3c4648150c5bae);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1.Foldable0());
    return function(i) {
        return function(xs) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $6482d98559452a87$var$Cons && v1.value1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons && v <= 0) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Cons) {
                            $tco_var_v = v - 1 | 0;
                            $copy_v1 = v1.value1;
                            return;
                        }
                        if (v1 instanceof $6482d98559452a87$var$Nil) {
                            $tco_done = true;
                            return $6482d98559452a87$var$un($19578e25953179c0$export$bed9238d8933c9a8)(foldMap1($19578e25953179c0$export$bed9238d8933c9a8)(xs));
                        }
                        throw new Error("Failed pattern match at Control.Monad.Gen (line 128, column 5 - line 128, column 26): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return go(i)(foldr($6482d98559452a87$var$Cons.create)($6482d98559452a87$var$Nil.value)(xs));
        };
    };
};
var $6482d98559452a87$export$a9a18ae5ba42aeab = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseInt = $f38acfbf15955b73$export$24b3f9c3c8227daa(dictMonadGen);
    return function(dictFoldable1) {
        var length = $4fe7b6acfba7f29f$export$f24224f1c91d8156(dictFoldable1.Foldable0())($c0e822be92afc4df$export$7e80d6910c05bd77);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return fromIndex1(n)(xs);
            });
        };
    };
};
var $6482d98559452a87$var$freqSemigroup = function(v) {
    return function(pos) {
        var $119 = pos >= v.value0;
        if ($119) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $06733ae99ed4f534$export$8a67b48435b5d073(pos - v.value0), v.value1);
        return new $71f2e2e9476163f8$export$1908877435b1d5e9($06733ae99ed4f534$export$bebe9059409a0d04.value, v.value1);
    };
};
var $6482d98559452a87$export$7ca27958f28e2974 = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    return function(dictFoldable1) {
        var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1.Foldable0())($6482d98559452a87$var$monoidAdditive);
        var foldMap1 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($6482d98559452a87$var$semigroupFreqSemigroup);
        return function(xs) {
            var total = $6482d98559452a87$var$alaF($e48f2e41a907ae60$export$14f8ce08180a98e1)(foldMap)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(xs);
            return bind(chooseFloat(0.0)(total))($6482d98559452a87$var$getFreqVal(foldMap1($6482d98559452a87$var$freqSemigroup)(xs)));
        };
    };
};
var $6482d98559452a87$export$8082fa36f85e6b63 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictMonadGen) {
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            var go = function(v) {
                return mapFlipped(gen)(function(a) {
                    if (a instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                    if (a instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(a.value0);
                    throw new Error("Failed pattern match at Control.Monad.Gen (line 118, column 24 - line 120, column 23): " + [
                        a.constructor.name
                    ]);
                });
            };
            return tailRecM(go)($05149ea687d6b460$export$523c0b569236b342);
        };
    };
};
var $6482d98559452a87$export$a7e2a49ace6c34c5 = function(dictMonadRec) {
    var filtered1 = $6482d98559452a87$export$8082fa36f85e6b63(dictMonadRec);
    return function(dictMonadGen) {
        var filtered2 = filtered1(dictMonadGen);
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadGen.Monad0().Bind1().Apply0().Functor0());
        return function(gen) {
            return function(pred) {
                return filtered2(mapFlipped(gen)(function(a) {
                    var $124 = pred(a);
                    if ($124) return new $06733ae99ed4f534$export$8a67b48435b5d073(a);
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }));
            };
        };
    };
};
var $6482d98559452a87$export$7a5d735b2ab6389d = function(dictMonadGen) {
    var Monad0 = dictMonadGen.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var chooseInt = $f38acfbf15955b73$export$24b3f9c3c8227daa(dictMonadGen);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(dictFoldable1) {
        var length = $4fe7b6acfba7f29f$export$f24224f1c91d8156(dictFoldable1.Foldable0())($c0e822be92afc4df$export$7e80d6910c05bd77);
        var fromIndex1 = $6482d98559452a87$var$fromIndex(dictFoldable1);
        return function(xs) {
            return bind(chooseInt(0)(length(xs) - 1 | 0))(function(n) {
                return pure(fromIndex1(n)(xs));
            });
        };
    };
};
var $6482d98559452a87$export$7877a478dd30fd3d = function(dictMonadGen) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadGen.Monad0().Bind1());
    var chooseBool = $f38acfbf15955b73$export$ed1be54c7ccedf5b(dictMonadGen);
    return function(genA) {
        return function(genB) {
            return bind(chooseBool)(function(v) {
                if (v) return genA;
                return genB;
            });
        };
    };
};










var $26405903fe88aca2$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $26405903fe88aca2$export$5da10dd25b2cdff0 = function(dictApply) {
    return $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply)($71f2e2e9476163f8$export$1908877435b1d5e9.create);
};
var $26405903fe88aca2$export$732372634357300 = function(dictMonadRec) {
    var unfoldable = $6482d98559452a87$export$62262501c20ccc48(dictMonadRec);
    return function(dictMonadGen) {
        var Apply0 = dictMonadGen.Monad0().Bind1().Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var resize = $f38acfbf15955b73$export$4380c87abf28fdf(dictMonadGen);
        var unfoldable1 = unfoldable(dictMonadGen);
        return function(dictUnfoldable) {
            var unfoldable2 = unfoldable1(dictUnfoldable);
            return function(gen) {
                return apply(map($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(gen))(resize(function() {
                    var $46 = $26405903fe88aca2$var$max(0);
                    return function($47) {
                        return $46(function(v) {
                            return v - 1 | 0;
                        }($47));
                    };
                }())(unfoldable2(gen)));
            };
        };
    };
};
var $26405903fe88aca2$export$8066ddf427d75627 = function(dictMonadGen) {
    var Monad0 = dictMonadGen.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(bias) {
        return function(gen) {
            return bind(chooseFloat(0.0)(1.0))(function(n) {
                var $44 = n < bias;
                if ($44) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(gen);
                return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
            });
        };
    };
};
var $26405903fe88aca2$export$814577261e602aa0 = function(dictMonadGen) {
    return $26405903fe88aca2$export$8066ddf427d75627(dictMonadGen)(0.75);
};
var $26405903fe88aca2$export$8f75a736eace88f7 = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($50c50d1f444e5fa4$export$544bf02140fa9a77);
};
var $26405903fe88aca2$export$37745582fe1e869a = function(dictMonadGen) {
    var Bind1 = dictMonadGen.Monad0().Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var chooseFloat = $f38acfbf15955b73$export$73d56bd430e66c0c(dictMonadGen);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Bind1.Apply0().Functor0());
    return function(bias) {
        return function(genA) {
            return function(genB) {
                return bind(chooseFloat(0.0)(1.0))(function(n) {
                    var $45 = n < bias;
                    if ($45) return map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(genA);
                    return map($7d4cccdf062a2261$export$19db0165690c701a.create)(genB);
                });
            };
        };
    };
};
var $26405903fe88aca2$export$4c044f8c47b13786 = function(dictMonadGen) {
    return $26405903fe88aca2$export$37745582fe1e869a(dictMonadGen)(0.5);
};


























// Generated by purs version 0.15.15



var $6c6a555e6244fc9c$export$b25abba66f7be210 = function(x) {
    return x;
};
var $6c6a555e6244fc9c$export$20f833961f1940c8 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(First " + (show(v) + ")");
        }
    };
};
var $6c6a555e6244fc9c$export$53ff158b23f5d382 = {
    append: function(x) {
        return function(v) {
            return x;
        };
    }
};
var $6c6a555e6244fc9c$export$4d7d8eedf770f0 = function(dictOrd) {
    return dictOrd;
};
var $6c6a555e6244fc9c$export$98d9d13e8b5bfe4d = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $6c6a555e6244fc9c$export$8232f15b0b41395c = function(dictEq) {
    return dictEq;
};
var $6c6a555e6244fc9c$export$1a969f11cd8a353e = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($6c6a555e6244fc9c$export$8232f15b0b41395c(dictEq));
    }
};
var $6c6a555e6244fc9c$export$f6a5e365037ccf9a = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($6c6a555e6244fc9c$export$4d7d8eedf770f0(dictOrd));
    },
    Eq10: function() {
        return $6c6a555e6244fc9c$export$1a969f11cd8a353e;
    }
};
var $6c6a555e6244fc9c$export$315f32b6f78e2785 = function(dictBounded) {
    return dictBounded;
};
var $6c6a555e6244fc9c$export$e48e2da4536c2eea = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $6c6a555e6244fc9c$export$98d9d13e8b5bfe4d;
    }
};
var $6c6a555e6244fc9c$export$456f8570baa6024f = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $6c6a555e6244fc9c$export$e48e2da4536c2eea;
    }
};
var $6c6a555e6244fc9c$export$178f5831973b2ff8 = {
    pure: $6c6a555e6244fc9c$export$b25abba66f7be210,
    Apply0: function() {
        return $6c6a555e6244fc9c$export$e48e2da4536c2eea;
    }
};
var $6c6a555e6244fc9c$export$e17b0506de713d2e = {
    Applicative0: function() {
        return $6c6a555e6244fc9c$export$178f5831973b2ff8;
    },
    Bind1: function() {
        return $6c6a555e6244fc9c$export$456f8570baa6024f;
    }
};





// Generated by purs version 0.15.15






var $be985434983c0a5f$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $be985434983c0a5f$var$toNonEmptyString = $5505a3400147efbd$export$5e0a9ee3d3833c14;
var $be985434983c0a5f$export$c40cf5aab899f397 = function(c) {
    return function(s) {
        return $be985434983c0a5f$var$toNonEmptyString(s + $092fe44bc0883be6$export$439306a4dcaafbb9(c));
    };
};
var $be985434983c0a5f$export$439306a4dcaafbb9 = function($23) {
    return $be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$439306a4dcaafbb9($23));
};
var $be985434983c0a5f$var$liftS = function(f) {
    return function(v) {
        return f(v);
    };
};
var $be985434983c0a5f$export$9384c7afe4015e42 = function(f) {
    var $24 = $be985434983c0a5f$var$liftS($1a77d6934b592676$export$9384c7afe4015e42(f));
    return function($25) {
        return $5505a3400147efbd$export$3004f64547af360e($24($25));
    };
};
var $be985434983c0a5f$export$9dc3eed83bb14216 = function(pat) {
    var $26 = $1a77d6934b592676$export$9dc3eed83bb14216(pat);
    return function($27) {
        return $be985434983c0a5f$var$liftS($26($27));
    };
};
var $be985434983c0a5f$export$557cfb7ed375eeb7 = function($28) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$557cfb7ed375eeb7($28));
};
var $be985434983c0a5f$export$7f0e23922170149a = function(pat) {
    var $29 = $1a77d6934b592676$export$7f0e23922170149a(pat);
    return function($30) {
        return $be985434983c0a5f$var$liftS($29($30));
    };
};
var $be985434983c0a5f$export$305f7d4e9d4624f2 = function($31) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$305f7d4e9d4624f2($31));
};
var $be985434983c0a5f$var$fromNonEmptyString = function(v) {
    return v;
};
var $be985434983c0a5f$export$f24224f1c91d8156 = function($32) {
    return $092fe44bc0883be6$export$f24224f1c91d8156($be985434983c0a5f$var$fromNonEmptyString($32));
};
var $be985434983c0a5f$export$b0d75975ac0be0e1 = function(i) {
    return function(nes) {
        var v = $092fe44bc0883be6$export$b0d75975ac0be0e1(i)($be985434983c0a5f$var$fromNonEmptyString(nes));
        return {
            before: $5505a3400147efbd$export$3004f64547af360e(v.before),
            after: $5505a3400147efbd$export$3004f64547af360e(v.after)
        };
    };
};
var $be985434983c0a5f$export$b7df5d561049483a = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $18 = i < 1;
        if ($18) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$b7df5d561049483a(i)(s)));
    };
};
var $be985434983c0a5f$export$1bbc425ddca7f2c6 = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $19 = i < 1;
        if ($19) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($1a77d6934b592676$export$1bbc425ddca7f2c6(i)(s)));
    };
};
var $be985434983c0a5f$export$bafb3da1554990db = function($33) {
    return $1a77d6934b592676$export$bafb3da1554990db($be985434983c0a5f$var$fromNonEmptyString($33));
};
var $be985434983c0a5f$export$f718f38b069557c4 = function($34) {
    return $092fe44bc0883be6$export$f718f38b069557c4($be985434983c0a5f$var$fromNonEmptyString($34));
};
var $be985434983c0a5f$export$12fb146e54f03cae = function($36) {
    return $be985434983c0a5f$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($be985434983c0a5f$export$f718f38b069557c4($36)));
};
var $be985434983c0a5f$export$b446f6baa3bb1430 = function(nes) {
    var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
    return {
        head: $3296d29fc7ea4822$export$bbcf894add1d392c(0)(s),
        tail: $5505a3400147efbd$export$3004f64547af360e($092fe44bc0883be6$export$663103110d94aac9(1)(s))
    };
};
var $be985434983c0a5f$export$95b95426129653f6 = function(dictFoldable1) {
    var $37 = $086486679aa806fa$export$2e430a6d03f6ee23(dictFoldable1)($5505a3400147efbd$export$d35c69c74cf52f2a);
    return function($38) {
        return $37($38);
    };
};
var $be985434983c0a5f$export$709e3b51bf2e2249 = function(v) {
    if (v.length === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$709e3b51bf2e2249(v)));
};
var $be985434983c0a5f$export$a6233231f8d671d1 = function($40) {
    return $be985434983c0a5f$var$fromJust($be985434983c0a5f$export$709e3b51bf2e2249($e39dfcf102cdca3c$export$45b10814cc054894($40)));
};
var $be985434983c0a5f$export$533af5c8cd6afa16 = function(f) {
    var $41 = $be985434983c0a5f$var$liftS($1a77d6934b592676$export$533af5c8cd6afa16(f));
    return function($42) {
        return $5505a3400147efbd$export$3004f64547af360e($41($42));
    };
};
var $be985434983c0a5f$export$6ba801e3e123536e = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $21 = i >= $092fe44bc0883be6$export$f24224f1c91d8156(s);
        if ($21) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($1a77d6934b592676$export$6ba801e3e123536e(i)(s)));
    };
};
var $be985434983c0a5f$export$663103110d94aac9 = function(i) {
    return function(nes) {
        var s = $be985434983c0a5f$var$fromNonEmptyString(nes);
        var $22 = i >= $092fe44bc0883be6$export$f24224f1c91d8156(s);
        if ($22) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$663103110d94aac9(i)(s)));
    };
};
var $be985434983c0a5f$export$29a68f758c141c85 = function($43) {
    return $be985434983c0a5f$var$liftS($092fe44bc0883be6$export$29a68f758c141c85($43));
};
var $be985434983c0a5f$export$8327ebbef2a0ba76 = function(c) {
    return function(s) {
        return $be985434983c0a5f$var$toNonEmptyString($092fe44bc0883be6$export$439306a4dcaafbb9(c) + s);
    };
};
var $be985434983c0a5f$export$bbcf894add1d392c = function($44) {
    return $be985434983c0a5f$var$liftS($1a77d6934b592676$export$bbcf894add1d392c($44));
};






// Generated by purs version 0.15.15
/* global ArrayBuffer, Float32Array, Int32Array */ // module Test.QuickCheck.Gen
function $afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7(n) {
    var arr = new ArrayBuffer(4);
    var fv = new Float32Array(arr);
    var iv = new Int32Array(arr);
    fv[0] = n;
    return iv[0];
}






// Generated by purs version 0.15.15




var $4a0611d0fc3e3eac$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4a0611d0fc3e3eac$export$29d22fcef0a54f1b = $e9bda291f4ec10ec$export$72aea7109e8312dd;
var $4a0611d0fc3e3eac$export$4b65631072155b20 = function(v) {
    return function($18) {
        return $4a0611d0fc3e3eac$var$unwrap(v($18));
    };
};
var $4a0611d0fc3e3eac$export$a337c713bdba072 = function(f) {
    return $e9bda291f4ec10ec$export$8342df5ddac360cd(function($19) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($4a0611d0fc3e3eac$var$unwrap($19)));
    });
};
var $4a0611d0fc3e3eac$export$6feb49085bba08e4 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value1;
    };
};
var $4a0611d0fc3e3eac$export$3f3c20f32c573065 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value0;
    };
};

























// Generated by purs version 0.15.15








// Generated by purs version 0.15.15
const $12b21e1b0d841cdb$export$4385e60b38654f68 = Math.random;





var $779c6109fa03e926$export$5c61011b8a176cb5 = function(min) {
    return function(max) {
        return function __do() {
            var n = $12b21e1b0d841cdb$export$4385e60b38654f68();
            return n * (max - min) + min;
        };
    };
};
var $779c6109fa03e926$export$3c5f89dae98e900b = function(low) {
    return function(high) {
        return function __do() {
            var n = $12b21e1b0d841cdb$export$4385e60b38654f68();
            var asNumber = ($4ab74a20512cef04$export$a0a81dc3380ce7d3(high) - $4ab74a20512cef04$export$a0a81dc3380ce7d3(low) + 1) * n + $4ab74a20512cef04$export$a0a81dc3380ce7d3(low);
            return $8d5664f12212b23e$export$a3fe094919f356fd(asNumber);
        };
    };
};
var $779c6109fa03e926$export$b3b584c8d6ffe165 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)(function(v) {
    return v < 0.5;
})($12b21e1b0d841cdb$export$4385e60b38654f68);


var $9559f84fe253e941$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $9559f84fe253e941$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $9559f84fe253e941$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $9559f84fe253e941$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $9559f84fe253e941$var$Seed = function(x) {
    return x;
};
var $9559f84fe253e941$export$7042ae9d28c01125 = function(v) {
    return v;
};
var $9559f84fe253e941$export$e65cb34e627289de = {
    show: function(v) {
        return "Seed " + $9559f84fe253e941$var$show(v);
    }
};
var $9559f84fe253e941$var$seedMin = 1;
var $9559f84fe253e941$export$d98c3c51a54fd85 = 2147483647;
var $9559f84fe253e941$var$seedMax = /* #__PURE__ */ function() {
    return $9559f84fe253e941$export$d98c3c51a54fd85 - 1 | 0;
}();
var $9559f84fe253e941$export$2735a0808990c853 = function(x) {
    var ensureBetween = function(min) {
        return function(max) {
            return function(n) {
                var rangeSize = max - min | 0;
                var n$prime = $9559f84fe253e941$var$mod(n)(rangeSize);
                var $25 = n$prime < min;
                if ($25) return n$prime + max | 0;
                return n$prime;
            };
        };
    };
    return ensureBetween($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax)(x);
};
var $9559f84fe253e941$export$7c185c3757807f6c = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($9559f84fe253e941$export$2735a0808990c853)(/* #__PURE__ */ $779c6109fa03e926$export$3c5f89dae98e900b($9559f84fe253e941$var$seedMin)($9559f84fe253e941$var$seedMax));
var $9559f84fe253e941$export$61f3493dfd88d63c = 0;
var $9559f84fe253e941$export$f17df8294784fc83 = 48271;
var $9559f84fe253e941$export$4adeeb01377a1217 = function(d) {
    return function(v) {
        return $9559f84fe253e941$var$fromJust($8d5664f12212b23e$export$7bbb4164c9a77bc2($9a14cd925227149d$export$159037f780d3415c($4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$f17df8294784fc83) * $4ab74a20512cef04$export$a0a81dc3380ce7d3(v) + $4ab74a20512cef04$export$a0a81dc3380ce7d3(d))($4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$d98c3c51a54fd85))));
    };
};
var $9559f84fe253e941$export$9b78b1302b1d14b9 = /* #__PURE__ */ $9559f84fe253e941$export$4adeeb01377a1217($9559f84fe253e941$export$61f3493dfd88d63c);
var $9559f84fe253e941$export$1bcc581bf56ac2e3 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $9559f84fe253e941$export$bcaddbba31d9e24 = {
    compare: function(x) {
        return function(y) {
            return $9559f84fe253e941$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $9559f84fe253e941$export$1bcc581bf56ac2e3;
    }
};


var $bc49024203989caa$var$monadStateStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$state = /* #__PURE__ */ $f2d5035ce6148af6$export$ca000e230c0caa3e($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $bc49024203989caa$var$bindStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$f28534bdc7259c7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($bc49024203989caa$var$bindStateT);
var $bc49024203989caa$var$functorStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$d5449d946db19e3a($50c50d1f444e5fa4$export$dc85e8383eafbd81);
var $bc49024203989caa$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($bc49024203989caa$var$functorStateT);
var $bc49024203989caa$var$modify = /* #__PURE__ */ $f2d5035ce6148af6$export$3ff57735a52b8713($bc49024203989caa$var$monadStateStateT);
var $bc49024203989caa$var$toUnfoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $bc49024203989caa$var$mul = /* #__PURE__ */ $c0e822be92afc4df$export$6e3a27864ab166fe($c0e822be92afc4df$export$f48694d6539477b9);
var $bc49024203989caa$var$min = /* #__PURE__ */ $97937c29f879e68e$export$96ec731ed4dcb222($97937c29f879e68e$export$5ed021ff2336715c);
var $bc49024203989caa$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$5ed021ff2336715c);
var $bc49024203989caa$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$f48694d6539477b9);
var $bc49024203989caa$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $bc49024203989caa$var$foldMap1 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($91ee3359f6bcea22$export$33591d20dac5147e)(/* #__PURE__ */ $e48f2e41a907ae60$export$8adb2de2291fe34($c0e822be92afc4df$export$f48694d6539477b9));
var $bc49024203989caa$var$unsafeIndex = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $bc49024203989caa$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $bc49024203989caa$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $bc49024203989caa$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $bc49024203989caa$var$comparing = /* #__PURE__ */ $97937c29f879e68e$export$e9509a298f6befc2($97937c29f879e68e$export$ff461bf68e7dd332);
var $bc49024203989caa$var$Gen = function(x) {
    return x;
};
var $bc49024203989caa$export$501e8ddb7256577d = function(v) {
    return v;
};
var $bc49024203989caa$export$57b56d217c942094 = function($103) {
    return $4a0611d0fc3e3eac$export$4b65631072155b20($bc49024203989caa$export$501e8ddb7256577d($103));
};
var $bc49024203989caa$export$b9607df69539b8a5 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return $bc49024203989caa$export$57b56d217c942094(f(s))(s);
    });
};
var $bc49024203989caa$export$c1c8be52b85daeca = function(f) {
    return $bc49024203989caa$export$b9607df69539b8a5(function(s) {
        return f(s.size);
    });
};
var $bc49024203989caa$export$8fdf71db98f19724 = function(n) {
    return function(g) {
        return $bc49024203989caa$var$state(function(s) {
            return $bc49024203989caa$export$57b56d217c942094(g)({
                size: s.size,
                newSeed: n
            });
        });
    };
};
var $bc49024203989caa$export$4380c87abf28fdf = function(sz) {
    return function(g) {
        return $bc49024203989caa$var$state(function(v) {
            return $bc49024203989caa$var$map(function(v1) {
                return {
                    newSeed: v1.newSeed,
                    size: v.size
                };
            })($bc49024203989caa$export$57b56d217c942094(g)({
                newSeed: v.newSeed,
                size: sz
            }));
        });
    };
};
var $bc49024203989caa$var$replicateMRec = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure2 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Monad0.Bind1().Apply0().Functor0());
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(v) {
        return function(v1) {
            if (v <= 0) return pure2($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var go = function(v2) {
                if (v2.value1 === 0) return pure2(new $f93520de2fa37b44$export$7fe28cb29e71bf10(v2.value0));
                return mapFlipped(v1)(function(x) {
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v2.value0), v2.value1 - 1 | 0));
                });
            };
            return tailRecM1(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, v));
        };
    };
};
var $bc49024203989caa$export$a1767e9fa438fa19 = function(f) {
    return $bc49024203989caa$var$state(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(function(a) {
            return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($bc49024203989caa$export$57b56d217c942094(f(a))(s));
        }, {
            size: s.size,
            newSeed: $9559f84fe253e941$export$9b78b1302b1d14b9(s.newSeed)
        });
    });
};
var $bc49024203989caa$export$1c0695923c609880 = function(n) {
    return function(gen) {
        return $bc49024203989caa$var$discard($bc49024203989caa$var$$$void($bc49024203989caa$var$modify(function(s) {
            var $91 = {};
            for(var $92 in s)if (({}).hasOwnProperty.call(s, $92)) $91[$92] = s[$92];
            $91.newSeed = $9559f84fe253e941$export$4adeeb01377a1217($afe9bbfe2ce5003b$export$2d1ed1a7368a8bb7(n))(s.newSeed);
            return $91;
        })))(function() {
            return $bc49024203989caa$export$501e8ddb7256577d(gen);
        });
    };
};
var $bc49024203989caa$export$b03367abac3ff7e8 = /* #__PURE__ */ $e9bda291f4ec10ec$export$ade5de830b656137($f93520de2fa37b44$export$ef692454cdd8c2ba);
var $bc49024203989caa$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$export$52ad81a118d95d95 = /* #__PURE__ */ $e9bda291f4ec10ec$export$345b4840c14ff10f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$export$2e12bfb3e89e4ebb = /* #__PURE__ */ $bc49024203989caa$var$replicateMRec($bc49024203989caa$export$b03367abac3ff7e8);
var $bc49024203989caa$var$lcgStep = /* #__PURE__ */ function() {
    var f = function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9($9559f84fe253e941$export$7042ae9d28c01125(s.newSeed), function() {
            var $94 = {};
            for(var $95 in s)if (({}).hasOwnProperty.call(s, $95)) $94[$95] = s[$95];
            $94.newSeed = $9559f84fe253e941$export$9b78b1302b1d14b9(s.newSeed);
            return $94;
        }());
    };
    return $bc49024203989caa$var$state(f);
}();
var $bc49024203989caa$export$c1f7d6d1f306d098 = $e9bda291f4ec10ec$export$dce43013fc3a5fe1;
var $bc49024203989caa$export$5d116872cdd6398d = $bc49024203989caa$var$functorStateT;
var $bc49024203989caa$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d);
var $bc49024203989caa$export$379455b567eff87d = /* #__PURE__ */ $bc49024203989caa$var$map2(function(n) {
    return $4ab74a20512cef04$export$a0a81dc3380ce7d3(n) / $4ab74a20512cef04$export$a0a81dc3380ce7d3($9559f84fe253e941$export$d98c3c51a54fd85);
})($bc49024203989caa$var$lcgStep);
var $bc49024203989caa$export$b81db5163bc14d3a = function(k) {
    return function(g) {
        return $bc49024203989caa$var$map2($bc49024203989caa$var$toUnfoldable)($bc49024203989caa$export$2e12bfb3e89e4ebb(k)(g));
    };
};
var $bc49024203989caa$export$15844f9800ba116b = function($104) {
    return $4a0611d0fc3e3eac$export$3f3c20f32c573065($bc49024203989caa$export$501e8ddb7256577d($104));
};
var $bc49024203989caa$export$277a6090301c27ce = function(gen) {
    return function __do() {
        var seed = $9559f84fe253e941$export$7c185c3757807f6c();
        return $bc49024203989caa$export$15844f9800ba116b(gen)({
            newSeed: seed,
            size: 10
        });
    };
};
var $bc49024203989caa$export$4812e460280c6ef2 = function(seed) {
    return function(sz) {
        return function(g) {
            return $bc49024203989caa$export$15844f9800ba116b($bc49024203989caa$export$b81db5163bc14d3a(sz)(g))({
                newSeed: seed,
                size: sz
            });
        };
    };
};
var $bc49024203989caa$export$e2ce9cb992b4de1d = function(n) {
    return function(g) {
        return function __do() {
            var seed = $9559f84fe253e941$export$7c185c3757807f6c();
            return $bc49024203989caa$export$4812e460280c6ef2(seed)(n)(g);
        };
    };
};
var $bc49024203989caa$export$cd4f956adf59bc3d = /* #__PURE__ */ $bc49024203989caa$export$e2ce9cb992b4de1d(10);
var $bc49024203989caa$export$7877a478dd30fd3d = function(a) {
    return function(b) {
        var unscale = function(v) {
            return v * 2.0;
        };
        var scale = function(v) {
            return v * 0.5;
        };
        var min$prime = scale($bc49024203989caa$var$min(a)(b));
        var max$prime = scale($bc49024203989caa$var$max(a)(b));
        return $bc49024203989caa$var$map2(function() {
            var $105 = $bc49024203989caa$var$add(min$prime);
            var $106 = $bc49024203989caa$var$mul(max$prime - min$prime);
            return function($107) {
                return unscale($105($106($107)));
            };
        }())($bc49024203989caa$export$379455b567eff87d);
    };
};
var $bc49024203989caa$export$6d788b9a2716f3a2 = $bc49024203989caa$var$bindStateT;
var $bc49024203989caa$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($bc49024203989caa$export$6d788b9a2716f3a2);
var $bc49024203989caa$export$7ca27958f28e2974 = function(xxs) {
    var total = $bc49024203989caa$var$unwrap($bc49024203989caa$var$foldMap1(function($108) {
        return $e48f2e41a907ae60$export$14f8ce08180a98e1($71f2e2e9476163f8$export$9e770fa6ce19a9d6($108));
    })(xxs));
    var $$default = $71f2e2e9476163f8$export$6f71268a1666ab58($e39dfcf102cdca3c$export$5fd5031fecdacec3(xxs));
    var pick = function($copy_i) {
        return function($copy_n) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, n) {
                var v = $e39dfcf102cdca3c$export$b610b8812bbcded9(xxs)(i);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $$default;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    if (n <= v.value0.value0) {
                        $tco_done = true;
                        return v.value0.value1;
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_i = i + 1 | 0;
                        $copy_n = n - v.value0.value0;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Test.QuickCheck.Gen (line 168, column 16 - line 172, column 44): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_n);
            return $tco_result;
        };
    };
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$7877a478dd30fd3d(0)(total))(function(n) {
        return pick(0)(n);
    });
};
var $bc49024203989caa$export$f24ec99cecd50fca = /* #__PURE__ */ $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca);
var $bc49024203989caa$var$chooseInt$prime = function(a) {
    return function(b) {
        var numB = $4ab74a20512cef04$export$a0a81dc3380ce7d3(b);
        var numA = $4ab74a20512cef04$export$a0a81dc3380ce7d3(a);
        var clamp = function(x) {
            return numA + $9a14cd925227149d$export$159037f780d3415c(x)(numB - numA + 1);
        };
        var choose31BitPosNumber = $bc49024203989caa$var$map2($4ab74a20512cef04$export$a0a81dc3380ce7d3)($bc49024203989caa$var$lcgStep);
        var choose32BitPosNumber = $bc49024203989caa$var$apply($bc49024203989caa$var$map2($bc49024203989caa$var$add)(choose31BitPosNumber))($bc49024203989caa$var$map2($bc49024203989caa$var$mul(2.0))(choose31BitPosNumber));
        return $bc49024203989caa$var$map2(function($109) {
            return $8d5664f12212b23e$export$a3fe094919f356fd(clamp($109));
        })(choose32BitPosNumber);
    };
};
var $bc49024203989caa$export$24b3f9c3c8227daa = function(a) {
    return function(b) {
        var $101 = a <= b;
        if ($101) return $bc49024203989caa$var$chooseInt$prime(a)(b);
        return $bc49024203989caa$var$chooseInt$prime(b)(a);
    };
};
var $bc49024203989caa$export$e57ff0f701c44363 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$export$b81db5163bc14d3a(k)(g);
        });
    });
};
var $bc49024203989caa$export$f103a64475a4fd0b = {
    chooseInt: $bc49024203989caa$export$24b3f9c3c8227daa,
    chooseFloat: $bc49024203989caa$export$7877a478dd30fd3d,
    chooseBool: /* #__PURE__ */ $bc49024203989caa$var$map2(function(v) {
        return v < 0.5;
    })($bc49024203989caa$export$379455b567eff87d),
    resize: function(f) {
        return function(g) {
            return $bc49024203989caa$export$c1c8be52b85daeca(function(s) {
                return $bc49024203989caa$export$4380c87abf28fdf(f(s))(g);
            });
        };
    },
    sized: $bc49024203989caa$export$c1c8be52b85daeca,
    Monad0: function() {
        return $bc49024203989caa$export$52ad81a118d95d95;
    }
};
var $bc49024203989caa$export$a9a18ae5ba42aeab = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($e39dfcf102cdca3c$export$f24224f1c91d8156(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$unsafeIndex(xs)(n);
    });
};
var $bc49024203989caa$export$69ada092a2da39c = /* #__PURE__ */ $e9bda291f4ec10ec$export$5cbc630d6fbe2e14($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $bc49024203989caa$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($bc49024203989caa$export$69ada092a2da39c);
var $bc49024203989caa$export$d809131b0d748327 = function(g) {
    return $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
        return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))(function(k) {
            return $bc49024203989caa$var$bind1(g)(function(x) {
                return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a(k - 1 | 0)(g))(function(xs) {
                    return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x)(xs))));
                });
            });
        });
    });
};
var $bc49024203989caa$export$7a5d735b2ab6389d = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(0)($e39dfcf102cdca3c$export$f24224f1c91d8156(xs) - 1 | 0))(function(n) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$unsafeIndex(xs)(n));
    });
};
var $bc49024203989caa$export$78a99c8d44d72635 = function(dictBoundedEnum) {
    var fromEnum = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var Bounded0 = dictBoundedEnum.Bounded0();
    var toEnum = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$24b3f9c3c8227daa(fromEnum($69d0e3dbb12088d2$export$40e543e69a8b3fbb(Bounded0)))(fromEnum($69d0e3dbb12088d2$export$1e95b668f3b82d(Bounded0))))(function(i) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$fromJust(toEnum(i)));
    });
};
var $bc49024203989caa$export$448332262467e042 = function(xs) {
    return $bc49024203989caa$var$bind1($bc49024203989caa$export$b81db5163bc14d3a($fc8c1182ec2aefec$export$f24224f1c91d8156(xs))($bc49024203989caa$export$24b3f9c3c8227daa(0)($bc49024203989caa$var$top)))(function(ns) {
        return $bc49024203989caa$var$pure1($bc49024203989caa$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)($396c4c3d9e7fae3c$export$b035e44d7bb4278f($bc49024203989caa$var$comparing($71f2e2e9476163f8$export$9e770fa6ce19a9d6))($396c4c3d9e7fae3c$export$8901015135f2fb22(ns)(xs))));
    });
};
var $bc49024203989caa$export$a7e2a49ace6c34c5 = function(gen) {
    return function(pred) {
        var go = function(v) {
            return $bc49024203989caa$var$bind1(gen)(function(a) {
                return $bc49024203989caa$var$pure1(function() {
                    var $102 = pred(a);
                    if ($102) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(a);
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                }());
            });
        };
        return $bc49024203989caa$var$tailRecM(go)($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $bc49024203989caa$export$9a3b72d4f4d3c6b8 = /* #__PURE__ */ $e9bda291f4ec10ec$export$d5bde0fdc0bca75b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)($50c50d1f444e5fa4$export$1cd7ff14f6a7fcef);



var $015c2f962b1b4ea6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $015c2f962b1b4ea6$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $015c2f962b1b4ea6$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $015c2f962b1b4ea6$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $015c2f962b1b4ea6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $015c2f962b1b4ea6$var$wrap = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $015c2f962b1b4ea6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($bc49024203989caa$export$69ada092a2da39c);
var $015c2f962b1b4ea6$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d);
var $015c2f962b1b4ea6$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($bc49024203989caa$export$6d788b9a2716f3a2);
var $015c2f962b1b4ea6$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca);
var $015c2f962b1b4ea6$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $015c2f962b1b4ea6$var$genMaybe = /* #__PURE__ */ $26405903fe88aca2$export$814577261e602aa0($bc49024203989caa$export$f103a64475a4fd0b);
var $015c2f962b1b4ea6$var$genEither = /* #__PURE__ */ $26405903fe88aca2$export$4c044f8c47b13786($bc49024203989caa$export$f103a64475a4fd0b);
var $015c2f962b1b4ea6$export$861a40465c22b816 = {
    coarbitrary: function(v) {
        return $015c2f962b1b4ea6$var$identity;
    }
};
var $015c2f962b1b4ea6$export$fa568a34e9057c95 = function(dict) {
    return dict.coarbitrary;
};
var $015c2f962b1b4ea6$export$133fabada3459bf2 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$5b13dccb935ebfc = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$c1fcdb426307b7f1 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $211 = coarbitrary4(v.value1);
                var $212 = coarbitrary3(v.value0);
                return function($213) {
                    return $211($212($213));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$d57c6210617cde99 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return coarbitrary3(v.value0);
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return coarbitrary4(v.value0);
                throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 249, column 1 - line 251, column 38): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $015c2f962b1b4ea6$export$32b717d60d3a07f5 = function(dictGeneric) {
    var from = $91c996e9c07e3b3f$export$6788812c4e6611e6(dictGeneric);
    return function(dictCoarbitrary) {
        var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
        return function(x) {
            return coarbitrary3(from(x));
        };
    };
};
var $015c2f962b1b4ea6$export$842c7e46be26b8 = {
    coarbitrary: function(v) {
        return $bc49024203989caa$export$1c0695923c609880(1.0);
    }
};
var $015c2f962b1b4ea6$export$b84841b17616fb21 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $214 = coarbitrary4(v.value1);
                var $215 = coarbitrary3(v.value0);
                return function($216) {
                    return $214($215($216));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$42da7c65c0c86615 = {
    coarbitrary: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $bc49024203989caa$export$1c0695923c609880(1.0);
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $bc49024203989caa$export$1c0695923c609880(2.0);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $bc49024203989caa$export$1c0695923c609880(3.0);
        throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 123, column 1 - line 126, column 34): " + [
            v.constructor.name
        ]);
    }
};
var $015c2f962b1b4ea6$export$c955bf422d2842ab = {
    coarbitrary: $bc49024203989caa$export$1c0695923c609880
};
var $015c2f962b1b4ea6$export$3df6fd0aac33bc4d = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                var $217 = coarbitrary3(v.value1);
                var $218 = coarbitrary4(v.value0);
                return function($219) {
                    return $217($218($219));
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$78f80636858d77cf = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $bc49024203989caa$export$1c0695923c609880(1.0);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return coarbitrary3(v.value0);
            throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 187, column 1 - line 189, column 39): " + [
                v.constructor.name
            ]);
        }
    };
};
var $015c2f962b1b4ea6$export$1c88b540e53f1367 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: $015c2f962b1b4ea6$var$foldl(function(f) {
            return function(x) {
                var $220 = coarbitrary3(x);
                return function($221) {
                    return f($220($221));
                };
            };
        })($015c2f962b1b4ea6$var$identity)
    };
};
var $015c2f962b1b4ea6$export$45d23c89ee56081f = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$3df6fd0aac33bc4d($015c2f962b1b4ea6$export$1c88b540e53f1367(dictCoarbitrary))(dictCoarbitrary));
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$f6298d343c57762e = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(a) {
            return coarbitrary3($99af8ad7682e39c7$export$4d82290515cd0ddb(a));
        }
    };
};
var $015c2f962b1b4ea6$export$8d82884d164ab631 = {
    coarbitrary: function($222) {
        return $bc49024203989caa$export$1c0695923c609880($4ab74a20512cef04$export$a0a81dc3380ce7d3($222));
    }
};
var $015c2f962b1b4ea6$var$coarbitrary1 = /* #__PURE__ */ $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$8d82884d164ab631);
var $015c2f962b1b4ea6$export$13af4cd5dc1ddde9 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: function(v) {
            return coarbitrary3(v);
        }
    };
};
var $015c2f962b1b4ea6$export$62394f742bc4ab7 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictCoarbitrary1) {
        var coarbitrary4 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary1);
        return {
            coarbitrary: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return coarbitrary3(v.value0);
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return coarbitrary4(v.value0);
                throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 194, column 1 - line 196, column 40): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $015c2f962b1b4ea6$export$da64647ab4f27ecb = {
    coarbitrary: function(c) {
        return $015c2f962b1b4ea6$var$coarbitrary1($015c2f962b1b4ea6$var$fromEnum(c));
    }
};
var $015c2f962b1b4ea6$export$95b1b165fefacaf6 = {
    coarbitrary: function(v) {
        if (v) return $bc49024203989caa$export$1c0695923c609880(1.0);
        if (!v) return $bc49024203989caa$export$1c0695923c609880(2.0);
        throw new Error("Failed pattern match at Test.QuickCheck.Arbitrary (line 80, column 1 - line 82, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return {
        coarbitrary: $015c2f962b1b4ea6$var$foldl1(function(f) {
            return function(x) {
                var $223 = coarbitrary3(x);
                return function($224) {
                    return f($223($224));
                };
            };
        })($015c2f962b1b4ea6$var$identity)
    };
};
var $015c2f962b1b4ea6$var$coarbitrary2 = /* #__PURE__ */ $015c2f962b1b4ea6$export$fa568a34e9057c95(/* #__PURE__ */ $015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(/* #__PURE__ */ $015c2f962b1b4ea6$export$78f80636858d77cf($015c2f962b1b4ea6$export$da64647ab4f27ecb)));
var $015c2f962b1b4ea6$export$16a20aeec0a3142c = function(dictCoarbitrary) {
    return {
        coarbitrary: function() {
            var $225 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(dictCoarbitrary));
            return function($226) {
                return $225($e39dfcf102cdca3c$export$45b10814cc054894($226));
            };
        }()
    };
};
var $015c2f962b1b4ea6$export$d9f93714e8eaead1 = {
    coarbitrary: function(s) {
        return $015c2f962b1b4ea6$var$coarbitrary2($015c2f962b1b4ea6$var$map($1a77d6934b592676$export$bbcf894add1d392c(0))($5b07e36f812dd04b$export$65980d18b75784e2($015c2f962b1b4ea6$var$wrap(""))(s)));
    }
};
var $015c2f962b1b4ea6$export$892519f250c4be9 = {
    coarbitrary: /* #__PURE__ */ function() {
        var $227 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$d9f93714e8eaead1);
        return function($228) {
            return $227($5505a3400147efbd$export$f84e8e69fd4488a5($228));
        };
    }()
};
var $015c2f962b1b4ea6$export$e2d53d3c92ca8e5f = {
    arbitraryRecord: function(v) {
        return $015c2f962b1b4ea6$var$pure({});
    }
};
var $015c2f962b1b4ea6$export$df70e74a961d9c9 = function(dict) {
    return dict.arbitraryRecord;
};
var $015c2f962b1b4ea6$export$f36b0b309ad6e0ca = function() {
    return function(dictArbitraryRowList) {
        return {
            arbitrary: $015c2f962b1b4ea6$export$df70e74a961d9c9(dictArbitraryRowList)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $015c2f962b1b4ea6$export$38522914432e39fd = /* #__PURE__ */ function() {
    return {
        arbitrary: $015c2f962b1b4ea6$var$pure($91c996e9c07e3b3f$export$928c7f2d618c070b.value)
    };
}();
var $015c2f962b1b4ea6$export$39644750a668e0b0 = function(dict) {
    return dict.arbitraryGenericSum;
};
var $015c2f962b1b4ea6$export$11be7c034231ec78 = function(dict) {
    return dict.arbitrary;
};
var $015c2f962b1b4ea6$export$a85aa5ff6696db10 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$84637ea037d2e218)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$dca64850086bd9e9 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$8bfc33963ccbb2a)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$88e1efb12b274102 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($50c50d1f444e5fa4$export$544bf02140fa9a77)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$1fa12060b5b0a611 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$bind($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))(function($229) {
            return $015c2f962b1b4ea6$var$pure($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($229)));
        })
    };
};
var $015c2f962b1b4ea6$export$bab0bb9deb3e9d00 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return {
        arbitrary: $bc49024203989caa$export$c1c8be52b85daeca(function(n) {
            return $015c2f962b1b4ea6$var$bind($bc49024203989caa$export$24b3f9c3c8227daa(0)(n))($f57f4b701aa7b66e$export$8a83211c878a3f1f($bc49024203989caa$export$2e12bfb3e89e4ebb)(arbitrary1));
        })
    };
};
var $015c2f962b1b4ea6$export$c73be5e2553898b4 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$264ad599d7cef668.create)(arbitrary1))($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$5f8951a9546a42f5 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryRowList) {
        var arbitraryRecord1 = $015c2f962b1b4ea6$export$df70e74a961d9c9(dictArbitraryRowList);
        return function() {
            return function() {
                return function() {
                    return function(dictIsSymbol) {
                        var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
                        return {
                            arbitraryRecord: function(v) {
                                return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(value) {
                                    return $015c2f962b1b4ea6$var$bind(arbitraryRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(function(previous) {
                                        return $015c2f962b1b4ea6$var$pure(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(value)(previous));
                                    });
                                });
                            }
                        };
                    };
                };
            };
        };
    };
};
var $015c2f962b1b4ea6$export$cb90f6dcb5b2d3fc = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryGenericSum) {
        return {
            arbitrary: $bc49024203989caa$export$a9a18ae5ba42aeab($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$8327ebbef2a0ba76($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$dd5fad028b7772cd.create)(arbitrary1))($015c2f962b1b4ea6$var$map($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$df71ca4577dbdff6.create))($015c2f962b1b4ea6$export$39644750a668e0b0(dictArbitraryGenericSum))))))
        };
    };
};
var $015c2f962b1b4ea6$export$f575d4062c2cc1a7 = function(dictGeneric) {
    var to = $91c996e9c07e3b3f$export$2c618a4308a30424(dictGeneric);
    return function(dictArbitrary) {
        return $015c2f962b1b4ea6$var$map1(to)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary));
    };
};
var $015c2f962b1b4ea6$export$bec194de819af8c7 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$pure($05149ea687d6b460$export$523c0b569236b342)
};
var $015c2f962b1b4ea6$export$1a314bd0d9117271 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create)(arbitrary1))($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$a79945929bf98a5b = /* #__PURE__ */ function() {
    return {
        arbitrary: $bc49024203989caa$export$7a5d735b2ab6389d($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e([
            $5026be88823ef1f4$export$7158f0ceb70f54c7.value,
            $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value,
            $5026be88823ef1f4$export$b023c82b48e70453.value
        ])))
    };
}();
var $015c2f962b1b4ea6$export$b387f11d309e6775 = {
    arbitrary: $bc49024203989caa$export$379455b567eff87d
};
var $015c2f962b1b4ea6$export$295408394c3b9019 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$apply($015c2f962b1b4ea6$var$map1($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1)))(arbitrary1)
        };
    };
};
var $015c2f962b1b4ea6$export$30697c93cf332701 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($78c799cba34fcb8d$export$ab241a3582569781)($015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$295408394c3b9019($015c2f962b1b4ea6$export$bab0bb9deb3e9d00(dictArbitrary))(dictArbitrary)))
    };
};
var $015c2f962b1b4ea6$export$6a544b0a2ef23806 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($665413393090e9d0$export$d0198c9c86fc2be1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$fdae917d8821d63f = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$genMaybe($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$17074bd582307253 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($19578e25953179c0$export$bed9238d8933c9a8)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$fb30076ef0cfa906 = /* #__PURE__ */ function() {
    return {
        arbitrary: $bc49024203989caa$export$24b3f9c3c8227daa(-1000000)(1000000)
    };
}();
var $015c2f962b1b4ea6$export$5fe62db8f5e41ef7 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitraryGenericSum) {
        return {
            arbitraryGenericSum: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$dd5fad028b7772cd.create)(arbitrary1))($015c2f962b1b4ea6$var$map($015c2f962b1b4ea6$var$map1($91c996e9c07e3b3f$export$df71ca4577dbdff6.create))($015c2f962b1b4ea6$export$39644750a668e0b0(dictArbitraryGenericSum)))
        };
    };
};
var $015c2f962b1b4ea6$export$4842e4f68d486a6 = function(dictArbitrary) {
    return {
        arbitraryGenericSum: [
            $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$dca64850086bd9e9(dictArbitrary))
        ]
    };
};
var $015c2f962b1b4ea6$export$2a9d85b1c8520746 = function(dictCoarbitrary) {
    var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95(dictCoarbitrary);
    return function(dictArbitrary) {
        var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
        return {
            arbitrary: $bc49024203989caa$export$a1767e9fa438fa19(function(a) {
                return coarbitrary3(a)(arbitrary1);
            })
        };
    };
};
var $015c2f962b1b4ea6$export$4fb4ffb23a5a31e4 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($6c6a555e6244fc9c$export$b25abba66f7be210)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$771b18865ddf6ea = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($57b8542ac3131c5d$export$6aef3ff797629bec)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$e2b294368e8fdc49 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary);
    return function(dictArbitrary1) {
        return {
            arbitrary: $015c2f962b1b4ea6$var$genEither(arbitrary1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary1))
        };
    };
};
var $015c2f962b1b4ea6$export$fc8e201052e462f4 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($8257f7a36ab9f9cd$export$c26a72e8d91adeec)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$1a8e34126024bfa9 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($1242d110ab1edcd9$export$286e7113895e33ef)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$783d1c888386f680 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($65ae0a43a0950bac$export$c688766eb4789b8c)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$c1be33fa5eb75494 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$map1(/* #__PURE__ */ $f935a9866e211c00$export$1e2c188a485bdeae($f935a9866e211c00$export$be1f07c3580164c)(/* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79))(/* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79)))(/* #__PURE__ */ $bc49024203989caa$export$24b3f9c3c8227daa(0)(65536))
};
var $015c2f962b1b4ea6$export$bc46b00127c8a98c = {
    arbitrary: /* #__PURE__ */ $f38acfbf15955b73$export$ed1be54c7ccedf5b($bc49024203989caa$export$f103a64475a4fd0b)
};
var $015c2f962b1b4ea6$export$575cda352fa57683 = function(dictArbitrary) {
    return {
        arbitrary: $bc49024203989caa$export$e57ff0f701c44363($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};
var $015c2f962b1b4ea6$export$ed5d9d023af9ba05 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$575cda352fa57683(dictArbitrary));
    return {
        arbitrary: $015c2f962b1b4ea6$var$bind($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))(function(x) {
            return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(xs) {
                return $015c2f962b1b4ea6$var$pure($015c2f962b1b4ea6$var$fromJust($e39dfcf102cdca3c$export$571d59b505e6bb4e(function __do() {
                    var mxs = $784e144d56146b5c$export$cc9b8725eef9c137(xs)();
                    $784e144d56146b5c$export$4cbf152802aa238(x)(mxs)();
                    return $784e144d56146b5c$export$7c850c5af9b9983e(mxs)();
                }())));
            });
        })
    };
};
var $015c2f962b1b4ea6$export$fb88443f408965ad = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$map1($092fe44bc0883be6$export$709e3b51bf2e2249)(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78(/* #__PURE__ */ $015c2f962b1b4ea6$export$575cda352fa57683($015c2f962b1b4ea6$export$c1be33fa5eb75494)))
};
var $015c2f962b1b4ea6$export$7e267739562d6412 = {
    arbitrary: /* #__PURE__ */ $015c2f962b1b4ea6$var$apply(/* #__PURE__ */ $015c2f962b1b4ea6$var$map1($be985434983c0a5f$export$8327ebbef2a0ba76)(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$c1be33fa5eb75494)))(/* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$fb88443f408965ad))
};
var $015c2f962b1b4ea6$export$236978e8a91250c5 = function(dictArbitrary) {
    var arbitrary1 = $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$575cda352fa57683(dictArbitrary));
    return function(dictCoarbitrary) {
        var coarbitrary3 = $015c2f962b1b4ea6$export$fa568a34e9057c95($015c2f962b1b4ea6$export$b1c4b6cc9f6e15d5(dictCoarbitrary));
        return {
            coarbitrary: function(f) {
                return function(gen) {
                    return $015c2f962b1b4ea6$var$bind(arbitrary1)(function(xs) {
                        return coarbitrary3($015c2f962b1b4ea6$var$map(f)(xs))(gen);
                    });
                };
            }
        };
    };
};
var $015c2f962b1b4ea6$export$bad24e41c274ef0 = function(dictArbitrary) {
    return {
        arbitrary: $015c2f962b1b4ea6$var$map1($e48f2e41a907ae60$export$14f8ce08180a98e1)($015c2f962b1b4ea6$export$11be7c034231ec78(dictArbitrary))
    };
};



var $77539ec2bd3ecb1b$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($42bb2ee83e728aa3$export$69fb02bfcf12f956);
var $77539ec2bd3ecb1b$var$zero = /* #__PURE__ */ $c0e822be92afc4df$export$7f9972325ebfd559($42bb2ee83e728aa3$export$69fb02bfcf12f956);
var $77539ec2bd3ecb1b$var$mul = /* #__PURE__ */ $c0e822be92afc4df$export$6e3a27864ab166fe($42bb2ee83e728aa3$export$69fb02bfcf12f956);
var $77539ec2bd3ecb1b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($bc49024203989caa$export$6d788b9a2716f3a2);
var $77539ec2bd3ecb1b$var$arbitrary = /* #__PURE__ */ $015c2f962b1b4ea6$export$11be7c034231ec78($015c2f962b1b4ea6$export$fb30076ef0cfa906);
var $77539ec2bd3ecb1b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($bc49024203989caa$export$69ada092a2da39c);
var $77539ec2bd3ecb1b$var$sub2 = /* #__PURE__ */ $d061555d3b2c84b2$export$f93b5905241a7cca($42bb2ee83e728aa3$export$e306a275e43b2c5c);
var $77539ec2bd3ecb1b$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $77539ec2bd3ecb1b$var$secondsIsSymbol = {
    reflectSymbol: function() {
        return "seconds";
    }
};
var $77539ec2bd3ecb1b$var$nanosIsSymbol = {
    reflectSymbol: function() {
        return "nanos";
    }
};
var $77539ec2bd3ecb1b$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$fee2d5446387c54f))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($77539ec2bd3ecb1b$var$secondsIsSymbol)()())($77539ec2bd3ecb1b$var$nanosIsSymbol)()())());
var $77539ec2bd3ecb1b$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $77539ec2bd3ecb1b$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $77539ec2bd3ecb1b$var$lessThan = /* #__PURE__ */ $97937c29f879e68e$export$9b050841a3a1b328($42bb2ee83e728aa3$export$6e394a688eb23b55);
var $77539ec2bd3ecb1b$var$greaterThanOrEq = /* #__PURE__ */ $97937c29f879e68e$export$4be320a4fd1ac499($42bb2ee83e728aa3$export$6e394a688eb23b55);
var $77539ec2bd3ecb1b$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($5dfefa023749ded0$export$390154ec55cffb04);
var $77539ec2bd3ecb1b$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$b198596427f378ab);
var $77539ec2bd3ecb1b$var$encodeJson1 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$ff344db3ed099c93);
var $77539ec2bd3ecb1b$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $77539ec2bd3ecb1b$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($42bb2ee83e728aa3$export$ef4744d73986e4c1);
var $77539ec2bd3ecb1b$var$div1 = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($42bb2ee83e728aa3$export$ef4744d73986e4c1);
var $77539ec2bd3ecb1b$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$ff344db3ed099c93);
var $77539ec2bd3ecb1b$var$encodeJson2 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $77539ec2bd3ecb1b$var$gEncodeJsonCons(/* #__PURE__ */ $77539ec2bd3ecb1b$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726)($77539ec2bd3ecb1b$var$secondsIsSymbol)())($77539ec2bd3ecb1b$var$nanosIsSymbol)())());
var $77539ec2bd3ecb1b$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $77539ec2bd3ecb1b$var$Duration = function(x) {
    return x;
};
var $77539ec2bd3ecb1b$export$be90a4e56bd555d = {
    show: function(v) {
        return '(D.fromStr "' + ($42bb2ee83e728aa3$export$f84e8e69fd4488a5(v) + '")');
    }
};
var $77539ec2bd3ecb1b$export$81344b777cb25916 = {
    append: function(v) {
        return function(v1) {
            return $77539ec2bd3ecb1b$var$add(v)(v1);
        };
    }
};
var $77539ec2bd3ecb1b$export$344a6ecac1b76847 = $42bb2ee83e728aa3$export$6e394a688eb23b55;
var $77539ec2bd3ecb1b$export$9f1c1a0ca1896daf = {
    mempty: $77539ec2bd3ecb1b$var$zero,
    Semigroup0: function() {
        return $77539ec2bd3ecb1b$export$81344b777cb25916;
    }
};
var $77539ec2bd3ecb1b$export$4f82b8060a07bc6 = $42bb2ee83e728aa3$export$a3814c85036d46cf;
var $77539ec2bd3ecb1b$export$68674a2aef2c81c4 = {
    fromDuration: function(v) {
        var numInNano = $998a039567e3ac95$export$a0a81dc3380ce7d3(v);
        var numInMs = numInNano / 1000000.0;
        return numInMs;
    },
    toDuration: function(v) {
        var wholePart = $9a14cd925227149d$export$a3fe094919f356fd(v);
        var wholePartNanos = $77539ec2bd3ecb1b$var$mul($06733ae99ed4f534$export$43db023a260c5e9f($77539ec2bd3ecb1b$var$zero)($42bb2ee83e728aa3$export$7bbb4164c9a77bc2(wholePart)))($998a039567e3ac95$export$62ffe363f1b08494(1000000));
        var fractionalPart = v - wholePart;
        var fractionalPartNanos = $06733ae99ed4f534$export$43db023a260c5e9f($77539ec2bd3ecb1b$var$zero)($42bb2ee83e728aa3$export$7bbb4164c9a77bc2(fractionalPart * 1000000.0));
        return $77539ec2bd3ecb1b$var$add(wholePartNanos)(fractionalPartNanos);
    }
};
var $77539ec2bd3ecb1b$var$toDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$9eabacebe6624782($77539ec2bd3ecb1b$export$68674a2aef2c81c4);
var $77539ec2bd3ecb1b$export$f8bfe8367b459bd7 = {
    arbitrary: /* #__PURE__ */ $77539ec2bd3ecb1b$var$bind($77539ec2bd3ecb1b$var$arbitrary)(function(v) {
        return $77539ec2bd3ecb1b$var$bind($77539ec2bd3ecb1b$var$arbitrary)(function(v1) {
            return $77539ec2bd3ecb1b$var$bind($77539ec2bd3ecb1b$var$arbitrary)(function(v2) {
                return $77539ec2bd3ecb1b$var$pure($77539ec2bd3ecb1b$var$mul($77539ec2bd3ecb1b$var$mul($998a039567e3ac95$export$62ffe363f1b08494(v))($998a039567e3ac95$export$62ffe363f1b08494(v1)))($998a039567e3ac95$export$62ffe363f1b08494(v2)));
            });
        });
    })
};
var $77539ec2bd3ecb1b$export$f93b5905241a7cca = function(v) {
    return function(v1) {
        return $77539ec2bd3ecb1b$var$sub2(v)(v1);
    };
};
var $77539ec2bd3ecb1b$export$dcdf75081b88279d = function(factor) {
    return function(v) {
        return $77539ec2bd3ecb1b$var$mul(v)($998a039567e3ac95$export$62ffe363f1b08494(factor));
    };
};
var $77539ec2bd3ecb1b$var$nanosPerSecond = /* #__PURE__ */ $998a039567e3ac95$export$62ffe363f1b08494(1000000000);
var $77539ec2bd3ecb1b$export$85d1ccf85e38e58e = {
    decodeJson: function(json) {
        return $77539ec2bd3ecb1b$var$bind1($77539ec2bd3ecb1b$var$decodeJson(json))(function(v) {
            var nanosBi = $998a039567e3ac95$export$62ffe363f1b08494(v.nanos);
            return $77539ec2bd3ecb1b$var$discard($77539ec2bd3ecb1b$var$when($77539ec2bd3ecb1b$var$lessThan(nanosBi)($77539ec2bd3ecb1b$var$zero) || $77539ec2bd3ecb1b$var$greaterThanOrEq(nanosBi)($77539ec2bd3ecb1b$var$nanosPerSecond))($77539ec2bd3ecb1b$var$throwError(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("nanos", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($77539ec2bd3ecb1b$var$encodeJson(v.nanos))))))(function() {
                return $77539ec2bd3ecb1b$var$bind1($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("seconds", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($77539ec2bd3ecb1b$var$encodeJson1(v.seconds))))($42bb2ee83e728aa3$export$7bbb4164c9a77bc2(v.seconds)))(function(v1) {
                    return $77539ec2bd3ecb1b$var$pure1($77539ec2bd3ecb1b$var$add($77539ec2bd3ecb1b$var$mul(v1)($77539ec2bd3ecb1b$var$nanosPerSecond))(nanosBi));
                });
            });
        });
    }
};
var $77539ec2bd3ecb1b$export$d4d30c563312c444 = {
    encodeJson: function(v) {
        var nanos = $77539ec2bd3ecb1b$var$mod(v)($77539ec2bd3ecb1b$var$nanosPerSecond);
        var seconds = $77539ec2bd3ecb1b$var$div1(v)($77539ec2bd3ecb1b$var$nanosPerSecond);
        return $77539ec2bd3ecb1b$var$encodeJson2({
            seconds: $998a039567e3ac95$export$a0a81dc3380ce7d3(seconds),
            nanos: $998a039567e3ac95$export$a0a81dc3380ce7d3(nanos)
        });
    }
};
var $77539ec2bd3ecb1b$export$efeb4d52140d5239 = function() {
    return function(str) {
        return $77539ec2bd3ecb1b$var$fromJust($42bb2ee83e728aa3$export$3004f64547af360e(str));
    };
};
var $77539ec2bd3ecb1b$export$a4cfb53d2e8c8e2a = function(ms) {
    return $77539ec2bd3ecb1b$var$toDuration(ms);
};








// Generated by purs version 0.15.15
function $6bdc250f9303b68c$var$wrap(method) {
    return function(d) {
        return function(num) {
            return method.apply(num, [
                d
            ]);
        };
    };
}
const $6bdc250f9303b68c$export$9815865600981587 = $6bdc250f9303b68c$var$wrap(Number.prototype.toPrecision);
const $6bdc250f9303b68c$export$774771fbf04a1705 = $6bdc250f9303b68c$var$wrap(Number.prototype.toFixed);
const $6bdc250f9303b68c$export$f13bf1cdd2e9b9e3 = $6bdc250f9303b68c$var$wrap(Number.prototype.toExponential);
function $6bdc250f9303b68c$export$f84e8e69fd4488a5(num) {
    return num.toString();
}



var $73e6cbfd0da8b99a$var$clamp = /* #__PURE__ */ $97937c29f879e68e$export$7d15b64cf5a3a4c4($97937c29f879e68e$export$ff461bf68e7dd332);
var $73e6cbfd0da8b99a$var$Precision = /* #__PURE__ */ function() {
    function Precision(value0) {
        this.value0 = value0;
    }
    Precision.create = function(value0) {
        return new Precision(value0);
    };
    return Precision;
}();
var $73e6cbfd0da8b99a$var$Fixed = /* #__PURE__ */ function() {
    function Fixed(value0) {
        this.value0 = value0;
    }
    Fixed.create = function(value0) {
        return new Fixed(value0);
    };
    return Fixed;
}();
var $73e6cbfd0da8b99a$var$Exponential = /* #__PURE__ */ function() {
    function Exponential(value0) {
        this.value0 = value0;
    }
    Exponential.create = function(value0) {
        return new Exponential(value0);
    };
    return Exponential;
}();
var $73e6cbfd0da8b99a$export$bfa12905cd10b99c = function(v) {
    if (v instanceof $73e6cbfd0da8b99a$var$Precision) return $6bdc250f9303b68c$export$9815865600981587(v.value0);
    if (v instanceof $73e6cbfd0da8b99a$var$Fixed) return $6bdc250f9303b68c$export$774771fbf04a1705(v.value0);
    if (v instanceof $73e6cbfd0da8b99a$var$Exponential) return $6bdc250f9303b68c$export$f13bf1cdd2e9b9e3(v.value0);
    throw new Error("Failed pattern match at Data.Number.Format (line 59, column 1 - line 59, column 43): " + [
        v.constructor.name
    ]);
};
var $73e6cbfd0da8b99a$export$b70eeb0e623ceb0d = /* #__PURE__ */ function() {
    var $7 = $73e6cbfd0da8b99a$var$clamp(1)(21);
    return function($8) {
        return $73e6cbfd0da8b99a$var$Precision.create($7($8));
    };
}();
var $73e6cbfd0da8b99a$export$3ef1e4fab5115712 = /* #__PURE__ */ function() {
    var $9 = $73e6cbfd0da8b99a$var$clamp(0)(20);
    return function($10) {
        return $73e6cbfd0da8b99a$var$Fixed.create($9($10));
    };
}();
var $73e6cbfd0da8b99a$export$d1fa2f47db032cbd = /* #__PURE__ */ function() {
    var $11 = $73e6cbfd0da8b99a$var$clamp(0)(20);
    return function($12) {
        return $73e6cbfd0da8b99a$var$Exponential.create($11($12));
    };
}();









// Generated by purs version 0.15.15




var $ec52a8164fabd1b2$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $ec52a8164fabd1b2$export$28709abf85ddce1d = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $55 = $78386b654cef599e$export$28709abf85ddce1d(dictShow);
        return function($56) {
            return liftEffect($55($56));
        };
    };
};
var $ec52a8164fabd1b2$export$c106dd0671a0fc2d = function(dictMonadEffect) {
    var $57 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($58) {
        return $57($93c729927fdf3160$export$c106dd0671a0fc2d($58));
    };
};
var $ec52a8164fabd1b2$export$1694f226a9241aae = function(dictMonadEffect) {
    var $59 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($60) {
        return $59($93c729927fdf3160$export$1694f226a9241aae($60));
    };
};
var $ec52a8164fabd1b2$export$8f2977fb54cb3601 = function(dictMonadEffect) {
    var $61 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($62) {
        return $61($93c729927fdf3160$export$8f2977fb54cb3601($62));
    };
};
var $ec52a8164fabd1b2$export$2da9be4cfdb689b1 = function(dictMonadEffect) {
    var $63 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($64) {
        return $63($93c729927fdf3160$export$2da9be4cfdb689b1($64));
    };
};
var $ec52a8164fabd1b2$export$9f43f5977f8d5609 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $65 = $78386b654cef599e$export$9f43f5977f8d5609(dictShow);
        return function($66) {
            return liftEffect($65($66));
        };
    };
};
var $ec52a8164fabd1b2$export$bef1f36f5486a6a3 = function(dictMonadEffect) {
    var $67 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($68) {
        return $67($93c729927fdf3160$export$bef1f36f5486a6a3($68));
    };
};
var $ec52a8164fabd1b2$export$fc9467e2ad369291 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $69 = $78386b654cef599e$export$fc9467e2ad369291(dictShow);
        return function($70) {
            return liftEffect($69($70));
        };
    };
};
var $ec52a8164fabd1b2$export$a80b3bd66acc52ff = function(dictMonadEffect) {
    var $71 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($72) {
        return $71($93c729927fdf3160$export$a80b3bd66acc52ff($72));
    };
};
var $ec52a8164fabd1b2$export$a57f3dfe595273e6 = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$a57f3dfe595273e6);
};
var $ec52a8164fabd1b2$export$488ef8fb3416a29f = function(dictMonadEffect) {
    var $73 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($74) {
        return $73($93c729927fdf3160$export$488ef8fb3416a29f($74));
    };
};
var $ec52a8164fabd1b2$export$e5e25fbcc1f7affe = function(dictMonadEffect) {
    var $75 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($76) {
        return $75($93c729927fdf3160$export$e5e25fbcc1f7affe($76));
    };
};
var $ec52a8164fabd1b2$export$a188e271553f9211 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = $ec52a8164fabd1b2$var$discard(Bind1);
    var group1 = $ec52a8164fabd1b2$export$e5e25fbcc1f7affe(dictMonadEffect);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var groupEnd1 = $ec52a8164fabd1b2$export$a57f3dfe595273e6(dictMonadEffect);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(name) {
        return function(inner) {
            return discard1(group1(name))(function() {
                return bind(inner)(function(result) {
                    return discard1(groupEnd1)(function() {
                        return pure(result);
                    });
                });
            });
        };
    };
};
var $ec52a8164fabd1b2$export$cbd229996ecd7704 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $77 = $78386b654cef599e$export$cbd229996ecd7704(dictShow);
        return function($78) {
            return liftEffect($77($78));
        };
    };
};
var $ec52a8164fabd1b2$export$a3bc9b8ed74fc = function(dictMonadEffect) {
    var $79 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($80) {
        return $79($93c729927fdf3160$export$a3bc9b8ed74fc($80));
    };
};
var $ec52a8164fabd1b2$export$18fab8ed91d044eb = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $81 = $78386b654cef599e$export$18fab8ed91d044eb(dictShow);
        return function($82) {
            return liftEffect($81($82));
        };
    };
};
var $ec52a8164fabd1b2$export$1c9f709888824e05 = function(dictMonadEffect) {
    var $83 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($84) {
        return $83($93c729927fdf3160$export$1c9f709888824e05($84));
    };
};
var $ec52a8164fabd1b2$export$42ffd38884aecdac = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$42ffd38884aecdac);
};


// Generated by purs version 0.15.15
function $04a918a3ed46422a$export$461939dd4422153() {
    return Date.now();
}
function $04a918a3ed46422a$export$4c9db454e2785fd9() {
    var n = new Date(Date.now());
    return n.getTimezoneOffset();
}






var $f4c9a553a5348ce3$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f4c9a553a5348ce3$export$1789df67d9a28d08 = /* #__PURE__ */ $f4c9a553a5348ce3$var$map(function($2) {
    return $18f2b327b2ac3376$export$2da9be4cfdb689b1($0e22ea1e74f8e3e7$export$c2dea5c02f48568d($2));
})($04a918a3ed46422a$export$461939dd4422153);
var $f4c9a553a5348ce3$export$9123026da2f03e72 = /* #__PURE__ */ $f4c9a553a5348ce3$var$map($0e22ea1e74f8e3e7$export$c2dea5c02f48568d)($04a918a3ed46422a$export$461939dd4422153);
var $f4c9a553a5348ce3$export$4197fd15784ef012 = /* #__PURE__ */ $f4c9a553a5348ce3$var$map(function($3) {
    return $18f2b327b2ac3376$export$324d90190a8b822a($0e22ea1e74f8e3e7$export$c2dea5c02f48568d($3));
})($04a918a3ed46422a$export$461939dd4422153);






// Generated by purs version 0.15.15



// Generated by purs version 0.15.15






var $e29c68187e6c3036$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $e29c68187e6c3036$export$47a3d634abc09f70 = /* #__PURE__ */ function() {
    var $3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($50c50d1f444e5fa4$export$fd3b2458e55fc503);
    return function($4) {
        return $d9ef009191ddae40$export$6bef9d59f22e8880($3($4));
    };
}();
var $e29c68187e6c3036$export$79eb0c30e59e91f0 = function($5) {
    return $e29c68187e6c3036$var$unwrap($d9ef009191ddae40$export$973e92d98e897dbf($5));
};
var $e29c68187e6c3036$export$782654d2aac6abda = function(f) {
    return $d9ef009191ddae40$export$c950a71321ef1ffc(function($6) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($e29c68187e6c3036$var$unwrap($6)));
    });
};
var $e29c68187e6c3036$export$57fa136512985dbf = function(m) {
    return $71f2e2e9476163f8$export$6f71268a1666ab58($e29c68187e6c3036$export$79eb0c30e59e91f0(m));
};







// Generated by purs version 0.15.15
// This Source Code Form is subject to the terms of the Mozilla Public
// License, v. 2.0. If a copy of the MPL was not distributed with this
// file, You can obtain one at http://mozilla.org/MPL/2.0/.
"use strict";
function $7225ff3117d1c37e$export$62ee1a9a628ac0e2(o) {
    if (o !== o || o === Infinity) return 0;
    var h = o | 0;
    if (h !== o) h ^= o * 0xffffffff;
    while(o > 0xffffffff){
        o /= 0xffffffff;
        h ^= o;
    }
    return h;
}
function $7225ff3117d1c37e$export$9169be2e06c9c165(s) {
    var h = 0;
    for(var i = 0; i < s.length; i++)h = 31 * h + s.charCodeAt(i) | 0;
    return h;
}











var $f826a0b6995a637c$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $f826a0b6995a637c$export$9e9a625e57eb7c68 = {
    hash: function(v) {
        return 0;
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$2965418ef5ae9704;
    }
};
var $f826a0b6995a637c$export$66b20690a22a7168 = {
    hash: function(v) {
        return 1;
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$671c8820f3b36bad;
    }
};
var $f826a0b6995a637c$export$62216838365b140d = {
    hash: $7225ff3117d1c37e$export$9169be2e06c9c165,
    Eq0: function() {
        return $37b880af5f4991bd$export$fa624555ca2acbc8;
    }
};
var $f826a0b6995a637c$export$c8e6dfb0ac43e34a = {
    hashRecord: function(v) {
        return function(v1) {
            return 0;
        };
    },
    EqRecord0: function() {
        return $37b880af5f4991bd$export$d12253326f924cb1;
    }
};
var $f826a0b6995a637c$export$7213863e2ea5aa04 = {
    hash: $7225ff3117d1c37e$export$62ee1a9a628ac0e2,
    Eq0: function() {
        return $37b880af5f4991bd$export$e24978670be1e4f3;
    }
};
var $f826a0b6995a637c$export$4710cc514553efa8 = {
    hash: function(n) {
        return n;
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$e65788c6d4494539;
    }
};
var $f826a0b6995a637c$export$521fc4c5b1658d1e = {
    hash: /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c),
    Eq0: function() {
        return $37b880af5f4991bd$export$bcd79f9321394c38;
    }
};
var $f826a0b6995a637c$export$1d466edec4bfe328 = {
    hash: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Hashable (line 52, column 1 - line 54, column 16): " + [
            v.constructor.name
        ]);
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$d7927e8ffc1afb48;
    }
};
var $f826a0b6995a637c$export$66693550090a5ac9 = function(dict) {
    return dict.hashRecord;
};
var $f826a0b6995a637c$export$45e8583d24f12bef = function() {
    return function(dictHashableRecord) {
        var hashRecord1 = $f826a0b6995a637c$export$66693550090a5ac9(dictHashableRecord);
        return function(dictEqRecord) {
            var eqRec1 = $f826a0b6995a637c$var$eqRec(dictEqRecord);
            return {
                hash: hashRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
                Eq0: function() {
                    return eqRec1;
                }
            };
        };
    };
};
var $f826a0b6995a637c$export$d6af199866bfb566 = function(dict) {
    return dict.hash;
};
var $f826a0b6995a637c$var$hashFoldable = function(dictFoldable) {
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictHashable) {
        var hash1 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable);
        return foldl(function(h) {
            return function(a) {
                return (31 * h | 0) + hash1(a) | 0;
            };
        })(1);
    };
};
var $f826a0b6995a637c$var$hashFoldable1 = /* #__PURE__ */ $f826a0b6995a637c$var$hashFoldable($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $f826a0b6995a637c$var$hashFoldable2 = /* #__PURE__ */ $f826a0b6995a637c$var$hashFoldable($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f826a0b6995a637c$export$76e0e711b2fff99d = function(dictHashable) {
    var eqArray = $37b880af5f4991bd$export$159e06dc5ec60b00(dictHashable.Eq0());
    return {
        hash: $f826a0b6995a637c$var$hashFoldable1(dictHashable),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $f826a0b6995a637c$export$fb0561421e8cbd6 = function(dictHashable) {
    var eqList = $78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictHashable.Eq0());
    return {
        hash: $f826a0b6995a637c$var$hashFoldable2(dictHashable),
        Eq0: function() {
            return eqList;
        }
    };
};
var $f826a0b6995a637c$export$89d70fe046a54f60 = function(dictHashable) {
    var hash1 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable);
    var eqEither = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictHashable.Eq0());
    return function(dictHashable1) {
        var hash2 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable1);
        var eqEither1 = eqEither(dictHashable1.Eq0());
        return {
            hash: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return hash1(v.value0) ^ 1431655765;
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return hash2(v.value0);
                throw new Error("Failed pattern match at Data.Hashable (line 88, column 1 - line 90, column 26): " + [
                    v.constructor.name
                ]);
            },
            Eq0: function() {
                return eqEither1;
            }
        };
    };
};
var $f826a0b6995a637c$export$9a9df3f0e52d9324 = function(dictHashable) {
    var hash1 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable);
    var eqMaybe = $06733ae99ed4f534$export$8f45bb76abf9699e(dictHashable.Eq0());
    return {
        hash: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return 0;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return 1 + hash1(v.value0) | 0;
            throw new Error("Failed pattern match at Data.Hashable (line 84, column 1 - line 86, column 29): " + [
                v.constructor.name
            ]);
        },
        Eq0: function() {
            return eqMaybe;
        }
    };
};
var $f826a0b6995a637c$export$1f00891ff4bb67e7 = function(dictHashable) {
    var hash1 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable);
    var Eq0 = dictHashable.Eq0();
    return function(dictHashableRecord) {
        var hashRecord1 = $f826a0b6995a637c$export$66693550090a5ac9(dictHashableRecord);
        var eqRowCons = $37b880af5f4991bd$export$730b16b2c839caa0(dictHashableRecord.EqRecord0())();
        return function(dictIsSymbol) {
            var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
            var eqRowCons1 = eqRowCons(dictIsSymbol)(Eq0);
            return function() {
                return {
                    hashRecord: function(v) {
                        return function(record) {
                            return (hash1(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record)) * 31 | 0) + hashRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record) | 0;
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons1;
                    }
                };
            };
        };
    };
};
var $f826a0b6995a637c$export$737a77ae4431514a = function(dictHashable) {
    var hash1 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable);
    var eqTuple = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictHashable.Eq0());
    return function(dictHashable1) {
        var hash2 = $f826a0b6995a637c$export$d6af199866bfb566(dictHashable1);
        var eqTuple1 = eqTuple(dictHashable1.Eq0());
        return {
            hash: function(v) {
                return (hash1(v.value0) * 31 | 0) + hash2(v.value1) | 0;
            },
            Eq0: function() {
                return eqTuple1;
            }
        };
    };
};



// Generated by purs version 0.15.15




var $219a0fb476f33a30$export$6f6f12e098819a11 = function(x) {
    return x;
};
var $219a0fb476f33a30$export$3c5e6b006a1d848e = $ea3eb84de0acf574$export$8999febf5cd85b5c;
var $219a0fb476f33a30$export$4e81f95457a4f9c5 = $ea3eb84de0acf574$export$78146089411e393d;
var $219a0fb476f33a30$export$f5ad5bc4482e056b = function(dictShow) {
    var showMap = $ea3eb84de0acf574$export$c448526daa762015(dictShow);
    return function(dictShow1) {
        return showMap(dictShow1);
    };
};
var $219a0fb476f33a30$export$c5313cc0fc33667c = function(dictOrd) {
    var unionWith = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return unionWith(append)(v)(v1);
                };
            }
        };
    };
};
var $219a0fb476f33a30$export$38a252bff8e0b233 = function(dictOrd) {
    return $ea3eb84de0acf574$export$4c085c510196daa3(dictOrd);
};
var $219a0fb476f33a30$export$4d301b1aaca6e5ee = function(dictOrd) {
    var ordMap = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    return function(dictOrd1) {
        return ordMap(dictOrd1);
    };
};
var $219a0fb476f33a30$export$3a647d35f27c2c21 = function(dictOrd) {
    return $ea3eb84de0acf574$export$e2f3c1862bab1bff(dictOrd);
};
var $219a0fb476f33a30$export$4eb746bad571b4ba = {
    Coercible0: function() {
        return undefined;
    }
};
var $219a0fb476f33a30$export$546d2468bc9efbc6 = function(dictOrd) {
    var semigroupSemigroupMap1 = $219a0fb476f33a30$export$c5313cc0fc33667c(dictOrd);
    return function(dictSemigroup) {
        var semigroupSemigroupMap2 = semigroupSemigroupMap1(dictSemigroup);
        return {
            mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
            Semigroup0: function() {
                return semigroupSemigroupMap2;
            }
        };
    };
};
var $219a0fb476f33a30$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    var $38 = $f4b2eb11fc32ed34$export$490e536ee7389aeb($ea3eb84de0acf574$export$3930f636962ed944);
    return function($39) {
        return $a393155e52307a24$export$d81aa96f14f987cc($38($39));
    };
}();
var $219a0fb476f33a30$export$1096fce6f8157f49 = $ea3eb84de0acf574$export$d7c684e0b3e84e77;
var $219a0fb476f33a30$export$96367dab66c5c370 = $ea3eb84de0acf574$export$3930f636962ed944;
var $219a0fb476f33a30$export$239aaad87589a3f0 = $ea3eb84de0acf574$export$91e1c50dfb7225a6;
var $219a0fb476f33a30$export$732ac04c4dce73f6 = $ea3eb84de0acf574$export$4295a0c2ad7aa544;
var $219a0fb476f33a30$export$884432d781bab8d3 = function(dictEq) {
    var eqMap = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return function(dictEq1) {
        return eqMap(dictEq1);
    };
};
var $219a0fb476f33a30$export$64a7582da2ca8e9c = function(dictEq) {
    return $ea3eb84de0acf574$export$e321b34a2787dc8d(dictEq);
};
var $219a0fb476f33a30$export$e9f090025f05634f = function(dictOrd) {
    return $ea3eb84de0acf574$export$886591aa0ffe34d5(dictOrd);
};
var $219a0fb476f33a30$export$bb3d8f5a7f1d9f6a = function(dictOrd) {
    return $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
};
var $219a0fb476f33a30$export$fb15286a85c58e76 = function(dictOrd) {
    return $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
};
















// Generated by purs version 0.15.15

var $96c9893fb882decd$export$b5023c870cb34848 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("ul");
var $96c9893fb882decd$export$995bef5d59d32608 = /* #__PURE__ */ $96c9893fb882decd$export$b5023c870cb34848([]);
var $96c9893fb882decd$export$72451b88a72ad9c2 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("tr");
var $96c9893fb882decd$export$6645783692722b88 = /* #__PURE__ */ $96c9893fb882decd$export$72451b88a72ad9c2([]);
var $96c9893fb882decd$export$e3f32a5920890b82 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("thead");
var $96c9893fb882decd$export$e607565248beba15 = /* #__PURE__ */ $96c9893fb882decd$export$e3f32a5920890b82([]);
var $96c9893fb882decd$export$9396b2f97a03ad14 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("tfoot");
var $96c9893fb882decd$export$7f741d66040a80c8 = /* #__PURE__ */ $96c9893fb882decd$export$9396b2f97a03ad14([]);
var $96c9893fb882decd$export$7cdd536eaa8f163c = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("tbody");
var $96c9893fb882decd$export$a78509387f11524c = /* #__PURE__ */ $96c9893fb882decd$export$7cdd536eaa8f163c([]);
var $96c9893fb882decd$export$9852986a3ec5f6a0 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("table");
var $96c9893fb882decd$export$67d0d859a50d84a3 = /* #__PURE__ */ $96c9893fb882decd$export$9852986a3ec5f6a0([]);
var $96c9893fb882decd$export$b2235297ee22a6fe = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("ol");
var $96c9893fb882decd$export$ccd58f56d982d30 = /* #__PURE__ */ $96c9893fb882decd$export$b2235297ee22a6fe([]);
var $96c9893fb882decd$export$b1e5508a851be14d = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("menu");
var $96c9893fb882decd$export$d18229b57986002 = /* #__PURE__ */ $96c9893fb882decd$export$b1e5508a851be14d([]);
var $96c9893fb882decd$export$38e42c68cf43b5d4 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("header");
var $96c9893fb882decd$export$8bf7349458487350 = /* #__PURE__ */ $96c9893fb882decd$export$38e42c68cf43b5d4([]);
var $96c9893fb882decd$export$6210fa4921d2a466 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("form");
var $96c9893fb882decd$export$1df82cba65ddbdc7 = /* #__PURE__ */ $96c9893fb882decd$export$6210fa4921d2a466([]);
var $96c9893fb882decd$export$adb608be33961c98 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("footer");
var $96c9893fb882decd$export$70a8ff4564bfd029 = /* #__PURE__ */ $96c9893fb882decd$export$adb608be33961c98([]);
var $96c9893fb882decd$export$a38812d1aa1302d9 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("fieldset");
var $96c9893fb882decd$export$2dc1b8d0924efe56 = /* #__PURE__ */ $96c9893fb882decd$export$a38812d1aa1302d9([]);
var $96c9893fb882decd$export$53d26b7a9a23d594 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("dl");
var $96c9893fb882decd$export$e8817a08353617fb = /* #__PURE__ */ $96c9893fb882decd$export$53d26b7a9a23d594([]);
var $96c9893fb882decd$export$159d9494db57879b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("div");
var $96c9893fb882decd$export$3327f90baeaa2cb3 = /* #__PURE__ */ $96c9893fb882decd$export$159d9494db57879b([]);
var $96c9893fb882decd$export$518824cf31321346 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("dialog");
var $96c9893fb882decd$export$95cd7f04cb5b4aa5 = /* #__PURE__ */ $96c9893fb882decd$export$518824cf31321346([]);
var $96c9893fb882decd$export$3db318dd257cd653 = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("colgroup");
var $96c9893fb882decd$export$4d89c25fc3dc3ce6 = /* #__PURE__ */ $96c9893fb882decd$export$3db318dd257cd653([]);
var $96c9893fb882decd$export$bba2aacf8566461b = /* #__PURE__ */ $e5b7e89a68d9c456$export$8dbf9c790527241e("article");
var $96c9893fb882decd$export$1cb8fa25968bee4e = /* #__PURE__ */ $96c9893fb882decd$export$bba2aacf8566461b([]);




var $5fa7403fc5cf157d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $5fa7403fc5cf157d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $5fa7403fc5cf157d$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($c959b62ce0c19dfe$export$a02e13c6b9f001c6);
var $5fa7403fc5cf157d$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $5fa7403fc5cf157d$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $5fa7403fc5cf157d$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $5fa7403fc5cf157d$var$applicativeWriterT = /* #__PURE__ */ $d9ef009191ddae40$export$c3b0a193a5475c40($784e1bd3d26d71da$export$db307f59121ffcc4)($50c50d1f444e5fa4$export$fd3b2458e55fc503);
var $5fa7403fc5cf157d$var$$$for = /* #__PURE__ */ $11d1e86de605dfc6$export$f89de2e5bf57e5e6($5fa7403fc5cf157d$var$applicativeWriterT)($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $5fa7403fc5cf157d$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)(/* #__PURE__ */ $d9ef009191ddae40$export$4483e5256f36d121($d7bf9817a417d4ae$export$d082f07d0a8e9909)($50c50d1f444e5fa4$export$91e759983456b85e));
var $5fa7403fc5cf157d$var$tell = /* #__PURE__ */ $2c4a247071255d7e$export$de3113ed932c61ab(/* #__PURE__ */ $d9ef009191ddae40$export$b022f808a9791225($784e1bd3d26d71da$export$db307f59121ffcc4)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $5fa7403fc5cf157d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($5fa7403fc5cf157d$var$applicativeWriterT);
var $5fa7403fc5cf157d$var$toUnfoldable1 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $5fa7403fc5cf157d$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $5fa7403fc5cf157d$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($d8c91a2be15f75cb$export$b50b66d86c8b8bf));
var $5fa7403fc5cf157d$var$hash = /* #__PURE__ */ $f826a0b6995a637c$export$d6af199866bfb566($f826a0b6995a637c$export$62216838365b140d);
var $5fa7403fc5cf157d$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $5fa7403fc5cf157d$var$abs = /* #__PURE__ */ $97937c29f879e68e$export$2335f513bbd82c6d($97937c29f879e68e$export$ff461bf68e7dd332)($d061555d3b2c84b2$export$d40e27c88e22a303);
var $5fa7403fc5cf157d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $5fa7403fc5cf157d$export$a871d3b711b41122 = function(x) {
    return x;
};
var $5fa7403fc5cf157d$export$ac79afef85bfbb36 = function(x) {
    return x;
};
var $5fa7403fc5cf157d$export$2b7a1999f6654e0 = function(x) {
    return x;
};
var $5fa7403fc5cf157d$var$StyledHTML = function(x) {
    return x;
};
var $5fa7403fc5cf157d$export$c456ed68258049b2 = function(x) {
    return x;
};
var $5fa7403fc5cf157d$export$87ee80f9d4520292 = {
    append: function(v) {
        return function(v1) {
            return function($99) {
                return v1(v($99));
            };
        };
    }
};
var $5fa7403fc5cf157d$export$5cc9280cbd68e4c7 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $5fa7403fc5cf157d$var$fromFoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($5fa7403fc5cf157d$export$5cc9280cbd68e4c7)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $5fa7403fc5cf157d$var$unions = /* #__PURE__ */ $ea3eb84de0acf574$export$30b2db2f7030f6cf($5fa7403fc5cf157d$export$5cc9280cbd68e4c7)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $5fa7403fc5cf157d$export$12bba3425d0a2311 = {
    Coercible0: function() {
        return undefined;
    }
};
var $5fa7403fc5cf157d$export$3a38f7217078e90d = {
    Coercible0: function() {
        return undefined;
    }
};
var $5fa7403fc5cf157d$export$d39a4b749f5ad43c = {
    Coercible0: function() {
        return undefined;
    }
};
var $5fa7403fc5cf157d$export$d2a310f2b8863532 = {
    mempty: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Semigroup0: function() {
        return $5fa7403fc5cf157d$export$87ee80f9d4520292;
    }
};
var $5fa7403fc5cf157d$export$51e487c70ff2fd9a = {
    map: function(f) {
        return function(m) {
            return $5fa7403fc5cf157d$var$map($5fa7403fc5cf157d$var$map1($5fa7403fc5cf157d$var$map2(f)))(m);
        };
    }
};
var $5fa7403fc5cf157d$export$bad8520c55b5054c = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $5fa7403fc5cf157d$var$runHTML = function(ctx) {
    return function(v) {
        return v(ctx);
    };
};
var $5fa7403fc5cf157d$export$438fa7935f716bdf = function(ctx) {
    return function(stHtml) {
        var v = $5fa7403fc5cf157d$var$runHTML(ctx)(stHtml);
        var styleElems = $5fa7403fc5cf157d$var$map3(function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($5fa7403fc5cf157d$var$unwrap(v1.value0), $e5b7e89a68d9c456$export$1d567c320f4763bc([])([
                $c959b62ce0c19dfe$export$6f093cfa640b7166($5fa7403fc5cf157d$var$unwrap(v1.value1))
            ]));
        })($5fa7403fc5cf157d$var$toUnfoldable(v.value0));
        return [
            v.value1,
            $96c9893fb882decd$export$159d9494db57879b([
                $94c2c7ff32ca5bd1$export$1d567c320f4763bc("display: none")
            ])(styleElems)
        ];
    };
};
var $5fa7403fc5cf157d$export$694b237e827a3d23 = function(mkStyledHtml) {
    return function(ctx) {
        return $5fa7403fc5cf157d$var$runHTML(ctx)(mkStyledHtml(ctx));
    };
};
var $5fa7403fc5cf157d$var$runChildrenKeyed = function(ctx) {
    return function(children) {
        return $e29c68187e6c3036$export$79eb0c30e59e91f0($5fa7403fc5cf157d$var$$$for(children)(function(v) {
            var v1 = $5fa7403fc5cf157d$var$runHTML(ctx)(v.value1);
            return $5fa7403fc5cf157d$var$discard($5fa7403fc5cf157d$var$tell([
                v1.value0
            ]))(function() {
                return $5fa7403fc5cf157d$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, v1.value1));
            });
        }));
    };
};
var $5fa7403fc5cf157d$var$runChildren = function(ctx) {
    return function(children) {
        return $e29c68187e6c3036$export$79eb0c30e59e91f0($5fa7403fc5cf157d$var$$$for(children)(function(styledHtml) {
            var v = $5fa7403fc5cf157d$var$runHTML(ctx)(styledHtml);
            return $5fa7403fc5cf157d$var$discard($5fa7403fc5cf157d$var$tell([
                v.value0
            ]))(function() {
                return $5fa7403fc5cf157d$var$pure(v.value1);
            });
        }));
    };
};
var $5fa7403fc5cf157d$var$prettyHashToClassName = function(v) {
    return v;
};
var $5fa7403fc5cf157d$var$styleMapToClassNames = function(styleMap) {
    return $5fa7403fc5cf157d$var$map3($5fa7403fc5cf157d$var$prettyHashToClassName)($5fa7403fc5cf157d$var$toUnfoldable1($219a0fb476f33a30$export$ed97f33186d4b816(styleMap)));
};
var $5fa7403fc5cf157d$var$nodeToLeaf = function(node) {
    return function(props) {
        return node(props)([]);
    };
};
var $5fa7403fc5cf157d$var$mkProps = function(cfg) {
    var classNames = $5fa7403fc5cf157d$var$append(cfg.extraClasses)($5fa7403fc5cf157d$var$styleMapToClassNames(cfg.styleMap));
    var inlineStyles = $5b07e36f812dd04b$export$ec1dc8fbeea3467e(";")(cfg.inlineStyles);
    return $5fa7403fc5cf157d$var$append(function() {
        var $86 = $5fa7403fc5cf157d$var$eq(classNames)([]);
        if ($86) return [];
        return [
            $94c2c7ff32ca5bd1$export$188d75d71883854a(classNames)
        ];
    }())(function() {
        var $87 = inlineStyles === "";
        if ($87) return [];
        return [
            $94c2c7ff32ca5bd1$export$1d567c320f4763bc(inlineStyles)
        ];
    }());
};
var $5fa7403fc5cf157d$var$mkPrettyHash = function(name) {
    return function(v) {
        var prefix = function() {
            var $90 = name === "";
            if ($90) return "";
            return name + "-";
        }();
        var numericHash = $5fa7403fc5cf157d$var$hash(v);
        var stringHash = function() {
            var $91 = numericHash < 0;
            if ($91) return "a" + $5fa7403fc5cf157d$var$show($5fa7403fc5cf157d$var$abs(numericHash));
            return "b" + $5fa7403fc5cf157d$var$show(numericHash);
        }();
        return prefix + stringHash;
    };
};
var $5fa7403fc5cf157d$var$printStyleSheetHashed = function(uniqueIdent) {
    return function(name) {
        return function(sheetTemplate) {
            var prettyHash = $5fa7403fc5cf157d$var$mkPrettyHash(name)(sheetTemplate);
            var sheet = $5b07e36f812dd04b$export$b8b3234b4edfc4c2(uniqueIdent)($5fa7403fc5cf157d$var$unwrap(prettyHash))($5fa7403fc5cf157d$var$unwrap(sheetTemplate));
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(prettyHash, sheet);
        };
    };
};
var $5fa7403fc5cf157d$export$c1c17605031f935e = function(replacer) {
    return function(sheetTemplate) {
        return function(opts) {
            return {
                name: opts.name,
                extraClasses: opts.extraClasses,
                inlineStyles: opts.inlineStyles,
                props: opts.props,
                context: opts.context,
                styleSheets: $5fa7403fc5cf157d$var$append(opts.styleSheets)([
                    $5fa7403fc5cf157d$var$printStyleSheetHashed(replacer)(opts.name)(sheetTemplate)
                ])
            };
        };
    };
};
var $5fa7403fc5cf157d$var$mkDefaultOpts = function(ctx) {
    return {
        name: "",
        extraClasses: [],
        styleSheets: [],
        inlineStyles: [],
        context: ctx,
        props: []
    };
};
var $5fa7403fc5cf157d$var$leafToNode = function(leaf) {
    return function(props) {
        return function(v) {
            return leaf(props);
        };
    };
};
var $5fa7403fc5cf157d$export$eb0555af76ce23a7 = function(inlineStr) {
    return function(opts) {
        return {
            name: opts.name,
            extraClasses: opts.extraClasses,
            styleSheets: opts.styleSheets,
            props: opts.props,
            context: opts.context,
            inlineStyles: $5fa7403fc5cf157d$var$append(opts.inlineStyles)([
                inlineStr
            ])
        };
    };
};
var $5fa7403fc5cf157d$export$7d19145171e92f10 = function(mkHtml) {
    return function(ctx) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9($ea3eb84de0acf574$export$6e22c362a0406a2c, mkHtml(ctx));
    };
};
var $5fa7403fc5cf157d$export$6f093cfa640b7166 = function(str) {
    return $5fa7403fc5cf157d$export$7d19145171e92f10(function(v) {
        return $c959b62ce0c19dfe$export$6f093cfa640b7166(str);
    });
};
var $5fa7403fc5cf157d$export$8b0d4beda27bc773 = function(cls) {
    return function(opts) {
        return {
            name: opts.name,
            inlineStyles: opts.inlineStyles,
            styleSheets: opts.styleSheets,
            props: opts.props,
            context: opts.context,
            extraClasses: $5fa7403fc5cf157d$var$append(opts.extraClasses)($5fa7403fc5cf157d$var$map3($d8c91a2be15f75cb$export$880a60b2adf28011)(cls))
        };
    };
};
var $5fa7403fc5cf157d$var$combineOpts = function(opts) {
    return function(updateOpts) {
        return $5fa7403fc5cf157d$var$foldl(function(x) {
            return function(v) {
                return v(x);
            };
        })(opts)(updateOpts);
    };
};
var $5fa7403fc5cf157d$export$d790dbddab3a5a7 = function(node) {
    return function(optsUpdates) {
        return function(props) {
            return function(children) {
                return function(ctx) {
                    var v = $5fa7403fc5cf157d$var$runChildren(ctx)(children);
                    var opts = $5fa7403fc5cf157d$var$combineOpts($5fa7403fc5cf157d$var$mkDefaultOpts(ctx))(optsUpdates);
                    var styleMapParent = $5fa7403fc5cf157d$var$fromFoldable(opts.styleSheets);
                    var styleMap = $5fa7403fc5cf157d$var$unions($5fa7403fc5cf157d$var$append([
                        styleMapParent
                    ])(v.value1));
                    var newProps = $5fa7403fc5cf157d$var$mkProps({
                        extraClasses: opts.extraClasses,
                        styleMap: styleMapParent,
                        inlineStyles: opts.inlineStyles
                    });
                    var html = node($5fa7403fc5cf157d$var$append(opts.props)($5fa7403fc5cf157d$var$append(newProps)(props)))(v.value0);
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(styleMap, html);
                };
            };
        };
    };
};
var $5fa7403fc5cf157d$export$f67f8a5eca7106c1 = function(leaf) {
    return function(updateOpts) {
        return $5fa7403fc5cf157d$var$nodeToLeaf($5fa7403fc5cf157d$export$d790dbddab3a5a7($5fa7403fc5cf157d$var$leafToNode(leaf))(updateOpts));
    };
};
var $5fa7403fc5cf157d$export$a66106a33b3dcd36 = function(node) {
    return function(optsUpdates) {
        return function(props) {
            return function(children) {
                return function(ctx) {
                    var v = $5fa7403fc5cf157d$var$runChildrenKeyed(ctx)(children);
                    var opts = $5fa7403fc5cf157d$var$combineOpts($5fa7403fc5cf157d$var$mkDefaultOpts(ctx))(optsUpdates);
                    var styleMapParent = $5fa7403fc5cf157d$var$fromFoldable(opts.styleSheets);
                    var styleMap = $5fa7403fc5cf157d$var$unions($5fa7403fc5cf157d$var$append([
                        styleMapParent
                    ])(v.value1));
                    var newProps = $5fa7403fc5cf157d$var$mkProps({
                        extraClasses: opts.extraClasses,
                        styleMap: styleMapParent,
                        inlineStyles: opts.inlineStyles
                    });
                    var html = node($5fa7403fc5cf157d$var$append(opts.props)($5fa7403fc5cf157d$var$append(newProps)(props)))(v.value0);
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(styleMap, html);
                };
            };
        };
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
function $1f4ad780c651f89e$export$9d38b81df1e4ff(platformSpecificDriver, timeoutErrorMessageIdent, requestFailedMessageIdent, mkHeader, options) {
    return function(errback, callback) {
        var xhr = platformSpecificDriver.newXHR();
        var fixedUrl = platformSpecificDriver.fixupUrl(options.url, xhr);
        xhr.open(options.method || "GET", fixedUrl, true, options.username, options.password);
        if (options.headers) try {
            // eslint-disable-next-line no-eq-null,eqeqeq
            for(var i = 0, header; (header = options.headers[i]) != null; i++)xhr.setRequestHeader(header.field, header.value);
        } catch (e) {
            errback(e);
        }
        var onerror = function(msgIdent) {
            return function() {
                errback(new Error(msgIdent));
            };
        };
        xhr.onerror = onerror(requestFailedMessageIdent);
        xhr.ontimeout = onerror(timeoutErrorMessageIdent);
        xhr.onload = function() {
            callback({
                status: xhr.status,
                statusText: xhr.statusText,
                headers: xhr.getAllResponseHeaders().split("\r\n").filter(function(header) {
                    return header.length > 0;
                }).map(function(header) {
                    var i = header.indexOf(":");
                    return mkHeader(header.substring(0, i))(header.substring(i + 2));
                }),
                body: xhr.response
            });
        };
        xhr.responseType = options.responseType;
        xhr.withCredentials = options.withCredentials;
        xhr.timeout = options.timeout;
        xhr.send(options.content);
        return function(error, cancelErrback, cancelCallback) {
            try {
                xhr.abort();
            } catch (e) {
                return cancelErrback(e);
            }
            return cancelCallback();
        };
    };
}


// Generated by purs version 0.15.15

// Generated by purs version 0.15.15
var $aa56e5edbb68560e$export$530ca42686ee50e7 = "text/xml";
var $aa56e5edbb68560e$export$2f41145206b9f9f7 = "text/plain";
var $aa56e5edbb68560e$export$c3083f63e1ea2b38 = "text/html";
var $aa56e5edbb68560e$export$8dc8d9feea5d979c = "text/csv";
var $aa56e5edbb68560e$export$24b70d93726c4adb = "text/css";
var $aa56e5edbb68560e$export$fafce06ba36b9255 = "multipart/form-data";
var $aa56e5edbb68560e$export$21bcf3835c99f43b = "image/png";
var $aa56e5edbb68560e$export$a62c8cedf817011c = "image/jpeg";
var $aa56e5edbb68560e$export$e9344de2d32713db = "image/gif";
var $aa56e5edbb68560e$export$631c3fb8a394143b = "application/xml";
var $aa56e5edbb68560e$export$4e485c779e35576d = "application/octet-stream";
var $aa56e5edbb68560e$export$25ba185f98df4cf3 = "application/javascript";
var $aa56e5edbb68560e$export$2316f0d99a99ce39 = "application/json";
var $aa56e5edbb68560e$export$af360fa1725483a8 = "application/x-www-form-urlencoded";


var $1bb5df538ea16bd9$export$2369e6c56c47a5bd = /* #__PURE__ */ function() {
    function ArrayView(value0) {
        this.value0 = value0;
    }
    ArrayView.create = function(value0) {
        return new ArrayView(value0);
    };
    return ArrayView;
}();
var $1bb5df538ea16bd9$export$3b660928c86ff55c = /* #__PURE__ */ function() {
    function Blob(value0) {
        this.value0 = value0;
    }
    Blob.create = function(value0) {
        return new Blob(value0);
    };
    return Blob;
}();
var $1bb5df538ea16bd9$export$b34a105447964f9f = /* #__PURE__ */ function() {
    function Document(value0) {
        this.value0 = value0;
    }
    Document.create = function(value0) {
        return new Document(value0);
    };
    return Document;
}();
var $1bb5df538ea16bd9$export$89b8e0fa65f6a914 = /* #__PURE__ */ function() {
    function $$String(value0) {
        this.value0 = value0;
    }
    $$String.create = function(value0) {
        return new $$String(value0);
    };
    return $$String;
}();
var $1bb5df538ea16bd9$export$3963aa24c930693c = /* #__PURE__ */ function() {
    function FormData(value0) {
        this.value0 = value0;
    }
    FormData.create = function(value0) {
        return new FormData(value0);
    };
    return FormData;
}();
var $1bb5df538ea16bd9$export$bcdd6637213a40ec = /* #__PURE__ */ function() {
    function FormURLEncoded(value0) {
        this.value0 = value0;
    }
    FormURLEncoded.create = function(value0) {
        return new FormURLEncoded(value0);
    };
    return FormURLEncoded;
}();
var $1bb5df538ea16bd9$export$48880ac635f47186 = /* #__PURE__ */ function() {
    function Json(value0) {
        this.value0 = value0;
    }
    Json.create = function(value0) {
        return new Json(value0);
    };
    return Json;
}();
var $1bb5df538ea16bd9$export$64f69cdd5524ddeb = function(v) {
    if (v instanceof $1bb5df538ea16bd9$export$bcdd6637213a40ec) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$af360fa1725483a8);
    if (v instanceof $1bb5df538ea16bd9$export$48880ac635f47186) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$2316f0d99a99ce39);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $1bb5df538ea16bd9$export$22b082955e083ec3 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$89b8e0fa65f6a914.create;
}();
var $1bb5df538ea16bd9$export$7b419323e6ed4f31 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$48880ac635f47186.create;
}();
var $1bb5df538ea16bd9$export$6461fd54a649b18e = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$bcdd6637213a40ec.create;
}();
var $1bb5df538ea16bd9$export$c3f886ccd454773d = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$3963aa24c930693c.create;
}();
var $1bb5df538ea16bd9$export$5a7bfc01df82fcd1 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$b34a105447964f9f.create;
}();
var $1bb5df538ea16bd9$export$8cf3c1c9f525ba2 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$3b660928c86ff55c.create;
}();
var $1bb5df538ea16bd9$export$ba40bc0510bff334 = function(av) {
    return new $1bb5df538ea16bd9$export$2369e6c56c47a5bd(function(f) {
        return f(av);
    });
};


// Generated by purs version 0.15.15






var $04f1e5e12069f6d8$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $04f1e5e12069f6d8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($25a73b5eff39e983$export$74c0afb45691d798);
var $04f1e5e12069f6d8$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $04f1e5e12069f6d8$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($25a73b5eff39e983$export$2fed9e13b0c7effc);
var $04f1e5e12069f6d8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($25a73b5eff39e983$export$11071179e210ac75);
var $04f1e5e12069f6d8$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $04f1e5e12069f6d8$export$5e41db7437457e4f = /* #__PURE__ */ function() {
    function Accept(value0) {
        this.value0 = value0;
    }
    Accept.create = function(value0) {
        return new Accept(value0);
    };
    return Accept;
}();
var $04f1e5e12069f6d8$export$e2e108cbe2e4f865 = /* #__PURE__ */ function() {
    function ContentType(value0) {
        this.value0 = value0;
    }
    ContentType.create = function(value0) {
        return new ContentType(value0);
    };
    return ContentType;
}();
var $04f1e5e12069f6d8$export$21640746b57e4864 = /* #__PURE__ */ function() {
    function RequestHeader(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RequestHeader.create = function(value0) {
        return function(value1) {
            return new RequestHeader(value0, value1);
        };
    };
    return RequestHeader;
}();
var $04f1e5e12069f6d8$export$2ab9a8f9f1186f14 = function(v) {
    if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$unwrap(v.value0);
    if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$unwrap(v.value0);
    if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return v.value1;
    throw new Error("Failed pattern match at Affjax.RequestHeader (line 26, column 1 - line 26, column 33): " + [
        v.constructor.name
    ]);
};
var $04f1e5e12069f6d8$export$1d707710be2d5ee3 = {
    show: function(v) {
        if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return "(Accept " + ($04f1e5e12069f6d8$var$show(v.value0) + ")");
        if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return "(ContentType " + ($04f1e5e12069f6d8$var$show(v.value0) + ")");
        if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return "(RequestHeader " + ($04f1e5e12069f6d8$var$show1(v.value0) + (" " + ($04f1e5e12069f6d8$var$show1(v.value1) + ")")));
        throw new Error("Failed pattern match at Affjax.RequestHeader (line 16, column 1 - line 19, column 81): " + [
            v.constructor.name
        ]);
    }
};
var $04f1e5e12069f6d8$export$a8ff84c12d48cfa6 = function(v) {
    if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return "Accept";
    if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return "Content-Type";
    if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return v.value0;
    throw new Error("Failed pattern match at Affjax.RequestHeader (line 21, column 1 - line 21, column 32): " + [
        v.constructor.name
    ]);
};
var $04f1e5e12069f6d8$export$b220e5ff0b5d2c8d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f && y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$eq(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865 && y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$eq(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$21640746b57e4864 && y instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return x.value0 === y.value0 && x.value1 === y.value1;
            return false;
        };
    }
};
var $04f1e5e12069f6d8$export$eec6d50b1349dc5b = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f && y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$compare(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865 && y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$compare(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $04f1e5e12069f6d8$export$21640746b57e4864 && y instanceof $04f1e5e12069f6d8$export$21640746b57e4864) {
                var v = $04f1e5e12069f6d8$var$compare1(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $04f1e5e12069f6d8$var$compare1(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Affjax.RequestHeader (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $04f1e5e12069f6d8$export$b220e5ff0b5d2c8d;
    }
};


// Generated by purs version 0.15.15



var $c02e13aaef170b91$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c02e13aaef170b91$export$5d43b79a1f53c8d0 = /* #__PURE__ */ function() {
    function $$ArrayBuffer(value0) {
        this.value0 = value0;
    }
    $$ArrayBuffer.create = function(value0) {
        return new $$ArrayBuffer(value0);
    };
    return $$ArrayBuffer;
}();
var $c02e13aaef170b91$export$3b660928c86ff55c = /* #__PURE__ */ function() {
    function Blob(value0) {
        this.value0 = value0;
    }
    Blob.create = function(value0) {
        return new Blob(value0);
    };
    return Blob;
}();
var $c02e13aaef170b91$export$b34a105447964f9f = /* #__PURE__ */ function() {
    function Document(value0) {
        this.value0 = value0;
    }
    Document.create = function(value0) {
        return new Document(value0);
    };
    return Document;
}();
var $c02e13aaef170b91$export$48880ac635f47186 = /* #__PURE__ */ function() {
    function Json(value0) {
        this.value0 = value0;
    }
    Json.create = function(value0) {
        return new Json(value0);
    };
    return Json;
}();
var $c02e13aaef170b91$export$89b8e0fa65f6a914 = /* #__PURE__ */ function() {
    function $$String(value0) {
        this.value0 = value0;
    }
    $$String.create = function(value0) {
        return new $$String(value0);
    };
    return $$String;
}();
var $c02e13aaef170b91$export$e92c65af050aed9a = /* #__PURE__ */ function() {
    function Ignore(value0) {
        this.value0 = value0;
    }
    Ignore.create = function(value0) {
        return new Ignore(value0);
    };
    return Ignore;
}();
var $c02e13aaef170b91$export$17004af5aa52bce6 = function(v) {
    if (v instanceof $c02e13aaef170b91$export$5d43b79a1f53c8d0) return "arraybuffer";
    if (v instanceof $c02e13aaef170b91$export$3b660928c86ff55c) return "blob";
    if (v instanceof $c02e13aaef170b91$export$b34a105447964f9f) return "document";
    if (v instanceof $c02e13aaef170b91$export$48880ac635f47186) return "text";
    if (v instanceof $c02e13aaef170b91$export$89b8e0fa65f6a914) return "text";
    if (v instanceof $c02e13aaef170b91$export$e92c65af050aed9a) return "";
    throw new Error("Failed pattern match at Affjax.ResponseFormat (line 44, column 3 - line 50, column 19): " + [
        v.constructor.name
    ]);
};
var $c02e13aaef170b91$export$64f69cdd5524ddeb = function(v) {
    if (v instanceof $c02e13aaef170b91$export$48880ac635f47186) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$2316f0d99a99ce39);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c02e13aaef170b91$export$22b082955e083ec3 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$89b8e0fa65f6a914($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$7b419323e6ed4f31 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$48880ac635f47186($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$738b109e247a462c = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$e92c65af050aed9a($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$5a7bfc01df82fcd1 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$b34a105447964f9f($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$8cf3c1c9f525ba2 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$3b660928c86ff55c($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$f57200da856d736b = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$5d43b79a1f53c8d0($c02e13aaef170b91$var$identity);
}();


// Generated by purs version 0.15.15



var $d5f2bbf513cce8c9$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $d5f2bbf513cce8c9$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $d5f2bbf513cce8c9$export$42f186449ccf2a6a = /* #__PURE__ */ function() {
    function ResponseHeader(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ResponseHeader.create = function(value0) {
        return function(value1) {
            return new ResponseHeader(value0, value1);
        };
    };
    return ResponseHeader;
}();
var $d5f2bbf513cce8c9$export$2ab9a8f9f1186f14 = function(v) {
    return v.value1;
};
var $d5f2bbf513cce8c9$export$930aa88cd8251f2f = {
    show: function(v) {
        return "(ResponseHeader " + ($d5f2bbf513cce8c9$var$show(v.value0) + (" " + ($d5f2bbf513cce8c9$var$show(v.value1) + ")")));
    }
};
var $d5f2bbf513cce8c9$export$a8ff84c12d48cfa6 = function(v) {
    return v.value0;
};
var $d5f2bbf513cce8c9$export$5846351b1960bc7e = {
    eq: function(x) {
        return function(y) {
            return x.value0 === y.value0 && x.value1 === y.value1;
        };
    }
};
var $d5f2bbf513cce8c9$export$130cbaa46b01e3bf = {
    compare: function(x) {
        return function(y) {
            var v = $d5f2bbf513cce8c9$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $d5f2bbf513cce8c9$var$compare(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $d5f2bbf513cce8c9$export$5846351b1960bc7e;
    }
};






// Generated by purs version 0.15.15




var $f9f243b94d1fc188$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $f9f243b94d1fc188$export$64f3cd24d850d401 = /* #__PURE__ */ $d2284b2d3e1b6f87$export$998a9a780731dd5b($50c50d1f444e5fa4$export$dc85e8383eafbd81);
var $f9f243b94d1fc188$export$a25b8a8a37f2d1cd = function($3) {
    return $f9f243b94d1fc188$var$unwrap($d2284b2d3e1b6f87$export$8291c2122093ac93($3));
};
var $f9f243b94d1fc188$export$8e638b2c22277c65 = function(f) {
    return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function($4) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($f9f243b94d1fc188$var$unwrap($4)));
    });
};




// Generated by purs version 0.15.15
function $e2dfac74220fdf7a$export$4d9ac7ad03be5d48(fail, succ, s) {
    try {
        return succ(JSON.parse(s));
    } catch (e) {
        return fail(e.message);
    }
}



var $44e5fdc48745e77c$export$f3a8d475da9d5fc3 = function(j) {
    return $e2dfac74220fdf7a$export$4d9ac7ad03be5d48($7d4cccdf062a2261$export$37c4d04eafdc5515.create, $7d4cccdf062a2261$export$19db0165690c701a.create, j);
};






// Generated by purs version 0.15.15












// Generated by purs version 0.15.15
// A helper which transforms the result of encodeURIComponent to be compliant
// with RFC3986, as described in the MDN documentation here:
//
// https://web.archive.org/web/20201206001047/https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
function $554797afd3ad4541$var$encodeURIComponent_to_RFC3986(input) {
    return input.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}
// A helper which transforms the result of encodeURI to be compliant
// with RFC3986, as described in the MDN documentation here:
//
// https://web.archive.org/web/20210117175449/https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI#encoding_for_ipv6
function $554797afd3ad4541$var$encodeURI_to_RFC3986(input) {
    return input.replace(/%5B/g, "[").replace(/%5D/g, "]");
}
function $554797afd3ad4541$export$5aceb7cfc152c7a0(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURIComponent_to_RFC3986(encodeURIComponent(input)));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$737f67b1f296a4c1(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURIComponent_to_RFC3986(encodeURIComponent(input)).replace(/%20/g, "+"));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$5befbc415e45c4d5(fail, succeed, input) {
    try {
        return succeed(decodeURIComponent(input));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$c2133655cc0dfcac(fail, succeed, input) {
    return $554797afd3ad4541$export$5befbc415e45c4d5(fail, succeed, input.replace(/\+/g, " "));
}
function $554797afd3ad4541$export$15690d419f50b5b6(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURI_to_RFC3986(encodeURI(input)));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$18efed955e3526a8(fail, succeed, input) {
    try {
        return succeed(decodeURI(input));
    } catch (err) {
        return fail(err);
    }
}





var $f9a555fb76059872$export$ab54ccbe87d5558 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$5aceb7cfc152c7a0)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$90c31d5baa78df44 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$15690d419f50b5b6)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$33ec49fcdd8b3995 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$737f67b1f296a4c1)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$8824b4be61b7d619 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$5befbc415e45c4d5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$e57f0a7b2f7731fd = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$18efed955e3526a8)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$4704bdfecb34953a = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$c2133655cc0dfcac)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();


var $d7072b1f1f4574d6$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6)(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6))));
var $d7072b1f1f4574d6$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $d7072b1f1f4574d6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d7072b1f1f4574d6$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($06733ae99ed4f534$export$b203ef4465f15037);
var $d7072b1f1f4574d6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $d7072b1f1f4574d6$export$bcdd6637213a40ec = function(x) {
    return x;
};
var $d7072b1f1f4574d6$export$45b10814cc054894 = function(v) {
    return v;
};
var $d7072b1f1f4574d6$export$2632a4b24e64e691 = {
    show: function(v) {
        return "(FormURLEncoded " + ($d7072b1f1f4574d6$var$show(v) + ")");
    }
};
var $d7072b1f1f4574d6$export$98b361b5782a88c3 = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $d7072b1f1f4574d6$export$c82dd5dde548866e = /* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e(/* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($97937c29f879e68e$export$c5f2758e49b2b86a)));
var $d7072b1f1f4574d6$export$c7e663b2f165d3c8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d7072b1f1f4574d6$export$9af01926b7d3c975 = $784e1bd3d26d71da$export$db307f59121ffcc4;
var $d7072b1f1f4574d6$export$571d59b505e6bb4e = $d7072b1f1f4574d6$export$bcdd6637213a40ec;
var $d7072b1f1f4574d6$export$8273fbac6769ef04 = /* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00(/* #__PURE__ */ $71f2e2e9476163f8$export$d625e8a97ba36bd6($37b880af5f4991bd$export$fa624555ca2acbc8)(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $d7072b1f1f4574d6$export$c564cdbbe6da493 = /* #__PURE__ */ function() {
    var encodePart = function(v) {
        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f9a555fb76059872$export$33ec49fcdd8b3995(v.value0);
        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map(function(key) {
            return function(val) {
                return key + ("=" + val);
            };
        })($f9a555fb76059872$export$33ec49fcdd8b3995(v.value0)))($f9a555fb76059872$export$33ec49fcdd8b3995(v.value1.value0));
        throw new Error("Failed pattern match at Data.FormURLEncoded (line 37, column 16 - line 39, column 114): " + [
            v.constructor.name
        ]);
    };
    var $37 = $d7072b1f1f4574d6$var$map($5b07e36f812dd04b$export$ec1dc8fbeea3467e("&"));
    var $38 = $d7072b1f1f4574d6$var$traverse(encodePart);
    return function($39) {
        return $37($38($d7072b1f1f4574d6$export$45b10814cc054894($39)));
    };
}();
var $d7072b1f1f4574d6$export$2f872c0f2117be69 = /* #__PURE__ */ function() {
    var decodePart = function() {
        var $40 = $5b07e36f812dd04b$export$65980d18b75784e2("=");
        return function($41) {
            return function(v) {
                if (v.length === 2) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map(function(key) {
                    return function(val) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(key, new $06733ae99ed4f534$export$8a67b48435b5d073(val));
                    };
                })($f9a555fb76059872$export$4704bdfecb34953a(v[0])))($f9a555fb76059872$export$4704bdfecb34953a(v[1]));
                if (v.length === 1) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map($71f2e2e9476163f8$export$1908877435b1d5e9.create)($f9a555fb76059872$export$4704bdfecb34953a(v[0])))($d7072b1f1f4574d6$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }($40($41));
        };
    }();
    var $42 = $d7072b1f1f4574d6$var$map($d7072b1f1f4574d6$export$bcdd6637213a40ec);
    var $43 = $d7072b1f1f4574d6$var$traverse(decodePart);
    var $44 = $5b07e36f812dd04b$export$65980d18b75784e2("&");
    return function($45) {
        return $42($43($44($45)));
    };
}();




// Generated by purs version 0.15.15





var $0279ce8fdb6b506c$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $0279ce8fdb6b506c$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $0279ce8fdb6b506c$export$8eb3892b442747bd = /* #__PURE__ */ function() {
    function OPTIONS() {}
    OPTIONS.value = new OPTIONS();
    return OPTIONS;
}();
var $0279ce8fdb6b506c$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa = /* #__PURE__ */ function() {
    function HEAD() {}
    HEAD.value = new HEAD();
    return HEAD;
}();
var $0279ce8fdb6b506c$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $0279ce8fdb6b506c$export$5508c7b57250ebc6 = /* #__PURE__ */ function() {
    function PUT() {}
    PUT.value = new PUT();
    return PUT;
}();
var $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 = /* #__PURE__ */ function() {
    function DELETE() {}
    DELETE.value = new DELETE();
    return DELETE;
}();
var $0279ce8fdb6b506c$export$8754b71dc67cd5d0 = /* #__PURE__ */ function() {
    function TRACE() {}
    TRACE.value = new TRACE();
    return TRACE;
}();
var $0279ce8fdb6b506c$export$df50b52b1548c0dc = /* #__PURE__ */ function() {
    function CONNECT() {}
    CONNECT.value = new CONNECT();
    return CONNECT;
}();
var $0279ce8fdb6b506c$export$673494e2608125f7 = /* #__PURE__ */ function() {
    function PROPFIND() {}
    PROPFIND.value = new PROPFIND();
    return PROPFIND;
}();
var $0279ce8fdb6b506c$export$d16982ce725f2efb = /* #__PURE__ */ function() {
    function PROPPATCH() {}
    PROPPATCH.value = new PROPPATCH();
    return PROPPATCH;
}();
var $0279ce8fdb6b506c$export$36dd893c77c0f7d8 = /* #__PURE__ */ function() {
    function MKCOL() {}
    MKCOL.value = new MKCOL();
    return MKCOL;
}();
var $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 = /* #__PURE__ */ function() {
    function COPY() {}
    COPY.value = new COPY();
    return COPY;
}();
var $0279ce8fdb6b506c$export$346f08c1f0d0fe41 = /* #__PURE__ */ function() {
    function MOVE() {}
    MOVE.value = new MOVE();
    return MOVE;
}();
var $0279ce8fdb6b506c$export$9227a1a65abc0f40 = /* #__PURE__ */ function() {
    function LOCK() {}
    LOCK.value = new LOCK();
    return LOCK;
}();
var $0279ce8fdb6b506c$export$81c5e18fd95994a5 = /* #__PURE__ */ function() {
    function UNLOCK() {}
    UNLOCK.value = new UNLOCK();
    return UNLOCK;
}();
var $0279ce8fdb6b506c$export$54950d96c4d7b0 = /* #__PURE__ */ function() {
    function PATCH() {}
    PATCH.value = new PATCH();
    return PATCH;
}();
var $0279ce8fdb6b506c$var$CustomMethod = function(x) {
    return x;
};
var $0279ce8fdb6b506c$export$7afd0cf4e939f7e8 = function(v) {
    return v;
};
var $0279ce8fdb6b506c$export$9710b60f7f869999 = {
    show: function(v) {
        if (v instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return "OPTIONS";
        if (v instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return "GET";
        if (v instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return "HEAD";
        if (v instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return "POST";
        if (v instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return "PUT";
        if (v instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return "DELETE";
        if (v instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return "TRACE";
        if (v instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return "CONNECT";
        if (v instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return "PROPFIND";
        if (v instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return "PROPPATCH";
        if (v instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return "MKCOL";
        if (v instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return "COPY";
        if (v instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return "MOVE";
        if (v instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return "LOCK";
        if (v instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return "UNLOCK";
        if (v instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return "PATCH";
        throw new Error("Failed pattern match at Data.HTTP.Method (line 43, column 1 - line 59, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $0279ce8fdb6b506c$export$9d28283af741e4f8 = {
    show: function(v) {
        return "(CustomMethod " + ($0279ce8fdb6b506c$var$show(v) + ")");
    }
};
var $0279ce8fdb6b506c$export$c2d084dc44961371 = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0279ce8fdb6b506c$export$9710b60f7f869999))($0279ce8fdb6b506c$export$7afd0cf4e939f7e8);
var $0279ce8fdb6b506c$var$parse = function(handleMethod) {
    return function(handleUnknown) {
        return function(s) {
            var v = $5b07e36f812dd04b$export$43df7fc17cca38a4(s);
            if (v === "OPTIONS") return handleMethod($0279ce8fdb6b506c$export$8eb3892b442747bd.value);
            if (v === "GET") return handleMethod($0279ce8fdb6b506c$export$1bb358554aac31c1.value);
            if (v === "HEAD") return handleMethod($0279ce8fdb6b506c$export$3cdc0b6c64b90aaa.value);
            if (v === "POST") return handleMethod($0279ce8fdb6b506c$export$484f3009c2ee32ad.value);
            if (v === "PUT") return handleMethod($0279ce8fdb6b506c$export$5508c7b57250ebc6.value);
            if (v === "DELETE") return handleMethod($0279ce8fdb6b506c$export$4bd2facc4a3e6aa1.value);
            if (v === "TRACE") return handleMethod($0279ce8fdb6b506c$export$8754b71dc67cd5d0.value);
            if (v === "CONNECT") return handleMethod($0279ce8fdb6b506c$export$df50b52b1548c0dc.value);
            if (v === "PROPFIND") return handleMethod($0279ce8fdb6b506c$export$673494e2608125f7.value);
            if (v === "PROPPATCH") return handleMethod($0279ce8fdb6b506c$export$d16982ce725f2efb.value);
            if (v === "MKCOL") return handleMethod($0279ce8fdb6b506c$export$36dd893c77c0f7d8.value);
            if (v === "COPY") return handleMethod($0279ce8fdb6b506c$export$92f9e1ed9114d3a6.value);
            if (v === "MOVE") return handleMethod($0279ce8fdb6b506c$export$346f08c1f0d0fe41.value);
            if (v === "LOCK") return handleMethod($0279ce8fdb6b506c$export$9227a1a65abc0f40.value);
            if (v === "UNLOCK") return handleMethod($0279ce8fdb6b506c$export$81c5e18fd95994a5.value);
            if (v === "PATCH") return handleMethod($0279ce8fdb6b506c$export$54950d96c4d7b0.value);
            return handleUnknown(v);
        };
    };
};
var $0279ce8fdb6b506c$export$3004f64547af360e = /* #__PURE__ */ function() {
    return $0279ce8fdb6b506c$var$parse($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function($34) {
        return $7d4cccdf062a2261$export$19db0165690c701a.create($0279ce8fdb6b506c$var$CustomMethod($34));
    });
}();
var $0279ce8fdb6b506c$export$f20e5e4763052386 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd && y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return true;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1 && y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return true;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa && y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return true;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad && y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return true;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6 && y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return true;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 && y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return true;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0 && y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return true;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc && y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return true;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7 && y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return true;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb && y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return true;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8 && y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return true;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 && y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return true;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41 && y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return true;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40 && y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return true;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5 && y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return true;
            if (x instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0 && y instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return true;
            return false;
        };
    }
};
var $0279ce8fdb6b506c$export$87b67b987c5486ec = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd && y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1 && y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa && y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad && y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6 && y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 && y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0 && y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc && y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7 && y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb && y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8 && y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 && y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41 && y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40 && y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5 && y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0 && y instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.HTTP.Method (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0279ce8fdb6b506c$export$f20e5e4763052386;
    }
};
var $0279ce8fdb6b506c$export$2ec54f6342f5f5ac = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $0279ce8fdb6b506c$export$c7119fb43836d0ad = {
    compare: function(x) {
        return function(y) {
            return $0279ce8fdb6b506c$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $0279ce8fdb6b506c$export$2ec54f6342f5f5ac;
    }
};










// Generated by purs version 0.15.15



var $107430d2749bac15$export$9223adb43c31d760 = function(x) {
    return x;
};
var $107430d2749bac15$export$e806838bdd212676 = function(x) {
    return x;
};
var $107430d2749bac15$export$2e3eef4f26ade0f7 = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(k) {
        return function __do() {
            var v1 = v(function($9) {
                return k($7d4cccdf062a2261$export$37c4d04eafdc5515.create($9))();
            }, function($10) {
                return k($7d4cccdf062a2261$export$19db0165690c701a.create($10))();
            });
            return function(e) {
                return $b28443a27438717a$export$49d5975414e0a979(function(k2) {
                    return function __do() {
                        v1(e, function($11) {
                            return k2($7d4cccdf062a2261$export$37c4d04eafdc5515.create($11))();
                        }, function($12) {
                            return k2($7d4cccdf062a2261$export$19db0165690c701a.create($12))();
                        });
                        return $edf0339512807bee$export$8deb6e154ce67af6;
                    };
                });
            };
        };
    });
};




var $3b38984084ed8eff$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$fail = /* #__PURE__ */ $c97d2d0f578f81ad$export$2b62a06a9fee979c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $3b38984084ed8eff$var$unsafeReadTagged = /* #__PURE__ */ $c97d2d0f578f81ad$export$6190f2182377b437($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $3b38984084ed8eff$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3b38984084ed8eff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $3b38984084ed8eff$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$fa624555ca2acbc8);
var $3b38984084ed8eff$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $3b38984084ed8eff$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $3b38984084ed8eff$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $3b38984084ed8eff$var$$$try = /* #__PURE__ */ $5dfefa023749ded0$export$410a452afcd48948($edf0339512807bee$export$9efce1646e93cba4);
var $3b38984084ed8eff$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $3b38984084ed8eff$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $3b38984084ed8eff$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($7d4cccdf062a2261$export$f0a413d3d6075601);
var $3b38984084ed8eff$export$b1b4758529f693c0 = /* #__PURE__ */ function() {
    function RequestContentError(value0) {
        this.value0 = value0;
    }
    RequestContentError.create = function(value0) {
        return new RequestContentError(value0);
    };
    return RequestContentError;
}();
var $3b38984084ed8eff$export$10b74a1a57a5fea2 = /* #__PURE__ */ function() {
    function ResponseBodyError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ResponseBodyError.create = function(value0) {
        return function(value1) {
            return new ResponseBodyError(value0, value1);
        };
    };
    return ResponseBodyError;
}();
var $3b38984084ed8eff$export$66d311bf29d5c89c = /* #__PURE__ */ function() {
    function TimeoutError() {}
    TimeoutError.value = new TimeoutError();
    return TimeoutError;
}();
var $3b38984084ed8eff$export$4e8ebf4980bdf90a = /* #__PURE__ */ function() {
    function RequestFailedError() {}
    RequestFailedError.value = new RequestFailedError();
    return RequestFailedError;
}();
var $3b38984084ed8eff$export$b4982b9cefddd7f3 = /* #__PURE__ */ function() {
    function XHROtherError(value0) {
        this.value0 = value0;
    }
    XHROtherError.create = function(value0) {
        return new XHROtherError(value0);
    };
    return XHROtherError;
}();
var $3b38984084ed8eff$export$b5fe3f66a567bec0 = function(driver) {
    return function(req) {
        var parseJSON = function(v) {
            if (v === "") return $3b38984084ed8eff$var$pure($2a035e92dc768ac1$export$d0304b893d105187);
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($74) {
                return $3b38984084ed8eff$var$fail($c97d2d0f578f81ad$export$f6a37cc43a8b8898.create($74));
            })($3b38984084ed8eff$var$pure)($44e5fdc48745e77c$export$f3a8d475da9d5fc3(v));
        };
        var fromResponse = function() {
            if (req.responseFormat instanceof $c02e13aaef170b91$export$5d43b79a1f53c8d0) return $3b38984084ed8eff$var$unsafeReadTagged("ArrayBuffer");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$3b660928c86ff55c) return $3b38984084ed8eff$var$unsafeReadTagged("Blob");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$b34a105447964f9f) return function(x) {
                return $3b38984084ed8eff$var$alt($3b38984084ed8eff$var$unsafeReadTagged("Document")(x))($3b38984084ed8eff$var$alt($3b38984084ed8eff$var$unsafeReadTagged("XMLDocument")(x))($3b38984084ed8eff$var$unsafeReadTagged("HTMLDocument")(x)));
            };
            if (req.responseFormat instanceof $c02e13aaef170b91$export$48880ac635f47186) return $3b38984084ed8eff$var$composeKleisliFlipped(function($75) {
                return req.responseFormat.value0(parseJSON($75));
            })($3b38984084ed8eff$var$unsafeReadTagged("String"));
            if (req.responseFormat instanceof $c02e13aaef170b91$export$89b8e0fa65f6a914) return $3b38984084ed8eff$var$unsafeReadTagged("String");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$e92c65af050aed9a) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(req.responseFormat.value0($3b38984084ed8eff$var$pure($05149ea687d6b460$export$523c0b569236b342)));
            throw new Error("Failed pattern match at Affjax (line 274, column 18 - line 283, column 57): " + [
                req.responseFormat.constructor.name
            ]);
        }();
        var extractContent = function(v) {
            if (v instanceof $1bb5df538ea16bd9$export$2369e6c56c47a5bd) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0($c97d2d0f578f81ad$export$9d82982d31d9d171));
            if (v instanceof $1bb5df538ea16bd9$export$3b660928c86ff55c) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$b34a105447964f9f) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$89b8e0fa65f6a914) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$3963aa24c930693c) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$bcdd6637213a40ec) return $7d4cccdf062a2261$export$a92e4c44d367d0af("Body contains values that cannot be encoded as application/x-www-form-urlencoded")($3b38984084ed8eff$var$map($c97d2d0f578f81ad$export$9d82982d31d9d171)($d7072b1f1f4574d6$export$c564cdbbe6da493(v.value0)));
            if (v instanceof $1bb5df538ea16bd9$export$48880ac635f47186) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171($0e031af7428ef07d$export$fac44ee5b035f737(v.value0)));
            throw new Error("Failed pattern match at Affjax (line 235, column 20 - line 250, column 69): " + [
                v.constructor.name
            ]);
        };
        var addHeader = function(mh) {
            return function(hs) {
                if (mh instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && !$3b38984084ed8eff$var$any($f57f4b701aa7b66e$export$af631764ddc44097($3b38984084ed8eff$var$eq)($04f1e5e12069f6d8$export$a8ff84c12d48cfa6)(mh.value0))(hs)) return $396c4c3d9e7fae3c$export$c40cf5aab899f397(hs)(mh.value0);
                return hs;
            };
        };
        var headers = function(reqContent) {
            return addHeader($3b38984084ed8eff$var$map($04f1e5e12069f6d8$export$e2e108cbe2e4f865.create)($3b38984084ed8eff$var$bindFlipped($1bb5df538ea16bd9$export$64f69cdd5524ddeb)(reqContent)))(addHeader($3b38984084ed8eff$var$map($04f1e5e12069f6d8$export$5e41db7437457e4f.create)($c02e13aaef170b91$export$64f69cdd5524ddeb(req.responseFormat)))(req.headers));
        };
        var ajaxRequest = function(v) {
            return {
                method: $0279ce8fdb6b506c$export$c2d084dc44961371(req.method),
                url: req.url,
                headers: $3b38984084ed8eff$var$map1(function(h) {
                    return {
                        field: $04f1e5e12069f6d8$export$a8ff84c12d48cfa6(h),
                        value: $04f1e5e12069f6d8$export$2ab9a8f9f1186f14(h)
                    };
                })(headers(req.content)),
                content: v,
                responseType: $c02e13aaef170b91$export$17004af5aa52bce6(req.responseFormat),
                username: $0a5aaf95f168428e$export$b187f57ee1822bc5(req.username),
                password: $0a5aaf95f168428e$export$b187f57ee1822bc5(req.password),
                withCredentials: req.withCredentials,
                timeout: $06733ae99ed4f534$export$43db023a260c5e9f(0.0)($3b38984084ed8eff$var$map(function(v1) {
                    return v1;
                })(req.timeout))
            };
        };
        var send = function(content) {
            return $3b38984084ed8eff$var$mapFlipped($3b38984084ed8eff$var$$$try($107430d2749bac15$export$2e3eef4f26ade0f7($1f4ad780c651f89e$export$9d38b81df1e4ff(driver, "AffjaxTimeoutErrorMessageIdent", "AffjaxRequestFailedMessageIdent", $d5f2bbf513cce8c9$export$42f186449ccf2a6a.create, ajaxRequest(content)))))(function(v) {
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    var v1 = $f9f243b94d1fc188$export$a25b8a8a37f2d1cd(fromResponse(v.value0.body));
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $3b38984084ed8eff$export$10b74a1a57a5fea2($ba51d599f79a6310$export$5fd5031fecdacec3(v1.value0), v.value0));
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        headers: v.value0.headers,
                        status: v.value0.status,
                        statusText: v.value0.statusText,
                        body: v1.value0
                    });
                    throw new Error("Failed pattern match at Affjax (line 209, column 9 - line 211, column 52): " + [
                        v1.constructor.name
                    ]);
                }
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(function() {
                    var message = $ad2cf6904bca3ba1$export$a8ecead220dd38a6(v.value0);
                    var $61 = message === "AffjaxTimeoutErrorMessageIdent";
                    if ($61) return $3b38984084ed8eff$export$66d311bf29d5c89c.value;
                    var $62 = message === "AffjaxRequestFailedMessageIdent";
                    if ($62) return $3b38984084ed8eff$export$4e8ebf4980bdf90a.value;
                    return new $3b38984084ed8eff$export$b4982b9cefddd7f3(v.value0);
                }());
                throw new Error("Failed pattern match at Affjax (line 207, column 144 - line 219, column 28): " + [
                    v.constructor.name
                ]);
            });
        };
        if (req.content instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return send($0a5aaf95f168428e$export$b187f57ee1822bc5($06733ae99ed4f534$export$bebe9059409a0d04.value));
        if (req.content instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var v = extractContent(req.content.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return send($0a5aaf95f168428e$export$b187f57ee1822bc5(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)));
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $3b38984084ed8eff$var$pure1(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $3b38984084ed8eff$export$b1b4758529f693c0(v.value0)));
            throw new Error("Failed pattern match at Affjax (line 199, column 7 - line 203, column 48): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Affjax (line 195, column 3 - line 203, column 48): " + [
            req.content.constructor.name
        ]);
    };
};
var $3b38984084ed8eff$export$55ee1551a3f962e6 = function(v) {
    if (v instanceof $3b38984084ed8eff$export$b1b4758529f693c0) return "There was a problem with the request content: " + v.value0;
    if (v instanceof $3b38984084ed8eff$export$10b74a1a57a5fea2) return "There was a problem with the response body: " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value0);
    if (v instanceof $3b38984084ed8eff$export$66d311bf29d5c89c) return "There was a problem making the request: timeout";
    if (v instanceof $3b38984084ed8eff$export$4e8ebf4980bdf90a) return "There was a problem making the request: request failed";
    if (v instanceof $3b38984084ed8eff$export$b4982b9cefddd7f3) return "There was a problem making the request: " + $ad2cf6904bca3ba1$export$a8ecead220dd38a6(v.value0);
    throw new Error("Failed pattern match at Affjax (line 113, column 14 - line 123, column 66): " + [
        v.constructor.name
    ]);
};
var $3b38984084ed8eff$export$de89fc8561ede42f = /* #__PURE__ */ function() {
    return {
        method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$1bb358554aac31c1.value),
        url: "/",
        headers: [],
        content: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        username: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        password: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        withCredentials: false,
        responseFormat: $c02e13aaef170b91$export$738b109e247a462c,
        timeout: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $3b38984084ed8eff$export$1822828d790e23ee = function(driver) {
    return function(rf) {
        return function(u) {
            return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                content: $3b38984084ed8eff$export$de89fc8561ede42f.content,
                username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$4bd2facc4a3e6aa1.value),
                url: u,
                responseFormat: rf
            });
        };
    };
};
var $3b38984084ed8eff$export$38dab5a9fea42f39 = function(driver) {
    var $76 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
    var $77 = $3b38984084ed8eff$export$1822828d790e23ee(driver)($c02e13aaef170b91$export$738b109e247a462c);
    return function($78) {
        return $76($77($78));
    };
};
var $3b38984084ed8eff$export$3988ae62b71be9a3 = function(driver) {
    return function(rf) {
        return function(u) {
            return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                method: $3b38984084ed8eff$export$de89fc8561ede42f.method,
                headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                content: $3b38984084ed8eff$export$de89fc8561ede42f.content,
                username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                url: u,
                responseFormat: rf
            });
        };
    };
};
var $3b38984084ed8eff$export$b76953f99ab2be78 = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$54950d96c4d7b0.value),
                    url: u,
                    content: new $06733ae99ed4f534$export$8a67b48435b5d073(c),
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$3e5572abde0c1b7c = function(driver) {
    return function(url) {
        var $79 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $80 = $3b38984084ed8eff$export$b76953f99ab2be78(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($81) {
            return $79($80($81));
        };
    };
};
var $3b38984084ed8eff$export$299ba2dee77727e9 = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$484f3009c2ee32ad.value),
                    url: u,
                    content: c,
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$a51007acc2c57e79 = function(driver) {
    return function(url) {
        var $82 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $83 = $3b38984084ed8eff$export$299ba2dee77727e9(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($84) {
            return $82($83($84));
        };
    };
};
var $3b38984084ed8eff$export$327f7b26ebf455db = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$5508c7b57250ebc6.value),
                    url: u,
                    content: c,
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$3ea07e5c3343cd8a = function(driver) {
    return function(url) {
        var $85 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $86 = $3b38984084ed8eff$export$327f7b26ebf455db(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($87) {
            return $85($86($87));
        };
    };
};





// Generated by purs version 0.15.15


var $6f224010b6164ac0$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $6f224010b6164ac0$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $6f224010b6164ac0$export$f66f92b8741acd5b = function(x) {
    return x;
};
var $6f224010b6164ac0$export$3a7dfd032479a874 = {
    show: function(v) {
        return "(StatusCode " + ($6f224010b6164ac0$var$show(v) + ")");
    }
};
var $6f224010b6164ac0$export$ba69ab2a5a2ce9aa = {
    Coercible0: function() {
        return undefined;
    }
};
var $6f224010b6164ac0$export$20b6cc2eca112841 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6f224010b6164ac0$export$cce84f13c2d7a69e = {
    compare: function(x) {
        return function(y) {
            return $6f224010b6164ac0$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6f224010b6164ac0$export$20b6cc2eca112841;
    }
};


// Generated by purs version 0.15.15
const $d615f2c6d9bee660$export$7a292f067638ecd6 = {
    newXHR: function() {
        return new XMLHttpRequest();
    },
    fixupUrl: function(url) {
        return url || "/";
    }
};



var $f13553b3f174bc1f$export$b5fe3f66a567bec0 = /* #__PURE__ */ $3b38984084ed8eff$export$b5fe3f66a567bec0($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3ea07e5c3343cd8a = /* #__PURE__ */ $3b38984084ed8eff$export$3ea07e5c3343cd8a($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$327f7b26ebf455db = /* #__PURE__ */ $3b38984084ed8eff$export$327f7b26ebf455db($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$a51007acc2c57e79 = /* #__PURE__ */ $3b38984084ed8eff$export$a51007acc2c57e79($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$299ba2dee77727e9 = /* #__PURE__ */ $3b38984084ed8eff$export$299ba2dee77727e9($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3e5572abde0c1b7c = /* #__PURE__ */ $3b38984084ed8eff$export$3e5572abde0c1b7c($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$b76953f99ab2be78 = /* #__PURE__ */ $3b38984084ed8eff$export$b76953f99ab2be78($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3988ae62b71be9a3 = /* #__PURE__ */ $3b38984084ed8eff$export$3988ae62b71be9a3($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$38dab5a9fea42f39 = /* #__PURE__ */ $3b38984084ed8eff$export$38dab5a9fea42f39($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$1822828d790e23ee = /* #__PURE__ */ $3b38984084ed8eff$export$1822828d790e23ee($d615f2c6d9bee660$export$7a292f067638ecd6);







// Generated by purs version 0.15.15














// Generated by purs version 0.15.15


// Generated by purs version 0.15.15



















var $d92fd2ed216a6b0a$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $d92fd2ed216a6b0a$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $d92fd2ed216a6b0a$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($78c799cba34fcb8d$export$97980ce7ea95015b);
var $d92fd2ed216a6b0a$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$25cda6d3e08b28fe);
var $d92fd2ed216a6b0a$var$empty = /* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($78c799cba34fcb8d$export$55d622505c452dcb);
var $d92fd2ed216a6b0a$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $d92fd2ed216a6b0a$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $d92fd2ed216a6b0a$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($08944f7287e2704c$export$65915895b3a8faeb);
var $d92fd2ed216a6b0a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $d92fd2ed216a6b0a$export$709f6946f4e97408 = function(dict) {
    return dict.separate;
};
var $d92fd2ed216a6b0a$var$mapToList = function(dictOrd) {
    return $d92fd2ed216a6b0a$var$toUnfoldable;
};
var $d92fd2ed216a6b0a$export$9203270bb02a0af4 = {
    compact: /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($06733ae99ed4f534$export$e5fea5661dee377),
    separate: function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
            left: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            right: $06733ae99ed4f534$export$bebe9059409a0d04.value
        };
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            if (v.value0 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                left: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.value0),
                right: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
            if (v.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                left: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                right: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.value0)
            };
            throw new Error("Failed pattern match at Data.Compactable (line 91, column 23 - line 93, column 48): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Compactable (line 87, column 1 - line 93, column 48): " + [
            v.constructor.name
        ]);
    }
};
var $d92fd2ed216a6b0a$export$3d21250b0fc194c = function(dictOrd) {
    var alter = $ea3eb84de0acf574$export$22a7378e1d3307a4(dictOrd);
    var mapToList1 = $d92fd2ed216a6b0a$var$mapToList(dictOrd);
    var insert = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return {
        compact: function() {
            var select = function(v) {
                return function(m) {
                    return alter($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v.value1))(v.value0)(m);
                };
            };
            var $104 = $d92fd2ed216a6b0a$var$foldr(select)($ea3eb84de0acf574$export$6e22c362a0406a2c);
            return function($105) {
                return $104(mapToList1($105));
            };
        }(),
        separate: function() {
            var select = function(v) {
                return function(v1) {
                    if (v.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                        left: insert(v.value0)(v.value1.value0)(v1.left),
                        right: v1.right
                    };
                    if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                        left: v1.left,
                        right: insert(v.value0)(v.value1.value0)(v1.right)
                    };
                    throw new Error("Failed pattern match at Data.Compactable (line 142, column 44 - line 144, column 63): " + [
                        v.value1.constructor.name
                    ]);
                };
            };
            var $106 = $d92fd2ed216a6b0a$var$foldr(select)({
                left: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                right: $ea3eb84de0acf574$export$6e22c362a0406a2c
            });
            return function($107) {
                return $106(mapToList1($107));
            };
        }()
    };
};
var $d92fd2ed216a6b0a$export$58895fd069208b4a = {
    compact: $3d4fd987da5242ff$export$986c2bbe7a34be0b,
    separate: /* #__PURE__ */ function() {
        var go = function(acc) {
            return function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                    right: acc.right,
                    left: $d92fd2ed216a6b0a$var$alt(acc.left)($d92fd2ed216a6b0a$var$pure(v.value0))
                };
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                    left: acc.left,
                    right: $d92fd2ed216a6b0a$var$alt(acc.right)($d92fd2ed216a6b0a$var$pure(v.value0))
                };
                throw new Error("Failed pattern match at Data.Compactable (line 131, column 14 - line 133, column 54): " + [
                    v.constructor.name
                ]);
            };
        };
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)(go)({
            left: $d92fd2ed216a6b0a$var$empty,
            right: $d92fd2ed216a6b0a$var$empty
        });
    }()
};
var $d92fd2ed216a6b0a$export$d1aeb92518ef4dec = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        compact: function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0);
                if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty);
                throw new Error("Failed pattern match at Data.Compactable (line 97, column 23 - line 99, column 27): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Compactable (line 95, column 1 - line 104, column 53): " + [
                v.constructor.name
            ]);
        },
        separate: function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                left: new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0),
                right: new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0)
            };
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                if (v.value0 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                    left: new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0),
                    right: new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty)
                };
                if (v.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                    left: new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty),
                    right: new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0)
                };
                throw new Error("Failed pattern match at Data.Compactable (line 102, column 24 - line 104, column 53): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Compactable (line 95, column 1 - line 104, column 53): " + [
                v.constructor.name
            ]);
        }
    };
};
var $d92fd2ed216a6b0a$export$dbe0fd5d50f3e4cd = {
    compact: function(xs) {
        return function __do() {
            var result = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function($108) {
                return $d92fd2ed216a6b0a$var$$$void(function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $d92fd2ed216a6b0a$var$pure1(0);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $784e144d56146b5c$export$4cbf152802aa238(v.value0)(result);
                    throw new Error("Failed pattern match at Data.Compactable (line 111, column 34 - line 113, column 35): " + [
                        v.constructor.name
                    ]);
                }($108));
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }();
    },
    separate: function(xs) {
        return function __do() {
            var ls = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var rs = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function($109) {
                return $d92fd2ed216a6b0a$var$$$void(function(v) {
                    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $784e144d56146b5c$export$4cbf152802aa238(v.value0)(ls);
                    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $784e144d56146b5c$export$4cbf152802aa238(v.value0)(rs);
                    throw new Error("Failed pattern match at Data.Compactable (line 122, column 34 - line 124, column 31): " + [
                        v.constructor.name
                    ]);
                }($109));
            })();
            return $d92fd2ed216a6b0a$var$apply($d92fd2ed216a6b0a$var$map(function(v) {
                return function(v1) {
                    return {
                        left: v,
                        right: v1
                    };
                };
            })($784e144d56146b5c$export$7c850c5af9b9983e(ls)))($784e144d56146b5c$export$7c850c5af9b9983e(rs))();
        }();
    }
};
var $d92fd2ed216a6b0a$export$504a9c3e83f54728 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictCompactable) {
        var $110 = $d92fd2ed216a6b0a$export$709f6946f4e97408(dictCompactable);
        var $111 = map1($7d4cccdf062a2261$export$a92e4c44d367d0af($05149ea687d6b460$export$523c0b569236b342));
        return function($112) {
            return function(v) {
                return v.right;
            }($110($111($112)));
        };
    };
};
var $d92fd2ed216a6b0a$export$8e16b83750b44988 = function(dict) {
    return dict.compact;
};
var $d92fd2ed216a6b0a$export$be2da359f0d77b49 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictCompactable) {
        var compact1 = $d92fd2ed216a6b0a$export$8e16b83750b44988(dictCompactable);
        return function(xs) {
            var swapEither = function(e) {
                if (e instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$19db0165690c701a(e.value0);
                if (e instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(e.value0);
                throw new Error("Failed pattern match at Data.Compactable (line 83, column 20 - line 85, column 24): " + [
                    e.constructor.name
                ]);
            };
            return {
                left: compact1(map1(function($113) {
                    return $7d4cccdf062a2261$export$3a6c138b8d0f3874(swapEither($113));
                })(xs)),
                right: compact1(map1($7d4cccdf062a2261$export$3a6c138b8d0f3874)(xs))
            };
        };
    };
};
var $d92fd2ed216a6b0a$export$e5fea5661dee377 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(dictCompactable) {
        var compact1 = $d92fd2ed216a6b0a$export$8e16b83750b44988(dictCompactable);
        return function(x) {
            var $114 = bind1(x);
            return function($115) {
                return compact1($114($115));
            };
        };
    };
};
var $d92fd2ed216a6b0a$export$3806e10d0c441ac5 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(dictCompactable) {
        var separate1 = $d92fd2ed216a6b0a$export$709f6946f4e97408(dictCompactable);
        return function(x) {
            var $116 = bind1(x);
            return function($117) {
                return separate1($116($117));
            };
        };
    };
};
var $d92fd2ed216a6b0a$export$22d9917da16590e7 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    return function(dictCompactable) {
        var compact1 = $d92fd2ed216a6b0a$export$8e16b83750b44988(dictCompactable);
        return function(p) {
            var $118 = apply1(p);
            return function($119) {
                return compact1($118($119));
            };
        };
    };
};
var $d92fd2ed216a6b0a$export$d5df7cb019d08f04 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    return function(dictCompactable) {
        var separate1 = $d92fd2ed216a6b0a$export$709f6946f4e97408(dictCompactable);
        return function(p) {
            var $120 = apply1(p);
            return function($121) {
                return separate1($120($121));
            };
        };
    };
};













var $f157a7fafda88939$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $f157a7fafda88939$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $f157a7fafda88939$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $f157a7fafda88939$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592($f8fc227945eb179e$export$d7d9283ee84f4c3f));
var $f157a7fafda88939$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $f157a7fafda88939$export$2981e3c3d289ce4e = function(dictFilterable) {
    var separate = $d92fd2ed216a6b0a$export$709f6946f4e97408(dictFilterable.Compactable0());
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFilterable.Functor1());
    return function(p) {
        var $117 = map(p);
        return function($118) {
            return separate($117($118));
        };
    };
};
var $f157a7fafda88939$export$3117e3f9ececb6bc = function(dict) {
    return dict.partitionMap;
};
var $f157a7fafda88939$export$b29f828819edca8d = function(dict) {
    return dict.partition;
};
var $f157a7fafda88939$export$aec28ae317a0f172 = function(p) {
    return function(x) {
        var $66 = p(x);
        if ($66) return new $06733ae99ed4f534$export$8a67b48435b5d073(x);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $f157a7fafda88939$export$672d1d8928870de = {
    partitionMap: function(p) {
        return function(xs) {
            var select = function(x) {
                return function(v) {
                    var v1 = p(x);
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                        left: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.left),
                        right: v.right
                    };
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                        left: v.left,
                        right: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v.right)
                    };
                    throw new Error("Failed pattern match at Data.Filterable (line 190, column 36 - line 192, column 83): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $f157a7fafda88939$var$foldr(select)({
                left: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                right: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(xs);
        };
    },
    partition: function(p) {
        return function(xs) {
            var select = function(x) {
                return function(v) {
                    var $76 = p(x);
                    if ($76) return {
                        no: v.no,
                        yes: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.yes)
                    };
                    return {
                        no: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.no),
                        yes: v.yes
                    };
                };
            };
            return $f157a7fafda88939$var$foldr(select)({
                no: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                yes: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(xs);
        };
    },
    filterMap: function(p) {
        return $3d4fd987da5242ff$export$e70771d2e7e590a(p);
    },
    filter: $3d4fd987da5242ff$export$3dea766d36a8935f,
    Compactable0: function() {
        return $d92fd2ed216a6b0a$export$58895fd069208b4a;
    },
    Functor1: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $f157a7fafda88939$export$352788f778c11933 = {
    partitionMap: function(p) {
        var go = function(acc) {
            return function(x) {
                var v = p(x);
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                    right: acc.right,
                    left: $f157a7fafda88939$var$append(acc.left)([
                        v.value0
                    ])
                };
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                    left: acc.left,
                    right: $f157a7fafda88939$var$append(acc.right)([
                        v.value0
                    ])
                };
                throw new Error("Failed pattern match at Data.Filterable (line 149, column 16 - line 151, column 50): " + [
                    v.constructor.name
                ]);
            };
        };
        return $f157a7fafda88939$var$foldl(go)({
            left: [],
            right: []
        });
    },
    partition: $396c4c3d9e7fae3c$export$b29f828819edca8d,
    filterMap: $396c4c3d9e7fae3c$export$e70771d2e7e590a,
    filter: $396c4c3d9e7fae3c$export$3dea766d36a8935f,
    Compactable0: function() {
        return $d92fd2ed216a6b0a$export$dbe0fd5d50f3e4cd;
    },
    Functor1: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $f157a7fafda88939$export$345e9a20fad9eacf = function(dictFilterable) {
    var compact = $d92fd2ed216a6b0a$export$8e16b83750b44988(dictFilterable.Compactable0());
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFilterable.Functor1());
    return function(p) {
        var $119 = map(p);
        return function($120) {
            return compact($119($120));
        };
    };
};
var $f157a7fafda88939$export$a04c6c6965dd4709 = function(dict) {
    return dict.filterMap;
};
var $f157a7fafda88939$export$418fec99fa55c891 = function(dictFilterable) {
    var filterMap1 = $f157a7fafda88939$export$a04c6c6965dd4709(dictFilterable);
    return function(p) {
        return function(xs) {
            return {
                yes: filterMap1($f157a7fafda88939$export$aec28ae317a0f172(p))(xs),
                no: filterMap1($f157a7fafda88939$export$aec28ae317a0f172($f157a7fafda88939$var$not(p)))(xs)
            };
        };
    };
};
var $f157a7fafda88939$export$4031be3f439d938d = function(dictFilterable) {
    var partition1 = $f157a7fafda88939$export$b29f828819edca8d(dictFilterable);
    return function(p) {
        return function(xs) {
            return partition1(p)(xs).yes;
        };
    };
};
var $f157a7fafda88939$export$e981d4deac08c34a = function(dictFilterable) {
    var $121 = $f157a7fafda88939$export$a04c6c6965dd4709(dictFilterable);
    return function($122) {
        return $121($f157a7fafda88939$export$aec28ae317a0f172($122));
    };
};
var $f157a7fafda88939$export$3dea766d36a8935f = function(dict) {
    return dict.filter;
};
var $f157a7fafda88939$export$a475b8d3546eb5a5 = function(dictFilterable) {
    var filter1 = $f157a7fafda88939$export$3dea766d36a8935f(dictFilterable);
    return function(p) {
        return function(xs) {
            return {
                yes: filter1(p)(xs),
                no: filter1($f157a7fafda88939$var$not(p))(xs)
            };
        };
    };
};
var $f157a7fafda88939$export$a45a579158253b98 = function(p) {
    return function(x) {
        var $84 = p(x);
        if ($84) return new $7d4cccdf062a2261$export$19db0165690c701a(x);
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(x);
    };
};
var $f157a7fafda88939$export$a2cdbcfbb7e2f2da = function(dictFilterable) {
    var partitionMap1 = $f157a7fafda88939$export$3117e3f9ececb6bc(dictFilterable);
    return function(p) {
        return function(xs) {
            return partitionMap1($f157a7fafda88939$export$a45a579158253b98(p))(xs).right;
        };
    };
};
var $f157a7fafda88939$export$a10993d6dde41fad = function(dictFilterable) {
    var partitionMap1 = $f157a7fafda88939$export$3117e3f9ececb6bc(dictFilterable);
    return function(p) {
        return function(xs) {
            var o = partitionMap1($f157a7fafda88939$export$a45a579158253b98(p))(xs);
            return {
                no: o.left,
                yes: o.right
            };
        };
    };
};
var $f157a7fafda88939$export$f907c13ac3e76da7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var compactableEither = $d92fd2ed216a6b0a$export$d1aeb92518ef4dec(dictMonoid);
    return {
        partitionMap: function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                    left: new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0),
                    right: new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0)
                };
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    var v2 = v(v1.value0);
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                        left: new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0),
                        right: new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty)
                    };
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                        left: new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty),
                        right: new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0)
                    };
                    throw new Error("Failed pattern match at Data.Filterable (line 173, column 30 - line 175, column 53): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Filterable (line 171, column 1 - line 184, column 29): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        partition: function(p) {
            return $f157a7fafda88939$export$a10993d6dde41fad($f157a7fafda88939$export$f907c13ac3e76da7(dictMonoid))(p);
        },
        filterMap: function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    var v2 = v(v1.value0);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(mempty);
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0);
                    throw new Error("Failed pattern match at Data.Filterable (line 180, column 27 - line 182, column 22): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Filterable (line 171, column 1 - line 184, column 29): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        filter: function(p) {
            return $f157a7fafda88939$export$e981d4deac08c34a($f157a7fafda88939$export$f907c13ac3e76da7(dictMonoid))(p);
        },
        Compactable0: function() {
            return compactableEither;
        },
        Functor1: function() {
            return $7d4cccdf062a2261$export$f0a413d3d6075601;
        }
    };
};
var $f157a7fafda88939$export$3ddea25c6066424f = function(dictOrd) {
    var insert = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    var alter = $ea3eb84de0acf574$export$22a7378e1d3307a4(dictOrd);
    var compactableMap = $d92fd2ed216a6b0a$export$3d21250b0fc194c(dictOrd);
    return {
        partitionMap: function(p) {
            return function(xs) {
                var select = function(v) {
                    return function(v1) {
                        var v2 = p(v.value1);
                        if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                            left: insert(v.value0)(v2.value0)(v1.left),
                            right: v1.right
                        };
                        if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                            left: v1.left,
                            right: insert(v.value0)(v2.value0)(v1.right)
                        };
                        throw new Error("Failed pattern match at Data.Filterable (line 215, column 44 - line 217, column 57): " + [
                            v2.constructor.name
                        ]);
                    };
                };
                return $f157a7fafda88939$var$foldr(select)({
                    left: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                    right: $ea3eb84de0acf574$export$6e22c362a0406a2c
                })($f157a7fafda88939$var$toUnfoldable(xs));
            };
        },
        partition: function(p) {
            return $f157a7fafda88939$export$a10993d6dde41fad($f157a7fafda88939$export$3ddea25c6066424f(dictOrd))(p);
        },
        filterMap: function(p) {
            return function(xs) {
                var select = function(v) {
                    return function(m) {
                        return alter($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(p(v.value1)))(v.value0)(m);
                    };
                };
                return $f157a7fafda88939$var$foldr(select)($ea3eb84de0acf574$export$6e22c362a0406a2c)($f157a7fafda88939$var$toUnfoldable(xs));
            };
        },
        filter: function(p) {
            return $f157a7fafda88939$export$e981d4deac08c34a($f157a7fafda88939$export$3ddea25c6066424f(dictOrd))(p);
        },
        Compactable0: function() {
            return compactableMap;
        },
        Functor1: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $f157a7fafda88939$export$17bc6e29a04233e5 = {
    partitionMap: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                left: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                right: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var v2 = v(v1.value0);
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return {
                    left: new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0),
                    right: $06733ae99ed4f534$export$bebe9059409a0d04.value
                };
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return {
                    left: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    right: new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0)
                };
                throw new Error("Failed pattern match at Data.Filterable (line 161, column 29 - line 163, column 48): " + [
                    v2.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Filterable (line 159, column 1 - line 169, column 29): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    partition: function(p) {
        return $f157a7fafda88939$export$a10993d6dde41fad($f157a7fafda88939$export$17bc6e29a04233e5)(p);
    },
    filterMap: /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377),
    filter: function(p) {
        return $f157a7fafda88939$export$e981d4deac08c34a($f157a7fafda88939$export$17bc6e29a04233e5)(p);
    },
    Compactable0: function() {
        return $d92fd2ed216a6b0a$export$9203270bb02a0af4;
    },
    Functor1: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $f157a7fafda88939$export$fdd23185b96b7046 = function(dictFilterable) {
    return $f157a7fafda88939$export$a04c6c6965dd4709(dictFilterable)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value));
};




// Generated by purs version 0.15.15


// Generated by purs version 0.15.15





var $00137f617725882c$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $00137f617725882c$export$79ffe56a765070d2 = function(dict) {
    return dict.right;
};
var $00137f617725882c$export$eabcd2c8791e7bf4 = function(dict) {
    return dict.left;
};
var $00137f617725882c$export$325b6c2fcdddb4a0 = function(dictSemigroupoid) {
    var composeFlipped = $5807467a73465f3c$export$b5a9558a7176e41b(dictSemigroupoid);
    return function(dictChoice) {
        var left1 = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
        var right1 = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
        return function(l) {
            return function(r) {
                return composeFlipped(left1(l))(right1(r));
            };
        };
    };
};
var $00137f617725882c$export$7de307094d63789d = function(dictSemigroupoid) {
    var splitChoice1 = $00137f617725882c$export$325b6c2fcdddb4a0(dictSemigroupoid);
    return function(dictChoice) {
        var rmap = $9be1c75e3223ee2e$export$6630987c9d273301(dictChoice.Profunctor0());
        var splitChoice2 = splitChoice1(dictChoice);
        return function(l) {
            return function(r) {
                return rmap($7d4cccdf062a2261$export$5f5be1bb6cd1fded($00137f617725882c$var$identity)($00137f617725882c$var$identity))(splitChoice2(l)(r));
            };
        };
    };
};
var $00137f617725882c$export$fc24090daa54e09a = {
    left: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
            throw new Error("Failed pattern match at Data.Profunctor.Choice (line 32, column 1 - line 35, column 16): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    right: /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601),
    Profunctor0: function() {
        return $9be1c75e3223ee2e$export$e10497e40cde5fd3;
    }
};



// Generated by purs version 0.15.15




var $65bbf210574f301e$export$311dde6ade8133c7 = {
    first: function(a2b) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a2b(v.value0), v.value1);
        };
    },
    second: /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0),
    Profunctor0: function() {
        return $9be1c75e3223ee2e$export$e10497e40cde5fd3;
    }
};
var $65bbf210574f301e$export$3d3c77ce7df7d30d = function(dict) {
    return dict.second;
};
var $65bbf210574f301e$export$43128fadae87b74a = function(dict) {
    return dict.first;
};
var $65bbf210574f301e$export$a66b5a8932fce7e1 = function(dictSemigroupoid) {
    var composeFlipped = $5807467a73465f3c$export$b5a9558a7176e41b(dictSemigroupoid);
    return function(dictStrong) {
        var first1 = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
        var second1 = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
        return function(l) {
            return function(r) {
                return composeFlipped(first1(l))(second1(r));
            };
        };
    };
};
var $65bbf210574f301e$export$296bafc6ffe8d435 = function(dictSemigroupoid) {
    var splitStrong1 = $65bbf210574f301e$export$a66b5a8932fce7e1(dictSemigroupoid);
    return function(dictStrong) {
        var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(dictStrong.Profunctor0());
        var splitStrong2 = splitStrong1(dictStrong);
        return function(l) {
            return function(r) {
                return lcmap(function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, a);
                })(splitStrong2(l)(r));
            };
        };
    };
};


var $48c79e0fab366ce5$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $48c79e0fab366ce5$export$da26cf42b4a20975 = function(dictApplicative) {
    var strongStar = $6f71832c0f0d3a5b$export$1bd208d997e69566(dictApplicative.Apply0().Functor0());
    var choiceStar = $6f71832c0f0d3a5b$export$9b633f3f90080760(dictApplicative);
    return {
        wander: function(t) {
            return function(v) {
                return t(dictApplicative)(v);
            };
        },
        Strong0: function() {
            return strongStar;
        },
        Choice1: function() {
            return choiceStar;
        }
    };
};
var $48c79e0fab366ce5$export$3576324867460c38 = {
    wander: function(t) {
        return $48c79e0fab366ce5$var$alaF($50c50d1f444e5fa4$export$544bf02140fa9a77)(t($50c50d1f444e5fa4$export$fd3b2458e55fc503));
    },
    Strong0: function() {
        return $65bbf210574f301e$export$311dde6ade8133c7;
    },
    Choice1: function() {
        return $00137f617725882c$export$fc24090daa54e09a;
    }
};
var $48c79e0fab366ce5$export$cfc1ea1528b06875 = function(dict) {
    return dict.wander;
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15






var $6390cf100bf9f6d9$var$second = /* #__PURE__ */ $65bbf210574f301e$export$3d3c77ce7df7d30d($65bbf210574f301e$export$311dde6ade8133c7);
var $6390cf100bf9f6d9$export$8ef99100a3c56f8c = function(x) {
    return x;
};
var $6390cf100bf9f6d9$export$8681e402e0126fd = function(dictProfunctor) {
    var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    return dimap($6390cf100bf9f6d9$var$second(f))(g)(v);
                };
            };
        }
    };
};
var $6390cf100bf9f6d9$export$5e8bf7b4ad0c1b2d = function(dictStrong) {
    var Profunctor0 = dictStrong.Profunctor0();
    var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(Profunctor0);
    var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
    var second1 = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
    var profunctorIndexed1 = $6390cf100bf9f6d9$export$8681e402e0126fd(Profunctor0);
    return {
        first: function(v) {
            return lcmap(function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1.value0), v1.value1.value1);
            })(first(v));
        },
        second: function(v) {
            return lcmap(function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1.value1));
            })(second1(v));
        },
        Profunctor0: function() {
            return profunctorIndexed1;
        }
    };
};
var $6390cf100bf9f6d9$export$84206951dae378d4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6390cf100bf9f6d9$export$b117f91de9fdbe82 = function(dictChoice) {
    var Profunctor0 = dictChoice.Profunctor0();
    var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(Profunctor0);
    var left = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
    var right = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
    var profunctorIndexed1 = $6390cf100bf9f6d9$export$8681e402e0126fd(Profunctor0);
    return {
        left: function(v) {
            return lcmap(function(v1) {
                return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                    var $63 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                    return function($64) {
                        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($63($64));
                    };
                }())($7d4cccdf062a2261$export$19db0165690c701a.create)(v1.value1);
            })(left(v));
        },
        right: function(v) {
            return lcmap(function(v1) {
                return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function() {
                    var $65 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                    return function($66) {
                        return $7d4cccdf062a2261$export$19db0165690c701a.create($65($66));
                    };
                }())(v1.value1);
            })(right(v));
        },
        Profunctor0: function() {
            return profunctorIndexed1;
        }
    };
};
var $6390cf100bf9f6d9$export$b6c86e7b404c18c9 = function(dictWander) {
    var wander = $48c79e0fab366ce5$export$cfc1ea1528b06875(dictWander);
    var strongIndexed1 = $6390cf100bf9f6d9$export$5e8bf7b4ad0c1b2d(dictWander.Strong0());
    var choiceIndexed1 = $6390cf100bf9f6d9$export$b117f91de9fdbe82(dictWander.Choice1());
    return {
        wander: function(trav) {
            return function(v) {
                return wander(function(dictApplicative) {
                    var trav2 = trav(dictApplicative);
                    return function(ia2fb) {
                        return function(v1) {
                            return trav2(function() {
                                var $67 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                                return function($68) {
                                    return ia2fb($67($68));
                                };
                            }())(v1.value1);
                        };
                    };
                })(v);
            };
        },
        Strong0: function() {
            return strongIndexed1;
        },
        Choice1: function() {
            return choiceIndexed1;
        }
    };
};


// Generated by purs version 0.15.15

var $4412cb41f741288f$export$aa82d568fb2f38da = /* #__PURE__ */ function() {
    function Shop(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Shop.create = function(value0) {
        return function(value1) {
            return new Shop(value0, value1);
        };
    };
    return Shop;
}();
var $4412cb41f741288f$export$fec4dc80195438b9 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $4412cb41f741288f$export$aa82d568fb2f38da(function($31) {
                    return v.value0(f($31));
                }, function(s) {
                    var $32 = v.value1(f(s));
                    return function($33) {
                        return g($32($33));
                    };
                });
            };
        };
    }
};
var $4412cb41f741288f$export$a705c9672fb9f75 = {
    first: function(v) {
        return new $4412cb41f741288f$export$aa82d568fb2f38da(function(v1) {
            return v.value0(v1.value0);
        }, function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1(v1.value0)(b), v1.value1);
            };
        });
    },
    second: function(v) {
        return new $4412cb41f741288f$export$aa82d568fb2f38da(function(v1) {
            return v.value0(v1.value1);
        }, function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1(v1.value1)(b));
            };
        });
    },
    Profunctor0: function() {
        return $4412cb41f741288f$export$fec4dc80195438b9;
    }
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
var $704a14067558099e$export$745d998ba62b3184 = /* #__PURE__ */ function() {
    function Exchange(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Exchange.create = function(value0) {
        return function(value1) {
            return new Exchange(value0, value1);
        };
    };
    return Exchange;
}();
var $704a14067558099e$export$3ce281628d36b8a1 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $704a14067558099e$export$745d998ba62b3184(function($12) {
                    return v.value0(f($12));
                }, function($13) {
                    return g(v.value1($13));
                });
            };
        };
    }
};
var $704a14067558099e$export$e5090b67a0fa69cf = {
    map: function(f) {
        return function(v) {
            return new $704a14067558099e$export$745d998ba62b3184(v.value0, function($14) {
                return f(v.value1($14));
            });
        };
    }
};


// Generated by purs version 0.15.15






var $64b04bb6c92110b4$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $64b04bb6c92110b4$export$7999ed7bf07e0908 = function(x) {
    return x;
};
var $64b04bb6c92110b4$export$a6b352dfd8349508 = function(dictSemigroup) {
    return $d7bf9817a417d4ae$export$49c9dc4575956c55(dictSemigroup);
};
var $64b04bb6c92110b4$export$4abec2a7e626a96e = {
    dimap: function(f) {
        return function(v) {
            return function(v1) {
                return function($36) {
                    return v1(f($36));
                };
            };
        };
    }
};
var $64b04bb6c92110b4$export$babcd87d8ce55e9e = {
    first: function(v) {
        return function($37) {
            return v($71f2e2e9476163f8$export$9e770fa6ce19a9d6($37));
        };
    },
    second: function(v) {
        return function($38) {
            return v($71f2e2e9476163f8$export$6f71268a1666ab58($38));
        };
    },
    Profunctor0: function() {
        return $64b04bb6c92110b4$export$4abec2a7e626a96e;
    }
};
var $64b04bb6c92110b4$export$d143b437db5aa20 = {
    Coercible0: function() {
        return undefined;
    }
};
var $64b04bb6c92110b4$export$37677d741fe484a1 = function(dictMonoid) {
    return $784e1bd3d26d71da$export$192e81b9fe7e4abe(dictMonoid);
};
var $64b04bb6c92110b4$export$85ce6f625a0d3bb3 = {
    unleft: function(v) {
        return function($39) {
            return v($7d4cccdf062a2261$export$37c4d04eafdc5515.create($39));
        };
    },
    unright: function(v) {
        return function($40) {
            return v($7d4cccdf062a2261$export$19db0165690c701a.create($40));
        };
    },
    Profunctor0: function() {
        return $64b04bb6c92110b4$export$4abec2a7e626a96e;
    }
};
var $64b04bb6c92110b4$export$b41051971cb8cf21 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($784e1bd3d26d71da$export$192e81b9fe7e4abe(dictMonoid));
    return {
        left: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(v)(mempty);
        },
        right: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(mempty)(v);
        },
        Profunctor0: function() {
            return $64b04bb6c92110b4$export$4abec2a7e626a96e;
        }
    };
};
var $64b04bb6c92110b4$export$b8012e26804f1c03 = function(dictMonoid) {
    var applicativeConst = $10ae0394c8c3139a$export$38647a91a5af2717(dictMonoid);
    var choiceForget1 = $64b04bb6c92110b4$export$b41051971cb8cf21(dictMonoid);
    return {
        wander: function(f) {
            return function(v) {
                return $64b04bb6c92110b4$var$alaF($10ae0394c8c3139a$export$8ad5d15375e29446)(f(applicativeConst))(v);
            };
        },
        Strong0: function() {
            return $64b04bb6c92110b4$export$babcd87d8ce55e9e;
        },
        Choice1: function() {
            return choiceForget1;
        }
    };
};


// Generated by purs version 0.15.15
var $954c5a7609942688$export$494c25d006806a39 = function(x) {
    return x;
};
var $954c5a7609942688$export$87627d8471c3113f = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return function(d) {
                    return g(v(function(k) {
                        return d(function($7) {
                            return k(f($7));
                        });
                    }));
                };
            };
        };
    }
};
var $954c5a7609942688$export$bda6fbf5eb25f0fc = {
    Coercible0: function() {
        return undefined;
    }
};
var $954c5a7609942688$export$62ed8e5ffb5b363d = {
    closed: function(v) {
        return function(f) {
            return function(x) {
                return v(function(k) {
                    return f(function(g) {
                        return k(g(x));
                    });
                });
            };
        };
    },
    Profunctor0: function() {
        return $954c5a7609942688$export$87627d8471c3113f;
    }
};



// Generated by purs version 0.15.15


var $f9bc92cc92266955$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $f9bc92cc92266955$export$3db8c5834c5aa726 = /* #__PURE__ */ function() {
    function Market(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Market.create = function(value0) {
        return function(value1) {
            return new Market(value0, value1);
        };
    };
    return Market;
}();
var $f9bc92cc92266955$export$8693aba30958a33d = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($21) {
                    return g(v.value0($21));
                }, function() {
                    var $22 = $f9bc92cc92266955$var$lmap(g);
                    return function($23) {
                        return $22(v.value1(f($23)));
                    };
                }());
            };
        };
    }
};
var $f9bc92cc92266955$export$cd2871f7f716f5c4 = {
    map: function(f) {
        return function(v) {
            return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($24) {
                return f(v.value0($24));
            }, function() {
                var $25 = $f9bc92cc92266955$var$lmap(f);
                return function($26) {
                    return $25(v.value1($26));
                };
            }());
        };
    }
};
var $f9bc92cc92266955$export$eaf0e5cd44be9d3c = {
    left: function(v) {
        return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($27) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(v.value0($27));
        }, $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
            var $28 = $f9bc92cc92266955$var$lmap($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
            return function($29) {
                return $28(v.value1($29));
            };
        }())(function($30) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($7d4cccdf062a2261$export$19db0165690c701a.create($30));
        }));
    },
    right: function(v) {
        return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($31) {
            return $7d4cccdf062a2261$export$19db0165690c701a.create(v.value0($31));
        }, $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($32) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($32));
        })(function() {
            var $33 = $f9bc92cc92266955$var$lmap($7d4cccdf062a2261$export$19db0165690c701a.create);
            return function($34) {
                return $33(v.value1($34));
            };
        }()));
    },
    Profunctor0: function() {
        return $f9bc92cc92266955$export$8693aba30958a33d;
    }
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15
var $6312e0f0493654fc$export$32c5facbb64cac7f = function(dict) {
    return dict.unright;
};
var $6312e0f0493654fc$export$b5d72aec2da3ea19 = function(dict) {
    return dict.unleft;
};


// Generated by purs version 0.15.15
var $cada8a38adf1edb6$export$820fe413f6cf1de5 = function(dict) {
    return dict.unsecond;
};
var $cada8a38adf1edb6$export$a329cdab990c51ff = function(dict) {
    return dict.unfirst;
};



var $a7b9ed7c15cf8966$export$2f2cbc902dde0906 = function(x) {
    return x;
};
var $a7b9ed7c15cf8966$export$723210aeb8c6f0f6 = function(dictProfunctor) {
    var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $43 = dimap(g)(f);
                    return function($44) {
                        return v($43($44));
                    };
                };
            };
        }
    };
};
var $a7b9ed7c15cf8966$export$1a1045dfc0970e6f = function(dictStrong) {
    var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
    var second = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictStrong.Profunctor0());
    return {
        unfirst: function(v) {
            return function($45) {
                return v(first($45));
            };
        },
        unsecond: function(v) {
            return function($46) {
                return v(second($46));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$ae005232e0e57b3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $a7b9ed7c15cf8966$export$d7de09889a8b31b2 = function(dictCostrong) {
    var unfirst = $cada8a38adf1edb6$export$a329cdab990c51ff(dictCostrong);
    var unsecond = $cada8a38adf1edb6$export$820fe413f6cf1de5(dictCostrong);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictCostrong.Profunctor0());
    return {
        first: function(v) {
            return function($47) {
                return v(unfirst($47));
            };
        },
        second: function(v) {
            return function($48) {
                return v(unsecond($48));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$5705537200f3530 = function(dictCochoice) {
    var unleft = $6312e0f0493654fc$export$b5d72aec2da3ea19(dictCochoice);
    var unright = $6312e0f0493654fc$export$32c5facbb64cac7f(dictCochoice);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictCochoice.Profunctor0());
    return {
        left: function(v) {
            return function($49) {
                return v(unleft($49));
            };
        },
        right: function(v) {
            return function($50) {
                return v(unright($50));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$ce74e260a720e457 = function(dictChoice) {
    var left = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
    var right = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictChoice.Profunctor0());
    return {
        unleft: function(v) {
            return function($51) {
                return v(left($51));
            };
        },
        unright: function(v) {
            return function($52) {
                return v(right($52));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};



// Generated by purs version 0.15.15




var $dea9e9a4897f9486$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $dea9e9a4897f9486$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $dea9e9a4897f9486$export$a4c5071042bb3941 = /* #__PURE__ */ function() {
    function Stall(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Stall.create = function(value0) {
        return function(value1) {
            return new Stall(value0, value1);
        };
    };
    return Stall;
}();
var $dea9e9a4897f9486$export$cc7fb5dffce8cf27 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $dea9e9a4897f9486$export$a4c5071042bb3941(function() {
                    var $64 = $dea9e9a4897f9486$var$map(g);
                    return function($65) {
                        return $64(v.value0(f($65)));
                    };
                }(), function() {
                    var $66 = $dea9e9a4897f9486$var$lmap(g);
                    return function($67) {
                        return $66(v.value1(f($67)));
                    };
                }());
            };
        };
    }
};
var $dea9e9a4897f9486$export$b5b4ef4e571e6800 = {
    first: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0(v1.value0)(b), v1.value1);
            };
        }, function(v1) {
            return $dea9e9a4897f9486$var$lmap(function(t) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(t, v1.value1);
            })(v.value1(v1.value0));
        });
    },
    second: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value0(v1.value1)(b));
            };
        }, function(v1) {
            return $dea9e9a4897f9486$var$lmap($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0))(v.value1(v1.value1));
        });
    },
    Profunctor0: function() {
        return $dea9e9a4897f9486$export$cc7fb5dffce8cf27;
    }
};
var $dea9e9a4897f9486$export$86efaf93cc453e83 = {
    map: function(f) {
        return function(v) {
            return new $dea9e9a4897f9486$export$a4c5071042bb3941(function() {
                var $68 = $dea9e9a4897f9486$var$map(f);
                return function($69) {
                    return $68(v.value0($69));
                };
            }(), function() {
                var $70 = $dea9e9a4897f9486$var$lmap(f);
                return function($71) {
                    return $70(v.value1($71));
                };
            }());
        };
    }
};
var $dea9e9a4897f9486$export$3216926ea4acbfa6 = {
    left: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return function(b) {
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0(v1.value0)(b));
            };
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return function(v2) {
                return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
            };
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 36, column 9 - line 38, column 35): " + [
                v1.constructor.name
            ]);
        }, function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $dea9e9a4897f9486$var$lmap($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(v.value1(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0));
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 40, column 9 - line 42, column 36): " + [
                v1.constructor.name
            ]);
        });
    },
    right: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return function(v2) {
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            };
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return function(b) {
                return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0(v1.value0)(b));
            };
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 47, column 9 - line 49, column 41): " + [
                v1.constructor.name
            ]);
        }, function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $dea9e9a4897f9486$var$lmap($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value1(v1.value0));
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 51, column 9 - line 53, column 38): " + [
                v1.constructor.name
            ]);
        });
    },
    Profunctor0: function() {
        return $dea9e9a4897f9486$export$cc7fb5dffce8cf27;
    }
};


// Generated by purs version 0.15.15





var $333e6139bd8d8d5d$export$b40ff0778ec92ebb = function(x) {
    return x;
};
var $333e6139bd8d8d5d$export$6b99682488d6b082 = {
    dimap: function(v) {
        return function(g) {
            return function(v1) {
                return g(v1);
            };
        };
    }
};
var $333e6139bd8d8d5d$export$a20b385d3e05c24e = {
    unfirst: function(v) {
        return v.value0;
    },
    unsecond: function(v) {
        return v.value1;
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$486a67f830a39b92 = {
    closed: function(v) {
        return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v);
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$5fa6ad029e8dcb6e = {
    left: function(v) {
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v);
    },
    right: function(v) {
        return new $7d4cccdf062a2261$export$19db0165690c701a(v);
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$8e57909c79fa72ff = {
    Coercible0: function() {
        return undefined;
    }
};
var $333e6139bd8d8d5d$export$9f02894590a2f0f7 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $333e6139bd8d8d5d$export$419b07851c0b3688 = {
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldr: function(f) {
        return function(b) {
            return function(v) {
                return f(v)(b);
            };
        };
    },
    foldl: function(f) {
        return function(b) {
            return function(v) {
                return f(b)(v);
            };
        };
    }
};
var $333e6139bd8d8d5d$export$2defb87457b7d824 = {
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($333e6139bd8d8d5d$export$b40ff0778ec92ebb)(v);
        };
    },
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($333e6139bd8d8d5d$export$b40ff0778ec92ebb)(f(v));
            };
        };
    },
    Functor0: function() {
        return $333e6139bd8d8d5d$export$9f02894590a2f0f7;
    },
    Foldable1: function() {
        return $333e6139bd8d8d5d$export$419b07851c0b3688;
    }
};
var $333e6139bd8d8d5d$export$ecae7ebd109c6538 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq(x)(y);
            };
        }
    };
};
var $333e6139bd8d8d5d$export$ce07ee061b9e8cbc = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqTagged1 = $333e6139bd8d8d5d$export$ecae7ebd109c6538(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqTagged1;
        }
    };
};
var $333e6139bd8d8d5d$export$cadadebf8f4168cc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($333e6139bd8d8d5d$export$ecae7ebd109c6538(dictEq));
    }
};
var $333e6139bd8d8d5d$export$185a5532b1c5359b = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($333e6139bd8d8d5d$export$ce07ee061b9e8cbc(dictOrd));
    },
    Eq10: function() {
        return $333e6139bd8d8d5d$export$cadadebf8f4168cc;
    }
};









var $03856732e0180b78$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $03856732e0180b78$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($7576d3a958d66ab0$export$2f68caa5c730775d);
var $03856732e0180b78$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $03856732e0180b78$export$bb492ec6a8dde761 = function(l) {
    return function(f) {
        var v = l(new $4412cb41f741288f$export$aa82d568fb2f38da($03856732e0180b78$var$identity, function(v1) {
            return function(b) {
                return b;
            };
        }));
        return f(v.value0)(v.value1);
    };
};
var $03856732e0180b78$export$b9c8f4c583975536 = function(l) {
    return function(f) {
        var v = l(new $4412cb41f741288f$export$aa82d568fb2f38da($03856732e0180b78$var$identity, function(v1) {
            return function(b) {
                return b;
            };
        }));
        return f(v.value0)(v.value1);
    };
};
var $03856732e0180b78$export$a798adea9c8f9960 = function(l) {
    return $03856732e0180b78$export$bb492ec6a8dde761(l)($03856732e0180b78$var$lift2($71f2e2e9476163f8$export$1908877435b1d5e9.create));
};
var $03856732e0180b78$export$96b9aa254b12a908 = function(to) {
    return function(dictStrong) {
        var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictStrong.Profunctor0());
        var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
        return function(pab) {
            return dimap(to)(function(v) {
                return v.value1(v.value0);
            })(first(pab));
        };
    };
};
var $03856732e0180b78$export$21cde5187c2605a3 = function(get) {
    return function(set) {
        return function(dictStrong) {
            return $03856732e0180b78$export$96b9aa254b12a908(function(s) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(get(s), function(b) {
                    return set(s)(b);
                });
            })(dictStrong);
        };
    };
};
var $03856732e0180b78$export$5c05a294ebe30581 = function(to) {
    return function(dictStrong) {
        var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictStrong.Profunctor0());
        var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
        return function(pab) {
            return dimap(to)(function(v) {
                return v.value1(v.value0);
            })(first($03856732e0180b78$var$un($6390cf100bf9f6d9$export$8ef99100a3c56f8c)(pab)));
        };
    };
};
var $03856732e0180b78$export$7051353daaf9baef = function(get) {
    return function(set) {
        return function(dictStrong) {
            return $03856732e0180b78$export$5c05a294ebe30581(function(s) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(get(s), function(b) {
                    return set(s)(b);
                });
            })(dictStrong);
        };
    };
};
var $03856732e0180b78$export$cb984a643a984e6c = function(l) {
    return function(dictStrong) {
        return $03856732e0180b78$export$bb492ec6a8dde761(l)(function(x) {
            return function(y) {
                return function(p) {
                    return $03856732e0180b78$export$21cde5187c2605a3(x)(y)(dictStrong)(p);
                };
            };
        });
    };
};
var $03856732e0180b78$export$4604be57151298fe = function(l) {
    return function(dictStrong) {
        return $03856732e0180b78$export$b9c8f4c583975536(l)(function(x) {
            return function(y) {
                return function(p) {
                    return $03856732e0180b78$export$7051353daaf9baef(x)(y)(dictStrong)(p);
                };
            };
        });
    };
};


// Generated by purs version 0.15.15











var $5b0358e10bf152e0$export$fb4902fd9e525693 = function(l) {
    return l;
};
var $5b0358e10bf152e0$export$adaa4cf7ef1b65be = function(l) {
    return function(b) {
        return $5b0358e10bf152e0$export$fb4902fd9e525693(l)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(b));
    };
};
var $5b0358e10bf152e0$export$bd1981977ac950af = function(p) {
    var $59 = $5b0358e10bf152e0$export$adaa4cf7ef1b65be(p);
    return function($60) {
        return $59($06733ae99ed4f534$export$8a67b48435b5d073.create($60));
    };
};
var $5b0358e10bf152e0$export$4591dae0bb89b7fa = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    return function(p) {
        var $61 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $62 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(sub);
        return function($63) {
            return $61($62($63));
        };
    };
};
var $5b0358e10bf152e0$export$59c558d9dc09baf0 = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return function(p) {
        var $64 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $65 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(mul);
        return function($66) {
            return $64($65($66));
        };
    };
};
var $5b0358e10bf152e0$export$86b6baac93ff82e3 = function(dictMonadState) {
    var $$void = $f4b2eb11fc32ed34$export$490e536ee7389aeb(dictMonadState.Monad0().Bind1().Apply0().Functor0());
    var modify = $f2d5035ce6148af6$export$3ff57735a52b8713(dictMonadState);
    return function(p) {
        return function(f) {
            return $$void(modify($5b0358e10bf152e0$export$fb4902fd9e525693(p)(f)));
        };
    };
};
var $5b0358e10bf152e0$export$bdf21a3648c59b5b = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemiring) {
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
        return function(p) {
            var $67 = modifying1(p);
            var $68 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(mul);
            return function($69) {
                return $67($68($69));
            };
        };
    };
};
var $5b0358e10bf152e0$export$af7e4897080700dd = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictRing) {
        var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
        return function(p) {
            var $70 = modifying1(p);
            var $71 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(sub);
            return function($72) {
                return $70($71($72));
            };
        };
    };
};
var $5b0358e10bf152e0$export$7deb1a7d85cbf52a = function(l) {
    return function(f) {
        return l($71f2e2e9476163f8$export$7864d59d01b6d6bf(f));
    };
};
var $5b0358e10bf152e0$export$6ce2128036d9209a = function(dictEuclideanRing) {
    var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
    return function(p) {
        var $73 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $74 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(div);
        return function($75) {
            return $73($74($75));
        };
    };
};
var $5b0358e10bf152e0$export$5cf5a3773c82cb31 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictEuclideanRing) {
        var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        return function(p) {
            var $76 = modifying1(p);
            var $77 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(div);
            return function($78) {
                return $76($77($78));
            };
        };
    };
};
var $5b0358e10bf152e0$export$970f645509ec836c = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return function(p) {
        var $79 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $80 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(disj);
        return function($81) {
            return $79($80($81));
        };
    };
};
var $5b0358e10bf152e0$export$f9fe8cf3da8b72b8 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictHeytingAlgebra) {
        var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
        return function(p) {
            var $82 = modifying1(p);
            var $83 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(disj);
            return function($84) {
                return $82($83($84));
            };
        };
    };
};
var $5b0358e10bf152e0$export$7c4dc0be2ad2572f = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return function(p) {
        var $85 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $86 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(conj);
        return function($87) {
            return $85($86($87));
        };
    };
};
var $5b0358e10bf152e0$export$1041c8de5afeb06e = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictHeytingAlgebra) {
        var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
        return function(p) {
            var $88 = modifying1(p);
            var $89 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(conj);
            return function($90) {
                return $88($89($90));
            };
        };
    };
};
var $5b0358e10bf152e0$export$e6e34fd1f2686227 = function(dictMonadState) {
    var $$void = $f4b2eb11fc32ed34$export$490e536ee7389aeb(dictMonadState.Monad0().Bind1().Apply0().Functor0());
    var modify = $f2d5035ce6148af6$export$3ff57735a52b8713(dictMonadState);
    return function(p) {
        return function(b) {
            return $$void(modify($5b0358e10bf152e0$export$adaa4cf7ef1b65be(p)(b)));
        };
    };
};
var $5b0358e10bf152e0$export$49b51df7f48fca22 = function(dictMonadState) {
    var assign1 = $5b0358e10bf152e0$export$e6e34fd1f2686227(dictMonadState);
    return function(p) {
        var $91 = assign1(p);
        return function($92) {
            return $91($06733ae99ed4f534$export$8a67b48435b5d073.create($92));
        };
    };
};
var $5b0358e10bf152e0$export$8a0bf61e09475492 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(p) {
        var $93 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $94 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(append);
        return function($95) {
            return $93($94($95));
        };
    };
};
var $5b0358e10bf152e0$export$43d406ede97d8cbb = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(p) {
            var $96 = modifying1(p);
            var $97 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(append);
            return function($98) {
                return $96($97($98));
            };
        };
    };
};
var $5b0358e10bf152e0$export$328c930ee4a5b767 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return function(p) {
        var $99 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        return function($100) {
            return $99(add($100));
        };
    };
};
var $5b0358e10bf152e0$export$c88597abc83b6ce1 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemiring) {
        var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
        return function(p) {
            var $101 = modifying1(p);
            return function($102) {
                return $101(add($102));
            };
        };
    };
};









// Generated by purs version 0.15.15



// Generated by purs version 0.15.15



// Generated by purs version 0.15.15














var $627093fb1ee74b6b$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $627093fb1ee74b6b$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $627093fb1ee74b6b$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $627093fb1ee74b6b$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($627093fb1ee74b6b$var$monoidEndo);
var $627093fb1ee74b6b$export$140b6cacf0caee10 = function(dict) {
    return dict.bifoldr;
};
var $627093fb1ee74b6b$export$2467df3bb4497583 = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    return function(dictApplicative) {
        var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(g) {
                return bifoldr1(function($207) {
                    return applySecond(f($207));
                })(function($208) {
                    return applySecond(g($208));
                })(pure($05149ea687d6b460$export$523c0b569236b342));
            };
        };
    };
};
var $627093fb1ee74b6b$export$2018976ee387bf60 = function(dictBifoldable) {
    var bitraverse_1 = $627093fb1ee74b6b$export$2467df3bb4497583(dictBifoldable);
    return function(dictApplicative) {
        var bitraverse_2 = bitraverse_1(dictApplicative);
        return function(t) {
            return function(f) {
                return function(g) {
                    return bitraverse_2(f)(g)(t);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$39fe8462a48d4c44 = function(dictBifoldable) {
    var bitraverse_1 = $627093fb1ee74b6b$export$2467df3bb4497583(dictBifoldable);
    return function(dictApplicative) {
        return bitraverse_1(dictApplicative)($627093fb1ee74b6b$var$identity)($627093fb1ee74b6b$var$identity);
    };
};
var $627093fb1ee74b6b$export$fd45dcee229151ae = function(dict) {
    return dict.bifoldl;
};
var $627093fb1ee74b6b$export$9e57ed04fa06006f = {
    bifoldMap: function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            return function(g) {
                return function(v) {
                    return append(f(v.value0))(g(v.value1));
                };
            };
        };
    },
    bifoldr: function(f) {
        return function(g) {
            return function(z) {
                return function(v) {
                    return f(v.value0)(g(v.value1)(z));
                };
            };
        };
    },
    bifoldl: function(f) {
        return function(g) {
            return function(z) {
                return function(v) {
                    return g(f(z)(v.value0))(v.value1);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$3ea37b6c505d5921 = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        bifoldr: function(v) {
            return function(r) {
                return function(u) {
                    return function(v1) {
                        return foldr(r)(u)(v1);
                    };
                };
            };
        },
        bifoldl: function(v) {
            return function(r) {
                return function(u) {
                    return function(v1) {
                        return foldl(r)(u)(v1);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(v) {
                return function(r) {
                    return function(v1) {
                        return foldMap1(r)(v1);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$631c798dd7783874 = {
    bifoldr: function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v3.value0)(v2);
                    if (v3 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v3.value0)(v2);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name,
                        v3.constructor.name
                    ]);
                };
            };
        };
    },
    bifoldl: function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2)(v3.value0);
                    if (v3 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2)(v3.value0);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name,
                        v3.constructor.name
                    ]);
                };
            };
        };
    },
    bifoldMap: function(dictMonoid) {
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
                    throw new Error("Failed pattern match at Data.Bifoldable (line 62, column 1 - line 68, column 32): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$fac7dcf8414b1558 = {
    bifoldr: function(f) {
        return function(v) {
            return function(z) {
                return function(v1) {
                    return f(v1)(z);
                };
            };
        };
    },
    bifoldl: function(f) {
        return function(v) {
            return function(z) {
                return function(v1) {
                    return f(z)(v1);
                };
            };
        };
    },
    bifoldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return function(v1) {
                    return f(v1);
                };
            };
        };
    }
};
var $627093fb1ee74b6b$export$48d6bd28fb1f7b98 = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        bifoldr: function(l) {
            return function(v) {
                return function(u) {
                    return function(v1) {
                        return foldr(l)(u)(v1);
                    };
                };
            };
        },
        bifoldl: function(l) {
            return function(v) {
                return function(u) {
                    return function(v1) {
                        return foldl(l)(u)(v1);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(l) {
                return function(v) {
                    return function(v1) {
                        return foldMap1(l)(v1);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$d9dff9894698034d = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return function(g) {
                return bifoldr1(function($209) {
                    return append(f($209));
                })(function($210) {
                    return append(g($210));
                })(mempty);
            };
        };
    };
};
var $627093fb1ee74b6b$export$d9474c98248f3f9f = function(dictBifoldable) {
    var bifoldl1 = $627093fb1ee74b6b$export$fd45dcee229151ae(dictBifoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return function(g) {
                return bifoldl1(function(m) {
                    return function(a) {
                        return append(m)(f(a));
                    };
                })(function(m) {
                    return function(b) {
                        return append(m)(g(b));
                    };
                })(mempty);
            };
        };
    };
};
var $627093fb1ee74b6b$export$7bc3582301cda79f = function(dict) {
    return dict.bifoldMap;
};
var $627093fb1ee74b6b$export$83ed5690f1f40b8b = function(dictBifoldable) {
    var bifoldr1 = $627093fb1ee74b6b$export$140b6cacf0caee10(dictBifoldable);
    var bifoldl1 = $627093fb1ee74b6b$export$fd45dcee229151ae(dictBifoldable);
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return {
        bifoldr: function(r) {
            return function(l) {
                return function(u) {
                    return function(v) {
                        return bifoldr1(l)(r)(u)(v);
                    };
                };
            };
        },
        bifoldl: function(r) {
            return function(l) {
                return function(u) {
                    return function(v) {
                        return bifoldl1(l)(r)(u)(v);
                    };
                };
            };
        },
        bifoldMap: function(dictMonoid) {
            var bifoldMap2 = bifoldMap1(dictMonoid);
            return function(r) {
                return function(l) {
                    return function(v) {
                        return bifoldMap2(l)(r)(v);
                    };
                };
            };
        }
    };
};
var $627093fb1ee74b6b$export$c7471c021d101489 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable)($627093fb1ee74b6b$var$monoidDual);
    return function(f) {
        return function(g) {
            return function(z) {
                return function(p) {
                    return $627093fb1ee74b6b$var$unwrap($627093fb1ee74b6b$var$unwrap(bifoldMap1(function() {
                        var $211 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(f);
                        return function($212) {
                            return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($211($212)));
                        };
                    }())(function() {
                        var $213 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(g);
                        return function($214) {
                            return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($213($214)));
                        };
                    }())(p)))(z);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$43eff0ef7d27584d = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable)($627093fb1ee74b6b$var$monoidEndo);
    return function(f) {
        return function(g) {
            return function(z) {
                return function(p) {
                    return $627093fb1ee74b6b$var$unwrap(bifoldMap1(function($215) {
                        return $57b8542ac3131c5d$export$6aef3ff797629bec(f($215));
                    })(function($216) {
                        return $57b8542ac3131c5d$export$6aef3ff797629bec(g($216));
                    })(p))(z);
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$15009c29dbef42b7 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBifoldable1) {
        var bifoldMap2 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable1);
        return {
            bifoldr: function(l) {
                return function(r) {
                    return function(u) {
                        return function(m) {
                            return $627093fb1ee74b6b$export$43eff0ef7d27584d($627093fb1ee74b6b$export$15009c29dbef42b7(dictBifoldable)(dictBifoldable1))(l)(r)(u)(m);
                        };
                    };
                };
            },
            bifoldl: function(l) {
                return function(r) {
                    return function(u) {
                        return function(m) {
                            return $627093fb1ee74b6b$export$c7471c021d101489($627093fb1ee74b6b$export$15009c29dbef42b7(dictBifoldable)(dictBifoldable1))(l)(r)(u)(m);
                        };
                    };
                };
            },
            bifoldMap: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var bifoldMap3 = bifoldMap1(dictMonoid);
                var bifoldMap4 = bifoldMap2(dictMonoid);
                return function(l) {
                    return function(r) {
                        return function(v) {
                            return append(bifoldMap3(l)(r)(v.value0))(bifoldMap4(l)(r)(v.value1));
                        };
                    };
                };
            }
        };
    };
};
var $627093fb1ee74b6b$export$16bd399c2eeb79bd = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictMonoid) {
        return bifoldMap1(dictMonoid)($627093fb1ee74b6b$var$identity)($627093fb1ee74b6b$var$identity);
    };
};
var $627093fb1ee74b6b$export$b2f5f4f071ae5de6 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBooleanAlgebra) {
        var bifoldMap2 = bifoldMap1($1242d110ab1edcd9$export$e1c73e5b30670500(dictBooleanAlgebra.HeytingAlgebra0()));
        return function(p) {
            return function(q) {
                var $217 = bifoldMap2(function($219) {
                    return $1242d110ab1edcd9$export$286e7113895e33ef(p($219));
                })(function($220) {
                    return $1242d110ab1edcd9$export$286e7113895e33ef(q($220));
                });
                return function($218) {
                    return $627093fb1ee74b6b$var$unwrap($217($218));
                };
            };
        };
    };
};
var $627093fb1ee74b6b$export$75b148bc89d1ac62 = function(dictBifoldable) {
    var bifoldMap1 = $627093fb1ee74b6b$export$7bc3582301cda79f(dictBifoldable);
    return function(dictBooleanAlgebra) {
        var bifoldMap2 = bifoldMap1($65ae0a43a0950bac$export$4f2b093ea8408d89(dictBooleanAlgebra.HeytingAlgebra0()));
        return function(p) {
            return function(q) {
                var $221 = bifoldMap2(function($223) {
                    return $65ae0a43a0950bac$export$c688766eb4789b8c(p($223));
                })(function($224) {
                    return $65ae0a43a0950bac$export$c688766eb4789b8c(q($224));
                });
                return function($222) {
                    return $627093fb1ee74b6b$var$unwrap($221($222));
                };
            };
        };
    };
};






// Generated by purs version 0.15.15





var $d6d149fa89f1aabd$export$617c6d3c4831cc55 = function(x) {
    return x;
};
var $d6d149fa89f1aabd$export$c320d38647c61759 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Clown " + (show(v) + ")");
        }
    };
};
var $d6d149fa89f1aabd$export$62a719bb29c754ea = function(dictContravariant) {
    var cmap = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return {
        dimap: function(f) {
            return function(v) {
                return function(v1) {
                    return cmap(f)(v1);
                };
            };
        }
    };
};
var $d6d149fa89f1aabd$export$98046469085cbfc0 = function(dictOrd) {
    return dictOrd;
};
var $d6d149fa89f1aabd$export$4c876fa5e839e472 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d6d149fa89f1aabd$export$968b613baf9bea0a = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d6d149fa89f1aabd$export$a63b78c5190ed148 = {
    map: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d6d149fa89f1aabd$export$e11f6184161f7535 = function(dictEq) {
    return dictEq;
};
var $d6d149fa89f1aabd$export$49a3b6a3ac05d533 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        bimap: function(f) {
            return function(v) {
                return function(v1) {
                    return map(f)(v1);
                };
            };
        }
    };
};
var $d6d149fa89f1aabd$export$2e3be9fb35707fb9 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var bifunctorClown1 = $d6d149fa89f1aabd$export$49a3b6a3ac05d533(dictApply.Functor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorClown1;
        }
    };
};
var $d6d149fa89f1aabd$export$3bb380ca0409a138 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var biapplyClown1 = $d6d149fa89f1aabd$export$2e3be9fb35707fb9(dictApplicative.Apply0());
    return {
        bipure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Biapply0: function() {
            return biapplyClown1;
        }
    };
};


// Generated by purs version 0.15.15
// Generated by purs version 0.15.15
// Generated by purs version 0.15.15




var $6363af3298f653fe$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $6363af3298f653fe$export$10012d3bb776a59b = {
    biapply: function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0(v1.value0), v.value1(v1.value1));
        };
    },
    Bifunctor0: function() {
        return $20615e99b278adf5$export$34a2521cb7920188;
    }
};
var $6363af3298f653fe$export$6ff8eae0be34c22f = function(dict) {
    return dict.biapply;
};
var $6363af3298f653fe$export$ce80f032d535bf8c = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBiapply.Bifunctor0());
    return function(a) {
        return function(b) {
            return biapply1(bimap($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($6363af3298f653fe$var$identity))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($6363af3298f653fe$var$identity))(a))(b);
        };
    };
};
var $6363af3298f653fe$export$f0109f4e856ff51b = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBiapply.Bifunctor0());
    return function(a) {
        return function(b) {
            return biapply1(bimap($f57f4b701aa7b66e$export$5b38a098e5a9e7ca)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca)(a))(b);
        };
    };
};
var $6363af3298f653fe$export$abae8d500b299649 = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBiapply.Bifunctor0());
    return function(f) {
        return function(g) {
            return function(a) {
                return function(b) {
                    return biapply1(bimap(f)(g)(a))(b);
                };
            };
        };
    };
};
var $6363af3298f653fe$export$2f99c17ac3b747ef = function(dictBiapply) {
    var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBiapply.Bifunctor0());
    return function(f) {
        return function(g) {
            return function(a) {
                return function(b) {
                    return function(c) {
                        return biapply1(biapply1(bimap(f)(g)(a))(b))(c);
                    };
                };
            };
        };
    };
};



var $a92b99b22372f0f6$export$2a8f362ea9934c72 = function(dict) {
    return dict.bipure;
};
var $a92b99b22372f0f6$export$9a37246915e03f77 = /* #__PURE__ */ function() {
    return {
        bipure: $71f2e2e9476163f8$export$1908877435b1d5e9.create,
        Biapply0: function() {
            return $6363af3298f653fe$export$10012d3bb776a59b;
        }
    };
}();








var $de250e9a855a8821$export$4d2fae537bd90431 = function(x) {
    return x;
};
var $de250e9a855a8821$export$29291423364aa70c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Flip " + (show(v) + ")");
        }
    };
};
var $de250e9a855a8821$export$4ae6be85993247fc = function(dictSemigroupoid) {
    var compose = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return {
        compose: function(v) {
            return function(v1) {
                return compose(v1)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$175d7b12ce1db076 = function(dictOrd) {
    return dictOrd;
};
var $de250e9a855a8821$export$a74ebf4492f31698 = {
    Coercible0: function() {
        return undefined;
    }
};
var $de250e9a855a8821$export$663e27a09bebb78f = function(dictBifunctor) {
    var lmap = $20615e99b278adf5$export$2ad466be2e2b0196(dictBifunctor);
    return {
        map: function(f) {
            return function(v) {
                return lmap(f)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$ffc04081e45d2595 = function(dictEq) {
    return dictEq;
};
var $de250e9a855a8821$export$621a9013f7700922 = function(dictProfunctor) {
    var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(dictProfunctor);
    return {
        cmap: function(f) {
            return function(v) {
                return lcmap(f)(v);
            };
        }
    };
};
var $de250e9a855a8821$export$8edc16d54231bba5 = function(dictCategory) {
    var semigroupoidFlip1 = $de250e9a855a8821$export$4ae6be85993247fc(dictCategory.Semigroupoid0());
    return {
        identity: $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory),
        Semigroupoid0: function() {
            return semigroupoidFlip1;
        }
    };
};
var $de250e9a855a8821$export$3cb4e79429911677 = function(dictBifunctor) {
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    return bimap(g)(f)(v);
                };
            };
        }
    };
};
var $de250e9a855a8821$export$5ff98b746a3df330 = function(dictBiapply) {
    var biapply = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bifunctorFlip1 = $de250e9a855a8821$export$3cb4e79429911677(dictBiapply.Bifunctor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return biapply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorFlip1;
        }
    };
};
var $de250e9a855a8821$export$f4fd609408b6b321 = function(dictBiapplicative) {
    var bipure = $a92b99b22372f0f6$export$2a8f362ea9934c72(dictBiapplicative);
    var biapplyFlip1 = $de250e9a855a8821$export$5ff98b746a3df330(dictBiapplicative.Biapply0());
    return {
        bipure: function(a) {
            return function(b) {
                return bipure(b)(a);
            };
        },
        Biapply0: function() {
            return biapplyFlip1;
        }
    };
};


// Generated by purs version 0.15.15







var $f78f43f57784c3b0$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $f78f43f57784c3b0$export$6aabc6925447f4b0 = function(x) {
    return x;
};
var $f78f43f57784c3b0$export$b4ec34c7248171a7 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Joker " + (show(v) + ")");
        }
    };
};
var $f78f43f57784c3b0$export$452aa45645295937 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(v) {
            return function(g) {
                return function(v1) {
                    return map(g)(v1);
                };
            };
        }
    };
};
var $f78f43f57784c3b0$export$ced2a20c0b18b37d = function(dictOrd) {
    return dictOrd;
};
var $f78f43f57784c3b0$export$89da6ea6949743c = {
    Coercible0: function() {
        return undefined;
    }
};
var $f78f43f57784c3b0$export$391d641ca6d60218 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $f78f43f57784c3b0$export$f3932b67dd828010 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map(f)(v);
            };
        }
    };
};
var $f78f43f57784c3b0$export$c3be8193cff8c2a1 = function(dictEq) {
    return dictEq;
};
var $f78f43f57784c3b0$export$61eb042f0a783df2 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorJoker1 = $f78f43f57784c3b0$export$452aa45645295937(dictFunctor);
    return {
        left: function(v) {
            return map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(v);
        },
        right: function(v) {
            return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v);
        },
        Profunctor0: function() {
            return profunctorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$fef3ae072f671f73 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        bimap: function(v) {
            return function(g) {
                return function(v1) {
                    return map(g)(v1);
                };
            };
        }
    };
};
var $f78f43f57784c3b0$export$45bd288b70d866e3 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var bifunctorJoker1 = $f78f43f57784c3b0$export$fef3ae072f671f73(dictApply.Functor0());
    return {
        biapply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Bifunctor0: function() {
            return bifunctorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$9f071db006f4d6df = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var biapplyJoker1 = $f78f43f57784c3b0$export$45bd288b70d866e3(dictApplicative.Apply0());
    return {
        bipure: function(v) {
            return function(b) {
                return pure(b);
            };
        },
        Biapply0: function() {
            return biapplyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$ea793751a641ee88 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorJoker1 = $f78f43f57784c3b0$export$f3932b67dd828010(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return apply(v)(v1);
            };
        },
        Functor0: function() {
            return functorJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$aeee4b79ac977d96 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyJoker1 = $f78f43f57784c3b0$export$ea793751a641ee88(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(amb) {
                return bind(v)(function() {
                    var $76 = $f78f43f57784c3b0$var$un($f78f43f57784c3b0$export$6aabc6925447f4b0);
                    return function($77) {
                        return $76(amb($77));
                    };
                }());
            };
        },
        Apply0: function() {
            return applyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$eb740e16f1c502d6 = function(dictApplicative) {
    var applyJoker1 = $f78f43f57784c3b0$export$ea793751a641ee88(dictApplicative.Apply0());
    return {
        pure: function() {
            var $78 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($79) {
                return $f78f43f57784c3b0$export$6aabc6925447f4b0($78($79));
            };
        }(),
        Apply0: function() {
            return applyJoker1;
        }
    };
};
var $f78f43f57784c3b0$export$c73a19238155f37d = function(dictMonad) {
    var applicativeJoker1 = $f78f43f57784c3b0$export$eb740e16f1c502d6(dictMonad.Applicative0());
    var bindJoker1 = $f78f43f57784c3b0$export$aeee4b79ac977d96(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeJoker1;
        },
        Bind1: function() {
            return bindJoker1;
        }
    };
};


// Generated by purs version 0.15.15









var $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c = /* #__PURE__ */ function() {
    function Product2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product2.create = function(value0) {
        return function(value1) {
            return new Product2(value0, value1);
        };
    };
    return Product2;
}();
var $fcbd98bdf4ceeb9f$export$6c093255e90d22dc = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Product2 " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$5f8c2a3cf153d402 = function(dictProfunctor) {
    var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(dictProfunctor1) {
        var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor1);
        return {
            dimap: function(f) {
                return function(g) {
                    return function(v) {
                        return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(dimap(f)(g)(v.value0), dimap1(f)(g)(v.value1));
                    };
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$df18121261f4a19e = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(map(f)(v.value0), map1(f)(v.value1));
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$a9ce93700a5c7167 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$3df4cac97292b80b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqProduct21 = $fcbd98bdf4ceeb9f$export$a9ce93700a5c7167(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqProduct22 = eqProduct21(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqProduct22;
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$61e154f74ad4267e = function(dictBifunctor) {
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return function(dictBifunctor1) {
        var bimap1 = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor1);
        return {
            bimap: function(f) {
                return function(g) {
                    return function(v) {
                        return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(bimap(f)(g)(v.value0), bimap1(f)(g)(v.value1));
                    };
                };
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$682ecf1e69af4477 = function(dictBiapply) {
    var biapply = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply);
    var bifunctorProduct21 = $fcbd98bdf4ceeb9f$export$61e154f74ad4267e(dictBiapply.Bifunctor0());
    return function(dictBiapply1) {
        var biapply1 = $6363af3298f653fe$export$6ff8eae0be34c22f(dictBiapply1);
        var bifunctorProduct22 = bifunctorProduct21(dictBiapply1.Bifunctor0());
        return {
            biapply: function(v) {
                return function(v1) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(biapply(v.value0)(v1.value0), biapply1(v.value1)(v1.value1));
                };
            },
            Bifunctor0: function() {
                return bifunctorProduct22;
            }
        };
    };
};
var $fcbd98bdf4ceeb9f$export$439f710a1c8c1d51 = function(dictBiapplicative) {
    var bipure = $a92b99b22372f0f6$export$2a8f362ea9934c72(dictBiapplicative);
    var biapplyProduct21 = $fcbd98bdf4ceeb9f$export$682ecf1e69af4477(dictBiapplicative.Biapply0());
    return function(dictBiapplicative1) {
        var bipure1 = $a92b99b22372f0f6$export$2a8f362ea9934c72(dictBiapplicative1);
        var biapplyProduct22 = biapplyProduct21(dictBiapplicative1.Biapply0());
        return {
            bipure: function(a) {
                return function(b) {
                    return new $fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c(bipure(a)(b), bipure1(a)(b));
                };
            },
            Biapply0: function() {
                return biapplyProduct22;
            }
        };
    };
};




var $efac99db7971f271$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $efac99db7971f271$export$f664b6bec32af3f2 = function(dict) {
    return dict.bitraverse;
};
var $efac99db7971f271$export$4bdf9ec3e0ef1266 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(t) {
            return function(f) {
                return bitraverse2(f)(pure)(t);
            };
        };
    };
};
var $efac99db7971f271$export$4a1651cd8fd555cf = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return bitraverse2(f)(pure);
        };
    };
};
var $efac99db7971f271$export$e0fb30cfec67a969 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(t) {
            return function(f) {
                return bitraverse2(pure)(f)(t);
            };
        };
    };
};
var $efac99db7971f271$export$6f921142225b4cb1 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        return bitraverse1(dictApplicative)($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative));
    };
};
var $efac99db7971f271$export$b0be3b32fab47d0a = {
    bitraverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            return function(g) {
                return function(v) {
                    return apply(map($71f2e2e9476163f8$export$1908877435b1d5e9.create)(f(v.value0)))(g(v.value1));
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            return apply(map($71f2e2e9476163f8$export$1908877435b1d5e9.create)(v.value0))(v.value1);
        };
    },
    Bifunctor0: function() {
        return $20615e99b278adf5$export$34a2521cb7920188;
    },
    Bifoldable1: function() {
        return $627093fb1ee74b6b$export$9e57ed04fa06006f;
    }
};
var $efac99db7971f271$export$5c615a3bd82f83ea = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var bifunctorJoker = $f78f43f57784c3b0$export$fef3ae072f671f73(dictTraversable.Functor0());
    var bifoldableJoker = $627093fb1ee74b6b$export$3ea37b6c505d5921(dictTraversable.Foldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(v) {
                return function(r) {
                    return function(v1) {
                        return map($f78f43f57784c3b0$export$6aabc6925447f4b0)(traverse1(r)(v1));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return map($f78f43f57784c3b0$export$6aabc6925447f4b0)(sequence1(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorJoker;
        },
        Bifoldable1: function() {
            return bifoldableJoker;
        }
    };
};
var $efac99db7971f271$export$d5985330978d0d8e = {
    bitraverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(v(v2.value0));
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v1(v2.value0));
                    throw new Error("Failed pattern match at Data.Bitraversable (line 57, column 1 - line 61, column 37): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value0);
            throw new Error("Failed pattern match at Data.Bitraversable (line 57, column 1 - line 61, column 37): " + [
                v.constructor.name
            ]);
        };
    },
    Bifunctor0: function() {
        return $20615e99b278adf5$export$9b66d4861c364eff;
    },
    Bifoldable1: function() {
        return $627093fb1ee74b6b$export$631c798dd7783874;
    }
};
var $efac99db7971f271$export$f03ce3e5a761332f = {
    bitraverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return function(v1) {
                    return map($10ae0394c8c3139a$export$8ad5d15375e29446)(f(v1));
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($10ae0394c8c3139a$export$8ad5d15375e29446)(v);
        };
    },
    Bifunctor0: function() {
        return $20615e99b278adf5$export$52f77c2cc8ef8f31;
    },
    Bifoldable1: function() {
        return $627093fb1ee74b6b$export$fac7dcf8414b1558;
    }
};
var $efac99db7971f271$export$69b7519c34a78b72 = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var bifunctorClown = $d6d149fa89f1aabd$export$49a3b6a3ac05d533(dictTraversable.Functor0());
    var bifoldableClown = $627093fb1ee74b6b$export$48d6bd28fb1f7b98(dictTraversable.Foldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(l) {
                return function(v) {
                    return function(v1) {
                        return map($d6d149fa89f1aabd$export$617c6d3c4831cc55)(traverse1(l)(v1));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return map($d6d149fa89f1aabd$export$617c6d3c4831cc55)(sequence1(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorClown;
        },
        Bifoldable1: function() {
            return bifoldableClown;
        }
    };
};
var $efac99db7971f271$export$b907c0867bacb762 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        return bitraverse1(dictApplicative)($efac99db7971f271$var$identity)($efac99db7971f271$var$identity);
    };
};
var $efac99db7971f271$export$105dc78ebd8ad704 = function(dict) {
    return dict.bisequence;
};
var $efac99db7971f271$export$763d9827b6839c7a = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bifunctorFlip = $de250e9a855a8821$export$3cb4e79429911677(dictBitraversable.Bifunctor0());
    var bifoldableFlip = $627093fb1ee74b6b$export$83ed5690f1f40b8b(dictBitraversable.Bifoldable1());
    return {
        bitraverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var bitraverse2 = bitraverse1(dictApplicative);
            return function(r) {
                return function(l) {
                    return function(v) {
                        return map($de250e9a855a8821$export$4d2fae537bd90431)(bitraverse2(l)(r)(v));
                    };
                };
            };
        },
        bisequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var bisequence2 = bisequence1(dictApplicative);
            return function(v) {
                return map($de250e9a855a8821$export$4d2fae537bd90431)(bisequence2(v));
            };
        },
        Bifunctor0: function() {
            return bifunctorFlip;
        },
        Bifoldable1: function() {
            return bifoldableFlip;
        }
    };
};
var $efac99db7971f271$export$6e4c0387ddae9c26 = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bifunctorProduct2 = $fcbd98bdf4ceeb9f$export$61e154f74ad4267e(dictBitraversable.Bifunctor0());
    var bifoldableProduct2 = $627093fb1ee74b6b$export$15009c29dbef42b7(dictBitraversable.Bifoldable1());
    return function(dictBitraversable1) {
        var bitraverse2 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable1);
        var bisequence2 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable1);
        var bifunctorProduct21 = bifunctorProduct2(dictBitraversable1.Bifunctor0());
        var bifoldableProduct21 = bifoldableProduct2(dictBitraversable1.Bifoldable1());
        return {
            bitraverse: function(dictApplicative) {
                var Apply0 = dictApplicative.Apply0();
                var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
                var bitraverse3 = bitraverse1(dictApplicative);
                var bitraverse4 = bitraverse2(dictApplicative);
                return function(l) {
                    return function(r) {
                        return function(v) {
                            return apply(map($fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c.create)(bitraverse3(l)(r)(v.value0)))(bitraverse4(l)(r)(v.value1));
                        };
                    };
                };
            },
            bisequence: function(dictApplicative) {
                var Apply0 = dictApplicative.Apply0();
                var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
                var bisequence3 = bisequence1(dictApplicative);
                var bisequence4 = bisequence2(dictApplicative);
                return function(v) {
                    return apply(map($fcbd98bdf4ceeb9f$export$ad5a88bb6a2c931c.create)(bisequence3(v.value0)))(bisequence4(v.value1));
                };
            },
            Bifunctor0: function() {
                return bifunctorProduct21;
            },
            Bifoldable1: function() {
                return bifoldableProduct21;
            }
        };
    };
};
var $efac99db7971f271$export$4fc918b93696de0e = function(dictBitraversable) {
    var bisequence1 = $efac99db7971f271$export$105dc78ebd8ad704(dictBitraversable);
    var bimap = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBitraversable.Bifunctor0());
    return function(dictApplicative) {
        var bisequence2 = bisequence1(dictApplicative);
        return function(f) {
            return function(g) {
                return function(t) {
                    return bisequence2(bimap(f)(g)(t));
                };
            };
        };
    };
};
var $efac99db7971f271$export$864c03cc95ff0e3b = function(dictBitraversable) {
    var bitraverse1 = $efac99db7971f271$export$f664b6bec32af3f2(dictBitraversable);
    return function(dictApplicative) {
        var bitraverse2 = bitraverse1(dictApplicative);
        return function(t) {
            return function(f) {
                return function(g) {
                    return bitraverse2(f)(g)(t);
                };
            };
        };
    };
};













var $40b881c663abaa3d$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $40b881c663abaa3d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $40b881c663abaa3d$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $40b881c663abaa3d$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $40b881c663abaa3d$export$fd98f31541acd35d = /* #__PURE__ */ function() {
    function This(value0) {
        this.value0 = value0;
    }
    This.create = function(value0) {
        return new This(value0);
    };
    return This;
}();
var $40b881c663abaa3d$export$ede717b1aa59264f = /* #__PURE__ */ function() {
    function That(value0) {
        this.value0 = value0;
    }
    That.create = function(value0) {
        return new That(value0);
    };
    return That;
}();
var $40b881c663abaa3d$export$d91d8a092b6c59d3 = /* #__PURE__ */ function() {
    function Both(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Both.create = function(value0) {
        return function(value1) {
            return new Both(value0, value1);
        };
    };
    return Both;
}();
var $40b881c663abaa3d$export$39c6a2e0e2af12a4 = function(v) {
    return function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $40b881c663abaa3d$export$fd98f31541acd35d(v);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v, v1.value0);
        throw new Error("Failed pattern match at Data.These (line 110, column 1 - line 110, column 52): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $40b881c663abaa3d$export$a118e840177d1324 = function(v) {
    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $40b881c663abaa3d$export$6d4b77a375512c2 = function(v) {
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $40b881c663abaa3d$export$a1db1ff5ddf41328 = function(v) {
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $40b881c663abaa3d$export$c181e1b18f331e8c = function(v) {
    return function(v1) {
        return function(v2) {
            return function(v3) {
                if (v3 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return v(v3.value0);
                if (v3 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return v1(v3.value0);
                if (v3 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return v2(v3.value0)(v3.value1);
                throw new Error("Failed pattern match at Data.These (line 105, column 1 - line 105, column 79): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name,
                    v3.constructor.name
                ]);
            };
        };
    };
};
var $40b881c663abaa3d$export$16b829d0619dc98e = function(v) {
    return function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $40b881c663abaa3d$export$ede717b1aa59264f(v);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v1.value0, v);
        throw new Error("Failed pattern match at Data.These (line 114, column 1 - line 114, column 52): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $40b881c663abaa3d$export$249c7d9e163e8239 = function(v) {
    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $40b881c663abaa3d$export$b0e76d9850c64156 = /* #__PURE__ */ function() {
    return $40b881c663abaa3d$export$c181e1b18f331e8c($40b881c663abaa3d$export$ede717b1aa59264f.create)($40b881c663abaa3d$export$fd98f31541acd35d.create)($f57f4b701aa7b66e$export$8a83211c878a3f1f($40b881c663abaa3d$export$d91d8a092b6c59d3.create));
}();
var $40b881c663abaa3d$export$428f0a2e7552746a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return "(This " + (show(v.value0) + ")");
                if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return "(That " + (show1(v.value0) + ")");
                if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return "(Both " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
                throw new Error("Failed pattern match at Data.These (line 98, column 1 - line 101, column 63): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $40b881c663abaa3d$export$2f3ef9f44002786f = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(append1(v.value0)(v1.value0));
                    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0, v1.value0);
                    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(append1(v.value0)(v1.value0), v1.value1);
                    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v1.value0, v.value0);
                    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(append2(v.value0)(v1.value0));
                    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v1.value0, append2(v.value0)(v1.value1));
                    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(append1(v.value0)(v1.value0), v.value1);
                    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0, append2(v.value1)(v1.value0));
                    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                    throw new Error("Failed pattern match at Data.These (line 23, column 1 - line 32, column 56): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            }
        };
    };
};
var $40b881c663abaa3d$export$a3c9299f334f427a = function(v) {
    return function(v1) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$ede717b1aa59264f(v1.value0));
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0, v1.value0));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.These (line 120, column 14 - line 124, column 30): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $40b881c663abaa3d$export$60b718ee0855c009 = function($308) {
    return $06733ae99ed4f534$export$c15bd07a493e1236($40b881c663abaa3d$export$a118e840177d1324($308));
};
var $40b881c663abaa3d$export$45ca171e796965bc = function($309) {
    return $06733ae99ed4f534$export$c15bd07a493e1236($40b881c663abaa3d$export$249c7d9e163e8239($309));
};
var $40b881c663abaa3d$export$c8bd2478d1c66774 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v1.value0, v(v1.value1));
            if (v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(v(v1.value0));
            if (v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v1.value0);
            throw new Error("Failed pattern match at Data.These (line 34, column 1 - line 37, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $40b881c663abaa3d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($40b881c663abaa3d$export$c8bd2478d1c66774);
var $40b881c663abaa3d$export$f92ec6556ef002f5 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($40b881c663abaa3d$export$c8bd2478d1c66774)
};
var $40b881c663abaa3d$export$7ece24ad37202c55 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0, v1);
            if (v2 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, v2.value0);
            if (v2 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0, v2.value1);
            throw new Error("Failed pattern match at Data.These (line 130, column 1 - line 130, column 58): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $40b881c663abaa3d$export$23a2cab0e36a432d = {
    foldr: function(f) {
        return function(z) {
            var $310 = $40b881c663abaa3d$var$foldr(f)(z);
            return function($311) {
                return $310($40b881c663abaa3d$export$6d4b77a375512c2($311));
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            var $312 = $40b881c663abaa3d$var$foldl(f)(z);
            return function($313) {
                return $312($40b881c663abaa3d$export$6d4b77a375512c2($313));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $40b881c663abaa3d$var$foldMap(dictMonoid);
        return function(f) {
            var $314 = foldMap1(f);
            return function($315) {
                return $314($40b881c663abaa3d$export$6d4b77a375512c2($315));
            };
        };
    }
};
var $40b881c663abaa3d$export$adeed7ff9423136c = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return pure(new $40b881c663abaa3d$export$fd98f31541acd35d(v1.value0));
                if (v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return map1($40b881c663abaa3d$export$ede717b1aa59264f.create)(v(v1.value0));
                if (v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return map1($40b881c663abaa3d$export$d91d8a092b6c59d3.create(v1.value0))(v(v1.value1));
                throw new Error("Failed pattern match at Data.These (line 47, column 1 - line 53, column 37): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return pure(new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0));
            if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return map1($40b881c663abaa3d$export$ede717b1aa59264f.create)(v.value0);
            if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return map1($40b881c663abaa3d$export$d91d8a092b6c59d3.create(v.value0))(v.value1);
            throw new Error("Failed pattern match at Data.These (line 47, column 1 - line 53, column 37): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $40b881c663abaa3d$export$c8bd2478d1c66774;
    },
    Foldable1: function() {
        return $40b881c663abaa3d$export$23a2cab0e36a432d;
    }
};
var $40b881c663abaa3d$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v1.value0);
            return $40b881c663abaa3d$var$map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v(v1)))(v1);
        };
    },
    Functor0: function() {
        return $40b881c663abaa3d$export$c8bd2478d1c66774;
    }
};
var $40b881c663abaa3d$export$398f7d8c6e232fe2 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $40b881c663abaa3d$export$fd98f31541acd35d && y instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return eq(x.value0)(y.value0);
                    if (x instanceof $40b881c663abaa3d$export$ede717b1aa59264f && y instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return eq1(x.value0)(y.value0);
                    if (x instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && y instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                    return false;
                };
            }
        };
    };
};
var $40b881c663abaa3d$export$8f635747586ce15 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqThese1 = $40b881c663abaa3d$export$398f7d8c6e232fe2(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqThese2 = eqThese1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $40b881c663abaa3d$export$fd98f31541acd35d && y instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return compare(x.value0)(y.value0);
                    if (x instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (y instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (x instanceof $40b881c663abaa3d$export$ede717b1aa59264f && y instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return compare1(x.value0)(y.value0);
                    if (x instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (y instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (x instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && y instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) {
                        var v = compare(x.value0)(y.value0);
                        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        return compare1(x.value1)(y.value1);
                    }
                    throw new Error("Failed pattern match at Data.These (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqThese2;
            }
        };
    };
};
var $40b881c663abaa3d$export$807cb1ad79a6419b = function(v) {
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, v.value1));
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $40b881c663abaa3d$export$a2890fe62798b262 = function($316) {
    return $06733ae99ed4f534$export$c15bd07a493e1236($40b881c663abaa3d$export$807cb1ad79a6419b($316));
};
var $40b881c663abaa3d$export$748ed80770dd64f9 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v(v2.value0));
                if (v2 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(v1(v2.value0));
                if (v2 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v(v2.value0), v1(v2.value1));
                throw new Error("Failed pattern match at Data.These (line 55, column 1 - line 58, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $40b881c663abaa3d$export$cb4265e670894dc0 = {
    bifoldr: function(f) {
        return function(g) {
            return function(z) {
                return $40b881c663abaa3d$export$c181e1b18f331e8c(function(v) {
                    return f(v)(z);
                })(function(v) {
                    return g(v)(z);
                })(function(x) {
                    return function(y) {
                        return f(x)(g(y)(z));
                    };
                });
            };
        };
    },
    bifoldl: function(f) {
        return function(g) {
            return function(z) {
                return $40b881c663abaa3d$export$c181e1b18f331e8c(function(v) {
                    return f(z)(v);
                })(function(v) {
                    return g(z)(v);
                })(function(x) {
                    return function(y) {
                        return g(f(z)(x))(y);
                    };
                });
            };
        };
    },
    bifoldMap: function(dictMonoid) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            return function(g) {
                return $40b881c663abaa3d$export$c181e1b18f331e8c(f)(g)(function(x) {
                    return function(y) {
                        return append1(f(x))(g(y));
                    };
                });
            };
        };
    }
};
var $40b881c663abaa3d$export$339fbce01a478d00 = {
    bitraverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return map1($40b881c663abaa3d$export$fd98f31541acd35d.create)(v(v2.value0));
                    if (v2 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return map1($40b881c663abaa3d$export$ede717b1aa59264f.create)(v1(v2.value0));
                    if (v2 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return apply(map1($40b881c663abaa3d$export$d91d8a092b6c59d3.create)(v(v2.value0)))(v1(v2.value1));
                    throw new Error("Failed pattern match at Data.These (line 65, column 1 - line 69, column 44): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    },
    bisequence: function(dictApplicative) {
        return $efac99db7971f271$export$f664b6bec32af3f2($40b881c663abaa3d$export$339fbce01a478d00)(dictApplicative)($40b881c663abaa3d$var$identity)($40b881c663abaa3d$var$identity);
    },
    Bifunctor0: function() {
        return $40b881c663abaa3d$export$748ed80770dd64f9;
    },
    Bifoldable1: function() {
        return $40b881c663abaa3d$export$cb4265e670894dc0;
    }
};
var $40b881c663abaa3d$export$3f4996019e520711 = function(v) {
    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v.value0 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0.value0);
    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v.value0 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0.value0));
    if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d && v.value0 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0.value0, new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0.value1));
    if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(new $40b881c663abaa3d$export$ede717b1aa59264f(v.value0));
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v.value0 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0.value0, new $40b881c663abaa3d$export$ede717b1aa59264f(v.value1));
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v.value0 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0.value0, v.value1));
    if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v.value0 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0.value0, new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0.value1, v.value1));
    throw new Error("Failed pattern match at Data.These (line 184, column 9 - line 191, column 41): " + [
        v.constructor.name
    ]);
};
var $40b881c663abaa3d$export$d3ab3321df553420 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0);
                if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v1.value0);
                if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$ede717b1aa59264f(v.value0(v1.value0));
                if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f && v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v1.value0, v.value0(v1.value1));
                if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(append1(v.value0)(v1.value0));
                if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0, v.value1(v1.value0));
                if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3 && v1 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(append1(v.value0)(v1.value0), v.value1(v1.value1));
                throw new Error("Failed pattern match at Data.These (line 71, column 1 - line 78, column 52): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return $40b881c663abaa3d$export$c8bd2478d1c66774;
        }
    };
};
var $40b881c663abaa3d$export$70cd680158191f49 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyThese1 = $40b881c663abaa3d$export$d3ab3321df553420(dictSemigroup);
    return {
        bind: function(v) {
            return function(v1) {
                if (v instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(v.value0);
                if (v instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return v1(v.value0);
                if (v instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) {
                    var v2 = v1(v.value1);
                    if (v2 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return new $40b881c663abaa3d$export$fd98f31541acd35d(append1(v.value0)(v2.value0));
                    if (v2 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(v.value0, v2.value0);
                    if (v2 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return new $40b881c663abaa3d$export$d91d8a092b6c59d3(append1(v.value0)(v2.value0), v2.value1);
                    throw new Error("Failed pattern match at Data.These (line 87, column 5 - line 90, column 34): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.These (line 83, column 1 - line 90, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        Apply0: function() {
            return applyThese1;
        }
    };
};
var $40b881c663abaa3d$export$7f18746567fff2ed = function(dictSemigroup) {
    var applyThese1 = $40b881c663abaa3d$export$d3ab3321df553420(dictSemigroup);
    return {
        pure: $40b881c663abaa3d$export$ede717b1aa59264f.create,
        Apply0: function() {
            return applyThese1;
        }
    };
};
var $40b881c663abaa3d$export$8da744b036e759bd = function(dictSemigroup) {
    var applicativeThese1 = $40b881c663abaa3d$export$7f18746567fff2ed(dictSemigroup);
    var bindThese1 = $40b881c663abaa3d$export$70cd680158191f49(dictSemigroup);
    return {
        Applicative0: function() {
            return applicativeThese1;
        },
        Bind1: function() {
            return bindThese1;
        }
    };
};





// Generated by purs version 0.15.15




















// Generated by purs version 0.15.15
const $80594d6a65468c7b$export$739ec22334c44788 = function(separator) {
    return function(xs) {
        return xs.join(separator);
    };
};







var $544b62a378cc0091$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $544b62a378cc0091$export$f7ad98836d6849e8 = {
    genericShowArgs: function(v) {
        return [];
    }
};
var $544b62a378cc0091$export$bc1180ef96fcb658 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        genericShowArgs: function(v) {
            return [
                show(v)
            ];
        }
    };
};
var $544b62a378cc0091$export$13bb3b5ea79b5fe6 = function(dict) {
    return dict.genericShowArgs;
};
var $544b62a378cc0091$export$b8b972500eedbc74 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictGenericShowArgs1) {
        var genericShowArgs2 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs1);
        return {
            genericShowArgs: function(v) {
                return $544b62a378cc0091$var$append(genericShowArgs1(v.value0))(genericShowArgs2(v.value1));
            }
        };
    };
};
var $544b62a378cc0091$export$186afff91b813845 = function(dictGenericShowArgs) {
    var genericShowArgs1 = $544b62a378cc0091$export$13bb3b5ea79b5fe6(dictGenericShowArgs);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return {
            "genericShow'": function(v) {
                var ctor = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                var v1 = genericShowArgs1(v);
                if (v1.length === 0) return ctor;
                return "(" + ($80594d6a65468c7b$export$739ec22334c44788(" ")($544b62a378cc0091$var$append([
                    ctor
                ])(v1)) + ")");
            }
        };
    };
};
var $544b62a378cc0091$export$c357439213aef314 = function(dict) {
    return dict["genericShow'"];
};
var $544b62a378cc0091$export$385ce500412a77a5 = {
    "genericShow'": function(a) {
        return $544b62a378cc0091$export$c357439213aef314($544b62a378cc0091$export$385ce500412a77a5)(a);
    }
};
var $544b62a378cc0091$export$29d77e0cd7b7a3b8 = function(dictGenericShow) {
    var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
    return function(dictGenericShow1) {
        var genericShow$prime2 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow1);
        return {
            "genericShow'": function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return genericShow$prime1(v.value0);
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return genericShow$prime2(v.value0);
                throw new Error("Failed pattern match at Data.Show.Generic (line 26, column 1 - line 28, column 40): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $544b62a378cc0091$export$dc29b8461849edae = function(dictGeneric) {
    var from = $91c996e9c07e3b3f$export$6788812c4e6611e6(dictGeneric);
    return function(dictGenericShow) {
        var genericShow$prime1 = $544b62a378cc0091$export$c357439213aef314(dictGenericShow);
        return function(x) {
            return genericShow$prime1(from(x));
        };
    };
};




var $2b6d012b5a71a466$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2b6d012b5a71a466$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $2b6d012b5a71a466$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $2b6d012b5a71a466$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $2b6d012b5a71a466$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $2b6d012b5a71a466$export$13807d9ee5a34a42 = function(x) {
    return x;
};
var $2b6d012b5a71a466$export$c791339539b80010 = /* #__PURE__ */ function() {
    function ParseState(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ParseState.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ParseState(value0, value1, value2);
            };
        };
    };
    return ParseState;
}();
var $2b6d012b5a71a466$export$f9c837a54db411d = /* #__PURE__ */ function() {
    function ParseError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ParseError.create = function(value0) {
        return function(value1) {
            return new ParseError(value0, value1);
        };
    };
    return ParseError;
}();
var $2b6d012b5a71a466$export$9a8df86115a1646c = function(x) {
    return x;
};
var $2b6d012b5a71a466$var$More = /* #__PURE__ */ function() {
    function More(value0) {
        this.value0 = value0;
    }
    More.create = function(value0) {
        return new More(value0);
    };
    return More;
}();
var $2b6d012b5a71a466$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $2b6d012b5a71a466$var$Stop = /* #__PURE__ */ function() {
    function Stop(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Stop.create = function(value0) {
        return function(value1) {
            return new Stop(value0, value1);
        };
    };
    return Stop;
}();
var $2b6d012b5a71a466$export$61e09139d046f494 = {
    lift: function(dictMonad) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
        return function(m) {
            return function(state1, v, lift$prime, v1, done) {
                return lift$prime(map(function(a) {
                    return function(v2) {
                        return done(state1, a);
                    };
                })(m));
            };
        };
    }
};
var $2b6d012b5a71a466$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($2b6d012b5a71a466$export$61e09139d046f494);
var $2b6d012b5a71a466$export$e21af47273e843bd = {
    defer: function(f) {
        var m = $99af8ad7682e39c7$export$260e5c0943f31606(f);
        return function(state1, more, lift1, $$throw, done) {
            var v = $99af8ad7682e39c7$export$4d82290515cd0ddb(m);
            return v(state1, more, lift1, $$throw, done);
        };
    }
};
var $2b6d012b5a71a466$export$11f7f1f26222322b = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $2b6d012b5a71a466$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($2b6d012b5a71a466$export$11f7f1f26222322b)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "column";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "index";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "line";
    }
})($2c6b3d51d10471a7$export$3d7cf516d27998a0))($2c6b3d51d10471a7$export$3d7cf516d27998a0))($2c6b3d51d10471a7$export$3d7cf516d27998a0))))({
    reflectSymbol: function() {
        return "Position";
    }
}));
var $2b6d012b5a71a466$export$f8dfc55d5069b2 = {
    show: function(x) {
        return $2b6d012b5a71a466$var$genericShow(x);
    }
};
var $2b6d012b5a71a466$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2b6d012b5a71a466$export$f8dfc55d5069b2);
var $2b6d012b5a71a466$export$858eabc7228a4f5b = {
    map: function(f) {
        return function(v) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, $$throw, function(state2, a) {
                        return more(function(v2) {
                            return done(state2, f(a));
                        });
                    });
                });
            };
        };
    }
};
var $2b6d012b5a71a466$export$364314875de70a73 = {
    eq: function(v) {
        return function(v1) {
            return v.index === v1.index;
        };
    }
};
var $2b6d012b5a71a466$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2b6d012b5a71a466$export$364314875de70a73);
var $2b6d012b5a71a466$export$a1b20bb8f2712ebf = {
    compare: function(v) {
        return function(v1) {
            return $2b6d012b5a71a466$var$compare(v.index)(v1.index);
        };
    },
    Eq0: function() {
        return $2b6d012b5a71a466$export$364314875de70a73;
    }
};
var $2b6d012b5a71a466$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($2b6d012b5a71a466$export$a1b20bb8f2712ebf);
var $2b6d012b5a71a466$export$8808000bb50bc47 = {
    apply: function(v) {
        return function(v1) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v2) {
                    return v(state1, more, lift1, $$throw, function(state2, f) {
                        return more(function(v3) {
                            return v1(state2, more, lift1, $$throw, function(state3, a) {
                                return more(function(v4) {
                                    return done(state3, f(a));
                                });
                            });
                        });
                    });
                });
            };
        };
    },
    Functor0: function() {
        return $2b6d012b5a71a466$export$858eabc7228a4f5b;
    }
};
var $2b6d012b5a71a466$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($2b6d012b5a71a466$export$8808000bb50bc47);
var $2b6d012b5a71a466$export$d3d664fa4d5a96c6 = {
    bind: function(v) {
        return function(next) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, $$throw, function(state2, a) {
                        return more(function(v2) {
                            var v3 = next(a);
                            return v3(state2, more, lift1, $$throw, done);
                        });
                    });
                });
            };
        };
    },
    Apply0: function() {
        return $2b6d012b5a71a466$export$8808000bb50bc47;
    }
};
var $2b6d012b5a71a466$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $2b6d012b5a71a466$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $2b6d012b5a71a466$export$32bd52aa0d2a958d = function(dictSemigroup) {
    return {
        append: $2b6d012b5a71a466$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $2b6d012b5a71a466$export$a80a9dff0c4321f9 = {
    pure: function(a) {
        return function(state1, v, v1, v2, done) {
            return done(state1, a);
        };
    },
    Apply0: function() {
        return $2b6d012b5a71a466$export$8808000bb50bc47;
    }
};
var $2b6d012b5a71a466$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $2b6d012b5a71a466$export$50fcd154ffbb53ba = {
    Applicative0: function() {
        return $2b6d012b5a71a466$export$a80a9dff0c4321f9;
    },
    Bind1: function() {
        return $2b6d012b5a71a466$export$d3d664fa4d5a96c6;
    }
};
var $2b6d012b5a71a466$export$cb0672d40d811a96 = function(dictMonadAsk) {
    return {
        ask: $2b6d012b5a71a466$var$lift(dictMonadAsk.Monad0())($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
        }
    };
};
var $2b6d012b5a71a466$export$ecce73bba72cc5 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskParserT1 = $2b6d012b5a71a466$export$cb0672d40d811a96(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return function(v) {
                return function(state1, more, lift1, $$throw, done) {
                    return v(state1, more, function() {
                        var $279 = local(f);
                        return function($280) {
                            return lift1($279($280));
                        };
                    }(), $$throw, done);
                };
            };
        },
        MonadAsk0: function() {
            return monadAskParserT1;
        }
    };
};
var $2b6d012b5a71a466$export$c97488a047bfb404 = {
    tailRecM: function(next) {
        return function(initArg) {
            return function(state1, more, lift1, $$throw, done) {
                var $lazy_loop = $2b6d012b5a71a466$var$$runtime_lazy("loop", "Parsing", function() {
                    return function(state2, arg, gas) {
                        var v = next(arg);
                        return v(state2, more, lift1, $$throw, function(state3, step) {
                            if (step instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                                var $206 = gas === 0;
                                if ($206) return more(function(v1) {
                                    return $lazy_loop(277)(state3, step.value0, 30);
                                });
                                return $lazy_loop(279)(state3, step.value0, gas - 1 | 0);
                            }
                            if (step instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return done(state3, step.value0);
                            throw new Error("Failed pattern match at Parsing (line 273, column 39 - line 281, column 43): " + [
                                step.constructor.name
                            ]);
                        });
                    };
                });
                var loop = $lazy_loop(270);
                return loop(state1, initArg, 30);
            };
        };
    },
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    }
};
var $2b6d012b5a71a466$export$76baed2e83aead93 = function(dictMonadState) {
    var lift1 = $2b6d012b5a71a466$var$lift(dictMonadState.Monad0());
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return {
        state: function(k) {
            return lift1(state(k));
        },
        Monad0: function() {
            return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
        }
    };
};
var $2b6d012b5a71a466$export$728b06f25edead82 = {
    throwError: function(err) {
        return function(state1, v, v1, $$throw, v2) {
            return $$throw(state1, err);
        };
    },
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    }
};
var $2b6d012b5a71a466$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($2b6d012b5a71a466$export$728b06f25edead82);
var $2b6d012b5a71a466$export$ce3dafa370e28e44 = {
    catchError: function(v) {
        return function(next) {
            return function(state1, more, lift1, $$throw, done) {
                return more(function(v1) {
                    return v(state1, more, lift1, function(state2, err) {
                        var v2 = next(err);
                        return v2(state2, more, lift1, $$throw, done);
                    }, done);
                });
            };
        };
    },
    MonadThrow0: function() {
        return $2b6d012b5a71a466$export$728b06f25edead82;
    }
};
var $2b6d012b5a71a466$var$catchError = /* #__PURE__ */ $5dfefa023749ded0$export$3dede90624df3ba9($2b6d012b5a71a466$export$ce3dafa370e28e44);
var $2b6d012b5a71a466$export$93591ff715526817 = function(dictMonoid) {
    var semigroupParserT1 = $2b6d012b5a71a466$export$32bd52aa0d2a958d(dictMonoid.Semigroup0());
    return {
        mempty: $2b6d012b5a71a466$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupParserT1;
        }
    };
};
var $2b6d012b5a71a466$export$6d6c2eed9b26bef3 = {
    alt: function(v) {
        return function(v1) {
            return function(v2, more, lift1, $$throw, done) {
                return more(function(v3) {
                    return v(new $2b6d012b5a71a466$export$c791339539b80010(v2.value0, v2.value1, false), more, lift1, function(v4, err) {
                        return more(function(v5) {
                            if (v4.value2) return $$throw(v4, err);
                            return v1(v2, more, lift1, $$throw, done);
                        });
                    }, done);
                });
            };
        };
    },
    Functor0: function() {
        return $2b6d012b5a71a466$export$858eabc7228a4f5b;
    }
};
var $2b6d012b5a71a466$export$a961fe75161cc564 = function(k) {
    return function(state1, v, v1, v2, done) {
        var v3 = k(state1);
        return done(v3.value1, v3.value0);
    };
};
var $2b6d012b5a71a466$export$7967a4332fb063d4 = {
    show: function(v) {
        return "(ParseError " + ($2b6d012b5a71a466$var$show(v.value0) + (" " + ($2b6d012b5a71a466$var$show1(v.value1) + ")")));
    }
};
var $2b6d012b5a71a466$export$cadc613b8e93558 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(state1) {
        return function(v) {
            var go = function($copy_step) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(step) {
                    var v1 = step($05149ea687d6b460$export$523c0b569236b342);
                    if (v1 instanceof $2b6d012b5a71a466$var$More) {
                        $copy_step = v1.value0;
                        return;
                    }
                    if (v1 instanceof $2b6d012b5a71a466$var$Lift) {
                        $tco_done = true;
                        return map($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(v1.value0);
                    }
                    if (v1 instanceof $2b6d012b5a71a466$var$Stop) {
                        $tco_done = true;
                        return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1, v1.value0)));
                    }
                    throw new Error("Failed pattern match at Parsing (line 152, column 13 - line 158, column 32): " + [
                        v1.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_step);
                return $tco_result;
            };
            return tailRecM(go)(function(v1) {
                return v(state1, $2b6d012b5a71a466$var$More.create, $2b6d012b5a71a466$var$Lift.create, function(state2, err) {
                    return new $2b6d012b5a71a466$var$Stop(state2, new $7d4cccdf062a2261$export$37c4d04eafdc5515(err));
                }, function(state2, res) {
                    return new $2b6d012b5a71a466$var$Stop(state2, new $7d4cccdf062a2261$export$19db0165690c701a(res));
                });
            });
        };
    };
};
var $2b6d012b5a71a466$export$9b1a70c9ede163e = function(context) {
    return function(p) {
        return $2b6d012b5a71a466$var$catchError(p)(function(err) {
            return $2b6d012b5a71a466$var$throwError(context(err));
        });
    };
};
var $2b6d012b5a71a466$export$5880b8b5730aff45 = /* #__PURE__ */ $2b6d012b5a71a466$export$a961fe75161cc564(function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v);
});
var $2b6d012b5a71a466$export$f6224d1ee5ebdf6a = function(v) {
    return v.value1;
};
var $2b6d012b5a71a466$export$91c32f1b22d29b2d = function(v) {
    return v.value0;
};
var $2b6d012b5a71a466$export$b2a98702105c3a71 = function(dictMonadRec) {
    var runParserT$prime1 = $2b6d012b5a71a466$export$cadc613b8e93558(dictMonadRec);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            return function(p) {
                return function(state1, v, lift1, $$throw, done) {
                    return lift1(map(function(v1) {
                        return function(v2) {
                            if (v1.value0 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $$throw(v1.value1, v1.value0.value0);
                            if (v1.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return done(v1.value1, v1.value0.value0);
                            throw new Error("Failed pattern match at Parsing (line 192, column 13 - line 196, column 37): " + [
                                v1.value0.constructor.name
                            ]);
                        };
                    })(f(runParserT$prime1(state1)(p))));
                };
            };
        };
    };
};
var $2b6d012b5a71a466$export$3b2cd57af4544298 = {
    index: 0,
    line: 1,
    column: 1
};
var $2b6d012b5a71a466$export$9f9314778b57da70 = function(dictMonadRec) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    var runParserT$prime1 = $2b6d012b5a71a466$export$cadc613b8e93558(dictMonadRec);
    return function(s) {
        return function(p) {
            var initialState = new $2b6d012b5a71a466$export$c791339539b80010(s, $2b6d012b5a71a466$export$3b2cd57af4544298, false);
            return map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(runParserT$prime1(initialState)(p));
        };
    };
};
var $2b6d012b5a71a466$var$runParserT1 = /* #__PURE__ */ $2b6d012b5a71a466$export$9f9314778b57da70($f93520de2fa37b44$export$ef692454cdd8c2ba);
var $2b6d012b5a71a466$export$4ad9239eebc1597f = function(s) {
    var $281 = $2b6d012b5a71a466$var$runParserT1(s);
    return function($282) {
        return $2b6d012b5a71a466$var$unwrap($281($282));
    };
};
var $2b6d012b5a71a466$export$ee5cf94f27827250 = function(f) {
    return function(v) {
        return function(state1, more, lift1, $$throw, done) {
            return v(state1, more, function($283) {
                return lift1(f($283));
            }, $$throw, done);
        };
    };
};
var $2b6d012b5a71a466$export$99cb5271137cc3e6 = function(state1, v, v1, v2, done) {
    return done(state1, state1);
};
var $2b6d012b5a71a466$export$d048d07e0ea3e0f1 = function(message) {
    return function(pos) {
        return $2b6d012b5a71a466$var$throwError(new $2b6d012b5a71a466$export$f9c837a54db411d(message, pos));
    };
};
var $2b6d012b5a71a466$export$2b62a06a9fee979c = function(message) {
    return $2b6d012b5a71a466$var$bindFlipped($2b6d012b5a71a466$export$d048d07e0ea3e0f1(message))($2b6d012b5a71a466$export$5880b8b5730aff45);
};
var $2b6d012b5a71a466$export$bd6bd7bb5418f998 = function(dictMonad) {
    return function(f) {
        if (f instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $2b6d012b5a71a466$export$2b62a06a9fee979c(f.value0);
        if (f instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $2b6d012b5a71a466$var$pure(f.value0);
        throw new Error("Failed pattern match at Parsing (line 515, column 16 - line 517, column 20): " + [
            f.constructor.name
        ]);
    };
};
var $2b6d012b5a71a466$export$d5cae9b05ce784eb = function(dictMonad) {
    var lift1 = $2b6d012b5a71a466$var$lift(dictMonad);
    return function(f) {
        return $2b6d012b5a71a466$var$bind(lift1($d2284b2d3e1b6f87$export$8291c2122093ac93(f)))(function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $2b6d012b5a71a466$export$2b62a06a9fee979c(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $2b6d012b5a71a466$var$pure(v.value0);
            throw new Error("Failed pattern match at Parsing (line 529, column 41 - line 531, column 20): " + [
                v.constructor.name
            ]);
        });
    };
};
var $2b6d012b5a71a466$export$1cf01ae67112be7b = function(dictMonad) {
    return function(message) {
        return function(f) {
            if (f instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $2b6d012b5a71a466$export$2b62a06a9fee979c(message($05149ea687d6b460$export$523c0b569236b342));
            if (f instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $2b6d012b5a71a466$var$pure(f.value0);
            throw new Error("Failed pattern match at Parsing (line 501, column 23 - line 503, column 19): " + [
                f.constructor.name
            ]);
        };
    };
};
var $2b6d012b5a71a466$export$304c3a29e5bb9689 = {
    empty: /* #__PURE__ */ $2b6d012b5a71a466$export$2b62a06a9fee979c("No alternative"),
    Alt0: function() {
        return $2b6d012b5a71a466$export$6d6c2eed9b26bef3;
    }
};
var $2b6d012b5a71a466$export$5220689f708908c3 = {
    Applicative0: function() {
        return $2b6d012b5a71a466$export$a80a9dff0c4321f9;
    },
    Plus1: function() {
        return $2b6d012b5a71a466$export$304c3a29e5bb9689;
    }
};
var $2b6d012b5a71a466$export$e929610c0683bf9a = {
    Monad0: function() {
        return $2b6d012b5a71a466$export$50fcd154ffbb53ba;
    },
    Alternative1: function() {
        return $2b6d012b5a71a466$export$5220689f708908c3;
    }
};
var $2b6d012b5a71a466$export$adbb70a5bd2c0146 = {
    eq: function(x) {
        return function(y) {
            return x.value0 === y.value0 && $2b6d012b5a71a466$var$eq2(x.value1)(y.value1);
        };
    }
};
var $2b6d012b5a71a466$export$3f38bd25419f2c1c = {
    compare: function(x) {
        return function(y) {
            var v = $2b6d012b5a71a466$var$compare1(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $2b6d012b5a71a466$var$compare2(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $2b6d012b5a71a466$export$adbb70a5bd2c0146;
    }
};
var $2b6d012b5a71a466$export$e11e6a155c5c4d9d = /* #__PURE__ */ $2b6d012b5a71a466$export$a961fe75161cc564(function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, new $2b6d012b5a71a466$export$c791339539b80010(v.value0, v.value1, true));
});




// Generated by purs version 0.15.15













// Generated by purs version 0.15.15












// Generated by purs version 0.15.15















// Generated by purs version 0.15.15


























var $52d2aab060724108$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $52d2aab060724108$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $52d2aab060724108$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $52d2aab060724108$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$96fd6c73d03c9dd2($73aa5dd1904ebcb7$export$4fb3dc255b34fa12);
var $52d2aab060724108$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$693feb0c3c484b70($73aa5dd1904ebcb7$export$d65b504a31b57308);
var $52d2aab060724108$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $52d2aab060724108$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $52d2aab060724108$export$54c2e3dc7acea9f5 = function(x) {
    return x;
};
var $52d2aab060724108$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $52d2aab060724108$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $52d2aab060724108$export$ab241a3582569781 = function(x) {
    return x;
};
var $52d2aab060724108$export$f2c4f74e8fe88e34 = /* #__PURE__ */ $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
    return $52d2aab060724108$export$c1bed610ade55e1c.value;
});
var $52d2aab060724108$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $52d2aab060724108$export$d7c6954d7d62822f = {
    Coercible0: function() {
        return undefined;
    }
};
var $52d2aab060724108$export$35d34bc0ed591a92 = function($319) {
    return $99af8ad7682e39c7$export$4d82290515cd0ddb($52d2aab060724108$var$unwrap($319));
};
var $52d2aab060724108$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$35d34bc0ed591a92(ys);
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $d7bf9817a417d4ae$export$10d8903dec122b9d($52d2aab060724108$export$11cb7909a85856b)(v.value1)(ys));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 103, column 5 - line 103, column 21): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    }
};
var $52d2aab060724108$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($52d2aab060724108$export$11cb7909a85856b);
var $52d2aab060724108$export$14584e231e9c63ca = {
    mempty: $52d2aab060724108$export$f2c4f74e8fe88e34,
    Semigroup0: function() {
        return $52d2aab060724108$export$11cb7909a85856b;
    }
};
var $52d2aab060724108$export$b4de83846969a6e1 = {
    defer: function(f) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function($320) {
            return $52d2aab060724108$export$35d34bc0ed591a92(f($320));
        });
    }
};
var $52d2aab060724108$var$defer = /* #__PURE__ */ $a1e0a82f0b162743$export$260e5c0943f31606($52d2aab060724108$export$b4de83846969a6e1);
var $52d2aab060724108$export$40b9e4330ffd17e3 = {
    map: function(f) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(f(v.value0), $f4b2eb11fc32ed34$export$871de8747c9eaa88($52d2aab060724108$export$40b9e4330ffd17e3)(f)(v.value1));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 112, column 5 - line 112, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    }
};
var $52d2aab060724108$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0($52d2aab060724108$export$40b9e4330ffd17e3));
var $52d2aab060724108$export$3c979cc7d75b024c = {
    map: function(f) {
        return function(v) {
            return $52d2aab060724108$var$map($52d2aab060724108$var$map1(f))(v);
        };
    }
};
var $52d2aab060724108$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c && v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return true;
                            }
                            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0 && eq(v.value0)(v1.value0)) {
                                $tco_var_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                                $copy_v1 = $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                                return;
                            }
                            $tco_done = true;
                            return false;
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($52d2aab060724108$export$35d34bc0ed591a92(xs))($52d2aab060724108$export$35d34bc0ed591a92(ys));
            };
        };
    }
};
var $52d2aab060724108$var$eqNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$460809894af54b0a($52d2aab060724108$export$b7e705972f3b8317);
var $52d2aab060724108$var$eq11 = /* #__PURE__ */ $37b880af5f4991bd$export$96fd6c73d03c9dd2($52d2aab060724108$export$b7e705972f3b8317);
var $52d2aab060724108$export$80901a10e94c964a = {
    eq1: function(dictEq) {
        var eq12 = $52d2aab060724108$var$eq1($52d2aab060724108$var$eqNonEmpty(dictEq));
        return function(v) {
            return function(v1) {
                return eq12(v)(v1);
            };
        };
    }
};
var $52d2aab060724108$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $52d2aab060724108$var$eq11(dictEq)
    };
};
var $52d2aab060724108$export$25985b0447eac39b = function(dictEq) {
    return $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5($52d2aab060724108$var$eqNonEmpty(dictEq));
};
var $52d2aab060724108$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c && v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                            }
                            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    $tco_var_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                                    $copy_v1 = $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 89, column 5 - line 89, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($52d2aab060724108$export$35d34bc0ed591a92(xs))($52d2aab060724108$export$35d34bc0ed591a92(ys));
            };
        };
    },
    Eq10: function() {
        return $52d2aab060724108$export$b7e705972f3b8317;
    }
};
var $52d2aab060724108$var$ordNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ec32b9103f985218($52d2aab060724108$export$a37dd417b96243af);
var $52d2aab060724108$var$compare11 = /* #__PURE__ */ $97937c29f879e68e$export$693feb0c3c484b70($52d2aab060724108$export$a37dd417b96243af);
var $52d2aab060724108$export$bf20701e75931fe8 = {
    compare1: function(dictOrd) {
        var compare12 = $52d2aab060724108$var$compare1($52d2aab060724108$var$ordNonEmpty(dictOrd));
        return function(v) {
            return function(v1) {
                return compare12(v)(v1);
            };
        };
    },
    Eq10: function() {
        return $52d2aab060724108$export$80901a10e94c964a;
    }
};
var $52d2aab060724108$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $52d2aab060724108$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $52d2aab060724108$var$compare11(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $52d2aab060724108$export$783a13ebf5a1203d = function(dictOrd) {
    return $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db($52d2aab060724108$var$ordNonEmpty(dictOrd));
};
var $52d2aab060724108$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return new $52d2aab060724108$export$74c44e616647f5c0(x, xs);
        });
    };
};
var $52d2aab060724108$export$92659ee1fc91a075 = {
    foldr: function(op) {
        return function(z) {
            return function(xs) {
                var rev = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$export$92659ee1fc91a075)($f57f4b701aa7b66e$export$8a83211c878a3f1f($52d2aab060724108$export$8327ebbef2a0ba76))($52d2aab060724108$export$f2c4f74e8fe88e34);
                return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$export$92659ee1fc91a075)($f57f4b701aa7b66e$export$8a83211c878a3f1f(op))(z)(rev(xs));
            };
        };
    },
    foldl: function(op) {
        var go = function($copy_b) {
            return function($copy_xs) {
                var $tco_var_b = $copy_b;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(b, xs) {
                    var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
                    if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return b;
                    }
                    if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                        $tco_var_b = op(b)(v.value0);
                        $copy_xs = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 127, column 7 - line 129, column 40): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_b, $copy_xs);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$export$92659ee1fc91a075)(function(b) {
                return function(a) {
                    return append2(b)(f(a));
                };
            })(mempty);
        };
    }
};
var $52d2aab060724108$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$var$foldableNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$20ebd08132411556($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($52d2aab060724108$var$foldableNonEmpty);
var $52d2aab060724108$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$export$92659ee1fc91a075);
var $52d2aab060724108$export$a2b02e086d468c06 = {
    extend: function(f) {
        return function(l) {
            var go = function(a) {
                return function(v) {
                    var acc$prime = $52d2aab060724108$export$8327ebbef2a0ba76(a)(v.acc);
                    return {
                        val: $52d2aab060724108$export$8327ebbef2a0ba76(f(acc$prime))(v.val),
                        acc: acc$prime
                    };
                };
            };
            var v = $52d2aab060724108$export$35d34bc0ed591a92(l);
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$f2c4f74e8fe88e34;
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return $52d2aab060724108$export$8327ebbef2a0ba76(f(l))($52d2aab060724108$var$foldr(go)({
                val: $52d2aab060724108$export$f2c4f74e8fe88e34,
                acc: $52d2aab060724108$export$f2c4f74e8fe88e34
            })(v.value1).val);
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 197, column 5 - line 200, column 55): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: $52d2aab060724108$export$8327ebbef2a0ba76(f($99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v1.acc);
                        })))(v1.val),
                        acc: $52d2aab060724108$export$8327ebbef2a0ba76(a)(v1.acc)
                    };
                };
            };
            var v1 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v);
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v), $52d2aab060724108$var$foldr(go)({
                    val: $52d2aab060724108$export$f2c4f74e8fe88e34,
                    acc: $52d2aab060724108$export$f2c4f74e8fe88e34
                })(v1.value1).val);
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$604c31769a93bbe0 = {
    foldr: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldr1(f)(b)($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    },
    foldl: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldl(f)(b)($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $52d2aab060724108$var$foldMap(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap1(f)($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    }
};
var $52d2aab060724108$export$36831384a74c4427 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(xs) {
            return "(fromFoldable [" + (function() {
                var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return "";
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return show(v.value0) + $52d2aab060724108$var$foldl1(function(shown) {
                    return function(x$prime) {
                        return shown + ("," + show(x$prime));
                    };
                })("")(v.value1);
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 66, column 13 - line 69, column 78): " + [
                    v.constructor.name
                ]);
            }() + "])");
        }
    };
};
var $52d2aab060724108$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($73aa5dd1904ebcb7$export$bb0ce398898c1c48($1f1c3fb67e79b37f$export$ffafc93d2cc87798(dictShow)($52d2aab060724108$export$36831384a74c4427(dictShow))));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $52d2aab060724108$export$17f3d25eed773ff1 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0($52d2aab060724108$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return "Nil";
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return "(" + (show(v.value0) + (" : " + (show1(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 36, column 1 - line 38, column 62): " + [
                v.constructor.name
            ]);
        }
    };
};
var $52d2aab060724108$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $52d2aab060724108$var$foldl1(function(v1) {
                        return function(a) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 + 1 | 0, $52d2aab060724108$export$8327ebbef2a0ba76(a)(v1.value1));
                        };
                    });
                    return rev(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $52d2aab060724108$export$f2c4f74e8fe88e34))(xs);
                }();
                return $71f2e2e9476163f8$export$6f71268a1666ab58($52d2aab060724108$var$foldl1(function(v1) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $321 = $52d2aab060724108$var$foldl1(function(v) {
                return function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, acc));
            return function($322) {
                return $71f2e2e9476163f8$export$6f71268a1666ab58($321($322));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $519ef1967f17d101$export$2d70b9efb960f478($52d2aab060724108$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $323 = append2(acc);
                    var $324 = f(i);
                    return function($325) {
                        return $323($324($325));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $52d2aab060724108$export$92659ee1fc91a075;
    }
};
var $52d2aab060724108$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$9a79a74e355c28b1($52d2aab060724108$export$465bfc9894c20a50);
var $52d2aab060724108$var$foldMapWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$18153bb1181268e5($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldlWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($52d2aab060724108$var$foldableWithIndexNonEmpty);
var $52d2aab060724108$var$foldrWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($52d2aab060724108$export$465bfc9894c20a50);
var $52d2aab060724108$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $52d2aab060724108$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $326 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($52d2aab060724108$var$add(1));
                    return function($327) {
                        return f($326($327));
                    };
                }())($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldlWithIndex(function() {
                    var $328 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($52d2aab060724108$var$add(1));
                    return function($329) {
                        return f($328($329));
                    };
                }())(b)($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $52d2aab060724108$var$foldrWithIndex(function() {
                    var $330 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($52d2aab060724108$var$add(1));
                    return function($331) {
                        return f($330($331));
                    };
                }())(b)($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            };
        };
    },
    Foldable0: function() {
        return $52d2aab060724108$export$604c31769a93bbe0;
    }
};
var $52d2aab060724108$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $52d2aab060724108$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return $52d2aab060724108$export$8327ebbef2a0ba76(f(i)(x))(acc);
                };
            };
        })($52d2aab060724108$export$f2c4f74e8fe88e34);
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50(/* #__PURE__ */ $1f1c3fb67e79b37f$export$cdee60b0fe4303fd($52d2aab060724108$export$3951fb12c9649f2b));
var $52d2aab060724108$export$116ff457f4ca2f6a = {
    mapWithIndex: function(f) {
        return function(v) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                return $52d2aab060724108$var$mapWithIndex(function() {
                    var $332 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($52d2aab060724108$var$add(1));
                    return function($333) {
                        return f($332($333));
                    };
                }())($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$effcdbd76139450 = function(v) {
    return $52d2aab060724108$var$defer(function(v1) {
        var v2 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v);
        return $52d2aab060724108$export$8327ebbef2a0ba76(v2.value0)(v2.value1);
    });
};
var $52d2aab060724108$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            var v1 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v);
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, $52d2aab060724108$var$append1(v1.value1)($52d2aab060724108$export$effcdbd76139450(as$prime)));
            });
        };
    }
};
var $52d2aab060724108$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return $52d2aab060724108$var$foldr(function(a) {
                return function(b) {
                    return apply1(map2($52d2aab060724108$export$8327ebbef2a0ba76)(f(a)))(b);
                };
            })(pure($52d2aab060724108$export$f2c4f74e8fe88e34));
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($52d2aab060724108$export$99c2ce29c0ead637)(dictApplicative)($52d2aab060724108$var$identity);
    },
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $52d2aab060724108$export$92659ee1fc91a075;
    }
};
var $52d2aab060724108$var$traversableNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($52d2aab060724108$export$99c2ce29c0ead637);
var $52d2aab060724108$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($52d2aab060724108$var$traversableNonEmpty);
var $52d2aab060724108$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($52d2aab060724108$var$traversableNonEmpty);
var $52d2aab060724108$export$d0a0d45336d2d3e3 = {
    traverse: function(dictApplicative) {
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse1 = $52d2aab060724108$var$traverse(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return xxs;
                    });
                })(traverse1(f)($99af8ad7682e39c7$export$4d82290515cd0ddb(v)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence1 = $52d2aab060724108$var$sequence(dictApplicative);
        return function(v) {
            return map2(function(xxs) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                    return xxs;
                });
            })(sequence1($99af8ad7682e39c7$export$4d82290515cd0ddb(v)));
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    },
    Foldable1: function() {
        return $52d2aab060724108$export$604c31769a93bbe0;
    }
};
var $52d2aab060724108$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return $52d2aab060724108$var$foldrWithIndex1(function(i) {
                return function(a) {
                    return function(b) {
                        return apply1(map2($52d2aab060724108$export$8327ebbef2a0ba76)(f(i)(a)))(b);
                    };
                };
            })(pure($52d2aab060724108$export$f2c4f74e8fe88e34));
        };
    },
    FunctorWithIndex0: function() {
        return $52d2aab060724108$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $52d2aab060724108$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $52d2aab060724108$export$99c2ce29c0ead637;
    }
};
var $52d2aab060724108$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249(/* #__PURE__ */ $1f1c3fb67e79b37f$export$6e693a2e8188a772($52d2aab060724108$export$aed77e3b7bbfc02d));
var $52d2aab060724108$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $52d2aab060724108$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return xxs;
                    });
                })(traverseWithIndex1(function() {
                    var $334 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($52d2aab060724108$var$add(1));
                    return function($335) {
                        return f($334($335));
                    };
                }())($99af8ad7682e39c7$export$4d82290515cd0ddb(v)));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $52d2aab060724108$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $52d2aab060724108$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $52d2aab060724108$export$d0a0d45336d2d3e3;
    }
};
var $52d2aab060724108$export$c7fe2ca4bf0cb8df = {
    unfoldr1: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $52d2aab060724108$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0)(go(f)(v1.value1.value0));
                    if (v1.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0)($52d2aab060724108$export$f2c4f74e8fe88e34);
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 151, column 28 - line 153, column 33): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }()
};
var $52d2aab060724108$export$1d41caf0a0a6a680 = {
    unfoldr: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $52d2aab060724108$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $52d2aab060724108$export$f2c4f74e8fe88e34;
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $52d2aab060724108$export$8327ebbef2a0ba76(v1.value0.value0)(go(f)(v1.value0.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 157, column 28 - line 159, column 39): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }(),
    Unfoldable10: function() {
        return $52d2aab060724108$export$c7fe2ca4bf0cb8df;
    }
};
var $52d2aab060724108$var$unfoldr1 = /* #__PURE__ */ $cf5af1199a495394$export$158c052536266a97(/* #__PURE__ */ $1f1c3fb67e79b37f$export$3d29df45c3f8cf54($52d2aab060724108$export$1d41caf0a0a6a680));
var $52d2aab060724108$export$6907256bb4275b5b = {
    unfoldr1: function(f) {
        return function(b) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $52d2aab060724108$var$unfoldr1(f)(b);
            });
        };
    }
};
var $52d2aab060724108$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return $1f1c3fb67e79b37f$export$5fd5031fecdacec3($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
    },
    Extend0: function() {
        return $52d2aab060724108$export$44a6d15320cfc4c5;
    }
};
var $52d2aab060724108$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $52d2aab060724108$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $52d2aab060724108$export$497dcf96eb2383ec;
    }
};
var $52d2aab060724108$export$497dcf96eb2383ec = {
    bind: function(xs) {
        return function(f) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return $52d2aab060724108$export$35d34bc0ed591a92($52d2aab060724108$var$append1(f(v.value0))($70cd3177464e7915$export$2385a24977818dd0($52d2aab060724108$export$497dcf96eb2383ec)(v.value1)(f)));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 180, column 5 - line 180, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $52d2aab060724108$var$map(go)($52d2aab060724108$var$unwrap(xs));
        };
    },
    Apply0: function() {
        return $52d2aab060724108$var$$lazy_applyList(0);
    }
};
var $52d2aab060724108$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return $52d2aab060724108$export$8327ebbef2a0ba76(a)($52d2aab060724108$export$f2c4f74e8fe88e34);
    },
    Apply0: function() {
        return $52d2aab060724108$var$$lazy_applyList(0);
    }
};
var $52d2aab060724108$var$$lazy_applyList = /* #__PURE__ */ $52d2aab060724108$var$$runtime_lazy("applyList", "Data.List.Lazy.Types", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($52d2aab060724108$export$7c78e86b21f51881),
        Functor0: function() {
            return $52d2aab060724108$export$40b9e4330ffd17e3;
        }
    };
});
var $52d2aab060724108$export$7e49f2fa1ca16fbc = /* #__PURE__ */ $52d2aab060724108$var$$lazy_applyList(171);
var $52d2aab060724108$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($52d2aab060724108$export$7e49f2fa1ca16fbc);
var $52d2aab060724108$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($52d2aab060724108$export$497dcf96eb2383ec);
var $52d2aab060724108$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            var v2 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v1);
            var v3 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v);
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v4) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v3.value0(v2.value0), $52d2aab060724108$var$append1($52d2aab060724108$var$apply(v3.value1)($52d2aab060724108$export$8327ebbef2a0ba76(v2.value0)($52d2aab060724108$export$f2c4f74e8fe88e34)))($52d2aab060724108$var$apply($52d2aab060724108$export$8327ebbef2a0ba76(v3.value0)(v3.value1))(v2.value1)));
            });
        };
    },
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = $99af8ad7682e39c7$export$4d82290515cd0ddb(v);
            var v2 = $99af8ad7682e39c7$export$4d82290515cd0ddb($52d2aab060724108$var$unwrap(f(v1.value0)));
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v3) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v2.value0, $52d2aab060724108$var$append1(v2.value1)($52d2aab060724108$var$bind(v1.value1)(function($336) {
                    return $52d2aab060724108$export$effcdbd76139450(f($336));
                })));
            });
        };
    },
    Apply0: function() {
        return $52d2aab060724108$export$18f1a42667f2921e;
    }
};
var $52d2aab060724108$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($52d2aab060724108$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $52d2aab060724108$export$3c979cc7d75b024c;
    }
};
var $52d2aab060724108$export$97980ce7ea95015b = {
    alt: $52d2aab060724108$var$append1,
    Functor0: function() {
        return $52d2aab060724108$export$40b9e4330ffd17e3;
    }
};
var $52d2aab060724108$export$55d622505c452dcb = {
    empty: $52d2aab060724108$export$f2c4f74e8fe88e34,
    Alt0: function() {
        return $52d2aab060724108$export$97980ce7ea95015b;
    }
};
var $52d2aab060724108$var$singleton = /* #__PURE__ */ $1f1c3fb67e79b37f$export$439306a4dcaafbb9($52d2aab060724108$export$55d622505c452dcb);
var $52d2aab060724108$export$503ce72759d93980 = {
    Applicative0: function() {
        return $52d2aab060724108$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $52d2aab060724108$export$55d622505c452dcb;
    }
};
var $52d2aab060724108$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $52d2aab060724108$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $52d2aab060724108$export$503ce72759d93980;
    }
};
var $52d2aab060724108$export$e5d0ed5dac805e10 = {
    pure: function(a) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return $52d2aab060724108$var$singleton(a);
        });
    },
    Apply0: function() {
        return $52d2aab060724108$export$18f1a42667f2921e;
    }
};
var $52d2aab060724108$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $52d2aab060724108$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $52d2aab060724108$export$12e3398ee6f4a417;
    }
};












var $292f8c84f8002d8c$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
var $292f8c84f8002d8c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $292f8c84f8002d8c$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $292f8c84f8002d8c$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($52d2aab060724108$export$99c2ce29c0ead637);
var $292f8c84f8002d8c$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($52d2aab060724108$export$92659ee1fc91a075);
var $292f8c84f8002d8c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $292f8c84f8002d8c$var$tailRecM2 = /* #__PURE__ */ $f93520de2fa37b44$export$9056a6bb308e8c79($f93520de2fa37b44$export$6a06149683d26749);
var $292f8c84f8002d8c$var$defer = /* #__PURE__ */ $a1e0a82f0b162743$export$260e5c0943f31606($52d2aab060724108$export$b4de83846969a6e1);
var $292f8c84f8002d8c$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($52d2aab060724108$export$92659ee1fc91a075);
var $292f8c84f8002d8c$var$fix = /* #__PURE__ */ $a1e0a82f0b162743$export$d838837eb5b184e3($52d2aab060724108$export$b4de83846969a6e1);
var $292f8c84f8002d8c$var$unfoldr = /* #__PURE__ */ $cb5fedc2c4837e1c$export$df2b8ee1690308ae($52d2aab060724108$export$1d41caf0a0a6a680);
var $292f8c84f8002d8c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($52d2aab060724108$export$40b9e4330ffd17e3);
var $292f8c84f8002d8c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $292f8c84f8002d8c$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $292f8c84f8002d8c$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($52d2aab060724108$export$92659ee1fc91a075)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $292f8c84f8002d8c$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($52d2aab060724108$export$11cb7909a85856b);
var $292f8c84f8002d8c$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($52d2aab060724108$export$497dcf96eb2383ec);
var $292f8c84f8002d8c$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $292f8c84f8002d8c$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $292f8c84f8002d8c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function(v) {
                return function(v1) {
                    if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                    if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                    if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(f(v.value0)(v1.value0), $292f8c84f8002d8c$export$b634740ce272acb5(f)(v.value1)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 705, column 3 - line 705, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$apply($292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs)))($292f8c84f8002d8c$var$unwrap(ys));
        };
    };
};
var $292f8c84f8002d8c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $292f8c84f8002d8c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($292f8c84f8002d8c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $292f8c84f8002d8c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $292f8c84f8002d8c$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $292f8c84f8002d8c$export$b6d8713d53419d4c = function(n) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                    if (v === 0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(x, v1.value1);
                    if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, $292f8c84f8002d8c$export$b6d8713d53419d4c(v - 1 | 0)(x)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 361, column 3 - line 361, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $292f8c84f8002d8c$var$foldr(function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($52d2aab060724108$export$8327ebbef2a0ba76(v.value0)(v1.value0), $52d2aab060724108$export$8327ebbef2a0ba76(v.value1)(v1.value1));
        };
    })(new $71f2e2e9476163f8$export$1908877435b1d5e9($52d2aab060724108$export$f2c4f74e8fe88e34, $52d2aab060724108$export$f2c4f74e8fe88e34));
}();
var $292f8c84f8002d8c$export$b446f6baa3bb1430 = function(xs) {
    var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
    if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List.Lazy (line 288, column 13 - line 290, column 44): " + [
        v.constructor.name
    ]);
};
var $292f8c84f8002d8c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $292f8c84f8002d8c$var$map1(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
    });
};
var $292f8c84f8002d8c$export$9384c7afe4015e42 = function(p) {
    var go = function(v) {
        if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && p(v.value0)) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $292f8c84f8002d8c$export$9384c7afe4015e42(p)(v.value1));
        return $52d2aab060724108$export$c1bed610ade55e1c.value;
    };
    var $331 = $292f8c84f8002d8c$var$map(go);
    return function($332) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($331($292f8c84f8002d8c$var$unwrap($332)));
    };
};
var $292f8c84f8002d8c$export$b7df5d561049483a = function(n) {
    var go = function(v) {
        return function(v1) {
            if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
            if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, $292f8c84f8002d8c$export$b7df5d561049483a(v - 1 | 0)(v1.value1));
            throw new Error("Failed pattern match at Data.List.Lazy (line 505, column 3 - line 505, column 32): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var $202 = n <= 0;
    if ($202) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($52d2aab060724108$export$f2c4f74e8fe88e34);
    var $333 = $292f8c84f8002d8c$var$map(go(n));
    return function($334) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($333($292f8c84f8002d8c$var$unwrap($334)));
    };
};
var $292f8c84f8002d8c$export$c01875f616615628 = function(xs) {
    return $292f8c84f8002d8c$var$map1(function(v) {
        return v.tail;
    })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
};
var $292f8c84f8002d8c$export$71c2a1babd78d286 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    var v1 = $52d2aab060724108$export$35d34bc0ed591a92(prefix);
                    if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$7fe28cb29e71bf10(input));
                    if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                        var v2 = $52d2aab060724108$export$35d34bc0ed591a92(input);
                        if (v2 instanceof $52d2aab060724108$export$74c44e616647f5c0 && eq(v1.value0)(v2.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                            a: v1.value1,
                            b: v2.value1
                        }));
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy (line 487, column 21 - line 491, column 19): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$tailRecM2(go)(v)(s);
        };
    };
};
var $292f8c84f8002d8c$export$afc1bfabebaf28a2 = function(p) {
    return function(xs) {
        var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && p(v.value0.head)) {
            var v1 = $292f8c84f8002d8c$export$afc1bfabebaf28a2(p)(v.value0.tail);
            return {
                init: $52d2aab060724108$export$8327ebbef2a0ba76(v.value0.head)(v1.init),
                rest: v1.rest
            };
        }
        return {
            init: $52d2aab060724108$export$f2c4f74e8fe88e34,
            rest: xs
        };
    };
};
var $292f8c84f8002d8c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $292f8c84f8002d8c$var$foldr($52d2aab060724108$export$8327ebbef2a0ba76)($52d2aab060724108$export$8327ebbef2a0ba76(x)($52d2aab060724108$export$f2c4f74e8fe88e34))(xs);
    };
};
var $292f8c84f8002d8c$export$439306a4dcaafbb9 = function(a) {
    return $52d2aab060724108$export$8327ebbef2a0ba76(a)($52d2aab060724108$export$f2c4f74e8fe88e34);
};
var $292f8c84f8002d8c$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($52d2aab060724108$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $292f8c84f8002d8c$export$951e420fdeef37cd = function(f) {
    return function(acc) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                    var acc$prime = f(acc)(v.value0);
                    return new $52d2aab060724108$export$74c44e616647f5c0(acc$prime, $292f8c84f8002d8c$export$951e420fdeef37cd(f)(acc$prime)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 776, column 5 - line 776, column 27): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$66c1ae025e96b4bc = function(xs) {
    return $292f8c84f8002d8c$var$defer(function(v) {
        return $292f8c84f8002d8c$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($52d2aab060724108$export$8327ebbef2a0ba76))($52d2aab060724108$export$f2c4f74e8fe88e34)(xs);
    });
};
var $292f8c84f8002d8c$export$f1fa93b59bdd728d = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(n) {
        return function(m) {
            if (n < 1) return pure1($52d2aab060724108$export$f2c4f74e8fe88e34);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind2(m)(function(a) {
                return bind2($292f8c84f8002d8c$export$f1fa93b59bdd728d(dictMonad)(n - 1 | 0)(m))(function(as) {
                    return pure1($52d2aab060724108$export$8327ebbef2a0ba76(a)(as));
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 164, column 1 - line 164, column 62): " + [
                n.constructor.name,
                m.constructor.name
            ]);
        };
    };
};
var $292f8c84f8002d8c$export$76d90c956114f2c2 = function(x) {
    return $292f8c84f8002d8c$var$fix(function(xs) {
        return $52d2aab060724108$export$8327ebbef2a0ba76(x)(xs);
    });
};
var $292f8c84f8002d8c$export$606959e7ccb797f0 = function(i) {
    return function(xs) {
        return $292f8c84f8002d8c$export$b7df5d561049483a(i)($292f8c84f8002d8c$export$76d90c956114f2c2(xs));
    };
};
var $292f8c84f8002d8c$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start > end) {
            var g = function(x) {
                if (x >= end) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(x, x - 1 | 0));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 151, column 13 - line 152, column 38): " + [
                    x.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$unfoldr(g)(start);
        }
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var f = function(x) {
                if (x <= end) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(x, x + 1 | 0));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 156, column 5 - line 157, column 30): " + [
                    x.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$unfoldr(f)(start);
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 148, column 1 - line 148, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $292f8c84f8002d8c$export$b29f828819edca8d = function(f) {
    var go = function(x) {
        return function(v) {
            var $230 = f(x);
            if ($230) return {
                yes: $52d2aab060724108$export$8327ebbef2a0ba76(x)(v.yes),
                no: v.no
            };
            return {
                yes: v.yes,
                no: $52d2aab060724108$export$8327ebbef2a0ba76(x)(v.no)
            };
        };
    };
    return $292f8c84f8002d8c$var$foldr(go)({
        yes: $52d2aab060724108$export$f2c4f74e8fe88e34,
        no: $52d2aab060724108$export$f2c4f74e8fe88e34
    });
};
var $292f8c84f8002d8c$export$7b1b591b262c240 = function($335) {
    return $06733ae99ed4f534$export$4967676db1b89293($292f8c84f8002d8c$export$b446f6baa3bb1430($335));
};
var $292f8c84f8002d8c$export$18f77a3bafa759b9 = function(p) {
    var goStep = function(v) {
        return function(v1) {
            if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
            if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                var v2 = $5ce356b15dd97b57$export$b5a179e49e0f2907(p)(v1.value0)(v);
                if (v2.found) return $52d2aab060724108$export$35d34bc0ed591a92(go(v2.result)(v1.value1));
                return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, go(v2.result)(v1.value1));
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 613, column 5 - line 613, column 23): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var go = function(s) {
        return function(v) {
            return $292f8c84f8002d8c$var$map(goStep(s))(v);
        };
    };
    return go($5ce356b15dd97b57$export$4e5bc754a9c955a);
};
var $292f8c84f8002d8c$export$94f4066a75b10404 = function(dictOrd) {
    return $292f8c84f8002d8c$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $292f8c84f8002d8c$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $292f8c84f8002d8c$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $52d2aab060724108$export$c1bed610ade55e1c.value;
            }
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                var v1 = f(v.value0);
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $copy_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                    return;
                }
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_done = true;
                    return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, $292f8c84f8002d8c$export$e70771d2e7e590a(f)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 448, column 5 - line 450, column 39): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 446, column 3 - line 446, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $336 = $292f8c84f8002d8c$var$map(go);
    return function($337) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($336($292f8c84f8002d8c$var$unwrap($337)));
    };
};
var $292f8c84f8002d8c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply1(map3($52d2aab060724108$export$8327ebbef2a0ba76)(v))(defer1(function(v1) {
                return $292f8c84f8002d8c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $292f8c84f8002d8c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($292f8c84f8002d8c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1($52d2aab060724108$export$f2c4f74e8fe88e34));
        };
    };
};
var $292f8c84f8002d8c$export$f24224f1c91d8156 = /* #__PURE__ */ $292f8c84f8002d8c$var$foldl(function(l) {
    return function(v) {
        return l + 1 | 0;
    };
})(0);
var $292f8c84f8002d8c$export$4c7897fafd92b108 = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                if ($292f8c84f8002d8c$export$7b1b591b262c240(v.value1)) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $copy_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                    return;
                }
            }
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($338) {
        return go($52d2aab060724108$export$35d34bc0ed591a92($338));
    };
}();
var $292f8c84f8002d8c$export$c1a059043cc9c119 = function(f) {
    return function(x) {
        return $292f8c84f8002d8c$var$fix(function(xs) {
            return $52d2aab060724108$export$8327ebbef2a0ba76(x)($292f8c84f8002d8c$var$map2(f)(xs));
        });
    };
};
var $292f8c84f8002d8c$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return $52d2aab060724108$export$8327ebbef2a0ba76(v1)(v2);
            var go = function(v3) {
                if (v3 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return new $52d2aab060724108$export$74c44e616647f5c0(v1, $52d2aab060724108$export$f2c4f74e8fe88e34);
                if (v3 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v3.value0, $292f8c84f8002d8c$export$9f200c4466975173(v - 1 | 0)(v1)(v3.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 340, column 3 - line 340, column 22): " + [
                    v3.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(v2));
        };
    };
};
var $292f8c84f8002d8c$export$2cd8252107eb640b = /* #__PURE__ */ function() {
    var go = function(v) {
        if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
            if ($292f8c84f8002d8c$export$7b1b591b262c240(v.value1)) return new $06733ae99ed4f534$export$8a67b48435b5d073($52d2aab060724108$export$f2c4f74e8fe88e34);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $292f8c84f8002d8c$var$map1($52d2aab060724108$export$8327ebbef2a0ba76(v.value0))(go($52d2aab060724108$export$35d34bc0ed591a92(v.value1)));
        }
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    return function($339) {
        return go($52d2aab060724108$export$35d34bc0ed591a92($339));
    };
}();
var $292f8c84f8002d8c$export$b610b8812bbcded9 = function(xs) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && v1 === 0) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
                }
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                    $tco_var_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                    $copy_v1 = v1 - 1 | 0;
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 302, column 3 - line 302, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($52d2aab060724108$export$35d34bc0ed591a92(xs));
};
var $292f8c84f8002d8c$export$5fd5031fecdacec3 = function(xs) {
    return $292f8c84f8002d8c$var$map1(function(v) {
        return v.head;
    })($292f8c84f8002d8c$export$b446f6baa3bb1430(xs));
};
var $292f8c84f8002d8c$export$9cb09a71b7d66923 = function(xs) {
    var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return xs;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
        var v1 = $292f8c84f8002d8c$export$b446f6baa3bb1430(v.value0.head);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $292f8c84f8002d8c$export$9cb09a71b7d66923(v.value0.tail);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $52d2aab060724108$export$8327ebbef2a0ba76($52d2aab060724108$export$8327ebbef2a0ba76(v1.value0.head)($292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$export$5fd5031fecdacec3)(v.value0.tail)))($292f8c84f8002d8c$export$9cb09a71b7d66923($52d2aab060724108$export$8327ebbef2a0ba76(v1.value0.tail)($292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$export$c01875f616615628)(v.value0.tail))));
        throw new Error("Failed pattern match at Data.List.Lazy (line 746, column 7 - line 750, column 72): " + [
            v1.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.List.Lazy (line 742, column 3 - line 750, column 72): " + [
        v.constructor.name
    ]);
};
var $292f8c84f8002d8c$export$3f063810d7bf01bd = function(eq) {
    var go = function(v) {
        if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
        if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
            var v1 = $292f8c84f8002d8c$export$afc1bfabebaf28a2(eq(v.value0))(v.value1);
            return new $52d2aab060724108$export$74c44e616647f5c0($99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1.init);
            }), $292f8c84f8002d8c$export$3f063810d7bf01bd(eq)(v1.rest));
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 576, column 3 - line 576, column 15): " + [
            v.constructor.name
        ]);
    };
    var $340 = $292f8c84f8002d8c$var$map(go);
    return function($341) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($340($292f8c84f8002d8c$var$unwrap($341)));
    };
};
var $292f8c84f8002d8c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $292f8c84f8002d8c$export$3f063810d7bf01bd($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $292f8c84f8002d8c$var$fromStep = /* #__PURE__ */ function() {
    var $342 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($73aa5dd1904ebcb7$export$28587442a46d4141);
    return function($343) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($342($343));
    };
}();
var $292f8c84f8002d8c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return new $52d2aab060724108$export$74c44e616647f5c0(x, $52d2aab060724108$export$f2c4f74e8fe88e34);
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                    var v1 = cmp(x)(v.value0);
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $292f8c84f8002d8c$export$b8bc901090d2b1d4(cmp)(x)(v.value1));
                    return new $52d2aab060724108$export$74c44e616647f5c0(x, $292f8c84f8002d8c$var$fromStep(v));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 238, column 3 - line 238, column 22): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $292f8c84f8002d8c$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $292f8c84f8002d8c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)($52d2aab060724108$export$8327ebbef2a0ba76)($52d2aab060724108$export$f2c4f74e8fe88e34);
};
var $292f8c84f8002d8c$export$a6d4c5c719005a90 = function(dictLazy) {
    var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(op) {
        return function(z) {
            var go = function(xs) {
                var v = $52d2aab060724108$export$35d34bc0ed591a92(xs);
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return defer1(function(v1) {
                    return op(v.value0)(go(v.value1));
                });
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return z;
                throw new Error("Failed pattern match at Data.List.Lazy (line 768, column 13 - line 770, column 15): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $292f8c84f8002d8c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return function(xs) {
                var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(xs);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind2(f(b)(v.value0.head))(function(b$prime) {
                    return $292f8c84f8002d8c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(v.value0.tail);
                });
                throw new Error("Failed pattern match at Data.List.Lazy (line 759, column 5 - line 762, column 54): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $292f8c84f8002d8c$export$de3a4d4a0d731119 = function(fn) {
    var go = function(n) {
        return function(list) {
            return $292f8c84f8002d8c$var$bind($292f8c84f8002d8c$export$b446f6baa3bb1430(list))(function(o) {
                var $291 = fn(o.head);
                if ($291) return $292f8c84f8002d8c$var$pure(n);
                return go(n + 1 | 0)(o.tail);
            });
        };
    };
    return go(0);
};
var $292f8c84f8002d8c$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $292f8c84f8002d8c$var$map1(function(v) {
            return ($292f8c84f8002d8c$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($292f8c84f8002d8c$export$de3a4d4a0d731119(fn)($292f8c84f8002d8c$export$66c1ae025e96b4bc(xs)));
    };
};
var $292f8c84f8002d8c$export$20098ecb074a31e6 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(p) {
        return function(list) {
            var v = $292f8c84f8002d8c$export$b446f6baa3bb1430(list);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1($52d2aab060724108$export$f2c4f74e8fe88e34);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind2(p(v.value0.head))(function(b) {
                return bind2($292f8c84f8002d8c$export$20098ecb074a31e6(dictMonad)(p)(v.value0.tail))(function(xs$prime) {
                    return pure1(function() {
                        if (b) return $52d2aab060724108$export$8327ebbef2a0ba76(v.value0.head)(xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 431, column 5 - line 436, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};
var $292f8c84f8002d8c$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $52d2aab060724108$export$c1bed610ade55e1c.value;
            }
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                if (p(v.value0)) {
                    $tco_done = true;
                    return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $292f8c84f8002d8c$export$3dea766d36a8935f(p)(v.value1));
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $copy_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                    return;
                }
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 416, column 3 - line 416, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $344 = $292f8c84f8002d8c$var$map(go);
    return function($345) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($344($292f8c84f8002d8c$var$unwrap($345)));
    };
};
var $292f8c84f8002d8c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        return function(ys) {
            return $292f8c84f8002d8c$export$3dea766d36a8935f(function(x) {
                return $292f8c84f8002d8c$var$any(eq(x))(ys);
            })(xs);
        };
    };
};
var $292f8c84f8002d8c$export$1f4807a235930d45 = function(dictEq) {
    return $292f8c84f8002d8c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $292f8c84f8002d8c$export$45273896c792ff3b = function(eq) {
    var go = function(v) {
        if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
        if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $292f8c84f8002d8c$export$45273896c792ff3b(eq)($292f8c84f8002d8c$export$3dea766d36a8935f(function(y) {
            return !eq(v.value0)(y);
        })(v.value1)));
        throw new Error("Failed pattern match at Data.List.Lazy (line 633, column 3 - line 633, column 15): " + [
            v.constructor.name
        ]);
    };
    var $346 = $292f8c84f8002d8c$var$map(go);
    return function($347) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($346($292f8c84f8002d8c$var$unwrap($347)));
    };
};
var $292f8c84f8002d8c$export$edce5881c815871 = function(dictEq) {
    return $292f8c84f8002d8c$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $292f8c84f8002d8c$export$3c57592525e2b27e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($52d2aab060724108$export$1ae88a7f3c5f59ef(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq(x)(y);
            };
        }
    };
};
var $292f8c84f8002d8c$export$21c206d752eba296 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($52d2aab060724108$export$86359cd4476084f8(dictOrd));
    var eqPattern1 = $292f8c84f8002d8c$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $292f8c84f8002d8c$export$c19d79386f4ed99a = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $292f8c84f8002d8c$export$8855a8be7bd3e9f8(function(v) {
            return eq(v)(x);
        });
    };
};
var $292f8c84f8002d8c$export$f444781b0adb7e4d = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $292f8c84f8002d8c$export$de3a4d4a0d731119(function(v) {
            return eq(v)(x);
        });
    };
};
var $292f8c84f8002d8c$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $52d2aab060724108$export$74c44e616647f5c0 && p(v.value0)) {
                $copy_v = $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                return;
            }
            $tco_done = true;
            return $292f8c84f8002d8c$var$fromStep(v);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($348) {
        return go($52d2aab060724108$export$35d34bc0ed591a92($348));
    };
};
var $292f8c84f8002d8c$export$663103110d94aac9 = function(n) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v === 0) {
                    $tco_done = true;
                    return v1;
                }
                if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $52d2aab060724108$export$c1bed610ade55e1c.value;
                }
                if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                    $tco_var_v = v - 1 | 0;
                    $copy_v1 = $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 524, column 3 - line 524, column 15): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    var $349 = $292f8c84f8002d8c$var$map(go(n));
    return function($350) {
        return $52d2aab060724108$export$54c2e3dc7acea9f5($349($292f8c84f8002d8c$var$unwrap($350)));
    };
};
var $292f8c84f8002d8c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $292f8c84f8002d8c$export$b7df5d561049483a(end - start | 0)($292f8c84f8002d8c$export$663103110d94aac9(start)(xs));
        };
    };
};
var $292f8c84f8002d8c$export$9ea2b6c3fae093d8 = function(eq) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                    if (eq(x)(v.value0)) return $52d2aab060724108$export$35d34bc0ed591a92(v.value1);
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $52d2aab060724108$export$74c44e616647f5c0(v.value0, $292f8c84f8002d8c$export$9ea2b6c3fae093d8(eq)(x)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 662, column 3 - line 662, column 15): " + [
                    v.constructor.name
                ]);
            };
            return $292f8c84f8002d8c$var$map(go)($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        return function(ys) {
            return $292f8c84f8002d8c$var$append1(xs)($292f8c84f8002d8c$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($292f8c84f8002d8c$export$9ea2b6c3fae093d8(eq)))($292f8c84f8002d8c$export$45273896c792ff3b(eq)(ys))(xs));
        };
    };
};
var $292f8c84f8002d8c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $292f8c84f8002d8c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $292f8c84f8002d8c$export$90f9093465da3136 = function(n) {
    return function(xs) {
        var go = function(v) {
            return function(v1) {
                if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                if (v === 0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, $292f8c84f8002d8c$export$90f9093465da3136(v - 1 | 0)(v1.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 350, column 3 - line 350, column 17): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
    };
};
var $292f8c84f8002d8c$export$1822828d790e23ee = function(dictEq) {
    return $292f8c84f8002d8c$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $292f8c84f8002d8c$export$acaf96a27438246b = function(dictEq) {
    return $292f8c84f8002d8c$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($292f8c84f8002d8c$export$1822828d790e23ee(dictEq)));
};
var $292f8c84f8002d8c$export$c04a9f24a4230e1f = function(xs) {
    return $292f8c84f8002d8c$var$fix(function(ys) {
        return $292f8c84f8002d8c$var$append1(xs)(ys);
    });
};
var $292f8c84f8002d8c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($292f8c84f8002d8c$var$bind1);
var $292f8c84f8002d8c$export$ee1b3e54f0441b22 = function(v) {
    return $292f8c84f8002d8c$var$bind1(v)($292f8c84f8002d8c$var$identity);
};
var $292f8c84f8002d8c$export$986c2bbe7a34be0b = /* #__PURE__ */ $292f8c84f8002d8c$export$e70771d2e7e590a($292f8c84f8002d8c$var$identity);
var $292f8c84f8002d8c$export$2dd9d44f93be5e22 = function(n) {
    return function(f) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $52d2aab060724108$export$c1bed610ade55e1c) return $52d2aab060724108$export$c1bed610ade55e1c.value;
                    if (v === 0 && v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) {
                        var v2 = f(v1.value0);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $52d2aab060724108$export$35d34bc0ed591a92(v1.value1);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $52d2aab060724108$export$74c44e616647f5c0(v2.value0, v1.value1);
                        throw new Error("Failed pattern match at Data.List.Lazy (line 382, column 22 - line 384, column 26): " + [
                            v2.constructor.name
                        ]);
                    }
                    if (v1 instanceof $52d2aab060724108$export$74c44e616647f5c0) return new $52d2aab060724108$export$74c44e616647f5c0(v1.value0, $292f8c84f8002d8c$export$2dd9d44f93be5e22(v - 1 | 0)(f)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 381, column 3 - line 381, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $292f8c84f8002d8c$var$map(go(n))($292f8c84f8002d8c$var$unwrap(xs));
        };
    };
};
var $292f8c84f8002d8c$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $292f8c84f8002d8c$export$2dd9d44f93be5e22(n)(function($351) {
            return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($351));
        });
    };
};











var $11bbe85c947c529d$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $11bbe85c947c529d$var$defer = /* #__PURE__ */ $a1e0a82f0b162743$export$260e5c0943f31606($2b6d012b5a71a466$export$e21af47273e843bd);
var $11bbe85c947c529d$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $11bbe85c947c529d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $11bbe85c947c529d$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47);
var $11bbe85c947c529d$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($2b6d012b5a71a466$export$c97488a047bfb404);
var $11bbe85c947c529d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $11bbe85c947c529d$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $11bbe85c947c529d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $11bbe85c947c529d$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $11bbe85c947c529d$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $11bbe85c947c529d$var$catchError = /* #__PURE__ */ $5dfefa023749ded0$export$3dede90624df3ba9($2b6d012b5a71a466$export$ce3dafa370e28e44);
var $11bbe85c947c529d$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($2b6d012b5a71a466$export$728b06f25edead82);
var $11bbe85c947c529d$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $11bbe85c947c529d$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($2b6d012b5a71a466$export$8808000bb50bc47);
var $11bbe85c947c529d$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $11bbe85c947c529d$var$empty = /* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($2b6d012b5a71a466$export$304c3a29e5bb9689);
var $11bbe85c947c529d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $11bbe85c947c529d$export$db22ac524b337b7 = function(p) {
    return function(msg) {
        return $11bbe85c947c529d$var$alt(p)($11bbe85c947c529d$var$defer(function(v) {
            return $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected " + msg($05149ea687d6b460$export$523c0b569236b342));
        }));
    };
};
var $11bbe85c947c529d$export$49261000d13ed9a7 = function(p) {
    return function(msg) {
        return $11bbe85c947c529d$var$alt(p)($2b6d012b5a71a466$export$2b62a06a9fee979c("Expected " + msg));
    };
};
var $11bbe85c947c529d$export$6f621483de7c32dc = function(v) {
    return function(v1, more, lift, $$throw, done) {
        return v(v1, more, lift, function(v2, v3) {
            return $$throw(new $2b6d012b5a71a466$export$c791339539b80010(v2.value0, v2.value1, v1.value2), new $2b6d012b5a71a466$export$f9c837a54db411d(v3.value0, v1.value1));
        }, done);
    };
};
var $11bbe85c947c529d$export$410a452afcd48948 = function(v) {
    return function(v1, more, lift, $$throw, done) {
        return v(v1, more, lift, function(v2, err) {
            return $$throw(new $2b6d012b5a71a466$export$c791339539b80010(v2.value0, v2.value1, v1.value2), err);
        }, done);
    };
};
var $11bbe85c947c529d$export$764f12fa29fd189c = function(p) {
    var go = function(v) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$voidLeft(p)(new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342)))($11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342)));
    };
    return $11bbe85c947c529d$var$applySecond(p)($11bbe85c947c529d$var$tailRecM(go)($05149ea687d6b460$export$523c0b569236b342));
};
var $11bbe85c947c529d$export$1871c6d98c36e478 = function(p) {
    return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$764f12fa29fd189c(p))($11bbe85c947c529d$var$pure($05149ea687d6b460$export$523c0b569236b342));
};
var $11bbe85c947c529d$export$d2ed8cc1d2e8029b = function(p) {
    return function(sep) {
        var go = function(acc) {
            var done = $11bbe85c947c529d$var$defer(function(v) {
                return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($3d4fd987da5242ff$export$66c1ae025e96b4bc(acc)));
            });
            var nextOne = $11bbe85c947c529d$var$bind(sep)(function() {
                return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$mapFlipped(p)(function(a) {
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $78c799cba34fcb8d$export$74c44e616647f5c0(a, acc));
                }))(done);
            });
            return $11bbe85c947c529d$var$alt(nextOne)(done);
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($ba51d599f79a6310$export$cc3b5f3f66225fbe(a))($11bbe85c947c529d$var$tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($11bbe85c947c529d$var$pure($ba51d599f79a6310$export$439306a4dcaafbb9(a)));
        });
    };
};
var $11bbe85c947c529d$export$3f00b9d4810f7a39 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($ba51d599f79a6310$export$effcdbd76139450)($11bbe85c947c529d$export$d2ed8cc1d2e8029b(p)(sep)))($11bbe85c947c529d$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
    };
};
var $11bbe85c947c529d$export$617220f394cba247 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$bind($11bbe85c947c529d$var$manyRec($11bbe85c947c529d$var$applySecond(sep)(p)))(function(as) {
                return $11bbe85c947c529d$var$pure($ba51d599f79a6310$export$cc3b5f3f66225fbe(a)(as));
            });
        });
    };
};
var $11bbe85c947c529d$export$a0228d318ff1a462 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$map($ba51d599f79a6310$export$effcdbd76139450)($11bbe85c947c529d$export$617220f394cba247(p)(sep)))($11bbe85c947c529d$var$pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
    };
};
var $11bbe85c947c529d$export$516e28dec6a4b6d4 = function(p) {
    return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$$$void(p))($11bbe85c947c529d$var$pure($05149ea687d6b460$export$523c0b569236b342));
};
var $11bbe85c947c529d$export$a75d1723e6bda2ec = function(a) {
    return function(p) {
        return $11bbe85c947c529d$var$alt(p)($11bbe85c947c529d$var$pure(a));
    };
};
var $11bbe85c947c529d$export$b9803a97967f594 = function(p) {
    return $11bbe85c947c529d$export$a75d1723e6bda2ec($06733ae99ed4f534$export$bebe9059409a0d04.value)($11bbe85c947c529d$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(p));
};
var $11bbe85c947c529d$export$5cdbf197bae344fe = function(p) {
    return $11bbe85c947c529d$export$410a452afcd48948($11bbe85c947c529d$var$alt($11bbe85c947c529d$var$applySecond($11bbe85c947c529d$export$410a452afcd48948(p))($2b6d012b5a71a466$export$2b62a06a9fee979c("Negated parser succeeded")))($11bbe85c947c529d$var$pure($05149ea687d6b460$export$523c0b569236b342)));
};
var $11bbe85c947c529d$export$633afda11b622955 = function(p) {
    return function(end) {
        var go = function(xs) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(end)(function(t) {
                return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9($3d4fd987da5242ff$export$66c1ae025e96b4bc(xs), t)));
            }))($11bbe85c947c529d$var$bind(p)(function(x) {
                return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, xs)));
            }));
        };
        return $11bbe85c947c529d$var$tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    };
};
var $11bbe85c947c529d$export$cf7e1b47032e4a7c = function(p) {
    return function(end) {
        var go = function(acc) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$mapFlipped(end)(function(v) {
                return new $f93520de2fa37b44$export$7fe28cb29e71bf10($3d4fd987da5242ff$export$66c1ae025e96b4bc(acc));
            }))($11bbe85c947c529d$var$mapFlipped(p)(function(x) {
                return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, acc));
            }));
        };
        return $11bbe85c947c529d$var$tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    };
};
var $11bbe85c947c529d$export$3f2c92a97f73c35a = function(from) {
    return function(to) {
        return function(p) {
            var go = function(v) {
                var $72 = v.value0 >= to;
                if ($72) return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value1))));
                return $11bbe85c947c529d$var$catchError($11bbe85c947c529d$var$bind(p(v.value0))(function(x) {
                    return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0 + 1 | 0, new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.value1))));
                }))(function(e) {
                    var $73 = v.value0 >= from;
                    if ($73) return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value1))));
                    return $11bbe85c947c529d$var$throwError(new $2b6d012b5a71a466$export$f9c837a54db411d($2b6d012b5a71a466$export$91c32f1b22d29b2d(e) + (" (at least " + ($11bbe85c947c529d$var$show(from) + (", but only parsed " + ($11bbe85c947c529d$var$show(v.value0) + ")")))), $2b6d012b5a71a466$export$f6224d1ee5ebdf6a(e)));
                });
            };
            var $76 = from > to || from < 0;
            if ($76) return $11bbe85c947c529d$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return $11bbe85c947c529d$var$tailRecM(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $11bbe85c947c529d$export$d0905e8758ea346d = function(p) {
    return function(end) {
        return $11bbe85c947c529d$var$bind(p)(function(x) {
            return $11bbe85c947c529d$var$bind($11bbe85c947c529d$export$633afda11b622955(p)(end))(function(v) {
                return $11bbe85c947c529d$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($ba51d599f79a6310$export$cc3b5f3f66225fbe(x)(v.value0), v.value1));
            });
        });
    };
};
var $11bbe85c947c529d$export$eddf5dbe069fa672 = function(p) {
    return function(end) {
        return $11bbe85c947c529d$var$apply($11bbe85c947c529d$var$map($ba51d599f79a6310$export$cc3b5f3f66225fbe)(p))($11bbe85c947c529d$export$cf7e1b47032e4a7c(p)(end));
    };
};
var $11bbe85c947c529d$export$a6482580fab70c30 = function(p) {
    return $11bbe85c947c529d$var$apply($11bbe85c947c529d$var$map($ba51d599f79a6310$export$cc3b5f3f66225fbe)(p))($11bbe85c947c529d$var$manyRec(p));
};
var $11bbe85c947c529d$export$14badfee79ea396f = $11bbe85c947c529d$var$manyRec;
var $11bbe85c947c529d$export$89c36ea49ad05bf3 = function(v) {
    return function(state1, more, lift, $$throw, done) {
        return v(state1, more, lift, function(v1, err) {
            return $$throw(state1, err);
        }, function(v1, res) {
            return done(state1, res);
        });
    };
};
var $11bbe85c947c529d$export$30acb68292ba53d0 = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$export$a6482580fab70c30($11bbe85c947c529d$var$applyFirst(p)(sep));
    };
};
var $11bbe85c947c529d$export$62391786201b0e3b = function(p) {
    return function(sep) {
        return $11bbe85c947c529d$var$manyRec($11bbe85c947c529d$var$applyFirst(p)(sep));
    };
};
var $11bbe85c947c529d$export$7a5825874deea16a = function(dictFoldable) {
    var go = function(p1) {
        return function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(p1);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($11bbe85c947c529d$var$alt(p1)(v.value0));
            throw new Error("Failed pattern match at Parsing.Combinators (line 358, column 11 - line 360, column 32): " + [
                v.constructor.name
            ]);
        };
    };
    var $95 = $06733ae99ed4f534$export$43db023a260c5e9f($11bbe85c947c529d$var$empty);
    var $96 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    return function($97) {
        return $95($96($97));
    };
};
var $11bbe85c947c529d$export$38a115df1905c022 = function(p) {
    return function(f) {
        var apply1 = function(y) {
            return function(v) {
                return v.value1(v.value0)(y);
            };
        };
        var go = function(v) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(f)(function(op) {
                return $11bbe85c947c529d$var$bind(p)(function(a) {
                    return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        last: a,
                        init: new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.last, op), v.init)
                    }));
                });
            }))($11bbe85c947c529d$var$defer(function(v1) {
                return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($11bbe85c947c529d$var$foldl(apply1)(v.last)(v.init)));
            }));
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$tailRecM(go)({
                last: a,
                init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            });
        });
    };
};
var $11bbe85c947c529d$export$d2a0d5a23b042780 = function(p) {
    return function(f) {
        return function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$38a115df1905c022(p)(f))($11bbe85c947c529d$var$pure(a));
        };
    };
};
var $11bbe85c947c529d$export$3acf224bcd43567a = function(p) {
    return function(f) {
        var go = function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$var$bind(f)(function(op) {
                return $11bbe85c947c529d$var$bind(p)(function(a$prime) {
                    return $11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(op(a)(a$prime)));
                });
            }))($11bbe85c947c529d$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(a)));
        };
        return $11bbe85c947c529d$var$bind(p)(function(a) {
            return $11bbe85c947c529d$var$tailRecM(go)(a);
        });
    };
};
var $11bbe85c947c529d$export$6f5833edc27e1eaa = function(p) {
    return function(f) {
        return function(a) {
            return $11bbe85c947c529d$var$alt($11bbe85c947c529d$export$3acf224bcd43567a(p)(f))($11bbe85c947c529d$var$pure(a));
        };
    };
};
var $11bbe85c947c529d$export$cf95c51b03f10bae = function(open) {
    return function(close) {
        return function(p) {
            return $11bbe85c947c529d$var$applyFirst($11bbe85c947c529d$var$applySecond(open)(p))(close);
        };
    };
};
var $11bbe85c947c529d$export$7fff6b5ce3920a5c = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($11bbe85c947c529d$export$49261000d13ed9a7);
var $11bbe85c947c529d$export$35d233f3b2dbf62a = function(p) {
    return $11bbe85c947c529d$var$bind($2b6d012b5a71a466$export$5880b8b5730aff45)(function(v) {
        return $11bbe85c947c529d$var$bind(p)(function(x) {
            return $11bbe85c947c529d$var$bind($2b6d012b5a71a466$export$5880b8b5730aff45)(function(v1) {
                var $92 = v1.index > v.index;
                if ($92) return $11bbe85c947c529d$var$pure(x);
                return $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected progress");
            });
        });
    });
};


// Generated by purs version 0.15.15





















// Generated by purs version 0.15.15
const $ed6295dbdc25761e$export$22dedfc55ca7a214 = function(r) {
    return "" + r;
};
const $ed6295dbdc25761e$export$f69e81cb42c99394 = function(left) {
    return function(right) {
        return function(s1) {
            return function(s2) {
                try {
                    return right(new RegExp(s1, s2));
                } catch (e) {
                    return left(e.message);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$b4d5da5f34fb77ad = function(r) {
    return r.source;
};
const $ed6295dbdc25761e$export$a0f57c1eeb878eb7 = function(r) {
    return {
        multiline: r.multiline,
        ignoreCase: r.ignoreCase,
        global: r.global,
        dotAll: r.dotAll,
        sticky: !!r.sticky,
        unicode: !!r.unicode
    };
};
const $ed6295dbdc25761e$export$e0969da9b8fb378d = function(r) {
    return function(s) {
        var lastIndex = r.lastIndex;
        var result = r.test(s);
        r.lastIndex = lastIndex;
        return result;
    };
};
const $ed6295dbdc25761e$export$46506e5af176113c = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var m = s.match(r);
                if (m == null || m.length === 0) return nothing;
                else {
                    for(var i = 0; i < m.length; i++)m[i] = m[i] == null ? nothing : just(m[i]);
                    return just(m);
                }
            };
        };
    };
};
const $ed6295dbdc25761e$export$77ad94ebf1c2b9ed = function(r) {
    return function(s1) {
        return function(s2) {
            return s2.replace(r, s1);
        };
    };
};
const $ed6295dbdc25761e$export$bad08cfccf5cc7c3 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(f) {
                return function(s) {
                    return s.replace(r, function(match) {
                        var groups = [];
                        var group, i = 1;
                        while(typeof (group = arguments[i++]) !== "number")groups.push(group == null ? nothing : just(group));
                        return f(match)(groups);
                    });
                };
            };
        };
    };
};
const $ed6295dbdc25761e$export$abe1cf074395fe09 = function(just) {
    return function(nothing) {
        return function(r) {
            return function(s) {
                var result = s.search(r);
                return result === -1 ? nothing : just(result);
            };
        };
    };
};
const $ed6295dbdc25761e$export$65980d18b75784e2 = function(r) {
    return function(s) {
        return s.split(r);
    };
};





// Generated by purs version 0.15.15





var $fb3071975af0bbe0$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $fb3071975af0bbe0$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $fb3071975af0bbe0$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($f1992c51575cdea6$export$5e87c78e215371ee);
var $fb3071975af0bbe0$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($37b880af5f4991bd$export$fa624555ca2acbc8));
var $fb3071975af0bbe0$export$8760a645d51315cb = function(x) {
    return x;
};
var $fb3071975af0bbe0$export$1aaf7eccd7f610ad = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: true
};
var $fb3071975af0bbe0$export$4bd4b47501432316 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: true,
    unicode: false
};
var $fb3071975af0bbe0$export$ea09a2a1f3b28164 = {
    show: function(v) {
        var usedFlags = $fb3071975af0bbe0$var$append([])($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.global))("global"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.ignoreCase))("ignoreCase"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.multiline))("multiline"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.dotAll))("dotAll"))($fb3071975af0bbe0$var$append($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.sticky))("sticky"))($fb3071975af0bbe0$var$voidLeft($fb3071975af0bbe0$var$guard(v.unicode))("unicode")))))));
        var $43 = $fb3071975af0bbe0$var$eq(usedFlags)([]);
        if ($43) return "noFlags";
        return "(" + ($5b07e36f812dd04b$export$ec1dc8fbeea3467e(" <> ")(usedFlags) + ")");
    }
};
var $fb3071975af0bbe0$export$69936738517d6e4e = {
    append: function(v) {
        return function(v1) {
            return {
                global: v.global || v1.global,
                ignoreCase: v.ignoreCase || v1.ignoreCase,
                multiline: v.multiline || v1.multiline,
                dotAll: v.dotAll || v1.dotAll,
                sticky: v.sticky || v1.sticky,
                unicode: v.unicode || v1.unicode
            };
        };
    }
};
var $fb3071975af0bbe0$export$77e76a4721f88dfa = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$726fd70d90b3a5b4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fb3071975af0bbe0$export$e086dccf8e77e85 = {
    global: false,
    ignoreCase: false,
    multiline: true,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$85aac2cdb4833912 = {
    mempty: $fb3071975af0bbe0$export$77e76a4721f88dfa,
    Semigroup0: function() {
        return $fb3071975af0bbe0$export$69936738517d6e4e;
    }
};
var $fb3071975af0bbe0$export$2afc0c80c8dff0e7 = {
    global: false,
    ignoreCase: true,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$90b4d2ff6acb88af = {
    global: true,
    ignoreCase: false,
    multiline: false,
    dotAll: false,
    sticky: false,
    unicode: false
};
var $fb3071975af0bbe0$export$36f4f1589a5fb413 = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e()(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)()({
    reflectSymbol: function() {
        return "unicode";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "sticky";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "multiline";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "ignoreCase";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "global";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48))()({
    reflectSymbol: function() {
        return "dotAll";
    }
})($37b880af5f4991bd$export$d7927e8ffc1afb48));
var $fb3071975af0bbe0$export$6866eb06e0b66746 = {
    global: false,
    ignoreCase: false,
    multiline: false,
    dotAll: true,
    sticky: false,
    unicode: false
};


var $03be6cc86948e3c6$export$a9b8f38109c4ed61 = {
    show: $ed6295dbdc25761e$export$22dedfc55ca7a214
};
var $03be6cc86948e3c6$export$d76128d007d19019 = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$abe1cf074395fe09($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$1b5e458140968481 = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$bad08cfccf5cc7c3($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$b6228dc14c5adf51 = function(v) {
    return function() {
        if (v.global) return "g";
        return "";
    }() + (function() {
        if (v.ignoreCase) return "i";
        return "";
    }() + (function() {
        if (v.multiline) return "m";
        return "";
    }() + (function() {
        if (v.dotAll) return "s";
        return "";
    }() + (function() {
        if (v.sticky) return "y";
        return "";
    }() + function() {
        if (v.unicode) return "u";
        return "";
    }()))));
};
var $03be6cc86948e3c6$export$17b0f4d84dbfeedf = function(s) {
    return function(f) {
        return $ed6295dbdc25761e$export$f69e81cb42c99394($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($7d4cccdf062a2261$export$19db0165690c701a.create)(s)($03be6cc86948e3c6$export$b6228dc14c5adf51(f));
    };
};
var $03be6cc86948e3c6$export$909765d3c3e4d815 = function(s) {
    return {
        global: $1a77d6934b592676$export$2344b14b097df817("g")(s),
        ignoreCase: $1a77d6934b592676$export$2344b14b097df817("i")(s),
        multiline: $1a77d6934b592676$export$2344b14b097df817("m")(s),
        dotAll: $1a77d6934b592676$export$2344b14b097df817("s")(s),
        sticky: $1a77d6934b592676$export$2344b14b097df817("y")(s),
        unicode: $1a77d6934b592676$export$2344b14b097df817("u")(s)
    };
};
var $03be6cc86948e3c6$export$4659b591c19bdf3d = /* #__PURE__ */ function() {
    return $ed6295dbdc25761e$export$46506e5af176113c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $03be6cc86948e3c6$export$ceac1d294cf61000 = function($10) {
    return $fb3071975af0bbe0$export$8760a645d51315cb($ed6295dbdc25761e$export$a0f57c1eeb878eb7($10));
};






var $ca4b6f31ec4b9857$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1);
var $ca4b6f31ec4b9857$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $ca4b6f31ec4b9857$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $ca4b6f31ec4b9857$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($f935a9866e211c00$export$be1f07c3580164c);
var $ca4b6f31ec4b9857$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($3ee2158c14339cc9$export$e200a5917becef04);
var $ca4b6f31ec4b9857$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $ca4b6f31ec4b9857$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $ca4b6f31ec4b9857$var$min = /* #__PURE__ */ $97937c29f879e68e$export$96ec731ed4dcb222($97937c29f879e68e$export$ff461bf68e7dd332);
var $ca4b6f31ec4b9857$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ca4b6f31ec4b9857$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $ca4b6f31ec4b9857$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $ca4b6f31ec4b9857$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($7d4cccdf062a2261$export$f0a413d3d6075601);
var $ca4b6f31ec4b9857$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ca4b6f31ec4b9857$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $ca4b6f31ec4b9857$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$def6059c21714f2a);
var $ca4b6f31ec4b9857$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $ca4b6f31ec4b9857$var$tailRecM = /* #__PURE__ */ $f93520de2fa37b44$export$c025cfd4cc93300b($2b6d012b5a71a466$export$c97488a047bfb404);
var $ca4b6f31ec4b9857$var$updatePosSingle = function(v) {
    return function(cp) {
        return function(after) {
            var v1 = $ca4b6f31ec4b9857$var$fromEnum(cp);
            if (v1 === 10) return {
                index: v.index + 1 | 0,
                line: v.line + 1 | 0,
                column: 1
            };
            if (v1 === 13) {
                var v2 = $3ee2158c14339cc9$export$42977f40461e1360(0)(after);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $ca4b6f31ec4b9857$var$fromEnum(v2.value0) === 10) return {
                    index: v.index + 1 | 0,
                    line: v.line,
                    column: v.column
                };
                return {
                    index: v.index + 1 | 0,
                    line: v.line + 1 | 0,
                    column: 1
                };
            }
            if (v1 === 9) return {
                index: v.index + 1 | 0,
                line: v.line,
                column: (v.column + 8 | 0) - $ca4b6f31ec4b9857$var$mod(v.column - 1 | 0)(8) | 0
            };
            return {
                index: v.index + 1 | 0,
                line: v.line,
                column: v.column + 1 | 0
            };
        };
    };
};
var $ca4b6f31ec4b9857$var$updatePosString = function($copy_pos) {
    return function($copy_before) {
        return function($copy_after) {
            var $tco_var_pos = $copy_pos;
            var $tco_var_before = $copy_before;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(pos, before, after) {
                var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(before);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return pos;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var newPos = function() {
                        if ($22d4f8ab6946d33a$export$7b1b591b262c240(v.value0.tail)) return $ca4b6f31ec4b9857$var$updatePosSingle(pos)(v.value0.head)(after);
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ca4b6f31ec4b9857$var$updatePosSingle(pos)(v.value0.head)(v.value0.tail);
                        throw new Error("Failed pattern match at Parsing.String (line 165, column 7 - line 167, column 52): ");
                    }();
                    $tco_var_pos = newPos;
                    $tco_var_before = v.value0.tail;
                    $copy_after = after;
                    return;
                }
                throw new Error("Failed pattern match at Parsing.String (line 161, column 36 - line 168, column 38): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_pos, $tco_var_before, $copy_after);
            return $tco_result;
        };
    };
};
var $ca4b6f31ec4b9857$export$566aa36e2fcdcfb9 = function(f) {
    return $8f2697950ee155e1$export$253781be9f84fbc(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v.value0);
                        if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Unexpected EOF", v.value1));
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            var $76 = f(v3.value0.head);
                            if ($76) return done(new $2b6d012b5a71a466$export$c791339539b80010(v3.value0.tail, $ca4b6f31ec4b9857$var$updatePosSingle(v.value1)(v3.value0.head)(v3.value0.tail), true), v3.value0.head);
                            return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Predicate unsatisfied", v.value1));
                        }
                        throw new Error("Failed pattern match at Parsing.String (line 136, column 7 - line 143, column 73): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$ec0bab193bdafe1 = function(f) {
    return $8f2697950ee155e1$export$253781be9f84fbc(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v.value0);
                        if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Unexpected EOF", v.value1));
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            var cp = $ca4b6f31ec4b9857$var$fromEnum(v3.value0.head);
                            var $85 = cp < 0 || cp > 65535;
                            if ($85) return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Expected Char", v.value1));
                            var ch = $ca4b6f31ec4b9857$var$fromJust($ca4b6f31ec4b9857$var$toEnum(cp));
                            var $86 = f(ch);
                            if ($86) return done(new $2b6d012b5a71a466$export$c791339539b80010(v3.value0.tail, $ca4b6f31ec4b9857$var$updatePosSingle(v.value1)(v3.value0.head)(v3.value0.tail), true), ch);
                            return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Predicate unsatisfied", v.value1));
                        }
                        throw new Error("Failed pattern match at Parsing.String (line 114, column 7 - line 129, column 75): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$37fb72b4878ecd33 = function(input) {
    return function(contextSize) {
        return function(v) {
            var v1 = function() {
                var go = function($copy_posBegin) {
                    return function($copy_lineBegin) {
                        return function($copy_posEnd) {
                            return function($copy_lineEnd) {
                                var $tco_var_posBegin = $copy_posBegin;
                                var $tco_var_lineBegin = $copy_lineBegin;
                                var $tco_var_posEnd = $copy_posEnd;
                                var $tco_done = false;
                                var $tco_result;
                                function $tco_loop(posBegin, lineBegin, posEnd, lineEnd) {
                                    var v2 = $3ee2158c14339cc9$export$b446f6baa3bb1430(lineEnd);
                                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $ca4b6f31ec4b9857$var$eq1(v2.value0.head)($3ee2158c14339cc9$export$dd1029f96c3dd62a("\n"))) {
                                        var $97 = posEnd === v.value1.index;
                                        if ($97) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd + 1 | 0,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        var $98 = posEnd > v.value1.index;
                                        if ($98) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        $tco_var_posBegin = posEnd + 1 | 0;
                                        $tco_var_lineBegin = v2.value0.tail;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $ca4b6f31ec4b9857$var$eq1(v2.value0.head)($3ee2158c14339cc9$export$dd1029f96c3dd62a("\r"))) {
                                        var $102 = posEnd === v.value1.index;
                                        if ($102) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd + 1 | 0,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        var $103 = posEnd > v.value1.index;
                                        if ($103) {
                                            $tco_done = true;
                                            return {
                                                posBegin: posBegin,
                                                posEnd: posEnd,
                                                lineBegin: lineBegin
                                            };
                                        }
                                        $tco_var_posBegin = posEnd + 1 | 0;
                                        $tco_var_lineBegin = v2.value0.tail;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                        $tco_var_posBegin = posBegin;
                                        $tco_var_lineBegin = lineBegin;
                                        $tco_var_posEnd = posEnd + 1 | 0;
                                        $copy_lineEnd = v2.value0.tail;
                                        return;
                                    }
                                    $tco_done = true;
                                    return {
                                        posBegin: posBegin,
                                        posEnd: posEnd,
                                        lineBegin: lineBegin
                                    };
                                }
                                while(!$tco_done)$tco_result = $tco_loop($tco_var_posBegin, $tco_var_lineBegin, $tco_var_posEnd, $copy_lineEnd);
                                return $tco_result;
                            };
                        };
                    };
                };
                return go(0)(input)(0)(input);
            }();
            var lineSelect = $3ee2158c14339cc9$export$b7df5d561049483a(v1.posEnd - v1.posBegin | 0)(v1.lineBegin);
            var lineLength = $3ee2158c14339cc9$export$f24224f1c91d8156(lineSelect);
            var lineIndex = v.value1.index - v1.posBegin | 0;
            var bestPosBefore = lineIndex - $ca4b6f31ec4b9857$var$div(contextSize)(2) | 0;
            var bestPosAfter = (lineIndex + $ca4b6f31ec4b9857$var$div(contextSize)(2) | 0) + function() {
                var $110 = $8d5664f12212b23e$export$74b48c691cc42eb1(contextSize);
                if ($110) return 1;
                return 0;
            }() | 0;
            var v2 = function() {
                var $111 = bestPosBefore >= 0;
                if ($111) {
                    var $112 = bestPosAfter <= lineLength;
                    if ($112) return new $71f2e2e9476163f8$export$1908877435b1d5e9(bestPosBefore, bestPosAfter);
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9($ca4b6f31ec4b9857$var$max(0)(lineLength - contextSize | 0), lineLength);
                }
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $ca4b6f31ec4b9857$var$min(lineLength)(contextSize));
            }();
            var inputContext = $3ee2158c14339cc9$export$b7df5d561049483a(v2.value1 - v2.value0 | 0)($3ee2158c14339cc9$export$663103110d94aac9(v2.value0)(lineSelect));
            return [
                v.value0 + (" at position index:" + ($ca4b6f31ec4b9857$var$show(v.value1.index) + (" (line:" + ($ca4b6f31ec4b9857$var$show(v.value1.line) + (", column:" + ($ca4b6f31ec4b9857$var$show(v.value1.column) + ")")))))),
                $5b07e36f812dd04b$export$ec1dc8fbeea3467e("")($396c4c3d9e7fae3c$export$606959e7ccb797f0(lineIndex - v2.value0 | 0)(" ")) + "\u25BC",
                inputContext
            ];
        };
    };
};
var $ca4b6f31ec4b9857$export$4659b591c19bdf3d = function(p) {
    return $ca4b6f31ec4b9857$var$bind($2b6d012b5a71a466$export$99cb5271137cc3e6)(function(v) {
        return $ca4b6f31ec4b9857$var$bind(p)(function(x) {
            return $ca4b6f31ec4b9857$var$bind($2b6d012b5a71a466$export$99cb5271137cc3e6)(function(v1) {
                return $ca4b6f31ec4b9857$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$f24224f1c91d8156(v.value0) - $092fe44bc0883be6$export$f24224f1c91d8156(v1.value0) | 0)(v.value0), x));
            });
        });
    });
};
var $ca4b6f31ec4b9857$export$d83becf4b42ec59 = /* #__PURE__ */ $8f2697950ee155e1$export$253781be9f84fbc(function(v) {
    return function(v1) {
        return function(v2) {
            return function($$throw) {
                return function(done) {
                    var $133 = $22d4f8ab6946d33a$export$7b1b591b262c240(v.value0);
                    if ($133) return done(new $2b6d012b5a71a466$export$c791339539b80010(v.value0, v.value1, true), $05149ea687d6b460$export$523c0b569236b342);
                    return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d("Expected EOF", v.value1));
                };
            };
        };
    };
});
var $ca4b6f31ec4b9857$export$9b3710c6484cace = function(f) {
    return $8f2697950ee155e1$export$253781be9f84fbc(function(v) {
        return function(v1) {
            return function(v2) {
                return function($$throw) {
                    return function(done) {
                        var v3 = f(v.value0);
                        if (v3 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $$throw(v, new $2b6d012b5a71a466$export$f9c837a54db411d(v3.value0, v.value1));
                        if (v3 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return done(new $2b6d012b5a71a466$export$c791339539b80010(v3.value0.remainder, $ca4b6f31ec4b9857$var$updatePosString(v.value1)(v3.value0.consumed)(v3.value0.remainder), !$22d4f8ab6946d33a$export$7b1b591b262c240(v3.value0.consumed)), v3.value0.value);
                        throw new Error("Failed pattern match at Parsing.String (line 286, column 7 - line 290, column 121): " + [
                            v3.constructor.name
                        ]);
                    };
                };
            };
        };
    });
};
var $ca4b6f31ec4b9857$export$17b0f4d84dbfeedf = function(pattern) {
    return function(flags) {
        return $ca4b6f31ec4b9857$var$mapFlipped($03be6cc86948e3c6$export$17b0f4d84dbfeedf("^(" + (pattern + ")"))(flags))(function(regexobj) {
            return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
                var v = $ca4b6f31ec4b9857$var$map($e39dfcf102cdca3c$export$5fd5031fecdacec3)($03be6cc86948e3c6$export$4659b591c19bdf3d(regexobj)(input));
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var remainder = $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(v.value0.value0))(input);
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        value: v.value0.value0,
                        consumed: v.value0.value0,
                        remainder: remainder
                    });
                }
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515("No Regex pattern match");
            });
        });
    };
};
var $ca4b6f31ec4b9857$export$c58417706a208278 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$9b3710c6484cace(function(consumed) {
    return new $7d4cccdf062a2261$export$19db0165690c701a({
        value: consumed,
        consumed: consumed,
        remainder: ""
    });
});
var $ca4b6f31ec4b9857$export$22b082955e083ec3 = function(str) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
        var v = $1a77d6934b592676$export$71c2a1babd78d286(str)(input);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
            value: str,
            consumed: str,
            remainder: v.value0
        });
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected " + $ca4b6f31ec4b9857$var$show1(str));
    });
};
var $ca4b6f31ec4b9857$export$7634b617e2c58e32 = function(n) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(input) {
        var v = $3ee2158c14339cc9$export$b0d75975ac0be0e1(n)(input);
        var $153 = $3ee2158c14339cc9$export$f24224f1c91d8156(v.before) === n;
        if ($153) return new $7d4cccdf062a2261$export$19db0165690c701a({
            value: v.before,
            consumed: v.before,
            remainder: v.after
        });
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Could not take " + ($ca4b6f31ec4b9857$var$show(n) + " characters"));
    });
};
var $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7 = function(c) {
    return $11bbe85c947c529d$export$49261000d13ed9a7($ca4b6f31ec4b9857$export$ec0bab193bdafe1(function(v) {
        return v === c;
    }))($ca4b6f31ec4b9857$var$show2(c));
};
var $ca4b6f31ec4b9857$export$3eeefabf9b38b449 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$566aa36e2fcdcfb9(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $ca4b6f31ec4b9857$export$cf85aa27ccfa294 = function(dictMonad) {
    return function(p) {
        var go = function(unit) {
            return $ca4b6f31ec4b9857$var$alt($ca4b6f31ec4b9857$var$bind($2b6d012b5a71a466$export$99cb5271137cc3e6)(function(v) {
                return $ca4b6f31ec4b9857$var$bind($11bbe85c947c529d$export$410a452afcd48948(p))(function(t) {
                    return $ca4b6f31ec4b9857$var$pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, t)));
                });
            }))($ca4b6f31ec4b9857$var$bind($ca4b6f31ec4b9857$export$3eeefabf9b38b449)(function() {
                return $ca4b6f31ec4b9857$var$pure(new $f93520de2fa37b44$export$550acbd06a1f5a6a(unit));
            }));
        };
        return $ca4b6f31ec4b9857$var$bind($2b6d012b5a71a466$export$99cb5271137cc3e6)(function(v) {
            return $ca4b6f31ec4b9857$var$bind($ca4b6f31ec4b9857$var$tailRecM(go)($05149ea687d6b460$export$523c0b569236b342))(function(v1) {
                return $ca4b6f31ec4b9857$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$f24224f1c91d8156(v.value0) - $092fe44bc0883be6$export$f24224f1c91d8156(v1.value0) | 0)(v.value0), v1.value1));
            });
        });
    };
};
var $ca4b6f31ec4b9857$export$3df35137cff8cab7 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$ec0bab193bdafe1(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));


// Generated by purs version 0.15.15























// Generated by purs version 0.15.15






// Generated by purs version 0.15.15

// Generated by purs version 0.15.15

var $50b5a2f2b28bbba4$export$d90166409dd04e85 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $50b5a2f2b28bbba4$export$30216c0101da0ee0 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($f935a9866e211c00$export$be1f07c3580164c);


// Generated by purs version 0.15.15








var $f87c9187b968257a$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $f87c9187b968257a$var$unsafeIndex = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $f87c9187b968257a$var$elemIndex = /* #__PURE__ */ $396c4c3d9e7fae3c$export$f444781b0adb7e4d($37b880af5f4991bd$export$e65788c6d4494539);
var $f87c9187b968257a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f87c9187b968257a$export$74fad270c4b7b59c = /* #__PURE__ */ function() {
    function NUMCAT_LU() {}
    NUMCAT_LU.value = new NUMCAT_LU();
    return NUMCAT_LU;
}();
var $f87c9187b968257a$export$d4598102ceb86c96 = /* #__PURE__ */ function() {
    function NUMCAT_LL() {}
    NUMCAT_LL.value = new NUMCAT_LL();
    return NUMCAT_LL;
}();
var $f87c9187b968257a$export$676a18bdacd919c8 = /* #__PURE__ */ function() {
    function NUMCAT_LT() {}
    NUMCAT_LT.value = new NUMCAT_LT();
    return NUMCAT_LT;
}();
var $f87c9187b968257a$export$3be55c3cc7f2867 = /* #__PURE__ */ function() {
    function NUMCAT_LM() {}
    NUMCAT_LM.value = new NUMCAT_LM();
    return NUMCAT_LM;
}();
var $f87c9187b968257a$export$20b05fa78ae7527a = /* #__PURE__ */ function() {
    function NUMCAT_LO() {}
    NUMCAT_LO.value = new NUMCAT_LO();
    return NUMCAT_LO;
}();
var $f87c9187b968257a$export$79b57d103eae7039 = /* #__PURE__ */ function() {
    function NUMCAT_MN() {}
    NUMCAT_MN.value = new NUMCAT_MN();
    return NUMCAT_MN;
}();
var $f87c9187b968257a$export$60e41f2154339dc7 = /* #__PURE__ */ function() {
    function NUMCAT_MC() {}
    NUMCAT_MC.value = new NUMCAT_MC();
    return NUMCAT_MC;
}();
var $f87c9187b968257a$export$77f7cb14f5a8a8ea = /* #__PURE__ */ function() {
    function NUMCAT_ME() {}
    NUMCAT_ME.value = new NUMCAT_ME();
    return NUMCAT_ME;
}();
var $f87c9187b968257a$export$1a1df9278c5a4522 = /* #__PURE__ */ function() {
    function NUMCAT_ND() {}
    NUMCAT_ND.value = new NUMCAT_ND();
    return NUMCAT_ND;
}();
var $f87c9187b968257a$export$ffe624f4617a733d = /* #__PURE__ */ function() {
    function NUMCAT_NL() {}
    NUMCAT_NL.value = new NUMCAT_NL();
    return NUMCAT_NL;
}();
var $f87c9187b968257a$export$21de707035b964f7 = /* #__PURE__ */ function() {
    function NUMCAT_NO() {}
    NUMCAT_NO.value = new NUMCAT_NO();
    return NUMCAT_NO;
}();
var $f87c9187b968257a$export$edda2e74149c5a6e = /* #__PURE__ */ function() {
    function NUMCAT_PC() {}
    NUMCAT_PC.value = new NUMCAT_PC();
    return NUMCAT_PC;
}();
var $f87c9187b968257a$export$8ef7193d38bceddf = /* #__PURE__ */ function() {
    function NUMCAT_PD() {}
    NUMCAT_PD.value = new NUMCAT_PD();
    return NUMCAT_PD;
}();
var $f87c9187b968257a$export$a44baae05e4dd261 = /* #__PURE__ */ function() {
    function NUMCAT_PS() {}
    NUMCAT_PS.value = new NUMCAT_PS();
    return NUMCAT_PS;
}();
var $f87c9187b968257a$export$3e12887efe278a41 = /* #__PURE__ */ function() {
    function NUMCAT_PE() {}
    NUMCAT_PE.value = new NUMCAT_PE();
    return NUMCAT_PE;
}();
var $f87c9187b968257a$export$594ecb1526fb138a = /* #__PURE__ */ function() {
    function NUMCAT_PI() {}
    NUMCAT_PI.value = new NUMCAT_PI();
    return NUMCAT_PI;
}();
var $f87c9187b968257a$export$18c5ebc155f51ada = /* #__PURE__ */ function() {
    function NUMCAT_PF() {}
    NUMCAT_PF.value = new NUMCAT_PF();
    return NUMCAT_PF;
}();
var $f87c9187b968257a$export$e57c737c9939aaf8 = /* #__PURE__ */ function() {
    function NUMCAT_PO() {}
    NUMCAT_PO.value = new NUMCAT_PO();
    return NUMCAT_PO;
}();
var $f87c9187b968257a$export$b699f9c90222e3b1 = /* #__PURE__ */ function() {
    function NUMCAT_SM() {}
    NUMCAT_SM.value = new NUMCAT_SM();
    return NUMCAT_SM;
}();
var $f87c9187b968257a$export$afd75ca7ec085208 = /* #__PURE__ */ function() {
    function NUMCAT_SC() {}
    NUMCAT_SC.value = new NUMCAT_SC();
    return NUMCAT_SC;
}();
var $f87c9187b968257a$export$fcf99045e4ea7aa7 = /* #__PURE__ */ function() {
    function NUMCAT_SK() {}
    NUMCAT_SK.value = new NUMCAT_SK();
    return NUMCAT_SK;
}();
var $f87c9187b968257a$export$cbb37359c0c92ac5 = /* #__PURE__ */ function() {
    function NUMCAT_SO() {}
    NUMCAT_SO.value = new NUMCAT_SO();
    return NUMCAT_SO;
}();
var $f87c9187b968257a$export$f359e26b05cf8d05 = /* #__PURE__ */ function() {
    function NUMCAT_ZS() {}
    NUMCAT_ZS.value = new NUMCAT_ZS();
    return NUMCAT_ZS;
}();
var $f87c9187b968257a$export$bb5b519c0a0e45c0 = /* #__PURE__ */ function() {
    function NUMCAT_ZL() {}
    NUMCAT_ZL.value = new NUMCAT_ZL();
    return NUMCAT_ZL;
}();
var $f87c9187b968257a$export$c5677ea07a95661f = /* #__PURE__ */ function() {
    function NUMCAT_ZP() {}
    NUMCAT_ZP.value = new NUMCAT_ZP();
    return NUMCAT_ZP;
}();
var $f87c9187b968257a$export$88d4031ea4604c81 = /* #__PURE__ */ function() {
    function NUMCAT_CC() {}
    NUMCAT_CC.value = new NUMCAT_CC();
    return NUMCAT_CC;
}();
var $f87c9187b968257a$export$a566777c5e1513f9 = /* #__PURE__ */ function() {
    function NUMCAT_CF() {}
    NUMCAT_CF.value = new NUMCAT_CF();
    return NUMCAT_CF;
}();
var $f87c9187b968257a$export$ef2df197b5c4ec96 = /* #__PURE__ */ function() {
    function NUMCAT_CS() {}
    NUMCAT_CS.value = new NUMCAT_CS();
    return NUMCAT_CS;
}();
var $f87c9187b968257a$export$86eb9fe5fb3b572b = /* #__PURE__ */ function() {
    function NUMCAT_CO() {}
    NUMCAT_CO.value = new NUMCAT_CO();
    return NUMCAT_CO;
}();
var $f87c9187b968257a$export$1ae025eae1298b53 = /* #__PURE__ */ function() {
    function NUMCAT_CN() {}
    NUMCAT_CN.value = new NUMCAT_CN();
    return NUMCAT_CN;
}();
var $f87c9187b968257a$export$154f02f2beb6faa8 = function(x) {
    return x;
};
var $f87c9187b968257a$export$9ed3095a7f93f608 = function(x) {
    return x;
};
var $f87c9187b968257a$export$4c3dd2d20cbe23e4 = {
    show: function(v) {
        if (v instanceof $f87c9187b968257a$export$74fad270c4b7b59c) return "NUMCAT_LU";
        if (v instanceof $f87c9187b968257a$export$d4598102ceb86c96) return "NUMCAT_LL";
        if (v instanceof $f87c9187b968257a$export$676a18bdacd919c8) return "NUMCAT_LT";
        if (v instanceof $f87c9187b968257a$export$3be55c3cc7f2867) return "NUMCAT_LM";
        if (v instanceof $f87c9187b968257a$export$20b05fa78ae7527a) return "NUMCAT_LO";
        if (v instanceof $f87c9187b968257a$export$79b57d103eae7039) return "NUMCAT_MN";
        if (v instanceof $f87c9187b968257a$export$60e41f2154339dc7) return "NUMCAT_MC";
        if (v instanceof $f87c9187b968257a$export$77f7cb14f5a8a8ea) return "NUMCAT_ME";
        if (v instanceof $f87c9187b968257a$export$1a1df9278c5a4522) return "NUMCAT_ND";
        if (v instanceof $f87c9187b968257a$export$ffe624f4617a733d) return "NUMCAT_NL";
        if (v instanceof $f87c9187b968257a$export$21de707035b964f7) return "NUMCAT_NO";
        if (v instanceof $f87c9187b968257a$export$edda2e74149c5a6e) return "NUMCAT_PC";
        if (v instanceof $f87c9187b968257a$export$8ef7193d38bceddf) return "NUMCAT_PD";
        if (v instanceof $f87c9187b968257a$export$a44baae05e4dd261) return "NUMCAT_PS";
        if (v instanceof $f87c9187b968257a$export$3e12887efe278a41) return "NUMCAT_PE";
        if (v instanceof $f87c9187b968257a$export$594ecb1526fb138a) return "NUMCAT_PI";
        if (v instanceof $f87c9187b968257a$export$18c5ebc155f51ada) return "NUMCAT_PF";
        if (v instanceof $f87c9187b968257a$export$e57c737c9939aaf8) return "NUMCAT_PO";
        if (v instanceof $f87c9187b968257a$export$b699f9c90222e3b1) return "NUMCAT_SM";
        if (v instanceof $f87c9187b968257a$export$afd75ca7ec085208) return "NUMCAT_SC";
        if (v instanceof $f87c9187b968257a$export$fcf99045e4ea7aa7) return "NUMCAT_SK";
        if (v instanceof $f87c9187b968257a$export$cbb37359c0c92ac5) return "NUMCAT_SO";
        if (v instanceof $f87c9187b968257a$export$f359e26b05cf8d05) return "NUMCAT_ZS";
        if (v instanceof $f87c9187b968257a$export$bb5b519c0a0e45c0) return "NUMCAT_ZL";
        if (v instanceof $f87c9187b968257a$export$c5677ea07a95661f) return "NUMCAT_ZP";
        if (v instanceof $f87c9187b968257a$export$88d4031ea4604c81) return "NUMCAT_CC";
        if (v instanceof $f87c9187b968257a$export$a566777c5e1513f9) return "NUMCAT_CF";
        if (v instanceof $f87c9187b968257a$export$ef2df197b5c4ec96) return "NUMCAT_CS";
        if (v instanceof $f87c9187b968257a$export$86eb9fe5fb3b572b) return "NUMCAT_CO";
        if (v instanceof $f87c9187b968257a$export$1ae025eae1298b53) return "NUMCAT_CN";
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 49, column 1 - line 79, column 31): " + [
            v.constructor.name
        ]);
    }
};
var $f87c9187b968257a$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($f87c9187b968257a$export$4c3dd2d20cbe23e4);
var $f87c9187b968257a$export$421f3f6a9cd52817 = {
    show: function(v) {
        return "ConversionRule { category: " + ($f87c9187b968257a$var$show(v.category) + (", unicodeCat: " + ($f87c9187b968257a$var$show1(v.unicodeCat) + (", possible: " + ($f87c9187b968257a$var$show(v.possible) + (", updist: " + ($f87c9187b968257a$var$show(v.updist) + (", lowdist: " + ($f87c9187b968257a$var$show(v.lowdist) + (", titledist: " + ($f87c9187b968257a$var$show(v.titledist) + " }")))))))))));
    }
};
var $f87c9187b968257a$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($f87c9187b968257a$export$421f3f6a9cd52817);
var $f87c9187b968257a$export$499a224d8474750c = {
    show: function(v) {
        return "CharBlock { start: " + ($f87c9187b968257a$var$show(v.start) + (", length: " + ($f87c9187b968257a$var$show(v.length) + (", convRule: " + ($f87c9187b968257a$var$show2(v.convRule) + " }")))));
    }
};
var $f87c9187b968257a$export$4a55201518f6815a = 7;
var $f87c9187b968257a$export$89d8ce56cc204d98 = 205;
var $f87c9187b968257a$export$7f6a2f09c9988b4f = 63;
var $f87c9187b968257a$export$7fc0e22034febfb5 = 1332;
var $f87c9187b968257a$export$d769d73966952fc5 = 3396;
var $f87c9187b968257a$export$7e18a596ae5ccbdf = 1114109;
var $f87c9187b968257a$export$8e8b15481dfb814b = 2;
var $f87c9187b968257a$export$51ebcaadb3c67176 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$8e8b15481dfb814b,
        unicodeCat: $f87c9187b968257a$export$f359e26b05cf8d05.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ba10242678b7b4dd = [
    {
        start: 32,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 160,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 5760,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8192,
        length: 11,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8239,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8287,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 12288,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    }
];
var $f87c9187b968257a$export$ca68228673da9c74 = 67108864;
var $f87c9187b968257a$export$f862c925a5027a25 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$ca68228673da9c74,
        unicodeCat: $f87c9187b968257a$export$c5677ea07a95661f.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$23cae0324393e20a = 33554432;
var $f87c9187b968257a$export$6b7d2f092933a352 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$23cae0324393e20a,
        unicodeCat: $f87c9187b968257a$export$bb5b519c0a0e45c0.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a88f47445a8e3717 = 8192;
var $f87c9187b968257a$export$d8f896e54b4d4d94 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$d7ef16e275a7be6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 1,
        updist: 0,
        lowdist: 26,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$99dabaca8c45da79 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a88f47445a8e3717,
        unicodeCat: $f87c9187b968257a$export$cbb37359c0c92ac5.value,
        possible: 1,
        updist: -26,
        lowdist: 0,
        titledist: -26
    };
}();
var $f87c9187b968257a$export$19ffa5f679fe11c0 = 64;
var $f87c9187b968257a$export$794fb0e11b7dc9ad = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$19ffa5f679fe11c0,
        unicodeCat: $f87c9187b968257a$export$b699f9c90222e3b1.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$12ed53279ee450c4 = 1024;
var $f87c9187b968257a$export$24824e665deb80e4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$12ed53279ee450c4,
        unicodeCat: $f87c9187b968257a$export$fcf99045e4ea7aa7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c3ab662ef084c6ac = 8;
var $f87c9187b968257a$export$866935d782a1adf9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c3ab662ef084c6ac,
        unicodeCat: $f87c9187b968257a$export$afd75ca7ec085208.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$657f9ea297735c46 = 16;
var $f87c9187b968257a$export$e8bb70a7af6f494 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$657f9ea297735c46,
        unicodeCat: $f87c9187b968257a$export$a44baae05e4dd261.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a143e8efcc235a35 = 4;
var $f87c9187b968257a$export$fb53d86ce7e0a34e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a143e8efcc235a35,
        unicodeCat: $f87c9187b968257a$export$e57c737c9939aaf8.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e01a543066f4428d = 32768;
var $f87c9187b968257a$export$6d507407c09b2bdb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$e01a543066f4428d,
        unicodeCat: $f87c9187b968257a$export$594ecb1526fb138a.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$845a9d462a039d1b = 262144;
var $f87c9187b968257a$export$b954bed55b55ec5c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$845a9d462a039d1b,
        unicodeCat: $f87c9187b968257a$export$18c5ebc155f51ada.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fd83b20886c8feaa = 32;
var $f87c9187b968257a$export$29b16d96ce047ca9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$fd83b20886c8feaa,
        unicodeCat: $f87c9187b968257a$export$3e12887efe278a41.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fd5605db2a5deb4d = 128;
var $f87c9187b968257a$export$3db8b2fe6cbecf3b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$fd5605db2a5deb4d,
        unicodeCat: $f87c9187b968257a$export$8ef7193d38bceddf.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$686b010d74c757cc = 2048;
var $f87c9187b968257a$export$3e4e0426de951c07 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$686b010d74c757cc,
        unicodeCat: $f87c9187b968257a$export$edda2e74149c5a6e.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b6e1d994a4b080a2 = 131072;
var $f87c9187b968257a$export$33c1a8bf25446776 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$b6e1d994a4b080a2,
        unicodeCat: $f87c9187b968257a$export$21de707035b964f7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a933a29cf15fc29a = 16777216;
var $f87c9187b968257a$export$cb3182d6558993ee = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e687e84bc5c52c67 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 1,
        updist: 0,
        lowdist: 16,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a7141f854b2c3f56 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a933a29cf15fc29a,
        unicodeCat: $f87c9187b968257a$export$ffe624f4617a733d.value,
        possible: 1,
        updist: -16,
        lowdist: 0,
        titledist: -16
    };
}();
var $f87c9187b968257a$export$a698e2e1192c5125 = 256;
var $f87c9187b968257a$export$81f55ec0bbc32b6e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$a698e2e1192c5125,
        unicodeCat: $f87c9187b968257a$export$1a1df9278c5a4522.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f3ac9c79570e46a = 2097152;
var $f87c9187b968257a$export$87fde0d9cf78d1f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f3ac9c79570e46a,
        unicodeCat: $f87c9187b968257a$export$79b57d103eae7039.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$dd16db91a51d355b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f3ac9c79570e46a,
        unicodeCat: $f87c9187b968257a$export$79b57d103eae7039.value,
        possible: 1,
        updist: 84,
        lowdist: 0,
        titledist: 84
    };
}();
var $f87c9187b968257a$export$ad5a9d75e70e6c80 = 4194304;
var $f87c9187b968257a$export$69945c68dca01b70 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$ad5a9d75e70e6c80,
        unicodeCat: $f87c9187b968257a$export$77f7cb14f5a8a8ea.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b2d990af7ab79d15 = 8388608;
var $f87c9187b968257a$export$7132832865eb9304 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$b2d990af7ab79d15,
        unicodeCat: $f87c9187b968257a$export$60e41f2154339dc7.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$87f3132a44b1d0ea = 512;
var $f87c9187b968257a$export$1532ce0136c37755 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$1ae025eae1298b53.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$679c844c5f2e021b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$36a4b98da6bb954e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9e78c7e0e3c1bda1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -60,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9568c26f20ab8b54 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3d630acc0c1aeac3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 80,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9bb9980a5fba9cf6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 15,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$663d5f91785521bc = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 48,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4373e966038dbe47 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 7264,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2f42ee7f4ae770fa = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 38864,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ea5950d132bda3cb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -3008,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$6ed378352675c85b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7615,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f07dab3e1e2f044b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b6ed7bef3aaad2a4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -74,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a2950913305bfd2f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -86,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4debf059fdd78967 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -100,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3cc60af0b8fe51fb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -112,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c251b05d03bb1b09 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -128,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$db469ad8291bc174 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -126,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c50d507ea3901971 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -7517,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c3ea2d19789db55a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8383,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$757246ae7800bfc2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -8262,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3c9855e4a4f89f58 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 28,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$7c2398d5fd516c81 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10743,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$474b42537797e1da = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -3814,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$364aece97ca575d1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10727,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5744c09a46214cda = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10780,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cbfae993dd34ee83 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10749,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a51fc7ab2fc1de9b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10783,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e0af8c92046dd53d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10782,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2b358c6ece5bacbe = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -10815,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5c0a6992d16a2cde = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -35332,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4e7f444f251bc9f3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42280,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e5aa8d48ff844b5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42308,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$56d3f806283387c4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42319,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f4c6bcc526d116d5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42315,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9b012ad386207454 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42305,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$8ecae8a612aae856 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42258,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$126aa15c1eb2342d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42282,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9d1fbeb551ba701e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42261,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b525d0e4ac5bf938 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 928,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c8d4bace2652a68 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -48,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9e706749f691962d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -42307,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$df8ee31db7227919 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -35384,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5f381834e520bfa8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 40,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f0d6a468761d4066 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 34,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$7dea77bc2e51a670 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 1,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3905653af80b0d3e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -199,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$17cb0979b5fdd87b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -121,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$acd6a2e0e1f36119 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 210,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$622de29d3b1ec6a9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 206,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e5b51f2dbdbfec58 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 205,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$6e688fec7aa0bec0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 79,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2307e0c1f6060bff = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 202,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$ee0aa35c8a71be4a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 203,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$335d579666536cd9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 207,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f0789b3782dd73b9 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 211,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$4d4410af2f036ea6 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 209,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f9bf0a40bfb66578 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 213,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$1fcc3cbf89bafa25 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 214,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$dd4c0f14baaae57 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 218,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b9e0d5ea32762a6c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 217,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$893538eb43bbf231 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 219,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$8d167c964d5a8755 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 2,
        titledist: 1
    };
}();
var $f87c9187b968257a$export$7d86d2448c3bc365 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -97,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$42cea668cab33501 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -56,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b1b9763a354df855 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -130,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$806b8f4997f947bb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 10795,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e685c0641eef8ee5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -163,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$68150a2ac77076df = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 10792,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5018e8548b89e0b8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: -195,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$b91e7d7ce718aa5e = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 69,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$d2e4e93aee941b65 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 71,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$5a8ad4756351e1a2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 32,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cb38bf493c63b044 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 116,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$1e277fd57a02853c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 38,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$cf251c63ab3fda90 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 37,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$31515a1452fded76 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 64,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c78a5306187d3d1a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$87f3132a44b1d0ea,
        unicodeCat: $f87c9187b968257a$export$74fad270c4b7b59c.value,
        possible: 1,
        updist: 0,
        lowdist: 63,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$c216bdb3b7384b3d = 524288;
var $f87c9187b968257a$export$9073887b88a95a65 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: 0,
        lowdist: -8,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$a9178d4e39cbf99b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: 0,
        lowdist: -9,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$765a30f3fb53310f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$c216bdb3b7384b3d,
        unicodeCat: $f87c9187b968257a$export$676a18bdacd919c8.value,
        possible: 1,
        updist: -1,
        lowdist: 1,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$e589cea9a12b5fd5 = 16384;
var $f87c9187b968257a$export$3ce418d90f721a6f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$e589cea9a12b5fd5,
        unicodeCat: $f87c9187b968257a$export$20b05fa78ae7527a.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$f1770ca2c5ffe2d = 1048576;
var $f87c9187b968257a$export$74a12340c61f1f97 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$f1770ca2c5ffe2d,
        unicodeCat: $f87c9187b968257a$export$3be55c3cc7f2867.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$2bb2c2963662e583 = 4096;
var $f87c9187b968257a$export$8c9d0b2e40231e86 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -37,
        lowdist: 0,
        titledist: -37
    };
}();
var $f87c9187b968257a$export$f96cf9acbd4d5317 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -31,
        lowdist: 0,
        titledist: -31
    };
}();
var $f87c9187b968257a$export$3fc150f61f8b8954 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -64,
        lowdist: 0,
        titledist: -64
    };
}();
var $f87c9187b968257a$export$a555eb1807a2d462 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -63,
        lowdist: 0,
        titledist: -63
    };
}();
var $f87c9187b968257a$export$4e1e7ce4c3737105 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -62,
        lowdist: 0,
        titledist: -62
    };
}();
var $f87c9187b968257a$export$e78c54e089b97a10 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -57,
        lowdist: 0,
        titledist: -57
    };
}();
var $f87c9187b968257a$export$10e7925a46b9a72 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -47,
        lowdist: 0,
        titledist: -47
    };
}();
var $f87c9187b968257a$export$1103c35de4bfac55 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -54,
        lowdist: 0,
        titledist: -54
    };
}();
var $f87c9187b968257a$export$9773cf18228b1a46 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -8,
        lowdist: 0,
        titledist: -8
    };
}();
var $f87c9187b968257a$export$b8ffbf54f5716e89 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -86,
        lowdist: 0,
        titledist: -86
    };
}();
var $f87c9187b968257a$export$19657fe4412c06ca = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -80,
        lowdist: 0,
        titledist: -80
    };
}();
var $f87c9187b968257a$export$541be5c98ac427fb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 7,
        lowdist: 0,
        titledist: 7
    };
}();
var $f87c9187b968257a$export$7ca1b59fddace17a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -116,
        lowdist: 0,
        titledist: -116
    };
}();
var $f87c9187b968257a$export$a40e98a4ed4424b0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -96,
        lowdist: 0,
        titledist: -96
    };
}();
var $f87c9187b968257a$export$7173d2ee342e278 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -32,
        lowdist: 0,
        titledist: -32
    };
}();
var $f87c9187b968257a$export$467bc6be00b6e5f7 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -15,
        lowdist: 0,
        titledist: -15
    };
}();
var $f87c9187b968257a$export$31855f4179a9d698 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -48,
        lowdist: 0,
        titledist: -48
    };
}();
var $f87c9187b968257a$export$659683f76ff91445 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 3008,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$959ab01c5a7aed98 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6254,
        lowdist: 0,
        titledist: -6254
    };
}();
var $f87c9187b968257a$export$4b86aace1bd7e1bd = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6253,
        lowdist: 0,
        titledist: -6253
    };
}();
var $f87c9187b968257a$export$af46a44506145125 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6244,
        lowdist: 0,
        titledist: -6244
    };
}();
var $f87c9187b968257a$export$5b58a7342deeffb1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6242,
        lowdist: 0,
        titledist: -6242
    };
}();
var $f87c9187b968257a$export$ce586bf4d1a1e66 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6243,
        lowdist: 0,
        titledist: -6243
    };
}();
var $f87c9187b968257a$export$2da14ab05c277ce3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6236,
        lowdist: 0,
        titledist: -6236
    };
}();
var $f87c9187b968257a$export$50efda91b0b7cb4d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -6181,
        lowdist: 0,
        titledist: -6181
    };
}();
var $f87c9187b968257a$export$a003c458cd158704 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35266,
        lowdist: 0,
        titledist: 35266
    };
}();
var $f87c9187b968257a$export$72fbf6834eb62a3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35332,
        lowdist: 0,
        titledist: 35332
    };
}();
var $f87c9187b968257a$export$a54f88f7b56ccb1b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 3814,
        lowdist: 0,
        titledist: 3814
    };
}();
var $f87c9187b968257a$export$1630391a83c31f3f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 35384,
        lowdist: 0,
        titledist: 35384
    };
}();
var $f87c9187b968257a$export$77879d885a56be5b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -59,
        lowdist: 0,
        titledist: -59
    };
}();
var $f87c9187b968257a$export$2bf374c619a884c0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 8,
        lowdist: 0,
        titledist: 8
    };
}();
var $f87c9187b968257a$export$5d5cff08baa82bb3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 74,
        lowdist: 0,
        titledist: 74
    };
}();
var $f87c9187b968257a$export$30cbf10eadff8354 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 86,
        lowdist: 0,
        titledist: 86
    };
}();
var $f87c9187b968257a$export$625a4e9662bb8009 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 100,
        lowdist: 0,
        titledist: 100
    };
}();
var $f87c9187b968257a$export$bfd29a26bb9c7604 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 128,
        lowdist: 0,
        titledist: 128
    };
}();
var $f87c9187b968257a$export$84e329f80ee32d86 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 112,
        lowdist: 0,
        titledist: 112
    };
}();
var $f87c9187b968257a$export$ec097e7d1326c9d8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 126,
        lowdist: 0,
        titledist: 126
    };
}();
var $f87c9187b968257a$export$14cf3cf7fed1ce4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 9,
        lowdist: 0,
        titledist: 9
    };
}();
var $f87c9187b968257a$export$847447ed9edca5f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -7205,
        lowdist: 0,
        titledist: -7205
    };
}();
var $f87c9187b968257a$export$3f567b3eda4c98ad = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -28,
        lowdist: 0,
        titledist: -28
    };
}();
var $f87c9187b968257a$export$3cf8e408ecc23ac8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -10795,
        lowdist: 0,
        titledist: -10795
    };
}();
var $f87c9187b968257a$export$625d51f562fcdce = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -10792,
        lowdist: 0,
        titledist: -10792
    };
}();
var $f87c9187b968257a$export$26575529bb6b00f3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 743,
        lowdist: 0,
        titledist: 743
    };
}();
var $f87c9187b968257a$export$7c5cb8ca51bc2320 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -7264,
        lowdist: 0,
        titledist: -7264
    };
}();
var $f87c9187b968257a$export$3eb062d0712525b5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 48,
        lowdist: 0,
        titledist: 48
    };
}();
var $f87c9187b968257a$export$4b12fa44376611d5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -928,
        lowdist: 0,
        titledist: -928
    };
}();
var $f87c9187b968257a$export$5b2d7b2d5041cd36 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -38864,
        lowdist: 0,
        titledist: -38864
    };
}();
var $f87c9187b968257a$export$d27b372c28d7cd4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$fb16bdb144aa72d1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -40,
        lowdist: 0,
        titledist: -40
    };
}();
var $f87c9187b968257a$export$2a95711cd575be0d = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -34,
        lowdist: 0,
        titledist: -34
    };
}();
var $f87c9187b968257a$export$faf1fbc46b682d31 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 121,
        lowdist: 0,
        titledist: 121
    };
}();
var $f87c9187b968257a$export$ad90e8d621d1d2f5 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -1,
        lowdist: 0,
        titledist: -1
    };
}();
var $f87c9187b968257a$export$825149518e5256a = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -232,
        lowdist: 0,
        titledist: -232
    };
}();
var $f87c9187b968257a$export$498eb5d479bb7ce7 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -300,
        lowdist: 0,
        titledist: -300
    };
}();
var $f87c9187b968257a$export$86720d766a71c0f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 195,
        lowdist: 0,
        titledist: 195
    };
}();
var $f87c9187b968257a$export$5c6d53f26f6a0003 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 97,
        lowdist: 0,
        titledist: 97
    };
}();
var $f87c9187b968257a$export$c3f89e13d99585be = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 163,
        lowdist: 0,
        titledist: 163
    };
}();
var $f87c9187b968257a$export$f540d74c78ee7c6f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 130,
        lowdist: 0,
        titledist: 130
    };
}();
var $f87c9187b968257a$export$60fbc66d1ed52465 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 56,
        lowdist: 0,
        titledist: 56
    };
}();
var $f87c9187b968257a$export$518ccb34de7e3cbb = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -2,
        lowdist: 0,
        titledist: -1
    };
}();
var $f87c9187b968257a$export$e943da14442eb991 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -79,
        lowdist: 0,
        titledist: -79
    };
}();
var $f87c9187b968257a$export$b5d11fd411ae7308 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10815,
        lowdist: 0,
        titledist: 10815
    };
}();
var $f87c9187b968257a$export$43152f1584a84996 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10783,
        lowdist: 0,
        titledist: 10783
    };
}();
var $f87c9187b968257a$export$fc83989919685fe0 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10780,
        lowdist: 0,
        titledist: 10780
    };
}();
var $f87c9187b968257a$export$19fce1b8696a0382 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10782,
        lowdist: 0,
        titledist: 10782
    };
}();
var $f87c9187b968257a$export$5858d445afcb1060 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -210,
        lowdist: 0,
        titledist: -210
    };
}();
var $f87c9187b968257a$export$7d23753ed8606c3c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -206,
        lowdist: 0,
        titledist: -206
    };
}();
var $f87c9187b968257a$export$b0442e2b6e2e396f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -205,
        lowdist: 0,
        titledist: -205
    };
}();
var $f87c9187b968257a$export$994a8a9eebf1e80f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -202,
        lowdist: 0,
        titledist: -202
    };
}();
var $f87c9187b968257a$export$f4cdedc47d618c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -203,
        lowdist: 0,
        titledist: -203
    };
}();
var $f87c9187b968257a$export$edf7537a5466cbbd = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42319,
        lowdist: 0,
        titledist: 42319
    };
}();
var $f87c9187b968257a$export$8a875ec5816630ca = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42315,
        lowdist: 0,
        titledist: 42315
    };
}();
var $f87c9187b968257a$export$5f2cc4a9566fc84f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -207,
        lowdist: 0,
        titledist: -207
    };
}();
var $f87c9187b968257a$export$77796939240e1153 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42280,
        lowdist: 0,
        titledist: 42280
    };
}();
var $f87c9187b968257a$export$87bde82168b7b62f = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42308,
        lowdist: 0,
        titledist: 42308
    };
}();
var $f87c9187b968257a$export$bfd284cd195987b2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -209,
        lowdist: 0,
        titledist: -209
    };
}();
var $f87c9187b968257a$export$9bce57c33159db29 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -211,
        lowdist: 0,
        titledist: -211
    };
}();
var $f87c9187b968257a$export$beaa5bc52e18b6f8 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10743,
        lowdist: 0,
        titledist: 10743
    };
}();
var $f87c9187b968257a$export$6fd5d6fa96b32e1c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42305,
        lowdist: 0,
        titledist: 42305
    };
}();
var $f87c9187b968257a$export$bff6f6acb9080a71 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10749,
        lowdist: 0,
        titledist: 10749
    };
}();
var $f87c9187b968257a$export$47c98be6407fc86b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -213,
        lowdist: 0,
        titledist: -213
    };
}();
var $f87c9187b968257a$export$bdfd084f94b8abe4 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -214,
        lowdist: 0,
        titledist: -214
    };
}();
var $f87c9187b968257a$export$8da9e42c98688195 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 10727,
        lowdist: 0,
        titledist: 10727
    };
}();
var $f87c9187b968257a$export$86b5f28b6c0e0fc1 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -218,
        lowdist: 0,
        titledist: -218
    };
}();
var $f87c9187b968257a$export$a2aa412b2731fae3 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42307,
        lowdist: 0,
        titledist: 42307
    };
}();
var $f87c9187b968257a$export$9b9a33d1752912b = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42282,
        lowdist: 0,
        titledist: 42282
    };
}();
var $f87c9187b968257a$export$5785034bbc9842fc = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -69,
        lowdist: 0,
        titledist: -69
    };
}();
var $f87c9187b968257a$export$13d1ec53b7904ae2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -217,
        lowdist: 0,
        titledist: -217
    };
}();
var $f87c9187b968257a$export$21ce3a5d14104c9c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -71,
        lowdist: 0,
        titledist: -71
    };
}();
var $f87c9187b968257a$export$db5c3b84d1bf1368 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -219,
        lowdist: 0,
        titledist: -219
    };
}();
var $f87c9187b968257a$export$ee9294eaaf9c94c2 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42261,
        lowdist: 0,
        titledist: 42261
    };
}();
var $f87c9187b968257a$export$8e30aa3c367beb33 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: 42258,
        lowdist: 0,
        titledist: 42258
    };
}();
var $f87c9187b968257a$export$66d8fe2369335850 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$2bb2c2963662e583,
        unicodeCat: $f87c9187b968257a$export$d4598102ceb86c96.value,
        possible: 1,
        updist: -38,
        lowdist: 0,
        titledist: -38
    };
}();
var $f87c9187b968257a$export$1f5712044a662533 = 134217728;
var $f87c9187b968257a$export$8664fc4768208d13 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$1f5712044a662533,
        unicodeCat: $f87c9187b968257a$export$ef2df197b5c4ec96.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$9b456472c58eac67 = 268435456;
var $f87c9187b968257a$export$d3f5d9ad8c1cc11c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$9b456472c58eac67,
        unicodeCat: $f87c9187b968257a$export$86eb9fe5fb3b572b.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$80ab533b3ecfc10d = 65536;
var $f87c9187b968257a$export$def784bda4c4ba83 = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$80ab533b3ecfc10d,
        unicodeCat: $f87c9187b968257a$export$a566777c5e1513f9.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$3546ca4e02dbfe5f = 1;
var $f87c9187b968257a$export$516a0353e84e6d2c = /* #__PURE__ */ function() {
    return {
        category: $f87c9187b968257a$export$3546ca4e02dbfe5f,
        unicodeCat: $f87c9187b968257a$export$88d4031ea4604c81.value,
        possible: 0,
        updist: 0,
        lowdist: 0,
        titledist: 0
    };
}();
var $f87c9187b968257a$export$bfccab8956ac9f85 = [
    {
        start: 65,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 97,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 181,
        length: 1,
        convRule: $f87c9187b968257a$export$26575529bb6b00f3
    },
    {
        start: 192,
        length: 23,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 216,
        length: 7,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 224,
        length: 23,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 248,
        length: 7,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 255,
        length: 1,
        convRule: $f87c9187b968257a$export$faf1fbc46b682d31
    },
    {
        start: 256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 304,
        length: 1,
        convRule: $f87c9187b968257a$export$3905653af80b0d3e
    },
    {
        start: 305,
        length: 1,
        convRule: $f87c9187b968257a$export$825149518e5256a
    },
    {
        start: 306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 313,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 314,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 315,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 316,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 317,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 318,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 319,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 320,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 321,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 322,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 323,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 324,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 325,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 326,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 327,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 328,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 330,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 331,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 332,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 333,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 334,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 335,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 336,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 337,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 338,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 339,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 340,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 341,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 342,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 343,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 344,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 345,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 346,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 347,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 348,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 349,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 350,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 351,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 352,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 353,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 354,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 355,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 356,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 357,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 358,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 359,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 362,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 363,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 364,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 365,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 366,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 367,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 368,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 369,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 370,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 371,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 372,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 373,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 374,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 375,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 376,
        length: 1,
        convRule: $f87c9187b968257a$export$17cb0979b5fdd87b
    },
    {
        start: 377,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 378,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 379,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 380,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 383,
        length: 1,
        convRule: $f87c9187b968257a$export$498eb5d479bb7ce7
    },
    {
        start: 384,
        length: 1,
        convRule: $f87c9187b968257a$export$86720d766a71c0f
    },
    {
        start: 385,
        length: 1,
        convRule: $f87c9187b968257a$export$acd6a2e0e1f36119
    },
    {
        start: 386,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 387,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 388,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 389,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 390,
        length: 1,
        convRule: $f87c9187b968257a$export$622de29d3b1ec6a9
    },
    {
        start: 391,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 392,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 393,
        length: 2,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 395,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 396,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 398,
        length: 1,
        convRule: $f87c9187b968257a$export$6e688fec7aa0bec0
    },
    {
        start: 399,
        length: 1,
        convRule: $f87c9187b968257a$export$2307e0c1f6060bff
    },
    {
        start: 400,
        length: 1,
        convRule: $f87c9187b968257a$export$ee0aa35c8a71be4a
    },
    {
        start: 401,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 402,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 403,
        length: 1,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 404,
        length: 1,
        convRule: $f87c9187b968257a$export$335d579666536cd9
    },
    {
        start: 405,
        length: 1,
        convRule: $f87c9187b968257a$export$5c6d53f26f6a0003
    },
    {
        start: 406,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 407,
        length: 1,
        convRule: $f87c9187b968257a$export$4d4410af2f036ea6
    },
    {
        start: 408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 410,
        length: 1,
        convRule: $f87c9187b968257a$export$c3f89e13d99585be
    },
    {
        start: 412,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 413,
        length: 1,
        convRule: $f87c9187b968257a$export$f9bf0a40bfb66578
    },
    {
        start: 414,
        length: 1,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 415,
        length: 1,
        convRule: $f87c9187b968257a$export$1fcc3cbf89bafa25
    },
    {
        start: 416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 422,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 423,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 424,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 425,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 430,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 431,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 432,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 433,
        length: 2,
        convRule: $f87c9187b968257a$export$b9e0d5ea32762a6c
    },
    {
        start: 435,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 436,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 437,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 438,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 439,
        length: 1,
        convRule: $f87c9187b968257a$export$893538eb43bbf231
    },
    {
        start: 440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 447,
        length: 1,
        convRule: $f87c9187b968257a$export$60fbc66d1ed52465
    },
    {
        start: 452,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 453,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 454,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 455,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 456,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 457,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 458,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 459,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 460,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 461,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 462,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 463,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 464,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 465,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 466,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 467,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 468,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 469,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 470,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 471,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 472,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 473,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 474,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 475,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 476,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 477,
        length: 1,
        convRule: $f87c9187b968257a$export$e943da14442eb991
    },
    {
        start: 478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 492,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 493,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 494,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 495,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 497,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 498,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 499,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 500,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 501,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 502,
        length: 1,
        convRule: $f87c9187b968257a$export$7d86d2448c3bc365
    },
    {
        start: 503,
        length: 1,
        convRule: $f87c9187b968257a$export$42cea668cab33501
    },
    {
        start: 504,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 505,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 508,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 509,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 510,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 511,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 512,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 513,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 514,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 515,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 516,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 517,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 518,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 519,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 520,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 521,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 522,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 523,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 524,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 525,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 526,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 527,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 528,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 529,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 530,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 531,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 532,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 533,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 534,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 535,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 536,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 537,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 538,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 539,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 540,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 541,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 542,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 543,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 544,
        length: 1,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 546,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 547,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 548,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 549,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 550,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 551,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 552,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 553,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 554,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 555,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 556,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 557,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 558,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 559,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 570,
        length: 1,
        convRule: $f87c9187b968257a$export$806b8f4997f947bb
    },
    {
        start: 571,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 572,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 573,
        length: 1,
        convRule: $f87c9187b968257a$export$e685c0641eef8ee5
    },
    {
        start: 574,
        length: 1,
        convRule: $f87c9187b968257a$export$68150a2ac77076df
    },
    {
        start: 575,
        length: 2,
        convRule: $f87c9187b968257a$export$b5d11fd411ae7308
    },
    {
        start: 577,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 578,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 579,
        length: 1,
        convRule: $f87c9187b968257a$export$5018e8548b89e0b8
    },
    {
        start: 580,
        length: 1,
        convRule: $f87c9187b968257a$export$b91e7d7ce718aa5e
    },
    {
        start: 581,
        length: 1,
        convRule: $f87c9187b968257a$export$d2e4e93aee941b65
    },
    {
        start: 582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 592,
        length: 1,
        convRule: $f87c9187b968257a$export$43152f1584a84996
    },
    {
        start: 593,
        length: 1,
        convRule: $f87c9187b968257a$export$fc83989919685fe0
    },
    {
        start: 594,
        length: 1,
        convRule: $f87c9187b968257a$export$19fce1b8696a0382
    },
    {
        start: 595,
        length: 1,
        convRule: $f87c9187b968257a$export$5858d445afcb1060
    },
    {
        start: 596,
        length: 1,
        convRule: $f87c9187b968257a$export$7d23753ed8606c3c
    },
    {
        start: 598,
        length: 2,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 601,
        length: 1,
        convRule: $f87c9187b968257a$export$994a8a9eebf1e80f
    },
    {
        start: 603,
        length: 1,
        convRule: $f87c9187b968257a$export$f4cdedc47d618c
    },
    {
        start: 604,
        length: 1,
        convRule: $f87c9187b968257a$export$edf7537a5466cbbd
    },
    {
        start: 608,
        length: 1,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 609,
        length: 1,
        convRule: $f87c9187b968257a$export$8a875ec5816630ca
    },
    {
        start: 611,
        length: 1,
        convRule: $f87c9187b968257a$export$5f2cc4a9566fc84f
    },
    {
        start: 613,
        length: 1,
        convRule: $f87c9187b968257a$export$77796939240e1153
    },
    {
        start: 614,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 616,
        length: 1,
        convRule: $f87c9187b968257a$export$bfd284cd195987b2
    },
    {
        start: 617,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 618,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 619,
        length: 1,
        convRule: $f87c9187b968257a$export$beaa5bc52e18b6f8
    },
    {
        start: 620,
        length: 1,
        convRule: $f87c9187b968257a$export$6fd5d6fa96b32e1c
    },
    {
        start: 623,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 625,
        length: 1,
        convRule: $f87c9187b968257a$export$bff6f6acb9080a71
    },
    {
        start: 626,
        length: 1,
        convRule: $f87c9187b968257a$export$47c98be6407fc86b
    },
    {
        start: 629,
        length: 1,
        convRule: $f87c9187b968257a$export$bdfd084f94b8abe4
    },
    {
        start: 637,
        length: 1,
        convRule: $f87c9187b968257a$export$8da9e42c98688195
    },
    {
        start: 640,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 642,
        length: 1,
        convRule: $f87c9187b968257a$export$a2aa412b2731fae3
    },
    {
        start: 643,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 647,
        length: 1,
        convRule: $f87c9187b968257a$export$9b9a33d1752912b
    },
    {
        start: 648,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 649,
        length: 1,
        convRule: $f87c9187b968257a$export$5785034bbc9842fc
    },
    {
        start: 650,
        length: 2,
        convRule: $f87c9187b968257a$export$13d1ec53b7904ae2
    },
    {
        start: 652,
        length: 1,
        convRule: $f87c9187b968257a$export$21ce3a5d14104c9c
    },
    {
        start: 658,
        length: 1,
        convRule: $f87c9187b968257a$export$db5c3b84d1bf1368
    },
    {
        start: 669,
        length: 1,
        convRule: $f87c9187b968257a$export$ee9294eaaf9c94c2
    },
    {
        start: 670,
        length: 1,
        convRule: $f87c9187b968257a$export$8e30aa3c367beb33
    },
    {
        start: 837,
        length: 1,
        convRule: $f87c9187b968257a$export$dd16db91a51d355b
    },
    {
        start: 880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 891,
        length: 3,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 895,
        length: 1,
        convRule: $f87c9187b968257a$export$cb38bf493c63b044
    },
    {
        start: 902,
        length: 1,
        convRule: $f87c9187b968257a$export$1e277fd57a02853c
    },
    {
        start: 904,
        length: 3,
        convRule: $f87c9187b968257a$export$cf251c63ab3fda90
    },
    {
        start: 908,
        length: 1,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 910,
        length: 2,
        convRule: $f87c9187b968257a$export$c78a5306187d3d1a
    },
    {
        start: 913,
        length: 17,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 931,
        length: 9,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 940,
        length: 1,
        convRule: $f87c9187b968257a$export$66d8fe2369335850
    },
    {
        start: 941,
        length: 3,
        convRule: $f87c9187b968257a$export$8c9d0b2e40231e86
    },
    {
        start: 945,
        length: 17,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 962,
        length: 1,
        convRule: $f87c9187b968257a$export$f96cf9acbd4d5317
    },
    {
        start: 963,
        length: 9,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 972,
        length: 1,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 973,
        length: 2,
        convRule: $f87c9187b968257a$export$a555eb1807a2d462
    },
    {
        start: 975,
        length: 1,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 976,
        length: 1,
        convRule: $f87c9187b968257a$export$4e1e7ce4c3737105
    },
    {
        start: 977,
        length: 1,
        convRule: $f87c9187b968257a$export$e78c54e089b97a10
    },
    {
        start: 981,
        length: 1,
        convRule: $f87c9187b968257a$export$10e7925a46b9a72
    },
    {
        start: 982,
        length: 1,
        convRule: $f87c9187b968257a$export$1103c35de4bfac55
    },
    {
        start: 983,
        length: 1,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 984,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 985,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 986,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 987,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 988,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 989,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 990,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 991,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 992,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 993,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 994,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 995,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 996,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 997,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 998,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 999,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1000,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1001,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1002,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1003,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1004,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1005,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1006,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1007,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1008,
        length: 1,
        convRule: $f87c9187b968257a$export$b8ffbf54f5716e89
    },
    {
        start: 1009,
        length: 1,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1010,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 1011,
        length: 1,
        convRule: $f87c9187b968257a$export$7ca1b59fddace17a
    },
    {
        start: 1012,
        length: 1,
        convRule: $f87c9187b968257a$export$9e78c7e0e3c1bda1
    },
    {
        start: 1013,
        length: 1,
        convRule: $f87c9187b968257a$export$a40e98a4ed4424b0
    },
    {
        start: 1015,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1016,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1017,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 1018,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1019,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1021,
        length: 3,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 1024,
        length: 16,
        convRule: $f87c9187b968257a$export$3d630acc0c1aeac3
    },
    {
        start: 1040,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 1072,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 1104,
        length: 16,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1120,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1121,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1122,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1123,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1124,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1125,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1126,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1127,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1128,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1129,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1130,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1131,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1132,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1133,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1134,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1135,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1136,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1137,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1138,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1139,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1140,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1141,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1142,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1143,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1144,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1145,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1146,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1147,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1148,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1149,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1150,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1151,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1152,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1153,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1162,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1163,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1164,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1165,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1166,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1167,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1168,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1169,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1170,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1171,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1172,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1173,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1174,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1175,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1176,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1177,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1178,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1179,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1180,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1181,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1182,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1183,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1184,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1185,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1186,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1187,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1188,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1189,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1190,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1191,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1192,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1193,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1194,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1195,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1196,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1197,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1198,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1199,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1200,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1201,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1202,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1203,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1204,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1205,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1206,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1207,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1208,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1209,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1210,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1211,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1212,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1213,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1214,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1215,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1216,
        length: 1,
        convRule: $f87c9187b968257a$export$9bb9980a5fba9cf6
    },
    {
        start: 1217,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1218,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1219,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1220,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1221,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1222,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1223,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1224,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1225,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1226,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1227,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1228,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1229,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1230,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1231,
        length: 1,
        convRule: $f87c9187b968257a$export$467bc6be00b6e5f7
    },
    {
        start: 1232,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1233,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1234,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1235,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1236,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1237,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1238,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1239,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1240,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1241,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1242,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1243,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1244,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1245,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1246,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1247,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1248,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1249,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1250,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1251,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1252,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1253,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1254,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1255,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1304,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1305,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1312,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1313,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1314,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1315,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1316,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1317,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1318,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1319,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1320,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1321,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1322,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1323,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1324,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1325,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1326,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1327,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1329,
        length: 38,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 1377,
        length: 38,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 4256,
        length: 38,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4295,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4301,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4304,
        length: 43,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4349,
        length: 3,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 5024,
        length: 80,
        convRule: $f87c9187b968257a$export$2f42ee7f4ae770fa
    },
    {
        start: 5104,
        length: 6,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 5112,
        length: 6,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 7296,
        length: 1,
        convRule: $f87c9187b968257a$export$959ab01c5a7aed98
    },
    {
        start: 7297,
        length: 1,
        convRule: $f87c9187b968257a$export$4b86aace1bd7e1bd
    },
    {
        start: 7298,
        length: 1,
        convRule: $f87c9187b968257a$export$af46a44506145125
    },
    {
        start: 7299,
        length: 2,
        convRule: $f87c9187b968257a$export$5b58a7342deeffb1
    },
    {
        start: 7301,
        length: 1,
        convRule: $f87c9187b968257a$export$ce586bf4d1a1e66
    },
    {
        start: 7302,
        length: 1,
        convRule: $f87c9187b968257a$export$2da14ab05c277ce3
    },
    {
        start: 7303,
        length: 1,
        convRule: $f87c9187b968257a$export$50efda91b0b7cb4d
    },
    {
        start: 7304,
        length: 1,
        convRule: $f87c9187b968257a$export$a003c458cd158704
    },
    {
        start: 7312,
        length: 43,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7357,
        length: 3,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7545,
        length: 1,
        convRule: $f87c9187b968257a$export$72fbf6834eb62a3
    },
    {
        start: 7549,
        length: 1,
        convRule: $f87c9187b968257a$export$a54f88f7b56ccb1b
    },
    {
        start: 7566,
        length: 1,
        convRule: $f87c9187b968257a$export$1630391a83c31f3f
    },
    {
        start: 7680,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7681,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7682,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7683,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7684,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7685,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7686,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7687,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7688,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7689,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7690,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7691,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7692,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7693,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7694,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7695,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7696,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7697,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7698,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7699,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7700,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7701,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7702,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7703,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7704,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7705,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7706,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7707,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7708,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7709,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7710,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7711,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7712,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7713,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7714,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7715,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7716,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7717,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7718,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7719,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7720,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7721,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7722,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7723,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7724,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7725,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7726,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7727,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7728,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7729,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7730,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7731,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7732,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7733,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7734,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7735,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7736,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7737,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7738,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7739,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7740,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7741,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7742,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7743,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7744,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7745,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7746,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7747,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7748,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7749,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7750,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7751,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7752,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7753,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7754,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7755,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7756,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7757,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7758,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7759,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7760,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7761,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7762,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7763,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7764,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7765,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7766,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7767,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7768,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7769,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7770,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7771,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7772,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7773,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7774,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7775,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7776,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7777,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7778,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7779,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7780,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7781,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7782,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7783,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7784,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7785,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7800,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7801,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7835,
        length: 1,
        convRule: $f87c9187b968257a$export$77879d885a56be5b
    },
    {
        start: 7838,
        length: 1,
        convRule: $f87c9187b968257a$export$6ed378352675c85b
    },
    {
        start: 7840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7864,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7865,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7866,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7867,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7868,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7869,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7870,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7871,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7872,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7873,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7874,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7875,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7876,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7877,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7888,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7889,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7890,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7891,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7892,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7893,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7894,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7895,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7900,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7901,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7922,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7923,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7924,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7925,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7926,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7927,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7928,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7929,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7930,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7931,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7936,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7944,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7952,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7960,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7968,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7976,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7984,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7992,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8000,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8008,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8017,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8019,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8021,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8023,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8025,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8027,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8029,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8031,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8032,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8040,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8048,
        length: 2,
        convRule: $f87c9187b968257a$export$5d5cff08baa82bb3
    },
    {
        start: 8050,
        length: 4,
        convRule: $f87c9187b968257a$export$30cbf10eadff8354
    },
    {
        start: 8054,
        length: 2,
        convRule: $f87c9187b968257a$export$625a4e9662bb8009
    },
    {
        start: 8056,
        length: 2,
        convRule: $f87c9187b968257a$export$bfd29a26bb9c7604
    },
    {
        start: 8058,
        length: 2,
        convRule: $f87c9187b968257a$export$84e329f80ee32d86
    },
    {
        start: 8060,
        length: 2,
        convRule: $f87c9187b968257a$export$ec097e7d1326c9d8
    },
    {
        start: 8064,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8072,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8080,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8088,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8096,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8104,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8112,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8115,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8120,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8122,
        length: 2,
        convRule: $f87c9187b968257a$export$b6ed7bef3aaad2a4
    },
    {
        start: 8124,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8126,
        length: 1,
        convRule: $f87c9187b968257a$export$847447ed9edca5f
    },
    {
        start: 8131,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8136,
        length: 4,
        convRule: $f87c9187b968257a$export$a2950913305bfd2f
    },
    {
        start: 8140,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8144,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8152,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8154,
        length: 2,
        convRule: $f87c9187b968257a$export$4debf059fdd78967
    },
    {
        start: 8160,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8165,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 8168,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8170,
        length: 2,
        convRule: $f87c9187b968257a$export$3cc60af0b8fe51fb
    },
    {
        start: 8172,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 8179,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8184,
        length: 2,
        convRule: $f87c9187b968257a$export$c251b05d03bb1b09
    },
    {
        start: 8186,
        length: 2,
        convRule: $f87c9187b968257a$export$db469ad8291bc174
    },
    {
        start: 8188,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8486,
        length: 1,
        convRule: $f87c9187b968257a$export$c50d507ea3901971
    },
    {
        start: 8490,
        length: 1,
        convRule: $f87c9187b968257a$export$c3ea2d19789db55a
    },
    {
        start: 8491,
        length: 1,
        convRule: $f87c9187b968257a$export$757246ae7800bfc2
    },
    {
        start: 8498,
        length: 1,
        convRule: $f87c9187b968257a$export$3c9855e4a4f89f58
    },
    {
        start: 8526,
        length: 1,
        convRule: $f87c9187b968257a$export$3f567b3eda4c98ad
    },
    {
        start: 8544,
        length: 16,
        convRule: $f87c9187b968257a$export$e687e84bc5c52c67
    },
    {
        start: 8560,
        length: 16,
        convRule: $f87c9187b968257a$export$a7141f854b2c3f56
    },
    {
        start: 8579,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 8580,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 9398,
        length: 26,
        convRule: $f87c9187b968257a$export$d7ef16e275a7be6
    },
    {
        start: 9424,
        length: 26,
        convRule: $f87c9187b968257a$export$99dabaca8c45da79
    },
    {
        start: 11264,
        length: 47,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 11312,
        length: 47,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 11360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11362,
        length: 1,
        convRule: $f87c9187b968257a$export$7c2398d5fd516c81
    },
    {
        start: 11363,
        length: 1,
        convRule: $f87c9187b968257a$export$474b42537797e1da
    },
    {
        start: 11364,
        length: 1,
        convRule: $f87c9187b968257a$export$364aece97ca575d1
    },
    {
        start: 11365,
        length: 1,
        convRule: $f87c9187b968257a$export$3cf8e408ecc23ac8
    },
    {
        start: 11366,
        length: 1,
        convRule: $f87c9187b968257a$export$625d51f562fcdce
    },
    {
        start: 11367,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11368,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11369,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11370,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11371,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11372,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11373,
        length: 1,
        convRule: $f87c9187b968257a$export$5744c09a46214cda
    },
    {
        start: 11374,
        length: 1,
        convRule: $f87c9187b968257a$export$cbfae993dd34ee83
    },
    {
        start: 11375,
        length: 1,
        convRule: $f87c9187b968257a$export$a51fc7ab2fc1de9b
    },
    {
        start: 11376,
        length: 1,
        convRule: $f87c9187b968257a$export$e0af8c92046dd53d
    },
    {
        start: 11378,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11379,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11390,
        length: 2,
        convRule: $f87c9187b968257a$export$2b358c6ece5bacbe
    },
    {
        start: 11392,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11393,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11394,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11395,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11396,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11397,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11398,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11399,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11400,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11401,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11402,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11403,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11404,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11405,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11406,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11407,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11410,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11411,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11412,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11413,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11414,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11415,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11422,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11423,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11424,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11425,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11426,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11427,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11430,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11431,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11432,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11433,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11434,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11435,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11436,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11437,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11438,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11439,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11442,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11443,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11446,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11447,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11448,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11449,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11450,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11451,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11452,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11453,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11454,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11455,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11456,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11457,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11458,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11459,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11460,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11461,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11462,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11463,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11464,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11465,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11466,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11467,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11468,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11469,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11470,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11471,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11472,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11473,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11474,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11475,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11476,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11477,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11499,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11500,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11501,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11502,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11520,
        length: 38,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11559,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11565,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 42560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42564,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42565,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42566,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42567,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42568,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42569,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42570,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42571,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42572,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42573,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42574,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42575,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42576,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42577,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42578,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42579,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42580,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42581,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42592,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42593,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42594,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42595,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42596,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42597,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42598,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42599,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42600,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42601,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42602,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42603,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42604,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42605,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42624,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42625,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42626,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42627,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42628,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42629,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42630,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42631,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42632,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42633,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42634,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42635,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42636,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42637,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42638,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42639,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42640,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42641,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42642,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42643,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42644,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42645,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42646,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42647,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42648,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42649,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42650,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42651,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42830,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42831,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42832,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42833,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42834,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42835,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42836,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42837,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42838,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42839,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42873,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42874,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42875,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42876,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42877,
        length: 1,
        convRule: $f87c9187b968257a$export$5c0a6992d16a2cde
    },
    {
        start: 42878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42891,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42892,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42893,
        length: 1,
        convRule: $f87c9187b968257a$export$4e7f444f251bc9f3
    },
    {
        start: 42896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42900,
        length: 1,
        convRule: $f87c9187b968257a$export$3eb062d0712525b5
    },
    {
        start: 42902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42922,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42923,
        length: 1,
        convRule: $f87c9187b968257a$export$56d3f806283387c4
    },
    {
        start: 42924,
        length: 1,
        convRule: $f87c9187b968257a$export$f4c6bcc526d116d5
    },
    {
        start: 42925,
        length: 1,
        convRule: $f87c9187b968257a$export$9b012ad386207454
    },
    {
        start: 42926,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42928,
        length: 1,
        convRule: $f87c9187b968257a$export$8ecae8a612aae856
    },
    {
        start: 42929,
        length: 1,
        convRule: $f87c9187b968257a$export$126aa15c1eb2342d
    },
    {
        start: 42930,
        length: 1,
        convRule: $f87c9187b968257a$export$9d1fbeb551ba701e
    },
    {
        start: 42931,
        length: 1,
        convRule: $f87c9187b968257a$export$b525d0e4ac5bf938
    },
    {
        start: 42932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42936,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42937,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42938,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42939,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42940,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42941,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42942,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42943,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42946,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42947,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42948,
        length: 1,
        convRule: $f87c9187b968257a$export$c8d4bace2652a68
    },
    {
        start: 42949,
        length: 1,
        convRule: $f87c9187b968257a$export$9e706749f691962d
    },
    {
        start: 42950,
        length: 1,
        convRule: $f87c9187b968257a$export$df8ee31db7227919
    },
    {
        start: 42951,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42952,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42953,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42954,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42997,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42998,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 43859,
        length: 1,
        convRule: $f87c9187b968257a$export$4b12fa44376611d5
    },
    {
        start: 43888,
        length: 80,
        convRule: $f87c9187b968257a$export$5b2d7b2d5041cd36
    },
    {
        start: 65313,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 65345,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 66560,
        length: 40,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66600,
        length: 40,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66736,
        length: 36,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66776,
        length: 36,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 68736,
        length: 51,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 68800,
        length: 51,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 71840,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 71872,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 93760,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 93792,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 125184,
        length: 34,
        convRule: $f87c9187b968257a$export$f0d6a468761d4066
    },
    {
        start: 125218,
        length: 34,
        convRule: $f87c9187b968257a$export$2a95711cd575be0d
    }
];
var $f87c9187b968257a$export$6029ab542afbcf48 = function(a) {
    return function(array) {
        return function(size) {
            return function(compare) {
                var go = function($copy_i) {
                    return function($copy_k) {
                        var $tco_var_i = $copy_i;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(i, k) {
                            if (i > k || i >= $fc8c1182ec2aefec$export$f24224f1c91d8156(array)) {
                                $tco_done = true;
                                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            }
                            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                var j = $8d5664f12212b23e$export$a3fe094919f356fd($4ab74a20512cef04$export$a0a81dc3380ce7d3(i + k | 0) / 2.0);
                                var b = $f87c9187b968257a$var$unsafeIndex(array)(j);
                                var v = compare(a)(b);
                                if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    $tco_done = true;
                                    return new $06733ae99ed4f534$export$8a67b48435b5d073(b);
                                }
                                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                                    $tco_var_i = j + 1 | 0;
                                    $copy_k = k;
                                    return;
                                }
                                $tco_var_i = i;
                                $copy_k = j - 1 | 0;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5622, column 3 - line 5632, column 30): " + [
                                i.constructor.name,
                                k.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_k);
                        return $tco_result;
                    };
                };
                return go(0)(size);
            };
        };
    };
};
var $f87c9187b968257a$export$37ec41d8baf7e4c2 = function(v) {
    return function(v1) {
        if (v.start >= v1.start && v.start < (v1.start + v1.length | 0)) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        if (v.start > v1.start) return $5026be88823ef1f4$export$b023c82b48e70453.value;
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5598, column 1 - line 5598, column 45): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$8a73d6c1af11382a = function(blocks) {
    return function(unichar) {
        return function(size) {
            var key = {
                start: unichar,
                length: 1,
                convRule: $f87c9187b968257a$export$1532ce0136c37755
            };
            var maybeCharBlock = $f87c9187b968257a$export$6029ab542afbcf48(key)(blocks)(size)($f87c9187b968257a$export$37ec41d8baf7e4c2);
            if (maybeCharBlock instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (maybeCharBlock instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(maybeCharBlock.value0.convRule);
            throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5612, column 5 - line 5614, column 60): " + [
                maybeCharBlock.constructor.name
            ]);
        };
    };
};
var $f87c9187b968257a$export$15b55fe776496b2f = function(f) {
    return function($$char) {
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$bfccab8956ac9f85)($$char)($f87c9187b968257a$export$7fc0e22034febfb5);
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $$char;
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $$char + f(maybeConversionRule.value0) | 0;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5727, column 5 - line 5729, column 53): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$c8e8c950fabdf148 = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.lowdist;
});
var $f87c9187b968257a$export$60bc89e8f464ddae = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.titledist;
});
var $f87c9187b968257a$export$d3a8c5dfd48993e0 = /* #__PURE__ */ $f87c9187b968257a$export$15b55fe776496b2f(function(v) {
    return v.updist;
});
var $f87c9187b968257a$export$eee0beb4445e5ae6 = function(categories) {
    return function($$char) {
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$ba10242678b7b4dd)($$char)($f87c9187b968257a$export$4a55201518f6815a);
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$export$c15bd07a493e1236($f87c9187b968257a$var$elemIndex(maybeConversionRule.value0.category)(categories));
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5654, column 5 - line 5656, column 86): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$882876e1e8ba136f = /* #__PURE__ */ $f87c9187b968257a$export$eee0beb4445e5ae6([
    $f87c9187b968257a$export$8e8b15481dfb814b
]);
var $f87c9187b968257a$export$865f22e68241060 = [
    {
        start: 0,
        length: 32,
        convRule: $f87c9187b968257a$export$516a0353e84e6d2c
    },
    {
        start: 32,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 33,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 36,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 37,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 40,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 41,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 42,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 44,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 45,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 46,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 48,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 58,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 60,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 63,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 91,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 92,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 93,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 94,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 95,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 96,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 97,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 123,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 124,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 125,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 126,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 127,
        length: 33,
        convRule: $f87c9187b968257a$export$516a0353e84e6d2c
    },
    {
        start: 160,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 161,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 162,
        length: 4,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 166,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 167,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 168,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 169,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 170,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 171,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 172,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 173,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 174,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 175,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 176,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 177,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 178,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 180,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 181,
        length: 1,
        convRule: $f87c9187b968257a$export$26575529bb6b00f3
    },
    {
        start: 182,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 184,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 185,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 186,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 187,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 188,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 191,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 192,
        length: 23,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 215,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 216,
        length: 7,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 223,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 224,
        length: 23,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 247,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 248,
        length: 7,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 255,
        length: 1,
        convRule: $f87c9187b968257a$export$faf1fbc46b682d31
    },
    {
        start: 256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 304,
        length: 1,
        convRule: $f87c9187b968257a$export$3905653af80b0d3e
    },
    {
        start: 305,
        length: 1,
        convRule: $f87c9187b968257a$export$825149518e5256a
    },
    {
        start: 306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 312,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 313,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 314,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 315,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 316,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 317,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 318,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 319,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 320,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 321,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 322,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 323,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 324,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 325,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 326,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 327,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 328,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 329,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 330,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 331,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 332,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 333,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 334,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 335,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 336,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 337,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 338,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 339,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 340,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 341,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 342,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 343,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 344,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 345,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 346,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 347,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 348,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 349,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 350,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 351,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 352,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 353,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 354,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 355,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 356,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 357,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 358,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 359,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 362,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 363,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 364,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 365,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 366,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 367,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 368,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 369,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 370,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 371,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 372,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 373,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 374,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 375,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 376,
        length: 1,
        convRule: $f87c9187b968257a$export$17cb0979b5fdd87b
    },
    {
        start: 377,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 378,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 379,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 380,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 383,
        length: 1,
        convRule: $f87c9187b968257a$export$498eb5d479bb7ce7
    },
    {
        start: 384,
        length: 1,
        convRule: $f87c9187b968257a$export$86720d766a71c0f
    },
    {
        start: 385,
        length: 1,
        convRule: $f87c9187b968257a$export$acd6a2e0e1f36119
    },
    {
        start: 386,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 387,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 388,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 389,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 390,
        length: 1,
        convRule: $f87c9187b968257a$export$622de29d3b1ec6a9
    },
    {
        start: 391,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 392,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 393,
        length: 2,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 395,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 396,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 397,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 398,
        length: 1,
        convRule: $f87c9187b968257a$export$6e688fec7aa0bec0
    },
    {
        start: 399,
        length: 1,
        convRule: $f87c9187b968257a$export$2307e0c1f6060bff
    },
    {
        start: 400,
        length: 1,
        convRule: $f87c9187b968257a$export$ee0aa35c8a71be4a
    },
    {
        start: 401,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 402,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 403,
        length: 1,
        convRule: $f87c9187b968257a$export$e5b51f2dbdbfec58
    },
    {
        start: 404,
        length: 1,
        convRule: $f87c9187b968257a$export$335d579666536cd9
    },
    {
        start: 405,
        length: 1,
        convRule: $f87c9187b968257a$export$5c6d53f26f6a0003
    },
    {
        start: 406,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 407,
        length: 1,
        convRule: $f87c9187b968257a$export$4d4410af2f036ea6
    },
    {
        start: 408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 410,
        length: 1,
        convRule: $f87c9187b968257a$export$c3f89e13d99585be
    },
    {
        start: 411,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 412,
        length: 1,
        convRule: $f87c9187b968257a$export$f0789b3782dd73b9
    },
    {
        start: 413,
        length: 1,
        convRule: $f87c9187b968257a$export$f9bf0a40bfb66578
    },
    {
        start: 414,
        length: 1,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 415,
        length: 1,
        convRule: $f87c9187b968257a$export$1fcc3cbf89bafa25
    },
    {
        start: 416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 422,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 423,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 424,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 425,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 426,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 430,
        length: 1,
        convRule: $f87c9187b968257a$export$dd4c0f14baaae57
    },
    {
        start: 431,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 432,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 433,
        length: 2,
        convRule: $f87c9187b968257a$export$b9e0d5ea32762a6c
    },
    {
        start: 435,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 436,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 437,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 438,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 439,
        length: 1,
        convRule: $f87c9187b968257a$export$893538eb43bbf231
    },
    {
        start: 440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 442,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 443,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 446,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 447,
        length: 1,
        convRule: $f87c9187b968257a$export$60fbc66d1ed52465
    },
    {
        start: 448,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 452,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 453,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 454,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 455,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 456,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 457,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 458,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 459,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 460,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 461,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 462,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 463,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 464,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 465,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 466,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 467,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 468,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 469,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 470,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 471,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 472,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 473,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 474,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 475,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 476,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 477,
        length: 1,
        convRule: $f87c9187b968257a$export$e943da14442eb991
    },
    {
        start: 478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 492,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 493,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 494,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 495,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 496,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 497,
        length: 1,
        convRule: $f87c9187b968257a$export$8d167c964d5a8755
    },
    {
        start: 498,
        length: 1,
        convRule: $f87c9187b968257a$export$765a30f3fb53310f
    },
    {
        start: 499,
        length: 1,
        convRule: $f87c9187b968257a$export$518ccb34de7e3cbb
    },
    {
        start: 500,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 501,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 502,
        length: 1,
        convRule: $f87c9187b968257a$export$7d86d2448c3bc365
    },
    {
        start: 503,
        length: 1,
        convRule: $f87c9187b968257a$export$42cea668cab33501
    },
    {
        start: 504,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 505,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 508,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 509,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 510,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 511,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 512,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 513,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 514,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 515,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 516,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 517,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 518,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 519,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 520,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 521,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 522,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 523,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 524,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 525,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 526,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 527,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 528,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 529,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 530,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 531,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 532,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 533,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 534,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 535,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 536,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 537,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 538,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 539,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 540,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 541,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 542,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 543,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 544,
        length: 1,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 545,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 546,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 547,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 548,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 549,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 550,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 551,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 552,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 553,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 554,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 555,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 556,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 557,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 558,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 559,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 564,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 570,
        length: 1,
        convRule: $f87c9187b968257a$export$806b8f4997f947bb
    },
    {
        start: 571,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 572,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 573,
        length: 1,
        convRule: $f87c9187b968257a$export$e685c0641eef8ee5
    },
    {
        start: 574,
        length: 1,
        convRule: $f87c9187b968257a$export$68150a2ac77076df
    },
    {
        start: 575,
        length: 2,
        convRule: $f87c9187b968257a$export$b5d11fd411ae7308
    },
    {
        start: 577,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 578,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 579,
        length: 1,
        convRule: $f87c9187b968257a$export$5018e8548b89e0b8
    },
    {
        start: 580,
        length: 1,
        convRule: $f87c9187b968257a$export$b91e7d7ce718aa5e
    },
    {
        start: 581,
        length: 1,
        convRule: $f87c9187b968257a$export$d2e4e93aee941b65
    },
    {
        start: 582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 592,
        length: 1,
        convRule: $f87c9187b968257a$export$43152f1584a84996
    },
    {
        start: 593,
        length: 1,
        convRule: $f87c9187b968257a$export$fc83989919685fe0
    },
    {
        start: 594,
        length: 1,
        convRule: $f87c9187b968257a$export$19fce1b8696a0382
    },
    {
        start: 595,
        length: 1,
        convRule: $f87c9187b968257a$export$5858d445afcb1060
    },
    {
        start: 596,
        length: 1,
        convRule: $f87c9187b968257a$export$7d23753ed8606c3c
    },
    {
        start: 597,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 598,
        length: 2,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 600,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 601,
        length: 1,
        convRule: $f87c9187b968257a$export$994a8a9eebf1e80f
    },
    {
        start: 602,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 603,
        length: 1,
        convRule: $f87c9187b968257a$export$f4cdedc47d618c
    },
    {
        start: 604,
        length: 1,
        convRule: $f87c9187b968257a$export$edf7537a5466cbbd
    },
    {
        start: 605,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 608,
        length: 1,
        convRule: $f87c9187b968257a$export$b0442e2b6e2e396f
    },
    {
        start: 609,
        length: 1,
        convRule: $f87c9187b968257a$export$8a875ec5816630ca
    },
    {
        start: 610,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 611,
        length: 1,
        convRule: $f87c9187b968257a$export$5f2cc4a9566fc84f
    },
    {
        start: 612,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 613,
        length: 1,
        convRule: $f87c9187b968257a$export$77796939240e1153
    },
    {
        start: 614,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 615,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 616,
        length: 1,
        convRule: $f87c9187b968257a$export$bfd284cd195987b2
    },
    {
        start: 617,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 618,
        length: 1,
        convRule: $f87c9187b968257a$export$87bde82168b7b62f
    },
    {
        start: 619,
        length: 1,
        convRule: $f87c9187b968257a$export$beaa5bc52e18b6f8
    },
    {
        start: 620,
        length: 1,
        convRule: $f87c9187b968257a$export$6fd5d6fa96b32e1c
    },
    {
        start: 621,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 623,
        length: 1,
        convRule: $f87c9187b968257a$export$9bce57c33159db29
    },
    {
        start: 624,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 625,
        length: 1,
        convRule: $f87c9187b968257a$export$bff6f6acb9080a71
    },
    {
        start: 626,
        length: 1,
        convRule: $f87c9187b968257a$export$47c98be6407fc86b
    },
    {
        start: 627,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 629,
        length: 1,
        convRule: $f87c9187b968257a$export$bdfd084f94b8abe4
    },
    {
        start: 630,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 637,
        length: 1,
        convRule: $f87c9187b968257a$export$8da9e42c98688195
    },
    {
        start: 638,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 640,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 641,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 642,
        length: 1,
        convRule: $f87c9187b968257a$export$a2aa412b2731fae3
    },
    {
        start: 643,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 644,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 647,
        length: 1,
        convRule: $f87c9187b968257a$export$9b9a33d1752912b
    },
    {
        start: 648,
        length: 1,
        convRule: $f87c9187b968257a$export$86b5f28b6c0e0fc1
    },
    {
        start: 649,
        length: 1,
        convRule: $f87c9187b968257a$export$5785034bbc9842fc
    },
    {
        start: 650,
        length: 2,
        convRule: $f87c9187b968257a$export$13d1ec53b7904ae2
    },
    {
        start: 652,
        length: 1,
        convRule: $f87c9187b968257a$export$21ce3a5d14104c9c
    },
    {
        start: 653,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 658,
        length: 1,
        convRule: $f87c9187b968257a$export$db5c3b84d1bf1368
    },
    {
        start: 659,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 660,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 661,
        length: 8,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 669,
        length: 1,
        convRule: $f87c9187b968257a$export$ee9294eaaf9c94c2
    },
    {
        start: 670,
        length: 1,
        convRule: $f87c9187b968257a$export$8e30aa3c367beb33
    },
    {
        start: 671,
        length: 17,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 688,
        length: 18,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 706,
        length: 4,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 710,
        length: 12,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 722,
        length: 14,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 736,
        length: 5,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 741,
        length: 7,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 748,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 749,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 750,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 751,
        length: 17,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 768,
        length: 69,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 837,
        length: 1,
        convRule: $f87c9187b968257a$export$dd16db91a51d355b
    },
    {
        start: 838,
        length: 42,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 884,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 885,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 890,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 891,
        length: 3,
        convRule: $f87c9187b968257a$export$f540d74c78ee7c6f
    },
    {
        start: 894,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 895,
        length: 1,
        convRule: $f87c9187b968257a$export$cb38bf493c63b044
    },
    {
        start: 900,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 902,
        length: 1,
        convRule: $f87c9187b968257a$export$1e277fd57a02853c
    },
    {
        start: 903,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 904,
        length: 3,
        convRule: $f87c9187b968257a$export$cf251c63ab3fda90
    },
    {
        start: 908,
        length: 1,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 910,
        length: 2,
        convRule: $f87c9187b968257a$export$c78a5306187d3d1a
    },
    {
        start: 912,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 913,
        length: 17,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 931,
        length: 9,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 940,
        length: 1,
        convRule: $f87c9187b968257a$export$66d8fe2369335850
    },
    {
        start: 941,
        length: 3,
        convRule: $f87c9187b968257a$export$8c9d0b2e40231e86
    },
    {
        start: 944,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 945,
        length: 17,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 962,
        length: 1,
        convRule: $f87c9187b968257a$export$f96cf9acbd4d5317
    },
    {
        start: 963,
        length: 9,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 972,
        length: 1,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 973,
        length: 2,
        convRule: $f87c9187b968257a$export$a555eb1807a2d462
    },
    {
        start: 975,
        length: 1,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 976,
        length: 1,
        convRule: $f87c9187b968257a$export$4e1e7ce4c3737105
    },
    {
        start: 977,
        length: 1,
        convRule: $f87c9187b968257a$export$e78c54e089b97a10
    },
    {
        start: 978,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 981,
        length: 1,
        convRule: $f87c9187b968257a$export$10e7925a46b9a72
    },
    {
        start: 982,
        length: 1,
        convRule: $f87c9187b968257a$export$1103c35de4bfac55
    },
    {
        start: 983,
        length: 1,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 984,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 985,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 986,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 987,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 988,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 989,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 990,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 991,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 992,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 993,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 994,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 995,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 996,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 997,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 998,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 999,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1000,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1001,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1002,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1003,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1004,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1005,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1006,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1007,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1008,
        length: 1,
        convRule: $f87c9187b968257a$export$b8ffbf54f5716e89
    },
    {
        start: 1009,
        length: 1,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1010,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 1011,
        length: 1,
        convRule: $f87c9187b968257a$export$7ca1b59fddace17a
    },
    {
        start: 1012,
        length: 1,
        convRule: $f87c9187b968257a$export$9e78c7e0e3c1bda1
    },
    {
        start: 1013,
        length: 1,
        convRule: $f87c9187b968257a$export$a40e98a4ed4424b0
    },
    {
        start: 1014,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 1015,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1016,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1017,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 1018,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1019,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1020,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1021,
        length: 3,
        convRule: $f87c9187b968257a$export$b1b9763a354df855
    },
    {
        start: 1024,
        length: 16,
        convRule: $f87c9187b968257a$export$3d630acc0c1aeac3
    },
    {
        start: 1040,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 1072,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 1104,
        length: 16,
        convRule: $f87c9187b968257a$export$19657fe4412c06ca
    },
    {
        start: 1120,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1121,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1122,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1123,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1124,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1125,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1126,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1127,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1128,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1129,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1130,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1131,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1132,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1133,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1134,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1135,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1136,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1137,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1138,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1139,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1140,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1141,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1142,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1143,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1144,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1145,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1146,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1147,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1148,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1149,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1150,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1151,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1152,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1153,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1154,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1155,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1160,
        length: 2,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 1162,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1163,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1164,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1165,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1166,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1167,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1168,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1169,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1170,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1171,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1172,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1173,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1174,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1175,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1176,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1177,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1178,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1179,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1180,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1181,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1182,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1183,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1184,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1185,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1186,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1187,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1188,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1189,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1190,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1191,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1192,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1193,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1194,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1195,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1196,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1197,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1198,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1199,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1200,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1201,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1202,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1203,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1204,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1205,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1206,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1207,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1208,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1209,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1210,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1211,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1212,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1213,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1214,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1215,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1216,
        length: 1,
        convRule: $f87c9187b968257a$export$9bb9980a5fba9cf6
    },
    {
        start: 1217,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1218,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1219,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1220,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1221,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1222,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1223,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1224,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1225,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1226,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1227,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1228,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1229,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1230,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1231,
        length: 1,
        convRule: $f87c9187b968257a$export$467bc6be00b6e5f7
    },
    {
        start: 1232,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1233,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1234,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1235,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1236,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1237,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1238,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1239,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1240,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1241,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1242,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1243,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1244,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1245,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1246,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1247,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1248,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1249,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1250,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1251,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1252,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1253,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1254,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1255,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1256,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1257,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1258,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1259,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1260,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1261,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1262,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1263,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1264,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1265,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1266,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1267,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1268,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1269,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1270,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1271,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1272,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1273,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1274,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1275,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1276,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1277,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1278,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1279,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1280,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1281,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1282,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1283,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1284,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1285,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1286,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1287,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1288,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1289,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1290,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1291,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1292,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1293,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1294,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1295,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1296,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1297,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1298,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1299,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1300,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1301,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1302,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1303,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1304,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1305,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1306,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1307,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1308,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1309,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1310,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1311,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1312,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1313,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1314,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1315,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1316,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1317,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1318,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1319,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1320,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1321,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1322,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1323,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1324,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1325,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1326,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 1327,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 1329,
        length: 38,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 1369,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1370,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1376,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1377,
        length: 38,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 1415,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 1417,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1418,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 1421,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1423,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 1425,
        length: 45,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1470,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 1471,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1472,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1473,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1475,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1476,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1478,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1479,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1488,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1519,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1523,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1536,
        length: 6,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1542,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 1545,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1547,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 1548,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1550,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1552,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1563,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1564,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1566,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1568,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1600,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1601,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1611,
        length: 21,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1632,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1642,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1646,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1648,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1649,
        length: 99,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1748,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1750,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1757,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1758,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1759,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1765,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 1767,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1769,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1770,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1774,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1776,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1786,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1789,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 1791,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1792,
        length: 14,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 1807,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 1808,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1809,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1810,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1840,
        length: 27,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1869,
        length: 89,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1958,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 1969,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 1984,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 1994,
        length: 33,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2027,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2036,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2038,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2039,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2042,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2045,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2046,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2048,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2070,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2074,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2075,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2084,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2085,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2088,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2089,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2096,
        length: 15,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2112,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2137,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2142,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2144,
        length: 11,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2208,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2230,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2259,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2274,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 2275,
        length: 32,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2307,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2308,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2362,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2363,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2364,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2365,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2366,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2369,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2377,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2381,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2382,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2384,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2385,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2392,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2402,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2404,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2406,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2416,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2417,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 2418,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2433,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2434,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2437,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2447,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2451,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2474,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2482,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2486,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2492,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2493,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2494,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2497,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2503,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2507,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2509,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2510,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2519,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2524,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2527,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2530,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2534,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2544,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2546,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2548,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 2554,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2555,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2556,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2557,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2558,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2561,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2563,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2565,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2575,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2579,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2602,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2610,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2613,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2616,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2620,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2622,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2625,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2631,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2635,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2641,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2649,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2654,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2662,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2672,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2674,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2677,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2678,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2689,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2691,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2693,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2703,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2707,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2730,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2738,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2741,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2748,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2750,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2753,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2759,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2761,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2763,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2765,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2768,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2784,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2786,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2790,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2800,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 2801,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 2809,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2810,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2817,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2818,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2821,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2831,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2835,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2858,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2866,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2869,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2876,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2877,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2878,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2879,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2880,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2881,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2887,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2891,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2893,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2901,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2903,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 2908,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2911,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2914,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2918,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 2928,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 2929,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2930,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 2946,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 2947,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2949,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2958,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2962,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2969,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2972,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2974,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2979,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2984,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 2990,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3006,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3008,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3009,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3014,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3018,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3021,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3024,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3031,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3046,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3056,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3059,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3065,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 3066,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3072,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3073,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3076,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3077,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3086,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3090,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3114,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3133,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3134,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3137,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3142,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3146,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3157,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3160,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3168,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3170,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3174,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3191,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3192,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3199,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3200,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3201,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3202,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3204,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3205,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3214,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3218,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3242,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3253,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3260,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3261,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3262,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3264,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3270,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3271,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3274,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3276,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3285,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3294,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3296,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3298,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3302,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3313,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3328,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3330,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3332,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3342,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3346,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3387,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3389,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3390,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3393,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3398,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3402,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3405,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3406,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3407,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3412,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3415,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3416,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3423,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3426,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3430,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3440,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3449,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3450,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3457,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3458,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3461,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3482,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3507,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3517,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3520,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3530,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3535,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3538,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3542,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3544,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3558,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3570,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3572,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3585,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3633,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3634,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3636,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3647,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 3648,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3654,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 3655,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3663,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3664,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3674,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3713,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3716,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3718,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3724,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3749,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3751,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3761,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3762,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3764,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3773,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3776,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3782,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 3784,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3792,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3804,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3840,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3841,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3844,
        length: 15,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3859,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3860,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3861,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3864,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3866,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3872,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 3882,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 3892,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3893,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3894,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3895,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3896,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 3897,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3898,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 3899,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 3900,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 3901,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 3902,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3904,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3913,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3953,
        length: 14,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3967,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 3968,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3973,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 3974,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3976,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 3981,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 3993,
        length: 36,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4030,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4038,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4039,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4046,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4048,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4053,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4057,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4096,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4139,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4141,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4145,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4146,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4152,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4153,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4155,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4157,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4159,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4160,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 4170,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4176,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4182,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4184,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4186,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4190,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4193,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4194,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4197,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4199,
        length: 7,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4206,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4209,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4213,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4226,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4227,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4229,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4231,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4237,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4238,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4239,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4240,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 4250,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 4253,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4254,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 4256,
        length: 38,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4295,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4301,
        length: 1,
        convRule: $f87c9187b968257a$export$4373e966038dbe47
    },
    {
        start: 4304,
        length: 43,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4347,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4348,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 4349,
        length: 3,
        convRule: $f87c9187b968257a$export$659683f76ff91445
    },
    {
        start: 4352,
        length: 329,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4682,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4688,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4696,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4698,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4704,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4746,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4752,
        length: 33,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4786,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4792,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4800,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4802,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4808,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4824,
        length: 57,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4882,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4888,
        length: 67,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 4957,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 4960,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 4969,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 4992,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5008,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 5024,
        length: 80,
        convRule: $f87c9187b968257a$export$2f42ee7f4ae770fa
    },
    {
        start: 5104,
        length: 6,
        convRule: $f87c9187b968257a$export$679c844c5f2e021b
    },
    {
        start: 5112,
        length: 6,
        convRule: $f87c9187b968257a$export$9773cf18228b1a46
    },
    {
        start: 5120,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 5121,
        length: 620,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5741,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 5742,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5743,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5760,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 5761,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5787,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 5788,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 5792,
        length: 75,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5867,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5870,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 5873,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5888,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5902,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5906,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5920,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5938,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5941,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 5952,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5970,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 5984,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 5998,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6002,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6016,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6068,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6070,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6071,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6078,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6086,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6087,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6089,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6100,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6103,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6104,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6107,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 6108,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6109,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6112,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6128,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 6144,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6150,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 6151,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6155,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6158,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 6160,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6176,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6211,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6212,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6272,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6277,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6279,
        length: 34,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6313,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6314,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6320,
        length: 70,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6400,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6432,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6435,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6439,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6441,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6448,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6450,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6451,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6457,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6464,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 6468,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6470,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6480,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6512,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6528,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6576,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6608,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6618,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 6622,
        length: 34,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 6656,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6679,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6681,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6683,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6686,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6688,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6741,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6742,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6743,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6744,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6752,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6753,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6754,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6755,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6757,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6765,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6771,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6783,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6784,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6800,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 6816,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6823,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 6824,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 6832,
        length: 14,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6846,
        length: 1,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 6847,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6912,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6916,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6917,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6964,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6965,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6966,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6971,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6972,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6973,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6978,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 6979,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 6981,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 6992,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7002,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7009,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 7019,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7028,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 7040,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7042,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7043,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7073,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7074,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7078,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7080,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7082,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7083,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7086,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7088,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7098,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7142,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7143,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7144,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7146,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7149,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7150,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7151,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7154,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7164,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7168,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7204,
        length: 8,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7212,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7220,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7222,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7227,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7232,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7245,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7248,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 7258,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7288,
        length: 6,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7294,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7296,
        length: 1,
        convRule: $f87c9187b968257a$export$959ab01c5a7aed98
    },
    {
        start: 7297,
        length: 1,
        convRule: $f87c9187b968257a$export$4b86aace1bd7e1bd
    },
    {
        start: 7298,
        length: 1,
        convRule: $f87c9187b968257a$export$af46a44506145125
    },
    {
        start: 7299,
        length: 2,
        convRule: $f87c9187b968257a$export$5b58a7342deeffb1
    },
    {
        start: 7301,
        length: 1,
        convRule: $f87c9187b968257a$export$ce586bf4d1a1e66
    },
    {
        start: 7302,
        length: 1,
        convRule: $f87c9187b968257a$export$2da14ab05c277ce3
    },
    {
        start: 7303,
        length: 1,
        convRule: $f87c9187b968257a$export$50efda91b0b7cb4d
    },
    {
        start: 7304,
        length: 1,
        convRule: $f87c9187b968257a$export$a003c458cd158704
    },
    {
        start: 7312,
        length: 43,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7357,
        length: 3,
        convRule: $f87c9187b968257a$export$ea5950d132bda3cb
    },
    {
        start: 7360,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7376,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7379,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 7380,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7393,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7394,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7401,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7405,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7406,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7412,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7413,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7415,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 7416,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7418,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 7424,
        length: 44,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7468,
        length: 63,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7531,
        length: 13,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7544,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7545,
        length: 1,
        convRule: $f87c9187b968257a$export$72fbf6834eb62a3
    },
    {
        start: 7546,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7549,
        length: 1,
        convRule: $f87c9187b968257a$export$a54f88f7b56ccb1b
    },
    {
        start: 7550,
        length: 16,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7566,
        length: 1,
        convRule: $f87c9187b968257a$export$1630391a83c31f3f
    },
    {
        start: 7567,
        length: 12,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7579,
        length: 37,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 7616,
        length: 58,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7675,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 7680,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7681,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7682,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7683,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7684,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7685,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7686,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7687,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7688,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7689,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7690,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7691,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7692,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7693,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7694,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7695,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7696,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7697,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7698,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7699,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7700,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7701,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7702,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7703,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7704,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7705,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7706,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7707,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7708,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7709,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7710,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7711,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7712,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7713,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7714,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7715,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7716,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7717,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7718,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7719,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7720,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7721,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7722,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7723,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7724,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7725,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7726,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7727,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7728,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7729,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7730,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7731,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7732,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7733,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7734,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7735,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7736,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7737,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7738,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7739,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7740,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7741,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7742,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7743,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7744,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7745,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7746,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7747,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7748,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7749,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7750,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7751,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7752,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7753,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7754,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7755,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7756,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7757,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7758,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7759,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7760,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7761,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7762,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7763,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7764,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7765,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7766,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7767,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7768,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7769,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7770,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7771,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7772,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7773,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7774,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7775,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7776,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7777,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7778,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7779,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7780,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7781,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7782,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7783,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7784,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7785,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7800,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7801,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7830,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7835,
        length: 1,
        convRule: $f87c9187b968257a$export$77879d885a56be5b
    },
    {
        start: 7836,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7838,
        length: 1,
        convRule: $f87c9187b968257a$export$6ed378352675c85b
    },
    {
        start: 7839,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 7840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7864,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7865,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7866,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7867,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7868,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7869,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7870,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7871,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7872,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7873,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7874,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7875,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7876,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7877,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7888,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7889,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7890,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7891,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7892,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7893,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7894,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7895,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7900,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7901,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7922,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7923,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7924,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7925,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7926,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7927,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7928,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7929,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7930,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7931,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 7935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 7936,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7944,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7952,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7960,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7968,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7976,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 7984,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 7992,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8000,
        length: 6,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8008,
        length: 6,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8016,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8017,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8018,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8019,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8020,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8021,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8022,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8023,
        length: 1,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8025,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8027,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8029,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8031,
        length: 1,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8032,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8040,
        length: 8,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8048,
        length: 2,
        convRule: $f87c9187b968257a$export$5d5cff08baa82bb3
    },
    {
        start: 8050,
        length: 4,
        convRule: $f87c9187b968257a$export$30cbf10eadff8354
    },
    {
        start: 8054,
        length: 2,
        convRule: $f87c9187b968257a$export$625a4e9662bb8009
    },
    {
        start: 8056,
        length: 2,
        convRule: $f87c9187b968257a$export$bfd29a26bb9c7604
    },
    {
        start: 8058,
        length: 2,
        convRule: $f87c9187b968257a$export$84e329f80ee32d86
    },
    {
        start: 8060,
        length: 2,
        convRule: $f87c9187b968257a$export$ec097e7d1326c9d8
    },
    {
        start: 8064,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8072,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8080,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8088,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8096,
        length: 8,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8104,
        length: 8,
        convRule: $f87c9187b968257a$export$9073887b88a95a65
    },
    {
        start: 8112,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8114,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8115,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8116,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8118,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8120,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8122,
        length: 2,
        convRule: $f87c9187b968257a$export$b6ed7bef3aaad2a4
    },
    {
        start: 8124,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8125,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8126,
        length: 1,
        convRule: $f87c9187b968257a$export$847447ed9edca5f
    },
    {
        start: 8127,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8130,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8131,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8132,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8134,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8136,
        length: 4,
        convRule: $f87c9187b968257a$export$a2950913305bfd2f
    },
    {
        start: 8140,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8141,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8144,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8146,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8150,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8152,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8154,
        length: 2,
        convRule: $f87c9187b968257a$export$4debf059fdd78967
    },
    {
        start: 8157,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8160,
        length: 2,
        convRule: $f87c9187b968257a$export$2bf374c619a884c0
    },
    {
        start: 8162,
        length: 3,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8165,
        length: 1,
        convRule: $f87c9187b968257a$export$541be5c98ac427fb
    },
    {
        start: 8166,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8168,
        length: 2,
        convRule: $f87c9187b968257a$export$f07dab3e1e2f044b
    },
    {
        start: 8170,
        length: 2,
        convRule: $f87c9187b968257a$export$3cc60af0b8fe51fb
    },
    {
        start: 8172,
        length: 1,
        convRule: $f87c9187b968257a$export$9568c26f20ab8b54
    },
    {
        start: 8173,
        length: 3,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8178,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8179,
        length: 1,
        convRule: $f87c9187b968257a$export$14cf3cf7fed1ce4
    },
    {
        start: 8180,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8182,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8184,
        length: 2,
        convRule: $f87c9187b968257a$export$c251b05d03bb1b09
    },
    {
        start: 8186,
        length: 2,
        convRule: $f87c9187b968257a$export$db469ad8291bc174
    },
    {
        start: 8188,
        length: 1,
        convRule: $f87c9187b968257a$export$a9178d4e39cbf99b
    },
    {
        start: 8189,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 8192,
        length: 11,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8203,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8208,
        length: 6,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 8214,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8216,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8217,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8218,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8219,
        length: 2,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8221,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8222,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8223,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8224,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8232,
        length: 1,
        convRule: $f87c9187b968257a$export$6b7d2f092933a352
    },
    {
        start: 8233,
        length: 1,
        convRule: $f87c9187b968257a$export$f862c925a5027a25
    },
    {
        start: 8234,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8239,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8240,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8249,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 8250,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 8251,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8255,
        length: 2,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 8257,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8260,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8261,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8262,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8263,
        length: 11,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8274,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8275,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8276,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 8277,
        length: 10,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 8287,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 8288,
        length: 5,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8294,
        length: 10,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 8304,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8305,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8308,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8314,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8317,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8318,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8319,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8320,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8330,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8333,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8334,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8336,
        length: 13,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 8352,
        length: 32,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 8400,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8413,
        length: 4,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 8417,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8418,
        length: 3,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 8421,
        length: 12,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 8448,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8450,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8451,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8455,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8456,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8458,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8459,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8462,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8464,
        length: 3,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8467,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8468,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8469,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8470,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8472,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8473,
        length: 5,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8478,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8484,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8485,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8486,
        length: 1,
        convRule: $f87c9187b968257a$export$c50d507ea3901971
    },
    {
        start: 8487,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8488,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8489,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8490,
        length: 1,
        convRule: $f87c9187b968257a$export$c3ea2d19789db55a
    },
    {
        start: 8491,
        length: 1,
        convRule: $f87c9187b968257a$export$757246ae7800bfc2
    },
    {
        start: 8492,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8494,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8495,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8496,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8498,
        length: 1,
        convRule: $f87c9187b968257a$export$3c9855e4a4f89f58
    },
    {
        start: 8499,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8500,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8501,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 8505,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8506,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8508,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8510,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8512,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8517,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 8518,
        length: 4,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 8522,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8523,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8524,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8526,
        length: 1,
        convRule: $f87c9187b968257a$export$3f567b3eda4c98ad
    },
    {
        start: 8527,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8528,
        length: 16,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8544,
        length: 16,
        convRule: $f87c9187b968257a$export$e687e84bc5c52c67
    },
    {
        start: 8560,
        length: 16,
        convRule: $f87c9187b968257a$export$a7141f854b2c3f56
    },
    {
        start: 8576,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 8579,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 8580,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 8581,
        length: 4,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 8585,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 8586,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8592,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8597,
        length: 5,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8602,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8604,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8608,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8609,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8611,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8612,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8614,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8615,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8622,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8623,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8654,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8656,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8658,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8659,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8660,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8661,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8692,
        length: 268,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8960,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8968,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8969,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8970,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 8971,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 8972,
        length: 20,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 8992,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 8994,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9001,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 9002,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 9003,
        length: 81,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9084,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9085,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9115,
        length: 25,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9140,
        length: 40,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9180,
        length: 6,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9186,
        length: 69,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9280,
        length: 11,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9312,
        length: 60,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 9372,
        length: 26,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9398,
        length: 26,
        convRule: $f87c9187b968257a$export$d7ef16e275a7be6
    },
    {
        start: 9424,
        length: 26,
        convRule: $f87c9187b968257a$export$99dabaca8c45da79
    },
    {
        start: 9450,
        length: 22,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 9472,
        length: 183,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9655,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9656,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9665,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9666,
        length: 54,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9720,
        length: 8,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9728,
        length: 111,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 9839,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 9840,
        length: 248,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10088,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10089,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10090,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10091,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10092,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10093,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10094,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10095,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10096,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10097,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10098,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10099,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10100,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10101,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10102,
        length: 30,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 10132,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10176,
        length: 5,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10181,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10182,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10183,
        length: 31,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10214,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10215,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10216,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10217,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10218,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10219,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10220,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10221,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10222,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10223,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10224,
        length: 16,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10240,
        length: 256,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 10496,
        length: 131,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10627,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10628,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10629,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10630,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10631,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10632,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10633,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10634,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10635,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10636,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10637,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10638,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10639,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10640,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10641,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10642,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10643,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10644,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10645,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10646,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10647,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10648,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10649,
        length: 63,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10712,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10713,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10714,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10715,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10716,
        length: 32,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 10748,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 10749,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 10750,
        length: 258,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11008,
        length: 48,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11056,
        length: 21,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11077,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11079,
        length: 6,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 11085,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11126,
        length: 32,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11159,
        length: 105,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11264,
        length: 47,
        convRule: $f87c9187b968257a$export$663d5f91785521bc
    },
    {
        start: 11312,
        length: 47,
        convRule: $f87c9187b968257a$export$31855f4179a9d698
    },
    {
        start: 11360,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11361,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11362,
        length: 1,
        convRule: $f87c9187b968257a$export$7c2398d5fd516c81
    },
    {
        start: 11363,
        length: 1,
        convRule: $f87c9187b968257a$export$474b42537797e1da
    },
    {
        start: 11364,
        length: 1,
        convRule: $f87c9187b968257a$export$364aece97ca575d1
    },
    {
        start: 11365,
        length: 1,
        convRule: $f87c9187b968257a$export$3cf8e408ecc23ac8
    },
    {
        start: 11366,
        length: 1,
        convRule: $f87c9187b968257a$export$625d51f562fcdce
    },
    {
        start: 11367,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11368,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11369,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11370,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11371,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11372,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11373,
        length: 1,
        convRule: $f87c9187b968257a$export$5744c09a46214cda
    },
    {
        start: 11374,
        length: 1,
        convRule: $f87c9187b968257a$export$cbfae993dd34ee83
    },
    {
        start: 11375,
        length: 1,
        convRule: $f87c9187b968257a$export$a51fc7ab2fc1de9b
    },
    {
        start: 11376,
        length: 1,
        convRule: $f87c9187b968257a$export$e0af8c92046dd53d
    },
    {
        start: 11377,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11378,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11379,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11380,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11381,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11382,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11383,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11388,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11390,
        length: 2,
        convRule: $f87c9187b968257a$export$2b358c6ece5bacbe
    },
    {
        start: 11392,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11393,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11394,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11395,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11396,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11397,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11398,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11399,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11400,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11401,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11402,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11403,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11404,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11405,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11406,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11407,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11408,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11409,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11410,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11411,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11412,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11413,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11414,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11415,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11416,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11417,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11418,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11419,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11420,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11421,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11422,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11423,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11424,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11425,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11426,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11427,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11428,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11429,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11430,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11431,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11432,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11433,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11434,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11435,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11436,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11437,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11438,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11439,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11440,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11441,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11442,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11443,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11444,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11445,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11446,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11447,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11448,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11449,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11450,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11451,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11452,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11453,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11454,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11455,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11456,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11457,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11458,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11459,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11460,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11461,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11462,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11463,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11464,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11465,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11466,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11467,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11468,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11469,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11470,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11471,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11472,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11473,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11474,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11475,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11476,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11477,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11478,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11479,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11480,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11481,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11482,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11483,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11484,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11485,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11486,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11487,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11488,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11489,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11490,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11491,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11492,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 11493,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11499,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11500,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11501,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11502,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11503,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11506,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 11507,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 11513,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11517,
        length: 1,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 11518,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11520,
        length: 38,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11559,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11565,
        length: 1,
        convRule: $f87c9187b968257a$export$7c5cb8ca51bc2320
    },
    {
        start: 11568,
        length: 56,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11631,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11632,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11647,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11648,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11680,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11688,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11696,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11704,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11712,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11720,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11728,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11736,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 11744,
        length: 32,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 11776,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11778,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11779,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11780,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11781,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11782,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11785,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11786,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11787,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11788,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11789,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11790,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11799,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11800,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11802,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11803,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11804,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11805,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11806,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11808,
        length: 1,
        convRule: $f87c9187b968257a$export$6d507407c09b2bdb
    },
    {
        start: 11809,
        length: 1,
        convRule: $f87c9187b968257a$export$b954bed55b55ec5c
    },
    {
        start: 11810,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11811,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11812,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11813,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11814,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11815,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11816,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11817,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 11818,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11823,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 11824,
        length: 10,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11834,
        length: 2,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11836,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11840,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 11841,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11842,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 11843,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11856,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11858,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 11904,
        length: 26,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 11931,
        length: 89,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12032,
        length: 214,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12272,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12288,
        length: 1,
        convRule: $f87c9187b968257a$export$51ebcaadb3c67176
    },
    {
        start: 12289,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12292,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12293,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12294,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12295,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12296,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12297,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12298,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12299,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12300,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12301,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12302,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12303,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12304,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12305,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12306,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12308,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12309,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12310,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12311,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12312,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12313,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12314,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12315,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12316,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12317,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 12318,
        length: 2,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 12320,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12321,
        length: 9,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12330,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 12334,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 12336,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12337,
        length: 5,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12342,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12344,
        length: 3,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 12347,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12348,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12349,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12350,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12353,
        length: 86,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12441,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 12443,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 12445,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12447,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12448,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 12449,
        length: 90,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12539,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 12540,
        length: 3,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 12543,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12549,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12593,
        length: 94,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12688,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12690,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12694,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12704,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12736,
        length: 36,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12784,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 12800,
        length: 31,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12832,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12842,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12872,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12880,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12881,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12896,
        length: 32,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12928,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12938,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 12977,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 12992,
        length: 320,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 13312,
        length: 6592,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 19904,
        length: 64,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 19968,
        length: 20989,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 40960,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 40981,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 40982,
        length: 1143,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42128,
        length: 55,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 42192,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42232,
        length: 6,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42238,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42240,
        length: 268,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42508,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42509,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42512,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42528,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 42538,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42560,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42561,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42562,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42563,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42564,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42565,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42566,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42567,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42568,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42569,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42570,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42571,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42572,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42573,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42574,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42575,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42576,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42577,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42578,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42579,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42580,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42581,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42582,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42583,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42584,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42585,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42586,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42587,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42588,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42589,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42590,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42591,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42592,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42593,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42594,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42595,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42596,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42597,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42598,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42599,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42600,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42601,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42602,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42603,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42604,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42605,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42606,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42607,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42608,
        length: 3,
        convRule: $f87c9187b968257a$export$69945c68dca01b70
    },
    {
        start: 42611,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42612,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42622,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42623,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42624,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42625,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42626,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42627,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42628,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42629,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42630,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42631,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42632,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42633,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42634,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42635,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42636,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42637,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42638,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42639,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42640,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42641,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42642,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42643,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42644,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42645,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42646,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42647,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42648,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42649,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42650,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42651,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42652,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42654,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42656,
        length: 70,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42726,
        length: 10,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 42736,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 42738,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 42752,
        length: 23,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42775,
        length: 9,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42784,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42786,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42787,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42788,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42789,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42790,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42791,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42792,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42793,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42794,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42795,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42796,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42797,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42798,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42799,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42800,
        length: 2,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42802,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42803,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42804,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42805,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42806,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42807,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42808,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42809,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42810,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42811,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42812,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42813,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42814,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42815,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42816,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42817,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42818,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42819,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42820,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42821,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42822,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42823,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42824,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42825,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42826,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42827,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42828,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42829,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42830,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42831,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42832,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42833,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42834,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42835,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42836,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42837,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42838,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42839,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42840,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42841,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42842,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42843,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42844,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42845,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42846,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42847,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42848,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42849,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42850,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42851,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42852,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42853,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42854,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42855,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42856,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42857,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42858,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42859,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42860,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42861,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42862,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42863,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42864,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42865,
        length: 8,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42873,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42874,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42875,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42876,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42877,
        length: 1,
        convRule: $f87c9187b968257a$export$5c0a6992d16a2cde
    },
    {
        start: 42878,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42879,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42880,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42881,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42882,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42883,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42884,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42885,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42886,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42887,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42888,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 42889,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 42891,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42892,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42893,
        length: 1,
        convRule: $f87c9187b968257a$export$4e7f444f251bc9f3
    },
    {
        start: 42894,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42895,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 42896,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42897,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42898,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42899,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42900,
        length: 1,
        convRule: $f87c9187b968257a$export$3eb062d0712525b5
    },
    {
        start: 42901,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42902,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42903,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42904,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42905,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42906,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42907,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42908,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42909,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42910,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42911,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42912,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42913,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42914,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42915,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42916,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42917,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42918,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42919,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42920,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42921,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42922,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42923,
        length: 1,
        convRule: $f87c9187b968257a$export$56d3f806283387c4
    },
    {
        start: 42924,
        length: 1,
        convRule: $f87c9187b968257a$export$f4c6bcc526d116d5
    },
    {
        start: 42925,
        length: 1,
        convRule: $f87c9187b968257a$export$9b012ad386207454
    },
    {
        start: 42926,
        length: 1,
        convRule: $f87c9187b968257a$export$e5aa8d48ff844b5
    },
    {
        start: 42927,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 42928,
        length: 1,
        convRule: $f87c9187b968257a$export$8ecae8a612aae856
    },
    {
        start: 42929,
        length: 1,
        convRule: $f87c9187b968257a$export$126aa15c1eb2342d
    },
    {
        start: 42930,
        length: 1,
        convRule: $f87c9187b968257a$export$9d1fbeb551ba701e
    },
    {
        start: 42931,
        length: 1,
        convRule: $f87c9187b968257a$export$b525d0e4ac5bf938
    },
    {
        start: 42932,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42933,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42934,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42935,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42936,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42937,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42938,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42939,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42940,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42941,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42942,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42943,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42946,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42947,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42948,
        length: 1,
        convRule: $f87c9187b968257a$export$c8d4bace2652a68
    },
    {
        start: 42949,
        length: 1,
        convRule: $f87c9187b968257a$export$9e706749f691962d
    },
    {
        start: 42950,
        length: 1,
        convRule: $f87c9187b968257a$export$df8ee31db7227919
    },
    {
        start: 42951,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42952,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42953,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42954,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42997,
        length: 1,
        convRule: $f87c9187b968257a$export$7dea77bc2e51a670
    },
    {
        start: 42998,
        length: 1,
        convRule: $f87c9187b968257a$export$ad90e8d621d1d2f5
    },
    {
        start: 42999,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43000,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43002,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43003,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43010,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43011,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43014,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43015,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43019,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43020,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43043,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43045,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43047,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43048,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43052,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43056,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 43062,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43064,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 43065,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43072,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43124,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43136,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43138,
        length: 50,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43188,
        length: 16,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43204,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43214,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43216,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43232,
        length: 18,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43250,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43256,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43259,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43260,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43261,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43264,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43274,
        length: 28,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43302,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43310,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43312,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43335,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43346,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43359,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43360,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43392,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43395,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43396,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43443,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43444,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43446,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43450,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43452,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43454,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43457,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43471,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43472,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43486,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43488,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43493,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43494,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43495,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43504,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43514,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43520,
        length: 41,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43561,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43567,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43569,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43571,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43573,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43584,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43587,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43588,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43596,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43597,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43600,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 43612,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43616,
        length: 16,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43632,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43633,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43639,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 43642,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43643,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43644,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43645,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43646,
        length: 50,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43696,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43697,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43698,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43701,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43703,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43705,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43710,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43712,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43713,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43714,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43739,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43741,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43742,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43744,
        length: 11,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43755,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43756,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43758,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43760,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 43762,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43763,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43765,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 43766,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 43777,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43785,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43793,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43808,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43816,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 43824,
        length: 35,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43859,
        length: 1,
        convRule: $f87c9187b968257a$export$4b12fa44376611d5
    },
    {
        start: 43860,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43867,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 43868,
        length: 4,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43872,
        length: 9,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 43881,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 43882,
        length: 2,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 43888,
        length: 80,
        convRule: $f87c9187b968257a$export$5b2d7b2d5041cd36
    },
    {
        start: 43968,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 44003,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44005,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44006,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44008,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44009,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44011,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 44012,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 44013,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 44016,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 44032,
        length: 11172,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55216,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55243,
        length: 49,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 55296,
        length: 896,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 56192,
        length: 128,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 56320,
        length: 1024,
        convRule: $f87c9187b968257a$export$8664fc4768208d13
    },
    {
        start: 57344,
        length: 6400,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    },
    {
        start: 63744,
        length: 366,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64112,
        length: 106,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64256,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 64275,
        length: 5,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 64285,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64286,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 64287,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64297,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 64298,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64312,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64318,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64320,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64323,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64326,
        length: 108,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64434,
        length: 16,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 64467,
        length: 363,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64830,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 64831,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 64848,
        length: 64,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 64914,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65008,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65020,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65021,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65024,
        length: 16,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 65040,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65047,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65048,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65049,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65056,
        length: 16,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 65072,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65073,
        length: 2,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65075,
        length: 2,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65077,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65078,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65079,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65080,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65081,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65082,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65083,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65084,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65085,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65086,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65087,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65088,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65089,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65090,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65091,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65092,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65093,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65095,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65096,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65097,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65101,
        length: 3,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65104,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65108,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65112,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65113,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65114,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65115,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65116,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65117,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65118,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65119,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65122,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65123,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65124,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65128,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65129,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65130,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65136,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65142,
        length: 135,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65279,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 65281,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65284,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65285,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65288,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65289,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65290,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65291,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65292,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65293,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 65294,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65296,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 65306,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65308,
        length: 3,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65311,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65313,
        length: 26,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 65339,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65340,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65341,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65342,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65343,
        length: 1,
        convRule: $f87c9187b968257a$export$3e4e0426de951c07
    },
    {
        start: 65344,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65345,
        length: 26,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 65371,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65372,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65373,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65374,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65375,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65376,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65377,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65378,
        length: 1,
        convRule: $f87c9187b968257a$export$e8bb70a7af6f494
    },
    {
        start: 65379,
        length: 1,
        convRule: $f87c9187b968257a$export$29b16d96ce047ca9
    },
    {
        start: 65380,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65382,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65392,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 65393,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65438,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 65440,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65474,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65482,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65490,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65498,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65504,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65506,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65507,
        length: 1,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 65508,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65509,
        length: 2,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 65512,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65513,
        length: 4,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 65517,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65529,
        length: 3,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 65532,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65536,
        length: 12,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65549,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65576,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65596,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65599,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65616,
        length: 14,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65664,
        length: 123,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 65792,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 65799,
        length: 45,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65847,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65856,
        length: 53,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 65909,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65913,
        length: 17,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65930,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 65932,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65936,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 65952,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 66000,
        length: 45,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 66045,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66176,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66208,
        length: 49,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66272,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66273,
        length: 27,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 66304,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66336,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 66349,
        length: 20,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66369,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66370,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66378,
        length: 1,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66384,
        length: 38,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66422,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 66432,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66463,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 66464,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66504,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66512,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 66513,
        length: 5,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 66560,
        length: 40,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66600,
        length: 40,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66640,
        length: 78,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66720,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 66736,
        length: 36,
        convRule: $f87c9187b968257a$export$5f381834e520bfa8
    },
    {
        start: 66776,
        length: 36,
        convRule: $f87c9187b968257a$export$fb16bdb144aa72d1
    },
    {
        start: 66816,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66864,
        length: 52,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 66927,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67072,
        length: 311,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67392,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67424,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67584,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67592,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67594,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67639,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67644,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67647,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67671,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67672,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67680,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67703,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 67705,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67712,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67751,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67808,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67828,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67835,
        length: 5,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67840,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67862,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 67871,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67872,
        length: 26,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 67903,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 67968,
        length: 56,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68028,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68030,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68032,
        length: 16,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68050,
        length: 46,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68096,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68097,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68101,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68108,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68112,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68117,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68121,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68152,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68159,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68160,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68176,
        length: 9,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68192,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68221,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68223,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68224,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68253,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68288,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68296,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 68297,
        length: 28,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68325,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68331,
        length: 5,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68336,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68352,
        length: 54,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68409,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68416,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68440,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68448,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68472,
        length: 8,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68480,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68505,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 68521,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68608,
        length: 73,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68736,
        length: 51,
        convRule: $f87c9187b968257a$export$31515a1452fded76
    },
    {
        start: 68800,
        length: 51,
        convRule: $f87c9187b968257a$export$3fc150f61f8b8954
    },
    {
        start: 68858,
        length: 6,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 68864,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 68900,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 68912,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69216,
        length: 31,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69248,
        length: 42,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69291,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69293,
        length: 1,
        convRule: $f87c9187b968257a$export$3db8b2fe6cbecf3b
    },
    {
        start: 69296,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69376,
        length: 29,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69405,
        length: 10,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69415,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69424,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69446,
        length: 11,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69457,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69461,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69552,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69573,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69600,
        length: 23,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69632,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69633,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69634,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69635,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69688,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69703,
        length: 7,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69714,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 69734,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69759,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69762,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69763,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69808,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69811,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69815,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69817,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69819,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69821,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 69822,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69837,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 69840,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69872,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69888,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69891,
        length: 36,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69927,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69932,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69933,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 69942,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 69952,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 69956,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69957,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 69959,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 69968,
        length: 35,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70003,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70004,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70006,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70016,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70018,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70019,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70067,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70070,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70079,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70081,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70085,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70089,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70093,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70094,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70095,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70096,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70106,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70107,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70108,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70109,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70113,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 70144,
        length: 18,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70163,
        length: 25,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70188,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70191,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70194,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70196,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70197,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70198,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70200,
        length: 6,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70206,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70272,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70280,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70282,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70287,
        length: 15,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70303,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70313,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70320,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70367,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70368,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70371,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70384,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70400,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70402,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70405,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70415,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70419,
        length: 22,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70442,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70450,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70453,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70459,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70461,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70462,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70464,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70465,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70471,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70475,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70480,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70487,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70493,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70498,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70502,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70512,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70656,
        length: 53,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70709,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70712,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70720,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70722,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70725,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70726,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70727,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70731,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70736,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 70746,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70749,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70750,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70751,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70784,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70832,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70835,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70841,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70842,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70843,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70847,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70849,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 70850,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 70852,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70854,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 70855,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 70864,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71040,
        length: 47,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71087,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71090,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71096,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71100,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71102,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71103,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71105,
        length: 23,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71128,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71132,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71168,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71216,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71219,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71227,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71229,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71230,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71231,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71233,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71236,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71248,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71264,
        length: 13,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71296,
        length: 43,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71339,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71340,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71341,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71342,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71344,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71350,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71351,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71352,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71360,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71424,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71453,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71456,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71458,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71462,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71463,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71472,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71482,
        length: 2,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 71484,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71487,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 71680,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71724,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71727,
        length: 9,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71736,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71737,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71739,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 71840,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 71872,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 71904,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 71914,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 71935,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71945,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71948,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71957,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71960,
        length: 24,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 71984,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71991,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71995,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71997,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 71998,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 71999,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72000,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72001,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72002,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72003,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72004,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72016,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 72096,
        length: 8,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72106,
        length: 39,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72145,
        length: 3,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72148,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72154,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72156,
        length: 4,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72160,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72161,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72162,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72163,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72164,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72192,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72193,
        length: 10,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72203,
        length: 40,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72243,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72249,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72250,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72251,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72255,
        length: 8,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72263,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72272,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72273,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72279,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72281,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72284,
        length: 46,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72330,
        length: 13,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72343,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72344,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72346,
        length: 3,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72349,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72350,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72384,
        length: 57,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72704,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72714,
        length: 37,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72751,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72752,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72760,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72766,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72767,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72768,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72769,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72784,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 72794,
        length: 19,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 72816,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 72818,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72850,
        length: 22,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72873,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72874,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72881,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72882,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72884,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 72885,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 72960,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72968,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 72971,
        length: 38,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73009,
        length: 6,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73018,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73020,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73023,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73030,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73031,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73040,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 73056,
        length: 6,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73063,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73066,
        length: 32,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73098,
        length: 5,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73104,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73107,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73109,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73110,
        length: 1,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73111,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73112,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73120,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 73440,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73459,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 73461,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 73463,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 73648,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 73664,
        length: 21,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 73685,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 73693,
        length: 4,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 73697,
        length: 17,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 73727,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 73728,
        length: 922,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 74752,
        length: 111,
        convRule: $f87c9187b968257a$export$cb3182d6558993ee
    },
    {
        start: 74864,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 74880,
        length: 196,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 77824,
        length: 1071,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 78896,
        length: 9,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 82944,
        length: 583,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92160,
        length: 569,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92736,
        length: 31,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92768,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 92782,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92880,
        length: 30,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92912,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 92917,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92928,
        length: 48,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 92976,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 92983,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92988,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 92992,
        length: 4,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 92996,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 92997,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 93008,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 93019,
        length: 7,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 93027,
        length: 21,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 93053,
        length: 19,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 93760,
        length: 32,
        convRule: $f87c9187b968257a$export$5a8ad4756351e1a2
    },
    {
        start: 93792,
        length: 32,
        convRule: $f87c9187b968257a$export$7173d2ee342e278
    },
    {
        start: 93824,
        length: 23,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 93847,
        length: 4,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 93952,
        length: 75,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 94031,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94032,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 94033,
        length: 55,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 94095,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94099,
        length: 13,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94176,
        length: 2,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94178,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 94179,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 94180,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 94192,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 94208,
        length: 6136,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 100352,
        length: 1238,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 101632,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110592,
        length: 287,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110928,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110948,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 110960,
        length: 396,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113664,
        length: 107,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113776,
        length: 13,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113792,
        length: 9,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113808,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 113820,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 113821,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 113823,
        length: 1,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 113824,
        length: 4,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 118784,
        length: 246,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119040,
        length: 39,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119081,
        length: 60,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119141,
        length: 2,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 119143,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119146,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119149,
        length: 6,
        convRule: $f87c9187b968257a$export$7132832865eb9304
    },
    {
        start: 119155,
        length: 8,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 119163,
        length: 8,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119171,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119173,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119180,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119210,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119214,
        length: 59,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119296,
        length: 66,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119362,
        length: 3,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 119365,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119520,
        length: 20,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 119552,
        length: 87,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 119648,
        length: 25,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 119808,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119834,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119860,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119886,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119894,
        length: 18,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119912,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119938,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119964,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119966,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119970,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119973,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119977,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119982,
        length: 8,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 119990,
        length: 4,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119995,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 119997,
        length: 7,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120005,
        length: 11,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120016,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120042,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120068,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120071,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120077,
        length: 8,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120086,
        length: 7,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120094,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120120,
        length: 2,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120123,
        length: 4,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120128,
        length: 5,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120134,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120138,
        length: 7,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120146,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120172,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120198,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120224,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120250,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120276,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120302,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120328,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120354,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120380,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120406,
        length: 26,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120432,
        length: 26,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120458,
        length: 28,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120488,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120513,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120514,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120539,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120540,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120546,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120571,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120572,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120597,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120598,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120604,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120629,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120630,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120655,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120656,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120662,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120687,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120688,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120713,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120714,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120720,
        length: 25,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120745,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120746,
        length: 25,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120771,
        length: 1,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 120772,
        length: 6,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120778,
        length: 1,
        convRule: $f87c9187b968257a$export$36a4b98da6bb954e
    },
    {
        start: 120779,
        length: 1,
        convRule: $f87c9187b968257a$export$d27b372c28d7cd4
    },
    {
        start: 120782,
        length: 50,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 120832,
        length: 512,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121344,
        length: 55,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121399,
        length: 4,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121403,
        length: 50,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121453,
        length: 8,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121461,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121462,
        length: 14,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121476,
        length: 1,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121477,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 121479,
        length: 5,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 121499,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 121505,
        length: 15,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122880,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122888,
        length: 17,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122907,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122915,
        length: 2,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 122918,
        length: 5,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123136,
        length: 45,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123184,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123191,
        length: 7,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 123200,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 123214,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123215,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 123584,
        length: 44,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 123628,
        length: 4,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 123632,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 123647,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 124928,
        length: 197,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 125127,
        length: 9,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 125136,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 125184,
        length: 34,
        convRule: $f87c9187b968257a$export$f0d6a468761d4066
    },
    {
        start: 125218,
        length: 34,
        convRule: $f87c9187b968257a$export$2a95711cd575be0d
    },
    {
        start: 125252,
        length: 7,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 125259,
        length: 1,
        convRule: $f87c9187b968257a$export$74a12340c61f1f97
    },
    {
        start: 125264,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 125278,
        length: 2,
        convRule: $f87c9187b968257a$export$fb53d86ce7e0a34e
    },
    {
        start: 126065,
        length: 59,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126124,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 126125,
        length: 3,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126128,
        length: 1,
        convRule: $f87c9187b968257a$export$866935d782a1adf9
    },
    {
        start: 126129,
        length: 4,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126209,
        length: 45,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126254,
        length: 1,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 126255,
        length: 15,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 126464,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126469,
        length: 27,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126497,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126500,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126503,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126505,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126516,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126521,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126523,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126530,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126535,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126537,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126539,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126541,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126545,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126548,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126551,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126553,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126555,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126557,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126559,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126561,
        length: 2,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126564,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126567,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126572,
        length: 7,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126580,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126585,
        length: 4,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126590,
        length: 1,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126592,
        length: 10,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126603,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126625,
        length: 3,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126629,
        length: 5,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126635,
        length: 17,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 126704,
        length: 2,
        convRule: $f87c9187b968257a$export$794fb0e11b7dc9ad
    },
    {
        start: 126976,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127024,
        length: 100,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127136,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127153,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127169,
        length: 15,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127185,
        length: 37,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127232,
        length: 13,
        convRule: $f87c9187b968257a$export$33c1a8bf25446776
    },
    {
        start: 127245,
        length: 161,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127462,
        length: 29,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127504,
        length: 44,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127552,
        length: 9,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127568,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127584,
        length: 6,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127744,
        length: 251,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 127995,
        length: 5,
        convRule: $f87c9187b968257a$export$24824e665deb80e4
    },
    {
        start: 128000,
        length: 728,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128736,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128752,
        length: 13,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128768,
        length: 116,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128896,
        length: 89,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 128992,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129024,
        length: 12,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129040,
        length: 56,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129104,
        length: 10,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129120,
        length: 40,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129168,
        length: 30,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129200,
        length: 2,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129280,
        length: 121,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129402,
        length: 82,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129485,
        length: 135,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129632,
        length: 14,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129648,
        length: 5,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129656,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129664,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129680,
        length: 25,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129712,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129728,
        length: 3,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129744,
        length: 7,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129792,
        length: 147,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 129940,
        length: 55,
        convRule: $f87c9187b968257a$export$d8f896e54b4d4d94
    },
    {
        start: 130032,
        length: 10,
        convRule: $f87c9187b968257a$export$81f55ec0bbc32b6e
    },
    {
        start: 131072,
        length: 42718,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 173824,
        length: 4149,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 177984,
        length: 222,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 178208,
        length: 5762,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 183984,
        length: 7473,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 194560,
        length: 542,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 196608,
        length: 4939,
        convRule: $f87c9187b968257a$export$3ce418d90f721a6f
    },
    {
        start: 917505,
        length: 1,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 917536,
        length: 96,
        convRule: $f87c9187b968257a$export$def784bda4c4ba83
    },
    {
        start: 917760,
        length: 240,
        convRule: $f87c9187b968257a$export$87fde0d9cf78d1f
    },
    {
        start: 983040,
        length: 65534,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    },
    {
        start: 1048576,
        length: 65534,
        convRule: $f87c9187b968257a$export$d3f5d9ad8c1cc11c
    }
];
var $f87c9187b968257a$export$392fe5f697aae183 = function(categories) {
    return function($$char) {
        var numOfBlocks = function() {
            var $43 = $$char < 256;
            if ($43) return $f87c9187b968257a$export$7f6a2f09c9988b4f;
            return $f87c9187b968257a$export$d769d73966952fc5;
        }();
        var maybeConversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$865f22e68241060)($$char)(numOfBlocks);
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
        if (maybeConversionRule instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$export$c15bd07a493e1236($f87c9187b968257a$var$elemIndex(maybeConversionRule.value0.category)(categories));
        throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal (line 5645, column 5 - line 5647, column 86): " + [
            maybeConversionRule.constructor.name
        ]);
    };
};
var $f87c9187b968257a$export$a0fec735e7d145b = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e589cea9a12b5fd5,
    $f87c9187b968257a$export$b2d990af7ab79d15,
    $f87c9187b968257a$export$ad5a9d75e70e6c80,
    $f87c9187b968257a$export$f3ac9c79570e46a,
    $f87c9187b968257a$export$b6e1d994a4b080a2,
    $f87c9187b968257a$export$a698e2e1192c5125,
    $f87c9187b968257a$export$a933a29cf15fc29a
]);
var $f87c9187b968257a$export$edcbae4531e40b8a = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e589cea9a12b5fd5
]);
var $f87c9187b968257a$export$fed91e20fe04f313 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$3546ca4e02dbfe5f
]);
var $f87c9187b968257a$export$5d47dfc33b19ad38 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$a698e2e1192c5125
]);
var $f87c9187b968257a$export$7a4a3ef8a70b2a6 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$2bb2c2963662e583
]);
var $f87c9187b968257a$export$8b4972b3757fc3c7 = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$b2d990af7ab79d15,
    $f87c9187b968257a$export$b6e1d994a4b080a2,
    $f87c9187b968257a$export$12ed53279ee450c4,
    $f87c9187b968257a$export$ad5a9d75e70e6c80,
    $f87c9187b968257a$export$a698e2e1192c5125,
    $f87c9187b968257a$export$a143e8efcc235a35,
    $f87c9187b968257a$export$c216bdb3b7384b3d,
    $f87c9187b968257a$export$686b010d74c757cc,
    $f87c9187b968257a$export$19ffa5f679fe11c0,
    $f87c9187b968257a$export$8e8b15481dfb814b,
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$fd5605db2a5deb4d,
    $f87c9187b968257a$export$a88f47445a8e3717,
    $f87c9187b968257a$export$fd83b20886c8feaa,
    $f87c9187b968257a$export$845a9d462a039d1b,
    $f87c9187b968257a$export$657f9ea297735c46,
    $f87c9187b968257a$export$c3ab662ef084c6ac,
    $f87c9187b968257a$export$2bb2c2963662e583,
    $f87c9187b968257a$export$f1770ca2c5ffe2d,
    $f87c9187b968257a$export$e01a543066f4428d,
    $f87c9187b968257a$export$a933a29cf15fc29a,
    $f87c9187b968257a$export$f3ac9c79570e46a,
    $f87c9187b968257a$export$e589cea9a12b5fd5
]);
var $f87c9187b968257a$export$3cb76ee86c1f055b = /* #__PURE__ */ $f87c9187b968257a$export$392fe5f697aae183([
    $f87c9187b968257a$export$87f3132a44b1d0ea,
    $f87c9187b968257a$export$c216bdb3b7384b3d
]);
var $f87c9187b968257a$export$6d2646f79a263fa8 = function($$char) {
    var conversionRule = $f87c9187b968257a$export$8a73d6c1af11382a($f87c9187b968257a$export$865f22e68241060)($$char)($f87c9187b968257a$export$d769d73966952fc5);
    return $f87c9187b968257a$var$map(function(v) {
        return v.unicodeCat;
    })(conversionRule);
};


// Generated by purs version 0.15.15




var $7b07f9d0d04434a1$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $7b07f9d0d04434a1$export$b6e1a177a4bea09c = function(code) {
    return {
        code: code,
        lower: [],
        title: [],
        upper: [],
        fold: 0,
        foldFull: []
    };
};
var $7b07f9d0d04434a1$export$354076178bdef094 = [
    {
        code: 65,
        lower: [],
        title: [],
        upper: [],
        fold: 97,
        foldFull: [
            97
        ]
    },
    {
        code: 66,
        lower: [],
        title: [],
        upper: [],
        fold: 98,
        foldFull: [
            98
        ]
    },
    {
        code: 67,
        lower: [],
        title: [],
        upper: [],
        fold: 99,
        foldFull: [
            99
        ]
    },
    {
        code: 68,
        lower: [],
        title: [],
        upper: [],
        fold: 100,
        foldFull: [
            100
        ]
    },
    {
        code: 69,
        lower: [],
        title: [],
        upper: [],
        fold: 101,
        foldFull: [
            101
        ]
    },
    {
        code: 70,
        lower: [],
        title: [],
        upper: [],
        fold: 102,
        foldFull: [
            102
        ]
    },
    {
        code: 71,
        lower: [],
        title: [],
        upper: [],
        fold: 103,
        foldFull: [
            103
        ]
    },
    {
        code: 72,
        lower: [],
        title: [],
        upper: [],
        fold: 104,
        foldFull: [
            104
        ]
    },
    {
        code: 73,
        lower: [],
        title: [],
        upper: [],
        fold: 105,
        foldFull: [
            105
        ]
    },
    {
        code: 74,
        lower: [],
        title: [],
        upper: [],
        fold: 106,
        foldFull: [
            106
        ]
    },
    {
        code: 75,
        lower: [],
        title: [],
        upper: [],
        fold: 107,
        foldFull: [
            107
        ]
    },
    {
        code: 76,
        lower: [],
        title: [],
        upper: [],
        fold: 108,
        foldFull: [
            108
        ]
    },
    {
        code: 77,
        lower: [],
        title: [],
        upper: [],
        fold: 109,
        foldFull: [
            109
        ]
    },
    {
        code: 78,
        lower: [],
        title: [],
        upper: [],
        fold: 110,
        foldFull: [
            110
        ]
    },
    {
        code: 79,
        lower: [],
        title: [],
        upper: [],
        fold: 111,
        foldFull: [
            111
        ]
    },
    {
        code: 80,
        lower: [],
        title: [],
        upper: [],
        fold: 112,
        foldFull: [
            112
        ]
    },
    {
        code: 81,
        lower: [],
        title: [],
        upper: [],
        fold: 113,
        foldFull: [
            113
        ]
    },
    {
        code: 82,
        lower: [],
        title: [],
        upper: [],
        fold: 114,
        foldFull: [
            114
        ]
    },
    {
        code: 83,
        lower: [],
        title: [],
        upper: [],
        fold: 115,
        foldFull: [
            115
        ]
    },
    {
        code: 84,
        lower: [],
        title: [],
        upper: [],
        fold: 116,
        foldFull: [
            116
        ]
    },
    {
        code: 85,
        lower: [],
        title: [],
        upper: [],
        fold: 117,
        foldFull: [
            117
        ]
    },
    {
        code: 86,
        lower: [],
        title: [],
        upper: [],
        fold: 118,
        foldFull: [
            118
        ]
    },
    {
        code: 87,
        lower: [],
        title: [],
        upper: [],
        fold: 119,
        foldFull: [
            119
        ]
    },
    {
        code: 88,
        lower: [],
        title: [],
        upper: [],
        fold: 120,
        foldFull: [
            120
        ]
    },
    {
        code: 89,
        lower: [],
        title: [],
        upper: [],
        fold: 121,
        foldFull: [
            121
        ]
    },
    {
        code: 90,
        lower: [],
        title: [],
        upper: [],
        fold: 122,
        foldFull: [
            122
        ]
    },
    {
        code: 181,
        lower: [],
        title: [],
        upper: [],
        fold: 956,
        foldFull: [
            956
        ]
    },
    {
        code: 192,
        lower: [],
        title: [],
        upper: [],
        fold: 224,
        foldFull: [
            224
        ]
    },
    {
        code: 193,
        lower: [],
        title: [],
        upper: [],
        fold: 225,
        foldFull: [
            225
        ]
    },
    {
        code: 194,
        lower: [],
        title: [],
        upper: [],
        fold: 226,
        foldFull: [
            226
        ]
    },
    {
        code: 195,
        lower: [],
        title: [],
        upper: [],
        fold: 227,
        foldFull: [
            227
        ]
    },
    {
        code: 196,
        lower: [],
        title: [],
        upper: [],
        fold: 228,
        foldFull: [
            228
        ]
    },
    {
        code: 197,
        lower: [],
        title: [],
        upper: [],
        fold: 229,
        foldFull: [
            229
        ]
    },
    {
        code: 198,
        lower: [],
        title: [],
        upper: [],
        fold: 230,
        foldFull: [
            230
        ]
    },
    {
        code: 199,
        lower: [],
        title: [],
        upper: [],
        fold: 231,
        foldFull: [
            231
        ]
    },
    {
        code: 200,
        lower: [],
        title: [],
        upper: [],
        fold: 232,
        foldFull: [
            232
        ]
    },
    {
        code: 201,
        lower: [],
        title: [],
        upper: [],
        fold: 233,
        foldFull: [
            233
        ]
    },
    {
        code: 202,
        lower: [],
        title: [],
        upper: [],
        fold: 234,
        foldFull: [
            234
        ]
    },
    {
        code: 203,
        lower: [],
        title: [],
        upper: [],
        fold: 235,
        foldFull: [
            235
        ]
    },
    {
        code: 204,
        lower: [],
        title: [],
        upper: [],
        fold: 236,
        foldFull: [
            236
        ]
    },
    {
        code: 205,
        lower: [],
        title: [],
        upper: [],
        fold: 237,
        foldFull: [
            237
        ]
    },
    {
        code: 206,
        lower: [],
        title: [],
        upper: [],
        fold: 238,
        foldFull: [
            238
        ]
    },
    {
        code: 207,
        lower: [],
        title: [],
        upper: [],
        fold: 239,
        foldFull: [
            239
        ]
    },
    {
        code: 208,
        lower: [],
        title: [],
        upper: [],
        fold: 240,
        foldFull: [
            240
        ]
    },
    {
        code: 209,
        lower: [],
        title: [],
        upper: [],
        fold: 241,
        foldFull: [
            241
        ]
    },
    {
        code: 210,
        lower: [],
        title: [],
        upper: [],
        fold: 242,
        foldFull: [
            242
        ]
    },
    {
        code: 211,
        lower: [],
        title: [],
        upper: [],
        fold: 243,
        foldFull: [
            243
        ]
    },
    {
        code: 212,
        lower: [],
        title: [],
        upper: [],
        fold: 244,
        foldFull: [
            244
        ]
    },
    {
        code: 213,
        lower: [],
        title: [],
        upper: [],
        fold: 245,
        foldFull: [
            245
        ]
    },
    {
        code: 214,
        lower: [],
        title: [],
        upper: [],
        fold: 246,
        foldFull: [
            246
        ]
    },
    {
        code: 216,
        lower: [],
        title: [],
        upper: [],
        fold: 248,
        foldFull: [
            248
        ]
    },
    {
        code: 217,
        lower: [],
        title: [],
        upper: [],
        fold: 249,
        foldFull: [
            249
        ]
    },
    {
        code: 218,
        lower: [],
        title: [],
        upper: [],
        fold: 250,
        foldFull: [
            250
        ]
    },
    {
        code: 219,
        lower: [],
        title: [],
        upper: [],
        fold: 251,
        foldFull: [
            251
        ]
    },
    {
        code: 220,
        lower: [],
        title: [],
        upper: [],
        fold: 252,
        foldFull: [
            252
        ]
    },
    {
        code: 221,
        lower: [],
        title: [],
        upper: [],
        fold: 253,
        foldFull: [
            253
        ]
    },
    {
        code: 222,
        lower: [],
        title: [],
        upper: [],
        fold: 254,
        foldFull: [
            254
        ]
    },
    {
        code: 223,
        lower: [
            223
        ],
        title: [
            83,
            115
        ],
        upper: [
            83,
            83
        ],
        fold: 0,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 223,
        lower: [
            223
        ],
        title: [
            83,
            115
        ],
        upper: [
            83,
            83
        ],
        fold: 0,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 256,
        lower: [],
        title: [],
        upper: [],
        fold: 257,
        foldFull: [
            257
        ]
    },
    {
        code: 258,
        lower: [],
        title: [],
        upper: [],
        fold: 259,
        foldFull: [
            259
        ]
    },
    {
        code: 260,
        lower: [],
        title: [],
        upper: [],
        fold: 261,
        foldFull: [
            261
        ]
    },
    {
        code: 262,
        lower: [],
        title: [],
        upper: [],
        fold: 263,
        foldFull: [
            263
        ]
    },
    {
        code: 264,
        lower: [],
        title: [],
        upper: [],
        fold: 265,
        foldFull: [
            265
        ]
    },
    {
        code: 266,
        lower: [],
        title: [],
        upper: [],
        fold: 267,
        foldFull: [
            267
        ]
    },
    {
        code: 268,
        lower: [],
        title: [],
        upper: [],
        fold: 269,
        foldFull: [
            269
        ]
    },
    {
        code: 270,
        lower: [],
        title: [],
        upper: [],
        fold: 271,
        foldFull: [
            271
        ]
    },
    {
        code: 272,
        lower: [],
        title: [],
        upper: [],
        fold: 273,
        foldFull: [
            273
        ]
    },
    {
        code: 274,
        lower: [],
        title: [],
        upper: [],
        fold: 275,
        foldFull: [
            275
        ]
    },
    {
        code: 276,
        lower: [],
        title: [],
        upper: [],
        fold: 277,
        foldFull: [
            277
        ]
    },
    {
        code: 278,
        lower: [],
        title: [],
        upper: [],
        fold: 279,
        foldFull: [
            279
        ]
    },
    {
        code: 280,
        lower: [],
        title: [],
        upper: [],
        fold: 281,
        foldFull: [
            281
        ]
    },
    {
        code: 282,
        lower: [],
        title: [],
        upper: [],
        fold: 283,
        foldFull: [
            283
        ]
    },
    {
        code: 284,
        lower: [],
        title: [],
        upper: [],
        fold: 285,
        foldFull: [
            285
        ]
    },
    {
        code: 286,
        lower: [],
        title: [],
        upper: [],
        fold: 287,
        foldFull: [
            287
        ]
    },
    {
        code: 288,
        lower: [],
        title: [],
        upper: [],
        fold: 289,
        foldFull: [
            289
        ]
    },
    {
        code: 290,
        lower: [],
        title: [],
        upper: [],
        fold: 291,
        foldFull: [
            291
        ]
    },
    {
        code: 292,
        lower: [],
        title: [],
        upper: [],
        fold: 293,
        foldFull: [
            293
        ]
    },
    {
        code: 294,
        lower: [],
        title: [],
        upper: [],
        fold: 295,
        foldFull: [
            295
        ]
    },
    {
        code: 296,
        lower: [],
        title: [],
        upper: [],
        fold: 297,
        foldFull: [
            297
        ]
    },
    {
        code: 298,
        lower: [],
        title: [],
        upper: [],
        fold: 299,
        foldFull: [
            299
        ]
    },
    {
        code: 300,
        lower: [],
        title: [],
        upper: [],
        fold: 301,
        foldFull: [
            301
        ]
    },
    {
        code: 302,
        lower: [],
        title: [],
        upper: [],
        fold: 303,
        foldFull: [
            303
        ]
    },
    {
        code: 304,
        lower: [
            105,
            775
        ],
        title: [
            304
        ],
        upper: [
            304
        ],
        fold: 0,
        foldFull: [
            105,
            775
        ]
    },
    {
        code: 304,
        lower: [
            105,
            775
        ],
        title: [
            304
        ],
        upper: [
            304
        ],
        fold: 0,
        foldFull: [
            105,
            775
        ]
    },
    {
        code: 306,
        lower: [],
        title: [],
        upper: [],
        fold: 307,
        foldFull: [
            307
        ]
    },
    {
        code: 308,
        lower: [],
        title: [],
        upper: [],
        fold: 309,
        foldFull: [
            309
        ]
    },
    {
        code: 310,
        lower: [],
        title: [],
        upper: [],
        fold: 311,
        foldFull: [
            311
        ]
    },
    {
        code: 313,
        lower: [],
        title: [],
        upper: [],
        fold: 314,
        foldFull: [
            314
        ]
    },
    {
        code: 315,
        lower: [],
        title: [],
        upper: [],
        fold: 316,
        foldFull: [
            316
        ]
    },
    {
        code: 317,
        lower: [],
        title: [],
        upper: [],
        fold: 318,
        foldFull: [
            318
        ]
    },
    {
        code: 319,
        lower: [],
        title: [],
        upper: [],
        fold: 320,
        foldFull: [
            320
        ]
    },
    {
        code: 321,
        lower: [],
        title: [],
        upper: [],
        fold: 322,
        foldFull: [
            322
        ]
    },
    {
        code: 323,
        lower: [],
        title: [],
        upper: [],
        fold: 324,
        foldFull: [
            324
        ]
    },
    {
        code: 325,
        lower: [],
        title: [],
        upper: [],
        fold: 326,
        foldFull: [
            326
        ]
    },
    {
        code: 327,
        lower: [],
        title: [],
        upper: [],
        fold: 328,
        foldFull: [
            328
        ]
    },
    {
        code: 329,
        lower: [
            329
        ],
        title: [
            700,
            78
        ],
        upper: [
            700,
            78
        ],
        fold: 0,
        foldFull: [
            700,
            110
        ]
    },
    {
        code: 329,
        lower: [
            329
        ],
        title: [
            700,
            78
        ],
        upper: [
            700,
            78
        ],
        fold: 0,
        foldFull: [
            700,
            110
        ]
    },
    {
        code: 330,
        lower: [],
        title: [],
        upper: [],
        fold: 331,
        foldFull: [
            331
        ]
    },
    {
        code: 332,
        lower: [],
        title: [],
        upper: [],
        fold: 333,
        foldFull: [
            333
        ]
    },
    {
        code: 334,
        lower: [],
        title: [],
        upper: [],
        fold: 335,
        foldFull: [
            335
        ]
    },
    {
        code: 336,
        lower: [],
        title: [],
        upper: [],
        fold: 337,
        foldFull: [
            337
        ]
    },
    {
        code: 338,
        lower: [],
        title: [],
        upper: [],
        fold: 339,
        foldFull: [
            339
        ]
    },
    {
        code: 340,
        lower: [],
        title: [],
        upper: [],
        fold: 341,
        foldFull: [
            341
        ]
    },
    {
        code: 342,
        lower: [],
        title: [],
        upper: [],
        fold: 343,
        foldFull: [
            343
        ]
    },
    {
        code: 344,
        lower: [],
        title: [],
        upper: [],
        fold: 345,
        foldFull: [
            345
        ]
    },
    {
        code: 346,
        lower: [],
        title: [],
        upper: [],
        fold: 347,
        foldFull: [
            347
        ]
    },
    {
        code: 348,
        lower: [],
        title: [],
        upper: [],
        fold: 349,
        foldFull: [
            349
        ]
    },
    {
        code: 350,
        lower: [],
        title: [],
        upper: [],
        fold: 351,
        foldFull: [
            351
        ]
    },
    {
        code: 352,
        lower: [],
        title: [],
        upper: [],
        fold: 353,
        foldFull: [
            353
        ]
    },
    {
        code: 354,
        lower: [],
        title: [],
        upper: [],
        fold: 355,
        foldFull: [
            355
        ]
    },
    {
        code: 356,
        lower: [],
        title: [],
        upper: [],
        fold: 357,
        foldFull: [
            357
        ]
    },
    {
        code: 358,
        lower: [],
        title: [],
        upper: [],
        fold: 359,
        foldFull: [
            359
        ]
    },
    {
        code: 360,
        lower: [],
        title: [],
        upper: [],
        fold: 361,
        foldFull: [
            361
        ]
    },
    {
        code: 362,
        lower: [],
        title: [],
        upper: [],
        fold: 363,
        foldFull: [
            363
        ]
    },
    {
        code: 364,
        lower: [],
        title: [],
        upper: [],
        fold: 365,
        foldFull: [
            365
        ]
    },
    {
        code: 366,
        lower: [],
        title: [],
        upper: [],
        fold: 367,
        foldFull: [
            367
        ]
    },
    {
        code: 368,
        lower: [],
        title: [],
        upper: [],
        fold: 369,
        foldFull: [
            369
        ]
    },
    {
        code: 370,
        lower: [],
        title: [],
        upper: [],
        fold: 371,
        foldFull: [
            371
        ]
    },
    {
        code: 372,
        lower: [],
        title: [],
        upper: [],
        fold: 373,
        foldFull: [
            373
        ]
    },
    {
        code: 374,
        lower: [],
        title: [],
        upper: [],
        fold: 375,
        foldFull: [
            375
        ]
    },
    {
        code: 376,
        lower: [],
        title: [],
        upper: [],
        fold: 255,
        foldFull: [
            255
        ]
    },
    {
        code: 377,
        lower: [],
        title: [],
        upper: [],
        fold: 378,
        foldFull: [
            378
        ]
    },
    {
        code: 379,
        lower: [],
        title: [],
        upper: [],
        fold: 380,
        foldFull: [
            380
        ]
    },
    {
        code: 381,
        lower: [],
        title: [],
        upper: [],
        fold: 382,
        foldFull: [
            382
        ]
    },
    {
        code: 383,
        lower: [],
        title: [],
        upper: [],
        fold: 115,
        foldFull: [
            115
        ]
    },
    {
        code: 385,
        lower: [],
        title: [],
        upper: [],
        fold: 595,
        foldFull: [
            595
        ]
    },
    {
        code: 386,
        lower: [],
        title: [],
        upper: [],
        fold: 387,
        foldFull: [
            387
        ]
    },
    {
        code: 388,
        lower: [],
        title: [],
        upper: [],
        fold: 389,
        foldFull: [
            389
        ]
    },
    {
        code: 390,
        lower: [],
        title: [],
        upper: [],
        fold: 596,
        foldFull: [
            596
        ]
    },
    {
        code: 391,
        lower: [],
        title: [],
        upper: [],
        fold: 392,
        foldFull: [
            392
        ]
    },
    {
        code: 393,
        lower: [],
        title: [],
        upper: [],
        fold: 598,
        foldFull: [
            598
        ]
    },
    {
        code: 394,
        lower: [],
        title: [],
        upper: [],
        fold: 599,
        foldFull: [
            599
        ]
    },
    {
        code: 395,
        lower: [],
        title: [],
        upper: [],
        fold: 396,
        foldFull: [
            396
        ]
    },
    {
        code: 398,
        lower: [],
        title: [],
        upper: [],
        fold: 477,
        foldFull: [
            477
        ]
    },
    {
        code: 399,
        lower: [],
        title: [],
        upper: [],
        fold: 601,
        foldFull: [
            601
        ]
    },
    {
        code: 400,
        lower: [],
        title: [],
        upper: [],
        fold: 603,
        foldFull: [
            603
        ]
    },
    {
        code: 401,
        lower: [],
        title: [],
        upper: [],
        fold: 402,
        foldFull: [
            402
        ]
    },
    {
        code: 403,
        lower: [],
        title: [],
        upper: [],
        fold: 608,
        foldFull: [
            608
        ]
    },
    {
        code: 404,
        lower: [],
        title: [],
        upper: [],
        fold: 611,
        foldFull: [
            611
        ]
    },
    {
        code: 406,
        lower: [],
        title: [],
        upper: [],
        fold: 617,
        foldFull: [
            617
        ]
    },
    {
        code: 407,
        lower: [],
        title: [],
        upper: [],
        fold: 616,
        foldFull: [
            616
        ]
    },
    {
        code: 408,
        lower: [],
        title: [],
        upper: [],
        fold: 409,
        foldFull: [
            409
        ]
    },
    {
        code: 412,
        lower: [],
        title: [],
        upper: [],
        fold: 623,
        foldFull: [
            623
        ]
    },
    {
        code: 413,
        lower: [],
        title: [],
        upper: [],
        fold: 626,
        foldFull: [
            626
        ]
    },
    {
        code: 415,
        lower: [],
        title: [],
        upper: [],
        fold: 629,
        foldFull: [
            629
        ]
    },
    {
        code: 416,
        lower: [],
        title: [],
        upper: [],
        fold: 417,
        foldFull: [
            417
        ]
    },
    {
        code: 418,
        lower: [],
        title: [],
        upper: [],
        fold: 419,
        foldFull: [
            419
        ]
    },
    {
        code: 420,
        lower: [],
        title: [],
        upper: [],
        fold: 421,
        foldFull: [
            421
        ]
    },
    {
        code: 422,
        lower: [],
        title: [],
        upper: [],
        fold: 640,
        foldFull: [
            640
        ]
    },
    {
        code: 423,
        lower: [],
        title: [],
        upper: [],
        fold: 424,
        foldFull: [
            424
        ]
    },
    {
        code: 425,
        lower: [],
        title: [],
        upper: [],
        fold: 643,
        foldFull: [
            643
        ]
    },
    {
        code: 428,
        lower: [],
        title: [],
        upper: [],
        fold: 429,
        foldFull: [
            429
        ]
    },
    {
        code: 430,
        lower: [],
        title: [],
        upper: [],
        fold: 648,
        foldFull: [
            648
        ]
    },
    {
        code: 431,
        lower: [],
        title: [],
        upper: [],
        fold: 432,
        foldFull: [
            432
        ]
    },
    {
        code: 433,
        lower: [],
        title: [],
        upper: [],
        fold: 650,
        foldFull: [
            650
        ]
    },
    {
        code: 434,
        lower: [],
        title: [],
        upper: [],
        fold: 651,
        foldFull: [
            651
        ]
    },
    {
        code: 435,
        lower: [],
        title: [],
        upper: [],
        fold: 436,
        foldFull: [
            436
        ]
    },
    {
        code: 437,
        lower: [],
        title: [],
        upper: [],
        fold: 438,
        foldFull: [
            438
        ]
    },
    {
        code: 439,
        lower: [],
        title: [],
        upper: [],
        fold: 658,
        foldFull: [
            658
        ]
    },
    {
        code: 440,
        lower: [],
        title: [],
        upper: [],
        fold: 441,
        foldFull: [
            441
        ]
    },
    {
        code: 444,
        lower: [],
        title: [],
        upper: [],
        fold: 445,
        foldFull: [
            445
        ]
    },
    {
        code: 452,
        lower: [],
        title: [],
        upper: [],
        fold: 454,
        foldFull: [
            454
        ]
    },
    {
        code: 453,
        lower: [],
        title: [],
        upper: [],
        fold: 454,
        foldFull: [
            454
        ]
    },
    {
        code: 455,
        lower: [],
        title: [],
        upper: [],
        fold: 457,
        foldFull: [
            457
        ]
    },
    {
        code: 456,
        lower: [],
        title: [],
        upper: [],
        fold: 457,
        foldFull: [
            457
        ]
    },
    {
        code: 458,
        lower: [],
        title: [],
        upper: [],
        fold: 460,
        foldFull: [
            460
        ]
    },
    {
        code: 459,
        lower: [],
        title: [],
        upper: [],
        fold: 460,
        foldFull: [
            460
        ]
    },
    {
        code: 461,
        lower: [],
        title: [],
        upper: [],
        fold: 462,
        foldFull: [
            462
        ]
    },
    {
        code: 463,
        lower: [],
        title: [],
        upper: [],
        fold: 464,
        foldFull: [
            464
        ]
    },
    {
        code: 465,
        lower: [],
        title: [],
        upper: [],
        fold: 466,
        foldFull: [
            466
        ]
    },
    {
        code: 467,
        lower: [],
        title: [],
        upper: [],
        fold: 468,
        foldFull: [
            468
        ]
    },
    {
        code: 469,
        lower: [],
        title: [],
        upper: [],
        fold: 470,
        foldFull: [
            470
        ]
    },
    {
        code: 471,
        lower: [],
        title: [],
        upper: [],
        fold: 472,
        foldFull: [
            472
        ]
    },
    {
        code: 473,
        lower: [],
        title: [],
        upper: [],
        fold: 474,
        foldFull: [
            474
        ]
    },
    {
        code: 475,
        lower: [],
        title: [],
        upper: [],
        fold: 476,
        foldFull: [
            476
        ]
    },
    {
        code: 478,
        lower: [],
        title: [],
        upper: [],
        fold: 479,
        foldFull: [
            479
        ]
    },
    {
        code: 480,
        lower: [],
        title: [],
        upper: [],
        fold: 481,
        foldFull: [
            481
        ]
    },
    {
        code: 482,
        lower: [],
        title: [],
        upper: [],
        fold: 483,
        foldFull: [
            483
        ]
    },
    {
        code: 484,
        lower: [],
        title: [],
        upper: [],
        fold: 485,
        foldFull: [
            485
        ]
    },
    {
        code: 486,
        lower: [],
        title: [],
        upper: [],
        fold: 487,
        foldFull: [
            487
        ]
    },
    {
        code: 488,
        lower: [],
        title: [],
        upper: [],
        fold: 489,
        foldFull: [
            489
        ]
    },
    {
        code: 490,
        lower: [],
        title: [],
        upper: [],
        fold: 491,
        foldFull: [
            491
        ]
    },
    {
        code: 492,
        lower: [],
        title: [],
        upper: [],
        fold: 493,
        foldFull: [
            493
        ]
    },
    {
        code: 494,
        lower: [],
        title: [],
        upper: [],
        fold: 495,
        foldFull: [
            495
        ]
    },
    {
        code: 496,
        lower: [
            496
        ],
        title: [
            74,
            780
        ],
        upper: [
            74,
            780
        ],
        fold: 0,
        foldFull: [
            106,
            780
        ]
    },
    {
        code: 496,
        lower: [
            496
        ],
        title: [
            74,
            780
        ],
        upper: [
            74,
            780
        ],
        fold: 0,
        foldFull: [
            106,
            780
        ]
    },
    {
        code: 497,
        lower: [],
        title: [],
        upper: [],
        fold: 499,
        foldFull: [
            499
        ]
    },
    {
        code: 498,
        lower: [],
        title: [],
        upper: [],
        fold: 499,
        foldFull: [
            499
        ]
    },
    {
        code: 500,
        lower: [],
        title: [],
        upper: [],
        fold: 501,
        foldFull: [
            501
        ]
    },
    {
        code: 502,
        lower: [],
        title: [],
        upper: [],
        fold: 405,
        foldFull: [
            405
        ]
    },
    {
        code: 503,
        lower: [],
        title: [],
        upper: [],
        fold: 447,
        foldFull: [
            447
        ]
    },
    {
        code: 504,
        lower: [],
        title: [],
        upper: [],
        fold: 505,
        foldFull: [
            505
        ]
    },
    {
        code: 506,
        lower: [],
        title: [],
        upper: [],
        fold: 507,
        foldFull: [
            507
        ]
    },
    {
        code: 508,
        lower: [],
        title: [],
        upper: [],
        fold: 509,
        foldFull: [
            509
        ]
    },
    {
        code: 510,
        lower: [],
        title: [],
        upper: [],
        fold: 511,
        foldFull: [
            511
        ]
    },
    {
        code: 512,
        lower: [],
        title: [],
        upper: [],
        fold: 513,
        foldFull: [
            513
        ]
    },
    {
        code: 514,
        lower: [],
        title: [],
        upper: [],
        fold: 515,
        foldFull: [
            515
        ]
    },
    {
        code: 516,
        lower: [],
        title: [],
        upper: [],
        fold: 517,
        foldFull: [
            517
        ]
    },
    {
        code: 518,
        lower: [],
        title: [],
        upper: [],
        fold: 519,
        foldFull: [
            519
        ]
    },
    {
        code: 520,
        lower: [],
        title: [],
        upper: [],
        fold: 521,
        foldFull: [
            521
        ]
    },
    {
        code: 522,
        lower: [],
        title: [],
        upper: [],
        fold: 523,
        foldFull: [
            523
        ]
    },
    {
        code: 524,
        lower: [],
        title: [],
        upper: [],
        fold: 525,
        foldFull: [
            525
        ]
    },
    {
        code: 526,
        lower: [],
        title: [],
        upper: [],
        fold: 527,
        foldFull: [
            527
        ]
    },
    {
        code: 528,
        lower: [],
        title: [],
        upper: [],
        fold: 529,
        foldFull: [
            529
        ]
    },
    {
        code: 530,
        lower: [],
        title: [],
        upper: [],
        fold: 531,
        foldFull: [
            531
        ]
    },
    {
        code: 532,
        lower: [],
        title: [],
        upper: [],
        fold: 533,
        foldFull: [
            533
        ]
    },
    {
        code: 534,
        lower: [],
        title: [],
        upper: [],
        fold: 535,
        foldFull: [
            535
        ]
    },
    {
        code: 536,
        lower: [],
        title: [],
        upper: [],
        fold: 537,
        foldFull: [
            537
        ]
    },
    {
        code: 538,
        lower: [],
        title: [],
        upper: [],
        fold: 539,
        foldFull: [
            539
        ]
    },
    {
        code: 540,
        lower: [],
        title: [],
        upper: [],
        fold: 541,
        foldFull: [
            541
        ]
    },
    {
        code: 542,
        lower: [],
        title: [],
        upper: [],
        fold: 543,
        foldFull: [
            543
        ]
    },
    {
        code: 544,
        lower: [],
        title: [],
        upper: [],
        fold: 414,
        foldFull: [
            414
        ]
    },
    {
        code: 546,
        lower: [],
        title: [],
        upper: [],
        fold: 547,
        foldFull: [
            547
        ]
    },
    {
        code: 548,
        lower: [],
        title: [],
        upper: [],
        fold: 549,
        foldFull: [
            549
        ]
    },
    {
        code: 550,
        lower: [],
        title: [],
        upper: [],
        fold: 551,
        foldFull: [
            551
        ]
    },
    {
        code: 552,
        lower: [],
        title: [],
        upper: [],
        fold: 553,
        foldFull: [
            553
        ]
    },
    {
        code: 554,
        lower: [],
        title: [],
        upper: [],
        fold: 555,
        foldFull: [
            555
        ]
    },
    {
        code: 556,
        lower: [],
        title: [],
        upper: [],
        fold: 557,
        foldFull: [
            557
        ]
    },
    {
        code: 558,
        lower: [],
        title: [],
        upper: [],
        fold: 559,
        foldFull: [
            559
        ]
    },
    {
        code: 560,
        lower: [],
        title: [],
        upper: [],
        fold: 561,
        foldFull: [
            561
        ]
    },
    {
        code: 562,
        lower: [],
        title: [],
        upper: [],
        fold: 563,
        foldFull: [
            563
        ]
    },
    {
        code: 570,
        lower: [],
        title: [],
        upper: [],
        fold: 11365,
        foldFull: [
            11365
        ]
    },
    {
        code: 571,
        lower: [],
        title: [],
        upper: [],
        fold: 572,
        foldFull: [
            572
        ]
    },
    {
        code: 573,
        lower: [],
        title: [],
        upper: [],
        fold: 410,
        foldFull: [
            410
        ]
    },
    {
        code: 574,
        lower: [],
        title: [],
        upper: [],
        fold: 11366,
        foldFull: [
            11366
        ]
    },
    {
        code: 577,
        lower: [],
        title: [],
        upper: [],
        fold: 578,
        foldFull: [
            578
        ]
    },
    {
        code: 579,
        lower: [],
        title: [],
        upper: [],
        fold: 384,
        foldFull: [
            384
        ]
    },
    {
        code: 580,
        lower: [],
        title: [],
        upper: [],
        fold: 649,
        foldFull: [
            649
        ]
    },
    {
        code: 581,
        lower: [],
        title: [],
        upper: [],
        fold: 652,
        foldFull: [
            652
        ]
    },
    {
        code: 582,
        lower: [],
        title: [],
        upper: [],
        fold: 583,
        foldFull: [
            583
        ]
    },
    {
        code: 584,
        lower: [],
        title: [],
        upper: [],
        fold: 585,
        foldFull: [
            585
        ]
    },
    {
        code: 586,
        lower: [],
        title: [],
        upper: [],
        fold: 587,
        foldFull: [
            587
        ]
    },
    {
        code: 588,
        lower: [],
        title: [],
        upper: [],
        fold: 589,
        foldFull: [
            589
        ]
    },
    {
        code: 590,
        lower: [],
        title: [],
        upper: [],
        fold: 591,
        foldFull: [
            591
        ]
    },
    {
        code: 837,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 880,
        lower: [],
        title: [],
        upper: [],
        fold: 881,
        foldFull: [
            881
        ]
    },
    {
        code: 882,
        lower: [],
        title: [],
        upper: [],
        fold: 883,
        foldFull: [
            883
        ]
    },
    {
        code: 886,
        lower: [],
        title: [],
        upper: [],
        fold: 887,
        foldFull: [
            887
        ]
    },
    {
        code: 895,
        lower: [],
        title: [],
        upper: [],
        fold: 1011,
        foldFull: [
            1011
        ]
    },
    {
        code: 902,
        lower: [],
        title: [],
        upper: [],
        fold: 940,
        foldFull: [
            940
        ]
    },
    {
        code: 904,
        lower: [],
        title: [],
        upper: [],
        fold: 941,
        foldFull: [
            941
        ]
    },
    {
        code: 905,
        lower: [],
        title: [],
        upper: [],
        fold: 942,
        foldFull: [
            942
        ]
    },
    {
        code: 906,
        lower: [],
        title: [],
        upper: [],
        fold: 943,
        foldFull: [
            943
        ]
    },
    {
        code: 908,
        lower: [],
        title: [],
        upper: [],
        fold: 972,
        foldFull: [
            972
        ]
    },
    {
        code: 910,
        lower: [],
        title: [],
        upper: [],
        fold: 973,
        foldFull: [
            973
        ]
    },
    {
        code: 911,
        lower: [],
        title: [],
        upper: [],
        fold: 974,
        foldFull: [
            974
        ]
    },
    {
        code: 912,
        lower: [
            912
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 912,
        lower: [
            912
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 913,
        lower: [],
        title: [],
        upper: [],
        fold: 945,
        foldFull: [
            945
        ]
    },
    {
        code: 914,
        lower: [],
        title: [],
        upper: [],
        fold: 946,
        foldFull: [
            946
        ]
    },
    {
        code: 915,
        lower: [],
        title: [],
        upper: [],
        fold: 947,
        foldFull: [
            947
        ]
    },
    {
        code: 916,
        lower: [],
        title: [],
        upper: [],
        fold: 948,
        foldFull: [
            948
        ]
    },
    {
        code: 917,
        lower: [],
        title: [],
        upper: [],
        fold: 949,
        foldFull: [
            949
        ]
    },
    {
        code: 918,
        lower: [],
        title: [],
        upper: [],
        fold: 950,
        foldFull: [
            950
        ]
    },
    {
        code: 919,
        lower: [],
        title: [],
        upper: [],
        fold: 951,
        foldFull: [
            951
        ]
    },
    {
        code: 920,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 921,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 922,
        lower: [],
        title: [],
        upper: [],
        fold: 954,
        foldFull: [
            954
        ]
    },
    {
        code: 923,
        lower: [],
        title: [],
        upper: [],
        fold: 955,
        foldFull: [
            955
        ]
    },
    {
        code: 924,
        lower: [],
        title: [],
        upper: [],
        fold: 956,
        foldFull: [
            956
        ]
    },
    {
        code: 925,
        lower: [],
        title: [],
        upper: [],
        fold: 957,
        foldFull: [
            957
        ]
    },
    {
        code: 926,
        lower: [],
        title: [],
        upper: [],
        fold: 958,
        foldFull: [
            958
        ]
    },
    {
        code: 927,
        lower: [],
        title: [],
        upper: [],
        fold: 959,
        foldFull: [
            959
        ]
    },
    {
        code: 928,
        lower: [],
        title: [],
        upper: [],
        fold: 960,
        foldFull: [
            960
        ]
    },
    {
        code: 929,
        lower: [],
        title: [],
        upper: [],
        fold: 961,
        foldFull: [
            961
        ]
    },
    {
        code: 931,
        lower: [],
        title: [],
        upper: [],
        fold: 963,
        foldFull: [
            963
        ]
    },
    {
        code: 932,
        lower: [],
        title: [],
        upper: [],
        fold: 964,
        foldFull: [
            964
        ]
    },
    {
        code: 933,
        lower: [],
        title: [],
        upper: [],
        fold: 965,
        foldFull: [
            965
        ]
    },
    {
        code: 934,
        lower: [],
        title: [],
        upper: [],
        fold: 966,
        foldFull: [
            966
        ]
    },
    {
        code: 935,
        lower: [],
        title: [],
        upper: [],
        fold: 967,
        foldFull: [
            967
        ]
    },
    {
        code: 936,
        lower: [],
        title: [],
        upper: [],
        fold: 968,
        foldFull: [
            968
        ]
    },
    {
        code: 937,
        lower: [],
        title: [],
        upper: [],
        fold: 969,
        foldFull: [
            969
        ]
    },
    {
        code: 938,
        lower: [],
        title: [],
        upper: [],
        fold: 970,
        foldFull: [
            970
        ]
    },
    {
        code: 939,
        lower: [],
        title: [],
        upper: [],
        fold: 971,
        foldFull: [
            971
        ]
    },
    {
        code: 944,
        lower: [
            944
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 944,
        lower: [
            944
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 962,
        lower: [],
        title: [],
        upper: [],
        fold: 963,
        foldFull: [
            963
        ]
    },
    {
        code: 975,
        lower: [],
        title: [],
        upper: [],
        fold: 983,
        foldFull: [
            983
        ]
    },
    {
        code: 976,
        lower: [],
        title: [],
        upper: [],
        fold: 946,
        foldFull: [
            946
        ]
    },
    {
        code: 977,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 981,
        lower: [],
        title: [],
        upper: [],
        fold: 966,
        foldFull: [
            966
        ]
    },
    {
        code: 982,
        lower: [],
        title: [],
        upper: [],
        fold: 960,
        foldFull: [
            960
        ]
    },
    {
        code: 984,
        lower: [],
        title: [],
        upper: [],
        fold: 985,
        foldFull: [
            985
        ]
    },
    {
        code: 986,
        lower: [],
        title: [],
        upper: [],
        fold: 987,
        foldFull: [
            987
        ]
    },
    {
        code: 988,
        lower: [],
        title: [],
        upper: [],
        fold: 989,
        foldFull: [
            989
        ]
    },
    {
        code: 990,
        lower: [],
        title: [],
        upper: [],
        fold: 991,
        foldFull: [
            991
        ]
    },
    {
        code: 992,
        lower: [],
        title: [],
        upper: [],
        fold: 993,
        foldFull: [
            993
        ]
    },
    {
        code: 994,
        lower: [],
        title: [],
        upper: [],
        fold: 995,
        foldFull: [
            995
        ]
    },
    {
        code: 996,
        lower: [],
        title: [],
        upper: [],
        fold: 997,
        foldFull: [
            997
        ]
    },
    {
        code: 998,
        lower: [],
        title: [],
        upper: [],
        fold: 999,
        foldFull: [
            999
        ]
    },
    {
        code: 1000,
        lower: [],
        title: [],
        upper: [],
        fold: 1001,
        foldFull: [
            1001
        ]
    },
    {
        code: 1002,
        lower: [],
        title: [],
        upper: [],
        fold: 1003,
        foldFull: [
            1003
        ]
    },
    {
        code: 1004,
        lower: [],
        title: [],
        upper: [],
        fold: 1005,
        foldFull: [
            1005
        ]
    },
    {
        code: 1006,
        lower: [],
        title: [],
        upper: [],
        fold: 1007,
        foldFull: [
            1007
        ]
    },
    {
        code: 1008,
        lower: [],
        title: [],
        upper: [],
        fold: 954,
        foldFull: [
            954
        ]
    },
    {
        code: 1009,
        lower: [],
        title: [],
        upper: [],
        fold: 961,
        foldFull: [
            961
        ]
    },
    {
        code: 1012,
        lower: [],
        title: [],
        upper: [],
        fold: 952,
        foldFull: [
            952
        ]
    },
    {
        code: 1013,
        lower: [],
        title: [],
        upper: [],
        fold: 949,
        foldFull: [
            949
        ]
    },
    {
        code: 1015,
        lower: [],
        title: [],
        upper: [],
        fold: 1016,
        foldFull: [
            1016
        ]
    },
    {
        code: 1017,
        lower: [],
        title: [],
        upper: [],
        fold: 1010,
        foldFull: [
            1010
        ]
    },
    {
        code: 1018,
        lower: [],
        title: [],
        upper: [],
        fold: 1019,
        foldFull: [
            1019
        ]
    },
    {
        code: 1021,
        lower: [],
        title: [],
        upper: [],
        fold: 891,
        foldFull: [
            891
        ]
    },
    {
        code: 1022,
        lower: [],
        title: [],
        upper: [],
        fold: 892,
        foldFull: [
            892
        ]
    },
    {
        code: 1023,
        lower: [],
        title: [],
        upper: [],
        fold: 893,
        foldFull: [
            893
        ]
    },
    {
        code: 1024,
        lower: [],
        title: [],
        upper: [],
        fold: 1104,
        foldFull: [
            1104
        ]
    },
    {
        code: 1025,
        lower: [],
        title: [],
        upper: [],
        fold: 1105,
        foldFull: [
            1105
        ]
    },
    {
        code: 1026,
        lower: [],
        title: [],
        upper: [],
        fold: 1106,
        foldFull: [
            1106
        ]
    },
    {
        code: 1027,
        lower: [],
        title: [],
        upper: [],
        fold: 1107,
        foldFull: [
            1107
        ]
    },
    {
        code: 1028,
        lower: [],
        title: [],
        upper: [],
        fold: 1108,
        foldFull: [
            1108
        ]
    },
    {
        code: 1029,
        lower: [],
        title: [],
        upper: [],
        fold: 1109,
        foldFull: [
            1109
        ]
    },
    {
        code: 1030,
        lower: [],
        title: [],
        upper: [],
        fold: 1110,
        foldFull: [
            1110
        ]
    },
    {
        code: 1031,
        lower: [],
        title: [],
        upper: [],
        fold: 1111,
        foldFull: [
            1111
        ]
    },
    {
        code: 1032,
        lower: [],
        title: [],
        upper: [],
        fold: 1112,
        foldFull: [
            1112
        ]
    },
    {
        code: 1033,
        lower: [],
        title: [],
        upper: [],
        fold: 1113,
        foldFull: [
            1113
        ]
    },
    {
        code: 1034,
        lower: [],
        title: [],
        upper: [],
        fold: 1114,
        foldFull: [
            1114
        ]
    },
    {
        code: 1035,
        lower: [],
        title: [],
        upper: [],
        fold: 1115,
        foldFull: [
            1115
        ]
    },
    {
        code: 1036,
        lower: [],
        title: [],
        upper: [],
        fold: 1116,
        foldFull: [
            1116
        ]
    },
    {
        code: 1037,
        lower: [],
        title: [],
        upper: [],
        fold: 1117,
        foldFull: [
            1117
        ]
    },
    {
        code: 1038,
        lower: [],
        title: [],
        upper: [],
        fold: 1118,
        foldFull: [
            1118
        ]
    },
    {
        code: 1039,
        lower: [],
        title: [],
        upper: [],
        fold: 1119,
        foldFull: [
            1119
        ]
    },
    {
        code: 1040,
        lower: [],
        title: [],
        upper: [],
        fold: 1072,
        foldFull: [
            1072
        ]
    },
    {
        code: 1041,
        lower: [],
        title: [],
        upper: [],
        fold: 1073,
        foldFull: [
            1073
        ]
    },
    {
        code: 1042,
        lower: [],
        title: [],
        upper: [],
        fold: 1074,
        foldFull: [
            1074
        ]
    },
    {
        code: 1043,
        lower: [],
        title: [],
        upper: [],
        fold: 1075,
        foldFull: [
            1075
        ]
    },
    {
        code: 1044,
        lower: [],
        title: [],
        upper: [],
        fold: 1076,
        foldFull: [
            1076
        ]
    },
    {
        code: 1045,
        lower: [],
        title: [],
        upper: [],
        fold: 1077,
        foldFull: [
            1077
        ]
    },
    {
        code: 1046,
        lower: [],
        title: [],
        upper: [],
        fold: 1078,
        foldFull: [
            1078
        ]
    },
    {
        code: 1047,
        lower: [],
        title: [],
        upper: [],
        fold: 1079,
        foldFull: [
            1079
        ]
    },
    {
        code: 1048,
        lower: [],
        title: [],
        upper: [],
        fold: 1080,
        foldFull: [
            1080
        ]
    },
    {
        code: 1049,
        lower: [],
        title: [],
        upper: [],
        fold: 1081,
        foldFull: [
            1081
        ]
    },
    {
        code: 1050,
        lower: [],
        title: [],
        upper: [],
        fold: 1082,
        foldFull: [
            1082
        ]
    },
    {
        code: 1051,
        lower: [],
        title: [],
        upper: [],
        fold: 1083,
        foldFull: [
            1083
        ]
    },
    {
        code: 1052,
        lower: [],
        title: [],
        upper: [],
        fold: 1084,
        foldFull: [
            1084
        ]
    },
    {
        code: 1053,
        lower: [],
        title: [],
        upper: [],
        fold: 1085,
        foldFull: [
            1085
        ]
    },
    {
        code: 1054,
        lower: [],
        title: [],
        upper: [],
        fold: 1086,
        foldFull: [
            1086
        ]
    },
    {
        code: 1055,
        lower: [],
        title: [],
        upper: [],
        fold: 1087,
        foldFull: [
            1087
        ]
    },
    {
        code: 1056,
        lower: [],
        title: [],
        upper: [],
        fold: 1088,
        foldFull: [
            1088
        ]
    },
    {
        code: 1057,
        lower: [],
        title: [],
        upper: [],
        fold: 1089,
        foldFull: [
            1089
        ]
    },
    {
        code: 1058,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 1059,
        lower: [],
        title: [],
        upper: [],
        fold: 1091,
        foldFull: [
            1091
        ]
    },
    {
        code: 1060,
        lower: [],
        title: [],
        upper: [],
        fold: 1092,
        foldFull: [
            1092
        ]
    },
    {
        code: 1061,
        lower: [],
        title: [],
        upper: [],
        fold: 1093,
        foldFull: [
            1093
        ]
    },
    {
        code: 1062,
        lower: [],
        title: [],
        upper: [],
        fold: 1094,
        foldFull: [
            1094
        ]
    },
    {
        code: 1063,
        lower: [],
        title: [],
        upper: [],
        fold: 1095,
        foldFull: [
            1095
        ]
    },
    {
        code: 1064,
        lower: [],
        title: [],
        upper: [],
        fold: 1096,
        foldFull: [
            1096
        ]
    },
    {
        code: 1065,
        lower: [],
        title: [],
        upper: [],
        fold: 1097,
        foldFull: [
            1097
        ]
    },
    {
        code: 1066,
        lower: [],
        title: [],
        upper: [],
        fold: 1098,
        foldFull: [
            1098
        ]
    },
    {
        code: 1067,
        lower: [],
        title: [],
        upper: [],
        fold: 1099,
        foldFull: [
            1099
        ]
    },
    {
        code: 1068,
        lower: [],
        title: [],
        upper: [],
        fold: 1100,
        foldFull: [
            1100
        ]
    },
    {
        code: 1069,
        lower: [],
        title: [],
        upper: [],
        fold: 1101,
        foldFull: [
            1101
        ]
    },
    {
        code: 1070,
        lower: [],
        title: [],
        upper: [],
        fold: 1102,
        foldFull: [
            1102
        ]
    },
    {
        code: 1071,
        lower: [],
        title: [],
        upper: [],
        fold: 1103,
        foldFull: [
            1103
        ]
    },
    {
        code: 1120,
        lower: [],
        title: [],
        upper: [],
        fold: 1121,
        foldFull: [
            1121
        ]
    },
    {
        code: 1122,
        lower: [],
        title: [],
        upper: [],
        fold: 1123,
        foldFull: [
            1123
        ]
    },
    {
        code: 1124,
        lower: [],
        title: [],
        upper: [],
        fold: 1125,
        foldFull: [
            1125
        ]
    },
    {
        code: 1126,
        lower: [],
        title: [],
        upper: [],
        fold: 1127,
        foldFull: [
            1127
        ]
    },
    {
        code: 1128,
        lower: [],
        title: [],
        upper: [],
        fold: 1129,
        foldFull: [
            1129
        ]
    },
    {
        code: 1130,
        lower: [],
        title: [],
        upper: [],
        fold: 1131,
        foldFull: [
            1131
        ]
    },
    {
        code: 1132,
        lower: [],
        title: [],
        upper: [],
        fold: 1133,
        foldFull: [
            1133
        ]
    },
    {
        code: 1134,
        lower: [],
        title: [],
        upper: [],
        fold: 1135,
        foldFull: [
            1135
        ]
    },
    {
        code: 1136,
        lower: [],
        title: [],
        upper: [],
        fold: 1137,
        foldFull: [
            1137
        ]
    },
    {
        code: 1138,
        lower: [],
        title: [],
        upper: [],
        fold: 1139,
        foldFull: [
            1139
        ]
    },
    {
        code: 1140,
        lower: [],
        title: [],
        upper: [],
        fold: 1141,
        foldFull: [
            1141
        ]
    },
    {
        code: 1142,
        lower: [],
        title: [],
        upper: [],
        fold: 1143,
        foldFull: [
            1143
        ]
    },
    {
        code: 1144,
        lower: [],
        title: [],
        upper: [],
        fold: 1145,
        foldFull: [
            1145
        ]
    },
    {
        code: 1146,
        lower: [],
        title: [],
        upper: [],
        fold: 1147,
        foldFull: [
            1147
        ]
    },
    {
        code: 1148,
        lower: [],
        title: [],
        upper: [],
        fold: 1149,
        foldFull: [
            1149
        ]
    },
    {
        code: 1150,
        lower: [],
        title: [],
        upper: [],
        fold: 1151,
        foldFull: [
            1151
        ]
    },
    {
        code: 1152,
        lower: [],
        title: [],
        upper: [],
        fold: 1153,
        foldFull: [
            1153
        ]
    },
    {
        code: 1162,
        lower: [],
        title: [],
        upper: [],
        fold: 1163,
        foldFull: [
            1163
        ]
    },
    {
        code: 1164,
        lower: [],
        title: [],
        upper: [],
        fold: 1165,
        foldFull: [
            1165
        ]
    },
    {
        code: 1166,
        lower: [],
        title: [],
        upper: [],
        fold: 1167,
        foldFull: [
            1167
        ]
    },
    {
        code: 1168,
        lower: [],
        title: [],
        upper: [],
        fold: 1169,
        foldFull: [
            1169
        ]
    },
    {
        code: 1170,
        lower: [],
        title: [],
        upper: [],
        fold: 1171,
        foldFull: [
            1171
        ]
    },
    {
        code: 1172,
        lower: [],
        title: [],
        upper: [],
        fold: 1173,
        foldFull: [
            1173
        ]
    },
    {
        code: 1174,
        lower: [],
        title: [],
        upper: [],
        fold: 1175,
        foldFull: [
            1175
        ]
    },
    {
        code: 1176,
        lower: [],
        title: [],
        upper: [],
        fold: 1177,
        foldFull: [
            1177
        ]
    },
    {
        code: 1178,
        lower: [],
        title: [],
        upper: [],
        fold: 1179,
        foldFull: [
            1179
        ]
    },
    {
        code: 1180,
        lower: [],
        title: [],
        upper: [],
        fold: 1181,
        foldFull: [
            1181
        ]
    },
    {
        code: 1182,
        lower: [],
        title: [],
        upper: [],
        fold: 1183,
        foldFull: [
            1183
        ]
    },
    {
        code: 1184,
        lower: [],
        title: [],
        upper: [],
        fold: 1185,
        foldFull: [
            1185
        ]
    },
    {
        code: 1186,
        lower: [],
        title: [],
        upper: [],
        fold: 1187,
        foldFull: [
            1187
        ]
    },
    {
        code: 1188,
        lower: [],
        title: [],
        upper: [],
        fold: 1189,
        foldFull: [
            1189
        ]
    },
    {
        code: 1190,
        lower: [],
        title: [],
        upper: [],
        fold: 1191,
        foldFull: [
            1191
        ]
    },
    {
        code: 1192,
        lower: [],
        title: [],
        upper: [],
        fold: 1193,
        foldFull: [
            1193
        ]
    },
    {
        code: 1194,
        lower: [],
        title: [],
        upper: [],
        fold: 1195,
        foldFull: [
            1195
        ]
    },
    {
        code: 1196,
        lower: [],
        title: [],
        upper: [],
        fold: 1197,
        foldFull: [
            1197
        ]
    },
    {
        code: 1198,
        lower: [],
        title: [],
        upper: [],
        fold: 1199,
        foldFull: [
            1199
        ]
    },
    {
        code: 1200,
        lower: [],
        title: [],
        upper: [],
        fold: 1201,
        foldFull: [
            1201
        ]
    },
    {
        code: 1202,
        lower: [],
        title: [],
        upper: [],
        fold: 1203,
        foldFull: [
            1203
        ]
    },
    {
        code: 1204,
        lower: [],
        title: [],
        upper: [],
        fold: 1205,
        foldFull: [
            1205
        ]
    },
    {
        code: 1206,
        lower: [],
        title: [],
        upper: [],
        fold: 1207,
        foldFull: [
            1207
        ]
    },
    {
        code: 1208,
        lower: [],
        title: [],
        upper: [],
        fold: 1209,
        foldFull: [
            1209
        ]
    },
    {
        code: 1210,
        lower: [],
        title: [],
        upper: [],
        fold: 1211,
        foldFull: [
            1211
        ]
    },
    {
        code: 1212,
        lower: [],
        title: [],
        upper: [],
        fold: 1213,
        foldFull: [
            1213
        ]
    },
    {
        code: 1214,
        lower: [],
        title: [],
        upper: [],
        fold: 1215,
        foldFull: [
            1215
        ]
    },
    {
        code: 1216,
        lower: [],
        title: [],
        upper: [],
        fold: 1231,
        foldFull: [
            1231
        ]
    },
    {
        code: 1217,
        lower: [],
        title: [],
        upper: [],
        fold: 1218,
        foldFull: [
            1218
        ]
    },
    {
        code: 1219,
        lower: [],
        title: [],
        upper: [],
        fold: 1220,
        foldFull: [
            1220
        ]
    },
    {
        code: 1221,
        lower: [],
        title: [],
        upper: [],
        fold: 1222,
        foldFull: [
            1222
        ]
    },
    {
        code: 1223,
        lower: [],
        title: [],
        upper: [],
        fold: 1224,
        foldFull: [
            1224
        ]
    },
    {
        code: 1225,
        lower: [],
        title: [],
        upper: [],
        fold: 1226,
        foldFull: [
            1226
        ]
    },
    {
        code: 1227,
        lower: [],
        title: [],
        upper: [],
        fold: 1228,
        foldFull: [
            1228
        ]
    },
    {
        code: 1229,
        lower: [],
        title: [],
        upper: [],
        fold: 1230,
        foldFull: [
            1230
        ]
    },
    {
        code: 1232,
        lower: [],
        title: [],
        upper: [],
        fold: 1233,
        foldFull: [
            1233
        ]
    },
    {
        code: 1234,
        lower: [],
        title: [],
        upper: [],
        fold: 1235,
        foldFull: [
            1235
        ]
    },
    {
        code: 1236,
        lower: [],
        title: [],
        upper: [],
        fold: 1237,
        foldFull: [
            1237
        ]
    },
    {
        code: 1238,
        lower: [],
        title: [],
        upper: [],
        fold: 1239,
        foldFull: [
            1239
        ]
    },
    {
        code: 1240,
        lower: [],
        title: [],
        upper: [],
        fold: 1241,
        foldFull: [
            1241
        ]
    },
    {
        code: 1242,
        lower: [],
        title: [],
        upper: [],
        fold: 1243,
        foldFull: [
            1243
        ]
    },
    {
        code: 1244,
        lower: [],
        title: [],
        upper: [],
        fold: 1245,
        foldFull: [
            1245
        ]
    },
    {
        code: 1246,
        lower: [],
        title: [],
        upper: [],
        fold: 1247,
        foldFull: [
            1247
        ]
    },
    {
        code: 1248,
        lower: [],
        title: [],
        upper: [],
        fold: 1249,
        foldFull: [
            1249
        ]
    },
    {
        code: 1250,
        lower: [],
        title: [],
        upper: [],
        fold: 1251,
        foldFull: [
            1251
        ]
    },
    {
        code: 1252,
        lower: [],
        title: [],
        upper: [],
        fold: 1253,
        foldFull: [
            1253
        ]
    },
    {
        code: 1254,
        lower: [],
        title: [],
        upper: [],
        fold: 1255,
        foldFull: [
            1255
        ]
    },
    {
        code: 1256,
        lower: [],
        title: [],
        upper: [],
        fold: 1257,
        foldFull: [
            1257
        ]
    },
    {
        code: 1258,
        lower: [],
        title: [],
        upper: [],
        fold: 1259,
        foldFull: [
            1259
        ]
    },
    {
        code: 1260,
        lower: [],
        title: [],
        upper: [],
        fold: 1261,
        foldFull: [
            1261
        ]
    },
    {
        code: 1262,
        lower: [],
        title: [],
        upper: [],
        fold: 1263,
        foldFull: [
            1263
        ]
    },
    {
        code: 1264,
        lower: [],
        title: [],
        upper: [],
        fold: 1265,
        foldFull: [
            1265
        ]
    },
    {
        code: 1266,
        lower: [],
        title: [],
        upper: [],
        fold: 1267,
        foldFull: [
            1267
        ]
    },
    {
        code: 1268,
        lower: [],
        title: [],
        upper: [],
        fold: 1269,
        foldFull: [
            1269
        ]
    },
    {
        code: 1270,
        lower: [],
        title: [],
        upper: [],
        fold: 1271,
        foldFull: [
            1271
        ]
    },
    {
        code: 1272,
        lower: [],
        title: [],
        upper: [],
        fold: 1273,
        foldFull: [
            1273
        ]
    },
    {
        code: 1274,
        lower: [],
        title: [],
        upper: [],
        fold: 1275,
        foldFull: [
            1275
        ]
    },
    {
        code: 1276,
        lower: [],
        title: [],
        upper: [],
        fold: 1277,
        foldFull: [
            1277
        ]
    },
    {
        code: 1278,
        lower: [],
        title: [],
        upper: [],
        fold: 1279,
        foldFull: [
            1279
        ]
    },
    {
        code: 1280,
        lower: [],
        title: [],
        upper: [],
        fold: 1281,
        foldFull: [
            1281
        ]
    },
    {
        code: 1282,
        lower: [],
        title: [],
        upper: [],
        fold: 1283,
        foldFull: [
            1283
        ]
    },
    {
        code: 1284,
        lower: [],
        title: [],
        upper: [],
        fold: 1285,
        foldFull: [
            1285
        ]
    },
    {
        code: 1286,
        lower: [],
        title: [],
        upper: [],
        fold: 1287,
        foldFull: [
            1287
        ]
    },
    {
        code: 1288,
        lower: [],
        title: [],
        upper: [],
        fold: 1289,
        foldFull: [
            1289
        ]
    },
    {
        code: 1290,
        lower: [],
        title: [],
        upper: [],
        fold: 1291,
        foldFull: [
            1291
        ]
    },
    {
        code: 1292,
        lower: [],
        title: [],
        upper: [],
        fold: 1293,
        foldFull: [
            1293
        ]
    },
    {
        code: 1294,
        lower: [],
        title: [],
        upper: [],
        fold: 1295,
        foldFull: [
            1295
        ]
    },
    {
        code: 1296,
        lower: [],
        title: [],
        upper: [],
        fold: 1297,
        foldFull: [
            1297
        ]
    },
    {
        code: 1298,
        lower: [],
        title: [],
        upper: [],
        fold: 1299,
        foldFull: [
            1299
        ]
    },
    {
        code: 1300,
        lower: [],
        title: [],
        upper: [],
        fold: 1301,
        foldFull: [
            1301
        ]
    },
    {
        code: 1302,
        lower: [],
        title: [],
        upper: [],
        fold: 1303,
        foldFull: [
            1303
        ]
    },
    {
        code: 1304,
        lower: [],
        title: [],
        upper: [],
        fold: 1305,
        foldFull: [
            1305
        ]
    },
    {
        code: 1306,
        lower: [],
        title: [],
        upper: [],
        fold: 1307,
        foldFull: [
            1307
        ]
    },
    {
        code: 1308,
        lower: [],
        title: [],
        upper: [],
        fold: 1309,
        foldFull: [
            1309
        ]
    },
    {
        code: 1310,
        lower: [],
        title: [],
        upper: [],
        fold: 1311,
        foldFull: [
            1311
        ]
    },
    {
        code: 1312,
        lower: [],
        title: [],
        upper: [],
        fold: 1313,
        foldFull: [
            1313
        ]
    },
    {
        code: 1314,
        lower: [],
        title: [],
        upper: [],
        fold: 1315,
        foldFull: [
            1315
        ]
    },
    {
        code: 1316,
        lower: [],
        title: [],
        upper: [],
        fold: 1317,
        foldFull: [
            1317
        ]
    },
    {
        code: 1318,
        lower: [],
        title: [],
        upper: [],
        fold: 1319,
        foldFull: [
            1319
        ]
    },
    {
        code: 1320,
        lower: [],
        title: [],
        upper: [],
        fold: 1321,
        foldFull: [
            1321
        ]
    },
    {
        code: 1322,
        lower: [],
        title: [],
        upper: [],
        fold: 1323,
        foldFull: [
            1323
        ]
    },
    {
        code: 1324,
        lower: [],
        title: [],
        upper: [],
        fold: 1325,
        foldFull: [
            1325
        ]
    },
    {
        code: 1326,
        lower: [],
        title: [],
        upper: [],
        fold: 1327,
        foldFull: [
            1327
        ]
    },
    {
        code: 1329,
        lower: [],
        title: [],
        upper: [],
        fold: 1377,
        foldFull: [
            1377
        ]
    },
    {
        code: 1330,
        lower: [],
        title: [],
        upper: [],
        fold: 1378,
        foldFull: [
            1378
        ]
    },
    {
        code: 1331,
        lower: [],
        title: [],
        upper: [],
        fold: 1379,
        foldFull: [
            1379
        ]
    },
    {
        code: 1332,
        lower: [],
        title: [],
        upper: [],
        fold: 1380,
        foldFull: [
            1380
        ]
    },
    {
        code: 1333,
        lower: [],
        title: [],
        upper: [],
        fold: 1381,
        foldFull: [
            1381
        ]
    },
    {
        code: 1334,
        lower: [],
        title: [],
        upper: [],
        fold: 1382,
        foldFull: [
            1382
        ]
    },
    {
        code: 1335,
        lower: [],
        title: [],
        upper: [],
        fold: 1383,
        foldFull: [
            1383
        ]
    },
    {
        code: 1336,
        lower: [],
        title: [],
        upper: [],
        fold: 1384,
        foldFull: [
            1384
        ]
    },
    {
        code: 1337,
        lower: [],
        title: [],
        upper: [],
        fold: 1385,
        foldFull: [
            1385
        ]
    },
    {
        code: 1338,
        lower: [],
        title: [],
        upper: [],
        fold: 1386,
        foldFull: [
            1386
        ]
    },
    {
        code: 1339,
        lower: [],
        title: [],
        upper: [],
        fold: 1387,
        foldFull: [
            1387
        ]
    },
    {
        code: 1340,
        lower: [],
        title: [],
        upper: [],
        fold: 1388,
        foldFull: [
            1388
        ]
    },
    {
        code: 1341,
        lower: [],
        title: [],
        upper: [],
        fold: 1389,
        foldFull: [
            1389
        ]
    },
    {
        code: 1342,
        lower: [],
        title: [],
        upper: [],
        fold: 1390,
        foldFull: [
            1390
        ]
    },
    {
        code: 1343,
        lower: [],
        title: [],
        upper: [],
        fold: 1391,
        foldFull: [
            1391
        ]
    },
    {
        code: 1344,
        lower: [],
        title: [],
        upper: [],
        fold: 1392,
        foldFull: [
            1392
        ]
    },
    {
        code: 1345,
        lower: [],
        title: [],
        upper: [],
        fold: 1393,
        foldFull: [
            1393
        ]
    },
    {
        code: 1346,
        lower: [],
        title: [],
        upper: [],
        fold: 1394,
        foldFull: [
            1394
        ]
    },
    {
        code: 1347,
        lower: [],
        title: [],
        upper: [],
        fold: 1395,
        foldFull: [
            1395
        ]
    },
    {
        code: 1348,
        lower: [],
        title: [],
        upper: [],
        fold: 1396,
        foldFull: [
            1396
        ]
    },
    {
        code: 1349,
        lower: [],
        title: [],
        upper: [],
        fold: 1397,
        foldFull: [
            1397
        ]
    },
    {
        code: 1350,
        lower: [],
        title: [],
        upper: [],
        fold: 1398,
        foldFull: [
            1398
        ]
    },
    {
        code: 1351,
        lower: [],
        title: [],
        upper: [],
        fold: 1399,
        foldFull: [
            1399
        ]
    },
    {
        code: 1352,
        lower: [],
        title: [],
        upper: [],
        fold: 1400,
        foldFull: [
            1400
        ]
    },
    {
        code: 1353,
        lower: [],
        title: [],
        upper: [],
        fold: 1401,
        foldFull: [
            1401
        ]
    },
    {
        code: 1354,
        lower: [],
        title: [],
        upper: [],
        fold: 1402,
        foldFull: [
            1402
        ]
    },
    {
        code: 1355,
        lower: [],
        title: [],
        upper: [],
        fold: 1403,
        foldFull: [
            1403
        ]
    },
    {
        code: 1356,
        lower: [],
        title: [],
        upper: [],
        fold: 1404,
        foldFull: [
            1404
        ]
    },
    {
        code: 1357,
        lower: [],
        title: [],
        upper: [],
        fold: 1405,
        foldFull: [
            1405
        ]
    },
    {
        code: 1358,
        lower: [],
        title: [],
        upper: [],
        fold: 1406,
        foldFull: [
            1406
        ]
    },
    {
        code: 1359,
        lower: [],
        title: [],
        upper: [],
        fold: 1407,
        foldFull: [
            1407
        ]
    },
    {
        code: 1360,
        lower: [],
        title: [],
        upper: [],
        fold: 1408,
        foldFull: [
            1408
        ]
    },
    {
        code: 1361,
        lower: [],
        title: [],
        upper: [],
        fold: 1409,
        foldFull: [
            1409
        ]
    },
    {
        code: 1362,
        lower: [],
        title: [],
        upper: [],
        fold: 1410,
        foldFull: [
            1410
        ]
    },
    {
        code: 1363,
        lower: [],
        title: [],
        upper: [],
        fold: 1411,
        foldFull: [
            1411
        ]
    },
    {
        code: 1364,
        lower: [],
        title: [],
        upper: [],
        fold: 1412,
        foldFull: [
            1412
        ]
    },
    {
        code: 1365,
        lower: [],
        title: [],
        upper: [],
        fold: 1413,
        foldFull: [
            1413
        ]
    },
    {
        code: 1366,
        lower: [],
        title: [],
        upper: [],
        fold: 1414,
        foldFull: [
            1414
        ]
    },
    {
        code: 1415,
        lower: [
            1415
        ],
        title: [
            1333,
            1410
        ],
        upper: [
            1333,
            1362
        ],
        fold: 0,
        foldFull: [
            1381,
            1410
        ]
    },
    {
        code: 1415,
        lower: [
            1415
        ],
        title: [
            1333,
            1410
        ],
        upper: [
            1333,
            1362
        ],
        fold: 0,
        foldFull: [
            1381,
            1410
        ]
    },
    {
        code: 4256,
        lower: [],
        title: [],
        upper: [],
        fold: 11520,
        foldFull: [
            11520
        ]
    },
    {
        code: 4257,
        lower: [],
        title: [],
        upper: [],
        fold: 11521,
        foldFull: [
            11521
        ]
    },
    {
        code: 4258,
        lower: [],
        title: [],
        upper: [],
        fold: 11522,
        foldFull: [
            11522
        ]
    },
    {
        code: 4259,
        lower: [],
        title: [],
        upper: [],
        fold: 11523,
        foldFull: [
            11523
        ]
    },
    {
        code: 4260,
        lower: [],
        title: [],
        upper: [],
        fold: 11524,
        foldFull: [
            11524
        ]
    },
    {
        code: 4261,
        lower: [],
        title: [],
        upper: [],
        fold: 11525,
        foldFull: [
            11525
        ]
    },
    {
        code: 4262,
        lower: [],
        title: [],
        upper: [],
        fold: 11526,
        foldFull: [
            11526
        ]
    },
    {
        code: 4263,
        lower: [],
        title: [],
        upper: [],
        fold: 11527,
        foldFull: [
            11527
        ]
    },
    {
        code: 4264,
        lower: [],
        title: [],
        upper: [],
        fold: 11528,
        foldFull: [
            11528
        ]
    },
    {
        code: 4265,
        lower: [],
        title: [],
        upper: [],
        fold: 11529,
        foldFull: [
            11529
        ]
    },
    {
        code: 4266,
        lower: [],
        title: [],
        upper: [],
        fold: 11530,
        foldFull: [
            11530
        ]
    },
    {
        code: 4267,
        lower: [],
        title: [],
        upper: [],
        fold: 11531,
        foldFull: [
            11531
        ]
    },
    {
        code: 4268,
        lower: [],
        title: [],
        upper: [],
        fold: 11532,
        foldFull: [
            11532
        ]
    },
    {
        code: 4269,
        lower: [],
        title: [],
        upper: [],
        fold: 11533,
        foldFull: [
            11533
        ]
    },
    {
        code: 4270,
        lower: [],
        title: [],
        upper: [],
        fold: 11534,
        foldFull: [
            11534
        ]
    },
    {
        code: 4271,
        lower: [],
        title: [],
        upper: [],
        fold: 11535,
        foldFull: [
            11535
        ]
    },
    {
        code: 4272,
        lower: [],
        title: [],
        upper: [],
        fold: 11536,
        foldFull: [
            11536
        ]
    },
    {
        code: 4273,
        lower: [],
        title: [],
        upper: [],
        fold: 11537,
        foldFull: [
            11537
        ]
    },
    {
        code: 4274,
        lower: [],
        title: [],
        upper: [],
        fold: 11538,
        foldFull: [
            11538
        ]
    },
    {
        code: 4275,
        lower: [],
        title: [],
        upper: [],
        fold: 11539,
        foldFull: [
            11539
        ]
    },
    {
        code: 4276,
        lower: [],
        title: [],
        upper: [],
        fold: 11540,
        foldFull: [
            11540
        ]
    },
    {
        code: 4277,
        lower: [],
        title: [],
        upper: [],
        fold: 11541,
        foldFull: [
            11541
        ]
    },
    {
        code: 4278,
        lower: [],
        title: [],
        upper: [],
        fold: 11542,
        foldFull: [
            11542
        ]
    },
    {
        code: 4279,
        lower: [],
        title: [],
        upper: [],
        fold: 11543,
        foldFull: [
            11543
        ]
    },
    {
        code: 4280,
        lower: [],
        title: [],
        upper: [],
        fold: 11544,
        foldFull: [
            11544
        ]
    },
    {
        code: 4281,
        lower: [],
        title: [],
        upper: [],
        fold: 11545,
        foldFull: [
            11545
        ]
    },
    {
        code: 4282,
        lower: [],
        title: [],
        upper: [],
        fold: 11546,
        foldFull: [
            11546
        ]
    },
    {
        code: 4283,
        lower: [],
        title: [],
        upper: [],
        fold: 11547,
        foldFull: [
            11547
        ]
    },
    {
        code: 4284,
        lower: [],
        title: [],
        upper: [],
        fold: 11548,
        foldFull: [
            11548
        ]
    },
    {
        code: 4285,
        lower: [],
        title: [],
        upper: [],
        fold: 11549,
        foldFull: [
            11549
        ]
    },
    {
        code: 4286,
        lower: [],
        title: [],
        upper: [],
        fold: 11550,
        foldFull: [
            11550
        ]
    },
    {
        code: 4287,
        lower: [],
        title: [],
        upper: [],
        fold: 11551,
        foldFull: [
            11551
        ]
    },
    {
        code: 4288,
        lower: [],
        title: [],
        upper: [],
        fold: 11552,
        foldFull: [
            11552
        ]
    },
    {
        code: 4289,
        lower: [],
        title: [],
        upper: [],
        fold: 11553,
        foldFull: [
            11553
        ]
    },
    {
        code: 4290,
        lower: [],
        title: [],
        upper: [],
        fold: 11554,
        foldFull: [
            11554
        ]
    },
    {
        code: 4291,
        lower: [],
        title: [],
        upper: [],
        fold: 11555,
        foldFull: [
            11555
        ]
    },
    {
        code: 4292,
        lower: [],
        title: [],
        upper: [],
        fold: 11556,
        foldFull: [
            11556
        ]
    },
    {
        code: 4293,
        lower: [],
        title: [],
        upper: [],
        fold: 11557,
        foldFull: [
            11557
        ]
    },
    {
        code: 4295,
        lower: [],
        title: [],
        upper: [],
        fold: 11559,
        foldFull: [
            11559
        ]
    },
    {
        code: 4301,
        lower: [],
        title: [],
        upper: [],
        fold: 11565,
        foldFull: [
            11565
        ]
    },
    {
        code: 5112,
        lower: [],
        title: [],
        upper: [],
        fold: 5104,
        foldFull: [
            5104
        ]
    },
    {
        code: 5113,
        lower: [],
        title: [],
        upper: [],
        fold: 5105,
        foldFull: [
            5105
        ]
    },
    {
        code: 5114,
        lower: [],
        title: [],
        upper: [],
        fold: 5106,
        foldFull: [
            5106
        ]
    },
    {
        code: 5115,
        lower: [],
        title: [],
        upper: [],
        fold: 5107,
        foldFull: [
            5107
        ]
    },
    {
        code: 5116,
        lower: [],
        title: [],
        upper: [],
        fold: 5108,
        foldFull: [
            5108
        ]
    },
    {
        code: 5117,
        lower: [],
        title: [],
        upper: [],
        fold: 5109,
        foldFull: [
            5109
        ]
    },
    {
        code: 7296,
        lower: [],
        title: [],
        upper: [],
        fold: 1074,
        foldFull: [
            1074
        ]
    },
    {
        code: 7297,
        lower: [],
        title: [],
        upper: [],
        fold: 1076,
        foldFull: [
            1076
        ]
    },
    {
        code: 7298,
        lower: [],
        title: [],
        upper: [],
        fold: 1086,
        foldFull: [
            1086
        ]
    },
    {
        code: 7299,
        lower: [],
        title: [],
        upper: [],
        fold: 1089,
        foldFull: [
            1089
        ]
    },
    {
        code: 7300,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 7301,
        lower: [],
        title: [],
        upper: [],
        fold: 1090,
        foldFull: [
            1090
        ]
    },
    {
        code: 7302,
        lower: [],
        title: [],
        upper: [],
        fold: 1098,
        foldFull: [
            1098
        ]
    },
    {
        code: 7303,
        lower: [],
        title: [],
        upper: [],
        fold: 1123,
        foldFull: [
            1123
        ]
    },
    {
        code: 7304,
        lower: [],
        title: [],
        upper: [],
        fold: 42571,
        foldFull: [
            42571
        ]
    },
    {
        code: 7312,
        lower: [],
        title: [],
        upper: [],
        fold: 4304,
        foldFull: [
            4304
        ]
    },
    {
        code: 7313,
        lower: [],
        title: [],
        upper: [],
        fold: 4305,
        foldFull: [
            4305
        ]
    },
    {
        code: 7314,
        lower: [],
        title: [],
        upper: [],
        fold: 4306,
        foldFull: [
            4306
        ]
    },
    {
        code: 7315,
        lower: [],
        title: [],
        upper: [],
        fold: 4307,
        foldFull: [
            4307
        ]
    },
    {
        code: 7316,
        lower: [],
        title: [],
        upper: [],
        fold: 4308,
        foldFull: [
            4308
        ]
    },
    {
        code: 7317,
        lower: [],
        title: [],
        upper: [],
        fold: 4309,
        foldFull: [
            4309
        ]
    },
    {
        code: 7318,
        lower: [],
        title: [],
        upper: [],
        fold: 4310,
        foldFull: [
            4310
        ]
    },
    {
        code: 7319,
        lower: [],
        title: [],
        upper: [],
        fold: 4311,
        foldFull: [
            4311
        ]
    },
    {
        code: 7320,
        lower: [],
        title: [],
        upper: [],
        fold: 4312,
        foldFull: [
            4312
        ]
    },
    {
        code: 7321,
        lower: [],
        title: [],
        upper: [],
        fold: 4313,
        foldFull: [
            4313
        ]
    },
    {
        code: 7322,
        lower: [],
        title: [],
        upper: [],
        fold: 4314,
        foldFull: [
            4314
        ]
    },
    {
        code: 7323,
        lower: [],
        title: [],
        upper: [],
        fold: 4315,
        foldFull: [
            4315
        ]
    },
    {
        code: 7324,
        lower: [],
        title: [],
        upper: [],
        fold: 4316,
        foldFull: [
            4316
        ]
    },
    {
        code: 7325,
        lower: [],
        title: [],
        upper: [],
        fold: 4317,
        foldFull: [
            4317
        ]
    },
    {
        code: 7326,
        lower: [],
        title: [],
        upper: [],
        fold: 4318,
        foldFull: [
            4318
        ]
    },
    {
        code: 7327,
        lower: [],
        title: [],
        upper: [],
        fold: 4319,
        foldFull: [
            4319
        ]
    },
    {
        code: 7328,
        lower: [],
        title: [],
        upper: [],
        fold: 4320,
        foldFull: [
            4320
        ]
    },
    {
        code: 7329,
        lower: [],
        title: [],
        upper: [],
        fold: 4321,
        foldFull: [
            4321
        ]
    },
    {
        code: 7330,
        lower: [],
        title: [],
        upper: [],
        fold: 4322,
        foldFull: [
            4322
        ]
    },
    {
        code: 7331,
        lower: [],
        title: [],
        upper: [],
        fold: 4323,
        foldFull: [
            4323
        ]
    },
    {
        code: 7332,
        lower: [],
        title: [],
        upper: [],
        fold: 4324,
        foldFull: [
            4324
        ]
    },
    {
        code: 7333,
        lower: [],
        title: [],
        upper: [],
        fold: 4325,
        foldFull: [
            4325
        ]
    },
    {
        code: 7334,
        lower: [],
        title: [],
        upper: [],
        fold: 4326,
        foldFull: [
            4326
        ]
    },
    {
        code: 7335,
        lower: [],
        title: [],
        upper: [],
        fold: 4327,
        foldFull: [
            4327
        ]
    },
    {
        code: 7336,
        lower: [],
        title: [],
        upper: [],
        fold: 4328,
        foldFull: [
            4328
        ]
    },
    {
        code: 7337,
        lower: [],
        title: [],
        upper: [],
        fold: 4329,
        foldFull: [
            4329
        ]
    },
    {
        code: 7338,
        lower: [],
        title: [],
        upper: [],
        fold: 4330,
        foldFull: [
            4330
        ]
    },
    {
        code: 7339,
        lower: [],
        title: [],
        upper: [],
        fold: 4331,
        foldFull: [
            4331
        ]
    },
    {
        code: 7340,
        lower: [],
        title: [],
        upper: [],
        fold: 4332,
        foldFull: [
            4332
        ]
    },
    {
        code: 7341,
        lower: [],
        title: [],
        upper: [],
        fold: 4333,
        foldFull: [
            4333
        ]
    },
    {
        code: 7342,
        lower: [],
        title: [],
        upper: [],
        fold: 4334,
        foldFull: [
            4334
        ]
    },
    {
        code: 7343,
        lower: [],
        title: [],
        upper: [],
        fold: 4335,
        foldFull: [
            4335
        ]
    },
    {
        code: 7344,
        lower: [],
        title: [],
        upper: [],
        fold: 4336,
        foldFull: [
            4336
        ]
    },
    {
        code: 7345,
        lower: [],
        title: [],
        upper: [],
        fold: 4337,
        foldFull: [
            4337
        ]
    },
    {
        code: 7346,
        lower: [],
        title: [],
        upper: [],
        fold: 4338,
        foldFull: [
            4338
        ]
    },
    {
        code: 7347,
        lower: [],
        title: [],
        upper: [],
        fold: 4339,
        foldFull: [
            4339
        ]
    },
    {
        code: 7348,
        lower: [],
        title: [],
        upper: [],
        fold: 4340,
        foldFull: [
            4340
        ]
    },
    {
        code: 7349,
        lower: [],
        title: [],
        upper: [],
        fold: 4341,
        foldFull: [
            4341
        ]
    },
    {
        code: 7350,
        lower: [],
        title: [],
        upper: [],
        fold: 4342,
        foldFull: [
            4342
        ]
    },
    {
        code: 7351,
        lower: [],
        title: [],
        upper: [],
        fold: 4343,
        foldFull: [
            4343
        ]
    },
    {
        code: 7352,
        lower: [],
        title: [],
        upper: [],
        fold: 4344,
        foldFull: [
            4344
        ]
    },
    {
        code: 7353,
        lower: [],
        title: [],
        upper: [],
        fold: 4345,
        foldFull: [
            4345
        ]
    },
    {
        code: 7354,
        lower: [],
        title: [],
        upper: [],
        fold: 4346,
        foldFull: [
            4346
        ]
    },
    {
        code: 7357,
        lower: [],
        title: [],
        upper: [],
        fold: 4349,
        foldFull: [
            4349
        ]
    },
    {
        code: 7358,
        lower: [],
        title: [],
        upper: [],
        fold: 4350,
        foldFull: [
            4350
        ]
    },
    {
        code: 7359,
        lower: [],
        title: [],
        upper: [],
        fold: 4351,
        foldFull: [
            4351
        ]
    },
    {
        code: 7680,
        lower: [],
        title: [],
        upper: [],
        fold: 7681,
        foldFull: [
            7681
        ]
    },
    {
        code: 7682,
        lower: [],
        title: [],
        upper: [],
        fold: 7683,
        foldFull: [
            7683
        ]
    },
    {
        code: 7684,
        lower: [],
        title: [],
        upper: [],
        fold: 7685,
        foldFull: [
            7685
        ]
    },
    {
        code: 7686,
        lower: [],
        title: [],
        upper: [],
        fold: 7687,
        foldFull: [
            7687
        ]
    },
    {
        code: 7688,
        lower: [],
        title: [],
        upper: [],
        fold: 7689,
        foldFull: [
            7689
        ]
    },
    {
        code: 7690,
        lower: [],
        title: [],
        upper: [],
        fold: 7691,
        foldFull: [
            7691
        ]
    },
    {
        code: 7692,
        lower: [],
        title: [],
        upper: [],
        fold: 7693,
        foldFull: [
            7693
        ]
    },
    {
        code: 7694,
        lower: [],
        title: [],
        upper: [],
        fold: 7695,
        foldFull: [
            7695
        ]
    },
    {
        code: 7696,
        lower: [],
        title: [],
        upper: [],
        fold: 7697,
        foldFull: [
            7697
        ]
    },
    {
        code: 7698,
        lower: [],
        title: [],
        upper: [],
        fold: 7699,
        foldFull: [
            7699
        ]
    },
    {
        code: 7700,
        lower: [],
        title: [],
        upper: [],
        fold: 7701,
        foldFull: [
            7701
        ]
    },
    {
        code: 7702,
        lower: [],
        title: [],
        upper: [],
        fold: 7703,
        foldFull: [
            7703
        ]
    },
    {
        code: 7704,
        lower: [],
        title: [],
        upper: [],
        fold: 7705,
        foldFull: [
            7705
        ]
    },
    {
        code: 7706,
        lower: [],
        title: [],
        upper: [],
        fold: 7707,
        foldFull: [
            7707
        ]
    },
    {
        code: 7708,
        lower: [],
        title: [],
        upper: [],
        fold: 7709,
        foldFull: [
            7709
        ]
    },
    {
        code: 7710,
        lower: [],
        title: [],
        upper: [],
        fold: 7711,
        foldFull: [
            7711
        ]
    },
    {
        code: 7712,
        lower: [],
        title: [],
        upper: [],
        fold: 7713,
        foldFull: [
            7713
        ]
    },
    {
        code: 7714,
        lower: [],
        title: [],
        upper: [],
        fold: 7715,
        foldFull: [
            7715
        ]
    },
    {
        code: 7716,
        lower: [],
        title: [],
        upper: [],
        fold: 7717,
        foldFull: [
            7717
        ]
    },
    {
        code: 7718,
        lower: [],
        title: [],
        upper: [],
        fold: 7719,
        foldFull: [
            7719
        ]
    },
    {
        code: 7720,
        lower: [],
        title: [],
        upper: [],
        fold: 7721,
        foldFull: [
            7721
        ]
    },
    {
        code: 7722,
        lower: [],
        title: [],
        upper: [],
        fold: 7723,
        foldFull: [
            7723
        ]
    },
    {
        code: 7724,
        lower: [],
        title: [],
        upper: [],
        fold: 7725,
        foldFull: [
            7725
        ]
    },
    {
        code: 7726,
        lower: [],
        title: [],
        upper: [],
        fold: 7727,
        foldFull: [
            7727
        ]
    },
    {
        code: 7728,
        lower: [],
        title: [],
        upper: [],
        fold: 7729,
        foldFull: [
            7729
        ]
    },
    {
        code: 7730,
        lower: [],
        title: [],
        upper: [],
        fold: 7731,
        foldFull: [
            7731
        ]
    },
    {
        code: 7732,
        lower: [],
        title: [],
        upper: [],
        fold: 7733,
        foldFull: [
            7733
        ]
    },
    {
        code: 7734,
        lower: [],
        title: [],
        upper: [],
        fold: 7735,
        foldFull: [
            7735
        ]
    },
    {
        code: 7736,
        lower: [],
        title: [],
        upper: [],
        fold: 7737,
        foldFull: [
            7737
        ]
    },
    {
        code: 7738,
        lower: [],
        title: [],
        upper: [],
        fold: 7739,
        foldFull: [
            7739
        ]
    },
    {
        code: 7740,
        lower: [],
        title: [],
        upper: [],
        fold: 7741,
        foldFull: [
            7741
        ]
    },
    {
        code: 7742,
        lower: [],
        title: [],
        upper: [],
        fold: 7743,
        foldFull: [
            7743
        ]
    },
    {
        code: 7744,
        lower: [],
        title: [],
        upper: [],
        fold: 7745,
        foldFull: [
            7745
        ]
    },
    {
        code: 7746,
        lower: [],
        title: [],
        upper: [],
        fold: 7747,
        foldFull: [
            7747
        ]
    },
    {
        code: 7748,
        lower: [],
        title: [],
        upper: [],
        fold: 7749,
        foldFull: [
            7749
        ]
    },
    {
        code: 7750,
        lower: [],
        title: [],
        upper: [],
        fold: 7751,
        foldFull: [
            7751
        ]
    },
    {
        code: 7752,
        lower: [],
        title: [],
        upper: [],
        fold: 7753,
        foldFull: [
            7753
        ]
    },
    {
        code: 7754,
        lower: [],
        title: [],
        upper: [],
        fold: 7755,
        foldFull: [
            7755
        ]
    },
    {
        code: 7756,
        lower: [],
        title: [],
        upper: [],
        fold: 7757,
        foldFull: [
            7757
        ]
    },
    {
        code: 7758,
        lower: [],
        title: [],
        upper: [],
        fold: 7759,
        foldFull: [
            7759
        ]
    },
    {
        code: 7760,
        lower: [],
        title: [],
        upper: [],
        fold: 7761,
        foldFull: [
            7761
        ]
    },
    {
        code: 7762,
        lower: [],
        title: [],
        upper: [],
        fold: 7763,
        foldFull: [
            7763
        ]
    },
    {
        code: 7764,
        lower: [],
        title: [],
        upper: [],
        fold: 7765,
        foldFull: [
            7765
        ]
    },
    {
        code: 7766,
        lower: [],
        title: [],
        upper: [],
        fold: 7767,
        foldFull: [
            7767
        ]
    },
    {
        code: 7768,
        lower: [],
        title: [],
        upper: [],
        fold: 7769,
        foldFull: [
            7769
        ]
    },
    {
        code: 7770,
        lower: [],
        title: [],
        upper: [],
        fold: 7771,
        foldFull: [
            7771
        ]
    },
    {
        code: 7772,
        lower: [],
        title: [],
        upper: [],
        fold: 7773,
        foldFull: [
            7773
        ]
    },
    {
        code: 7774,
        lower: [],
        title: [],
        upper: [],
        fold: 7775,
        foldFull: [
            7775
        ]
    },
    {
        code: 7776,
        lower: [],
        title: [],
        upper: [],
        fold: 7777,
        foldFull: [
            7777
        ]
    },
    {
        code: 7778,
        lower: [],
        title: [],
        upper: [],
        fold: 7779,
        foldFull: [
            7779
        ]
    },
    {
        code: 7780,
        lower: [],
        title: [],
        upper: [],
        fold: 7781,
        foldFull: [
            7781
        ]
    },
    {
        code: 7782,
        lower: [],
        title: [],
        upper: [],
        fold: 7783,
        foldFull: [
            7783
        ]
    },
    {
        code: 7784,
        lower: [],
        title: [],
        upper: [],
        fold: 7785,
        foldFull: [
            7785
        ]
    },
    {
        code: 7786,
        lower: [],
        title: [],
        upper: [],
        fold: 7787,
        foldFull: [
            7787
        ]
    },
    {
        code: 7788,
        lower: [],
        title: [],
        upper: [],
        fold: 7789,
        foldFull: [
            7789
        ]
    },
    {
        code: 7790,
        lower: [],
        title: [],
        upper: [],
        fold: 7791,
        foldFull: [
            7791
        ]
    },
    {
        code: 7792,
        lower: [],
        title: [],
        upper: [],
        fold: 7793,
        foldFull: [
            7793
        ]
    },
    {
        code: 7794,
        lower: [],
        title: [],
        upper: [],
        fold: 7795,
        foldFull: [
            7795
        ]
    },
    {
        code: 7796,
        lower: [],
        title: [],
        upper: [],
        fold: 7797,
        foldFull: [
            7797
        ]
    },
    {
        code: 7798,
        lower: [],
        title: [],
        upper: [],
        fold: 7799,
        foldFull: [
            7799
        ]
    },
    {
        code: 7800,
        lower: [],
        title: [],
        upper: [],
        fold: 7801,
        foldFull: [
            7801
        ]
    },
    {
        code: 7802,
        lower: [],
        title: [],
        upper: [],
        fold: 7803,
        foldFull: [
            7803
        ]
    },
    {
        code: 7804,
        lower: [],
        title: [],
        upper: [],
        fold: 7805,
        foldFull: [
            7805
        ]
    },
    {
        code: 7806,
        lower: [],
        title: [],
        upper: [],
        fold: 7807,
        foldFull: [
            7807
        ]
    },
    {
        code: 7808,
        lower: [],
        title: [],
        upper: [],
        fold: 7809,
        foldFull: [
            7809
        ]
    },
    {
        code: 7810,
        lower: [],
        title: [],
        upper: [],
        fold: 7811,
        foldFull: [
            7811
        ]
    },
    {
        code: 7812,
        lower: [],
        title: [],
        upper: [],
        fold: 7813,
        foldFull: [
            7813
        ]
    },
    {
        code: 7814,
        lower: [],
        title: [],
        upper: [],
        fold: 7815,
        foldFull: [
            7815
        ]
    },
    {
        code: 7816,
        lower: [],
        title: [],
        upper: [],
        fold: 7817,
        foldFull: [
            7817
        ]
    },
    {
        code: 7818,
        lower: [],
        title: [],
        upper: [],
        fold: 7819,
        foldFull: [
            7819
        ]
    },
    {
        code: 7820,
        lower: [],
        title: [],
        upper: [],
        fold: 7821,
        foldFull: [
            7821
        ]
    },
    {
        code: 7822,
        lower: [],
        title: [],
        upper: [],
        fold: 7823,
        foldFull: [
            7823
        ]
    },
    {
        code: 7824,
        lower: [],
        title: [],
        upper: [],
        fold: 7825,
        foldFull: [
            7825
        ]
    },
    {
        code: 7826,
        lower: [],
        title: [],
        upper: [],
        fold: 7827,
        foldFull: [
            7827
        ]
    },
    {
        code: 7828,
        lower: [],
        title: [],
        upper: [],
        fold: 7829,
        foldFull: [
            7829
        ]
    },
    {
        code: 7830,
        lower: [
            7830
        ],
        title: [
            72,
            817
        ],
        upper: [
            72,
            817
        ],
        fold: 0,
        foldFull: [
            104,
            817
        ]
    },
    {
        code: 7830,
        lower: [
            7830
        ],
        title: [
            72,
            817
        ],
        upper: [
            72,
            817
        ],
        fold: 0,
        foldFull: [
            104,
            817
        ]
    },
    {
        code: 7831,
        lower: [
            7831
        ],
        title: [
            84,
            776
        ],
        upper: [
            84,
            776
        ],
        fold: 0,
        foldFull: [
            116,
            776
        ]
    },
    {
        code: 7831,
        lower: [
            7831
        ],
        title: [
            84,
            776
        ],
        upper: [
            84,
            776
        ],
        fold: 0,
        foldFull: [
            116,
            776
        ]
    },
    {
        code: 7832,
        lower: [
            7832
        ],
        title: [
            87,
            778
        ],
        upper: [
            87,
            778
        ],
        fold: 0,
        foldFull: [
            119,
            778
        ]
    },
    {
        code: 7832,
        lower: [
            7832
        ],
        title: [
            87,
            778
        ],
        upper: [
            87,
            778
        ],
        fold: 0,
        foldFull: [
            119,
            778
        ]
    },
    {
        code: 7833,
        lower: [
            7833
        ],
        title: [
            89,
            778
        ],
        upper: [
            89,
            778
        ],
        fold: 0,
        foldFull: [
            121,
            778
        ]
    },
    {
        code: 7833,
        lower: [
            7833
        ],
        title: [
            89,
            778
        ],
        upper: [
            89,
            778
        ],
        fold: 0,
        foldFull: [
            121,
            778
        ]
    },
    {
        code: 7834,
        lower: [
            7834
        ],
        title: [
            65,
            702
        ],
        upper: [
            65,
            702
        ],
        fold: 0,
        foldFull: [
            97,
            702
        ]
    },
    {
        code: 7834,
        lower: [
            7834
        ],
        title: [
            65,
            702
        ],
        upper: [
            65,
            702
        ],
        fold: 0,
        foldFull: [
            97,
            702
        ]
    },
    {
        code: 7835,
        lower: [],
        title: [],
        upper: [],
        fold: 7777,
        foldFull: [
            7777
        ]
    },
    {
        code: 7838,
        lower: [],
        title: [],
        upper: [],
        fold: 223,
        foldFull: [
            115,
            115
        ]
    },
    {
        code: 7840,
        lower: [],
        title: [],
        upper: [],
        fold: 7841,
        foldFull: [
            7841
        ]
    },
    {
        code: 7842,
        lower: [],
        title: [],
        upper: [],
        fold: 7843,
        foldFull: [
            7843
        ]
    },
    {
        code: 7844,
        lower: [],
        title: [],
        upper: [],
        fold: 7845,
        foldFull: [
            7845
        ]
    },
    {
        code: 7846,
        lower: [],
        title: [],
        upper: [],
        fold: 7847,
        foldFull: [
            7847
        ]
    },
    {
        code: 7848,
        lower: [],
        title: [],
        upper: [],
        fold: 7849,
        foldFull: [
            7849
        ]
    },
    {
        code: 7850,
        lower: [],
        title: [],
        upper: [],
        fold: 7851,
        foldFull: [
            7851
        ]
    },
    {
        code: 7852,
        lower: [],
        title: [],
        upper: [],
        fold: 7853,
        foldFull: [
            7853
        ]
    },
    {
        code: 7854,
        lower: [],
        title: [],
        upper: [],
        fold: 7855,
        foldFull: [
            7855
        ]
    },
    {
        code: 7856,
        lower: [],
        title: [],
        upper: [],
        fold: 7857,
        foldFull: [
            7857
        ]
    },
    {
        code: 7858,
        lower: [],
        title: [],
        upper: [],
        fold: 7859,
        foldFull: [
            7859
        ]
    },
    {
        code: 7860,
        lower: [],
        title: [],
        upper: [],
        fold: 7861,
        foldFull: [
            7861
        ]
    },
    {
        code: 7862,
        lower: [],
        title: [],
        upper: [],
        fold: 7863,
        foldFull: [
            7863
        ]
    },
    {
        code: 7864,
        lower: [],
        title: [],
        upper: [],
        fold: 7865,
        foldFull: [
            7865
        ]
    },
    {
        code: 7866,
        lower: [],
        title: [],
        upper: [],
        fold: 7867,
        foldFull: [
            7867
        ]
    },
    {
        code: 7868,
        lower: [],
        title: [],
        upper: [],
        fold: 7869,
        foldFull: [
            7869
        ]
    },
    {
        code: 7870,
        lower: [],
        title: [],
        upper: [],
        fold: 7871,
        foldFull: [
            7871
        ]
    },
    {
        code: 7872,
        lower: [],
        title: [],
        upper: [],
        fold: 7873,
        foldFull: [
            7873
        ]
    },
    {
        code: 7874,
        lower: [],
        title: [],
        upper: [],
        fold: 7875,
        foldFull: [
            7875
        ]
    },
    {
        code: 7876,
        lower: [],
        title: [],
        upper: [],
        fold: 7877,
        foldFull: [
            7877
        ]
    },
    {
        code: 7878,
        lower: [],
        title: [],
        upper: [],
        fold: 7879,
        foldFull: [
            7879
        ]
    },
    {
        code: 7880,
        lower: [],
        title: [],
        upper: [],
        fold: 7881,
        foldFull: [
            7881
        ]
    },
    {
        code: 7882,
        lower: [],
        title: [],
        upper: [],
        fold: 7883,
        foldFull: [
            7883
        ]
    },
    {
        code: 7884,
        lower: [],
        title: [],
        upper: [],
        fold: 7885,
        foldFull: [
            7885
        ]
    },
    {
        code: 7886,
        lower: [],
        title: [],
        upper: [],
        fold: 7887,
        foldFull: [
            7887
        ]
    },
    {
        code: 7888,
        lower: [],
        title: [],
        upper: [],
        fold: 7889,
        foldFull: [
            7889
        ]
    },
    {
        code: 7890,
        lower: [],
        title: [],
        upper: [],
        fold: 7891,
        foldFull: [
            7891
        ]
    },
    {
        code: 7892,
        lower: [],
        title: [],
        upper: [],
        fold: 7893,
        foldFull: [
            7893
        ]
    },
    {
        code: 7894,
        lower: [],
        title: [],
        upper: [],
        fold: 7895,
        foldFull: [
            7895
        ]
    },
    {
        code: 7896,
        lower: [],
        title: [],
        upper: [],
        fold: 7897,
        foldFull: [
            7897
        ]
    },
    {
        code: 7898,
        lower: [],
        title: [],
        upper: [],
        fold: 7899,
        foldFull: [
            7899
        ]
    },
    {
        code: 7900,
        lower: [],
        title: [],
        upper: [],
        fold: 7901,
        foldFull: [
            7901
        ]
    },
    {
        code: 7902,
        lower: [],
        title: [],
        upper: [],
        fold: 7903,
        foldFull: [
            7903
        ]
    },
    {
        code: 7904,
        lower: [],
        title: [],
        upper: [],
        fold: 7905,
        foldFull: [
            7905
        ]
    },
    {
        code: 7906,
        lower: [],
        title: [],
        upper: [],
        fold: 7907,
        foldFull: [
            7907
        ]
    },
    {
        code: 7908,
        lower: [],
        title: [],
        upper: [],
        fold: 7909,
        foldFull: [
            7909
        ]
    },
    {
        code: 7910,
        lower: [],
        title: [],
        upper: [],
        fold: 7911,
        foldFull: [
            7911
        ]
    },
    {
        code: 7912,
        lower: [],
        title: [],
        upper: [],
        fold: 7913,
        foldFull: [
            7913
        ]
    },
    {
        code: 7914,
        lower: [],
        title: [],
        upper: [],
        fold: 7915,
        foldFull: [
            7915
        ]
    },
    {
        code: 7916,
        lower: [],
        title: [],
        upper: [],
        fold: 7917,
        foldFull: [
            7917
        ]
    },
    {
        code: 7918,
        lower: [],
        title: [],
        upper: [],
        fold: 7919,
        foldFull: [
            7919
        ]
    },
    {
        code: 7920,
        lower: [],
        title: [],
        upper: [],
        fold: 7921,
        foldFull: [
            7921
        ]
    },
    {
        code: 7922,
        lower: [],
        title: [],
        upper: [],
        fold: 7923,
        foldFull: [
            7923
        ]
    },
    {
        code: 7924,
        lower: [],
        title: [],
        upper: [],
        fold: 7925,
        foldFull: [
            7925
        ]
    },
    {
        code: 7926,
        lower: [],
        title: [],
        upper: [],
        fold: 7927,
        foldFull: [
            7927
        ]
    },
    {
        code: 7928,
        lower: [],
        title: [],
        upper: [],
        fold: 7929,
        foldFull: [
            7929
        ]
    },
    {
        code: 7930,
        lower: [],
        title: [],
        upper: [],
        fold: 7931,
        foldFull: [
            7931
        ]
    },
    {
        code: 7932,
        lower: [],
        title: [],
        upper: [],
        fold: 7933,
        foldFull: [
            7933
        ]
    },
    {
        code: 7934,
        lower: [],
        title: [],
        upper: [],
        fold: 7935,
        foldFull: [
            7935
        ]
    },
    {
        code: 7944,
        lower: [],
        title: [],
        upper: [],
        fold: 7936,
        foldFull: [
            7936
        ]
    },
    {
        code: 7945,
        lower: [],
        title: [],
        upper: [],
        fold: 7937,
        foldFull: [
            7937
        ]
    },
    {
        code: 7946,
        lower: [],
        title: [],
        upper: [],
        fold: 7938,
        foldFull: [
            7938
        ]
    },
    {
        code: 7947,
        lower: [],
        title: [],
        upper: [],
        fold: 7939,
        foldFull: [
            7939
        ]
    },
    {
        code: 7948,
        lower: [],
        title: [],
        upper: [],
        fold: 7940,
        foldFull: [
            7940
        ]
    },
    {
        code: 7949,
        lower: [],
        title: [],
        upper: [],
        fold: 7941,
        foldFull: [
            7941
        ]
    },
    {
        code: 7950,
        lower: [],
        title: [],
        upper: [],
        fold: 7942,
        foldFull: [
            7942
        ]
    },
    {
        code: 7951,
        lower: [],
        title: [],
        upper: [],
        fold: 7943,
        foldFull: [
            7943
        ]
    },
    {
        code: 7960,
        lower: [],
        title: [],
        upper: [],
        fold: 7952,
        foldFull: [
            7952
        ]
    },
    {
        code: 7961,
        lower: [],
        title: [],
        upper: [],
        fold: 7953,
        foldFull: [
            7953
        ]
    },
    {
        code: 7962,
        lower: [],
        title: [],
        upper: [],
        fold: 7954,
        foldFull: [
            7954
        ]
    },
    {
        code: 7963,
        lower: [],
        title: [],
        upper: [],
        fold: 7955,
        foldFull: [
            7955
        ]
    },
    {
        code: 7964,
        lower: [],
        title: [],
        upper: [],
        fold: 7956,
        foldFull: [
            7956
        ]
    },
    {
        code: 7965,
        lower: [],
        title: [],
        upper: [],
        fold: 7957,
        foldFull: [
            7957
        ]
    },
    {
        code: 7976,
        lower: [],
        title: [],
        upper: [],
        fold: 7968,
        foldFull: [
            7968
        ]
    },
    {
        code: 7977,
        lower: [],
        title: [],
        upper: [],
        fold: 7969,
        foldFull: [
            7969
        ]
    },
    {
        code: 7978,
        lower: [],
        title: [],
        upper: [],
        fold: 7970,
        foldFull: [
            7970
        ]
    },
    {
        code: 7979,
        lower: [],
        title: [],
        upper: [],
        fold: 7971,
        foldFull: [
            7971
        ]
    },
    {
        code: 7980,
        lower: [],
        title: [],
        upper: [],
        fold: 7972,
        foldFull: [
            7972
        ]
    },
    {
        code: 7981,
        lower: [],
        title: [],
        upper: [],
        fold: 7973,
        foldFull: [
            7973
        ]
    },
    {
        code: 7982,
        lower: [],
        title: [],
        upper: [],
        fold: 7974,
        foldFull: [
            7974
        ]
    },
    {
        code: 7983,
        lower: [],
        title: [],
        upper: [],
        fold: 7975,
        foldFull: [
            7975
        ]
    },
    {
        code: 7992,
        lower: [],
        title: [],
        upper: [],
        fold: 7984,
        foldFull: [
            7984
        ]
    },
    {
        code: 7993,
        lower: [],
        title: [],
        upper: [],
        fold: 7985,
        foldFull: [
            7985
        ]
    },
    {
        code: 7994,
        lower: [],
        title: [],
        upper: [],
        fold: 7986,
        foldFull: [
            7986
        ]
    },
    {
        code: 7995,
        lower: [],
        title: [],
        upper: [],
        fold: 7987,
        foldFull: [
            7987
        ]
    },
    {
        code: 7996,
        lower: [],
        title: [],
        upper: [],
        fold: 7988,
        foldFull: [
            7988
        ]
    },
    {
        code: 7997,
        lower: [],
        title: [],
        upper: [],
        fold: 7989,
        foldFull: [
            7989
        ]
    },
    {
        code: 7998,
        lower: [],
        title: [],
        upper: [],
        fold: 7990,
        foldFull: [
            7990
        ]
    },
    {
        code: 7999,
        lower: [],
        title: [],
        upper: [],
        fold: 7991,
        foldFull: [
            7991
        ]
    },
    {
        code: 8008,
        lower: [],
        title: [],
        upper: [],
        fold: 8000,
        foldFull: [
            8000
        ]
    },
    {
        code: 8009,
        lower: [],
        title: [],
        upper: [],
        fold: 8001,
        foldFull: [
            8001
        ]
    },
    {
        code: 8010,
        lower: [],
        title: [],
        upper: [],
        fold: 8002,
        foldFull: [
            8002
        ]
    },
    {
        code: 8011,
        lower: [],
        title: [],
        upper: [],
        fold: 8003,
        foldFull: [
            8003
        ]
    },
    {
        code: 8012,
        lower: [],
        title: [],
        upper: [],
        fold: 8004,
        foldFull: [
            8004
        ]
    },
    {
        code: 8013,
        lower: [],
        title: [],
        upper: [],
        fold: 8005,
        foldFull: [
            8005
        ]
    },
    {
        code: 8016,
        lower: [
            8016
        ],
        title: [
            933,
            787
        ],
        upper: [
            933,
            787
        ],
        fold: 0,
        foldFull: [
            965,
            787
        ]
    },
    {
        code: 8016,
        lower: [
            8016
        ],
        title: [
            933,
            787
        ],
        upper: [
            933,
            787
        ],
        fold: 0,
        foldFull: [
            965,
            787
        ]
    },
    {
        code: 8018,
        lower: [
            8018
        ],
        title: [
            933,
            787,
            768
        ],
        upper: [
            933,
            787,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            768
        ]
    },
    {
        code: 8018,
        lower: [
            8018
        ],
        title: [
            933,
            787,
            768
        ],
        upper: [
            933,
            787,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            768
        ]
    },
    {
        code: 8020,
        lower: [
            8020
        ],
        title: [
            933,
            787,
            769
        ],
        upper: [
            933,
            787,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            769
        ]
    },
    {
        code: 8020,
        lower: [
            8020
        ],
        title: [
            933,
            787,
            769
        ],
        upper: [
            933,
            787,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            769
        ]
    },
    {
        code: 8022,
        lower: [
            8022
        ],
        title: [
            933,
            787,
            834
        ],
        upper: [
            933,
            787,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            834
        ]
    },
    {
        code: 8022,
        lower: [
            8022
        ],
        title: [
            933,
            787,
            834
        ],
        upper: [
            933,
            787,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            787,
            834
        ]
    },
    {
        code: 8025,
        lower: [],
        title: [],
        upper: [],
        fold: 8017,
        foldFull: [
            8017
        ]
    },
    {
        code: 8027,
        lower: [],
        title: [],
        upper: [],
        fold: 8019,
        foldFull: [
            8019
        ]
    },
    {
        code: 8029,
        lower: [],
        title: [],
        upper: [],
        fold: 8021,
        foldFull: [
            8021
        ]
    },
    {
        code: 8031,
        lower: [],
        title: [],
        upper: [],
        fold: 8023,
        foldFull: [
            8023
        ]
    },
    {
        code: 8040,
        lower: [],
        title: [],
        upper: [],
        fold: 8032,
        foldFull: [
            8032
        ]
    },
    {
        code: 8041,
        lower: [],
        title: [],
        upper: [],
        fold: 8033,
        foldFull: [
            8033
        ]
    },
    {
        code: 8042,
        lower: [],
        title: [],
        upper: [],
        fold: 8034,
        foldFull: [
            8034
        ]
    },
    {
        code: 8043,
        lower: [],
        title: [],
        upper: [],
        fold: 8035,
        foldFull: [
            8035
        ]
    },
    {
        code: 8044,
        lower: [],
        title: [],
        upper: [],
        fold: 8036,
        foldFull: [
            8036
        ]
    },
    {
        code: 8045,
        lower: [],
        title: [],
        upper: [],
        fold: 8037,
        foldFull: [
            8037
        ]
    },
    {
        code: 8046,
        lower: [],
        title: [],
        upper: [],
        fold: 8038,
        foldFull: [
            8038
        ]
    },
    {
        code: 8047,
        lower: [],
        title: [],
        upper: [],
        fold: 8039,
        foldFull: [
            8039
        ]
    },
    {
        code: 8064,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 0,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8064,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 0,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8065,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 0,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8065,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 0,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8066,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 0,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8066,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 0,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8067,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 0,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8067,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 0,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8068,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 0,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8068,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 0,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8069,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 0,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8069,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 0,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8070,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 0,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8070,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 0,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8071,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 0,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8071,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 0,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8072,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 8064,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8072,
        lower: [
            8064
        ],
        title: [
            8072
        ],
        upper: [
            7944,
            921
        ],
        fold: 8064,
        foldFull: [
            7936,
            953
        ]
    },
    {
        code: 8073,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 8065,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8073,
        lower: [
            8065
        ],
        title: [
            8073
        ],
        upper: [
            7945,
            921
        ],
        fold: 8065,
        foldFull: [
            7937,
            953
        ]
    },
    {
        code: 8074,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 8066,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8074,
        lower: [
            8066
        ],
        title: [
            8074
        ],
        upper: [
            7946,
            921
        ],
        fold: 8066,
        foldFull: [
            7938,
            953
        ]
    },
    {
        code: 8075,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 8067,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8075,
        lower: [
            8067
        ],
        title: [
            8075
        ],
        upper: [
            7947,
            921
        ],
        fold: 8067,
        foldFull: [
            7939,
            953
        ]
    },
    {
        code: 8076,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 8068,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8076,
        lower: [
            8068
        ],
        title: [
            8076
        ],
        upper: [
            7948,
            921
        ],
        fold: 8068,
        foldFull: [
            7940,
            953
        ]
    },
    {
        code: 8077,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 8069,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8077,
        lower: [
            8069
        ],
        title: [
            8077
        ],
        upper: [
            7949,
            921
        ],
        fold: 8069,
        foldFull: [
            7941,
            953
        ]
    },
    {
        code: 8078,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 8070,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8078,
        lower: [
            8070
        ],
        title: [
            8078
        ],
        upper: [
            7950,
            921
        ],
        fold: 8070,
        foldFull: [
            7942,
            953
        ]
    },
    {
        code: 8079,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 8071,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8079,
        lower: [
            8071
        ],
        title: [
            8079
        ],
        upper: [
            7951,
            921
        ],
        fold: 8071,
        foldFull: [
            7943,
            953
        ]
    },
    {
        code: 8080,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 0,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8080,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 0,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8081,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 0,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8081,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 0,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8082,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 0,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8082,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 0,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8083,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 0,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8083,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 0,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8084,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 0,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8084,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 0,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8085,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 0,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8085,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 0,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8086,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 0,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8086,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 0,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8087,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 0,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8087,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 0,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8088,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 8080,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8088,
        lower: [
            8080
        ],
        title: [
            8088
        ],
        upper: [
            7976,
            921
        ],
        fold: 8080,
        foldFull: [
            7968,
            953
        ]
    },
    {
        code: 8089,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 8081,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8089,
        lower: [
            8081
        ],
        title: [
            8089
        ],
        upper: [
            7977,
            921
        ],
        fold: 8081,
        foldFull: [
            7969,
            953
        ]
    },
    {
        code: 8090,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 8082,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8090,
        lower: [
            8082
        ],
        title: [
            8090
        ],
        upper: [
            7978,
            921
        ],
        fold: 8082,
        foldFull: [
            7970,
            953
        ]
    },
    {
        code: 8091,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 8083,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8091,
        lower: [
            8083
        ],
        title: [
            8091
        ],
        upper: [
            7979,
            921
        ],
        fold: 8083,
        foldFull: [
            7971,
            953
        ]
    },
    {
        code: 8092,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 8084,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8092,
        lower: [
            8084
        ],
        title: [
            8092
        ],
        upper: [
            7980,
            921
        ],
        fold: 8084,
        foldFull: [
            7972,
            953
        ]
    },
    {
        code: 8093,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 8085,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8093,
        lower: [
            8085
        ],
        title: [
            8093
        ],
        upper: [
            7981,
            921
        ],
        fold: 8085,
        foldFull: [
            7973,
            953
        ]
    },
    {
        code: 8094,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 8086,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8094,
        lower: [
            8086
        ],
        title: [
            8094
        ],
        upper: [
            7982,
            921
        ],
        fold: 8086,
        foldFull: [
            7974,
            953
        ]
    },
    {
        code: 8095,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 8087,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8095,
        lower: [
            8087
        ],
        title: [
            8095
        ],
        upper: [
            7983,
            921
        ],
        fold: 8087,
        foldFull: [
            7975,
            953
        ]
    },
    {
        code: 8096,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 0,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8096,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 0,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8097,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 0,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8097,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 0,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8098,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 0,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8098,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 0,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8099,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 0,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8099,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 0,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8100,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 0,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8100,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 0,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8101,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 0,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8101,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 0,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8102,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 0,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8102,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 0,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8103,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 0,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8103,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 0,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8104,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 8096,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8104,
        lower: [
            8096
        ],
        title: [
            8104
        ],
        upper: [
            8040,
            921
        ],
        fold: 8096,
        foldFull: [
            8032,
            953
        ]
    },
    {
        code: 8105,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 8097,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8105,
        lower: [
            8097
        ],
        title: [
            8105
        ],
        upper: [
            8041,
            921
        ],
        fold: 8097,
        foldFull: [
            8033,
            953
        ]
    },
    {
        code: 8106,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 8098,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8106,
        lower: [
            8098
        ],
        title: [
            8106
        ],
        upper: [
            8042,
            921
        ],
        fold: 8098,
        foldFull: [
            8034,
            953
        ]
    },
    {
        code: 8107,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 8099,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8107,
        lower: [
            8099
        ],
        title: [
            8107
        ],
        upper: [
            8043,
            921
        ],
        fold: 8099,
        foldFull: [
            8035,
            953
        ]
    },
    {
        code: 8108,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 8100,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8108,
        lower: [
            8100
        ],
        title: [
            8108
        ],
        upper: [
            8044,
            921
        ],
        fold: 8100,
        foldFull: [
            8036,
            953
        ]
    },
    {
        code: 8109,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 8101,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8109,
        lower: [
            8101
        ],
        title: [
            8109
        ],
        upper: [
            8045,
            921
        ],
        fold: 8101,
        foldFull: [
            8037,
            953
        ]
    },
    {
        code: 8110,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 8102,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8110,
        lower: [
            8102
        ],
        title: [
            8110
        ],
        upper: [
            8046,
            921
        ],
        fold: 8102,
        foldFull: [
            8038,
            953
        ]
    },
    {
        code: 8111,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 8103,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8111,
        lower: [
            8103
        ],
        title: [
            8111
        ],
        upper: [
            8047,
            921
        ],
        fold: 8103,
        foldFull: [
            8039,
            953
        ]
    },
    {
        code: 8114,
        lower: [
            8114
        ],
        title: [
            8122,
            837
        ],
        upper: [
            8122,
            921
        ],
        fold: 0,
        foldFull: [
            8048,
            953
        ]
    },
    {
        code: 8114,
        lower: [
            8114
        ],
        title: [
            8122,
            837
        ],
        upper: [
            8122,
            921
        ],
        fold: 0,
        foldFull: [
            8048,
            953
        ]
    },
    {
        code: 8115,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8115,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8116,
        lower: [
            8116
        ],
        title: [
            902,
            837
        ],
        upper: [
            902,
            921
        ],
        fold: 0,
        foldFull: [
            940,
            953
        ]
    },
    {
        code: 8116,
        lower: [
            8116
        ],
        title: [
            902,
            837
        ],
        upper: [
            902,
            921
        ],
        fold: 0,
        foldFull: [
            940,
            953
        ]
    },
    {
        code: 8118,
        lower: [
            8118
        ],
        title: [
            913,
            834
        ],
        upper: [
            913,
            834
        ],
        fold: 0,
        foldFull: [
            945,
            834
        ]
    },
    {
        code: 8118,
        lower: [
            8118
        ],
        title: [
            913,
            834
        ],
        upper: [
            913,
            834
        ],
        fold: 0,
        foldFull: [
            945,
            834
        ]
    },
    {
        code: 8119,
        lower: [
            8119
        ],
        title: [
            913,
            834,
            837
        ],
        upper: [
            913,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            834,
            953
        ]
    },
    {
        code: 8119,
        lower: [
            8119
        ],
        title: [
            913,
            834,
            837
        ],
        upper: [
            913,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            945,
            834,
            953
        ]
    },
    {
        code: 8120,
        lower: [],
        title: [],
        upper: [],
        fold: 8112,
        foldFull: [
            8112
        ]
    },
    {
        code: 8121,
        lower: [],
        title: [],
        upper: [],
        fold: 8113,
        foldFull: [
            8113
        ]
    },
    {
        code: 8122,
        lower: [],
        title: [],
        upper: [],
        fold: 8048,
        foldFull: [
            8048
        ]
    },
    {
        code: 8123,
        lower: [],
        title: [],
        upper: [],
        fold: 8049,
        foldFull: [
            8049
        ]
    },
    {
        code: 8124,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 8115,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8124,
        lower: [
            8115
        ],
        title: [
            8124
        ],
        upper: [
            913,
            921
        ],
        fold: 8115,
        foldFull: [
            945,
            953
        ]
    },
    {
        code: 8126,
        lower: [],
        title: [],
        upper: [],
        fold: 953,
        foldFull: [
            953
        ]
    },
    {
        code: 8130,
        lower: [
            8130
        ],
        title: [
            8138,
            837
        ],
        upper: [
            8138,
            921
        ],
        fold: 0,
        foldFull: [
            8052,
            953
        ]
    },
    {
        code: 8130,
        lower: [
            8130
        ],
        title: [
            8138,
            837
        ],
        upper: [
            8138,
            921
        ],
        fold: 0,
        foldFull: [
            8052,
            953
        ]
    },
    {
        code: 8131,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8131,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8132,
        lower: [
            8132
        ],
        title: [
            905,
            837
        ],
        upper: [
            905,
            921
        ],
        fold: 0,
        foldFull: [
            942,
            953
        ]
    },
    {
        code: 8132,
        lower: [
            8132
        ],
        title: [
            905,
            837
        ],
        upper: [
            905,
            921
        ],
        fold: 0,
        foldFull: [
            942,
            953
        ]
    },
    {
        code: 8134,
        lower: [
            8134
        ],
        title: [
            919,
            834
        ],
        upper: [
            919,
            834
        ],
        fold: 0,
        foldFull: [
            951,
            834
        ]
    },
    {
        code: 8134,
        lower: [
            8134
        ],
        title: [
            919,
            834
        ],
        upper: [
            919,
            834
        ],
        fold: 0,
        foldFull: [
            951,
            834
        ]
    },
    {
        code: 8135,
        lower: [
            8135
        ],
        title: [
            919,
            834,
            837
        ],
        upper: [
            919,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            834,
            953
        ]
    },
    {
        code: 8135,
        lower: [
            8135
        ],
        title: [
            919,
            834,
            837
        ],
        upper: [
            919,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            951,
            834,
            953
        ]
    },
    {
        code: 8136,
        lower: [],
        title: [],
        upper: [],
        fold: 8050,
        foldFull: [
            8050
        ]
    },
    {
        code: 8137,
        lower: [],
        title: [],
        upper: [],
        fold: 8051,
        foldFull: [
            8051
        ]
    },
    {
        code: 8138,
        lower: [],
        title: [],
        upper: [],
        fold: 8052,
        foldFull: [
            8052
        ]
    },
    {
        code: 8139,
        lower: [],
        title: [],
        upper: [],
        fold: 8053,
        foldFull: [
            8053
        ]
    },
    {
        code: 8140,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 8131,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8140,
        lower: [
            8131
        ],
        title: [
            8140
        ],
        upper: [
            919,
            921
        ],
        fold: 8131,
        foldFull: [
            951,
            953
        ]
    },
    {
        code: 8146,
        lower: [
            8146
        ],
        title: [
            921,
            776,
            768
        ],
        upper: [
            921,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            768
        ]
    },
    {
        code: 8146,
        lower: [
            8146
        ],
        title: [
            921,
            776,
            768
        ],
        upper: [
            921,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            768
        ]
    },
    {
        code: 8147,
        lower: [
            8147
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 8147,
        lower: [
            8147
        ],
        title: [
            921,
            776,
            769
        ],
        upper: [
            921,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            769
        ]
    },
    {
        code: 8150,
        lower: [
            8150
        ],
        title: [
            921,
            834
        ],
        upper: [
            921,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            834
        ]
    },
    {
        code: 8150,
        lower: [
            8150
        ],
        title: [
            921,
            834
        ],
        upper: [
            921,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            834
        ]
    },
    {
        code: 8151,
        lower: [
            8151
        ],
        title: [
            921,
            776,
            834
        ],
        upper: [
            921,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            834
        ]
    },
    {
        code: 8151,
        lower: [
            8151
        ],
        title: [
            921,
            776,
            834
        ],
        upper: [
            921,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            953,
            776,
            834
        ]
    },
    {
        code: 8152,
        lower: [],
        title: [],
        upper: [],
        fold: 8144,
        foldFull: [
            8144
        ]
    },
    {
        code: 8153,
        lower: [],
        title: [],
        upper: [],
        fold: 8145,
        foldFull: [
            8145
        ]
    },
    {
        code: 8154,
        lower: [],
        title: [],
        upper: [],
        fold: 8054,
        foldFull: [
            8054
        ]
    },
    {
        code: 8155,
        lower: [],
        title: [],
        upper: [],
        fold: 8055,
        foldFull: [
            8055
        ]
    },
    {
        code: 8162,
        lower: [
            8162
        ],
        title: [
            933,
            776,
            768
        ],
        upper: [
            933,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            768
        ]
    },
    {
        code: 8162,
        lower: [
            8162
        ],
        title: [
            933,
            776,
            768
        ],
        upper: [
            933,
            776,
            768
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            768
        ]
    },
    {
        code: 8163,
        lower: [
            8163
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 8163,
        lower: [
            8163
        ],
        title: [
            933,
            776,
            769
        ],
        upper: [
            933,
            776,
            769
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            769
        ]
    },
    {
        code: 8164,
        lower: [
            8164
        ],
        title: [
            929,
            787
        ],
        upper: [
            929,
            787
        ],
        fold: 0,
        foldFull: [
            961,
            787
        ]
    },
    {
        code: 8164,
        lower: [
            8164
        ],
        title: [
            929,
            787
        ],
        upper: [
            929,
            787
        ],
        fold: 0,
        foldFull: [
            961,
            787
        ]
    },
    {
        code: 8166,
        lower: [
            8166
        ],
        title: [
            933,
            834
        ],
        upper: [
            933,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            834
        ]
    },
    {
        code: 8166,
        lower: [
            8166
        ],
        title: [
            933,
            834
        ],
        upper: [
            933,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            834
        ]
    },
    {
        code: 8167,
        lower: [
            8167
        ],
        title: [
            933,
            776,
            834
        ],
        upper: [
            933,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            834
        ]
    },
    {
        code: 8167,
        lower: [
            8167
        ],
        title: [
            933,
            776,
            834
        ],
        upper: [
            933,
            776,
            834
        ],
        fold: 0,
        foldFull: [
            965,
            776,
            834
        ]
    },
    {
        code: 8168,
        lower: [],
        title: [],
        upper: [],
        fold: 8160,
        foldFull: [
            8160
        ]
    },
    {
        code: 8169,
        lower: [],
        title: [],
        upper: [],
        fold: 8161,
        foldFull: [
            8161
        ]
    },
    {
        code: 8170,
        lower: [],
        title: [],
        upper: [],
        fold: 8058,
        foldFull: [
            8058
        ]
    },
    {
        code: 8171,
        lower: [],
        title: [],
        upper: [],
        fold: 8059,
        foldFull: [
            8059
        ]
    },
    {
        code: 8172,
        lower: [],
        title: [],
        upper: [],
        fold: 8165,
        foldFull: [
            8165
        ]
    },
    {
        code: 8178,
        lower: [
            8178
        ],
        title: [
            8186,
            837
        ],
        upper: [
            8186,
            921
        ],
        fold: 0,
        foldFull: [
            8060,
            953
        ]
    },
    {
        code: 8178,
        lower: [
            8178
        ],
        title: [
            8186,
            837
        ],
        upper: [
            8186,
            921
        ],
        fold: 0,
        foldFull: [
            8060,
            953
        ]
    },
    {
        code: 8179,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8179,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8180,
        lower: [
            8180
        ],
        title: [
            911,
            837
        ],
        upper: [
            911,
            921
        ],
        fold: 0,
        foldFull: [
            974,
            953
        ]
    },
    {
        code: 8180,
        lower: [
            8180
        ],
        title: [
            911,
            837
        ],
        upper: [
            911,
            921
        ],
        fold: 0,
        foldFull: [
            974,
            953
        ]
    },
    {
        code: 8182,
        lower: [
            8182
        ],
        title: [
            937,
            834
        ],
        upper: [
            937,
            834
        ],
        fold: 0,
        foldFull: [
            969,
            834
        ]
    },
    {
        code: 8182,
        lower: [
            8182
        ],
        title: [
            937,
            834
        ],
        upper: [
            937,
            834
        ],
        fold: 0,
        foldFull: [
            969,
            834
        ]
    },
    {
        code: 8183,
        lower: [
            8183
        ],
        title: [
            937,
            834,
            837
        ],
        upper: [
            937,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            834,
            953
        ]
    },
    {
        code: 8183,
        lower: [
            8183
        ],
        title: [
            937,
            834,
            837
        ],
        upper: [
            937,
            834,
            921
        ],
        fold: 0,
        foldFull: [
            969,
            834,
            953
        ]
    },
    {
        code: 8184,
        lower: [],
        title: [],
        upper: [],
        fold: 8056,
        foldFull: [
            8056
        ]
    },
    {
        code: 8185,
        lower: [],
        title: [],
        upper: [],
        fold: 8057,
        foldFull: [
            8057
        ]
    },
    {
        code: 8186,
        lower: [],
        title: [],
        upper: [],
        fold: 8060,
        foldFull: [
            8060
        ]
    },
    {
        code: 8187,
        lower: [],
        title: [],
        upper: [],
        fold: 8061,
        foldFull: [
            8061
        ]
    },
    {
        code: 8188,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 8179,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8188,
        lower: [
            8179
        ],
        title: [
            8188
        ],
        upper: [
            937,
            921
        ],
        fold: 8179,
        foldFull: [
            969,
            953
        ]
    },
    {
        code: 8486,
        lower: [],
        title: [],
        upper: [],
        fold: 969,
        foldFull: [
            969
        ]
    },
    {
        code: 8490,
        lower: [],
        title: [],
        upper: [],
        fold: 107,
        foldFull: [
            107
        ]
    },
    {
        code: 8491,
        lower: [],
        title: [],
        upper: [],
        fold: 229,
        foldFull: [
            229
        ]
    },
    {
        code: 8498,
        lower: [],
        title: [],
        upper: [],
        fold: 8526,
        foldFull: [
            8526
        ]
    },
    {
        code: 8544,
        lower: [],
        title: [],
        upper: [],
        fold: 8560,
        foldFull: [
            8560
        ]
    },
    {
        code: 8545,
        lower: [],
        title: [],
        upper: [],
        fold: 8561,
        foldFull: [
            8561
        ]
    },
    {
        code: 8546,
        lower: [],
        title: [],
        upper: [],
        fold: 8562,
        foldFull: [
            8562
        ]
    },
    {
        code: 8547,
        lower: [],
        title: [],
        upper: [],
        fold: 8563,
        foldFull: [
            8563
        ]
    },
    {
        code: 8548,
        lower: [],
        title: [],
        upper: [],
        fold: 8564,
        foldFull: [
            8564
        ]
    },
    {
        code: 8549,
        lower: [],
        title: [],
        upper: [],
        fold: 8565,
        foldFull: [
            8565
        ]
    },
    {
        code: 8550,
        lower: [],
        title: [],
        upper: [],
        fold: 8566,
        foldFull: [
            8566
        ]
    },
    {
        code: 8551,
        lower: [],
        title: [],
        upper: [],
        fold: 8567,
        foldFull: [
            8567
        ]
    },
    {
        code: 8552,
        lower: [],
        title: [],
        upper: [],
        fold: 8568,
        foldFull: [
            8568
        ]
    },
    {
        code: 8553,
        lower: [],
        title: [],
        upper: [],
        fold: 8569,
        foldFull: [
            8569
        ]
    },
    {
        code: 8554,
        lower: [],
        title: [],
        upper: [],
        fold: 8570,
        foldFull: [
            8570
        ]
    },
    {
        code: 8555,
        lower: [],
        title: [],
        upper: [],
        fold: 8571,
        foldFull: [
            8571
        ]
    },
    {
        code: 8556,
        lower: [],
        title: [],
        upper: [],
        fold: 8572,
        foldFull: [
            8572
        ]
    },
    {
        code: 8557,
        lower: [],
        title: [],
        upper: [],
        fold: 8573,
        foldFull: [
            8573
        ]
    },
    {
        code: 8558,
        lower: [],
        title: [],
        upper: [],
        fold: 8574,
        foldFull: [
            8574
        ]
    },
    {
        code: 8559,
        lower: [],
        title: [],
        upper: [],
        fold: 8575,
        foldFull: [
            8575
        ]
    },
    {
        code: 8579,
        lower: [],
        title: [],
        upper: [],
        fold: 8580,
        foldFull: [
            8580
        ]
    },
    {
        code: 9398,
        lower: [],
        title: [],
        upper: [],
        fold: 9424,
        foldFull: [
            9424
        ]
    },
    {
        code: 9399,
        lower: [],
        title: [],
        upper: [],
        fold: 9425,
        foldFull: [
            9425
        ]
    },
    {
        code: 9400,
        lower: [],
        title: [],
        upper: [],
        fold: 9426,
        foldFull: [
            9426
        ]
    },
    {
        code: 9401,
        lower: [],
        title: [],
        upper: [],
        fold: 9427,
        foldFull: [
            9427
        ]
    },
    {
        code: 9402,
        lower: [],
        title: [],
        upper: [],
        fold: 9428,
        foldFull: [
            9428
        ]
    },
    {
        code: 9403,
        lower: [],
        title: [],
        upper: [],
        fold: 9429,
        foldFull: [
            9429
        ]
    },
    {
        code: 9404,
        lower: [],
        title: [],
        upper: [],
        fold: 9430,
        foldFull: [
            9430
        ]
    },
    {
        code: 9405,
        lower: [],
        title: [],
        upper: [],
        fold: 9431,
        foldFull: [
            9431
        ]
    },
    {
        code: 9406,
        lower: [],
        title: [],
        upper: [],
        fold: 9432,
        foldFull: [
            9432
        ]
    },
    {
        code: 9407,
        lower: [],
        title: [],
        upper: [],
        fold: 9433,
        foldFull: [
            9433
        ]
    },
    {
        code: 9408,
        lower: [],
        title: [],
        upper: [],
        fold: 9434,
        foldFull: [
            9434
        ]
    },
    {
        code: 9409,
        lower: [],
        title: [],
        upper: [],
        fold: 9435,
        foldFull: [
            9435
        ]
    },
    {
        code: 9410,
        lower: [],
        title: [],
        upper: [],
        fold: 9436,
        foldFull: [
            9436
        ]
    },
    {
        code: 9411,
        lower: [],
        title: [],
        upper: [],
        fold: 9437,
        foldFull: [
            9437
        ]
    },
    {
        code: 9412,
        lower: [],
        title: [],
        upper: [],
        fold: 9438,
        foldFull: [
            9438
        ]
    },
    {
        code: 9413,
        lower: [],
        title: [],
        upper: [],
        fold: 9439,
        foldFull: [
            9439
        ]
    },
    {
        code: 9414,
        lower: [],
        title: [],
        upper: [],
        fold: 9440,
        foldFull: [
            9440
        ]
    },
    {
        code: 9415,
        lower: [],
        title: [],
        upper: [],
        fold: 9441,
        foldFull: [
            9441
        ]
    },
    {
        code: 9416,
        lower: [],
        title: [],
        upper: [],
        fold: 9442,
        foldFull: [
            9442
        ]
    },
    {
        code: 9417,
        lower: [],
        title: [],
        upper: [],
        fold: 9443,
        foldFull: [
            9443
        ]
    },
    {
        code: 9418,
        lower: [],
        title: [],
        upper: [],
        fold: 9444,
        foldFull: [
            9444
        ]
    },
    {
        code: 9419,
        lower: [],
        title: [],
        upper: [],
        fold: 9445,
        foldFull: [
            9445
        ]
    },
    {
        code: 9420,
        lower: [],
        title: [],
        upper: [],
        fold: 9446,
        foldFull: [
            9446
        ]
    },
    {
        code: 9421,
        lower: [],
        title: [],
        upper: [],
        fold: 9447,
        foldFull: [
            9447
        ]
    },
    {
        code: 9422,
        lower: [],
        title: [],
        upper: [],
        fold: 9448,
        foldFull: [
            9448
        ]
    },
    {
        code: 9423,
        lower: [],
        title: [],
        upper: [],
        fold: 9449,
        foldFull: [
            9449
        ]
    },
    {
        code: 11264,
        lower: [],
        title: [],
        upper: [],
        fold: 11312,
        foldFull: [
            11312
        ]
    },
    {
        code: 11265,
        lower: [],
        title: [],
        upper: [],
        fold: 11313,
        foldFull: [
            11313
        ]
    },
    {
        code: 11266,
        lower: [],
        title: [],
        upper: [],
        fold: 11314,
        foldFull: [
            11314
        ]
    },
    {
        code: 11267,
        lower: [],
        title: [],
        upper: [],
        fold: 11315,
        foldFull: [
            11315
        ]
    },
    {
        code: 11268,
        lower: [],
        title: [],
        upper: [],
        fold: 11316,
        foldFull: [
            11316
        ]
    },
    {
        code: 11269,
        lower: [],
        title: [],
        upper: [],
        fold: 11317,
        foldFull: [
            11317
        ]
    },
    {
        code: 11270,
        lower: [],
        title: [],
        upper: [],
        fold: 11318,
        foldFull: [
            11318
        ]
    },
    {
        code: 11271,
        lower: [],
        title: [],
        upper: [],
        fold: 11319,
        foldFull: [
            11319
        ]
    },
    {
        code: 11272,
        lower: [],
        title: [],
        upper: [],
        fold: 11320,
        foldFull: [
            11320
        ]
    },
    {
        code: 11273,
        lower: [],
        title: [],
        upper: [],
        fold: 11321,
        foldFull: [
            11321
        ]
    },
    {
        code: 11274,
        lower: [],
        title: [],
        upper: [],
        fold: 11322,
        foldFull: [
            11322
        ]
    },
    {
        code: 11275,
        lower: [],
        title: [],
        upper: [],
        fold: 11323,
        foldFull: [
            11323
        ]
    },
    {
        code: 11276,
        lower: [],
        title: [],
        upper: [],
        fold: 11324,
        foldFull: [
            11324
        ]
    },
    {
        code: 11277,
        lower: [],
        title: [],
        upper: [],
        fold: 11325,
        foldFull: [
            11325
        ]
    },
    {
        code: 11278,
        lower: [],
        title: [],
        upper: [],
        fold: 11326,
        foldFull: [
            11326
        ]
    },
    {
        code: 11279,
        lower: [],
        title: [],
        upper: [],
        fold: 11327,
        foldFull: [
            11327
        ]
    },
    {
        code: 11280,
        lower: [],
        title: [],
        upper: [],
        fold: 11328,
        foldFull: [
            11328
        ]
    },
    {
        code: 11281,
        lower: [],
        title: [],
        upper: [],
        fold: 11329,
        foldFull: [
            11329
        ]
    },
    {
        code: 11282,
        lower: [],
        title: [],
        upper: [],
        fold: 11330,
        foldFull: [
            11330
        ]
    },
    {
        code: 11283,
        lower: [],
        title: [],
        upper: [],
        fold: 11331,
        foldFull: [
            11331
        ]
    },
    {
        code: 11284,
        lower: [],
        title: [],
        upper: [],
        fold: 11332,
        foldFull: [
            11332
        ]
    },
    {
        code: 11285,
        lower: [],
        title: [],
        upper: [],
        fold: 11333,
        foldFull: [
            11333
        ]
    },
    {
        code: 11286,
        lower: [],
        title: [],
        upper: [],
        fold: 11334,
        foldFull: [
            11334
        ]
    },
    {
        code: 11287,
        lower: [],
        title: [],
        upper: [],
        fold: 11335,
        foldFull: [
            11335
        ]
    },
    {
        code: 11288,
        lower: [],
        title: [],
        upper: [],
        fold: 11336,
        foldFull: [
            11336
        ]
    },
    {
        code: 11289,
        lower: [],
        title: [],
        upper: [],
        fold: 11337,
        foldFull: [
            11337
        ]
    },
    {
        code: 11290,
        lower: [],
        title: [],
        upper: [],
        fold: 11338,
        foldFull: [
            11338
        ]
    },
    {
        code: 11291,
        lower: [],
        title: [],
        upper: [],
        fold: 11339,
        foldFull: [
            11339
        ]
    },
    {
        code: 11292,
        lower: [],
        title: [],
        upper: [],
        fold: 11340,
        foldFull: [
            11340
        ]
    },
    {
        code: 11293,
        lower: [],
        title: [],
        upper: [],
        fold: 11341,
        foldFull: [
            11341
        ]
    },
    {
        code: 11294,
        lower: [],
        title: [],
        upper: [],
        fold: 11342,
        foldFull: [
            11342
        ]
    },
    {
        code: 11295,
        lower: [],
        title: [],
        upper: [],
        fold: 11343,
        foldFull: [
            11343
        ]
    },
    {
        code: 11296,
        lower: [],
        title: [],
        upper: [],
        fold: 11344,
        foldFull: [
            11344
        ]
    },
    {
        code: 11297,
        lower: [],
        title: [],
        upper: [],
        fold: 11345,
        foldFull: [
            11345
        ]
    },
    {
        code: 11298,
        lower: [],
        title: [],
        upper: [],
        fold: 11346,
        foldFull: [
            11346
        ]
    },
    {
        code: 11299,
        lower: [],
        title: [],
        upper: [],
        fold: 11347,
        foldFull: [
            11347
        ]
    },
    {
        code: 11300,
        lower: [],
        title: [],
        upper: [],
        fold: 11348,
        foldFull: [
            11348
        ]
    },
    {
        code: 11301,
        lower: [],
        title: [],
        upper: [],
        fold: 11349,
        foldFull: [
            11349
        ]
    },
    {
        code: 11302,
        lower: [],
        title: [],
        upper: [],
        fold: 11350,
        foldFull: [
            11350
        ]
    },
    {
        code: 11303,
        lower: [],
        title: [],
        upper: [],
        fold: 11351,
        foldFull: [
            11351
        ]
    },
    {
        code: 11304,
        lower: [],
        title: [],
        upper: [],
        fold: 11352,
        foldFull: [
            11352
        ]
    },
    {
        code: 11305,
        lower: [],
        title: [],
        upper: [],
        fold: 11353,
        foldFull: [
            11353
        ]
    },
    {
        code: 11306,
        lower: [],
        title: [],
        upper: [],
        fold: 11354,
        foldFull: [
            11354
        ]
    },
    {
        code: 11307,
        lower: [],
        title: [],
        upper: [],
        fold: 11355,
        foldFull: [
            11355
        ]
    },
    {
        code: 11308,
        lower: [],
        title: [],
        upper: [],
        fold: 11356,
        foldFull: [
            11356
        ]
    },
    {
        code: 11309,
        lower: [],
        title: [],
        upper: [],
        fold: 11357,
        foldFull: [
            11357
        ]
    },
    {
        code: 11310,
        lower: [],
        title: [],
        upper: [],
        fold: 11358,
        foldFull: [
            11358
        ]
    },
    {
        code: 11360,
        lower: [],
        title: [],
        upper: [],
        fold: 11361,
        foldFull: [
            11361
        ]
    },
    {
        code: 11362,
        lower: [],
        title: [],
        upper: [],
        fold: 619,
        foldFull: [
            619
        ]
    },
    {
        code: 11363,
        lower: [],
        title: [],
        upper: [],
        fold: 7549,
        foldFull: [
            7549
        ]
    },
    {
        code: 11364,
        lower: [],
        title: [],
        upper: [],
        fold: 637,
        foldFull: [
            637
        ]
    },
    {
        code: 11367,
        lower: [],
        title: [],
        upper: [],
        fold: 11368,
        foldFull: [
            11368
        ]
    },
    {
        code: 11369,
        lower: [],
        title: [],
        upper: [],
        fold: 11370,
        foldFull: [
            11370
        ]
    },
    {
        code: 11371,
        lower: [],
        title: [],
        upper: [],
        fold: 11372,
        foldFull: [
            11372
        ]
    },
    {
        code: 11373,
        lower: [],
        title: [],
        upper: [],
        fold: 593,
        foldFull: [
            593
        ]
    },
    {
        code: 11374,
        lower: [],
        title: [],
        upper: [],
        fold: 625,
        foldFull: [
            625
        ]
    },
    {
        code: 11375,
        lower: [],
        title: [],
        upper: [],
        fold: 592,
        foldFull: [
            592
        ]
    },
    {
        code: 11376,
        lower: [],
        title: [],
        upper: [],
        fold: 594,
        foldFull: [
            594
        ]
    },
    {
        code: 11378,
        lower: [],
        title: [],
        upper: [],
        fold: 11379,
        foldFull: [
            11379
        ]
    },
    {
        code: 11381,
        lower: [],
        title: [],
        upper: [],
        fold: 11382,
        foldFull: [
            11382
        ]
    },
    {
        code: 11390,
        lower: [],
        title: [],
        upper: [],
        fold: 575,
        foldFull: [
            575
        ]
    },
    {
        code: 11391,
        lower: [],
        title: [],
        upper: [],
        fold: 576,
        foldFull: [
            576
        ]
    },
    {
        code: 11392,
        lower: [],
        title: [],
        upper: [],
        fold: 11393,
        foldFull: [
            11393
        ]
    },
    {
        code: 11394,
        lower: [],
        title: [],
        upper: [],
        fold: 11395,
        foldFull: [
            11395
        ]
    },
    {
        code: 11396,
        lower: [],
        title: [],
        upper: [],
        fold: 11397,
        foldFull: [
            11397
        ]
    },
    {
        code: 11398,
        lower: [],
        title: [],
        upper: [],
        fold: 11399,
        foldFull: [
            11399
        ]
    },
    {
        code: 11400,
        lower: [],
        title: [],
        upper: [],
        fold: 11401,
        foldFull: [
            11401
        ]
    },
    {
        code: 11402,
        lower: [],
        title: [],
        upper: [],
        fold: 11403,
        foldFull: [
            11403
        ]
    },
    {
        code: 11404,
        lower: [],
        title: [],
        upper: [],
        fold: 11405,
        foldFull: [
            11405
        ]
    },
    {
        code: 11406,
        lower: [],
        title: [],
        upper: [],
        fold: 11407,
        foldFull: [
            11407
        ]
    },
    {
        code: 11408,
        lower: [],
        title: [],
        upper: [],
        fold: 11409,
        foldFull: [
            11409
        ]
    },
    {
        code: 11410,
        lower: [],
        title: [],
        upper: [],
        fold: 11411,
        foldFull: [
            11411
        ]
    },
    {
        code: 11412,
        lower: [],
        title: [],
        upper: [],
        fold: 11413,
        foldFull: [
            11413
        ]
    },
    {
        code: 11414,
        lower: [],
        title: [],
        upper: [],
        fold: 11415,
        foldFull: [
            11415
        ]
    },
    {
        code: 11416,
        lower: [],
        title: [],
        upper: [],
        fold: 11417,
        foldFull: [
            11417
        ]
    },
    {
        code: 11418,
        lower: [],
        title: [],
        upper: [],
        fold: 11419,
        foldFull: [
            11419
        ]
    },
    {
        code: 11420,
        lower: [],
        title: [],
        upper: [],
        fold: 11421,
        foldFull: [
            11421
        ]
    },
    {
        code: 11422,
        lower: [],
        title: [],
        upper: [],
        fold: 11423,
        foldFull: [
            11423
        ]
    },
    {
        code: 11424,
        lower: [],
        title: [],
        upper: [],
        fold: 11425,
        foldFull: [
            11425
        ]
    },
    {
        code: 11426,
        lower: [],
        title: [],
        upper: [],
        fold: 11427,
        foldFull: [
            11427
        ]
    },
    {
        code: 11428,
        lower: [],
        title: [],
        upper: [],
        fold: 11429,
        foldFull: [
            11429
        ]
    },
    {
        code: 11430,
        lower: [],
        title: [],
        upper: [],
        fold: 11431,
        foldFull: [
            11431
        ]
    },
    {
        code: 11432,
        lower: [],
        title: [],
        upper: [],
        fold: 11433,
        foldFull: [
            11433
        ]
    },
    {
        code: 11434,
        lower: [],
        title: [],
        upper: [],
        fold: 11435,
        foldFull: [
            11435
        ]
    },
    {
        code: 11436,
        lower: [],
        title: [],
        upper: [],
        fold: 11437,
        foldFull: [
            11437
        ]
    },
    {
        code: 11438,
        lower: [],
        title: [],
        upper: [],
        fold: 11439,
        foldFull: [
            11439
        ]
    },
    {
        code: 11440,
        lower: [],
        title: [],
        upper: [],
        fold: 11441,
        foldFull: [
            11441
        ]
    },
    {
        code: 11442,
        lower: [],
        title: [],
        upper: [],
        fold: 11443,
        foldFull: [
            11443
        ]
    },
    {
        code: 11444,
        lower: [],
        title: [],
        upper: [],
        fold: 11445,
        foldFull: [
            11445
        ]
    },
    {
        code: 11446,
        lower: [],
        title: [],
        upper: [],
        fold: 11447,
        foldFull: [
            11447
        ]
    },
    {
        code: 11448,
        lower: [],
        title: [],
        upper: [],
        fold: 11449,
        foldFull: [
            11449
        ]
    },
    {
        code: 11450,
        lower: [],
        title: [],
        upper: [],
        fold: 11451,
        foldFull: [
            11451
        ]
    },
    {
        code: 11452,
        lower: [],
        title: [],
        upper: [],
        fold: 11453,
        foldFull: [
            11453
        ]
    },
    {
        code: 11454,
        lower: [],
        title: [],
        upper: [],
        fold: 11455,
        foldFull: [
            11455
        ]
    },
    {
        code: 11456,
        lower: [],
        title: [],
        upper: [],
        fold: 11457,
        foldFull: [
            11457
        ]
    },
    {
        code: 11458,
        lower: [],
        title: [],
        upper: [],
        fold: 11459,
        foldFull: [
            11459
        ]
    },
    {
        code: 11460,
        lower: [],
        title: [],
        upper: [],
        fold: 11461,
        foldFull: [
            11461
        ]
    },
    {
        code: 11462,
        lower: [],
        title: [],
        upper: [],
        fold: 11463,
        foldFull: [
            11463
        ]
    },
    {
        code: 11464,
        lower: [],
        title: [],
        upper: [],
        fold: 11465,
        foldFull: [
            11465
        ]
    },
    {
        code: 11466,
        lower: [],
        title: [],
        upper: [],
        fold: 11467,
        foldFull: [
            11467
        ]
    },
    {
        code: 11468,
        lower: [],
        title: [],
        upper: [],
        fold: 11469,
        foldFull: [
            11469
        ]
    },
    {
        code: 11470,
        lower: [],
        title: [],
        upper: [],
        fold: 11471,
        foldFull: [
            11471
        ]
    },
    {
        code: 11472,
        lower: [],
        title: [],
        upper: [],
        fold: 11473,
        foldFull: [
            11473
        ]
    },
    {
        code: 11474,
        lower: [],
        title: [],
        upper: [],
        fold: 11475,
        foldFull: [
            11475
        ]
    },
    {
        code: 11476,
        lower: [],
        title: [],
        upper: [],
        fold: 11477,
        foldFull: [
            11477
        ]
    },
    {
        code: 11478,
        lower: [],
        title: [],
        upper: [],
        fold: 11479,
        foldFull: [
            11479
        ]
    },
    {
        code: 11480,
        lower: [],
        title: [],
        upper: [],
        fold: 11481,
        foldFull: [
            11481
        ]
    },
    {
        code: 11482,
        lower: [],
        title: [],
        upper: [],
        fold: 11483,
        foldFull: [
            11483
        ]
    },
    {
        code: 11484,
        lower: [],
        title: [],
        upper: [],
        fold: 11485,
        foldFull: [
            11485
        ]
    },
    {
        code: 11486,
        lower: [],
        title: [],
        upper: [],
        fold: 11487,
        foldFull: [
            11487
        ]
    },
    {
        code: 11488,
        lower: [],
        title: [],
        upper: [],
        fold: 11489,
        foldFull: [
            11489
        ]
    },
    {
        code: 11490,
        lower: [],
        title: [],
        upper: [],
        fold: 11491,
        foldFull: [
            11491
        ]
    },
    {
        code: 11499,
        lower: [],
        title: [],
        upper: [],
        fold: 11500,
        foldFull: [
            11500
        ]
    },
    {
        code: 11501,
        lower: [],
        title: [],
        upper: [],
        fold: 11502,
        foldFull: [
            11502
        ]
    },
    {
        code: 11506,
        lower: [],
        title: [],
        upper: [],
        fold: 11507,
        foldFull: [
            11507
        ]
    },
    {
        code: 42560,
        lower: [],
        title: [],
        upper: [],
        fold: 42561,
        foldFull: [
            42561
        ]
    },
    {
        code: 42562,
        lower: [],
        title: [],
        upper: [],
        fold: 42563,
        foldFull: [
            42563
        ]
    },
    {
        code: 42564,
        lower: [],
        title: [],
        upper: [],
        fold: 42565,
        foldFull: [
            42565
        ]
    },
    {
        code: 42566,
        lower: [],
        title: [],
        upper: [],
        fold: 42567,
        foldFull: [
            42567
        ]
    },
    {
        code: 42568,
        lower: [],
        title: [],
        upper: [],
        fold: 42569,
        foldFull: [
            42569
        ]
    },
    {
        code: 42570,
        lower: [],
        title: [],
        upper: [],
        fold: 42571,
        foldFull: [
            42571
        ]
    },
    {
        code: 42572,
        lower: [],
        title: [],
        upper: [],
        fold: 42573,
        foldFull: [
            42573
        ]
    },
    {
        code: 42574,
        lower: [],
        title: [],
        upper: [],
        fold: 42575,
        foldFull: [
            42575
        ]
    },
    {
        code: 42576,
        lower: [],
        title: [],
        upper: [],
        fold: 42577,
        foldFull: [
            42577
        ]
    },
    {
        code: 42578,
        lower: [],
        title: [],
        upper: [],
        fold: 42579,
        foldFull: [
            42579
        ]
    },
    {
        code: 42580,
        lower: [],
        title: [],
        upper: [],
        fold: 42581,
        foldFull: [
            42581
        ]
    },
    {
        code: 42582,
        lower: [],
        title: [],
        upper: [],
        fold: 42583,
        foldFull: [
            42583
        ]
    },
    {
        code: 42584,
        lower: [],
        title: [],
        upper: [],
        fold: 42585,
        foldFull: [
            42585
        ]
    },
    {
        code: 42586,
        lower: [],
        title: [],
        upper: [],
        fold: 42587,
        foldFull: [
            42587
        ]
    },
    {
        code: 42588,
        lower: [],
        title: [],
        upper: [],
        fold: 42589,
        foldFull: [
            42589
        ]
    },
    {
        code: 42590,
        lower: [],
        title: [],
        upper: [],
        fold: 42591,
        foldFull: [
            42591
        ]
    },
    {
        code: 42592,
        lower: [],
        title: [],
        upper: [],
        fold: 42593,
        foldFull: [
            42593
        ]
    },
    {
        code: 42594,
        lower: [],
        title: [],
        upper: [],
        fold: 42595,
        foldFull: [
            42595
        ]
    },
    {
        code: 42596,
        lower: [],
        title: [],
        upper: [],
        fold: 42597,
        foldFull: [
            42597
        ]
    },
    {
        code: 42598,
        lower: [],
        title: [],
        upper: [],
        fold: 42599,
        foldFull: [
            42599
        ]
    },
    {
        code: 42600,
        lower: [],
        title: [],
        upper: [],
        fold: 42601,
        foldFull: [
            42601
        ]
    },
    {
        code: 42602,
        lower: [],
        title: [],
        upper: [],
        fold: 42603,
        foldFull: [
            42603
        ]
    },
    {
        code: 42604,
        lower: [],
        title: [],
        upper: [],
        fold: 42605,
        foldFull: [
            42605
        ]
    },
    {
        code: 42624,
        lower: [],
        title: [],
        upper: [],
        fold: 42625,
        foldFull: [
            42625
        ]
    },
    {
        code: 42626,
        lower: [],
        title: [],
        upper: [],
        fold: 42627,
        foldFull: [
            42627
        ]
    },
    {
        code: 42628,
        lower: [],
        title: [],
        upper: [],
        fold: 42629,
        foldFull: [
            42629
        ]
    },
    {
        code: 42630,
        lower: [],
        title: [],
        upper: [],
        fold: 42631,
        foldFull: [
            42631
        ]
    },
    {
        code: 42632,
        lower: [],
        title: [],
        upper: [],
        fold: 42633,
        foldFull: [
            42633
        ]
    },
    {
        code: 42634,
        lower: [],
        title: [],
        upper: [],
        fold: 42635,
        foldFull: [
            42635
        ]
    },
    {
        code: 42636,
        lower: [],
        title: [],
        upper: [],
        fold: 42637,
        foldFull: [
            42637
        ]
    },
    {
        code: 42638,
        lower: [],
        title: [],
        upper: [],
        fold: 42639,
        foldFull: [
            42639
        ]
    },
    {
        code: 42640,
        lower: [],
        title: [],
        upper: [],
        fold: 42641,
        foldFull: [
            42641
        ]
    },
    {
        code: 42642,
        lower: [],
        title: [],
        upper: [],
        fold: 42643,
        foldFull: [
            42643
        ]
    },
    {
        code: 42644,
        lower: [],
        title: [],
        upper: [],
        fold: 42645,
        foldFull: [
            42645
        ]
    },
    {
        code: 42646,
        lower: [],
        title: [],
        upper: [],
        fold: 42647,
        foldFull: [
            42647
        ]
    },
    {
        code: 42648,
        lower: [],
        title: [],
        upper: [],
        fold: 42649,
        foldFull: [
            42649
        ]
    },
    {
        code: 42650,
        lower: [],
        title: [],
        upper: [],
        fold: 42651,
        foldFull: [
            42651
        ]
    },
    {
        code: 42786,
        lower: [],
        title: [],
        upper: [],
        fold: 42787,
        foldFull: [
            42787
        ]
    },
    {
        code: 42788,
        lower: [],
        title: [],
        upper: [],
        fold: 42789,
        foldFull: [
            42789
        ]
    },
    {
        code: 42790,
        lower: [],
        title: [],
        upper: [],
        fold: 42791,
        foldFull: [
            42791
        ]
    },
    {
        code: 42792,
        lower: [],
        title: [],
        upper: [],
        fold: 42793,
        foldFull: [
            42793
        ]
    },
    {
        code: 42794,
        lower: [],
        title: [],
        upper: [],
        fold: 42795,
        foldFull: [
            42795
        ]
    },
    {
        code: 42796,
        lower: [],
        title: [],
        upper: [],
        fold: 42797,
        foldFull: [
            42797
        ]
    },
    {
        code: 42798,
        lower: [],
        title: [],
        upper: [],
        fold: 42799,
        foldFull: [
            42799
        ]
    },
    {
        code: 42802,
        lower: [],
        title: [],
        upper: [],
        fold: 42803,
        foldFull: [
            42803
        ]
    },
    {
        code: 42804,
        lower: [],
        title: [],
        upper: [],
        fold: 42805,
        foldFull: [
            42805
        ]
    },
    {
        code: 42806,
        lower: [],
        title: [],
        upper: [],
        fold: 42807,
        foldFull: [
            42807
        ]
    },
    {
        code: 42808,
        lower: [],
        title: [],
        upper: [],
        fold: 42809,
        foldFull: [
            42809
        ]
    },
    {
        code: 42810,
        lower: [],
        title: [],
        upper: [],
        fold: 42811,
        foldFull: [
            42811
        ]
    },
    {
        code: 42812,
        lower: [],
        title: [],
        upper: [],
        fold: 42813,
        foldFull: [
            42813
        ]
    },
    {
        code: 42814,
        lower: [],
        title: [],
        upper: [],
        fold: 42815,
        foldFull: [
            42815
        ]
    },
    {
        code: 42816,
        lower: [],
        title: [],
        upper: [],
        fold: 42817,
        foldFull: [
            42817
        ]
    },
    {
        code: 42818,
        lower: [],
        title: [],
        upper: [],
        fold: 42819,
        foldFull: [
            42819
        ]
    },
    {
        code: 42820,
        lower: [],
        title: [],
        upper: [],
        fold: 42821,
        foldFull: [
            42821
        ]
    },
    {
        code: 42822,
        lower: [],
        title: [],
        upper: [],
        fold: 42823,
        foldFull: [
            42823
        ]
    },
    {
        code: 42824,
        lower: [],
        title: [],
        upper: [],
        fold: 42825,
        foldFull: [
            42825
        ]
    },
    {
        code: 42826,
        lower: [],
        title: [],
        upper: [],
        fold: 42827,
        foldFull: [
            42827
        ]
    },
    {
        code: 42828,
        lower: [],
        title: [],
        upper: [],
        fold: 42829,
        foldFull: [
            42829
        ]
    },
    {
        code: 42830,
        lower: [],
        title: [],
        upper: [],
        fold: 42831,
        foldFull: [
            42831
        ]
    },
    {
        code: 42832,
        lower: [],
        title: [],
        upper: [],
        fold: 42833,
        foldFull: [
            42833
        ]
    },
    {
        code: 42834,
        lower: [],
        title: [],
        upper: [],
        fold: 42835,
        foldFull: [
            42835
        ]
    },
    {
        code: 42836,
        lower: [],
        title: [],
        upper: [],
        fold: 42837,
        foldFull: [
            42837
        ]
    },
    {
        code: 42838,
        lower: [],
        title: [],
        upper: [],
        fold: 42839,
        foldFull: [
            42839
        ]
    },
    {
        code: 42840,
        lower: [],
        title: [],
        upper: [],
        fold: 42841,
        foldFull: [
            42841
        ]
    },
    {
        code: 42842,
        lower: [],
        title: [],
        upper: [],
        fold: 42843,
        foldFull: [
            42843
        ]
    },
    {
        code: 42844,
        lower: [],
        title: [],
        upper: [],
        fold: 42845,
        foldFull: [
            42845
        ]
    },
    {
        code: 42846,
        lower: [],
        title: [],
        upper: [],
        fold: 42847,
        foldFull: [
            42847
        ]
    },
    {
        code: 42848,
        lower: [],
        title: [],
        upper: [],
        fold: 42849,
        foldFull: [
            42849
        ]
    },
    {
        code: 42850,
        lower: [],
        title: [],
        upper: [],
        fold: 42851,
        foldFull: [
            42851
        ]
    },
    {
        code: 42852,
        lower: [],
        title: [],
        upper: [],
        fold: 42853,
        foldFull: [
            42853
        ]
    },
    {
        code: 42854,
        lower: [],
        title: [],
        upper: [],
        fold: 42855,
        foldFull: [
            42855
        ]
    },
    {
        code: 42856,
        lower: [],
        title: [],
        upper: [],
        fold: 42857,
        foldFull: [
            42857
        ]
    },
    {
        code: 42858,
        lower: [],
        title: [],
        upper: [],
        fold: 42859,
        foldFull: [
            42859
        ]
    },
    {
        code: 42860,
        lower: [],
        title: [],
        upper: [],
        fold: 42861,
        foldFull: [
            42861
        ]
    },
    {
        code: 42862,
        lower: [],
        title: [],
        upper: [],
        fold: 42863,
        foldFull: [
            42863
        ]
    },
    {
        code: 42873,
        lower: [],
        title: [],
        upper: [],
        fold: 42874,
        foldFull: [
            42874
        ]
    },
    {
        code: 42875,
        lower: [],
        title: [],
        upper: [],
        fold: 42876,
        foldFull: [
            42876
        ]
    },
    {
        code: 42877,
        lower: [],
        title: [],
        upper: [],
        fold: 7545,
        foldFull: [
            7545
        ]
    },
    {
        code: 42878,
        lower: [],
        title: [],
        upper: [],
        fold: 42879,
        foldFull: [
            42879
        ]
    },
    {
        code: 42880,
        lower: [],
        title: [],
        upper: [],
        fold: 42881,
        foldFull: [
            42881
        ]
    },
    {
        code: 42882,
        lower: [],
        title: [],
        upper: [],
        fold: 42883,
        foldFull: [
            42883
        ]
    },
    {
        code: 42884,
        lower: [],
        title: [],
        upper: [],
        fold: 42885,
        foldFull: [
            42885
        ]
    },
    {
        code: 42886,
        lower: [],
        title: [],
        upper: [],
        fold: 42887,
        foldFull: [
            42887
        ]
    },
    {
        code: 42891,
        lower: [],
        title: [],
        upper: [],
        fold: 42892,
        foldFull: [
            42892
        ]
    },
    {
        code: 42893,
        lower: [],
        title: [],
        upper: [],
        fold: 613,
        foldFull: [
            613
        ]
    },
    {
        code: 42896,
        lower: [],
        title: [],
        upper: [],
        fold: 42897,
        foldFull: [
            42897
        ]
    },
    {
        code: 42898,
        lower: [],
        title: [],
        upper: [],
        fold: 42899,
        foldFull: [
            42899
        ]
    },
    {
        code: 42902,
        lower: [],
        title: [],
        upper: [],
        fold: 42903,
        foldFull: [
            42903
        ]
    },
    {
        code: 42904,
        lower: [],
        title: [],
        upper: [],
        fold: 42905,
        foldFull: [
            42905
        ]
    },
    {
        code: 42906,
        lower: [],
        title: [],
        upper: [],
        fold: 42907,
        foldFull: [
            42907
        ]
    },
    {
        code: 42908,
        lower: [],
        title: [],
        upper: [],
        fold: 42909,
        foldFull: [
            42909
        ]
    },
    {
        code: 42910,
        lower: [],
        title: [],
        upper: [],
        fold: 42911,
        foldFull: [
            42911
        ]
    },
    {
        code: 42912,
        lower: [],
        title: [],
        upper: [],
        fold: 42913,
        foldFull: [
            42913
        ]
    },
    {
        code: 42914,
        lower: [],
        title: [],
        upper: [],
        fold: 42915,
        foldFull: [
            42915
        ]
    },
    {
        code: 42916,
        lower: [],
        title: [],
        upper: [],
        fold: 42917,
        foldFull: [
            42917
        ]
    },
    {
        code: 42918,
        lower: [],
        title: [],
        upper: [],
        fold: 42919,
        foldFull: [
            42919
        ]
    },
    {
        code: 42920,
        lower: [],
        title: [],
        upper: [],
        fold: 42921,
        foldFull: [
            42921
        ]
    },
    {
        code: 42922,
        lower: [],
        title: [],
        upper: [],
        fold: 614,
        foldFull: [
            614
        ]
    },
    {
        code: 42923,
        lower: [],
        title: [],
        upper: [],
        fold: 604,
        foldFull: [
            604
        ]
    },
    {
        code: 42924,
        lower: [],
        title: [],
        upper: [],
        fold: 609,
        foldFull: [
            609
        ]
    },
    {
        code: 42925,
        lower: [],
        title: [],
        upper: [],
        fold: 620,
        foldFull: [
            620
        ]
    },
    {
        code: 42926,
        lower: [],
        title: [],
        upper: [],
        fold: 618,
        foldFull: [
            618
        ]
    },
    {
        code: 42928,
        lower: [],
        title: [],
        upper: [],
        fold: 670,
        foldFull: [
            670
        ]
    },
    {
        code: 42929,
        lower: [],
        title: [],
        upper: [],
        fold: 647,
        foldFull: [
            647
        ]
    },
    {
        code: 42930,
        lower: [],
        title: [],
        upper: [],
        fold: 669,
        foldFull: [
            669
        ]
    },
    {
        code: 42931,
        lower: [],
        title: [],
        upper: [],
        fold: 43859,
        foldFull: [
            43859
        ]
    },
    {
        code: 42932,
        lower: [],
        title: [],
        upper: [],
        fold: 42933,
        foldFull: [
            42933
        ]
    },
    {
        code: 42934,
        lower: [],
        title: [],
        upper: [],
        fold: 42935,
        foldFull: [
            42935
        ]
    },
    {
        code: 42936,
        lower: [],
        title: [],
        upper: [],
        fold: 42937,
        foldFull: [
            42937
        ]
    },
    {
        code: 42938,
        lower: [],
        title: [],
        upper: [],
        fold: 42939,
        foldFull: [
            42939
        ]
    },
    {
        code: 42940,
        lower: [],
        title: [],
        upper: [],
        fold: 42941,
        foldFull: [
            42941
        ]
    },
    {
        code: 42942,
        lower: [],
        title: [],
        upper: [],
        fold: 42943,
        foldFull: [
            42943
        ]
    },
    {
        code: 42946,
        lower: [],
        title: [],
        upper: [],
        fold: 42947,
        foldFull: [
            42947
        ]
    },
    {
        code: 42948,
        lower: [],
        title: [],
        upper: [],
        fold: 42900,
        foldFull: [
            42900
        ]
    },
    {
        code: 42949,
        lower: [],
        title: [],
        upper: [],
        fold: 642,
        foldFull: [
            642
        ]
    },
    {
        code: 42950,
        lower: [],
        title: [],
        upper: [],
        fold: 7566,
        foldFull: [
            7566
        ]
    },
    {
        code: 42951,
        lower: [],
        title: [],
        upper: [],
        fold: 42952,
        foldFull: [
            42952
        ]
    },
    {
        code: 42953,
        lower: [],
        title: [],
        upper: [],
        fold: 42954,
        foldFull: [
            42954
        ]
    },
    {
        code: 42997,
        lower: [],
        title: [],
        upper: [],
        fold: 42998,
        foldFull: [
            42998
        ]
    },
    {
        code: 43888,
        lower: [],
        title: [],
        upper: [],
        fold: 5024,
        foldFull: [
            5024
        ]
    },
    {
        code: 43889,
        lower: [],
        title: [],
        upper: [],
        fold: 5025,
        foldFull: [
            5025
        ]
    },
    {
        code: 43890,
        lower: [],
        title: [],
        upper: [],
        fold: 5026,
        foldFull: [
            5026
        ]
    },
    {
        code: 43891,
        lower: [],
        title: [],
        upper: [],
        fold: 5027,
        foldFull: [
            5027
        ]
    },
    {
        code: 43892,
        lower: [],
        title: [],
        upper: [],
        fold: 5028,
        foldFull: [
            5028
        ]
    },
    {
        code: 43893,
        lower: [],
        title: [],
        upper: [],
        fold: 5029,
        foldFull: [
            5029
        ]
    },
    {
        code: 43894,
        lower: [],
        title: [],
        upper: [],
        fold: 5030,
        foldFull: [
            5030
        ]
    },
    {
        code: 43895,
        lower: [],
        title: [],
        upper: [],
        fold: 5031,
        foldFull: [
            5031
        ]
    },
    {
        code: 43896,
        lower: [],
        title: [],
        upper: [],
        fold: 5032,
        foldFull: [
            5032
        ]
    },
    {
        code: 43897,
        lower: [],
        title: [],
        upper: [],
        fold: 5033,
        foldFull: [
            5033
        ]
    },
    {
        code: 43898,
        lower: [],
        title: [],
        upper: [],
        fold: 5034,
        foldFull: [
            5034
        ]
    },
    {
        code: 43899,
        lower: [],
        title: [],
        upper: [],
        fold: 5035,
        foldFull: [
            5035
        ]
    },
    {
        code: 43900,
        lower: [],
        title: [],
        upper: [],
        fold: 5036,
        foldFull: [
            5036
        ]
    },
    {
        code: 43901,
        lower: [],
        title: [],
        upper: [],
        fold: 5037,
        foldFull: [
            5037
        ]
    },
    {
        code: 43902,
        lower: [],
        title: [],
        upper: [],
        fold: 5038,
        foldFull: [
            5038
        ]
    },
    {
        code: 43903,
        lower: [],
        title: [],
        upper: [],
        fold: 5039,
        foldFull: [
            5039
        ]
    },
    {
        code: 43904,
        lower: [],
        title: [],
        upper: [],
        fold: 5040,
        foldFull: [
            5040
        ]
    },
    {
        code: 43905,
        lower: [],
        title: [],
        upper: [],
        fold: 5041,
        foldFull: [
            5041
        ]
    },
    {
        code: 43906,
        lower: [],
        title: [],
        upper: [],
        fold: 5042,
        foldFull: [
            5042
        ]
    },
    {
        code: 43907,
        lower: [],
        title: [],
        upper: [],
        fold: 5043,
        foldFull: [
            5043
        ]
    },
    {
        code: 43908,
        lower: [],
        title: [],
        upper: [],
        fold: 5044,
        foldFull: [
            5044
        ]
    },
    {
        code: 43909,
        lower: [],
        title: [],
        upper: [],
        fold: 5045,
        foldFull: [
            5045
        ]
    },
    {
        code: 43910,
        lower: [],
        title: [],
        upper: [],
        fold: 5046,
        foldFull: [
            5046
        ]
    },
    {
        code: 43911,
        lower: [],
        title: [],
        upper: [],
        fold: 5047,
        foldFull: [
            5047
        ]
    },
    {
        code: 43912,
        lower: [],
        title: [],
        upper: [],
        fold: 5048,
        foldFull: [
            5048
        ]
    },
    {
        code: 43913,
        lower: [],
        title: [],
        upper: [],
        fold: 5049,
        foldFull: [
            5049
        ]
    },
    {
        code: 43914,
        lower: [],
        title: [],
        upper: [],
        fold: 5050,
        foldFull: [
            5050
        ]
    },
    {
        code: 43915,
        lower: [],
        title: [],
        upper: [],
        fold: 5051,
        foldFull: [
            5051
        ]
    },
    {
        code: 43916,
        lower: [],
        title: [],
        upper: [],
        fold: 5052,
        foldFull: [
            5052
        ]
    },
    {
        code: 43917,
        lower: [],
        title: [],
        upper: [],
        fold: 5053,
        foldFull: [
            5053
        ]
    },
    {
        code: 43918,
        lower: [],
        title: [],
        upper: [],
        fold: 5054,
        foldFull: [
            5054
        ]
    },
    {
        code: 43919,
        lower: [],
        title: [],
        upper: [],
        fold: 5055,
        foldFull: [
            5055
        ]
    },
    {
        code: 43920,
        lower: [],
        title: [],
        upper: [],
        fold: 5056,
        foldFull: [
            5056
        ]
    },
    {
        code: 43921,
        lower: [],
        title: [],
        upper: [],
        fold: 5057,
        foldFull: [
            5057
        ]
    },
    {
        code: 43922,
        lower: [],
        title: [],
        upper: [],
        fold: 5058,
        foldFull: [
            5058
        ]
    },
    {
        code: 43923,
        lower: [],
        title: [],
        upper: [],
        fold: 5059,
        foldFull: [
            5059
        ]
    },
    {
        code: 43924,
        lower: [],
        title: [],
        upper: [],
        fold: 5060,
        foldFull: [
            5060
        ]
    },
    {
        code: 43925,
        lower: [],
        title: [],
        upper: [],
        fold: 5061,
        foldFull: [
            5061
        ]
    },
    {
        code: 43926,
        lower: [],
        title: [],
        upper: [],
        fold: 5062,
        foldFull: [
            5062
        ]
    },
    {
        code: 43927,
        lower: [],
        title: [],
        upper: [],
        fold: 5063,
        foldFull: [
            5063
        ]
    },
    {
        code: 43928,
        lower: [],
        title: [],
        upper: [],
        fold: 5064,
        foldFull: [
            5064
        ]
    },
    {
        code: 43929,
        lower: [],
        title: [],
        upper: [],
        fold: 5065,
        foldFull: [
            5065
        ]
    },
    {
        code: 43930,
        lower: [],
        title: [],
        upper: [],
        fold: 5066,
        foldFull: [
            5066
        ]
    },
    {
        code: 43931,
        lower: [],
        title: [],
        upper: [],
        fold: 5067,
        foldFull: [
            5067
        ]
    },
    {
        code: 43932,
        lower: [],
        title: [],
        upper: [],
        fold: 5068,
        foldFull: [
            5068
        ]
    },
    {
        code: 43933,
        lower: [],
        title: [],
        upper: [],
        fold: 5069,
        foldFull: [
            5069
        ]
    },
    {
        code: 43934,
        lower: [],
        title: [],
        upper: [],
        fold: 5070,
        foldFull: [
            5070
        ]
    },
    {
        code: 43935,
        lower: [],
        title: [],
        upper: [],
        fold: 5071,
        foldFull: [
            5071
        ]
    },
    {
        code: 43936,
        lower: [],
        title: [],
        upper: [],
        fold: 5072,
        foldFull: [
            5072
        ]
    },
    {
        code: 43937,
        lower: [],
        title: [],
        upper: [],
        fold: 5073,
        foldFull: [
            5073
        ]
    },
    {
        code: 43938,
        lower: [],
        title: [],
        upper: [],
        fold: 5074,
        foldFull: [
            5074
        ]
    },
    {
        code: 43939,
        lower: [],
        title: [],
        upper: [],
        fold: 5075,
        foldFull: [
            5075
        ]
    },
    {
        code: 43940,
        lower: [],
        title: [],
        upper: [],
        fold: 5076,
        foldFull: [
            5076
        ]
    },
    {
        code: 43941,
        lower: [],
        title: [],
        upper: [],
        fold: 5077,
        foldFull: [
            5077
        ]
    },
    {
        code: 43942,
        lower: [],
        title: [],
        upper: [],
        fold: 5078,
        foldFull: [
            5078
        ]
    },
    {
        code: 43943,
        lower: [],
        title: [],
        upper: [],
        fold: 5079,
        foldFull: [
            5079
        ]
    },
    {
        code: 43944,
        lower: [],
        title: [],
        upper: [],
        fold: 5080,
        foldFull: [
            5080
        ]
    },
    {
        code: 43945,
        lower: [],
        title: [],
        upper: [],
        fold: 5081,
        foldFull: [
            5081
        ]
    },
    {
        code: 43946,
        lower: [],
        title: [],
        upper: [],
        fold: 5082,
        foldFull: [
            5082
        ]
    },
    {
        code: 43947,
        lower: [],
        title: [],
        upper: [],
        fold: 5083,
        foldFull: [
            5083
        ]
    },
    {
        code: 43948,
        lower: [],
        title: [],
        upper: [],
        fold: 5084,
        foldFull: [
            5084
        ]
    },
    {
        code: 43949,
        lower: [],
        title: [],
        upper: [],
        fold: 5085,
        foldFull: [
            5085
        ]
    },
    {
        code: 43950,
        lower: [],
        title: [],
        upper: [],
        fold: 5086,
        foldFull: [
            5086
        ]
    },
    {
        code: 43951,
        lower: [],
        title: [],
        upper: [],
        fold: 5087,
        foldFull: [
            5087
        ]
    },
    {
        code: 43952,
        lower: [],
        title: [],
        upper: [],
        fold: 5088,
        foldFull: [
            5088
        ]
    },
    {
        code: 43953,
        lower: [],
        title: [],
        upper: [],
        fold: 5089,
        foldFull: [
            5089
        ]
    },
    {
        code: 43954,
        lower: [],
        title: [],
        upper: [],
        fold: 5090,
        foldFull: [
            5090
        ]
    },
    {
        code: 43955,
        lower: [],
        title: [],
        upper: [],
        fold: 5091,
        foldFull: [
            5091
        ]
    },
    {
        code: 43956,
        lower: [],
        title: [],
        upper: [],
        fold: 5092,
        foldFull: [
            5092
        ]
    },
    {
        code: 43957,
        lower: [],
        title: [],
        upper: [],
        fold: 5093,
        foldFull: [
            5093
        ]
    },
    {
        code: 43958,
        lower: [],
        title: [],
        upper: [],
        fold: 5094,
        foldFull: [
            5094
        ]
    },
    {
        code: 43959,
        lower: [],
        title: [],
        upper: [],
        fold: 5095,
        foldFull: [
            5095
        ]
    },
    {
        code: 43960,
        lower: [],
        title: [],
        upper: [],
        fold: 5096,
        foldFull: [
            5096
        ]
    },
    {
        code: 43961,
        lower: [],
        title: [],
        upper: [],
        fold: 5097,
        foldFull: [
            5097
        ]
    },
    {
        code: 43962,
        lower: [],
        title: [],
        upper: [],
        fold: 5098,
        foldFull: [
            5098
        ]
    },
    {
        code: 43963,
        lower: [],
        title: [],
        upper: [],
        fold: 5099,
        foldFull: [
            5099
        ]
    },
    {
        code: 43964,
        lower: [],
        title: [],
        upper: [],
        fold: 5100,
        foldFull: [
            5100
        ]
    },
    {
        code: 43965,
        lower: [],
        title: [],
        upper: [],
        fold: 5101,
        foldFull: [
            5101
        ]
    },
    {
        code: 43966,
        lower: [],
        title: [],
        upper: [],
        fold: 5102,
        foldFull: [
            5102
        ]
    },
    {
        code: 43967,
        lower: [],
        title: [],
        upper: [],
        fold: 5103,
        foldFull: [
            5103
        ]
    },
    {
        code: 64256,
        lower: [
            64256
        ],
        title: [
            70,
            102
        ],
        upper: [
            70,
            70
        ],
        fold: 0,
        foldFull: [
            102,
            102
        ]
    },
    {
        code: 64256,
        lower: [
            64256
        ],
        title: [
            70,
            102
        ],
        upper: [
            70,
            70
        ],
        fold: 0,
        foldFull: [
            102,
            102
        ]
    },
    {
        code: 64257,
        lower: [
            64257
        ],
        title: [
            70,
            105
        ],
        upper: [
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            105
        ]
    },
    {
        code: 64257,
        lower: [
            64257
        ],
        title: [
            70,
            105
        ],
        upper: [
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            105
        ]
    },
    {
        code: 64258,
        lower: [
            64258
        ],
        title: [
            70,
            108
        ],
        upper: [
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            108
        ]
    },
    {
        code: 64258,
        lower: [
            64258
        ],
        title: [
            70,
            108
        ],
        upper: [
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            108
        ]
    },
    {
        code: 64259,
        lower: [
            64259
        ],
        title: [
            70,
            102,
            105
        ],
        upper: [
            70,
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            105
        ]
    },
    {
        code: 64259,
        lower: [
            64259
        ],
        title: [
            70,
            102,
            105
        ],
        upper: [
            70,
            70,
            73
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            105
        ]
    },
    {
        code: 64260,
        lower: [
            64260
        ],
        title: [
            70,
            102,
            108
        ],
        upper: [
            70,
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            108
        ]
    },
    {
        code: 64260,
        lower: [
            64260
        ],
        title: [
            70,
            102,
            108
        ],
        upper: [
            70,
            70,
            76
        ],
        fold: 0,
        foldFull: [
            102,
            102,
            108
        ]
    },
    {
        code: 64261,
        lower: [
            64261
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64261,
        lower: [
            64261
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64262,
        lower: [
            64262
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64262,
        lower: [
            64262
        ],
        title: [
            83,
            116
        ],
        upper: [
            83,
            84
        ],
        fold: 0,
        foldFull: [
            115,
            116
        ]
    },
    {
        code: 64275,
        lower: [
            64275
        ],
        title: [
            1348,
            1398
        ],
        upper: [
            1348,
            1350
        ],
        fold: 0,
        foldFull: [
            1396,
            1398
        ]
    },
    {
        code: 64275,
        lower: [
            64275
        ],
        title: [
            1348,
            1398
        ],
        upper: [
            1348,
            1350
        ],
        fold: 0,
        foldFull: [
            1396,
            1398
        ]
    },
    {
        code: 64276,
        lower: [
            64276
        ],
        title: [
            1348,
            1381
        ],
        upper: [
            1348,
            1333
        ],
        fold: 0,
        foldFull: [
            1396,
            1381
        ]
    },
    {
        code: 64276,
        lower: [
            64276
        ],
        title: [
            1348,
            1381
        ],
        upper: [
            1348,
            1333
        ],
        fold: 0,
        foldFull: [
            1396,
            1381
        ]
    },
    {
        code: 64277,
        lower: [
            64277
        ],
        title: [
            1348,
            1387
        ],
        upper: [
            1348,
            1339
        ],
        fold: 0,
        foldFull: [
            1396,
            1387
        ]
    },
    {
        code: 64277,
        lower: [
            64277
        ],
        title: [
            1348,
            1387
        ],
        upper: [
            1348,
            1339
        ],
        fold: 0,
        foldFull: [
            1396,
            1387
        ]
    },
    {
        code: 64278,
        lower: [
            64278
        ],
        title: [
            1358,
            1398
        ],
        upper: [
            1358,
            1350
        ],
        fold: 0,
        foldFull: [
            1406,
            1398
        ]
    },
    {
        code: 64278,
        lower: [
            64278
        ],
        title: [
            1358,
            1398
        ],
        upper: [
            1358,
            1350
        ],
        fold: 0,
        foldFull: [
            1406,
            1398
        ]
    },
    {
        code: 64279,
        lower: [
            64279
        ],
        title: [
            1348,
            1389
        ],
        upper: [
            1348,
            1341
        ],
        fold: 0,
        foldFull: [
            1396,
            1389
        ]
    },
    {
        code: 64279,
        lower: [
            64279
        ],
        title: [
            1348,
            1389
        ],
        upper: [
            1348,
            1341
        ],
        fold: 0,
        foldFull: [
            1396,
            1389
        ]
    },
    {
        code: 65313,
        lower: [],
        title: [],
        upper: [],
        fold: 65345,
        foldFull: [
            65345
        ]
    },
    {
        code: 65314,
        lower: [],
        title: [],
        upper: [],
        fold: 65346,
        foldFull: [
            65346
        ]
    },
    {
        code: 65315,
        lower: [],
        title: [],
        upper: [],
        fold: 65347,
        foldFull: [
            65347
        ]
    },
    {
        code: 65316,
        lower: [],
        title: [],
        upper: [],
        fold: 65348,
        foldFull: [
            65348
        ]
    },
    {
        code: 65317,
        lower: [],
        title: [],
        upper: [],
        fold: 65349,
        foldFull: [
            65349
        ]
    },
    {
        code: 65318,
        lower: [],
        title: [],
        upper: [],
        fold: 65350,
        foldFull: [
            65350
        ]
    },
    {
        code: 65319,
        lower: [],
        title: [],
        upper: [],
        fold: 65351,
        foldFull: [
            65351
        ]
    },
    {
        code: 65320,
        lower: [],
        title: [],
        upper: [],
        fold: 65352,
        foldFull: [
            65352
        ]
    },
    {
        code: 65321,
        lower: [],
        title: [],
        upper: [],
        fold: 65353,
        foldFull: [
            65353
        ]
    },
    {
        code: 65322,
        lower: [],
        title: [],
        upper: [],
        fold: 65354,
        foldFull: [
            65354
        ]
    },
    {
        code: 65323,
        lower: [],
        title: [],
        upper: [],
        fold: 65355,
        foldFull: [
            65355
        ]
    },
    {
        code: 65324,
        lower: [],
        title: [],
        upper: [],
        fold: 65356,
        foldFull: [
            65356
        ]
    },
    {
        code: 65325,
        lower: [],
        title: [],
        upper: [],
        fold: 65357,
        foldFull: [
            65357
        ]
    },
    {
        code: 65326,
        lower: [],
        title: [],
        upper: [],
        fold: 65358,
        foldFull: [
            65358
        ]
    },
    {
        code: 65327,
        lower: [],
        title: [],
        upper: [],
        fold: 65359,
        foldFull: [
            65359
        ]
    },
    {
        code: 65328,
        lower: [],
        title: [],
        upper: [],
        fold: 65360,
        foldFull: [
            65360
        ]
    },
    {
        code: 65329,
        lower: [],
        title: [],
        upper: [],
        fold: 65361,
        foldFull: [
            65361
        ]
    },
    {
        code: 65330,
        lower: [],
        title: [],
        upper: [],
        fold: 65362,
        foldFull: [
            65362
        ]
    },
    {
        code: 65331,
        lower: [],
        title: [],
        upper: [],
        fold: 65363,
        foldFull: [
            65363
        ]
    },
    {
        code: 65332,
        lower: [],
        title: [],
        upper: [],
        fold: 65364,
        foldFull: [
            65364
        ]
    },
    {
        code: 65333,
        lower: [],
        title: [],
        upper: [],
        fold: 65365,
        foldFull: [
            65365
        ]
    },
    {
        code: 65334,
        lower: [],
        title: [],
        upper: [],
        fold: 65366,
        foldFull: [
            65366
        ]
    },
    {
        code: 65335,
        lower: [],
        title: [],
        upper: [],
        fold: 65367,
        foldFull: [
            65367
        ]
    },
    {
        code: 65336,
        lower: [],
        title: [],
        upper: [],
        fold: 65368,
        foldFull: [
            65368
        ]
    },
    {
        code: 65337,
        lower: [],
        title: [],
        upper: [],
        fold: 65369,
        foldFull: [
            65369
        ]
    },
    {
        code: 65338,
        lower: [],
        title: [],
        upper: [],
        fold: 65370,
        foldFull: [
            65370
        ]
    },
    {
        code: 66560,
        lower: [],
        title: [],
        upper: [],
        fold: 66600,
        foldFull: [
            66600
        ]
    },
    {
        code: 66561,
        lower: [],
        title: [],
        upper: [],
        fold: 66601,
        foldFull: [
            66601
        ]
    },
    {
        code: 66562,
        lower: [],
        title: [],
        upper: [],
        fold: 66602,
        foldFull: [
            66602
        ]
    },
    {
        code: 66563,
        lower: [],
        title: [],
        upper: [],
        fold: 66603,
        foldFull: [
            66603
        ]
    },
    {
        code: 66564,
        lower: [],
        title: [],
        upper: [],
        fold: 66604,
        foldFull: [
            66604
        ]
    },
    {
        code: 66565,
        lower: [],
        title: [],
        upper: [],
        fold: 66605,
        foldFull: [
            66605
        ]
    },
    {
        code: 66566,
        lower: [],
        title: [],
        upper: [],
        fold: 66606,
        foldFull: [
            66606
        ]
    },
    {
        code: 66567,
        lower: [],
        title: [],
        upper: [],
        fold: 66607,
        foldFull: [
            66607
        ]
    },
    {
        code: 66568,
        lower: [],
        title: [],
        upper: [],
        fold: 66608,
        foldFull: [
            66608
        ]
    },
    {
        code: 66569,
        lower: [],
        title: [],
        upper: [],
        fold: 66609,
        foldFull: [
            66609
        ]
    },
    {
        code: 66570,
        lower: [],
        title: [],
        upper: [],
        fold: 66610,
        foldFull: [
            66610
        ]
    },
    {
        code: 66571,
        lower: [],
        title: [],
        upper: [],
        fold: 66611,
        foldFull: [
            66611
        ]
    },
    {
        code: 66572,
        lower: [],
        title: [],
        upper: [],
        fold: 66612,
        foldFull: [
            66612
        ]
    },
    {
        code: 66573,
        lower: [],
        title: [],
        upper: [],
        fold: 66613,
        foldFull: [
            66613
        ]
    },
    {
        code: 66574,
        lower: [],
        title: [],
        upper: [],
        fold: 66614,
        foldFull: [
            66614
        ]
    },
    {
        code: 66575,
        lower: [],
        title: [],
        upper: [],
        fold: 66615,
        foldFull: [
            66615
        ]
    },
    {
        code: 66576,
        lower: [],
        title: [],
        upper: [],
        fold: 66616,
        foldFull: [
            66616
        ]
    },
    {
        code: 66577,
        lower: [],
        title: [],
        upper: [],
        fold: 66617,
        foldFull: [
            66617
        ]
    },
    {
        code: 66578,
        lower: [],
        title: [],
        upper: [],
        fold: 66618,
        foldFull: [
            66618
        ]
    },
    {
        code: 66579,
        lower: [],
        title: [],
        upper: [],
        fold: 66619,
        foldFull: [
            66619
        ]
    },
    {
        code: 66580,
        lower: [],
        title: [],
        upper: [],
        fold: 66620,
        foldFull: [
            66620
        ]
    },
    {
        code: 66581,
        lower: [],
        title: [],
        upper: [],
        fold: 66621,
        foldFull: [
            66621
        ]
    },
    {
        code: 66582,
        lower: [],
        title: [],
        upper: [],
        fold: 66622,
        foldFull: [
            66622
        ]
    },
    {
        code: 66583,
        lower: [],
        title: [],
        upper: [],
        fold: 66623,
        foldFull: [
            66623
        ]
    },
    {
        code: 66584,
        lower: [],
        title: [],
        upper: [],
        fold: 66624,
        foldFull: [
            66624
        ]
    },
    {
        code: 66585,
        lower: [],
        title: [],
        upper: [],
        fold: 66625,
        foldFull: [
            66625
        ]
    },
    {
        code: 66586,
        lower: [],
        title: [],
        upper: [],
        fold: 66626,
        foldFull: [
            66626
        ]
    },
    {
        code: 66587,
        lower: [],
        title: [],
        upper: [],
        fold: 66627,
        foldFull: [
            66627
        ]
    },
    {
        code: 66588,
        lower: [],
        title: [],
        upper: [],
        fold: 66628,
        foldFull: [
            66628
        ]
    },
    {
        code: 66589,
        lower: [],
        title: [],
        upper: [],
        fold: 66629,
        foldFull: [
            66629
        ]
    },
    {
        code: 66590,
        lower: [],
        title: [],
        upper: [],
        fold: 66630,
        foldFull: [
            66630
        ]
    },
    {
        code: 66591,
        lower: [],
        title: [],
        upper: [],
        fold: 66631,
        foldFull: [
            66631
        ]
    },
    {
        code: 66592,
        lower: [],
        title: [],
        upper: [],
        fold: 66632,
        foldFull: [
            66632
        ]
    },
    {
        code: 66593,
        lower: [],
        title: [],
        upper: [],
        fold: 66633,
        foldFull: [
            66633
        ]
    },
    {
        code: 66594,
        lower: [],
        title: [],
        upper: [],
        fold: 66634,
        foldFull: [
            66634
        ]
    },
    {
        code: 66595,
        lower: [],
        title: [],
        upper: [],
        fold: 66635,
        foldFull: [
            66635
        ]
    },
    {
        code: 66596,
        lower: [],
        title: [],
        upper: [],
        fold: 66636,
        foldFull: [
            66636
        ]
    },
    {
        code: 66597,
        lower: [],
        title: [],
        upper: [],
        fold: 66637,
        foldFull: [
            66637
        ]
    },
    {
        code: 66598,
        lower: [],
        title: [],
        upper: [],
        fold: 66638,
        foldFull: [
            66638
        ]
    },
    {
        code: 66599,
        lower: [],
        title: [],
        upper: [],
        fold: 66639,
        foldFull: [
            66639
        ]
    },
    {
        code: 66736,
        lower: [],
        title: [],
        upper: [],
        fold: 66776,
        foldFull: [
            66776
        ]
    },
    {
        code: 66737,
        lower: [],
        title: [],
        upper: [],
        fold: 66777,
        foldFull: [
            66777
        ]
    },
    {
        code: 66738,
        lower: [],
        title: [],
        upper: [],
        fold: 66778,
        foldFull: [
            66778
        ]
    },
    {
        code: 66739,
        lower: [],
        title: [],
        upper: [],
        fold: 66779,
        foldFull: [
            66779
        ]
    },
    {
        code: 66740,
        lower: [],
        title: [],
        upper: [],
        fold: 66780,
        foldFull: [
            66780
        ]
    },
    {
        code: 66741,
        lower: [],
        title: [],
        upper: [],
        fold: 66781,
        foldFull: [
            66781
        ]
    },
    {
        code: 66742,
        lower: [],
        title: [],
        upper: [],
        fold: 66782,
        foldFull: [
            66782
        ]
    },
    {
        code: 66743,
        lower: [],
        title: [],
        upper: [],
        fold: 66783,
        foldFull: [
            66783
        ]
    },
    {
        code: 66744,
        lower: [],
        title: [],
        upper: [],
        fold: 66784,
        foldFull: [
            66784
        ]
    },
    {
        code: 66745,
        lower: [],
        title: [],
        upper: [],
        fold: 66785,
        foldFull: [
            66785
        ]
    },
    {
        code: 66746,
        lower: [],
        title: [],
        upper: [],
        fold: 66786,
        foldFull: [
            66786
        ]
    },
    {
        code: 66747,
        lower: [],
        title: [],
        upper: [],
        fold: 66787,
        foldFull: [
            66787
        ]
    },
    {
        code: 66748,
        lower: [],
        title: [],
        upper: [],
        fold: 66788,
        foldFull: [
            66788
        ]
    },
    {
        code: 66749,
        lower: [],
        title: [],
        upper: [],
        fold: 66789,
        foldFull: [
            66789
        ]
    },
    {
        code: 66750,
        lower: [],
        title: [],
        upper: [],
        fold: 66790,
        foldFull: [
            66790
        ]
    },
    {
        code: 66751,
        lower: [],
        title: [],
        upper: [],
        fold: 66791,
        foldFull: [
            66791
        ]
    },
    {
        code: 66752,
        lower: [],
        title: [],
        upper: [],
        fold: 66792,
        foldFull: [
            66792
        ]
    },
    {
        code: 66753,
        lower: [],
        title: [],
        upper: [],
        fold: 66793,
        foldFull: [
            66793
        ]
    },
    {
        code: 66754,
        lower: [],
        title: [],
        upper: [],
        fold: 66794,
        foldFull: [
            66794
        ]
    },
    {
        code: 66755,
        lower: [],
        title: [],
        upper: [],
        fold: 66795,
        foldFull: [
            66795
        ]
    },
    {
        code: 66756,
        lower: [],
        title: [],
        upper: [],
        fold: 66796,
        foldFull: [
            66796
        ]
    },
    {
        code: 66757,
        lower: [],
        title: [],
        upper: [],
        fold: 66797,
        foldFull: [
            66797
        ]
    },
    {
        code: 66758,
        lower: [],
        title: [],
        upper: [],
        fold: 66798,
        foldFull: [
            66798
        ]
    },
    {
        code: 66759,
        lower: [],
        title: [],
        upper: [],
        fold: 66799,
        foldFull: [
            66799
        ]
    },
    {
        code: 66760,
        lower: [],
        title: [],
        upper: [],
        fold: 66800,
        foldFull: [
            66800
        ]
    },
    {
        code: 66761,
        lower: [],
        title: [],
        upper: [],
        fold: 66801,
        foldFull: [
            66801
        ]
    },
    {
        code: 66762,
        lower: [],
        title: [],
        upper: [],
        fold: 66802,
        foldFull: [
            66802
        ]
    },
    {
        code: 66763,
        lower: [],
        title: [],
        upper: [],
        fold: 66803,
        foldFull: [
            66803
        ]
    },
    {
        code: 66764,
        lower: [],
        title: [],
        upper: [],
        fold: 66804,
        foldFull: [
            66804
        ]
    },
    {
        code: 66765,
        lower: [],
        title: [],
        upper: [],
        fold: 66805,
        foldFull: [
            66805
        ]
    },
    {
        code: 66766,
        lower: [],
        title: [],
        upper: [],
        fold: 66806,
        foldFull: [
            66806
        ]
    },
    {
        code: 66767,
        lower: [],
        title: [],
        upper: [],
        fold: 66807,
        foldFull: [
            66807
        ]
    },
    {
        code: 66768,
        lower: [],
        title: [],
        upper: [],
        fold: 66808,
        foldFull: [
            66808
        ]
    },
    {
        code: 66769,
        lower: [],
        title: [],
        upper: [],
        fold: 66809,
        foldFull: [
            66809
        ]
    },
    {
        code: 66770,
        lower: [],
        title: [],
        upper: [],
        fold: 66810,
        foldFull: [
            66810
        ]
    },
    {
        code: 66771,
        lower: [],
        title: [],
        upper: [],
        fold: 66811,
        foldFull: [
            66811
        ]
    },
    {
        code: 68736,
        lower: [],
        title: [],
        upper: [],
        fold: 68800,
        foldFull: [
            68800
        ]
    },
    {
        code: 68737,
        lower: [],
        title: [],
        upper: [],
        fold: 68801,
        foldFull: [
            68801
        ]
    },
    {
        code: 68738,
        lower: [],
        title: [],
        upper: [],
        fold: 68802,
        foldFull: [
            68802
        ]
    },
    {
        code: 68739,
        lower: [],
        title: [],
        upper: [],
        fold: 68803,
        foldFull: [
            68803
        ]
    },
    {
        code: 68740,
        lower: [],
        title: [],
        upper: [],
        fold: 68804,
        foldFull: [
            68804
        ]
    },
    {
        code: 68741,
        lower: [],
        title: [],
        upper: [],
        fold: 68805,
        foldFull: [
            68805
        ]
    },
    {
        code: 68742,
        lower: [],
        title: [],
        upper: [],
        fold: 68806,
        foldFull: [
            68806
        ]
    },
    {
        code: 68743,
        lower: [],
        title: [],
        upper: [],
        fold: 68807,
        foldFull: [
            68807
        ]
    },
    {
        code: 68744,
        lower: [],
        title: [],
        upper: [],
        fold: 68808,
        foldFull: [
            68808
        ]
    },
    {
        code: 68745,
        lower: [],
        title: [],
        upper: [],
        fold: 68809,
        foldFull: [
            68809
        ]
    },
    {
        code: 68746,
        lower: [],
        title: [],
        upper: [],
        fold: 68810,
        foldFull: [
            68810
        ]
    },
    {
        code: 68747,
        lower: [],
        title: [],
        upper: [],
        fold: 68811,
        foldFull: [
            68811
        ]
    },
    {
        code: 68748,
        lower: [],
        title: [],
        upper: [],
        fold: 68812,
        foldFull: [
            68812
        ]
    },
    {
        code: 68749,
        lower: [],
        title: [],
        upper: [],
        fold: 68813,
        foldFull: [
            68813
        ]
    },
    {
        code: 68750,
        lower: [],
        title: [],
        upper: [],
        fold: 68814,
        foldFull: [
            68814
        ]
    },
    {
        code: 68751,
        lower: [],
        title: [],
        upper: [],
        fold: 68815,
        foldFull: [
            68815
        ]
    },
    {
        code: 68752,
        lower: [],
        title: [],
        upper: [],
        fold: 68816,
        foldFull: [
            68816
        ]
    },
    {
        code: 68753,
        lower: [],
        title: [],
        upper: [],
        fold: 68817,
        foldFull: [
            68817
        ]
    },
    {
        code: 68754,
        lower: [],
        title: [],
        upper: [],
        fold: 68818,
        foldFull: [
            68818
        ]
    },
    {
        code: 68755,
        lower: [],
        title: [],
        upper: [],
        fold: 68819,
        foldFull: [
            68819
        ]
    },
    {
        code: 68756,
        lower: [],
        title: [],
        upper: [],
        fold: 68820,
        foldFull: [
            68820
        ]
    },
    {
        code: 68757,
        lower: [],
        title: [],
        upper: [],
        fold: 68821,
        foldFull: [
            68821
        ]
    },
    {
        code: 68758,
        lower: [],
        title: [],
        upper: [],
        fold: 68822,
        foldFull: [
            68822
        ]
    },
    {
        code: 68759,
        lower: [],
        title: [],
        upper: [],
        fold: 68823,
        foldFull: [
            68823
        ]
    },
    {
        code: 68760,
        lower: [],
        title: [],
        upper: [],
        fold: 68824,
        foldFull: [
            68824
        ]
    },
    {
        code: 68761,
        lower: [],
        title: [],
        upper: [],
        fold: 68825,
        foldFull: [
            68825
        ]
    },
    {
        code: 68762,
        lower: [],
        title: [],
        upper: [],
        fold: 68826,
        foldFull: [
            68826
        ]
    },
    {
        code: 68763,
        lower: [],
        title: [],
        upper: [],
        fold: 68827,
        foldFull: [
            68827
        ]
    },
    {
        code: 68764,
        lower: [],
        title: [],
        upper: [],
        fold: 68828,
        foldFull: [
            68828
        ]
    },
    {
        code: 68765,
        lower: [],
        title: [],
        upper: [],
        fold: 68829,
        foldFull: [
            68829
        ]
    },
    {
        code: 68766,
        lower: [],
        title: [],
        upper: [],
        fold: 68830,
        foldFull: [
            68830
        ]
    },
    {
        code: 68767,
        lower: [],
        title: [],
        upper: [],
        fold: 68831,
        foldFull: [
            68831
        ]
    },
    {
        code: 68768,
        lower: [],
        title: [],
        upper: [],
        fold: 68832,
        foldFull: [
            68832
        ]
    },
    {
        code: 68769,
        lower: [],
        title: [],
        upper: [],
        fold: 68833,
        foldFull: [
            68833
        ]
    },
    {
        code: 68770,
        lower: [],
        title: [],
        upper: [],
        fold: 68834,
        foldFull: [
            68834
        ]
    },
    {
        code: 68771,
        lower: [],
        title: [],
        upper: [],
        fold: 68835,
        foldFull: [
            68835
        ]
    },
    {
        code: 68772,
        lower: [],
        title: [],
        upper: [],
        fold: 68836,
        foldFull: [
            68836
        ]
    },
    {
        code: 68773,
        lower: [],
        title: [],
        upper: [],
        fold: 68837,
        foldFull: [
            68837
        ]
    },
    {
        code: 68774,
        lower: [],
        title: [],
        upper: [],
        fold: 68838,
        foldFull: [
            68838
        ]
    },
    {
        code: 68775,
        lower: [],
        title: [],
        upper: [],
        fold: 68839,
        foldFull: [
            68839
        ]
    },
    {
        code: 68776,
        lower: [],
        title: [],
        upper: [],
        fold: 68840,
        foldFull: [
            68840
        ]
    },
    {
        code: 68777,
        lower: [],
        title: [],
        upper: [],
        fold: 68841,
        foldFull: [
            68841
        ]
    },
    {
        code: 68778,
        lower: [],
        title: [],
        upper: [],
        fold: 68842,
        foldFull: [
            68842
        ]
    },
    {
        code: 68779,
        lower: [],
        title: [],
        upper: [],
        fold: 68843,
        foldFull: [
            68843
        ]
    },
    {
        code: 68780,
        lower: [],
        title: [],
        upper: [],
        fold: 68844,
        foldFull: [
            68844
        ]
    },
    {
        code: 68781,
        lower: [],
        title: [],
        upper: [],
        fold: 68845,
        foldFull: [
            68845
        ]
    },
    {
        code: 68782,
        lower: [],
        title: [],
        upper: [],
        fold: 68846,
        foldFull: [
            68846
        ]
    },
    {
        code: 68783,
        lower: [],
        title: [],
        upper: [],
        fold: 68847,
        foldFull: [
            68847
        ]
    },
    {
        code: 68784,
        lower: [],
        title: [],
        upper: [],
        fold: 68848,
        foldFull: [
            68848
        ]
    },
    {
        code: 68785,
        lower: [],
        title: [],
        upper: [],
        fold: 68849,
        foldFull: [
            68849
        ]
    },
    {
        code: 68786,
        lower: [],
        title: [],
        upper: [],
        fold: 68850,
        foldFull: [
            68850
        ]
    },
    {
        code: 71840,
        lower: [],
        title: [],
        upper: [],
        fold: 71872,
        foldFull: [
            71872
        ]
    },
    {
        code: 71841,
        lower: [],
        title: [],
        upper: [],
        fold: 71873,
        foldFull: [
            71873
        ]
    },
    {
        code: 71842,
        lower: [],
        title: [],
        upper: [],
        fold: 71874,
        foldFull: [
            71874
        ]
    },
    {
        code: 71843,
        lower: [],
        title: [],
        upper: [],
        fold: 71875,
        foldFull: [
            71875
        ]
    },
    {
        code: 71844,
        lower: [],
        title: [],
        upper: [],
        fold: 71876,
        foldFull: [
            71876
        ]
    },
    {
        code: 71845,
        lower: [],
        title: [],
        upper: [],
        fold: 71877,
        foldFull: [
            71877
        ]
    },
    {
        code: 71846,
        lower: [],
        title: [],
        upper: [],
        fold: 71878,
        foldFull: [
            71878
        ]
    },
    {
        code: 71847,
        lower: [],
        title: [],
        upper: [],
        fold: 71879,
        foldFull: [
            71879
        ]
    },
    {
        code: 71848,
        lower: [],
        title: [],
        upper: [],
        fold: 71880,
        foldFull: [
            71880
        ]
    },
    {
        code: 71849,
        lower: [],
        title: [],
        upper: [],
        fold: 71881,
        foldFull: [
            71881
        ]
    },
    {
        code: 71850,
        lower: [],
        title: [],
        upper: [],
        fold: 71882,
        foldFull: [
            71882
        ]
    },
    {
        code: 71851,
        lower: [],
        title: [],
        upper: [],
        fold: 71883,
        foldFull: [
            71883
        ]
    },
    {
        code: 71852,
        lower: [],
        title: [],
        upper: [],
        fold: 71884,
        foldFull: [
            71884
        ]
    },
    {
        code: 71853,
        lower: [],
        title: [],
        upper: [],
        fold: 71885,
        foldFull: [
            71885
        ]
    },
    {
        code: 71854,
        lower: [],
        title: [],
        upper: [],
        fold: 71886,
        foldFull: [
            71886
        ]
    },
    {
        code: 71855,
        lower: [],
        title: [],
        upper: [],
        fold: 71887,
        foldFull: [
            71887
        ]
    },
    {
        code: 71856,
        lower: [],
        title: [],
        upper: [],
        fold: 71888,
        foldFull: [
            71888
        ]
    },
    {
        code: 71857,
        lower: [],
        title: [],
        upper: [],
        fold: 71889,
        foldFull: [
            71889
        ]
    },
    {
        code: 71858,
        lower: [],
        title: [],
        upper: [],
        fold: 71890,
        foldFull: [
            71890
        ]
    },
    {
        code: 71859,
        lower: [],
        title: [],
        upper: [],
        fold: 71891,
        foldFull: [
            71891
        ]
    },
    {
        code: 71860,
        lower: [],
        title: [],
        upper: [],
        fold: 71892,
        foldFull: [
            71892
        ]
    },
    {
        code: 71861,
        lower: [],
        title: [],
        upper: [],
        fold: 71893,
        foldFull: [
            71893
        ]
    },
    {
        code: 71862,
        lower: [],
        title: [],
        upper: [],
        fold: 71894,
        foldFull: [
            71894
        ]
    },
    {
        code: 71863,
        lower: [],
        title: [],
        upper: [],
        fold: 71895,
        foldFull: [
            71895
        ]
    },
    {
        code: 71864,
        lower: [],
        title: [],
        upper: [],
        fold: 71896,
        foldFull: [
            71896
        ]
    },
    {
        code: 71865,
        lower: [],
        title: [],
        upper: [],
        fold: 71897,
        foldFull: [
            71897
        ]
    },
    {
        code: 71866,
        lower: [],
        title: [],
        upper: [],
        fold: 71898,
        foldFull: [
            71898
        ]
    },
    {
        code: 71867,
        lower: [],
        title: [],
        upper: [],
        fold: 71899,
        foldFull: [
            71899
        ]
    },
    {
        code: 71868,
        lower: [],
        title: [],
        upper: [],
        fold: 71900,
        foldFull: [
            71900
        ]
    },
    {
        code: 71869,
        lower: [],
        title: [],
        upper: [],
        fold: 71901,
        foldFull: [
            71901
        ]
    },
    {
        code: 71870,
        lower: [],
        title: [],
        upper: [],
        fold: 71902,
        foldFull: [
            71902
        ]
    },
    {
        code: 71871,
        lower: [],
        title: [],
        upper: [],
        fold: 71903,
        foldFull: [
            71903
        ]
    },
    {
        code: 93760,
        lower: [],
        title: [],
        upper: [],
        fold: 93792,
        foldFull: [
            93792
        ]
    },
    {
        code: 93761,
        lower: [],
        title: [],
        upper: [],
        fold: 93793,
        foldFull: [
            93793
        ]
    },
    {
        code: 93762,
        lower: [],
        title: [],
        upper: [],
        fold: 93794,
        foldFull: [
            93794
        ]
    },
    {
        code: 93763,
        lower: [],
        title: [],
        upper: [],
        fold: 93795,
        foldFull: [
            93795
        ]
    },
    {
        code: 93764,
        lower: [],
        title: [],
        upper: [],
        fold: 93796,
        foldFull: [
            93796
        ]
    },
    {
        code: 93765,
        lower: [],
        title: [],
        upper: [],
        fold: 93797,
        foldFull: [
            93797
        ]
    },
    {
        code: 93766,
        lower: [],
        title: [],
        upper: [],
        fold: 93798,
        foldFull: [
            93798
        ]
    },
    {
        code: 93767,
        lower: [],
        title: [],
        upper: [],
        fold: 93799,
        foldFull: [
            93799
        ]
    },
    {
        code: 93768,
        lower: [],
        title: [],
        upper: [],
        fold: 93800,
        foldFull: [
            93800
        ]
    },
    {
        code: 93769,
        lower: [],
        title: [],
        upper: [],
        fold: 93801,
        foldFull: [
            93801
        ]
    },
    {
        code: 93770,
        lower: [],
        title: [],
        upper: [],
        fold: 93802,
        foldFull: [
            93802
        ]
    },
    {
        code: 93771,
        lower: [],
        title: [],
        upper: [],
        fold: 93803,
        foldFull: [
            93803
        ]
    },
    {
        code: 93772,
        lower: [],
        title: [],
        upper: [],
        fold: 93804,
        foldFull: [
            93804
        ]
    },
    {
        code: 93773,
        lower: [],
        title: [],
        upper: [],
        fold: 93805,
        foldFull: [
            93805
        ]
    },
    {
        code: 93774,
        lower: [],
        title: [],
        upper: [],
        fold: 93806,
        foldFull: [
            93806
        ]
    },
    {
        code: 93775,
        lower: [],
        title: [],
        upper: [],
        fold: 93807,
        foldFull: [
            93807
        ]
    },
    {
        code: 93776,
        lower: [],
        title: [],
        upper: [],
        fold: 93808,
        foldFull: [
            93808
        ]
    },
    {
        code: 93777,
        lower: [],
        title: [],
        upper: [],
        fold: 93809,
        foldFull: [
            93809
        ]
    },
    {
        code: 93778,
        lower: [],
        title: [],
        upper: [],
        fold: 93810,
        foldFull: [
            93810
        ]
    },
    {
        code: 93779,
        lower: [],
        title: [],
        upper: [],
        fold: 93811,
        foldFull: [
            93811
        ]
    },
    {
        code: 93780,
        lower: [],
        title: [],
        upper: [],
        fold: 93812,
        foldFull: [
            93812
        ]
    },
    {
        code: 93781,
        lower: [],
        title: [],
        upper: [],
        fold: 93813,
        foldFull: [
            93813
        ]
    },
    {
        code: 93782,
        lower: [],
        title: [],
        upper: [],
        fold: 93814,
        foldFull: [
            93814
        ]
    },
    {
        code: 93783,
        lower: [],
        title: [],
        upper: [],
        fold: 93815,
        foldFull: [
            93815
        ]
    },
    {
        code: 93784,
        lower: [],
        title: [],
        upper: [],
        fold: 93816,
        foldFull: [
            93816
        ]
    },
    {
        code: 93785,
        lower: [],
        title: [],
        upper: [],
        fold: 93817,
        foldFull: [
            93817
        ]
    },
    {
        code: 93786,
        lower: [],
        title: [],
        upper: [],
        fold: 93818,
        foldFull: [
            93818
        ]
    },
    {
        code: 93787,
        lower: [],
        title: [],
        upper: [],
        fold: 93819,
        foldFull: [
            93819
        ]
    },
    {
        code: 93788,
        lower: [],
        title: [],
        upper: [],
        fold: 93820,
        foldFull: [
            93820
        ]
    },
    {
        code: 93789,
        lower: [],
        title: [],
        upper: [],
        fold: 93821,
        foldFull: [
            93821
        ]
    },
    {
        code: 93790,
        lower: [],
        title: [],
        upper: [],
        fold: 93822,
        foldFull: [
            93822
        ]
    },
    {
        code: 93791,
        lower: [],
        title: [],
        upper: [],
        fold: 93823,
        foldFull: [
            93823
        ]
    },
    {
        code: 125184,
        lower: [],
        title: [],
        upper: [],
        fold: 125218,
        foldFull: [
            125218
        ]
    },
    {
        code: 125185,
        lower: [],
        title: [],
        upper: [],
        fold: 125219,
        foldFull: [
            125219
        ]
    },
    {
        code: 125186,
        lower: [],
        title: [],
        upper: [],
        fold: 125220,
        foldFull: [
            125220
        ]
    },
    {
        code: 125187,
        lower: [],
        title: [],
        upper: [],
        fold: 125221,
        foldFull: [
            125221
        ]
    },
    {
        code: 125188,
        lower: [],
        title: [],
        upper: [],
        fold: 125222,
        foldFull: [
            125222
        ]
    },
    {
        code: 125189,
        lower: [],
        title: [],
        upper: [],
        fold: 125223,
        foldFull: [
            125223
        ]
    },
    {
        code: 125190,
        lower: [],
        title: [],
        upper: [],
        fold: 125224,
        foldFull: [
            125224
        ]
    },
    {
        code: 125191,
        lower: [],
        title: [],
        upper: [],
        fold: 125225,
        foldFull: [
            125225
        ]
    },
    {
        code: 125192,
        lower: [],
        title: [],
        upper: [],
        fold: 125226,
        foldFull: [
            125226
        ]
    },
    {
        code: 125193,
        lower: [],
        title: [],
        upper: [],
        fold: 125227,
        foldFull: [
            125227
        ]
    },
    {
        code: 125194,
        lower: [],
        title: [],
        upper: [],
        fold: 125228,
        foldFull: [
            125228
        ]
    },
    {
        code: 125195,
        lower: [],
        title: [],
        upper: [],
        fold: 125229,
        foldFull: [
            125229
        ]
    },
    {
        code: 125196,
        lower: [],
        title: [],
        upper: [],
        fold: 125230,
        foldFull: [
            125230
        ]
    },
    {
        code: 125197,
        lower: [],
        title: [],
        upper: [],
        fold: 125231,
        foldFull: [
            125231
        ]
    },
    {
        code: 125198,
        lower: [],
        title: [],
        upper: [],
        fold: 125232,
        foldFull: [
            125232
        ]
    },
    {
        code: 125199,
        lower: [],
        title: [],
        upper: [],
        fold: 125233,
        foldFull: [
            125233
        ]
    },
    {
        code: 125200,
        lower: [],
        title: [],
        upper: [],
        fold: 125234,
        foldFull: [
            125234
        ]
    },
    {
        code: 125201,
        lower: [],
        title: [],
        upper: [],
        fold: 125235,
        foldFull: [
            125235
        ]
    },
    {
        code: 125202,
        lower: [],
        title: [],
        upper: [],
        fold: 125236,
        foldFull: [
            125236
        ]
    },
    {
        code: 125203,
        lower: [],
        title: [],
        upper: [],
        fold: 125237,
        foldFull: [
            125237
        ]
    },
    {
        code: 125204,
        lower: [],
        title: [],
        upper: [],
        fold: 125238,
        foldFull: [
            125238
        ]
    },
    {
        code: 125205,
        lower: [],
        title: [],
        upper: [],
        fold: 125239,
        foldFull: [
            125239
        ]
    },
    {
        code: 125206,
        lower: [],
        title: [],
        upper: [],
        fold: 125240,
        foldFull: [
            125240
        ]
    },
    {
        code: 125207,
        lower: [],
        title: [],
        upper: [],
        fold: 125241,
        foldFull: [
            125241
        ]
    },
    {
        code: 125208,
        lower: [],
        title: [],
        upper: [],
        fold: 125242,
        foldFull: [
            125242
        ]
    },
    {
        code: 125209,
        lower: [],
        title: [],
        upper: [],
        fold: 125243,
        foldFull: [
            125243
        ]
    },
    {
        code: 125210,
        lower: [],
        title: [],
        upper: [],
        fold: 125244,
        foldFull: [
            125244
        ]
    },
    {
        code: 125211,
        lower: [],
        title: [],
        upper: [],
        fold: 125245,
        foldFull: [
            125245
        ]
    },
    {
        code: 125212,
        lower: [],
        title: [],
        upper: [],
        fold: 125246,
        foldFull: [
            125246
        ]
    },
    {
        code: 125213,
        lower: [],
        title: [],
        upper: [],
        fold: 125247,
        foldFull: [
            125247
        ]
    },
    {
        code: 125214,
        lower: [],
        title: [],
        upper: [],
        fold: 125248,
        foldFull: [
            125248
        ]
    },
    {
        code: 125215,
        lower: [],
        title: [],
        upper: [],
        fold: 125249,
        foldFull: [
            125249
        ]
    },
    {
        code: 125216,
        lower: [],
        title: [],
        upper: [],
        fold: 125250,
        foldFull: [
            125250
        ]
    },
    {
        code: 125217,
        lower: [],
        title: [],
        upper: [],
        fold: 125251,
        foldFull: [
            125251
        ]
    }
];
var $7b07f9d0d04434a1$export$11ed315285584913 = function(v) {
    return function(v1) {
        return $7b07f9d0d04434a1$var$compare(v.code)(v1.code);
    };
};
var $7b07f9d0d04434a1$export$19817ff19468d542 = function(code) {
    var v = $f87c9187b968257a$export$6029ab542afbcf48($7b07f9d0d04434a1$export$b6e1a177a4bea09c(code))($7b07f9d0d04434a1$export$354076178bdef094)($fc8c1182ec2aefec$export$f24224f1c91d8156($7b07f9d0d04434a1$export$354076178bdef094))($7b07f9d0d04434a1$export$11ed315285584913);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7b07f9d0d04434a1$export$b6e1a177a4bea09c(code);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode.Internal.Casing (line 1627, column 17 - line 1629, column 14): " + [
        v.constructor.name
    ]);
};
var $7b07f9d0d04434a1$export$93e2b83da34ff82a = function(code) {
    var folded = $7b07f9d0d04434a1$export$19817ff19468d542(code).fold;
    var $11 = folded === 0;
    if ($11) return $f87c9187b968257a$export$c8e8c950fabdf148(code);
    return folded;
};
var $7b07f9d0d04434a1$export$c86ab0718f163a93 = function(code) {
    var folded = $7b07f9d0d04434a1$export$19817ff19468d542(code).foldFull;
    var $12 = $396c4c3d9e7fae3c$export$7b1b591b262c240(folded);
    if ($12) return [
        $f87c9187b968257a$export$c8e8c950fabdf148(code)
    ];
    return folded;
};
var $7b07f9d0d04434a1$export$abae053c7acf36bb = function(code) {
    var lowered = $7b07f9d0d04434a1$export$19817ff19468d542(code).lower;
    var $13 = $396c4c3d9e7fae3c$export$7b1b591b262c240(lowered);
    if ($13) return [
        $f87c9187b968257a$export$c8e8c950fabdf148(code)
    ];
    return lowered;
};
var $7b07f9d0d04434a1$export$fb184b623420d9be = function(code) {
    var titled = $7b07f9d0d04434a1$export$19817ff19468d542(code).title;
    var $14 = $396c4c3d9e7fae3c$export$7b1b591b262c240(titled);
    if ($14) return [
        $f87c9187b968257a$export$60bc89e8f464ddae(code)
    ];
    return titled;
};
var $7b07f9d0d04434a1$export$74b75dbc6083f1f5 = function(code) {
    var uppered = $7b07f9d0d04434a1$export$19817ff19468d542(code).upper;
    var $15 = $396c4c3d9e7fae3c$export$7b1b591b262c240(uppered);
    if ($15) return [
        $f87c9187b968257a$export$d3a8c5dfd48993e0(code)
    ];
    return uppered;
};








var $ae1fc60b21f03c62$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1);
var $ae1fc60b21f03c62$var$lessThanOrEq1 = /* #__PURE__ */ $97937c29f879e68e$export$f0c1dc893917aeba($3ee2158c14339cc9$export$b08a820ff2b5847d);
var $ae1fc60b21f03c62$var$greaterThanOrEq1 = /* #__PURE__ */ $97937c29f879e68e$export$4be320a4fd1ac499($3ee2158c14339cc9$export$b08a820ff2b5847d);
var $ae1fc60b21f03c62$var$lessThan = /* #__PURE__ */ $97937c29f879e68e$export$9b050841a3a1b328($3ee2158c14339cc9$export$b08a820ff2b5847d);
var $ae1fc60b21f03c62$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $ae1fc60b21f03c62$export$ba163c2257d3dcff = /* #__PURE__ */ function() {
    function UppercaseLetter() {}
    UppercaseLetter.value = new UppercaseLetter();
    return UppercaseLetter;
}();
var $ae1fc60b21f03c62$export$f97856bb28e7278d = /* #__PURE__ */ function() {
    function LowercaseLetter() {}
    LowercaseLetter.value = new LowercaseLetter();
    return LowercaseLetter;
}();
var $ae1fc60b21f03c62$export$ee42eb148e8da2d3 = /* #__PURE__ */ function() {
    function TitlecaseLetter() {}
    TitlecaseLetter.value = new TitlecaseLetter();
    return TitlecaseLetter;
}();
var $ae1fc60b21f03c62$export$1143edeb415eb3db = /* #__PURE__ */ function() {
    function ModifierLetter() {}
    ModifierLetter.value = new ModifierLetter();
    return ModifierLetter;
}();
var $ae1fc60b21f03c62$export$bc7f3db2d3cba36f = /* #__PURE__ */ function() {
    function OtherLetter() {}
    OtherLetter.value = new OtherLetter();
    return OtherLetter;
}();
var $ae1fc60b21f03c62$export$f196939a6e3c6116 = /* #__PURE__ */ function() {
    function NonSpacingMark() {}
    NonSpacingMark.value = new NonSpacingMark();
    return NonSpacingMark;
}();
var $ae1fc60b21f03c62$export$88093afafbb74ea5 = /* #__PURE__ */ function() {
    function SpacingCombiningMark() {}
    SpacingCombiningMark.value = new SpacingCombiningMark();
    return SpacingCombiningMark;
}();
var $ae1fc60b21f03c62$export$5d50d5f906d4a533 = /* #__PURE__ */ function() {
    function EnclosingMark() {}
    EnclosingMark.value = new EnclosingMark();
    return EnclosingMark;
}();
var $ae1fc60b21f03c62$export$b6fbbffa48fbb725 = /* #__PURE__ */ function() {
    function DecimalNumber() {}
    DecimalNumber.value = new DecimalNumber();
    return DecimalNumber;
}();
var $ae1fc60b21f03c62$export$24be45a284e3902b = /* #__PURE__ */ function() {
    function LetterNumber() {}
    LetterNumber.value = new LetterNumber();
    return LetterNumber;
}();
var $ae1fc60b21f03c62$export$94c512b4b5438d90 = /* #__PURE__ */ function() {
    function OtherNumber() {}
    OtherNumber.value = new OtherNumber();
    return OtherNumber;
}();
var $ae1fc60b21f03c62$export$befef8e3bda25d8d = /* #__PURE__ */ function() {
    function ConnectorPunctuation() {}
    ConnectorPunctuation.value = new ConnectorPunctuation();
    return ConnectorPunctuation;
}();
var $ae1fc60b21f03c62$export$f65249b82daae727 = /* #__PURE__ */ function() {
    function DashPunctuation() {}
    DashPunctuation.value = new DashPunctuation();
    return DashPunctuation;
}();
var $ae1fc60b21f03c62$export$91846c2aea856cce = /* #__PURE__ */ function() {
    function OpenPunctuation() {}
    OpenPunctuation.value = new OpenPunctuation();
    return OpenPunctuation;
}();
var $ae1fc60b21f03c62$export$a4d3a0253b65f083 = /* #__PURE__ */ function() {
    function ClosePunctuation() {}
    ClosePunctuation.value = new ClosePunctuation();
    return ClosePunctuation;
}();
var $ae1fc60b21f03c62$export$35d55de78258e09c = /* #__PURE__ */ function() {
    function InitialQuote() {}
    InitialQuote.value = new InitialQuote();
    return InitialQuote;
}();
var $ae1fc60b21f03c62$export$84e1e73db8a6fcf4 = /* #__PURE__ */ function() {
    function FinalQuote() {}
    FinalQuote.value = new FinalQuote();
    return FinalQuote;
}();
var $ae1fc60b21f03c62$export$7bc2110f87f79574 = /* #__PURE__ */ function() {
    function OtherPunctuation() {}
    OtherPunctuation.value = new OtherPunctuation();
    return OtherPunctuation;
}();
var $ae1fc60b21f03c62$export$2d8ad6e0bc55950e = /* #__PURE__ */ function() {
    function MathSymbol() {}
    MathSymbol.value = new MathSymbol();
    return MathSymbol;
}();
var $ae1fc60b21f03c62$export$45568c72b5c00715 = /* #__PURE__ */ function() {
    function CurrencySymbol() {}
    CurrencySymbol.value = new CurrencySymbol();
    return CurrencySymbol;
}();
var $ae1fc60b21f03c62$export$44424ac90397f38c = /* #__PURE__ */ function() {
    function ModifierSymbol() {}
    ModifierSymbol.value = new ModifierSymbol();
    return ModifierSymbol;
}();
var $ae1fc60b21f03c62$export$f602d6b39d1f67cf = /* #__PURE__ */ function() {
    function OtherSymbol() {}
    OtherSymbol.value = new OtherSymbol();
    return OtherSymbol;
}();
var $ae1fc60b21f03c62$export$eef1e68107c58ef2 = /* #__PURE__ */ function() {
    function Space() {}
    Space.value = new Space();
    return Space;
}();
var $ae1fc60b21f03c62$export$d3714c887ff0b3a1 = /* #__PURE__ */ function() {
    function LineSeparator() {}
    LineSeparator.value = new LineSeparator();
    return LineSeparator;
}();
var $ae1fc60b21f03c62$export$55d91bb2895e56f6 = /* #__PURE__ */ function() {
    function ParagraphSeparator() {}
    ParagraphSeparator.value = new ParagraphSeparator();
    return ParagraphSeparator;
}();
var $ae1fc60b21f03c62$export$7a7fa4424cb20976 = /* #__PURE__ */ function() {
    function Control() {}
    Control.value = new Control();
    return Control;
}();
var $ae1fc60b21f03c62$export$93514d28bd18d75a = /* #__PURE__ */ function() {
    function Format() {}
    Format.value = new Format();
    return Format;
}();
var $ae1fc60b21f03c62$export$47ecfea156e07ce1 = /* #__PURE__ */ function() {
    function Surrogate() {}
    Surrogate.value = new Surrogate();
    return Surrogate;
}();
var $ae1fc60b21f03c62$export$99814c886715a026 = /* #__PURE__ */ function() {
    function PrivateUse() {}
    PrivateUse.value = new PrivateUse();
    return PrivateUse;
}();
var $ae1fc60b21f03c62$export$6f449c45ca2e4ef5 = /* #__PURE__ */ function() {
    function NotAssigned() {}
    NotAssigned.value = new NotAssigned();
    return NotAssigned;
}();
var $ae1fc60b21f03c62$export$8c566994308f50f1 = function(v) {
    if (v instanceof $f87c9187b968257a$export$74fad270c4b7b59c) return $ae1fc60b21f03c62$export$ba163c2257d3dcff.value;
    if (v instanceof $f87c9187b968257a$export$d4598102ceb86c96) return $ae1fc60b21f03c62$export$f97856bb28e7278d.value;
    if (v instanceof $f87c9187b968257a$export$676a18bdacd919c8) return $ae1fc60b21f03c62$export$ee42eb148e8da2d3.value;
    if (v instanceof $f87c9187b968257a$export$3be55c3cc7f2867) return $ae1fc60b21f03c62$export$1143edeb415eb3db.value;
    if (v instanceof $f87c9187b968257a$export$20b05fa78ae7527a) return $ae1fc60b21f03c62$export$bc7f3db2d3cba36f.value;
    if (v instanceof $f87c9187b968257a$export$79b57d103eae7039) return $ae1fc60b21f03c62$export$f196939a6e3c6116.value;
    if (v instanceof $f87c9187b968257a$export$60e41f2154339dc7) return $ae1fc60b21f03c62$export$88093afafbb74ea5.value;
    if (v instanceof $f87c9187b968257a$export$77f7cb14f5a8a8ea) return $ae1fc60b21f03c62$export$5d50d5f906d4a533.value;
    if (v instanceof $f87c9187b968257a$export$1a1df9278c5a4522) return $ae1fc60b21f03c62$export$b6fbbffa48fbb725.value;
    if (v instanceof $f87c9187b968257a$export$ffe624f4617a733d) return $ae1fc60b21f03c62$export$24be45a284e3902b.value;
    if (v instanceof $f87c9187b968257a$export$21de707035b964f7) return $ae1fc60b21f03c62$export$94c512b4b5438d90.value;
    if (v instanceof $f87c9187b968257a$export$edda2e74149c5a6e) return $ae1fc60b21f03c62$export$befef8e3bda25d8d.value;
    if (v instanceof $f87c9187b968257a$export$8ef7193d38bceddf) return $ae1fc60b21f03c62$export$f65249b82daae727.value;
    if (v instanceof $f87c9187b968257a$export$a44baae05e4dd261) return $ae1fc60b21f03c62$export$91846c2aea856cce.value;
    if (v instanceof $f87c9187b968257a$export$3e12887efe278a41) return $ae1fc60b21f03c62$export$a4d3a0253b65f083.value;
    if (v instanceof $f87c9187b968257a$export$594ecb1526fb138a) return $ae1fc60b21f03c62$export$35d55de78258e09c.value;
    if (v instanceof $f87c9187b968257a$export$18c5ebc155f51ada) return $ae1fc60b21f03c62$export$84e1e73db8a6fcf4.value;
    if (v instanceof $f87c9187b968257a$export$e57c737c9939aaf8) return $ae1fc60b21f03c62$export$7bc2110f87f79574.value;
    if (v instanceof $f87c9187b968257a$export$b699f9c90222e3b1) return $ae1fc60b21f03c62$export$2d8ad6e0bc55950e.value;
    if (v instanceof $f87c9187b968257a$export$afd75ca7ec085208) return $ae1fc60b21f03c62$export$45568c72b5c00715.value;
    if (v instanceof $f87c9187b968257a$export$fcf99045e4ea7aa7) return $ae1fc60b21f03c62$export$44424ac90397f38c.value;
    if (v instanceof $f87c9187b968257a$export$cbb37359c0c92ac5) return $ae1fc60b21f03c62$export$f602d6b39d1f67cf.value;
    if (v instanceof $f87c9187b968257a$export$f359e26b05cf8d05) return $ae1fc60b21f03c62$export$eef1e68107c58ef2.value;
    if (v instanceof $f87c9187b968257a$export$bb5b519c0a0e45c0) return $ae1fc60b21f03c62$export$d3714c887ff0b3a1.value;
    if (v instanceof $f87c9187b968257a$export$c5677ea07a95661f) return $ae1fc60b21f03c62$export$55d91bb2895e56f6.value;
    if (v instanceof $f87c9187b968257a$export$88d4031ea4604c81) return $ae1fc60b21f03c62$export$7a7fa4424cb20976.value;
    if (v instanceof $f87c9187b968257a$export$a566777c5e1513f9) return $ae1fc60b21f03c62$export$93514d28bd18d75a.value;
    if (v instanceof $f87c9187b968257a$export$ef2df197b5c4ec96) return $ae1fc60b21f03c62$export$47ecfea156e07ce1.value;
    if (v instanceof $f87c9187b968257a$export$86eb9fe5fb3b572b) return $ae1fc60b21f03c62$export$99814c886715a026.value;
    if (v instanceof $f87c9187b968257a$export$1ae025eae1298b53) return $ae1fc60b21f03c62$export$6f449c45ca2e4ef5.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 206, column 1 - line 206, column 61): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$261cacb5fb2d0b3c = {
    show: function(v) {
        if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return "UppercaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return "LowercaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return "TitlecaseLetter";
        if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return "ModifierLetter";
        if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return "OtherLetter";
        if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return "NonSpacingMark";
        if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return "SpacingCombiningMark";
        if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return "EnclosingMark";
        if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return "DecimalNumber";
        if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return "LetterNumber";
        if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return "OtherNumber";
        if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return "ConnectorPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return "DashPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return "OpenPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return "ClosePunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return "InitialQuote";
        if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return "FinalQuote";
        if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return "OtherPunctuation";
        if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return "MathSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return "CurrencySymbol";
        if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return "ModifierSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return "OtherSymbol";
        if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return "Space";
        if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return "LineSeparator";
        if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return "ParagraphSeparator";
        if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return "Control";
        if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return "Format";
        if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return "Surrogate";
        if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return "PrivateUse";
        if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return "NotAssigned";
        throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 238, column 1 - line 268, column 35): " + [
            v.constructor.name
        ]);
    }
};
var $ae1fc60b21f03c62$var$modifyFull = $ac8b3532514ac019$export$401372c57776dc;
var $ae1fc60b21f03c62$export$b1ceac3893cbda6b = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($7b07f9d0d04434a1$export$abae053c7acf36bb);
var $ae1fc60b21f03c62$export$1294308be85b4eca = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($7b07f9d0d04434a1$export$fb184b623420d9be);
var $ae1fc60b21f03c62$export$43df7fc17cca38a4 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($7b07f9d0d04434a1$export$74b75dbc6083f1f5);
var $ae1fc60b21f03c62$var$modify = $ac8b3532514ac019$export$401372c57776dc;
var $ae1fc60b21f03c62$export$3407ec4ae1791d82 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($f87c9187b968257a$export$c8e8c950fabdf148);
var $ae1fc60b21f03c62$export$ce8e628e067c78e7 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($f87c9187b968257a$export$60bc89e8f464ddae);
var $ae1fc60b21f03c62$export$758e327c875e235b = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($f87c9187b968257a$export$d3a8c5dfd48993e0);
var $ae1fc60b21f03c62$export$ae50dec7acbeb690 = function($66) {
    return $f87c9187b968257a$export$3cb76ee86c1f055b($ae1fc60b21f03c62$var$fromEnum($66));
};
var $ae1fc60b21f03c62$export$1d5ccafae59b4926 = function(c) {
    var uc = $ae1fc60b21f03c62$var$fromEnum(c);
    var $28 = uc <= 823;
    if ($28) return uc === 32 || uc >= 9 && uc <= 13 || uc === 160;
    return $f87c9187b968257a$export$882876e1e8ba136f(uc);
};
var $ae1fc60b21f03c62$export$70fd39c87e72de00 = function($67) {
    return $f87c9187b968257a$export$8b4972b3757fc3c7($ae1fc60b21f03c62$var$fromEnum($67));
};
var $ae1fc60b21f03c62$export$537eb6b62c8dbc27 = function(c) {
    var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("0") | 0;
    return diff <= 7 && diff >= 0;
};
var $ae1fc60b21f03c62$export$e826a59393915b9 = function(c) {
    if ($ae1fc60b21f03c62$export$537eb6b62c8dbc27(c)) return new $06733ae99ed4f534$export$8a67b48435b5d073($ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("0") | 0);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 636, column 1 - line 636, column 40): " + [
        c.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$612428811da8e7ba = function($68) {
    return $f87c9187b968257a$export$7a4a3ef8a70b2a6($ae1fc60b21f03c62$var$fromEnum($68));
};
var $ae1fc60b21f03c62$export$a33149e31f083a2b = function(c) {
    return $ae1fc60b21f03c62$var$lessThanOrEq1(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("\xff"));
};
var $ae1fc60b21f03c62$export$e03c54e9ed5bdad0 = function(c) {
    var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("0") | 0;
    return diff <= 9 && diff >= 0;
};
var $ae1fc60b21f03c62$export$727d9dbc4fbb948f = function() {
    return $ae1fc60b21f03c62$export$e03c54e9ed5bdad0;
};
var $ae1fc60b21f03c62$export$2a81dc4d1a2f9334 = function(c) {
    return $ae1fc60b21f03c62$export$e03c54e9ed5bdad0(c) || function() {
        var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("A") | 0;
        return diff <= 5 && diff >= 0;
    }() || function() {
        var diff = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("a") | 0;
        return diff <= 5 && diff >= 0;
    }();
};
var $ae1fc60b21f03c62$export$5a68459d5634ec09 = function($69) {
    return $f87c9187b968257a$export$fed91e20fe04f313($ae1fc60b21f03c62$var$fromEnum($69));
};
var $ae1fc60b21f03c62$export$66b98c3a43d12999 = function(c) {
    return $ae1fc60b21f03c62$var$greaterThanOrEq1(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("A")) && $ae1fc60b21f03c62$var$lessThanOrEq1(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("Z"));
};
var $ae1fc60b21f03c62$export$201a409c4b42ac0d = function(c) {
    return $ae1fc60b21f03c62$var$greaterThanOrEq1(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("a")) && $ae1fc60b21f03c62$var$lessThanOrEq1(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("z"));
};
var $ae1fc60b21f03c62$export$5687edf39827d1cd = function(c) {
    return $ae1fc60b21f03c62$var$lessThan(c)($3ee2158c14339cc9$export$dd1029f96c3dd62a("\x80"));
};
var $ae1fc60b21f03c62$export$bbe6438367709b6a = function($70) {
    return $f87c9187b968257a$export$a0fec735e7d145b($ae1fc60b21f03c62$var$fromEnum($70));
};
var $ae1fc60b21f03c62$export$4f1b4fd0a80ed3b5 = function($71) {
    return $f87c9187b968257a$export$edcbae4531e40b8a($ae1fc60b21f03c62$var$fromEnum($71));
};
var $ae1fc60b21f03c62$export$a9520415cc1c4631 = function(c) {
    var hexUpper = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("A") | 0;
    var hexLower = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("a") | 0;
    var dec = $ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("0") | 0;
    var result = function() {
        if (dec <= 9 && dec >= 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(dec);
        if (hexLower <= 5 && hexLower >= 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(hexLower + 10 | 0);
        if (hexUpper <= 5 && hexUpper >= 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(hexUpper + 10 | 0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 591, column 3 - line 591, column 22): ");
    }();
    return result;
};
var $ae1fc60b21f03c62$export$6476fa500734b59e = /* #__PURE__ */ function() {
    var $72 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66)($ae1fc60b21f03c62$export$8c566994308f50f1);
    return function($73) {
        return $72($f87c9187b968257a$export$6d2646f79a263fa8($ae1fc60b21f03c62$var$fromEnum($73)));
    };
}();
var $ae1fc60b21f03c62$export$79c5d5217943d6a7 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return true;
    return false;
};
var $ae1fc60b21f03c62$export$e33ad6871e762338 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return true;
    return false;
};
var $ae1fc60b21f03c62$export$7e4aa119212bc614 = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return true;
    return false;
};
var $ae1fc60b21f03c62$export$a5b49f4dc6a07d2c = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return true;
    return false;
};
var $ae1fc60b21f03c62$export$aa03971fc638f7dd = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return true;
    return false;
};
var $ae1fc60b21f03c62$export$a244864fd9645c7f = function(c) {
    var v = $ae1fc60b21f03c62$export$6476fa500734b59e(c);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return true;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return true;
    return false;
};
var $ae1fc60b21f03c62$export$d47bed3dfc848b44 = function(v) {
    if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return $f87c9187b968257a$export$74fad270c4b7b59c.value;
    if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return $f87c9187b968257a$export$d4598102ceb86c96.value;
    if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return $f87c9187b968257a$export$676a18bdacd919c8.value;
    if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return $f87c9187b968257a$export$3be55c3cc7f2867.value;
    if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return $f87c9187b968257a$export$20b05fa78ae7527a.value;
    if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return $f87c9187b968257a$export$79b57d103eae7039.value;
    if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return $f87c9187b968257a$export$60e41f2154339dc7.value;
    if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return $f87c9187b968257a$export$77f7cb14f5a8a8ea.value;
    if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return $f87c9187b968257a$export$1a1df9278c5a4522.value;
    if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return $f87c9187b968257a$export$ffe624f4617a733d.value;
    if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return $f87c9187b968257a$export$21de707035b964f7.value;
    if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return $f87c9187b968257a$export$edda2e74149c5a6e.value;
    if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return $f87c9187b968257a$export$8ef7193d38bceddf.value;
    if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return $f87c9187b968257a$export$a44baae05e4dd261.value;
    if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return $f87c9187b968257a$export$3e12887efe278a41.value;
    if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return $f87c9187b968257a$export$594ecb1526fb138a.value;
    if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return $f87c9187b968257a$export$18c5ebc155f51ada.value;
    if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return $f87c9187b968257a$export$e57c737c9939aaf8.value;
    if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return $f87c9187b968257a$export$b699f9c90222e3b1.value;
    if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return $f87c9187b968257a$export$afd75ca7ec085208.value;
    if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return $f87c9187b968257a$export$fcf99045e4ea7aa7.value;
    if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return $f87c9187b968257a$export$cbb37359c0c92ac5.value;
    if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return $f87c9187b968257a$export$f359e26b05cf8d05.value;
    if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return $f87c9187b968257a$export$bb5b519c0a0e45c0.value;
    if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return $f87c9187b968257a$export$c5677ea07a95661f.value;
    if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return $f87c9187b968257a$export$88d4031ea4604c81.value;
    if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return $f87c9187b968257a$export$a566777c5e1513f9.value;
    if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return $f87c9187b968257a$export$ef2df197b5c4ec96.value;
    if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return $f87c9187b968257a$export$86eb9fe5fb3b572b.value;
    if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return $f87c9187b968257a$export$1ae025eae1298b53.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 174, column 1 - line 174, column 61): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$4a6f37acacca068c = function(v) {
    if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return 1;
    if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return 2;
    if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return 3;
    if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return 4;
    if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return 5;
    if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return 6;
    if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return 7;
    if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return 8;
    if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return 9;
    if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return 10;
    if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return 11;
    if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return 12;
    if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return 13;
    if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return 14;
    if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return 15;
    if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return 16;
    if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return 17;
    if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return 18;
    if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return 19;
    if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return 20;
    if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return 21;
    if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return 22;
    if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return 23;
    if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return 24;
    if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return 25;
    if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return 26;
    if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return 27;
    if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return 28;
    if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026) return 29;
    if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return 30;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 142, column 1 - line 142, column 42): " + [
        v.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$a33be10dfbfb0fd9 = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff && v1 instanceof $ae1fc60b21f03c62$export$ba163c2257d3dcff) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d && v1 instanceof $ae1fc60b21f03c62$export$f97856bb28e7278d) return true;
            if (v instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3 && v1 instanceof $ae1fc60b21f03c62$export$ee42eb148e8da2d3) return true;
            if (v instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db && v1 instanceof $ae1fc60b21f03c62$export$1143edeb415eb3db) return true;
            if (v instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f && v1 instanceof $ae1fc60b21f03c62$export$bc7f3db2d3cba36f) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116 && v1 instanceof $ae1fc60b21f03c62$export$f196939a6e3c6116) return true;
            if (v instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5 && v1 instanceof $ae1fc60b21f03c62$export$88093afafbb74ea5) return true;
            if (v instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533 && v1 instanceof $ae1fc60b21f03c62$export$5d50d5f906d4a533) return true;
            if (v instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725 && v1 instanceof $ae1fc60b21f03c62$export$b6fbbffa48fbb725) return true;
            if (v instanceof $ae1fc60b21f03c62$export$24be45a284e3902b && v1 instanceof $ae1fc60b21f03c62$export$24be45a284e3902b) return true;
            if (v instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90 && v1 instanceof $ae1fc60b21f03c62$export$94c512b4b5438d90) return true;
            if (v instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d && v1 instanceof $ae1fc60b21f03c62$export$befef8e3bda25d8d) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f65249b82daae727 && v1 instanceof $ae1fc60b21f03c62$export$f65249b82daae727) return true;
            if (v instanceof $ae1fc60b21f03c62$export$91846c2aea856cce && v1 instanceof $ae1fc60b21f03c62$export$91846c2aea856cce) return true;
            if (v instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083 && v1 instanceof $ae1fc60b21f03c62$export$a4d3a0253b65f083) return true;
            if (v instanceof $ae1fc60b21f03c62$export$35d55de78258e09c && v1 instanceof $ae1fc60b21f03c62$export$35d55de78258e09c) return true;
            if (v instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4 && v1 instanceof $ae1fc60b21f03c62$export$84e1e73db8a6fcf4) return true;
            if (v instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574 && v1 instanceof $ae1fc60b21f03c62$export$7bc2110f87f79574) return true;
            if (v instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e && v1 instanceof $ae1fc60b21f03c62$export$2d8ad6e0bc55950e) return true;
            if (v instanceof $ae1fc60b21f03c62$export$45568c72b5c00715 && v1 instanceof $ae1fc60b21f03c62$export$45568c72b5c00715) return true;
            if (v instanceof $ae1fc60b21f03c62$export$44424ac90397f38c && v1 instanceof $ae1fc60b21f03c62$export$44424ac90397f38c) return true;
            if (v instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf && v1 instanceof $ae1fc60b21f03c62$export$f602d6b39d1f67cf) return true;
            if (v instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2 && v1 instanceof $ae1fc60b21f03c62$export$eef1e68107c58ef2) return true;
            if (v instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1 && v1 instanceof $ae1fc60b21f03c62$export$d3714c887ff0b3a1) return true;
            if (v instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6 && v1 instanceof $ae1fc60b21f03c62$export$55d91bb2895e56f6) return true;
            if (v instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976 && v1 instanceof $ae1fc60b21f03c62$export$7a7fa4424cb20976) return true;
            if (v instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a && v1 instanceof $ae1fc60b21f03c62$export$93514d28bd18d75a) return true;
            if (v instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1 && v1 instanceof $ae1fc60b21f03c62$export$47ecfea156e07ce1) return true;
            if (v instanceof $ae1fc60b21f03c62$export$99814c886715a026 && v1 instanceof $ae1fc60b21f03c62$export$99814c886715a026) return true;
            if (v instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5 && v1 instanceof $ae1fc60b21f03c62$export$6f449c45ca2e4ef5) return true;
            return false;
        };
    }
};
var $ae1fc60b21f03c62$export$c4022f78235b5179 = {
    compare: function(catA) {
        return function(catB) {
            return $ae1fc60b21f03c62$var$compare($ae1fc60b21f03c62$export$4a6f37acacca068c(catA))($ae1fc60b21f03c62$export$4a6f37acacca068c(catB));
        };
    },
    Eq0: function() {
        return $ae1fc60b21f03c62$export$a33be10dfbfb0fd9;
    }
};
var $ae1fc60b21f03c62$export$87f6f309ec737545 = function() {
    return $ae1fc60b21f03c62$export$a9520415cc1c4631;
};
var $ae1fc60b21f03c62$export$affdad0e6d95dbf1 = function(c) {
    if ($ae1fc60b21f03c62$export$e03c54e9ed5bdad0(c)) return new $06733ae99ed4f534$export$8a67b48435b5d073($ae1fc60b21f03c62$var$fromEnum(c) - $50b5a2f2b28bbba4$export$d90166409dd04e85("0") | 0);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.CodePoint.Unicode (line 619, column 1 - line 619, column 40): " + [
        c.constructor.name
    ]);
};
var $ae1fc60b21f03c62$export$aa379662b51020a0 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modify($7b07f9d0d04434a1$export$93e2b83da34ff82a);
var $ae1fc60b21f03c62$export$ed703a87961582a2 = /* #__PURE__ */ $ae1fc60b21f03c62$var$modifyFull($7b07f9d0d04434a1$export$c86ab0718f163a93);
var $ae1fc60b21f03c62$export$46ec243958c72e02 = /* #__PURE__ */ function() {
    return {
        bottom: $ae1fc60b21f03c62$export$ba163c2257d3dcff.value,
        top: $ae1fc60b21f03c62$export$6f449c45ca2e4ef5.value,
        Ord0: function() {
            return $ae1fc60b21f03c62$export$c4022f78235b5179;
        }
    };
}();



















var $32834c6d75ca0cb1$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($3ee2158c14339cc9$export$e200a5917becef04);
var $32834c6d75ca0cb1$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $32834c6d75ca0cb1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $32834c6d75ca0cb1$var$elem1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($37b880af5f4991bd$export$bcd79f9321394c38);
var $32834c6d75ca0cb1$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($2c6b3d51d10471a7$export$def6059c21714f2a));
var $32834c6d75ca0cb1$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $32834c6d75ca0cb1$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($fb3071975af0bbe0$export$85aac2cdb4833912);
var $32834c6d75ca0cb1$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $32834c6d75ca0cb1$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47);
var $32834c6d75ca0cb1$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $32834c6d75ca0cb1$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $32834c6d75ca0cb1$var$notElem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$63faa62a0284a4a6($3ee2158c14339cc9$export$e200a5917becef04);
var $32834c6d75ca0cb1$var$notElem1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$63faa62a0284a4a6($37b880af5f4991bd$export$bcd79f9321394c38);
var $32834c6d75ca0cb1$export$fa0d629c75fdc0f1 = function(predicate) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(s) {
        var value = $3ee2158c14339cc9$export$9384c7afe4015e42(predicate)(s);
        var len = $092fe44bc0883be6$export$f24224f1c91d8156(value);
        var $27 = len > 0;
        if ($27) return new $7d4cccdf062a2261$export$19db0165690c701a({
            consumed: value,
            remainder: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(value))(s),
            value: value
        });
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Expected character satisfying predicate");
    });
};
var $32834c6d75ca0cb1$export$9384c7afe4015e42 = function(predicate) {
    return $ca4b6f31ec4b9857$export$9b3710c6484cace(function(s) {
        var value = $3ee2158c14339cc9$export$9384c7afe4015e42(predicate)(s);
        return new $7d4cccdf062a2261$export$19db0165690c701a({
            consumed: value,
            remainder: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(value))(s),
            value: value
        });
    });
};
var $32834c6d75ca0cb1$export$9ef81298ca34ad41 = /* #__PURE__ */ $32834c6d75ca0cb1$export$9384c7afe4015e42($ae1fc60b21f03c62$export$1d5ccafae59b4926);
var $32834c6d75ca0cb1$export$c85b81cf4e701929 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($2b6d012b5a71a466$export$858eabc7228a4f5b)($32834c6d75ca0cb1$export$9ef81298ca34ad41);
var $32834c6d75ca0cb1$var$satisfyCP = function(p) {
    return $ca4b6f31ec4b9857$export$ec0bab193bdafe1(function($32) {
        return p($3ee2158c14339cc9$export$dd1029f96c3dd62a($32));
    });
};
var $32834c6d75ca0cb1$export$a941ed4b947d12f8 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$1d5ccafae59b4926))("space");
var $32834c6d75ca0cb1$export$74b75dbc6083f1f5 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$ae50dec7acbeb690))("uppercase letter");
var $32834c6d75ca0cb1$export$719a4d2b42fce467 = function(ss) {
    return $11bbe85c947c529d$export$db22ac524b337b7($ca4b6f31ec4b9857$export$566aa36e2fcdcfb9($f57f4b701aa7b66e$export$8a83211c878a3f1f($32834c6d75ca0cb1$var$elem)(ss)))(function(v) {
        return "one of " + $32834c6d75ca0cb1$var$show($32834c6d75ca0cb1$var$map($3ee2158c14339cc9$export$439306a4dcaafbb9)(ss));
    });
};
var $32834c6d75ca0cb1$export$a9a18ae5ba42aeab = function(ss) {
    return $11bbe85c947c529d$export$db22ac524b337b7($ca4b6f31ec4b9857$export$ec0bab193bdafe1($f57f4b701aa7b66e$export$8a83211c878a3f1f($32834c6d75ca0cb1$var$elem1)(ss)))(function(v) {
        return "one of " + $32834c6d75ca0cb1$var$show1(ss);
    });
};
var $32834c6d75ca0cb1$export$6558cf8480d84f77 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$537eb6b62c8dbc27))("oct digit");
var $32834c6d75ca0cb1$var$numberRegex = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($8bcde8f642a64c7d$export$51b220bae4359b72)($32834c6d75ca0cb1$var$identity)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$17b0f4d84dbfeedf("[+-]?[0-9]*(\\.[0-9]*)?([eE][+-]?[0-9]*(\\.[0-9]*)?)?")($32834c6d75ca0cb1$var$mempty));
var $32834c6d75ca0cb1$export$98e628dec113755e = /* #__PURE__ */ function() {
    return $32834c6d75ca0cb1$var$alt($11bbe85c947c529d$export$7a5825874deea16a($4fe7b6acfba7f29f$export$e97014618a7eb593)([
        $32834c6d75ca0cb1$var$applySecond($ca4b6f31ec4b9857$export$22b082955e083ec3("Infinity"))($32834c6d75ca0cb1$var$pure($9a14cd925227149d$export$a0978488bc4efbee)),
        $32834c6d75ca0cb1$var$applySecond($ca4b6f31ec4b9857$export$22b082955e083ec3("+Infinity"))($32834c6d75ca0cb1$var$pure($9a14cd925227149d$export$a0978488bc4efbee)),
        $32834c6d75ca0cb1$var$applySecond($ca4b6f31ec4b9857$export$22b082955e083ec3("-Infinity"))($32834c6d75ca0cb1$var$pure(-$9a14cd925227149d$export$a0978488bc4efbee)),
        $32834c6d75ca0cb1$var$applySecond($ca4b6f31ec4b9857$export$22b082955e083ec3("NaN"))($32834c6d75ca0cb1$var$pure($9a14cd925227149d$export$9e06de0973666692)),
        $11bbe85c947c529d$export$6f621483de7c32dc($32834c6d75ca0cb1$var$bind($32834c6d75ca0cb1$var$numberRegex)(function(section) {
            var v = $052de1c85deb22bf$export$3004f64547af360e(section);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected Number");
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $32834c6d75ca0cb1$var$pure(v.value0);
            throw new Error("Failed pattern match at Parsing.String.Basic (line 118, column 9 - line 120, column 27): " + [
                v.constructor.name
            ]);
        }))
    ]))($2b6d012b5a71a466$export$2b62a06a9fee979c("Expected Number"));
}();
var $32834c6d75ca0cb1$export$64af8ff3ab95bbe6 = function(ss) {
    return $11bbe85c947c529d$export$db22ac524b337b7($ca4b6f31ec4b9857$export$566aa36e2fcdcfb9($f57f4b701aa7b66e$export$8a83211c878a3f1f($32834c6d75ca0cb1$var$notElem)(ss)))(function(v) {
        return "none of " + $32834c6d75ca0cb1$var$show($32834c6d75ca0cb1$var$map($3ee2158c14339cc9$export$439306a4dcaafbb9)(ss));
    });
};
var $32834c6d75ca0cb1$export$2a75fb877f753830 = function(ss) {
    return $11bbe85c947c529d$export$db22ac524b337b7($ca4b6f31ec4b9857$export$ec0bab193bdafe1($f57f4b701aa7b66e$export$8a83211c878a3f1f($32834c6d75ca0cb1$var$notElem1)(ss)))(function(v) {
        return "none of " + $32834c6d75ca0cb1$var$show1(ss);
    });
};
var $32834c6d75ca0cb1$export$abae053c7acf36bb = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$612428811da8e7ba))("lowercase letter");
var $32834c6d75ca0cb1$export$30780d0b6b610af8 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$4f1b4fd0a80ed3b5))("letter");
var $32834c6d75ca0cb1$var$intDecimalRegex = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($8bcde8f642a64c7d$export$51b220bae4359b72)($32834c6d75ca0cb1$var$identity)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$17b0f4d84dbfeedf("[+-]?[0-9]+")($32834c6d75ca0cb1$var$mempty));
var $32834c6d75ca0cb1$export$198d5c93fe95ea67 = /* #__PURE__ */ $11bbe85c947c529d$export$6f621483de7c32dc(/* #__PURE__ */ $32834c6d75ca0cb1$var$bind(/* #__PURE__ */ $32834c6d75ca0cb1$var$alt($32834c6d75ca0cb1$var$intDecimalRegex)(/* #__PURE__ */ $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected Int")))(function(section) {
    var v = $8d5664f12212b23e$export$3004f64547af360e(section);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected Int");
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $32834c6d75ca0cb1$var$pure(v.value0);
    throw new Error("Failed pattern match at Parsing.String.Basic (line 140, column 3 - line 142, column 21): " + [
        v.constructor.name
    ]);
}));
var $32834c6d75ca0cb1$export$6cf91e62dabd9493 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$2a81dc4d1a2f9334))("hex digit");
var $32834c6d75ca0cb1$export$8a40e5669d3698bc = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$e03c54e9ed5bdad0))("digit");
var $32834c6d75ca0cb1$export$2f9d0d831d496619 = /* #__PURE__ */ $11bbe85c947c529d$export$49261000d13ed9a7(/* #__PURE__ */ $32834c6d75ca0cb1$var$satisfyCP($ae1fc60b21f03c62$export$bbe6438367709b6a))("letter or digit");


var $65049bb6418b06dc$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $65049bb6418b06dc$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($2b6d012b5a71a466$export$728b06f25edead82);
var $65049bb6418b06dc$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $65049bb6418b06dc$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $65049bb6418b06dc$var$unsafeFromString = /* #__PURE__ */ $5505a3400147efbd$export$6c65599023ae894b();
var $65049bb6418b06dc$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $65049bb6418b06dc$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $65049bb6418b06dc$var$joinWith = /* #__PURE__ */ $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075);
var $65049bb6418b06dc$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $65049bb6418b06dc$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $65049bb6418b06dc$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $65049bb6418b06dc$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($5505a3400147efbd$export$d35c69c74cf52f2a);
var $65049bb6418b06dc$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $65049bb6418b06dc$export$8ebdfbdc4622b672 = function(x) {
    return x;
};
var $65049bb6418b06dc$export$26b0cb12afaf64f7 = function(dictMonad) {
    return function(parseA) {
        return function(p) {
            return $65049bb6418b06dc$var$bind($2b6d012b5a71a466$export$99cb5271137cc3e6)(function(v) {
                return $65049bb6418b06dc$var$bind(p)(function(a) {
                    var v1 = parseA(a);
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $65049bb6418b06dc$var$throwError(new $2b6d012b5a71a466$export$f9c837a54db411d(v1.value0, v.value1));
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $65049bb6418b06dc$var$pure(v1.value0);
                    throw new Error("Failed pattern match at URI.Common (line 58, column 3 - line 60, column 22): " + [
                        v1.constructor.name
                    ]);
                });
            });
        };
    };
};
var $65049bb6418b06dc$export$a0a602ac6ffe7549 = /* #__PURE__ */ $32834c6d75ca0cb1$export$a9a18ae5ba42aeab([
    "!",
    "$",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ";",
    "=",
    ","
]);
var $65049bb6418b06dc$export$cced2b75a857d31f = function(p) {
    return function(s) {
        var simpleChar = $65049bb6418b06dc$var$map($be985434983c0a5f$export$439306a4dcaafbb9)(p);
        var handleURIEncodingResult = function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $65049bb6418b06dc$var$throwError(new $2b6d012b5a71a466$export$f9c837a54db411d("Could not URI encode", $2b6d012b5a71a466$export$3b2cd57af4544298));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $65049bb6418b06dc$var$pure($65049bb6418b06dc$var$unsafeFromString(v.value0));
            throw new Error("Failed pattern match at URI.Common (line 105, column 3 - line 105, column 74): " + [
                v.constructor.name
            ]);
        };
        var encodedChar = $65049bb6418b06dc$var$bindFlipped(handleURIEncodingResult)($65049bb6418b06dc$var$map(function($42) {
            return $f9a555fb76059872$export$ab54ccbe87d5558($092fe44bc0883be6$export$439306a4dcaafbb9($42));
        })($ca4b6f31ec4b9857$export$3df35137cff8cab7));
        var parse = $65049bb6418b06dc$var$applyFirst($65049bb6418b06dc$var$map($65049bb6418b06dc$var$joinWith(""))($65049bb6418b06dc$var$manyRec($65049bb6418b06dc$var$alt(simpleChar)(encodedChar))))($ca4b6f31ec4b9857$export$d83becf4b42ec59);
        return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(s))($65049bb6418b06dc$var$identity)($2b6d012b5a71a466$export$4ad9239eebc1597f(s)(parse));
    };
};
var $65049bb6418b06dc$export$256236776516d24 = function(p) {
    var $44 = $65049bb6418b06dc$export$cced2b75a857d31f(p);
    return function($45) {
        return $65049bb6418b06dc$var$unsafeFromString($44($5505a3400147efbd$export$f84e8e69fd4488a5($45)));
    };
};
var $65049bb6418b06dc$export$212cc4c54b7f9d4d = /* #__PURE__ */ $65049bb6418b06dc$var$bind(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("%"))(function(d0) {
    return $65049bb6418b06dc$var$bind($32834c6d75ca0cb1$export$6cf91e62dabd9493)(function(d1) {
        return $65049bb6418b06dc$var$bind($32834c6d75ca0cb1$export$6cf91e62dabd9493)(function(d2) {
            return $65049bb6418b06dc$var$pure($65049bb6418b06dc$var$append($be985434983c0a5f$export$439306a4dcaafbb9(d0))($65049bb6418b06dc$var$append($be985434983c0a5f$export$439306a4dcaafbb9(d1))($be985434983c0a5f$export$439306a4dcaafbb9(d2))));
        });
    });
});
var $65049bb6418b06dc$export$6f46242832a766b0 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $65049bb6418b06dc$export$fa3a3bb2e2737ab7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $65049bb6418b06dc$export$f49419f754972f29 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $65049bb6418b06dc$export$7d8885b8a3ad5bfd = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($65049bb6418b06dc$export$f49419f754972f29)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($2c6b3d51d10471a7$export$e4b6cd05df3043f6))({
        reflectSymbol: function() {
            return "URIPartParseError";
        }
    }))
};
var $65049bb6418b06dc$export$99cb8b90c04fcd3f = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $65049bb6418b06dc$export$68410c2af0b88c0 = function($48) {
    return $65049bb6418b06dc$var$unsafeFromString($65049bb6418b06dc$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619($5505a3400147efbd$export$f84e8e69fd4488a5($48))));
};
var $65049bb6418b06dc$export$58f0f39f63f3cf42 = /* #__PURE__ */ $ca4b6f31ec4b9857$export$ec0bab193bdafe1(function(c) {
    return c >= "a" && c <= "z" || c >= "A" && c <= "Z";
});
var $65049bb6418b06dc$export$2f9d0d831d496619 = /* #__PURE__ */ $65049bb6418b06dc$var$alt($65049bb6418b06dc$export$58f0f39f63f3cf42)($32834c6d75ca0cb1$export$8a40e5669d3698bc);
var $65049bb6418b06dc$export$723eaa54d8971962 = /* #__PURE__ */ $65049bb6418b06dc$var$alt($65049bb6418b06dc$export$2f9d0d831d496619)(/* #__PURE__ */ $65049bb6418b06dc$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("-"))(/* #__PURE__ */ $65049bb6418b06dc$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("."))(/* #__PURE__ */ $65049bb6418b06dc$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("_"))(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("~")))));


// Generated by purs version 0.15.15















// Generated by purs version 0.15.15















// Generated by purs version 0.15.15




// Generated by purs version 0.15.15















var $9e314cb25c39ecff$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $9e314cb25c39ecff$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($06733ae99ed4f534$export$92d23d3d8fa78a80);
var $9e314cb25c39ecff$export$c6018b43dc90bc4b = function(l) {
    return function(f) {
        var v = l(new $f9bc92cc92266955$export$3db8c5834c5aa726($9e314cb25c39ecff$var$identity, $7d4cccdf062a2261$export$19db0165690c701a.create));
        return f(v.value0)(v.value1);
    };
};
var $9e314cb25c39ecff$export$95794f71fd1fcea8 = /* #__PURE__ */ $4fa4836228a192cc$export$3b98aa7d576b2b80()()($333e6139bd8d8d5d$export$b40ff0778ec92ebb);
var $9e314cb25c39ecff$export$e469dcfea9910464 = function(to) {
    return function(fro) {
        return function(dictChoice) {
            var Profunctor0 = dictChoice.Profunctor0();
            var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(Profunctor0);
            var right = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
            var rmap = $9be1c75e3223ee2e$export$6630987c9d273301(Profunctor0);
            return function(pab) {
                return dimap(fro)($7d4cccdf062a2261$export$5f5be1bb6cd1fded($9e314cb25c39ecff$var$identity)($9e314cb25c39ecff$var$identity))(right(rmap(to)(pab)));
            };
        };
    };
};
var $9e314cb25c39ecff$export$312354c024d04a0e = function(to) {
    return function(fro) {
        return function(dictChoice) {
            return $9e314cb25c39ecff$export$e469dcfea9910464(to)(function(s) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(s))($7d4cccdf062a2261$export$19db0165690c701a.create)(fro(s));
            })(dictChoice);
        };
    };
};
var $9e314cb25c39ecff$export$1ddd0ba470ef2478 = function(x) {
    return function(f) {
        return function(dictChoice) {
            return $9e314cb25c39ecff$export$312354c024d04a0e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x))(function($38) {
                return $9e314cb25c39ecff$var$guard(f($38));
            })(dictChoice);
        };
    };
};
var $9e314cb25c39ecff$export$fe98000b1ab912f3 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(dictChoice) {
            return $9e314cb25c39ecff$export$1ddd0ba470ef2478(x)(function(v) {
                return eq(v)(x);
            })(dictChoice);
        };
    };
};
var $9e314cb25c39ecff$export$ba4f22f061f42309 = function(l) {
    return $9e314cb25c39ecff$export$c6018b43dc90bc4b(l)(function(v) {
        return function(f) {
            return f;
        };
    });
};
var $9e314cb25c39ecff$export$226b3eccf92c9ed9 = function(dictHeytingAlgebra) {
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    return function(l) {
        var $39 = $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(ff))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(tt));
        var $40 = $9e314cb25c39ecff$export$ba4f22f061f42309(l);
        return function($41) {
            return $39($40($41));
        };
    };
};
var $9e314cb25c39ecff$export$fc4f6349419be15f = function(dictHeytingAlgebra) {
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    var is1 = $9e314cb25c39ecff$export$226b3eccf92c9ed9(dictHeytingAlgebra);
    return function(l) {
        var $42 = is1(l);
        return function($43) {
            return not($42($43));
        };
    };
};
var $9e314cb25c39ecff$export$d37dd3217d26f03c = function(l) {
    return function(dictChoice) {
        return $9e314cb25c39ecff$export$c6018b43dc90bc4b(l)(function(x) {
            return function(y) {
                return function(p) {
                    return $9e314cb25c39ecff$export$e469dcfea9910464(x)(y)(dictChoice)(p);
                };
            };
        });
    };
};
var $9e314cb25c39ecff$export$c6ccdd35ddcb5cc8 = function(dictTraversable) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable.Functor0());
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
    return function(k) {
        return function(dictChoice) {
            return $9e314cb25c39ecff$export$c6018b43dc90bc4b(k)(function(bt) {
                return function(seta) {
                    return $9e314cb25c39ecff$export$e469dcfea9910464(map(bt))(function(s) {
                        var v = traverse(seta)(s);
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(s);
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
                        throw new Error("Failed pattern match at Data.Lens.Prism (line 199, column 7 - line 201, column 27): " + [
                            v.constructor.name
                        ]);
                    })(dictChoice);
                };
            });
        };
    };
};








// Generated by purs version 0.15.15




















var $ba204c36e9a0fee4$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ba204c36e9a0fee4$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $ba204c36e9a0fee4$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($2b6d012b5a71a466$export$8808000bb50bc47);
var $ba204c36e9a0fee4$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $ba204c36e9a0fee4$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $ba204c36e9a0fee4$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $ba204c36e9a0fee4$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $ba204c36e9a0fee4$var$apply1 = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $ba204c36e9a0fee4$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ba204c36e9a0fee4$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $ba204c36e9a0fee4$var$IPv4Address = /* #__PURE__ */ function() {
    function IPv4Address(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    IPv4Address.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new IPv4Address(value0, value1, value2, value3);
                };
            };
        };
    };
    return IPv4Address;
}();
var $ba204c36e9a0fee4$var$toInt = function(s) {
    var v = $8d5664f12212b23e$export$3004f64547af360e(s);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 >= 0 && v.value0 <= 255) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Invalid IPv4 address octet");
};
var $ba204c36e9a0fee4$export$51fa635f6a7fbd47 = {
    show: function(v) {
        return "(IPv4Address.unsafeFromInts " + ($ba204c36e9a0fee4$var$show(v.value0) + (" " + ($ba204c36e9a0fee4$var$show(v.value1) + (" " + ($ba204c36e9a0fee4$var$show(v.value2) + (" " + ($ba204c36e9a0fee4$var$show(v.value3) + ")")))))));
    }
};
var $ba204c36e9a0fee4$export$c2d084dc44961371 = function(v) {
    return $ba204c36e9a0fee4$var$show(v.value0) + ("." + ($ba204c36e9a0fee4$var$show(v.value1) + ("." + ($ba204c36e9a0fee4$var$show(v.value2) + ("." + $ba204c36e9a0fee4$var$show(v.value3))))));
};
var $ba204c36e9a0fee4$var$nzDigit = /* #__PURE__ */ $ca4b6f31ec4b9857$export$ec0bab193bdafe1(function(c) {
    return c >= "1" && c <= "9";
});
var $ba204c36e9a0fee4$var$octet = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)($ba204c36e9a0fee4$var$toInt)(/* #__PURE__ */ $ba204c36e9a0fee4$var$alt(/* #__PURE__ */ $11bbe85c947c529d$export$410a452afcd48948(/* #__PURE__ */ $ba204c36e9a0fee4$var$apply(/* #__PURE__ */ $ba204c36e9a0fee4$var$apply(/* #__PURE__ */ $ba204c36e9a0fee4$var$map(function(x) {
    return function(y) {
        return function(z) {
            return $092fe44bc0883be6$export$709e3b51bf2e2249([
                x,
                y,
                z
            ]);
        };
    };
})($ba204c36e9a0fee4$var$nzDigit))($32834c6d75ca0cb1$export$8a40e5669d3698bc))($32834c6d75ca0cb1$export$8a40e5669d3698bc)))(/* #__PURE__ */ $ba204c36e9a0fee4$var$alt(/* #__PURE__ */ $11bbe85c947c529d$export$410a452afcd48948(/* #__PURE__ */ $ba204c36e9a0fee4$var$apply(/* #__PURE__ */ $ba204c36e9a0fee4$var$map(function(x) {
    return function(y) {
        return $092fe44bc0883be6$export$709e3b51bf2e2249([
            x,
            y
        ]);
    };
})($ba204c36e9a0fee4$var$nzDigit))($32834c6d75ca0cb1$export$8a40e5669d3698bc)))(/* #__PURE__ */ $ba204c36e9a0fee4$var$map($092fe44bc0883be6$export$439306a4dcaafbb9)($32834c6d75ca0cb1$export$8a40e5669d3698bc))));
var $ba204c36e9a0fee4$export$8f49e4af10703ce3 = /* #__PURE__ */ $ba204c36e9a0fee4$var$bind(/* #__PURE__ */ $ba204c36e9a0fee4$var$applyFirst($ba204c36e9a0fee4$var$octet)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(".")))(function(o1) {
    return $ba204c36e9a0fee4$var$bind($ba204c36e9a0fee4$var$applyFirst($ba204c36e9a0fee4$var$octet)($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(".")))(function(o2) {
        return $ba204c36e9a0fee4$var$bind($ba204c36e9a0fee4$var$applyFirst($ba204c36e9a0fee4$var$octet)($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(".")))(function(o3) {
            return $ba204c36e9a0fee4$var$bind($ba204c36e9a0fee4$var$octet)(function(o4) {
                return $ba204c36e9a0fee4$var$pure(new $ba204c36e9a0fee4$var$IPv4Address(o1, o2, o3, o4));
            });
        });
    });
});
var $ba204c36e9a0fee4$export$6f511d4f8a01d621 = function(o1) {
    return function(o2) {
        return function(o3) {
            return function(o4) {
                var check = function(i) {
                    if (i >= 0 && i <= 255) return new $06733ae99ed4f534$export$8a67b48435b5d073(i);
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at URI.Host.IPv4Address (line 38, column 3 - line 38, column 28): " + [
                        i.constructor.name
                    ]);
                };
                return $ba204c36e9a0fee4$var$apply1($ba204c36e9a0fee4$var$apply1($ba204c36e9a0fee4$var$apply1($ba204c36e9a0fee4$var$map1($ba204c36e9a0fee4$var$IPv4Address.create)(check(o1)))(check(o2)))(check(o3)))(check(o4));
            };
        };
    };
};
var $ba204c36e9a0fee4$export$3b19ea5ae48c0a1c = function(o1) {
    return function(o2) {
        return function(o3) {
            return function(o4) {
                var v = $ba204c36e9a0fee4$export$6f511d4f8a01d621(o1)(o2)(o3)(o4);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8bcde8f642a64c7d$export$51b220bae4359b72("IPv4Address octet was out of range");
                throw new Error("Failed pattern match at URI.Host.IPv4Address (line 51, column 3 - line 53, column 68): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $ba204c36e9a0fee4$export$d6d82787ded81f3d = {
    eq: function(x) {
        return function(y) {
            return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2 && x.value3 === y.value3;
        };
    }
};
var $ba204c36e9a0fee4$export$c2c0697cfe881ae6 = {
    compare: function(x) {
        return function(y) {
            var v = $ba204c36e9a0fee4$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v1 = $ba204c36e9a0fee4$var$compare(x.value1)(y.value1);
            if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v2 = $ba204c36e9a0fee4$var$compare(x.value2)(y.value2);
            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $ba204c36e9a0fee4$var$compare(x.value3)(y.value3);
        };
    },
    Eq0: function() {
        return $ba204c36e9a0fee4$export$d6d82787ded81f3d;
    }
};


// Generated by purs version 0.15.15














var $1df86747ed1111fe$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $1df86747ed1111fe$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $1df86747ed1111fe$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $1df86747ed1111fe$var$IPv6Address = function(x) {
    return x;
};
var $1df86747ed1111fe$export$46c39d7334f59785 = function(v) {
    return "[" + (v + "]");
};
var $1df86747ed1111fe$export$6c65599023ae894b = $1df86747ed1111fe$var$IPv6Address;
var $1df86747ed1111fe$export$759e84da42e82963 = {
    show: function(v) {
        return "(IPv6Address.unsafeFromString " + ($1df86747ed1111fe$var$show(v) + ")");
    }
};
var $1df86747ed1111fe$export$8f49e4af10703ce3 = /* #__PURE__ */ function() {
    var ipv6Char = $1df86747ed1111fe$var$alt($32834c6d75ca0cb1$export$6cf91e62dabd9493)($1df86747ed1111fe$var$alt($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(".")));
    return $11bbe85c947c529d$export$49261000d13ed9a7($1df86747ed1111fe$var$map($1df86747ed1111fe$var$IPv6Address)($7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47)($7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47)($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("["))($1df86747ed1111fe$var$map($5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075)(""))($3d4fd987da5242ff$export$934820ddadec516f($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3)($1df86747ed1111fe$var$map($be985434983c0a5f$export$439306a4dcaafbb9)(ipv6Char)))))($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("]"))))("IPv6 address");
}();
var $1df86747ed1111fe$export$6410c19ffbd21559 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $1df86747ed1111fe$export$bf39e606dcad40a0 = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15









var $065990febae20ab8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $065990febae20ab8$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $065990febae20ab8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $065990febae20ab8$var$RegName = function(x) {
    return x;
};
var $065990febae20ab8$export$46c39d7334f59785 = function(v) {
    return v;
};
var $065990febae20ab8$export$6c65599023ae894b = $065990febae20ab8$var$RegName;
var $065990febae20ab8$export$f84e8e69fd4488a5 = function(v) {
    return $65049bb6418b06dc$export$68410c2af0b88c0(v);
};
var $065990febae20ab8$export$4f21dea5c38fd1df = {
    show: function(v) {
        return "(RegName.unsafeFromString " + ($065990febae20ab8$var$show(v) + ")");
    }
};
var $065990febae20ab8$export$9ca189132150f36a = $5505a3400147efbd$export$d35c69c74cf52f2a;
var $065990febae20ab8$export$fd2b5a378c38cbdd = /* #__PURE__ */ $065990febae20ab8$var$alt($65049bb6418b06dc$export$723eaa54d8971962)($65049bb6418b06dc$export$a0a602ac6ffe7549);
var $065990febae20ab8$export$c2d084dc44961371 = function($14) {
    return $5505a3400147efbd$export$f84e8e69fd4488a5($065990febae20ab8$export$46c39d7334f59785($14));
};
var $065990febae20ab8$export$8f49e4af10703ce3 = /* #__PURE__ */ function() {
    var p = $065990febae20ab8$var$alt($65049bb6418b06dc$export$212cc4c54b7f9d4d)($065990febae20ab8$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($065990febae20ab8$export$fd2b5a378c38cbdd));
    return $065990febae20ab8$var$map(function() {
        var $15 = $5505a3400147efbd$export$f542ede54c0f0952($91ee3359f6bcea22$export$33591d20dac5147e)("");
        return function($16) {
            return $065990febae20ab8$var$RegName($15($16));
        };
    }())($e39dfcf102cdca3c$export$ad14ef4001db2bcd($2b6d012b5a71a466$export$5220689f708908c3)($2b6d012b5a71a466$export$e21af47273e843bd)(p));
}();
var $065990febae20ab8$export$7cf84fca18c9cdbf = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $065990febae20ab8$export$3004f64547af360e = /* #__PURE__ */ function() {
    var $17 = $65049bb6418b06dc$export$256236776516d24($065990febae20ab8$export$fd2b5a378c38cbdd);
    return function($18) {
        return $065990febae20ab8$var$RegName($17($18));
    };
}();
var $065990febae20ab8$export$b2a2871ecca7ce21 = $5505a3400147efbd$export$5982362881026796;


var $39cc522fd39c4f12$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $39cc522fd39c4f12$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $39cc522fd39c4f12$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($1df86747ed1111fe$export$bf39e606dcad40a0);
var $39cc522fd39c4f12$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($ba204c36e9a0fee4$export$d6d82787ded81f3d);
var $39cc522fd39c4f12$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($065990febae20ab8$export$b2a2871ecca7ce21);
var $39cc522fd39c4f12$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($1df86747ed1111fe$export$6410c19ffbd21559);
var $39cc522fd39c4f12$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($ba204c36e9a0fee4$export$c2c0697cfe881ae6);
var $39cc522fd39c4f12$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($065990febae20ab8$export$7cf84fca18c9cdbf);
var $39cc522fd39c4f12$export$6ec383f12dda5af6 = /* #__PURE__ */ function() {
    function IPv6Address(value0) {
        this.value0 = value0;
    }
    IPv6Address.create = function(value0) {
        return new IPv6Address(value0);
    };
    return IPv6Address;
}();
var $39cc522fd39c4f12$export$1a7875a3abe4aee7 = /* #__PURE__ */ function() {
    function IPv4Address(value0) {
        this.value0 = value0;
    }
    IPv4Address.create = function(value0) {
        return new IPv4Address(value0);
    };
    return IPv4Address;
}();
var $39cc522fd39c4f12$export$ca531fcbac3bd92f = /* #__PURE__ */ function() {
    function NameAddress(value0) {
        this.value0 = value0;
    }
    NameAddress.create = function(value0) {
        return new NameAddress(value0);
    };
    return NameAddress;
}();
var $39cc522fd39c4f12$export$c2d084dc44961371 = function(v) {
    if (v instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return $1df86747ed1111fe$export$46c39d7334f59785(v.value0);
    if (v instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return $ba204c36e9a0fee4$export$c2d084dc44961371(v.value0);
    if (v instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f) return $065990febae20ab8$export$c2d084dc44961371(v.value0);
    throw new Error("Failed pattern match at URI.Host (line 50, column 9 - line 53, column 41): " + [
        v.constructor.name
    ]);
};
var $39cc522fd39c4f12$export$8f49e4af10703ce3 = /* #__PURE__ */ function() {
    return $39cc522fd39c4f12$var$alt($39cc522fd39c4f12$var$map($39cc522fd39c4f12$export$6ec383f12dda5af6.create)($1df86747ed1111fe$export$8f49e4af10703ce3))($39cc522fd39c4f12$var$alt($11bbe85c947c529d$export$410a452afcd48948($39cc522fd39c4f12$var$map($39cc522fd39c4f12$export$1a7875a3abe4aee7.create)($ba204c36e9a0fee4$export$8f49e4af10703ce3)))($39cc522fd39c4f12$var$map($39cc522fd39c4f12$export$ca531fcbac3bd92f.create)($065990febae20ab8$export$8f49e4af10703ce3)));
}();
var $39cc522fd39c4f12$export$f9fc6100084c99bf = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $39cc522fd39c4f12$export$6ec383f12dda5af6(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $39cc522fd39c4f12$export$1a7875a3abe4aee7(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $39cc522fd39c4f12$export$ca531fcbac3bd92f(x.value0.value0);
        throw new Error("Failed pattern match at URI.Host (line 37, column 1 - line 37, column 46): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0));
        throw new Error("Failed pattern match at URI.Host (line 37, column 1 - line 37, column 46): " + [
            x.constructor.name
        ]);
    }
};
var $39cc522fd39c4f12$export$d1990f64a358c2bf = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($39cc522fd39c4f12$export$f9fc6100084c99bf)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($1df86747ed1111fe$export$759e84da42e82963))({
        reflectSymbol: function() {
            return "IPv6Address";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($ba204c36e9a0fee4$export$51fa635f6a7fbd47))({
        reflectSymbol: function() {
            return "IPv4Address";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($065990febae20ab8$export$4f21dea5c38fd1df))({
        reflectSymbol: function() {
            return "NameAddress";
        }
    }))))
};
var $39cc522fd39c4f12$export$78d798b24b7b0fe4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6 && y instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return $39cc522fd39c4f12$var$eq(x.value0)(y.value0);
            if (x instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7 && y instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return $39cc522fd39c4f12$var$eq1(x.value0)(y.value0);
            if (x instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f && y instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f) return $39cc522fd39c4f12$var$eq2(x.value0)(y.value0);
            return false;
        };
    }
};
var $39cc522fd39c4f12$export$cd969b2b7da24e75 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6 && y instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return $39cc522fd39c4f12$var$compare(x.value0)(y.value0);
            if (x instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7 && y instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return $39cc522fd39c4f12$var$compare1(x.value0)(y.value0);
            if (x instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f && y instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f) return $39cc522fd39c4f12$var$compare2(x.value0)(y.value0);
            throw new Error("Failed pattern match at URI.Host (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $39cc522fd39c4f12$export$78d798b24b7b0fe4;
    }
};
var $39cc522fd39c4f12$export$24c258bf5a5c2441 = function(dictChoice) {
    return $9e314cb25c39ecff$export$312354c024d04a0e($39cc522fd39c4f12$export$ca531fcbac3bd92f.create)(function(v) {
        if (v instanceof $39cc522fd39c4f12$export$ca531fcbac3bd92f) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    })(dictChoice);
};
var $39cc522fd39c4f12$export$63e93b41dc2994d0 = function(dictChoice) {
    return $9e314cb25c39ecff$export$312354c024d04a0e($39cc522fd39c4f12$export$6ec383f12dda5af6.create)(function(v) {
        if (v instanceof $39cc522fd39c4f12$export$6ec383f12dda5af6) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    })(dictChoice);
};
var $39cc522fd39c4f12$export$fdad065cc65380d5 = function(dictChoice) {
    return $9e314cb25c39ecff$export$312354c024d04a0e($39cc522fd39c4f12$export$1a7875a3abe4aee7.create)(function(v) {
        if (v instanceof $39cc522fd39c4f12$export$1a7875a3abe4aee7) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    })(dictChoice);
};


// Generated by purs version 0.15.15


















var $a56d5e8d101df263$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $a56d5e8d101df263$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $a56d5e8d101df263$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $a56d5e8d101df263$var$Port = function(x) {
    return x;
};
var $a56d5e8d101df263$export$e7a1baa2fae31f0f = function(v) {
    return v;
};
var $a56d5e8d101df263$export$7e850863bd67159f = {
    show: function(v) {
        return "(Port.unsafeFromInt " + ($a56d5e8d101df263$var$show(v) + ")");
    }
};
var $a56d5e8d101df263$export$c2d084dc44961371 = function(v) {
    return ":" + $a56d5e8d101df263$var$show(v);
};
var $a56d5e8d101df263$export$8f49e4af10703ce3 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6)(/* #__PURE__ */ $a56d5e8d101df263$var$map(/* #__PURE__ */ $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075)(""))(/* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))(/* #__PURE__ */ $3d4fd987da5242ff$export$934820ddadec516f($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3)(/* #__PURE__ */ $a56d5e8d101df263$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($32834c6d75ca0cb1$export$8a40e5669d3698bc)))))(function(s) {
    var v = $8d5664f12212b23e$export$d7a050b0311540b9($8d5664f12212b23e$export$78a48a3d1e5dbe89)(s);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $a56d5e8d101df263$var$pure(v.value0);
    return $2b6d012b5a71a466$export$2b62a06a9fee979c("Expected a valid port number");
});
var $a56d5e8d101df263$export$dfaa82d206179b93 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $a56d5e8d101df263$export$62ffe363f1b08494 = function(i) {
    if (i >= 0 && i <= 65535) return new $06733ae99ed4f534$export$8a67b48435b5d073(i);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at URI.Port (line 37, column 1 - line 37, column 29): " + [
        i.constructor.name
    ]);
};
var $a56d5e8d101df263$export$86cfc0e38580aa9a = function(i) {
    var v = $a56d5e8d101df263$export$62ffe363f1b08494(i);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8bcde8f642a64c7d$export$51b220bae4359b72("Port value " + ($a56d5e8d101df263$var$show(i) + " is out of range"));
    throw new Error("Failed pattern match at URI.Port (line 49, column 3 - line 51, column 79): " + [
        v.constructor.name
    ]);
};
var $a56d5e8d101df263$export$55183a1ea5cf7649 = $37b880af5f4991bd$export$e65788c6d4494539;


// Generated by purs version 0.15.15










var $5881ee4120bfebb5$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $5881ee4120bfebb5$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $5881ee4120bfebb5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $5881ee4120bfebb5$var$UserInfo = function(x) {
    return x;
};
var $5881ee4120bfebb5$export$52228096379ed3a7 = /* #__PURE__ */ $5881ee4120bfebb5$var$alt($65049bb6418b06dc$export$723eaa54d8971962)(/* #__PURE__ */ $5881ee4120bfebb5$var$alt($65049bb6418b06dc$export$a0a602ac6ffe7549)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":")));
var $5881ee4120bfebb5$export$46c39d7334f59785 = function(v) {
    return v;
};
var $5881ee4120bfebb5$export$6c65599023ae894b = $5881ee4120bfebb5$var$UserInfo;
var $5881ee4120bfebb5$export$f84e8e69fd4488a5 = function(v) {
    return $65049bb6418b06dc$export$68410c2af0b88c0(v);
};
var $5881ee4120bfebb5$export$e31bbce436393609 = {
    show: function(v) {
        return "(UserInfo.unsafeFromString " + ($5881ee4120bfebb5$var$show(v) + ")");
    }
};
var $5881ee4120bfebb5$export$aac32cdc9a200ea8 = $5505a3400147efbd$export$d35c69c74cf52f2a;
var $5881ee4120bfebb5$export$c2d084dc44961371 = function($14) {
    return $5505a3400147efbd$export$f84e8e69fd4488a5($5881ee4120bfebb5$export$46c39d7334f59785($14));
};
var $5881ee4120bfebb5$export$8f49e4af10703ce3 = /* #__PURE__ */ function() {
    var parse = $5881ee4120bfebb5$var$alt($5881ee4120bfebb5$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($5881ee4120bfebb5$export$52228096379ed3a7))($65049bb6418b06dc$export$212cc4c54b7f9d4d);
    return $5881ee4120bfebb5$var$map(function() {
        var $15 = $5505a3400147efbd$export$f542ede54c0f0952($91ee3359f6bcea22$export$33591d20dac5147e)("");
        return function($16) {
            return $5881ee4120bfebb5$var$UserInfo($15($16));
        };
    }())($e39dfcf102cdca3c$export$ad14ef4001db2bcd($2b6d012b5a71a466$export$5220689f708908c3)($2b6d012b5a71a466$export$e21af47273e843bd)(parse));
}();
var $5881ee4120bfebb5$export$6eff4a84271d68ef = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $5881ee4120bfebb5$export$3004f64547af360e = /* #__PURE__ */ function() {
    var $17 = $65049bb6418b06dc$export$256236776516d24($5881ee4120bfebb5$export$52228096379ed3a7);
    return function($18) {
        return $5881ee4120bfebb5$var$UserInfo($17($18));
    };
}();
var $5881ee4120bfebb5$export$335cba34d1460647 = $5505a3400147efbd$export$5982362881026796;


var $e958b450d709607c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $e958b450d709607c$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $e958b450d709607c$var$wrapParser = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $e958b450d709607c$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $e958b450d709607c$var$AuthorityIsSymbol = {
    reflectSymbol: function() {
        return "Authority";
    }
};
var $e958b450d709607c$export$f1c6ec2e6d68c49c = /* #__PURE__ */ function() {
    function Authority(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Authority.create = function(value0) {
        return function(value1) {
            return new Authority(value0, value1);
        };
    };
    return Authority;
}();
var $e958b450d709607c$export$c2d084dc44961371 = function(opts) {
    return function(v) {
        if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "//" + ($5881ee4120bfebb5$export$c2d084dc44961371(opts.printUserInfo(v.value0.value0)) + ("@" + opts.printHosts(v.value1)));
        if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "//" + opts.printHosts(v.value1);
        throw new Error("Failed pattern match at URI.Authority (line 90, column 33 - line 92, column 40): " + [
            v.value0.constructor.name
        ]);
    };
};
var $e958b450d709607c$export$8f49e4af10703ce3 = function(opts) {
    return $e958b450d709607c$var$bind($ca4b6f31ec4b9857$export$22b082955e083ec3("//"))(function() {
        return $e958b450d709607c$var$bind($11bbe85c947c529d$export$b9803a97967f594($11bbe85c947c529d$export$410a452afcd48948($e958b450d709607c$var$applyFirst($e958b450d709607c$var$wrapParser(opts.parseUserInfo)($5881ee4120bfebb5$export$8f49e4af10703ce3))($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("@")))))(function(ui) {
            return $e958b450d709607c$var$bind(opts.parseHosts)(function(hosts) {
                return $e958b450d709607c$var$pure(new $e958b450d709607c$export$f1c6ec2e6d68c49c(ui, hosts));
            });
        });
    });
};
var $e958b450d709607c$export$5a5d545152d48110 = {
    to: function(x) {
        return new $e958b450d709607c$export$f1c6ec2e6d68c49c(x.value0, x.value1);
    },
    from: function(x) {
        return new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1);
    }
};
var $e958b450d709607c$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($e958b450d709607c$export$5a5d545152d48110);
var $e958b450d709607c$export$acb1cb62298cb1de = function(dictShow) {
    var genericShowArgsProduct = $544b62a378cc0091$export$b8b972500eedbc74($544b62a378cc0091$export$bc1180ef96fcb658($06733ae99ed4f534$export$9b814e760fdd264a(dictShow)));
    return function(dictShow1) {
        return {
            show: $e958b450d709607c$var$genericShow($544b62a378cc0091$export$186afff91b813845(genericShowArgsProduct($544b62a378cc0091$export$bc1180ef96fcb658(dictShow1)))($e958b450d709607c$var$AuthorityIsSymbol))
        };
    };
};
var $e958b450d709607c$export$8ac072b352363b0 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq));
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $e958b450d709607c$export$16b5b8c277f87a2e = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd));
    var eqAuthority1 = $e958b450d709607c$export$8ac072b352363b0(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqAuthority2 = eqAuthority1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqAuthority2;
            }
        };
    };
};
var $e958b450d709607c$export$f95bc15db7d4c68c = function(dictStrong) {
    return $03856732e0180b78$export$21cde5187c2605a3(function(v) {
        return v.value0;
    })(function(v) {
        return function(ui) {
            return new $e958b450d709607c$export$f1c6ec2e6d68c49c(ui, v.value1);
        };
    })(dictStrong);
};
var $e958b450d709607c$export$bb32aa5a593876fa = function(dictStrong) {
    return $03856732e0180b78$export$21cde5187c2605a3(function(v) {
        return v.value1;
    })(function(v) {
        return function(hs) {
            return new $e958b450d709607c$export$f1c6ec2e6d68c49c(v.value0, hs);
        };
    })(dictStrong);
};



// Generated by purs version 0.15.15















// Generated by purs version 0.15.15
















var $18aa4e196c556c9e$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $18aa4e196c556c9e$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $18aa4e196c556c9e$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $18aa4e196c556c9e$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $18aa4e196c556c9e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $18aa4e196c556c9e$var$join1With = /* #__PURE__ */ $5505a3400147efbd$export$f542ede54c0f0952($91ee3359f6bcea22$export$33591d20dac5147e);
var $18aa4e196c556c9e$var$some = /* #__PURE__ */ $e39dfcf102cdca3c$export$ad14ef4001db2bcd($2b6d012b5a71a466$export$5220689f708908c3)($2b6d012b5a71a466$export$e21af47273e843bd);
var $18aa4e196c556c9e$var$PathSegmentNZNC = function(x) {
    return x;
};
var $18aa4e196c556c9e$var$PathSegmentNZ = function(x) {
    return x;
};
var $18aa4e196c556c9e$var$PathSegment = function(x) {
    return x;
};
var $18aa4e196c556c9e$export$fe8dceefe7377757 = function(v) {
    return v;
};
var $18aa4e196c556c9e$export$fb552b7e9cd682f0 = function(v) {
    return v;
};
var $18aa4e196c556c9e$export$4346850e4a475898 = function(v) {
    return v;
};
var $18aa4e196c556c9e$export$6125778f0d9e8c5b = $18aa4e196c556c9e$var$PathSegmentNZNC;
var $18aa4e196c556c9e$export$2e560e33b0b28342 = $18aa4e196c556c9e$var$PathSegmentNZ;
var $18aa4e196c556c9e$export$24c95d6d78e2df4f = $18aa4e196c556c9e$var$PathSegment;
var $18aa4e196c556c9e$export$b36e50677793bf82 = {
    show: function(v) {
        return "(Segment.unsafeSegmentNZNCToString " + ($18aa4e196c556c9e$var$show(v) + ")");
    }
};
var $18aa4e196c556c9e$export$1737cbd6ddd476e0 = {
    show: function(v) {
        return "(Segment.unsafeSegmentNZFromString " + ($18aa4e196c556c9e$var$show(v) + ")");
    }
};
var $18aa4e196c556c9e$export$74eeba61cd416584 = {
    show: function(v) {
        return "(Segment.unsafeSegmentToString " + ($18aa4e196c556c9e$var$show1(v) + ")");
    }
};
var $18aa4e196c556c9e$export$f108bb490d3f260f = function(v) {
    return $18aa4e196c556c9e$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619(v));
};
var $18aa4e196c556c9e$export$ea2eb8326e92a9a7 = function(v) {
    return $65049bb6418b06dc$export$68410c2af0b88c0(v);
};
var $18aa4e196c556c9e$export$3218fc651e0d51d2 = function(v) {
    return $65049bb6418b06dc$export$68410c2af0b88c0(v);
};
var $18aa4e196c556c9e$export$18adb160bd4fde3e = /* #__PURE__ */ $18aa4e196c556c9e$var$alt($65049bb6418b06dc$export$723eaa54d8971962)(/* #__PURE__ */ $18aa4e196c556c9e$var$alt($65049bb6418b06dc$export$a0a602ac6ffe7549)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("@")));
var $18aa4e196c556c9e$export$ea80c68c63626d5c = /* #__PURE__ */ function() {
    var $31 = $65049bb6418b06dc$export$256236776516d24($18aa4e196c556c9e$export$18adb160bd4fde3e);
    return function($32) {
        return $18aa4e196c556c9e$var$PathSegmentNZNC($31($32));
    };
}();
var $18aa4e196c556c9e$export$582e23f03f71819a = /* #__PURE__ */ $18aa4e196c556c9e$var$alt($18aa4e196c556c9e$export$18adb160bd4fde3e)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"));
var $18aa4e196c556c9e$export$6894d5eeabfa3a56 = /* #__PURE__ */ function() {
    var $33 = $65049bb6418b06dc$export$cced2b75a857d31f($18aa4e196c556c9e$export$582e23f03f71819a);
    return function($34) {
        return $18aa4e196c556c9e$var$PathSegment($33($34));
    };
}();
var $18aa4e196c556c9e$export$a72bb629a6814c04 = /* #__PURE__ */ function() {
    var $35 = $65049bb6418b06dc$export$256236776516d24($18aa4e196c556c9e$export$582e23f03f71819a);
    return function($36) {
        return $18aa4e196c556c9e$var$PathSegmentNZ($35($36));
    };
}();
var $18aa4e196c556c9e$export$7c43a6e296edd805 = function($37) {
    return $5505a3400147efbd$export$f84e8e69fd4488a5($18aa4e196c556c9e$export$4346850e4a475898($37));
};
var $18aa4e196c556c9e$export$4c0b40e53ba1cc19 = function($38) {
    return $5505a3400147efbd$export$f84e8e69fd4488a5($18aa4e196c556c9e$export$fb552b7e9cd682f0($38));
};
var $18aa4e196c556c9e$export$33c74ae163aadbcc = $18aa4e196c556c9e$export$fe8dceefe7377757;
var $18aa4e196c556c9e$export$ec7eed2c33819956 = /* #__PURE__ */ $18aa4e196c556c9e$var$map(/* #__PURE__ */ function() {
    var $39 = $18aa4e196c556c9e$var$join1With("");
    return function($40) {
        return $18aa4e196c556c9e$var$PathSegmentNZNC($39($40));
    };
}())(/* #__PURE__ */ $18aa4e196c556c9e$var$some(/* #__PURE__ */ $18aa4e196c556c9e$var$alt($65049bb6418b06dc$export$212cc4c54b7f9d4d)(/* #__PURE__ */ $18aa4e196c556c9e$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($18aa4e196c556c9e$export$18adb160bd4fde3e))));
var $18aa4e196c556c9e$export$1fecf01800f55760 = /* #__PURE__ */ $18aa4e196c556c9e$var$map(/* #__PURE__ */ function() {
    var $41 = $18aa4e196c556c9e$var$join1With("");
    return function($42) {
        return $18aa4e196c556c9e$var$PathSegmentNZ($41($42));
    };
}())(/* #__PURE__ */ $18aa4e196c556c9e$var$some(/* #__PURE__ */ $18aa4e196c556c9e$var$alt($65049bb6418b06dc$export$212cc4c54b7f9d4d)(/* #__PURE__ */ $18aa4e196c556c9e$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($18aa4e196c556c9e$export$582e23f03f71819a))));
var $18aa4e196c556c9e$export$af89f897824e29a5 = /* #__PURE__ */ $18aa4e196c556c9e$var$map(/* #__PURE__ */ function() {
    var $43 = $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075)("");
    return function($44) {
        return $18aa4e196c556c9e$var$PathSegment($43($44));
    };
}())(/* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3)(/* #__PURE__ */ $18aa4e196c556c9e$var$alt($65049bb6418b06dc$export$212cc4c54b7f9d4d)(/* #__PURE__ */ $18aa4e196c556c9e$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($18aa4e196c556c9e$export$582e23f03f71819a))));
var $18aa4e196c556c9e$export$74a6bd1adafa3d1e = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $18aa4e196c556c9e$export$bbf2b7040d41eea4 = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $18aa4e196c556c9e$export$eaba4991a6a32c97 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $18aa4e196c556c9e$export$3bd90d24d2ec969e = $5505a3400147efbd$export$5982362881026796;
var $18aa4e196c556c9e$export$be9bdb2e5096af5b = $5505a3400147efbd$export$5982362881026796;
var $18aa4e196c556c9e$export$2560ee2e5b993668 = $37b880af5f4991bd$export$fa624555ca2acbc8;


var $affc06959d096a42$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $affc06959d096a42$export$4b2950bdac9b6ee9 = function(x) {
    return x;
};
var $affc06959d096a42$export$cce6d46abb8ecaa0 = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $affc06959d096a42$export$c2d084dc44961371 = function(v) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(v)) return "";
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return "/" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e("/")($affc06959d096a42$var$map($18aa4e196c556c9e$export$fe8dceefe7377757)(v));
    throw new Error("Failed pattern match at URI.Path (line 35, column 1 - line 35, column 24): " + [
        v.constructor.name
    ]);
};
var $affc06959d096a42$export$8f49e4af10703ce3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b)(/* #__PURE__ */ function() {
    var $23 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
    return function($24) {
        return $affc06959d096a42$export$4b2950bdac9b6ee9($23($24));
    };
}())(/* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3)(/* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("/"))($18aa4e196c556c9e$export$af89f897824e29a5)));
var $affc06959d096a42$export$9bb20365e82eaacb = /* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($18aa4e196c556c9e$export$eaba4991a6a32c97);
var $affc06959d096a42$export$19fa9f1fff10b44e = $784e1bd3d26d71da$export$db307f59121ffcc4;
var $affc06959d096a42$export$2cb1ddd215cfd095 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $affc06959d096a42$export$d53d9be948a7219c = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($affc06959d096a42$export$2cb1ddd215cfd095)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($18aa4e196c556c9e$export$74eeba61cd416584)))({
        reflectSymbol: function() {
            return "Path";
        }
    }))
};
var $affc06959d096a42$export$af26477280c1e920 = /* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($18aa4e196c556c9e$export$2560ee2e5b993668);


// Generated by purs version 0.15.15


















var $725d29a28b8fa299$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $725d29a28b8fa299$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $725d29a28b8fa299$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $725d29a28b8fa299$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $725d29a28b8fa299$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $725d29a28b8fa299$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47);
var $725d29a28b8fa299$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $725d29a28b8fa299$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e(/* #__PURE__ */ $71f2e2e9476163f8$export$d625e8a97ba36bd6($18aa4e196c556c9e$export$be9bdb2e5096af5b)(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($18aa4e196c556c9e$export$2560ee2e5b993668))));
var $725d29a28b8fa299$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46(/* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($18aa4e196c556c9e$export$bbf2b7040d41eea4)(/* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($18aa4e196c556c9e$export$eaba4991a6a32c97))));
var $725d29a28b8fa299$export$a03ca9a908d54ab6 = function(x) {
    return x;
};
var $725d29a28b8fa299$export$c2d084dc44961371 = function(v) {
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "/";
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.value1.length === 0) return "/" + $18aa4e196c556c9e$export$4c0b40e53ba1cc19(v.value0.value0);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "/" + ($18aa4e196c556c9e$export$4c0b40e53ba1cc19(v.value0.value0) + ("/" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e("/")($725d29a28b8fa299$var$map($18aa4e196c556c9e$export$33c74ae163aadbcc)(v.value0.value1))));
    throw new Error("Failed pattern match at URI.Path.Absolute (line 52, column 9 - line 61, column 53): " + [
        v.constructor.name
    ]);
};
var $725d29a28b8fa299$export$98e6a39c04603d36 = /* #__PURE__ */ $725d29a28b8fa299$var$bind(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("/"))(function() {
    return $725d29a28b8fa299$var$bind($11bbe85c947c529d$export$b9803a97967f594($18aa4e196c556c9e$export$1fecf01800f55760))(function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $725d29a28b8fa299$var$map1(function() {
            var $57 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
            return function($58) {
                return $725d29a28b8fa299$export$a03ca9a908d54ab6($06733ae99ed4f534$export$8a67b48435b5d073.create($57($725d29a28b8fa299$var$fromFoldable($58))));
            };
        }())($725d29a28b8fa299$var$manyRec($725d29a28b8fa299$var$applySecond($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("/"))($18aa4e196c556c9e$export$af89f897824e29a5)));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $725d29a28b8fa299$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
        throw new Error("Failed pattern match at URI.Path.Absolute (line 40, column 34 - line 48, column 34): " + [
            v.constructor.name
        ]);
    });
});
var $725d29a28b8fa299$export$2d6b8b876f8850d7 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $725d29a28b8fa299$export$298ab62a06583b20 = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($725d29a28b8fa299$export$2d6b8b876f8850d7)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a(/* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($18aa4e196c556c9e$export$1737cbd6ddd476e0)(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($18aa4e196c556c9e$export$74eeba61cd416584)))))({
        reflectSymbol: function() {
            return "PathAbsolute";
        }
    }))
};
var $725d29a28b8fa299$export$f577f13a77f23d48 = {
    eq: function(x) {
        return function(y) {
            return $725d29a28b8fa299$var$eq(x)(y);
        };
    }
};
var $725d29a28b8fa299$export$802273242e567dae = {
    compare: function(x) {
        return function(y) {
            return $725d29a28b8fa299$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $725d29a28b8fa299$export$f577f13a77f23d48;
    }
};


// Generated by purs version 0.15.15
















var $c48ca4c81564148e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c48ca4c81564148e$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $c48ca4c81564148e$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $c48ca4c81564148e$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47);
var $c48ca4c81564148e$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $c48ca4c81564148e$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $c48ca4c81564148e$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $71f2e2e9476163f8$export$d625e8a97ba36bd6($18aa4e196c556c9e$export$be9bdb2e5096af5b)(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($18aa4e196c556c9e$export$2560ee2e5b993668)));
var $c48ca4c81564148e$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($18aa4e196c556c9e$export$bbf2b7040d41eea4)(/* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e($18aa4e196c556c9e$export$eaba4991a6a32c97)));
var $c48ca4c81564148e$export$3ba87e3ce3c16ab2 = function(x) {
    return x;
};
var $c48ca4c81564148e$export$c2d084dc44961371 = function(v) {
    if (v.value1.length === 0) return $18aa4e196c556c9e$export$4c0b40e53ba1cc19(v.value0);
    return $18aa4e196c556c9e$export$4c0b40e53ba1cc19(v.value0) + ("/" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e("/")($c48ca4c81564148e$var$map($18aa4e196c556c9e$export$33c74ae163aadbcc)(v.value1)));
};
var $c48ca4c81564148e$export$98e6a39c04603d36 = /* #__PURE__ */ $c48ca4c81564148e$var$bind($18aa4e196c556c9e$export$1fecf01800f55760)(function(head) {
    return $c48ca4c81564148e$var$bind($c48ca4c81564148e$var$manyRec($c48ca4c81564148e$var$applySecond($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("/"))($18aa4e196c556c9e$export$af89f897824e29a5)))(function(tail) {
        return $c48ca4c81564148e$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(head, $c48ca4c81564148e$var$fromFoldable(tail)));
    });
});
var $c48ca4c81564148e$export$702879c4f934d994 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $c48ca4c81564148e$export$a7c5a7a80c704f2a = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($c48ca4c81564148e$export$702879c4f934d994)(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($18aa4e196c556c9e$export$1737cbd6ddd476e0)(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($18aa4e196c556c9e$export$74eeba61cd416584))))({
        reflectSymbol: function() {
            return "PathRootless";
        }
    }))
};
var $c48ca4c81564148e$export$f4f11c60fd21d4a9 = {
    eq: function(x) {
        return function(y) {
            return $c48ca4c81564148e$var$eq(x)(y);
        };
    }
};
var $c48ca4c81564148e$export$eab6b016a36cf6b0 = {
    compare: function(x) {
        return function(y) {
            return $c48ca4c81564148e$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c48ca4c81564148e$export$f4f11c60fd21d4a9;
    }
};


var $d0fc10256bba7201$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($2b6d012b5a71a466$export$8808000bb50bc47);
var $d0fc10256bba7201$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $d0fc10256bba7201$var$wrapParser = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $d0fc10256bba7201$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $d0fc10256bba7201$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $d0fc10256bba7201$var$HierarchicalPartAuthIsSymbol = {
    reflectSymbol: function() {
        return "HierarchicalPartAuth";
    }
};
var $d0fc10256bba7201$var$HierarchicalPartNoAuthIsSymbol = {
    reflectSymbol: function() {
        return "HierarchicalPartNoAuth";
    }
};
var $d0fc10256bba7201$export$a92244b8f5b77411 = /* #__PURE__ */ function() {
    function HierarchicalPartAuth(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    HierarchicalPartAuth.create = function(value0) {
        return function(value1) {
            return new HierarchicalPartAuth(value0, value1);
        };
    };
    return HierarchicalPartAuth;
}();
var $d0fc10256bba7201$export$8c11c9eba29d8596 = /* #__PURE__ */ function() {
    function HierarchicalPartNoAuth(value0) {
        this.value0 = value0;
    }
    HierarchicalPartNoAuth.create = function(value0) {
        return new HierarchicalPartNoAuth(value0);
    };
    return HierarchicalPartNoAuth;
}();
var $d0fc10256bba7201$export$c2d084dc44961371 = function(opts) {
    return function(v) {
        if (v instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return $e958b450d709607c$export$c2d084dc44961371(opts)(v.value0) + $affc06959d096a42$export$c2d084dc44961371(opts.printPath(v.value1));
        if (v instanceof $d0fc10256bba7201$export$8c11c9eba29d8596) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function() {
            var $146 = $7d4cccdf062a2261$export$5f5be1bb6cd1fded($725d29a28b8fa299$export$c2d084dc44961371)($c48ca4c81564148e$export$c2d084dc44961371);
            return function($147) {
                return $146(opts.printHierPath($147));
            };
        }())(v.value0);
        throw new Error("Failed pattern match at URI.HierarchicalPart (line 119, column 14 - line 123, column 80): " + [
            v.constructor.name
        ]);
    };
};
var $d0fc10256bba7201$export$8f49e4af10703ce3 = function(opts) {
    var withAuth = $d0fc10256bba7201$var$apply($d0fc10256bba7201$var$map($d0fc10256bba7201$export$a92244b8f5b77411.create)($e958b450d709607c$export$8f49e4af10703ce3(opts)))($d0fc10256bba7201$var$wrapParser(opts.parsePath)($affc06959d096a42$export$8f49e4af10703ce3));
    var noAuthPath = $d0fc10256bba7201$var$alt($d0fc10256bba7201$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($d0fc10256bba7201$var$wrapParser(function($148) {
        return opts.parseHierPath($7d4cccdf062a2261$export$37c4d04eafdc5515.create($148));
    })($725d29a28b8fa299$export$98e6a39c04603d36)))($d0fc10256bba7201$var$alt($d0fc10256bba7201$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($d0fc10256bba7201$var$wrapParser(function($149) {
        return opts.parseHierPath($7d4cccdf062a2261$export$19db0165690c701a.create($149));
    })($c48ca4c81564148e$export$98e6a39c04603d36)))($d0fc10256bba7201$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value)));
    var withoutAuth = $d0fc10256bba7201$var$map($d0fc10256bba7201$export$8c11c9eba29d8596.create)(noAuthPath);
    return $d0fc10256bba7201$var$alt(withAuth)(withoutAuth);
};
var $d0fc10256bba7201$export$427fe5bc23a80820 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $d0fc10256bba7201$export$a92244b8f5b77411(x.value0.value0, x.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $d0fc10256bba7201$export$8c11c9eba29d8596(x.value0);
        throw new Error("Failed pattern match at URI.HierarchicalPart (line 50, column 1 - line 50, column 101): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1));
        if (x instanceof $d0fc10256bba7201$export$8c11c9eba29d8596) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at URI.HierarchicalPart (line 50, column 1 - line 50, column 101): " + [
            x.constructor.name
        ]);
    }
};
var $d0fc10256bba7201$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($d0fc10256bba7201$export$427fe5bc23a80820);
var $d0fc10256bba7201$export$9729917653af08b7 = function(dictShow) {
    var showAuthority = $e958b450d709607c$export$acb1cb62298cb1de(dictShow);
    return function(dictShow1) {
        var genericShowArgsProduct = $544b62a378cc0091$export$b8b972500eedbc74($544b62a378cc0091$export$bc1180ef96fcb658(showAuthority(dictShow1)));
        return function(dictShow2) {
            var genericShowSum = $544b62a378cc0091$export$29d77e0cd7b7a3b8($544b62a378cc0091$export$186afff91b813845(genericShowArgsProduct($544b62a378cc0091$export$bc1180ef96fcb658(dictShow2)))($d0fc10256bba7201$var$HierarchicalPartAuthIsSymbol));
            return function(dictShow3) {
                return {
                    show: $d0fc10256bba7201$var$genericShow(genericShowSum($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658($06733ae99ed4f534$export$9b814e760fdd264a(dictShow3)))($d0fc10256bba7201$var$HierarchicalPartNoAuthIsSymbol)))
                };
            };
        };
    };
};
var $d0fc10256bba7201$export$10fab18e950ed3d5 = function(dictEq) {
    var eqAuthority = $e958b450d709607c$export$8ac072b352363b0(dictEq);
    return function(dictEq1) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(eqAuthority(dictEq1));
        return function(dictEq2) {
            var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq2);
            return function(dictEq3) {
                var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq3));
                return {
                    eq: function(x) {
                        return function(y) {
                            if (x instanceof $d0fc10256bba7201$export$a92244b8f5b77411 && y instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                            if (x instanceof $d0fc10256bba7201$export$8c11c9eba29d8596 && y instanceof $d0fc10256bba7201$export$8c11c9eba29d8596) return eq2(x.value0)(y.value0);
                            return false;
                        };
                    }
                };
            };
        };
    };
};
var $d0fc10256bba7201$export$9e4ed5f137c75ddd = function(dictOrd) {
    var ordAuthority = $e958b450d709607c$export$16b5b8c277f87a2e(dictOrd);
    var eqHierarchicalPart1 = $d0fc10256bba7201$export$10fab18e950ed3d5(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(ordAuthority(dictOrd1));
        var eqHierarchicalPart2 = eqHierarchicalPart1(dictOrd1.Eq0());
        return function(dictOrd2) {
            var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd2);
            var eqHierarchicalPart3 = eqHierarchicalPart2(dictOrd2.Eq0());
            return function(dictOrd3) {
                var compare2 = $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd3));
                var eqHierarchicalPart4 = eqHierarchicalPart3(dictOrd3.Eq0());
                return {
                    compare: function(x) {
                        return function(y) {
                            if (x instanceof $d0fc10256bba7201$export$a92244b8f5b77411 && y instanceof $d0fc10256bba7201$export$a92244b8f5b77411) {
                                var v = compare(x.value0)(y.value0);
                                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                                return compare1(x.value1)(y.value1);
                            }
                            if (x instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            if (y instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            if (x instanceof $d0fc10256bba7201$export$8c11c9eba29d8596 && y instanceof $d0fc10256bba7201$export$8c11c9eba29d8596) return compare2(x.value0)(y.value0);
                            throw new Error("Failed pattern match at URI.HierarchicalPart (line 0, column 0 - line 0, column 0): " + [
                                x.constructor.name,
                                y.constructor.name
                            ]);
                        };
                    },
                    Eq0: function() {
                        return eqHierarchicalPart4;
                    }
                };
            };
        };
    };
};
var $d0fc10256bba7201$export$ba3c492dc54826d6 = function(dictWander) {
    return $48c79e0fab366ce5$export$cfc1ea1528b06875(dictWander)(function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(v) {
                if (v instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return map1($d0fc10256bba7201$export$a92244b8f5b77411.create(v.value0))(f(v.value1));
                return pure1(v);
            };
        };
    });
};
var $d0fc10256bba7201$export$d25b1d15dcb86a73 = function(dictWander) {
    return $48c79e0fab366ce5$export$cfc1ea1528b06875(dictWander)(function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(v) {
                if (v instanceof $d0fc10256bba7201$export$8c11c9eba29d8596) return map1($d0fc10256bba7201$export$8c11c9eba29d8596.create)(f(v.value0));
                return pure1(v);
            };
        };
    });
};
var $d0fc10256bba7201$export$562979087f45072d = function(dictWander) {
    return $48c79e0fab366ce5$export$cfc1ea1528b06875(dictWander)(function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(v) {
                if (v instanceof $d0fc10256bba7201$export$a92244b8f5b77411) return map1($f57f4b701aa7b66e$export$8a83211c878a3f1f($d0fc10256bba7201$export$a92244b8f5b77411.create)(v.value1))(f(v.value0));
                return pure1(v);
            };
        };
    });
};


// Generated by purs version 0.15.15

















var $ce223683b9c93444$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $ce223683b9c93444$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $ce223683b9c93444$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $ce223683b9c93444$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $ce223683b9c93444$var$Query = function(x) {
    return x;
};
var $ce223683b9c93444$export$46c39d7334f59785 = function(v) {
    return v;
};
var $ce223683b9c93444$export$6c65599023ae894b = $ce223683b9c93444$var$Query;
var $ce223683b9c93444$export$f84e8e69fd4488a5 = function(v) {
    return $ce223683b9c93444$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619(v));
};
var $ce223683b9c93444$export$8c06a41e700e9046 = {
    show: function(v) {
        return "(Query.unsafeFromString " + ($ce223683b9c93444$var$show(v) + ")");
    }
};
var $ce223683b9c93444$export$c58bbf20c9188758 = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $ce223683b9c93444$export$aec484f6c28ba0c7 = /* #__PURE__ */ $ce223683b9c93444$var$alt($65049bb6418b06dc$export$723eaa54d8971962)(/* #__PURE__ */ $ce223683b9c93444$var$alt($65049bb6418b06dc$export$a0a602ac6ffe7549)(/* #__PURE__ */ $ce223683b9c93444$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))(/* #__PURE__ */ $ce223683b9c93444$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("@"))(/* #__PURE__ */ $ce223683b9c93444$var$alt(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("/"))(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("?"))))));
var $ce223683b9c93444$export$c2d084dc44961371 = function(v) {
    return "?" + v;
};
var $ce223683b9c93444$export$8f49e4af10703ce3 = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($2b6d012b5a71a466$export$8808000bb50bc47)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("?"))(/* #__PURE__ */ $ce223683b9c93444$var$map(/* #__PURE__ */ function() {
    var $18 = $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075)("");
    return function($19) {
        return $ce223683b9c93444$var$Query($18($19));
    };
}())(/* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3)(/* #__PURE__ */ $ce223683b9c93444$var$alt(/* #__PURE__ */ $ce223683b9c93444$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($ce223683b9c93444$export$aec484f6c28ba0c7))($65049bb6418b06dc$export$212cc4c54b7f9d4d))));
var $ce223683b9c93444$export$32170250d4fda2dd = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $ce223683b9c93444$export$618a93e671867b3b = $784e1bd3d26d71da$export$fc39f3d77fa2e58a;
var $ce223683b9c93444$export$3004f64547af360e = /* #__PURE__ */ function() {
    var $20 = $65049bb6418b06dc$export$cced2b75a857d31f($ce223683b9c93444$export$aec484f6c28ba0c7);
    return function($21) {
        return $ce223683b9c93444$var$Query($20($21));
    };
}();
var $ce223683b9c93444$export$6125a812cb12e84f = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.15

















var $ff3693eeb39da812$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $ff3693eeb39da812$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $ff3693eeb39da812$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $ff3693eeb39da812$var$joinWith = /* #__PURE__ */ $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075);
var $ff3693eeb39da812$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $ff3693eeb39da812$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $ff3693eeb39da812$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $ff3693eeb39da812$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $ff3693eeb39da812$var$Scheme = function(x) {
    return x;
};
var $ff3693eeb39da812$export$f84e8e69fd4488a5 = function(v) {
    return v;
};
var $ff3693eeb39da812$export$5367220435b54d3c = {
    show: function(v) {
        return "(Scheme.unsafeFromString " + ($ff3693eeb39da812$var$show($5505a3400147efbd$export$f84e8e69fd4488a5(v)) + ")");
    }
};
var $ff3693eeb39da812$export$c2d084dc44961371 = function(v) {
    return $5505a3400147efbd$export$f84e8e69fd4488a5(v) + ":";
};
var $ff3693eeb39da812$var$parseScheme = /* #__PURE__ */ $ff3693eeb39da812$var$bind($65049bb6418b06dc$export$58f0f39f63f3cf42)(function(init) {
    return $ff3693eeb39da812$var$bind($ff3693eeb39da812$var$map($ff3693eeb39da812$var$joinWith(""))($ff3693eeb39da812$var$manyRec($ff3693eeb39da812$var$map($be985434983c0a5f$export$439306a4dcaafbb9)($ff3693eeb39da812$var$alt($65049bb6418b06dc$export$2f9d0d831d496619)($ff3693eeb39da812$var$alt($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("+"))($ff3693eeb39da812$var$alt($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("-"))($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("."))))))))(function(rest) {
        return $ff3693eeb39da812$var$pure($5505a3400147efbd$export$8c3d57ec79c4009e($be985434983c0a5f$export$439306a4dcaafbb9(init))(rest));
    });
});
var $ff3693eeb39da812$export$8f49e4af10703ce3 = /* #__PURE__ */ $ff3693eeb39da812$var$applyFirst(/* #__PURE__ */ $ff3693eeb39da812$var$map($ff3693eeb39da812$var$Scheme)($ff3693eeb39da812$var$parseScheme))(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"));
var $ff3693eeb39da812$export$7a064c61b96ec688 = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $ff3693eeb39da812$export$3004f64547af360e = /* #__PURE__ */ function() {
    var $21 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66)($ff3693eeb39da812$var$Scheme);
    var $22 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($2b6d012b5a71a466$export$4ad9239eebc1597f)($ff3693eeb39da812$var$applyFirst($ff3693eeb39da812$var$parseScheme)($ca4b6f31ec4b9857$export$d83becf4b42ec59));
    return function($23) {
        return $21($7d4cccdf062a2261$export$3a6c138b8d0f3874($22($23)));
    };
}();
var $ff3693eeb39da812$export$6c65599023ae894b = function(s) {
    var v = $ff3693eeb39da812$export$3004f64547af360e(s);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8bcde8f642a64c7d$export$51b220bae4359b72("Scheme value is invalid: `" + ($ff3693eeb39da812$var$show(s) + "`"));
    throw new Error("Failed pattern match at URI.Scheme (line 61, column 22 - line 63, column 77): " + [
        v.constructor.name
    ]);
};
var $ff3693eeb39da812$export$ac18efa11dafab54 = $5505a3400147efbd$export$5982362881026796;


var $c558d54e53fc2088$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c558d54e53fc2088$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($2b6d012b5a71a466$export$8808000bb50bc47);
var $c558d54e53fc2088$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($2b6d012b5a71a466$export$8808000bb50bc47);
var $c558d54e53fc2088$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $c558d54e53fc2088$var$wrapParser = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $c558d54e53fc2088$var$genericShowArgsProduct = /* #__PURE__ */ $544b62a378cc0091$export$b8b972500eedbc74(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($ff3693eeb39da812$export$5367220435b54d3c));
var $c558d54e53fc2088$var$AbsoluteURIIsSymbol = {
    reflectSymbol: function() {
        return "AbsoluteURI";
    }
};
var $c558d54e53fc2088$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($ff3693eeb39da812$export$ac18efa11dafab54);
var $c558d54e53fc2088$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($ff3693eeb39da812$export$7a064c61b96ec688);
var $c558d54e53fc2088$export$38616893db4b7095 = /* #__PURE__ */ function() {
    function AbsoluteURI(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    AbsoluteURI.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new AbsoluteURI(value0, value1, value2);
            };
        };
    };
    return AbsoluteURI;
}();
var $c558d54e53fc2088$export$c2d084dc44961371 = function(opts) {
    return function(v) {
        return $5b07e36f812dd04b$export$ec1dc8fbeea3467e("")($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($ff3693eeb39da812$export$c2d084dc44961371(v.value0)),
            new $06733ae99ed4f534$export$8a67b48435b5d073($d0fc10256bba7201$export$c2d084dc44961371(opts)(v.value1)),
            $c558d54e53fc2088$var$map(function($153) {
                return $ce223683b9c93444$export$c2d084dc44961371(opts.printQuery($153));
            })(v.value2)
        ]));
    };
};
var $c558d54e53fc2088$export$8f49e4af10703ce3 = function(opts) {
    return $c558d54e53fc2088$var$applyFirst($c558d54e53fc2088$var$apply($c558d54e53fc2088$var$apply($c558d54e53fc2088$var$map1($c558d54e53fc2088$export$38616893db4b7095.create)($ff3693eeb39da812$export$8f49e4af10703ce3))($d0fc10256bba7201$export$8f49e4af10703ce3(opts)))($11bbe85c947c529d$export$b9803a97967f594($c558d54e53fc2088$var$wrapParser(opts.parseQuery)($ce223683b9c93444$export$8f49e4af10703ce3))))($ca4b6f31ec4b9857$export$d83becf4b42ec59);
};
var $c558d54e53fc2088$export$a1fbed2de1650871 = {
    to: function(x) {
        return new $c558d54e53fc2088$export$38616893db4b7095(x.value0, x.value1.value0, x.value1.value1);
    },
    from: function(x) {
        return new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value1, x.value2));
    }
};
var $c558d54e53fc2088$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($c558d54e53fc2088$export$a1fbed2de1650871);
var $c558d54e53fc2088$export$7eeec00c08779f4b = function(dictShow) {
    var showHierarchicalPart = $d0fc10256bba7201$export$9729917653af08b7(dictShow);
    return function(dictShow1) {
        var showHierarchicalPart1 = showHierarchicalPart(dictShow1);
        return function(dictShow2) {
            var showHierarchicalPart2 = showHierarchicalPart1(dictShow2);
            return function(dictShow3) {
                var genericShowArgsProduct1 = $544b62a378cc0091$export$b8b972500eedbc74($544b62a378cc0091$export$bc1180ef96fcb658(showHierarchicalPart2(dictShow3)));
                return function(dictShow4) {
                    return {
                        show: $c558d54e53fc2088$var$genericShow($544b62a378cc0091$export$186afff91b813845($c558d54e53fc2088$var$genericShowArgsProduct(genericShowArgsProduct1($544b62a378cc0091$export$bc1180ef96fcb658($06733ae99ed4f534$export$9b814e760fdd264a(dictShow4)))))($c558d54e53fc2088$var$AbsoluteURIIsSymbol))
                    };
                };
            };
        };
    };
};
var $c558d54e53fc2088$export$733c65f4ff45e10c = function(dictEq) {
    var eqHierarchicalPart = $d0fc10256bba7201$export$10fab18e950ed3d5(dictEq);
    return function(dictEq1) {
        var eqHierarchicalPart1 = eqHierarchicalPart(dictEq1);
        return function(dictEq2) {
            var eqHierarchicalPart2 = eqHierarchicalPart1(dictEq2);
            return function(dictEq3) {
                var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(eqHierarchicalPart2(dictEq3));
                return function(dictEq4) {
                    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq4));
                    return {
                        eq: function(x) {
                            return function(y) {
                                return $c558d54e53fc2088$var$eq(x.value0)(y.value0) && eq1(x.value1)(y.value1) && eq2(x.value2)(y.value2);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $c558d54e53fc2088$export$5b62b9a09c5181d0 = function(dictOrd) {
    var ordHierarchicalPart = $d0fc10256bba7201$export$9e4ed5f137c75ddd(dictOrd);
    var eqAbsoluteURI1 = $c558d54e53fc2088$export$733c65f4ff45e10c(dictOrd.Eq0());
    return function(dictOrd1) {
        var ordHierarchicalPart1 = ordHierarchicalPart(dictOrd1);
        var eqAbsoluteURI2 = eqAbsoluteURI1(dictOrd1.Eq0());
        return function(dictOrd2) {
            var ordHierarchicalPart2 = ordHierarchicalPart1(dictOrd2);
            var eqAbsoluteURI3 = eqAbsoluteURI2(dictOrd2.Eq0());
            return function(dictOrd3) {
                var compare1 = $97937c29f879e68e$export$398604a469f7de9a(ordHierarchicalPart2(dictOrd3));
                var eqAbsoluteURI4 = eqAbsoluteURI3(dictOrd3.Eq0());
                return function(dictOrd4) {
                    var compare2 = $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd4));
                    var eqAbsoluteURI5 = eqAbsoluteURI4(dictOrd4.Eq0());
                    return {
                        compare: function(x) {
                            return function(y) {
                                var v = $c558d54e53fc2088$var$compare(x.value0)(y.value0);
                                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                                var v1 = compare1(x.value1)(y.value1);
                                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                                return compare2(x.value2)(y.value2);
                            };
                        },
                        Eq0: function() {
                            return eqAbsoluteURI5;
                        }
                    };
                };
            };
        };
    };
};
var $c558d54e53fc2088$export$887ac8ee5e08dcad = function(dictStrong) {
    return $03856732e0180b78$export$21cde5187c2605a3(function(v) {
        return v.value0;
    })(function(v) {
        return function(s) {
            return new $c558d54e53fc2088$export$38616893db4b7095(s, v.value1, v.value2);
        };
    })(dictStrong);
};
var $c558d54e53fc2088$export$a6bf5b217f4ae5bf = function(dictStrong) {
    return $03856732e0180b78$export$21cde5187c2605a3(function(v) {
        return v.value2;
    })(function(v) {
        return function(q) {
            return new $c558d54e53fc2088$export$38616893db4b7095(v.value0, v.value1, q);
        };
    })(dictStrong);
};
var $c558d54e53fc2088$export$37cbedc4b55914e4 = function(dictStrong) {
    return $03856732e0180b78$export$21cde5187c2605a3(function(v) {
        return v.value1;
    })(function(v) {
        return function(h) {
            return new $c558d54e53fc2088$export$38616893db4b7095(v.value0, h, v.value2);
        };
    })(dictStrong);
};



// Generated by purs version 0.15.15































var $4083877d53c3526b$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $4083877d53c3526b$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $4083877d53c3526b$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $4083877d53c3526b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $4083877d53c3526b$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($2b6d012b5a71a466$export$6d6c2eed9b26bef3);
var $4083877d53c3526b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $4083877d53c3526b$var$wrapParser = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $4083877d53c3526b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($2b6d012b5a71a466$export$858eabc7228a4f5b);
var $4083877d53c3526b$var$joinWith = /* #__PURE__ */ $5505a3400147efbd$export$ec1dc8fbeea3467e($78c799cba34fcb8d$export$92659ee1fc91a075);
var $4083877d53c3526b$var$someRec = /* #__PURE__ */ $3d4fd987da5242ff$export$934820ddadec516f($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $4083877d53c3526b$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $4083877d53c3526b$var$manyRec = /* #__PURE__ */ $3d4fd987da5242ff$export$17771a97d85ba7eb($2b6d012b5a71a466$export$c97488a047bfb404)($2b6d012b5a71a466$export$5220689f708908c3);
var $4083877d53c3526b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $4083877d53c3526b$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $4083877d53c3526b$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $4083877d53c3526b$var$QueryPairsIsSymbol = {
    reflectSymbol: function() {
        return "QueryPairs";
    }
};
var $4083877d53c3526b$var$Value = function(x) {
    return x;
};
var $4083877d53c3526b$export$6907e5fd9635b283 = function(x) {
    return x;
};
var $4083877d53c3526b$var$Key = function(x) {
    return x;
};
var $4083877d53c3526b$export$7fcada0453713929 = function(v) {
    return $4083877d53c3526b$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619(v));
};
var $4083877d53c3526b$export$cbaab10292c2cd14 = function(v) {
    return v;
};
var $4083877d53c3526b$export$a138a83921ee994c = $4083877d53c3526b$var$Value;
var $4083877d53c3526b$export$1c9303d28d2e173c = function(v) {
    return v;
};
var $4083877d53c3526b$export$226468c4756c8fb3 = $4083877d53c3526b$var$Key;
var $4083877d53c3526b$export$4dffb421cfcec105 = {
    show: function(v) {
        return "(QueryPairs.unsafeValueFromString " + ($4083877d53c3526b$var$show(v) + ")");
    }
};
var $4083877d53c3526b$export$656258d3c2e86952 = {
    show: function(v) {
        return "(QueryPairs.unsafeKeyFromString " + ($4083877d53c3526b$var$show(v) + ")");
    }
};
var $4083877d53c3526b$export$9f1662b0d944c9c = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $4083877d53c3526b$export$8771234b24d56f55 = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $4083877d53c3526b$export$f24614ba16b56c9f = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $4083877d53c3526b$export$c2d084dc44961371 = function(printK) {
    return function(printV) {
        return function(v) {
            var printPart = function(v1) {
                if (v1.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4083877d53c3526b$export$1c9303d28d2e173c(printK(v1.value0));
                if (v1.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4083877d53c3526b$export$1c9303d28d2e173c(printK(v1.value0)) + ("=" + $4083877d53c3526b$export$cbaab10292c2cd14(printV(v1.value1.value0)));
                throw new Error("Failed pattern match at URI.Extra.QueryPairs (line 106, column 15 - line 110, column 76): " + [
                    v1.constructor.name
                ]);
            };
            return $ce223683b9c93444$export$6c65599023ae894b($5b07e36f812dd04b$export$ec1dc8fbeea3467e("&")($4083877d53c3526b$var$fromFoldable($4083877d53c3526b$var$map(printPart)(v))));
        };
    };
};
var $4083877d53c3526b$export$98c58b176174c8b0 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $4083877d53c3526b$export$92c8a52524a5b159 = function(dictOrd) {
    var ordTuple = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictOrd);
    return function(dictOrd1) {
        return $97937c29f879e68e$export$6ace7ea8ac01a75e(ordTuple($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd1)));
    };
};
var $4083877d53c3526b$export$ee307e7d0c0c420e = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $4083877d53c3526b$export$3a2d9ddae8c4b036 = $784e1bd3d26d71da$export$fc39f3d77fa2e58a;
var $4083877d53c3526b$export$b808b1e430bf9524 = $784e1bd3d26d71da$export$db307f59121ffcc4;
var $4083877d53c3526b$export$e657daf16c784c05 = $784e1bd3d26d71da$export$fc39f3d77fa2e58a;
var $4083877d53c3526b$export$f8f6563c0cfc2be4 = function(v) {
    return $4083877d53c3526b$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619(v));
};
var $4083877d53c3526b$export$829a293c8fabe723 = /* #__PURE__ */ $4083877d53c3526b$var$alt($65049bb6418b06dc$export$723eaa54d8971962)(/* #__PURE__ */ $32834c6d75ca0cb1$export$a9a18ae5ba42aeab([
    "!",
    "$",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    ":",
    "@",
    "/",
    "?"
]));
var $4083877d53c3526b$export$84c91e425ef00fa1 = /* #__PURE__ */ function() {
    var $75 = $65049bb6418b06dc$export$cced2b75a857d31f($4083877d53c3526b$export$829a293c8fabe723);
    return function($76) {
        return $4083877d53c3526b$var$Value($75($76));
    };
}();
var $4083877d53c3526b$export$7c92bd5ed7bb8364 = /* #__PURE__ */ $4083877d53c3526b$var$alt($4083877d53c3526b$export$829a293c8fabe723)(/* #__PURE__ */ $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("="));
var $4083877d53c3526b$var$parsePart = function(parseK) {
    return function(parseV) {
        return $4083877d53c3526b$var$bind($4083877d53c3526b$var$wrapParser(function($77) {
            return parseK($4083877d53c3526b$var$Key($77));
        })($4083877d53c3526b$var$map1($4083877d53c3526b$var$joinWith(""))($4083877d53c3526b$var$someRec($4083877d53c3526b$var$alt($4083877d53c3526b$var$map1($be985434983c0a5f$export$439306a4dcaafbb9)($4083877d53c3526b$export$829a293c8fabe723))($65049bb6418b06dc$export$212cc4c54b7f9d4d)))))(function(key) {
            return $4083877d53c3526b$var$bind($4083877d53c3526b$var$wrapParser($4083877d53c3526b$var$traverse(function($78) {
                return parseV($4083877d53c3526b$var$Value($78));
            }))($11bbe85c947c529d$export$b9803a97967f594($4083877d53c3526b$var$bind($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("="))(function() {
                return $4083877d53c3526b$var$map1($4083877d53c3526b$var$joinWith(""))($4083877d53c3526b$var$manyRec($4083877d53c3526b$var$alt($4083877d53c3526b$var$map1($be985434983c0a5f$export$439306a4dcaafbb9)($4083877d53c3526b$export$7c92bd5ed7bb8364))($65049bb6418b06dc$export$212cc4c54b7f9d4d)));
            }))))(function(value) {
                return $4083877d53c3526b$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(key, value));
            });
        });
    };
};
var $4083877d53c3526b$export$98e6a39c04603d36 = function(parseK) {
    return function(parseV) {
        var $79 = $4083877d53c3526b$var$bimap(function(v) {
            return v.value0;
        })($4083877d53c3526b$export$6907e5fd9635b283);
        var $80 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($2b6d012b5a71a466$export$4ad9239eebc1597f)($4083877d53c3526b$var$map1($4083877d53c3526b$var$fromFoldable1)($11bbe85c947c529d$export$a0228d318ff1a462($4083877d53c3526b$var$parsePart(parseK)(parseV))($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("&"))));
        return function($81) {
            return $79($80($ce223683b9c93444$export$46c39d7334f59785($81)));
        };
    };
};
var $4083877d53c3526b$export$748790c1f594ba2f = /* #__PURE__ */ function() {
    var $82 = $65049bb6418b06dc$export$cced2b75a857d31f($4083877d53c3526b$export$829a293c8fabe723);
    return function($83) {
        return $4083877d53c3526b$var$Key($82($83));
    };
}();
var $4083877d53c3526b$export$e688e9bfa0af50e7 = {
    to: function(x) {
        return x;
    },
    from: function(x) {
        return x;
    }
};
var $4083877d53c3526b$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($4083877d53c3526b$export$e688e9bfa0af50e7);
var $4083877d53c3526b$export$4be1ac53d00d7f05 = function(dictShow) {
    var showTuple = $71f2e2e9476163f8$export$c29279d1dfdefb95(dictShow);
    return function(dictShow1) {
        return {
            show: $4083877d53c3526b$var$genericShow($544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$bc1180ef96fcb658($2c6b3d51d10471a7$export$5bda33a3389a7225(showTuple($06733ae99ed4f534$export$9b814e760fdd264a(dictShow1)))))($4083877d53c3526b$var$QueryPairsIsSymbol))
        };
    };
};
var $4083877d53c3526b$export$7e7ad869a5fd5749 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $4083877d53c3526b$export$6356368b212c762f = function(dictEq) {
    var eqTuple = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictEq);
    return function(dictEq1) {
        return $37b880af5f4991bd$export$159e06dc5ec60b00(eqTuple($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq1)));
    };
};
var $4083877d53c3526b$export$7ac91c09e470f573 = $37b880af5f4991bd$export$fa624555ca2acbc8;




// Generated by purs version 0.15.15










var $2e891cc83246e2b6$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $2e891cc83246e2b6$var$wrapParser = /* #__PURE__ */ $65049bb6418b06dc$export$26b0cb12afaf64f7($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $2e891cc83246e2b6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $2e891cc83246e2b6$export$c2d084dc44961371 = function(printHost) {
    return function(printPort) {
        return function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "";
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $40b881c663abaa3d$export$fd98f31541acd35d) return $39cc522fd39c4f12$export$c2d084dc44961371(printHost(v.value0.value0));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $40b881c663abaa3d$export$ede717b1aa59264f) return $a56d5e8d101df263$export$c2d084dc44961371(printPort(v.value0.value0));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $40b881c663abaa3d$export$d91d8a092b6c59d3) return $39cc522fd39c4f12$export$c2d084dc44961371(printHost(v.value0.value0)) + $a56d5e8d101df263$export$c2d084dc44961371(printPort(v.value0.value1));
            throw new Error("Failed pattern match at URI.HostPortPair (line 58, column 29 - line 66, column 63): " + [
                v.constructor.name
            ]);
        };
    };
};
var $2e891cc83246e2b6$export$8f49e4af10703ce3 = function(parseHost) {
    return function(parsePort) {
        return $2e891cc83246e2b6$var$bind($11bbe85c947c529d$export$b9803a97967f594($2e891cc83246e2b6$var$wrapParser(parseHost)($39cc522fd39c4f12$export$8f49e4af10703ce3)))(function(mh) {
            return $2e891cc83246e2b6$var$bind($11bbe85c947c529d$export$b9803a97967f594($2e891cc83246e2b6$var$wrapParser(parsePort)($a56d5e8d101df263$export$8f49e4af10703ce3)))(function(mp) {
                return $2e891cc83246e2b6$var$pure(function() {
                    if (mh instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && mp instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$fd98f31541acd35d(mh.value0));
                    if (mh instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && mp instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$ede717b1aa59264f(mp.value0));
                    if (mh instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && mp instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$d91d8a092b6c59d3(mh.value0, mp.value0));
                    if (mh instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && mp instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    throw new Error("Failed pattern match at URI.HostPortPair (line 41, column 8 - line 45, column 32): " + [
                        mh.constructor.name,
                        mp.constructor.name
                    ]);
                }());
            });
        });
    };
};






var $b9f56ead6323c237$var$_hierPart = /* #__PURE__ */ $c558d54e53fc2088$export$37cbedc4b55914e4($65bbf210574f301e$export$311dde6ade8133c7);
var $b9f56ead6323c237$var$_path = /* #__PURE__ */ $d0fc10256bba7201$export$ba3c492dc54826d6($48c79e0fab366ce5$export$3576324867460c38);
var $b9f56ead6323c237$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $b9f56ead6323c237$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $b9f56ead6323c237$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
var $b9f56ead6323c237$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $b9f56ead6323c237$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $b9f56ead6323c237$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $b9f56ead6323c237$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($06733ae99ed4f534$export$b203ef4465f15037);
var $b9f56ead6323c237$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b9f56ead6323c237$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $b9f56ead6323c237$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2b6d012b5a71a466$export$7967a4332fb063d4);
var $b9f56ead6323c237$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $b9f56ead6323c237$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $b9f56ead6323c237$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e);
var $b9f56ead6323c237$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($bc49024203989caa$export$f24ec99cecd50fca);
var $b9f56ead6323c237$var$elements = /* #__PURE__ */ $6482d98559452a87$export$7a5d735b2ab6389d($bc49024203989caa$export$f103a64475a4fd0b)($91ee3359f6bcea22$export$33591d20dac5147e);
var $b9f56ead6323c237$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($4083877d53c3526b$export$b808b1e430bf9524);
var $b9f56ead6323c237$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($4083877d53c3526b$export$7ac91c09e470f573);
var $b9f56ead6323c237$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $b9f56ead6323c237$var$filter = /* #__PURE__ */ $f157a7fafda88939$export$3dea766d36a8935f($f157a7fafda88939$export$352788f778c11933);
var $b9f56ead6323c237$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($4083877d53c3526b$export$7ac91c09e470f573);
var $b9f56ead6323c237$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $b9f56ead6323c237$var$_query = /* #__PURE__ */ $c558d54e53fc2088$export$a6bf5b217f4ae5bf($65bbf210574f301e$export$311dde6ade8133c7);
var $b9f56ead6323c237$var$BasicURL = function(x) {
    return x;
};
var $b9f56ead6323c237$export$d3eab9e9a761ac09 = /* #__PURE__ */ $c558d54e53fc2088$export$5b62b9a09c5181d0($97937c29f879e68e$export$752cdd067643c910)(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46(/* #__PURE__ */ $40b881c663abaa3d$export$8f635747586ce15($39cc522fd39c4f12$export$cd969b2b7da24e75)($a56d5e8d101df263$export$dfaa82d206179b93)))($affc06959d096a42$export$9bb20365e82eaacb)($97937c29f879e68e$export$752cdd067643c910)(/* #__PURE__ */ $4083877d53c3526b$export$92c8a52524a5b159($4083877d53c3526b$export$ee307e7d0c0c420e)($4083877d53c3526b$export$98c58b176174c8b0));
var $b9f56ead6323c237$export$c396f9855a58c80a = /* #__PURE__ */ $c558d54e53fc2088$export$733c65f4ff45e10c($37b880af5f4991bd$export$2965418ef5ae9704)(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e(/* #__PURE__ */ $40b881c663abaa3d$export$398f7d8c6e232fe2($39cc522fd39c4f12$export$78d798b24b7b0fe4)($a56d5e8d101df263$export$55183a1ea5cf7649)))($affc06959d096a42$export$af26477280c1e920)($37b880af5f4991bd$export$2965418ef5ae9704)(/* #__PURE__ */ $4083877d53c3526b$export$6356368b212c762f($4083877d53c3526b$export$7ac91c09e470f573)($4083877d53c3526b$export$7e7ad869a5fd5749));
var $b9f56ead6323c237$export$d94f0b417988a126 = function(path) {
    return function(v) {
        return $5b0358e10bf152e0$export$adaa4cf7ef1b65be(function($117) {
            return $b9f56ead6323c237$var$_hierPart($b9f56ead6323c237$var$_path($117));
        })(path)(v);
    };
};
var $b9f56ead6323c237$export$c2d084dc44961371 = function(v) {
    return $c558d54e53fc2088$export$c2d084dc44961371({
        printUserInfo: $58f3cdfbfe212d20$export$f172309911142386,
        printHosts: $2e891cc83246e2b6$export$c2d084dc44961371($b9f56ead6323c237$var$identity)($b9f56ead6323c237$var$identity),
        printPath: $b9f56ead6323c237$var$identity,
        printHierPath: $58f3cdfbfe212d20$export$f172309911142386,
        printQuery: $4083877d53c3526b$export$c2d084dc44961371($b9f56ead6323c237$var$identity)($b9f56ead6323c237$var$identity)
    })(v);
};
var $b9f56ead6323c237$export$a438c3a1b8645bfe = function(urls) {
    return $5b07e36f812dd04b$export$ec1dc8fbeea3467e(",")($b9f56ead6323c237$var$map($b9f56ead6323c237$export$c2d084dc44961371)($e39dfcf102cdca3c$export$45b10814cc054894(urls)));
};
var $b9f56ead6323c237$export$32f464e0a5764126 = {
    encodeJson: function(url) {
        return $b9f56ead6323c237$var$encodeJson($b9f56ead6323c237$export$c2d084dc44961371(url));
    }
};
var $b9f56ead6323c237$export$fe2f838f7144ced1 = {
    show: function(url) {
        return "BasicURL.fromString " + $b9f56ead6323c237$var$show($b9f56ead6323c237$export$c2d084dc44961371(url));
    }
};
var $b9f56ead6323c237$var$parser = /* #__PURE__ */ function() {
    return $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($2b6d012b5a71a466$export$858eabc7228a4f5b)($c558d54e53fc2088$export$8f49e4af10703ce3({
        parseUserInfo: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $7d4cccdf062a2261$export$37c4d04eafdc5515("User info is not supported")),
        parseHosts: $2e891cc83246e2b6$export$8f49e4af10703ce3($b9f56ead6323c237$var$pure)($b9f56ead6323c237$var$pure),
        parsePath: $b9f56ead6323c237$var$pure,
        parseHierPath: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Hier paths are not supported")),
        parseQuery: $4083877d53c3526b$export$98e6a39c04603d36($b9f56ead6323c237$var$pure)($b9f56ead6323c237$var$pure)
    }))($b9f56ead6323c237$var$BasicURL);
}();
var $b9f56ead6323c237$export$98e6a39c04603d36 = function(str) {
    return $2b6d012b5a71a466$export$4ad9239eebc1597f(str)($b9f56ead6323c237$var$parser);
};
var $b9f56ead6323c237$export$c9b2085314771d6f = function(str) {
    var parts = $5b07e36f812dd04b$export$65980d18b75784e2(",")(str);
    return $b9f56ead6323c237$var$bind($b9f56ead6323c237$var$traverse(function($118) {
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($b9f56ead6323c237$export$98e6a39c04603d36($118));
    })(parts))(function(partsParsed) {
        return $e39dfcf102cdca3c$export$571d59b505e6bb4e(partsParsed);
    });
};
var $b9f56ead6323c237$export$2a7da4e8bb63ce2d = {
    decodeJson: function(json) {
        return $b9f56ead6323c237$var$bind1($b9f56ead6323c237$var$decodeJson(json))(function(v) {
            var mapError = function(err) {
                return new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Error parsing URL " + (v + (": " + $b9f56ead6323c237$var$show1(err))));
            };
            var result = $b9f56ead6323c237$export$98e6a39c04603d36(v);
            return $b9f56ead6323c237$var$lmap(mapError)(result);
        });
    }
};
var $b9f56ead6323c237$export$78431a15e874892c = {
    parseValue: function($119) {
        return $7d4cccdf062a2261$export$3a6c138b8d0f3874($b9f56ead6323c237$export$98e6a39c04603d36($119));
    }
};
var $b9f56ead6323c237$export$dd44f18ab656f3bb = function(scheme) {
    return function(host) {
        return function(port) {
            return function(path) {
                return function(query) {
                    return new $c558d54e53fc2088$export$38616893db4b7095(scheme, new $d0fc10256bba7201$export$a92244b8f5b77411(new $e958b450d709607c$export$f1c6ec2e6d68c49c($06733ae99ed4f534$export$bebe9059409a0d04.value, new $06733ae99ed4f534$export$8a67b48435b5d073(new $40b881c663abaa3d$export$d91d8a092b6c59d3(host, port))), path), query);
                };
            };
        };
    };
};
var $b9f56ead6323c237$export$51dfa1fd090a7c00 = {
    arbitrary: /* #__PURE__ */ function() {
        var unsafeMkScheme = function(str) {
            return $06733ae99ed4f534$export$770f48d991b0f2a2(function(v) {
                return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid scheme: " + str);
            })($ff3693eeb39da812$export$3004f64547af360e(str));
        };
        var unsafeMkQuery = function(str) {
            return $7d4cccdf062a2261$export$f41f6e6ed5e42617(function(v) {
                return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid query: " + str);
            })($4083877d53c3526b$export$98e6a39c04603d36($b9f56ead6323c237$var$pure)($b9f56ead6323c237$var$pure)($ce223683b9c93444$export$3004f64547af360e(str)));
        };
        var unsafeMkPort = function(str) {
            return $06733ae99ed4f534$export$770f48d991b0f2a2(function(v) {
                return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid port: " + $b9f56ead6323c237$var$show2(str));
            })($a56d5e8d101df263$export$62ffe363f1b08494(str));
        };
        var unsafeMkPath = function(str) {
            return $7d4cccdf062a2261$export$f41f6e6ed5e42617(function(v) {
                return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid path: " + str);
            })($2b6d012b5a71a466$export$4ad9239eebc1597f(str)($affc06959d096a42$export$8f49e4af10703ce3));
        };
        var unsafeMkHost = function(str) {
            return $7d4cccdf062a2261$export$f41f6e6ed5e42617(function(v) {
                return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid host: " + str);
            })($2b6d012b5a71a466$export$4ad9239eebc1597f(str)($39cc522fd39c4f12$export$8f49e4af10703ce3));
        };
        var schemes = $b9f56ead6323c237$var$map1(unsafeMkScheme)($e39dfcf102cdca3c$export$cc3b5f3f66225fbe("http")([
            "https",
            "ftp"
        ]));
        var queries = $b9f56ead6323c237$var$map1(unsafeMkQuery)($e39dfcf102cdca3c$export$cc3b5f3f66225fbe("?")([
            "?foo=bar",
            "?foo=bar&baz=qux"
        ]));
        var ports = $b9f56ead6323c237$var$map1(unsafeMkPort)($e39dfcf102cdca3c$export$cc3b5f3f66225fbe(80)([
            443,
            8080,
            8081,
            8082,
            8083,
            8084,
            8085,
            8086
        ]));
        var paths = $b9f56ead6323c237$var$map1(unsafeMkPath)($e39dfcf102cdca3c$export$cc3b5f3f66225fbe("/")([
            "/foo",
            "/foo/bar",
            "/foo/bar/baz"
        ]));
        var hosts = $b9f56ead6323c237$var$map1(unsafeMkHost)($e39dfcf102cdca3c$export$cc3b5f3f66225fbe("example.com")([
            "192.168.0.1",
            "172.16.254.1",
            "10.0.0.2"
        ]));
        return $b9f56ead6323c237$var$apply($b9f56ead6323c237$var$apply($b9f56ead6323c237$var$apply($b9f56ead6323c237$var$apply($f4b2eb11fc32ed34$export$871de8747c9eaa88($bc49024203989caa$export$5d116872cdd6398d)(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return $b9f56ead6323c237$export$dd44f18ab656f3bb(v)(v1)(v2)(v3)(v4);
                        };
                    };
                };
            };
        })($b9f56ead6323c237$var$elements(schemes)))($b9f56ead6323c237$var$elements(hosts)))($b9f56ead6323c237$var$elements(ports)))($b9f56ead6323c237$var$elements(paths)))($b9f56ead6323c237$var$elements($e39dfcf102cdca3c$export$8327ebbef2a0ba76($06733ae99ed4f534$export$bebe9059409a0d04.value)($b9f56ead6323c237$var$map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(queries))));
    }()
};
var $b9f56ead6323c237$export$6a835e070ba60ba0 = function(v) {
    return $06733ae99ed4f534$export$43db023a260c5e9f($b9f56ead6323c237$var$mempty)(v.value2);
};
var $b9f56ead6323c237$export$f3df203850dc0dd8 = function(paramName) {
    return function(url) {
        var key = $4083877d53c3526b$export$748790c1f594ba2f(paramName);
        var v = $b9f56ead6323c237$export$6a835e070ba60ba0(url);
        var tuple = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(v1) {
            return $b9f56ead6323c237$var$eq(v1.value0)(key);
        })(v);
        return $b9f56ead6323c237$var$map2(function(v1) {
            return $b9f56ead6323c237$var$map2($4083877d53c3526b$export$7fcada0453713929)(v1.value1);
        })(tuple);
    };
};
var $b9f56ead6323c237$export$3004f64547af360e = function() {
    return function(str) {
        return $7d4cccdf062a2261$export$f41f6e6ed5e42617(function(v) {
            return $8bcde8f642a64c7d$export$51b220bae4359b72("invalid url");
        })($b9f56ead6323c237$export$98e6a39c04603d36(str));
    };
};
var $b9f56ead6323c237$var$addQueryParameterImpl = function(overwrite) {
    return function(key) {
        return function(value) {
            return function(v) {
                var addQuery = function(initialQuery) {
                    var v1 = $06733ae99ed4f534$export$43db023a260c5e9f($b9f56ead6323c237$var$mempty)(initialQuery);
                    var encValue = $b9f56ead6323c237$var$map2($4083877d53c3526b$export$84c91e425ef00fa1)(value);
                    var encKey = $4083877d53c3526b$export$748790c1f594ba2f(key);
                    var filtered = $b9f56ead6323c237$var$filter(function($120) {
                        return function(v2) {
                            return $b9f56ead6323c237$var$notEq(v2)(encKey);
                        }($71f2e2e9476163f8$export$9e770fa6ce19a9d6($120));
                    })(v1);
                    var $112 = overwrite || $fc8c1182ec2aefec$export$f24224f1c91d8156(filtered) === $fc8c1182ec2aefec$export$f24224f1c91d8156(v1);
                    if ($112) return $b9f56ead6323c237$var$append1(filtered)([
                        new $71f2e2e9476163f8$export$1908877435b1d5e9(encKey, encValue)
                    ]);
                    return v1;
                };
                return $5b0358e10bf152e0$export$fb4902fd9e525693($b9f56ead6323c237$var$_query)(function($121) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create(addQuery($121));
                })(v);
            };
        };
    };
};
var $b9f56ead6323c237$export$9468cba4d014a896 = /* #__PURE__ */ $b9f56ead6323c237$var$addQueryParameterImpl(false);
var $b9f56ead6323c237$export$73c2a24238aa8f0c = /* #__PURE__ */ $b9f56ead6323c237$var$addQueryParameterImpl(true);
var $b9f56ead6323c237$export$39a7adaa6215a5d2 = function(newSegment) {
    return function(v) {
        var addSegment = function(v1) {
            return $396c4c3d9e7fae3c$export$c40cf5aab899f397(v1)(newSegment);
        };
        return $5b0358e10bf152e0$export$fb4902fd9e525693(function($122) {
            return $b9f56ead6323c237$var$_hierPart($b9f56ead6323c237$var$_path($122));
        })(addSegment)(v);
    };
};
var $b9f56ead6323c237$export$887ac8ee5e08dcad = function(dictStrong) {
    var setter = function(v) {
        return function(uri) {
            return uri;
        };
    };
    var getter = function(v) {
        return v;
    };
    var $123 = $03856732e0180b78$export$21cde5187c2605a3(getter)(setter)(dictStrong);
    var $124 = $c558d54e53fc2088$export$887ac8ee5e08dcad(dictStrong);
    return function($125) {
        return $123($124($125));
    };
};










// Generated by purs version 0.15.15













var $91dd73a7945cfe05$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $91dd73a7945cfe05$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $91dd73a7945cfe05$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $91dd73a7945cfe05$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $91dd73a7945cfe05$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $91dd73a7945cfe05$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $91dd73a7945cfe05$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $91dd73a7945cfe05$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $91dd73a7945cfe05$var$fromEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $91dd73a7945cfe05$var$fromEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $91dd73a7945cfe05$var$pad = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v === 0) {
                $tco_done = true;
                return v1;
            }
            if (v === 1) {
                $tco_done = true;
                return "0" + v1;
            }
            $tco_var_v = v - 1 | 0;
            $copy_v1 = "0" + v1;
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $91dd73a7945cfe05$export$35ab1104d640300a = function(n) {
    return function(str) {
        return $91dd73a7945cfe05$var$pad(n - $3ee2158c14339cc9$export$f24224f1c91d8156(str) | 0)(str);
    };
};
var $91dd73a7945cfe05$export$b4c06bb854ea5a32 = function(dictMonadError) {
    var liftEither = $5dfefa023749ded0$export$bd6bd7bb5418f998(dictMonadError.MonadThrow0());
    return function(mapErr) {
        var $33 = $91dd73a7945cfe05$var$lmap(mapErr);
        return function($34) {
            return liftEither($33($34));
        };
    };
};
var $91dd73a7945cfe05$export$b5443d4f570b75b4 = function(dictMonadError) {
    var liftEither = $5dfefa023749ded0$export$bd6bd7bb5418f998(dictMonadError.MonadThrow0());
    return function(dictMonadAff) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonadAff.MonadEffect0().Monad0().Bind1());
        var liftAff = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
        return function(mapErr) {
            return function(io) {
                return bind(liftAff($91dd73a7945cfe05$var$map($91dd73a7945cfe05$var$lmap(mapErr))(io)))(liftEither);
            };
        };
    };
};
var $91dd73a7945cfe05$export$e003485a67becadb = function(v) {
    var encodeTime = function(t) {
        return $91dd73a7945cfe05$export$35ab1104d640300a(2)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum($d254595454e6e9b0$export$842e383dfc19bc67(t)))) + (":" + ($91dd73a7945cfe05$export$35ab1104d640300a(2)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum1($d254595454e6e9b0$export$1cacba1045a8e790(t)))) + (":" + ($91dd73a7945cfe05$export$35ab1104d640300a(2)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum2($d254595454e6e9b0$export$3d3c77ce7df7d30d(t)))) + ("." + ($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum3($d254595454e6e9b0$export$edc5e5cb87280477(t))) + "Z"))))));
    };
    var encodeDate = function(d) {
        return $91dd73a7945cfe05$export$35ab1104d640300a(4)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum4($7577649a7445e8e0$export$31803937850fb2da(d)))) + ("-" + ($91dd73a7945cfe05$export$35ab1104d640300a(2)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum5($7577649a7445e8e0$export$af5de1609f06c8e6(d)))) + ("-" + $91dd73a7945cfe05$export$35ab1104d640300a(2)($91dd73a7945cfe05$var$show($91dd73a7945cfe05$var$fromEnum6($7577649a7445e8e0$export$d2d39d1adcc883a2(d)))))));
    };
    return encodeDate(v.value0) + ("T" + encodeTime(v.value1));
};


var $0dd27f203988b439$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $0dd27f203988b439$var$bindExceptT = /* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e);
var $0dd27f203988b439$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($0dd27f203988b439$var$bindExceptT);
var $0dd27f203988b439$var$monadErrorExceptT = /* #__PURE__ */ $d2284b2d3e1b6f87$export$78c1353d784c47dd($edf0339512807bee$export$b147a380fa8fdc0e);
var $0dd27f203988b439$var$liftAffErr = /* #__PURE__ */ $91dd73a7945cfe05$export$b5443d4f570b75b4($0dd27f203988b439$var$monadErrorExceptT)(/* #__PURE__ */ $b6d6cce78665f23d$export$87a4e9dc50af0c41($b6d6cce78665f23d$export$bd75e69808ef8e57));
var $0dd27f203988b439$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($0dd27f203988b439$var$bindExceptT);
var $0dd27f203988b439$var$applicativeExceptT = /* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e);
var $0dd27f203988b439$var$unless = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$6f0673371501d6b6($0dd27f203988b439$var$applicativeExceptT);
var $0dd27f203988b439$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($6f224010b6164ac0$export$20b6cc2eca112841);
var $0dd27f203988b439$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055(/* #__PURE__ */ $d2284b2d3e1b6f87$export$75f89ba5e7a712b0($edf0339512807bee$export$b147a380fa8fdc0e));
var $0dd27f203988b439$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($6f224010b6164ac0$export$3a7dfd032479a874);
var $0dd27f203988b439$var$liftEitherErr = /* #__PURE__ */ $91dd73a7945cfe05$export$b4c06bb854ea5a32($0dd27f203988b439$var$monadErrorExceptT);
var $0dd27f203988b439$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($59dadf91e1f9eb9a$export$d3ac27ab5a0173d);
var $0dd27f203988b439$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($0dd27f203988b439$var$applicativeExceptT);
var $0dd27f203988b439$export$80924b6edd3335d0 = function(opts) {
    var mayQueryEncoded = $0dd27f203988b439$var$map(opts.encodeQuery)(opts.query);
    var mayBodyEncoded = $0dd27f203988b439$var$map(function($21) {
        return $1bb5df538ea16bd9$export$7b419323e6ed4f31(opts.encodeBody($21));
    })(opts.body);
    var headers = [
        $0dd27f203988b439$var$map(function(tok) {
            return new $04f1e5e12069f6d8$export$21640746b57e4864("Authorization", "Bearer " + tok);
        })(opts.token)
    ];
    var fullUrl = $b9f56ead6323c237$export$c2d084dc44961371(opts.baseUrl) + ("/" + (opts.path + ("/" + $06733ae99ed4f534$export$43db023a260c5e9f("")(mayQueryEncoded))));
    var req = {
        username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
        password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
        withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
        timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
        responseFormat: $c02e13aaef170b91$export$7b419323e6ed4f31,
        method: new $7d4cccdf062a2261$export$37c4d04eafdc5515(opts.method),
        url: fullUrl,
        content: mayBodyEncoded,
        headers: $396c4c3d9e7fae3c$export$986c2bbe7a34be0b(headers)
    };
    return $d2284b2d3e1b6f87$export$8291c2122093ac93($0dd27f203988b439$var$bind($0dd27f203988b439$var$liftAffErr($3b38984084ed8eff$export$55ee1551a3f962e6)($f13553b3f174bc1f$export$b5fe3f66a567bec0(req)))(function(result) {
        return $0dd27f203988b439$var$discard($0dd27f203988b439$var$unless($0dd27f203988b439$var$eq(result.status)(200))($0dd27f203988b439$var$throwError("Request failed with status: " + $0dd27f203988b439$var$show(result.status))))(function() {
            return $0dd27f203988b439$var$bind($0dd27f203988b439$var$liftEitherErr($0dd27f203988b439$var$show1)(opts.decodeResponse(result.body)))(function(val) {
                return $0dd27f203988b439$var$pure(val);
            });
        });
    }));
};









// Generated by purs version 0.15.15






// Generated by purs version 0.15.15











var $371e0b86ca22b610$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $371e0b86ca22b610$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $371e0b86ca22b610$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $371e0b86ca22b610$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $371e0b86ca22b610$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $371e0b86ca22b610$export$b0569af1074bf9f5 = function(name) {
    return function(printTag) {
        return function(parseTag) {
            return function(f) {
                return function(g) {
                    var encodeCase = function(a) {
                        var v = g(a);
                        return $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$685e5903508e8c02)($03b6b966974423fe$export$c764c4f4747e1972(function __do() {
                            var obj = $0061661dcaa2328e$export$b8cb59497041ffe4();
                            $0061661dcaa2328e$export$dc13bdd74c909d26("tag")($4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$22b082955e083ec3)(printTag(v.value0)))(obj)();
                            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($371e0b86ca22b610$var$pure(obj))(function(v1) {
                                return $0061661dcaa2328e$export$dc13bdd74c909d26("value")(v1)(obj);
                            })(v.value1)();
                        }));
                    };
                    var decodeCase = function(j) {
                        return $371e0b86ca22b610$var$lmap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create(name))($371e0b86ca22b610$var$bind1($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$685e5903508e8c02)(j))(function(obj) {
                            return $371e0b86ca22b610$var$bind1($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$977f3f6a9323c0f6("tag")($59dadf91e1f9eb9a$export$22b082955e083ec3))(obj))(function(tag) {
                                var v = parseTag(tag);
                                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$26ae1106fd92d0a8("tag", new $59dadf91e1f9eb9a$export$35fbad60f29e98f2($0e031af7428ef07d$export$dbafa4424a806c15(tag))));
                                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                    var v1 = f(v.value0);
                                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $371e0b86ca22b610$var$pure1(v1.value0);
                                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $371e0b86ca22b610$var$bind1($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$977f3f6a9323c0f6("value")($59dadf91e1f9eb9a$export$7b419323e6ed4f31))(obj))(function(value) {
                                        return $371e0b86ca22b610$var$lmap($59dadf91e1f9eb9a$export$26ae1106fd92d0a8.create("value"))(v1.value0(value));
                                    });
                                    throw new Error("Failed pattern match at Data.Codec.Argonaut.Sum (line 59, column 9 - line 63, column 52): " + [
                                        v1.constructor.name
                                    ]);
                                }
                                throw new Error("Failed pattern match at Data.Codec.Argonaut.Sum (line 56, column 5 - line 63, column 52): " + [
                                    v.constructor.name
                                ]);
                            });
                        }));
                    };
                    return $4672333bf471fbe0$export$1c37c01eba8ed446(decodeCase)(encodeCase);
                };
            };
        };
    };
};
var $371e0b86ca22b610$export$2fd5b39dc7d6bb7a = function(printTag) {
    return function(parseTag) {
        return $4672333bf471fbe0$export$1c37c01eba8ed446(function(j) {
            return $371e0b86ca22b610$var$bindFlipped(function() {
                var $18 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$35fbad60f29e98f2(j)))($7d4cccdf062a2261$export$19db0165690c701a.create);
                return function($19) {
                    return $18(parseTag($19));
                };
            }())($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$22b082955e083ec3)(j));
        })(function() {
            var $20 = $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$22b082955e083ec3);
            return function($21) {
                return $20(printTag($21));
            };
        }());
    };
};













// Generated by purs version 0.15.15













var $5d234b0186e94f32$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $5d234b0186e94f32$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $5d234b0186e94f32$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $5d234b0186e94f32$var$foldMap1 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($78c799cba34fcb8d$export$b16c60cd2a91c938);
var $5d234b0186e94f32$var$foldr1 = /* #__PURE__ */ $086486679aa806fa$export$c8b99533c112636f($78c799cba34fcb8d$export$b16c60cd2a91c938);
var $5d234b0186e94f32$var$foldl1 = /* #__PURE__ */ $086486679aa806fa$export$eb5e1ef4ea2eca3d($78c799cba34fcb8d$export$b16c60cd2a91c938);
var $5d234b0186e94f32$var$NonEmptySet = function(x) {
    return x;
};
var $5d234b0186e94f32$export$3a88d122b15b2ce7 = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($d7bf9817a417d4ae$export$10d8903dec122b9d($a393155e52307a24$export$7c6a06df4f9b9fb3(dictOrd)));
};
var $5d234b0186e94f32$export$d1f81bca2a8c7b07 = function(dictUnfoldable1) {
    var stepNext = $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, next));
    })(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
    var stepHead = $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(k, next);
    })(function(v) {
        return $8bcde8f642a64c7d$export$51b220bae4359b72("toUnfoldable1: impossible");
    });
    var $82 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)(function(v) {
        return $5d234b0186e94f32$var$map1(stepNext)(v);
    });
    return function($83) {
        return $82(stepHead($ea3eb84de0acf574$export$a07cd7d770cb0fb3($a393155e52307a24$export$e98af36a72b77685($5d234b0186e94f32$var$coerce($83)))));
    };
};
var $5d234b0186e94f32$var$toUnfoldable11 = /* #__PURE__ */ $5d234b0186e94f32$export$d1f81bca2a8c7b07($91ee3359f6bcea22$export$5cc19ce746f40583);
var $5d234b0186e94f32$var$toUnfoldable12 = /* #__PURE__ */ $5d234b0186e94f32$export$d1f81bca2a8c7b07($78c799cba34fcb8d$export$6907256bb4275b5b);
var $5d234b0186e94f32$export$823be24f8766da23 = function(dictUnfoldable) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$823be24f8766da23(dictUnfoldable));
};
var $5d234b0186e94f32$export$f416efe173c6901c = function(v) {
    return v;
};
var $5d234b0186e94f32$export$e06bd7b1ab877a71 = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$e06bd7b1ab877a71(dictOrd));
};
var $5d234b0186e94f32$export$346677f925de839c = /* #__PURE__ */ $5d234b0186e94f32$var$coerce($a393155e52307a24$export$346677f925de839c);
var $5d234b0186e94f32$export$439306a4dcaafbb9 = /* #__PURE__ */ $5d234b0186e94f32$var$coerce($a393155e52307a24$export$439306a4dcaafbb9);
var $5d234b0186e94f32$export$b3c916a0320e8908 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($91ee3359f6bcea22$export$58eaac0549d62906(dictShow));
    return {
        show: function(s) {
            return "(fromFoldable1 " + (show($5d234b0186e94f32$var$toUnfoldable11(s)) + ")");
        }
    };
};
var $5d234b0186e94f32$export$9b7257801ab5f207 = function(dictOrd) {
    return $a393155e52307a24$export$7c6a06df4f9b9fb3(dictOrd);
};
var $5d234b0186e94f32$export$fed8bbb04775a01f = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$fed8bbb04775a01f(dictOrd));
};
var $5d234b0186e94f32$export$b077a83c6687d61e = function(dictOrd) {
    return $a393155e52307a24$export$273c875222ee923d(dictOrd);
};
var $5d234b0186e94f32$export$2d5fb2e9733c92fd = $a393155e52307a24$export$3f209a28ab615424;
var $5d234b0186e94f32$export$96ec731ed4dcb222 = function(v) {
    return $5d234b0186e94f32$var$fromJust($a393155e52307a24$export$3c39a95b7a4d5e28(v));
};
var $5d234b0186e94f32$export$6a0d13241802fe80 = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$6a0d13241802fe80(dictOrd));
};
var $5d234b0186e94f32$export$8960430cfd85939f = function(v) {
    return $5d234b0186e94f32$var$fromJust($a393155e52307a24$export$35f577b3da447d17(v));
};
var $5d234b0186e94f32$export$e70771d2e7e590a = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$e70771d2e7e590a(dictOrd));
};
var $5d234b0186e94f32$export$871de8747c9eaa88 = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$871de8747c9eaa88(dictOrd));
};
var $5d234b0186e94f32$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd));
};
var $5d234b0186e94f32$export$7d98477f9d1e986f = function(s) {
    var $75 = $a393155e52307a24$export$dd1bc94b04021eeb(s);
    if ($75) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(s);
};
var $5d234b0186e94f32$export$bc86dfbf7795668c = function(dictOrd) {
    var intersection1 = $a393155e52307a24$export$bc86dfbf7795668c(dictOrd);
    return function(v) {
        return function(v1) {
            return $5d234b0186e94f32$export$7d98477f9d1e986f(intersection1(v)(v1));
        };
    };
};
var $5d234b0186e94f32$export$95b95426129653f6 = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictOrd) {
        return foldMap11($5d234b0186e94f32$export$9b7257801ab5f207(dictOrd))($5d234b0186e94f32$export$439306a4dcaafbb9);
    };
};
var $5d234b0186e94f32$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable2 = $a393155e52307a24$export$b7d5d9bb9ff52072(dictFoldable);
    return function(dictOrd) {
        var $84 = fromFoldable2(dictOrd);
        return function($85) {
            return $5d234b0186e94f32$export$7d98477f9d1e986f($84($85));
        };
    };
};
var $5d234b0186e94f32$export$e05aa42557fda917 = $a393155e52307a24$export$fd19c21b7e75dff0;
var $5d234b0186e94f32$export$d05a0aeae9b4a707 = {
    foldMap1: function(dictSemigroup) {
        var foldMap11 = $5d234b0186e94f32$var$foldMap1(dictSemigroup);
        return function(f) {
            var $86 = foldMap11(f);
            return function($87) {
                return $86($5d234b0186e94f32$var$toUnfoldable12($87));
            };
        };
    },
    foldr1: function(f) {
        var $88 = $5d234b0186e94f32$var$foldr1(f);
        return function($89) {
            return $88($5d234b0186e94f32$var$toUnfoldable12($89));
        };
    },
    foldl1: function(f) {
        var $90 = $5d234b0186e94f32$var$foldl1(f);
        return function($91) {
            return $90($5d234b0186e94f32$var$toUnfoldable12($91));
        };
    },
    Foldable0: function() {
        return $5d234b0186e94f32$export$e05aa42557fda917;
    }
};
var $5d234b0186e94f32$export$3dea766d36a8935f = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$3dea766d36a8935f(dictOrd));
};
var $5d234b0186e94f32$export$c76767288a60785f = function(dictEq) {
    return $a393155e52307a24$export$15038a5bf6277d57(dictEq);
};
var $5d234b0186e94f32$export$8269333b3e669fb8 = $a393155e52307a24$export$886f72205c1e73dc;
var $5d234b0186e94f32$export$acaf96a27438246b = function(dictOrd) {
    var difference1 = $a393155e52307a24$export$acaf96a27438246b(dictOrd);
    return function(v) {
        return function(v1) {
            return $5d234b0186e94f32$export$7d98477f9d1e986f(difference1(v)(v1));
        };
    };
};
var $5d234b0186e94f32$export$1822828d790e23ee = function(dictOrd) {
    var delete1 = $a393155e52307a24$export$1822828d790e23ee(dictOrd);
    return function(a) {
        return function(v) {
            return $5d234b0186e94f32$export$7d98477f9d1e986f(delete1(a)(v));
        };
    };
};
var $5d234b0186e94f32$export$8327ebbef2a0ba76 = function(dictOrd) {
    return $5d234b0186e94f32$var$coerce($a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd));
};







var $2cc1e29b7237f20d$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c(/* #__PURE__ */ $4672333bf471fbe0$export$28632269e4a04430($7d4cccdf062a2261$export$d5df7cb019d08f04)($78c799cba34fcb8d$export$11cb7909a85856b));
var $2cc1e29b7237f20d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $4672333bf471fbe0$export$1eacdb5c4de310e7($7d4cccdf062a2261$export$f0a413d3d6075601));
var $2cc1e29b7237f20d$var$profunctorCodec = /* #__PURE__ */ $4672333bf471fbe0$export$255bfd6acde6dd7($7d4cccdf062a2261$export$f0a413d3d6075601);
var $2cc1e29b7237f20d$var$lcmap = /* #__PURE__ */ $9be1c75e3223ee2e$export$48f54268254cf7d0($2cc1e29b7237f20d$var$profunctorCodec);
var $2cc1e29b7237f20d$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $2cc1e29b7237f20d$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $2cc1e29b7237f20d$var$fromFoldableWithIndex = /* #__PURE__ */ $ea3eb84de0acf574$export$78cfe3464e7eb77b($97937c29f879e68e$export$c5f2758e49b2b86a)($c045ea5df33bba60$export$341deb6f42c48978);
var $2cc1e29b7237f20d$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $2cc1e29b7237f20d$var$fromFoldableWithIndex1 = /* #__PURE__ */ $c045ea5df33bba60$export$78cfe3464e7eb77b($ea3eb84de0acf574$export$91e1c50dfb7225a6);
var $2cc1e29b7237f20d$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($ea3eb84de0acf574$export$3930f636962ed944);
var $2cc1e29b7237f20d$var$dimap = /* #__PURE__ */ $9be1c75e3223ee2e$export$7c344215185fc3ac($2cc1e29b7237f20d$var$profunctorCodec);
var $2cc1e29b7237f20d$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $2cc1e29b7237f20d$var$fromFoldable1 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2cc1e29b7237f20d$var$fromFoldable2 = /* #__PURE__ */ $5d234b0186e94f32$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2cc1e29b7237f20d$var$toUnfoldable = /* #__PURE__ */ $5d234b0186e94f32$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $2cc1e29b7237f20d$var$fromFoldable3 = /* #__PURE__ */ $ba51d599f79a6310$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2cc1e29b7237f20d$var$fromFoldable4 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$604c31769a93bbe0);
var $2cc1e29b7237f20d$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $2cc1e29b7237f20d$var$fromFoldable5 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $2cc1e29b7237f20d$var$fromFoldable6 = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $2cc1e29b7237f20d$export$65e3907585753458 = function(codecA) {
    return function(codecB) {
        return $59dadf91e1f9eb9a$export$4201f0c4645b3d26("Tuple")($2cc1e29b7237f20d$var$apply($2cc1e29b7237f20d$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create)($2cc1e29b7237f20d$var$lcmap($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($59dadf91e1f9eb9a$export$b610b8812bbcded9(0)(codecA))))($2cc1e29b7237f20d$var$lcmap($71f2e2e9476163f8$export$6f71268a1666ab58)($59dadf91e1f9eb9a$export$b610b8812bbcded9(1)(codecB))));
    };
};
var $2cc1e29b7237f20d$export$4dbc9bb913ac528d = function(codec) {
    return $4672333bf471fbe0$export$a1db28a6a036e024($2cc1e29b7237f20d$var$composeKleisliFlipped(function() {
        var $54 = $2cc1e29b7237f20d$var$map2($2cc1e29b7237f20d$var$fromFoldableWithIndex);
        var $55 = $2cc1e29b7237f20d$var$traverse($4672333bf471fbe0$export$2f872c0f2117be69(codec));
        return function($56) {
            return $54($55($56));
        };
    }())($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$685e5903508e8c02)))(function() {
        var $57 = $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$685e5903508e8c02);
        var $58 = $2cc1e29b7237f20d$var$map3($4672333bf471fbe0$export$c564cdbbe6da493(codec));
        return function($59) {
            return $57($2cc1e29b7237f20d$var$fromFoldableWithIndex1($58($59)));
        };
    }());
};
var $2cc1e29b7237f20d$export$adaa4cf7ef1b65be = function(dictOrd) {
    var fromFoldable7 = $2cc1e29b7237f20d$var$fromFoldable1(dictOrd);
    return function(codec) {
        return $2cc1e29b7237f20d$var$dimap($2cc1e29b7237f20d$var$fromFoldable)(fromFoldable7)($59dadf91e1f9eb9a$export$e1744e1bc4c7f337("Set")($59dadf91e1f9eb9a$export$2f23118c22fb2630(codec)));
    };
};
var $2cc1e29b7237f20d$export$cf37a15c1da41d8f = /* #__PURE__ */ $59dadf91e1f9eb9a$export$56923548158521c8("NonEmptyString")($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$f84e8e69fd4488a5)($59dadf91e1f9eb9a$export$22b082955e083ec3);
var $2cc1e29b7237f20d$export$ab42a0145f5020c6 = function(dictOrd) {
    var fromFoldable7 = $2cc1e29b7237f20d$var$fromFoldable2(dictOrd);
    return function(codec) {
        return $59dadf91e1f9eb9a$export$56923548158521c8("NonEmptySet")(fromFoldable7)($2cc1e29b7237f20d$var$toUnfoldable)($59dadf91e1f9eb9a$export$2f23118c22fb2630(codec));
    };
};
var $2cc1e29b7237f20d$export$889482be59f95193 = function(codec) {
    return $59dadf91e1f9eb9a$export$56923548158521c8("NonEmptyList")($2cc1e29b7237f20d$var$fromFoldable3)($2cc1e29b7237f20d$var$fromFoldable4)($59dadf91e1f9eb9a$export$2f23118c22fb2630(codec));
};
var $2cc1e29b7237f20d$export$a5383a53b408af94 = function(codec) {
    return $59dadf91e1f9eb9a$export$56923548158521c8("NonEmptyArray")($e39dfcf102cdca3c$export$571d59b505e6bb4e)($e39dfcf102cdca3c$export$45b10814cc054894)($59dadf91e1f9eb9a$export$2f23118c22fb2630(codec));
};
var $2cc1e29b7237f20d$export$f8b8b9ce72e9ccbf = function(codec) {
    var printTag = function(v) {
        if (!v) return "Nothing";
        if (v) return "Just";
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 45, column 14 - line 47, column 18): " + [
            v.constructor.name
        ]);
    };
    var parseTag = function(v) {
        if (v === "Nothing") return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        if (v === "Just") return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    var enc = function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $71f2e2e9476163f8$export$1908877435b1d5e9(false, $06733ae99ed4f534$export$bebe9059409a0d04.value);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $71f2e2e9476163f8$export$1908877435b1d5e9(true, new $06733ae99ed4f534$export$8a67b48435b5d073($4672333bf471fbe0$export$c564cdbbe6da493(codec)(v.value0)));
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 55, column 9 - line 57, column 48): " + [
            v.constructor.name
        ]);
    };
    var dec = function(v) {
        if (!v) return new $7d4cccdf062a2261$export$37c4d04eafdc5515($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if (v) return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
            var $60 = $2cc1e29b7237f20d$var$map2($06733ae99ed4f534$export$8a67b48435b5d073.create);
            var $61 = $4672333bf471fbe0$export$2f872c0f2117be69(codec);
            return function($62) {
                return $60($61($62));
            };
        }());
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 52, column 9 - line 54, column 47): " + [
            v.constructor.name
        ]);
    };
    return $371e0b86ca22b610$export$b0569af1074bf9f5("Maybe")(printTag)(parseTag)(dec)(enc);
};
var $2cc1e29b7237f20d$export$871de8747c9eaa88 = function(dictOrd) {
    var fromFoldable7 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072(dictOrd)($4fe7b6acfba7f29f$export$e97014618a7eb593);
    return function(codecA) {
        return function(codecB) {
            return $2cc1e29b7237f20d$var$dimap($2cc1e29b7237f20d$var$toUnfoldable1)(fromFoldable7)($59dadf91e1f9eb9a$export$e1744e1bc4c7f337("Map")($59dadf91e1f9eb9a$export$2f23118c22fb2630($2cc1e29b7237f20d$export$65e3907585753458(codecA)(codecB))));
        };
    };
};
var $2cc1e29b7237f20d$export$8837f4fc672e936d = function(codec) {
    return $2cc1e29b7237f20d$var$dimap($2cc1e29b7237f20d$var$fromFoldable5)($2cc1e29b7237f20d$var$fromFoldable6)($59dadf91e1f9eb9a$export$e1744e1bc4c7f337("List")($59dadf91e1f9eb9a$export$2f23118c22fb2630(codec)));
};
var $2cc1e29b7237f20d$export$25ef286fa535664a = /* #__PURE__ */ function() {
    var $63 = $2cc1e29b7237f20d$var$dimap($c045ea5df33bba60$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5))($c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593));
    var $64 = $2cc1e29b7237f20d$export$65e3907585753458($59dadf91e1f9eb9a$export$22b082955e083ec3);
    return function($65) {
        return $63($59dadf91e1f9eb9a$export$2f23118c22fb2630($64($65)));
    };
}();
var $2cc1e29b7237f20d$export$5f5be1bb6cd1fded = function(codecA) {
    return function(codecB) {
        var printTag = function(v) {
            if (v) return "Left";
            if (!v) return "Right";
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 72, column 14 - line 74, column 20): " + [
                v.constructor.name
            ]);
        };
        var parseTag = function(v) {
            if (v === "Left") return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
            if (v === "Right") return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var enc = function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $71f2e2e9476163f8$export$1908877435b1d5e9(true, new $06733ae99ed4f534$export$8a67b48435b5d073($4672333bf471fbe0$export$c564cdbbe6da493(codecA)(v.value0)));
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $71f2e2e9476163f8$export$1908877435b1d5e9(false, new $06733ae99ed4f534$export$8a67b48435b5d073($4672333bf471fbe0$export$c564cdbbe6da493(codecB)(v.value0)));
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 82, column 9 - line 84, column 51): " + [
                v.constructor.name
            ]);
        };
        var dec = function(v) {
            if (v) return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                var $66 = $2cc1e29b7237f20d$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
                var $67 = $4672333bf471fbe0$export$2f872c0f2117be69(codecA);
                return function($68) {
                    return $66($67($68));
                };
            }());
            if (!v) return new $7d4cccdf062a2261$export$19db0165690c701a(function() {
                var $69 = $2cc1e29b7237f20d$var$map2($7d4cccdf062a2261$export$19db0165690c701a.create);
                var $70 = $4672333bf471fbe0$export$2f872c0f2117be69(codecB);
                return function($71) {
                    return $69($70($71));
                };
            }());
            throw new Error("Failed pattern match at Data.Codec.Argonaut.Common (line 79, column 9 - line 81, column 50): " + [
                v.constructor.name
            ]);
        };
        return $371e0b86ca22b610$export$b0569af1074bf9f5("Either")(printTag)(parseTag)(dec)(enc);
    };
};


// Generated by purs version 0.15.15
















var $a33259e81bd72832$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $a33259e81bd72832$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $a33259e81bd72832$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $a33259e81bd72832$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $a33259e81bd72832$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $a33259e81bd72832$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $a33259e81bd72832$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $a33259e81bd72832$var$toUnfoldable = /* #__PURE__ */ $c045ea5df33bba60$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $a33259e81bd72832$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($c045ea5df33bba60$export$b7bb4265e2e489e0);
var $a33259e81bd72832$export$f8b8b9ce72e9ccbf = function(codec) {
    var enc = function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $0e031af7428ef07d$export$63ea9a5410ee0cef;
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4672333bf471fbe0$export$c564cdbbe6da493(codec)(v.value0);
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Compat (line 35, column 9 - line 37, column 28): " + [
            v.constructor.name
        ]);
    };
    var dec = function(j) {
        if ($2a035e92dc768ac1$export$630801d484da15df(j)) return $a33259e81bd72832$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $a33259e81bd72832$var$bimap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create("Maybe"))($06733ae99ed4f534$export$8a67b48435b5d073.create)($4672333bf471fbe0$export$2f872c0f2117be69(codec)(j));
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Compat (line 29, column 3 - line 29, column 50): " + [
            j.constructor.name
        ]);
    };
    return $4672333bf471fbe0$export$a1db28a6a036e024(dec)(enc);
};
var $a33259e81bd72832$export$25ef286fa535664a = function(codec) {
    var decodeItem = function(v) {
        return $a33259e81bd72832$var$bimap($59dadf91e1f9eb9a$export$26ae1106fd92d0a8.create(v.value0))($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))($4672333bf471fbe0$export$2f872c0f2117be69(codec)(v.value1));
    };
    return $4672333bf471fbe0$export$a1db28a6a036e024($a33259e81bd72832$var$composeKleisliFlipped(function() {
        var $19 = $a33259e81bd72832$var$lmap($59dadf91e1f9eb9a$export$4e021928efe6b6bd.create("StrMap"));
        var $20 = $a33259e81bd72832$var$map($a33259e81bd72832$var$fromFoldable);
        var $21 = $a33259e81bd72832$var$traverse(decodeItem);
        return function($22) {
            return $19($20($21($a33259e81bd72832$var$toUnfoldable($22))));
        };
    }())($4672333bf471fbe0$export$2f872c0f2117be69($59dadf91e1f9eb9a$export$685e5903508e8c02)))(function() {
        var $23 = $4672333bf471fbe0$export$c564cdbbe6da493($59dadf91e1f9eb9a$export$685e5903508e8c02);
        var $24 = $a33259e81bd72832$var$map1($4672333bf471fbe0$export$c564cdbbe6da493(codec));
        return function($25) {
            return $23($24($25));
        };
    }());
};


// Generated by purs version 0.15.15




var $de857520e626927f$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $de857520e626927f$export$7acb7b24c478f9c6 = function(x) {
    return x;
};
var $de857520e626927f$export$e2fadcee73eb7d4b = {
    rowListCodec: function(v) {
        return function(v1) {
            return $59dadf91e1f9eb9a$export$e5185e241753e543;
        };
    }
};
var $de857520e626927f$export$861848ecfd078af9 = function(dict) {
    return dict.rowListCodec;
};
var $de857520e626927f$export$d6995eb37c070d1c = function(dictRowListCodec) {
    var rowListCodec1 = $de857520e626927f$export$861848ecfd078af9(dictRowListCodec);
    return function() {
        return function() {
            return function(dictIsSymbol) {
                var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
                var recordProp = $59dadf91e1f9eb9a$export$953dd5c815c55fd6(dictIsSymbol)();
                return {
                    rowListCodec: function(v) {
                        return function(codecs) {
                            var tail = rowListCodec1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codecs);
                            var codec = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codecs);
                            return recordProp($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codec)(tail);
                        };
                    }
                };
            };
        };
    };
};
var $de857520e626927f$export$833910855e0453a8 = function(dictRowListCodec) {
    var rowListCodec1 = $de857520e626927f$export$861848ecfd078af9(dictRowListCodec);
    return function() {
        return function() {
            return function(dictIsSymbol) {
                var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
                var recordPropOptional = $59dadf91e1f9eb9a$export$dcb784050502c5aa(dictIsSymbol)();
                return {
                    rowListCodec: function(v) {
                        return function(codecs) {
                            var tail = rowListCodec1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codecs);
                            var codec = $de857520e626927f$var$coerce(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codecs));
                            return recordPropOptional($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(codec)(tail);
                        };
                    }
                };
            };
        };
    };
};
var $de857520e626927f$export$e5185e241753e543 = function() {
    return function(dictRowListCodec) {
        return $de857520e626927f$export$861848ecfd078af9(dictRowListCodec)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
    };
};
var $de857520e626927f$var$record1 = /* #__PURE__ */ $de857520e626927f$export$e5185e241753e543();
var $de857520e626927f$export$516e28dec6a4b6d4 = $de857520e626927f$export$7acb7b24c478f9c6;
var $de857520e626927f$export$be5493f9613cbbe = function() {
    return function(dictRowListCodec) {
        var record2 = $de857520e626927f$var$record1(dictRowListCodec);
        return function(name) {
            return function(rec) {
                return $59dadf91e1f9eb9a$export$be5493f9613cbbe(name)(record2(rec));
            };
        };
    };
};



// Generated by purs version 0.15.15




























var $d957c5ca0f0ee82a$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$a2181cffc8c78aa4);
var $d957c5ca0f0ee82a$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$17f5c7433e4de947);
var $d957c5ca0f0ee82a$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($18f2b327b2ac3376$export$a99463abb2339a45);
var $d957c5ca0f0ee82a$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $d957c5ca0f0ee82a$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $d957c5ca0f0ee82a$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $d957c5ca0f0ee82a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d957c5ca0f0ee82a$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $d957c5ca0f0ee82a$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $d957c5ca0f0ee82a$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $d957c5ca0f0ee82a$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $d957c5ca0f0ee82a$var$diff = /* #__PURE__ */ $d254595454e6e9b0$export$a37e3c603d7117e5($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $d957c5ca0f0ee82a$var$adjust = /* #__PURE__ */ $18f2b327b2ac3376$export$2c0e788bcc82013($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $d957c5ca0f0ee82a$var$negateDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$28743521ea1cb8f9($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $d957c5ca0f0ee82a$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$737acbed1f5b7f59);
var $d957c5ca0f0ee82a$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$59c06e2004fc98a4);
var $d957c5ca0f0ee82a$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($18f2b327b2ac3376$export$a1af12e21b57795a);
var $d957c5ca0f0ee82a$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($2b6d012b5a71a466$export$d3d664fa4d5a96c6);
var $d957c5ca0f0ee82a$var$choice = /* #__PURE__ */ $11bbe85c947c529d$export$7a5825874deea16a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $d957c5ca0f0ee82a$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $d957c5ca0f0ee82a$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$db307f59121ffcc4);
var $d957c5ca0f0ee82a$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a)($2b6d012b5a71a466$export$a80a9dff0c4321f9);
var $d957c5ca0f0ee82a$export$2d9ac7aa84f97a08 = /* #__PURE__ */ function() {
    function Plus() {}
    Plus.value = new Plus();
    return Plus;
}();
var $d957c5ca0f0ee82a$export$da45d96ed490d127 = /* #__PURE__ */ function() {
    function Minus() {}
    Minus.value = new Minus();
    return Minus;
}();
var $d957c5ca0f0ee82a$export$a016bb0f0790822f = /* #__PURE__ */ function() {
    function Zulu() {}
    Zulu.value = new Zulu();
    return Zulu;
}();
var $d957c5ca0f0ee82a$export$8caee09accd95d7f = /* #__PURE__ */ function() {
    function Offset(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Offset.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Offset(value0, value1, value2);
            };
        };
    };
    return Offset;
}();
var $d957c5ca0f0ee82a$export$f4ac5e2570b151fc = /* #__PURE__ */ function() {
    function FullDateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FullDateTime.create = function(value0) {
        return function(value1) {
            return new FullDateTime(value0, value1);
        };
    };
    return FullDateTime;
}();
var $d957c5ca0f0ee82a$export$a5102117ae957b06 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d957c5ca0f0ee82a$export$2d9ac7aa84f97a08 && y instanceof $d957c5ca0f0ee82a$export$2d9ac7aa84f97a08) return true;
            if (x instanceof $d957c5ca0f0ee82a$export$da45d96ed490d127 && y instanceof $d957c5ca0f0ee82a$export$da45d96ed490d127) return true;
            return false;
        };
    }
};
var $d957c5ca0f0ee82a$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($d957c5ca0f0ee82a$export$a5102117ae957b06);
var $d957c5ca0f0ee82a$export$93503218f94aa7c3 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d957c5ca0f0ee82a$export$a016bb0f0790822f && y instanceof $d957c5ca0f0ee82a$export$a016bb0f0790822f) return true;
            if (x instanceof $d957c5ca0f0ee82a$export$8caee09accd95d7f && y instanceof $d957c5ca0f0ee82a$export$8caee09accd95d7f) return $d957c5ca0f0ee82a$var$eq3(x.value0)(y.value0) && $d957c5ca0f0ee82a$var$eq(x.value1)(y.value1) && $d957c5ca0f0ee82a$var$eq1(x.value2)(y.value2);
            return false;
        };
    }
};
var $d957c5ca0f0ee82a$var$eq4 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($d957c5ca0f0ee82a$export$93503218f94aa7c3);
var $d957c5ca0f0ee82a$export$aab759d720ad2853 = {
    eq: function(x) {
        return function(y) {
            return $d957c5ca0f0ee82a$var$eq2(x.value0)(y.value0) && $d957c5ca0f0ee82a$var$eq4(x.value1)(y.value1);
        };
    }
};
var $d957c5ca0f0ee82a$export$f0b41a4f43dc334e = function(v) {
    if (v.value1 instanceof $d957c5ca0f0ee82a$export$a016bb0f0790822f) return $d957c5ca0f0ee82a$var$pure(v.value0);
    if (v.value1 instanceof $d957c5ca0f0ee82a$export$8caee09accd95d7f) return $d957c5ca0f0ee82a$var$bind($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($d957c5ca0f0ee82a$var$pure(v.value1.value1)))($d957c5ca0f0ee82a$var$pure(v.value1.value2)))($d957c5ca0f0ee82a$var$toEnum(0)))($d957c5ca0f0ee82a$var$toEnum1(0)))(function(offsetTime) {
        return $d957c5ca0f0ee82a$var$bind($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$apply($d957c5ca0f0ee82a$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($d957c5ca0f0ee82a$var$toEnum2(0)))($d957c5ca0f0ee82a$var$toEnum3(0)))($d957c5ca0f0ee82a$var$toEnum(0)))($d957c5ca0f0ee82a$var$toEnum1(0)))(function(zeroTime) {
            var duration = $d957c5ca0f0ee82a$var$diff(zeroTime)(offsetTime);
            if (v.value1.value0 instanceof $d957c5ca0f0ee82a$export$2d9ac7aa84f97a08) return $d957c5ca0f0ee82a$var$adjust(duration)(v.value0);
            if (v.value1.value0 instanceof $d957c5ca0f0ee82a$export$da45d96ed490d127) return $d957c5ca0f0ee82a$var$adjust($d957c5ca0f0ee82a$var$negateDuration(duration))(v.value0);
            throw new Error("Failed pattern match at Data.DateTime.Parsing (line 185, column 3 - line 187, column 56): " + [
                v.value1.value0.constructor.name
            ]);
        });
    });
    throw new Error("Failed pattern match at Data.DateTime.Parsing (line 178, column 1 - line 178, column 43): " + [
        v.constructor.name
    ]);
};
var $d957c5ca0f0ee82a$export$d9bc1ead39e03d8b = {
    show: function(v) {
        if (v instanceof $d957c5ca0f0ee82a$export$2d9ac7aa84f97a08) return "+";
        if (v instanceof $d957c5ca0f0ee82a$export$da45d96ed490d127) return "-";
        throw new Error("Failed pattern match at Data.DateTime.Parsing (line 44, column 1 - line 46, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $d957c5ca0f0ee82a$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($d957c5ca0f0ee82a$export$d9bc1ead39e03d8b);
var $d957c5ca0f0ee82a$export$ed2ec6e8778f388f = {
    show: function(v) {
        if (v instanceof $d957c5ca0f0ee82a$export$a016bb0f0790822f) return "(Offset Zulu)";
        if (v instanceof $d957c5ca0f0ee82a$export$8caee09accd95d7f) return "(Offset " + ($d957c5ca0f0ee82a$var$show3(v.value0) + (" " + ($d957c5ca0f0ee82a$var$show(v.value1) + (":" + ($d957c5ca0f0ee82a$var$show1(v.value2) + ")")))));
        throw new Error("Failed pattern match at Data.DateTime.Parsing (line 35, column 1 - line 37, column 86): " + [
            v.constructor.name
        ]);
    }
};
var $d957c5ca0f0ee82a$var$show4 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($d957c5ca0f0ee82a$export$ed2ec6e8778f388f);
var $d957c5ca0f0ee82a$export$728d28d8f6d617dd = {
    show: function(v) {
        return "(FullDateTime " + ($d957c5ca0f0ee82a$var$show2(v.value0) + (" " + ($d957c5ca0f0ee82a$var$show4(v.value1) + ")")));
    }
};
var $d957c5ca0f0ee82a$var$parseZuluOffset = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$choice([
        $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("Z"),
        $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("z")
    ]))(function() {
        return $d957c5ca0f0ee82a$var$pure1($d957c5ca0f0ee82a$export$a016bb0f0790822f.value);
    });
};
var $d957c5ca0f0ee82a$var$parseDirection = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$choice([
        $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("+"),
        $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("-")
    ]))(function(direction) {
        if (direction === "+") return $d957c5ca0f0ee82a$var$pure1($d957c5ca0f0ee82a$export$2d9ac7aa84f97a08.value);
        if (direction === "-") return $d957c5ca0f0ee82a$var$pure1($d957c5ca0f0ee82a$export$da45d96ed490d127.value);
        return $2b6d012b5a71a466$export$2b62a06a9fee979c("Bad direction");
    });
};
var $d957c5ca0f0ee82a$var$maybeFail = function(dictMonad) {
    return function(str) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($2b6d012b5a71a466$export$2b62a06a9fee979c(str))($d957c5ca0f0ee82a$var$pure1);
    };
};
var $d957c5ca0f0ee82a$var$digit = function(dictMonad) {
    return $ca4b6f31ec4b9857$export$ec0bab193bdafe1(function($146) {
        return $ae1fc60b21f03c62$export$e03c54e9ed5bdad0($3ee2158c14339cc9$export$dd1029f96c3dd62a($146));
    });
};
var $d957c5ca0f0ee82a$var$parseSecondFraction = function(dictMonad) {
    var digit1 = $d957c5ca0f0ee82a$var$digit(dictMonad);
    var maybeFail1 = $d957c5ca0f0ee82a$var$maybeFail(dictMonad);
    return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("."))(function() {
        return $d957c5ca0f0ee82a$var$bind1($11bbe85c947c529d$export$a6482580fab70c30(digit1))(function(digits) {
            var arrayOfDigits = $fc8c1182ec2aefec$export$ee1b3e54f0441b22(function(x) {
                return [
                    [
                        "0",
                        "."
                    ],
                    x
                ];
            }($396c4c3d9e7fae3c$export$b7df5d561049483a(3)($d957c5ca0f0ee82a$var$foldMap($396c4c3d9e7fae3c$export$439306a4dcaafbb9)($78c799cba34fcb8d$export$effcdbd76139450(digits)))));
            var maybeN = $052de1c85deb22bf$export$3004f64547af360e($092fe44bc0883be6$export$709e3b51bf2e2249(arrayOfDigits));
            var millisecond = $d957c5ca0f0ee82a$var$bind(maybeN)(function(n) {
                return $d957c5ca0f0ee82a$var$toEnum1($8d5664f12212b23e$export$a3fe094919f356fd(n * 1000.0));
            });
            return maybeFail1("bad millisecond")(millisecond);
        });
    });
};
var $d957c5ca0f0ee82a$var$count = function(dictMonad) {
    return function(n) {
        return function(p) {
            return $d957c5ca0f0ee82a$var$sequence($396c4c3d9e7fae3c$export$606959e7ccb797f0(n)(p));
        };
    };
};
var $d957c5ca0f0ee82a$var$parseDigits = function(dictMonad) {
    var count1 = $d957c5ca0f0ee82a$var$count(dictMonad);
    var digit1 = $d957c5ca0f0ee82a$var$digit(dictMonad);
    return function(n) {
        return $d957c5ca0f0ee82a$var$bind1(count1(n)(digit1))(function(digits) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($2b6d012b5a71a466$export$2b62a06a9fee979c("bad number"))(function($147) {
                return $d957c5ca0f0ee82a$var$pure1($8d5664f12212b23e$export$a3fe094919f356fd($147));
            })($052de1c85deb22bf$export$3004f64547af360e($092fe44bc0883be6$export$709e3b51bf2e2249(digits)));
        });
    };
};
var $d957c5ca0f0ee82a$var$parseDateTimeSegment = function(dictMonad) {
    var parseDigits1 = $d957c5ca0f0ee82a$var$parseDigits(dictMonad);
    var maybeFail1 = $d957c5ca0f0ee82a$var$maybeFail(dictMonad);
    return function(dictBoundedEnum) {
        var toEnum4 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
        return function(errorMessage) {
            return function(n) {
                return $d957c5ca0f0ee82a$var$bind1(parseDigits1(n))(function(digits) {
                    return maybeFail1(errorMessage)(toEnum4(digits));
                });
            };
        };
    };
};
var $d957c5ca0f0ee82a$var$parseDay = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($e660aadfc8d8f891$export$2f59e9c675f625db)("bad day")(2);
};
var $d957c5ca0f0ee82a$var$parseHour = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($0b11e4a917ce3a7d$export$3e668e9da55710cb)("bad hour")(2);
};
var $d957c5ca0f0ee82a$var$parseMinute = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a)("bad minute")(2);
};
var $d957c5ca0f0ee82a$var$parseNumOffset = function(dictMonad) {
    var parseHour1 = $d957c5ca0f0ee82a$var$parseHour(dictMonad);
    var parseMinute1 = $d957c5ca0f0ee82a$var$parseMinute(dictMonad);
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$parseDirection(dictMonad))(function(direction) {
        return $d957c5ca0f0ee82a$var$bind1(parseHour1)(function(hour) {
            return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))(function() {
                return $d957c5ca0f0ee82a$var$bind1(parseMinute1)(function(minute) {
                    return $d957c5ca0f0ee82a$var$pure1(new $d957c5ca0f0ee82a$export$8caee09accd95d7f(direction, hour, minute));
                });
            });
        });
    });
};
var $d957c5ca0f0ee82a$var$parseOffset = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$choice([
        $d957c5ca0f0ee82a$var$parseZuluOffset(dictMonad),
        $d957c5ca0f0ee82a$var$parseNumOffset(dictMonad)
    ]);
};
var $d957c5ca0f0ee82a$var$parseMonth = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($e660aadfc8d8f891$export$e744bc4044126e99)("bad month")(2);
};
var $d957c5ca0f0ee82a$var$parseSecond = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($0b11e4a917ce3a7d$export$c9467b6184dd9c81)("bad second")(2);
};
var $d957c5ca0f0ee82a$var$parsePartialTime = function(dictMonad) {
    var parseMinute1 = $d957c5ca0f0ee82a$var$parseMinute(dictMonad);
    var parseSecond1 = $d957c5ca0f0ee82a$var$parseSecond(dictMonad);
    var maybeFail1 = $d957c5ca0f0ee82a$var$maybeFail(dictMonad);
    var parseSecondFraction1 = $d957c5ca0f0ee82a$var$parseSecondFraction(dictMonad);
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$parseHour(dictMonad))(function(hh) {
        return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))(function() {
            return $d957c5ca0f0ee82a$var$bind1(parseMinute1)(function(mm) {
                return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7(":"))(function() {
                    return $d957c5ca0f0ee82a$var$bind1(parseSecond1)(function(ss) {
                        return $d957c5ca0f0ee82a$var$bind1(maybeFail1("bad default millisecond")($d957c5ca0f0ee82a$var$toEnum1(0)))(function(default_mss) {
                            return $d957c5ca0f0ee82a$var$bind1($11bbe85c947c529d$export$a75d1723e6bda2ec(default_mss)(parseSecondFraction1))(function(mss) {
                                return $d957c5ca0f0ee82a$var$pure1(new $d254595454e6e9b0$export$680ea196effce5f(hh, mm, ss, mss));
                            });
                        });
                    });
                });
            });
        });
    });
};
var $d957c5ca0f0ee82a$var$parseYear = function(dictMonad) {
    return $d957c5ca0f0ee82a$var$parseDateTimeSegment(dictMonad)($e660aadfc8d8f891$export$2391dde84a7e2cbd)("bad year")(4);
};
var $d957c5ca0f0ee82a$var$parseDate = function(dictMonad) {
    var parseMonth1 = $d957c5ca0f0ee82a$var$parseMonth(dictMonad);
    var parseDay1 = $d957c5ca0f0ee82a$var$parseDay(dictMonad);
    var maybeFail1 = $d957c5ca0f0ee82a$var$maybeFail(dictMonad);
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$parseYear(dictMonad))(function(year) {
        return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("-"))(function() {
            return $d957c5ca0f0ee82a$var$bind1(parseMonth1)(function(month) {
                return $d957c5ca0f0ee82a$var$bind1($ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("-"))(function() {
                    return $d957c5ca0f0ee82a$var$bind1(parseDay1)(function(day) {
                        return maybeFail1("bad date")($7577649a7445e8e0$export$4803c954abcb09a(year)(month)(day));
                    });
                });
            });
        });
    });
};
var $d957c5ca0f0ee82a$export$211c992dec5fdf92 = function(dictMonad) {
    var parsePartialTime1 = $d957c5ca0f0ee82a$var$parsePartialTime(dictMonad);
    var parseOffset1 = $d957c5ca0f0ee82a$var$parseOffset(dictMonad);
    return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$parseDate(dictMonad))(function(date) {
        return $d957c5ca0f0ee82a$var$bind1($d957c5ca0f0ee82a$var$choice([
            $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("T"),
            $ca4b6f31ec4b9857$export$eba6f6f03b0a92e7("t")
        ]))(function() {
            return $d957c5ca0f0ee82a$var$bind1(parsePartialTime1)(function(time) {
                return $d957c5ca0f0ee82a$var$bind1(parseOffset1)(function(offset) {
                    return $d957c5ca0f0ee82a$var$pure1(new $d957c5ca0f0ee82a$export$f4ac5e2570b151fc(new $18f2b327b2ac3376$export$82f9ebd9adeba146(date, time), offset));
                });
            });
        });
    });
};
var $d957c5ca0f0ee82a$var$parseFullDateTime1 = /* #__PURE__ */ $d957c5ca0f0ee82a$export$211c992dec5fdf92($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $d957c5ca0f0ee82a$export$3004f64547af360e = function(s) {
    return $2b6d012b5a71a466$export$4ad9239eebc1597f(s)($d957c5ca0f0ee82a$var$parseFullDateTime1);
};















// Generated by purs version 0.15.15













// Generated by purs version 0.15.15



























// Generated by purs version 0.15.15
var $7be7da501cc98863$export$910fc5c18aadca57 = {
    segments: [],
    params: [],
    hash: ""
};


var $103f9ee2d6d6c8d4$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $103f9ee2d6d6c8d4$var$bitraverse = /* #__PURE__ */ $efac99db7971f271$export$f664b6bec32af3f2($efac99db7971f271$export$b0be3b32fab47d0a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $103f9ee2d6d6c8d4$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $103f9ee2d6d6c8d4$var$lookup = /* #__PURE__ */ $4fe7b6acfba7f29f$export$dfc7155ac0343b8($4fe7b6acfba7f29f$export$e97014618a7eb593)($37b880af5f4991bd$export$fa624555ca2acbc8);
var $103f9ee2d6d6c8d4$var$genericShowArgsArgument = /* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $103f9ee2d6d6c8d4$var$genericShowConstructor = /* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($103f9ee2d6d6c8d4$var$genericShowArgsArgument);
var $103f9ee2d6d6c8d4$var$genericShowArgsProduct = /* #__PURE__ */ $544b62a378cc0091$export$b8b972500eedbc74(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "hash";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "params";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "segments";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6)($2c6b3d51d10471a7$export$e4b6cd05df3043f6))))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))));
var $103f9ee2d6d6c8d4$var$SuccessIsSymbol = {
    reflectSymbol: function() {
        return "Success";
    }
};
var $103f9ee2d6d6c8d4$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e);
var $103f9ee2d6d6c8d4$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $103f9ee2d6d6c8d4$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00(/* #__PURE__ */ $71f2e2e9476163f8$export$d625e8a97ba36bd6($37b880af5f4991bd$export$fa624555ca2acbc8)($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $103f9ee2d6d6c8d4$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($37b880af5f4991bd$export$fa624555ca2acbc8));
var $103f9ee2d6d6c8d4$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($91ee3359f6bcea22$export$7090c31be3a1e8ea);
var $103f9ee2d6d6c8d4$var$composeKleisli = /* #__PURE__ */ $70cd3177464e7915$export$61a2047e1b1e0d3e($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $103f9ee2d6d6c8d4$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($91ee3359f6bcea22$export$7e27c982686236c);
var $103f9ee2d6d6c8d4$export$81fb35b60cc61a90 = /* #__PURE__ */ function() {
    function Expected(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Expected.create = function(value0) {
        return function(value1) {
            return new Expected(value0, value1);
        };
    };
    return Expected;
}();
var $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c = /* #__PURE__ */ function() {
    function ExpectedEndOfPath(value0) {
        this.value0 = value0;
    }
    ExpectedEndOfPath.create = function(value0) {
        return new ExpectedEndOfPath(value0);
    };
    return ExpectedEndOfPath;
}();
var $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04 = /* #__PURE__ */ function() {
    function MissingParam(value0) {
        this.value0 = value0;
    }
    MissingParam.create = function(value0) {
        return new MissingParam(value0);
    };
    return MissingParam;
}();
var $103f9ee2d6d6c8d4$export$758a5e8577f9e088 = /* #__PURE__ */ function() {
    function MalformedURIComponent(value0) {
        this.value0 = value0;
    }
    MalformedURIComponent.create = function(value0) {
        return new MalformedURIComponent(value0);
    };
    return MalformedURIComponent;
}();
var $103f9ee2d6d6c8d4$export$98f3eafddb5fc114 = /* #__PURE__ */ function() {
    function EndOfPath() {}
    EndOfPath.value = new EndOfPath();
    return EndOfPath;
}();
var $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00 = /* #__PURE__ */ function() {
    function Fail(value0) {
        this.value0 = value0;
    }
    Fail.create = function(value0) {
        return new Fail(value0);
    };
    return Fail;
}();
var $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a = /* #__PURE__ */ function() {
    function Success(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Success.create = function(value0) {
        return function(value1) {
            return new Success(value0, value1);
        };
    };
    return Success;
}();
var $103f9ee2d6d6c8d4$export$25ba4469a069167 = /* #__PURE__ */ function() {
    function Alt(value0) {
        this.value0 = value0;
    }
    Alt.create = function(value0) {
        return new Alt(value0);
    };
    return Alt;
}();
var $103f9ee2d6d6c8d4$export$ad869d5fe680aaff = /* #__PURE__ */ function() {
    function Chomp(value0) {
        this.value0 = value0;
    }
    Chomp.create = function(value0) {
        return new Chomp(value0);
    };
    return Chomp;
}();
var $103f9ee2d6d6c8d4$export$e77cfe0b08ec163 = /* #__PURE__ */ function() {
    function Prefix(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Prefix.create = function(value0) {
        return function(value1) {
            return new Prefix(value0, value1);
        };
    };
    return Prefix;
}();
var $103f9ee2d6d6c8d4$export$b7df5d561049483a = /* #__PURE__ */ function() {
    return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
        var v = $396c4c3d9e7fae3c$export$b446f6baa3bb1430(state.segments);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a({
            params: state.params,
            hash: state.hash,
            segments: v.value0.tail
        }, v.value0.head);
        return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00($103f9ee2d6d6c8d4$export$98f3eafddb5fc114.value);
    });
}();
var $103f9ee2d6d6c8d4$export$c58417706a208278 = /* #__PURE__ */ function() {
    return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
        return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a({
            params: state.params,
            hash: state.hash,
            segments: []
        }, state.segments);
    });
}();
var $103f9ee2d6d6c8d4$export$82e9f45cca5ba907 = /* #__PURE__ */ function() {
    return $103f9ee2d6d6c8d4$export$e77cfe0b08ec163.create;
}();
var $103f9ee2d6d6c8d4$export$8ccf933b0513f8d0 = /* #__PURE__ */ function() {
    var toRouteState = function(v) {
        return {
            segments: v.value0.value0,
            params: v.value0.value1,
            hash: v.value1
        };
    };
    var splitNonEmpty = function(v) {
        return function(v1) {
            if (v1 === "") return [];
            return $5b07e36f812dd04b$export$65980d18b75784e2(v)(v1);
        };
    };
    var splitAt = function(k) {
        return function(p) {
            return function(str) {
                var v = $1a77d6934b592676$export$305f7d4e9d4624f2(p)(str);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $71f2e2e9476163f8$export$1908877435b1d5e9($092fe44bc0883be6$export$b7df5d561049483a(v.value0)(str), $092fe44bc0883be6$export$663103110d94aac9(v.value0 + $092fe44bc0883be6$export$f24224f1c91d8156(p) | 0)(str));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return k(str);
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 191, column 5 - line 193, column 23): " + [
                    v.constructor.name
                ]);
            };
        };
    };
    var decodeURIComponent$prime = function(str) {
        var v = $f9a555fb76059872$export$8824b4be61b7d619(str);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $103f9ee2d6d6c8d4$export$758a5e8577f9e088(str));
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 195, column 29 - line 197, column 22): " + [
            v.constructor.name
        ]);
    };
    var splitKeyValue = function() {
        var $349 = $103f9ee2d6d6c8d4$var$bitraverse(decodeURIComponent$prime)(decodeURIComponent$prime);
        var $350 = splitAt($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(""))("=");
        return function($351) {
            return $349($350($351));
        };
    }();
    var splitParams = function() {
        var $352 = $103f9ee2d6d6c8d4$var$traverse(splitKeyValue);
        var $353 = splitNonEmpty("&");
        return function($354) {
            return $352($353($354));
        };
    }();
    var splitSegments = function() {
        var $355 = splitNonEmpty("/");
        return function($356) {
            return function(v) {
                if (v.length === 2 && v[0] === "" && v[1] === "") return new $7d4cccdf062a2261$export$19db0165690c701a([
                    ""
                ]);
                return $103f9ee2d6d6c8d4$var$traverse(decodeURIComponent$prime)(v);
            }($355($356));
        };
    }();
    var splitPath = function() {
        var $357 = $103f9ee2d6d6c8d4$var$bitraverse(splitSegments)(splitParams);
        var $358 = splitAt($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(""))("?");
        return function($359) {
            return $357($358($359));
        };
    }();
    var $360 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601)(toRouteState);
    var $361 = $efac99db7971f271$export$4a1651cd8fd555cf($efac99db7971f271$export$b0be3b32fab47d0a)($7d4cccdf062a2261$export$400f1ef3f3ec304d)(splitPath);
    var $362 = splitAt($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(""))("#");
    return function($363) {
        return $360($361($362($363)));
    };
}();
var $103f9ee2d6d6c8d4$export$6f7d1d9d04558207 = function(key) {
    return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
        var v = $103f9ee2d6d6c8d4$var$lookup(key)(state.params);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(state, v.value0);
        return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(new $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04(key));
    });
};
var $103f9ee2d6d6c8d4$export$7d260a2a5f8bc19e = /* #__PURE__ */ function() {
    var $364 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Int"))($7d4cccdf062a2261$export$19db0165690c701a.create);
    return function($365) {
        return $364($8d5664f12212b23e$export$3004f64547af360e($365));
    };
}();
var $103f9ee2d6d6c8d4$export$d6af199866bfb566 = /* #__PURE__ */ function() {
    return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
        return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(state, state.hash);
    });
}();
var $103f9ee2d6d6c8d4$export$1ac1fabef8691a41 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(x.value0.value0, x.value0.value1);
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 54, column 1 - line 54, column 64): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1));
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 54, column 1 - line 54, column 64): " + [
            x.constructor.name
        ]);
    }
};
var $103f9ee2d6d6c8d4$var$genericShow = /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($103f9ee2d6d6c8d4$export$1ac1fabef8691a41);
var $103f9ee2d6d6c8d4$export$a2204c11bb7739f0 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $103f9ee2d6d6c8d4$export$81fb35b60cc61a90(x.value0.value0, x.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04(x.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $103f9ee2d6d6c8d4$export$758a5e8577f9e088(x.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $103f9ee2d6d6c8d4$export$98f3eafddb5fc114.value;
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 67, column 1 - line 67, column 58): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $103f9ee2d6d6c8d4$export$81fb35b60cc61a90) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1));
        if (x instanceof $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)));
        if (x instanceof $103f9ee2d6d6c8d4$export$758a5e8577f9e088) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))));
        if (x instanceof $103f9ee2d6d6c8d4$export$98f3eafddb5fc114) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value))));
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 67, column 1 - line 67, column 58): " + [
            x.constructor.name
        ]);
    }
};
var $103f9ee2d6d6c8d4$export$1619b73bea7bcf63 = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($103f9ee2d6d6c8d4$export$a2204c11bb7739f0)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$b8b972500eedbc74($103f9ee2d6d6c8d4$var$genericShowArgsArgument)($103f9ee2d6d6c8d4$var$genericShowArgsArgument))({
        reflectSymbol: function() {
            return "Expected";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $103f9ee2d6d6c8d4$var$genericShowConstructor({
        reflectSymbol: function() {
            return "ExpectedEndOfPath";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $103f9ee2d6d6c8d4$var$genericShowConstructor({
        reflectSymbol: function() {
            return "MissingParam";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $103f9ee2d6d6c8d4$var$genericShowConstructor({
        reflectSymbol: function() {
            return "MalformedURIComponent";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$f7ad98836d6849e8)({
        reflectSymbol: function() {
            return "EndOfPath";
        }
    }))))))
};
var $103f9ee2d6d6c8d4$var$genericShowSum = /* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658($103f9ee2d6d6c8d4$export$1619b73bea7bcf63))({
    reflectSymbol: function() {
        return "Fail";
    }
}));
var $103f9ee2d6d6c8d4$export$2f91b6c2721d02cb = function(dictShow) {
    return {
        show: $103f9ee2d6d6c8d4$var$genericShow($103f9ee2d6d6c8d4$var$genericShowSum($544b62a378cc0091$export$186afff91b813845($103f9ee2d6d6c8d4$var$genericShowArgsProduct($544b62a378cc0091$export$bc1180ef96fcb658(dictShow)))($103f9ee2d6d6c8d4$var$SuccessIsSymbol)))
    };
};
var $103f9ee2d6d6c8d4$export$9a724b75afce4d6 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(m.value0);
            if (m instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(m.value0, f(m.value1));
            throw new Error("Failed pattern match at Routing.Duplex.Parser (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $103f9ee2d6d6c8d4$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($103f9ee2d6d6c8d4$export$9a724b75afce4d6);
var $103f9ee2d6d6c8d4$export$26b7132f5789b0b0 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167) return new $103f9ee2d6d6c8d4$export$25ba4469a069167($103f9ee2d6d6c8d4$var$map($f4b2eb11fc32ed34$export$871de8747c9eaa88($103f9ee2d6d6c8d4$export$26b7132f5789b0b0)(f))(m.value0));
            if (m instanceof $103f9ee2d6d6c8d4$export$ad869d5fe680aaff) return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff($103f9ee2d6d6c8d4$var$map1($103f9ee2d6d6c8d4$var$map2(f))(m.value0));
            if (m instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) return new $103f9ee2d6d6c8d4$export$e77cfe0b08ec163(m.value0, $f4b2eb11fc32ed34$export$871de8747c9eaa88($103f9ee2d6d6c8d4$export$26b7132f5789b0b0)(f)(m.value1));
            throw new Error("Failed pattern match at Routing.Duplex.Parser (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $103f9ee2d6d6c8d4$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($103f9ee2d6d6c8d4$export$26b7132f5789b0b0);
var $103f9ee2d6d6c8d4$export$c4a4ca780c536eff = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $103f9ee2d6d6c8d4$export$81fb35b60cc61a90 && y instanceof $103f9ee2d6d6c8d4$export$81fb35b60cc61a90) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c && y instanceof $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c) return x.value0 === y.value0;
            if (x instanceof $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04 && y instanceof $103f9ee2d6d6c8d4$export$96e47dbe1f0c1d04) return x.value0 === y.value0;
            if (x instanceof $103f9ee2d6d6c8d4$export$758a5e8577f9e088 && y instanceof $103f9ee2d6d6c8d4$export$758a5e8577f9e088) return x.value0 === y.value0;
            if (x instanceof $103f9ee2d6d6c8d4$export$98f3eafddb5fc114 && y instanceof $103f9ee2d6d6c8d4$export$98f3eafddb5fc114) return true;
            return false;
        };
    }
};
var $103f9ee2d6d6c8d4$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($103f9ee2d6d6c8d4$export$c4a4ca780c536eff);
var $103f9ee2d6d6c8d4$export$5a046c52e0d37971 = function(dictEq) {
    var eq4 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00 && y instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return $103f9ee2d6d6c8d4$var$eq3(x.value0)(y.value0);
                if (x instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a && y instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return x.value0.hash === y.value0.hash && $103f9ee2d6d6c8d4$var$eq1(x.value0.params)(y.value0.params) && $103f9ee2d6d6c8d4$var$eq2(x.value0.segments)(y.value0.segments) && eq4(x.value1)(y.value1);
                return false;
            };
        }
    };
};
var $103f9ee2d6d6c8d4$export$bd5df0f255a350f8 = /* #__PURE__ */ function() {
    return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(state.segments);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(state, $05149ea687d6b460$export$523c0b569236b342);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(new $103f9ee2d6d6c8d4$export$171cf1dba3fb2e0c(v.value0));
        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 266, column 3 - line 268, column 45): " + [
            v.constructor.name
        ]);
    });
}();
var $103f9ee2d6d6c8d4$var$chompPrefix = function(pre) {
    return function(state) {
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(state.segments);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && pre === v.value0) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a({
            params: state.params,
            hash: state.hash,
            segments: $396c4c3d9e7fae3c$export$663103110d94aac9(1)(state.segments)
        }, $05149ea687d6b460$export$523c0b569236b342);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(new $103f9ee2d6d6c8d4$export$81fb35b60cc61a90(pre, v.value0));
        return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00($103f9ee2d6d6c8d4$export$98f3eafddb5fc114.value);
    };
};
var $103f9ee2d6d6c8d4$var$$lazy_runRouteParser = /* #__PURE__ */ $103f9ee2d6d6c8d4$var$$runtime_lazy("runRouteParser", "Routing.Duplex.Parser", function() {
    var goAlt = function(v) {
        return function(v1) {
            return function(v2) {
                if (v1 instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return $103f9ee2d6d6c8d4$var$$lazy_runRouteParser(161)(v)(v2);
                return v1;
            };
        };
    };
    var go = function($copy_state) {
        return function($copy_v) {
            var $tco_var_state = $copy_state;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(state, v) {
                if (v instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167) {
                    $tco_done = true;
                    return $103f9ee2d6d6c8d4$var$foldl(goAlt(state))(new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00($103f9ee2d6d6c8d4$export$98f3eafddb5fc114.value))(v.value0);
                }
                if (v instanceof $103f9ee2d6d6c8d4$export$ad869d5fe680aaff) {
                    $tco_done = true;
                    return v.value0(state);
                }
                if (v instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
                    var v1 = $103f9ee2d6d6c8d4$var$chompPrefix(v.value0)(state);
                    if (v1 instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) {
                        $tco_done = true;
                        return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(v1.value0);
                    }
                    if (v1 instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) {
                        $tco_var_state = v1.value0;
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 157, column 7 - line 159, column 40): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 153, column 14 - line 159, column 40): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_state, $copy_v);
            return $tco_result;
        };
    };
    return go;
});
var $103f9ee2d6d6c8d4$export$9c99688b14d1593d = /* #__PURE__ */ $103f9ee2d6d6c8d4$var$$lazy_runRouteParser(150);
var $103f9ee2d6d6c8d4$export$baca7000bf4ed9f7 = {
    defer: function(k) {
        var parser = $99af8ad7682e39c7$export$260e5c0943f31606(k);
        return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
            return $103f9ee2d6d6c8d4$export$9c99688b14d1593d(state)($99af8ad7682e39c7$export$4d82290515cd0ddb(parser));
        });
    }
};
var $103f9ee2d6d6c8d4$export$a6482580fab70c30 = function(dictAlt) {
    var alt1 = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    return function(dictApplicative) {
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(p) {
            var go$prime = function($copy_state) {
                return function($copy_xs) {
                    var $tco_var_state = $copy_state;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(state, xs) {
                        var v = $103f9ee2d6d6c8d4$export$9c99688b14d1593d(state)(p);
                        if (v instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) {
                            $tco_done = true;
                            return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(state, xs);
                        }
                        if (v instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) {
                            $tco_var_state = v.value0;
                            $copy_xs = alt1(xs)(pure1(v.value1));
                            return;
                        }
                        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 233, column 5 - line 235, column 53): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_state, $copy_xs);
                    return $tco_result;
                };
            };
            var go = function(state) {
                var v = $103f9ee2d6d6c8d4$export$9c99688b14d1593d(state)(p);
                if (v instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(v.value0);
                if (v instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return go$prime(v.value0)(pure1(v.value1));
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 227, column 5 - line 229, column 46): " + [
                    v.constructor.name
                ]);
            };
            return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(go);
        };
    };
};
var $103f9ee2d6d6c8d4$export$889ea624f2cb2c57 = function(p) {
    return $103f9ee2d6d6c8d4$var$composeKleisli($103f9ee2d6d6c8d4$export$8ccf933b0513f8d0)(function() {
        var $366 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($103f9ee2d6d6c8d4$export$9c99688b14d1593d)(p);
        return function($367) {
            return function(v) {
                if (v instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
                if (v instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value1);
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 200, column 49 - line 202, column 29): " + [
                    v.constructor.name
                ]);
            }($366($367));
        };
    }());
};
var $103f9ee2d6d6c8d4$export$4a21f16c33752377 = function(v) {
    if (v === "true") return new $7d4cccdf062a2261$export$19db0165690c701a(true);
    if (v === "false") return new $7d4cccdf062a2261$export$19db0165690c701a(false);
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515("Boolean");
};
var $103f9ee2d6d6c8d4$export$6554612db691658e = function(print) {
    return function(decode) {
        return function(p) {
            return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
                var v = $103f9ee2d6d6c8d4$export$9c99688b14d1593d(state)(p);
                if (v instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(v.value0);
                if (v instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) {
                    var v1 = decode(v.value1);
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(new $103f9ee2d6d6c8d4$export$81fb35b60cc61a90(v1.value0, print(v.value1)));
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a(v.value0, v1.value0);
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 254, column 7 - line 256, column 36): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 251, column 3 - line 256, column 36): " + [
                    v.constructor.name
                ]);
            });
        };
    };
};
var $103f9ee2d6d6c8d4$export$4d1e42c8f37c64fd = {
    apply: function(fx) {
        return function(x) {
            return new $103f9ee2d6d6c8d4$export$ad869d5fe680aaff(function(state) {
                var v = $103f9ee2d6d6c8d4$export$9c99688b14d1593d(state)(fx);
                if (v instanceof $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00) return new $103f9ee2d6d6c8d4$export$9c5a8101c9b12c00(v.value0);
                if (v instanceof $103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a) return $103f9ee2d6d6c8d4$var$map2(v.value1)($103f9ee2d6d6c8d4$export$9c99688b14d1593d(v.value0)(x));
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 81, column 5 - line 83, column 56): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Functor0: function() {
        return $103f9ee2d6d6c8d4$export$26b7132f5789b0b0;
    }
};
var $103f9ee2d6d6c8d4$export$2e826c8750ceccf2 = {
    pure: /* #__PURE__ */ function() {
        var $368 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($103f9ee2d6d6c8d4$export$ffa3d9fee6fd705a.create);
        return function($369) {
            return $103f9ee2d6d6c8d4$export$ad869d5fe680aaff.create($368($369));
        };
    }(),
    Apply0: function() {
        return $103f9ee2d6d6c8d4$export$4d1e42c8f37c64fd;
    }
};
var $103f9ee2d6d6c8d4$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($103f9ee2d6d6c8d4$export$2e826c8750ceccf2);
var $103f9ee2d6d6c8d4$var$altSnoc = function(v) {
    return function(v1) {
        var v2 = function(v3) {
            return $e39dfcf102cdca3c$export$c40cf5aab899f397(v)(v1);
        };
        if (v1 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
            var $310 = $e39dfcf102cdca3c$export$4c7897fafd92b108(v);
            if ($310 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
                var $311 = v1.value0 === $310.value0;
                if ($311) return $e39dfcf102cdca3c$export$5b6d1d165591a48c($e39dfcf102cdca3c$export$2cd8252107eb640b(v))(new $103f9ee2d6d6c8d4$export$e77cfe0b08ec163(v1.value0, $75e93a4111e80214$export$228be17d80722ab($103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf)($310.value1)(v1.value1)));
                return v2(true);
            }
            return v2(true);
        }
        return v2(true);
    };
};
var $103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167 && v1 instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167) return new $103f9ee2d6d6c8d4$export$25ba4469a069167($103f9ee2d6d6c8d4$var$altAppend(v.value0)(v1.value0));
            if (v instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167) return new $103f9ee2d6d6c8d4$export$25ba4469a069167($103f9ee2d6d6c8d4$var$altSnoc(v.value0)(v1));
            if (v1 instanceof $103f9ee2d6d6c8d4$export$25ba4469a069167) return new $103f9ee2d6d6c8d4$export$25ba4469a069167($103f9ee2d6d6c8d4$var$altCons(v)(v1.value0));
            if (v instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163 && v1 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163 && v.value0 === v1.value0) return new $103f9ee2d6d6c8d4$export$e77cfe0b08ec163(v.value0, $75e93a4111e80214$export$228be17d80722ab($103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf)(v.value1)(v1.value1));
            return new $103f9ee2d6d6c8d4$export$25ba4469a069167($e39dfcf102cdca3c$export$8327ebbef2a0ba76(v)($e39dfcf102cdca3c$export$439306a4dcaafbb9(v1)));
        };
    },
    Functor0: function() {
        return $103f9ee2d6d6c8d4$export$26b7132f5789b0b0;
    }
};
var $103f9ee2d6d6c8d4$var$altCons = function(v) {
    return function(v1) {
        var v2 = function(v3) {
            return $e39dfcf102cdca3c$export$8327ebbef2a0ba76(v)(v1);
        };
        if (v instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
            var $330 = $e39dfcf102cdca3c$export$5fd5031fecdacec3(v1);
            if ($330 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
                var $331 = v.value0 === $330.value0;
                if ($331) return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(new $103f9ee2d6d6c8d4$export$e77cfe0b08ec163(v.value0, $75e93a4111e80214$export$228be17d80722ab($103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf)(v.value1)($330.value1)))($e39dfcf102cdca3c$export$c01875f616615628(v1));
                return v2(true);
            }
            return v2(true);
        }
        return v2(true);
    };
};
var $103f9ee2d6d6c8d4$var$altAppend = function($copy_ls) {
    return function($copy_rs) {
        var $tco_var_ls = $copy_ls;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(ls, rs) {
            var v = function(v1) {
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $103f9ee2d6d6c8d4$var$append(ls)(rs);
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 103, column 1 - line 107, column 35): " + [
                    ls.constructor.name,
                    rs.constructor.name
                ]);
            };
            var $340 = $e39dfcf102cdca3c$export$4c7897fafd92b108(ls);
            if ($340 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
                var $341 = $e39dfcf102cdca3c$export$5fd5031fecdacec3(rs);
                if ($341 instanceof $103f9ee2d6d6c8d4$export$e77cfe0b08ec163) {
                    var $342 = $340.value0 === $341.value0;
                    if ($342) {
                        var rs$prime = $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(new $103f9ee2d6d6c8d4$export$e77cfe0b08ec163($340.value0, $75e93a4111e80214$export$228be17d80722ab($103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf)($340.value1)($341.value1)))($e39dfcf102cdca3c$export$c01875f616615628(rs));
                        var v1 = $e39dfcf102cdca3c$export$571d59b505e6bb4e($e39dfcf102cdca3c$export$2cd8252107eb640b(ls));
                        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_ls = v1.value0;
                            $copy_rs = rs$prime;
                            return;
                        }
                        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return rs$prime;
                        }
                        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 116, column 9 - line 118, column 25): " + [
                            v1.constructor.name
                        ]);
                    }
                    $tco_done = true;
                    return v(true);
                }
                $tco_done = true;
                return v(true);
            }
            $tco_done = true;
            return v(true);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_ls, $copy_rs);
        return $tco_result;
    };
};
var $103f9ee2d6d6c8d4$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($103f9ee2d6d6c8d4$export$735fdfb4a5ac6edf);
var $103f9ee2d6d6c8d4$export$2e2bcd8739ae039 = /* #__PURE__ */ function() {
    var $370 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($103f9ee2d6d6c8d4$var$alt);
    return function($371) {
        return $370($103f9ee2d6d6c8d4$var$pure($371));
    };
}();
var $103f9ee2d6d6c8d4$export$42405f212471e8a2 = /* #__PURE__ */ function() {
    var $372 = $103f9ee2d6d6c8d4$export$2e2bcd8739ae039(false);
    var $373 = $103f9ee2d6d6c8d4$var$map3($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
    return function($374) {
        return $372($373($103f9ee2d6d6c8d4$export$6f7d1d9d04558207($374)));
    };
}();
var $103f9ee2d6d6c8d4$export$516e28dec6a4b6d4 = /* #__PURE__ */ function() {
    var $375 = $103f9ee2d6d6c8d4$export$2e2bcd8739ae039($06733ae99ed4f534$export$bebe9059409a0d04.value);
    var $376 = $103f9ee2d6d6c8d4$var$map3($06733ae99ed4f534$export$8a67b48435b5d073.create);
    return function($377) {
        return $375($376($377));
    };
}();
var $103f9ee2d6d6c8d4$export$14badfee79ea396f = function(dictAlternative) {
    var Plus1 = dictAlternative.Plus1();
    var many11 = $103f9ee2d6d6c8d4$export$a6482580fab70c30(Plus1.Alt0())(dictAlternative.Applicative0());
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(Plus1);
    return function(p) {
        return $103f9ee2d6d6c8d4$var$alt(many11(p))($103f9ee2d6d6c8d4$var$pure(empty));
    };
};


// Generated by purs version 0.15.15












var $f2a05b25fd567d1b$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d(/* #__PURE__ */ $06733ae99ed4f534$export$fb85b8a3a6158141($d7bf9817a417d4ae$export$d9b7100b101f2c5b));
var $f2a05b25fd567d1b$export$55c2431467d5b150 = function(x) {
    return x;
};
var $f2a05b25fd567d1b$export$36091c79ca1ac67 = {
    append: function(v) {
        return function(v1) {
            return function($33) {
                return v1(v($33));
            };
        };
    }
};
var $f2a05b25fd567d1b$export$327f7b26ebf455db = function(str) {
    return function(state) {
        return {
            params: state.params,
            hash: state.hash,
            segments: $396c4c3d9e7fae3c$export$c40cf5aab899f397(state.segments)(str)
        };
    };
};
var $f2a05b25fd567d1b$export$72cb4a02f52e34ed = function(v) {
    var printSegments = function(v1) {
        if (v1.length === 1 && v1[0] === "") return "/";
        return $5b07e36f812dd04b$export$ec1dc8fbeea3467e("/")($396c4c3d9e7fae3c$export$e70771d2e7e590a($f9a555fb76059872$export$ab54ccbe87d5558)(v1));
    };
    var printParam = function(v1) {
        return function(v2) {
            if (v2 === "") return $f9a555fb76059872$export$ab54ccbe87d5558(v1);
            return $f2a05b25fd567d1b$var$append($f9a555fb76059872$export$ab54ccbe87d5558(v1))($f2a05b25fd567d1b$var$append(new $06733ae99ed4f534$export$8a67b48435b5d073("="))($f9a555fb76059872$export$ab54ccbe87d5558(v2)));
        };
    };
    var printParams = function(v1) {
        if (v1.length === 0) return "";
        return "?" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e("&")($396c4c3d9e7fae3c$export$e70771d2e7e590a($71f2e2e9476163f8$export$7864d59d01b6d6bf(printParam))(v1));
    };
    var printHash = function(v1) {
        if (v1 === "") return "";
        return "#" + v1;
    };
    return printSegments(v.segments) + (printParams(v.params) + printHash(v.hash));
};
var $f2a05b25fd567d1b$export$6f7d1d9d04558207 = function(key) {
    return function(val) {
        return function(state) {
            return {
                segments: state.segments,
                hash: state.hash,
                params: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(new $71f2e2e9476163f8$export$1908877435b1d5e9(key, val))(state.params)
            };
        };
    };
};
var $f2a05b25fd567d1b$export$e8e1fd29b495a76c = {
    Coercible0: function() {
        return undefined;
    }
};
var $f2a05b25fd567d1b$export$889ea624f2cb2c57 = /* #__PURE__ */ function() {
    var $34 = $f57f4b701aa7b66e$export$5f9c390da86b6e49($7be7da501cc98863$export$910fc5c18aadca57);
    var $35 = $4fa4836228a192cc$export$debb760848ca95a();
    return function($36) {
        return $f2a05b25fd567d1b$export$72cb4a02f52e34ed($34($35($36)));
    };
}();
var $f2a05b25fd567d1b$export$6a64e684da29873 = {
    mempty: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Semigroup0: function() {
        return $f2a05b25fd567d1b$export$36091c79ca1ac67;
    }
};
var $f2a05b25fd567d1b$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($f2a05b25fd567d1b$export$6a64e684da29873);
var $f2a05b25fd567d1b$export$d6af199866bfb566 = function(h) {
    return function(v) {
        return {
            segments: v.segments,
            params: v.params,
            hash: h
        };
    };
};
var $f2a05b25fd567d1b$export$42405f212471e8a2 = function(key) {
    return function(val) {
        if (val) return $f2a05b25fd567d1b$export$6f7d1d9d04558207(key)("");
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $f2a05b25fd567d1b$var$mempty;
        throw new Error("Failed pattern match at Routing.Duplex.Printer (line 38, column 1 - line 38, column 42): " + [
            key.constructor.name,
            val.constructor.name
        ]);
    };
};



var $31c552654473c9c5$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($f2a05b25fd567d1b$export$36091c79ca1ac67);
var $31c552654473c9c5$var$applyFirst = /* #__PURE__ */ $7576d3a958d66ab0$export$e48e2da4536c2eea($103f9ee2d6d6c8d4$export$4d1e42c8f37c64fd);
var $31c552654473c9c5$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($103f9ee2d6d6c8d4$export$2e826c8750ceccf2);
var $31c552654473c9c5$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $31c552654473c9c5$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($103f9ee2d6d6c8d4$export$4d1e42c8f37c64fd);
var $31c552654473c9c5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($103f9ee2d6d6c8d4$export$26b7132f5789b0b0);
var $31c552654473c9c5$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6)($f2a05b25fd567d1b$export$6a64e684da29873);
var $31c552654473c9c5$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($f2a05b25fd567d1b$export$6a64e684da29873);
var $31c552654473c9c5$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($103f9ee2d6d6c8d4$export$26b7132f5789b0b0);
var $31c552654473c9c5$var$apply1 = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7576d3a958d66ab0$export$2f68caa5c730775d);
var $31c552654473c9c5$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $31c552654473c9c5$export$b27cd6e37b4ab43d = /* #__PURE__ */ function() {
    function RouteDuplex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RouteDuplex.create = function(value0) {
        return function(value1) {
            return new RouteDuplex(value0, value1);
        };
    };
    return RouteDuplex;
}();
var $31c552654473c9c5$export$559d1204393b53b9 = function(v) {
    return function(s) {
        return new $31c552654473c9c5$export$b27cd6e37b4ab43d(function(a) {
            return $31c552654473c9c5$var$append(v.value0(a))($f2a05b25fd567d1b$export$327f7b26ebf455db(s));
        }, $31c552654473c9c5$var$applyFirst(v.value1)($103f9ee2d6d6c8d4$export$82e9f45cca5ba907(s)($31c552654473c9c5$var$pure($05149ea687d6b460$export$523c0b569236b342))));
    };
};
var $31c552654473c9c5$export$22b082955e083ec3 = $31c552654473c9c5$var$identity;
var $31c552654473c9c5$export$6519c25590136c5e = /* #__PURE__ */ function() {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($f2a05b25fd567d1b$export$327f7b26ebf455db, $103f9ee2d6d6c8d4$export$b7df5d561049483a);
}();
var $31c552654473c9c5$export$c58417706a208278 = /* #__PURE__ */ function() {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$e97014618a7eb593)($f2a05b25fd567d1b$export$6a64e684da29873)($f2a05b25fd567d1b$export$327f7b26ebf455db), $103f9ee2d6d6c8d4$export$c58417706a208278);
}();
var $31c552654473c9c5$export$e5185e241753e543 = /* #__PURE__ */ function() {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($784e1bd3d26d71da$export$9a7d64bc1d75357($784e1bd3d26d71da$export$192e81b9fe7e4abe($f2a05b25fd567d1b$export$6a64e684da29873)), $31c552654473c9c5$var$pure({}));
}();
var $31c552654473c9c5$export$977f3f6a9323c0f6 = function(dictIsSymbol) {
    var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
    return function() {
        return function() {
            return function() {
                return function(sym) {
                    return function(v) {
                        return function(v1) {
                            return new $31c552654473c9c5$export$b27cd6e37b4ab43d(function(r) {
                                return $31c552654473c9c5$var$append(v1.value0(r))(v.value0(get(sym)(r)));
                            }, $31c552654473c9c5$var$apply($31c552654473c9c5$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f(insert(sym)))(v1.value1))(v.value1));
                        };
                    };
                };
            };
        };
    };
};
var $31c552654473c9c5$export$38d7971fe02ccb0c = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $31c552654473c9c5$export$b27cd6e37b4ab43d(function($137) {
                    return v.value0(f($137));
                }, $31c552654473c9c5$var$map(g)(v.value1));
            };
        };
    }
};
var $31c552654473c9c5$export$c2d084dc44961371 = function(v) {
    return function($138) {
        return $f2a05b25fd567d1b$export$889ea624f2cb2c57(v.value0($138));
    };
};
var $31c552654473c9c5$export$82e9f45cca5ba907 = function(s) {
    return function(v) {
        return new $31c552654473c9c5$export$b27cd6e37b4ab43d(function(a) {
            return $31c552654473c9c5$var$append($f2a05b25fd567d1b$export$327f7b26ebf455db(s))(v.value0(a));
        }, $103f9ee2d6d6c8d4$export$82e9f45cca5ba907(s)(v.value1));
    };
};
var $31c552654473c9c5$export$bb654e07daaf8c3a = /* #__PURE__ */ function() {
    var $139 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593)($31c552654473c9c5$export$82e9f45cca5ba907));
    var $140 = $5b07e36f812dd04b$export$65980d18b75784e2("/");
    return function($141) {
        return $139($140($141));
    };
}();
var $31c552654473c9c5$export$e8e78c978b129247 = /* #__PURE__ */ $31c552654473c9c5$export$bb654e07daaf8c3a("");
var $31c552654473c9c5$export$98e6a39c04603d36 = function(v) {
    return $103f9ee2d6d6c8d4$export$889ea624f2cb2c57(v.value1);
};
var $31c552654473c9c5$export$281ad3752a540efe = function(dict) {
    return dict.params;
};
var $31c552654473c9c5$export$6f7d1d9d04558207 = function(p) {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($f2a05b25fd567d1b$export$6f7d1d9d04558207(p), $103f9ee2d6d6c8d4$export$6f7d1d9d04558207(p));
};
var $31c552654473c9c5$export$516e28dec6a4b6d4 = function(v) {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($31c552654473c9c5$var$foldMap(v.value0), $103f9ee2d6d6c8d4$export$516e28dec6a4b6d4(v.value1));
};
var $31c552654473c9c5$export$a6482580fab70c30 = function(dictFoldable) {
    var foldMap1 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($f2a05b25fd567d1b$export$6a64e684da29873);
    return function(dictAlt) {
        var many11 = $103f9ee2d6d6c8d4$export$a6482580fab70c30(dictAlt);
        return function(dictApplicative) {
            var many12 = many11(dictApplicative);
            return function(v) {
                return new $31c552654473c9c5$export$b27cd6e37b4ab43d(foldMap1(v.value0), many12(v.value1));
            };
        };
    };
};
var $31c552654473c9c5$export$14badfee79ea396f = function(dictFoldable) {
    var foldMap1 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($f2a05b25fd567d1b$export$6a64e684da29873);
    return function(dictAlternative) {
        var many2 = $103f9ee2d6d6c8d4$export$14badfee79ea396f(dictAlternative);
        return function(v) {
            return new $31c552654473c9c5$export$b27cd6e37b4ab43d(foldMap1(v.value0), many2(v.value1));
        };
    };
};
var $31c552654473c9c5$export$d6af199866bfb566 = /* #__PURE__ */ function() {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d($f2a05b25fd567d1b$export$d6af199866bfb566, $103f9ee2d6d6c8d4$export$d6af199866bfb566);
}();
var $31c552654473c9c5$export$9276c8ded7831972 = {
    map: function(f) {
        return function(m) {
            return new $31c552654473c9c5$export$b27cd6e37b4ab43d(m.value0, $31c552654473c9c5$var$map(f)(m.value1));
        };
    }
};
var $31c552654473c9c5$export$42405f212471e8a2 = function(v) {
    var enc$prime = function(v1) {
        if (v1) return v.value0("");
        return $31c552654473c9c5$var$mempty;
    };
    var dec$prime = $103f9ee2d6d6c8d4$export$2e2bcd8739ae039(false)($31c552654473c9c5$var$voidLeft(v.value1)(true));
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d(enc$prime, dec$prime);
};
var $31c552654473c9c5$export$bd5df0f255a350f8 = function(v) {
    return new $31c552654473c9c5$export$b27cd6e37b4ab43d(v.value0, $31c552654473c9c5$var$applyFirst(v.value1)($103f9ee2d6d6c8d4$export$bd5df0f255a350f8));
};
var $31c552654473c9c5$export$2e2bcd8739ae039 = function(d) {
    return function(v) {
        return new $31c552654473c9c5$export$b27cd6e37b4ab43d(v.value0, $103f9ee2d6d6c8d4$export$2e2bcd8739ae039(d)(v.value1));
    };
};
var $31c552654473c9c5$export$306f402c2435746a = {
    buildParams: function(v) {
        return function(v1) {
            return $31c552654473c9c5$var$identity;
        };
    }
};
var $31c552654473c9c5$export$2b8d6efcffd455aa = function(dict) {
    return dict.buildParams;
};
var $31c552654473c9c5$export$badcc48b542f5e34 = function(dictIsSymbol) {
    var prop1 = $31c552654473c9c5$export$977f3f6a9323c0f6(dictIsSymbol)()()();
    var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function() {
                return function() {
                    return function(dictRouteDuplexBuildParams) {
                        var buildParams1 = $31c552654473c9c5$export$2b8d6efcffd455aa(dictRouteDuplexBuildParams);
                        return {
                            buildParams: function(v) {
                                return function(r) {
                                    return function(prev) {
                                        return buildParams1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r)(prop1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r)($31c552654473c9c5$export$6f7d1d9d04558207(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))))(prev));
                                    };
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var $31c552654473c9c5$export$8b89325bd0e98955 = function() {
    return function(dictRouteDuplexBuildParams) {
        var buildParams1 = $31c552654473c9c5$export$2b8d6efcffd455aa(dictRouteDuplexBuildParams);
        return {
            params: function(r) {
                return buildParams1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r)($31c552654473c9c5$export$e5185e241753e543);
            }
        };
    };
};
var $31c552654473c9c5$export$6554612db691658e = function(f) {
    return function(g) {
        return function(v) {
            return new $31c552654473c9c5$export$b27cd6e37b4ab43d(function($142) {
                return v.value0(f($142));
            }, $103f9ee2d6d6c8d4$export$6554612db691658e($31c552654473c9c5$var$identity)(g)(v.value1));
        };
    };
};
var $31c552654473c9c5$export$4a21f16c33752377 = /* #__PURE__ */ $31c552654473c9c5$export$6554612db691658e(/* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$ad55f318773e3cd5))($103f9ee2d6d6c8d4$export$4a21f16c33752377);
var $31c552654473c9c5$export$7d260a2a5f8bc19e = /* #__PURE__ */ $31c552654473c9c5$export$6554612db691658e(/* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0))($103f9ee2d6d6c8d4$export$7d260a2a5f8bc19e);
var $31c552654473c9c5$export$ab240c7ff09fcaae = {
    apply: function(v) {
        return function(v1) {
            return new $31c552654473c9c5$export$b27cd6e37b4ab43d($31c552654473c9c5$var$apply1($31c552654473c9c5$var$map1($31c552654473c9c5$var$append)(v.value0))(v1.value0), $31c552654473c9c5$var$apply(v.value1)(v1.value1));
        };
    },
    Functor0: function() {
        return $31c552654473c9c5$export$9276c8ded7831972;
    }
};
var $31c552654473c9c5$export$a770758c786d6ce1 = {
    pure: /* #__PURE__ */ function() {
        var $143 = $31c552654473c9c5$export$b27cd6e37b4ab43d.create($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($31c552654473c9c5$var$mempty));
        return function($144) {
            return $143($31c552654473c9c5$var$pure($144));
        };
    }(),
    Apply0: function() {
        return $31c552654473c9c5$export$ab240c7ff09fcaae;
    }
};



var $c18e210e93b812bc$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $c18e210e93b812bc$var$pingTimeAvgMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeAvgMillis";
    }
};
var $c18e210e93b812bc$var$pingTimeMaxMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeMaxMillis";
    }
};
var $c18e210e93b812bc$var$pingTimeMedianMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeMedianMillis";
    }
};
var $c18e210e93b812bc$var$pingTimeMinMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeMinMillis";
    }
};
var $c18e210e93b812bc$var$pingTimeStdDevJitterMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeStdDevJitterMillis";
    }
};
var $c18e210e93b812bc$var$pingTimeTR143JitterMillisIsSymbol = {
    reflectSymbol: function() {
        return "pingTimeTR143JitterMillis";
    }
};
var $c18e210e93b812bc$var$timestampIsSymbol = {
    reflectSymbol: function() {
        return "timestamp";
    }
};
var $c18e210e93b812bc$var$messageIsSymbol = {
    reflectSymbol: function() {
        return "message";
    }
};
var $c18e210e93b812bc$var$genericShowConstructor = /* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$f7ad98836d6849e8);
var $c18e210e93b812bc$var$routeDuplexParams = /* #__PURE__ */ $31c552654473c9c5$export$8b89325bd0e98955();
var $c18e210e93b812bc$var$buildParamsCons = /* #__PURE__ */ $31c552654473c9c5$export$badcc48b542f5e34({
    reflectSymbol: function() {
        return "c";
    }
})()()()();
var $c18e210e93b812bc$var$jobIdIsSymbol = {
    reflectSymbol: function() {
        return "jobId";
    }
};
var $c18e210e93b812bc$var$object = /* #__PURE__ */ $de857520e626927f$export$be5493f9613cbbe();
var $c18e210e93b812bc$var$rowListCodecCons = /* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$e2fadcee73eb7d4b)()();
var $c18e210e93b812bc$var$composeFlipped1 = /* #__PURE__ */ $4672333bf471fbe0$export$b5a9558a7176e41b($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $c18e210e93b812bc$var$object1 = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons($c18e210e93b812bc$var$jobIdIsSymbol));
var $c18e210e93b812bc$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $c18e210e93b812bc$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $c18e210e93b812bc$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $784e1bd3d26d71da$export$192e81b9fe7e4abe($784e1bd3d26d71da$export$fc39f3d77fa2e58a));
var $c18e210e93b812bc$var$configIsSymbol = {
    reflectSymbol: function() {
        return "config";
    }
};
var $c18e210e93b812bc$export$c658a51c52adf59c = /* #__PURE__ */ function() {
    function BulkPingSuccess(value0) {
        this.value0 = value0;
    }
    BulkPingSuccess.create = function(value0) {
        return new BulkPingSuccess(value0);
    };
    return BulkPingSuccess;
}();
var $c18e210e93b812bc$export$41b4bf69b8d5459d = /* #__PURE__ */ function() {
    function BulkPingError(value0) {
        this.value0 = value0;
    }
    BulkPingError.create = function(value0) {
        return new BulkPingError(value0);
    };
    return BulkPingError;
}();
var $c18e210e93b812bc$export$f01a785a5ae81e49 = /* #__PURE__ */ function() {
    function Pending() {}
    Pending.value = new Pending();
    return Pending;
}();
var $c18e210e93b812bc$export$91ba99b381c82aee = /* #__PURE__ */ function() {
    function Running() {}
    Running.value = new Running();
    return Running;
}();
var $c18e210e93b812bc$export$98c5edc703974274 = /* #__PURE__ */ function() {
    function Cancelled() {}
    Cancelled.value = new Cancelled();
    return Cancelled;
}();
var $c18e210e93b812bc$export$c5d72bc034a5be08 = /* #__PURE__ */ function() {
    function Finished() {}
    Finished.value = new Finished();
    return Finished;
}();
var $c18e210e93b812bc$export$91ae1e982b7b05d4 = /* #__PURE__ */ function() {
    function Failed() {}
    Failed.value = new Failed();
    return Failed;
}();
var $c18e210e93b812bc$export$f8f951e3e7d3e921 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $c18e210e93b812bc$export$c658a51c52adf59c(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $c18e210e93b812bc$export$41b4bf69b8d5459d(x.value0);
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 274, column 1 - line 274, column 41): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $c18e210e93b812bc$export$41b4bf69b8d5459d) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 274, column 1 - line 274, column 41): " + [
            x.constructor.name
        ]);
    }
};
var $c18e210e93b812bc$export$dc3dbe75e16c66dc = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($c18e210e93b812bc$export$f8f951e3e7d3e921)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $c18e210e93b812bc$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeAvgMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeMaxMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeMedianMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeMinMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeStdDevJitterMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c18e210e93b812bc$var$pingTimeTR143JitterMillisIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($c18e210e93b812bc$var$timestampIsSymbol)($18f2b327b2ac3376$export$a1af12e21b57795a))($77539ec2bd3ecb1b$export$be90a4e56bd555d))($77539ec2bd3ecb1b$export$be90a4e56bd555d))($77539ec2bd3ecb1b$export$be90a4e56bd555d))($77539ec2bd3ecb1b$export$be90a4e56bd555d))($77539ec2bd3ecb1b$export$be90a4e56bd555d))($77539ec2bd3ecb1b$export$be90a4e56bd555d))))({
        reflectSymbol: function() {
            return "BulkPingSuccess";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845(/* #__PURE__ */ $544b62a378cc0091$export$bc1180ef96fcb658(/* #__PURE__ */ $c18e210e93b812bc$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($c18e210e93b812bc$var$messageIsSymbol)($2c6b3d51d10471a7$export$e4b6cd05df3043f6))))({
        reflectSymbol: function() {
            return "BulkPingError";
        }
    })))
};
var $c18e210e93b812bc$export$4ccbac7219bc9ad2 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $c18e210e93b812bc$export$f01a785a5ae81e49.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $c18e210e93b812bc$export$91ba99b381c82aee.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $c18e210e93b812bc$export$98c5edc703974274.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $c18e210e93b812bc$export$c5d72bc034a5be08.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $c18e210e93b812bc$export$91ae1e982b7b05d4.value;
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 184, column 1 - line 184, column 44): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $c18e210e93b812bc$export$f01a785a5ae81e49) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $c18e210e93b812bc$export$98c5edc703974274) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)));
        if (x instanceof $c18e210e93b812bc$export$c5d72bc034a5be08) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value))));
        if (x instanceof $c18e210e93b812bc$export$91ae1e982b7b05d4) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value))));
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 184, column 1 - line 184, column 44): " + [
            x.constructor.name
        ]);
    }
};
var $c18e210e93b812bc$export$312553782ac604fe = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($c18e210e93b812bc$export$4ccbac7219bc9ad2)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $c18e210e93b812bc$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Pending";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $c18e210e93b812bc$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Running";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $c18e210e93b812bc$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Cancelled";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $c18e210e93b812bc$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Finished";
        }
    }))(/* #__PURE__ */ $c18e210e93b812bc$var$genericShowConstructor({
        reflectSymbol: function() {
            return "Failed";
        }
    }))))))
};
var $c18e210e93b812bc$var$rdBulkPingStatusQuery = /* #__PURE__ */ $31c552654473c9c5$export$281ad3752a540efe(/* #__PURE__ */ $c18e210e93b812bc$var$routeDuplexParams(/* #__PURE__ */ $c18e210e93b812bc$var$buildParamsCons($31c552654473c9c5$export$306f402c2435746a)))({
    c: $31c552654473c9c5$export$7d260a2a5f8bc19e
});
var $c18e210e93b812bc$var$rdBulkPingResultQuery = /* #__PURE__ */ $31c552654473c9c5$export$281ad3752a540efe(/* #__PURE__ */ $c18e210e93b812bc$var$routeDuplexParams(/* #__PURE__ */ $c18e210e93b812bc$var$buildParamsCons(/* #__PURE__ */ $31c552654473c9c5$export$badcc48b542f5e34($c18e210e93b812bc$var$jobIdIsSymbol)()()()()($31c552654473c9c5$export$306f402c2435746a))))({
    jobId: $31c552654473c9c5$export$22b082955e083ec3,
    c: $31c552654473c9c5$export$7d260a2a5f8bc19e
});
var $c18e210e93b812bc$var$codecObj = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$833910855e0453a8(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "tag";
    }
}))()()({
    reflectSymbol: function() {
        return "payload";
    }
}))("TaggedObject")({
    tag: $59dadf91e1f9eb9a$export$22b082955e083ec3,
    payload: /* #__PURE__ */ $de857520e626927f$export$516e28dec6a4b6d4($59dadf91e1f9eb9a$export$7b419323e6ed4f31)
});
var $c18e210e93b812bc$var$codecJobStatus = /* #__PURE__ */ function() {
    var encode = function(v) {
        if (v instanceof $c18e210e93b812bc$export$f01a785a5ae81e49) return "Pending";
        if (v instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return "Running";
        if (v instanceof $c18e210e93b812bc$export$98c5edc703974274) return "Cancelled";
        if (v instanceof $c18e210e93b812bc$export$c5d72bc034a5be08) return "Finished";
        if (v instanceof $c18e210e93b812bc$export$91ae1e982b7b05d4) return "Failed";
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 230, column 14 - line 235, column 25): " + [
            v.constructor.name
        ]);
    };
    var decode = function(v) {
        if (v === "Pending") return new $06733ae99ed4f534$export$8a67b48435b5d073($c18e210e93b812bc$export$f01a785a5ae81e49.value);
        if (v === "Running") return new $06733ae99ed4f534$export$8a67b48435b5d073($c18e210e93b812bc$export$91ba99b381c82aee.value);
        if (v === "Cancelled") return new $06733ae99ed4f534$export$8a67b48435b5d073($c18e210e93b812bc$export$98c5edc703974274.value);
        if (v === "Finished") return new $06733ae99ed4f534$export$8a67b48435b5d073($c18e210e93b812bc$export$c5d72bc034a5be08.value);
        if (v === "Failed") return new $06733ae99ed4f534$export$8a67b48435b5d073($c18e210e93b812bc$export$91ae1e982b7b05d4.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    return $59dadf91e1f9eb9a$export$56923548158521c8("BulkPingJobStatus")(decode)(encode)($59dadf91e1f9eb9a$export$22b082955e083ec3);
}();
var $c18e210e93b812bc$var$codecDurationMillis = /* #__PURE__ */ function() {
    var encode = function() {
        var $273 = $4fa4836228a192cc$export$a2a39c9747f0e54a()($3c54b6e6d30cc3be$export$e4eccef8f937a949);
        var $274 = $3c54b6e6d30cc3be$export$3082151037402ab5($77539ec2bd3ecb1b$export$68674a2aef2c81c4)($3c54b6e6d30cc3be$export$44304cbc75c995e8);
        return function($275) {
            return $273($274($275));
        };
    }();
    var decode = function() {
        var $276 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
        return function($277) {
            return $276($77539ec2bd3ecb1b$export$a4cfb53d2e8c8e2a($277));
        };
    }();
    return $c18e210e93b812bc$var$composeFlipped1($59dadf91e1f9eb9a$export$98e628dec113755e)($4672333bf471fbe0$export$1c37c01eba8ed446(decode)(encode));
}();
var $c18e210e93b812bc$var$codecDateTime = /* #__PURE__ */ function() {
    var decode = function() {
        var $278 = $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff)(function($280) {
            return $59dadf91e1f9eb9a$export$168e2d3b16829a.create($2b6d012b5a71a466$export$91c32f1b22d29b2d($280));
        })(function(v) {
            return v.value0;
        });
        return function($279) {
            return $278($d957c5ca0f0ee82a$export$3004f64547af360e($279));
        };
    }();
    return $c18e210e93b812bc$var$composeFlipped1($59dadf91e1f9eb9a$export$22b082955e083ec3)($4672333bf471fbe0$export$1c37c01eba8ed446(decode)($91dd73a7945cfe05$export$e003485a67becadb));
}();
var $c18e210e93b812bc$export$45f73b85628cdada = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "status";
    }
}))()()({
    reflectSymbol: function() {
        return "startedAt";
    }
}))()()({
    reflectSymbol: function() {
        return "processedIpCount";
    }
}))()()({
    reflectSymbol: function() {
        return "initialIpCount";
    }
}))()()({
    reflectSymbol: function() {
        return "errorsCount";
    }
}))("BulkPingJobStatusEntry")({
    status: $c18e210e93b812bc$var$codecJobStatus,
    processedIpCount: $59dadf91e1f9eb9a$export$7d260a2a5f8bc19e,
    initialIpCount: $59dadf91e1f9eb9a$export$7d260a2a5f8bc19e,
    errorsCount: $59dadf91e1f9eb9a$export$7d260a2a5f8bc19e,
    startedAt: $c18e210e93b812bc$var$codecDateTime
});
var $c18e210e93b812bc$export$3e98d7ad229e11ad = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "jobs";
    }
}))("BulkPingStatusResponse")({
    jobs: /* #__PURE__ */ $2cc1e29b7237f20d$export$4dbc9bb913ac528d($c18e210e93b812bc$export$45f73b85628cdada)
});
var $c18e210e93b812bc$export$2d2b162ef7dafa93 = function(baseUrl) {
    return function(token) {
        return function(query) {
            return $0dd27f203988b439$export$80924b6edd3335d0({
                baseUrl: baseUrl,
                method: $0279ce8fdb6b506c$export$1bb358554aac31c1.value,
                path: "v1/vf/bulk-ping/status",
                token: new $06733ae99ed4f534$export$8a67b48435b5d073(token),
                query: new $06733ae99ed4f534$export$8a67b48435b5d073(query),
                body: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                encodeBody: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($0e031af7428ef07d$export$63ea9a5410ee0cef),
                encodeQuery: $31c552654473c9c5$export$c2d084dc44961371($c18e210e93b812bc$var$rdBulkPingStatusQuery),
                decodeResponse: $4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$export$3e98d7ad229e11ad)
            });
        };
    };
};
var $c18e210e93b812bc$var$codecBulkPingStartResponse = /* #__PURE__ */ $c18e210e93b812bc$var$object1("BulkPingStartResponse")({
    jobId: $59dadf91e1f9eb9a$export$22b082955e083ec3
});
var $c18e210e93b812bc$var$codecBulkPingResult = /* #__PURE__ */ function() {
    var codecSuccessFields = $c18e210e93b812bc$var$object($de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$d6995eb37c070d1c($de857520e626927f$export$d6995eb37c070d1c($c18e210e93b812bc$var$rowListCodecCons($c18e210e93b812bc$var$timestampIsSymbol))()()($c18e210e93b812bc$var$pingTimeTR143JitterMillisIsSymbol))()()($c18e210e93b812bc$var$pingTimeStdDevJitterMillisIsSymbol))()()($c18e210e93b812bc$var$pingTimeMinMillisIsSymbol))()()($c18e210e93b812bc$var$pingTimeMedianMillisIsSymbol))()()($c18e210e93b812bc$var$pingTimeMaxMillisIsSymbol))()()($c18e210e93b812bc$var$pingTimeAvgMillisIsSymbol))("BulkPingSuccess")({
        pingTimeMinMillis: $c18e210e93b812bc$var$codecDurationMillis,
        pingTimeAvgMillis: $c18e210e93b812bc$var$codecDurationMillis,
        pingTimeMaxMillis: $c18e210e93b812bc$var$codecDurationMillis,
        pingTimeStdDevJitterMillis: $c18e210e93b812bc$var$codecDurationMillis,
        pingTimeTR143JitterMillis: $c18e210e93b812bc$var$codecDurationMillis,
        pingTimeMedianMillis: $c18e210e93b812bc$var$codecDurationMillis,
        timestamp: $c18e210e93b812bc$var$codecDateTime
    });
    var codecErrorFields = $c18e210e93b812bc$var$object($c18e210e93b812bc$var$rowListCodecCons($c18e210e93b812bc$var$messageIsSymbol))("BulkPingError")({
        message: $59dadf91e1f9eb9a$export$22b082955e083ec3
    });
    var decode = function(json) {
        return $c18e210e93b812bc$var$bind($4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$var$codecObj)(json))(function(obj) {
            if (obj.tag === "BulkPingSuccess") {
                if (obj.payload instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c18e210e93b812bc$var$map($c18e210e93b812bc$export$c658a51c52adf59c.create)($4672333bf471fbe0$export$2f872c0f2117be69(codecSuccessFields)(obj.payload.value0));
                if (obj.payload instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$168e2d3b16829a("BulkPingResult"));
                throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 291, column 28 - line 293, column 59): " + [
                    obj.payload.constructor.name
                ]);
            }
            if (obj.tag === "BulkPingError") {
                if (obj.payload instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c18e210e93b812bc$var$map($c18e210e93b812bc$export$41b4bf69b8d5459d.create)($4672333bf471fbe0$export$2f872c0f2117be69(codecErrorFields)(obj.payload.value0));
                if (obj.payload instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$168e2d3b16829a("BulkPingResult"));
                throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 294, column 26 - line 296, column 59): " + [
                    obj.payload.constructor.name
                ]);
            }
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $59dadf91e1f9eb9a$export$168e2d3b16829a("BulkPingResult"));
        });
    };
    var encode = function(v) {
        if (v instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return $4672333bf471fbe0$export$c564cdbbe6da493(codecSuccessFields)(v.value0);
        if (v instanceof $c18e210e93b812bc$export$41b4bf69b8d5459d) return $4672333bf471fbe0$export$c564cdbbe6da493(codecErrorFields)(v.value0);
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 283, column 12 - line 285, column 52): " + [
            v.constructor.name
        ]);
    };
    return $4672333bf471fbe0$export$1c37c01eba8ed446(decode)(encode);
}();
var $c18e210e93b812bc$var$codecBulkPingEntry = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "timeSyn";
    }
}))()()({
    reflectSymbol: function() {
        return "timeIcmp";
    }
}))()()({
    reflectSymbol: function() {
        return "destination";
    }
}))("BulkPingEntry")({
    destination: $59dadf91e1f9eb9a$export$22b082955e083ec3,
    timeSyn: /* #__PURE__ */ $a33259e81bd72832$export$f8b8b9ce72e9ccbf($c18e210e93b812bc$var$codecBulkPingResult),
    timeIcmp: /* #__PURE__ */ $a33259e81bd72832$export$f8b8b9ce72e9ccbf($c18e210e93b812bc$var$codecBulkPingResult)
});
var $c18e210e93b812bc$var$codecBulkPingCancelResponse = /* #__PURE__ */ $c18e210e93b812bc$var$object($de857520e626927f$export$e2fadcee73eb7d4b)("BulkPingCancelResponse")({});
var $c18e210e93b812bc$var$codecBulkPingCancelRequest = /* #__PURE__ */ $c18e210e93b812bc$var$object1("BulkPingCancelRequest")({
    jobId: $59dadf91e1f9eb9a$export$22b082955e083ec3
});
var $c18e210e93b812bc$export$84751c876800def0 = function(baseUrl) {
    return function(token) {
        return function(body) {
            return $0dd27f203988b439$export$80924b6edd3335d0({
                baseUrl: baseUrl,
                method: $0279ce8fdb6b506c$export$484f3009c2ee32ad.value,
                path: "v1/vf/bulk-ping/cancel",
                token: new $06733ae99ed4f534$export$8a67b48435b5d073(token),
                query: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                body: new $06733ae99ed4f534$export$8a67b48435b5d073(body),
                encodeBody: $4672333bf471fbe0$export$c564cdbbe6da493($c18e210e93b812bc$var$codecBulkPingCancelRequest),
                decodeResponse: $4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$var$codecBulkPingCancelResponse),
                encodeQuery: $c18e210e93b812bc$var$mempty
            });
        };
    };
};
var $c18e210e93b812bc$var$codecBasicURL = /* #__PURE__ */ function() {
    var decode = function() {
        var $281 = $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff)(function() {
            var $283 = $2c6b3d51d10471a7$export$57bf213be019eeb0($2b6d012b5a71a466$export$7967a4332fb063d4);
            return function($284) {
                return $59dadf91e1f9eb9a$export$168e2d3b16829a.create($283($284));
            };
        }());
        return function($282) {
            return $281($b9f56ead6323c237$export$98e6a39c04603d36($282));
        };
    }();
    return $c18e210e93b812bc$var$composeFlipped1($59dadf91e1f9eb9a$export$22b082955e083ec3)($4672333bf471fbe0$export$1c37c01eba8ed446(decode)($b9f56ead6323c237$export$c2d084dc44961371));
}();
var $c18e210e93b812bc$var$codecBulkPingConfig = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "useSynToPort";
    }
}))()()({
    reflectSymbol: function() {
        return "useIcmp";
    }
}))()()({
    reflectSymbol: function() {
        return "pingCountPerIp";
    }
}))()()({
    reflectSymbol: function() {
        return "intervalBetweenPingsMillis";
    }
}))()()({
    reflectSymbol: function() {
        return "intervalBetweenIpsMillis";
    }
}))()()({
    reflectSymbol: function() {
        return "agentUrl";
    }
}))("BulkPingConfig")({
    pingCountPerIp: $59dadf91e1f9eb9a$export$7d260a2a5f8bc19e,
    agentUrl: $c18e210e93b812bc$var$codecBasicURL,
    intervalBetweenPingsMillis: $c18e210e93b812bc$var$codecDurationMillis,
    intervalBetweenIpsMillis: $c18e210e93b812bc$var$codecDurationMillis,
    useSynToPort: /* #__PURE__ */ $a33259e81bd72832$export$f8b8b9ce72e9ccbf($59dadf91e1f9eb9a$export$7d260a2a5f8bc19e),
    useIcmp: $59dadf91e1f9eb9a$export$4a21f16c33752377
});
var $c18e210e93b812bc$export$25d59078780ac8cb = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "results";
    }
}))()()($c18e210e93b812bc$var$configIsSymbol))("BulkPingResultResponse")({
    config: $c18e210e93b812bc$var$codecBulkPingConfig,
    results: /* #__PURE__ */ $59dadf91e1f9eb9a$export$2f23118c22fb2630($c18e210e93b812bc$var$codecBulkPingEntry)
});
var $c18e210e93b812bc$export$a50228035c1e8ce6 = function(baseUrl) {
    return function(token) {
        return function(query) {
            return $0dd27f203988b439$export$80924b6edd3335d0({
                baseUrl: baseUrl,
                method: $0279ce8fdb6b506c$export$1bb358554aac31c1.value,
                path: "v1/vf/bulk-ping/result",
                token: new $06733ae99ed4f534$export$8a67b48435b5d073(token),
                query: new $06733ae99ed4f534$export$8a67b48435b5d073(query),
                body: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                encodeBody: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($0e031af7428ef07d$export$63ea9a5410ee0cef),
                encodeQuery: $31c552654473c9c5$export$c2d084dc44961371($c18e210e93b812bc$var$rdBulkPingResultQuery),
                decodeResponse: $4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$export$25d59078780ac8cb)
            });
        };
    };
};
var $c18e210e93b812bc$export$435850408b08cfa8 = /* #__PURE__ */ $c18e210e93b812bc$var$object(/* #__PURE__ */ $de857520e626927f$export$d6995eb37c070d1c(/* #__PURE__ */ $c18e210e93b812bc$var$rowListCodecCons({
    reflectSymbol: function() {
        return "destinationIps";
    }
}))()()($c18e210e93b812bc$var$configIsSymbol))("BulkPingStartRequest")({
    destinationIps: /* #__PURE__ */ $59dadf91e1f9eb9a$export$2f23118c22fb2630($59dadf91e1f9eb9a$export$22b082955e083ec3),
    config: $c18e210e93b812bc$var$codecBulkPingConfig
});
var $c18e210e93b812bc$export$29f8406c1d30ba25 = function(baseUrl) {
    return function(token) {
        return function(body) {
            return $0dd27f203988b439$export$80924b6edd3335d0({
                baseUrl: baseUrl,
                method: $0279ce8fdb6b506c$export$484f3009c2ee32ad.value,
                path: "v1/vf/bulk-ping/start",
                token: new $06733ae99ed4f534$export$8a67b48435b5d073(token),
                query: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                body: new $06733ae99ed4f534$export$8a67b48435b5d073(body),
                encodeBody: $4672333bf471fbe0$export$c564cdbbe6da493($c18e210e93b812bc$export$435850408b08cfa8),
                decodeResponse: $4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$var$codecBulkPingStartResponse),
                encodeQuery: $c18e210e93b812bc$var$mempty
            });
        };
    };
};


// Generated by purs version 0.15.15


// Generated by purs version 0.15.15











// Generated by purs version 0.15.15
function $2d783a45bb716946$export$209a9e76e7f1bdd5(f, s, key, value) {
    return value == null ? f : s(value[key]);
}
function $2d783a45bb716946$export$2c522840c892e8a(prop, value) {
    return Object.prototype.hasOwnProperty.call(value, prop);
}
function $2d783a45bb716946$export$c3f84ec7467d28a0(prop, value) {
    return prop in value;
}







var $79efcffe70231542$var$unsafeReadProp = function(dictMonad) {
    var fail = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(k) {
        return function(value) {
            return $2d783a45bb716946$export$209a9e76e7f1bdd5(fail(new $c97d2d0f578f81ad$export$168e2d3b16829a("object", $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value))), pure, k, value);
        };
    };
};
var $79efcffe70231542$export$d133c026d013828b = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$49ec5109fafd7888 = function(dictMonad) {
    return $79efcffe70231542$var$unsafeReadProp(dictMonad);
};
var $79efcffe70231542$export$bc3518d3f65cefd1 = function(dict) {
    return dict.ix;
};
var $79efcffe70231542$export$b610b8812bbcded9 = function(dict) {
    return dict.index;
};
var $79efcffe70231542$export$8e083630a1c429e2 = function(dictMonad) {
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9($d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad));
    return {
        ix: function(dictIndex) {
            var index1 = $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
            return function(f) {
                return function(i) {
                    return bindFlipped($f57f4b701aa7b66e$export$8a83211c878a3f1f(index1)(i))(f);
                };
            };
        }
    };
};
var $79efcffe70231542$export$5603d6456559ad27 = function(dictMonad) {
    return {
        ix: function(dictIndex) {
            return $79efcffe70231542$export$b610b8812bbcded9(dictIndex);
        }
    };
};
var $79efcffe70231542$var$hasPropertyImpl = function(v) {
    return function(v1) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "object" || $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "function") return $2d783a45bb716946$export$c3f84ec7467d28a0(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$bf9617eaf5d2451 = function(dict) {
    return dict.hasProperty;
};
var $79efcffe70231542$var$hasOwnPropertyImpl = function(v) {
    return function(v1) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(v1)) return false;
        if ($c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "object" || $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(v1) === "function") return $2d783a45bb716946$export$2c522840c892e8a(v, v1);
        return false;
    };
};
var $79efcffe70231542$export$27e041b47b0d7594 = function(dictMonad) {
    return {
        index: $f57f4b701aa7b66e$export$8a83211c878a3f1f($79efcffe70231542$export$49ec5109fafd7888(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $c97d2d0f578f81ad$export$20d9a5af040a79f1.create
    };
};
var $79efcffe70231542$export$d60c33947aba4299 = function(dictMonad) {
    return {
        index: $f57f4b701aa7b66e$export$8a83211c878a3f1f($79efcffe70231542$export$d133c026d013828b(dictMonad)),
        hasProperty: $79efcffe70231542$var$hasPropertyImpl,
        hasOwnProperty: $79efcffe70231542$var$hasOwnPropertyImpl,
        errorAt: $c97d2d0f578f81ad$export$92e5795aa905bd26.create
    };
};
var $79efcffe70231542$export$5a15a386532a5ea4 = function(dict) {
    return dict.hasOwnProperty;
};
var $79efcffe70231542$export$6917a1a7c5a9c9cc = function(dict) {
    return dict.errorAt;
};





// Generated by purs version 0.15.15
var $5253348ec4f02e0c$export$9b6706c8686cfc8e = "paste";
var $5253348ec4f02e0c$export$af2a99f971a346e6 = "cut";
var $5253348ec4f02e0c$export$784d13d8ee351f07 = "copy";
var $5253348ec4f02e0c$export$82e583f9eee21106 = "clipboardchange";


// Generated by purs version 0.15.15
function $669be0b5ad323ff1$export$a0e54c3daa7db493(e) {
    return e.bubbles;
}
function $669be0b5ad323ff1$export$95ff25b64c2b7c9d(e) {
    return e.cancelable;
}
function $669be0b5ad323ff1$export$c2cb7a6607e209d9(e) {
    return e.currentTarget;
}
function $669be0b5ad323ff1$export$6add31d873bb7f97(e) {
    return function() {
        return e.defaultPrevented;
    };
}
function $669be0b5ad323ff1$export$751396ee394cb35f(e) {
    return e.eventPhase;
}
function $669be0b5ad323ff1$export$e2c9f5456eee864(e) {
    return e.target;
}
function $669be0b5ad323ff1$export$c0dbb1ea68a069d3(e) {
    return e.timeStamp;
}
function $669be0b5ad323ff1$export$d4a6a4db5b31e621(e) {
    return e.type;
}
function $669be0b5ad323ff1$export$fa3b29edae795ef4(e) {
    return function() {
        return e.preventDefault();
    };
}
function $669be0b5ad323ff1$export$d5cb5f1c8a62fdf1(e) {
    return function() {
        return e.stopImmediatePropagation();
    };
}
function $669be0b5ad323ff1$export$51134cce184326b9(e) {
    return function() {
        return e.stopPropagation();
    };
}







// Generated by purs version 0.15.15



var $4cea5a089b994203$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $4cea5a089b994203$export$7c1f271456e9da5c = /* #__PURE__ */ function() {
    function Capturing() {}
    Capturing.value = new Capturing();
    return Capturing;
}();
var $4cea5a089b994203$export$c9dfa296ffa718f3 = /* #__PURE__ */ function() {
    function AtTarget() {}
    AtTarget.value = new AtTarget();
    return AtTarget;
}();
var $4cea5a089b994203$export$afda6610fd3be704 = /* #__PURE__ */ function() {
    function Bubbling() {}
    Bubbling.value = new Bubbling();
    return Bubbling;
}();
var $4cea5a089b994203$export$87e393cb260cfe35 = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$57ca7e07b341709d.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$7c1f271456e9da5c.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$c9dfa296ffa718f3.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($4cea5a089b994203$export$afda6610fd3be704.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $4cea5a089b994203$export$bf52d9629dd54342 = function(v) {
    if (v instanceof $4cea5a089b994203$export$57ca7e07b341709d) return 0;
    if (v instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return 1;
    if (v instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return 2;
    if (v instanceof $4cea5a089b994203$export$afda6610fd3be704) return 3;
    throw new Error("Failed pattern match at Web.Event.EventPhase (line 40, column 3 - line 44, column 18): " + [
        v.constructor.name
    ]);
};
var $4cea5a089b994203$export$e7849b249d968c7d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return true;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return true;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return true;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return true;
            return false;
        };
    }
};
var $4cea5a089b994203$export$2dff6326408f563 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d && y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$57ca7e07b341709d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c && y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$7c1f271456e9da5c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3 && y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $4cea5a089b994203$export$c9dfa296ffa718f3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $4cea5a089b994203$export$afda6610fd3be704 && y instanceof $4cea5a089b994203$export$afda6610fd3be704) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.Event.EventPhase (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $4cea5a089b994203$export$e7849b249d968c7d;
    }
};
var $4cea5a089b994203$export$1961ce3762a1f623 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($4cea5a089b994203$export$87e393cb260cfe35)($4cea5a089b994203$export$bf52d9629dd54342),
    Ord0: function() {
        return $4cea5a089b994203$export$2dff6326408f563;
    }
};
var $4cea5a089b994203$export$2c5501f89051a84e = /* #__PURE__ */ function() {
    return {
        bottom: $4cea5a089b994203$export$57ca7e07b341709d.value,
        top: $4cea5a089b994203$export$afda6610fd3be704.value,
        Ord0: function() {
            return $4cea5a089b994203$export$2dff6326408f563;
        }
    };
}();
var $4cea5a089b994203$export$9171e0cf0644640e = {
    cardinality: 4,
    toEnum: $4cea5a089b994203$export$87e393cb260cfe35,
    fromEnum: $4cea5a089b994203$export$bf52d9629dd54342,
    Bounded0: function() {
        return $4cea5a089b994203$export$2c5501f89051a84e;
    },
    Enum1: function() {
        return $4cea5a089b994203$export$1961ce3762a1f623;
    }
};



var $2829090ac282514c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $2829090ac282514c$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($4cea5a089b994203$export$9171e0cf0644640e);
var $2829090ac282514c$export$3d7865934588d77e = function(x) {
    return x;
};
var $2829090ac282514c$export$44271b4f0c6a3563 = function($3) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($669be0b5ad323ff1$export$e2c9f5456eee864($3));
};
var $2829090ac282514c$export$5c9c459b1e542b91 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $2829090ac282514c$export$bbde49cc37df068e = {
    Coercible0: function() {
        return undefined;
    }
};
var $2829090ac282514c$export$adaf9bfc2029072d = function() {
    return function($4) {
        return $2829090ac282514c$var$fromJust($2829090ac282514c$var$toEnum($669be0b5ad323ff1$export$751396ee394cb35f($4)));
    };
};
var $2829090ac282514c$export$521449dd33bc9b79 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $2829090ac282514c$export$28b27b1605aa05ad = function($5) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($669be0b5ad323ff1$export$c2cb7a6607e209d9($5));
};


// Generated by purs version 0.15.15
function $837e6eb387618e21$export$f24224f1c91d8156(fileList) {
    return fileList.length;
}
function $837e6eb387618e21$export$613ce04884e90507(index) {
    return function(fileList) {
        return fileList.item(index);
    };
}








var $520c7508336e9c23$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $520c7508336e9c23$export$7061c75fc5af8b7e = function(i) {
    var $5 = $837e6eb387618e21$export$613ce04884e90507(i);
    return function($6) {
        return $0a5aaf95f168428e$export$1ba013b88f4f21f3($5($6));
    };
};
var $520c7508336e9c23$export$17a1664ed1fb5d6f = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(fl) {
        return unfoldr(function(i) {
            return $520c7508336e9c23$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(i + 1 | 0))($520c7508336e9c23$export$7061c75fc5af8b7e(i)(fl));
        })(0);
    };
};


// Generated by purs version 0.15.15
var $9ca8e76be04efe86$export$663103110d94aac9 = "drop";
var $9ca8e76be04efe86$export$dc0badfde684823c = "dragstart";
var $9ca8e76be04efe86$export$ced0a5bb82ba6aee = "dragover";
var $9ca8e76be04efe86$export$f58195b0ad38aa36 = "dragleave";
var $9ca8e76be04efe86$export$ddffa9b7b4c3e300 = "dragexit";
var $9ca8e76be04efe86$export$bf1ba5dda238dc20 = "dragenter";
var $9ca8e76be04efe86$export$26ae3c90d367ea9a = "dragend";
var $9ca8e76be04efe86$export$d7d5d435647ed5a0 = "drag";




// Generated by purs version 0.15.15
var $9285e421afbabad0$export$d0dc5134b51e78ad = "focusout";
var $9285e421afbabad0$export$e7fa4ea7f1bfcb53 = "focusin";
var $9285e421afbabad0$export$d7ddd398f22d79ef = "focus";
var $9285e421afbabad0$export$2cc7ff91bcacba5e = "blur";


// Generated by purs version 0.15.15
var $981a0c6551e76cf0$export$d26052c770f81a55 = "keyup";
var $981a0c6551e76cf0$export$e65a0c4970da3025 = "keydown";


// Generated by purs version 0.15.15
var $7868044d3d97cfc5$export$c367b5bd9b361db9 = "mouseup";
var $7868044d3d97cfc5$export$41b161f130dc7f9 = "mouseover";
var $7868044d3d97cfc5$export$c3a736a37c400eb8 = "mouseout";
var $7868044d3d97cfc5$export$6d0a9e0f4f73830a = "mousemove";
var $7868044d3d97cfc5$export$996a190879e3098b = "mouseleave";
var $7868044d3d97cfc5$export$474cd8abd87e2f89 = "mouseenter";
var $7868044d3d97cfc5$export$8b0cb8993e7a9391 = "mousedown";
var $7868044d3d97cfc5$export$efb8dd8d61939266 = "dblclick";
var $7868044d3d97cfc5$export$64ef1bee2b9504c1 = "click";
var $7868044d3d97cfc5$export$2991dd47f111a03b = "auxclick";


// Generated by purs version 0.15.15
var $64b79e1476c3e095$export$d3028820ea014224 = "wheel";


var $10ae9db6658426ac$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $10ae9db6658426ac$var$composeKleisli = /* #__PURE__ */ $70cd3177464e7915$export$61a2047e1b1e0d3e($06733ae99ed4f534$export$e5fea5661dee377);
var $10ae9db6658426ac$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$var$readProp = /* #__PURE__ */ $79efcffe70231542$export$d133c026d013828b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $10ae9db6658426ac$var$readString = /* #__PURE__ */ $c97d2d0f578f81ad$export$dda73877cb166cd3($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $10ae9db6658426ac$var$wheelHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$touchHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$mouseHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$var$keyHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$6b8360dd6fa5f18d = function(et) {
    return function(f) {
        return $c959b62ce0c19dfe$export$c3c52e219617878(et)(function(ev) {
            return $10ae9db6658426ac$var$map($969bbf7e7aa55092$export$e19cd5f9376f8cee.create)(f(ev));
        });
    };
};
var $10ae9db6658426ac$export$c3c52e219617878 = function(et) {
    return function(f) {
        return $c959b62ce0c19dfe$export$c3c52e219617878(et)(function(ev) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $969bbf7e7aa55092$export$e19cd5f9376f8cee(f(ev)));
        });
    };
};
var $10ae9db6658426ac$export$d36091e57812e07 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("abort");
var $10ae9db6658426ac$export$81738f2b2c64902d = /* #__PURE__ */ function() {
    var $13 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$2991dd47f111a03b);
    return function($14) {
        return $13($10ae9db6658426ac$var$mouseHandler($14));
    };
}();
var $10ae9db6658426ac$export$bd913411069e59d3 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$d8a7b8f475ec0161);
var $10ae9db6658426ac$export$1d5a917feb871989 = /* #__PURE__ */ function() {
    var $15 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$64ef1bee2b9504c1);
    return function($16) {
        return $15($10ae9db6658426ac$var$mouseHandler($16));
    };
}();
var $10ae9db6658426ac$export$12204e800775a4e0 = /* #__PURE__ */ function() {
    var $17 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$efb8dd8d61939266);
    return function($18) {
        return $17($10ae9db6658426ac$var$mouseHandler($18));
    };
}();
var $10ae9db6658426ac$export$2288787135a8f66e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$a3bc9b8ed74fc);
var $10ae9db6658426ac$export$83b89249c82cb32b = function(dictUnfoldable) {
    var none = $cb5fedc2c4837e1c$export$f883a24d5edde77c(dictUnfoldable);
    var items = $520c7508336e9c23$export$17a1664ed1fb5d6f(dictUnfoldable);
    return function(f) {
        return $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$d8a7b8f475ec0161)(function() {
            var $19 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(none)(items);
            var $20 = $10ae9db6658426ac$var$composeKleisli($2829090ac282514c$export$44271b4f0c6a3563)($10ae9db6658426ac$var$composeKleisli($dbc3cf4ed216a106$export$a0a0bf09b44710c9)(function($22) {
                return $c02f07bc0f38e9e9$export$c62839628b30a695($dbc3cf4ed216a106$export$3a444357c5f65f65($22));
            }));
            return function($21) {
                return f($19($20($21)));
            };
        }());
    };
};
var $10ae9db6658426ac$export$7fbc06d7c1beb512 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$b7e3ae3d7c15e42e);
var $10ae9db6658426ac$export$ea9576bc99d1b7dd = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$9f85add0327f687e);
var $10ae9db6658426ac$export$de8e1b1372cdb41b = /* #__PURE__ */ function() {
    var $23 = $10ae9db6658426ac$export$c3c52e219617878($981a0c6551e76cf0$export$e65a0c4970da3025);
    return function($24) {
        return $23($10ae9db6658426ac$var$keyHandler($24));
    };
}();
var $10ae9db6658426ac$export$f144bbb6e186b14b = /* #__PURE__ */ function() {
    var $25 = $10ae9db6658426ac$export$c3c52e219617878($981a0c6551e76cf0$export$d26052c770f81a55);
    return function($26) {
        return $25($10ae9db6658426ac$var$keyHandler($26));
    };
}();
var $10ae9db6658426ac$export$4e4d8b287d028b6b = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$11e63f7b0f3d9900);
var $10ae9db6658426ac$export$6b09a96aed3f5178 = /* #__PURE__ */ function() {
    var $27 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$8b0cb8993e7a9391);
    return function($28) {
        return $27($10ae9db6658426ac$var$mouseHandler($28));
    };
}();
var $10ae9db6658426ac$export$7c562fbb06b8dec3 = /* #__PURE__ */ function() {
    var $29 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$474cd8abd87e2f89);
    return function($30) {
        return $29($10ae9db6658426ac$var$mouseHandler($30));
    };
}();
var $10ae9db6658426ac$export$f06e70624327ed63 = /* #__PURE__ */ function() {
    var $31 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$996a190879e3098b);
    return function($32) {
        return $31($10ae9db6658426ac$var$mouseHandler($32));
    };
}();
var $10ae9db6658426ac$export$4e8e585ca96adf5d = /* #__PURE__ */ function() {
    var $33 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$6d0a9e0f4f73830a);
    return function($34) {
        return $33($10ae9db6658426ac$var$mouseHandler($34));
    };
}();
var $10ae9db6658426ac$export$65a11040da641544 = /* #__PURE__ */ function() {
    var $35 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$c3a736a37c400eb8);
    return function($36) {
        return $35($10ae9db6658426ac$var$mouseHandler($36));
    };
}();
var $10ae9db6658426ac$export$afc474fdab5e8a8e = /* #__PURE__ */ function() {
    var $37 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$41b161f130dc7f9);
    return function($38) {
        return $37($10ae9db6658426ac$var$mouseHandler($38));
    };
}();
var $10ae9db6658426ac$export$3df825bff4f0a835 = /* #__PURE__ */ function() {
    var $39 = $10ae9db6658426ac$export$c3c52e219617878($7868044d3d97cfc5$export$c367b5bd9b361db9);
    return function($40) {
        return $39($10ae9db6658426ac$var$mouseHandler($40));
    };
}();
var $10ae9db6658426ac$export$79fcb145cc53473e = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("reset");
var $10ae9db6658426ac$export$45b39e67d4ce4921 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("resize");
var $10ae9db6658426ac$export$d4d89fd61e5416ee = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("scroll");
var $10ae9db6658426ac$export$2cc8197d6ae5570 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$2e6c959c16ff56b8);
var $10ae9db6658426ac$export$307d29742c654737 = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("submit");
var $10ae9db6658426ac$export$931f312019b226f2 = /* #__PURE__ */ function() {
    var $41 = $10ae9db6658426ac$export$c3c52e219617878("touchcancel");
    return function($42) {
        return $41($10ae9db6658426ac$var$touchHandler($42));
    };
}();
var $10ae9db6658426ac$export$79b4bc20f2630414 = /* #__PURE__ */ function() {
    var $43 = $10ae9db6658426ac$export$c3c52e219617878("touchend");
    return function($44) {
        return $43($10ae9db6658426ac$var$touchHandler($44));
    };
}();
var $10ae9db6658426ac$export$e1ee796ca0d1f5fd = /* #__PURE__ */ function() {
    var $45 = $10ae9db6658426ac$export$c3c52e219617878("touchenter");
    return function($46) {
        return $45($10ae9db6658426ac$var$touchHandler($46));
    };
}();
var $10ae9db6658426ac$export$a8fb1c034c732052 = /* #__PURE__ */ function() {
    var $47 = $10ae9db6658426ac$export$c3c52e219617878("touchleave");
    return function($48) {
        return $47($10ae9db6658426ac$var$touchHandler($48));
    };
}();
var $10ae9db6658426ac$export$42c53271760d4595 = /* #__PURE__ */ function() {
    var $49 = $10ae9db6658426ac$export$c3c52e219617878("touchmove");
    return function($50) {
        return $49($10ae9db6658426ac$var$touchHandler($50));
    };
}();
var $10ae9db6658426ac$export$37cbf11924865552 = /* #__PURE__ */ function() {
    var $51 = $10ae9db6658426ac$export$c3c52e219617878("touchstart");
    return function($52) {
        return $51($10ae9db6658426ac$var$touchHandler($52));
    };
}();
var $10ae9db6658426ac$export$e967ac7bdb3c237c = /* #__PURE__ */ $10ae9db6658426ac$export$c3c52e219617878("transitionend");
var $10ae9db6658426ac$export$65ea24ac132a9be9 = /* #__PURE__ */ function() {
    var $53 = $10ae9db6658426ac$export$c3c52e219617878($64b79e1476c3e095$export$d3028820ea014224);
    return function($54) {
        return $53($10ae9db6658426ac$var$wheelHandler($54));
    };
}();
var $10ae9db6658426ac$var$focusHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$5e446bc31724fca4 = /* #__PURE__ */ function() {
    var $55 = $10ae9db6658426ac$export$c3c52e219617878($98632a8bc67f7e8c$export$2cc7ff91bcacba5e);
    return function($56) {
        return $55($10ae9db6658426ac$var$focusHandler($56));
    };
}();
var $10ae9db6658426ac$export$ecf9bf35ad97eb74 = /* #__PURE__ */ function() {
    var $57 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$d7ddd398f22d79ef);
    return function($58) {
        return $57($10ae9db6658426ac$var$focusHandler($58));
    };
}();
var $10ae9db6658426ac$export$e9c0af77f352888d = /* #__PURE__ */ function() {
    var $59 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$e7fa4ea7f1bfcb53);
    return function($60) {
        return $59($10ae9db6658426ac$var$focusHandler($60));
    };
}();
var $10ae9db6658426ac$export$299df4cb415b3de7 = /* #__PURE__ */ function() {
    var $61 = $10ae9db6658426ac$export$c3c52e219617878($9285e421afbabad0$export$d0dc5134b51e78ad);
    return function($62) {
        return $61($10ae9db6658426ac$var$focusHandler($62));
    };
}();
var $10ae9db6658426ac$var$dragHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$11a07b18d6f8f6d2 = /* #__PURE__ */ function() {
    var $63 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$d7d5d435647ed5a0);
    return function($64) {
        return $63($10ae9db6658426ac$var$dragHandler($64));
    };
}();
var $10ae9db6658426ac$export$8566066e92caa8a = /* #__PURE__ */ function() {
    var $65 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$26ae3c90d367ea9a);
    return function($66) {
        return $65($10ae9db6658426ac$var$dragHandler($66));
    };
}();
var $10ae9db6658426ac$export$e2ce2d097d95a991 = /* #__PURE__ */ function() {
    var $67 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$bf1ba5dda238dc20);
    return function($68) {
        return $67($10ae9db6658426ac$var$dragHandler($68));
    };
}();
var $10ae9db6658426ac$export$5d99689eba023667 = /* #__PURE__ */ function() {
    var $69 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$ddffa9b7b4c3e300);
    return function($70) {
        return $69($10ae9db6658426ac$var$dragHandler($70));
    };
}();
var $10ae9db6658426ac$export$5280b1a9a538737a = /* #__PURE__ */ function() {
    var $71 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$f58195b0ad38aa36);
    return function($72) {
        return $71($10ae9db6658426ac$var$dragHandler($72));
    };
}();
var $10ae9db6658426ac$export$caca362e3b7795bf = /* #__PURE__ */ function() {
    var $73 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$ced0a5bb82ba6aee);
    return function($74) {
        return $73($10ae9db6658426ac$var$dragHandler($74));
    };
}();
var $10ae9db6658426ac$export$b00174fdb6a6ab8f = /* #__PURE__ */ function() {
    var $75 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$dc0badfde684823c);
    return function($76) {
        return $75($10ae9db6658426ac$var$dragHandler($76));
    };
}();
var $10ae9db6658426ac$export$c052d596304c05ec = /* #__PURE__ */ function() {
    var $77 = $10ae9db6658426ac$export$c3c52e219617878($9ca8e76be04efe86$export$663103110d94aac9);
    return function($78) {
        return $77($10ae9db6658426ac$var$dragHandler($78));
    };
}();
var $10ae9db6658426ac$var$clipboardHandler = $ac8b3532514ac019$export$401372c57776dc;
var $10ae9db6658426ac$export$f7fe233856e3c643 = /* #__PURE__ */ function() {
    var $79 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$784d13d8ee351f07);
    return function($80) {
        return $79($10ae9db6658426ac$var$clipboardHandler($80));
    };
}();
var $10ae9db6658426ac$export$330ca67a316b532c = /* #__PURE__ */ function() {
    var $81 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$af2a99f971a346e6);
    return function($82) {
        return $81($10ae9db6658426ac$var$clipboardHandler($82));
    };
}();
var $10ae9db6658426ac$export$48aae1120b60938a = /* #__PURE__ */ function() {
    var $83 = $10ae9db6658426ac$export$c3c52e219617878($5253348ec4f02e0c$export$9b6706c8686cfc8e);
    return function($84) {
        return $83($10ae9db6658426ac$var$clipboardHandler($84));
    };
}();
var $10ae9db6658426ac$var$addForeignPropHandler = function(key) {
    return function(prop) {
        return function(reader) {
            return function(f) {
                var go = function(a) {
                    return $10ae9db6658426ac$var$composeKleisliFlipped(reader)($10ae9db6658426ac$var$readProp(prop))($c97d2d0f578f81ad$export$9d82982d31d9d171(a));
                };
                return $10ae9db6658426ac$export$6b8360dd6fa5f18d(key)($10ae9db6658426ac$var$composeKleisli($2829090ac282514c$export$28b27b1605aa05ad)(function(e) {
                    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function($85) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($85));
                    })($f9f243b94d1fc188$export$a25b8a8a37f2d1cd(go(e)));
                }));
            };
        };
    };
};
var $10ae9db6658426ac$export$1706e2dd89331370 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("checked")(/* #__PURE__ */ $c97d2d0f578f81ad$export$f9a84177eae95ed5($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$export$4a70483021db3500 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("selectedIndex")(/* #__PURE__ */ $c97d2d0f578f81ad$export$ac3747cb00139c63($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $10ae9db6658426ac$export$faef864395e27f71 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$d8a7b8f475ec0161)("value")($10ae9db6658426ac$var$readString);
var $10ae9db6658426ac$export$4b31b9659da30fc9 = /* #__PURE__ */ $10ae9db6658426ac$var$addForeignPropHandler($98632a8bc67f7e8c$export$b7e3ae3d7c15e42e)("value")($10ae9db6658426ac$var$readString);




// Generated by purs version 0.15.15






// Generated by purs version 0.15.15




var $5c0b3c602b128ea0$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $5c0b3c602b128ea0$export$d962eb330c9c823c = function(s) {
    return function(f) {
        return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($8bcde8f642a64c7d$export$51b220bae4359b72)($5c0b3c602b128ea0$var$identity)($03be6cc86948e3c6$export$17b0f4d84dbfeedf(s)(f));
    };
};






var $a7ffc4a28f77a8cf$var$fromHomogeneous = /* #__PURE__ */ $c045ea5df33bba60$export$a47a4d0fc4d6b25();
var $a7ffc4a28f77a8cf$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a7ffc4a28f77a8cf$var$toUnfoldable = /* #__PURE__ */ $c045ea5df33bba60$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $a7ffc4a28f77a8cf$var$AnimStep = /* #__PURE__ */ function() {
    function AnimStep(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AnimStep.create = function(value0) {
        return function(value1) {
            return new AnimStep(value0, value1);
        };
    };
    return AnimStep;
}();
var $a7ffc4a28f77a8cf$var$RuleSet = /* #__PURE__ */ function() {
    function RuleSet(value0) {
        this.value0 = value0;
    }
    RuleSet.create = function(value0) {
        return new RuleSet(value0);
    };
    return RuleSet;
}();
var $a7ffc4a28f77a8cf$var$MediaRule = /* #__PURE__ */ function() {
    function MediaRule(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    MediaRule.create = function(value0) {
        return function(value1) {
            return new MediaRule(value0, value1);
        };
    };
    return MediaRule;
}();
var $a7ffc4a28f77a8cf$var$AtKeyframes = /* #__PURE__ */ function() {
    function AtKeyframes(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtKeyframes.create = function(value0) {
        return function(value1) {
            return new AtKeyframes(value0, value1);
        };
    };
    return AtKeyframes;
}();
var $a7ffc4a28f77a8cf$var$Raw = /* #__PURE__ */ function() {
    function Raw(value0) {
        this.value0 = value0;
    }
    Raw.create = function(value0) {
        return new Raw(value0);
    };
    return Raw;
}();
var $a7ffc4a28f77a8cf$var$Cat = /* #__PURE__ */ function() {
    function Cat(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cat.create = function(value0) {
        return function(value1) {
            return new Cat(value0, value1);
        };
    };
    return Cat;
}();
var $a7ffc4a28f77a8cf$var$Empty = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $a7ffc4a28f77a8cf$export$f76591688f805ba2 = /* #__PURE__ */ function() {
    return {
        append: $a7ffc4a28f77a8cf$var$Cat.create
    };
}();
var $a7ffc4a28f77a8cf$export$38bc81a0625a445 = /* #__PURE__ */ function() {
    return {
        mempty: $a7ffc4a28f77a8cf$var$Empty.value,
        Semigroup0: function() {
            return $a7ffc4a28f77a8cf$export$f76591688f805ba2;
        }
    };
}();
var $a7ffc4a28f77a8cf$var$fold = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593)($a7ffc4a28f77a8cf$export$38bc81a0625a445);
var $a7ffc4a28f77a8cf$var$uniqueIdent = "$unique";
var $a7ffc4a28f77a8cf$export$35d34bc0ed591a92 = function() {
    return function(name) {
        return function(sheet) {
            return new $a7ffc4a28f77a8cf$var$AnimStep(name, $a7ffc4a28f77a8cf$var$fromHomogeneous(sheet));
        };
    };
};
var $a7ffc4a28f77a8cf$export$2e6c959c16ff56b8 = function() {
    return function(selector) {
        return function(sheet) {
            return new $a7ffc4a28f77a8cf$var$RuleSet({
                selector: "." + ($a7ffc4a28f77a8cf$var$uniqueIdent + selector),
                declarations: $a7ffc4a28f77a8cf$var$fromHomogeneous(sheet)
            });
        };
    };
};
var $a7ffc4a28f77a8cf$var$select1 = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$2e6c959c16ff56b8();
var $a7ffc4a28f77a8cf$export$626530082bbb6846 = function() {
    return function(sheet) {
        return $a7ffc4a28f77a8cf$var$select1("")(sheet);
    };
};
var $a7ffc4a28f77a8cf$var$select_1 = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$626530082bbb6846();
var $a7ffc4a28f77a8cf$export$3293e33169162bb3 = /* #__PURE__ */ function() {
    return $a7ffc4a28f77a8cf$var$Raw.create;
}();
var $a7ffc4a28f77a8cf$var$camelToKebab = /* #__PURE__ */ $03be6cc86948e3c6$export$1b5e458140968481(/* #__PURE__ */ $5c0b3c602b128ea0$export$d962eb330c9c823c("([a-z])([A-Z])")($fb3071975af0bbe0$export$90b4d2ff6acb88af))(function(v) {
    return function(v1) {
        if (v1.length === 2 && v1[0] instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1[1] instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1[0].value0 + ("-" + $5b07e36f812dd04b$export$b1ceac3893cbda6b(v1[1].value0));
        return $8bcde8f642a64c7d$export$51b220bae4359b72("camelToKebab: impossible");
    };
});
var $a7ffc4a28f77a8cf$var$printDecls = function(obj) {
    var printDecl = function(v) {
        return $a7ffc4a28f77a8cf$var$camelToKebab(v.value0) + (": " + (v.value1 + ";"));
    };
    return $5b07e36f812dd04b$export$ec1dc8fbeea3467e("")($a7ffc4a28f77a8cf$var$map(printDecl)($a7ffc4a28f77a8cf$var$toUnfoldable(obj)));
};
var $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5 = function() {
    return function(r) {
        return $5fa7403fc5cf157d$export$eb0555af76ce23a7($a7ffc4a28f77a8cf$var$printDecls($a7ffc4a28f77a8cf$var$fromHomogeneous(r)));
    };
};
var $a7ffc4a28f77a8cf$var$printAnimStep = function(v) {
    return v.value0 + ("{" + ($a7ffc4a28f77a8cf$var$printDecls(v.value1) + "}"));
};
var $a7ffc4a28f77a8cf$var$printStyleSheet = /* #__PURE__ */ function() {
    var go = function(v) {
        if (v instanceof $a7ffc4a28f77a8cf$var$RuleSet) return v.value0.selector + (" " + ("{" + ($a7ffc4a28f77a8cf$var$printDecls(v.value0.declarations) + "}")));
        if (v instanceof $a7ffc4a28f77a8cf$var$MediaRule) return v.value0 + ("{" + (go(v.value1) + "}"));
        if (v instanceof $a7ffc4a28f77a8cf$var$AtKeyframes) return "@keyframes " + (v.value0 + ("{" + ($5b07e36f812dd04b$export$ec1dc8fbeea3467e("\n")($a7ffc4a28f77a8cf$var$map($a7ffc4a28f77a8cf$var$printAnimStep)(v.value1)) + "}")));
        if (v instanceof $a7ffc4a28f77a8cf$var$Raw) return v.value0;
        if (v instanceof $a7ffc4a28f77a8cf$var$Cat) return go(v.value0) + ("\n" + go(v.value1));
        if (v instanceof $a7ffc4a28f77a8cf$var$Empty) return "";
        throw new Error("Failed pattern match at Halogen.Styled.DSL (line 56, column 8 - line 62, column 16): " + [
            v.constructor.name
        ]);
    };
    return function($38) {
        return $5fa7403fc5cf157d$export$a871d3b711b41122(go($38));
    };
}();
var $a7ffc4a28f77a8cf$export$dad8f725bebc058f = function(ss) {
    return $5fa7403fc5cf157d$export$c1c17605031f935e($a7ffc4a28f77a8cf$var$uniqueIdent)($a7ffc4a28f77a8cf$var$printStyleSheet(ss));
};
var $a7ffc4a28f77a8cf$export$ecad260a8a5fef4f = function(steps) {
    return $a7ffc4a28f77a8cf$var$fold([
        new $a7ffc4a28f77a8cf$var$AtKeyframes($a7ffc4a28f77a8cf$var$uniqueIdent, steps),
        $a7ffc4a28f77a8cf$var$select_1({
            animationName: $a7ffc4a28f77a8cf$var$uniqueIdent
        })
    ]);
};


// Generated by purs version 0.15.15



var $16229b40a032db8e$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $16229b40a032db8e$var$debug = function(name) {
    return function(r) {
        if (r.context.debug) return {
            extraClasses: r.extraClasses,
            inlineStyles: r.inlineStyles,
            styleSheets: r.styleSheets,
            context: r.context,
            name: name,
            props: $16229b40a032db8e$var$append(r.props)([
                $94c2c7ff32ca5bd1$export$7aabe8b3a840d2fd("data-label")(name)
            ])
        };
        return r;
    };
};
var $16229b40a032db8e$export$f67f8a5eca7106c1 = function(leaf) {
    return function(name) {
        return function(opts) {
            return $5fa7403fc5cf157d$export$f67f8a5eca7106c1(leaf)($16229b40a032db8e$var$append([
                $16229b40a032db8e$var$debug(name)
            ])(opts));
        };
    };
};
var $16229b40a032db8e$export$d790dbddab3a5a7 = function(node) {
    return function(name) {
        return function(opts) {
            return $5fa7403fc5cf157d$export$d790dbddab3a5a7(node)($16229b40a032db8e$var$append([
                $16229b40a032db8e$var$debug(name)
            ])(opts));
        };
    };
};
var $16229b40a032db8e$export$a66106a33b3dcd36 = function(nodeKeyed) {
    return function(name) {
        return function(opts) {
            return $5fa7403fc5cf157d$export$a66106a33b3dcd36(nodeKeyed)($16229b40a032db8e$var$append([
                $16229b40a032db8e$var$debug(name)
            ])(opts));
        };
    };
};


// Generated by purs version 0.15.15

const $96894ac293b91509$export$afa0814ff668284f = (parcelRequire("gNDfO"));

const $96894ac293b91509$export$2639cc1d556c561b = (parcelRequire("btwiI"));

const $96894ac293b91509$export$1e39664d884e7996 = (parcelRequire("9nqpg"));

const $96894ac293b91509$export$98a6f6a039d9e21e = (parcelRequire("e5cS6"));

const $96894ac293b91509$export$2f1e35fbc592b279 = (parcelRequire("34LYy"));

const $96894ac293b91509$export$6ed6dbcd940b5d29 = (parcelRequire("7igRj"));

const $96894ac293b91509$export$24e33f9956394e27 = (parcelRequire("optnq"));

const $96894ac293b91509$export$bcd3d50876c81a23 = (parcelRequire("gZlTU"));




var $45a471ab25dc72d0$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $45a471ab25dc72d0$export$c4ddc81c7b2c8d7a = function(props) {
    var elTitle = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("ErrorTitle")([
        $45a471ab25dc72d0$var$inline({
            gridArea: "Title",
            fontSize: "1.5em",
            fontWeight: "bold"
        })
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Error")([
        $45a471ab25dc72d0$var$inline({
            display: "grid",
            width: "100%",
            height: "100%",
            gridTemplateColumns: "1fr 40px",
            gridTemplateRows: "1fr 1fr",
            gap: "10px",
            gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                '"Title   Close"',
                '"Message Close"'
            ]),
            fontFamily: "Arial"
        })
    ]);
    var elMessage = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("ErrorMessage")([
        $45a471ab25dc72d0$var$inline({
            gridArea: "Message",
            fontSize: "10px",
            color: "black"
        })
    ]);
    var elCloseIcon = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("ErrorCloseIcon")([
        $45a471ab25dc72d0$var$inline({
            gridArea: "Close",
            cursor: "pointer",
            width: "30px",
            height: "30px"
        })
    ]);
    return elRoot([])([
        elTitle([])([
            $5fa7403fc5cf157d$export$6f093cfa640b7166(props.title)
        ]),
        elMessage([])([
            $5fa7403fc5cf157d$export$6f093cfa640b7166(props.message)
        ]),
        elCloseIcon([
            $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$98a6f6a039d9e21e),
            $10ae9db6658426ac$export$1d5a917feb871989(function(v) {
                return props.onClose;
            })
        ])
    ]);
};


// Generated by purs version 0.15.15








// Generated by purs version 0.15.15










var $4c2daae6d737ec23$var$genericShowConstructor = /* #__PURE__ */ $544b62a378cc0091$export$186afff91b813845($544b62a378cc0091$export$f7ad98836d6849e8);
var $4c2daae6d737ec23$var$fromHomogeneous = /* #__PURE__ */ $c045ea5df33bba60$export$a47a4d0fc4d6b25();
var $4c2daae6d737ec23$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $4c2daae6d737ec23$export$ea50864c095dc75e = /* #__PURE__ */ function() {
    function LoginNotTried() {}
    LoginNotTried.value = new LoginNotTried();
    return LoginNotTried;
}();
var $4c2daae6d737ec23$export$30c73144fd8fd206 = /* #__PURE__ */ function() {
    function LoginChecking() {}
    LoginChecking.value = new LoginChecking();
    return LoginChecking;
}();
var $4c2daae6d737ec23$export$494f0b40d3d9a8bd = /* #__PURE__ */ function() {
    function LoginSuccess() {}
    LoginSuccess.value = new LoginSuccess();
    return LoginSuccess;
}();
var $4c2daae6d737ec23$export$9b562f8f165ccd03 = /* #__PURE__ */ function() {
    function LoginFailure() {}
    LoginFailure.value = new LoginFailure();
    return LoginFailure;
}();
var $4c2daae6d737ec23$export$b3d768da5d38cc29 = /* #__PURE__ */ function() {
    function DownloadCsv() {}
    DownloadCsv.value = new DownloadCsv();
    return DownloadCsv;
}();
var $4c2daae6d737ec23$export$7012a6c0fb70ee84 = /* #__PURE__ */ function() {
    function DownloadJson() {}
    DownloadJson.value = new DownloadJson();
    return DownloadJson;
}();
var $4c2daae6d737ec23$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize() {}
    Initialize.value = new Initialize();
    return Initialize;
}();
var $4c2daae6d737ec23$export$29defdae7b3f3a01 = /* #__PURE__ */ function() {
    function Finalize() {}
    Finalize.value = new Finalize();
    return Finalize;
}();
var $4c2daae6d737ec23$export$9012028d858731d1 = /* #__PURE__ */ function() {
    function ShowDetails(value0) {
        this.value0 = value0;
    }
    ShowDetails.create = function(value0) {
        return new ShowDetails(value0);
    };
    return ShowDetails;
}();
var $4c2daae6d737ec23$export$e43329afd813864e = /* #__PURE__ */ function() {
    function HideDetails() {}
    HideDetails.value = new HideDetails();
    return HideDetails;
}();
var $4c2daae6d737ec23$export$5655dab0f67f1911 = /* #__PURE__ */ function() {
    function DownloadResults(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DownloadResults.create = function(value0) {
        return function(value1) {
            return new DownloadResults(value0, value1);
        };
    };
    return DownloadResults;
}();
var $4c2daae6d737ec23$export$8e9d7cb3988dac7d = /* #__PURE__ */ function() {
    function UpdateJobInput(value0) {
        this.value0 = value0;
    }
    UpdateJobInput.create = function(value0) {
        return new UpdateJobInput(value0);
    };
    return UpdateJobInput;
}();
var $4c2daae6d737ec23$export$50f5fb6fac94cad = /* #__PURE__ */ function() {
    function SetShowNewJob(value0) {
        this.value0 = value0;
    }
    SetShowNewJob.create = function(value0) {
        return new SetShowNewJob(value0);
    };
    return SetShowNewJob;
}();
var $4c2daae6d737ec23$export$226dadd12c8383ca = /* #__PURE__ */ function() {
    function SubmitNewJob() {}
    SubmitNewJob.value = new SubmitNewJob();
    return SubmitNewJob;
}();
var $4c2daae6d737ec23$export$e91361436c2780bd = /* #__PURE__ */ function() {
    function SetPassword(value0) {
        this.value0 = value0;
    }
    SetPassword.create = function(value0) {
        return new SetPassword(value0);
    };
    return SetPassword;
}();
var $4c2daae6d737ec23$export$4c0b5b4a50347504 = /* #__PURE__ */ function() {
    function CancelJob(value0) {
        this.value0 = value0;
    }
    CancelJob.create = function(value0) {
        return new CancelJob(value0);
    };
    return CancelJob;
}();
var $4c2daae6d737ec23$export$5e7093d893e872e5 = /* #__PURE__ */ function() {
    function HideError() {}
    HideError.value = new HideError();
    return HideError;
}();
var $4c2daae6d737ec23$export$21a94553ffa41578 = /* #__PURE__ */ function() {
    function Login() {}
    Login.value = new Login();
    return Login;
}();
var $4c2daae6d737ec23$export$cad1a703886b4e3a = /* #__PURE__ */ function() {
    function Logout() {}
    Logout.value = new Logout();
    return Logout;
}();
var $4c2daae6d737ec23$export$849507a07a72cfb7 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $4c2daae6d737ec23$export$ea50864c095dc75e.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $4c2daae6d737ec23$export$30c73144fd8fd206.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $4c2daae6d737ec23$export$494f0b40d3d9a8bd.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $4c2daae6d737ec23$export$9b562f8f165ccd03.value;
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App.Types (line 83, column 1 - line 83, column 37): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $4c2daae6d737ec23$export$ea50864c095dc75e) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $4c2daae6d737ec23$export$30c73144fd8fd206) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $4c2daae6d737ec23$export$494f0b40d3d9a8bd) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)));
        if (x instanceof $4c2daae6d737ec23$export$9b562f8f165ccd03) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value)));
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App.Types (line 83, column 1 - line 83, column 37): " + [
            x.constructor.name
        ]);
    }
};
var $4c2daae6d737ec23$export$f081e81d78a6f74 = {
    show: /* #__PURE__ */ $544b62a378cc0091$export$dc29b8461849edae($4c2daae6d737ec23$export$849507a07a72cfb7)(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $4c2daae6d737ec23$var$genericShowConstructor({
        reflectSymbol: function() {
            return "LoginNotTried";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $4c2daae6d737ec23$var$genericShowConstructor({
        reflectSymbol: function() {
            return "LoginChecking";
        }
    }))(/* #__PURE__ */ $544b62a378cc0091$export$29d77e0cd7b7a3b8(/* #__PURE__ */ $4c2daae6d737ec23$var$genericShowConstructor({
        reflectSymbol: function() {
            return "LoginSuccess";
        }
    }))(/* #__PURE__ */ $4c2daae6d737ec23$var$genericShowConstructor({
        reflectSymbol: function() {
            return "LoginFailure";
        }
    })))))
};
var $4c2daae6d737ec23$export$a7b80668833273f4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $4c2daae6d737ec23$export$ea50864c095dc75e && y instanceof $4c2daae6d737ec23$export$ea50864c095dc75e) return true;
            if (x instanceof $4c2daae6d737ec23$export$30c73144fd8fd206 && y instanceof $4c2daae6d737ec23$export$30c73144fd8fd206) return true;
            if (x instanceof $4c2daae6d737ec23$export$494f0b40d3d9a8bd && y instanceof $4c2daae6d737ec23$export$494f0b40d3d9a8bd) return true;
            if (x instanceof $4c2daae6d737ec23$export$9b562f8f165ccd03 && y instanceof $4c2daae6d737ec23$export$9b562f8f165ccd03) return true;
            return false;
        };
    }
};
var $4c2daae6d737ec23$export$aa3adf7c41bfc422 = function(vals) {
    var obj = $0e031af7428ef07d$export$dbafa4424a806c15($4c2daae6d737ec23$var$fromHomogeneous({
        destinationIps: $0e031af7428ef07d$export$dbafa4424a806c15($4c2daae6d737ec23$var$map($0e031af7428ef07d$export$dbafa4424a806c15)($4c2daae6d737ec23$var$map($5b07e36f812dd04b$export$87c2784dc9fc4ab)($5b07e36f812dd04b$export$65980d18b75784e2("\n")($5b07e36f812dd04b$export$87c2784dc9fc4ab(vals.destinationIps))))),
        config: $0e031af7428ef07d$export$dbafa4424a806c15($4c2daae6d737ec23$var$fromHomogeneous({
            agentUrl: $0e031af7428ef07d$export$dbafa4424a806c15(vals.agentUrl),
            pingCountPerIp: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)($052de1c85deb22bf$export$3004f64547af360e(vals.pingCountPerIp)),
            intervalBetweenIpsMillis: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)($052de1c85deb22bf$export$3004f64547af360e(vals.intervalBetweenIpsMillis)),
            intervalBetweenPingsMillis: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)($052de1c85deb22bf$export$3004f64547af360e(vals.intervalBetweenPingsMillis)),
            useIcmp: $0e031af7428ef07d$export$dbafa4424a806c15(vals.useIcmp),
            useSynToPort: function() {
                if (vals.useSyn) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)($052de1c85deb22bf$export$3004f64547af360e(vals.synPort));
                return $0e031af7428ef07d$export$63ea9a5410ee0cef;
            }()
        }))
    }));
    return $4672333bf471fbe0$export$2f872c0f2117be69($c18e210e93b812bc$export$435850408b08cfa8)(obj);
};



var $67247a27085e93fc$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $67247a27085e93fc$var$select = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$2e6c959c16ff56b8();
var $67247a27085e93fc$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($4c2daae6d737ec23$export$a7b80668833273f4);
var $67247a27085e93fc$export$c4ddc81c7b2c8d7a = function(state) {
    var elVfLogo = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("VfLogo")([
        $67247a27085e93fc$var$inline({
            width: "40px",
            height: "40px"
        })
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Header")([
        $67247a27085e93fc$var$inline({
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            height: "100%",
            padding: "15px"
        })
    ]);
    var elLogoutIcon = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("Logout")([
        $67247a27085e93fc$var$inline({
            width: "40px",
            height: "40px",
            cursor: "pointer",
            borderRadius: "50%",
            padding: "10px"
        }),
        $a7ffc4a28f77a8cf$export$dad8f725bebc058f($67247a27085e93fc$var$select(":hover")({
            backgroundColor: "rgba(0,0,0,0.05)"
        }))
    ]);
    var elLogo = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Logo")([
        $67247a27085e93fc$var$inline({
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center"
        })
    ]);
    var elBmpLogo = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("BmpLogo")([
        $67247a27085e93fc$var$inline({
            height: "30px",
            justifySelf: "start",
            flex: "1"
        })
    ]);
    return elRoot([
        $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($4c2daae6d737ec23$export$e43329afd813864e.value))
    ])([
        elLogo([])([
            elVfLogo([
                $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$2f1e35fbc592b279)
            ]),
            elBmpLogo([
                $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$bcd3d50876c81a23)
            ])
        ]),
        function() {
            var $3 = $67247a27085e93fc$var$eq(state.logInState)($4c2daae6d737ec23$export$494f0b40d3d9a8bd.value);
            if ($3) return elLogoutIcon([
                $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($4c2daae6d737ec23$export$cad1a703886b4e3a.value)),
                $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$24e33f9956394e27)
            ]);
            return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
        }()
    ]);
};


// Generated by purs version 0.15.15






// Generated by purs version 0.15.15






var $d05d8e965b24260b$var$select_ = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$626530082bbb6846();
var $d05d8e965b24260b$var$select = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$2e6c959c16ff56b8();
var $d05d8e965b24260b$export$c4ddc81c7b2c8d7a = function(props) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$2ba01fb71ed41cb6)("PrimaryButton")([
        $a7ffc4a28f77a8cf$export$dad8f725bebc058f($d05d8e965b24260b$var$select_({
            height: "40px",
            backgroundColor: "black",
            color: "white",
            borderRadius: "8px",
            paddingRight: "10px",
            paddingLeft: "10px",
            width: "max-content",
            cursor: function() {
                if (props.disabled) return "auto";
                return "pointer";
            }(),
            opacity: function() {
                if (props.disabled) return "0.5";
                return "1";
            }(),
            fontWeight: "semi-bold"
        })),
        $a7ffc4a28f77a8cf$export$dad8f725bebc058f($d05d8e965b24260b$var$select(":hover")({
            backgroundColor: "rgba(0,0,0,0.7)"
        }))
    ]);
    return elRoot(function() {
        if (props.disabled) return [];
        return [
            $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(props.onClick))
        ];
    }())([
        $5fa7403fc5cf157d$export$6f093cfa640b7166(props.label)
    ]);
};


// Generated by purs version 0.15.15












// Generated by purs version 0.15.15
function $86ce56577656a821$export$df61b30b684217c0(e) {
    return e.key;
}
function $86ce56577656a821$export$6565f9f03506010b(e) {
    return e.code;
}
function $86ce56577656a821$export$8665f65ae046ac45(e) {
    return e.location;
}
function $86ce56577656a821$export$37876086932f98b6(e) {
    return e.ctrlKey;
}
function $86ce56577656a821$export$7bcab82bb0a7284e(e) {
    return e.shiftKey;
}
function $86ce56577656a821$export$b3cce955e7350d33(e) {
    return e.altKey;
}
function $86ce56577656a821$export$a00c4774ca8bd5f6(e) {
    return e.metaKey;
}
function $86ce56577656a821$export$76d90c956114f2c2(e) {
    return e.repeat;
}
function $86ce56577656a821$export$fb9179785e6a2a67(e) {
    return e.isComposing;
}
function $86ce56577656a821$export$2ca6d30ac9cf718b(s) {
    return function(e) {
        return function() {
            return e.getModifierState(s);
        };
    };
}







var $5a2b1a38c76cc913$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $5a2b1a38c76cc913$export$d5a1f56087d42b19 = /* #__PURE__ */ function() {
    function Standard() {}
    Standard.value = new Standard();
    return Standard;
}();
var $5a2b1a38c76cc913$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left() {}
    Left.value = new Left();
    return Left;
}();
var $5a2b1a38c76cc913$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right() {}
    Right.value = new Right();
    return Right;
}();
var $5a2b1a38c76cc913$export$cc5e9aed99f114ac = /* #__PURE__ */ function() {
    function Numpad() {}
    Numpad.value = new Numpad();
    return Numpad;
}();
var $5a2b1a38c76cc913$export$b012e48794076f09 = $ac8b3532514ac019$export$401372c57776dc;
var $5a2b1a38c76cc913$export$99e19ad73c6296ba = $ac8b3532514ac019$export$401372c57776dc;
var $5a2b1a38c76cc913$export$bcb8bb2421ce8b69 = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($5a2b1a38c76cc913$export$d5a1f56087d42b19.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($5a2b1a38c76cc913$export$37c4d04eafdc5515.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($5a2b1a38c76cc913$export$19db0165690c701a.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($5a2b1a38c76cc913$export$cc5e9aed99f114ac.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $5a2b1a38c76cc913$export$96b0f76330f98e6a = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("KeyboardEvent");
var $5a2b1a38c76cc913$export$a36e16046ae8f1bb = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("KeyboardEvent");
var $5a2b1a38c76cc913$export$864e46f3c094c687 = function(v) {
    if (v instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19) return 0;
    if (v instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515) return 1;
    if (v instanceof $5a2b1a38c76cc913$export$19db0165690c701a) return 2;
    if (v instanceof $5a2b1a38c76cc913$export$cc5e9aed99f114ac) return 3;
    throw new Error("Failed pattern match at Web.UIEvent.KeyboardEvent (line 107, column 3 - line 111, column 16): " + [
        v.constructor.name
    ]);
};
var $5a2b1a38c76cc913$export$22e3f2fb9e3f1f67 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19 && y instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19) return true;
            if (x instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515 && y instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515) return true;
            if (x instanceof $5a2b1a38c76cc913$export$19db0165690c701a && y instanceof $5a2b1a38c76cc913$export$19db0165690c701a) return true;
            if (x instanceof $5a2b1a38c76cc913$export$cc5e9aed99f114ac && y instanceof $5a2b1a38c76cc913$export$cc5e9aed99f114ac) return true;
            return false;
        };
    }
};
var $5a2b1a38c76cc913$export$9930cfdb668c8670 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19 && y instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5a2b1a38c76cc913$export$d5a1f56087d42b19) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515 && y instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5a2b1a38c76cc913$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5a2b1a38c76cc913$export$19db0165690c701a && y instanceof $5a2b1a38c76cc913$export$19db0165690c701a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $5a2b1a38c76cc913$export$19db0165690c701a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $5a2b1a38c76cc913$export$19db0165690c701a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $5a2b1a38c76cc913$export$cc5e9aed99f114ac && y instanceof $5a2b1a38c76cc913$export$cc5e9aed99f114ac) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.UIEvent.KeyboardEvent (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5a2b1a38c76cc913$export$22e3f2fb9e3f1f67;
    }
};
var $5a2b1a38c76cc913$export$bab3a60a85f3ebb9 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($5a2b1a38c76cc913$export$bcb8bb2421ce8b69)($5a2b1a38c76cc913$export$864e46f3c094c687),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($5a2b1a38c76cc913$export$bcb8bb2421ce8b69)($5a2b1a38c76cc913$export$864e46f3c094c687),
    Ord0: function() {
        return $5a2b1a38c76cc913$export$9930cfdb668c8670;
    }
};
var $5a2b1a38c76cc913$export$f8455ffeb652f712 = /* #__PURE__ */ function() {
    return {
        bottom: $5a2b1a38c76cc913$export$d5a1f56087d42b19.value,
        top: $5a2b1a38c76cc913$export$cc5e9aed99f114ac.value,
        Ord0: function() {
            return $5a2b1a38c76cc913$export$9930cfdb668c8670;
        }
    };
}();
var $5a2b1a38c76cc913$export$a1b4d24459e75ede = {
    cardinality: 4,
    toEnum: $5a2b1a38c76cc913$export$bcb8bb2421ce8b69,
    fromEnum: $5a2b1a38c76cc913$export$864e46f3c094c687,
    Bounded0: function() {
        return $5a2b1a38c76cc913$export$f8455ffeb652f712;
    },
    Enum1: function() {
        return $5a2b1a38c76cc913$export$bab3a60a85f3ebb9;
    }
};
var $5a2b1a38c76cc913$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($5a2b1a38c76cc913$export$a1b4d24459e75ede);
var $5a2b1a38c76cc913$export$17b07c660794dc13 = function() {
    return function($15) {
        return $5a2b1a38c76cc913$var$fromJust($5a2b1a38c76cc913$var$toEnum($86ce56577656a821$export$8665f65ae046ac45($15)));
    };
};



var $9c9830865bbd3497$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $9c9830865bbd3497$var$value = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$2ab9a8f9f1186f14($c959b62ce0c19dfe$export$32e0d8bef35d3088);
var $9c9830865bbd3497$var$type_ = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621($c959b62ce0c19dfe$export$7333503111bf9adf);
var $9c9830865bbd3497$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $9c9830865bbd3497$export$c4ddc81c7b2c8d7a = function(props) {
    var elTextArea = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$a3574df893ffa88d)("Input")([
        $9c9830865bbd3497$var$inline({
            gridArea: "Input",
            margin: "1px",
            border: "1px solid #ccc",
            padding: "5px",
            borderRadius: "5px",
            fontSize: "10px",
            lineHeight: "15px"
        })
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("TextInput")([
        $9c9830865bbd3497$var$inline({
            width: "100%",
            display: "grid",
            gridTemplateColumns: "2fr 3fr",
            gridTemplateRows: "15px auto",
            gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                '"Label ErrorText"',
                '"Input Input    "'
            ]),
            padding: "2px",
            gap: "2px",
            height: "100%"
        })
    ]);
    var elLabel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$1237798dc640739a)("Label")([
        $9c9830865bbd3497$var$inline({
            gridArea: "Label",
            margin: "1px",
            fontSize: "10px",
            fontFamily: "Arial",
            fontWeight: "bold"
        })
    ]);
    var elInput = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$b7e3ae3d7c15e42e)("Input")([
        $9c9830865bbd3497$var$inline({
            gridArea: "Input",
            margin: "1px",
            border: "1px solid #ccc",
            height: "25px",
            padding: "5px",
            borderRadius: "5px",
            fontSize: "12px"
        })
    ]);
    var elErrorText = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("ErrorText")([
        $9c9830865bbd3497$var$inline({
            gridArea: "ErrorText",
            margin: "1px",
            fontSize: "10px",
            fontFamily: "Arial",
            textAlign: "right",
            color: "red"
        })
    ]);
    return elRoot([])([
        elLabel([])([
            $5fa7403fc5cf157d$export$6f093cfa640b7166(props.label)
        ]),
        elErrorText([])([]),
        function() {
            if (props.multiline) return elTextArea([
                $9c9830865bbd3497$var$value(props.value),
                $10ae9db6658426ac$export$4b31b9659da30fc9(function(val) {
                    return props.onChange(val);
                })
            ]);
            return elInput([
                $9c9830865bbd3497$var$value(props.value),
                $9c9830865bbd3497$var$type_(function() {
                    if (props.password) return $cec7e3152401d818$export$66ebaee5e192c141.value;
                    return $cec7e3152401d818$export$7034fcb7d6351061.value;
                }()),
                $10ae9db6658426ac$export$4b31b9659da30fc9(function(val) {
                    return props.onChange(val);
                }),
                $10ae9db6658426ac$export$6b8360dd6fa5f18d($981a0c6551e76cf0$export$e65a0c4970da3025)(function(ev) {
                    return $9c9830865bbd3497$var$bind($5a2b1a38c76cc913$export$a36e16046ae8f1bb(ev))(function(keyEvent) {
                        return $9c9830865bbd3497$var$bind(props.onEnter)(function(action) {
                            var $8 = $86ce56577656a821$export$df61b30b684217c0(keyEvent) === "Enter";
                            if ($8) return new $06733ae99ed4f534$export$8a67b48435b5d073(action);
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        });
                    });
                })
            ]);
        }()
    ]);
};
var $9c9830865bbd3497$export$9c21a3269931e1e6 = /* #__PURE__ */ function() {
    return {
        label: "",
        value: "",
        onChange: function(v) {
            return $05149ea687d6b460$export$523c0b569236b342;
        },
        multiline: false,
        password: false,
        onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();


var $e8c53d4f14fd2c9f$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $e8c53d4f14fd2c9f$var$viewLogin = function(state) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Login")([
        $e8c53d4f14fd2c9f$var$inline({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "20px"
        })
    ]);
    var elInput = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Input")([]);
    var elButton = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Button")([]);
    return elRoot([])([
        elInput([])([
            $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                label: "",
                value: state.spmApiKey,
                onChange: $4c2daae6d737ec23$export$e91361436c2780bd.create,
                onEnter: new $06733ae99ed4f534$export$8a67b48435b5d073($4c2daae6d737ec23$export$21a94553ffa41578.value),
                password: true
            })
        ]),
        elButton([])([
            $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                label: "Login",
                onClick: $4c2daae6d737ec23$export$21a94553ffa41578.value,
                disabled: false
            })
        ])
    ]);
};
var $e8c53d4f14fd2c9f$var$viewFailure = /* #__PURE__ */ function() {
    var elTryAgain = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("TryAgain")([
        $e8c53d4f14fd2c9f$var$inline({})
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Checking")([
        $e8c53d4f14fd2c9f$var$inline({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "20px",
            fontSize: "20px",
            fontFamily: "Arial"
        })
    ]);
    return elRoot([])([
        $5fa7403fc5cf157d$export$6f093cfa640b7166("Login failed"),
        elTryAgain([])([
            $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                label: "Try again",
                onClick: $4c2daae6d737ec23$export$cad1a703886b4e3a.value,
                disabled: false
            })
        ])
    ]);
}();
var $e8c53d4f14fd2c9f$var$viewChecking = /* #__PURE__ */ function() {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Checking")([
        $e8c53d4f14fd2c9f$var$inline({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "20px",
            fontSize: "20px",
            fontFamily: "Arial"
        })
    ]);
    return elRoot([])([
        $5fa7403fc5cf157d$export$6f093cfa640b7166("Loggin in...")
    ]);
}();
var $e8c53d4f14fd2c9f$export$c4ddc81c7b2c8d7a = function(state) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Login")([
        $e8c53d4f14fd2c9f$var$inline({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "20px",
            position: "relative"
        })
    ]);
    return elRoot([])([
        function() {
            if (state.logInState instanceof $4c2daae6d737ec23$export$30c73144fd8fd206) return $e8c53d4f14fd2c9f$var$viewChecking;
            if (state.logInState instanceof $4c2daae6d737ec23$export$ea50864c095dc75e) return $e8c53d4f14fd2c9f$var$viewLogin(state);
            if (state.logInState instanceof $4c2daae6d737ec23$export$494f0b40d3d9a8bd) return $e8c53d4f14fd2c9f$var$viewLogin(state);
            if (state.logInState instanceof $4c2daae6d737ec23$export$9b562f8f165ccd03) return $e8c53d4f14fd2c9f$var$viewFailure;
            throw new Error("Failed pattern match at Visonum.BulkPingApp.App.Login (line 34, column 9 - line 38, column 38): " + [
                state.logInState.constructor.name
            ]);
        }()
    ]);
};


// Generated by purs version 0.15.15





var $2b4efd30e9f98102$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592($f8fc227945eb179e$export$d7d9283ee84f4c3f));
var $2b4efd30e9f98102$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $2b4efd30e9f98102$var$hasDoubleTicks = /* #__PURE__ */ $1a77d6934b592676$export$2344b14b097df817('"');
var $2b4efd30e9f98102$var$hasCommas = /* #__PURE__ */ $1a77d6934b592676$export$2344b14b097df817(",");
var $2b4efd30e9f98102$var$printCell = function(v) {
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "";
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
        var $8 = $2b4efd30e9f98102$var$not($2b4efd30e9f98102$var$hasDoubleTicks)(v.value0) && $2b4efd30e9f98102$var$not($2b4efd30e9f98102$var$hasCommas)(v.value0);
        if ($8) return v.value0;
        return '"' + ($5b07e36f812dd04b$export$b8b3234b4edfc4c2('"')('""')(v.value0) + '"');
    }
    throw new Error("Failed pattern match at Visonum.BulkPingApp.CSV (line 30, column 13 - line 36, column 78): " + [
        v.constructor.name
    ]);
};
var $2b4efd30e9f98102$var$printRow = function(cells) {
    return $5b07e36f812dd04b$export$ec1dc8fbeea3467e(",")($2b4efd30e9f98102$var$map($2b4efd30e9f98102$var$printCell)(cells));
};
var $2b4efd30e9f98102$export$7e706347a8a392bc = function(v) {
    var head = $2b4efd30e9f98102$var$printRow($2b4efd30e9f98102$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v.headers)) + "\n";
    var body = $5b07e36f812dd04b$export$ec1dc8fbeea3467e("\n")($2b4efd30e9f98102$var$map($2b4efd30e9f98102$var$printRow)(v.rows));
    return head + body;
};



// Generated by purs version 0.15.15


















var $2a76971508c41242$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $2a76971508c41242$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $2a76971508c41242$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $2a76971508c41242$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($c18e210e93b812bc$export$312553782ac604fe);
var $2a76971508c41242$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $2a76971508c41242$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $2a76971508c41242$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $2a76971508c41242$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $2a76971508c41242$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $2a76971508c41242$var$fromDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$1a0a2c8fdf902748($77539ec2bd3ecb1b$export$68674a2aef2c81c4);
var $2a76971508c41242$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$ad55f318773e3cd5);
var $2a76971508c41242$var$viewData = function(data_) {
    var elValue = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelValue")([
        $2a76971508c41242$var$inline({
            fontSize: "10px",
            fontFamily: "Arial"
        })
    ]);
    var elRow = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelRow")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px"
        })
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanel")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "end",
            alignItems: "center",
            gap: "15px"
        })
    ]);
    var elKey = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelKey")([
        $2a76971508c41242$var$inline({
            fontSize: "12px",
            fontWeight: "bold",
            fontFamily: "Arial"
        })
    ]);
    var elItem = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelItem")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "5px",
            backgroundColor: "#f0f0f0",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: "5px"
        })
    ]);
    return elRoot([])($2a76971508c41242$var$map(function(row) {
        return elRow([])($2a76971508c41242$var$map(function(item) {
            return elItem([])([
                elKey([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166(item.key)
                ]),
                elValue([])([
                    item.value
                ])
            ]);
        })(row));
    })(data_));
};
var $2a76971508c41242$export$c4ddc81c7b2c8d7a = function(state) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanel")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "end",
            alignItems: "center",
            padding: "15px",
            gap: "30px"
        })
    ]);
    var elResults = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelResults")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "end",
            alignItems: "center",
            gap: "15px"
        })
    ]);
    var elLine = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelLine")([
        $2a76971508c41242$var$inline({
            width: "100%",
            height: "1px",
            backgroundColor: "#e0e0e0"
        })
    ]);
    var elJobId = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelJobId")([
        $2a76971508c41242$var$inline({
            fontSize: "12px",
            fontWeight: "bold",
            fontFamily: "Arial"
        })
    ]);
    var elBottomBar = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanelBottomBar")([
        $2a76971508c41242$var$inline({
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px"
        })
    ]);
    return elRoot([])([
        function() {
            if (state.details instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && state.details.value0.result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && state.details.value0.result.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return elResults([])([
                $2a76971508c41242$var$viewData([
                    [
                        {
                            key: "Job ID",
                            value: elJobId([])([
                                $5fa7403fc5cf157d$export$6f093cfa640b7166(state.details.value0.jobId)
                            ])
                        }
                    ],
                    [
                        {
                            key: "Status",
                            value: $5fa7403fc5cf157d$export$6f093cfa640b7166($06733ae99ed4f534$export$43db023a260c5e9f("N/A")($2a76971508c41242$var$map1(function(r) {
                                return $2a76971508c41242$var$show(r.status);
                            })($2a76971508c41242$var$lookup(state.details.value0.jobId)(state.bulkPingStatus.jobs))))
                        },
                        {
                            key: "Number of Errors",
                            value: $5fa7403fc5cf157d$export$6f093cfa640b7166($06733ae99ed4f534$export$43db023a260c5e9f("N/A")($2a76971508c41242$var$map1(function(r) {
                                return $2a76971508c41242$var$show1(r.errorsCount);
                            })($2a76971508c41242$var$lookup(state.details.value0.jobId)(state.bulkPingStatus.jobs))))
                        }
                    ]
                ]),
                elLine([])([]),
                $2a76971508c41242$var$viewData($2a76971508c41242$var$map($2a76971508c41242$var$pure)([
                    {
                        key: "Agent URL",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166($b9f56ead6323c237$export$c2d084dc44961371(state.details.value0.result.value0.value0.config.agentUrl))
                    },
                    {
                        key: "Ping Count per IP",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166($2a76971508c41242$var$show1(state.details.value0.result.value0.value0.config.pingCountPerIp))
                    },
                    {
                        key: "Interval Between Pings (ms)",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166($2a76971508c41242$var$show2($2a76971508c41242$var$unwrap($2a76971508c41242$var$fromDuration(state.details.value0.result.value0.value0.config.intervalBetweenPingsMillis))))
                    },
                    {
                        key: "Interval Between IPs (ms)",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166($2a76971508c41242$var$show2($2a76971508c41242$var$unwrap($2a76971508c41242$var$fromDuration(state.details.value0.result.value0.value0.config.intervalBetweenIpsMillis))))
                    },
                    {
                        key: "Use TCP SYN to Port",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166(function() {
                            if (state.details.value0.result.value0.value0.config.useSynToPort instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $2a76971508c41242$var$show1(state.details.value0.result.value0.value0.config.useSynToPort.value0);
                            if (state.details.value0.result.value0.value0.config.useSynToPort instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "false";
                            throw new Error("Failed pattern match at Visonum.BulkPingApp.DetailsPanel (line 116, column 37 - line 118, column 43): " + [
                                state.details.value0.result.value0.value0.config.useSynToPort.constructor.name
                            ]);
                        }())
                    },
                    {
                        key: "Use ICMP",
                        value: $5fa7403fc5cf157d$export$6f093cfa640b7166($2a76971508c41242$var$show3(state.details.value0.result.value0.value0.config.useIcmp))
                    }
                ])),
                elBottomBar([])([
                    $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                        label: "Download JSON",
                        onClick: new $4c2daae6d737ec23$export$5655dab0f67f1911(state.details.value0.jobId, $4c2daae6d737ec23$export$7012a6c0fb70ee84.value),
                        disabled: false
                    }),
                    $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                        label: "Download CSV",
                        onClick: new $4c2daae6d737ec23$export$5655dab0f67f1911(state.details.value0.jobId, $4c2daae6d737ec23$export$b3d768da5d38cc29.value),
                        disabled: false
                    })
                ])
            ]);
            return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
        }()
    ]);
};


// Generated by purs version 0.15.15

















var $c73aac2d8e1d2112$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $c73aac2d8e1d2112$var$type_ = /* #__PURE__ */ $94c2c7ff32ca5bd1$export$d4a6a4db5b31e621($c959b62ce0c19dfe$export$7333503111bf9adf);
var $c73aac2d8e1d2112$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c73aac2d8e1d2112$var$viewPingMethodInput = function(state) {
    var elSynPort = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("SynPort")([
        $c73aac2d8e1d2112$var$inline({
            gridArea: "SynPort"
        })
    ]);
    var elSynCheck = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("SynCheck")([
        $c73aac2d8e1d2112$var$inline({
            gridArea: "SynCheck"
        })
    ]);
    var elSyn = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Syn")([
        $c73aac2d8e1d2112$var$inline({
            display: "grid",
            gridTemplateColumns: "subgrid",
            gridColumnStart: "SynCheck",
            gridColumnEnd: "SynPort",
            border: "1px solid #ccc",
            borderRadius: "5px",
            alignItems: "center",
            padding: "5px"
        })
    ]);
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("PingMethodInput")([
        $c73aac2d8e1d2112$var$inline({
            display: "grid",
            gridTemplateColumns: "1fr 1fr 2fr",
            gridTemplateRows: "60px",
            gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                '"Icmp SynCheck SynPort"'
            ]),
            gap: "5px",
            padding: "2px",
            marginTop: "5px"
        })
    ]);
    var elLabel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$1237798dc640739a)("Label")([
        $c73aac2d8e1d2112$var$inline({
            fontSize: "10px",
            fontFamily: "Arial",
            fontWeight: "bold"
        })
    ]);
    var elIcmp = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Icmp")([
        $c73aac2d8e1d2112$var$inline({
            gridArea: "Icmp",
            border: "1px solid #ccc",
            borderRadius: "5px",
            display: "flex",
            alignItems: "start",
            padding: "5px"
        })
    ]);
    var elCheckWrapper = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("CheckWrapper")([
        $c73aac2d8e1d2112$var$inline({
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            padding: "5px"
        })
    ]);
    var elCheck = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$b7e3ae3d7c15e42e)("Check")([
        $c73aac2d8e1d2112$var$inline({
            width: "20px",
            height: "20px",
            accentColor: "black"
        })
    ]);
    return elRoot([])([
        elIcmp([])([
            elCheckWrapper([])([
                elLabel([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166("Use ICMP")
                ]),
                elCheck([
                    $c73aac2d8e1d2112$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                    $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(state.newJob.useIcmp),
                    $10ae9db6658426ac$export$7fbc06d7c1beb512($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                        agentUrl: state.newJob.agentUrl,
                        pingCountPerIp: state.newJob.pingCountPerIp,
                        intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                        intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                        useSyn: state.newJob.useSyn,
                        synPort: state.newJob.synPort,
                        destinationIps: state.newJob.destinationIps,
                        useIcmp: !state.newJob.useIcmp
                    })))
                ])
            ])
        ]),
        elSyn([])([
            elSynCheck([])([
                elCheckWrapper([])([
                    elLabel([])([
                        $5fa7403fc5cf157d$export$6f093cfa640b7166("Use TCP SYN")
                    ]),
                    elCheck([
                        $c73aac2d8e1d2112$var$type_($cec7e3152401d818$export$fa1253a65a9e747d.value),
                        $94c2c7ff32ca5bd1$export$b96bb35bc88d6fa(state.newJob.useSyn),
                        $10ae9db6658426ac$export$7fbc06d7c1beb512($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            agentUrl: state.newJob.agentUrl,
                            pingCountPerIp: state.newJob.pingCountPerIp,
                            intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                            intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                            useIcmp: state.newJob.useIcmp,
                            synPort: state.newJob.synPort,
                            destinationIps: state.newJob.destinationIps,
                            useSyn: !state.newJob.useSyn
                        })))
                    ])
                ])
            ]),
            elSynPort([])([
                function() {
                    if (state.newJob.useSyn) return $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                        multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                        password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                        label: "Port",
                        value: state.newJob.synPort,
                        onChange: function(str) {
                            return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                                agentUrl: state.newJob.agentUrl,
                                pingCountPerIp: state.newJob.pingCountPerIp,
                                intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                                intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                                useIcmp: state.newJob.useIcmp,
                                useSyn: state.newJob.useSyn,
                                destinationIps: state.newJob.destinationIps,
                                synPort: str
                            });
                        },
                        onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                    });
                    return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
                }()
            ])
        ])
    ]);
};
var $c73aac2d8e1d2112$export$c4ddc81c7b2c8d7a = function(state) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("EditPanel")([
        $c73aac2d8e1d2112$var$inline({
            display: "grid",
            width: "100%",
            padding: "5px",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "auto auto auto",
            gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                '"Header Header"',
                '"LeftPart RightPart"',
                '"BottomPart BottomPart"'
            ]),
            outline: function() {
                if (state.showNewJob) return "2px solid black";
                return "none";
            }()
        })
    ]);
    var elRightPart = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("RightPart")([
        $c73aac2d8e1d2112$var$inline({
            display: "flex",
            flexDirection: "column",
            gridArea: "RightPart",
            margin: "5px"
        })
    ]);
    var elLeftPart = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("LeftPart")([
        $c73aac2d8e1d2112$var$inline({
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            gridArea: "LeftPart",
            margin: "5px"
        })
    ]);
    var elHeader = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Header")([
        $c73aac2d8e1d2112$var$inline({
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            gridArea: "Header",
            justifyContent: "end",
            margin: "5px"
        })
    ]);
    var elCloseButton = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("DetailsPanelCloseButton")([
        $c73aac2d8e1d2112$var$inline({
            width: "20px",
            height: "20px",
            cursor: "pointer"
        })
    ]);
    var elBottomPart = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("BottomPart")([
        $c73aac2d8e1d2112$var$inline({
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gridArea: "BottomPart",
            justifyContent: "end",
            padding: "5px"
        })
    ]);
    return elRoot([])($c73aac2d8e1d2112$var$append([
        elHeader([])([
            function() {
                if (state.showNewJob) return elCloseButton([
                    $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$98a6f6a039d9e21e),
                    $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $4c2daae6d737ec23$export$50f5fb6fac94cad(false)))
                ]);
                return $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                    label: "Add new Job",
                    onClick: new $4c2daae6d737ec23$export$50f5fb6fac94cad(true),
                    disabled: false
                });
            }()
        ])
    ])(function() {
        var $21 = !state.showNewJob;
        if ($21) return [];
        return [
            elLeftPart([])([
                $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                    multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                    password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                    label: "Agent URL",
                    value: state.newJob.agentUrl,
                    onChange: function(str) {
                        return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            pingCountPerIp: state.newJob.pingCountPerIp,
                            intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                            intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                            useIcmp: state.newJob.useIcmp,
                            useSyn: state.newJob.useSyn,
                            synPort: state.newJob.synPort,
                            destinationIps: state.newJob.destinationIps,
                            agentUrl: str
                        });
                    },
                    onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }),
                $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                    multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                    password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                    label: "Ping Count per IP",
                    value: state.newJob.pingCountPerIp,
                    onChange: function(str) {
                        return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            agentUrl: state.newJob.agentUrl,
                            intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                            intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                            useIcmp: state.newJob.useIcmp,
                            useSyn: state.newJob.useSyn,
                            synPort: state.newJob.synPort,
                            destinationIps: state.newJob.destinationIps,
                            pingCountPerIp: str
                        });
                    },
                    onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }),
                $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                    multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                    password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                    label: "Interval Between IPs (ms)",
                    value: state.newJob.intervalBetweenIpsMillis,
                    onChange: function(str) {
                        return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            agentUrl: state.newJob.agentUrl,
                            pingCountPerIp: state.newJob.pingCountPerIp,
                            intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                            useIcmp: state.newJob.useIcmp,
                            useSyn: state.newJob.useSyn,
                            synPort: state.newJob.synPort,
                            destinationIps: state.newJob.destinationIps,
                            intervalBetweenIpsMillis: str
                        });
                    },
                    onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }),
                $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                    multiline: $9c9830865bbd3497$export$9c21a3269931e1e6.multiline,
                    password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                    label: "Interval Between Pings (ms)",
                    value: state.newJob.intervalBetweenPingsMillis,
                    onChange: function(str) {
                        return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            agentUrl: state.newJob.agentUrl,
                            pingCountPerIp: state.newJob.pingCountPerIp,
                            intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                            useIcmp: state.newJob.useIcmp,
                            useSyn: state.newJob.useSyn,
                            synPort: state.newJob.synPort,
                            destinationIps: state.newJob.destinationIps,
                            intervalBetweenPingsMillis: str
                        });
                    },
                    onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }),
                $c73aac2d8e1d2112$var$viewPingMethodInput(state)
            ]),
            elRightPart([])([
                $9c9830865bbd3497$export$c4ddc81c7b2c8d7a({
                    password: $9c9830865bbd3497$export$9c21a3269931e1e6.password,
                    label: "Destination IPs",
                    value: state.newJob.destinationIps,
                    onChange: function(str) {
                        return new $4c2daae6d737ec23$export$8e9d7cb3988dac7d({
                            agentUrl: state.newJob.agentUrl,
                            pingCountPerIp: state.newJob.pingCountPerIp,
                            intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                            intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                            useIcmp: state.newJob.useIcmp,
                            useSyn: state.newJob.useSyn,
                            synPort: state.newJob.synPort,
                            destinationIps: str
                        });
                    },
                    onEnter: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    multiline: true
                })
            ]),
            elBottomPart([])(function() {
                var result = $4c2daae6d737ec23$export$aa3adf7c41bfc422(state.newJob);
                return [
                    $d05d8e965b24260b$export$c4ddc81c7b2c8d7a({
                        label: "Submit Job",
                        onClick: $4c2daae6d737ec23$export$226dadd12c8383ca.value,
                        disabled: $7d4cccdf062a2261$export$d649b6842e09f2b(result)
                    })
                ];
            }())
        ];
    }()));
};


// Generated by purs version 0.15.15































var $03e1d4faad44e1d4$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $03e1d4faad44e1d4$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $03e1d4faad44e1d4$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $03e1d4faad44e1d4$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $03e1d4faad44e1d4$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $03e1d4faad44e1d4$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $03e1d4faad44e1d4$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $03e1d4faad44e1d4$var$fromEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $03e1d4faad44e1d4$var$select = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$2e6c959c16ff56b8();
var $03e1d4faad44e1d4$var$select_ = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$626530082bbb6846();
var $03e1d4faad44e1d4$var$fold = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593)($5fa7403fc5cf157d$export$d2a310f2b8863532);
var $03e1d4faad44e1d4$var$step = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$35d34bc0ed591a92();
var $03e1d4faad44e1d4$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($5fa7403fc5cf157d$export$d2a310f2b8863532);
var $03e1d4faad44e1d4$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($18f2b327b2ac3376$export$e2fa58ffd7b3a1ab);
var $03e1d4faad44e1d4$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $03e1d4faad44e1d4$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $03e1d4faad44e1d4$var$viewProgressBar = function(part) {
    return function(whole) {
        var percent = 100.0 * ($4ab74a20512cef04$export$a0a81dc3380ce7d3(part) / $4ab74a20512cef04$export$a0a81dc3380ce7d3(whole));
        var percentStr = $73e6cbfd0da8b99a$export$bfa12905cd10b99c($73e6cbfd0da8b99a$export$3ef1e4fab5115712(1))(percent);
        var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("ProgressBar")([
            $03e1d4faad44e1d4$var$inline({
                display: "flex",
                width: "100%",
                height: "3px",
                backgroundColor: "rgba(255, 255, 255, 0.5);",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                borderRadius: "2px",
                overflow: "hidden",
                opacity: function() {
                    var $27 = part === whole;
                    if ($27) return "0.0";
                    return "1";
                }()
            })
        ]);
        var elBar = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Bar")([
            $03e1d4faad44e1d4$var$inline({
                height: "100%",
                position: "absolute",
                backgroundColor: "black",
                left: "0",
                width: percentStr + "%",
                transition: "width 1000ms linear",
                opacity: "0.4"
            })
        ]);
        return elRoot([])([
            elBar([])([])
        ]);
    };
};
var $03e1d4faad44e1d4$var$printTime = function(time) {
    return $91dd73a7945cfe05$export$35ab1104d640300a(2)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum($d254595454e6e9b0$export$842e383dfc19bc67(time)))) + (":" + ($91dd73a7945cfe05$export$35ab1104d640300a(2)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum1($d254595454e6e9b0$export$1cacba1045a8e790(time)))) + (":" + $91dd73a7945cfe05$export$35ab1104d640300a(2)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum2($d254595454e6e9b0$export$3d3c77ce7df7d30d(time)))))));
};
var $03e1d4faad44e1d4$var$printDate = function(date) {
    return $91dd73a7945cfe05$export$35ab1104d640300a(4)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum3($7577649a7445e8e0$export$31803937850fb2da(date)))) + ("/" + ($91dd73a7945cfe05$export$35ab1104d640300a(2)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum4($7577649a7445e8e0$export$af5de1609f06c8e6(date)))) + ("/" + $91dd73a7945cfe05$export$35ab1104d640300a(2)($03e1d4faad44e1d4$var$show($03e1d4faad44e1d4$var$fromEnum5($7577649a7445e8e0$export$d2d39d1adcc883a2(date)))))));
};
var $03e1d4faad44e1d4$var$viewJob = function(state) {
    return function(v) {
        var isSelected = function() {
            if (state.details instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return state.details.value0.jobId === v.value0;
            return false;
        }();
        var isRunning = function() {
            if (v.value1.status instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return true;
            return false;
        }();
        var elUUID = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("UUID")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "UUID",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                fontFamily: "Monospace",
                fontSize: "10px",
                fontFeatureSettings: '"tnum"'
            })
        ]);
        var elTime = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Time")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "Time",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                fontFeatureSettings: '"tnum"'
            })
        ]);
        var elStatusIcon = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("StatusIcon")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "StatusIcon",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            })
        ]);
        var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Job")([
            $a7ffc4a28f77a8cf$export$dad8f725bebc058f($03e1d4faad44e1d4$var$select("")({
                width: "100%",
                height: "50px",
                outline: function() {
                    if (isSelected) return "2px solid #65687d";
                    return "1px solid #ACABAC";
                }(),
                borderRadius: "8px",
                backgroundColor: function() {
                    if (v.value1.status instanceof $c18e210e93b812bc$export$91ae1e982b7b05d4) return "#f0e0e0" + function() {
                        if (isSelected) return "FF";
                        return "88";
                    }();
                    if (v.value1.status instanceof $c18e210e93b812bc$export$c5d72bc034a5be08) return "#e0f0e0" + function() {
                        if (isSelected) return "FF";
                        return "88";
                    }();
                    if (v.value1.status instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return "#d0d7ff" + function() {
                        if (isSelected) return "FF";
                        return "88";
                    }();
                    if (v.value1.status instanceof $c18e210e93b812bc$export$98c5edc703974274) return "#f0f0e0" + function() {
                        if (isSelected) return "FF";
                        return "88";
                    }();
                    if (v.value1.status instanceof $c18e210e93b812bc$export$f01a785a5ae81e49) return "white";
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.MainPanel (line 91, column 30 - line 96, column 33): " + [
                        v.value1.status.constructor.name
                    ]);
                }(),
                transition: "background-color 0.1s",
                fontSize: "12px",
                fontFamily: "Arial",
                display: "flex",
                flexDirection: "row"
            }))
        ]);
        var elProgressBar = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("ProgressBar")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "ProgressBar",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            })
        ]);
        var elProgress = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Progress")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "Progress",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                fontSize: "10px",
                fontFeatureSettings: '"tnum"'
            })
        ]);
        var elMain = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Main")([
            $a7ffc4a28f77a8cf$export$dad8f725bebc058f($03e1d4faad44e1d4$var$select_({
                display: "grid",
                width: "100%",
                height: "100%",
                borderRadius: "8px",
                paddingRight: "10px",
                gridTemplateColumns: "40px 80px 80px 90px auto",
                gridTemplateRows: "1fr 1fr 1fr",
                gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                    '"StatusIcon Empty       Empty       Empty       Empty      "',
                    '"StatusIcon Date        Time        Progress    UUID       "',
                    '"StatusIcon ProgressBar ProgressBar ProgressBar ProgressBar"'
                ]),
                fontSize: "12px",
                fontWeight: function() {
                    if (isSelected) return "bold";
                    return "normal";
                }(),
                fontFamily: "Arial",
                cursor: "pointer"
            })),
            $a7ffc4a28f77a8cf$export$dad8f725bebc058f($03e1d4faad44e1d4$var$select(":hover")({
                fontWeight: "bold"
            }))
        ]);
        var elImg = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("Img")([
            $03e1d4faad44e1d4$var$inline({
                width: "20px",
                height: "20px"
            }),
            function() {
                if (v.value1.status instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return $03e1d4faad44e1d4$var$fold([
                    $a7ffc4a28f77a8cf$export$dad8f725bebc058f($a7ffc4a28f77a8cf$export$ecad260a8a5fef4f([
                        $03e1d4faad44e1d4$var$step("from")({
                            transform: "rotate(0deg)"
                        }),
                        $03e1d4faad44e1d4$var$step("to")({
                            transform: "rotate(359deg)"
                        })
                    ])),
                    $a7ffc4a28f77a8cf$export$dad8f725bebc058f($03e1d4faad44e1d4$var$select_({
                        animation: "3s linear infinite"
                    }))
                ]);
                return $03e1d4faad44e1d4$var$mempty;
            }()
        ]);
        var elEmpty = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Empty")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "Empty"
            })
        ]);
        var elDate = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Date")([
            $03e1d4faad44e1d4$var$inline({
                gridArea: "Date",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                fontFeatureSettings: '"tnum"'
            })
        ]);
        var elCancel = $16229b40a032db8e$export$f67f8a5eca7106c1($e5b7e89a68d9c456$export$463b44d9bf3628be)("Cancel")([
            $03e1d4faad44e1d4$var$inline({
                cursor: "pointer",
                width: "20px",
                height: "20px"
            })
        ]);
        var elActions = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Cancel")([
            $03e1d4faad44e1d4$var$inline({
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                marginLeft: "5px",
                padding: "5px"
            })
        ]);
        return elRoot([
            $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $4c2daae6d737ec23$export$9012028d858731d1(v.value0)))
        ])([
            elMain([])([
                elEmpty([])([]),
                elStatusIcon([])([
                    elImg(function() {
                        if (v.value1.status instanceof $c18e210e93b812bc$export$91ba99b381c82aee) return [
                            $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$2639cc1d556c561b)
                        ];
                        if (v.value1.status instanceof $c18e210e93b812bc$export$c5d72bc034a5be08) return [
                            $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$afa0814ff668284f)
                        ];
                        if (v.value1.status instanceof $c18e210e93b812bc$export$91ae1e982b7b05d4) return [
                            $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$1e39664d884e7996)
                        ];
                        if (v.value1.status instanceof $c18e210e93b812bc$export$98c5edc703974274) return [
                            $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$6ed6dbcd940b5d29)
                        ];
                        if (v.value1.status instanceof $c18e210e93b812bc$export$f01a785a5ae81e49) return [];
                        throw new Error("Failed pattern match at Visonum.BulkPingApp.MainPanel (line 257, column 19 - line 267, column 25): " + [
                            v.value1.status.constructor.name
                        ]);
                    }())
                ]),
                elDate([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166($03e1d4faad44e1d4$var$printDate($18f2b327b2ac3376$export$324d90190a8b822a(v.value1.startedAt)))
                ]),
                elTime([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166($03e1d4faad44e1d4$var$printTime($18f2b327b2ac3376$export$2da9be4cfdb689b1(v.value1.startedAt)))
                ]),
                elUUID([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166(v.value0)
                ]),
                elProgress([])([
                    $5fa7403fc5cf157d$export$6f093cfa640b7166($03e1d4faad44e1d4$var$show(v.value1.processedIpCount) + ("/" + $03e1d4faad44e1d4$var$show(v.value1.initialIpCount)))
                ]),
                elProgressBar([])([
                    $03e1d4faad44e1d4$var$viewProgressBar(v.value1.processedIpCount)(v.value1.initialIpCount)
                ])
            ]),
            function() {
                var $43 = isSelected && isRunning;
                if ($43) return elActions([
                    $10ae9db6658426ac$export$1d5a917feb871989($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $4c2daae6d737ec23$export$4c0b5b4a50347504(v.value0)))
                ])([
                    elCancel([
                        $94c2c7ff32ca5bd1$export$2e40c9e35e9506f4($96894ac293b91509$export$98a6f6a039d9e21e)
                    ])
                ]);
                return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
            }()
        ]);
    };
};
var $03e1d4faad44e1d4$export$c4ddc81c7b2c8d7a = function(state) {
    var sortedJobs = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(v) {
        return function(v2) {
            return $03e1d4faad44e1d4$var$compare(v2.value1.startedAt)(v.value1.startedAt);
        };
    })($03e1d4faad44e1d4$var$toUnfoldable(state.bulkPingStatus.jobs));
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("MainPanel")([
        $03e1d4faad44e1d4$var$inline({
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "15px",
            justifyContent: "space-between",
            fontFamily: "Arial",
            fontSize: "12px"
        })
    ]);
    var elJobs = $16229b40a032db8e$export$a66106a33b3dcd36($96c9893fb882decd$export$159d9494db57879b)("Jobs")([
        $03e1d4faad44e1d4$var$inline({
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "space-between",
            gap: "16px"
        })
    ]);
    return elRoot([])([
        function() {
            var $52 = $fc8c1182ec2aefec$export$f24224f1c91d8156(sortedJobs) === 0;
            if ($52) return $5fa7403fc5cf157d$export$6f093cfa640b7166("No Bulk Ping jobs available");
            return elJobs([])($03e1d4faad44e1d4$var$map(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $03e1d4faad44e1d4$var$viewJob(state)(v));
            })(sortedJobs));
        }()
    ]);
};



// Generated by purs version 0.15.15






var $bdfa2f6621c672b7$var$inline = /* #__PURE__ */ $a7ffc4a28f77a8cf$export$18c8ad048e32c7d5();
var $bdfa2f6621c672b7$var$theme = {
    background: "#fbfbfb",
    gray1: "#EDEDED55",
    foreground: "#000"
};
var $bdfa2f6621c672b7$export$c4ddc81c7b2c8d7a = function(props) {
    var elRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Layout")([
        $bdfa2f6621c672b7$var$inline({
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            backgroundColor: $bdfa2f6621c672b7$var$theme.background,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        })
    ]);
    var elMainPanel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("MainPanel")([
        $bdfa2f6621c672b7$var$inline({
            margin: "1px",
            gridArea: "MainPanel",
            backgroundColor: $bdfa2f6621c672b7$var$theme.gray1,
            overflow: "auto",
            border: "1px solid #d8d8d8"
        })
    ]);
    var elLoginPanel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("LoginPanel")([
        $bdfa2f6621c672b7$var$inline({
            gridArea: "LoginPanel",
            backgroundColor: $bdfa2f6621c672b7$var$theme.gray1,
            border: "1px solid #d8d8d8"
        })
    ]);
    var elHeader = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Header")([
        $bdfa2f6621c672b7$var$inline({
            gridArea: "Header",
            backgroundColor: $bdfa2f6621c672b7$var$theme.gray1,
            border: "1px solid #d8d8d8"
        })
    ]);
    var elError = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("Error")([
        $bdfa2f6621c672b7$var$inline({
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            backgroundColor: "#f95b5b",
            color: "white",
            padding: "10px",
            zIndex: "1000"
        })
    ]);
    var elEditPanel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("EditPanel")([
        $bdfa2f6621c672b7$var$inline({
            margin: "1px",
            gridArea: "EditPanel",
            backgroundColor: $bdfa2f6621c672b7$var$theme.gray1,
            border: "1px solid #d8d8d8"
        })
    ]);
    var elDetailsPanel = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("DetailsPanel")([
        $bdfa2f6621c672b7$var$inline({
            margin: "1px",
            gridArea: "DetailsPanel",
            backgroundColor: $bdfa2f6621c672b7$var$theme.gray1,
            border: "1px solid #d8d8d8",
            marginLeft: "10px",
            width: "300px",
            overflow: "auto"
        })
    ]);
    var elAppRoot = $16229b40a032db8e$export$d790dbddab3a5a7($e5b7e89a68d9c456$export$159d9494db57879b)("AppRoot")([
        $bdfa2f6621c672b7$var$inline({
            backgroundColor: $bdfa2f6621c672b7$var$theme.background,
            display: "grid",
            maxWidth: "1024px",
            maxHeight: "768px",
            height: "100%",
            width: "100%",
            gridTemplateColumns: "2fr auto",
            gridTemplateRows: "70px 2fr auto",
            gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                '"Header    Header      "',
                '"MainPanel DetailsPanel"',
                '"EditPanel EditPanel   "'
            ]),
            gridRowGap: "10px",
            position: "relative"
        }),
        function() {
            if (props.showLogin) return $bdfa2f6621c672b7$var$inline({
                gridTemplateColumns: "auto",
                gridTemplateRows: "70px auto",
                gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                    '"Header   "',
                    '"LoginPanel"'
                ])
            });
            return $bdfa2f6621c672b7$var$inline({
                gridTemplateColumns: "2fr auto",
                gridTemplateRows: "70px 2fr auto",
                gridTemplateAreas: $5b07e36f812dd04b$export$ec1dc8fbeea3467e(" ")([
                    '"Header    Header      "',
                    '"MainPanel DetailsPanel"',
                    '"EditPanel EditPanel   "'
                ])
            });
        }()
    ]);
    return elRoot([])([
        function() {
            if (props.showLogin) return elAppRoot([])([
                elHeader([])([
                    props.headerPanel
                ]),
                elLoginPanel([])([
                    props.loginPanel
                ])
            ]);
            return elAppRoot([])([
                elHeader([])([
                    props.headerPanel
                ]),
                elMainPanel([])([
                    props.mainPanel
                ]),
                elEditPanel([])([
                    props.editPanel
                ]),
                function() {
                    if (props.detailsPanel instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return elDetailsPanel([])([
                        props.detailsPanel.value0
                    ]);
                    if (props.detailsPanel instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.Views.Layout (line 169, column 15 - line 171, column 35): " + [
                        props.detailsPanel.constructor.name
                    ]);
                }()
            ]);
        }(),
        function() {
            if (props.error instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return elError([])([
                props.error.value0
            ]);
            if (props.error instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5fa7403fc5cf157d$export$6f093cfa640b7166("");
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Views.Layout (line 173, column 9 - line 175, column 29): " + [
                props.error.constructor.name
            ]);
        }()
    ]);
};




// Generated by purs version 0.15.15
function $35126d8d6f6b7968$export$f24224f1c91d8156(storage) {
    return function() {
        return storage.length;
    };
}
function $35126d8d6f6b7968$export$e24e1c0f7cb08bf4(index) {
    return function(storage) {
        return function() {
            return storage.key(index);
        };
    };
}
function $35126d8d6f6b7968$export$f9bac3ba1280d655(key) {
    return function(storage) {
        return function() {
            return storage.getItem(key);
        };
    };
}
function $35126d8d6f6b7968$export$8a8216c44337cd5(key) {
    return function(value) {
        return function(storage) {
            return function() {
                storage.setItem(key, value);
            };
        };
    };
}
function $35126d8d6f6b7968$export$fe2d9b4e03920b4c(key) {
    return function(storage) {
        return function() {
            storage.removeItem(key);
        };
    };
}
function $35126d8d6f6b7968$export$42ffd38884aecdac(storage) {
    return function() {
        storage.clear();
    };
}





var $e3492520acd16a37$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $e3492520acd16a37$export$df61b30b684217c0 = function(i) {
    var $2 = $e3492520acd16a37$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $3 = $35126d8d6f6b7968$export$e24e1c0f7cb08bf4(i);
    return function($4) {
        return $2($3($4));
    };
};
var $e3492520acd16a37$export$f92dfeb71e9bb569 = function(s) {
    var $5 = $e3492520acd16a37$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $6 = $35126d8d6f6b7968$export$f9bac3ba1280d655(s);
    return function($7) {
        return $5($6($7));
    };
};


var $1150df68cd261ce8$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $1150df68cd261ce8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $1150df68cd261ce8$var$get = /* #__PURE__ */ $f2d5035ce6148af6$export$3988ae62b71be9a3($84222ab19bdc98bd$export$87bf621137788b28);
var $1150df68cd261ce8$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($84222ab19bdc98bd$export$be2318e898dcc68)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $1150df68cd261ce8$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($84222ab19bdc98bd$export$172cc2b2b4e6467a);
var $1150df68cd261ce8$var$modify_ = /* #__PURE__ */ $f2d5035ce6148af6$export$45b91115a89d6020($84222ab19bdc98bd$export$87bf621137788b28);
var $1150df68cd261ce8$var$monadEffectHalogenM = /* #__PURE__ */ $84222ab19bdc98bd$export$aecceb0bc1bf10d9($edf0339512807bee$export$666a030cecdf96c);
var $1150df68cd261ce8$var$error = /* #__PURE__ */ $ec52a8164fabd1b2$export$a3bc9b8ed74fc($1150df68cd261ce8$var$monadEffectHalogenM);
var $1150df68cd261ce8$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($84222ab19bdc98bd$export$be2318e898dcc68);
var $1150df68cd261ce8$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($1150df68cd261ce8$var$monadEffectHalogenM);
var $1150df68cd261ce8$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $1150df68cd261ce8$var$liftAff = /* #__PURE__ */ $b6d6cce78665f23d$export$37f61af225938e0f(/* #__PURE__ */ $84222ab19bdc98bd$export$6f4dec227404555($b6d6cce78665f23d$export$bd75e69808ef8e57));
var $1150df68cd261ce8$var$log = /* #__PURE__ */ $ec52a8164fabd1b2$export$bef1f36f5486a6a3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $1150df68cd261ce8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $1150df68cd261ce8$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $1150df68cd261ce8$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $1150df68cd261ce8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $1150df68cd261ce8$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($59dadf91e1f9eb9a$export$d3ac27ab5a0173d);
var $1150df68cd261ce8$export$f34361fb30a4cb79 = /* #__PURE__ */ function() {
    function Void() {}
    Void.value = new Void();
    return Void;
}();
var $1150df68cd261ce8$var$stopPolling = /* #__PURE__ */ $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(state) {
    return $1150df68cd261ce8$var$for_(state.pollingForkId)(function(forkId) {
        return $1150df68cd261ce8$var$discard($84222ab19bdc98bd$export$dfdb508572caf3d7(forkId))(function() {
            return $1150df68cd261ce8$var$modify_(function(v) {
                var $46 = {};
                for(var $47 in v)if (({}).hasOwnProperty.call(v, $47)) $46[$47] = v[$47];
                $46.pollingForkId = $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return $46;
            });
        });
    });
});
var $1150df68cd261ce8$var$showError = function(title) {
    return function(message) {
        return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
            var $49 = {};
            for(var $50 in state)if (({}).hasOwnProperty.call(state, $50)) $49[$50] = state[$50];
            $49.displayError = new $06733ae99ed4f534$export$8a67b48435b5d073({
                title: title,
                message: message
            });
            return $49;
        }))(function() {
            return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$error(message))(function() {
                return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
            });
        });
    };
};
var $1150df68cd261ce8$var$runSinglePoll = /* #__PURE__ */ $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(v) {
    return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect($779c6109fa03e926$export$3c5f89dae98e900b(0)($1150df68cd261ce8$var$top)))(function(c) {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftAff($c18e210e93b812bc$export$2d2b162ef7dafa93(v.staticConfig.speedMasterUrl)(v.spmApiKey)({
            c: c
        })))(function(res) {
            return $1150df68cd261ce8$var$discard(function() {
                if (res instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $1150df68cd261ce8$var$liftEffect($1150df68cd261ce8$var$log("Polling failed: " + $1150df68cd261ce8$var$show(res.value0)));
                if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $1150df68cd261ce8$var$modify_(function(state) {
                    var $55 = {};
                    for(var $56 in state)if (({}).hasOwnProperty.call(state, $56)) $55[$56] = state[$56];
                    $55.bulkPingStatus = res.value0;
                    return $55;
                });
                throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 262, column 3 - line 265, column 58): " + [
                    res.constructor.name
                ]);
            }())(function() {
                return $1150df68cd261ce8$var$pure($7d4cccdf062a2261$export$a9d71693f0c1a85d(res));
            });
        });
    });
});
var $1150df68cd261ce8$var$$lazy_runPolling = /* #__PURE__ */ $1150df68cd261ce8$var$$runtime_lazy("runPolling", "Visonum.BulkPingApp.Components.App", function() {
    return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$liftEffect($1150df68cd261ce8$var$log("Polling for bulk ping jobs")))(function() {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect($04a918a3ed46422a$export$461939dd4422153))(function(timeBefore) {
            return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$runSinglePoll)(function() {
                return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect($04a918a3ed46422a$export$461939dd4422153))(function(timeAfter) {
                    var elapsedMs = $1150df68cd261ce8$var$unwrap($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(timeAfter)) - $1150df68cd261ce8$var$unwrap($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(timeBefore));
                    return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$liftAff($edf0339512807bee$export$1391212d75b2ee65(1000.0 - elapsedMs)))(function() {
                        return $1150df68cd261ce8$var$$lazy_runPolling(252);
                    });
                });
            });
        });
    });
});
var $1150df68cd261ce8$var$runPolling = /* #__PURE__ */ $1150df68cd261ce8$var$$lazy_runPolling(238);
var $1150df68cd261ce8$var$startPolling = /* #__PURE__ */ $1150df68cd261ce8$var$bind(/* #__PURE__ */ $84222ab19bdc98bd$export$7a5058c6b79333e0($1150df68cd261ce8$var$runPolling))(function(forkId) {
    return $1150df68cd261ce8$var$modify_(function(state) {
        var $61 = {};
        for(var $62 in state)if (({}).hasOwnProperty.call(state, $62)) $61[$62] = state[$62];
        $61.pollingForkId = new $06733ae99ed4f534$export$8a67b48435b5d073(forkId);
        return $61;
    });
});
var $1150df68cd261ce8$var$render = function(state) {
    var ctx = {
        debug: true,
        staticConfig: state.staticConfig
    };
    return $e5b7e89a68d9c456$export$159d9494db57879b([])($5fa7403fc5cf157d$export$438fa7935f716bdf(ctx)($bdfa2f6621c672b7$export$c4ddc81c7b2c8d7a({
        headerPanel: $67247a27085e93fc$export$c4ddc81c7b2c8d7a(state),
        mainPanel: $03e1d4faad44e1d4$export$c4ddc81c7b2c8d7a(state),
        editPanel: $c73aac2d8e1d2112$export$c4ddc81c7b2c8d7a(state),
        detailsPanel: function() {
            if (state.details instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (state.details instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($2a76971508c41242$export$c4ddc81c7b2c8d7a(state));
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 98, column 27 - line 100, column 55): " + [
                state.details.constructor.name
            ]);
        }(),
        loginPanel: $e8c53d4f14fd2c9f$export$c4ddc81c7b2c8d7a(state),
        showLogin: function() {
            if (state.logInState instanceof $4c2daae6d737ec23$export$ea50864c095dc75e) return true;
            if (state.logInState instanceof $4c2daae6d737ec23$export$30c73144fd8fd206) return true;
            if (state.logInState instanceof $4c2daae6d737ec23$export$494f0b40d3d9a8bd) return false;
            if (state.logInState instanceof $4c2daae6d737ec23$export$9b562f8f165ccd03) return true;
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 102, column 24 - line 106, column 35): " + [
                state.logInState.constructor.name
            ]);
        }(),
        error: function() {
            if (state.displayError instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (state.displayError instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($45a471ab25dc72d0$export$c4ddc81c7b2c8d7a({
                title: state.displayError.value0.title,
                message: state.displayError.value0.message,
                onClose: $4c2daae6d737ec23$export$5e7093d893e872e5.value
            }));
            throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 107, column 20 - line 110, column 73): " + [
                state.displayError.constructor.name
            ]);
        }()
    })));
};
var $1150df68cd261ce8$var$printDuration = /* #__PURE__ */ function() {
    var $164 = $73e6cbfd0da8b99a$export$bfa12905cd10b99c($73e6cbfd0da8b99a$export$3ef1e4fab5115712(2));
    var $165 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748($77539ec2bd3ecb1b$export$68674a2aef2c81c4);
    return function($166) {
        return $164($1150df68cd261ce8$var$unwrap($165($166)));
    };
}();
var $1150df68cd261ce8$var$initialState = function(v) {
    return {
        bulkPingStatus: {
            jobs: $ea3eb84de0acf574$export$6e22c362a0406a2c
        },
        staticConfig: v.staticConfig,
        showNewJob: false,
        newJob: {
            agentUrl: "",
            pingCountPerIp: "3",
            intervalBetweenIpsMillis: "1000",
            intervalBetweenPingsMillis: "0",
            useIcmp: true,
            useSyn: false,
            synPort: "",
            destinationIps: ""
        },
        spmApiKey: "",
        logInState: $4c2daae6d737ec23$export$ea50864c095dc75e.value,
        details: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        displayError: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        pollingForkId: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
};
var $1150df68cd261ce8$var$cellsFromBulkPingResult = function(result) {
    return [
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($91dd73a7945cfe05$export$e003485a67becadb(result.value0.value0.timestamp));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeMinMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeAvgMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeMedianMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeMaxMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeStdDevJitterMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$c658a51c52adf59c) return new $06733ae99ed4f534$export$8a67b48435b5d073($1150df68cd261ce8$var$printDuration(result.value0.value0.pingTimeTR143JitterMillis));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }(),
        function() {
            if (result instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && result.value0 instanceof $c18e210e93b812bc$export$41b4bf69b8d5459d) return new $06733ae99ed4f534$export$8a67b48435b5d073(result.value0.value0.message);
            if (result instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073("N/A");
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }()
    ];
};
var $1150df68cd261ce8$var$pingsToCsv = function(entries) {
    var mkRow = function(v) {
        return $1150df68cd261ce8$var$append1([
            new $06733ae99ed4f534$export$8a67b48435b5d073(v.destination)
        ])($1150df68cd261ce8$var$append1($1150df68cd261ce8$var$cellsFromBulkPingResult(v.timeIcmp))($1150df68cd261ce8$var$cellsFromBulkPingResult(v.timeSyn)));
    };
    return {
        headers: [
            "Destination IP",
            "ICMP Timestamp",
            "ICMP Min (ms)",
            "ICMP Avg (ms)",
            "ICMP Median (ms)",
            "ICMP Max (ms)",
            "ICMP StdDev Jitter (ms)",
            "ICMP TR143 Jitter (ms)",
            "ICMP Error",
            "TCP SYN Timestamp",
            "TCP SYN Min (ms)",
            "TCP SYN Avg (ms)",
            "TCP SYN Median (ms)",
            "TCP SYN Max (ms)",
            "TCP SYN StdDev Jitter (ms)",
            "TCP SYN TR143 Jitter (ms)",
            "TCP SYN Error"
        ],
        rows: $1150df68cd261ce8$var$map(mkRow)(entries)
    };
};
var $1150df68cd261ce8$var$handleAction = function(ac) {
    if (ac instanceof $4c2daae6d737ec23$export$b03b1c699c90a9b4) return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect(function __do() {
        var win = $2603425f82e959df$export$8291e5b88f90ce4();
        var store = $aa35a24624ec08d2$export$c2ed3351cac403d1(win)();
        return $e3492520acd16a37$export$f92dfeb71e9bb569("key")(store)();
    }))(function(mayKey) {
        if (mayKey instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
            var $103 = {};
            for(var $104 in state)if (({}).hasOwnProperty.call(state, $104)) $103[$104] = state[$104];
            $103.spmApiKey = mayKey.value0;
            $103.logInState = $4c2daae6d737ec23$export$494f0b40d3d9a8bd.value;
            return $103;
        }))(function() {
            return $1150df68cd261ce8$var$startPolling;
        });
        if (mayKey instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 126, column 7 - line 133, column 29): " + [
            mayKey.constructor.name
        ]);
    });
    if (ac instanceof $4c2daae6d737ec23$export$29defdae7b3f3a01) return $1150df68cd261ce8$var$stopPolling;
    if (ac instanceof $4c2daae6d737ec23$export$5e7093d893e872e5) return $1150df68cd261ce8$var$modify_(function(state) {
        var $107 = {};
        for(var $108 in state)if (({}).hasOwnProperty.call(state, $108)) $107[$108] = state[$108];
        $107.displayError = $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return $107;
    });
    if (ac instanceof $4c2daae6d737ec23$export$8e9d7cb3988dac7d) return $1150df68cd261ce8$var$modify_(function(state) {
        var $110 = {};
        for(var $111 in state)if (({}).hasOwnProperty.call(state, $111)) $110[$111] = state[$111];
        $110.newJob = ac.value0;
        return $110;
    });
    if (ac instanceof $4c2daae6d737ec23$export$5655dab0f67f1911) return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(state) {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect($779c6109fa03e926$export$3c5f89dae98e900b(0)($1150df68cd261ce8$var$top)))(function(c) {
            return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftAff($c18e210e93b812bc$export$a50228035c1e8ce6(state.staticConfig.speedMasterUrl)(state.spmApiKey)({
                jobId: ac.value0,
                c: c
            })))(function(result) {
                if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $1150df68cd261ce8$var$showError("Failed to fetch Result")($1150df68cd261ce8$var$show(result.value0));
                if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    if (ac.value1 instanceof $4c2daae6d737ec23$export$7012a6c0fb70ee84) {
                        var json = $4672333bf471fbe0$export$c564cdbbe6da493($c18e210e93b812bc$export$25d59078780ac8cb)(result.value0);
                        var str = $0e031af7428ef07d$export$fac44ee5b035f737(json);
                        return $1150df68cd261ce8$var$liftEffect(function() {
                            return $8f9b63d9d9618bc3$export$24422be91ad4011f("bulk-ping-" + (ac.value0 + ".json"), str);
                        });
                    }
                    if (ac.value1 instanceof $4c2daae6d737ec23$export$b3d768da5d38cc29) {
                        var csv = $1150df68cd261ce8$var$pingsToCsv(result.value0.results);
                        var str = $2b4efd30e9f98102$export$7e706347a8a392bc(csv);
                        return $1150df68cd261ce8$var$liftEffect(function() {
                            return $8f9b63d9d9618bc3$export$24422be91ad4011f("bulk-ping-" + (ac.value0 + ".csv"), str);
                        });
                    }
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 152, column 11 - line 161, column 87): " + [
                        ac.value1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 148, column 7 - line 161, column 87): " + [
                    result.constructor.name
                ]);
            });
        });
    });
    if (ac instanceof $4c2daae6d737ec23$export$50f5fb6fac94cad) return $1150df68cd261ce8$var$modify_(function(state) {
        var $120 = {};
        for(var $121 in state)if (({}).hasOwnProperty.call(state, $121)) $120[$121] = state[$121];
        $120.showNewJob = ac.value0;
        return $120;
    });
    if (ac instanceof $4c2daae6d737ec23$export$9012028d858731d1) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
        var $124 = {};
        for(var $125 in state)if (({}).hasOwnProperty.call(state, $125)) $124[$125] = state[$125];
        $124.details = new $06733ae99ed4f534$export$8a67b48435b5d073({
            jobId: ac.value0,
            result: $06733ae99ed4f534$export$bebe9059409a0d04.value
        });
        return $124;
    }))(function() {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(state) {
            return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftEffect($779c6109fa03e926$export$3c5f89dae98e900b(0)($1150df68cd261ce8$var$top)))(function(c) {
                return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftAff($c18e210e93b812bc$export$a50228035c1e8ce6(state.staticConfig.speedMasterUrl)(state.spmApiKey)({
                    jobId: ac.value0,
                    c: c
                })))(function(resp) {
                    return $1150df68cd261ce8$var$discard(function() {
                        if (resp instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $1150df68cd261ce8$var$showError("Failed to fetch Result")($1150df68cd261ce8$var$show(resp.value0));
                        if (resp instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
                        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 174, column 7 - line 178, column 20): " + [
                            resp.constructor.name
                        ]);
                    }())(function() {
                        return $1150df68cd261ce8$var$modify_(function(v) {
                            var $130 = {};
                            for(var $131 in v)if (({}).hasOwnProperty.call(v, $131)) $130[$131] = v[$131];
                            $130.details = new $06733ae99ed4f534$export$8a67b48435b5d073({
                                jobId: ac.value0,
                                result: new $06733ae99ed4f534$export$8a67b48435b5d073(resp)
                            });
                            return $130;
                        });
                    });
                });
            });
        });
    });
    if (ac instanceof $4c2daae6d737ec23$export$e43329afd813864e) return $1150df68cd261ce8$var$modify_(function(state) {
        var $134 = {};
        for(var $135 in state)if (({}).hasOwnProperty.call(state, $135)) $134[$135] = state[$135];
        $134.details = $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return $134;
    });
    if (ac instanceof $4c2daae6d737ec23$export$226dadd12c8383ca) return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(st) {
        var result = $4c2daae6d737ec23$export$aa3adf7c41bfc422(st.newJob);
        if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $1150df68cd261ce8$var$showError("Invalid input")($1150df68cd261ce8$var$show1(result.value0));
        if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
            var $139 = {};
            for(var $140 in state)if (({}).hasOwnProperty.call(state, $140)) $139[$140] = state[$140];
            $139.showNewJob = false;
            return $139;
        }))(function() {
            return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftAff($c18e210e93b812bc$export$29f8406c1d30ba25(st.staticConfig.speedMasterUrl)(st.spmApiKey)(result.value0)))(function(startResult) {
                return $1150df68cd261ce8$var$discard(function() {
                    if (startResult instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $1150df68cd261ce8$var$showError("Failed to start job")($1150df68cd261ce8$var$show(startResult.value0));
                    if (startResult instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 194, column 11 - line 198, column 24): " + [
                        startResult.constructor.name
                    ]);
                }())(function() {
                    return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
                });
            });
        });
        throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 188, column 7 - line 199, column 20): " + [
            result.constructor.name
        ]);
    });
    if (ac instanceof $4c2daae6d737ec23$export$e91361436c2780bd) return $1150df68cd261ce8$var$modify_(function(state) {
        var $146 = {};
        for(var $147 in state)if (({}).hasOwnProperty.call(state, $147)) $146[$147] = state[$147];
        $146.spmApiKey = ac.value0;
        return $146;
    });
    if (ac instanceof $4c2daae6d737ec23$export$21a94553ffa41578) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
        var $150 = {};
        for(var $151 in state)if (({}).hasOwnProperty.call(state, $151)) $150[$151] = state[$151];
        $150.logInState = $4c2daae6d737ec23$export$30c73144fd8fd206.value;
        return $150;
    }))(function() {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$runSinglePoll)(function(ok) {
            if (ok) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
                var $154 = {};
                for(var $155 in state)if (({}).hasOwnProperty.call(state, $155)) $154[$155] = state[$155];
                $154.logInState = $4c2daae6d737ec23$export$494f0b40d3d9a8bd.value;
                return $154;
            }))(function() {
                return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(st) {
                    return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$liftEffect(function __do() {
                        var win = $2603425f82e959df$export$8291e5b88f90ce4();
                        var store = $aa35a24624ec08d2$export$c2ed3351cac403d1(win)();
                        return $35126d8d6f6b7968$export$8a8216c44337cd5("key")(st.spmApiKey)(store)();
                    }))(function() {
                        return $1150df68cd261ce8$var$startPolling;
                    });
                });
            });
            return $1150df68cd261ce8$var$modify_(function(state) {
                var $157 = {};
                for(var $158 in state)if (({}).hasOwnProperty.call(state, $158)) $157[$158] = state[$158];
                $157.logInState = $4c2daae6d737ec23$export$9b562f8f165ccd03.value;
                return $157;
            });
        });
    });
    if (ac instanceof $4c2daae6d737ec23$export$cad1a703886b4e3a) return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$modify_(function(state) {
        var $160 = {};
        for(var $161 in state)if (({}).hasOwnProperty.call(state, $161)) $160[$161] = state[$161];
        $160.logInState = $4c2daae6d737ec23$export$ea50864c095dc75e.value;
        $160.spmApiKey = "";
        return $160;
    }))(function() {
        return $1150df68cd261ce8$var$discard($1150df68cd261ce8$var$liftEffect(function __do() {
            var win = $2603425f82e959df$export$8291e5b88f90ce4();
            var store = $aa35a24624ec08d2$export$c2ed3351cac403d1(win)();
            return $35126d8d6f6b7968$export$fe2d9b4e03920b4c("key")(store)();
        }))(function() {
            return $1150df68cd261ce8$var$stopPolling;
        });
    });
    if (ac instanceof $4c2daae6d737ec23$export$4c0b5b4a50347504) return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$get)(function(st) {
        return $1150df68cd261ce8$var$bind($1150df68cd261ce8$var$liftAff($c18e210e93b812bc$export$84751c876800def0(st.staticConfig.speedMasterUrl)(st.spmApiKey)({
            jobId: ac.value0
        })))(function() {
            return $1150df68cd261ce8$var$pure($05149ea687d6b460$export$523c0b569236b342);
        });
    });
    throw new Error("Failed pattern match at Visonum.BulkPingApp.Components.App (line 119, column 3 - line 236, column 16): " + [
        ac.constructor.name
    ]);
};
var $1150df68cd261ce8$export$d8556a2a8f973135 = /* #__PURE__ */ function() {
    return $eea39ea934373596$export$3bb93a8213d3ef21({
        initialState: $1150df68cd261ce8$var$initialState,
        render: $1150df68cd261ce8$var$render,
        "eval": $eea39ea934373596$export$9eef9effff68b10a({
            handleQuery: $eea39ea934373596$export$cb95887a94082d64.handleQuery,
            receive: $eea39ea934373596$export$cb95887a94082d64.receive,
            handleAction: $1150df68cd261ce8$var$handleAction,
            initialize: new $06733ae99ed4f534$export$8a67b48435b5d073($4c2daae6d737ec23$export$b03b1c699c90a9b4.value),
            finalize: new $06733ae99ed4f534$export$8a67b48435b5d073($4c2daae6d737ec23$export$29defdae7b3f3a01.value)
        })
    });
}();


// Generated by purs version 0.15.15
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $1a9d797742944f04$export$6f9ff7e05815be8 = ()=>{
    if ($cfae44f0dfdf62c0$exports == undefined) return {};
    if ($cfae44f0dfdf62c0$exports.env == undefined) return {};
    return {
        SPEED_MASTER_URL: "https://speedmaster.vf.vsnm.net"
    };
};











var $b21f30c754fe2eff$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b21f30c754fe2eff$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $b21f30c754fe2eff$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2b6d012b5a71a466$export$7967a4332fb063d4);
var $b21f30c754fe2eff$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $b21f30c754fe2eff$var$getEnv = function(obj) {
    return function(parse) {
        return function(key) {
            return $b21f30c754fe2eff$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af("Missing env var: " + key)($c045ea5df33bba60$export$dfc7155ac0343b8(key)(obj)))(function(nullableVal) {
                return $b21f30c754fe2eff$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af("Env var is null: " + key)($0a5aaf95f168428e$export$1ba013b88f4f21f3(nullableVal)))(function(val) {
                    return parse(val);
                });
            });
        };
    };
};
var $b21f30c754fe2eff$var$parseStaticConfig = function(obj) {
    return $b21f30c754fe2eff$var$bind($b21f30c754fe2eff$var$getEnv(obj)(function() {
        var $8 = $b21f30c754fe2eff$var$lmap($b21f30c754fe2eff$var$show);
        return function($9) {
            return $8($b9f56ead6323c237$export$98e6a39c04603d36($9));
        };
    }())("SPEED_MASTER_URL"))(function(speedMasterUrl) {
        return $b21f30c754fe2eff$var$pure({
            speedMasterUrl: speedMasterUrl
        });
    });
};
var $b21f30c754fe2eff$export$a8ae18c459949e48 = function __do() {
    var env = $1a9d797742944f04$export$6f9ff7e05815be8();
    return $b21f30c754fe2eff$var$parseStaticConfig(env);
};


var $0c07a74dd7e350c8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $0c07a74dd7e350c8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $0c07a74dd7e350c8$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $0c07a74dd7e350c8$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $0c07a74dd7e350c8$var$liftEither = /* #__PURE__ */ $5dfefa023749ded0$export$bd6bd7bb5418f998($edf0339512807bee$export$37a9b80154c7d256);
var $0c07a74dd7e350c8$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $0c07a74dd7e350c8$export$f22da7240b7add18 = /* #__PURE__ */ $deee5b6018c98796$export$1b79e4d7fc8e4817(/* #__PURE__ */ $0c07a74dd7e350c8$var$bind($deee5b6018c98796$export$f79c83a36c9670be)(function(body) {
    return $0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$bind($0c07a74dd7e350c8$var$map($0c07a74dd7e350c8$var$lmap($ad2cf6904bca3ba1$export$a3bc9b8ed74fc))($0c07a74dd7e350c8$var$liftEffect($b21f30c754fe2eff$export$a8ae18c459949e48)))($0c07a74dd7e350c8$var$liftEither))(function(staticConfig) {
        return $0c07a74dd7e350c8$var$bind($80d0fbcfdca571e1$export$32d31a833a940d1c($1150df68cd261ce8$export$d8556a2a8f973135)({
            staticConfig: staticConfig
        })(body))(function() {
            return $0c07a74dd7e350c8$var$pure($05149ea687d6b460$export$523c0b569236b342);
        });
    });
}));


(0, $0c07a74dd7e350c8$export$f22da7240b7add18)();


//# sourceMappingURL=index.5cad0853.js.map
